
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bSweK", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $55fM8 = parcelRequire("55fM8");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $a1L5E = parcelRequire("a1L5E");


var $iwNka = parcelRequire("iwNka");

parcelRequire("e1iIh");
var $6m7J6 = parcelRequire("6m7J6");


var $bX4Zr = parcelRequire("bX4Zr");


var $35oAA = parcelRequire("35oAA");


var $gsWjA = parcelRequire("gsWjA");


var $g2oof = parcelRequire("g2oof");


var $7QM6o = parcelRequire("7QM6o");


var $3d5UI = parcelRequire("3d5UI");


var $lABjq = parcelRequire("lABjq");


var $9sGCn = parcelRequire("9sGCn");


var $hl1Kw = parcelRequire("hl1Kw");


var $8zMP3 = parcelRequire("8zMP3");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $1Af7Q = parcelRequire("1Af7Q");


// Rovo Chat reads the other side of this chunk. Kept dynamic so a page load that
// never opens the chat, or is not enrolled, does not pay for it.
const $271996e5cf264d1f$var$loadAutocompletePageContextBridge = ()=>(parcelRequire("eTuLj"));
const $271996e5cf264d1f$var$ViewPageInternal = (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { contentId: contentId, spaceKey: spaceKey, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader, children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { versionOverride: versionOverride } = (0, $35oAA.useViewPageParams)();
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentType: contentType } = t1;
    const [t2] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics } = t2;
    const onCurrentContentBodyDynamicChange = $271996e5cf264d1f$var$_temp;
    (0, $bX4Zr.useViewPagePersistentScrollPosition)(contentId);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[0] = t3;
    } else t3 = $[0];
    (0, $cozmU.useEffect)($271996e5cf264d1f$var$_temp2, t3);
    let contentHeader = null;
    if (contentId && spaceKey) {
        const t4 = contentType === "page";
        let t5;
        if ($[1] !== contentId || $[2] !== spaceKey || $[3] !== t4 || $[4] !== versionOverride) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6m7J6.ContentHeader), {
                spaceKey: spaceKey,
                contentId: contentId,
                versionOverride: versionOverride,
                isContentTypePublicLinkEligible: t4
            });
            $[1] = contentId;
            $[2] = spaceKey;
            $[3] = t4;
            $[4] = versionOverride;
            $[5] = t5;
        } else t5 = $[5];
        contentHeader = t5;
    }
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    let t4;
    let t5;
    if ($[6] !== contentId || $[7] !== createAnalyticsEvent || $[8] !== spaceId) {
        t4 = ()=>{
            (0, $3d5UI.waitForGlobal)({
                listener: "ViewPage",
                globalProperty: "AJS.bind"
            }, ()=>{
                window.AJS.bind("createGASv3Event", (_, data)=>{
                    createAnalyticsEvent(data).fire();
                });
            });
            if ((0, $lABjq.pagePublishedState).pageJustPublished) {
                (0, $lABjq.pagePublishedState).pageJustPublished = false;
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        action: "viewed",
                        actionSubject: "pagePublished",
                        source: "viewPage",
                        objectId: contentId,
                        containerId: spaceId,
                        containerType: "space"
                    }
                }).fire();
            }
            return $271996e5cf264d1f$var$_temp4;
        };
        t5 = [
            createAnalyticsEvent,
            contentId,
            spaceId
        ];
        $[6] = contentId;
        $[7] = createAnalyticsEvent;
        $[8] = spaceId;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[11] !== additionalAnalytics || $[12] !== contentId || $[13] !== createAnalyticsEvent || $[14] !== searchSessionId || $[15] !== spaceId) {
        t6 = ()=>{
            const scrollContainer = document.getElementById("AkMainContent") ?? document;
            const handlePageScrolledAnalytics = ()=>{
                const { scrollX: scrollX, scrollY: scrollY, innerWidth: innerWidth, innerHeight: innerHeight } = window;
                const { scrollWidth: scrollWidth, scrollHeight: scrollHeight } = document.documentElement;
                const attributes = {
                    scrollX: scrollX,
                    scrollY: scrollY,
                    innerWidth: innerWidth,
                    innerHeight: innerHeight,
                    scrollWidth: scrollWidth,
                    scrollHeight: scrollHeight,
                    depthX: Math.trunc((scrollX + innerWidth) / scrollWidth * 100) / 100,
                    depthY: Math.trunc((scrollY + innerHeight) / scrollHeight * 100) / 100,
                    searchSessionId: searchSessionId,
                    ...additionalAnalytics
                };
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "scrolled",
                        actionSubject: "page",
                        source: "viewPage",
                        objectId: contentId,
                        containerId: spaceId,
                        containerType: "space",
                        attributes: attributes
                    }
                })?.fire();
            };
            const debouncePageScrolledAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(handlePageScrolledAnalytics, 250);
            scrollContainer.addEventListener("scroll", debouncePageScrolledAnalytics);
            return ()=>{
                scrollContainer.removeEventListener("scroll", debouncePageScrolledAnalytics);
                debouncePageScrolledAnalytics.cancel();
            };
        };
        t7 = [
            createAnalyticsEvent,
            contentId,
            spaceId,
            searchSessionId,
            additionalAnalytics
        ];
        $[11] = additionalAnalytics;
        $[12] = contentId;
        $[13] = createAnalyticsEvent;
        $[14] = searchSessionId;
        $[15] = spaceId;
        $[16] = t6;
        $[17] = t7;
    } else {
        t6 = $[16];
        t7 = $[17];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[18] !== contentId) {
        t8 = (0, $9sGCn.getCachedPageData)(contentId);
        $[18] = contentId;
        $[19] = t8;
    } else t8 = $[19];
    const cachedPageData = t8;
    (0, $iwNka.useExposeGoogleMeetScreenShare)();
    let t9;
    if ($[20] !== contentId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gsWjA.StartViewPageLoad), {
            contentId: contentId
        });
        $[20] = contentId;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Af7Q.LegacyBridgeNext), null);
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== ClassicEditorContextProviderLoader || $[24] !== cachedPageData || $[25] !== children || $[26] !== contentHeader || $[27] !== contentId || $[28] !== spaceKey) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g2oof.ViewPageCommon), {
            spaceKey: spaceKey,
            contentId: contentId,
            contentHeader: contentHeader,
            hasPageComments: true,
            hasLabels: true,
            hasReactions: true,
            hasInlineComments: true,
            hasEOPRecs: true,
            ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader,
            cachedPageData: cachedPageData,
            onCurrentContentBodyDynamicChange: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("platform_editor_ai_autocomplete_rovo_chat_editor", "isEnabled", true) ? onCurrentContentBodyDynamicChange : undefined
        }, children, t10);
        $[23] = ClassicEditorContextProviderLoader;
        $[24] = cachedPageData;
        $[25] = children;
        $[26] = contentHeader;
        $[27] = contentId;
        $[28] = spaceKey;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== t11 || $[31] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t9, t11);
        $[30] = t11;
        $[31] = t9;
        $[32] = t12;
    } else t12 = $[32];
    return t12;
};
const $271996e5cf264d1f$export$767e3006bdbb424a = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "content-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "view-page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($271996e5cf264d1f$var$ViewPageInternal, props)));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
function $271996e5cf264d1f$var$_temp(contentBodyDynamic, currentContentId) {
    $271996e5cf264d1f$var$loadAutocompletePageContextBridge().then((t0)=>{
        const { publishAutocompletePageContent: publishAutocompletePageContent } = t0;
        publishAutocompletePageContent(contentBodyDynamic, currentContentId);
    });
}
function $271996e5cf264d1f$var$_temp2() {
    (0, $6mKj3.expVal)("confluence_aa_test", "isEnabled", false);
    (0, $6mKj3.expVal)("confluence_aa_test_fy27h1", "isEnabled", false);
}
function $271996e5cf264d1f$var$_temp3() {
    window.AJS.bind("createGASv3Event");
}
function $271996e5cf264d1f$var$_temp4() {
    (0, $3d5UI.waitForGlobal)({
        listener: "ViewPage",
        globalProperty: "AJS.unbind"
    }, $271996e5cf264d1f$var$_temp3);
}
module.exports["ViewPage"] = $271996e5cf264d1f$export$767e3006bdbb424a;

});

parcelRegister("iwNka", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7zgzO = parcelRequire("7zgzO");


var $fFk4O = parcelRequire("fFk4O");

const $54ae78ae571a596a$export$1a20dd7f74852e6b = ()=>{
    // Linter is forcing us to use getHref instead of window.location.href to retrieve href and it isn't the full href - it doesn't include origin
    const { getHref: getHref } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    (0, $cozmU.useEffect)(()=>{
        // https://atlassian.slack.com/archives/C0131PNA4GL/p1723738281832269
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ('setCaptureHandleConfig' in (navigator?.mediaDevices ?? {})) {
            const href = getHref();
            (0, $fFk4O.appendGoogleMeetScreenSharingScript)(href);
        }
    // Only execute on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
module.exports["useExposeGoogleMeetScreenShare"] = $54ae78ae571a596a$export$1a20dd7f74852e6b;

});

parcelRegister("fFk4O", function(module, exports) {

var $9ICY6 = parcelRequire("9ICY6");

const $1cd0e9177e768135$export$449f0d0bb2c2424b = 'https://www.gstatic.com/meetjs/addons/1.1.0/meet.addons.js';
const $1cd0e9177e768135$export$8ea5dba186347383 = (href)=>{
    // Create script
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const script = document.createElement('script');
    script.src = $1cd0e9177e768135$export$449f0d0bb2c2424b;
    script.async = true;
    // When script is done loading, run the Google Meet screenshare method
    script.onload = ()=>{
        (0, $9ICY6.exposeToMeetWhenScreensharing)(href);
    };
    // Add script to DOM
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.head.appendChild(script);
};
module.exports["appendGoogleMeetScreenSharingScript"] = $1cd0e9177e768135$export$8ea5dba186347383;

});

parcelRegister("9ICY6", function(module, exports) {

var $hph5e = parcelRequire("hph5e");

var $f29836a0ec4c93d3$export$eab8e91f09e6d84a = /*#__PURE__*/ function(ProjectNumber) {
    ProjectNumber["staging"] = "1017113233545";
    ProjectNumber["production"] = "118174936708";
    return ProjectNumber;
}({});
var $f29836a0ec4c93d3$export$73691bb86ec75a9 = /*#__PURE__*/ function(Hostname) {
    Hostname["staging"] = "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    Hostname["production"] = "cc-embedded-pages-integ.atlassian.com";
    return Hostname;
}({});
const $f29836a0ec4c93d3$export$8446085e93adc95b = (hostname, queryParams)=>`https://${hostname}/google-meet/page?${queryParams}`;
const $f29836a0ec4c93d3$export$7973aed45b22124c = (href)=>{
    const buildUrl = `${window.location.origin}${href}`;
    const parsedURL = (0, $hph5e.parseUrl)(buildUrl) ?? {};
    return new URLSearchParams(parsedURL).toString();
};
const $f29836a0ec4c93d3$export$88041f03017aa037 = (href)=>{
    const currentEnv = "production";
    // Create the correct query params for the main stage url - based on confluence embedded page
    const queryParams = $f29836a0ec4c93d3$export$7973aed45b22124c(href);
    // Grab hardcoded hostname and project number based on current env
    const hostname = $f29836a0ec4c93d3$export$73691bb86ec75a9[currentEnv] ?? "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    const cloudProjectNumber = $f29836a0ec4c93d3$export$eab8e91f09e6d84a[currentEnv] ?? "1017113233545";
    // Fire the Google add-on method to allow promotion and add-on use when screensharing
    // startActivityOnOpen needs to be set to true as long as we use mainstageUrl
    // See docs for additional info: https://developers.google.com/meet/add-ons/reference/websdk/screenshare_api.addonscreenshareinfo.startactivityonopen
    window?.meet?.addon?.screensharing?.exposeToMeetWhenScreensharing({
        cloudProjectNumber: cloudProjectNumber,
        startActivityOnOpen: true,
        mainStageUrl: $f29836a0ec4c93d3$export$8446085e93adc95b(hostname, queryParams)
    });
};
module.exports["exposeToMeetWhenScreensharing"] = $f29836a0ec4c93d3$export$88041f03017aa037;

});

parcelRegister("e1iIh", function(module, exports) {
$parcel$export(module.exports, "ContentHeader", () => (parcelRequire("6m7J6")).ContentHeader);

var $6m7J6 = parcelRequire("6m7J6");


});

parcelRegister("6m7J6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $kz1Yj = parcelRequire("kz1Yj");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $2wCqQ = parcelRequire("2wCqQ");


var $gnKXs = parcelRequire("gnKXs");


var $bavCP = parcelRequire("bavCP");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $JJ6wk = parcelRequire("JJ6wk");


var $cgsIj = parcelRequire("cgsIj");
var $8MMdp = parcelRequire("8MMdp");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $hFGQl = parcelRequire("hFGQl");


var $7boqA = parcelRequire("7boqA");


var $foQ4a = parcelRequire("foQ4a");


var $jmjWc = parcelRequire("jmjWc");


var $bFMG7 = parcelRequire("bFMG7");


var $2XV0z = parcelRequire("2XV0z");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bLtXM = parcelRequire("bLtXM");


var $fwwrH = parcelRequire("fwwrH");


var $fiBb3 = parcelRequire("fiBb3");


var $80xNa = parcelRequire("80xNa");


var $5W37o = parcelRequire("5W37o");


var $jbFlk = parcelRequire("jbFlk");


var $4Uc69 = parcelRequire("4Uc69");


var $JHogp = parcelRequire("JHogp");


var $hlP5l = parcelRequire("hlP5l");


var $a3W69 = parcelRequire("a3W69");


const $a6738032862091d5$var$ContentClassificationTagLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mTy4w",
    name: 'ContentClassificationTag',
    loader: async ()=>(await (parcelRequire("ds2ZC"))).ContentClassificationTag
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a6738032862091d5$var$SpacedActionItem = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFM1Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $a6738032862091d5$var$breadcrumbsAreaWrapper = (0, $buxP3.xcss)({
    flexWrap: 'nowrap',
    flex: '0 1 auto',
    minWidth: 'fit-content',
    gap: 'space.050',
    overflow: 'hidden',
    [(0, $gnKXs.media).above.xs]: {
        minWidth: '96px'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $a6738032862091d5$var$Metadata = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { shouldDisplayClassification: shouldDisplayClassification, ...__cmpldp } = __cmplp;
        const t3 = __cmplp.shouldDisplayClassification ? "20px" : "30px";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        const t5 = __cmplp.shouldDisplayClassification ? "-5px" : "0";
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $9aYkv.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== __cmpls || $[8] !== t4 || $[9] !== t6) {
            t7 = {
                ...__cmpls,
                "--_17u00py": t4,
                "--_p0qxq3": t6
            };
            $[7] = __cmpls;
            $[8] = t4;
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t7,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5v1qpb _3TGfC9HnLE _0NUa3rt3nE _4htEjZkbG2",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $a6738032862091d5$var$verticalSeparatorStyles = (0, $buxP3.xcss)({
    borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    height: '16px',
    margin: 'space.075'
});
const $a6738032862091d5$var$rightSideHeaderStyles = (0, $buxP3.xcss)({
    marginLeft: 'auto',
    alignItems: 'center'
});
const $a6738032862091d5$var$VerticalSeparator = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $a6738032862091d5$var$verticalSeparatorStyles
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$a6738032862091d5$var$SpacedActionItem.displayName = 'SpacedActionItem';
const $a6738032862091d5$var$EXCLUDED_SYSTEM_IDS = [
    (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID),
    (0, $hFGQl.CONTENT_METADATA_ATTACHMENTS_ID)
];
const $a6738032862091d5$var$SYSTEM_IDS_TO_SHOW_WITH_PAGE_BUTTONS = [
    (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID)
];
const $a6738032862091d5$export$b52a1b6380889dfe = (t0)=>{
    const $ = (0, $bDgLe.c)(41);
    const { spaceKey: spaceKey, contentId: contentId, actionItems: t1, versionOverride: t2, showMetadataItems: t3, isContentTypePublicLinkEligible: t4 } = t0;
    let t5;
    if ($[0] !== t1) {
        t5 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t5;
    } else t5 = $[1];
    const actionItems = t5;
    const versionOverride = t2 === undefined ? null : t2;
    const showMetadataItems = t3 === undefined ? true : t3;
    const isContentTypePublicLinkEligible = t4 === undefined ? false : t4;
    const [isContentToolsForcedOpen, setIsContentToolsForcedOpen] = (0, $cozmU.useState)(false);
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey) {
        t6 = {
            contentId: contentId,
            spaceKeyOverride: spaceKey,
            contentStatusContext: "current-only"
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t6;
    } else t6 = $[4];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)(t6);
    const { shouldDisplayClassification: shouldDisplayClassification } = contentClassificationMetadata;
    const { width: width } = (0, $2XV0z.usePageHeightWidthObserver)(false, -37, false);
    let t7;
    if ($[5] !== contentId || $[6] !== shouldDisplayClassification || $[7] !== showMetadataItems || $[8] !== spaceKey || $[9] !== versionOverride || $[10] !== width) {
        t7 = (t8)=>{
            const { contentTitle: contentTitle } = t8;
            const shouldRenderMetadataForPageWidth = ()=>width > 1000;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                alignItems: "center",
                xcss: $a6738032862091d5$var$breadcrumbsAreaWrapper,
                testId: "breadcrumb"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cgsIj.Breadcrumbs), {
                contentId: contentId,
                spaceKey: spaceKey,
                contentTitle: contentTitle || ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                alignBlock: "center"
            }, showMetadataItems && shouldRenderMetadataForPageWidth() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6738032862091d5$var$Metadata, {
                "data-testid": "metadata-wrapper",
                shouldDisplayClassification: shouldDisplayClassification
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Uc69.SystemContentMetadata), {
                key: `metadata-${contentId}`,
                contentId: contentId,
                versionOverride: versionOverride,
                excludeIds: $a6738032862091d5$var$EXCLUDED_SYSTEM_IDS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jbFlk.PageMetadataBanner), {
                key: `banner-${contentId}`,
                contentId: contentId,
                versionOverride: versionOverride
            }))));
        };
        $[5] = contentId;
        $[6] = shouldDisplayClassification;
        $[7] = showMetadataItems;
        $[8] = spaceKey;
        $[9] = versionOverride;
        $[10] = width;
        $[11] = t7;
    } else t7 = $[11];
    const renderBreadcrumbs = t7;
    let t8;
    if ($[12] !== actionItems || $[13] !== contentClassificationMetadata || $[14] !== contentId || $[15] !== isExternalCollaborator || $[16] !== renderBreadcrumbs || $[17] !== showMetadataItems || $[18] !== spaceKey || $[19] !== versionOverride) {
        t8 = (t9)=>{
            const { contentType: contentType, contentTitle: contentTitle_0, loading: loading, subType: subType, lastModifiedDate: lastModifiedDate, isContentToolsForcedOpen: isContentToolsForcedOpen_0, setIsContentToolsForcedOpen: setIsContentToolsForcedOpen_0, isArchived: isArchived, isFabricPage: isFabricPage } = t9;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, renderBreadcrumbs({
                contentTitle: contentTitle_0
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                testId: "content-classification-tag"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6738032862091d5$var$ContentClassificationTagLoader, {
                contentId: contentId,
                contentType: contentType || null,
                contentClassificationMetadata: contentClassificationMetadata,
                isEditMode: false
            })), showMetadataItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5W37o.PageMetadataAtl), {
                contentId: contentId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                alignItems: "center",
                xcss: $a6738032862091d5$var$rightSideHeaderStyles
            }, !isArchived && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bLtXM.ContentHeaderPresence), {
                contentId: contentId,
                contentType: contentType,
                analyticSource: "viewPageScreen"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6738032862091d5$var$VerticalSeparator, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JHogp.GroupedPageButtons), {
                contentId: contentId,
                version: versionOverride,
                includeSystemIds: $a6738032862091d5$var$SYSTEM_IDS_TO_SHOW_WITH_PAGE_BUTTONS,
                spaceKey: spaceKey,
                contentType: contentType,
                contentSubType: subType,
                isExternalCollaborator: isExternalCollaborator,
                lastModifiedDate: lastModifiedDate,
                showEdit: subType !== "live",
                isContentToolsForcedOpen: isContentToolsForcedOpen_0,
                setIsContentToolsForcedOpen: setIsContentToolsForcedOpen_0,
                isArchived: isArchived,
                isFabricPage: isFabricPage
            })), actionItems?.map((ActionItem, index)=>{
                const actionItemProps = {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: contentType
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6738032862091d5$var$SpacedActionItem, {
                    "data-testid": "spacedActionItemTestId",
                    key: ActionItem?.displayName || index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ActionItem, {
                    ...actionItemProps,
                    disabled: loading
                }));
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.VIEW_PAGE_CONTENT_HEADER_EXPERIENCE),
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    subType: subType,
                    isFabricPage: isFabricPage,
                    isContentWrapper: false
                }
            }));
        };
        $[12] = actionItems;
        $[13] = contentClassificationMetadata;
        $[14] = contentId;
        $[15] = isExternalCollaborator;
        $[16] = renderBreadcrumbs;
        $[17] = showMetadataItems;
        $[18] = spaceKey;
        $[19] = versionOverride;
        $[20] = t8;
    } else t8 = $[20];
    const renderContentHeader = t8;
    let t9;
    if ($[21] !== contentId || $[22] !== isContentToolsForcedOpen || $[23] !== renderContentHeader) {
        t9 = (t10)=>{
            const { loading: loading_0, error: error, data: data } = t10;
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            } else {
                if (!data) return null;
            }
            const contentNode = data?.content?.nodes?.[0];
            const contentType_0 = contentNode?.type;
            const lastModifiedDate_0 = contentNode?.metadata?.lastModifiedDate;
            const subType_0 = contentNode?.subType;
            const contentTitle_1 = contentNode?.title;
            const isFabricPage_0 = (0, $a3W69.checkIsFabricPage)(contentNode);
            const spaceIsThemed = Boolean(data?.space?.theme?.themeKey);
            const isArchived_0 = contentNode?.status === "archived";
            const contentHeader = isFabricPage_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JJ6wk.ContentTypesHeader), {
                contentId: contentId,
                contentFragmentRef: contentNode?.contentTypesHeader,
                editContentFragmentRef: contentNode?.editContentButton,
                shareContentFragmentRef: contentNode?.shareAndRestrictButtonData,
                publicLinkPage: data.publicLinkPage,
                isConvertToFolderHighlighted: isContentToolsForcedOpen,
                setIsConvertToFolderHighlighted: setIsContentToolsForcedOpen
            }) : renderContentHeader({
                contentType: contentType_0,
                contentTitle: contentTitle_1,
                isFabricPage: isFabricPage_0,
                loading: loading_0,
                subType: subType_0,
                lastModifiedDate: lastModifiedDate_0,
                isThemed: spaceIsThemed,
                isContentToolsForcedOpen: isContentToolsForcedOpen,
                setIsContentToolsForcedOpen: setIsContentToolsForcedOpen,
                isArchived: isArchived_0
            });
            const shouldShowAifcCreateBanner = isFabricPage_0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MMdp.FixedSpaceHeaderContainer), {
                isThemed: spaceIsThemed,
                "data-testid": "content-header-container",
                shouldHavePadding: !isFabricPage_0,
                shouldShowAifcCreateBanner: shouldShowAifcCreateBanner
            }, shouldShowAifcCreateBanner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                grow: "fill"
            }, contentHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
                contentType: "page"
            })) : contentHeader);
        };
        $[21] = contentId;
        $[22] = isContentToolsForcedOpen;
        $[23] = renderContentHeader;
        $[24] = t9;
    } else t9 = $[24];
    const renderQueryChildren = t9;
    let t10;
    if ($[25] !== contentId || $[26] !== renderQueryChildren || $[27] !== showMetadataItems || $[28] !== spaceKey || $[29] !== versionOverride) {
        t10 = (t11)=>{
            const { useEditButtonFragment: useEditButtonFragment, useAccessButtonFragment: useAccessButtonFragment, includePublicLink: includePublicLink } = t11;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).BACKBONE
            }, showMetadataItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
                key: `PageSegmentLoadStart-connect-${contentId}`,
                metric: (0, $hlP5l.CONNECT_APP_WEB_FRAGMENT_METRIC)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
                key: `object-header-${contentId}`,
                id: contentId,
                name: (0, $irVI7.OBJECT_HEADER_EXPERIENCE)
            }), (0, $6mKj3.expValEquals)("cc-markdown-mode", "isEnabled", true) ? (0, $9wGTI.fg)("confluence_vp_obj_header_frag_dedup") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $fiBb3.ContentHeaderUnifiedQuery),
                variables: {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    versionOverride: versionOverride || null,
                    embeddedContentRender: null,
                    limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                    useNewContentTopper: true,
                    isMarkdownModeEnabled: true,
                    includeDevDocsBylineConnection: false,
                    useObjectHeaderFragment: true,
                    useEditButtonFragment: useEditButtonFragment,
                    useAccessButtonFragment: useAccessButtonFragment,
                    includePublicLink: includePublicLink
                },
                context: {
                    single: true
                },
                __callerPackage__: "content-header"
            }, renderQueryChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $fiBb3.ContentHeaderUnifiedQuery),
                variables: {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    versionOverride: versionOverride || null,
                    embeddedContentRender: null,
                    limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                    useNewContentTopper: true,
                    isMarkdownModeEnabled: true,
                    includeDevDocsBylineConnection: false,
                    useObjectHeaderFragment: false,
                    useEditButtonFragment: useEditButtonFragment,
                    useAccessButtonFragment: useAccessButtonFragment,
                    includePublicLink: includePublicLink
                },
                context: {
                    single: true
                },
                __callerPackage__: "content-header"
            }, renderQueryChildren) : (0, $9wGTI.fg)("confluence_vp_obj_header_frag_dedup") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $fiBb3.ContentHeaderUnifiedQuery),
                variables: {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    versionOverride: versionOverride || null,
                    embeddedContentRender: null,
                    limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                    useNewContentTopper: true,
                    isMarkdownModeEnabled: false,
                    includeDevDocsBylineConnection: false,
                    useObjectHeaderFragment: true,
                    useEditButtonFragment: useEditButtonFragment,
                    useAccessButtonFragment: useAccessButtonFragment,
                    includePublicLink: includePublicLink
                },
                context: {
                    single: true
                },
                __callerPackage__: "content-header"
            }, renderQueryChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $fiBb3.ContentHeaderUnifiedQuery),
                variables: {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    versionOverride: versionOverride || null,
                    embeddedContentRender: null,
                    limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                    useNewContentTopper: true,
                    isMarkdownModeEnabled: false,
                    includeDevDocsBylineConnection: false,
                    useObjectHeaderFragment: false,
                    useEditButtonFragment: useEditButtonFragment,
                    useAccessButtonFragment: useAccessButtonFragment,
                    includePublicLink: includePublicLink
                },
                context: {
                    single: true
                },
                __callerPackage__: "content-header"
            }, renderQueryChildren));
        };
        $[25] = contentId;
        $[26] = renderQueryChildren;
        $[27] = showMetadataItems;
        $[28] = spaceKey;
        $[29] = versionOverride;
        $[30] = t10;
    } else t10 = $[30];
    const renderContentHeaderQuery = t10;
    if ((0, $9wGTI.fg)("confluence_vp_edit_frag_reader")) {
        if ((0, $9wGTI.fg)("confluence_vp_access_frag_reader")) {
            let t11;
            if ($[31] !== isContentTypePublicLinkEligible || $[32] !== renderContentHeaderQuery) {
                t11 = renderContentHeaderQuery({
                    useEditButtonFragment: true,
                    useAccessButtonFragment: true,
                    includePublicLink: isContentTypePublicLinkEligible
                });
                $[31] = isContentTypePublicLinkEligible;
                $[32] = renderContentHeaderQuery;
                $[33] = t11;
            } else t11 = $[33];
            return t11;
        }
        let t11;
        if ($[34] !== renderContentHeaderQuery) {
            t11 = renderContentHeaderQuery({
                useEditButtonFragment: true,
                useAccessButtonFragment: false,
                includePublicLink: false
            });
            $[34] = renderContentHeaderQuery;
            $[35] = t11;
        } else t11 = $[35];
        return t11;
    }
    if ((0, $9wGTI.fg)("confluence_vp_access_frag_reader")) {
        let t11;
        if ($[36] !== isContentTypePublicLinkEligible || $[37] !== renderContentHeaderQuery) {
            t11 = renderContentHeaderQuery({
                useEditButtonFragment: false,
                useAccessButtonFragment: true,
                includePublicLink: isContentTypePublicLinkEligible
            });
            $[36] = isContentTypePublicLinkEligible;
            $[37] = renderContentHeaderQuery;
            $[38] = t11;
        } else t11 = $[38];
        return t11;
    }
    let t11;
    if ($[39] !== renderContentHeaderQuery) {
        t11 = renderContentHeaderQuery({
            useEditButtonFragment: false,
            useAccessButtonFragment: false,
            includePublicLink: false
        });
        $[39] = renderContentHeaderQuery;
        $[40] = t11;
    } else t11 = $[40];
    return t11;
};
module.exports["ContentHeader"] = $a6738032862091d5$export$b52a1b6380889dfe;

});

parcelRegister("gnKXs", function(module, exports) {
const $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
module.exports["media"] = $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f;

});

parcelRegister("ln0hx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("cgsIj", function(module, exports) {
$parcel$export(module.exports, "FixedSpaceHeaderContainer", () => (parcelRequire("8MMdp")).FixedSpaceHeaderContainer);

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $eCJDV = parcelRequire("eCJDV");


var $8MMdp = parcelRequire("8MMdp");


const $b7f6794681d506d9$export$74cf87e24679ef23 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Z3pve",
    name: "BreadcrumbsLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).Breadcrumbs,
    loading: (0, $eCJDV.BreadcrumbsPlaceholder)
});
const $b7f6794681d506d9$export$2dc68d50d56fbbd = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);
const $b7f6794681d506d9$export$8bb26699ba16d6a3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MMdp.Breadcrumbs), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MMdp.Breadcrumbs), props);

const $b7f6794681d506d9$export$f979c33d59431f8e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G1kJd",
    name: "FixedBreadcrumbsNavForPageLayoutLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).FixedBreadcrumbsNavForPageLayout
});
module.exports["BreadcrumbsLoader"] = $b7f6794681d506d9$export$74cf87e24679ef23;
module.exports["Breadcrumbs"] = $b7f6794681d506d9$export$2dc68d50d56fbbd;
module.exports["BreadcrumbsNonLoadable"] = $b7f6794681d506d9$export$8bb26699ba16d6a3;
module.exports["FixedBreadcrumbsNavForPageLayoutLoader"] = $b7f6794681d506d9$export$f979c33d59431f8e;

});

parcelRegister("eCJDV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b8pma = parcelRequire("b8pma");

const $0c4308f795e44815$export$98d1f051069dd73b = (0, $3u0dr.isReactCompilerActiveV2)() ? function BreadcrumbsPlaceholder() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "BreadcrumbsPlaceholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "breadcrumbs-placeholder",
            "data-vc": "breadcrumbs-placeholder"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function BreadcrumbsPlaceholder() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "BreadcrumbsPlaceholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "breadcrumbs-placeholder",
        "data-vc": "breadcrumbs-placeholder"
    }));
};
module.exports["BreadcrumbsPlaceholder"] = $0c4308f795e44815$export$98d1f051069dd73b;

});

parcelRegister("8MMdp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $9DHhW = parcelRequire("9DHhW");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $jmjWc = parcelRequire("jmjWc");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $6mKj3 = parcelRequire("6mKj3");


var $5Vf1r = parcelRequire("5Vf1r");

const $6d14bad88596319b$var$hideDuringPdfPrint = null;

const $6d14bad88596319b$var$CompanyHubBreadcrumbs = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rj-y7",
    name: "CompanyHubBreadcrumbs",
    loader: async ()=>(await (parcelRequire("5PKaL"))).CompanyHubBreadcrumbs
}); // Keep this in sync with entry-points/breadcrumbsConstants.ts
const $6d14bad88596319b$var$BREADCRUMB_HEADER_HEIGHT = 56; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6d14bad88596319b$export$ba9528a5a0141231 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isThemed: isThemed, shouldHavePadding: shouldHavePadding, shouldShowAifcCreateBanner: shouldShowAifcCreateBanner, isTransparent: isTransparent, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1ji2brd": (0, $9aYkv.default)(__cmplp.justifyContent || "space-between")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1x1D3gYbGa _0jFU0VmdCj _42Yu6BaZ2J _1EqgXluI1V _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _24h04i2Njc _3OE6xY1nKm _37wbyu01Vb",
                __cmplp.isThemed ? "_1mT5xdHE3j" : "_1mT5xdy1CL",
                __cmplp.isThemed || !__cmplp.shouldHavePadding ? "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC" : "_0Of8r2dnbC _1ZnuxbxpxF _1wydGWdnbC _2Zuz6QxpxF",
                __cmplp.shouldShowAifcCreateBanner ? "_0aFT5vbt8w" : "_0aFT5v1qpb",
                __cmplp.isTransparent ? "_0KLXrujOvk" : "_0KLXrulfZc",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, shouldHavePadding: shouldHavePadding, shouldShowAifcCreateBanner: shouldShowAifcCreateBanner, isTransparent: isTransparent, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ji2brd": (0, $9aYkv.default)(__cmplp.justifyContent || 'space-between')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1x1D3gYbGa _0jFU0VmdCj _42Yu6BaZ2J _1EqgXluI1V _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _24h04i2Njc _3OE6xY1nKm _37wbyu01Vb",
            __cmplp.isThemed ? "_1mT5xdHE3j" : "_1mT5xdy1CL",
            __cmplp.isThemed || !__cmplp.shouldHavePadding ? "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC" : "_0Of8r2dnbC _1ZnuxbxpxF _1wydGWdnbC _2Zuz6QxpxF",
            __cmplp.shouldShowAifcCreateBanner ? "_0aFT5vbt8w" : "_0aFT5v1qpb",
            __cmplp.isTransparent ? "_0KLXrujOvk" : "_0KLXrulfZc",
            __cmplp.className
        ])
    });
});
const $6d14bad88596319b$var$SpaceHeaderWithBannerWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFullWidth: isFullWidth, isThemed: isThemed, isTransparent: isTransparent, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1x1D3gYbGa _42Yu6BaZ2J _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc _3OE6xY1nKm _2XsHFMdnbC",
            __cmplp.isFullWidth ? "_1EqgXlYbGa" : "_1EqgXluI1V",
            __cmplp.isThemed ? "_1mT5xdHE3j" : "_1mT5xdy1CL",
            __cmplp.isTransparent ? "_0KLXrujOvk" : "_0KLXrulfZc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFullWidth: isFullWidth, isThemed: isThemed, isTransparent: isTransparent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1x1D3gYbGa _42Yu6BaZ2J _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc _3OE6xY1nKm _2XsHFMdnbC",
            __cmplp.isFullWidth ? "_1EqgXlYbGa" : "_1EqgXluI1V",
            __cmplp.isThemed ? "_1mT5xdHE3j" : "_1mT5xdy1CL",
            __cmplp.isTransparent ? "_0KLXrujOvk" : "_0KLXrulfZc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $6d14bad88596319b$var$SpaceHeaderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isThemed: isThemed, shouldHavePadding: shouldHavePadding, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu8FQfX _0jFU0VmdCj _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.isThemed || !__cmplp.shouldHavePadding ? "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC" : "_0Of8r2dnbC _1ZnuxbxpxF _1wydGWdnbC _2Zuz6QxpxF",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, shouldHavePadding: shouldHavePadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu8FQfX _0jFU0VmdCj _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.isThemed || !__cmplp.shouldHavePadding ? "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC" : "_0Of8r2dnbC _1ZnuxbxpxF _1wydGWdnbC _2Zuz6QxpxF",
            __cmplp.className
        ])
    });
});
function $6d14bad88596319b$export$2dc68d50d56fbbd({ contentId: contentId, contentTitle: contentTitle, spaceKey: spaceKey, testId: testId, showInlineRename: showInlineRename, shouldDisableMoveButton: shouldDisableMoveButton, displayMode: displayMode = (0, $5Vf1r.BREADCRUMBS_MODES).FULL, contentLink: contentLink, contentType: contentType, subType: subType }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (!spaceKey) return null;
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$var$CompanyHubBreadcrumbs, null);
    const fireBreadcrumbError = (error)=>{
        let err;
        let nativeError;
        try {
            err = JSON.stringify(error, Object.getOwnPropertyNames(error)); // https://stackoverflow.com/a/26199752
            nativeError = JSON.stringify(error['nativeError']);
        } catch  {
            // if no error, means it failed to stringify so just set as empty string
            if (!err) err = '';
            if (!nativeError) nativeError = '';
        } finally{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'breadcrumbs',
                    action: 'errored',
                    actionSubject: 'viewPageBreadcrumbs',
                    attributes: {
                        message: error.message,
                        error: err,
                        nativeError: nativeError
                    }
                }
            }).fire();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        onError: fireBreadcrumbError,
        renderOnError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Vf1r.BreadcrumbsWithSpaceNameDropdown), {
        contentTitle: contentTitle,
        spaceKey: spaceKey || '',
        contentId: contentId,
        testId: testId,
        showInlineRename: showInlineRename,
        shouldDisableMoveButton: shouldDisableMoveButton,
        displayMode: displayMode,
        contentLink: contentLink,
        contentType: contentType,
        subType: subType
    })));
}
const $6d14bad88596319b$export$7d2750c639212b06 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] !== spaceKey) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$export$ba9528a5a0141231, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$export$2dc68d50d56fbbd, {
            spaceKey: spaceKey
        }));
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$export$ba9528a5a0141231, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$export$2dc68d50d56fbbd, {
        spaceKey: spaceKey
    }));
};
const $6d14bad88596319b$export$5adc3a1912461c1e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, banner: banner, isThemed: isThemed, shouldHavePadding: shouldHavePadding, isFullWidth: isFullWidth, isTransparent: isTransparent, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            (0, $6mKj3.expValEquals)("afm-hide-elements-from-pdf-print", "isEnabled", true) && "_08KCXeYbGa"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== isThemed || $[3] !== shouldHavePadding || $[4] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$var$SpaceHeaderWrapper, {
            isThemed: isThemed,
            "data-testid": testId,
            shouldHavePadding: shouldHavePadding
        }, children);
        $[1] = children;
        $[2] = isThemed;
        $[3] = shouldHavePadding;
        $[4] = testId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== banner || $[7] !== isFullWidth || $[8] !== isThemed || $[9] !== isTransparent || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$var$SpaceHeaderWithBannerWrapper, {
            isThemed: isThemed,
            isFullWidth: isFullWidth,
            isTransparent: isTransparent,
            className: t1
        }, banner, t2);
        $[6] = banner;
        $[7] = isFullWidth;
        $[8] = isThemed;
        $[9] = isTransparent;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ children: children, banner: banner, isThemed: isThemed, shouldHavePadding: shouldHavePadding, isFullWidth: isFullWidth, isTransparent: isTransparent, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$var$SpaceHeaderWithBannerWrapper, {
        isThemed: isThemed,
        isFullWidth: isFullWidth,
        isTransparent: isTransparent,
        className: (0, $hekY6.default)([
            (0, $6mKj3.expValEquals)('afm-hide-elements-from-pdf-print', 'isEnabled', true) && "_08KCXeYbGa"
        ])
    }, banner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$var$SpaceHeaderWrapper, {
        isThemed: isThemed,
        "data-testid": testId,
        shouldHavePadding: shouldHavePadding
    }, children));
};
module.exports["FixedSpaceHeaderContainer"] = $6d14bad88596319b$export$ba9528a5a0141231;
module.exports["Breadcrumbs"] = $6d14bad88596319b$export$2dc68d50d56fbbd;
module.exports["FixedBreadcrumbsNavForPageLayout"] = $6d14bad88596319b$export$7d2750c639212b06;
module.exports["FixedSpaceHeaderWithBannerContainer"] = $6d14bad88596319b$export$5adc3a1912461c1e;

});

parcelRegister("5Vf1r", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $9DHhW = parcelRequire("9DHhW");


var $kA6Zo = parcelRequire("kA6Zo");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $4n1IT = parcelRequire("4n1IT");


var $lpNn5 = parcelRequire("lpNn5");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $bMPhU = parcelRequire("bMPhU");


var $kqIWy = parcelRequire("kqIWy");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $b3j2Y = parcelRequire("b3j2Y");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $LSims = parcelRequire("LSims");


var $bCECL = parcelRequire("bCECL");


var $kM55L = parcelRequire("kM55L");


var $1jQpq = parcelRequire("1jQpq");


var $6mKj3 = parcelRequire("6mKj3");


var $ePiuX = parcelRequire("ePiuX");


var $hzkzq = parcelRequire("hzkzq");


const $7c978e5ad74fbe60$var$BreadcrumbsDropdownContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "d_JWZ",
    name: "BreadcrumbsDropdownContent",
    loader: async ()=>(await (parcelRequire("d0aff"))).BreadcrumbsDropdownContent
});

const $7c978e5ad74fbe60$var$BreadcrumbsPlaceholder = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YZZqh",
    name: "BreadcrumbsPlaceholder",
    loader: async ()=>(await Promise.resolve((parcelRequire("eCJDV")))).BreadcrumbsPlaceholder
});
const $7c978e5ad74fbe60$var$separatorStyles = null;
const $7c978e5ad74fbe60$var$hiddenStyles = null;
const $7c978e5ad74fbe60$var$hiddenContentTitleStyles = null;
const $7c978e5ad74fbe60$var$hideSeparatorStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbsStyles = (0, $buxP3.xcss)({
    minWidth: '32px',
    // needed for responsive breadcrumbs, 32px is the width of the chevron button
    alignItems: 'center',
    flex: '0 1 auto',
    gap: 'space.100'
});
const $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles = (0, $buxP3.xcss)({
    flex: '0 0 auto'
});
const $7c978e5ad74fbe60$var$fadedSpaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$spaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$noEllipsisStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthBreadcrumbsDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$onlySpaceNameTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthOnlyContentTitleTriggerStyles = null;
const $7c978e5ad74fbe60$var$currentPageBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$currentPageLinkBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$contentTitleStyles = null;
const $7c978e5ad74fbe60$var$dropdownLessContentTitleStyles = null;
const $7c978e5ad74fbe60$var$chevronBaseStyles = (0, $buxP3.xcss)({
    width: '32px',
    minWidth: '32px',
    height: '32px',
    borderRadius: "var(--ds-radius-small, 4px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'color.background.neutral.subtle'
});
const $7c978e5ad74fbe60$var$chevronHoverStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
var $7c978e5ad74fbe60$export$14e8342ddf0a4616 = /*#__PURE__*/ function(BREADCRUMBS_MODES) {
    BREADCRUMBS_MODES["ONLY_CONTENT_TITLE"] = "ONLY_CONTENT_TITLE";
    BREADCRUMBS_MODES["ONLY_SPACE_NAME"] = "ONLY_SPACE_NAME";
    BREADCRUMBS_MODES["FULL"] = "FULL";
    BREADCRUMBS_MODES["HIDDEN"] = "HIDDEN";
    return BREADCRUMBS_MODES;
}({});
const $7c978e5ad74fbe60$export$c71a066c29807b48 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(57);
    const { contentTitle: contentTitle, spaceKey: spaceKey, contentId: contentId, testId: t1, showInlineRename: t2, shouldDisableMoveButton: t3, displayMode: displayMode, contentLink: contentLink, contentType: contentType, subType: subType } = t0;
    const testId = t1 === undefined ? "breadcrumbs-with-space-name-dropdown" : t1;
    const showInlineRename = t2 === undefined ? false : t2;
    const shouldDisableMoveButton = t3 === undefined ? false : t3;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isBreadcrumbsPopupOpen, setIsBreadcrumbsPopupOpen] = (0, $cozmU.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { data: spaceData, error: error } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const spaceHomepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    const isLivePage = contentType === "page" && subType === "live";
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? contentId : undefined);
    const [t4] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t4;
    let t5;
    if ($[0] !== isCollabOffline) {
        t5 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[0] = isCollabOffline;
        $[1] = t5;
    } else t5 = $[1];
    const isNetworkDisabled = t5;
    if (error || !spaceData) {
        let t6;
        if ($[2] !== error) {
            t6 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
                name: (0, $irVI7.BREADCRUMBS_EXPERIENCE),
                error: error
            }));
            $[2] = error;
            $[3] = t6;
        } else t6 = $[3];
        let t7;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7c978e5ad74fbe60$var$BreadcrumbsPlaceholder, null);
            $[4] = t7;
        } else t7 = $[4];
        let t8;
        if ($[5] !== t6) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t7);
            $[5] = t6;
            $[6] = t8;
        } else t8 = $[6];
        return t8;
    }
    const spaceName = spaceData.name || spaceData.alias || spaceKey;
    const isSpaceNameLongerThan6Letters = spaceName?.length > 6;
    let T0;
    let renderContentTitle;
    let shouldShowCurrentContentTitle;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[7] !== contentId || $[8] !== contentLink || $[9] !== contentTitle || $[10] !== contentType || $[11] !== createAnalyticsEvent || $[12] !== displayMode || $[13] !== experienceTracker || $[14] !== intl || $[15] !== isBreadcrumbsPopupOpen || $[16] !== isMarkdownMode || $[17] !== isModernEmbeddedConfluence || $[18] !== isNetworkDisabled || $[19] !== isSpaceNameLongerThan6Letters || $[20] !== push || $[21] !== shouldDisableMoveButton || $[22] !== showInlineRename || $[23] !== spaceData.alias || $[24] !== spaceHomepageId || $[25] !== spaceKey || $[26] !== spaceName || $[27] !== ssrPlaceholderIdProp || $[28] !== subType || $[29] !== testId) {
        const baseContentTitle = contentTitle === "" ? intl.formatMessage($7c978e5ad74fbe60$var$i18n.untitledPage) : contentTitle;
        const contentTitleToRender = isMarkdownMode && baseContentTitle ? `${baseContentTitle}.md` : baseContentTitle;
        const shouldOpenDropdown = contentTitleToRender || showInlineRename;
        shouldShowCurrentContentTitle = contentTitleToRender && !showInlineRename;
        let t10;
        if ($[37] !== spaceData.alias || $[38] !== spaceHomepageId || $[39] !== spaceKey) {
            t10 = (0, $hzkzq.buildContentPath)({
                contentType: "page",
                isSpaceOverview: true,
                query: spaceHomepageId ? {
                    [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
                } : undefined,
                spaceAlias: spaceData.alias,
                spaceKey: spaceKey
            });
            $[37] = spaceData.alias;
            $[38] = spaceHomepageId;
            $[39] = spaceKey;
            $[40] = t10;
        } else t10 = $[40];
        const spaceOverviewPath = t10;
        const handleBreadcrumbDropdownTriggerClick = ()=>{
            if (shouldOpenDropdown) {
                if (!isBreadcrumbsPopupOpen) {
                    experienceTracker.start({
                        name: (0, $irVI7.BREADCRUMBS_DROPDOWN_EXPERIENCE)
                    });
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "opened",
                            actionSubject: "breadcrumbsDropdown",
                            source: "breadcrumbs",
                            attributes: {
                                isContentWrapper: true
                            }
                        }
                    }).fire();
                }
                setIsBreadcrumbsPopupOpen(!isBreadcrumbsPopupOpen);
            } else push(spaceOverviewPath);
        };
        const popupContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7c978e5ad74fbe60$var$BreadcrumbsDropdownContent, {
                spaceKey: spaceKey,
                contentId: contentId,
                closeDropdownOnClickOfBreadcrumbItem: closeDropdownOnClickOfBreadcrumbItem,
                spaceOverviewPath: spaceOverviewPath,
                shouldDisableMoveButton: shouldDisableMoveButton,
                contentTitle: contentTitleToRender
            });
        const closeDropdownOnClickOfBreadcrumbItem = ()=>{
            setIsBreadcrumbsPopupOpen(false);
        };
        let t11;
        if ($[41] !== contentId || $[42] !== spaceKey) {
            t11 = ()=>{
                (0, $ePiuX.preloadBreadcrumbsDropdown)({
                    spaceKey: spaceKey,
                    contentId: contentId
                });
            };
            $[41] = contentId;
            $[42] = spaceKey;
            $[43] = t11;
        } else t11 = $[43];
        const preloadBreadcrumbsDropdownOnSpaceNameHover = t11;
        const renderPopup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
                isOpen: isBreadcrumbsPopupOpen,
                onClose: ()=>setIsBreadcrumbsPopupOpen(false),
                placement: "bottom-start",
                content: popupContent,
                shouldRenderToParent: true,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                        id: "breadcrumbs-dropdown-chevron-button",
                        "data-testid": "breadcrumbs-dropdown-chevron-button",
                        disabled: isNetworkDisabled,
                        onClick: handleBreadcrumbDropdownTriggerClick,
                        onMouseEnter: preloadBreadcrumbsDropdownOnSpaceNameHover,
                        onFocus: preloadBreadcrumbsDropdownOnSpaceNameHover,
                        "aria-label": intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonAriaLabel),
                        ...triggerProps,
                        ...ssrPlaceholderIdProp,
                        className: (0, $hekY6.default)([
                            "_0bjKvDKxmn _30huDKjOvk _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _4c065UdnbC _2Y7lL4dnbC _3iDTPbvbI6 _0wOv4Q7zJH _3YEZNOdnbC _39xV02N91d _0KLXru66of _1UtDYzKGUX _4sSPMf98eZ _36W3EOYbGa _35OaAw6wH8 _2p7dw4KGUX _02aXbK18ZR _10n1R5ZpcK _1ubuxonXvL _34b3D2FQfX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _0CMRbky7kJ",
                            shouldOpenDropdown && "_1EqgXlGVdc _39xV02ZqHV _0yyhggaXQy",
                            displayMode === "ONLY_SPACE_NAME" && "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _1EqgXlHakr _39xV02ZqHV _0yyhggHakr",
                            displayMode === "ONLY_CONTENT_TITLE" && "_1EqgXlN91d _39HuIbz8Lp _0yyhggN91d",
                            displayMode === "HIDDEN" && "_3iDTPbYbGa"
                        ])
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                        alignItems: "center",
                        gap: "space.100"
                    }, shouldOpenDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                        content: !isNetworkDisabled && intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonTooltip),
                        hideTooltipOnClick: true
                    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                            xcss: [
                                $7c978e5ad74fbe60$var$chevronBaseStyles,
                                !isNetworkDisabled && $7c978e5ad74fbe60$var$chevronHoverStyles
                            ],
                            ...tooltipProps
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)",
                            size: "small"
                        }))), renderSpaceName()))
            }), shouldOpenDropdown && renderSeparator());
        renderContentTitle = ()=>{
            const titleElement = contentLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
                href: contentLink,
                className: (0, $hekY6.default)([
                    "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgEqul _1ANEUSLRg7 _39HuIbz8Lp _4ouGXIoWWg _1UtDYzy7kJ _2nTuUYy7kJ _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMM7Tp _4scvAwy7kJ _3PnjIVYbGa"
                ])
            }, contentTitleToRender) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgEqul _1ANEUSLRg7 _39HuIbz8Lp _4ouGXIoWWg _1UtDYzy7kJ _3PnjIVYbGa"
                ])
            }, contentTitleToRender);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                id: "breadcrumbs-content-title",
                className: (0, $hekY6.default)([
                    "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _23rrnHYbGa _3iDTPbQ4SZ _0hPCNLDIqT _1YKVNs7dHp _1EqgXlOAqP",
                    (displayMode === "HIDDEN" || displayMode === "ONLY_SPACE_NAME") && "_1YKVNsdnbC _1EqgXldnbC",
                    isModernEmbeddedConfluence && "_0LQT5E2ADO"
                ])
            }, (contentType === "page" || contentType === "blogpost") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
                type: contentType,
                subType: subType,
                color: "var(--ds-text, #292A2E)",
                isMarkdownMode: isMarkdownMode
            }), titleElement);
        };
        const renderSpaceName = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                id: "breadcrumbs-space-name",
                className: (0, $hekY6.default)([
                    "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _39HuIbz8Lp _39xV02N91d _1ANEUSLRg7 _1EqgXlN91d",
                    shouldOpenDropdown && displayMode === "FULL" && "_39HuIbZqHV",
                    shouldOpenDropdown && isSpaceNameLongerThan6Letters && displayMode === "FULL" && "_3X9j4qOxvQ _4vaMcNOxvQ",
                    (displayMode === "HIDDEN" || displayMode === "ONLY_CONTENT_TITLE") && "_3iDTPbYbGa"
                ])
            }, spaceName);
        const renderSeparator = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                id: "breadcrumbs-separator",
                className: (0, $hekY6.default)([
                    "_1UtDYzZpcK _1pp6NdYbGa _3YEZNOdnbC _0adFHs1Y8M _2XsHFM1Y8M",
                    !showInlineRename && "_3PnjIVYbGa",
                    displayMode != "FULL" && "_3iDTPbYbGa"
                ])
            }, "/");
        T0 = (0, $kA6Zo.default);
        const t12 = showInlineRename && $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles;
        if ($[44] !== t12) {
            t6 = [
                $7c978e5ad74fbe60$var$breadcrumbsStyles,
                t12
            ];
            $[44] = t12;
            $[45] = t6;
        } else t6 = $[45];
        t7 = testId;
        t8 = testId;
        t9 = !isModernEmbeddedConfluence && renderPopup();
        $[7] = contentId;
        $[8] = contentLink;
        $[9] = contentTitle;
        $[10] = contentType;
        $[11] = createAnalyticsEvent;
        $[12] = displayMode;
        $[13] = experienceTracker;
        $[14] = intl;
        $[15] = isBreadcrumbsPopupOpen;
        $[16] = isMarkdownMode;
        $[17] = isModernEmbeddedConfluence;
        $[18] = isNetworkDisabled;
        $[19] = isSpaceNameLongerThan6Letters;
        $[20] = push;
        $[21] = shouldDisableMoveButton;
        $[22] = showInlineRename;
        $[23] = spaceData.alias;
        $[24] = spaceHomepageId;
        $[25] = spaceKey;
        $[26] = spaceName;
        $[27] = ssrPlaceholderIdProp;
        $[28] = subType;
        $[29] = testId;
        $[30] = T0;
        $[31] = renderContentTitle;
        $[32] = shouldShowCurrentContentTitle;
        $[33] = t6;
        $[34] = t7;
        $[35] = t8;
        $[36] = t9;
    } else {
        T0 = $[30];
        renderContentTitle = $[31];
        shouldShowCurrentContentTitle = $[32];
        t6 = $[33];
        t7 = $[34];
        t8 = $[35];
        t9 = $[36];
    }
    let t10;
    if ($[46] !== renderContentTitle || $[47] !== shouldShowCurrentContentTitle) {
        t10 = shouldShowCurrentContentTitle && renderContentTitle();
        $[46] = renderContentTitle;
        $[47] = shouldShowCurrentContentTitle;
        $[48] = t10;
    } else t10 = $[48];
    let t11;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
        });
        $[49] = t11;
    } else t11 = $[49];
    let t12;
    if ($[50] !== T0 || $[51] !== t10 || $[52] !== t6 || $[53] !== t7 || $[54] !== t8 || $[55] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t6,
            testId: t7,
            "data-vc": t8
        }, t9, t10, t11);
        $[50] = T0;
        $[51] = t10;
        $[52] = t6;
        $[53] = t7;
        $[54] = t8;
        $[55] = t9;
        $[56] = t12;
    } else t12 = $[56];
    return t12;
} : ({ contentTitle: contentTitle, spaceKey: spaceKey, contentId: contentId, testId: testId = 'breadcrumbs-with-space-name-dropdown', showInlineRename: showInlineRename = false, shouldDisableMoveButton: shouldDisableMoveButton = false, displayMode: displayMode, contentLink: contentLink, contentType: contentType, subType: subType })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isBreadcrumbsPopupOpen, setIsBreadcrumbsPopupOpen] = (0, $cozmU.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { data: spaceData, error: error } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const spaceHomepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    const isLivePage = contentType === 'page' && subType === 'live';
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? contentId : undefined);
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override'); // Note don't check for loading as when refreshing data we will get data={...} and loading=true
    // In this case if we display the placeholder it will flash before the data is displayed
    // We should continue render with existing data and then update when the new data is available
    if (error || !spaceData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE),
        error: error
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7c978e5ad74fbe60$var$BreadcrumbsPlaceholder, null));
    const spaceName = spaceData.name || spaceData.alias || spaceKey;
    const isSpaceNameLongerThan6Letters = spaceName?.length > 6;
    const baseContentTitle = contentTitle === '' ? intl.formatMessage($7c978e5ad74fbe60$var$i18n.untitledPage) : contentTitle;
    const contentTitleToRender = isMarkdownMode && baseContentTitle ? `${baseContentTitle}.md` : baseContentTitle;
    const shouldOpenDropdown = contentTitleToRender || showInlineRename;
    const shouldShowCurrentContentTitle = contentTitleToRender && !showInlineRename;
    const spaceOverviewPath = (0, $hzkzq.buildContentPath)({
        contentType: 'page',
        isSpaceOverview: true,
        query: spaceHomepageId ? {
            [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
        } : undefined,
        spaceAlias: spaceData.alias,
        spaceKey: spaceKey
    });
    const handleBreadcrumbDropdownTriggerClick = ()=>{
        if (shouldOpenDropdown) {
            if (!isBreadcrumbsPopupOpen) {
                experienceTracker.start({
                    name: (0, $irVI7.BREADCRUMBS_DROPDOWN_EXPERIENCE)
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'opened',
                        actionSubject: 'breadcrumbsDropdown',
                        source: 'breadcrumbs',
                        attributes: {
                            isContentWrapper: true
                        }
                    }
                }).fire();
            }
            setIsBreadcrumbsPopupOpen(!isBreadcrumbsPopupOpen);
        } else push(spaceOverviewPath);
    };
    const popupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7c978e5ad74fbe60$var$BreadcrumbsDropdownContent, {
            spaceKey: spaceKey,
            contentId: contentId,
            closeDropdownOnClickOfBreadcrumbItem: closeDropdownOnClickOfBreadcrumbItem,
            spaceOverviewPath: spaceOverviewPath,
            shouldDisableMoveButton: shouldDisableMoveButton,
            contentTitle: contentTitleToRender
        });
    };
    const closeDropdownOnClickOfBreadcrumbItem = ()=>{
        setIsBreadcrumbsPopupOpen(false);
    };
    const preloadBreadcrumbsDropdownOnSpaceNameHover = ()=>{
        (0, $ePiuX.preloadBreadcrumbsDropdown)({
            spaceKey: spaceKey,
            contentId: contentId
        });
    };
    const renderPopup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: isBreadcrumbsPopupOpen,
            onClose: ()=>setIsBreadcrumbsPopupOpen(false),
            placement: "bottom-start",
            content: popupContent,
            shouldRenderToParent: true,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                    id: "breadcrumbs-dropdown-chevron-button",
                    "data-testid": "breadcrumbs-dropdown-chevron-button",
                    disabled: isNetworkDisabled,
                    onClick: handleBreadcrumbDropdownTriggerClick,
                    onMouseEnter: preloadBreadcrumbsDropdownOnSpaceNameHover,
                    onFocus: preloadBreadcrumbsDropdownOnSpaceNameHover,
                    "aria-label": intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonAriaLabel),
                    ...triggerProps,
                    ...ssrPlaceholderIdProp,
                    className: (0, $hekY6.default)([
                        "_0bjKvDKxmn _30huDKjOvk _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _4c065UdnbC _2Y7lL4dnbC _3iDTPbvbI6 _0wOv4Q7zJH _3YEZNOdnbC _39xV02N91d _0KLXru66of _1UtDYzKGUX _4sSPMf98eZ _36W3EOYbGa _35OaAw6wH8 _2p7dw4KGUX _02aXbK18ZR _10n1R5ZpcK _1ubuxonXvL _34b3D2FQfX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _0CMRbky7kJ",
                        shouldOpenDropdown && "_1EqgXlGVdc _39xV02ZqHV _0yyhggaXQy",
                        displayMode === "ONLY_SPACE_NAME" && "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _1EqgXlHakr _39xV02ZqHV _0yyhggHakr",
                        displayMode === "ONLY_CONTENT_TITLE" && "_1EqgXlN91d _39HuIbz8Lp _0yyhggN91d",
                        displayMode === "HIDDEN" && "_3iDTPbYbGa"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                    alignItems: "center",
                    gap: "space.100"
                }, shouldOpenDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: !isNetworkDisabled && intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonTooltip),
                    hideTooltipOnClick: true
                }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                        xcss: [
                            $7c978e5ad74fbe60$var$chevronBaseStyles,
                            !isNetworkDisabled && $7c978e5ad74fbe60$var$chevronHoverStyles
                        ],
                        ...tooltipProps
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        size: "small"
                    }))), renderSpaceName()))
        }), shouldOpenDropdown && renderSeparator());
    const renderContentTitle = ()=>{
        const titleElement = contentLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
            href: contentLink,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgEqul _1ANEUSLRg7 _39HuIbz8Lp _4ouGXIoWWg _1UtDYzy7kJ _2nTuUYy7kJ _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMM7Tp _4scvAwy7kJ _3PnjIVYbGa"
            ])
        }, contentTitleToRender) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgEqul _1ANEUSLRg7 _39HuIbz8Lp _4ouGXIoWWg _1UtDYzy7kJ _3PnjIVYbGa"
            ])
        }, contentTitleToRender);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            id: "breadcrumbs-content-title",
            className: (0, $hekY6.default)([
                "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _23rrnHYbGa _3iDTPbQ4SZ _0hPCNLDIqT _1YKVNs7dHp _1EqgXlOAqP",
                (displayMode === "HIDDEN" || displayMode === "ONLY_SPACE_NAME") && "_1YKVNsdnbC _1EqgXldnbC",
                isModernEmbeddedConfluence && "_0LQT5E2ADO"
            ])
        }, (contentType === 'page' || contentType === 'blogpost') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
            type: contentType,
            subType: subType,
            color: "var(--ds-text, #292A2E)",
            isMarkdownMode: isMarkdownMode
        }), titleElement);
    };
    const renderSpaceName = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: "breadcrumbs-space-name",
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _39HuIbz8Lp _39xV02N91d _1ANEUSLRg7 _1EqgXlN91d",
                shouldOpenDropdown && displayMode === "FULL" && "_39HuIbZqHV",
                shouldOpenDropdown && isSpaceNameLongerThan6Letters && displayMode === "FULL" && "_3X9j4qOxvQ _4vaMcNOxvQ",
                (displayMode === "HIDDEN" || displayMode === "ONLY_CONTENT_TITLE") && "_3iDTPbYbGa"
            ])
        }, spaceName);
    };
    const renderSeparator = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: "breadcrumbs-separator",
            className: (0, $hekY6.default)([
                "_1UtDYzZpcK _1pp6NdYbGa _3YEZNOdnbC _0adFHs1Y8M _2XsHFM1Y8M",
                !showInlineRename && "_3PnjIVYbGa",
                displayMode != "FULL" && "_3iDTPbYbGa"
            ])
        }, "/");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: [
            $7c978e5ad74fbe60$var$breadcrumbsStyles,
            showInlineRename && $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles
        ],
        testId: testId,
        "data-vc": testId
    }, !isModernEmbeddedConfluence && renderPopup(), shouldShowCurrentContentTitle && renderContentTitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }));
};
const $7c978e5ad74fbe60$var$i18n = (0, $kSwu1.defineMessages)({
    breadcrumbsChevronButtonAriaLabel: {
        id: "breadcrumbs.dropdown.button.chevron.aria-label",
        defaultMessage: "Breadcrumbs"
    },
    untitledPage: {
        id: "breadcrumbs.dropdown.untitled-page.default-title",
        defaultMessage: "Untitled"
    },
    breadcrumbsChevronButtonTooltip: {
        id: "breadcrumbs.dropdown.button.chevron.tooltip",
        defaultMessage: "Show navigation path"
    }
});
module.exports["BREADCRUMBS_MODES"] = $7c978e5ad74fbe60$export$14e8342ddf0a4616;
module.exports["BreadcrumbsWithSpaceNameDropdown"] = $7c978e5ad74fbe60$export$c71a066c29807b48;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("bMPhU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $bDgLe.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<9c89aa0352f7d1dca5a5a1271100cc40>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("kqIWy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    let t3;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t3 = {
            variables: {
                spaceKey: spaceKey,
                includeSpaceTypeSettings: includeSpaceTypeSettings
            }
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    const options = t3;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), {
        ...options,
        __callerPackage__: "space-utils"
    });
    let t4;
    if ($[5] !== data || $[6] !== includeSpaceTypeSettings) {
        t4 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[5] = data;
        $[6] = includeSpaceTypeSettings;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== error || $[9] !== loading || $[10] !== t4) {
        t5 = {
            loading: loading,
            data: t4,
            error: error
        };
        $[8] = error;
        $[9] = loading;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("gfIPU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("LSims", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $aJUpe = parcelRequire("aJUpe");


var $4Pmcr = parcelRequire("4Pmcr");

const $450638ee7a6e2e59$export$ec80b976b56288ba = (contentId)=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $aJUpe.default), {
        variables: {
            contentId: contentId ?? '',
            isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)
        },
        fetchPolicy: 'cache-only',
        skip: !contentId || !(0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
        __callerPackage__: "content-markdown-mode"
    });
    return (0, $4Pmcr.getIsMarkdownModeFromData)(data);
};
module.exports["useIsMarkdownMode"] = $450638ee7a6e2e59$export$ec80b976b56288ba;

});

parcelRegister("aJUpe", function(module, exports) {
/**
 * @generated SignedSource<<97f042394447b34381d2572432982113>>
 * @relayHash 8ee1f0cde2475ae17a8f029f978204ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971
const $1180c416e2ce3051$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isMarkdownModeEnabled"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isMarkdownModeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isMarkdownMode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8ee1f0cde2475ae17a8f029f978204ad",
            "id": "1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971",
            "metadata": {},
            "name": "IsMarkdownModeQuery",
            "operationKind": "query",
            "text": "query IsMarkdownModeQuery($contentId:ID!,$isMarkdownModeEnabled:Boolean=false){content(id:$contentId){nodes{id,contentProperties{latest{isMarkdownMode@include(if:$isMarkdownModeEnabled)}}}}}"
        }
    };
}();
$1180c416e2ce3051$var$node.hash = "65f92bc360aa57691987c1aba7d545ca";
var $1180c416e2ce3051$export$2e2bcd8739ae039 = $1180c416e2ce3051$var$node;
module.exports["default"] = $1180c416e2ce3051$export$2e2bcd8739ae039;

});

parcelRegister("4Pmcr", function(module, exports) {
const $70bbf1741b7230f7$export$6bc4ac71fcf3f02a = (data)=>{
    return data?.content?.nodes?.[0]?.contentProperties?.latest?.isMarkdownMode ?? false;
};
module.exports["getIsMarkdownModeFromData"] = $70bbf1741b7230f7$export$6bc4ac71fcf3f02a;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kLlYX = parcelRequire("kLlYX");


var $cow67 = parcelRequire("cow67");


var $3gdp3 = parcelRequire("3gdp3");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $2hJf7 = parcelRequire("2hJf7");


var $9zxkL = parcelRequire("9zxkL");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $5tsXU = parcelRequire("5tsXU");


var $hT3jf = parcelRequire("hT3jf");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) {
        let t3;
        if ($[4] !== color) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
                label: "",
                size: "small",
                color: color,
                testId: "icons.content-icon.label.managed-folder"
            });
            $[4] = color;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    const actualType = isLivePage && isMarkdownMode ? "markdown" : isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t3;
    if ($[6] !== Icon || $[7] !== color || $[8] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[6] = Icon;
        $[7] = color;
        $[8] = label.id;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
        label: "",
        size: "small",
        color: color,
        testId: "icons.content-icon.label.managed-folder"
    });
    const actualType = isLivePage && isMarkdownMode ? 'markdown' : isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    },
    markdown: {
        id: "icons.content-icon.label.markdown",
        defaultMessage: "Markdown"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gdp3))),
        label: $b2e0c504f331f5cc$var$i18n.note
    },
    markdown: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cow67))),
        label: $b2e0c504f331f5cc$var$i18n.markdown
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53807950cf9f28638ee48a6f68a59d1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_baseNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("cow67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116487cb0b813d32319987cd91f03acd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90609fd80a141ebe$var$_react = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $90609fd80a141ebe$var$_baseNew = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("gElAV")));
function $90609fd80a141ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/file-markdown
 * Usage guidance:
 * Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90609fd80a141ebe$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $90609fd80a141ebe$var$_react.default.createElement($90609fd80a141ebe$var$_baseNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$90609fd80a141ebe$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $90609fd80a141ebe$var$_default = module.exports.default = $90609fd80a141ebe$var$FileMarkdownIcon;

});

parcelRegister("3gdp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6311da47ce726fc7626619a6b7c14fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd434ab2c22b25$var$_react = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25fd434ab2c22b25$var$_baseNew = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("gElAV")));
function $25fd434ab2c22b25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/notepad
 * Usage guidance:
 * Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd434ab2c22b25$var$NotepadIcon = (props)=>/*#__PURE__*/ $25fd434ab2c22b25$var$_react.default.createElement($25fd434ab2c22b25$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$25fd434ab2c22b25$var$NotepadIcon.displayName = 'NotepadIcon';
var $25fd434ab2c22b25$var$_default = module.exports.default = $25fd434ab2c22b25$var$NotepadIcon;

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58786e80764588d2fd870a7346986359>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_baseNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-slides
 * Usage guidance:
 * Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("f0Ro4"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_2uo31fGsB2 _0bjKvDzXzM _2XghbEPgdg _3iDTPbvbI6 _0Of8r2Pgdg"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("f0Ro4", function(module, exports) {

let $aee044b04541a437$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aee044b04541a437$var$load("g81ly"),
    $aee044b04541a437$var$load("e3LAK"),
    $aee044b04541a437$var$load("eS3wT"),
    $aee044b04541a437$var$load("4uO8Y"),
    $aee044b04541a437$var$load("26l7c"),
    $aee044b04541a437$var$load("6wr18"),
    $aee044b04541a437$var$load("ffEVr"),
    $aee044b04541a437$var$load("4Ldt2"),
    $aee044b04541a437$var$load("4izLy"),
    $aee044b04541a437$var$load("fEWss"),
    $aee044b04541a437$var$load("ceGPg"),
    $aee044b04541a437$var$load("953Uz"),
    $aee044b04541a437$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $4xiow = parcelRequire("4xiow");


var $drRzc = parcelRequire("drRzc");


var $anBbz = parcelRequire("anBbz");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            if ((0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                // Skip SSR for nodes without an Id
                if (!node.attrs.id) return undefined;
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    id: node.attrs.id,
                    shortName: node.attrs.shortName,
                    fallback: node.attrs.text,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    },
                    searchable: true,
                    type: '',
                    category: ''
                };
            }
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // For STANDARD emojis, return a UnicodeRepresentation so they are rendered
            // as native text characters rather than images (twemoji removal).
            if (node.attrs.id && result && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    ...result,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    }
                };
            }
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.updateCache(ssrData, {
            strategy: 'replace',
            source: 'ssr'
        });
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.updateCache({
                    [dataKey]: data
                }, {
                    strategy: 'merge',
                    source: 'network'
                });
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("5tsXU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Custom icon for a managed (synced) closed folder.
 * Renders a folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $3216f3fcd316d4ef$export$75f34eec99819e9c = ({ label: label, size: size = 'medium', color: color, testId: testId })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": testId,
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.31055 2.75H13C14.1046 2.75 15 3.64543 15 4.75V10H13.5V7.5H2.5V13C2.5 13.2761 2.72386 13.5 3 13.5H10V15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H6.56055L8.31055 2.75ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V6H13.5V4.75C13.5 4.47386 13.2761 4.25 13 4.25H7.68945L5.93945 2.5H3Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderClosedIcon"] = $3216f3fcd316d4ef$export$75f34eec99819e9c;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("1jQpq", function(module, exports) {

var $lTECB = parcelRequire("lTECB");


var $cxu5H = parcelRequire("cxu5H");

const $951eaa69b00dd6e9$export$f183b986124d184 = ()=>{
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasModernHeader: hasModernHeader } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    return isEmbeddedConfluence && hasModernHeader;
};
module.exports["useEmbeddedModernHeader"] = $951eaa69b00dd6e9$export$f183b986124d184;

});

parcelRegister("cxu5H", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $4PNpW.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("36Uax", function(module, exports) {

var $bVevd = parcelRequire("bVevd");


var $kTPbu = parcelRequire("kTPbu");

var $dcf2160d889b63fd$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $dcf2160d889b63fd$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$var$pageAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$blogPostAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$whiteboardAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard
};
const $dcf2160d889b63fd$var$contentTypeAllowedFeatures = {
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $dcf2160d889b63fd$var$pageAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $dcf2160d889b63fd$var$blogPostAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $dcf2160d889b63fd$var$whiteboardAllowedFeatures
};
const $dcf2160d889b63fd$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$dcf2160d889b63fd$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $dcf2160d889b63fd$export$3207c60940c4a9b0;

});

parcelRegister("bVevd", function(module, exports) {
var $3914485ee940289d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $3914485ee940289d$export$816ef638e478449a;

});

parcelRegister("kTPbu", function(module, exports) {
var $eaa06f5f4964dde1$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $eaa06f5f4964dde1$export$942a5fac9b8c9dc2;

});

parcelRegister("4PNpW", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

const $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40 = (0, $36Uax.ALLOWED_FEATURES).view;
const $ff056bb0ad02bd7c$export$2c7469b01e61fde2 = (0, $36Uax.ALLOWED_FEATURES).edit;
const $ff056bb0ad02bd7c$export$72afc086e90eb0bf = (0, $36Uax.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $ff056bb0ad02bd7c$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1eD4P = parcelRequire("1eD4P");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $cozmU.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $cozmU.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("ePiuX", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $f4Qot = parcelRequire("f4Qot");

function $e956eba1dd4bb7db$export$e5d3f19aa88b9c61({ spaceKey: spaceKey, contentId: contentId }) {
    return (0, $dYU3e.query)({
        query: (0, $f4Qot.default),
        variables: {
            spaceKey: spaceKey,
            contentId: contentId,
            skipContent: !contentId
        },
        __callerPackage__: "breadcrumbs"
    });
}
module.exports["preloadBreadcrumbsDropdown"] = $e956eba1dd4bb7db$export$e5d3f19aa88b9c61;

});

parcelRegister("dYU3e", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $iffSy = parcelRequire("iffSy");



var $7Lnfv = parcelRequire("7Lnfv");


var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$addExtraInfoToError = (error, extraInfo)=>{
    try {
        const existingExtraInfo = Reflect.get(error, 'extraInfo');
        const existingExtraInfoObject = typeof existingExtraInfo === 'object' && existingExtraInfo !== null ? existingExtraInfo : undefined;
        Reflect.set(error, 'extraInfo', {
            ...existingExtraInfoObject,
            ...extraInfo
        });
    } catch  {
    // Some error shapes can be non-extensible. Extra info is best-effort diagnostics.
    }
};
const $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors = (errors, extraInfo)=>{
    errors?.forEach((error)=>{
        $48ba6fb41a85dc7e$var$addExtraInfoToError(error, extraInfo);
    });
};
const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT, __callerPackage__: __callerPackage__ }) {
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch({ isForAggOnly: true })
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client?.__isAGGClient === true;
    const preloaderErrorExtraInfo = {
        operationName: name ?? 'unknown',
        callerPackage: __callerPackage__
    };
    const queryContext = {
        ...context
    };
    // Only add atl-attribution header if AGG migration feature gate is enabled
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) queryContext.headers = {
        ...context?.headers,
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    return (0, $c0rhi.queryInterop)({
        query: _query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext,
        interopApolloAggClient: isForAggOnly,
        __callerPackage__: __callerPackage__
    }).then((result)=>{
        const errors = result.error?.graphQLErrors;
        if (result.error) $48ba6fb41a85dc7e$var$addExtraInfoToError(result.error, preloaderErrorExtraInfo);
        $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors(errors, preloaderErrorExtraInfo);
        const interopResult = {
            data: result.data,
            errors: errors
        };
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(interopResult);
        return {
            data: result.data ?? null,
            errors: errors,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)(options.__callerPackage__)) (0, $fEmGS.writeQueryInterop)({
        ...options,
        __callerPackage__: options.__callerPackage__
    });
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("f4Qot", function(module, exports) {
/**
 * @generated SignedSource<<316873462d81660513b39d3d9a706212>>
 * @relayHash eacc72b6f9ecbeb5ab52a1b74d6064a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4
const $ef0655697d43d9a3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipContent"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "condition": "skipContent",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "current",
                                "draft",
                                "archived"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "emoji-title-published",
                                                "emoji-title-draft"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v7 /*: any*/ ,
                                    "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                                },
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "emoji-title-published"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": v7 /*: any*/ ,
                                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BreadcrumbsDropdownContentQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BreadcrumbsDropdownContentQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "eacc72b6f9ecbeb5ab52a1b74d6064a5",
            "id": "4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4",
            "metadata": {},
            "name": "BreadcrumbsDropdownContentQuery",
            "operationKind": "query",
            "text": "query BreadcrumbsDropdownContentQuery($spaceKey:String!,$contentId:ID,$skipContent:Boolean!){space(key:$spaceKey){alias,id,name,icon{path},homepage{id}},content(id:$contentId,status:[\"current\",\"draft\",\"archived\"])@skip(if:$skipContent){nodes{id,type,subType,status,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},ancestors{id,type,subType,title,status,properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}}"
        }
    };
}();
$ef0655697d43d9a3$var$node.hash = "3e4a9d4b445d7d646b220e3bab421884";
var $ef0655697d43d9a3$export$2e2bcd8739ae039 = $ef0655697d43d9a3$var$node;
module.exports["default"] = $ef0655697d43d9a3$export$2e2bcd8739ae039;

});

parcelRegister("hzkzq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b055c0b5c16164d3$export$41b2e06f27dfe96e = 'archived';
const $b055c0b5c16164d3$export$6b45500787cf696 = ({ contentId: contentId, contentSlug: contentSlug, contentType: contentType, isSpaceOverview: isSpaceOverview, query: query, spaceAlias: spaceAlias, spaceKey: spaceKey })=>{
    if (contentType === 'folder') {
        if (!contentId) return '#';
        return (0, $1NBp8.FOLDER_VIEW).toUrl({
            contentId: contentId,
            spaceKey: spaceAlias || spaceKey
        });
    }
    let route;
    if (isSpaceOverview) route = (0, $1NBp8.SPACE_OVERVIEW);
    else switch(contentType){
        case 'blogpost':
            route = (0, $1NBp8.VIEW_BLOG);
            break;
        case 'page':
            route = (0, $1NBp8.VIEW_PAGE);
            break;
        case 'whiteboard':
            route = (0, $1NBp8.WHITEBOARD_BOARD);
            break;
        case 'slide':
            route = (0, $1NBp8.SLIDES_VIEW);
            break;
        case 'database':
            route = (0, $1NBp8.DATABASE_VIEW);
            break;
        case 'embed':
            route = (0, $1NBp8.EMBED_VIEW);
            break;
        default:
            throw new Error(`Received an unexpected content type: '${contentType}'`);
    }
    return route.toUrl({
        contentId: contentId,
        contentSlug: contentSlug,
        spaceKey: spaceAlias || spaceKey
    }, {
        query: query
    });
};
const $b055c0b5c16164d3$export$d3865786a3f7be67 = ({ ancestors: ancestors, status: status }, spaceHomepageId)=>{
    if (!ancestors) return [];
    // If current page is archived, filter out non-archived ancestors
    if (status === $b055c0b5c16164d3$export$41b2e06f27dfe96e) ancestors = ancestors.filter((ancestor)=>ancestor && ancestor.status === $b055c0b5c16164d3$export$41b2e06f27dfe96e);
    else // technically array elements can be null
    ancestors = ancestors.filter((node)=>node);
    // Filter out ancestors with null type
    ancestors = ancestors.filter((node)=>{
        if (!node) return false;
        if (!node.type) return false;
        return true;
    });
    // Filter out ancestors with null id to prevent TypeError from path-to-regexp
    ancestors = ancestors.filter((node)=>node && node.id);
    if (!ancestors.length) return ancestors;
    if (ancestors[0].id !== spaceHomepageId && ancestors[ancestors.length - 1].id === spaceHomepageId) return [
        ...ancestors
    ].reverse().slice(1);
    if (ancestors[0].id === spaceHomepageId) return ancestors.slice(1);
    return ancestors;
};
const $b055c0b5c16164d3$export$f6641c501f8a1aee = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$e1cb12562674727b = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$52c8bba571728790 = (textRef)=>{
    if (textRef.current) return textRef.current.scrollWidth > textRef.current.clientWidth;
    return false;
};
module.exports["buildContentPath"] = $b055c0b5c16164d3$export$6b45500787cf696;
module.exports["filterAncestors"] = $b055c0b5c16164d3$export$d3865786a3f7be67;
module.exports["getEmojiFromPublishedPageProperties"] = $b055c0b5c16164d3$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $b055c0b5c16164d3$export$e1cb12562674727b;
module.exports["getIsTextTruncated"] = $b055c0b5c16164d3$export$52c8bba571728790;

});

parcelRegister("d0aff", function(module, exports) {

let $977338e5fa9ab604$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $977338e5fa9ab604$var$load("cH8yZ"),
    $977338e5fa9ab604$var$load("6wr18"),
    $977338e5fa9ab604$var$load("ffEVr"),
    $977338e5fa9ab604$var$load("7EorR"),
    $977338e5fa9ab604$var$load("1GyAj")
]).then(()=>parcelRequire('auDgK'));

});

parcelRegister("5PKaL", function(module, exports) {

let $43f5881612af494e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $43f5881612af494e$var$load("6wr18"),
    $43f5881612af494e$var$load("ffEVr"),
    $43f5881612af494e$var$load("hhss7"),
    $43f5881612af494e$var$load("Wowvf"),
    $43f5881612af494e$var$load("b6JBs")
]).then(()=>parcelRequire('g3Wvh'));

});

parcelRegister("7boqA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $knAY5 = parcelRequire("knAY5");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $cozmU.useCallback)(()=>{
        (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("bFMG7", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $5dyIT = parcelRequire("5dyIT");


var $cod3r = parcelRequire("cod3r");


var $79mss = parcelRequire("79mss");


var $XKAGD = parcelRequire("XKAGD");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $7Sm4c = parcelRequire("7Sm4c");


var $e4o8D = parcelRequire("e4o8D");


var $308Wd = parcelRequire("308Wd");

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $1cYlh = parcelRequire("1cYlh");


var $in5LX = parcelRequire("in5LX");


var $kknEZ = parcelRequire("kknEZ");


var $gSfo4 = parcelRequire("gSfo4");


var $fcQxC = parcelRequire("fcQxC");


var $lwZTW = parcelRequire("lwZTW");

const $8f8b1f599c43d665$export$13c9dac546825a9c = (0, $XKAGD.default);
const $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery = (0, $79mss.default);
const $8f8b1f599c43d665$export$160e6dbb5cf9582 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus } = t0;
    let t1;
    let t2;
    if ($[0] !== flagStatus || $[1] !== setClassification || $[2] !== setFlagStatus || $[3] !== submittedClassification) {
        t1 = ()=>{
            if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
                setClassification(submittedClassification ?? null);
                setFlagStatus((0, $in5LX.FlagStatus).NONE);
            }
        };
        t2 = [
            flagStatus,
            submittedClassification,
            setClassification,
            setFlagStatus
        ];
        $[0] = flagStatus;
        $[1] = setClassification;
        $[2] = setFlagStatus;
        $[3] = submittedClassification;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus })=>{
    // Updates the classification state with the value of submittedClassification
    // on flag success, ensuring consistent behavior across edit tag & edit modal
    (0, $cozmU.useEffect)(()=>{
        if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
            setClassification(submittedClassification ?? null);
            setFlagStatus((0, $in5LX.FlagStatus).NONE);
        }
    }, [
        flagStatus,
        submittedClassification,
        setClassification,
        setFlagStatus
    ]);
};
/**
 *
 * @param contentId
 * @param spaceKeyOverride
 * @param contentStatusContext
 * @param shouldSkipQueries
 * @returns
 * 1) Content's classification level by contentId & by spaceId,
 * 2) Mutation functions for updating & deleting the content's classification,
 * 3) Flag status for rendering error flag upon updating classification.
 */ const $8f8b1f599c43d665$var$useContentClassificationMetadata = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { contentId: contentId, contentStatusContext: t1, shouldReadFromQueries: t2, classificationLevelDetails: classificationLevelDetails, contentLevelLoading: t3, contentLevelError: contentLevelError } = t0;
    const contentStatusContext = t1 === undefined ? "current-only" : t1;
    const shouldReadFromQueries = t2 === undefined ? false : t2;
    const contentLevelLoading = t3 === undefined ? false : t3;
    const [flagStatus, setFlagStatus] = (0, $cozmU.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $cozmU.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $cozmU.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $cozmU.useState)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t4;
    if ($[0] !== contentStatusContext) {
        t4 = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
        $[0] = contentStatusContext;
        $[1] = t4;
    } else t4 = $[1];
    const { readContext: contentStatusReadContext } = t4;
    let t5;
    if ($[2] !== flagStatus || $[3] !== submittedClassification) {
        t5 = {
            flagStatus: flagStatus,
            submittedClassification: submittedClassification,
            setClassification: setClassification,
            setFlagStatus: setFlagStatus
        };
        $[2] = flagStatus;
        $[3] = submittedClassification;
        $[4] = t5;
    } else t5 = $[4];
    $8f8b1f599c43d665$export$160e6dbb5cf9582(t5);
    let t6;
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        };
        t7 = (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[5] = t6;
        $[6] = t7;
    } else {
        t6 = $[5];
        t7 = $[6];
    }
    let t8;
    if ($[7] !== contentId || $[8] !== contentStatusReadContext) {
        t8 = {
            awaitRefetchQueries: true,
            onError: t6,
            onCompleted: t7,
            refetchQueries: ()=>[
                    {
                        query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                        variables: {
                            contentId: contentId,
                            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                        }
                    }
                ]
        };
        $[7] = contentId;
        $[8] = contentStatusReadContext;
        $[9] = t8;
    } else t8 = $[9];
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        ...t8,
        __callerPackage__: "data-classification"
    });
    let t10;
    let t9;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        };
        t10 = (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[10] = t10;
        $[11] = t9;
    } else {
        t10 = $[10];
        t9 = $[11];
    }
    let t11;
    if ($[12] !== contentId || $[13] !== contentStatusReadContext) {
        t11 = {
            awaitRefetchQueries: true,
            onError: t9,
            onCompleted: t10,
            refetchQueries: ()=>[
                    {
                        query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                        variables: {
                            contentId: contentId,
                            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                        }
                    }
                ]
        };
        $[12] = contentId;
        $[13] = contentStatusReadContext;
        $[14] = t11;
    } else t11 = $[14];
    const [deleteContentDataClassificationLevel, t12] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        ...t11,
        __callerPackage__: "data-classification"
    });
    const { loading: deleteLoading } = t12;
    const contentClassification = classificationLevelDetails?.classificationLevel;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === "CONTENT";
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    let t13;
    let t14;
    if ($[15] !== classification || $[16] !== contentId || $[17] !== updatedClassification) {
        t13 = ()=>{
            if (updatedClassification !== classification) {
                setClassification(updatedClassification ?? null);
                setCurrentContentId(contentId);
            }
        };
        t14 = [
            updatedClassification,
            classification,
            contentId
        ];
        $[15] = classification;
        $[16] = contentId;
        $[17] = updatedClassification;
        $[18] = t13;
        $[19] = t14;
    } else {
        t13 = $[18];
        t14 = $[19];
    }
    (0, $cozmU.useEffect)(t13, t14);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    let t15;
    if ($[20] !== classificationLevelDetails?.isReclassificationPermitted) {
        t15 = (classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false);
        $[20] = classificationLevelDetails?.isReclassificationPermitted;
        $[21] = t15;
    } else t15 = $[21];
    const isReclassificationPermitted = t15;
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    const t16 = classificationValue ?? null;
    const t17 = classificationLevelDetails?.source;
    const t18 = classificationLevelDetails?.canManageSpaceSettings;
    const t19 = classificationLevelDetails?.classificationControlSetting;
    const t20 = classificationLevelDetails?.userOverrideSetting;
    let t21;
    if ($[22] !== classificationFeatureEnabled || $[23] !== contentLevelError || $[24] !== contentLevelLoading || $[25] !== contentStatusContext || $[26] !== deleteContentDataClassificationLevel || $[27] !== errorState || $[28] !== flagStatus || $[29] !== hasNoClassification || $[30] !== isReclassificationPermitted || $[31] !== shouldDisplayClassification || $[32] !== spaceDefaultIsOverridden || $[33] !== t16 || $[34] !== t17 || $[35] !== t18 || $[36] !== t19 || $[37] !== t20 || $[38] !== updateContentDataClassificationLevel) {
        t21 = {
            classification: t16,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: t17,
            canManageSpaceSettings: t18,
            classificationControlSetting: t19,
            userOverrideSetting: t20
        };
        $[22] = classificationFeatureEnabled;
        $[23] = contentLevelError;
        $[24] = contentLevelLoading;
        $[25] = contentStatusContext;
        $[26] = deleteContentDataClassificationLevel;
        $[27] = errorState;
        $[28] = flagStatus;
        $[29] = hasNoClassification;
        $[30] = isReclassificationPermitted;
        $[31] = shouldDisplayClassification;
        $[32] = spaceDefaultIsOverridden;
        $[33] = t16;
        $[34] = t17;
        $[35] = t18;
        $[36] = t19;
        $[37] = t20;
        $[38] = updateContentDataClassificationLevel;
        $[39] = t21;
    } else t21 = $[39];
    return t21;
} : ({ contentId: contentId, contentStatusContext: contentStatusContext = 'current-only', shouldReadFromQueries: shouldReadFromQueries = false, classificationLevelDetails: classificationLevelDetails, contentLevelLoading: contentLevelLoading = false, contentLevelError: contentLevelError })=>{
    const [flagStatus, setFlagStatus] = (0, $cozmU.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $cozmU.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $cozmU.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $cozmU.useState)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    $8f8b1f599c43d665$export$160e6dbb5cf9582({
        flagStatus: flagStatus,
        submittedClassification: submittedClassification,
        setClassification: setClassification,
        setFlagStatus: setFlagStatus
    });
    // The following two mutation functions are returned by this hook, behavior upon completion is handled within the hook
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        awaitRefetchQueries: true,
        onError: (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        },
        onCompleted: (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ],
        __callerPackage__: "data-classification"
    });
    const [deleteContentDataClassificationLevel, { loading: deleteLoading }] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        awaitRefetchQueries: true,
        onError: (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        },
        onCompleted: (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ],
        __callerPackage__: "data-classification"
    });
    const contentClassification = classificationLevelDetails?.classificationLevel;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === 'CONTENT';
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    // Determine whether to set classification either content level classification, or space default classification, or null through a series of booleans.
    // Cases where we should not display content classification:
    // 1. If "No classification" option is selected as content classification
    // 2. If content classification was archived
    // 3. If classification value from state hook is null (i.e. classification was deleted) and delete mutation is still loading
    // 4. If delete was successful and classification value from state hook is null
    // 5. If there was an error fetching content level classification
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    // This ternary determines whether to display content classification value from query or from state hook.
    // Checks whether content ID has changed since the last render, and if it has then we display the classification value from query.
    // (Resolves bug where classification wasn't properly updating when navigating between pages via page tree)
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    // Ultimately, we'll be displaying one of the two values as a content's current classification (in order of priority):
    // 1. Content level classification
    // 2. No classification (may render Add Classification button instead)
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    (0, $cozmU.useEffect)(()=>{
        if (updatedClassification !== classification) {
            setClassification(updatedClassification ?? null);
            setCurrentContentId(contentId);
        }
    }, [
        updatedClassification,
        classification,
        contentId
    ]);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    const isReclassificationPermitted = (classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)('dlp_auto_classifications_enabled', 'isEnabled', false);
    //useEffect is not run during SSR, so we can't use classification from the state.
    //we cant use setClassification either as it causes side effects which causes unnecessary re-renders.
    //Instead, we can use updatedClassification for initial load for SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    return (0, $cozmU.useMemo)(()=>({
            classification: classificationValue ?? null,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: classificationLevelDetails?.source,
            canManageSpaceSettings: classificationLevelDetails?.canManageSpaceSettings,
            classificationControlSetting: classificationLevelDetails?.classificationControlSetting,
            userOverrideSetting: classificationLevelDetails?.userOverrideSetting
        }), [
        classificationValue,
        spaceDefaultIsOverridden,
        contentLevelLoading,
        contentLevelError,
        updateContentDataClassificationLevel,
        deleteContentDataClassificationLevel,
        setSubmittedClassification,
        flagStatus,
        setFlagStatus,
        errorState,
        shouldDisplayClassification,
        hasNoClassification,
        contentStatusContext,
        classificationFeatureEnabled,
        isReclassificationPermitted,
        classificationLevelDetails
    ]);
};
const $8f8b1f599c43d665$export$e948ce957637ade5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { contentId: contentId, contentStatusContext: t1, shouldSkipQueries: t2, shouldPreloadData: t3, shouldReadFromQueries: t4 } = t0;
    const contentStatusContext = t1 === undefined ? "current-only" : t1;
    const shouldSkipQueries = t2 === undefined ? false : t2;
    const shouldPreloadData = t3 === undefined ? false : t3;
    const shouldReadFromQueries = t4 === undefined ? false : t4;
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    let shouldSkipQueriesForClassification;
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[0] !== contentId || $[1] !== contentStatusContext || $[2] !== shouldSkipQueries) {
        const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
        shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
        t7 = (0, $jMyy4.useQueryInterop);
        t8 = $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery;
        t5 = contentId ?? "";
        t6 = (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext);
        $[0] = contentId;
        $[1] = contentStatusContext;
        $[2] = shouldSkipQueries;
        $[3] = shouldSkipQueriesForClassification;
        $[4] = t5;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
    } else {
        shouldSkipQueriesForClassification = $[3];
        t5 = $[4];
        t6 = $[5];
        t7 = $[6];
        t8 = $[7];
    }
    let t9;
    if ($[8] !== t5 || $[9] !== t6) {
        t9 = {
            contentId: t5,
            lowerCaseContentStatusArray: t6
        };
        $[8] = t5;
        $[9] = t6;
        $[10] = t9;
    } else t9 = $[10];
    const t10 = shouldPreloadContentClassificationData ? "cache-first" : "network-only";
    let t11;
    if ($[11] !== shouldSkipQueriesForClassification || $[12] !== t10 || $[13] !== t9) {
        t11 = {
            variables: t9,
            skip: shouldSkipQueriesForClassification,
            errorPolicy: "all",
            fetchPolicy: t10
        };
        $[11] = shouldSkipQueriesForClassification;
        $[12] = t10;
        $[13] = t9;
        $[14] = t11;
    } else t11 = $[14];
    const { data: objectLevelData, loading: objectLevelLoading, error: objectLevelError } = t7(t8, t11);
    const t12 = objectLevelData?.singleContent?.classificationLevelDetails;
    let t13;
    if ($[15] !== contentId || $[16] !== contentStatusContext || $[17] !== objectLevelError || $[18] !== objectLevelLoading || $[19] !== shouldReadFromQueries || $[20] !== t12) {
        t13 = {
            contentId: contentId,
            contentStatusContext: contentStatusContext,
            shouldReadFromQueries: shouldReadFromQueries,
            classificationLevelDetails: t12,
            contentLevelLoading: objectLevelLoading,
            contentLevelError: objectLevelError
        };
        $[15] = contentId;
        $[16] = contentStatusContext;
        $[17] = objectLevelError;
        $[18] = objectLevelLoading;
        $[19] = shouldReadFromQueries;
        $[20] = t12;
        $[21] = t13;
    } else t13 = $[21];
    return $8f8b1f599c43d665$var$useContentClassificationMetadata(t13);
} : ({ contentId: contentId, contentStatusContext: contentStatusContext = 'current-only', shouldSkipQueries: shouldSkipQueries = false, shouldPreloadData: shouldPreloadData = false, shouldReadFromQueries: shouldReadFromQueries = false })=>{
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    const shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
    const { data: objectLevelData, loading: objectLevelLoading, error: objectLevelError } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery, {
        variables: {
            contentId: contentId ?? '',
            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
        },
        skip: shouldSkipQueriesForClassification,
        errorPolicy: 'all',
        fetchPolicy: shouldPreloadContentClassificationData ? 'cache-first' : 'network-only',
        __callerPackage__: "data-classification"
    });
    return $8f8b1f599c43d665$var$useContentClassificationMetadata({
        contentId: contentId,
        contentStatusContext: contentStatusContext,
        shouldReadFromQueries: shouldReadFromQueries,
        classificationLevelDetails: objectLevelData?.singleContent?.classificationLevelDetails,
        contentLevelLoading: objectLevelLoading,
        contentLevelError: objectLevelError
    });
};
const $8f8b1f599c43d665$export$587e979724cc80f9 = ({ contentId: contentId, contentFragmentRef: contentFragmentRef, contentStatusContext: contentStatusContext = 'current-only', shouldReadFromQueries: shouldReadFromQueries = false })=>{
    const content = (0, $6SsN4.useFragment)($8f8b1f599c43d665$export$13c9dac546825a9c, contentFragmentRef);
    return $8f8b1f599c43d665$var$useContentClassificationMetadata({
        contentId: contentId,
        contentStatusContext: contentStatusContext,
        shouldReadFromQueries: shouldReadFromQueries,
        classificationLevelDetails: content?.classificationLevelDetails
    });
};
module.exports["useContentClassification"] = $8f8b1f599c43d665$export$e948ce957637ade5;
module.exports["useContentClassificationFromFragment"] = $8f8b1f599c43d665$export$587e979724cc80f9;

});

parcelRegister("5dyIT", function(module, exports) {
/**
 * @generated SignedSource<<20621d8c8d7d7f709ac76a84782dff9d>>
 * @relayHash ee02cd6160cc1cfee6fa6d1fba84a159
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2
const $916e4ca779bc282e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkDeleteContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkDeleteContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ee02cd6160cc1cfee6fa6d1fba84a159",
            "id": "4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2",
            "metadata": {},
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkDeleteContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!){bulkDeleteContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses}){success,errors{message}}}"
        }
    };
}();
$916e4ca779bc282e$var$node.hash = "482a842e925e6082fc32c6749e95ba4b";
var $916e4ca779bc282e$export$2e2bcd8739ae039 = $916e4ca779bc282e$var$node;
module.exports["default"] = $916e4ca779bc282e$export$2e2bcd8739ae039;

});

parcelRegister("cod3r", function(module, exports) {
/**
 * @generated SignedSource<<45eb54206aa80f8b681379fd99d07765>>
 * @relayHash e435d6d2ef1fb5eebfc9d5c505f1e65c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba
const $cca7f8f2e7a5e122$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "classificationLevelId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "classificationLevelId",
                            "variableName": "classificationLevelId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkUpdateContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkUpdateContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "e435d6d2ef1fb5eebfc9d5c505f1e65c",
            "id": "c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba",
            "metadata": {},
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkUpdateContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!,$classificationLevelId:ID!){bulkUpdateContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses,classificationLevelId:$classificationLevelId}){success,errors{message}}}"
        }
    };
}();
$cca7f8f2e7a5e122$var$node.hash = "9839fe96ab36e63f6aab91bb7d0d00f7";
var $cca7f8f2e7a5e122$export$2e2bcd8739ae039 = $cca7f8f2e7a5e122$var$node;
module.exports["default"] = $cca7f8f2e7a5e122$export$2e2bcd8739ae039;

});

parcelRegister("79mss", function(module, exports) {
/**
 * @generated SignedSource<<217ed72306ad0003c83611da9b9dfec7>>
 * @relayHash 02343eb4ab11fc6471bc117cd9c349d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d
const $22165adc85ae14ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "guidelineADF"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canManageSpaceSettings"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "classificationControlSetting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userOverrideSetting"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "02343eb4ab11fc6471bc117cd9c349d2",
            "id": "2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d",
            "metadata": {},
            "name": "useContentClassificationContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
        }
    };
}();
$22165adc85ae14ea$var$node.hash = "e2a3c90b94181436fe0a32faafb92cf6";
var $22165adc85ae14ea$export$2e2bcd8739ae039 = $22165adc85ae14ea$var$node;
module.exports["default"] = $22165adc85ae14ea$export$2e2bcd8739ae039;

});

parcelRegister("XKAGD", function(module, exports) {
/**
 * @generated SignedSource<<c86a4702e708a7bdd62c2dba894d220a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $162d832ed06b75d0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useContentClassification_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "ClassificationLevelDetails",
                "kind": "LinkedField",
                "name": "classificationLevelDetails",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentDataClassificationLevel",
                        "kind": "LinkedField",
                        "name": "classificationLevel",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "guideline"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "guidelineADF"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "description"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "color"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "featureEnabled"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "source"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isReclassificationPermitted"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "canManageSpaceSettings"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "classificationControlSetting"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "userOverrideSetting"
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$162d832ed06b75d0$var$node.hash = "c8de016d394e3db37049853fe1de9452";
var $162d832ed06b75d0$export$2e2bcd8739ae039 = $162d832ed06b75d0$var$node;
module.exports["default"] = $162d832ed06b75d0$export$2e2bcd8739ae039;

});

parcelRegister("1cYlh", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $kknEZ = parcelRequire("kknEZ");

const $e02e634ce8a36ce5$export$44086dc4ad5eb01b = 'NO_CLASSIFICATION';
const $e02e634ce8a36ce5$export$ea52aaec0b4536b2 = 'NO_CLASSIFICATION_OPTION';
const $e02e634ce8a36ce5$export$89b67151eed9295a = {
    id: $e02e634ce8a36ce5$export$ea52aaec0b4536b2,
    name: 'No default',
    order: 0,
    definition: "Pages in this space aren\u2019t classified by default.",
    color: 'NONE',
    status: (0, $kknEZ.Status).PUBLISHED
};
const $e02e634ce8a36ce5$export$de715bd2818cd084 = (0, $kSwu1.defineMessages)({
    name: {
        id: "data-classification.no-classification.content-name",
        defaultMessage: "No classification"
    },
    definition: {
        id: "data-classification.no-classification.content-definition",
        defaultMessage: "Content is not classified."
    }
});
const $e02e634ce8a36ce5$var$getDefaultMessage = (descriptor)=>typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : '';
const $e02e634ce8a36ce5$export$59df3feebe765454 = (formatMessage)=>({
        id: $e02e634ce8a36ce5$export$ea52aaec0b4536b2,
        name: formatMessage($e02e634ce8a36ce5$export$de715bd2818cd084.name),
        order: 0,
        definition: formatMessage($e02e634ce8a36ce5$export$de715bd2818cd084.definition),
        color: 'GREY',
        status: (0, $kknEZ.Status).PUBLISHED
    });
const $e02e634ce8a36ce5$export$2589b5a314728bad = $e02e634ce8a36ce5$export$59df3feebe765454($e02e634ce8a36ce5$var$getDefaultMessage);
module.exports["NO_CLASSIFICATION"] = $e02e634ce8a36ce5$export$44086dc4ad5eb01b;
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $e02e634ce8a36ce5$export$ea52aaec0b4536b2;
module.exports["NO_CLASSIFICATION_OPTION"] = $e02e634ce8a36ce5$export$89b67151eed9295a;
module.exports["getNoClassificationForContent"] = $e02e634ce8a36ce5$export$59df3feebe765454;

});

parcelRegister("kknEZ", function(module, exports) {
var $ac489c3aaa697fba$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["PUBLISHED"] = "PUBLISHED";
    Status["ARCHIVED"] = "ARCHIVED";
    Status["DRAFT"] = "DRAFT";
    return Status;
}({});
module.exports["Status"] = $ac489c3aaa697fba$export$96e9906d6d93a972;

});

parcelRegister("in5LX", function(module, exports) {
var $4e391701f1805c48$export$4417bd7c8606be45 = /*#__PURE__*/ function(FlagStatus) {
    FlagStatus["NONE"] = "NONE";
    FlagStatus["SUCCESS"] = "SUCCESS";
    FlagStatus["ERROR"] = "ERROR";
    FlagStatus["LOADING"] = "LOADING";
    return FlagStatus;
}({});
module.exports["FlagStatus"] = $4e391701f1805c48$export$4417bd7c8606be45;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("fcQxC", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $304e5e6450715c84$export$20226314cf99189a = (context)=>{
    let readContext;
    let writeContext;
    switch(context){
        case 'draft-only':
            readContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        case 'current-only':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
            break;
        case 'current-and-draft':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        default:
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
    }
    return {
        readContext: readContext,
        writeContext: writeContext
    };
};
module.exports["getReadAndWriteContextFromQueryContext"] = $304e5e6450715c84$export$20226314cf99189a;

});

parcelRegister("lwZTW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $79yie = parcelRequire("79yie");

const $68e08446abc76753$export$a992cfb755534ea3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (currentClassification, spaceLevelError, contentLevelError)=>{
    const $ = (0, $bDgLe.c)(5);
    const [errorState, setErrorState] = (0, $cozmU.useState)((0, $79yie.ErrorState).NO_ERROR);
    let t0;
    let t1;
    if ($[0] !== contentLevelError || $[1] !== currentClassification || $[2] !== spaceLevelError) {
        t0 = ()=>{
            if (!currentClassification) {
                if (spaceLevelError || contentLevelError) {
                    if ((0, $aMcHK.isStatusCodeError)(contentLevelError, "404") || (0, $aMcHK.isStatusCodeError)(spaceLevelError, "404")) {
                        (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                        (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                        setErrorState((0, $79yie.ErrorState).NULL);
                    } else setErrorState((0, $79yie.ErrorState).MESSAGE);
                }
            } else {
                if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                setErrorState((0, $79yie.ErrorState).NO_ERROR);
            }
        };
        t1 = [
            currentClassification,
            spaceLevelError,
            contentLevelError
        ];
        $[0] = contentLevelError;
        $[1] = currentClassification;
        $[2] = spaceLevelError;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return errorState;
} : (currentClassification, spaceLevelError, contentLevelError)=>{
    const [errorState, setErrorState] = (0, $cozmU.useState)((0, $79yie.ErrorState).NO_ERROR);
    (0, $cozmU.useEffect)(()=>{
        // If error exists, display corresponding components
        if (!currentClassification) {
            if (spaceLevelError || contentLevelError) {
                if ((0, $aMcHK.isStatusCodeError)(contentLevelError, '404') || (0, $aMcHK.isStatusCodeError)(spaceLevelError, '404')) {
                    (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                    (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                    // If there is a handled error (404), return nothing
                    setErrorState((0, $79yie.ErrorState).NULL);
                } else // If there is an unhandled error (a non-404 error), return error message with error displays
                setErrorState((0, $79yie.ErrorState).MESSAGE);
            }
        } else {
            // If there's a content classification, we don't want to render null nor an error message for a space level error. We'll just mark the error as handled.
            if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
            setErrorState((0, $79yie.ErrorState).NO_ERROR);
        }
    }, [
        currentClassification,
        spaceLevelError,
        contentLevelError
    ]);
    return errorState;
};
module.exports["useClassificationErrorState"] = $68e08446abc76753$export$a992cfb755534ea3;

});

parcelRegister("79yie", function(module, exports) {
var $b3b9916290115f64$export$c1ed4f415b9e7023 = /*#__PURE__*/ function(ErrorState) {
    ErrorState["NULL"] = "NULL";
    ErrorState["MESSAGE"] = "MESSAGE";
    ErrorState["NO_ERROR"] = "NO_ERROR";
    return ErrorState;
}({});
module.exports["ErrorState"] = $b3b9916290115f64$export$c1ed4f415b9e7023;

});

parcelRegister("2XV0z", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cMvQV = parcelRequire("cMvQV");


var $3WPGR = parcelRequire("3WPGR");

const $8c9f801fa4f4ae90$export$a5c14cb4205739db = (isPagePreview, leftRightPaddingValueOffset, isPresenterMode)=>{
    const $ = (0, $bDgLe.c)(9);
    const [height, setHeight] = (0, $cozmU.useState)(0);
    const [width, setWidth] = (0, $cozmU.useState)(0);
    const [leftOffset, setLeftOffset] = (0, $cozmU.useState)(0);
    const observerRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== isPagePreview || $[1] !== isPresenterMode || $[2] !== leftOffset || $[3] !== leftRightPaddingValueOffset) {
        t0 = ()=>{
            let queryId;
            if (isPresenterMode) queryId = "[id='presenter-mode-header-image-container']";
            else if (isPagePreview) queryId = "[id='header-row-wrapper']";
            else queryId = ".content-screen-component";
            const pageScrollParent = document.querySelector(queryId);
            if (pageScrollParent) {
                observerRef.current = new ResizeObserver((entries)=>{
                    if ((0, $cMvQV.isChrome)() || (0, $cMvQV.isSafari)()) {
                        const innerWidth = Math.floor(entries[0]?.target.clientWidth);
                        const outerWidth = Math.floor(entries[0]?.borderBoxSize?.[0].inlineSize);
                        if (outerWidth > innerWidth) setLeftOffset(outerWidth - innerWidth);
                    }
                    const currentWidth = Math.floor(entries[0]?.target.clientWidth) - leftOffset - leftRightPaddingValueOffset;
                    setWidth(currentWidth);
                    setHeight((0, $3WPGR.getDynamicCoverImageHeight)(currentWidth));
                });
                observerRef.current.observe(pageScrollParent);
                return ()=>observerRef?.current?.disconnect();
            }
        };
        t1 = [
            observerRef,
            leftOffset,
            isPagePreview,
            leftRightPaddingValueOffset,
            isPresenterMode
        ];
        $[0] = isPagePreview;
        $[1] = isPresenterMode;
        $[2] = leftOffset;
        $[3] = leftRightPaddingValueOffset;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[6] !== height || $[7] !== width) {
        t2 = {
            height: height,
            width: width
        };
        $[6] = height;
        $[7] = width;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
module.exports["usePageHeightWidthObserver"] = $8c9f801fa4f4ae90$export$a5c14cb4205739db;

});

parcelRegister("3WPGR", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $75Ax4 = parcelRequire("75Ax4");


var $dkxaU = parcelRequire("dkxaU");


var $bKd7w = parcelRequire("bKd7w");

function $523f2f8bee18c451$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    try {
        value = JSON.parse(p.value);
        version = parseInt(JSON.parse(p.version.number));
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
function $523f2f8bee18c451$export$64dc6e3789165979(appearanceValue) {
    let appearance;
    if (appearanceValue) try {
        appearance = JSON.parse(appearanceValue);
    } catch (e) {
        appearance = null;
    }
    return appearance ?? (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
function $523f2f8bee18c451$export$df5897f4041f380b(contentQueryData, isLivePage) {
    const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
    const properties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes || [];
    const published = isLivePage ? properties[0] : properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
    const coverPictureWidth = contentQueryData?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(contentQueryData);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const coverPicture = {
        draft: null,
        published: $523f2f8bee18c451$export$da000b5ddbbe9afc(published)
    };
    let publishedValue;
    try {
        publishedValue = JSON.parse(pageWidthType);
    } catch (e) {
        publishedValue = 'default';
    }
    const contentAppearance = {
        draft: '',
        published: publishedValue
    };
    const hasCoverPicture = !!coverPicture?.published?.value?.id;
    return {
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        hasCoverPicture: hasCoverPicture,
        coverPictureWidth: coverPictureWidth,
        isTitleCenterAligned: isTitleCenterAligned
    };
}
const $523f2f8bee18c451$export$abc9309e623c0351 = (width)=>{
    return (0, $dkxaU.calcDynamicCoverImageHeight)(width);
};
function $523f2f8bee18c451$export$8a432f79b719eeda(imageUrl) {
    if (!imageUrl) return false;
    return imageUrl.includes('images.unsplash.com') || imageUrl.includes('dam-cdn.atl.orangelogic.com') || /^https?:\/\/wac-cdn-[^.]+\.atlassian\.com/.test(imageUrl);
}
module.exports["propertyToId"] = $523f2f8bee18c451$export$da000b5ddbbe9afc;
module.exports["getRendererCoverPictureInfo"] = $523f2f8bee18c451$export$df5897f4041f380b;
module.exports["getDynamicCoverImageHeight"] = $523f2f8bee18c451$export$abc9309e623c0351;
module.exports["isAllowedExternalCoverPictureUrl"] = $523f2f8bee18c451$export$8a432f79b719eeda;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $eB536 = parcelRequire("eB536");


var $1Y111 = parcelRequire("1Y111");


var $jtuBN = parcelRequire("jtuBN");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$e114ec4e88c7fe33 = (0, $eB536.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch  {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$var$QUERY_OPTIONS = (contentId)=>({
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const options = $20e32f1deb8c1fe0$var$QUERY_OPTIONS(contentId);
    const { data: data, error: error, loading: loading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: options.variables,
        skip: !contentId,
        __callerPackage__: "content-topper"
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["useTitleContentPropertiesForPublishedPage_content"] = $20e32f1deb8c1fe0$export$e114ec4e88c7fe33;
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<27d66eab829e89ba017f17104702246d>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("eB536", function(module, exports) {
/**
 * @generated SignedSource<<f3aa298d710112bdac45cdae3936c970>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3cc0a8cff50ad3c7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useTitleContentPropertiesForPublishedPage_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            },
            {
                "alias": "pageTitleDraft",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-draft"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-draft\")"
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$3cc0a8cff50ad3c7$var$node.hash = "6913c519b951b36b57b6c77657b055fd";
var $3cc0a8cff50ad3c7$export$2e2bcd8739ae039 = $3cc0a8cff50ad3c7$var$node;
module.exports["default"] = $3cc0a8cff50ad3c7$export$2e2bcd8739ae039;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c93173dea6bc8ed379cb4b9b29fb2a88>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("75Ax4", function(module, exports) {
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$a9612492250fd8ea = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$b143b999ce4b353a = `round(down, calc(100cqw / (${$4cdfc0aeee394c11$export$e63c70235aab4f60})), 1px)`;
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;
const $4cdfc0aeee394c11$export$a682f4bbb3650e11 = 200;
module.exports["DEFAULT_POSITION_VALUE"] = $4cdfc0aeee394c11$export$5a7e63ae23cefcb;
module.exports["REFERRAL_LINK"] = $4cdfc0aeee394c11$export$535fddacdd1506a3;
module.exports["MIN_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$41f496cb75ebdbf4;
module.exports["MAX_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$e1a10bbd512cde25;
module.exports["COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO"] = $4cdfc0aeee394c11$export$e63c70235aab4f60;
module.exports["CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE"] = $4cdfc0aeee394c11$export$b143b999ce4b353a;
module.exports["COVER_IMAGE_FIXED_WIDTH"] = $4cdfc0aeee394c11$export$f94fb8385ddeea1f;
module.exports["COVER_IMAGE_FIXED_HEIGHT"] = $4cdfc0aeee394c11$export$f60e801aad1e2af5;
module.exports["SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH"] = $4cdfc0aeee394c11$export$a682f4bbb3650e11;

});

parcelRegister("dkxaU", function(module, exports) {

var $75Ax4 = parcelRequire("75Ax4");

const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};
module.exports["calcDynamicCoverImageHeight"] = $17b31ae3aa6020db$export$6a5c726aaec5b09;

});

parcelRegister("bKd7w", function(module, exports) {
var $9558c78c09e4ba60$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
module.exports["CoverPictureIdPropertyKey"] = $9558c78c09e4ba60$export$da638b84af7eb6eb;

});

parcelRegister("fwwrH", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0XSep",
    name: "SmartCreateFeedbackBannerLoader",
    loader: async ()=>(await (parcelRequire("6EqCT"))).SmartCreateFeedbackBanner
});
module.exports["SmartCreateFeedbackBannerLoader"] = $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44;

});

parcelRegister("6EqCT", function(module, exports) {

let $4d7b21f3edbfe36e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d7b21f3edbfe36e$var$load("hzVe9").then(()=>parcelRequire('dSB3l'));

});

parcelRegister("fiBb3", function(module, exports) {

var $fxLAA = parcelRequire("fxLAA");

const $23261b803687ce64$export$2b17287e63c772da = (0, $fxLAA.default);
module.exports["ContentHeaderUnifiedQuery"] = $23261b803687ce64$export$2b17287e63c772da;

});

parcelRegister("fxLAA", function(module, exports) {
/**
 * @generated SignedSource<<4517af059bf2add4d9365b4061674bbe>>
 * @relayHash 956ced6a9f85fb994986ab4d0d7cffa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e83d8378c923ba932bd8dd0335f6b765775cdc24ed775b3d1375f23bc47d6bd8
const $d3bfdb752c338d80$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "embeddedContentRender"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeClassification"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeDevDocsBylineConnection"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePublicLink"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isMarkdownModeEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useAccessButtonFragment"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useEditButtonFragment"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useObjectHeaderFragment"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v14 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "embeddedContentRender",
            "variableName": "embeddedContentRender"
        },
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v19 = {
        "kind": "ScalarField",
        "name": "title"
    }, v20 = {
        "kind": "ScalarField",
        "name": "status"
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "ScalarField",
        "name": "key"
    }, v23 = {
        "kind": "ScalarField",
        "name": "value"
    }, v24 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ 
            ]
        }
    ], v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "devdocsProperties",
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v24 /*: any*/ ,
        "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v26 /*: any*/ 
                    ]
                }
            ]
        }
    ], v28 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v27 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v29 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v31 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v32 = [
        v17 /*: any*/ ,
        v21 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ 
    ], v33 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v27 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v34 = {
        "condition": "useNewContentTopper",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v27 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            }
        ]
    }, v35 = {
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v24 /*: any*/ ,
        "storageKey": "properties(key:\"editor\")"
    }, v36 = {
        "kind": "ScalarField",
        "name": "name"
    }, v37 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            v36 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v38 = {
        "kind": "ScalarField",
        "name": "message"
    }, v39 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v40 = {
        "kind": "ScalarField",
        "name": "when"
    }, v41 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v42 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    },
                    {
                        "condition": "isMarkdownModeEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isMarkdownMode"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v43 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceTemplateEntityId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v44 = {
        "condition": "includePublicLink",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "contentId"
                    }
                ],
                "concreteType": "PublicLinkPage",
                "kind": "LinkedField",
                "name": "publicLinkPage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "pageId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "pageStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accessType"
                    }
                ]
            }
        ]
    }, v45 = [
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v46 = {
        "kind": "ScalarField",
        "name": "count"
    }, v47 = {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
    }, v48 = {
        "kind": "ScalarField",
        "name": "isOwnerContributor"
    }, v49 = [
        v22 /*: any*/ ,
        v23 /*: any*/ 
    ], v50 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MapOfStringToString",
                        "kind": "LinkedField",
                        "name": "headings",
                        "plural": true,
                        "selections": v49 /*: any*/ 
                    },
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "background"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundAttachment"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundBlendMode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundClip"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundColor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundImage"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundOrigin"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundPosition"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundRepeat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundSize"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "borderRadius"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "padding"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v51 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v52 = [
        v51 /*: any*/ ,
        v17 /*: any*/ ,
        v21 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ 
    ], v53 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v54 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v55 = [
        v51 /*: any*/ ,
        v21 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "condition": "useEditButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "EditContentButton_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "editContentButton"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useAccessButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "useShareAndRestrictButtonData_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "shareAndRestrictButtonData"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useObjectHeaderFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ContentTypesHeader_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentTypesHeader"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "BylineClassification_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "bylineClassificationFragment"
                                        }
                                    ]
                                },
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                {
                                    "condition": "includeDevDocsBylineConnection",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        }
                                    ]
                                },
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                v35 /*: any*/ ,
                                v37 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v38 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        },
                                        v39 /*: any*/ ,
                                        v40 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v41 /*: any*/ 
                                    ]
                                },
                                v42 /*: any*/ ,
                                v43 /*: any*/ 
                            ]
                        }
                    ]
                },
                v44 /*: any*/ ,
                {
                    "args": v45 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v46 /*: any*/ ,
                        v47 /*: any*/ ,
                        v48 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v32 /*: any*/ 
                        }
                    ]
                },
                v50 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v11 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v12 /*: any*/ ,
                v10 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        }
                                    ]
                                },
                                v33 /*: any*/ ,
                                v35 /*: any*/ ,
                                v37 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v38 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        v39 /*: any*/ ,
                                        v40 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v41 /*: any*/ 
                                    ]
                                },
                                v42 /*: any*/ ,
                                v43 /*: any*/ ,
                                {
                                    "condition": "useEditButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v53 /*: any*/ ,
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                                    "kind": "LinkedField",
                                                    "name": "frontend",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "embedded"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "collabService"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "useAccessButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasInheritedRestrictions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasRestrictions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasViewRestrictions"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useObjectHeaderFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v53 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        {
                                            "alias": "smartFolderProperties",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "smartFolderProperties"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JsonContentProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": v49 /*: any*/ 
                                                }
                                            ],
                                            "storageKey": "properties(keys:[\"smartFolderProperties\"])"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "draftVersion",
                                            "plural": false,
                                            "selections": [
                                                v41 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v55 /*: any*/ 
                                                },
                                                v40 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v53 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        {
                                            "concreteType": "ClassificationLevelDetails",
                                            "kind": "LinkedField",
                                            "name": "classificationLevelDetails",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentDataClassificationLevel",
                                                    "kind": "LinkedField",
                                                    "name": "classificationLevel",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "guideline"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "guidelineADF"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "color"
                                                        },
                                                        v36 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "featureEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "source"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isReclassificationPermitted"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canManageSpaceSettings"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "classificationControlSetting"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "userOverrideSetting"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeDevDocsBylineConnection",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": v55 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v34 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v45 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v46 /*: any*/ ,
                        v47 /*: any*/ ,
                        v48 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v52 /*: any*/ 
                        }
                    ]
                },
                v50 /*: any*/ ,
                v44 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "956ced6a9f85fb994986ab4d0d7cffa3",
            "id": "e83d8378c923ba932bd8dd0335f6b765775cdc24ed775b3d1375f23bc47d6bd8",
            "metadata": {},
            "name": "ContentHeaderUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentHeaderUnifiedQuery($contentId:ID!,$spaceKey:String,$versionOverride:Int,$embeddedContentRender:String,$limit:Int,$useNewContentTopper:Boolean=false,$isMarkdownModeEnabled:Boolean=false,$includeDevDocsBylineConnection:Boolean=false,$useObjectHeaderFragment:Boolean=false,$useEditButtonFragment:Boolean=false,$useAccessButtonFragment:Boolean=false,$includePublicLink:Boolean=false,$includeClassification:Boolean=false,$status:[String]){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender,status:$status){nodes{id,...EditContentButton_content@include(if:$useEditButtonFragment),...useShareAndRestrictButtonData_content@include(if:$useAccessButtonFragment),...ContentTypesHeader_content@include(if:$useObjectHeaderFragment),...BylineClassification_content@include(if:$includeClassification),type,subType,title,status,ancestors@include(if:$includeDevDocsBylineConnection){id,title,type,subType,history{createdBy{__typename,displayName}},properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"]){nodes{id,key,value}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},space{id,name,homepageId},version{message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy,isMarkdownMode@include(if:$isMarkdownModeEnabled)}},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}}}},publicLinkPage(pageId:$contentId)@include(if:$includePublicLink){pageId,pageStatus,accessType},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}}fragment BylineClassification_content on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment useContentClassification_content on Content{id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}"
        }
    };
}();
$d3bfdb752c338d80$var$node.hash = "89666392bf48786832264c0571389bf2";
var $d3bfdb752c338d80$export$2e2bcd8739ae039 = $d3bfdb752c338d80$var$node;
module.exports["default"] = $d3bfdb752c338d80$export$2e2bcd8739ae039;

});

parcelRegister("80xNa", function(module, exports) {
const $5d488939c8bec967$export$21191b0c00ca25f4 = 4;
const $5d488939c8bec967$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $5d488939c8bec967$export$21191b0c00ca25f4;
module.exports["CONFLUENCE_EDITION"] = $5d488939c8bec967$export$4b915fb24c39b396;

});

parcelRegister("5W37o", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $iqPSe = parcelRequire("iqPSe");


var $9Z1sw = parcelRequire("9Z1sw");


var $eSLr0 = parcelRequire("eSLr0");


var $80koo = parcelRequire("80koo");

parcelRequire("fh5wq");
var $f2ook = parcelRequire("f2ook");
var $FFoHM = parcelRequire("FFoHM");

const $7b4282d7c94dcb09$var$webPanelPageMetadataStyle = {
    verticalAlign: 'top',
    display: 'flex',
    alignItem: 'center',
    flexWrap: 'nowrap'
};
const $7b4282d7c94dcb09$var$WRM_MODULES = [
    /*
 https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-page-banner/browse
 still used for "page-metadata-banner-items"
 https://community.developer.atlassian.com/t/page-metadata-banner-in-custom-theme/12364
 */ 'wr!com.atlassian.confluence.plugins.confluence-page-banner:page-banner-common-resources'
];
class $7b4282d7c94dcb09$export$d55a1c591b25ea6e extends (0, $cozmU.PureComponent) {
    handleQueryCompleted(data) {
        const isPanelLoadedAndEmpty = data && data.webPanels && data.webPanels.length === 0;
        this.setState({
            isPanelLoadedAndEmpty: isPanelLoadedAndEmpty
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
            contentId: this.props.contentId,
            location: (0, $eSLr0.ATL_PAGE_METADATA),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $7b4282d7c94dcb09$var$webPanelPageMetadataStyle,
            onCompleted: (data)=>this.handleQueryCompleted(data)
        }, ({ panels: panels })=>{
            if (!panels || !panels.length) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80koo.RequireLegacyWRM), {
                wrm: $7b4282d7c94dcb09$var$WRM_MODULES
            }, ()=>panels.map((panel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                        key: panel.completeKey,
                        html: panel.html
                    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2ook.ConnectAppLoadEnd), {
                location: (0, $eSLr0.ATL_PAGE_METADATA),
                items: (0, $FFoHM.getConnectAppsItems)(panels)
            }));
        }), this.state.isPanelLoadedAndEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2ook.ConnectAppLoadEnd), {
            location: (0, $eSLr0.ATL_PAGE_METADATA),
            items: (0, $FFoHM.getConnectAppsItems)([])
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isPanelLoadedAndEmpty: false
        };
    }
}
$7b4282d7c94dcb09$export$d55a1c591b25ea6e.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired
};
module.exports["PageMetadataAtl"] = $7b4282d7c94dcb09$export$d55a1c591b25ea6e;

});

parcelRegister("iqPSe", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $6UM2Q = parcelRequire("6UM2Q");


var $gIaMn = parcelRequire("gIaMn");


var $gEtAQ = parcelRequire("gEtAQ");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { html: html, panelId: panelId } = t0;
    const containerRef = (0, $cozmU.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $cozmU.useState)(true);
    let t1;
    if ($[0] !== html) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /"moduleLocation"\s*:\s*"atl\.general"/;
            $[2] = t2;
        } else t2 = $[2];
        t1 = html.match(t2);
        $[0] = html;
        $[1] = t1;
    } else t1 = $[1];
    const moduleLocationMatch = t1;
    let t2;
    if ($[3] !== moduleLocationMatch) {
        t2 = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
        $[3] = moduleLocationMatch;
        $[4] = t2;
    } else t2 = $[4];
    const isMatchForActivatable = t2;
    let t3;
    if ($[5] !== isMatchForActivatable || $[6] !== ssrSuccess) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            if (isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false)) {
                if (window?.__HYDRATABLE__) {
                    const scriptElement = container.querySelector("script.ap-iframe-body-script");
                    if (scriptElement) {
                        const scriptContent = scriptElement.textContent || "";
                        const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                        if (match) {
                            const uniqueKey = match[1];
                            const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                            if (iframe) return;
                        }
                    }
                }
                if (ssrSuccess) setSsrSuccess(false);
            }
            (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false));
        };
        $[5] = isMatchForActivatable;
        $[6] = ssrSuccess;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== html || $[9] !== isMatchForActivatable || $[10] !== panelId || $[11] !== ssrSuccess) {
        t4 = [
            html,
            panelId,
            ssrSuccess,
            isMatchForActivatable
        ];
        $[8] = html;
        $[9] = isMatchForActivatable;
        $[10] = panelId;
        $[11] = ssrSuccess;
        $[12] = t4;
    } else t4 = $[12];
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[13] !== html || $[14] !== isMatchForActivatable || $[15] !== panelId || $[16] !== ssrSuccess) {
        t5 = isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6UM2Q.ActivatableComponent), {
            id: panelId ?? "WebPanel",
            triggers: [
                {
                    type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
                }
            ],
            ssrSuccess: ssrSuccess,
            analyticsName: "WebPanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: containerRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
        $[13] = html;
        $[14] = isMatchForActivatable;
        $[15] = panelId;
        $[16] = ssrSuccess;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("6UM2Q", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9s45p = parcelRequire("9s45p");


var $75bK2 = parcelRequire("75bK2");


var $hRdzX = parcelRequire("hRdzX");

const $68e0b10beef6f399$export$1db2f2faaee8467f = (0, $3u0dr.isReactCompilerActiveV2)() ? function ActivatableComponent(t0) {
    const $ = (0, $bDgLe.c)(26);
    const { children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9s45p.makeGate)();
        $[0] = t1;
    } else t1 = $[0];
    const gate = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[1] !== children) {
        t2 = ()=>children;
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    const renderChildren = t2;
    let t3;
    if ($[3] !== analyticsName || $[4] !== createAnalyticsEvent || $[5] !== id || $[6] !== onActivate || $[7] !== triggers) {
        t3 = (reason)=>{
            if (gate?.getStatus() === "suspended") {
                onActivate?.(reason);
                if (analyticsName) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        source: "activatableComponent",
                        action: "activated",
                        actionSubject: "activatableComponent",
                        attributes: {
                            analyticsName: analyticsName,
                            triggers: triggers,
                            boundaryId: id,
                            activationReason: reason
                        }
                    }
                }).fire();
                gate.resolve();
            }
        };
        $[3] = analyticsName;
        $[4] = createAnalyticsEvent;
        $[5] = id;
        $[6] = onActivate;
        $[7] = triggers;
        $[8] = t3;
    } else t3 = $[8];
    const activateComponent = t3;
    let t4;
    if ($[9] !== activateComponent || $[10] !== analyticsName || $[11] !== id || $[12] !== triggers) {
        t4 = {
            triggers: triggers,
            gate: gate,
            activateComponent: activateComponent,
            boundaryId: id,
            analyticsName: analyticsName
        };
        $[9] = activateComponent;
        $[10] = analyticsName;
        $[11] = id;
        $[12] = triggers;
        $[13] = t4;
    } else t4 = $[13];
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)(t4);
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = gate?.getStatus?.();
        $[14] = t5;
    } else t5 = $[14];
    const t6 = analyticsName || id;
    let t7;
    if ($[15] !== activateComponent || $[16] !== id || $[17] !== renderChildren || $[18] !== ssrSuccess || $[19] !== t6 || $[20] !== triggers) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75bK2.Boundary), {
            gate: gate,
            id: id,
            render: renderChildren,
            ssrSuccess: ssrSuccess,
            activateComponent: activateComponent,
            resolved: t5 === "resolved",
            boundaryName: t6,
            triggers: triggers
        });
        $[15] = activateComponent;
        $[16] = id;
        $[17] = renderChildren;
        $[18] = ssrSuccess;
        $[19] = t6;
        $[20] = triggers;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== hostRefWithActivation || $[23] !== id || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: hostRefWithActivation,
            "data-hydration-shield": id
        }, t7);
        $[22] = hostRefWithActivation;
        $[23] = id;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function ActivatableComponent({ children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess }) {
    const gate = (0, $cozmU.useMemo)(()=>(0, $9s45p.makeGate)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const renderChildren = (0, $cozmU.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    const activateComponent = (0, $cozmU.useCallback)((reason)=>{
        if (gate?.getStatus() === 'suspended') {
            onActivate?.(reason);
            if (analyticsName) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'activatableComponent',
                    action: 'activated',
                    actionSubject: 'activatableComponent',
                    attributes: {
                        analyticsName: analyticsName,
                        triggers: triggers,
                        boundaryId: id,
                        activationReason: reason
                    }
                }
            }).fire();
            gate.resolve();
        }
    }, [
        gate,
        id,
        onActivate,
        createAnalyticsEvent,
        analyticsName,
        triggers
    ]);
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)({
        triggers: triggers,
        gate: gate,
        activateComponent: activateComponent,
        boundaryId: id,
        analyticsName: analyticsName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: hostRefWithActivation,
        "data-hydration-shield": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75bK2.Boundary), {
        gate: gate,
        id: id,
        render: renderChildren,
        ssrSuccess: ssrSuccess,
        activateComponent: activateComponent,
        resolved: gate?.getStatus?.() === 'resolved',
        boundaryName: analyticsName || id,
        triggers: triggers
    }));
};
module.exports["ActivatableComponent"] = $68e0b10beef6f399$export$1db2f2faaee8467f;

});

parcelRegister("9Z1sw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eq95w = parcelRequire("eq95w");


var $cozmU = parcelRequire("cozmU");


var $ah4BL = parcelRequire("ah4BL");


var $bavCP = parcelRequire("bavCP");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $bDgLe.c)(3);
    const batchContext = (0, $cozmU.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    let t1;
    let t2;
    if ($[0] !== panels) {
        t1 = ()=>{
            if ((0, $9wGTI.fg)("cc_record_non_content_macros")) (0, $8wW9d.recordNonContentAppKeys)("web-panel", (panels ?? []).map($0aea74171df1eb15$var$_temp2));
        };
        t2 = [
            panels
        ];
        $[0] = panels;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!panelHasContent) return children;
    const t3 = `web-panel-${locationName}`;
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
};
const $0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { panel: panel } = t0;
    let t1;
    if ($[0] !== panel.completeKey || $[1] !== panel.html) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
            panelId: panel.completeKey,
            html: panel.html
        });
        $[0] = panel.completeKey;
        $[1] = panel.html;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}, (prevProps, nextProps)=>prevProps.panel.completeKey === nextProps.panel.completeKey);
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $cozmU.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $cozmU.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, loading: loading, error: error })=>{
        if (!renderWhenLoading) {
            if (error || !data || loading && !(0, $9wGTI.fg)('confluence_web_panel_location_render_loading')) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        const shouldMemoizeAtlGeneralWebPanel = location === (0, $eSLr0.ATL_GENERAL) && (0, $6mKj3.expValEquals)('confluence_memorize_atl_general_connect', 'isEnabled', true);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return shouldMemoizeAtlGeneralWebPanel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel, {
                key: panel.completeKey,
                panel: panel
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
function $0aea74171df1eb15$var$_temp2(panel_0) {
    return panel_0.completeKey;
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("fh5wq", function(module, exports) {
$parcel$export(module.exports, "ConnectAppLoadEnd", () => (parcelRequire("f2ook")).ConnectAppLoadEnd);
$parcel$export(module.exports, "getConnectAppsItems", () => (parcelRequire("FFoHM")).getConnectAppsItems);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $8X9dm = parcelRequire("8X9dm");


var $f2ook = parcelRequire("f2ook");


var $FFoHM = parcelRequire("FFoHM");


var $hB3yw = parcelRequire("hB3yw");


});

parcelRegister("8X9dm", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $FFoHM = parcelRequire("FFoHM");

const $fa75a12a8b648c36$var$actions = {
    updateConnectApps: (props)=>({ setState: setState, getState: getState })=>{
            const { location: location, items: items, isLoaded: isLoaded } = props;
            // Update connectApps when it completed load
            const newState = getState().connectApps.map((data)=>{
                if (data.location === location) return {
                    location: location,
                    items: items,
                    isLoaded: isLoaded
                };
                return data;
            });
            setState({
                connectApps: newState
            });
        },
    resetConnectApps: ()=>({ setState: setState })=>{
            setState({
                connectApps: (0, $FFoHM.generateInitialState)()
            });
        }
};
const $fa75a12a8b648c36$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        connectApps: (0, $FFoHM.generateInitialState)()
    },
    actions: $fa75a12a8b648c36$var$actions,
    name: 'connectAppsState'
});
const $fa75a12a8b648c36$var$getConnectAppsState = (state)=>{
    // Check if all measurable connect apps are loaded
    const isReady = state.connectApps.every((cp)=>{
        return cp.isLoaded === true;
    });
    if (!isReady) return {
        isReady: false,
        data: null
    };
    return {
        isReady: true,
        data: (0, $FFoHM.generateMetricData)(state.connectApps)
    };
};
const $fa75a12a8b648c36$export$582ddccddc369c8 = (0, $kBr4q.createHook)($fa75a12a8b648c36$var$Store, {
    selector: $fa75a12a8b648c36$var$getConnectAppsState
});
module.exports["useConnectAppsState"] = $fa75a12a8b648c36$export$582ddccddc369c8;

});

parcelRegister("FFoHM", function(module, exports) {

var $33OR5 = parcelRequire("33OR5");

const $2c1124407cafc284$export$5e6f85e4321dccd5 = (items, prop = 'completeKey')=>{
    if (!items || !items.length) return [];
    return items.map((item)=>{
        if (!item[prop]) return null;
        return item[prop];
    });
};
const $2c1124407cafc284$export$fe8c27474396e3df = (originalData)=>{
    const isEmpty = originalData.every((cp)=>{
        return cp.items.length === 0;
    });
    if (isEmpty) return null;
    return originalData.reduce((result, data)=>{
        if (data.items?.length) result[data.location] = data.items;
        return result;
    }, {});
};
const $2c1124407cafc284$export$6c48ceb03731fb94 = ()=>{
    return (0, $33OR5.measuredLocations).map((location)=>({
            location: location,
            items: [],
            isLoaded: false
        }));
};
module.exports["getConnectAppsItems"] = $2c1124407cafc284$export$5e6f85e4321dccd5;
module.exports["generateMetricData"] = $2c1124407cafc284$export$fe8c27474396e3df;
module.exports["generateInitialState"] = $2c1124407cafc284$export$6c48ceb03731fb94;

});

parcelRegister("33OR5", function(module, exports) {

var $eSLr0 = parcelRequire("eSLr0");

const $026eb3cae9c12bb0$export$b8794672440f0b1 = [
    (0, $eSLr0.PAGE_METADATA_BANNER),
    (0, $eSLr0.SYSTEM_CONTENT_METADATA),
    (0, $eSLr0.ATL_PAGE_METADATA)
];
const $026eb3cae9c12bb0$export$d18781600a31352 = 'com.atlassian.plugins.atlassian-connect-plugin';
module.exports["measuredLocations"] = $026eb3cae9c12bb0$export$b8794672440f0b1;
module.exports["MEASURE_KEY"] = $026eb3cae9c12bb0$export$d18781600a31352;

});

parcelRegister("f2ook", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $33OR5 = parcelRequire("33OR5");


var $8X9dm = parcelRequire("8X9dm");

const $7be4190af38bf0dd$export$2ed36e453078a2a = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { location: location, items: items } = t0;
    const [, connectAppsActions] = (0, $8X9dm.useConnectAppsState)();
    let t1;
    let t2;
    if ($[0] !== connectAppsActions || $[1] !== items || $[2] !== location) {
        t1 = ()=>{
            if (location && (0, $33OR5.measuredLocations).indexOf(location) !== -1) {
                const filteredItems = items.filter($7be4190af38bf0dd$var$_temp);
                connectAppsActions.updateConnectApps({
                    location: location,
                    items: filteredItems,
                    isLoaded: true
                });
            }
        };
        t2 = [
            location,
            items,
            connectAppsActions
        ];
        $[0] = connectAppsActions;
        $[1] = items;
        $[2] = location;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
};
function $7be4190af38bf0dd$var$_temp(item) {
    return item.indexOf((0, $33OR5.MEASURE_KEY)) !== -1;
}
module.exports["ConnectAppLoadEnd"] = $7be4190af38bf0dd$export$2ed36e453078a2a;

});

parcelRegister("hB3yw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kvJHJ = parcelRequire("kvJHJ");


var $8X9dm = parcelRequire("8X9dm");

const $ad90018ec7bbfcf2$export$c67125476ea8583f = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { contentId: contentId, metric: metric } = t0;
    const [connectApps, connectAppsActions] = (0, $8X9dm.useConnectAppsState)();
    let t1;
    if ($[0] !== connectAppsActions) {
        t1 = ()=>{
            connectAppsActions.resetConnectApps();
        };
        $[0] = connectAppsActions;
        $[1] = t1;
    } else t1 = $[1];
    const onMeasureCompleted = t1;
    if (!connectApps?.isReady) return null;
    if (!connectApps?.data) {
        onMeasureCompleted();
        return null;
    }
    const t2 = connectApps?.data;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            connectApps: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== contentId || $[5] !== metric || $[6] !== onMeasureCompleted || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: metric,
            customData: t3,
            onComplete: onMeasureCompleted
        });
        $[4] = contentId;
        $[5] = metric;
        $[6] = onMeasureCompleted;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $gXfti.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("jbFlk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $80koo = parcelRequire("80koo");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $hFGQl = parcelRequire("hFGQl");


var $asQED = parcelRequire("asQED");

parcelRequire("fh5wq");
var $f2ook = parcelRequire("f2ook");
var $FFoHM = parcelRequire("FFoHM");

const $2196709888d91a8b$var$WRM_MODULES = [
    'wrc!com.atlassian.confluence.plugins.confluence-feature-discovery-plugin',
    'wrc!com.atlassian.confluence.plugins.confluence-jira-metadata:confluence-jira-metadata-resources'
];
class $2196709888d91a8b$export$3977b622b23eae17 extends (0, $cozmU.PureComponent) {
    render() {
        const { contentId: contentId, versionOverride: versionOverride } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
            tagName: "span",
            location: (0, $eSLr0.PAGE_METADATA_BANNER),
            contentId: contentId,
            version: versionOverride
        }, ({ webItems: webItems })=>{
            const items = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $asQED.WebItemList), {
                pageId: contentId,
                webItems: webItems,
                id: "page-metadata-banner-items"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2ook.ConnectAppLoadEnd), {
                location: (0, $eSLr0.PAGE_METADATA_BANNER),
                items: (0, $FFoHM.getConnectAppsItems)(webItems)
            }));
            if (webItems.some((item)=>item.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80koo.RequireLegacyWRM), {
                wrm: $2196709888d91a8b$var$WRM_MODULES
            }, ()=>items);
            return items;
        }));
    }
}
$2196709888d91a8b$export$3977b622b23eae17.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number
};
module.exports["PageMetadataBanner"] = $2196709888d91a8b$export$3977b622b23eae17;

});

parcelRegister("asQED", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $5X6fy = parcelRequire("5X6fy");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $7XPIt = parcelRequire("7XPIt");


var $42cjr = parcelRequire("42cjr");


var $2d38b = parcelRequire("2d38b");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ht0Th = parcelRequire("ht0Th");


var $4aGJ9 = parcelRequire("4aGJ9");


var $hFGQl = parcelRequire("hFGQl");


var $1CpUP = parcelRequire("1CpUP");


var $d716L = parcelRequire("d716L");

const $27cf6bbb40785c7e$export$392ec14fa63f4ae3 = {
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    display: 'inline-block',
    verticalAlign: 'top',
    paddingLeft: "var(--ds-space-100, 8px)"
};
const $27cf6bbb40785c7e$export$63286b959e8d28b9 = (props)=>{
    const $ = (0, $bDgLe.c)(29);
    const { webItems: webItems, className: className, id: id, webItemClassName: webItemClassName, pageId: pageId, dataTestId: dataTestId, contentSubType: contentSubType, hideDot: hideDot, source: source, ContainerTagName: t0, actions: t1, modifications: t2, disableIcons: t3, noContainer: t4, useBadgeStyles: t5, isLegacyConnectApp: t6 } = props;
    const ContainerTagName = t0 === undefined ? "div" : t0;
    let t7;
    if ($[0] !== t1) {
        t7 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t7;
    } else t7 = $[1];
    const actions = t7;
    let t8;
    if ($[2] !== t2) {
        t8 = t2 === undefined ? {} : t2;
        $[2] = t2;
        $[3] = t8;
    } else t8 = $[3];
    const modifications = t8;
    const disableIcons = t3 === undefined ? false : t3;
    const noContainer = t4 === undefined ? false : t4;
    const useBadgeStyles = t5 === undefined ? false : t5;
    const isLegacyConnectApp = t6 === undefined ? false : t6;
    let t9;
    if ($[4] !== actions || $[5] !== contentSubType || $[6] !== disableIcons || $[7] !== hideDot || $[8] !== isLegacyConnectApp || $[9] !== modifications || $[10] !== pageId || $[11] !== source || $[12] !== useBadgeStyles || $[13] !== webItemClassName || $[14] !== webItems) {
        t9 = ()=>webItems.map((webItem)=>{
                const webItemProps = {
                    key: webItem.completeKey,
                    url: webItem.url,
                    id: webItem.id,
                    onClick: webItem.onClick || actions[webItem.moduleKey],
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))(webItem.styleClass, webItemClassName, {
                        "with-dot": !hideDot
                    }),
                    params: webItem.params,
                    iconInfo: webItem.icon,
                    label: webItem.label,
                    tooltip: webItem.tooltip,
                    spinner: modifications[webItem.moduleKey] ? modifications[webItem.moduleKey].spinner : false,
                    disableIcon: disableIcons,
                    iconStyle: webItem.iconStyle,
                    addLargerMargin: hideDot,
                    useBylineStyles: hideDot
                };
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) webItemProps["data-jira-metadata-count"] = -1;
                if (pageId && webItem.id === (0, $hFGQl.DRAFT_STATUS_LOZENGE_ID)) {
                    if (webItem.moduleKey === (0, $hFGQl.SCHEDULED_STATUS_LOZENGE_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $42cjr.ScheduledStatus), {
                        key: pageId,
                        contentId: pageId
                    });
                    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d38b.DraftStatus), {
                        key: pageId,
                        contentId: pageId
                    });
                }
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_ATTACHMENTS_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7XPIt.ViewAttachmentsButton), {
                    key: "view-attachments-button"
                });
                if (webItem.id === (0, $hFGQl.INVITE_TO_EDIT_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    style: $27cf6bbb40785c7e$export$392ec14fa63f4ae3,
                    key: "fabric-share"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
                    key: "share-and-restrict-button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aGJ9.ShareAndRestrictButton), {
                    contentId: webItem.contentId,
                    contentType: webItem.contentType ?? "page",
                    contentSubType: contentSubType || undefined,
                    source: source
                })));
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID)) return null;
                if (webItem.id === (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID) || webItem.id === (0, $hFGQl.ANALYTICS_ADDON_BYLINE_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ht0Th.JiraButtonAnalyticsWrapper), {
                    key: webItem.completeKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1CpUP.WebItem), webItemProps));
                if (isLegacyConnectApp) {
                    const appKey = webItem.moduleKey.split("__")[0];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                        key: webItem.completeKey
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d716L.ConnectEOSPopup), {
                        appKey: appKey
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1CpUP.WebItem), {
                        ...webItemProps,
                        useBadgeStyles: useBadgeStyles
                    }));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1CpUP.WebItem), {
                    key: webItem.completeKey,
                    ...webItemProps,
                    useBadgeStyles: useBadgeStyles
                });
            });
        $[4] = actions;
        $[5] = contentSubType;
        $[6] = disableIcons;
        $[7] = hideDot;
        $[8] = isLegacyConnectApp;
        $[9] = modifications;
        $[10] = pageId;
        $[11] = source;
        $[12] = useBadgeStyles;
        $[13] = webItemClassName;
        $[14] = webItems;
        $[15] = t9;
    } else t9 = $[15];
    const renderWebItems = t9;
    if (noContainer) {
        let t10;
        if ($[16] !== renderWebItems) {
            t10 = renderWebItems();
            $[16] = renderWebItems;
            $[17] = t10;
        } else t10 = $[17];
        let t11;
        if ($[18] !== t10) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t10);
            $[18] = t10;
            $[19] = t11;
        } else t11 = $[19];
        return t11;
    }
    const t10 = dataTestId || "web-item-wrapper";
    let t11;
    if ($[20] !== renderWebItems) {
        t11 = renderWebItems();
        $[20] = renderWebItems;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== ContainerTagName || $[23] !== className || $[24] !== dataTestId || $[25] !== id || $[26] !== t10 || $[27] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ContainerTagName, {
            className: className,
            id: id,
            "data-test-id": dataTestId,
            "data-testid": t10
        }, t11);
        $[22] = ContainerTagName;
        $[23] = className;
        $[24] = dataTestId;
        $[25] = id;
        $[26] = t10;
        $[27] = t11;
        $[28] = t12;
    } else t12 = $[28];
    return t12;
};
$27cf6bbb40785c7e$export$63286b959e8d28b9.displayName = 'WebItemList';
$27cf6bbb40785c7e$export$63286b959e8d28b9.propTypes = {
    webItems: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).array,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    modifications: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    disableIcons: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    ContainerTagName: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    webItemClassName: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    pageId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    dataTestId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    hideDot: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    noContainer: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isLegacyConnectApp: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
module.exports["SHARE_BTN_STYLE"] = $27cf6bbb40785c7e$export$392ec14fa63f4ae3;
module.exports["WebItemList"] = $27cf6bbb40785c7e$export$63286b959e8d28b9;

});

parcelRegister("7XPIt", function(module, exports) {
/* ViewAttachmentsButton.js generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $5SGpQ = parcelRequire("5SGpQ");


var $gxI48 = parcelRequire("gxI48");


var $2UWuP = parcelRequire("2UWuP");


var $jlIaF = parcelRequire("jlIaF");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cc628dffabd5f14$var$ViewAttachmentsButtonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3syKoKdnbC _2h7MEPdnbC _3tOQhEdnbC _04h2sEdnbC _3wdHVCdnbC _4mSr0ndnbC _2frtJQdnbC _11NgWudnbC _0jwYZZ7zJH _1iJnp6uNcX _2FH9z4uNcX _0gKGieZpcK _1E1xWzZpcK",
            __cmplp.className
        ])
    });
});
const $5cc628dffabd5f14$var$i18n = (0, $kSwu1.defineMessages)({
    attachments: {
        id: "attachments.view-attachments-button",
        defaultMessage: "View attachments"
    }
});
const $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'fromView'
        }
    }
};
const $5cc628dffabd5f14$export$6f695b80f23f4114 = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'actionsMenu'
        }
    }
};
const $5cc628dffabd5f14$export$774c527e91be8e54 = ({ intl: intl })=>{
    const label = intl.formatMessage($5cc628dffabd5f14$var$i18n.attachments);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'feature',
            action: 'exposed',
            source: 'ViewAttachmentsButton',
            attributes: {
                isPageSSRd: window.__SSR_RENDERED__
            }
        }
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cc628dffabd5f14$var$ViewAttachmentsButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        href: (0, $6mKj3.expValEquals)('cc_attachments_page', 'isEnabled', true) ? (0, $1NBp8.ATTACHMENTS_PAGE).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        }) : `${0, $jlIaF.CONTEXT_PATH}/pages/viewpageattachments.action?pageId=${contentId}&metadataLink=true`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gxI48))), {
        spacing: "spacious",
        label: label
    }))))));
};
$5cc628dffabd5f14$export$774c527e91be8e54.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object
};
const $5cc628dffabd5f14$export$5c9f1ebb6c75cefb = (0, $kSwu1.injectIntl)($5cc628dffabd5f14$export$774c527e91be8e54);
module.exports["ATTACHMENTS_ANALYTICS_FROM_ACTIONS_MENU"] = $5cc628dffabd5f14$export$6f695b80f23f4114;
module.exports["ViewAttachmentsButton"] = $5cc628dffabd5f14$export$5c9f1ebb6c75cefb;

});

parcelRegister("2UWuP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ggg0l = parcelRequire("ggg0l");

const $1c62d6fee936c450$var$noop = ()=>{};
function $1c62d6fee936c450$export$907c57431ebf932({ children: children, analyticsData: analyticsData, innerRef: innerRef, wrapChildren: wrapChildren = false }) {
    const handler = children?.props?.onClick || $1c62d6fee936c450$var$noop;
    const handleClick = (0, $ggg0l.useCallbackWithAnalytics)(handler, analyticsData);
    if (wrapChildren) {
        const wrappedChild = /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
            onClick: handleClick
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ref: innerRef
        }, wrappedChild);
    }
    return /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onClick: handleClick,
        ref: innerRef
    });
}
module.exports["WebItemAnalyticsWrapper"] = $1c62d6fee936c450$export$907c57431ebf932;

});

parcelRegister("42cjr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7f6808c58612208d$export$d10c0abe99daab65 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "a_lQj",
    name: "ScheduledStatus",
    loader: async ()=>(await (parcelRequire("7rkv2"))).ScheduledStatus
});
module.exports["ScheduledStatus"] = $7f6808c58612208d$export$d10c0abe99daab65;

});

parcelRegister("7rkv2", function(module, exports) {

let $56aaf4cc97703232$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56aaf4cc97703232$var$load("iWKl1").then(()=>parcelRequire('dqNU1'));

});

parcelRegister("2d38b", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $30c96bfad3bb5778$export$ad9db10db9173ca8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6vTJj",
    name: "DraftStatus",
    loader: async ()=>(await (parcelRequire("3ThaJ"))).DraftStatus
});
module.exports["DraftStatus"] = $30c96bfad3bb5778$export$ad9db10db9173ca8;

});

parcelRegister("3ThaJ", function(module, exports) {

let $2d53d42a7d15aa79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2d53d42a7d15aa79$var$load("jYr96").then(()=>parcelRequire('1cgZV'));

});

parcelRegister("ht0Th", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $9DHhW = parcelRequire("9DHhW");


var $2UWuP = parcelRequire("2UWuP");


var $hFGQl = parcelRequire("hFGQl");

const $cb75d5f0a986326c$var$JIRA_ANALYTICS = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        source: 'viewPageScreen',
        actionSubject: 'JiraTicketsButton'
    }
};
function $cb75d5f0a986326c$export$549130614231f8f4({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const container = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        setTimeout(()=>{
            let linkVisible = false;
            const link = container?.current?.children?.[0, $hFGQl.CONTENT_METADATA_JIRA_ID];
            if (link && !link.classList.contains('hidden')) linkVisible = true;
            if (linkVisible) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'JiraTicketsButton',
                    action: 'shown',
                    source: 'viewPageScreen',
                    attributes: {
                        isPageSSRd: window.__SSR_RENDERED__
                    }
                }
            }).fire();
        }, 5000); // should be enough for render after the plugin has mounted
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $cb75d5f0a986326c$var$JIRA_ANALYTICS,
        innerRef: container,
        wrapChildren: true
    }, children);
}
$cb75d5f0a986326c$export$549130614231f8f4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node
};
module.exports["JiraButtonAnalyticsWrapper"] = $cb75d5f0a986326c$export$549130614231f8f4;

});

parcelRegister("1CpUP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $5X6fy = parcelRequire("5X6fy");


var $3AVOh = parcelRequire("3AVOh");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $lpNn5 = parcelRequire("lpNn5");


var $bCECL = parcelRequire("bCECL");

function $12dd715bfa1d104a$var$_defineProperty(e, r, t) {
    return (r = $12dd715bfa1d104a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $12dd715bfa1d104a$var$_toPropertyKey(t) {
    var i = $12dd715bfa1d104a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $12dd715bfa1d104a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $12dd715bfa1d104a$var$imageStyles = null;
// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
const $12dd715bfa1d104a$var$baseStyles = null;
const $12dd715bfa1d104a$var$largeMargin = null;
const $12dd715bfa1d104a$var$bylineStyles = null;
const $12dd715bfa1d104a$var$badgeStyles = null;
const $12dd715bfa1d104a$var$WebItemTooltip = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { tooltip: tooltip, children: children } = t0;
    if (tooltip) {
        let t1;
        if ($[0] !== children) {
            t1 = (tooltipProps)=>children(tooltipProps);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1 || $[3] !== tooltip) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: tooltip
            }, t1);
            $[2] = t1;
            $[3] = tooltip;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    let t1;
    if ($[5] !== children) {
        t1 = children({});
        $[5] = children;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
$12dd715bfa1d104a$var$WebItemTooltip.propTypes = {
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
const $12dd715bfa1d104a$var$WebItemIcon = (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    let addLargerMargin;
    let classes;
    let icon;
    let id;
    let label;
    let onClick;
    let otherProps;
    let style;
    let tooltip;
    let url;
    let useBadgeStyles;
    let useBylineStyles;
    if ($[0] !== t0) {
        ({ classes: classes, id: id, url: url, label: label, tooltip: tooltip, onClick: onClick, style: style, icon: icon, addLargerMargin: addLargerMargin, useBylineStyles: useBylineStyles, useBadgeStyles: useBadgeStyles, ...otherProps } = t0);
        $[0] = t0;
        $[1] = addLargerMargin;
        $[2] = classes;
        $[3] = icon;
        $[4] = id;
        $[5] = label;
        $[6] = onClick;
        $[7] = otherProps;
        $[8] = style;
        $[9] = tooltip;
        $[10] = url;
        $[11] = useBadgeStyles;
        $[12] = useBylineStyles;
    } else {
        addLargerMargin = $[1];
        classes = $[2];
        icon = $[3];
        id = $[4];
        label = $[5];
        onClick = $[6];
        otherProps = $[7];
        style = $[8];
        tooltip = $[9];
        url = $[10];
        useBadgeStyles = $[11];
        useBylineStyles = $[12];
    }
    let t1;
    if ($[13] !== addLargerMargin || $[14] !== classes || $[15] !== icon || $[16] !== id || $[17] !== label || $[18] !== onClick || $[19] !== otherProps || $[20] !== style || $[21] !== url || $[22] !== useBadgeStyles || $[23] !== useBylineStyles) {
        t1 = (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
                "data-testid": "web-item-link",
                className: (0, $hekY6.default)([
                    "_0adFHs2ADO _26BoRwdIGx",
                    addLargerMargin && "_0adFHsCLgE _26BoRwa9Mq",
                    useBylineStyles && "_1UtDYzue9s",
                    useBadgeStyles && "_0bjKvDKxmn _2mHwu81Y8M _4FKVYE1Y8M _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbQ4SZ _26BoRwey7F _0adFHsPgdg _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _3932vvOiJt _3gzVzLN4oS _0NqVRtYbGa",
                    classes
                ]),
                href: url,
                id: id,
                onClick: onClick,
                style: style,
                ...tooltipProps,
                ...otherProps
            }, icon, typeof label === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                dangerouslySetInnerHTML: {
                    __html: label
                }
            }) : label);
        $[13] = addLargerMargin;
        $[14] = classes;
        $[15] = icon;
        $[16] = id;
        $[17] = label;
        $[18] = onClick;
        $[19] = otherProps;
        $[20] = style;
        $[21] = url;
        $[22] = useBadgeStyles;
        $[23] = useBylineStyles;
        $[24] = t1;
    } else t1 = $[24];
    let t2;
    if ($[25] !== t1 || $[26] !== tooltip) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12dd715bfa1d104a$var$WebItemTooltip, {
            tooltip: tooltip
        }, t1);
        $[25] = t1;
        $[26] = tooltip;
        $[27] = t2;
    } else t2 = $[27];
    return t2;
};
$12dd715bfa1d104a$var$WebItemIcon.propTypes = {
    /**
   * classes to use for the component
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * id passed from WebItem
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Route where the web item will point
   */ url: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Label of the web item
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Handler for clicks
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    /**
   * WebItem styles
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Icon obj
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Will be true for live pages since apps have different styling
   */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    /**
   * Will be true for live pages since apps have different styling
   */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
class $12dd715bfa1d104a$export$1c46d4b85d455dd4 extends (0, $cozmU.PureComponent) {
    getIcon() {
        const { disableIcon: disableIcon, params: params, iconStyle: iconStyle, spinner: spinner, iconInfo: iconInfo, label: label, iconSize: iconSize } = this.props;
        let auiIconClass = params && params.iconClass;
        if (disableIcon) return null;
        if (spinner) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            testId: "spinner",
            size: "small"
        });
        if (iconInfo && iconInfo.path) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        , {
            style: iconStyle,
            src: iconInfo.path,
            width: iconInfo.width,
            height: iconInfo.height,
            alt: label,
            title: label,
            className: (0, $hekY6.default)([
                "_0NUa3rN91d _0jFU0VIZbP _3iDTPbvbI6 _1RrJLit2nV _0adFHsyrFs"
            ])
        });
        if (auiIconClass) {
            if (auiIconClass.indexOf('aui-iconfont-') === -1) auiIconClass = `aui-iconfont-${auiIconClass}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
                iconSize: iconSize,
                className: auiIconClass,
                style: iconStyle
            });
        }
        return null;
    }
    render() {
        const { className: className, id: id, url: url, type: type, label: label, tooltip: tooltip, onClick: onClick, style: style, ...otherProps } = this.props;
        const buttonType = type === 'primary' ? 'aui-button-primary' : '';
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))(className, buttonType);
        const icon = this.getIcon(); //react complains about these extra props but we still need to pass otherProps (e.g. data-jira-metadata-count)
        const webItemIconProps = (0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))({
            classes: classes,
            id: id,
            url: url,
            label: label,
            tooltip: tooltip,
            onClick: onClick,
            style: style,
            icon: icon,
            ...otherProps
        }, [
            'disableIcon',
            'iconStyle',
            'spinner',
            'iconInfo',
            'iconSize'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12dd715bfa1d104a$var$WebItemIcon, webItemIconProps);
    }
}
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "propTypes", {
    /**
   * Classnames. Note that WebItem no longer assumes that it should render as a button
   * And as such you may need to explicitly pass the `aui-button` class here.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * id
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Route where the web item will point
   */ url: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Type of the button
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Label of the web item
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Handler for clicks
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    /**
   * Contain parameters setted in the descriptor
   */ params: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Doesn't render icons when true
   */ disableIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    /**
   * icon information used for absolute images
   */ iconInfo: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).shape({
        path: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number
    }),
    /**
   * Show spinner instead of an icon if equals true
   */ spinner: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    /**
   * WebItem styles
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Icon styles
   */ iconStyle: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    iconSize: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Will be true for live pages since apps have different styling
   */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    /**
   * Will be true for live pages since apps have different styling
   */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
});
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "defaultProps", {
    spinner: false,
    iconStyle: {},
    style: {},
    iconSize: 'small'
});
module.exports["WebItem"] = $12dd715bfa1d104a$export$1c46d4b85d455dd4;

});

parcelRegister("d716L", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0ca1f9f6493af470$export$88a847850fd26927 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "VrHkx",
    name: "ConnectEOSPopup",
    loader: async ()=>(await (parcelRequire("j1I7a"))).ConnectEOSPopup
});
module.exports["ConnectEOSPopup"] = $0ca1f9f6493af470$export$88a847850fd26927;

});

parcelRegister("j1I7a", function(module, exports) {

let $dda05492adb3b5fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dda05492adb3b5fe$var$load("Wowvf"),
    $dda05492adb3b5fe$var$load("jkP4F")
]).then(()=>parcelRequire('73nrX'));

});

parcelRegister("4Uc69", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $asQED = parcelRequire("asQED");


var $hFGQl = parcelRequire("hFGQl");

parcelRequire("fh5wq");
var $f2ook = parcelRequire("f2ook");
var $FFoHM = parcelRequire("FFoHM");

class $c77793ad2fffc9ee$export$3a0235893ca8c89e extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { excludeIds: excludeIds, contentId: contentId } = this.props;
        if (!excludeIds.includes((0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID))) (0, $fGzMp.getExperienceTracker)().start({
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
        });
    }
    render() {
        const { contentId: contentId, versionOverride: versionOverride, excludeIds: excludeIds } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
            tagName: "span",
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_METADATA),
            version: versionOverride
        }, ({ webItems: webItems })=>{
            let filteredWebItems = webItems;
            if (excludeIds && excludeIds.length) filteredWebItems = filteredWebItems.filter((item)=>!excludeIds.includes(item.id));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $asQED.WebItemList), {
                pageId: contentId,
                webItems: filteredWebItems,
                id: "system- content-items"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2ook.ConnectAppLoadEnd), {
                location: (0, $eSLr0.SYSTEM_CONTENT_METADATA),
                items: (0, $FFoHM.getConnectAppsItems)(filteredWebItems)
            }));
        });
    }
}
$c77793ad2fffc9ee$export$3a0235893ca8c89e.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    excludeIds: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string)
};
$c77793ad2fffc9ee$export$3a0235893ca8c89e.defaultProps = {
    excludeIds: []
};
module.exports["SystemContentMetadata"] = $c77793ad2fffc9ee$export$3a0235893ca8c89e;

});

parcelRegister("JHogp", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $b8pma = parcelRequire("b8pma");


var $jBnsv = parcelRequire("jBnsv");


var $5EoFB = parcelRequire("5EoFB");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $hQBR9 = parcelRequire("hQBR9");


var $lECEN = parcelRequire("lECEN");


var $cxCWb = parcelRequire("cxCWb");


var $D7PHQ = parcelRequire("D7PHQ");


var $bvg6Y = parcelRequire("bvg6Y");


var $2REhP = parcelRequire("2REhP");


var $8HdsQ = parcelRequire("8HdsQ");

parcelRequire("hAnPj");
var $SAFLR = parcelRequire("SAFLR");


var $2pIlF = parcelRequire("2pIlF");


var $eNjW4 = parcelRequire("eNjW4");


var $8Cofr = parcelRequire("8Cofr");

const $6e3ff5db190a542f$var$StyledWebItemButtonList = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $lECEN.WebItemButtonList) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1RrJLit2nV",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$StyledContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0hPCNLDIqT _3iDTPbQ4SZ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$StyledBorder = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEhM4o _3Jzbae1z4g _3iDTPbvbI6 _39xV02HZdu _0jFU0Vey7F",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$WebItemsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VN91d",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$SystemContentButtonMaxWidthContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1EqgXlgZxp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$ShareButtonPlaceholderSpacer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFM2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$ContentHeaderShareAndCopyButtons = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { contentId: contentId, versionOverride: versionOverride, contentType: contentType, contentSubType: contentSubType, isArchived: isArchived } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== contentSubType || $[2] !== contentType || $[3] !== isArchived || $[4] !== versionOverride) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$ShareAndCopyButtons, {
            contentId: contentId,
            versionOverride: versionOverride,
            contentType: contentType,
            contentSubType: contentSubType,
            isArchived: isArchived
        });
        $[0] = contentId;
        $[1] = contentSubType;
        $[2] = contentType;
        $[3] = isArchived;
        $[4] = versionOverride;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
$6e3ff5db190a542f$var$ContentHeaderShareAndCopyButtons.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    isArchived: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
const $6e3ff5db190a542f$var$ShareAndCopyButtons = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { contentId: contentId, versionOverride: versionOverride, contentType: contentType, contentSubType: contentSubType, isArchived: isArchived } = t0;
    const t1 = `share-button${isArchived ? "-archived" : ""}`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            (0, $jBnsv.INVITE_TO_EDIT_KEY)
        ];
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            display: "flex"
        };
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== contentId || $[3] !== contentSubType || $[4] !== contentType) {
        t4 = (t5)=>{
            const { loading: loading, webItems: webItems } = t5;
            if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
                name: "ShareButtonPlaceholderSpacer",
                hold: loading
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$ShareButtonPlaceholderSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2pIlF.ShareRestrictAndCopyButtonPlaceholder), null)));
            webItems.forEach((item)=>{
                if (item.completeKey === (0, $jBnsv.INVITE_TO_EDIT_KEY)) {
                    item.contentId = contentId;
                    item.contentType = contentType;
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$StyledWebItemButtonList, {
                pageId: contentId,
                webItems: webItems,
                id: "extracted-share-button",
                contentSubType: contentSubType,
                source: "contentHeader"
            });
        };
        $[2] = contentId;
        $[3] = contentSubType;
        $[4] = contentType;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== contentId || $[7] !== t1 || $[8] !== t4 || $[9] !== versionOverride) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$StyledContainer, {
            "data-vc": "share-button-copy-link-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
            key: t1,
            tagName: "span",
            contentId: contentId,
            allowedWebItems: t2,
            location: (0, $eSLr0.PAGE_BUTTONS),
            version: versionOverride,
            style: t3,
            renderWhenLoading: true
        }, t4));
        $[6] = contentId;
        $[7] = t1;
        $[8] = t4;
        $[9] = versionOverride;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
};
$6e3ff5db190a542f$var$ShareAndCopyButtons.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    addItem: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    isArchived: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
const $6e3ff5db190a542f$export$6955dde08e119b3d = (props)=>{
    const $ = (0, $bDgLe.c)(32);
    const { contentId: contentId, versionOverride: versionOverride, isExternalCollaborator: isExternalCollaborator, spaceKey: spaceKey, contentSubType: contentSubType, contentType: contentType, isArchived: isArchived } = props;
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    (0, $hQBR9.useAutomationUrlParamTrigger)();
    let t0;
    if ($[0] !== contentId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8HdsQ.CommentButtonWrapper), {
            key: contentId,
            contentId: contentId,
            isCommentButtonSSRd: Boolean(window.__SSR_RENDERED__ || undefined)
        });
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== contentId || $[3] !== contentType || $[4] !== isArchived || $[5] !== isLoomDisabled || $[6] !== spaceKey) {
        t1 = !isArchived && !isLoomDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType
        });
        $[2] = contentId;
        $[3] = contentType;
        $[4] = isArchived;
        $[5] = isLoomDisabled;
        $[6] = spaceKey;
        $[7] = t1;
    } else t1 = $[7];
    let t2;
    let t3;
    if ($[8] !== contentId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cxCWb.FavouriteButton), {
            key: "favourite-button",
            contentId: contentId,
            useLegacyIcon: true
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvg6Y.WatchDialogWrapper), {
            key: "watch-dialog",
            contentId: contentId,
            defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE,
            componentLocation: (0, $2REhP.WATCH_DIALOG_LOCATION).PAGE
        });
        $[8] = contentId;
        $[9] = t2;
        $[10] = t3;
    } else {
        t2 = $[9];
        t3 = $[10];
    }
    let t4;
    if ($[11] !== contentSubType) {
        t4 = (t5)=>{
            const { webItems: webItems } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$WebItemsContainer, null, !!webItems.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$StyledBorder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$SystemContentButtonMaxWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$StyledWebItemButtonList, {
                webItems: webItems,
                buttonType: "aui-button-subtle",
                contentSubType: contentSubType
            })));
        };
        $[11] = contentSubType;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== contentId || $[14] !== t4 || $[15] !== versionOverride) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
            key: "page-buttons",
            contentId: contentId,
            location: (0, $eSLr0.PAGE_BUTTONS),
            notAllowedWebItems: (0, $8Cofr.FILTERED_WEB_ITEM_KEYS),
            tagName: "span",
            version: versionOverride
        }, t4);
        $[13] = contentId;
        $[14] = t4;
        $[15] = versionOverride;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== contentId || $[18] !== contentSubType || $[19] !== contentType || $[20] !== isArchived || $[21] !== isExternalCollaborator || $[22] !== versionOverride) {
        t6 = !isExternalCollaborator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$StyledBorder, null), isArchived && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $SAFLR.RestrictionsDialogTriggerWrapper), {
            triggeredFrom: "fromView",
            contentId: contentId,
            contentSubType: contentSubType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$ContentHeaderShareAndCopyButtons, {
            contentId: contentId,
            versionOverride: versionOverride,
            contentType: contentType,
            contentSubType: contentSubType,
            isArchived: isArchived
        }));
        $[17] = contentId;
        $[18] = contentSubType;
        $[19] = contentType;
        $[20] = isArchived;
        $[21] = isExternalCollaborator;
        $[22] = versionOverride;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== props || $[25] !== t0 || $[26] !== t1 || $[27] !== t2 || $[28] !== t3 || $[29] !== t5 || $[30] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Cofr.GroupedPageButtonsCommon), props, t0, t1, t2, t3, t5, t6);
        $[24] = props;
        $[25] = t0;
        $[26] = t1;
        $[27] = t2;
        $[28] = t3;
        $[29] = t5;
        $[30] = t6;
        $[31] = t7;
    } else t7 = $[31];
    return t7;
};
$6e3ff5db190a542f$export$6955dde08e119b3d.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    headerSticky: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    lastModifiedDate: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    isArchived: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
module.exports["GroupedPageButtons"] = $6e3ff5db190a542f$export$6955dde08e119b3d;

});

parcelRegister("5EoFB", function(module, exports) {
const $41d3d3266b0b22cf$export$6b0a1934b74e691a = {
    PAGE: 0,
    SPACE: 1
};
const $41d3d3266b0b22cf$export$1841061cdd9b445a = 20;
module.exports["MANAGE_WATCHER_TAB_TYPES"] = $41d3d3266b0b22cf$export$6b0a1934b74e691a;

});

parcelRegister("lECEN", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $5X6fy = parcelRequire("5X6fy");


var $cpjd2 = parcelRequire("cpjd2");


var $asQED = parcelRequire("asQED");

const $fc3b51da62867b20$export$4354248d0b2a76d1 = [
    'wr!confluence.web.resources:querystring',
    'wr!confluence.web.resources:navigator-context',
    'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
];
const $fc3b51da62867b20$export$562269fb9a75cb04 = (props)=>{
    const $ = (0, $bDgLe.c)(19);
    const { id: id, webItems: webItems, actions: actions, modifications: modifications, buttonType: buttonType, className: className, disableIcons: disableIcons, contentSubType: contentSubType, source: source } = props;
    let t0;
    if ($[0] !== webItems) {
        t0 = webItems.some($fc3b51da62867b20$var$_temp);
        $[0] = webItems;
        $[1] = t0;
    } else t0 = $[1];
    const needsConnectWRM = t0;
    let t1;
    let t2;
    if ($[2] !== needsConnectWRM) {
        t1 = ()=>{
            if (needsConnectWRM) (0, $cpjd2.requireLegacyWRM)($fc3b51da62867b20$export$4354248d0b2a76d1, $fc3b51da62867b20$var$_temp2, $fc3b51da62867b20$var$_temp3);
        };
        t2 = [
            needsConnectWRM
        ];
        $[2] = needsConnectWRM;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[5] !== className) {
        t3 = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))("aui-buttons", className);
        $[5] = className;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== buttonType) {
        t4 = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))(buttonType, "aui-button");
        $[7] = buttonType;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== actions || $[10] !== contentSubType || $[11] !== disableIcons || $[12] !== id || $[13] !== modifications || $[14] !== source || $[15] !== t3 || $[16] !== t4 || $[17] !== webItems) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $asQED.WebItemList), {
            dataTestId: "web-item-button-list",
            id: id,
            actions: actions,
            modifications: modifications,
            webItems: webItems,
            className: t3,
            webItemClassName: t4,
            disableIcons: disableIcons,
            contentSubType: contentSubType,
            source: source
        });
        $[9] = actions;
        $[10] = contentSubType;
        $[11] = disableIcons;
        $[12] = id;
        $[13] = modifications;
        $[14] = source;
        $[15] = t3;
        $[16] = t4;
        $[17] = webItems;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
};
$fc3b51da62867b20$export$562269fb9a75cb04.displayName = 'WebItemButtonList';
$fc3b51da62867b20$export$562269fb9a75cb04.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    webItems: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).array,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    modifications: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    buttonType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    disableIcons: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
function $fc3b51da62867b20$var$_temp(item) {
    return item.completeKey.startsWith("com.atlassian.plugins.atlassian-connect-plugin");
}
function $fc3b51da62867b20$var$_temp2() {}
function $fc3b51da62867b20$var$_temp3() {}
module.exports["WebItemButtonList"] = $fc3b51da62867b20$export$562269fb9a75cb04;

});

parcelRegister("cxCWb", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $gaGKC = parcelRequire("gaGKC");


const $56c3dbef55a81b41$export$a1f5ff36b0810fd8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "0sh4s",
    name: "FavouriteButton",
    loader: async ()=>(await (parcelRequire("hiOIh"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});

const $56c3dbef55a81b41$export$4151d732511e5aa6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "m_S4n",
    name: "LazyFavouriteButton",
    loader: async ()=>(await (parcelRequire("hiOIh"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});
module.exports["FavouriteButton"] = $56c3dbef55a81b41$export$a1f5ff36b0810fd8;
module.exports["LazyFavouriteButton"] = $56c3dbef55a81b41$export$4151d732511e5aa6;

});

parcelRegister("gaGKC", function(module, exports) {
/* FavouriteButtonPlaceholder.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $lbT4j = parcelRequire("lbT4j");

const $97ecf1ddef823285$var$i18n = (0, $kSwu1.defineMessages)({
    starLabel: {
        id: "favourite-button.placeholder.star.label",
        defaultMessage: "Star"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97ecf1ddef823285$var$StyledButton = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0sElkwuNcX _4GiLnvFQfX _27WIHEFQfX",
            __cmplp.className
        ])
    });
});
const $97ecf1ddef823285$export$d599e45cb4e3913 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97ecf1ddef823285$var$StyledButton, {
        "data-test-id": "page-favourite-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
            label: formatMessage($97ecf1ddef823285$var$i18n.starLabel),
            color: "currentColor",
            spacing: "spacious"
        }),
        isDisabled: true
    });
};
module.exports["FavouriteButtonPlaceholder"] = $97ecf1ddef823285$export$d599e45cb4e3913;

});

parcelRegister("hiOIh", function(module, exports) {

let $c98b74b6e06e1016$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c98b74b6e06e1016$var$load("cH8yZ"),
    $c98b74b6e06e1016$var$load("6wr18"),
    $c98b74b6e06e1016$var$load("ffEVr"),
    $c98b74b6e06e1016$var$load("aLbuU"),
    $c98b74b6e06e1016$var$load("1sXQt")
]).then(()=>parcelRequire('lDaLP'));

});

parcelRegister("D7PHQ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $9DHhW = parcelRequire("9DHhW");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $2pBiX = parcelRequire("2pBiX");


var $4R3wx = parcelRequire("4R3wx");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $3Wf43 = parcelRequire("3Wf43");


var $5i3ci = parcelRequire("5i3ci");


var $aFmsO = parcelRequire("aFmsO");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $531iT = parcelRequire("531iT");


var $cxQ7E = parcelRequire("cxQ7E");


const $981c6be93b35769c$var$PageHeaderLoomButtonLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Bpphw",
    name: "PageHeaderLoomButtonLoader",
    loader: async ()=>(await (parcelRequire("2g3eB"))).PageHeaderLoomButton,
    loading: ({ isCircle: isCircle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), {
            isCircle: isCircle
        })
});

const $981c6be93b35769c$var$LoomCrossFlowPopupCardLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "J-rGd",
    name: "LoomCrossFlowPopupCardLoader",
    loader: async ()=>(await (parcelRequire("k1Pfm"))).LoomCrossFlowPopupCard,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), null)
});

const $981c6be93b35769c$var$LoomCrossJoinPopupCardLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "32FyG",
    name: "LoomCrossJoinPopupCardLoader",
    loader: async ()=>(await (parcelRequire("13FQj"))).LoomCrossJoinPopupCard,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), null)
}); /**
     * This touchpoint was previously in the page header, but has now been moved to the comments sidebar.
     * The naming will remain the same to avoid breaking any existing usages of this name.
     */ 
const $981c6be93b35769c$var$ENTRYPOINT_ID = 'loom-confluence-page-header';
const $981c6be93b35769c$var$SOURCE_COMPONENT = 'loomConfluencePageHeader';
const $981c6be93b35769c$var$SOURCE_CONTEXT = 'confluencePageHeaderRecordAVideo';
const $981c6be93b35769c$var$i18n = (0, $kSwu1.defineMessages)({
    crossJoinEntryPointLabel: {
        id: "page-header-loom-button.crossJoinEntryPointLabel",
        defaultMessage: "Join your team on Loom to record a video"
    },
    crossSellPopupCardDescription: {
        id: "page-header-loom-button.crossSellPopupCardDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    crossSellPopupCardTitle: {
        id: "page-header-loom-button.crossSellPopupCardTitle",
        defaultMessage: "Share your work with video"
    },
    entryPointLabel: {
        id: "page-header-loom-button.entryPointLabel",
        defaultMessage: "Record a Loom video"
    }
});
const $981c6be93b35769c$var$ButtonSpacer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4ouGXIuNcX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $981c6be93b35769c$var$PageHeaderLoomEntryPointComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(85);
    const { contentId: contentId, crossSellPopupPlacement: crossSellPopupPlacement, crossSellSpotlightPlacement: crossSellSpotlightPlacement, spaceKey: spaceKey, contentType: contentType, flags: flags, isCircle: t1, testId: testId, source: source, isDisabled: t2 } = t0;
    const isCircle = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    let entryPointVariant;
    let error;
    let loading;
    if (window.__SSR_RENDERED__ && window.__SSR_LOOM_ENTRY_POINT__) entryPointVariant = window.__SSR_LOOM_ENTRY_POINT__.entryPointVariant;
    const entryPointFromState = (0, $4R3wx.useLoomEntryPointVariant)();
    entryPointVariant = entryPointFromState.entryPointVariant;
    error = entryPointFromState.error;
    loading = entryPointFromState.loading;
    const isEntryPointEnabled = [
        "BETA",
        "CO_USE",
        "CROSS_FLOW",
        "CROSS_JOIN",
        "NONE"
    ].includes(entryPointVariant);
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)($981c6be93b35769c$var$ENTRYPOINT_ID);
    const intl = (0, $kSwu1.useIntl)();
    let t3;
    if ($[0] !== flags) {
        t3 = {
            flags: flags
        };
        $[0] = flags;
        $[1] = t3;
    } else t3 = $[1];
    const loomEntryPointErrorCallback = (0, $2pBiX.useLoomEntryPointErrorCallback)(t3);
    let t4;
    if ($[2] !== createAnalyticsEvent || $[3] !== entryPointVariant) {
        t4 = ()=>{
            if (entryPointVariant === "CROSS_JOIN") createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    action: "viewed",
                    name: "createLoomHeaderItem",
                    attributes: {
                        adType: "crossJoin",
                        entrypoint: $981c6be93b35769c$var$ENTRYPOINT_ID,
                        sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = entryPointVariant;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== createAnalyticsEvent || $[6] !== entryPointVariant) {
        t5 = [
            createAnalyticsEvent,
            entryPointVariant
        ];
        $[5] = createAnalyticsEvent;
        $[6] = entryPointVariant;
        $[7] = t5;
    } else t5 = $[7];
    (0, $cozmU.useEffect)(t4, t5);
    if (!isEntryPointEnabled) return null;
    if (entryPointVariant === "BETA" || entryPointVariant === "CO_USE") {
        let t6;
        if ($[8] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
            $[8] = intl;
            $[9] = t6;
        } else t6 = $[9];
        let t7;
        if ($[10] !== isDisabled) {
            t7 = isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false);
            $[10] = isDisabled;
            $[11] = t7;
        } else t7 = $[11];
        let t8;
        if ($[12] !== contentId || $[13] !== contentType || $[14] !== isCircle || $[15] !== source || $[16] !== spaceKey || $[17] !== ssrPlaceholderIdProp || $[18] !== t6 || $[19] !== t7 || $[20] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($981c6be93b35769c$var$PageHeaderLoomButtonLoader, {
                contentId: contentId,
                contentType: contentType,
                dataVC: "loom-button",
                label: t6,
                spaceKey: spaceKey,
                ssrPlaceholderIdProp: ssrPlaceholderIdProp,
                isCircle: isCircle,
                testId: testId,
                source: source,
                isDisabled: t7
            });
            $[12] = contentId;
            $[13] = contentType;
            $[14] = isCircle;
            $[15] = source;
            $[16] = spaceKey;
            $[17] = ssrPlaceholderIdProp;
            $[18] = t6;
            $[19] = t7;
            $[20] = testId;
            $[21] = t8;
        } else t8 = $[21];
        return t8;
    }
    if (error) {
        let t6;
        if ($[22] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
            $[22] = intl;
            $[23] = t6;
        } else t6 = $[23];
        let t7;
        if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $531iT.LoomVideoIcon), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            });
            $[24] = t7;
        } else t7 = $[24];
        let t8;
        if ($[25] !== loomEntryPointErrorCallback || $[26] !== t6) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                appearance: "subtle",
                "aria-label": t6,
                "data-vc": "loom-button",
                iconAfter: t7,
                onClick: loomEntryPointErrorCallback
            });
            $[25] = loomEntryPointErrorCallback;
            $[26] = t6;
            $[27] = t8;
        } else t8 = $[27];
        return t8;
    }
    if (loading) {
        let t6;
        if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), null);
            $[28] = t6;
        } else t6 = $[28];
        return t6;
    }
    if (entryPointVariant === "CROSS_FLOW") {
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)("confluence_selection_hydration_loom_button", "isEnabled", false)) {
            let t6;
            if ($[29] !== intl) {
                t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
                $[29] = intl;
                $[30] = t6;
            } else t6 = $[30];
            let t7;
            if ($[31] !== intl) {
                t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
                $[31] = intl;
                $[32] = t7;
            } else t7 = $[32];
            let t8;
            if ($[33] !== intl) {
                t8 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
                $[33] = intl;
                $[34] = t8;
            } else t8 = $[34];
            let t9;
            if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $531iT.LoomVideoIcon), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                });
                $[35] = t9;
            } else t9 = $[35];
            let t10;
            if ($[36] !== crossSellSpotlightPlacement || $[37] !== isCircle || $[38] !== isPulseActive || $[39] !== t6 || $[40] !== t7 || $[41] !== t8) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Wf43.LoomCrossFlowPopupLoader), {
                    description: t6,
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    spotlightPlacement: crossSellSpotlightPlacement,
                    sourceActionSubjectId: "createLoomHeaderItem",
                    sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT,
                    sourceContext: $981c6be93b35769c$var$SOURCE_CONTEXT,
                    title: t7,
                    isCircle: isCircle,
                    ariaLabel: t8,
                    iconAfter: t9,
                    appearance: "subtle",
                    immediateActivationCondition: isPulseActive
                });
                $[36] = crossSellSpotlightPlacement;
                $[37] = isCircle;
                $[38] = isPulseActive;
                $[39] = t6;
                $[40] = t7;
                $[41] = t8;
                $[42] = t10;
            } else t10 = $[42];
            return t10;
        }
        let t6;
        if ($[43] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
            $[43] = intl;
            $[44] = t6;
        } else t6 = $[44];
        let t7;
        if ($[45] !== intl) {
            t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
            $[45] = intl;
            $[46] = t7;
        } else t7 = $[46];
        let t8;
        if ($[47] !== intl || $[48] !== isCircle || $[49] !== ssrPlaceholderIdProp) {
            t8 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($981c6be93b35769c$var$ButtonSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                    ...triggerProps,
                    appearance: "subtle",
                    "aria-label": intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel),
                    "data-vc": "loom-button",
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $531iT.LoomVideoIcon), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    ...ssrPlaceholderIdProp
                })));
            $[47] = intl;
            $[48] = isCircle;
            $[49] = ssrPlaceholderIdProp;
            $[50] = t8;
        } else t8 = $[50];
        let t9;
        if ($[51] !== crossSellSpotlightPlacement || $[52] !== t6 || $[53] !== t7 || $[54] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($981c6be93b35769c$var$LoomCrossFlowPopupCardLoader, {
                description: t6,
                entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                spotlightPlacement: crossSellSpotlightPlacement,
                sourceActionSubjectId: "createLoomHeaderItem",
                sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT,
                sourceContext: $981c6be93b35769c$var$SOURCE_CONTEXT,
                title: t7,
                trigger: t8
            });
            $[51] = crossSellSpotlightPlacement;
            $[52] = t6;
            $[53] = t7;
            $[54] = t8;
            $[55] = t9;
        } else t9 = $[55];
        return t9;
    }
    if (entryPointVariant === "CROSS_JOIN") {
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)("confluence_selection_hydration_loom_button", "isEnabled", false)) {
            let t6;
            if ($[56] !== intl) {
                t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
                $[56] = intl;
                $[57] = t6;
            } else t6 = $[57];
            let t7;
            if ($[58] !== intl) {
                t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
                $[58] = intl;
                $[59] = t7;
            } else t7 = $[59];
            let t8;
            if ($[60] !== intl) {
                t8 = intl.formatMessage($981c6be93b35769c$var$i18n.crossJoinEntryPointLabel);
                $[60] = intl;
                $[61] = t8;
            } else t8 = $[61];
            let t9;
            if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $531iT.LoomVideoIcon), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                });
                $[62] = t9;
            } else t9 = $[62];
            let t10;
            if ($[63] !== crossSellPopupPlacement || $[64] !== flags || $[65] !== isCircle || $[66] !== isPulseActive || $[67] !== t6 || $[68] !== t7 || $[69] !== t8) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Wf43.LoomCrossJoinPopupLoader), {
                    description: t6,
                    placement: crossSellPopupPlacement,
                    sourceActionSubjectId: "createLoomHeaderItem",
                    title: t7,
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle,
                    ariaLabel: t8,
                    iconAfter: t9,
                    appearance: "subtle",
                    immediateActivationCondition: isPulseActive,
                    flags: flags,
                    sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
                });
                $[63] = crossSellPopupPlacement;
                $[64] = flags;
                $[65] = isCircle;
                $[66] = isPulseActive;
                $[67] = t6;
                $[68] = t7;
                $[69] = t8;
                $[70] = t10;
            } else t10 = $[70];
            return t10;
        }
        let t6;
        if ($[71] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
            $[71] = intl;
            $[72] = t6;
        } else t6 = $[72];
        let t7;
        if ($[73] !== intl) {
            t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
            $[73] = intl;
            $[74] = t7;
        } else t7 = $[74];
        let t8;
        if ($[75] !== intl || $[76] !== isCircle || $[77] !== ssrPlaceholderIdProp) {
            t8 = (href, t9)=>{
                const { onClick: onClick, ...otherTriggerProps } = t9;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($981c6be93b35769c$var$ButtonSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                    ...otherTriggerProps,
                    appearance: "subtle",
                    "aria-label": intl.formatMessage($981c6be93b35769c$var$i18n.crossJoinEntryPointLabel),
                    "data-vc": "loom-button",
                    href: href,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $531iT.LoomVideoIcon), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    rel: "noreferrer",
                    target: "_blank",
                    onClick: onClick,
                    ...ssrPlaceholderIdProp
                })));
            };
            $[75] = intl;
            $[76] = isCircle;
            $[77] = ssrPlaceholderIdProp;
            $[78] = t8;
        } else t8 = $[78];
        let t9;
        if ($[79] !== crossSellPopupPlacement || $[80] !== flags || $[81] !== t6 || $[82] !== t7 || $[83] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($981c6be93b35769c$var$LoomCrossJoinPopupCardLoader, {
                description: t6,
                placement: crossSellPopupPlacement,
                sourceActionSubjectId: "createLoomHeaderItem",
                title: t7,
                entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                triggerLink: t8,
                flags: flags,
                sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
            });
            $[79] = crossSellPopupPlacement;
            $[80] = flags;
            $[81] = t6;
            $[82] = t7;
            $[83] = t8;
            $[84] = t9;
        } else t9 = $[84];
        return t9;
    }
    return null;
};
const $981c6be93b35769c$export$35695746566a3d63 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
})((0, $7aRa9.withFlags)($981c6be93b35769c$var$PageHeaderLoomEntryPointComponent));
module.exports["PageHeaderLoomEntryPoint"] = $981c6be93b35769c$export$35695746566a3d63;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $e5ba90f4b97bd7c1$var$i18n = (0, $kSwu1.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");


var $c5JFM = parcelRequire("c5JFM");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(12);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
        $[0] = t0;
    } else t0 = $[0];
    const includeMeetingRecorderEligibility = t0;
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t1;
    if ($[1] !== cloudId) {
        t1 = {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        };
        $[1] = cloudId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== activationId || $[4] !== cloudId) {
        t2 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[3] = activationId;
        $[4] = cloudId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            headers: {
                ...t2
            }
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const t4 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t5;
    if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
        t5 = {
            variables: t1,
            context: t3,
            skip: t4
        };
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        ...t5,
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const includeMeetingRecorderEligibility = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__),
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<6593f3213f47a7e725f70d416f79d305>>
 * @relayHash 8a9390abebcb3e2c1af34fe271e87a0e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 35a7995000db8d19f165fbb586ae01b6e99b2295047bc3aced247c50c7b26886
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeMeetingRecorderEligibility"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ],
        "concreteType": "ConfluenceLoomEntryPoints",
        "kind": "LinkedField",
        "name": "confluence_loomEntryPoints",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isLoomEntryPointsEnabled"
            }
        ]
    }, v2 = [
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "cloudId"
        }
    ], v3 = {
        "args": v2 /*: any*/ ,
        "concreteType": "LoomSettings",
        "kind": "LinkedField",
        "name": "loom_settings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "meetingRecordingsAvailable"
            },
            {
                "kind": "ScalarField",
                "name": "meetingNotesEligible"
            }
        ]
    }, v4 = {
        "args": v2 /*: any*/ ,
        "concreteType": "LoomConnectedCalendar",
        "kind": "LinkedField",
        "name": "loom_connectedCalendars",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "guid"
            }
        ]
    }, v5 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v6 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "loom"
        }
    ], v7 = {
        "concreteType": "CcpEntitlementRelationship",
        "kind": "LinkedField",
        "name": "relatesFromEntitlements",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "relationshipId"
            },
            {
                "kind": "ScalarField",
                "name": "entitlementId"
            },
            {
                "kind": "ScalarField",
                "name": "relationshipType"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "condition": "includeMeetingRecorderEligibility",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": "loomEntitlementInfo",
                                    "args": v6 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "CcpEntitlement",
                                                    "kind": "LinkedField",
                                                    "name": "entitlement",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "CommerceEntitlementInfoCcp"
                                        }
                                    ],
                                    "storageKey": "entitlementInfo(hamsProductKey:\"loom\")"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "condition": "includeMeetingRecorderEligibility",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": "loomEntitlementInfo",
                                    "args": v6 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "CcpEntitlement",
                                                    "kind": "LinkedField",
                                                    "name": "entitlement",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CommerceEntitlementInfoCcp"
                                        }
                                    ],
                                    "storageKey": "entitlementInfo(hamsProductKey:\"loom\")"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "8a9390abebcb3e2c1af34fe271e87a0e",
            "id": "35a7995000db8d19f165fbb586ae01b6e99b2295047bc3aced247c50c7b26886",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!,$includeMeetingRecorderEligibility:Boolean!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}\n  tenantContexts(cloudIds:[$cloudId])@include(if:$includeMeetingRecorderEligibility){loomEntitlementInfo:entitlementInfo(hamsProductKey:\"loom\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{relatesFromEntitlements{relationshipId,entitlementId,relationshipType},id}}}}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "5b4fce201b90479ea767c22013e8b06f";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("c5JFM", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $c8d6014c9c636b97$export$7c5b1b3e3108671e = ()=>(0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-ht-gate') || (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-lt-gate');
module.exports["isMeetingRecorderEligibilityEnabled"] = $c8d6014c9c636b97$export$7c5b1b3e3108671e;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== environment || $[5] !== initLoomEntryPointVariant || $[6] !== loading || $[7] !== skip || $[8] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId,
            environment
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = environment;
        $[5] = initLoomEntryPointVariant;
        $[6] = loading;
        $[7] = skip;
        $[8] = userId;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $gXfti = parcelRequire("gXfti");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $6mKj3 = parcelRequire("6mKj3");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $3uzFB = parcelRequire("3uzFB");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default),
            __callerPackage__: "loom-utils"
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    if ((0, $6mKj3.isExperimentEnabled)('confluence_frontend_loom_agg_perm_check_exp')) return $9633e2f0bea217d1$var$getLoomUserAggPermissionStatus(cloudId, userId);
    return $9633e2f0bea217d1$export$4fb5a1b2348fe5c4(cloudId, userId, environment);
};
const $9633e2f0bea217d1$export$4fb5a1b2348fe5c4 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$getLoomUserAggPermissionStatus = async (cloudId, userId)=>{
    if (!userId) return "not-permitted";
    const variables = (0, $3uzFB.getLoomUserPermissionQueryVariables)(cloudId, userId);
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $3uzFB.LoomUserPermissionQuery),
            variables: variables,
            errorPolicy: 'all',
            interopApolloAggClient: true,
            __callerPackage__: "loom-utils"
        });
        if (error) throw error;
        return (0, $3uzFB.hasExactLoomUserPermission)(data, variables) ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    // No preloader counterpart needed: setCrossJoinSuccess is a runtime-only action
    // triggered after a user completes the interactive cross-join flow (navigates to
    // Loom, gets provisioned, and returns). This cannot occur during SSR. The
    // window.__SSR_LOOM_ENTRY_POINT__ write updates the cached signal so that
    // useLoomEntryPointVariant sees CO_USE on subsequent client-side navigations
    // without re-running the permissions fetch — same pattern as crossFlowSuccessCheck.
    setCrossJoinSuccess: ()=>({ setState: setState })=>{
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
            window.__SSR_LOOM_ENTRY_POINT__ = {
                entryPointVariant: 'CO_USE'
            };
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $gXfti.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $8s9DV.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $kBr4q.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $kBr4q.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserLegacyPermissionStatus"] = $9633e2f0bea217d1$export$4fb5a1b2348fe5c4;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("3uzFB", function(module, exports) {

var $keH2u = parcelRequire("keH2u");

const $9ee481529bbe8b4d$export$a4bb6b905bc500e2 = (0, $keH2u.default);
const $9ee481529bbe8b4d$export$8d50de945dbf45ca = (cloudId, userId)=>({
        principalId: `ari:cloud:identity::user/${userId}`,
        loomResourceId: `ari:cloud:loom::site/${cloudId}`
    });
const $9ee481529bbe8b4d$export$b048e9c33b8e482 = (data, variables)=>{
    const matchingRows = data?.bulkPermitted?.filter((row)=>row?.principalId === variables.principalId && row?.resourceId === variables.loomResourceId && row?.permissionId === 'write') ?? [];
    if (matchingRows.length < 1) return false;
    return matchingRows.every((row)=>row?.permitted === true);
};
module.exports["LoomUserPermissionQuery"] = $9ee481529bbe8b4d$export$a4bb6b905bc500e2;
module.exports["getLoomUserPermissionQueryVariables"] = $9ee481529bbe8b4d$export$8d50de945dbf45ca;
module.exports["hasExactLoomUserPermission"] = $9ee481529bbe8b4d$export$b048e9c33b8e482;

});

parcelRegister("keH2u", function(module, exports) {
/**
 * @generated SignedSource<<9936c66f475f5b5cae80af06b548f8cb>>
 * @relayHash 1246767ea7fb9149278e67c3ec09752c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5
const $ebcff904befcd9cb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "loomResourceId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "permissionIds",
                    "value": [
                        "write"
                    ]
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "principalIds.0",
                            "variableName": "principalId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "principalIds"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "resourceIds.0",
                            "variableName": "loomResourceId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "resourceIds"
                }
            ],
            "concreteType": "BulkPermittedResponse",
            "kind": "LinkedField",
            "name": "bulkPermitted",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "principalId"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permissionId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permitted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "1246767ea7fb9149278e67c3ec09752c",
            "id": "b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5",
            "metadata": {},
            "name": "loomUserPermissionQuery",
            "operationKind": "query",
            "text": "query loomUserPermissionQuery($principalId:String!,$loomResourceId:String!){bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted}}"
        }
    };
}();
$ebcff904befcd9cb$var$node.hash = "714c5537c580f754bda23bcf99534b30";
var $ebcff904befcd9cb$export$2e2bcd8739ae039 = $ebcff904befcd9cb$var$node;
module.exports["default"] = $ebcff904befcd9cb$export$2e2bcd8739ae039;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<7e1563bf12c221b07284eee871d1f539>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3ricL = parcelRequire("3ricL");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("3Wf43", function(module, exports) {

var $gIaMn = parcelRequire("gIaMn");

var $jmjWc = parcelRequire("jmjWc");


var $5Abqh = parcelRequire("5Abqh");


const $98cee705389562e0$export$2a0b2901b6f1e4ac = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "TnkNJ",
    name: "LoomCrossFlowPopupLoader",
    loader: async ()=>(await (parcelRequire("6OCKP"))).LoomCrossFlowPopupComponent,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).LoomButton
});

const $98cee705389562e0$export$ba53a8d423873260 = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "d4je0",
    name: "LoomCrossJoinPopupLoader",
    loader: async ()=>(await (parcelRequire("cs5DY"))).LoomCrossJoinPopupComponent,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).LoomButton
});
module.exports["LoomCrossFlowPopupLoader"] = $98cee705389562e0$export$2a0b2901b6f1e4ac;
module.exports["LoomCrossJoinPopupLoader"] = $98cee705389562e0$export$ba53a8d423873260;

});

parcelRegister("6OCKP", function(module, exports) {

let $4f65796273829b41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4f65796273829b41$var$load("8tI7S"),
    $4f65796273829b41$var$load("6wr18"),
    $4f65796273829b41$var$load("CqGpG"),
    $4f65796273829b41$var$load("ffEVr"),
    $4f65796273829b41$var$load("2DxXe")
]).then(()=>parcelRequire('9cwPn'));

});

parcelRegister("cs5DY", function(module, exports) {

let $910c7a4706af15e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $910c7a4706af15e1$var$load("8tI7S"),
    $910c7a4706af15e1$var$load("EYiM3")
]).then(()=>parcelRequire('lvs3G'));

});

parcelRegister("5i3ci", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gWLTH = parcelRequire("gWLTH");


var $9wGTI = parcelRequire("9wGTI");


var $aFmsO = parcelRequire("aFmsO");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");

const $9fbe62170cacfcf3$export$d6e697640576fe29 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, entryPointId: entryPointId, isCircle: isCircle } = t0;
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)(entryPointId);
    if (!isPulseActive) return children;
    if ((0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children));
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    const t1 = isCircle ? 24 : 3;
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWLTH.Pulse), {
            radius: t1,
            testId: "loom-cross-sell-discoverability-pulse"
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, entryPointId: entryPointId, isCircle: isCircle })=>{
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)(entryPointId);
    if (!isPulseActive) return children;
    // Feature-gated migration from @atlaskit/onboarding to @atlaskit/spotlight
    if ((0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWLTH.Pulse), {
        radius: isCircle ? 24 : 3,
        testId: "loom-cross-sell-discoverability-pulse"
    }, children);
};
module.exports["DiscoverabilityPulse"] = $9fbe62170cacfcf3$export$d6e697640576fe29;

});

parcelRegister("aFmsO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6m3nS = parcelRequire("6m3nS");


var $gd8AW = parcelRequire("gd8AW");

const $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS = [
    'cc-loom-x-sell-discoverability-pulse-1',
    'cc-loom-x-sell-discoverability-pulse-2',
    'cc-loom-x-sell-discoverability-pulse-3',
    'cc-loom-x-sell-discoverability-pulse-4',
    'cc-loom-x-sell-discoverability-pulse-5'
];
const $9c43e73b872d5b9c$var$TIMEOUT_MS = 300;
const $9c43e73b872d5b9c$var$LAST_PULSE_INDEX = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS.length - 1;
const $9c43e73b872d5b9c$var$requestNextPulse = (nextIndex, pulseHooks, hasRequestedRef, lastRequestedRef)=>{
    if (nextIndex < pulseHooks.length && !hasRequestedRef.current.has(nextIndex)) {
        hasRequestedRef.current.add(nextIndex);
        lastRequestedRef.current = {
            index: nextIndex,
            timestamp: Date.now()
        };
        pulseHooks[nextIndex].requestMessageStart();
    }
};
const $9c43e73b872d5b9c$export$2002ab0670152c89 = (0, $3u0dr.isReactCompilerActiveV2)() ? (entryPointId)=>{
    const $ = (0, $bDgLe.c)(74);
    const isPulseActive = (0, $gd8AW.useIsPulseActive)(entryPointId);
    const { startPulse: startPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t0;
    if ($[0] !== isPulseActive) {
        t0 = isPulseActive && (0, $gd8AW.havePulsesEnded)();
        $[0] = isPulseActive;
        $[1] = t0;
    } else t0 = $[1];
    const skipRefreshPulseStatus = t0;
    const pulse1 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[4]);
    let t1;
    if ($[2] !== pulse1 || $[3] !== pulse2 || $[4] !== pulse3 || $[5] !== pulse4 || $[6] !== pulse5) {
        t1 = [
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ];
        $[2] = pulse1;
        $[3] = pulse2;
        $[4] = pulse3;
        $[5] = pulse4;
        $[6] = pulse5;
        $[7] = t1;
    } else t1 = $[7];
    const pulseHooks = t1;
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Set();
        $[8] = t2;
    } else t2 = $[8];
    const hasRequestedRef = (0, $cozmU.useRef)(t2);
    const lastRequestedRef = (0, $cozmU.useRef)(null);
    const lastStartedIndexRef = (0, $cozmU.useRef)(null);
    const [timeoutTrigger, setTimeoutTrigger] = (0, $cozmU.useState)(0);
    let t3;
    if ($[9] !== pulseHooks || $[10] !== skipRefreshPulseStatus) {
        t3 = ()=>{
            if (skipRefreshPulseStatus) return;
            for(let i = 0; i < pulseHooks.length; i++){
                const pulseHook = pulseHooks[i];
                if (pulseHook.hasMessageStarted) {
                    lastRequestedRef.current = null;
                    lastStartedIndexRef.current = i;
                    break;
                }
                if (!hasRequestedRef.current.has(i)) {
                    hasRequestedRef.current.add(i);
                    lastRequestedRef.current = {
                        index: i,
                        timestamp: Date.now()
                    };
                    pulseHook.requestMessageStart();
                    break;
                }
            }
        };
        $[9] = pulseHooks;
        $[10] = skipRefreshPulseStatus;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== pulse1.handleClickTracking || $[13] !== pulse1.hasMessageStarted || $[14] !== pulse1.requestMessageStart || $[15] !== pulse2.handleClickTracking || $[16] !== pulse2.hasMessageStarted || $[17] !== pulse2.requestMessageStart || $[18] !== pulse3.handleClickTracking || $[19] !== pulse3.hasMessageStarted || $[20] !== pulse3.requestMessageStart || $[21] !== pulse4.handleClickTracking || $[22] !== pulse4.hasMessageStarted || $[23] !== pulse4.requestMessageStart || $[24] !== pulse5.handleClickTracking || $[25] !== pulse5.hasMessageStarted || $[26] !== pulse5.requestMessageStart || $[27] !== pulseHooks || $[28] !== skipRefreshPulseStatus) {
        t4 = [
            skipRefreshPulseStatus,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted,
            pulse1.requestMessageStart,
            pulse2.requestMessageStart,
            pulse3.requestMessageStart,
            pulse4.requestMessageStart,
            pulse5.requestMessageStart,
            pulse1.handleClickTracking,
            pulse2.handleClickTracking,
            pulse3.handleClickTracking,
            pulse4.handleClickTracking,
            pulse5.handleClickTracking
        ];
        $[12] = pulse1.handleClickTracking;
        $[13] = pulse1.hasMessageStarted;
        $[14] = pulse1.requestMessageStart;
        $[15] = pulse2.handleClickTracking;
        $[16] = pulse2.hasMessageStarted;
        $[17] = pulse2.requestMessageStart;
        $[18] = pulse3.handleClickTracking;
        $[19] = pulse3.hasMessageStarted;
        $[20] = pulse3.requestMessageStart;
        $[21] = pulse4.handleClickTracking;
        $[22] = pulse4.hasMessageStarted;
        $[23] = pulse4.requestMessageStart;
        $[24] = pulse5.handleClickTracking;
        $[25] = pulse5.hasMessageStarted;
        $[26] = pulse5.requestMessageStart;
        $[27] = pulseHooks;
        $[28] = skipRefreshPulseStatus;
        $[29] = t4;
    } else t4 = $[29];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[30] !== isPulseActive || $[31] !== pulseHooks || $[32] !== skipRefreshPulseStatus) {
        t5 = ()=>{
            if (skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
            const { index: index, timestamp: timestamp } = lastRequestedRef.current;
            const pulseHook_0 = pulseHooks[index];
            if (pulseHook_0.hasMessageStarted) {
                lastRequestedRef.current = null;
                return;
            }
            const elapsed = Date.now() - timestamp;
            if (elapsed >= $9c43e73b872d5b9c$var$TIMEOUT_MS) {
                lastRequestedRef.current = null;
                $9c43e73b872d5b9c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
            } else {
                const remainingTime = $9c43e73b872d5b9c$var$TIMEOUT_MS - elapsed;
                const timeoutId = setTimeout(()=>{
                    setTimeoutTrigger($9c43e73b872d5b9c$var$_temp);
                }, remainingTime);
                return ()=>clearTimeout(timeoutId);
            }
        };
        $[30] = isPulseActive;
        $[31] = pulseHooks;
        $[32] = skipRefreshPulseStatus;
        $[33] = t5;
    } else t5 = $[33];
    let t6;
    if ($[34] !== isPulseActive || $[35] !== pulse1.hasMessageStarted || $[36] !== pulse2.hasMessageStarted || $[37] !== pulse3.hasMessageStarted || $[38] !== pulse4.hasMessageStarted || $[39] !== pulse5.hasMessageStarted || $[40] !== pulseHooks || $[41] !== skipRefreshPulseStatus || $[42] !== timeoutTrigger) {
        t6 = [
            skipRefreshPulseStatus,
            isPulseActive,
            timeoutTrigger,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[34] = isPulseActive;
        $[35] = pulse1.hasMessageStarted;
        $[36] = pulse2.hasMessageStarted;
        $[37] = pulse3.hasMessageStarted;
        $[38] = pulse4.hasMessageStarted;
        $[39] = pulse5.hasMessageStarted;
        $[40] = pulseHooks;
        $[41] = skipRefreshPulseStatus;
        $[42] = timeoutTrigger;
        $[43] = t6;
    } else t6 = $[43];
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[44] !== entryPointId || $[45] !== pulseHooks || $[46] !== skipRefreshPulseStatus || $[47] !== startPulse) {
        t7 = ()=>{
            if (skipRefreshPulseStatus) return;
            for(let i_0 = 0; i_0 < pulseHooks.length; i_0++){
                const pulseHook_1 = pulseHooks[i_0];
                const messageId = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[i_0];
                if (pulseHook_1.hasMessageStarted) {
                    lastStartedIndexRef.current = i_0;
                    startPulse(entryPointId, messageId, {
                        onDismiss: ()=>pulseHook_1.dismissMessage(),
                        onClick: ()=>pulseHook_1.handleClickTracking?.()
                    });
                    if (i_0 === $9c43e73b872d5b9c$var$LAST_PULSE_INDEX) (0, $gd8AW.endPulses)();
                    break;
                }
            }
        };
        $[44] = entryPointId;
        $[45] = pulseHooks;
        $[46] = skipRefreshPulseStatus;
        $[47] = startPulse;
        $[48] = t7;
    } else t7 = $[48];
    let t8;
    if ($[49] !== entryPointId || $[50] !== pulse1.hasMessageStarted || $[51] !== pulse2.hasMessageStarted || $[52] !== pulse3.hasMessageStarted || $[53] !== pulse4.hasMessageStarted || $[54] !== pulse5.hasMessageStarted || $[55] !== pulseHooks || $[56] !== skipRefreshPulseStatus || $[57] !== startPulse) {
        t8 = [
            skipRefreshPulseStatus,
            entryPointId,
            startPulse,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[49] = entryPointId;
        $[50] = pulse1.hasMessageStarted;
        $[51] = pulse2.hasMessageStarted;
        $[52] = pulse3.hasMessageStarted;
        $[53] = pulse4.hasMessageStarted;
        $[54] = pulse5.hasMessageStarted;
        $[55] = pulseHooks;
        $[56] = skipRefreshPulseStatus;
        $[57] = startPulse;
        $[58] = t8;
    } else t8 = $[58];
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[59] !== isPulseActive || $[60] !== pulseHooks || $[61] !== skipRefreshPulseStatus) {
        t9 = ()=>{
            if (skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
            const startedIndex = lastStartedIndexRef.current;
            const startedPulseHook = pulseHooks[startedIndex];
            if (!startedPulseHook.hasMessageStarted) {
                hasRequestedRef.current.delete(startedIndex);
                lastStartedIndexRef.current = null;
                $9c43e73b872d5b9c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
            }
        };
        $[59] = isPulseActive;
        $[60] = pulseHooks;
        $[61] = skipRefreshPulseStatus;
        $[62] = t9;
    } else t9 = $[62];
    let t10;
    if ($[63] !== isPulseActive || $[64] !== pulse1.hasMessageStarted || $[65] !== pulse2.hasMessageStarted || $[66] !== pulse3.hasMessageStarted || $[67] !== pulse4.hasMessageStarted || $[68] !== pulse5.hasMessageStarted || $[69] !== pulseHooks || $[70] !== skipRefreshPulseStatus) {
        t10 = [
            skipRefreshPulseStatus,
            isPulseActive,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[63] = isPulseActive;
        $[64] = pulse1.hasMessageStarted;
        $[65] = pulse2.hasMessageStarted;
        $[66] = pulse3.hasMessageStarted;
        $[67] = pulse4.hasMessageStarted;
        $[68] = pulse5.hasMessageStarted;
        $[69] = pulseHooks;
        $[70] = skipRefreshPulseStatus;
        $[71] = t10;
    } else t10 = $[71];
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[72] !== isPulseActive) {
        t11 = {
            isPulseActive: isPulseActive
        };
        $[72] = isPulseActive;
        $[73] = t11;
    } else t11 = $[73];
    return t11;
} : (entryPointId)=>{
    // All hooks must be called unconditionally (Rules of Hooks)
    const isPulseActive = (0, $gd8AW.useIsPulseActive)(entryPointId);
    const { startPulse: startPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const skipRefreshPulseStatus = isPulseActive && (0, $gd8AW.havePulsesEnded)();
    // Call hooks at the top level for all message IDs
    const pulse1 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[4]);
    const pulseHooks = (0, $cozmU.useMemo)(()=>[
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ], [
        pulse1,
        pulse2,
        pulse3,
        pulse4,
        pulse5
    ]);
    // Track which messages we've requested to avoid duplicate requests
    const hasRequestedRef = (0, $cozmU.useRef)(new Set());
    // Track the last requested message index and when it was requested (for timeout)
    const lastRequestedRef = (0, $cozmU.useRef)(null);
    // Track which message index was last started (to detect dismissal)
    const lastStartedIndexRef = (0, $cozmU.useRef)(null);
    // State trigger to force re-evaluation when timeout expires
    const [timeoutTrigger, setTimeoutTrigger] = (0, $cozmU.useState)(0);
    // Request messages sequentially - only request the next one if previous ones haven't started
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Find the first message that hasn't started and request it
        // If a previous message has started, we stop (handled by the other effect)
        for(let i = 0; i < pulseHooks.length; i++){
            const pulseHook = pulseHooks[i];
            // If this message has started, we're done - don't request any more
            if (pulseHook.hasMessageStarted) {
                // Clear the timeout tracking since we found an active message
                lastRequestedRef.current = null;
                // Track which message is started (will be set by the activation effect, but set here too for consistency)
                lastStartedIndexRef.current = i;
                break;
            }
            // If we haven't requested this one yet, request it and stop
            // The effect will re-run when hasMessageStarted changes, allowing us to move to the next one
            if (!hasRequestedRef.current.has(i)) {
                hasRequestedRef.current.add(i);
                lastRequestedRef.current = {
                    index: i,
                    timestamp: Date.now()
                };
                pulseHook.requestMessageStart();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted,
        pulse1.requestMessageStart,
        pulse2.requestMessageStart,
        pulse3.requestMessageStart,
        pulse4.requestMessageStart,
        pulse5.requestMessageStart,
        pulse1.handleClickTracking,
        pulse2.handleClickTracking,
        pulse3.handleClickTracking,
        pulse4.handleClickTracking,
        pulse5.handleClickTracking
    ]);
    // Timeout handler: if a requested message hasn't started after a delay, try the next one
    // Note: If a message was already dismissed, Post Office filters it before page load
    // so we only need time for the initial load and state updates (~200-300ms)
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
        const { index: index, timestamp: timestamp } = lastRequestedRef.current;
        const pulseHook_0 = pulseHooks[index];
        // If the message has started, clear the timeout tracking
        if (pulseHook_0.hasMessageStarted) {
            lastRequestedRef.current = null;
            return;
        }
        // If enough time has passed and the message still hasn't started, move to the next one
        const elapsed = Date.now() - timestamp;
        if (elapsed >= $9c43e73b872d5b9c$var$TIMEOUT_MS) {
            // Clear the current request tracking
            lastRequestedRef.current = null;
            // Try the next message if available
            $9c43e73b872d5b9c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        } else {
            // Set a timeout to trigger re-evaluation when the timeout period elapses
            const remainingTime = $9c43e73b872d5b9c$var$TIMEOUT_MS - elapsed;
            const timeoutId = setTimeout(()=>{
                setTimeoutTrigger((prev)=>prev + 1);
            }, remainingTime);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        timeoutTrigger,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Reactively respond when a message starts - activate the pulse
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Check each pulse in sequence - activate the first one that has started
        for(let i_0 = 0; i_0 < pulseHooks.length; i_0++){
            const pulseHook_1 = pulseHooks[i_0];
            const messageId = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[i_0];
            if (pulseHook_1.hasMessageStarted) {
                lastStartedIndexRef.current = i_0;
                startPulse(entryPointId, messageId, {
                    onDismiss: ()=>pulseHook_1.dismissMessage(),
                    onClick: ()=>pulseHook_1.handleClickTracking?.()
                });
                // If this is the last pulse, mark pulses as ended
                if (i_0 === $9c43e73b872d5b9c$var$LAST_PULSE_INDEX) /**
           * Mark the EP message as "complete" and disable Loom discoverability in localStorage
           * immediately after showing the final pulse. Otherwise, if a user ignores the entrypoints
           * entirely and never clicks on one while it's pulsing, they'll:
           *
           * - Remain in the TAP audience forever
           * - Continue to check the EP messages every time an entrypoint renders
           *
           * This will technically unlock EP to show other messages, but the pulse is subtle enough that
           * this shouldn't result in poor UX
           */ (0, $gd8AW.endPulses)();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        entryPointId,
        startPulse,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Handle message dismissal: if a started message becomes not started, request the next one
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
        const startedIndex = lastStartedIndexRef.current;
        const startedPulseHook = pulseHooks[startedIndex];
        // If the message that was started is no longer started, it was dismissed
        if (!startedPulseHook.hasMessageStarted) {
            // Clear the tracking for this message so we can move forward
            hasRequestedRef.current.delete(startedIndex);
            lastStartedIndexRef.current = null;
            // Request the next message if available
            $9c43e73b872d5b9c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    return {
        isPulseActive: isPulseActive
    };
};
function $9c43e73b872d5b9c$var$_temp(prev) {
    return prev + 1;
}
module.exports["useDiscoverabilityPulse"] = $9c43e73b872d5b9c$export$2002ab0670152c89;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("gd8AW", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $8s9DV.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $kBr4q.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $kBr4q.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("531iT", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $60Yxm = parcelRequire("60Yxm");

const $bddab39ffd1b2325$export$412f97445c5fb31e = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const color = props.color || "var(--ds-icon-subtle, #505258)";
    const label = props.label || "";
    let t0;
    if ($[0] !== color || $[1] !== label || $[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            ...props,
            color: color,
            label: label,
            spacing: "spacious"
        });
        $[0] = color;
        $[1] = label;
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
module.exports["LoomVideoIcon"] = $bddab39ffd1b2325$export$412f97445c5fb31e;

});

parcelRegister("cxQ7E", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $1sCHt = parcelRequire("1sCHt");


var $4R3wx = parcelRequire("4R3wx");


var $531iT = parcelRequire("531iT");

const $acb63ca7a29d5cd7$var$buttonSpacerStyles = (0, $buxP3.xcss)({
    minWidth: '30px'
});
const $acb63ca7a29d5cd7$export$bc169f53ad8d6345 = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { isCircle: isCircle, isEnabled: isEnabled } = t0;
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    if (entryPointVariant === "DISABLED") return null;
    else {
        const t1 = isCircle ? "circle" : "default";
        const t2 = !isEnabled;
        let t3;
        if ($[0] !== t1 || $[1] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $acb63ca7a29d5cd7$var$buttonSpacerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                shape: t1,
                icon: (0, $531iT.LoomVideoIcon),
                testId: "page-header-loom-entry-point-loading-icon",
                "data-vc": "loom-button",
                isDisabled: t2,
                label: "Record a Loom video"
            }));
            $[0] = t1;
            $[1] = t2;
            $[2] = t3;
        } else t3 = $[2];
        return t3;
    }
};
module.exports["LoomPageHeaderPlaceholder"] = $acb63ca7a29d5cd7$export$bc169f53ad8d6345;

});

parcelRegister("2g3eB", function(module, exports) {

let $1a4f95af5e7c9b44$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1a4f95af5e7c9b44$var$load("8tI7S"),
    $1a4f95af5e7c9b44$var$load("Vjtcp")
]).then(()=>parcelRequire('hmdCl'));

});

parcelRegister("k1Pfm", function(module, exports) {

let $e94ba7310a879b09$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e94ba7310a879b09$var$load("8tI7S"),
    $e94ba7310a879b09$var$load("6wr18"),
    $e94ba7310a879b09$var$load("CqGpG"),
    $e94ba7310a879b09$var$load("ffEVr"),
    $e94ba7310a879b09$var$load("5Jv0P")
]).then(()=>parcelRequire('3Bted'));

});

parcelRegister("13FQj", function(module, exports) {

let $0c5687603373ef1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0c5687603373ef1b$var$load("8tI7S"),
    $0c5687603373ef1b$var$load("lx2XJ")
]).then(()=>parcelRequire('rnQny'));

});

parcelRegister("bvg6Y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $jmjWc = parcelRequire("jmjWc");


var $7boqA = parcelRequire("7boqA");


var $blsJs = parcelRequire("blsJs");


var $9SsRl = parcelRequire("9SsRl");


var $bl4QJ = parcelRequire("bl4QJ");


const $3be9bfd0a276360e$export$baaf0df5303f8865 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "L5BJl",
    name: "LazyDialogWrapperLoader",
    loader: async ()=>(await (parcelRequire("10db7"))).WatchDialogWrapper,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});

const $3be9bfd0a276360e$export$ab7826e0fbb7edbf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HpEKn",
    name: "WatchDialogWrapperLoader",
    loader: async ()=>(await (parcelRequire("10db7"))).WatchDialogWrapper,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});
const $3be9bfd0a276360e$export$a4de2aef32c151a8 = (props)=>{
    (0, $blsJs.useSubmitSSRScriptErrors)('page-watch-button');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        key: props.contentId,
        metric: (0, $9SsRl.WATCH_BUTTON_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3be9bfd0a276360e$export$ab7826e0fbb7edbf, props));
};
$3be9bfd0a276360e$export$a4de2aef32c151a8.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    defaultTab: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    componentLocation: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number
};
module.exports["LazyDialogWrapperLoader"] = $3be9bfd0a276360e$export$baaf0df5303f8865;
module.exports["WatchDialogWrapperLoader"] = $3be9bfd0a276360e$export$ab7826e0fbb7edbf;
module.exports["WatchDialogWrapper"] = $3be9bfd0a276360e$export$a4de2aef32c151a8;

});

parcelRegister("blsJs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5ZqQS = parcelRequire("5ZqQS");

const $7bdb5572ed9c8600$export$290a00987d4ffd42 = (scope)=>{
    (0, $cozmU.useEffect)(()=>{
        if (!window.__SSR_CLIENT_ERRORS__ || !window.__SSR_CLIENT_ERRORS__[scope]) return;
        const ssrErrors = window.__SSR_CLIENT_ERRORS__[scope];
        ssrErrors.forEach((error)=>(0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: 'backbone'
            }));
        delete window.__SSR_CLIENT_ERRORS__[scope];
    }, [
        scope
    ]);
};
module.exports["useSubmitSSRScriptErrors"] = $7bdb5572ed9c8600$export$290a00987d4ffd42;

});

parcelRegister("bl4QJ", function(module, exports) {
/* WatchButtonPlaceholder.js generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $a79Sy = parcelRequire("a79Sy");


var $7ZB0A = parcelRequire("7ZB0A");

const $84156adddab51810$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0sElkwuNcX _4GiLnvFQfX _27WIHEFQfX",
            __cmplp.className
        ])
    });
});
const $84156adddab51810$export$2d7669ced06071f = ({ compact: compact })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($84156adddab51810$export$2d5d2ba3c7c8c40b, {
        testId: "watch-button-placeholder",
        "data-test-id": "watch-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
            label: "WatchIcon",
            spacing: "spacious"
        }),
        isDisabled: true,
        spacing: compact ? 'compact' : 'default'
    });
$84156adddab51810$export$2d7669ced06071f.propTypes = {
    compact: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
module.exports["WatchButtonPlaceholder"] = $84156adddab51810$export$2d7669ced06071f;

});

parcelRegister("10db7", function(module, exports) {

let $0bb0037cee381d59$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0bb0037cee381d59$var$load("cH8yZ"),
    $0bb0037cee381d59$var$load("aLbuU"),
    $0bb0037cee381d59$var$load("6wr18"),
    $0bb0037cee381d59$var$load("6damH"),
    $0bb0037cee381d59$var$load("ffEVr"),
    $0bb0037cee381d59$var$load("953Uz"),
    $0bb0037cee381d59$var$load("cUtrS")
]).then(()=>parcelRequire('9dU2w'));

});

parcelRegister("8HdsQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $h0mTL = parcelRequire("h0mTL");


var $jIlrR = parcelRequire("jIlrR");


var $lF24E = parcelRequire("lF24E");

const $262f69aacf5ded76$var$noop = ()=>{};
const $262f69aacf5ded76$export$e64f20017ef2874a = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, isCommentButtonSSRd: isCommentButtonSSRd = false })=>{
    const { data: data, error: error } = (0, $lF24E.usePreloadCommentButton)(contentId, isCommentButtonSSRd);
    const contentNode = data?.commentData?.content?.nodes?.[0];
    const isFabricSuported = contentNode?.metadata?.frontend?.fabricEditorSupported ?? false;
    const [showCommentButton, setShowCommentButton] = (0, $cozmU.useState)(false);
    /* Scenario: A user has clicked on the button in SSR -> SPA transition.
     The mouse click event is captured and the loading of CommentButtonLazy is started.
     */ const handleCommentButtonClick = ()=>{
        setShowCommentButton(true);
    };
    /*Conditional Loading of CommentButtonLazy if FF is ON and showCommentButton true (user click)*/ /* in case of an error from CommentButtonQuery load CommentButtonLazy and allow CommentButton to make
          another network call to fetch data*/ const isDataLoaded = Boolean(data?.commentData && !error);
    if (showCommentButton || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h0mTL.CommentButtonLazy), {
        contentId: contentId,
        isDataLoaded: isDataLoaded,
        isFabricPage: isFabricSuported
    }));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jIlrR.CommentButtonPlaceholder), {
        isDisabled: !isDataLoaded && !isCommentButtonSSRd,
        handleCommentButtonClick: isDataLoaded || isCommentButtonSSRd ? handleCommentButtonClick : $262f69aacf5ded76$var$noop,
        contentId: contentId
    }));
});
module.exports["CommentButtonWrapper"] = $262f69aacf5ded76$export$e64f20017ef2874a;

});

parcelRegister("h0mTL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $jIlrR = parcelRequire("jIlrR");


const $3ed4db9782b8d46b$export$43a94cba75d164d3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pHrwQ",
    name: "CommentButtonLazy",
    loader: async ()=>(await (parcelRequire("bB2iM"))).CommentButton,
    loading: ({ isDataLoaded: isDataLoaded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jIlrR.CommentButtonPlaceholder), {
            isDisabled: !isDataLoaded
        })
});
module.exports["CommentButtonLazy"] = $3ed4db9782b8d46b$export$43a94cba75d164d3;

});

parcelRegister("jIlrR", function(module, exports) {
/* CommentButtonPlaceholder.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $fJCU9 = parcelRequire("fJCU9");


var $7ZB0A = parcelRequire("7ZB0A");


var $eDtFr = parcelRequire("eDtFr");


var $lpNn5 = parcelRequire("lpNn5");


var $gczDe = parcelRequire("gczDe");


var $7aw3q = parcelRequire("7aw3q");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");

const $e0f29c26904b1b78$export$2d5d2ba3c7c8c40b = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0sElkwuNcX _4GiLnvFQfX _27WIHEFQfX",
            __cmplp.className
        ])
    });
});
const $e0f29c26904b1b78$var$CommentCountWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5v1qpb",
            __cmplp.className
        ])
    });
});
const $e0f29c26904b1b78$export$400dbe00d66d91c = ({ isDisabled: isDisabled = true, handleCommentButtonClick: handleCommentButtonClick = ()=>{}, style: style, onRender: onRender })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!isDisabled) onRender && onRender();
    }, [
        isDisabled,
        onRender
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT)
    });
    const isEmbeddedCommentsEnabled = (0, $7aw3q.useEmbeddedComments)();
    const eventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    if (!isEmbeddedCommentsEnabled) return null;
    else if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f29c26904b1b78$export$2d5d2ba3c7c8c40b, {
        testId: "comment-button-placeholder",
        "data-test-id": "comment-button-placeholder",
        appearance: "subtle",
        "aria-label": formatMessage({
            id: "comment-button.icon.label",
            defaultMessage: "Comment button placeholder"
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: "",
            spacing: "spacious"
        }),
        isDisabled: true // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: style
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: (e)=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (document.getElementById('renderer-comments-sidebar')) {
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            } else handleCommentButtonClick(e);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "comment-button.tooltip",
            defaultMessage: "Show comments"
        }),
        shortcut: commentShortcutStrings,
        hideTooltipOnClick: true,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f29c26904b1b78$var$CommentCountWrapper, {
        onClick: handleCommentButtonClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f29c26904b1b78$export$2d5d2ba3c7c8c40b, {
        "data-id": "comment-button-placeholder",
        "data-cy": "comment-button-placeholder",
        testId: "comment-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: formatMessage({
                id: "comment-button.icon.label",
                defaultMessage: "Show comments"
            }),
            spacing: "spacious"
        })),
        isDisabled: isDisabled,
        style: style
    }))));
};
module.exports["CommentButtonPlaceholder"] = $e0f29c26904b1b78$export$400dbe00d66d91c;

});

parcelRegister("7aw3q", function(module, exports) {

var $lTECB = parcelRequire("lTECB");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 * Similarly, "enable-share" is an opt-in feature and should not be enabled when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons',
        'disable-close-button',
        'enable-share'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $4PNpW.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const hideCloseButton = allowedEditPageFeatures?.includes('disable-close-button');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo');
    const showShare = (0, $9wGTI.fg)('csm_ai_enable_share_feature') && allowedEditPageFeatures?.includes('enable-share');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        hideCloseButton: hideCloseButton,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled,
        showShare: showShare
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("bB2iM", function(module, exports) {

let $8714ef838e1c0ccb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8714ef838e1c0ccb$var$load("8LtYa"),
    $8714ef838e1c0ccb$var$load("9H0e8"),
    $8714ef838e1c0ccb$var$load("fM5g3"),
    $8714ef838e1c0ccb$var$load("i1fe2")
]).then(()=>parcelRequire('32Ecy'));

});

parcelRegister("lF24E", function(module, exports) {

var $6nmm4 = parcelRequire("6nmm4");


var $jMyy4 = parcelRequire("jMyy4");

const $d0986d2d4a7f2d28$var$usePreloadCommentButtonQuery = (0, $6nmm4.default);
const $d0986d2d4a7f2d28$export$d1f3401b494de415 = (contentId, isCommentButtonSSRd)=>{
    const { data: commentData, error: commentError } = (0, $jMyy4.useQueryInterop)($d0986d2d4a7f2d28$var$usePreloadCommentButtonQuery, {
        fetchPolicy: isCommentButtonSSRd ? 'cache-first' : 'cache-and-network',
        variables: {
            pageId: contentId
        },
        __callerPackage__: "comment-button"
    });
    return {
        data: {
            commentData: commentData
        },
        error: commentError
    };
};
module.exports["usePreloadCommentButton"] = $d0986d2d4a7f2d28$export$d1f3401b494de415;

});

parcelRegister("6nmm4", function(module, exports) {
/**
 * @generated SignedSource<<88f279dbe5ccdf9215c75bd7dca3235f>>
 * @relayHash 9c0afe40300e5013e32bbea6173aea1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06aa97550eece151c700159d732523f4cb4864ece75d8cd83f2a2040951feaf5
const $31e2294f16992ac7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "count"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            }
        ],
        "type": "InlineComment"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "pageId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v3 /*: any*/ ,
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "editor"
                            }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JsonContentProperty",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "properties(key:\"editor\")"
                    },
                    {
                        "concreteType": "ContentMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                "kind": "LinkedField",
                                "name": "frontend",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "fabricEditorSupported"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePreloadCommentButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePreloadCommentButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9c0afe40300e5013e32bbea6173aea1d",
            "id": "06aa97550eece151c700159d732523f4cb4864ece75d8cd83f2a2040951feaf5",
            "metadata": {},
            "name": "usePreloadCommentButtonQuery",
            "operationKind": "query",
            "text": "query usePreloadCommentButtonQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ALL){count,nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef}}}},content(id:$pageId){nodes{id,properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported}}}}}"
        }
    };
}();
$31e2294f16992ac7$var$node.hash = "213bd75259a759693c19bec62abadf60";
var $31e2294f16992ac7$export$2e2bcd8739ae039 = $31e2294f16992ac7$var$node;
module.exports["default"] = $31e2294f16992ac7$export$2e2bcd8739ae039;

});

parcelRegister("hAnPj", function(module, exports) {
$parcel$export(module.exports, "RestrictionsDialogTriggerWrapper", () => (parcelRequire("SAFLR")).RestrictionsDialogTriggerWrapper);
$parcel$export(module.exports, "RestrictionsDialogTrigger", () => (parcelRequire("lEXFh")).RestrictionsDialogTrigger);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $SAFLR = parcelRequire("SAFLR");


var $lEXFh = parcelRequire("lEXFh");



const $bb619eb96b539cb1$export$8c358bcfa2c0ec3f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qdHUS",
    name: "LazyRestrictionsDialogMountPoint",
    loader: async ()=>(await (parcelRequire("lQfHx"))).RestrictionsDialogMountPoint
});
module.exports["LazyRestrictionsDialogMountPoint"] = $bb619eb96b539cb1$export$8c358bcfa2c0ec3f;

});

parcelRegister("SAFLR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $lEXFh = parcelRequire("lEXFh");

const $84211cd137cf57b0$export$e8086e85d5f7d830 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    let t0;
    if ($[0] !== hasAccess || $[1] !== props) {
        t0 = hasAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            key: "restriction-button-start",
            id: props.contentId,
            name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lEXFh.RestrictionsDialogTrigger), props)) : null;
        $[0] = hasAccess;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
            key: "restrictions-dialog-trigger"
        }, t0);
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
        key: "restrictions-dialog-trigger"
    }, hasAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        key: "restriction-button-start",
        id: props.contentId,
        name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lEXFh.RestrictionsDialogTrigger), props)) : null);
};
module.exports["RestrictionsDialogTriggerWrapper"] = $84211cd137cf57b0$export$e8086e85d5f7d830;

});

parcelRegister("lEXFh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $iMnC5 = parcelRequire("iMnC5");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $7boqA = parcelRequire("7boqA");


var $b27bJ = parcelRequire("b27bJ");


var $euL71 = parcelRequire("euL71");


var $8RR7m = parcelRequire("8RR7m");


var $7zgzO = parcelRequire("7zgzO");


var $ckmNl = parcelRequire("ckmNl");


var $jLw6A = parcelRequire("jLw6A");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $bVAxT = parcelRequire("bVAxT");


var $14SPd = parcelRequire("14SPd");


var $cSVAY = parcelRequire("cSVAY");


var $eE3dj = parcelRequire("eE3dj");


var $fkOJz = parcelRequire("fkOJz");

const $0b24ce56d1d6b617$var$styles = {
    buttonContainer: "_3iDTPbvbI6 _1RrJLiBwqQ"
};
const $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT = 'bottom-end';
const $0b24ce56d1d6b617$export$4a978df01c3bf89e = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(28);
    const contentId = (0, $ckmNl.useContentId)(props.contentId) || "";
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            grantAccessClicked: false,
            hasAutoOpenedRestrictionDialog: false,
            showFreeRestrictionDialog: false
        };
        $[0] = t0;
    } else t0 = $[0];
    const [state, setState] = (0, $cozmU.useState)(t0);
    const contentSubType = props.contentSubType;
    const useAnalyticsEventsHook = (0, $9DHhW.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[1] !== contentId || $[2] !== contentSubType || $[3] !== contentType || $[4] !== edition || $[5] !== experienceTracker || $[6] !== useAnalyticsEventsHook) {
        t1 = (dialogStateContainer)=>()=>$0b24ce56d1d6b617$export$59974e42a4613c7({
                    ...useAnalyticsEventsHook,
                    actionSubjectId: "restrictionsDialogButton",
                    dialogStateContainer: dialogStateContainer,
                    edition: edition,
                    experienceTracker: experienceTracker,
                    contentType: contentType,
                    contentSubType: contentSubType,
                    contentId: contentId
                });
        $[1] = contentId;
        $[2] = contentSubType;
        $[3] = contentType;
        $[4] = edition;
        $[5] = experienceTracker;
        $[6] = useAnalyticsEventsHook;
        $[7] = t1;
    } else t1 = $[7];
    const makeHandleOpen = t1;
    const getParentData = $0b24ce56d1d6b617$var$_temp;
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setState($0b24ce56d1d6b617$var$_temp2);
        };
        $[8] = t2;
    } else t2 = $[8];
    const handleFreeEditionPadlockClicked = t2;
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setState($0b24ce56d1d6b617$var$_temp3);
        };
        $[9] = t3;
    } else t3 = $[9];
    const onFreeDialogClosed = t3;
    let t4;
    if ($[10] !== contentId || $[11] !== makeHandleOpen || $[12] !== props || $[13] !== state) {
        t4 = (dialogStateContainer_0, shouldShowDialog)=>{
            const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props;
            const shouldSSRViewPageFreeEditionButton = triggeredFrom === "fromView";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLw6A.PageRestrictionsContextConsumer), null, (t5)=>{
                const { loading: loading, error: error, restrictions: restrictions_0 } = t5;
                if (!restrictions_0 && loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
                const contentHasRestrictions = Boolean(restrictions_0?.hasRestrictions || restrictions_0?.hasInheritedRestrictions);
                const contentHasInheritedRestrictionsOnly = Boolean(restrictions_0?.hasInheritedRestrictions && !restrictions_0?.hasRestrictions);
                const immediateParentPageIndex = (restrictions_0?.ancestors.length || 0) - 1;
                const isChildPage = immediateParentPageIndex > 0;
                if (contentHasRestrictions) {
                    if (isChildPage && contentHasInheritedRestrictionsOnly) {
                        const parentData = getParentData(restrictions_0);
                        return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                            isOpen: state.showFreeRestrictionDialog,
                            onClose: onFreeDialogClosed,
                            parentData: parentData,
                            isChildPage: isChildPage,
                            placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                            contentId: contentId,
                            isDisabled: isDisabled,
                            onClick: handleFreeEditionPadlockClicked,
                            restrictionsButtonSSRRendered: true,
                            restrictionsButtonSSRLocation: "free inherited",
                            triggeredFrom: triggeredFrom
                        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                            isOpen: state.showFreeRestrictionDialog,
                            onClose: onFreeDialogClosed,
                            parentData: parentData,
                            isChildPage: isChildPage,
                            placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                            contentId: contentId,
                            isDisabled: isDisabled,
                            onClick: handleFreeEditionPadlockClicked,
                            restrictionsButtonSSRLocation: "free inherited",
                            triggeredFrom: triggeredFrom
                        }));
                    }
                    if (shouldShowDialog && !state.hasAutoOpenedRestrictionDialog) {
                        makeHandleOpen(dialogStateContainer_0)();
                        setState($0b24ce56d1d6b617$var$_temp4);
                    }
                    return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        resetDialogState: ()=>dialogStateContainer_0.initState(),
                        onClick: makeHandleOpen(dialogStateContainer_0),
                        restrictionsButtonSSRRendered: true,
                        restrictionsButtonSSRLocation: "free grandfather",
                        triggeredFrom: triggeredFrom
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: makeHandleOpen(dialogStateContainer_0),
                        restrictionsButtonSSRLocation: "free grandfather",
                        triggeredFrom: triggeredFrom
                    });
                }
                return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                    isOpen: state.showFreeRestrictionDialog,
                    onClose: onFreeDialogClosed,
                    placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: handleFreeEditionPadlockClicked,
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "free",
                    triggeredFrom: triggeredFrom
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                    isOpen: state.showFreeRestrictionDialog,
                    onClose: onFreeDialogClosed,
                    placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: handleFreeEditionPadlockClicked,
                    restrictionsButtonSSRLocation: "free",
                    triggeredFrom: triggeredFrom
                }));
            });
        };
        $[10] = contentId;
        $[11] = makeHandleOpen;
        $[12] = props;
        $[13] = state;
        $[14] = t4;
    } else t4 = $[14];
    const renderFreeEditionDialog = t4;
    let t5;
    if ($[15] !== contentId || $[16] !== makeHandleOpen || $[17] !== props) {
        t5 = (dialogStateContainer_1)=>{
            const { isDisabled: isDisabled_0, triggeredFrom: triggeredFrom_0 } = props;
            if (triggeredFrom_0 && triggeredFrom_0 === "fromView") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled_0,
                onClick: makeHandleOpen(dialogStateContainer_1),
                resetDialogState: ()=>dialogStateContainer_1.initState(),
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "default",
                triggeredFrom: triggeredFrom_0
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled_0,
                onClick: makeHandleOpen(dialogStateContainer_1),
                restrictionsButtonSSRLocation: "default",
                triggeredFrom: triggeredFrom_0
            });
        };
        $[15] = contentId;
        $[16] = makeHandleOpen;
        $[17] = props;
        $[18] = t5;
    } else t5 = $[18];
    const renderRestrictionsButton = t5;
    let t6;
    if ($[19] !== contentId || $[20] !== renderRestrictionsButton) {
        t6 = (dialogStateContainer_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderRestrictionsButton(dialogStateContainer_2), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8RR7m.GrantAccessFlagLoader), {
                contentId: contentId
            }));
        $[19] = contentId;
        $[20] = renderRestrictionsButton;
        $[21] = t6;
    } else t6 = $[21];
    const renderGrantAccessFlagAndButton = t6;
    let t7;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ];
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== contentId || $[24] !== edition || $[25] !== renderFreeEditionDialog || $[26] !== renderGrantAccessFlagAndButton) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t7
        }, (dialogStateContainer_3)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $0b24ce56d1d6b617$var$styles.buttonContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
                isCustomStart: true,
                key: `start-${contentId}`,
                metric: (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
            }), edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zgzO.RoutesContext).Consumer, null, (t9)=>{
                const { getQueryParams: getQueryParams } = t9;
                const { accountId: accountId, grantAccess: grantAccess, username: username } = getQueryParams();
                const shouldShowGrantAccessDialog = Boolean(grantAccess && accountId || username);
                return edition === (0, $euL71.ConfluenceEdition).FREE ? renderFreeEditionDialog(dialogStateContainer_3, shouldShowGrantAccessDialog) : renderGrantAccessFlagAndButton(dialogStateContainer_3);
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fkOJz.RestrictionsButtonLoading), null)));
        $[23] = contentId;
        $[24] = edition;
        $[25] = renderFreeEditionDialog;
        $[26] = renderGrantAccessFlagAndButton;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : (props)=>{
    const contentId = (0, $ckmNl.useContentId)(props.contentId) || '';
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [state, setState] = (0, $cozmU.useState)({
        grantAccessClicked: false,
        hasAutoOpenedRestrictionDialog: false,
        showFreeRestrictionDialog: false
    });
    const contentSubType = props.contentSubType;
    const useAnalyticsEventsHook = (0, $9DHhW.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeHandleOpen = (dialogStateContainer)=>()=>$0b24ce56d1d6b617$export$59974e42a4613c7({
                ...useAnalyticsEventsHook,
                actionSubjectId: 'restrictionsDialogButton',
                dialogStateContainer: dialogStateContainer,
                edition: edition,
                experienceTracker: experienceTracker,
                contentType: contentType,
                contentSubType: contentSubType,
                contentId: contentId
            });
    const getParentData = (restrictions)=>{
        const ancestors = restrictions?.ancestors || [];
        for(let i = ancestors.length - 1; i >= 0; i--){
            if (ancestors[i].hasRestrictions) return ancestors[i]; // content
        }
    };
    const handleFreeEditionPadlockClicked = ()=>{
        setState((state_0)=>({
                ...state_0,
                showFreeRestrictionDialog: true
            }));
    };
    const onFreeDialogClosed = ()=>{
        setState((state_1)=>({
                ...state_1,
                showFreeRestrictionDialog: false
            }));
    };
    const renderFreeEditionDialog = (dialogStateContainer_0, shouldShowDialog)=>{
        const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props; // already free edition
        const shouldSSRViewPageFreeEditionButton = triggeredFrom === 'fromView';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLw6A.PageRestrictionsContextConsumer), null, ({ loading: loading, error: error, restrictions: restrictions_0 })=>{
            if (!restrictions_0 && loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
            const contentHasRestrictions = Boolean(restrictions_0?.hasRestrictions || restrictions_0?.hasInheritedRestrictions);
            const contentHasInheritedRestrictionsOnly = Boolean(restrictions_0?.hasInheritedRestrictions && !restrictions_0?.hasRestrictions);
            const immediateParentPageIndex = (restrictions_0?.ancestors.length || 0) - 1;
            const isChildPage = immediateParentPageIndex > 0; // Note: content with restrictions is excluded from the pageRestrictionsExperiment
            if (contentHasRestrictions) {
                if (isChildPage && contentHasInheritedRestrictionsOnly) {
                    const parentData = getParentData(restrictions_0);
                    return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRRendered: true,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    }));
                }
                if (shouldShowDialog && !state.hasAutoOpenedRestrictionDialog) {
                    makeHandleOpen(dialogStateContainer_0)();
                    setState((state_2)=>({
                            ...state_2,
                            hasAutoOpenedRestrictionDialog: true
                        }));
                } // grandfathered content
                return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    resetDialogState: ()=>dialogStateContainer_0.initState(),
                    onClick: makeHandleOpen(dialogStateContainer_0),
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: makeHandleOpen(dialogStateContainer_0),
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                });
            }
            return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            }));
        });
    };
    const renderRestrictionsButton = (dialogStateContainer_1)=>{
        const { isDisabled: isDisabled_0, triggeredFrom: triggeredFrom_0 } = props;
        if (triggeredFrom_0 && triggeredFrom_0 === 'fromView') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
            contentId: contentId,
            isDisabled: isDisabled_0,
            onClick: makeHandleOpen(dialogStateContainer_1),
            resetDialogState: ()=>dialogStateContainer_1.initState(),
            restrictionsButtonSSRRendered: true,
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom_0
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
            contentId: contentId,
            isDisabled: isDisabled_0,
            onClick: makeHandleOpen(dialogStateContainer_1),
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom_0
        });
    };
    const renderGrantAccessFlagAndButton = (dialogStateContainer_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderRestrictionsButton(dialogStateContainer_2), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8RR7m.GrantAccessFlagLoader), {
            contentId: contentId
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer_3)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0b24ce56d1d6b617$var$styles.buttonContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            isCustomStart: true,
            key: `start-${contentId}`,
            metric: (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
        }), edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams })=>{
            const { accountId: accountId, grantAccess: grantAccess, username: // TODO(brizvash): non-gdpr params, remove when GDPR is on
            username } = getQueryParams();
            const shouldShowGrantAccessDialog = Boolean(grantAccess && accountId || username);
            return edition === (0, $euL71.ConfluenceEdition).FREE ? renderFreeEditionDialog(dialogStateContainer_3, shouldShowGrantAccessDialog) : renderGrantAccessFlagAndButton(dialogStateContainer_3);
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fkOJz.RestrictionsButtonLoading), null)));
});
$0b24ce56d1d6b617$export$4a978df01c3bf89e.displayName = 'RestrictionsDialogTrigger';
function $0b24ce56d1d6b617$export$59974e42a4613c7({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, dialogStateContainer: dialogStateContainer, edition: edition, experienceTracker: experienceTracker, triggeredFrom: triggeredFrom, contentType: contentType, contentSubType: contentSubType, contentId: contentId }) {
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            source: 'viewPageScreen',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                source: 'v2',
                triggeredFrom: triggeredFrom,
                edition: edition,
                contentType: contentType,
                isLivePage: contentSubType === 'live'
            }
        }
    }).fire();
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_EXPERIENCE),
        attributes: {
            contentType: contentType
        },
        collect (events, experience) {
            // Fail/Abort RESTRICTIONS_DIALOG as soon as _LOAD or _APPLY fails or aborts:
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskFail' || action === 'taskAbort') && (name === (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE) || name === (0, $irVI7.RESTRICTIONS_DIALOG_APPLY_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    }); //
    // Open RestrictionsDialog:
    //
    dialogStateContainer.setContentId(contentId);
    dialogStateContainer.setIsOpen(true, triggeredFrom);
    (0, $14SPd.RESTRICTIONS_DIALOG_METRIC).start();
}
function $0b24ce56d1d6b617$var$_temp(restrictions) {
    const ancestors = restrictions?.ancestors || [];
    for(let i = ancestors.length - 1; i >= 0; i--){
        if (ancestors[i].hasRestrictions) return ancestors[i];
    }
}
function $0b24ce56d1d6b617$var$_temp2(state_0) {
    return {
        ...state_0,
        showFreeRestrictionDialog: true
    };
}
function $0b24ce56d1d6b617$var$_temp3(state_1) {
    return {
        ...state_1,
        showFreeRestrictionDialog: false
    };
}
function $0b24ce56d1d6b617$var$_temp4(state_2) {
    return {
        ...state_2,
        hasAutoOpenedRestrictionDialog: true
    };
}
module.exports["RestrictionsDialogTrigger"] = $0b24ce56d1d6b617$export$4a978df01c3bf89e;

});

parcelRegister("b27bJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $306758770d5ee79f$export$4556cd06b2dec862 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "PlyJG",
    name: "ChangeEditionInlineDialogLoader",
    loader: async ()=>(await (parcelRequire("gthUF"))).ChangeEditionInlineDialog
});

const $306758770d5ee79f$export$5902d4a19951b5c3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4GH4a",
    name: "ChangeEditionInlineDialogPaintLoader",
    loader: async ()=>(await (parcelRequire("gthUF"))).ChangeEditionInlineDialog
});
module.exports["ChangeEditionInlineDialogLoader"] = $306758770d5ee79f$export$4556cd06b2dec862;
module.exports["ChangeEditionInlineDialogPaintLoader"] = $306758770d5ee79f$export$5902d4a19951b5c3;

});

parcelRegister("gthUF", function(module, exports) {

let $bfdd3feca862d035$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bfdd3feca862d035$var$load("6XCf4"),
    $bfdd3feca862d035$var$load("ebvEF"),
    $bfdd3feca862d035$var$load("aEiTV"),
    $bfdd3feca862d035$var$load("1qlDN"),
    $bfdd3feca862d035$var$load("1yVM6"),
    $bfdd3feca862d035$var$load("1zoBu")
]).then(()=>parcelRequire('4QNfT'));

});

parcelRegister("8RR7m", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1756d5d44ec15fad$export$a83249587a24be5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "960Da",
    name: "GrantAccessFlagLoader",
    loader: async ()=>(await (parcelRequire("4K8Yy"))).GrantAccessFlag
});
module.exports["GrantAccessFlagLoader"] = $1756d5d44ec15fad$export$a83249587a24be5;

});

parcelRegister("4K8Yy", function(module, exports) {

let $37426baa6fb21a26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $37426baa6fb21a26$var$load("dZsGY"),
    $37426baa6fb21a26$var$load("h4Nf7"),
    $37426baa6fb21a26$var$load("6wr18"),
    $37426baa6fb21a26$var$load("59hV4"),
    $37426baa6fb21a26$var$load("dr883"),
    $37426baa6fb21a26$var$load("bePXd"),
    $37426baa6fb21a26$var$load("ea3NB"),
    $37426baa6fb21a26$var$load("7EorR"),
    $37426baa6fb21a26$var$load("fuOfV"),
    $37426baa6fb21a26$var$load("jL1Ke"),
    $37426baa6fb21a26$var$load("5MQ0D"),
    $37426baa6fb21a26$var$load("6vqGz"),
    $37426baa6fb21a26$var$load("ffEVr"),
    $37426baa6fb21a26$var$load("eS3wT"),
    $37426baa6fb21a26$var$load("4uO8Y"),
    $37426baa6fb21a26$var$load("Wowvf"),
    $37426baa6fb21a26$var$load("2l8zo"),
    $37426baa6fb21a26$var$load("hhss7"),
    $37426baa6fb21a26$var$load("4mWJk")
]).then(()=>parcelRequire('4Cd45'));

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $kNIYN.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jIOyV = parcelRequire("jIOyV");


var $jX1qB = parcelRequire("jX1qB");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$f6bd20f4f796eb89 = 'folder-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["FOLDER_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f6bd20f4f796eb89;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("cSVAY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $eE3dj = parcelRequire("eE3dj");


var $fkOJz = parcelRequire("fkOJz");


const $c09757da0c891efc$export$758fc7bfe6cba448 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "langk",
    name: "RestrictionsButtonLoaderPaint",
    loader: async ()=>(await (parcelRequire("aTiwu"))).RestrictionsButton,
    loading: (0, $fkOJz.RestrictionsButtonLoading)
});

const $c09757da0c891efc$export$92f59ae572209281 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZXc7l",
    name: "RestrictionsButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("aTiwu"))).RestrictionsButton,
    loading: (0, $eE3dj.RestrictionsButtonPlaceholder)
});
module.exports["RestrictionsButtonLoaderPaint"] = $c09757da0c891efc$export$758fc7bfe6cba448;
module.exports["RestrictionsButtonLoaderAfterPaint"] = $c09757da0c891efc$export$92f59ae572209281;

});

parcelRegister("eE3dj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cb1652ec96a3881c$export$f7c9f842c83767d4 = (0, $3u0dr.isReactCompilerActiveV2)() ? function RestrictionsButtonPlaceholder() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "restrictions-button-placeholder",
            "data-test-id": "restrictions-button-placeholder",
            style: {
                width: 32,
                height: 32
            }
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RestrictionsButtonPlaceholder() {
    // The RestrictionsDialog will be positioned based on the initial dimensions of
    // RestrictionsButton, so we need to render a placeholder instead of `null`
    // This placeholder is also used in SSR.
    // All the place that is waiting for data in restrictions package should use this placeholder instead of null.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "restrictions-button-placeholder",
        "data-test-id": "restrictions-button-placeholder",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 32,
            height: 32
        }
    });
};
module.exports["RestrictionsButtonPlaceholder"] = $cb1652ec96a3881c$export$f7c9f842c83767d4;

});

parcelRegister("fkOJz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eE3dj = parcelRequire("eE3dj");

const $560660f3777cb1ae$export$3375d726052961a6 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
};
module.exports["RestrictionsButtonLoading"] = $560660f3777cb1ae$export$3375d726052961a6;

});

parcelRegister("aTiwu", function(module, exports) {

let $7edd68bc2f903c22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7edd68bc2f903c22$var$load("cH8yZ"),
    $7edd68bc2f903c22$var$load("6wr18"),
    $7edd68bc2f903c22$var$load("ffEVr"),
    $7edd68bc2f903c22$var$load("bfhXH")
]).then(()=>parcelRequire('l5Yc7'));

});

parcelRegister("lQfHx", function(module, exports) {

let $fe6aa23c64ba7ac0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fe6aa23c64ba7ac0$var$load("hhss7"),
    $fe6aa23c64ba7ac0$var$load("fno6o")
]).then(()=>parcelRequire('ca7si'));

});

parcelRegister("2pIlF", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $iV65j = parcelRequire("iV65j");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $luv00 = parcelRequire("luv00");


var $lT8a1 = parcelRequire("lT8a1");

const $4c5c52253c9aa054$var$iconSkeletonStyle = (0, $buxP3.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: 'radius.xsmall',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
});
const $4c5c52253c9aa054$var$SkeletonGlyph = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            testId: "icon-skeleton",
            xcss: $4c5c52253c9aa054$var$iconSkeletonStyle
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $4c5c52253c9aa054$export$4d89be89896b480 = ()=>{
    const $ = (0, $bDgLe.c)(3);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iV65j.SplitButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lT8a1.ShareAndRestrictButtonPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "copy-link-button-placeholder",
            icon: $4c5c52253c9aa054$var$SkeletonGlyph,
            label: "",
            isDisabled: true
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== ssrPlaceholderIdProp) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", ssrPlaceholderIdProp, t0);
        $[1] = ssrPlaceholderIdProp;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["ShareRestrictAndCopyButtonPlaceholder"] = $4c5c52253c9aa054$export$4d89be89896b480;

});

parcelRegister("8Cofr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $jBnsv = parcelRequire("jBnsv");


var $frvUM = parcelRequire("frvUM");


var $iAOfI = parcelRequire("iAOfI");

const $6464ae7cd7e3f432$export$fa1acf2328e09e6c = [
    (0, $jBnsv.WATCH_BUTTON_KEY),
    (0, $jBnsv.PAGE_FAVOURITE_KEY),
    (0, $jBnsv.PAGE_UNFAVOURITE_KEY),
    (0, $jBnsv.EDIT_BUTTON_PAGE_KEY),
    (0, $jBnsv.EDIT_BUTTON_BLOGPOST_KEY),
    (0, $jBnsv.INVITE_TO_EDIT_KEY)
];
const $6464ae7cd7e3f432$var$displayInlineBlock = {
    display: 'inline-block'
};
const $6464ae7cd7e3f432$var$displayFlex = {
    display: 'flex',
    alignItems: 'center'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6464ae7cd7e3f432$var$FlexNavigationContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0hPCNLDIqT _3iDTPbQ4SZ _0aFT5v1qpb _3TGfC9LRg7 _4kiQYAmpvA",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /* eslint-disable react/prop-types */ 
class $6464ae7cd7e3f432$export$60c40240daccf47b extends (0, $cozmU.PureComponent) {
    render() {
        const { spaceKey: spaceKey, contentId: contentId, versionOverride: versionOverride, showEdit: showEdit = true, isFabricPage: isFabricPage, allowedContentToolsItems: allowedContentToolsItems, children: children, contentType: contentType, isExternalCollaborator: isExternalCollaborator, isContentToolsForcedOpen: isContentToolsForcedOpen, setIsContentToolsForcedOpen: setIsContentToolsForcedOpen } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-id": "gpb-common",
            "data-testid": "gpb-common",
            "data-vc": "grouped-page-buttons-common"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6464ae7cd7e3f432$var$FlexNavigationContainer, {
            "data-vc": "grouped-page-buttons-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: $6464ae7cd7e3f432$var$displayInlineBlock
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-test-id": "content-buttons",
            style: $6464ae7cd7e3f432$var$displayFlex
        }, showEdit === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iAOfI.EditContentButton), {
            key: "edit-content-button",
            contentId: contentId
        }) : null, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $frvUM.ContentTools), {
            spaceKey: spaceKey,
            contentId: contentId,
            version: versionOverride,
            isFabricPage: isFabricPage,
            allowedContentToolsItems: allowedContentToolsItems,
            contentType: contentType,
            isExternalCollaborator: isExternalCollaborator,
            isContentToolsForcedOpen: isContentToolsForcedOpen,
            setIsContentToolsForcedOpen: setIsContentToolsForcedOpen
        })));
    }
}
$6464ae7cd7e3f432$export$60c40240daccf47b.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    showEdit: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isFabricPage: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    allowedContentToolsItems: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).any,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["FILTERED_WEB_ITEM_KEYS"] = $6464ae7cd7e3f432$export$fa1acf2328e09e6c;
module.exports["GroupedPageButtonsCommon"] = $6464ae7cd7e3f432$export$60c40240daccf47b;

});

parcelRegister("frvUM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4fa9fecc4e6fa66b$export$8e3d4e3d40a48fc4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3cAEv",
    name: "ContentTools",
    loader: async ()=>(await (parcelRequire("c9tpI"))).ContentTools
});
module.exports["ContentTools"] = $4fa9fecc4e6fa66b$export$8e3d4e3d40a48fc4;

});

parcelRegister("c9tpI", function(module, exports) {

let $8d8d2442ea0b4f1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8d8d2442ea0b4f1b$var$load("ct2Y3"),
    $8d8d2442ea0b4f1b$var$load("cjpt9"),
    $8d8d2442ea0b4f1b$var$load("26l7c"),
    $8d8d2442ea0b4f1b$var$load("aTNTz"),
    $8d8d2442ea0b4f1b$var$load("9V1vV"),
    $8d8d2442ea0b4f1b$var$load("4CyIY"),
    $8d8d2442ea0b4f1b$var$load("c831e"),
    $8d8d2442ea0b4f1b$var$load("dZsGY"),
    $8d8d2442ea0b4f1b$var$load("6XCf4"),
    $8d8d2442ea0b4f1b$var$load("ebvEF"),
    $8d8d2442ea0b4f1b$var$load("dgerE"),
    $8d8d2442ea0b4f1b$var$load("h4Nf7"),
    $8d8d2442ea0b4f1b$var$load("4t77a"),
    $8d8d2442ea0b4f1b$var$load("fM5g3"),
    $8d8d2442ea0b4f1b$var$load("cH8yZ"),
    $8d8d2442ea0b4f1b$var$load("el56J"),
    $8d8d2442ea0b4f1b$var$load("59hV4"),
    $8d8d2442ea0b4f1b$var$load("cFgVe"),
    $8d8d2442ea0b4f1b$var$load("5wzAc"),
    $8d8d2442ea0b4f1b$var$load("aEiTV"),
    $8d8d2442ea0b4f1b$var$load("dr883"),
    $8d8d2442ea0b4f1b$var$load("bePXd"),
    $8d8d2442ea0b4f1b$var$load("1qlDN"),
    $8d8d2442ea0b4f1b$var$load("1yVM6"),
    $8d8d2442ea0b4f1b$var$load("9cpj1"),
    $8d8d2442ea0b4f1b$var$load("aLbuU"),
    $8d8d2442ea0b4f1b$var$load("fuOfV"),
    $8d8d2442ea0b4f1b$var$load("jL1Ke"),
    $8d8d2442ea0b4f1b$var$load("5MQ0D"),
    $8d8d2442ea0b4f1b$var$load("6vqGz"),
    $8d8d2442ea0b4f1b$var$load("aC3bY"),
    $8d8d2442ea0b4f1b$var$load("eS3wT"),
    $8d8d2442ea0b4f1b$var$load("4uO8Y"),
    $8d8d2442ea0b4f1b$var$load("husez"),
    $8d8d2442ea0b4f1b$var$load("2l8zo"),
    $8d8d2442ea0b4f1b$var$load("4UHov"),
    $8d8d2442ea0b4f1b$var$load("hhss7"),
    $8d8d2442ea0b4f1b$var$load("6wr18"),
    $8d8d2442ea0b4f1b$var$load("bzc8Q"),
    $8d8d2442ea0b4f1b$var$load("ffEVr"),
    $8d8d2442ea0b4f1b$var$load("ea3NB"),
    $8d8d2442ea0b4f1b$var$load("Wowvf"),
    $8d8d2442ea0b4f1b$var$load("kyfJT"),
    $8d8d2442ea0b4f1b$var$load("7EorR"),
    $8d8d2442ea0b4f1b$var$load("hWs86")
]).then(()=>parcelRequire('bTUBB'));

});

parcelRegister("hlP5l", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $ca1c06444d7dc3f1$export$1acb68730768e8f3 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.BYLINE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $ca1c06444d7dc3f1$export$e2e4f4b09ade4a7e = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $ca1c06444d7dc3f1$export$9f06d0bab23f5435 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["BYLINE_METRIC"] = $ca1c06444d7dc3f1$export$1acb68730768e8f3;
module.exports["CONTENT_TITLE_METRIC"] = $ca1c06444d7dc3f1$export$e2e4f4b09ade4a7e;
module.exports["CONNECT_APP_WEB_FRAGMENT_METRIC"] = $ca1c06444d7dc3f1$export$9f06d0bab23f5435;

});

parcelRegister("a3W69", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $8bU3n = parcelRequire("8bU3n");


var $5FSHs = parcelRequire("5FSHs");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $zalpJ = parcelRequire("zalpJ");


var $8rneB = parcelRequire("8rneB");


var $1d2ww = parcelRequire("1d2ww");


var $8VcPj = parcelRequire("8VcPj");


var $7boqA = parcelRequire("7boqA");


var $gXrHX = parcelRequire("gXrHX");


var $lt6Lx = parcelRequire("lt6Lx");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $hlP5l = parcelRequire("hlP5l");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");


var $9BkfL = parcelRequire("9BkfL");


var $7xnK2 = parcelRequire("7xnK2");


var $eP7b6 = parcelRequire("eP7b6");

const $7e6bc24b02592f12$export$8b726f842fdbb0d1 = (0, $5FSHs.default);
const $7e6bc24b02592f12$export$5ab6716f55e6755d = (0, $8bU3n.default);
const $7e6bc24b02592f12$var$deriveLookAndFeelFromData = (data)=>{
    const { space: space } = data;
    if (!space) return null;
    const { lookAndFeel: lookAndFeel } = space;
    return {
        ...lookAndFeel,
        headings: lookAndFeel.headings.reduce((obj, heading)=>{
            obj[heading.key] = heading.value;
            return obj;
        }, {})
    };
};
const $7e6bc24b02592f12$export$27036aac658fb1f1 = (contentNode)=>{
    return contentNode?.metadata?.frontend?.fabricEditorSupported ?? false;
};
const $7e6bc24b02592f12$export$aaf6264d06ddc4ce = (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    let banner;
    let contentId;
    let hasCoverPicture;
    let includeDraftContentStatus;
    let isEmbeddedPage;
    let pageWidthType;
    let passThroughProps;
    let prefix;
    let spaceKey;
    let t1;
    if ($[0] !== t0) {
        ({ spaceKey: spaceKey, banner: banner, contentId: contentId, children: t1, prefix: prefix, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, includeDraftContentStatus: includeDraftContentStatus, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = banner;
        $[2] = contentId;
        $[3] = hasCoverPicture;
        $[4] = includeDraftContentStatus;
        $[5] = isEmbeddedPage;
        $[6] = pageWidthType;
        $[7] = passThroughProps;
        $[8] = prefix;
        $[9] = spaceKey;
        $[10] = t1;
    } else {
        banner = $[1];
        contentId = $[2];
        hasCoverPicture = $[3];
        includeDraftContentStatus = $[4];
        isEmbeddedPage = $[5];
        pageWidthType = $[6];
        passThroughProps = $[7];
        prefix = $[8];
        spaceKey = $[9];
        t1 = $[10];
    }
    const children = t1 === undefined ? null : t1;
    let t2;
    if ($[11] !== contentId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_TITLE_EXPERIENCE)
        });
        $[11] = contentId;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] !== contentId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            key: contentId,
            metric: (0, $hlP5l.CONTENT_TITLE_METRIC)
        });
        $[13] = contentId;
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== banner || $[16] !== children || $[17] !== contentId || $[18] !== hasCoverPicture || $[19] !== includeDraftContentStatus || $[20] !== isEmbeddedPage || $[21] !== pageWidthType || $[22] !== passThroughProps || $[23] !== prefix || $[24] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e6bc24b02592f12$var$ContentTitleWrapper, {
            contentId: contentId,
            spaceKey: spaceKey,
            banner: banner,
            prefix: prefix,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage,
            includeDraftContentStatus: includeDraftContentStatus,
            ...passThroughProps
        }, children);
        $[15] = banner;
        $[16] = children;
        $[17] = contentId;
        $[18] = hasCoverPicture;
        $[19] = includeDraftContentStatus;
        $[20] = isEmbeddedPage;
        $[21] = pageWidthType;
        $[22] = passThroughProps;
        $[23] = prefix;
        $[24] = spaceKey;
        $[25] = t4;
    } else t4 = $[25];
    let t5;
    if ($[26] !== t3 || $[27] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        }, t3, t4);
        $[26] = t3;
        $[27] = t4;
        $[28] = t5;
    } else t5 = $[28];
    let t6;
    if ($[29] !== t2 || $[30] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t2, t5);
        $[29] = t2;
        $[30] = t5;
        $[31] = t6;
    } else t6 = $[31];
    return t6;
};
const $7e6bc24b02592f12$export$50dbf7c0405e659c = (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    let banner;
    let contentFragmentRef;
    let contentId;
    let hasCoverPicture;
    let isEmbeddedPage;
    let pageWidthType;
    let passThroughProps;
    let prefix;
    let spaceFragmentRef;
    let spaceKey;
    let t1;
    if ($[0] !== t0) {
        ({ contentFragmentRef: contentFragmentRef, spaceFragmentRef: spaceFragmentRef, spaceKey: spaceKey, banner: banner, contentId: contentId, children: t1, prefix: prefix, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = banner;
        $[2] = contentFragmentRef;
        $[3] = contentId;
        $[4] = hasCoverPicture;
        $[5] = isEmbeddedPage;
        $[6] = pageWidthType;
        $[7] = passThroughProps;
        $[8] = prefix;
        $[9] = spaceFragmentRef;
        $[10] = spaceKey;
        $[11] = t1;
    } else {
        banner = $[1];
        contentFragmentRef = $[2];
        contentId = $[3];
        hasCoverPicture = $[4];
        isEmbeddedPage = $[5];
        pageWidthType = $[6];
        passThroughProps = $[7];
        prefix = $[8];
        spaceFragmentRef = $[9];
        spaceKey = $[10];
        t1 = $[11];
    }
    const children = t1 === undefined ? null : t1;
    let t2;
    if ($[12] !== contentId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_TITLE_EXPERIENCE)
        });
        $[12] = contentId;
        $[13] = t2;
    } else t2 = $[13];
    let t3;
    if ($[14] !== contentId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            key: contentId,
            metric: (0, $hlP5l.CONTENT_TITLE_METRIC)
        });
        $[14] = contentId;
        $[15] = t3;
    } else t3 = $[15];
    let t4;
    if ($[16] !== banner || $[17] !== children || $[18] !== contentFragmentRef || $[19] !== contentId || $[20] !== hasCoverPicture || $[21] !== isEmbeddedPage || $[22] !== pageWidthType || $[23] !== passThroughProps || $[24] !== prefix || $[25] !== spaceFragmentRef || $[26] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e6bc24b02592f12$var$ContentTitleFragmentWrapper, {
            contentFragmentRef: contentFragmentRef,
            spaceFragmentRef: spaceFragmentRef,
            contentId: contentId,
            spaceKey: spaceKey,
            banner: banner,
            prefix: prefix,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage,
            ...passThroughProps
        }, children);
        $[16] = banner;
        $[17] = children;
        $[18] = contentFragmentRef;
        $[19] = contentId;
        $[20] = hasCoverPicture;
        $[21] = isEmbeddedPage;
        $[22] = pageWidthType;
        $[23] = passThroughProps;
        $[24] = prefix;
        $[25] = spaceFragmentRef;
        $[26] = spaceKey;
        $[27] = t4;
    } else t4 = $[27];
    let t5;
    if ($[28] !== t3 || $[29] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        }, t3, t4);
        $[28] = t3;
        $[29] = t4;
        $[30] = t5;
    } else t5 = $[30];
    let t6;
    if ($[31] !== t2 || $[32] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t2, t5);
        $[31] = t2;
        $[32] = t5;
        $[33] = t6;
    } else t6 = $[33];
    return t6;
};
const $7e6bc24b02592f12$var$ContentTitleFragmentWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(58);
    let banner;
    let children;
    let contentFragmentRef;
    let contentId;
    let hasCoverPicture;
    let isEmbeddedPage;
    let pageWidthType;
    let passThroughProps;
    let prefix;
    let spaceFragmentRef;
    let spaceKey;
    if ($[0] !== t0) {
        ({ contentFragmentRef: contentFragmentRef, spaceFragmentRef: spaceFragmentRef, spaceKey: spaceKey, banner: banner, contentId: contentId, children: children, prefix: prefix, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = banner;
        $[2] = children;
        $[3] = contentFragmentRef;
        $[4] = contentId;
        $[5] = hasCoverPicture;
        $[6] = isEmbeddedPage;
        $[7] = pageWidthType;
        $[8] = passThroughProps;
        $[9] = prefix;
        $[10] = spaceFragmentRef;
        $[11] = spaceKey;
    } else {
        banner = $[1];
        children = $[2];
        contentFragmentRef = $[3];
        contentId = $[4];
        hasCoverPicture = $[5];
        isEmbeddedPage = $[6];
        pageWidthType = $[7];
        passThroughProps = $[8];
        prefix = $[9];
        spaceFragmentRef = $[10];
        spaceKey = $[11];
    }
    const data = (0, $6SsN4.useFragment)($7e6bc24b02592f12$export$8b726f842fdbb0d1, contentFragmentRef);
    const space = (0, $6SsN4.useFragment)($7e6bc24b02592f12$export$5ab6716f55e6755d, spaceFragmentRef ?? null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const title = data?.title || "";
    let t1;
    let t2;
    if ($[12] !== contentId || $[13] !== createAnalyticsEvent || $[14] !== title) {
        t1 = ()=>{
            if (title === "") createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    actionSubject: "emptyPageTitle",
                    action: "shown",
                    source: "ContentTitleComponent",
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            title,
            contentId
        ];
        $[12] = contentId;
        $[13] = createAnalyticsEvent;
        $[14] = title;
        $[15] = t1;
        $[16] = t2;
    } else {
        t1 = $[15];
        t2 = $[16];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[17] !== data) {
        t3 = $7e6bc24b02592f12$export$27036aac658fb1f1(data);
        $[17] = data;
        $[18] = t3;
    } else t3 = $[18];
    const isFabricPage = t3;
    let t4;
    if ($[19] !== data) {
        t4 = (0, $8VcPj.getContentAppearancePublished)(data);
        $[19] = data;
        $[20] = t4;
    } else t4 = $[20];
    const contentAppearance = t4;
    const centerTitle = isFabricPage && contentAppearance.appearance === (0, $1d2ww.ContentAppearanceType).DEFAULT;
    let t5;
    if ($[21] !== data) {
        t5 = (0, $8rneB.getPublishedEmojiId)({
            content: {
                nodes: [
                    data
                ]
            }
        });
        $[21] = data;
        $[22] = t5;
    } else t5 = $[22];
    const emojiId = t5;
    let t6;
    if ($[23] !== data) {
        t6 = (0, $8rneB.doesContentHaveEmojiPublished)(data);
        $[23] = data;
        $[24] = t6;
    } else t6 = $[24];
    const hasEmoji = t6;
    let t7;
    if ($[25] !== data) {
        t7 = (0, $zalpJ.getTitleContentProperty)({
            content: {
                nodes: [
                    data
                ]
            }
        });
        $[25] = data;
        $[26] = t7;
    } else t7 = $[26];
    const { titleContentProperties: titleContentProperties } = t7;
    let t8;
    if ($[27] !== space) {
        t8 = $7e6bc24b02592f12$var$deriveLookAndFeelFromData({
            space: space
        });
        $[27] = space;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[29] !== pageWidthType) {
        t9 = pageWidthType === "\"full-width\"" || pageWidthType === "\"max\"" && !(0, $6mKj3.expValEquals)("editor_tinymce_full_width_mode", "isEnabled", true) && !(0, $6mKj3.expValEquals)("confluence_max_width_content_appearance", "isEnabled", true);
        $[29] = pageWidthType;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== pageWidthType) {
        t10 = pageWidthType === "\"max\"" && ((0, $6mKj3.expValEquals)("editor_tinymce_full_width_mode", "isEnabled", true) || (0, $6mKj3.expValEquals)("confluence_max_width_content_appearance", "isEnabled", true));
        $[31] = pageWidthType;
        $[32] = t10;
    } else t10 = $[32];
    const t11 = data?.type ?? "";
    let t12;
    if ($[33] !== banner || $[34] !== centerTitle || $[35] !== children || $[36] !== contentId || $[37] !== emojiId || $[38] !== hasCoverPicture || $[39] !== hasEmoji || $[40] !== isEmbeddedPage || $[41] !== passThroughProps || $[42] !== prefix || $[43] !== spaceKey || $[44] !== t10 || $[45] !== t11 || $[46] !== t8 || $[47] !== t9 || $[48] !== title || $[49] !== titleContentProperties) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9BkfL.ContentTitleComponent), {
            contentId: contentId,
            title: title,
            lookAndFeel: t8,
            banner: banner,
            centerTitle: centerTitle,
            prefix: prefix,
            emojiId: emojiId,
            hasEmoji: hasEmoji,
            loading: false,
            hasCoverPicture: hasCoverPicture,
            isPageContentFullWidth: t9,
            isPageContentMaxWidth: t10,
            isEmbeddedPage: isEmbeddedPage,
            spaceKey: spaceKey,
            contentType: t11,
            titleContentProperties: titleContentProperties,
            ...passThroughProps
        }, children);
        $[33] = banner;
        $[34] = centerTitle;
        $[35] = children;
        $[36] = contentId;
        $[37] = emojiId;
        $[38] = hasCoverPicture;
        $[39] = hasEmoji;
        $[40] = isEmbeddedPage;
        $[41] = passThroughProps;
        $[42] = prefix;
        $[43] = spaceKey;
        $[44] = t10;
        $[45] = t11;
        $[46] = t8;
        $[47] = t9;
        $[48] = title;
        $[49] = titleContentProperties;
        $[50] = t12;
    } else t12 = $[50];
    const t13 = data?.space?.name || "";
    let t14;
    if ($[51] !== prefix || $[52] !== t13 || $[53] !== title) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
            contentTitle: title,
            contentSpace: t13,
            titlePrefix: prefix
        });
        $[51] = prefix;
        $[52] = t13;
        $[53] = title;
        $[54] = t14;
    } else t14 = $[54];
    let t15;
    if ($[55] !== t12 || $[56] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t12, t14);
        $[55] = t12;
        $[56] = t14;
        $[57] = t15;
    } else t15 = $[57];
    return t15;
};
const $7e6bc24b02592f12$var$ContentTitleWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(77);
    let banner;
    let children;
    let contentId;
    let hasCoverPicture;
    let includeDraftContentStatus;
    let isEmbeddedPage;
    let pageWidthType;
    let passThroughProps;
    let prefix;
    let spaceKey;
    if ($[0] !== t0) {
        ({ spaceKey: spaceKey, banner: banner, contentId: contentId, children: children, prefix: prefix, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, includeDraftContentStatus: includeDraftContentStatus, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = banner;
        $[2] = children;
        $[3] = contentId;
        $[4] = hasCoverPicture;
        $[5] = includeDraftContentStatus;
        $[6] = isEmbeddedPage;
        $[7] = pageWidthType;
        $[8] = passThroughProps;
        $[9] = prefix;
        $[10] = spaceKey;
    } else {
        banner = $[1];
        children = $[2];
        contentId = $[3];
        hasCoverPicture = $[4];
        includeDraftContentStatus = $[5];
        isEmbeddedPage = $[6];
        pageWidthType = $[7];
        passThroughProps = $[8];
        prefix = $[9];
        spaceKey = $[10];
    }
    const shouldCenterFabricPage = $7e6bc24b02592f12$var$_temp;
    let t1;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (graphqlData_0)=>{
            const isFabricPage = $7e6bc24b02592f12$export$27036aac658fb1f1(graphqlData_0);
            return isFabricPage ? shouldCenterFabricPage(graphqlData_0) : false;
        };
        $[11] = t1;
    } else t1 = $[11];
    const isCenteredTitle = t1;
    const { isExternalShareRequest: isExternalShareRequest } = (0, $cozmU.useContext)((0, $gXrHX.ExternalShareContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("cc-markdown-mode", "isEnabled", true);
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] !== includeDraftContentStatus || $[14] !== isExternalShareRequest) {
        t3 = includeDraftContentStatus && !isExternalShareRequest && {
            status: [
                "current",
                "draft"
            ]
        };
        $[13] = includeDraftContentStatus;
        $[14] = isExternalShareRequest;
        $[15] = t3;
    } else t3 = $[15];
    let t4;
    if ($[16] !== contentId || $[17] !== spaceKey || $[18] !== t3) {
        t4 = {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: null,
            embeddedContentRender: null,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            useNewContentTopper: true,
            isMarkdownModeEnabled: t2,
            includeDevDocsBylineConnection: false,
            ...t3
        };
        $[16] = contentId;
        $[17] = spaceKey;
        $[18] = t3;
        $[19] = t4;
    } else t4 = $[19];
    let t5;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            single: true,
            allowOnExternalPage: true
        };
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== t4) {
        t6 = {
            variables: t4,
            context: t5
        };
        $[21] = t4;
        $[22] = t6;
    } else t6 = $[22];
    const { loading: loading, error: error, data: queryData, refetch: refetch } = (0, $jMyy4.useQueryInterop)(isExternalShareRequest ? (0, $eP7b6.default) : (0, $fxLAA.default), {
        ...t6,
        __callerPackage__: "content-header"
    });
    const data = isExternalShareRequest ? queryData?.singleContent : queryData?.content?.nodes?.[0];
    let t7;
    if ($[23] !== contentId || $[24] !== refetch) {
        t7 = ()=>refetch({
                contentId: contentId,
                cacheBuster: ""
            });
        $[23] = contentId;
        $[24] = refetch;
        $[25] = t7;
    } else t7 = $[25];
    const reload = t7;
    let t8;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = [
            (0, $c0urc.ReloadType).content
        ];
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== reload) {
        t9 = {
            name: "title",
            types: t8,
            reload: reload
        };
        $[27] = reload;
        $[28] = t9;
    } else t9 = $[28];
    (0, $1SNEF.useQuickReloadSubscriber)(t9);
    const title = data?.title || "";
    let t10;
    let t11;
    if ($[29] !== contentId || $[30] !== createAnalyticsEvent || $[31] !== error || $[32] !== loading || $[33] !== title) {
        t10 = ()=>{
            if (!loading && !error && title === "") createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    actionSubject: "emptyPageTitle",
                    action: "shown",
                    source: "ContentTitleComponent",
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
        };
        t11 = [
            createAnalyticsEvent,
            title,
            loading,
            error,
            contentId
        ];
        $[29] = contentId;
        $[30] = createAnalyticsEvent;
        $[31] = error;
        $[32] = loading;
        $[33] = title;
        $[34] = t10;
        $[35] = t11;
    } else {
        t10 = $[34];
        t11 = $[35];
    }
    (0, $cozmU.useEffect)(t10, t11);
    if (error) {
        let t12;
        if ($[36] !== error) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[36] = error;
            $[37] = t12;
        } else t12 = $[37];
        return t12;
    } else if (!data) {
        let t12;
        if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7xnK2.ContentTitlePlaceholder), null);
            $[38] = t12;
        } else t12 = $[38];
        return t12;
    }
    let t12;
    if ($[39] !== queryData) {
        t12 = $7e6bc24b02592f12$var$deriveLookAndFeelFromData(queryData);
        $[39] = queryData;
        $[40] = t12;
    } else t12 = $[40];
    const lookAndFeel = t12;
    const spaceName = !isExternalShareRequest ? data?.space?.name : "";
    const centerTitle = isCenteredTitle(data);
    let t13;
    if ($[41] !== queryData) {
        t13 = (0, $8rneB.getPublishedEmojiId)(queryData);
        $[41] = queryData;
        $[42] = t13;
    } else t13 = $[42];
    const emojiId = t13;
    const t14 = isExternalShareRequest ? queryData?.singleContent : queryData?.content?.nodes?.[0];
    let t15;
    if ($[43] !== t14) {
        t15 = (0, $8rneB.doesContentHaveEmojiPublished)(t14);
        $[43] = t14;
        $[44] = t15;
    } else t15 = $[44];
    const hasEmoji = t15;
    let t16;
    if ($[45] !== queryData) {
        t16 = (0, $zalpJ.getTitleContentProperty)(queryData);
        $[45] = queryData;
        $[46] = t16;
    } else t16 = $[46];
    const { titleContentProperties: titleContentProperties } = t16;
    let t17;
    if ($[47] !== pageWidthType) {
        t17 = pageWidthType === "\"full-width\"" || pageWidthType === "\"max\"" && !(0, $6mKj3.expValEquals)("editor_tinymce_full_width_mode", "isEnabled", true) && !(0, $6mKj3.expValEquals)("confluence_max_width_content_appearance", "isEnabled", true);
        $[47] = pageWidthType;
        $[48] = t17;
    } else t17 = $[48];
    let t18;
    if ($[49] !== pageWidthType) {
        t18 = pageWidthType === "\"max\"" && ((0, $6mKj3.expValEquals)("editor_tinymce_full_width_mode", "isEnabled", true) || (0, $6mKj3.expValEquals)("confluence_max_width_content_appearance", "isEnabled", true));
        $[49] = pageWidthType;
        $[50] = t18;
    } else t18 = $[50];
    const t19 = data?.type ?? "";
    let t20;
    if ($[51] !== banner || $[52] !== centerTitle || $[53] !== children || $[54] !== contentId || $[55] !== emojiId || $[56] !== hasCoverPicture || $[57] !== hasEmoji || $[58] !== isEmbeddedPage || $[59] !== loading || $[60] !== lookAndFeel || $[61] !== passThroughProps || $[62] !== prefix || $[63] !== spaceKey || $[64] !== t17 || $[65] !== t18 || $[66] !== t19 || $[67] !== title || $[68] !== titleContentProperties) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9BkfL.ContentTitleComponent), {
            contentId: contentId,
            title: title,
            lookAndFeel: lookAndFeel,
            banner: banner,
            centerTitle: centerTitle,
            prefix: prefix,
            emojiId: emojiId,
            hasEmoji: hasEmoji,
            loading: loading,
            hasCoverPicture: hasCoverPicture,
            isPageContentFullWidth: t17,
            isPageContentMaxWidth: t18,
            isEmbeddedPage: isEmbeddedPage,
            spaceKey: spaceKey,
            contentType: t19,
            titleContentProperties: titleContentProperties,
            ...passThroughProps
        }, children);
        $[51] = banner;
        $[52] = centerTitle;
        $[53] = children;
        $[54] = contentId;
        $[55] = emojiId;
        $[56] = hasCoverPicture;
        $[57] = hasEmoji;
        $[58] = isEmbeddedPage;
        $[59] = loading;
        $[60] = lookAndFeel;
        $[61] = passThroughProps;
        $[62] = prefix;
        $[63] = spaceKey;
        $[64] = t17;
        $[65] = t18;
        $[66] = t19;
        $[67] = title;
        $[68] = titleContentProperties;
        $[69] = t20;
    } else t20 = $[69];
    const t21 = spaceName || "";
    let t22;
    if ($[70] !== prefix || $[71] !== t21 || $[72] !== title) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
            contentTitle: title,
            contentSpace: t21,
            titlePrefix: prefix
        });
        $[70] = prefix;
        $[71] = t21;
        $[72] = title;
        $[73] = t22;
    } else t22 = $[73];
    let t23;
    if ($[74] !== t20 || $[75] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t20, t22);
        $[74] = t20;
        $[75] = t22;
        $[76] = t23;
    } else t23 = $[76];
    return t23;
};
$7e6bc24b02592f12$export$aaf6264d06ddc4ce.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    banner: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node,
    prefix: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    headingContainer: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).elementType
};
$7e6bc24b02592f12$export$aaf6264d06ddc4ce.displayName = 'ContentTitle';
function $7e6bc24b02592f12$var$_temp(graphqlData) {
    const contentAppearance = (0, $8VcPj.getContentAppearancePublished)(graphqlData);
    return contentAppearance.appearance === (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
module.exports["checkIsFabricPage"] = $7e6bc24b02592f12$export$27036aac658fb1f1;
module.exports["ContentTitle"] = $7e6bc24b02592f12$export$aaf6264d06ddc4ce;
module.exports["ContentTitleFromFragment"] = $7e6bc24b02592f12$export$50dbf7c0405e659c;

});

parcelRegister("8bU3n", function(module, exports) {
/**
 * @generated SignedSource<<f602b3213f22bdf8f4d0cba101775046>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ab8f885a3e16c01f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ContentTitle_space",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "themeKey"
                }
            ]
        },
        {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "headings",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ContentLookAndFeel",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContainerLookAndFeel",
                            "kind": "LinkedField",
                            "name": "header",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "background"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundAttachment"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundBlendMode"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundClip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundColor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundImage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundOrigin"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundPosition"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundRepeat"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundSize"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "borderRadius"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "padding"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Space"
};
$ab8f885a3e16c01f$var$node.hash = "4554ec437025ed6932758ad73dffd78f";
var $ab8f885a3e16c01f$export$2e2bcd8739ae039 = $ab8f885a3e16c01f$var$node;
module.exports["default"] = $ab8f885a3e16c01f$export$2e2bcd8739ae039;

});

parcelRegister("5FSHs", function(module, exports) {
/**
 * @generated SignedSource<<f6e18ceca7458a82cb67b114b5b429a5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ed356ae207881d70$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "value"
    }, v3 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "useNewContentTopper"
            }
        ],
        "kind": "Fragment",
        "name": "ContentTitle_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "alias": "appearancePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "content-appearance-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v3 /*: any*/ ,
                "storageKey": "properties(key:\"content-appearance-published\")"
            },
            {
                "alias": "emojiTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "emoji-title-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v3 /*: any*/ ,
                "storageKey": "properties(key:\"emoji-title-published\")"
            },
            {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "pageTitlePublished",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "page-title-property-published"
                            }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": v3 /*: any*/ ,
                        "storageKey": "properties(key:\"page-title-property-published\")"
                    }
                ]
            },
            {
                "alias": "editorProperty",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "editor"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    }
                ],
                "storageKey": "properties(key:\"editor\")"
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fabricEditorSupported"
                            },
                            {
                                "condition": "useNewContentTopper",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "coverPictureWidth"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "homepageId"
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$ed356ae207881d70$var$node.hash = "749c768a4388809afc319a8a547db370";
var $ed356ae207881d70$export$2e2bcd8739ae039 = $ed356ae207881d70$var$node;
module.exports["default"] = $ed356ae207881d70$export$2e2bcd8739ae039;

});

parcelRegister("gXrHX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("lt6Lx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $kSwu1.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { siteTitle: siteTitle } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title — but only when this render has no
    // meaningful content to contribute. If contentTitle, titlePrefix, notFound,
    // isHomePage, or siteTitleOnly are set, we must still update the title
    // (e.g. relay race: new page renders before old cleanup effect runs).
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence").
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    // A title is considered "specific" if it provides either a contentTitle or a titlePrefix.
    // Pages like the advanced search page pass a titlePrefix (e.g. "Search") without a
    // contentTitle, and we must still allow that title to replace the previous page's title
    // during client-side navigation. notFound, isHomePage, and siteTitleOnly are also
    // meaningful signals that must always be allowed to update the title.
    if (typeof document !== 'undefined' && document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) {
        // If contentTitle, titlePrefix, notFound, isHomePage, and siteTitleOnly are all empty/false,
        // we're likely setting a generic title (just siteTitle or siteTitle with space).
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip.
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("9BkfL", function(module, exports) {
/* ContentTitleComponent.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values */ /** @jsxFrag React.Fragment */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $b9k8w = parcelRequire("b9k8w");


var $8Iwqw = parcelRequire("8Iwqw");


var $8lt1a = parcelRequire("8lt1a");


var $i7cz5 = parcelRequire("i7cz5");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $kvJHJ = parcelRequire("kvJHJ");


var $dPJCf = parcelRequire("dPJCf");


var $di8q4 = parcelRequire("di8q4");


var $Qlykt = parcelRequire("Qlykt");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $bPoXA = parcelRequire("bPoXA");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $kycWk = parcelRequire("kycWk");

var $iuuqT = parcelRequire("iuuqT");

var $2MwVI = parcelRequire("2MwVI");


var $hlP5l = parcelRequire("hlP5l");

const $7dc66c9df3113525$var$EMOJI_TOP_OFFSET_OBJECT_HEADER_WITH_COVER_IMG = '-40px';
const $7dc66c9df3113525$var$EMOJI_TOP_OFFSET_DEFAULT = 'unset'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $7dc66c9df3113525$var$HeadingWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmbeddedPage: isEmbeddedPage, hasBanner: hasBanner, isNativeEmbed: isNativeEmbed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _1DCdHidnbC",
            __cmplp.isNativeEmbed && ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')) ? "_46hvQmp0Oa" : "_46hvQmdnbC",
            __cmplp.className
        ])
    });
}); // TODO: Refactor to a common location
const $7dc66c9df3113525$var$styledContentTitle = null;
const $7dc66c9df3113525$var$centerTitleStyles = null;
const $7dc66c9df3113525$var$fullWidthLeftAlignStyles = null;
const $7dc66c9df3113525$var$maxWidthLeftAlignStyles = null; // Matches the 72px full-page gutter applied to the renderer in embedded view.
const $7dc66c9df3113525$var$embeddedUITitlePaddingStyles = null;
const $7dc66c9df3113525$var$getMarginTopStyledH1 = (isEmbeddedPage, hasCoverPicture, hasEmoji)=>{
    return isEmbeddedPage || hasCoverPicture && hasEmoji ? '0px' : '72px';
};
const $7dc66c9df3113525$var$getEmojiTopOffsetValue = (hasCoverPicture)=>{
    if (hasCoverPicture) return $7dc66c9df3113525$var$EMOJI_TOP_OFFSET_OBJECT_HEADER_WITH_COVER_IMG;
    else return $7dc66c9df3113525$var$EMOJI_TOP_OFFSET_DEFAULT;
}; // Note: this component extracts the props that we don't want to send to the DOM
// This avoids styled errors about these props being passed to the DOM
/* eslint-disable @typescript-eslint/no-unused-vars */ const $7dc66c9df3113525$var$ExperimentalHeadingContainer = ({ children: children, isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, isPageContentFullWidth: isPageContentFullWidth, isPageContentMaxWidth: isPageContentMaxWidth, isEmbeddedPage: isEmbeddedPage, hasEmoji: hasEmoji, isFixedWidthImageOption: isFixedWidthImageOption, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, children);
}; /* eslint-enable @typescript-eslint/no-unused-vars */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7dc66c9df3113525$var$StyledHeadingContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $7dc66c9df3113525$var$ExperimentalHeadingContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ywc76f": (0, $9aYkv.default)($7dc66c9df3113525$var$getMarginTopStyledH1(__cmplp.isEmbeddedPage, __cmplp.hasCoverPicture, __cmplp.hasEmoji))
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _1UtDYzy7kJ _3W2Oc8wPeg _1T2N03wPeg _1ANEUS4oEs _4kiQYArIqH _0Of8r2dnbC _0wOv4Q7zJH _3iDTPbQ4SZ _4wYTBBXwEm _1dW7FxDIqT _2Jd1exu7m9 _0zdWqnOz3Q",
            __cmplp.isTitleCenterAligned || __cmplp.isFixedWidthImageOption && __cmplp.hasEmoji && !__cmplp.isTitleCenterAligned && (__cmplp.isPageContentFullWidth || __cmplp.isPageContentMaxWidth && ((0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) && __cmplp.hasCoverPicture ? "_3QCn8Ybt8w" : "_3QCn8YZqHV",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_1Sj9yC5zaO" : "_1Sj9yCyL8i",
            __cmplp.onClick ? "_1pp6Nd18ZR" : "_1pp6NdYbGa",
            __cmplp.isTitleCenterAligned && "_37wbyuDIqT _2fwxA5DIqT _0aFT5vbt8w _0hPCNLDIqT",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7dc66c9df3113525$var$StyledHeadingText = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgXwEm _1kk5Tku7m9 _3iDTPbS8kF",
            __cmplp.className
        ])
    });
});
const $7dc66c9df3113525$var$emojiFullWidthLeftAlignWrapper = null;
const $7dc66c9df3113525$var$EmojiAlignmentWrapper = ({ children: children, isLeftAlignedTitleWithFixedWidthImageAndEmoji: isLeftAlignedTitleWithFixedWidthImageAndEmoji })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isLeftAlignedTitleWithFixedWidthImageAndEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "emoji-alignment-wrapper",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuzUZr _39xV02OAqP _2Zuz6QS40j"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children));
const $7dc66c9df3113525$var$titleTextFullWidthLeftAlignWrapper = null;
const $7dc66c9df3113525$var$TitleTextAlignmentWrapper = ({ children: children, isLeftAlignedTitleWithFixedWidthImageAndEmoji: isLeftAlignedTitleWithFixedWidthImageAndEmoji })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isLeftAlignedTitleWithFixedWidthImageAndEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "title-alignment-wrapper",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuchRC _39xV02N91d"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $7dc66c9df3113525$var$EmojiWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _2IhTonuXtm _1ACWzoQ4SZ _19MPeiDIqT _2ND2qhnQyn _0MI5WBnQyn _0gfXbTDIqT",
            __cmplp.isTitleCenterAligned ? "_1ZnuxbdnbC" : "_1ZnuxbuFDC",
            __cmplp.hasCoverPicture ? "_1EqgXlljYU" : "_1EqgXlUF4f",
            __cmplp.isTitleCenterAligned ? "_0hPCNLzUZr" : "_0hPCNLDIqT",
            __cmplp.hasCoverPicture ? "_1mT5xdWVPG" : "_1mT5xdZqHV",
            __cmplp.hasCoverPicture ? "_1oPLtcljYU" : "_1oPLtcUF4f",
            __cmplp.hasCoverPicture ? "_0PNsB9ljYU" : "_0PNsB9UF4f",
            __cmplp.className
        ])
    });
});
const $7dc66c9df3113525$var$titleCenteredMargin = (isTitleCenterAligned)=>{
    return isTitleCenterAligned ? '-5px' : 'unset';
};
const $7dc66c9df3113525$var$getMarginTopTitleTextWrapper = (isTitleCenterAligned, hasCoverPicture, hasEmoji, isEmbeddedPage)=>{
    return isEmbeddedPage ? '0px' : hasCoverPicture && hasEmoji ? '96px' : $7dc66c9df3113525$var$titleCenteredMargin(isTitleCenterAligned);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $7dc66c9df3113525$var$TitleTextWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, hasEmoji: hasEmoji, isEmbeddedPage: isEmbeddedPage, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gac3l6": (0, $9aYkv.default)($7dc66c9df3113525$var$getMarginTopTitleTextWrapper(__cmplp.isTitleCenterAligned, __cmplp.hasCoverPicture, __cmplp.hasEmoji, __cmplp.isEmbeddedPage))
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842BBIK _3L4DaX7dHp _4sG9F37dHp _3XTYJ0YbGa _4zqEKHYbGa _2fWlBce6K4 _1nNgbAe6K4",
            __cmplp.className
        ])
    });
});
const $7dc66c9df3113525$var$copyLinkWrapper = (0, $buxP3.xcss)({
    font: 'font.body',
    opacity: '0',
    position: 'absolute',
    transform: 'translateX(-4px)',
    transition: 'opacity 0.2s ease-out 0s, transform 0.2s ease-out 0s'
});
const $7dc66c9df3113525$var$migratedSpotlightTitleTarget = null;
const $7dc66c9df3113525$var$isURLVisible = ()=>window.top === window.self;
const $7dc66c9df3113525$export$c5305ddfc413155f = ({ lookAndFeel: lookAndFeel, banner: banner, title: title, children: children, centerTitle: centerTitle, prefix: prefix, hasEmoji: hasEmoji, emojiId: emojiId, contentId: contentId, spaceKey: spaceKey, contentType: contentType, loading: loading, headingContainer: HeadingContainer, hasCoverPicture: hasCoverPicture, isPageContentFullWidth: isPageContentFullWidth, isPageContentMaxWidth: isPageContentMaxWidth, isEmbeddedPage: isEmbeddedPage, titleContentProperties: titleContentProperties })=>{
    'use no memo';
    const isNativeEmbed = Boolean((0, $i7cz5.maybeParseNativeEmbedParams)(new URLSearchParams(window.location.search)));
    const emojiTitle = hasEmoji ? emojiId : null;
    const { setQueryParams: routeActionsSetQueryParams } = (0, $dPJCf.useRouteActions)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { coverPictureWidth: coverPictureWidth } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)({
        contentId: contentId
    });
    const isFixedWidthImageOption = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER; /**
                                                                                                           * The feature of clearing query params by clicking title is only useful when it's used in standalone Confluence with the URL visible.
                                                                                                           * When a page gets embedded e.g. rendered within iframe macro, user won't be able to see the effect from clearing query params and the mouse pointer and clicking lead to a confusing user experience.
                                                                                                           */ 
    const clearQueryParams = ()=>{
        if (!$7dc66c9df3113525$var$isURLVisible()) return;
        const queryParams = routeDataRef?.current?.queryParams;
        if (!queryParams) return;
        Object.keys(queryParams).forEach((k)=>{
            routeActionsSetQueryParams({
                [k]: undefined
            }, true);
        });
    };
    const isLeftAlignedTitleWithFixedWidthImageAndEmoji = isFixedWidthImageOption && hasEmoji && !isTitleCenterAligned && hasCoverPicture && (isPageContentFullWidth || isPageContentMaxWidth && ((0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)));
    (0, $2MwVI.useTrackTitleRedactionRendered)({
        contentId: contentId,
        title: title
    });
    const { activeSpotlight: activeSpotlight, renderMigratedSpotlight: renderMigratedSpotlight } = (0, $iuuqT.useRedactionsTour)({
        contentId: contentId,
        step: (0, $kycWk.RedactionsTourSteps).FIRST,
        firstStepSource: (0, $kycWk.RedactionTourStepSource).titleRedaction
    });
    const headingId = 'heading-title-text';
    const titleTextForSpotlight = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$TitleTextWrapper, {
        isTitleCenterAligned: isTitleCenterAligned,
        hasCoverPicture: hasCoverPicture,
        hasEmoji: hasEmoji,
        isEmbeddedPage: isEmbeddedPage,
        id: "content-title-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$StyledHeadingText, {
        id: headingId
    }, prefix && !emojiTitle ? `${prefix} - ${title}` : title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        as: "span",
        paddingInlineStart: "space.100",
        xcss: $7dc66c9df3113525$var$copyLinkWrapper,
        "data-vc": "copylink-wrapper",
        testId: "copylink-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPoXA.CopyLinkButtonLoader), {
        shouldResetOnHover: true,
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        pageMode: "view",
        source: "pageTitle",
        buttonAppearance: "subtle-link",
        tooltipPosition: "top",
        referencedContentId: headingId
    })));
    const heading = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$StyledHeadingContainer, {
        id: "title-text",
        "data-test-id": "title-text",
        "data-testid": "title-text",
        style: lookAndFeel?.headings,
        onClick: clearQueryParams,
        isTitleCenterAligned: isTitleCenterAligned,
        hasCoverPicture: hasCoverPicture,
        isPageContentFullWidth: isPageContentFullWidth,
        isPageContentMaxWidth: isPageContentMaxWidth,
        isFixedWidthImageOption: isFixedWidthImageOption,
        isEmbeddedPage: isEmbeddedPage,
        hasEmoji: hasEmoji
    }, prefix && emojiTitle ? `${prefix} - ` : null, emojiTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$EmojiAlignmentWrapper, {
        isLeftAlignedTitleWithFixedWidthImageAndEmoji: isLeftAlignedTitleWithFixedWidthImageAndEmoji
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$EmojiWrapper, {
        isTitleCenterAligned: isTitleCenterAligned,
        hasCoverPicture: hasCoverPicture,
        isEmbeddedPage: isEmbeddedPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        testId: "emoji-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emojiTitle,
        height: hasCoverPicture ? (0, $Qlykt.EMOJI_SIZE_LARGE) : (0, $Qlykt.EMOJI_SIZE_MEDIUM),
        hasCoverPicture: hasCoverPicture,
        context: "viewPage",
        showTooltip: true,
        renderResourcedEmoji: true,
        isPageTitleComponent: true
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$TitleTextAlignmentWrapper, {
        isLeftAlignedTitleWithFixedWidthImageAndEmoji: isLeftAlignedTitleWithFixedWidthImageAndEmoji
    }, (0, $9wGTI.fg)('cc-dlp-fix-regressed-redactions-spotlight-tour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbcK7c _2tL4YxccYA"
        ])
    }, renderMigratedSpotlight(titleTextForSpotlight)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
        name: (0, $kycWk.REDACTIONS_TOUR_TARGETS).TITLE_REDACTION
    }, titleTextForSpotlight), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, activeSpotlight))));
    const headerStyles = {
        ...lookAndFeel?.content?.header
    }; // header is from graphql result which will contain __typename
    delete headerStyles.__typename;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "title-wrapper",
        className: (0, $hekY6.default)([
            !centerTitle && isPageContentFullWidth && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1EqgXlJKzk",
            !centerTitle && isPageContentMaxWidth && ((0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1EqgXlwKnr",
            isNativeEmbed && ((0, $6mKj3.expValEquals)('cc-maui-experiment', 'isEnabled', true) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')) && "_2Zuz6QL04q _1ZnuxbL04q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: headerStyles,
        "data-test-id": "page-content-header",
        "data-testid": "page-content-header",
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _24h04i2Njc _4kiQYAv6H3 _39xV02N91d _1EqgXlN91d",
            centerTitle && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _3iDTPbvLZJ _3W2Oc8wPeg _1T2N03wPeg _1EqgXl8yGE"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$HeadingWrapper, {
        hasBanner: !!banner,
        isEmbeddedPage: isEmbeddedPage,
        isNativeEmbed: isNativeEmbed
    }, HeadingContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(HeadingContainer, {
        showInlineCommentButton: true,
        hasCoverPicture: hasCoverPicture && (0, $6mKj3.expValEquals)('confluence_restore_embedded_header_spacing', 'isEnabled', true)
    }, heading) : heading), banner || null, !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        key: contentId,
        metric: (0, $hlP5l.CONTENT_TITLE_METRIC)
    }), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.VIEW_PAGE_TITLE_EXPERIENCE)
    })));
};
$7dc66c9df3113525$export$c5305ddfc413155f.displayName = 'ContentTitleComponent';
module.exports["ContentTitleComponent"] = $7dc66c9df3113525$export$c5305ddfc413155f;

});

parcelRegister("i7cz5", function(module, exports) {

var $5TlVH = parcelRequire("5TlVH");

const $1b581ea1c80d4d76$var$ROVO_RECEIVER_ID_DATA_ATTR = 'data-rovo-receiver-id';
const [$1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY, $1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY] = (0, $5TlVH.NATIVE_EMBED_BRIDGE_QUERY_PARAM_KEYS);
function $1b581ea1c80d4d76$export$d5ca420e0d8fc785(bridgeParams) {
    const { embedClientId: embedClientId, hostClientId: hostClientId } = bridgeParams;
    return {
        clientId: embedClientId,
        getQueryParams: ()=>({
                [$1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY]: embedClientId,
                [$1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY]: hostClientId
            }),
        getIframeDataAttributes: ()=>({
                [$1b581ea1c80d4d76$var$ROVO_RECEIVER_ID_DATA_ATTR]: embedClientId
            })
    };
}
function $1b581ea1c80d4d76$export$a5e60906cc8da6df(params) {
    const id = params.get($1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY);
    const parentId = params.get($1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY);
    if (!id || id.length === 0 || !parentId || parentId.length === 0) return undefined;
    return {
        childClientId: id,
        parentClientId: parentId
    };
}
module.exports["createNativeEmbedClientIframeIntegrator"] = $1b581ea1c80d4d76$export$d5ca420e0d8fc785;
module.exports["maybeParseNativeEmbedParams"] = $1b581ea1c80d4d76$export$a5e60906cc8da6df;

});

parcelRegister("5TlVH", function(module, exports) {
const $2a2de016186788ad$export$4238689d357e0d1e = [
    'nativeEmbedChildId',
    'nativeEmbedParentId'
];
module.exports["NATIVE_EMBED_BRIDGE_QUERY_PARAM_KEYS"] = $2a2de016186788ad$export$4238689d357e0d1e;

});

parcelRegister("bPoXA", function(module, exports) {
$parcel$export(module.exports, "PAGE_MODE", () => (parcelRequire("1RN2b")).PAGE_MODE);

var $jmjWc = parcelRequire("jmjWc");


var $7VdCF = parcelRequire("7VdCF");


var $1RN2b = parcelRequire("1RN2b");


const $593a9a70400e9fe4$export$9d30156e45c09e81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VbFx8",
    name: "CopyLinkButtonLoader",
    loader: async ()=>{
        return (await (parcelRequire("2YAQL"))).CopyLink;
    },
    loading: (0, $7VdCF.CopyLinkButtonPlaceholder)
});
module.exports["CopyLinkButtonLoader"] = $593a9a70400e9fe4$export$9d30156e45c09e81;

});

parcelRegister("7VdCF", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $7ZB0A = parcelRequire("7ZB0A");

const $e679cdda51869592$var$i18n = (0, $kSwu1.defineMessages)({
    copyLinkLabel: {
        id: "share-and-restrict-dialog.copylink.icon.label",
        defaultMessage: "Copy link"
    }
});
const $e679cdda51869592$export$1f3200a5b8d4d8e1 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($e679cdda51869592$var$i18n.copyLinkLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            testId: "copy-link-button-placeholder",
            "data-test-id": "copy-link-button-placeholder",
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: t0,
                spacing: "spacious"
            }),
            isDisabled: true
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["CopyLinkButtonPlaceholder"] = $e679cdda51869592$export$1f3200a5b8d4d8e1;

});

parcelRegister("2YAQL", function(module, exports) {

let $22adc5010226413e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $22adc5010226413e$var$load("cH8yZ"),
    $22adc5010226413e$var$load("9RX5o")
]).then(()=>parcelRequire('eB05M'));

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
var $a7399ed0bcbe7ac9$export$f5d398bf946a6bf8 = /*#__PURE__*/ function(RedactionTourStepSource) {
    RedactionTourStepSource["bodyRedaction"] = "bodyRedaction";
    RedactionTourStepSource["titleRedaction"] = "titleRedaction";
    return RedactionTourStepSource;
}({});
const $a7399ed0bcbe7ac9$export$4d54b6650166caf9 = {
    REDACTION: 'redactions-tour-redaction',
    DETAILS_BUTTON: 'redactions-tour-details-button'
};
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["RedactionTourStepSource"] = $a7399ed0bcbe7ac9$export$f5d398bf946a6bf8;
module.exports["REDACTIONS_TOUR_MESSAGE_IDS"] = $a7399ed0bcbe7ac9$export$4d54b6650166caf9;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("iuuqT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $lsxnT = parcelRequire("lsxnT");


var $aWwYt = parcelRequire("aWwYt");


var $ep3mz = parcelRequire("ep3mz");


var $lfBMY = parcelRequire("lfBMY");


var $2wo33 = parcelRequire("2wo33");


var $8Lx5S = parcelRequire("8Lx5S");


var $26Yfd = parcelRequire("26Yfd");


var $kycWk = parcelRequire("kycWk");


var $gsf3i = parcelRequire("gsf3i");

const { IS_REDACTIONS_TOUR_VISIBLE: $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE } = (0, $dBcar.ONBOARDING_EXPERIENCES);
const $cbee4c9267979126$var$i18n = (0, $kSwu1.defineMessages)({
    stepOfSteps: {
        id: "redactions.redactions-tour.steps",
        defaultMessage: "{step}/{steps}"
    },
    dismiss: {
        id: "redactions.redactions-tour.dismiss",
        defaultMessage: "Dismiss"
    },
    next: {
        id: "redactions.redactions-tour.next",
        defaultMessage: "Next"
    },
    ok: {
        id: "redactions.redactions-tour.ok",
        defaultMessage: "OK"
    },
    readMore: {
        id: "redactions.redactions-tour.read-more",
        defaultMessage: "Read more"
    },
    solidBarIndicates: {
        id: "redactions.redactions-tour.solid-bar-indicates",
        defaultMessage: "The solid bar indicates that your organization detected and deleted sensitive data."
    },
    goToRedactions: {
        id: "redactions.redactions-tour.go-to-redactions",
        defaultMessage: "Go to Redactions in this menu to view details about the redactions on this page."
    },
    aboutRedactions: {
        id: "redactions.redactions-tour.about-redactions",
        defaultMessage: "About redactions"
    },
    viewRedactionDetails: {
        id: "redactions.redactions-tour.view-redaction-details",
        defaultMessage: "View redaction details"
    }
});
const $cbee4c9267979126$var$useSpotlights = ({ next: next, end: end, tourStartsInTitle: tourStartsInTitle })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstSpotlightKeyTarget = tourStartsInTitle ? (0, $kycWk.REDACTIONS_TOUR_TARGETS).TITLE_REDACTION : (0, $kycWk.REDACTIONS_TOUR_TARGETS).REDACTION_EXTENSION;
    return [
        {
            key: firstSpotlightKeyTarget,
            messageId: (0, $kycWk.REDACTIONS_TOUR_MESSAGE_IDS).REDACTION,
            target: firstSpotlightKeyTarget,
            messageType: (0, $kycWk.MessageType).Engagement,
            heading: formatMessage($cbee4c9267979126$var$i18n.aboutRedactions),
            actionsBeforeElement: formatMessage($cbee4c9267979126$var$i18n.stepOfSteps, {
                step: 1,
                steps: 2
            }),
            targetRadius: 3,
            actions: [
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.dismiss),
                    onClick: end
                },
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.next),
                    onClick: next
                }
            ],
            children: formatMessage($cbee4c9267979126$var$i18n.solidBarIndicates)
        },
        {
            key: (0, $kycWk.REDACTIONS_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            messageId: (0, $kycWk.REDACTIONS_TOUR_MESSAGE_IDS).DETAILS_BUTTON,
            target: (0, $kycWk.REDACTIONS_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            messageType: (0, $kycWk.MessageType).Transactional,
            heading: formatMessage($cbee4c9267979126$var$i18n.viewRedactionDetails),
            actionsBeforeElement: formatMessage($cbee4c9267979126$var$i18n.stepOfSteps, {
                step: 2,
                steps: 2
            }),
            targetRadius: 100,
            actions: [
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.ok),
                    onClick: end
                }
            ],
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage($cbee4c9267979126$var$i18n.goToRedactions), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: (0, $kycWk.READ_MORE_URL),
                target: "_blank",
                rel: "noopener noreferrer"
            }, formatMessage($cbee4c9267979126$var$i18n.readMore)))
        }
    ];
};
const $cbee4c9267979126$export$9b351a5d16cec916 = ({ contentId: contentId, step: step, firstStepSource: firstStepSource = (0, $kycWk.RedactionTourStepSource).bodyRedaction })=>{
    const { sidebarControlState: sidebarControlState } = (0, $aWwYt.useObjectSidebarState)();
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex, firstRedactionIdRendered: firstRedactionIdRendered, firstRedactionRenderedForContentId: firstRedactionRenderedForContentId, titleRedactionRenderedForContentId: titleRedactionRenderedForContentId, firstStepSource: activeFirstStepSource }, { concludeTour: endTour, proceedToNext: proceedToNext, initiateTour: initiateTour, resetTour: resetTour, setFirstRedactionIdRendered: setFirstRedactionIdRendered, setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId }] = (0, $gsf3i.useRedactionsTourState)();
    const isFirstTourTargetVisible = firstStepSource === (0, $kycWk.RedactionTourStepSource).bodyRedaction ? step === 0 && firstRedactionIdRendered && firstRedactionRenderedForContentId === contentId && titleRedactionRenderedForContentId !== contentId : step === 0 && titleRedactionRenderedForContentId === contentId; // otherwise, it's a title redaction
    const isSecondTourTargetVisible = sidebarControlState === 'shown';
    const [contentType] = (0, $ep3mz.useContentType)();
    const canUpdateContent = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentType,
        operation: (0, $lfBMY.OperationTypes).UPDATE
    });
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: onboardingStateData, error: onboardingStateError, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)($cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE, false);
    const isTourOnboardingStateCompleted = onboardingStateData?.onboardingState?.some(({ key: key, value: value })=>{
        return key === $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE && value === (0, $kycWk.IS_DISMISSED_FLAG);
    });
    const isTourCompleted = !onboardingStateError && !onboardingStateLoading && isTourOnboardingStateCompleted;
    const { Spotlight: Spotlight, SpotlightTarget: SpotlightTarget } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $cozmU.useCallback)(()=>{
        endTour();
        setOnboardingState({
            key: $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE,
            value: (0, $kycWk.IS_DISMISSED_FLAG)
        });
    }, [
        endTour,
        setOnboardingState
    ]);
    const initiateTourForSource = (0, $cozmU.useCallback)(()=>{
        initiateTour(firstStepSource);
    }, [
        firstStepSource,
        initiateTour
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (activeSpotlightIndex === null && isFirstTourTargetVisible && isSecondTourTargetVisible && !isTourCompleted && !onboardingStateError && !onboardingStateLoading && isLicensed && canUpdateContent) {
            const timeoutId = setTimeout(()=>{
                initiateTourForSource();
            }, 0);
            return ()=>clearTimeout(timeoutId);
        }
        return undefined;
    }, [
        activeSpotlightIndex,
        initiateTourForSource,
        isFirstTourTargetVisible,
        isSecondTourTargetVisible,
        isTourCompleted,
        onboardingStateError,
        onboardingStateLoading,
        isLicensed,
        canUpdateContent
    ]);
    const spotlights = $cbee4c9267979126$var$useSpotlights({
        next: proceedToNext,
        end: concludeTour,
        tourStartsInTitle: firstStepSource === (0, $kycWk.RedactionTourStepSource).titleRedaction
    });
    const spotlight = spotlights[step];
    const isSpotlightVisible = activeSpotlightIndex === step && (step !== (0, $kycWk.RedactionsTourSteps).FIRST || activeFirstStepSource === firstStepSource);
    const renderMigratedSpotlight = (0, $26Yfd.useStableCallback)((target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpotlightTarget, {
            name: spotlight.target
        }, target), isSpotlightVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            isMigrated: true,
            dialogPlacement: "bottom right",
            shouldWatchTarget: true,
            targetBgColor: "var(--ds-surface-raised, #FFFFFF)",
            ...spotlight
        }) : null));
    return {
        activeSpotlight: isSpotlightVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            dialogPlacement: "bottom right",
            shouldWatchTarget: true // Note: problematic layout shifts for both spotlights
            ,
            targetBgColor: "var(--ds-surface-raised, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }) : null,
        initiateTour: initiateTourForSource,
        proceedToNext: proceedToNext,
        concludeTour: concludeTour,
        resetTour: resetTour,
        renderMigratedSpotlight: renderMigratedSpotlight,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex,
        isTourCompleted: isTourCompleted,
        setFirstRedactionIdRendered: setFirstRedactionIdRendered,
        setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId // Note: mainly here for testing purposes
    };
};
module.exports["useRedactionsTour"] = $cbee4c9267979126$export$9b351a5d16cec916;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $1cHqV = parcelRequire("1cHqV");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$var$isOnboardingStateEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return !a && !b;
    if (a.length !== b.length) return false;
    return a.every((item, i)=>item.key === b[i].key && item.value === b[i].value);
};
// Hook to check if we're on a view page route
const $6fc4b7bb962289cc$var$useIsViewPageRoute = ()=>(0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
// Get the combined onboarding state from cache, returns null if not cached
const $6fc4b7bb962289cc$var$getCombinedQueryFromCache = ()=>{
    try {
        return (0, $l1uFv.readQueryInterop)({
            query: (0, $8Z78B.default),
            variables: {
                key: []
            },
            __callerPackage__: "onboarding-helpers"
        });
    } catch  {
        return null;
    }
};
// Updates the combined query cache with new onboarding state values.
// This ensures components using the centralized cache see updates on next mount/navigation.
const $6fc4b7bb962289cc$var$updateCombinedQueryCache = (updatedStates)=>{
    if (!(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return;
    const currentData = $6fc4b7bb962289cc$var$getCombinedQueryFromCache();
    if (!currentData?.onboardingState) return;
    const updatedMap = new Map(updatedStates.map((s)=>[
            s.key,
            s.value
        ]));
    const newOnboardingState = currentData.onboardingState.map((item)=>updatedMap.has(item.key) ? {
            ...item,
            value: updatedMap.get(item.key) ?? item.value
        } : item);
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        },
        data: {
            onboardingState: newOnboardingState
        },
        __callerPackage__: "onboarding-helpers"
    });
};
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
            // Update the combined query cache for centralized onboarding state
            $6fc4b7bb962289cc$var$updateCombinedQueryCache(states ?? []);
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false, reactive = true)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const isViewPageRoute = $6fc4b7bb962289cc$var$useIsViewPageRoute();
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    // Check if centralized cache should be used (experiment enabled + on view page route)
    const useCentralizedCache = isViewPageRoute && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false);
    // For non-reactive mode: read from cache once (no subscription)
    // This is a one-time synchronous read that doesn't trigger re-renders on cache changes
    const cachedCombinedData = !reactive && useCentralizedCache ? $6fc4b7bb962289cc$var$getCombinedQueryFromCache() : null;
    const hasCachedCombinedData = cachedCombinedData !== null;
    // For reactive mode: use useQueryInterop with cache-only to subscribe to cache changes
    // This subscribes to the centralized cache and re-renders when it changes (no network requests)
    const { data: reactiveCacheData, error: reactiveCacheError, loading: reactiveCacheLoading } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: []
        },
        skip: skipQuery || !reactive || !useCentralizedCache,
        fetchPolicy: 'cache-only',
        __callerPackage__: "onboarding-helpers"
    });
    // Memoize the filtered reactive cache result so filterOnboardingState is only called
    // when reactiveCacheData or key actually changes — not on every render.
    //
    // We must not skip the fallback just because reactiveCacheData is truthy — the centralized
    // cache may not contain the specific keys this consumer requested (e.g. the preload fetched
    // a different set of keys). We only skip the fallback when the filtered reactive cache data
    // actually has entries for the requested keys.
    const { reactiveFilteredData: reactiveFilteredData, reactiveFilteredHasData: reactiveFilteredHasData } = (0, $cozmU.useMemo)(()=>{
        if (!(reactive && useCentralizedCache && reactiveCacheData)) return {
            reactiveFilteredData: null,
            reactiveFilteredHasData: false
        };
        const filtered = (0, $1cHqV.filterOnboardingState)(reactiveCacheData, key);
        return {
            reactiveFilteredData: filtered,
            reactiveFilteredHasData: (filtered?.onboardingState?.length ?? 0) > 0
        };
    }, [
        reactive,
        useCentralizedCache,
        reactiveCacheData,
        key
    ]);
    const { data: fallbackQueryData, error: fallbackError, loading: fallbackLoading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery || hasCachedCombinedData || reactiveFilteredHasData,
        __callerPackage__: "onboarding-helpers"
    });
    // Determine which data source to use:
    // 1. Non-reactive with cached data: use cachedCombinedData (filtered)
    // 2. Reactive with centralized cache and keys found: use reactiveFilteredData
    // 3. Fallback: use fallbackQueryData
    // For reactive path: skip re-render if filtered data for our keys hasn't changed
    const prevFilteredDataRef = (0, $cozmU.useRef)(undefined);
    const data = (0, $cozmU.useMemo)(()=>{
        if (hasCachedCombinedData) return (0, $1cHqV.filterOnboardingState)(cachedCombinedData, key);
        if (reactiveFilteredHasData && reactiveFilteredData) {
            if (prevFilteredDataRef.current && $6fc4b7bb962289cc$var$isOnboardingStateEqual(prevFilteredDataRef.current.onboardingState, reactiveFilteredData.onboardingState)) return prevFilteredDataRef.current;
            prevFilteredDataRef.current = reactiveFilteredData;
            return reactiveFilteredData;
        }
        return fallbackQueryData;
    }, [
        hasCachedCombinedData,
        cachedCombinedData,
        reactiveFilteredHasData,
        reactiveFilteredData,
        fallbackQueryData,
        key
    ]);
    // Combine error and loading states from both queries
    const error = reactiveCacheError || fallbackError;
    // When centralized cache is enabled in reactive mode but the preload hasn't populated
    // the cache yet, cache-only returns loading: false with data: undefined. Without this
    // guard, consumers interpret undefined data as "user never saw this onboarding" and
    // incorrectly show spotlights/changeboarding that was already dismissed.
    // We report loading: true until either the reactive cache or fallback has actual data.
    //
    // Also guard the case where the reactive cache is populated but doesn't contain the
    // specific keys this consumer requested (reactiveFilteredHasData is false). In that
    // scenario the fallback query has been allowed to run — keep loading: true until it
    // either returns data or an error, so consumers don't prematurely see empty state.
    const isCentralizedCacheWaitingForPreload = reactive && useCentralizedCache && (!reactiveCacheData || !reactiveFilteredHasData) && !fallbackQueryData && !skipQuery && !reactiveCacheError && !fallbackError;
    const loading = isCentralizedCacheWaitingForPreload || (reactive && useCentralizedCache ? reactiveCacheLoading : false) || fallbackLoading;
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("l1uFv", function(module, exports) {

var $jWnFe = parcelRequire("jWnFe");


var $eqEJl = parcelRequire("eqEJl");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $7M67g = parcelRequire("7M67g");

const $65c7b8940c778902$var$CLIENT_EDGE_TRAVERSAL_PATH_KEY = '__clientEdgeTraversalPath';
function $65c7b8940c778902$var$cloneRelayQueryResult(data) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jWnFe)))(data, (value, key)=>{
        // Relay fragment refs can contain operation descriptors and client-edge reader nodes.
        // Keep that internal metadata by reference while restoring Apollo-compatible mutable data.
        if (key === (0, $eqEJl.FRAGMENT_OWNER_KEY) || key === $65c7b8940c778902$var$CLIENT_EDGE_TRAVERSAL_PATH_KEY) return value;
        return undefined;
    });
}
function $65c7b8940c778902$export$627cb922211284f(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Cache reads stay native to the selected route. The cache bridge only
    // mirrors successful writes/results into the other cache.
    return $65c7b8940c778902$var$readQueryInteropOriginal(params, source);
}
function $65c7b8940c778902$var$readQueryInteropOriginal(params, source) {
    return source === 'relay' ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for readQueryInterop; ${params.__callerPackage__}.`);
    const queryNode = params.query;
    if (!queryNode?.fragment || !queryNode?.operation) return null;
    const variables = params.variables ?? {};
    const operation = (0, $eqEJl.createOperationDescriptor)(queryNode, variables);
    const snapshot = relayEnv.lookup(operation.fragment);
    return snapshot.isMissingData ? null : $65c7b8940c778902$var$cloneRelayQueryResult(snapshot.data);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("jWnFe", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $e845ca4b0059397d$var$CLONE_DEEP_FLAG = 1, $e845ca4b0059397d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */ function $e845ca4b0059397d$var$cloneDeepWith(value, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $hGc5T(value, $e845ca4b0059397d$var$CLONE_DEEP_FLAG | $e845ca4b0059397d$var$CLONE_SYMBOLS_FLAG, customizer);
}
module.exports = $e845ca4b0059397d$var$cloneDeepWith;

});

parcelRegister("hGc5T", function(module, exports) {

var $1tgXD = parcelRequire("1tgXD");


var $7aPLP = parcelRequire("7aPLP");


var $aDCaS = parcelRequire("aDCaS");


var $e8WyO = parcelRequire("e8WyO");


var $lunGb = parcelRequire("lunGb");


var $19mn0 = parcelRequire("19mn0");


var $7WBxT = parcelRequire("7WBxT");


var $gwj3d = parcelRequire("gwj3d");


var $j60dZ = parcelRequire("j60dZ");


var $cTBpe = parcelRequire("cTBpe");


var $14dnq = parcelRequire("14dnq");


var $jOCrv = parcelRequire("jOCrv");


var $kGJE1 = parcelRequire("kGJE1");


var $cZmfO = parcelRequire("cZmfO");


var $jFqhM = parcelRequire("jFqhM");


var $1ScXu = parcelRequire("1ScXu");


var $6DVFM = parcelRequire("6DVFM");


var $aBDCC = parcelRequire("aBDCC");


var $izVFW = parcelRequire("izVFW");


var $1ji1e = parcelRequire("1ji1e");


var $f14Rr = parcelRequire("f14Rr");


var $dNyAN = parcelRequire("dNyAN");

/** Used to compose bitmasks for cloning. */ var $cdefbd8efe913551$var$CLONE_DEEP_FLAG = 1, $cdefbd8efe913551$var$CLONE_FLAT_FLAG = 2, $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $cdefbd8efe913551$var$argsTag = '[object Arguments]', $cdefbd8efe913551$var$arrayTag = '[object Array]', $cdefbd8efe913551$var$boolTag = '[object Boolean]', $cdefbd8efe913551$var$dateTag = '[object Date]', $cdefbd8efe913551$var$errorTag = '[object Error]', $cdefbd8efe913551$var$funcTag = '[object Function]', $cdefbd8efe913551$var$genTag = '[object GeneratorFunction]', $cdefbd8efe913551$var$mapTag = '[object Map]', $cdefbd8efe913551$var$numberTag = '[object Number]', $cdefbd8efe913551$var$objectTag = '[object Object]', $cdefbd8efe913551$var$regexpTag = '[object RegExp]', $cdefbd8efe913551$var$setTag = '[object Set]', $cdefbd8efe913551$var$stringTag = '[object String]', $cdefbd8efe913551$var$symbolTag = '[object Symbol]', $cdefbd8efe913551$var$weakMapTag = '[object WeakMap]';
var $cdefbd8efe913551$var$arrayBufferTag = '[object ArrayBuffer]', $cdefbd8efe913551$var$dataViewTag = '[object DataView]', $cdefbd8efe913551$var$float32Tag = '[object Float32Array]', $cdefbd8efe913551$var$float64Tag = '[object Float64Array]', $cdefbd8efe913551$var$int8Tag = '[object Int8Array]', $cdefbd8efe913551$var$int16Tag = '[object Int16Array]', $cdefbd8efe913551$var$int32Tag = '[object Int32Array]', $cdefbd8efe913551$var$uint8Tag = '[object Uint8Array]', $cdefbd8efe913551$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cdefbd8efe913551$var$uint16Tag = '[object Uint16Array]', $cdefbd8efe913551$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $cdefbd8efe913551$var$cloneableTags = {};
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$argsTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayBufferTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dataViewTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$boolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dateTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float64Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$mapTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$numberTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$objectTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$regexpTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$setTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$stringTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$symbolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8ClampedTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint32Tag] = true;
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$errorTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$funcTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $cdefbd8efe913551$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $cdefbd8efe913551$var$CLONE_DEEP_FLAG, isFlat = bitmask & $cdefbd8efe913551$var$CLONE_FLAT_FLAG, isFull = bitmask & $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$izVFW(value)) return value;
    var isArr = $1ScXu(value);
    if (isArr) {
        result = $kGJE1(value);
        if (!isDeep) return $7WBxT(value, result);
    } else {
        var tag = $jOCrv(value), isFunc = tag == $cdefbd8efe913551$var$funcTag || tag == $cdefbd8efe913551$var$genTag;
        if ($6DVFM(value)) return $19mn0(value, isDeep);
        if (tag == $cdefbd8efe913551$var$objectTag || tag == $cdefbd8efe913551$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $jFqhM(value);
            if (!isDeep) return isFlat ? $j60dZ(value, $lunGb(result, value)) : $gwj3d(value, $e8WyO(result, value));
        } else {
            if (!$cdefbd8efe913551$var$cloneableTags[tag]) return object ? value : {};
            result = $cZmfO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $1tgXD);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($1ji1e(value)) value.forEach(function(subValue) {
        result.add($cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($aBDCC(value)) value.forEach(function(subValue, key) {
        result.set(key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $14dnq : $cTBpe : isFlat ? $dNyAN : $f14Rr;
    var props = isArr ? undefined : keysFunc(value);
    $7aPLP(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $aDCaS(result, key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $cdefbd8efe913551$var$baseClone;

});

parcelRegister("7aPLP", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5391a0175a1872c4$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $5391a0175a1872c4$var$arrayEach;

});

parcelRegister("e8WyO", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a4bf3cec5f860948$var$baseAssign(object, source) {
    return object && $bk5x8(source, $f14Rr(source), object);
}
module.exports = $a4bf3cec5f860948$var$baseAssign;

});

parcelRegister("lunGb", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $dNyAN = parcelRequire("dNyAN");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $fa4ec48e79e3b749$var$baseAssignIn(object, source) {
    return object && $bk5x8(source, $dNyAN(source), object);
}
module.exports = $fa4ec48e79e3b749$var$baseAssignIn;

});

parcelRegister("gwj3d", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $j1qF4 = parcelRequire("j1qF4");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $c06e699caf978d13$var$copySymbols(source, object) {
    return $bk5x8(source, $j1qF4(source), object);
}
module.exports = $c06e699caf978d13$var$copySymbols;

});

parcelRegister("j60dZ", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $ahKsp = parcelRequire("ahKsp");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $de6ec073df6f66ec$var$copySymbolsIn(source, object) {
    return $bk5x8(source, $ahKsp(source), object);
}
module.exports = $de6ec073df6f66ec$var$copySymbolsIn;

});

parcelRegister("kGJE1", function(module, exports) {
/** Used for built-in method references. */ var $f0fb22f60689ed3d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0fb22f60689ed3d$var$hasOwnProperty = $f0fb22f60689ed3d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $f0fb22f60689ed3d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $f0fb22f60689ed3d$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $f0fb22f60689ed3d$var$initCloneArray;

});

parcelRegister("cZmfO", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");


var $2nf4s = parcelRequire("2nf4s");


var $aOXy4 = parcelRequire("aOXy4");


var $cPFvk = parcelRequire("cPFvk");


var $39R3S = parcelRequire("39R3S");

/** `Object#toString` result references. */ var $974c71bfd764326f$var$boolTag = '[object Boolean]', $974c71bfd764326f$var$dateTag = '[object Date]', $974c71bfd764326f$var$mapTag = '[object Map]', $974c71bfd764326f$var$numberTag = '[object Number]', $974c71bfd764326f$var$regexpTag = '[object RegExp]', $974c71bfd764326f$var$setTag = '[object Set]', $974c71bfd764326f$var$stringTag = '[object String]', $974c71bfd764326f$var$symbolTag = '[object Symbol]';
var $974c71bfd764326f$var$arrayBufferTag = '[object ArrayBuffer]', $974c71bfd764326f$var$dataViewTag = '[object DataView]', $974c71bfd764326f$var$float32Tag = '[object Float32Array]', $974c71bfd764326f$var$float64Tag = '[object Float64Array]', $974c71bfd764326f$var$int8Tag = '[object Int8Array]', $974c71bfd764326f$var$int16Tag = '[object Int16Array]', $974c71bfd764326f$var$int32Tag = '[object Int32Array]', $974c71bfd764326f$var$uint8Tag = '[object Uint8Array]', $974c71bfd764326f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $974c71bfd764326f$var$uint16Tag = '[object Uint16Array]', $974c71bfd764326f$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $974c71bfd764326f$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $974c71bfd764326f$var$arrayBufferTag:
            return $bAYSF(object);
        case $974c71bfd764326f$var$boolTag:
        case $974c71bfd764326f$var$dateTag:
            return new Ctor(+object);
        case $974c71bfd764326f$var$dataViewTag:
            return $2nf4s(object, isDeep);
        case $974c71bfd764326f$var$float32Tag:
        case $974c71bfd764326f$var$float64Tag:
        case $974c71bfd764326f$var$int8Tag:
        case $974c71bfd764326f$var$int16Tag:
        case $974c71bfd764326f$var$int32Tag:
        case $974c71bfd764326f$var$uint8Tag:
        case $974c71bfd764326f$var$uint8ClampedTag:
        case $974c71bfd764326f$var$uint16Tag:
        case $974c71bfd764326f$var$uint32Tag:
            return $39R3S(object, isDeep);
        case $974c71bfd764326f$var$mapTag:
            return new Ctor;
        case $974c71bfd764326f$var$numberTag:
        case $974c71bfd764326f$var$stringTag:
            return new Ctor(object);
        case $974c71bfd764326f$var$regexpTag:
            return $aOXy4(object);
        case $974c71bfd764326f$var$setTag:
            return new Ctor;
        case $974c71bfd764326f$var$symbolTag:
            return $cPFvk(object);
    }
}
module.exports = $974c71bfd764326f$var$initCloneByTag;

});

parcelRegister("2nf4s", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $1ba96b89566301a8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $bAYSF(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $1ba96b89566301a8$var$cloneDataView;

});

parcelRegister("aOXy4", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $7e0cc3fe33183417$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $7e0cc3fe33183417$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $7e0cc3fe33183417$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $7e0cc3fe33183417$var$cloneRegExp;

});

parcelRegister("cPFvk", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");

/** Used to convert symbols to primitives and strings. */ var $957a7155a4d05ec8$var$symbolProto = $2v1OR ? $2v1OR.prototype : undefined, $957a7155a4d05ec8$var$symbolValueOf = $957a7155a4d05ec8$var$symbolProto ? $957a7155a4d05ec8$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $957a7155a4d05ec8$var$cloneSymbol(symbol) {
    return $957a7155a4d05ec8$var$symbolValueOf ? Object($957a7155a4d05ec8$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $957a7155a4d05ec8$var$cloneSymbol;

});

parcelRegister("aBDCC", function(module, exports) {

var $aPSWx = parcelRequire("aPSWx");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $7b8c182c149a3e72$var$nodeIsMap = $izBVL && $izBVL.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $7b8c182c149a3e72$var$isMap = $7b8c182c149a3e72$var$nodeIsMap ? $gGzL7($7b8c182c149a3e72$var$nodeIsMap) : $aPSWx;
module.exports = $7b8c182c149a3e72$var$isMap;

});

parcelRegister("aPSWx", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $7e3949613e91b78e$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7e3949613e91b78e$var$baseIsMap(value) {
    return $7WFUU(value) && $jOCrv(value) == $7e3949613e91b78e$var$mapTag;
}
module.exports = $7e3949613e91b78e$var$baseIsMap;

});

parcelRegister("1ji1e", function(module, exports) {

var $l6Y5L = parcelRequire("l6Y5L");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $0f458af8916b54b7$var$nodeIsSet = $izBVL && $izBVL.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $0f458af8916b54b7$var$isSet = $0f458af8916b54b7$var$nodeIsSet ? $gGzL7($0f458af8916b54b7$var$nodeIsSet) : $l6Y5L;
module.exports = $0f458af8916b54b7$var$isSet;

});

parcelRegister("l6Y5L", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $f5e8c58b63155910$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $f5e8c58b63155910$var$baseIsSet(value) {
    return $7WFUU(value) && $jOCrv(value) == $f5e8c58b63155910$var$setTag;
}
module.exports = $f5e8c58b63155910$var$baseIsSet;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("1cHqV", function(module, exports) {
// Cache for filtered onboarding state results.
// Uses WeakMap keyed by data object (auto-clears when data is garbage collected),
// with nested Map keyed by keys string for O(1) lookup.
const $e7b7b792910c4288$var$filteredStateCache = new WeakMap();
/**
 * Creates a cache key from the requested keys.
 */ const $e7b7b792910c4288$var$createCacheKey = (keys)=>{
    return Array.isArray(keys) ? keys.join(',') : keys;
};
/**
 * Performs the actual filtering of onboarding state data.
 */ const $e7b7b792910c4288$var$filterData = (data, requestedKeys)=>{
    const keysArray = Array.isArray(requestedKeys) ? requestedKeys : [
        requestedKeys
    ];
    const keySet = new Set(keysArray);
    return {
        ...data,
        onboardingState: data.onboardingState?.filter(({ key: key })=>{
            // Check both the full key and the parsed key (without prefix)
            // Keys come back as "{prefix}:{property}" format
            const parsedKey = key.split(':')[1] || key;
            return keySet.has(key) || keySet.has(parsedKey);
        })
    };
};
const $e7b7b792910c4288$export$c1dd389f39afa62f = (data, requestedKeys)=>{
    if (!data?.onboardingState) // Convert null to undefined to maintain backward compatibility with consumers
    // that expect `T | undefined` rather than `T | null | undefined`
    return data ?? undefined;
    const cacheKey = $e7b7b792910c4288$var$createCacheKey(requestedKeys);
    let dataCache = $e7b7b792910c4288$var$filteredStateCache.get(data);
    if (!dataCache) {
        dataCache = new Map();
        $e7b7b792910c4288$var$filteredStateCache.set(data, dataCache);
    }
    if (dataCache.has(cacheKey)) return dataCache.get(cacheKey);
    const filteredResult = $e7b7b792910c4288$var$filterData(data, requestedKeys);
    dataCache.set(cacheKey, filteredResult);
    return filteredResult;
};
module.exports["filterOnboardingState"] = $e7b7b792910c4288$export$c1dd389f39afa62f;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");




var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            fetchPolicy: 'cache-first'
        } : {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId
            }
        },
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            variables: {
                contentId: contentId,
                status: status ?? [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            skip: !contentId,
            fetchPolicy: 'cache-first'
        } : {
            variables: {
                contentId: contentId,
                status: status
            },
            skip: !contentId
        },
        __callerPackage__: "entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType, skip: skip })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip,
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<1341e8100a34db255d375a90f5c4a762>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "e5daa0845f1390f74a58e4fd57f9defb";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<48d9ee7fb5d606ab817066b5f7172f92>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "0a581f032f7c1b6232f4634d5c3d1376";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<d4c33eb851813f5d8bdf7b8ddf9d7fb7>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "4ac4e53f1dd0ba665b3f48217ce7b74b";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<eaa114c9e42c98e4d30da80006b4df1f>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "5796c3a83a0773d6d932bd63d2fbf511";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("gsf3i", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $kycWk = parcelRequire("kycWk");

const $4c2208d3e228490f$var$initialState = {
    firstRedactionIdRendered: null,
    firstRedactionRenderedForContentId: null,
    titleRedactionRenderedForContentId: null,
    firstStepSource: null,
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $4c2208d3e228490f$var$Store = (0, $8s9DV.createStore)({
    initialState: $4c2208d3e228490f$var$initialState,
    actions: {
        setFirstRedactionIdRendered: (redactionId, contentId)=>({ getState: getState, setState: setState })=>{
                const { firstRedactionIdRendered: firstRedactionIdRendered, firstRedactionRenderedForContentId: firstRedactionRenderedForContentId } = getState();
                if (firstRedactionIdRendered && firstRedactionRenderedForContentId === contentId) return;
                setState({
                    firstRedactionIdRendered: redactionId,
                    firstRedactionRenderedForContentId: contentId ?? null
                });
            },
        setTitleRedactionRenderedForContentId: (contentId)=>({ setState: setState })=>{
                setState({
                    titleRedactionRenderedForContentId: contentId
                });
            },
        clearTitleRedactionRenderedForContentId: (contentId)=>({ getState: getState, setState: setState })=>{
                if (getState().titleRedactionRenderedForContentId !== contentId) return;
                setState({
                    titleRedactionRenderedForContentId: null
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: $4c2208d3e228490f$var$initialState.activeSpotlightIndex,
                    lastActiveSpotlightIndex: $4c2208d3e228490f$var$initialState.lastActiveSpotlightIndex,
                    firstStepSource: $4c2208d3e228490f$var$initialState.firstStepSource
                });
            },
        initiateTour: (firstStepSource)=>({ getState: getState, setState: setState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex, firstRedactionRenderedForContentId: firstRedactionRenderedForContentId, titleRedactionRenderedForContentId: titleRedactionRenderedForContentId } = getState();
                if (activeSpotlightIndex !== null) return;
                if (firstStepSource === (0, $kycWk.RedactionTourStepSource).bodyRedaction && titleRedactionRenderedForContentId !== null && firstRedactionRenderedForContentId === titleRedactionRenderedForContentId) return;
                setState({
                    activeSpotlightIndex: 0,
                    firstStepSource: firstStepSource
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex,
                    firstStepSource: $4c2208d3e228490f$var$initialState.firstStepSource
                });
            }
    }
});
const $4c2208d3e228490f$export$4e8589b303f4384d = (0, $kBr4q.createHook)($4c2208d3e228490f$var$Store);
const $4c2208d3e228490f$export$b121a589d2d05ff2 = (0, $kBr4q.createActionsHook)($4c2208d3e228490f$var$Store);
const $4c2208d3e228490f$export$f2a6ed6b1eb18db8 = (0, $kBr4q.createStateHook)($4c2208d3e228490f$var$Store, {
    selector: (state)=>state.activeSpotlightIndex !== null
});
module.exports["useRedactionsTourState"] = $4c2208d3e228490f$export$4e8589b303f4384d;
module.exports["useRedactionsTourActions"] = $4c2208d3e228490f$export$b121a589d2d05ff2;

});

parcelRegister("2MwVI", function(module, exports) {

var $635s2 = parcelRequire("635s2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $gsf3i = parcelRequire("gsf3i");

const $49bfbfa6f9c85bf2$export$ea561d273e8cda71 = "\u2588\u2588\u2588\u2588";
const $49bfbfa6f9c85bf2$var$TITLE_REDACTION_WITH_ID_PATTERN = /██\s*\[ID:[^\]]+\]/u;
const $49bfbfa6f9c85bf2$var$doesTitleContainCurrentRedactionString = (title)=>Boolean(title && $49bfbfa6f9c85bf2$var$TITLE_REDACTION_WITH_ID_PATTERN.test(title));
const $49bfbfa6f9c85bf2$var$doesTitleContainLegacyRedactionString = (title)=>Boolean(title && title.includes($49bfbfa6f9c85bf2$export$ea561d273e8cda71));
const $49bfbfa6f9c85bf2$export$d7a7fedf1f7b03e1 = (title)=>{
    return $49bfbfa6f9c85bf2$var$doesTitleContainLegacyRedactionString(title) || $49bfbfa6f9c85bf2$var$doesTitleContainCurrentRedactionString(title);
};
const $49bfbfa6f9c85bf2$export$19187316a5e6c180 = ({ contentId: contentId, title: title })=>{
    const { clearTitleRedactionRenderedForContentId: clearTitleRedactionRenderedForContentId, setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId } = (0, $gsf3i.useRedactionsTourActions)();
    const titleHasCurrentRedaction = (0, $cozmU.useMemo)(()=>$49bfbfa6f9c85bf2$var$doesTitleContainCurrentRedactionString(title), [
        title
    ]);
    const titleMaybeHasLegacyRedaction = (0, $cozmU.useMemo)(()=>!titleHasCurrentRedaction && $49bfbfa6f9c85bf2$var$doesTitleContainLegacyRedactionString(title), [
        title,
        titleHasCurrentRedaction
    ]);
    const { data: data, error: redactionsCountError } = (0, $jMyy4.useQueryInterop)((0, $635s2.default), {
        skip: !titleMaybeHasLegacyRedaction,
        variables: {
            contentId: contentId
        },
        errorPolicy: 'all',
        __callerPackage__: "redactions"
    });
    // handle 4xx errors
    (0, $cozmU.useEffect)(()=>{
        if (redactionsCountError && (0, $aMcHK.isStatusCodeError)(redactionsCountError, '404')) (0, $7Sm4c.markErrorAsHandled)(redactionsCountError);
    }, [
        redactionsCountError
    ]);
    const redactionsCount = data?.singleContent?.redactionMetadataCount ?? 0;
    const isTitleRedactionConfirmed = titleHasCurrentRedaction || titleMaybeHasLegacyRedaction && redactionsCount > 0;
    (0, $cozmU.useEffect)(()=>{
        if (contentId && isTitleRedactionConfirmed) setTitleRedactionRenderedForContentId(contentId);
        return ()=>{
            clearTitleRedactionRenderedForContentId(contentId);
        };
    }, [
        clearTitleRedactionRenderedForContentId,
        contentId,
        isTitleRedactionConfirmed,
        setTitleRedactionRenderedForContentId
    ]);
};
module.exports["useTrackTitleRedactionRendered"] = $49bfbfa6f9c85bf2$export$19187316a5e6c180;

});

parcelRegister("635s2", function(module, exports) {
/**
 * @generated SignedSource<<a0a12f229cf3db623a511192bab87885>>
 * @relayHash a2231280d1a64c0467ba87a246116380
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9
const $a51c9ec4f18af0fc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "redactionMetadataCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a2231280d1a64c0467ba87a246116380",
            "id": "5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9",
            "metadata": {},
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "operationKind": "query",
            "text": "query useTrackTitleRedactionRenderedRedactionsCountQuery($contentId:ID!){singleContent(id:$contentId){id,redactionMetadataCount}}"
        }
    };
}();
$a51c9ec4f18af0fc$var$node.hash = "f9a742b4e2840cd061fc6915ae9b6b93";
var $a51c9ec4f18af0fc$export$2e2bcd8739ae039 = $a51c9ec4f18af0fc$var$node;
module.exports["default"] = $a51c9ec4f18af0fc$export$2e2bcd8739ae039;

});

parcelRegister("7xnK2", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57ce080eaea1a7ac$var$Placeholder = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02HZdu _0jFU0Vv6H3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $57ce080eaea1a7ac$export$14728599fd1e0142 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($57ce080eaea1a7ac$var$Placeholder, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentTitlePlaceholder"] = $57ce080eaea1a7ac$export$14728599fd1e0142;

});

parcelRegister("eP7b6", function(module, exports) {
/**
 * @generated SignedSource<<293007c6777799aa33e10204d25d472b>>
 * @relayHash 002ee32db0695a9b63af69a407a07639
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54
const $0ba271c76ca4c8d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"content-appearance-published\")"
                },
                {
                    "alias": "emojiTitlePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "emoji-title-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"emoji-title-published\")"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fabricEditorSupported"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "002ee32db0695a9b63af69a407a07639",
            "id": "5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54",
            "metadata": {},
            "name": "ContentTitleExternalQuery",
            "operationKind": "query",
            "text": "query ContentTitleExternalQuery($contentId:ID!){singleContent(id:$contentId){id,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported}}}}"
        }
    };
}();
$0ba271c76ca4c8d2$var$node.hash = "99403818c8d620c95107a7fed0ae3cd7";
var $0ba271c76ca4c8d2$export$2e2bcd8739ae039 = $0ba271c76ca4c8d2$var$node;
module.exports["default"] = $0ba271c76ca4c8d2$export$2e2bcd8739ae039;

});

parcelRegister("ds2ZC", function(module, exports) {

let $9cb036305994698d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9cb036305994698d$var$load("5odbj"),
    $9cb036305994698d$var$load("frTOf")
]).then(()=>parcelRequire('8taxc'));

});

parcelRegister("bX4Zr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2FsQH = parcelRequire("2FsQH");


var $7zgzO = parcelRequire("7zgzO");

const $5437b70689f01310$var$useUnload = (fn)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    let t1;
    if ($[0] !== fn) {
        t0 = ()=>{
            window.addEventListener("beforeunload", fn);
            return ()=>{
                window.removeEventListener("beforeunload", fn);
            };
        };
        t1 = [
            fn
        ];
        $[0] = fn;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
function $5437b70689f01310$export$e38025aebea82d38(contentId, storageKeySuffix) {
    const $ = (0, $bDgLe.c)(7);
    const { getHash: getHash } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const hashRef = (0, $cozmU.useRef)(getHash);
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== storageKeySuffix) {
        t0 = ()=>{
            (0, $2FsQH.restoreScrollPositionIfNeeded)({
                contentId: contentId,
                isInViewPage: true,
                contentReadyState: 1,
                docObject: document,
                winObject: window,
                hash: hashRef.current(),
                storageKeySuffix: storageKeySuffix
            });
        };
        t1 = [
            contentId,
            storageKeySuffix
        ];
        $[0] = contentId;
        $[1] = storageKeySuffix;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] !== contentId || $[5] !== storageKeySuffix) {
        t2 = ()=>{
            (0, $2FsQH.persistRelativeScrollPosition)({
                contentId: contentId,
                isInViewPage: true,
                docObject: document,
                winObject: window,
                storageKeySuffix: storageKeySuffix
            });
        };
        $[4] = contentId;
        $[5] = storageKeySuffix;
        $[6] = t2;
    } else t2 = $[6];
    $5437b70689f01310$var$useUnload(t2);
}
module.exports["useViewPagePersistentScrollPosition"] = $5437b70689f01310$export$e38025aebea82d38;

});

parcelRegister("2FsQH", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $5ZqQS = parcelRequire("5ZqQS");


var $id4ij = parcelRequire("id4ij");

const $0318c9ad181ada0b$export$b2593172c1a4a4fd = (els)=>{
    const result = [];
    // use `Array.some` to stop the loop sooner.
    if (els) {
        for(let index = 0; index < els.length; index++)if ((0, $id4ij.isPartOfElementStillInViewPort)(els[index])) result.push({
            targetElementIndex: index,
            visibleBlockEl: els[index]
        });
    }
    return result;
};
const $0318c9ad181ada0b$export$9639f4e44d5443af = (els)=>{
    const visibleEls = $0318c9ad181ada0b$export$b2593172c1a4a4fd(els);
    let elHasTopVisible = null;
    const foundVisible = visibleEls.some((item)=>{
        if ((0, $id4ij.isTopOfElementStillInViewPort)(item.visibleBlockEl)) {
            elHasTopVisible = item;
            return true;
        }
        return false;
    });
    // in the worst case, return first element which is still in viewport
    if (!foundVisible && visibleEls.length > 0) return visibleEls[0];
    // a default value which indicates that no element is in viewport
    const noElementValue = {
        targetElementIndex: -1,
        visibleBlockEl: null
    };
    return elHasTopVisible || noElementValue;
};
const $0318c9ad181ada0b$export$f506f531b96875f7 = (columns)=>{
    const result = {
        targetElementIndexInColumn: -1,
        columnIndex: -1,
        // visible block element in target column
        visibleBlockEl: null
    };
    // usage of .some iterator without using its return value is considered a bug.
    for(let index = 0; index < columns.length; index++){
        const { visibleBlockEl: visibleBlockEl, targetElementIndex: targetElementIndex } = $0318c9ad181ada0b$export$9639f4e44d5443af(columns[index].children);
        if (visibleBlockEl) {
            result.columnIndex = index;
            result.targetElementIndexInColumn = targetElementIndex;
            result.visibleBlockEl = visibleBlockEl;
            break;
        }
    }
    return result;
};
const $0318c9ad181ada0b$export$7256c638fbf51d15 = (elContainer)=>{
    if (!elContainer) return false;
    const firstChildEl = elContainer.children[0];
    return firstChildEl && firstChildEl.classList.contains('contentLayout2');
};
function $0318c9ad181ada0b$export$2bc8e9ae2ef96ba4(elContainer, scrollY) {
    if (scrollY === 0 || elContainer === null) return null;
    const viewPositionData = {
        // index of block element in page, we call it as target element
        targetElementIndex: -1,
        // number of pixels from top of target element to current scroll position
        offsetBetweenTargetAndCurrentScroll: 0,
        // in case page has column layout, we need to save extra info.
        columnLayoutPosition: {
            columnIndex: -1,
            rowIndex: -1
        }
    };
    if (!$0318c9ad181ada0b$export$7256c638fbf51d15(elContainer)) {
        // easy in case page does not have column layout
        const { targetElementIndex: targetElementIndex, visibleBlockEl: visibleBlockEl } = $0318c9ad181ada0b$export$9639f4e44d5443af(elContainer.children);
        if (visibleBlockEl) {
            viewPositionData.targetElementIndex = targetElementIndex;
            viewPositionData.offsetBetweenTargetAndCurrentScroll = scrollY - (0, $id4ij.getElementTop)(visibleBlockEl);
            // don't need column layout data
            delete viewPositionData.columnLayoutPosition;
        }
    } else {
        // page has column layout so page content starts from first element
        const startPageContent = elContainer.children[0];
        const rows = startPageContent.children;
        // find visible row.
        const { targetElementIndex: rowIndex, visibleBlockEl: visibleRow } = $0318c9ad181ada0b$export$9639f4e44d5443af(rows);
        if (visibleRow && visibleRow.getElementsByClassName) {
            const columns = visibleRow.getElementsByClassName('innerCell');
            const { columnIndex: columnIndex, targetElementIndexInColumn: targetElementIndexInColumn, visibleBlockEl: visibleBlockInColumn } = $0318c9ad181ada0b$export$f506f531b96875f7(columns);
            if (visibleBlockInColumn) {
                viewPositionData.targetElementIndex = targetElementIndexInColumn;
                viewPositionData.offsetBetweenTargetAndCurrentScroll = scrollY - (0, $id4ij.getElementTop)(visibleBlockInColumn);
                viewPositionData.columnLayoutPosition = {
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                };
            }
        }
    }
    return viewPositionData.targetElementIndex !== -1 ? viewPositionData : null;
}
const $0318c9ad181ada0b$export$c3e0418bbdcd04e9 = (options)=>{
    const { contentId: contentId, isInViewPage: isInViewPage, docObject: // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    docObject = document, winObject: winObject = window, storageKeySuffix: storageKeySuffix = '' } = options;
    let mainContentEl;
    if (isInViewPage) // in view page
    mainContentEl = docObject.getElementById((0, $1UApO.keys).ID_START_CONTENT_IN_VIEW_PAGE);
    else // in edit page
    mainContentEl = docObject.body;
    const scrollPosition = $0318c9ad181ada0b$export$2bc8e9ae2ef96ba4(mainContentEl, winObject.pageYOffset);
    const persistScrollKey = (0, $1UApO.keys).PERSIST_SCROLL_POSITION_IN_VIEW_PAGE + contentId + storageKeySuffix;
    if (scrollPosition) {
        // add extra information so that when we do restoring, the data is safer
        scrollPosition.contentId = contentId;
        scrollPosition.isInViewPage = isInViewPage;
        (0, $17wUi.confluenceSessionStorageInstance).setItem(persistScrollKey, JSON.stringify(scrollPosition));
    } else {
        // when the scroll position is at the very top (default)
        // the scrollPosition is null, and we must check if there is a persisted value to avoid
        // the page from jumping
        const storedPosition = (0, $17wUi.confluenceSessionStorageInstance).getItem(persistScrollKey);
        if (storedPosition) (0, $17wUi.confluenceSessionStorageInstance).removeItem(persistScrollKey);
    }
};
const $0318c9ad181ada0b$export$a9f5dc6d645cb9a8 = (options)=>{
    const { contentId: contentId, isInViewPage: isInViewPage, contentReadyState: contentReadyState = 0, docObject: // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    docObject = document, winObject: winObject = window, hash: hash, storageKeySuffix: storageKeySuffix = '' } = options;
    const persistScrollKey = (0, $1UApO.keys).PERSIST_SCROLL_POSITION_IN_VIEW_PAGE + contentId + storageKeySuffix;
    let savedPosition = (0, $17wUi.confluenceSessionStorageInstance).getItem(persistScrollKey);
    try {
        savedPosition = JSON.parse(savedPosition);
        if (hash) {
            const decodeHash = decodeURIComponent(hash);
            const el = docObject.getElementById(decodeHash);
            const scrollPosition = el?.getBoundingClientRect().top;
            scrollPosition && winObject.scrollTo({
                top: scrollPosition
            });
        }
    } catch (error) {
        // could not parse the savedPosition or
        // anchor is invalid, may contain UTF-8 encoding of emoji which does not nice map back to the querySelector
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'backbone'
        });
    } finally{
        // removing the persisted scroll position here would cause the scroll position to jump
        // since this function should get called when content is and is not ready during SSR to SPA.
        // ideally we will use local storage values on SSR
        // however, when the content is READY (1) there is no need to persist the position
        if (contentReadyState === 1) (0, $17wUi.confluenceSessionStorageInstance).removeItem(persistScrollKey);
    }
    if (hash || // hash exists in the url, window already scrolled to the element in view
    !savedPosition || // does not match contentId so this data is invalid
    savedPosition.contentId !== contentId) return;
    let contentWrapper;
    if (isInViewPage) contentWrapper = docObject.getElementById((0, $1UApO.keys).ID_START_CONTENT_IN_VIEW_PAGE);
    else // inside editor iframe, content starts from body tag
    contentWrapper = docObject.body;
    if (!contentWrapper || !contentWrapper.children[0]) return;
    const { columnLayoutPosition: columnLayoutPosition } = savedPosition;
    let targetElement;
    if (columnLayoutPosition) {
        // page have layout
        const startEditorContent = contentWrapper.children[0];
        const targetRow = startEditorContent.children[columnLayoutPosition.rowIndex];
        const columns = targetRow?.getElementsByClassName('innerCell');
        const targetColumn = columns?.[columnLayoutPosition.columnIndex];
        targetElement = targetColumn && targetColumn?.children?.[savedPosition.targetElementIndex];
    } else // page does not have layout
    targetElement = contentWrapper.children[savedPosition.targetElementIndex];
    if (targetElement) {
        const topOffset = (0, $id4ij.getElementTop)(targetElement);
        const offset = savedPosition.offsetBetweenTargetAndCurrentScroll;
        let newPosition = topOffset + offset;
        // start scrolling to avoid jumping to the top of the page.
        if (isInViewPage) {
            const maxScrollHeight = docObject?.querySelector?.('#main-content')?.clientHeight || 0;
            newPosition = Math.min(maxScrollHeight, newPosition);
        }
        winObject.scrollTo(0, newPosition);
    }
};
module.exports["persistRelativeScrollPosition"] = $0318c9ad181ada0b$export$c3e0418bbdcd04e9;
module.exports["restoreScrollPositionIfNeeded"] = $0318c9ad181ada0b$export$a9f5dc6d645cb9a8;

});

parcelRegister("gsWjA", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $hDLmU = parcelRequire("hDLmU");


var $c411D = parcelRequire("c411D");


var $jOO7o = parcelRequire("jOO7o");


var $bQm3c = parcelRequire("bQm3c");


var $iFjdQ = parcelRequire("iFjdQ");


var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");

var $i3c1S = parcelRequire("i3c1S");


var $5q601 = parcelRequire("5q601");


var $1UCmC = parcelRequire("1UCmC");


var $jX1qB = parcelRequire("jX1qB");


var $lXYVJ = parcelRequire("lXYVJ");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $7sK8i = parcelRequire("7sK8i");


var $8w1c1 = parcelRequire("8w1c1");

parcelRequire("1InRL");
var $hlP5l = parcelRequire("hlP5l");


var $5qUgM = parcelRequire("5qUgM");


var $1q7H7 = parcelRequire("1q7H7");


var $aWrnw = parcelRequire("aWrnw");


var $5YLPl = parcelRequire("5YLPl");


var $fgdVB = parcelRequire("fgdVB");


var $itS9i = parcelRequire("itS9i");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $5vi32 = parcelRequire("5vi32");


var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");

const $a99ff50c139ee598$var$baseConfig = {
    slo: {
        // based on production p90
        fmp: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        },
        tti: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        }
    },
    histogram: {
        // based on pre-production pollinator and prod p90
        initial: {
            fmp: '5000_6000_7000_8000_10000_12000_14000',
            tti: '5000_6000_7000_8000_10000_12000_14000'
        },
        transition: {
            fmp: '2000_2500_3000_3500_4000_4500_5000',
            tti: '2000_2500_3000_3500_4000_4500_5000'
        }
    },
    timings: [
        // breakdowns in order of occurrence
        {
            key: 'html',
            endMark: 'html'
        },
        {
            key: 'appLoad',
            startMark: 'html',
            endMark: 'app'
        },
        {
            key: 'appRootRender',
            startMark: 'app',
            endMark: 'root-component-render'
        },
        {
            key: 'routerMatched',
            startMark: 'root-component-render',
            endMark: 'route-manager-initialized'
        }
    ]
};
const $a99ff50c139ee598$var$NOOP = ()=>{};
const $a99ff50c139ee598$export$2d5e2a82ee58820b = ({ isLite: isLite, isInitialLoad: isInitialLoad })=>{
    if (isLite) return [
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC)
    ];
    const segments = [
        // New metric adding to this list should also be added to fmpAsUntilStopTimeMetrics
        // See comments in fmpAsUntilStopTimeMetrics for more information
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC),
        $a99ff50c139ee598$export$e190581c76254e9
    ];
    segments.push((0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC));
    segments.push((0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC));
    if (isInitialLoad) {
        segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC));
        segments.push((0, $1q7H7.PAGE_TREE_METRIC));
    }
    return segments;
};
/**
 * fmpAsUntilStopTimeMetrics
 *
 * UPDATE 2025-04-29: TTI is deprecated. Going forward, new segments should be included here by default in order to
 * preserve the original TTI definition. Segments should be included even if they are not minimally interactive.
 *
 * What is minimally interactive?
 * Minimally interactive during the SSR phase at it's core, is determined if the component/element is clickable,
 * can register the action, and display a visual response that the action has been received.
 * The SSR phase can be stalled by appending ?NO_SPA=1 at the end of a CONNIE url.
 *
 * I.E. If you click on an inline comment/highlight, the click is registered, and displays a loading sidebar component.
 *
 * If a required segment is SSR'd and determined to be minimally interactive at FMP, ADD TO THIS LIST
 * If a required segment is SSR'd but determined to NOT be minimally interactive at FMP, DO NOT ADD TO THIS LIST
 * If a required segment is yet to be SSR'd, this config will not update TTI for that segment, by default is OFF.
 *
 * CONTEXT
 * the returned segments are considered to be minimally interactive during SSR
 * hence we want to use FMP (ssr-ttr mark)
 *
 * PageSegment TTI is measured: useFmpAsUntilStopTime ? FMP : Eventual load time
 * Content-renderer TTI: macros are SSRed ? FMP : Eventual Load Time
 *
 * View Page TTI is measured: Math.max(Non SSR PageSegments TTI, Content-renderer TTI)
 *
 */ const $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics = ({ isLite: isLite })=>{
    if (isLite) return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY)
    ];
    return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
        (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
        (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY)
    ];
};
const $a99ff50c139ee598$export$acf5746d268ae4ee = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { contentId: contentId, isLite: isLite, customConfig: customConfig } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const pageLoadMetricRef = (0, $cozmU.useRef)();
    const sendMetrics = (0, $c411D.useEmbeddedConfluenceEventMarkers)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== customConfig?.expectedPageLoadSegments || $[2] !== customConfig?.fmpUntilStopTimeMetrics || $[3] !== customConfig?.pageLoadKey || $[4] !== isEmbeddedConfluence || $[5] !== isLite || $[6] !== sendMetrics) {
        t1 = ()=>{
            const _isInitialLoad = (0, $6VdZc.isInitial)();
            const expectedPageSegments = customConfig?.expectedPageLoadSegments ?? $a99ff50c139ee598$export$2d5e2a82ee58820b({
                isInitialLoad: _isInitialLoad,
                isLite: isLite
            });
            if (0, $itS9i.debuggerEnabled) (0, $itS9i.cacheExpectedViewPageSegments)(expectedPageSegments);
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
            const untilExperienceMetricNames = customConfig?.fmpUntilStopTimeMetrics ?? $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics({
                isLite: isLite
            });
            const untilPageSegments = expectedPageSegments.map((segment)=>({
                    experience: segment,
                    useFmpAsUntilStopTime: untilExperienceMetricNames.includes(segment.key)
                }));
            pageLoadMetricRef.current = (0, $lSOAM.createPageLoadMetric)({
                ...$a99ff50c139ee598$var$baseConfig,
                key: customConfig?.pageLoadKey ?? (0, $1UCmC.VIEW_PAGE_LOAD_KEY),
                timings: [
                    ...$a99ff50c139ee598$var$baseConfig.timings,
                    ...(0, $i3c1S.getWaterfallTimings)(expectedPageSegments)
                ],
                include: expectedPageSegments,
                until: untilPageSegments
            });
            if (!_isInitialLoad) expectedPageSegments.forEach($a99ff50c139ee598$var$_temp);
            pageLoadMetricRef.current.startPageLoad();
            pageLoadMetricRef.current.onStop((0, $7fw2E.markBrowserMetricEnd).bind(null, pageLoadMetricRef.current), $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop((0, $7sK8i.resumeLowPriorityEvents), (0, $7sK8i.resumeLowPriorityEvents));
            pageLoadMetricRef.current.onStop((0, $lXYVJ.resetViewTransitionSource), (0, $lXYVJ.resetViewTransitionSource));
            pageLoadMetricRef.current.onStop(()=>{
                if (isEmbeddedConfluence) {
                    const observableObject = (0, $jOO7o.getIframeObservable_DO_NOT_USE)();
                    const uniqueKey = observableObject?.object?.uniqueKey;
                    sendMetrics({
                        timestamp: Date.now(),
                        customData: uniqueKey ? {
                            uniqueKey: uniqueKey
                        } : {}
                    }, `${(0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $hDLmU.EMBEDDED_VIEW_TTI)}`);
                }
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__)) {
                    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                    if (!(0, $9wGTI.fg)("confluence_frontend_sfx_hydration_errors") && window.__HYDRATION_ERRORS__ && window.__HYDRATION_ERRORS__.length > 0) {
                        const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
                        window.__HYDRATION_ERRORS__.forEach((error)=>{
                            if (error.type) {
                                const normalizedType = error.type.startsWith("UNSAFE_") ? error.type.slice(7) : error.type;
                                monitoringClient.incrementCounter("hydrationErrorCount", [
                                    `type:${normalizedType}`,
                                    `route:${route}`
                                ]);
                            }
                        });
                    }
                    if ((0, $6mKj3.expVal)("confluence_frontend_hydration_failure_reporting", "isEnabled", false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
                        source: "viewPageCommon",
                        route: route,
                        errorWithRoute: errorWithRoute,
                        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
                    })).fire();
                    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
                        attribution: "hydration"
                    });
                }
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__) && Boolean(window.__SSR_REACT_STREAMING__) && !(0, $6mKj3.expVal)("confluence_frontend_hydration_failure_reporting", "isEnabled", false)) {
                    const { error: errorWithRoute_0 } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                    (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute_0, {
                        attribution: "streaming-hydration"
                    });
                }
            }, $a99ff50c139ee598$var$NOOP);
            return ()=>{
                pageLoadMetricRef.current?.cancel();
            };
        };
        $[0] = createAnalyticsEvent;
        $[1] = customConfig?.expectedPageLoadSegments;
        $[2] = customConfig?.fmpUntilStopTimeMetrics;
        $[3] = customConfig?.pageLoadKey;
        $[4] = isEmbeddedConfluence;
        $[5] = isLite;
        $[6] = sendMetrics;
        $[7] = t1;
    } else t1 = $[7];
    let t2;
    if ($[8] !== contentId || $[9] !== createAnalyticsEvent || $[10] !== customConfig || $[11] !== isEmbeddedConfluence || $[12] !== isLite || $[13] !== sendMetrics || $[14] !== userId) {
        t2 = [
            contentId,
            customConfig,
            userId,
            isLite,
            isEmbeddedConfluence,
            sendMetrics,
            createAnalyticsEvent
        ];
        $[8] = contentId;
        $[9] = createAnalyticsEvent;
        $[10] = customConfig;
        $[11] = isEmbeddedConfluence;
        $[12] = isLite;
        $[13] = sendMetrics;
        $[14] = userId;
        $[15] = t2;
    } else t2 = $[15];
    (0, $cozmU.useEffect)(t1, t2);
    return null;
};
const $a99ff50c139ee598$export$e190581c76254e9 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
function $a99ff50c139ee598$var$_temp(m) {
    return m.startFromPageLoad();
}
module.exports["VIEW_PAGE_CONTAINER_METRIC"] = $a99ff50c139ee598$export$e190581c76254e9;
module.exports["StartViewPageLoad"] = $a99ff50c139ee598$export$acf5746d268ae4ee;

});

parcelRegister("hDLmU", function(module, exports) {
const $b5c2a7dcc1a96b34$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $b5c2a7dcc1a96b34$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $b5c2a7dcc1a96b34$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $b5c2a7dcc1a96b34$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $b5c2a7dcc1a96b34$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $b5c2a7dcc1a96b34$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $b5c2a7dcc1a96b34$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $b5c2a7dcc1a96b34$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $b5c2a7dcc1a96b34$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $b5c2a7dcc1a96b34$export$73b982309451f084;

});

parcelRegister("c411D", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $351b756af5d314b8$export$6654a9a4dc3a2802 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $351b756af5d314b8$var$_temp;
} : ()=>{
    return (0, $cozmU.useCallback)((payload, type)=>{
        window.parent.postMessage({
            type: type,
            payload: payload
        }, '*');
    }, []);
};
function $351b756af5d314b8$var$_temp(payload, type) {
    window.parent.postMessage({
        type: type,
        payload: payload
    }, "*");
}
module.exports["useEmbeddedConfluenceEventMarkers"] = $351b756af5d314b8$export$6654a9a4dc3a2802;

});

parcelRegister("5q601", function(module, exports) {
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';
module.exports["VIEW_EDIT_BUTTON_CLICKED_ACTION"] = $23ec6b91fddb9839$export$190611e0edbb22d5;
module.exports["EDIT_ROUTE_CHANGE_ACTION"] = $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e;
module.exports["EDIT_ROUTE_CHANGE_TO_FMP_ACTION"] = $23ec6b91fddb9839$export$caabe0b707a0bfac;
module.exports["TINY_SYNCHRONY_PLUGINS_LOAD_ACTION"] = $23ec6b91fddb9839$export$a5b3479b02282e8c;
module.exports["TINY_SYNCHRONY_CONTENT_FETCH_ACTION"] = $23ec6b91fddb9839$export$1787f4f7916eb601;
module.exports["EDIT_INTENT_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$99c2e20685f1cd4e;
module.exports["EDIT_INTENT_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$e04cfb21f00b2ad0;
module.exports["EMBEDDED_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$1d8f87e0ed24898e;
module.exports["EMBEDDED_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$16bdef2ba2fa4a5;
module.exports["EDIT_ROUTE_CHANGE_TO_TTI_ACTION"] = $23ec6b91fddb9839$export$4d09a02f749e3cc2;
module.exports["TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD"] = $23ec6b91fddb9839$export$c2bda34fe2c26f89;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$803e647119e41cc = 'embedded-store';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$2b4bf316b2f90e51 = 'folder-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["EMBEDDED_STORE_LOAD_KEY"] = $00aca2e58bbddd9e$export$803e647119e41cc;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["FOLDER_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2b4bf316b2f90e51;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("1InRL", function(module, exports) {
$parcel$export(module.exports, "BYLINE_METRIC", () => (parcelRequire("hlP5l")).BYLINE_METRIC);
$parcel$export(module.exports, "CONTENT_TITLE_METRIC", () => (parcelRequire("hlP5l")).CONTENT_TITLE_METRIC);

var $hlP5l = parcelRequire("hlP5l");


});

parcelRegister("fgdVB", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $70b3fb0961586b52$export$ac619e1da09d5f80 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["OBJECT_SIDEBAR_CONTROL_METRIC"] = $70b3fb0961586b52$export$ac619e1da09d5f80;

});

parcelRegister("5vi32", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    return (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("lABjq", function(module, exports) {
const $8cb98e143c540908$export$79ede1af301c436c = {
    pageJustPublished: false
};
module.exports["pagePublishedState"] = $8cb98e143c540908$export$79ede1af301c436c;

});

parcelRegister("1Af7Q", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $3fCLI = parcelRequire("3fCLI");

function $9a1f832417de6544$export$ae2b233b73197bb6() {
    const $ = (0, $bDgLe.c)(2);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t0;
    if ($[0] !== contentId) {
        t0 = contentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3fCLI.LegacyBridgeNextInner), {
            contentId: contentId
        }) : null;
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
}
module.exports["LegacyBridgeNext"] = $9a1f832417de6544$export$ae2b233b73197bb6;

});

parcelRegister("3fCLI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7W8i8 = parcelRequire("7W8i8");


var $1ytiN = parcelRequire("1ytiN");


var $e4o8D = parcelRequire("e4o8D");


var $8vxJi = parcelRequire("8vxJi");


var $3d5UI = parcelRequire("3d5UI");


var $jMyy4 = parcelRequire("jMyy4");


var $98Fgg = parcelRequire("98Fgg");

const $fdddd5e334b3dceb$var$logger = (0, $7W8i8.getLogger)('LegacyBridgeNext');
function $fdddd5e334b3dceb$export$af02eebb080c844({ contentId: contentId }) {
    const [contentType] = (0, $ep3mz.useContentType)();
    const { experimentFeatures: experimentFeatures } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // Due to circular dependency issues we are using the PreloadLegacyBridgeQuery from query-preloaders-common package
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $98Fgg.default), {
        variables: {
            contentId: contentId || '',
            isBlog: contentType === 'blogpost'
        },
        context: {
            single: true
        },
        __callerPackage__: "view-page"
    });
    const { ptpage: ptpage, content: content } = data || {};
    const contentNode = content?.nodes?.[0];
    const spaceNode = contentNode?.space;
    const pageVersion = contentNode?.version?.number;
    const ajsMetaParameters = [
        {
            key: 'space-key',
            value: spaceNode?.key
        },
        {
            key: 'space-name',
            value: spaceNode?.name
        },
        {
            key: 'space-type',
            value: spaceNode?.type
        },
        {
            key: 'content-type',
            value: contentNode?.type
        },
        {
            key: 'page-version',
            value: pageVersion
        },
        {
            key: 'page-title',
            value: contentNode?.title
        },
        {
            key: 'parent-page-id',
            value: ptpage?.nearestAncestors?.edges?.[0]?.node?.id
        },
        {
            key: 'parent-page-title',
            value: ptpage?.nearestAncestors?.edges?.[0]?.node?.title
        },
        {
            key: 'experiment-features',
            value: experimentFeatures
        }
    ];
    if (contentId) {
        const createPage = pageVersion === 0;
        const pageId = createPage ? '0' : contentId;
        ajsMetaParameters.push({
            key: 'content-id',
            value: contentId
        });
        ajsMetaParameters.push({
            key: 'latest-page-id',
            value: contentId
        });
        ajsMetaParameters.push({
            key: 'new-page',
            value: createPage
        });
        ajsMetaParameters.push({
            key: 'page-id',
            value: pageId
        });
    }
    const operations = contentNode?.operations;
    if (operations) {
        const canRemovePage = operations.filter((item)=>item?.operation === 'delete' && item?.targetType === 'page').length > 0;
        ajsMetaParameters.push({
            key: 'can-remove-page',
            value: canRemovePage
        });
    }
    const filteredAjsMetaParameters = ajsMetaParameters.filter(({ value: value })=>value !== undefined && value !== null);
    (0, $cozmU.useEffect)(()=>{
        (0, $3d5UI.waitForGlobal)({
            listener: 'LegacyBridgeNext.js',
            globalProperty: 'AJS.Meta.set'
        }, ()=>{
            if (error) {
                $fdddd5e334b3dceb$var$logger.error`Failed to Query Legacy AJSMetaData ${error}`;
                return;
            }
            if (filteredAjsMetaParameters.length === 0 || window.AJS.Meta.get('has-next-legacy-bridge')) return;
            // We have 2 legacy bridge here based on graphql
            // Another in packages/confluence-frontend-server/src/components/LegacyBridge/LegacyBridge.js based on Redux.
            // We need to let the legacy one know we have already dealt with these meta tags don't override
            window.AJS.Meta.set('has-next-legacy-bridge', true);
            filteredAjsMetaParameters.forEach(({ key: key, value: value_0 })=>window.AJS.Meta.set(key, value_0));
        });
        return ()=>{
            const ajsMeta = window.AJS?.Meta;
            ajsMeta && ajsMeta.set('has-next-legacy-bridge', false);
        };
    }, [
        error,
        contentId,
        filteredAjsMetaParameters
    ]);
    if (renderServerPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        nonce: nonceValue,
        "data-testid": "legacyBridge-ssr",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.__SSR_AJS_META__=${(0, $8vxJi.stringifyForSSR)(filteredAjsMetaParameters)}`
        }
    });
    return null;
}
module.exports["LegacyBridgeNextInner"] = $fdddd5e334b3dceb$export$af02eebb080c844;

});

parcelRegister("98Fgg", function(module, exports) {
/**
 * @generated SignedSource<<9e3e16b02d7e839cb28fafbd9cc22027>>
 * @relayHash 1eef94f086d4818dc81396289138687a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09
const $314d226daa5f5ce2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isBlog"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "condition": "isBlog",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "CURRENT"
                            ]
                        }
                    ],
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "ptpage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                }
                            ],
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "nearestAncestors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PTPageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "PTPage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "nearestAncestors(first:1)"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "1eef94f086d4818dc81396289138687a",
            "id": "57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09",
            "metadata": {},
            "name": "preloadLegacyBridgeQuery",
            "operationKind": "query",
            "text": "query preloadLegacyBridgeQuery($contentId:ID!,$isBlog:Boolean!){ptpage(id:$contentId,status:[CURRENT])@skip(if:$isBlog){id,nearestAncestors(first:1){edges{node{id,title}}}},content(id:$contentId){nodes{id,type,title,version{number},space{id,key,name,type},operations{operation,targetType}}}}"
        }
    };
}();
$314d226daa5f5ce2$var$node.hash = "6d396d281028b16cc64fd39e7d8cd3db";
var $314d226daa5f5ce2$export$2e2bcd8739ae039 = $314d226daa5f5ce2$var$node;
module.exports["default"] = $314d226daa5f5ce2$export$2e2bcd8739ae039;

});

parcelRegister("eTuLj", function(module, exports) {

let $ad7e106f0dc8aacf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad7e106f0dc8aacf$var$load("2SbEZ").then(()=>parcelRequire('dI68T'));

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $7G1r9 = parcelRequire("7G1r9");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)({
    isForAggOnly: true
});
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $7G1r9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $422HI = parcelRequire("422HI");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $422HI.ApolloErrorInterop)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("lyWac", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");


var $3mugH = parcelRequire("3mugH");

// Mirrors GraphqlErrorProcessor's mark. Read through the global symbol registry rather than
// importing `isErrorMarkedAsHandled`, because ~20 test files mock
// `@confluence/graphql-error-processor` partially and a new import here would break all of them.
// The registry is the same mechanism GraphqlErrorProcessor relies on to share the mark across the
// preloader and main-app bundles, and `ignores errors already marked as handled` in this module's
// tests exercises the real `markErrorAsHandled`, so the key cannot drift unnoticed.
const $6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL = Symbol.for('error marked as handled');
function $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) {
    return typeof error === 'object' && error !== null && Boolean(error[$6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL]);
}
const $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError = (error)=>error?.extensions?.data?.authorized === false;
/**
 * A page the viewer is not allowed to see is a normal SSR outcome, not a defect — the render falls
 * back to the restricted-content screen. `query()` marks these as handled when a preloader resolves
 * with its query result, but a task that *rejects* with a permission error (or resolves with the
 * error itself) never passes through that path, so the handled mark alone does not keep restricted
 * pages out of the SSR prepare errors.
 *
 * Covers both status codes of the permission contract — 401 (unauthenticated) and 403 (not
 * permitted) — plus the legacy `extensions.data.authorized === false` shape, matching
 * `@confluence/unauthorized-error-boundary`. `isStatusCodeError` walks `graphQLErrors`,
 * `networkError` and `originalError`, so a rejected ApolloError wrapping a 403 is recognised too.
 * `@confluence/error-types` is used rather than the boundary's copy of this predicate to keep React
 * out of the preloader bundle.
 *
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */ function $6e8f7926b945fe5e$var$isPermissionError(error) {
    const candidate = error;
    return (0, $aMcHK.isStatusCodeError)(candidate, '403', $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError) || (0, $aMcHK.isStatusCodeError)(candidate, '401');
}
/**
 * Errors that are an expected outcome of preloading and must not be reported as SSR prepare errors.
 */ function $6e8f7926b945fe5e$var$isExpectedPreloadError(error) {
    return $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) || $6e8f7926b945fe5e$var$isPermissionError(error);
}
function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
/**
 * `query()` and `queryAgg()` resolve to `{ data, errors, hasErrors }` rather than rejecting or
 * resolving to an `Error`, so a preloader that returns its result object straight into the task
 * list would otherwise slip past the `instanceof Error` checks below.
 */ function $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) {
    return typeof value === 'object' && value !== null && value.hasErrors === true && Array.isArray(value.errors);
}
/**
 * Only surfaces errors nobody has claimed. `query()` marks the expected ones (unauthorized,
 * not-found, and other known shapes) as handled before resolving, and those still come back with
 * `hasErrors: true` — reporting them here would turn every restricted or missing page into a bogus
 * SSR prepare error, since preloaders like `preloadPageStatusQuery` return their result object
 * straight into the task list.
 *
 * Filtering happens here, before the conversion below, because `new Error(message)` drops
 * `extensions` — the only place the permission status code lives on a plain GraphQL error object.
 */ function $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(result) {
    const unhandledErrors = [];
    for (const error of result.errors ?? []){
        if ($6e8f7926b945fe5e$var$isExpectedPreloadError(error)) continue;
        unhandledErrors.push(error instanceof Error ? error : new Error(String(error?.message ?? error)));
    }
    return unhandledErrors;
}
function $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(fulfilledValue) {
    if (fulfilledValue instanceof Error) return $6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue);
    if (Array.isArray(fulfilledValue)) return fulfilledValue.flatMap((value)=>value instanceof Error || $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) ? $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(value) : []);
    if ($6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(fulfilledValue)) return $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(fulfilledValue);
    return [];
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') errors.push(...$6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(result.value));
        }
        // Drop the expected outcomes — already-handled and permission errors — so a restricted page
        // does not report a prepare error. Rejections and error values are filtered here rather than
        // at each collection site so that every path is held to the same rule; query results are
        // filtered earlier, while their `extensions` are still intact.
        const reportableErrors = errors.filter((error)=>!$6e8f7926b945fe5e$var$isExpectedPreloadError(error));
        if (reportableErrors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of reportableErrors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return reportableErrors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("5AFnD", function(module, exports) {
const $00e2d16f0c5935d6$export$477408ab8b02b670 = 'twcg-2202-loom-nudge:remindMe';
const $00e2d16f0c5935d6$export$c98b33a7293cedf4 = 'twcg-2202-loom-nudge:lastShownAt';
module.exports["LOOM_NUDGE_REMIND_ME"] = $00e2d16f0c5935d6$export$477408ab8b02b670;
module.exports["LOOM_NUDGE_LAST_SHOWN_AT"] = $00e2d16f0c5935d6$export$c98b33a7293cedf4;

});

parcelRegister("bg9GW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8328b4ddc95230a8$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $8328b4ddc95230a8$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInHour);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("g93kp", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc101184c63d7a7a$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $bc101184c63d7a7a$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $3yGK6.default)(2, arguments);
    return (0, $dkBOe.default)(dateLeft).getTime() - (0, $dkBOe.default)(dateRight).getTime();
}

});

parcelRegister("byLBW", function(module, exports) {
var $86a7cd36e9b99950$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $86a7cd36e9b99950$var$defaultRoundingMethod = 'trunc';
function $86a7cd36e9b99950$export$b6474a47258c1211(method) {
    return method ? $86a7cd36e9b99950$var$roundingMap[method] : $86a7cd36e9b99950$var$roundingMap[$86a7cd36e9b99950$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $86a7cd36e9b99950$export$b6474a47258c1211;

});

parcelRegister("4YBSq", function(module, exports) {
/**
 * @generated SignedSource<<9700b2b14bf1783e20ed515703a9c457>>
 * @relayHash f85bb73042ebe75e2cb50dec93f9b7c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139
const $16e983e3bee16ecd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedded"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collabService"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f85bb73042ebe75e2cb50dec93f9b7c4",
            "id": "ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139",
            "metadata": {},
            "name": "EditContentButtonQuery",
            "operationKind": "query",
            "text": "query EditContentButtonQuery($contentId:ID!){content(id:$contentId){nodes{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}}}"
        }
    };
}();
$16e983e3bee16ecd$var$node.hash = "94b096c536d2633f3df010c4409c1c2a";
var $16e983e3bee16ecd$export$2e2bcd8739ae039 = $16e983e3bee16ecd$var$node;
module.exports["default"] = $16e983e3bee16ecd$export$2e2bcd8739ae039;

});

parcelRegister("568fA", function(module, exports) {
/**
 * @generated SignedSource<<edb2a48d5268bebed303963270db4c3a>>
 * @relayHash b647ff34a22d9e67b3330f440f310bb5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e540b0c89e30ec6f141235a6f4e47d93b9ce22a39faec34b35e59dfd7657f73
const $0dc90704ec36fa39$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current",
                "draft"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "kind": "ScalarField",
        "name": "status"
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v12 = {
        "kind": "ScalarField",
        "name": "number"
    }, v13 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "when"
    }, v16 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ], v17 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": v16 /*: any*/ 
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": v16 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b647ff34a22d9e67b3330f440f310bb5",
            "id": "8e540b0c89e30ec6f141235a6f4e47d93b9ce22a39faec34b35e59dfd7657f73",
            "metadata": {},
            "name": "ContentTypesHeaderQuery",
            "operationKind": "query",
            "text": "query ContentTypesHeaderQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}}}"
        }
    };
}();
$0dc90704ec36fa39$var$node.hash = "1e8693f245d726bc820bbd0bffbc0cff";
var $0dc90704ec36fa39$export$2e2bcd8739ae039 = $0dc90704ec36fa39$var$node;
module.exports["default"] = $0dc90704ec36fa39$export$2e2bcd8739ae039;

});

parcelRegister("fyUox", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $1Y111 = parcelRequire("1Y111");


var $zalpJ = parcelRequire("zalpJ");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (0, $dYU3e.query)({
        query: (0, $zalpJ.PreloadHomepageIdQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "content-topper"
    });
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $1Y111.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "content-topper"
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("6IsMq", function(module, exports) {
/**
 * @generated SignedSource<<d76d95039bbf9cae17d368276aebc792>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b
const $684f397ef7ad0ae2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": 65536,
            "kind": "LocalArgument",
            "name": "maxTokenLength"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
            "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
            "metadata": {},
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
        }
    };
}();
$684f397ef7ad0ae2$var$node.hash = "7036cf95096a08504e6375127746a507";
var $684f397ef7ad0ae2$export$2e2bcd8739ae039 = $684f397ef7ad0ae2$var$node;
module.exports["default"] = $684f397ef7ad0ae2$export$2e2bcd8739ae039;

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<5e736080ce8c5ab015a5851e0537f7fa>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("3j8TZ", function(module, exports) {
/**
 * @generated SignedSource<<bcf6371051972dda4e73703ef8d6345b>>
 * @relayHash 44fbfb9d6df590a6ee4e002cd5037220
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01
const $bcd0dbc3bf494067$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "size"
    }, v7 = {
        "kind": "ScalarField",
        "name": "mimeType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "processingStatus"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v10 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "cloudId",
                                                            "variableName": "cloudId"
                                                        }
                                                    ],
                                                    "concreteType": "MediaItem",
                                                    "kind": "LinkedField",
                                                    "name": "mediaItems",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        },
                                                        {
                                                            "concreteType": "MediaFileDetails",
                                                            "kind": "LinkedField",
                                                            "name": "details",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaType"
                                                                },
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "failReason"
                                                                },
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MediaFilePreview",
                                                                    "kind": "LinkedField",
                                                                    "name": "preview",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "cdnUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileArtifact",
                                                                    "kind": "LinkedField",
                                                                    "name": "artifactsList",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileRepresentations",
                                                                    "kind": "LinkedField",
                                                                    "name": "representations",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "MediaImageRepresentation",
                                                                            "kind": "LinkedField",
                                                                            "name": "image",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "_empty"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "mediaMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "duration"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileAbuseClassification",
                                                                    "kind": "LinkedField",
                                                                    "name": "abuseClassification",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "classification"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "confidence"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "cacheID": "44fbfb9d6df590a6ee4e002cd5037220",
            "id": "3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenWithMediaItemsQuery($cloudId:ID!,$contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token},mediaItems(cloudId:$cloudId){id,type,details{name,size,mimeType,mediaType,processingStatus,failReason,createdAt,preview{cdnUrl},artifactsList{createdAt,mimeType,name,processingStatus,size,url},representations{image{_empty}},mediaMetadata{duration},abuseClassification{classification,confidence}}}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$bcd0dbc3bf494067$var$node.hash = "c03e617139295e9107b3907ee1a06cb3";
var $bcd0dbc3bf494067$export$2e2bcd8739ae039 = $bcd0dbc3bf494067$var$node;
module.exports["default"] = $bcd0dbc3bf494067$export$2e2bcd8739ae039;

});

parcelRegister("k5dl6", function(module, exports) {
/**
 * @generated SignedSource<<6dc466aba14c78f3432cf6d35f092a95>>
 * @relayHash 9f9cb3b101c0d783a0151d795ee8a444
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06
const $bff977656480fdfe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "contentId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    },
                    v2 /*: any*/ 
                ]
            }
        ]
    }, v4 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v11 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "when"
    }, v14 = {
        "kind": "ScalarField",
        "name": "number"
    }, v15 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v20 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v21 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v24 /*: any*/ ,
            v16 /*: any*/ ,
            v25 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v24 /*: any*/ ,
                                v16 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9f9cb3b101c0d783a0151d795ee8a444",
            "id": "97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06",
            "metadata": {},
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentsFocusedInlineCommentQuery($commentId:ID!,$contentId:ID){content(id:$contentId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(commentId:$commentId,depth:ALL,type:UNRESOLVED){nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$bff977656480fdfe$var$node.hash = "c6bc55705b1b90c4e9cb60ee0b5a4650";
var $bff977656480fdfe$export$2e2bcd8739ae039 = $bff977656480fdfe$var$node;
module.exports["default"] = $bff977656480fdfe$export$2e2bcd8739ae039;

});

parcelRegister("5DJsZ", function(module, exports) {
/**
 * @generated SignedSource<<8b96b7ca504d956e62c9a3c7888eb72c>>
 * @relayHash 736318216100158fedfd1efdb0277723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6
const $4dc353069380bea7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPublishedFragment"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "condition": "skipPublishedFragment",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                }
                            ]
                        },
                        {
                            "alias": "emojiTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v5 /*: any*/ ,
                            "storageKey": "properties(key:\"emoji-title-draft\")"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "defaultTitleEmoji"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "736318216100158fedfd1efdb0277723",
            "id": "ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6",
            "metadata": {},
            "name": "EmojiTitleQuery",
            "operationKind": "query",
            "text": "query EmojiTitleQuery($contentId:ID,$status:[String],$draftShareId:String,$skipPublishedFragment:Boolean!){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,emojiTitlePublished:properties(key:\"emoji-title-published\")@skip(if:$skipPublishedFragment){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}}}"
        }
    };
}();
$4dc353069380bea7$var$node.hash = "c3af19fccb4a5096e4bb34c9aa198098";
var $4dc353069380bea7$export$2e2bcd8739ae039 = $4dc353069380bea7$var$node;
module.exports["default"] = $4dc353069380bea7$export$2e2bcd8739ae039;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9o4Fw = parcelRequire("9o4Fw");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $9o4Fw.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "content-appearance"
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("kae7O", function(module, exports) {
/**
 * @generated SignedSource<<235e2f4f1cae802c5b7683463fdf34f9>>
 * @relayHash 177df4e8b836b390b9636d650c93a7b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612
const $99e3ac9ccccf9f94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "177df4e8b836b390b9636d650c93a7b2",
            "id": "73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612",
            "metadata": {},
            "name": "useTitleContentPropertiesForEditorQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForEditorQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$99e3ac9ccccf9f94$var$node.hash = "cdd7743e3348e4dc97a35c6808323ae0";
var $99e3ac9ccccf9f94$export$2e2bcd8739ae039 = $99e3ac9ccccf9f94$var$node;
module.exports["default"] = $99e3ac9ccccf9f94$export$2e2bcd8739ae039;

});

parcelRegister("jGizm", function(module, exports) {

var $2zscg = parcelRequire("2zscg");

const $04d4b8463fee3aa7$var$extensionCache = new WeakMap();
const $04d4b8463fee3aa7$var$isStringArray = (value)=>Array.isArray(value) && value.every((item)=>typeof item === 'string');
const $04d4b8463fee3aa7$var$normalizeProperties = (properties)=>{
    const normalizedProperties = properties.reduce((acc, property)=>{
        if (!property.value || !property.key) return acc;
        try {
            const jsonValue = JSON.parse(property.value);
            acc[property.key] = jsonValue;
        } catch (_error) {
            acc[property.key] = property.value;
        }
        return acc;
    }, {});
    if ('migratedFrom' in normalizedProperties && !$04d4b8463fee3aa7$var$isStringArray(normalizedProperties.migratedFrom)) {
        const { migratedFrom: _migratedFrom, ...propertiesWithoutInvalidMigratedFrom } = normalizedProperties;
        return propertiesWithoutInvalidMigratedFrom;
    }
    return normalizedProperties;
};
const $04d4b8463fee3aa7$export$9ff84ea1b2ab439c = (extensions)=>{
    if (!extensions || extensions.length === 0) return [];
    if ($04d4b8463fee3aa7$var$extensionCache.has(extensions)) return $04d4b8463fee3aa7$var$extensionCache.get(extensions);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2zscg.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2zscg.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2zscg.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2zscg.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: $04d4b8463fee3aa7$var$normalizeProperties(extension.properties),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $04d4b8463fee3aa7$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                sandboxPolicies: extension.sandboxPolicies ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) $04d4b8463fee3aa7$var$extensionCache.set(extensions, result);
    return result;
};
const $04d4b8463fee3aa7$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $04d4b8463fee3aa7$export$9ff84ea1b2ab439c;

});

parcelRegister("2zscg", function(module, exports) {
var $a413c718e4c7bf40$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $a413c718e4c7bf40$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $a413c718e4c7bf40$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
const $a413c718e4c7bf40$export$586232a3e4271798 = {
    CUSTOM_MERGE_CHECK: 'bitbucket:mergeCheck',
    DYNAMIC_PIPELINES_PROVIDER: 'bitbucket:dynamicPipelinesProvider',
    REPOSITORY_CODE_FILE_VIEWER: 'bitbucket:repoCodeFileViewer',
    REPOSITORY_CODE_OVERVIEW_CARD: 'bitbucket:repoCodeOverviewCard',
    REPOSITORY_CODE_OVERVIEW_ACTION: 'bitbucket:repoCodeOverviewAction',
    REPOSITORY_CODE_OVERVIEW_PANEL: 'bitbucket:repoCodeOverviewPanel',
    REPOSITORY_PULL_REQUEST_CARD: 'bitbucket:repoPullRequestCard',
    REPOSITORY_PULL_REQUEST_ACTION: 'bitbucket:repoPullRequestAction',
    REPOSITORY_PULL_REQUEST_OVERVIEW_PANEL: 'bitbucket:repoPullRequestOverviewPanel',
    REPOSITORY_MAIN_MENU_PAGE: 'bitbucket:repoMainMenuPage',
    REPOSITORY_SETTINGS_MENU_PAGE: 'bitbucket:repoSettingsMenuPage',
    PROJECT_SETTINGS_MENU_PAGE: 'bitbucket:projectSettingsMenuPage',
    WORKSPACE_GLOBAL_PAGE: 'bitbucket:workspaceGlobalPage',
    WORKSPACE_PERSONAL_SETTINGS_PAGE: 'bitbucket:workspacePersonalSettingsPage',
    WORKSPACE_SETTINGS_MENU_PAGE: 'bitbucket:workspaceSettingsMenuPage'
};
const $a413c718e4c7bf40$export$ffcb70f38ee10c0a = {
    FULL_PAGE: 'global:fullPage'
};
module.exports["ExtensionEnvironment"] = $a413c718e4c7bf40$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $a413c718e4c7bf40$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $a413c718e4c7bf40$export$f06ffa3aa6bfec95;
module.exports["BitbucketExtension"] = $a413c718e4c7bf40$export$586232a3e4271798;
module.exports["GlobalExtension"] = $a413c718e4c7bf40$export$ffcb70f38ee10c0a;

});

parcelRegister("nIvaQ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $fXb84 = parcelRequire("fXb84");


var $7ZQNA = parcelRequire("7ZQNA");

const $c4f625141049567c$export$1248f2ac56981fbd = ()=>(0, $6mKj3.expValEquals)('platform_editor_early_exit_return_draft', 'isEnabled', true) ? (0, $fXb84.CollabDraftWithRelevanceQuery) : (0, $7ZQNA.CollabDraftQuery);
module.exports["getCollabDraftQuery"] = $c4f625141049567c$export$1248f2ac56981fbd;

});

parcelRegister("fXb84", function(module, exports) {

var $kiLxw = parcelRequire("kiLxw");

const $abbff5e8c5475947$export$fb92c84fb9714700 = (0, $kiLxw.default);
module.exports["CollabDraftWithRelevanceQuery"] = $abbff5e8c5475947$export$fb92c84fb9714700;

});

parcelRegister("kiLxw", function(module, exports) {
/**
 * @generated SignedSource<<c2d68d945c3fe4452d03d6bdc8ddfd5c>>
 * @relayHash 5eb9ba691ed48d80122a8d87074eee9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1
const $ff1e82bf0b897703$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relevance"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5eb9ba691ed48d80122a8d87074eee9c",
            "id": "19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1",
            "metadata": {},
            "name": "CollabDraftWithRelevanceQuery",
            "operationKind": "query",
            "text": "query CollabDraftWithRelevanceQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title,relevance}}}"
        }
    };
}();
$ff1e82bf0b897703$var$node.hash = "c0bfcca7b64103265224238d7c18d9b1";
var $ff1e82bf0b897703$export$2e2bcd8739ae039 = $ff1e82bf0b897703$var$node;
module.exports["default"] = $ff1e82bf0b897703$export$2e2bcd8739ae039;

});

parcelRegister("7ZQNA", function(module, exports) {

var $lU81J = parcelRequire("lU81J");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $lU81J.default);
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("lU81J", function(module, exports) {
/**
 * @generated SignedSource<<81d932c04171cccd3ee1c517fa2180ce>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a
const $e1affc2f9f206abd$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
            "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
            "metadata": {},
            "name": "CollabDraftQuery",
            "operationKind": "query",
            "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
        }
    };
}();
$e1affc2f9f206abd$var$node.hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";
var $e1affc2f9f206abd$export$2e2bcd8739ae039 = $e1affc2f9f206abd$var$node;
module.exports["default"] = $e1affc2f9f206abd$export$2e2bcd8739ae039;

});

parcelRegister("hNtOj", function(module, exports) {

var $etu7G = parcelRequire("etu7G");

const $120c25b1424bdefe$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();
module.exports["ssrPermissionsErrorHandler"] = $120c25b1424bdefe$export$c82fe4eede9104df;

});

parcelRegister("etu7G", function(module, exports) {
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}
module.exports["SSRPermissionsErrorHandler"] = $c6d83b8df27b1c26$export$e70f491dc46ba2ed;

});

parcelRegister("6GQtz", function(module, exports) {

var $6RwwD = parcelRequire("6RwwD");


var $6mKj3 = parcelRequire("6mKj3");

const $1f40ba7d8e61cd02$var$isTrelloBoardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/b/);
const $1f40ba7d8e61cd02$var$isFigmaFileUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?figma\.com\/(design|board|file|proto|slides)/);
const $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl = (url)=>!!url.match(/^https:\/\/.+\.figma\.site/);
const $1f40ba7d8e61cd02$var$isMiroUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?miro\.com\/app\/board/);
const $1f40ba7d8e61cd02$var$isCanvaUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?canva\.com\/design/);
const $1f40ba7d8e61cd02$var$isLucidUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?lucid\.app\/lucidchart/);
const $1f40ba7d8e61cd02$var$isGoogleSlidesUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/presentation/);
const $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl = (url)=>!!url.match(/^https:\/\/onedrive\.live\.com\/:p/) || !!url.match(/^https:\/\/1drv\.ms\/p/);
const $1f40ba7d8e61cd02$var$isTrelloCardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/c/);
const $1f40ba7d8e61cd02$var$isPowerBIUrl = (url)=>!!url.match(/^https:\/\/app\.powerbi\.com\/(groups|reportEmbed)/);
const $1f40ba7d8e61cd02$var$isGoogleDocsUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/document/);
// https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online
const $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl = (url)=>!!url.match(/^https:\/\/learn\.microsoft\.com/);
// https://support.google.com/mail/answer/112508?hl=en&co=GENIE.Platform%3DDesktop
const $1f40ba7d8e61cd02$var$isSupportGoogleUrl = (url)=>!!url.match(/^https:\/\/support\.google\.com/);
// https://docs.github.com/en/codespaces
const $1f40ba7d8e61cd02$var$isDocsGithubUrl = (url)=>!!url.match(/^https:\/\/docs\.github\.com/);
const $1f40ba7d8e61cd02$var$isDropboxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?dropbox\.com\/(home|preview|s|sh|sc|t|scl)/);
const $1f40ba7d8e61cd02$var$isBoxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?box\.com\/(folder|file|notes|integrations|services|s|v)/);
const $1f40ba7d8e61cd02$var$isSlackUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?slack\.com\/(archives|client)/);
const $1f40ba7d8e61cd02$var$isTeamsUrl = (url)=>!!url.match(/^https:\/\/teams\.microsoft\.com\/l\/channel/) || !!url.match(/^https:\/\/teams\.cloud\.microsoft\/l\/channel/);
const $1f40ba7d8e61cd02$var$isLovableAppUrl = (url)=>!!url.match(/^https:\/\/.+\.lovable\.app/);
const $1f40ba7d8e61cd02$var$isReplitAppUrl = (url)=>!!url.match(/^https:\/\/.+\.replit\.app/);
class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $6RwwD.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if (this.shouldDisplayAsEmbed(url)) return 'embed';
        if (this.shouldDisplayAsCard(url)) return 'block';
        return super.getHardCodedAppearance(url);
    }
    /**
   * Opt in to honouring an explicitly-requested embed appearance as the default
   * (validated, with a card fallback) for the quick-insert embed flow. Both active
   * cohorts of the quick-insert embeds experiment (`prioritizeLinkInQIM` and
   * `prioritizeEmbedInQIM`) enable this — they differ only in quick-insert menu
   * ordering, not in embedding behaviour. Only `control` and unenrolled users keep
   * the existing behaviour.
   *
   * The platform only calls this when a link is inserted with a requested embed
   * appearance and the user has no saved preference, so the exposure here is
   * scoped to the quick-insert embed insertion path.
   */ shouldHonorRequestedEmbedAsDefault() {
        return (0, $6mKj3.expVal)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control';
    }
    shouldDisplayAsEmbed(url) {
        return $1f40ba7d8e61cd02$var$isTrelloBoardUrl(url) || $1f40ba7d8e61cd02$var$isFigmaFileUrl(url) || $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl(url) || $1f40ba7d8e61cd02$var$isMiroUrl(url) || $1f40ba7d8e61cd02$var$isCanvaUrl(url) || $1f40ba7d8e61cd02$var$isLucidUrl(url) || $1f40ba7d8e61cd02$var$isGoogleSlidesUrl(url) || $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl(url);
    }
    shouldDisplayAsCard(url) {
        return $1f40ba7d8e61cd02$var$isTrelloCardUrl(url) || $1f40ba7d8e61cd02$var$isPowerBIUrl(url) || $1f40ba7d8e61cd02$var$isGoogleDocsUrl(url) || $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl(url) || $1f40ba7d8e61cd02$var$isSupportGoogleUrl(url) || $1f40ba7d8e61cd02$var$isDocsGithubUrl(url) || $1f40ba7d8e61cd02$var$isDropboxUrl(url) || $1f40ba7d8e61cd02$var$isBoxUrl(url) || $1f40ba7d8e61cd02$var$isSlackUrl(url) || $1f40ba7d8e61cd02$var$isTeamsUrl(url) || $1f40ba7d8e61cd02$var$isLovableAppUrl(url) || $1f40ba7d8e61cd02$var$isReplitAppUrl(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient, supportedUrlFilter, name){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient, supportedUrlFilter);
        this.name = void 0;
        this.name = name ?? 'editorCardProvider';
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("6RwwD", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $8OcYi = parcelRequire("8OcYi");


var $3ewaO = parcelRequire("3ewaO");


var $drRzc = parcelRequire("drRzc");


var $ieeJu = parcelRequire("ieeJu");


var $kzwaO = parcelRequire("kzwaO");

var $cXJjm = parcelRequire("cXJjm");

var $ggGdk = parcelRequire("ggGdk");


var $6Q8Dd = parcelRequire("6Q8Dd");


var $koAyx = parcelRequire("koAyx");


var $8kONW = parcelRequire("8kONW");


var $4yccB = parcelRequire("4yccB");


var $iDrrr = parcelRequire("iDrrr");


var $biKbJ = parcelRequire("biKbJ");


var $iyuxZ = parcelRequire("iyuxZ");

const $d4521f0694a3bb0e$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/;
const $d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX = /^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/;
const $d4521f0694a3bb0e$var$JWM_VIEW_REGEX = /^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/;
const $d4521f0694a3bb0e$var$JIRA_LIST_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/;
const $d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX = /^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//;
const $d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX = /^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/;
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?");
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?");
const $d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX = /\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/;
const $d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX = /^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/;
// prettier-ignore
const $d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
// prettier-ignore
const $d4521f0694a3bb0e$var$LOOM_PLAYLIST_URL_REGEX = /^https:\/\/(.*?\.)?loom\..*?\/(?:playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\/view)?|embed\/playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\?|$)/i;
const $d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?loom\\..*?\\/i\\/(?<id>[a-f0-9]{32})");
const $d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX = /^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/;
const $d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/;
const $d4521f0694a3bb0e$var$JIRA_BOARD_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_PLAN_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)");
// prettier-ignore
const $d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?");
const $d4521f0694a3bb0e$var$JIRA_VERSION_REGEX = /https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/;
const $d4521f0694a3bb0e$var$JIRA_FORM_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/;
const $d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX = /^https:\/\/.*?\/people\/agent\/.+$/;
const $d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX = /^https:\/\/customer\.atlassian\.com\/.*$/;
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX = RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)");
const $d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX = /^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/;
const $d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX = /^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/;
const $d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX = /\/browse\/((?:\w+)-(?:\d+))/i;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX = /^[a-zA-Z0-9]/;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX = /[a-zA-Z0-9]$/;
const $d4521f0694a3bb0e$var$CONFLUENCE_SHORT_LINK_URL_REGEX = /^https:\/\/[^/?#]+\/wiki\/x\/[A-Za-z0-9_-]+\/?(?:[?#].*)?$/;
const $d4521f0694a3bb0e$var$isConfluenceShortLinkUrl = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_SHORT_LINK_URL_REGEX);
const $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX);
const $d4521f0694a3bb0e$var$isPolarisView = (url)=>url.match($d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJwmView = (url)=>url.match($d4521f0694a3bb0e$var$JWM_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJiraList = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_LIST_REGEX);
const $d4521f0694a3bb0e$var$isGiphyMedia = (url)=>url.match($d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX);
const $d4521f0694a3bb0e$var$isProformaView = (url)=>url.match($d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceWhiteboard = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX) || url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceDatabase = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX);
const $d4521f0694a3bb0e$var$isYoutubeVideo = (url)=>url.match($d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX);
const $d4521f0694a3bb0e$var$isLoomVideoUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomPlaylistUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_PLAYLIST_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomScreenshotUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraDashboard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBacklog = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBoard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraPlan = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_PLAN_REGEX) || url.match($d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraVersion = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_VERSION_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraForm = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_FORM_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraSummary = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX);
};
const $d4521f0694a3bb0e$var$isRovoAgentProfilePage = (url)=>{
    return url.match($d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX);
};
const $d4521f0694a3bb0e$var$isCustomer360LandingPage = (url)=>url.match($d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceTeamCalendars = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX);
const $d4521f0694a3bb0e$var$isJiraIssueNavigator = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX);
const $d4521f0694a3bb0e$var$isAvpVisualizationView = (url)=>url.match($d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX);
const $d4521f0694a3bb0e$export$6a9668b99d8a1708 = (url)=>$d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX.test(url);
// Local UrlChecker-compatible wrapper around the boolean-returning
// `isConfluenceSlideUrl` from `./url-checkers` (the single source of truth for
// slide URL matching). Wrapping (rather than aliasing the imported identifier
// directly inside the exported `internalUrlCheckers` object) avoids the
// @atlaskit/editor/no-re-export lint rule and gives the registry a uniform
// `(url) => RegExpMatchArray | null` signature. Consumers of
// `internalUrlCheckers` only check the truthiness of the result, so returning
// a synthetic single-element match array (or `null`) preserves behaviour.
const $d4521f0694a3bb0e$var$isConfluenceSlide = (url)=>(0, $8kONW.isConfluenceSlideUrl)(url) ? [
        url
    ] : null;
const $d4521f0694a3bb0e$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline,
    isPolarisView: $d4521f0694a3bb0e$var$isPolarisView,
    isJwmView: $d4521f0694a3bb0e$var$isJwmView,
    isJiraList: $d4521f0694a3bb0e$var$isJiraList,
    isConfluenceWhiteboard: $d4521f0694a3bb0e$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $d4521f0694a3bb0e$var$isConfluenceDatabase,
    isConfluenceSlide: $d4521f0694a3bb0e$var$isConfluenceSlide,
    isJiraDashboard: $d4521f0694a3bb0e$var$isJiraDashboard,
    isJiraBacklog: $d4521f0694a3bb0e$var$isJiraBacklog,
    isJiraBoard: $d4521f0694a3bb0e$var$isJiraBoard,
    isJiraPlan: $d4521f0694a3bb0e$var$isJiraPlan,
    isJiraVersion: $d4521f0694a3bb0e$var$isJiraVersion,
    isJiraForm: $d4521f0694a3bb0e$var$isJiraForm,
    isJiraSummary: $d4521f0694a3bb0e$var$isJiraSummary,
    isRovoAgentProfilePage: $d4521f0694a3bb0e$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $d4521f0694a3bb0e$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $d4521f0694a3bb0e$var$isJiraIssueNavigator
};
function $d4521f0694a3bb0e$export$4006295459a20a0(url) {
    return Object.values($d4521f0694a3bb0e$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $d4521f0694a3bb0e$export$78234eee43b97e81(url) {
    return !$d4521f0694a3bb0e$export$4006295459a20a0(url);
}
function $d4521f0694a3bb0e$var$getAppearanceForNode(node) {
    return node.type === 'blockCard' ? 'block' : node.type === 'embedCard' ? 'embed' : 'inline';
}
function $d4521f0694a3bb0e$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $d4521f0694a3bb0e$export$e4635c0135e1a519 extends (0, $drRzc.NodeDataProvider) {
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        if ((0, $ieeJu.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) === false) // if local cache feature flag is disabled, fall back to the base implementation
        return super.getData(node, callback);
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
        const isResolvedCachedResponse = details && details.meta && (0, $ggGdk.getStatus)(details) === 'resolved';
        if (isResolvedCachedResponse) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the session storage cache
        if (isResolvedCachedResponse && this.getCacheStatusForNode(jsonNode) === 'network') return;
        // fetch the latest data async and update the session storage cache
        this.getDataAsync(node, (payload)=>{
            const response = payload.data;
            if (!payload.error && response?.meta) {
                const status = (0, $ggGdk.getStatus)(response);
                if (status === 'resolved') this.smartCardLocalCacheClient.setItem(key, response);
            }
            callback(payload);
        });
    }
    nodeDataKey(node) {
        if (!(0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return node.attrs.url;
        return `${node.attrs.url}|${$d4521f0694a3bb0e$var$getAppearanceForNode(node)}`;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            const appearance = (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? $d4521f0694a3bb0e$var$getAppearanceForNode(node) : undefined;
            return this.cardClient.fetchData(url, false, appearance);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$d4521f0694a3bb0e$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $biKbJ.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX.test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX.test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $d4521f0694a3bb0e$var$isJiraPlan(url);
        const isJiraFormEvaluated = $d4521f0694a3bb0e$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $d4521f0694a3bb0e$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $iDrrr.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $d4521f0694a3bb0e$var$isConfluenceTeamCalendars(url);
        if ($d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline(url) || $d4521f0694a3bb0e$var$isPolarisView(url) || $d4521f0694a3bb0e$var$isJwmView(url) || $d4521f0694a3bb0e$var$isJiraList(url) || $d4521f0694a3bb0e$var$isGiphyMedia(url) || $d4521f0694a3bb0e$var$isProformaView(url) || $d4521f0694a3bb0e$var$isConfluenceWhiteboard(url) || $d4521f0694a3bb0e$var$isConfluenceDatabase(url) || (0, $8kONW.isConfluenceSlideUrl)(url) || $d4521f0694a3bb0e$var$isYoutubeVideo(url) || $d4521f0694a3bb0e$var$isLoomVideoUrl(url) || $d4521f0694a3bb0e$var$isLoomPlaylistUrl(url) && (0, $iDrrr.fg)('loom-playlist-smartlink-embed-default') || $d4521f0694a3bb0e$var$isLoomScreenshotUrl(url) && (0, $iDrrr.fg)('loom-support-screenshot-sl-resolution') || $d4521f0694a3bb0e$var$isJiraDashboard(url) || $d4521f0694a3bb0e$var$isJiraBacklog(url) || $d4521f0694a3bb0e$var$isJiraBoard(url) || $d4521f0694a3bb0e$var$isRovoAgentProfilePage(url) || $d4521f0694a3bb0e$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $d4521f0694a3bb0e$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $d4521f0694a3bb0e$var$isJiraIssueNavigator(url) || $d4521f0694a3bb0e$var$isAvpVisualizationView(url) && (0, $iDrrr.fg)('avp_unfurl_shared_charts_embed_by_default_2')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    async resolvesToHardCodedEmbed(url) {
        try {
            const response = await this.fetchData(url);
            const resolvedUrl = (0, $3ewaO.extractSmartLinkUrl)(response);
            return resolvedUrl !== undefined && this.getHardCodedAppearance(resolvedUrl) === 'embed';
        } catch  {
            return false;
        }
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $ggGdk.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $8OcYi.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    /**
   * Opt-in hook: when a caller explicitly requests an `'embed'` appearance and the
   * user has no saved preference for the URL, honour that request as the default
   * (above any provider default), validating embeddability first and falling back
   * to a card (`'block'`) when the link cannot be embedded.
   *
   * Defaults to `false` so behaviour is unchanged for every existing consumer.
   * Subclasses (e.g. Confluence) can override this to opt in, typically behind an
   * experiment.
   */ shouldHonorRequestedEmbedAsDefault() {
        return false;
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $iDrrr.fg)('issue-link-suggestions-in-comments')) {
                if ($d4521f0694a3bb0e$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                const isNativeEmbedShortlinkResolutionEnabled = (0, $iDrrr.fg)('platform_native_embeds_enable_shortlink_resolution');
                const shouldResolveShortLinkForEmbed = isNativeEmbedShortlinkResolutionEnabled && matchedProviderPattern !== undefined && $d4521f0694a3bb0e$var$isConfluenceShortLinkUrl(url) && userPreference === undefined && isEmbedFriendlyLocationEvaluated;
                // Confluence shortlinks do not identify their content type. Resolve the URL before
                // deciding whether it should use one of the existing hardcoded embed appearances.
                if (shouldResolveShortLinkForEmbed && await this.resolvesToHardCodedEmbed(url)) preferredAppearance = 'embed';
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                // When a caller explicitly requested an embed (e.g. Confluence's quick-insert
                // embed flow tags the inserted link) and the user has no saved preference for
                // this URL, honour embed-by-default above the provider default — but only in an
                // embed-friendly location (matching how hard-coded embeds are gated above) and
                // only when the link can actually be embedded, otherwise fall back to a card.
                // Gated behind a default-off opt-in hook so other consumers are unaffected.
                if (!userPreference && appearance === 'embed' && isEmbedFriendlyLocationEvaluated && this.shouldHonorRequestedEmbedAsDefault()) {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    preferredAppearance = canItBeEmbed ? 'embed' : 'block';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') return this.transformer.toSmartlinkAdf(url, 'block');
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.smartCardLocalCacheClient = (0, $iyuxZ.SmartCardLocalCacheClient).getInstance();
        this.onResolve = void 0;
        this.supportedUrlFilter = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $koAyx.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $d4521f0694a3bb0e$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $4yccB.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $d4521f0694a3bb0e$export$b7c3c9a99f7959f5 = new $d4521f0694a3bb0e$export$e4635c0135e1a519();
module.exports["isInternalUrl"] = $d4521f0694a3bb0e$export$4006295459a20a0;
module.exports["isExternalUrl"] = $d4521f0694a3bb0e$export$78234eee43b97e81;
module.exports["EditorCardProvider"] = $d4521f0694a3bb0e$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $d4521f0694a3bb0e$export$b7c3c9a99f7959f5;

});

parcelRegister("3ewaO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $jMcHR = parcelRequire("jMcHR");


var $kAdyG = parcelRequire("kAdyG");

const $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.url;
    return (0, $jMcHR.extractLink)(response?.data);
};
module.exports["extractSmartLinkUrl"] = $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de;

});

parcelRegister("koAyx", function(module, exports) {
class $b7cac00c977cfcad$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b7cac00c977cfcad$export$f993aef960936087;

});

parcelRegister("8kONW", function(module, exports) {
/**
 * URL checker utilities for Confluence content types.
 *
 * Exported via the `@atlaskit/editor-card-provider/url-checkers` subpath
 * so consumers don't have to depend on the barrel file.
 */ /**
 * Matches Confluence Slides URLs.
 *
 * Examples:
 *   - /wiki/spaces/TEAM/slide/12345
 *   - /wiki/spaces/~uid/slide/8fb8c642-803d-59fe-8d1c-066610e860c6
 */ // eslint-disable-next-line require-unicode-regexp -- consistent with isConfluenceDatabase in provider.ts
const $025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN = /\/wiki\/spaces\/~?[\d\w]+\/slide\/[\d\w-]+(\?.*)?$/;
const $025d94307c54f6b4$export$4091d55e0211d2e1 = (url)=>$025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN.test(url);
module.exports["isConfluenceSlideUrl"] = $025d94307c54f6b4$export$4091d55e0211d2e1;

});

parcelRegister("biKbJ", function(module, exports) {
const $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $57ceb58159fd0951$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $57ceb58159fd0951$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $57ceb58159fd0951$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $57ceb58159fd0951$export$b5fe3f66a567bec0;

});

parcelRegister("iyuxZ", function(module, exports) {

var $6YrB3 = parcelRequire("6YrB3");

var $842937149a04b8ba$var$_SmartCardLocalCacheClient;
const $842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY = 'smart-card-url-data';
const $842937149a04b8ba$var$SMART_CARD_CACHE_KEY = 'response-cache';
const $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $842937149a04b8ba$export$1987ad1ab31f2528 {
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache and prevents
   * race conditions when multiple instances write to the same storage key.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$842937149a04b8ba$export$1987ad1ab31f2528.instance) $842937149a04b8ba$export$1987ad1ab31f2528.instance = new $842937149a04b8ba$export$1987ad1ab31f2528(maxItems);
        return $842937149a04b8ba$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
    }
    constructor(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.storageClient = new (0, $6YrB3.default)($842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY, {
            storageEngine: 'sessionStorage'
        });
        this.maxItems = void 0;
        this.memoryCache = void 0;
        this.pendingWrite = false;
        /**
     * Retrieves the entire cache object from memory
     * @returns The entire cache object
     */ this.getCache = ()=>{
            return this.memoryCache;
        };
        /**
     * Caches the SmartLinkResponse against the provided url in storage
     * @param url The url (key) to store the response against
     * @param response The SmartLinkResponse to be cached in storage
     */ this.setItem = (url, response)=>{
            // Add or update the item in the cache with current timestamp
            this.memoryCache[url] = {
                data: response,
                timestamp: Date.now()
            };
            // Apply FIFO behavior if cache exceeds maxItems
            const cacheKeys = Object.keys(this.memoryCache);
            if (cacheKeys.length > this.maxItems) {
                // Sort keys by timestamp (oldest first) and remove the oldest items
                const sortedKeys = cacheKeys.sort((a, b)=>this.memoryCache[a].timestamp - this.memoryCache[b].timestamp);
                const itemsToRemove = cacheKeys.length - this.maxItems;
                const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                keysToRemove.forEach((key)=>{
                    delete this.memoryCache[key];
                });
            }
            // Write through to storage asynchronously (non-blocking)
            // Debounced to batch multiple rapid calls into a single write
            if (!this.pendingWrite) {
                this.pendingWrite = true;
                queueMicrotask(()=>{
                    try {
                        this.storageClient.setItemWithExpiry($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, JSON.stringify(this.memoryCache));
                    } catch (_) {
                    // Ignore storage write errors (e.g. quota exceeded) to prevent blocking future writes
                    // Cache will still function in-memory for the session, but won't persist
                    } finally{
                        this.pendingWrite = false;
                    }
                });
            }
        };
        /**
     * Retrieves the cached SmartLinkResponse for the provided url from storage (if it exists)
     * @param url The url (key) to retrieve the cached response for
     * @returns The cached SmartLinkResponse if it exists, else undefined
     */ this.getItem = (url)=>{
            if (!url) return;
            const response = this.memoryCache?.[url]?.data;
            return response;
        };
        /**
     * Checks if a cached entry exists for the provided url in storage
     * @param url The url (key) to check for existence in the cache
     * @returns True if a cached entry exists, else false
     */ this.isUrlInCache = (url)=>{
            return url in this.memoryCache;
        };
        this.maxItems = maxItems;
        // Load cache from storage into memory on instantiation
        const stored = this.storageClient.getItem($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, {
            useExpiredItem: true
        });
        this.memoryCache = stored ? JSON.parse(stored) : {};
    }
}
$842937149a04b8ba$var$_SmartCardLocalCacheClient = $842937149a04b8ba$export$1987ad1ab31f2528;
$842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
module.exports["SmartCardLocalCacheClient"] = $842937149a04b8ba$export$1987ad1ab31f2528;

});

parcelRegister("6YrB3", function(module, exports) {
$parcel$export(module.exports, "default", () => $293056f9068f55f6$export$2e2bcd8739ae039);

var $f9XbP = parcelRequire("f9XbP");

const $293056f9068f55f6$export$3364800d9d60baf9 = 'localStorage';
var $293056f9068f55f6$export$2e2bcd8739ae039 = (0, $f9XbP.StorageClient);
module.exports["DEFAULT_STORAGE_ENGINE"] = $293056f9068f55f6$export$3364800d9d60baf9;

});

parcelRegister("f9XbP", function(module, exports) {

var $fmV2n = parcelRequire("fmV2n");


var $6YrB3 = parcelRequire("6YrB3");

class $cecff34dc45d8bb2$export$6c85f5032e75eff9 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || (0, $6YrB3.DEFAULT_STORAGE_ENGINE);
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fmV2n.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["StorageClient"] = $cecff34dc45d8bb2$export$6c85f5032e75eff9;

});

parcelRegister("fmV2n", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $a61ea4cfed034b37$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $a61ea4cfed034b37$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$a61ea4cfed034b37$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $a61ea4cfed034b37$export$efebfe7859cae3c7;

});

parcelRegister("yuV6Z", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    const baseUrl = (0, $iDrrr.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("jQQYu", function(module, exports) {
// Creates a cookie for object-resolver header
const $64671b371f568ec9$export$7892c26d6c7a7447 = (userContext)=>{
    const cookieTarget = 'cloud.session.token';
    return `${cookieTarget}=${userContext}`;
};
module.exports["createCookie"] = $64671b371f568ec9$export$7892c26d6c7a7447;

});

parcelRegister("8Pm8w", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ 
var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $3xsB6 = parcelRequire("3xsB6");


var $05aaK = parcelRequire("05aaK");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $cuwGS = parcelRequire("cuwGS");


var $d04Ge = parcelRequire("d04Ge");

const $9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX = /^ari:cloud:blocks:.*:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$mapBlockError = (error)=>{
    switch(error.status){
        case 400:
        case 401:
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 403:
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 404:
            return (0, $79ir6.SyncBlockError).NotFound;
        case 409:
            return (0, $79ir6.SyncBlockError).Conflict;
        case 429:
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 500:
        case 503:
        case 504:
            return (0, $79ir6.SyncBlockError).ServerError;
    }
    return (0, $79ir6.SyncBlockError).Errored;
};
const $9b0c4608cd445e14$var$mapErrorResponseCode = (errorCode)=>{
    switch(errorCode){
        case 'FORBIDDEN':
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 'RESOURCE_NOT_FOUND':
        case 'NOT_FOUND':
            return (0, $79ir6.SyncBlockError).NotFound;
        case 'EntityNotFound':
            return (0, $79ir6.SyncBlockError).EntityNotFound;
        case 'INVALID_REQUEST':
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 'CONFLICT':
            return (0, $79ir6.SyncBlockError).Conflict;
        case 'RATE_LIMITED':
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 'SERVER_ERROR':
            return (0, $79ir6.SyncBlockError).ServerError;
        case 'INVALID_CONTENT':
            return (0, $79ir6.SyncBlockError).InvalidContent;
        default:
            return (0, $79ir6.SyncBlockError).Errored;
    }
};
const $9b0c4608cd445e14$export$7a367d6c9621d11 = (blockAri)=>{
    // Validate ARI format and extract resourceId using regex
    // Format: ari:cloud:blocks:{uuid}:synced-block/{product}/{parentId}/{resourceId}
    // The regex captures the full path after synced-block/
    // e.g. ari:cloud:blocks:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:synced-block/confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    // should return confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    const match = blockAri.match($9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX);
    return match?.[1] || null;
};
const $9b0c4608cd445e14$export$bba762cb095b2f42 = (data, resourceId)=>{
    let createdAt;
    if (data.createdAt !== undefined && data.createdAt !== null) try {
        createdAt = new Date(data.createdAt).toISOString();
    } catch  {
        // fallback to undefined
        // as we don't want to block the whole process due to invalid date
        createdAt = undefined;
    }
    return {
        blockInstanceId: data.blockInstanceId,
        content: JSON.parse(data.content),
        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(data.contentUpdatedAt),
        createdAt: createdAt,
        createdBy: data.createdBy,
        product: data.product,
        resourceId: resourceId,
        sourceAri: data.sourceAri,
        status: data.status
    };
};
const $9b0c4608cd445e14$export$17132bdfdc28611c = async (documentAri)=>{
    let response;
    try {
        response = await (0, $05aaK.getReferenceSyncedBlocks)(documentAri);
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return $9b0c4608cd445e14$var$mapBlockError(error);
        return (0, $79ir6.SyncBlockError).Errored;
    }
    const { blocks: blocks, errors: errors } = response || {};
    const blocksInstances = (blocks || []).map((blockContentResponse)=>{
        try {
            const resourceId = $9b0c4608cd445e14$export$7a367d6c9621d11(blockContentResponse.blockAri);
            if (!resourceId) // could not extract resourceId from blockAri, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
            return {
                data: $9b0c4608cd445e14$export$bba762cb095b2f42(blockContentResponse, resourceId),
                resourceId: resourceId
            };
        } catch  {
            // JSON parsing error, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
        }
    });
    const errorInstances = (errors || []).map((errorBlock)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: errorBlock.blockAri
        }));
    return [
        ...blocksInstances,
        ...errorInstances
    ];
};
const $9b0c4608cd445e14$export$2837853885c81488 = (blockAri)=>{
    const match = blockAri.match($9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX);
    return match?.[1];
};
const $9b0c4608cd445e14$export$abdcb5d4d6767e73 = async (cloudId, parentAri, blockNodeIdentifiers, config)=>{
    const blockIdentifiers = blockNodeIdentifiers.map((blockIdentifier)=>({
            blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: cloudId,
                resourceId: blockIdentifier.resourceId
            }),
            blockInstanceId: blockIdentifier.blockInstanceId
        }));
    // Create a set of valid resourceIds for validation
    const validResourceIds = new Set(blockNodeIdentifiers.map((blockNodeIdentifier)=>blockNodeIdentifier.resourceId));
    // Track which resourceIds have been processed
    const processedResourceIds = new Set();
    if (!parentAri) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: blockNodeIdentifier.resourceId
        }));
    try {
        const response = await (0, $05aaK.batchRetrieveSyncedBlocks)({
            blockIdentifiers: blockIdentifiers,
            config: config
        });
        const results = [];
        // Process successful blocks
        if (response.success) for (const blockContentResponse of response.success){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(blockContentResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            const { content: content, deletionReason: deletionReason, sourceAri: sourceAri, blockAri: blockAri, contentUpdatedAt: contentUpdatedAt, blockInstanceId: blockInstanceId, product: product, status: status } = blockContentResponse;
            if (!content) {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).NotFound,
                        reason: deletionReason,
                        sourceAri: sourceAri
                    },
                    resourceId: resourceId
                });
                continue;
            }
            try {
                const syncedBlockData = JSON.parse(content);
                results.push({
                    data: {
                        content: syncedBlockData,
                        resourceId: blockAri,
                        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                        blockInstanceId: blockInstanceId,
                        sourceAri: sourceAri,
                        product: product,
                        status: status,
                        deletionReason: deletionReason
                    },
                    resourceId: resourceId
                });
            } catch  {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).Errored,
                        reason: `parsing JSON content response failed for resourceId: ${resourceId} localId: ${blockAri}`
                    },
                    resourceId: resourceId
                });
            }
        }
        // Process errors
        if (response.error) for (const errorResponse of response.error){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(errorResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            results.push({
                error: {
                    type: $9b0c4608cd445e14$var$mapErrorResponseCode(errorResponse.code),
                    reason: errorResponse.reason
                },
                resourceId: resourceId
            });
        }
        // Ensure all resourceIds have a result - return NotFound for any missing ones
        for (const blockNodeIdentifier of blockNodeIdentifiers)if (!processedResourceIds.has(blockNodeIdentifier.resourceId)) results.push({
            error: {
                type: (0, $79ir6.SyncBlockError).NotFound
            },
            resourceId: blockNodeIdentifier.resourceId
        });
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockTimeoutError) && (0, $ieeJu.expValEquals)('platform_editor_sync_block_ssr_config', 'isEnabled', true)) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: (0, $79ir6.SyncBlockError).Aborted,
                    reason: error.message
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
        // If batch request fails, return error for all resourceIds. Capture the HTTP
        // status from `BlockError` so fetch analytics can break failures down by
        // statusCode (EDITOR-7862); undefined for non-HTTP failures. Thread the PII-safe
        // original message/name so the renderer can de-opaque the `errored` bucket.
        return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: error instanceof (0, $05aaK.BlockError) ? $9b0c4608cd445e14$var$mapBlockError(error) : (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...error instanceof (0, $05aaK.BlockError) && {
                        statusCode: error.status
                    },
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
    }
};
const $9b0c4608cd445e14$export$13b682467148f88a = async (cloudId, parentAri, parentId, product, data, stepVersion)=>{
    if (!parentAri || !parentId) return data.map((block)=>({
            error: (0, $79ir6.SyncBlockError).Errored,
            resourceId: block.resourceId
        }));
    try {
        // Create a map from blockAri to original resourceId for matching responses
        const blockAriToResourceIdMap = new Map();
        const blocks = data.map((block)=>{
            const blockAri = (0, $3xsB6.generateBlockAri)({
                cloudId: cloudId,
                parentId: parentId,
                product: product,
                resourceId: block.resourceId
            });
            blockAriToResourceIdMap.set(blockAri, block.resourceId);
            return {
                blockAri: blockAri,
                content: JSON.stringify(block.content),
                status: block.status,
                stepVersion: stepVersion
            };
        });
        const response = await (0, $05aaK.updateSyncedBlocks)({
            blocks: blocks
        });
        const results = [];
        // Process successful updates
        if (response.success) {
            const successResourceIds = new Set(response.success.map((block)=>blockAriToResourceIdMap.get(block.blockAri)));
            for (const block of data)if (successResourceIds.has(block.resourceId)) results.push({
                resourceId: block.resourceId
            });
        }
        if (response.error) {
            const errorResourceIds = new Map(response.error.map((err)=>[
                    // Use the map to get the original resourceId
                    blockAriToResourceIdMap.get(err.blockAri) || '',
                    $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                ]));
            for (const block of data){
                const error = errorResourceIds.get(block.resourceId);
                if (error) results.push({
                    error: error,
                    resourceId: block.resourceId
                });
                else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                results.push({
                    error: (0, $79ir6.SyncBlockError).Errored,
                    resourceId: block.resourceId
                });
            }
        }
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: block.resourceId,
                statusCode: error.status
            }));
        return data.map((block)=>({
                error: (0, $916Gd.stringifyError)(error),
                resourceId: block.resourceId
            }));
    }
};

/**
 * ADFFetchProvider implementation that fetches synced block data from Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFFetchProvider {
    // resourceId of the reference synced block.
    // the ARI must be constructed to call the block service API
    async fetchData(resourceId) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        try {
            const blockContentResponse = await (0, $05aaK.getSyncedBlockContent)({
                blockAri: blockAri
            });
            const { content: content, sourceAri: sourceAri, deletionReason: deletionReason, blockInstanceId: blockInstanceId, contentUpdatedAt: contentUpdatedAt, product: product, status: status } = blockContentResponse;
            if (!content) return {
                error: {
                    type: (0, $79ir6.SyncBlockError).NotFound,
                    reason: deletionReason,
                    sourceAri: sourceAri
                },
                resourceId: resourceId
            };
            // Parse the synced block content from the response's content
            const syncedBlockData = JSON.parse(content);
            return {
                data: {
                    content: syncedBlockData,
                    resourceId: blockAri,
                    blockInstanceId: blockInstanceId,
                    // this was the node's localId, but has become the resourceId.
                    contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                    sourceAri: sourceAri,
                    product: product,
                    status: status,
                    deletionReason: deletionReason
                },
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) // Capture the HTTP status so fetch analytics can break failures down by
            // statusCode (EDITOR-7862). Thread the PII-safe original message/name so
            // the renderer can de-opaque failures.
            return {
                error: {
                    type: $9b0c4608cd445e14$var$mapBlockError(error),
                    reason: error.message,
                    statusCode: error.status,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
        }
    }
    async fetchReferences(referenceResourceId) {
        try {
            const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: this.cloudId,
                resourceId: referenceResourceId
            });
            const response = await (0, $05aaK.getReferenceSyncedBlocksByBlockAri)({
                blockAri: blockAri
            });
            const references = [];
            response.references.forEach((reference)=>{
                references.push({
                    ...reference,
                    hasAccess: true,
                    onSameDocument: this.parentAri === reference.documentAri
                });
            });
            response.errors.forEach((reference)=>{
                if (reference.code === 'FORBIDDEN') references.push({
                    blockAri: reference.blockAri,
                    documentAri: reference.documentAri,
                    hasAccess: false,
                    onSameDocument: false
                });
            });
            return {
                references: references
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error)
            };
            return {
                error: (0, $79ir6.SyncBlockError).Errored
            };
        }
    }
    /**
   * Batch fetches multiple synced blocks by their resource IDs.
   * @param blockNodeIdentifiers - Array of block node identifiers to fetch
   * @param config - Optional batch fetch configuration
   * @returns Array of SyncBlockInstance results
   */ async batchFetchData(blockNodeIdentifiers, config) {
        return await $9b0c4608cd445e14$export$abdcb5d4d6767e73(this.cloudId, this.parentAri, blockNodeIdentifiers, config);
    }
    /**
   * Subscribes to real-time updates for a specific block using GraphQL WebSocket subscriptions.
   * @param resourceId - The resource ID of the block to subscribe to
   * @param onUpdate - Callback function invoked when the block is updated
   * @param onError - Optional callback function invoked on subscription errors
   * @returns Unsubscribe function to stop receiving updates
   */ subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        // Track the real unsubscribe fn once the dynamic import resolves
        let unsubscribe;
        let cancelled = false;
        // Dynamically import blockSubscription so that graphql-ws is NOT pulled
        // into the SSR/preload bundle that imports this subpath.
        (parcelRequire("8qDKl")).then(({ subscribeToBlockUpdates: subscribeToBlockUpdatesWS })=>{
            if (cancelled) return;
            unsubscribe = subscribeToBlockUpdatesWS(blockAri, (parsedData)=>{
                // Convert ParsedBlockSubscriptionData to SyncBlockInstance
                const syncBlockInstance = {
                    data: {
                        content: parsedData.content,
                        resourceId: parsedData.blockAri,
                        blockInstanceId: parsedData.blockInstanceId,
                        sourceAri: parsedData.sourceAri,
                        product: parsedData.product,
                        createdAt: parsedData.createdAt,
                        contentUpdatedAt: parsedData.contentUpdatedAt,
                        createdBy: parsedData.createdBy,
                        status: parsedData.status
                    },
                    resourceId: parsedData.resourceId
                };
                onUpdate(syncBlockInstance);
            }, onError, onComplete);
        }).catch((err)=>{
            if (cancelled) return;
            onError?.(err instanceof Error ? err : new Error('Failed to load subscription module'));
        });
        // Return an unsubscribe fn that works whether the import has resolved or not
        return ()=>{
            cancelled = true;
            unsubscribe?.();
        };
    }
    constructor({ cloudId: cloudId, parentAri: parentAri }){
        this.cloudId = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
    }
}
/**
 * ADFWriteProvider implementation that writes synced block data to Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFWriteProvider {
    async writeData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            const status = data.status;
            await (0, $05aaK.updateSyncedBlock)({
                blockAri: blockAri,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    async createData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        const status = 'unpublished';
        try {
            await (0, $05aaK.createSyncedBlock)({
                blockAri: blockAri,
                blockInstanceId: data.blockInstanceId,
                sourceAri: this.parentAri,
                product: this.product,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    // soft deletes the source synced block
    async deleteData(resourceId, deleteReason) {
        if (!this.parentId) return {
            resourceId: resourceId,
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        try {
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockNotFoundError) && this.parentAri) return this.deleteOrphanBlock({
                blockAri: blockAri,
                resourceId: resourceId,
                parentAri: this.parentAri,
                deleteReason: deleteReason
            });
            if (error instanceof (0, $05aaK.BlockError)) {
                if (error.status === 404) // User should not be blocked by not_found error when deleting,
                // hence returns successful result for 404 error
                return {
                    resourceId: resourceId,
                    success: true
                };
                return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    statusCode: error.status
                };
            }
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // The block is an orphan (e.g. from a copied page) — it doesn't exist in Block Service.
    // Block Service uses soft-deletes, so we must first create the block then delete it,
    // ensuring a deletion-reason record is stored (used to display errors in reference blocks).
    async deleteOrphanBlock({ blockAri: blockAri, resourceId: resourceId, parentAri: parentAri, deleteReason: deleteReason }) {
        try {
            const stepVersion = this.getVersion ? await this.getVersion() : undefined;
            try {
                await (0, $05aaK.createSyncedBlock)({
                    blockAri: blockAri,
                    blockInstanceId: resourceId,
                    sourceAri: parentAri,
                    product: this.product,
                    content: '[]',
                    stepVersion: stepVersion
                });
            } catch (createError) {
                // "Conditional check failed" means the block already exists in Block Service.
                // This can happen when an orphan block is copied and pasted — a reference block repair
                // in the backend may have already created it. We can proceed directly to delete it.
                if (createError instanceof Error && createError.message.includes('Conditional check failed')) ;
                else if (createError instanceof (0, $05aaK.BlockError)) return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(createError),
                    statusCode: createError.status
                };
                else return {
                    resourceId: resourceId,
                    success: false,
                    error: (0, $916Gd.stringifyError)(createError)
                };
            }
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                resourceId: resourceId,
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // the sourceId is the resourceId of the source synced block.
    generateResourceIdForReference(sourceId) {
        return (0, $cuwGS.createResourceIdForReference)(this.product, this.parentId || '', sourceId);
    }
    generateResourceId() {
        return crypto.randomUUID();
    }
    generateBlockAri(resourceId) {
        return (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId || '',
            product: this.product,
            resourceId: resourceId
        });
    }
    async updateReferenceData(blocks, noContent) {
        if (!this.parentAri) return {
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        try {
            await (0, $05aaK.updateReferenceSyncedBlockOnDocument)({
                documentAri: this.parentAri,
                blocks: blocks.map((block)=>({
                        blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                            cloudId: this.cloudId,
                            resourceId: block.resourceId
                        }),
                        blockInstanceId: block.localId
                    })),
                noContent: noContent
            });
            return {
                success: true
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    async writeDataBatch(data) {
        if (!this.parentAri || !this.parentId) return data.map((block)=>({
                error: (0, $79ir6.SyncBlockError).Errored,
                resourceId: block.resourceId
            }));
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            // Create a map from blockAri to original resourceId for matching responses
            const blockAriToResourceIdMap = new Map();
            const blocks = data.map((block)=>{
                const blockAri = this.generateBlockAri(block.resourceId);
                blockAriToResourceIdMap.set(blockAri, block.resourceId);
                return {
                    blockAri: blockAri,
                    content: JSON.stringify(block.content),
                    status: block.status,
                    stepVersion: stepVersion
                };
            });
            const response = await (0, $05aaK.updateSyncedBlocks)({
                blocks: blocks
            });
            const results = [];
            // Process successful updates
            if (response.success) {
                const successBlocks = new Map(response.success.map((block)=>[
                        blockAriToResourceIdMap.get(block.blockAri),
                        block
                    ]));
                for (const block of data){
                    const successBlock = successBlocks.get(block.resourceId);
                    if (successBlock) results.push({
                        resourceId: block.resourceId,
                        status: successBlock.status
                    });
                }
            }
            if (response.error) {
                const errorResourceIds = new Map(response.error.map((err)=>[
                        // Use the map to get the original resourceId
                        blockAriToResourceIdMap.get(err.blockAri) || '',
                        $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                    ]));
                for (const block of data){
                    const error = errorResourceIds.get(block.resourceId);
                    if (error) {
                        if (error !== (0, $79ir6.SyncBlockError).NotFound) results.push({
                            error: error,
                            resourceId: block.resourceId
                        });
                    } else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                    results.push({
                        error: (0, $79ir6.SyncBlockError).Errored,
                        resourceId: block.resourceId
                    });
                }
            }
            return results;
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    resourceId: block.resourceId,
                    statusCode: error.status
                }));
            return data.map((block)=>({
                    error: (0, $916Gd.stringifyError)(error),
                    resourceId: block.resourceId
                }));
        }
    }
    constructor({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion }){
        this.cloudId = void 0;
        this.parentId = void 0;
        this.getVersion = void 0;
        this.product = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
        this.parentId = parentId;
        this.product = product;
        this.getVersion = getVersion;
    }
}
const $9b0c4608cd445e14$var$createBlockServiceAPIProviders = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: new $9b0c4608cd445e14$var$BlockServiceADFWriteProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        })
    };
};
const $9b0c4608cd445e14$export$ec654f5ac7e6d976 = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return (0, $cozmU.useMemo)(()=>{
        return $9b0c4608cd445e14$var$createBlockServiceAPIProviders({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        });
    }, [
        cloudId,
        parentAri,
        parentId,
        product,
        getVersion
    ]);
};
const $9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider = ({ cloudId: cloudId, parentAri: parentAri })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: undefined
    };
};
const $9b0c4608cd445e14$export$1e67317f82b65067 = ({ cloudId: cloudId, parentAri: parentAri })=>(0, $cozmU.useMemo)(()=>$9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }), [
        cloudId,
        parentAri
    ]);
module.exports["batchFetchData"] = $9b0c4608cd445e14$export$abdcb5d4d6767e73;
module.exports["useMemoizedBlockServiceAPIProviders"] = $9b0c4608cd445e14$export$ec654f5ac7e6d976;

});

parcelRegister("3xsB6", function(module, exports) {
/* eslint-disable require-unicode-regexp */ const $a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/;
const $a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX = /ari:cloud:jira:.*/;
const $a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX = /ari:cloud:confluence:.*/;
const $a2c616dead6b3b85$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $a2c616dead6b3b85$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $a2c616dead6b3b85$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match($a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $a2c616dead6b3b85$export$c10656f449ea0fb5 = (ari)=>{
    const jiraMatch = ari?.search($a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search($a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $a2c616dead6b3b85$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $a2c616dead6b3b85$export$92a2331f8a9ed841;
module.exports["getProductFromSourceAri"] = $a2c616dead6b3b85$export$c10656f449ea0fb5;

});

parcelRegister("05aaK", function(module, exports) {

var $48FpT = parcelRequire("48FpT");

const $59e004c7d849e8bb$export$f426a9918d7f49b3 = (response)=>{
    const content = response.content;
    return typeof content === 'string';
};
const $59e004c7d849e8bb$export$571f6abc3f4e5951 = async (documentAri)=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery(documentAri),
        operationName: $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetDocumentReferenceBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getDocumentReferenceBlocks;
};
const $59e004c7d849e8bb$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $59e004c7d849e8bb$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_DOCUMENT_REFERENCE_BLOCKS';
const $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_BLOCK';
const $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_DELETE_BLOCK';
const $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_CREATE_BLOCK';
const $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_DOCUMENT_REFERENCES';
const $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_RETRIEVE_BLOCKS';
const $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_REFERENCES';
const $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_BLOCK';
const $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_UPDATE_BLOCKS';
const $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery = (documentAri)=>`query ${$59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME} {
	blockService_getDocumentReferenceBlocks(documentAri: ${JSON.stringify(documentAri)}) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
const $59e004c7d849e8bb$var$buildGetBlockQuery = (blockAri)=>`query ${$59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME} {
	blockService_getBlock(blockAri: ${JSON.stringify(blockAri)}) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
const $59e004c7d849e8bb$var$buildUpdateBlockMutation = (blockAri, content, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `content: ${JSON.stringify(content)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME} {
	blockService_updateBlock(input: { ${inputArgs} }) {
		__typename
	}
}`;
};
const $59e004c7d849e8bb$var$buildDeleteBlockMutation = (blockAri, deletionReason)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`
    ];
    if (deletionReason !== undefined) inputParts.push(`deletionReason: ${JSON.stringify(deletionReason)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME} {
	blockService_deleteBlock(input: { ${inputArgs} }) {
		deleted
	}
}`;
};
/**
 * Converts product string to GraphQL enum format
 * 'confluence-page' -> 'CONFLUENCE_PAGE'
 * 'jira-work-item' -> 'JIRA_WORK_ITEM'
 */ const $59e004c7d849e8bb$var$convertProductToGraphQLEnum = (product)=>{
    switch(product){
        case 'confluence-page':
            return 'CONFLUENCE_PAGE';
        case 'jira-work-item':
            return 'JIRA_WORK_ITEM';
        default:
            {
                const exhaustiveCheck = product;
                throw new Error(`Unsupported product: ${exhaustiveCheck}`);
            }
    }
};
const $59e004c7d849e8bb$var$buildCreateBlockMutation = (blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `blockInstanceId: ${JSON.stringify(blockInstanceId)}`,
        `content: ${JSON.stringify(content)}`,
        `product: ${$59e004c7d849e8bb$var$convertProductToGraphQLEnum(product)}`,
        `sourceAri: ${JSON.stringify(sourceAri)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME} {
	blockService_createBlock(input: { ${inputArgs} }) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
};
const $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation = (documentAri, blocks, noContent)=>{
    const blocksArray = blocks.map((block)=>`{ blockAri: ${JSON.stringify(block.blockAri)}, blockInstanceId: ${JSON.stringify(block.blockInstanceId)} }`).join(', ');
    const inputArgs = `documentAri: ${JSON.stringify(documentAri)}, blocks: [${blocksArray}], noContent: ${noContent}`;
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME} {
	blockService_updateDocumentReferences(input: { ${inputArgs} }) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery = (blockAris)=>{
    const blockArisArray = blockAris.map((ari)=>JSON.stringify(ari)).join(', ');
    const inputArgs = `blockAris: [${blockArisArray}]`;
    return `query ${$59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME} {
	blockService_batchRetrieveBlocks(input: { ${inputArgs} }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildGetBlockReferencesQuery = (blockAri)=>{
    return `query ${$59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME} {
	blockService_getReferences(blockAri: ${JSON.stringify(blockAri)}) {
		references {
			blockAri
			blockInstanceId
			createdAt
			createdBy
			documentAri
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation = (blocks)=>{
    const blocksArray = blocks.map((block)=>{
        const inputParts = [
            `blockAri: ${JSON.stringify(block.blockAri)}`,
            `content: ${JSON.stringify(block.content)}`
        ];
        if (block.stepVersion !== undefined) inputParts.push(`stepVersion: ${block.stepVersion}`);
        if (block.status !== undefined) inputParts.push(`status: ${JSON.stringify(block.status)}`);
        return `{ ${inputParts.join(', ')} }`;
    }).join(', ');
    return `mutation ${$59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME} {
	blockService_batchUpdateBlocks(input: { blocks: [${blocksArray}] }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
class $59e004c7d849e8bb$export$e47a0a94b0998697 extends Error {
    constructor(status){
        super(`Block error`), this.status = status;
    }
}
class $59e004c7d849e8bb$export$f5a00468af285e38 extends Error {
    constructor(){
        super('Block not found in Block Service');
        this.name = 'BlockNotFoundError';
    }
}
class $59e004c7d849e8bb$export$b5687000eb0902be extends Error {
    constructor(){
        super('Block request timed out');
        this.name = 'BlockTimeoutError';
    }
}
const $59e004c7d849e8bb$export$fab66d51cc0c1a7 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getBlock) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getBlock;
};
const $59e004c7d849e8bb$export$48a4f565308f4741 = async ({ blockIdentifiers: blockIdentifiers, config: config })=>{
    const blockAris = blockIdentifiers.map((blockIdentifier)=>blockIdentifier.blockAri);
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery(blockAris),
        operationName: $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchRetrieveBlocks`;
    // undefined or 0 or negative means no timeout,
    // We don't enforce a minimum timeout for simplicity
    const fetchPromise = (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    const timeoutMs = config?.timeoutMs ?? 0;
    const response = await (timeoutMs > 0 ? Promise.race([
        fetchPromise,
        new Promise((_, reject)=>setTimeout(()=>reject(new $59e004c7d849e8bb$export$b5687000eb0902be()), timeoutMs))
    ]) : fetchPromise);
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchRetrieveBlocks) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_batchRetrieveBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
const $59e004c7d849e8bb$export$cbbc86409cac3ee5 = async ({ blockAri: blockAri, deleteReason: deleteReason })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildDeleteBlockMutation(blockAri, deleteReason),
        operationName: $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockDeleteBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) {
        const allNotFound = result.errors.every((e)=>e.extensions?.errorType === 'RESOURCE_NOT_FOUND');
        if (allNotFound) // Throw BlockNotFoundError so the caller can create the block first then retry the delete.
        // Block Service uses soft-deletes: the entry must exist before deletion so a deletion-reason
        // is stored (used to display errors in reference blocks).
        throw new $59e004c7d849e8bb$export$f5a00468af285e38();
        throw new Error(result.errors.map((e)=>e.message).join(', '));
    }
    const isDeleted = result.data?.blockService_deleteBlock?.deleted;
    if (!isDeleted) throw new Error('Block deletion failed; deleted flag is false');
};
const $59e004c7d849e8bb$export$d5bf0c5618431e5e = async ({ blockAri: blockAri, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateBlockMutation(blockAri, content, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
};
const $59e004c7d849e8bb$export$fbc30658d812c800 = async ({ blockAri: blockAri, blockInstanceId: blockInstanceId, sourceAri: sourceAri, product: product, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildCreateBlockMutation(blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockCreateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_createBlock) throw new Error('No data returned from GraphQL mutation');
    return result.data.blockService_createBlock;
};
const $59e004c7d849e8bb$export$59c7369fa04bcba1 = async ({ documentAri: documentAri, blocks: blocks, noContent: noContent = true })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation(documentAri, blocks, noContent),
        operationName: $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateDocumentReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData),
        keepalive: true
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!noContent) {
        if (!result.data?.blockService_updateDocumentReferences) throw new Error('No data returned from GraphQL mutation');
        return result.data.blockService_updateDocumentReferences;
    }
};
const $59e004c7d849e8bb$export$75f5aeff9ce22a33 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockReferencesQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getReferences) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_getReferences;
    return {
        blockAri: blockAri,
        references: graphqlResponse.references || [],
        errors: graphqlResponse.errors || []
    };
};
const $59e004c7d849e8bb$export$a9e53fa4329b5ed2 = async ({ blocks: blocks })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation(blocks),
        operationName: $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchUpdateBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchUpdateBlocks) throw new Error('No data returned from GraphQL mutation');
    const graphqlResponse = result.data.blockService_batchUpdateBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
module.exports["getReferenceSyncedBlocks"] = $59e004c7d849e8bb$export$571f6abc3f4e5951;
module.exports["BlockError"] = $59e004c7d849e8bb$export$e47a0a94b0998697;
module.exports["BlockNotFoundError"] = $59e004c7d849e8bb$export$f5a00468af285e38;
module.exports["BlockTimeoutError"] = $59e004c7d849e8bb$export$b5687000eb0902be;
module.exports["getSyncedBlockContent"] = $59e004c7d849e8bb$export$fab66d51cc0c1a7;
module.exports["batchRetrieveSyncedBlocks"] = $59e004c7d849e8bb$export$48a4f565308f4741;
module.exports["deleteSyncedBlock"] = $59e004c7d849e8bb$export$cbbc86409cac3ee5;
module.exports["updateSyncedBlock"] = $59e004c7d849e8bb$export$d5bf0c5618431e5e;
module.exports["createSyncedBlock"] = $59e004c7d849e8bb$export$fbc30658d812c800;
module.exports["updateReferenceSyncedBlockOnDocument"] = $59e004c7d849e8bb$export$59c7369fa04bcba1;
module.exports["getReferenceSyncedBlocksByBlockAri"] = $59e004c7d849e8bb$export$75f5aeff9ce22a33;
module.exports["updateSyncedBlocks"] = $59e004c7d849e8bb$export$a9e53fa4329b5ed2;

});

parcelRegister("48FpT", function(module, exports) {
const $fc075454b76b2577$var$MAX_RETRY_DELAY = 30000;
const $fc075454b76b2577$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $fc075454b76b2577$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $fc075454b76b2577$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $fc075454b76b2577$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $fc075454b76b2577$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $fc075454b76b2577$export$cffaac380b94df26;

});

parcelRegister("79ir6", function(module, exports) {
var $2ca041ce04439e9b$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    // attempt to create block that already exists
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    // content is not a valid JSON
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
const $2ca041ce04439e9b$export$7486a7adf8b0d591 = 'Data provider not set';
class $2ca041ce04439e9b$export$ca0858d4f5eeeac extends Error {
    constructor(message = $2ca041ce04439e9b$export$7486a7adf8b0d591){
        super(message);
        this.isProviderNotReadyError = true;
        this.name = 'ProviderNotReadyError';
        // Restore prototype chain so instanceof works after transpilation.
        Object.setPrototypeOf(this, $2ca041ce04439e9b$export$ca0858d4f5eeeac.prototype);
    }
}
const $2ca041ce04439e9b$export$7ba508051f94701f = (error)=>{
    if (error instanceof $2ca041ce04439e9b$export$ca0858d4f5eeeac) return true;
    if (typeof error === 'object' && error !== null && error.isProviderNotReadyError === true) return true;
    return error instanceof Error && error.message === $2ca041ce04439e9b$export$7486a7adf8b0d591;
};
module.exports["SyncBlockError"] = $2ca041ce04439e9b$export$686dd843fdf311d4;
module.exports["ProviderNotReadyError"] = $2ca041ce04439e9b$export$ca0858d4f5eeeac;
module.exports["isProviderNotReadyError"] = $2ca041ce04439e9b$export$7ba508051f94701f;

});

parcelRegister("916Gd", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $79ir6 = parcelRequire("79ir6");

const $5f570f8dd9ccb4e4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $5f570f8dd9ccb4e4$export$74ce7fda6da1109 = (error)=>{
    if (error instanceof Error) return {
        ...error.message && {
            originalMessage: error.message
        },
        ...error.name && {
            originalName: error.name
        }
    };
    return {};
};
const $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS = new Set(Object.values((0, $79ir6.SyncBlockError)));
const $5f570f8dd9ccb4e4$export$3bf11deac13e0617 = (error)=>{
    if (error && $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS.has(error)) return error;
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$78792f4ddc3998e8 = (error, statusCode)=>{
    return {
        reason: $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
const $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b = new Set([
    'source_deleted',
    'source_unpublished',
    'source_unsynced',
    'source_not_found',
    'permission_denied',
    'unauthenticated',
    // Mirror the benign write-path enum equivalents so already-classified errors are
    // treated consistently.
    'not_found',
    'forbidden',
    'unpublished',
    // `offline` is an expected client connectivity state, not a read-path system failure:
    // the error component is rendered for the offline experience, so it should not inflate
    // the true error rate. It still emits `reason` (so its volume can be inspected) but is
    // excluded from true-error counts.
    'offline'
]);
/**
 * Ordered list of substring matchers mapping known free-text fetch/subscribe error
 * strings to a categorical {@link SyncBlockFetchErrorReason}. Each entry is a list of
 * lowercase needles; if ANY needle is found (case-insensitively) in the raw `error`
 * string, the entry's reason is used. Order matters: more specific entries must precede
 * more general ones.
 *
 * Plain `String.includes` substring matching is used deliberately instead of `RegExp`:
 * it sidesteps the `require-unicode-regexp` lint rule AND the declaration build's lower
 * compile target (which rejects the regex `u` flag with TS1501), while being faster and
 * easier to read. Doing this classification in code (rather than in dashboard SQL) keeps
 * the buckets versioned with the source strings that produce them (EDITOR-7862).
 */ const $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS = [
    // Benign: source-state transitions (deletionReason values + free text).
    [
        [
            'source-document-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-unpublished'
        ],
        'source_unpublished'
    ],
    [
        [
            'source-block-unsynced'
        ],
        'source_unsynced'
    ],
    [
        [
            'does not exist'
        ],
        'source_not_found'
    ],
    [
        [
            'unpublished'
        ],
        'source_unpublished'
    ],
    // Working-as-designed permission outcomes.
    [
        [
            'unauthenticated'
        ],
        'unauthenticated'
    ],
    [
        [
            'not permitted to read synced block'
        ],
        'permission_denied'
    ],
    [
        [
            'bulk permission check failed'
        ],
        'permission_denied'
    ],
    [
        [
            'permission denied'
        ],
        'permission_denied'
    ],
    // Genuine system failures.
    [
        [
            'reconnection failed after'
        ],
        'websocket_exhausted'
    ],
    // `reconnect to the subscription` (not a bare `reconnect`) avoids false positives on
    // unrelated DB/GraphQL "reconnect" messages while still matching the WS-drop string.
    [
        [
            'websocket',
            'reconnect to the subscription',
            'subscription terminated'
        ],
        'websocket_drop'
    ],
    [
        [
            '429',
            'rate limit',
            'rate-limit',
            'ratelimit'
        ],
        'rate_limited'
    ],
    // `econnrefused`/`econnreset` (not a bare `econn`, which would also match `reconnect`).
    [
        [
            'network',
            'failed to fetch',
            'econnrefused',
            'econnreset',
            'timed out',
            'timeout'
        ],
        'network'
    ],
    [
        [
            'data provider not set'
        ],
        'data_provider_not_ready'
    ]
];
const $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55 = (error)=>{
    const enumReason = $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error);
    if (enumReason !== 'unknown') return enumReason;
    if (error) {
        const haystack = error.toLowerCase();
        for (const [needles, reason] of $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS){
            if (needles.some((needle)=>haystack.includes(needle))) return reason;
        }
    }
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$4ae89cef01c11c46 = (error, statusCode, deferred)=>{
    const reason = $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55(error);
    return {
        reason: reason,
        // A deferred (tab-hidden) exhaustion is benign regardless of reason bucket.
        benign: deferred === true || $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b.has(reason),
        ...statusCode !== undefined && {
            statusCode: statusCode
        },
        ...deferred === true && {
            deferred: true
        }
    };
};
function $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d(actionSubjectId, error, resourceId, sourceProduct, attribution) {
    return {
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...attribution?.reason && {
                reason: attribution.reason
            },
            ...attribution?.statusCode !== undefined && {
                statusCode: attribution.statusCode
            },
            // `benign` is only present on fetch/subscribe attribution (EDITOR-7862). It is a
            // boolean (never UGC); the `'benign' in attribution` check both guards the
            // write-path attribution (which has no `benign`) and narrows the union so
            // `attribution.benign` is accessible.
            ...attribution && 'benign' in attribution && {
                benign: attribution.benign
            },
            // `deferred` is only present on fetch/subscribe attribution, and only when a
            // tab-hidden exhaustion was deferred rather than surfaced. Boolean, never UGC.
            ...attribution && 'deferred' in attribution && attribution.deferred === true && {
                deferred: true
            }
        }
    };
}
const $5f570f8dd9ccb4e4$export$94dcd08406353dba = (error, resourceId, sourceProduct, attribution)=>// Branch on attribution presence so each call resolves to a concrete overload: with
    // attribution it hits the fetch overload (wider `reason`); without it, the
    // no-attribution overload. Both produce a fetch event regardless.
    attribution ? $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct, attribution) : $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$c5131f589148b9d3 = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$adc2363832f8735d = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$154595d209a77913 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$5d2f0c264cf49280 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$5665a31a69693485 = (resourceId, sourceProduct, context)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_INFO_ORPHANED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...context?.hasPendingDeletion !== undefined && {
                hasPendingDeletion: context.hasPendingDeletion
            },
            ...context?.hasSubscribers !== undefined && {
                hasSubscribers: context.hasSubscribers
            }
        }
    });
const $5f570f8dd9ccb4e4$export$82f9608c8438ecb2 = (rescheduleCount, resourceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CACHE_DELETION_FORCED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            rescheduleCount: rescheduleCount,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).FETCHED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$5b8e0915870366d0 = (resourceId, sourceProduct)=>{
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    };
};
const $5f570f8dd9ccb4e4$export$23e42fbf8039414c = (resourceId, blockInstanceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.inputMethod && {
                inputMethod: enrichment.inputMethod
            },
            ...enrichment?.createdEmpty !== undefined && {
                createdEmpty: enrichment.createdEmpty
            }
        }
    });
const $5f570f8dd9ccb4e4$export$c76f6dd50db89cda = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ADDED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_ADD_CONTENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$f2b4214fae56af83 = (resourceId, hasReference, sourceProduct)=>({
        action: (0, $krYZG.ACTION).UPDATED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$2283f5d682476cde = (resourceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.blockInstanceId && {
                blockInstanceId: enrichment.blockInstanceId
            },
            ...enrichment?.deletionReason && {
                deletionReason: enrichment.deletionReason
            },
            ...enrichment?.mechanism && {
                mechanism: enrichment.mechanism
            }
        }
    });
module.exports["stringifyError"] = $5f570f8dd9ccb4e4$export$7fc2c997455452c8;
module.exports["getPiiSafeOriginalError"] = $5f570f8dd9ccb4e4$export$74ce7fda6da1109;
module.exports["buildErrorAttribution"] = $5f570f8dd9ccb4e4$export$78792f4ddc3998e8;
module.exports["buildFetchErrorAttribution"] = $5f570f8dd9ccb4e4$export$4ae89cef01c11c46;
module.exports["fetchErrorPayload"] = $5f570f8dd9ccb4e4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $5f570f8dd9ccb4e4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $5f570f8dd9ccb4e4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $5f570f8dd9ccb4e4$export$154595d209a77913;
module.exports["createErrorPayload"] = $5f570f8dd9ccb4e4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e;
module.exports["sourceInfoOrphanedPayload"] = $5f570f8dd9ccb4e4$export$5665a31a69693485;
module.exports["cacheDeletionForcedPayload"] = $5f570f8dd9ccb4e4$export$82f9608c8438ecb2;
module.exports["fetchReferencesErrorPayload"] = $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76;
module.exports["createSuccessPayload"] = $5f570f8dd9ccb4e4$export$5b8e0915870366d0;
module.exports["createSuccessOperationalPayload"] = $5f570f8dd9ccb4e4$export$23e42fbf8039414c;
module.exports["addContentSuccessPayload"] = $5f570f8dd9ccb4e4$export$c76f6dd50db89cda;
module.exports["updateSuccessPayload"] = $5f570f8dd9ccb4e4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $5f570f8dd9ccb4e4$export$2283f5d682476cde;

});

parcelRegister("cuwGS", function(module, exports) {

var $kcJaM = parcelRequire("kcJaM");

const $dfc9aeca876e07dc$var$isSyncBlockProduct = (product)=>{
    return (0, $kcJaM.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $dfc9aeca876e07dc$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$dfc9aeca876e07dc$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $dfc9aeca876e07dc$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $dfc9aeca876e07dc$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $dfc9aeca876e07dc$export$cf5895b3b46faf63;

});

parcelRegister("kcJaM", function(module, exports) {
const $d6e2f975e4365dc3$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $d6e2f975e4365dc3$export$c05408ef703373ad;

});

parcelRegister("d04Ge", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX = /^(confluence-page|jira-work-item)\/([^/]+)/;
const $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal = (content, options)=>{
    let normalizedContent;
    content.forEach((contentNode, index)=>{
        if (!contentNode) {
            normalizedContent?.push(contentNode);
            return;
        }
        const hasAnnotationMark = contentNode.marks?.some((mark)=>mark.type === 'annotation');
        const shouldConvertPanelC1 = options.convertPanelC1ToPanel && contentNode.type === 'panel_c1';
        const childContent = contentNode.content ? $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(contentNode.content, options) : undefined;
        const hasContentChanged = childContent !== undefined && childContent !== contentNode.content;
        if (!hasAnnotationMark && !shouldConvertPanelC1 && !hasContentChanged) {
            normalizedContent?.push(contentNode);
            return;
        }
        if (!normalizedContent) normalizedContent = content.slice(0, index);
        const normalizedNode = {
            ...contentNode
        };
        if (shouldConvertPanelC1) normalizedNode.type = 'panel';
        if (hasAnnotationMark) {
            const marks = contentNode.marks?.filter((mark)=>mark.type !== 'annotation');
            if (marks && marks.length > 0) normalizedNode.marks = marks;
            else delete normalizedNode.marks;
        }
        if (hasContentChanged && childContent) normalizedNode.content = childContent;
        normalizedContent.push(normalizedNode);
    });
    return normalizedContent ?? content;
};
const $acebaa6737646e6e$export$19bb1d88f473b9c5 = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: false
    });
};
const $acebaa6737646e6e$export$b223a7607ed061dc = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: true
    });
};
const $acebaa6737646e6e$export$aafb32b192c8228c = (node)=>{
    const content = node.content.toJSON();
    return {
        blockInstanceId: node.attrs.localId,
        content: content ? $acebaa6737646e6e$export$b223a7607ed061dc(content) : content,
        resourceId: node.attrs.resourceId
    };
};
const $acebaa6737646e6e$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $acebaa6737646e6e$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$acebaa6737646e6e$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $acebaa6737646e6e$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match($acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $acebaa6737646e6e$export$31cbe0bed21e05b1 = (resourceId)=>{
    if (!resourceId) return undefined;
    try {
        return $acebaa6737646e6e$export$2cf4a74c3e18f31a(resourceId).sourceProduct;
    } catch  {
        return undefined;
    }
};
const $acebaa6737646e6e$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["normalizeSyncBlockJSONContent"] = $acebaa6737646e6e$export$b223a7607ed061dc;
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $acebaa6737646e6e$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $acebaa6737646e6e$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $acebaa6737646e6e$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $acebaa6737646e6e$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $acebaa6737646e6e$export$2cf4a74c3e18f31a;
module.exports["getSourceProductFromResourceIdSafe"] = $acebaa6737646e6e$export$31cbe0bed21e05b1;
module.exports["convertContentUpdatedAt"] = $acebaa6737646e6e$export$4c6687d128f55da5;

});

parcelRegister("8qDKl", function(module, exports) {

let $622f95420b83de1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $622f95420b83de1c$var$load("eS3wT"),
    $622f95420b83de1c$var$load("4uO8Y"),
    $622f95420b83de1c$var$load("cp9QV")
]).then(()=>parcelRequire('kRm6Y'));

});

parcelRegister("6oMcp", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX = /ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/;
const $0dfedb71521ac678$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $0dfedb71521ac678$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match($0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $0dfedb71521ac678$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $0dfedb71521ac678$export$2ee4e689bde04de2;

});

parcelRegister("gb05o", function(module, exports) {
/**
 * Error codes for synced blocks preloading
 * Used for tracking and monitoring errors during SSR preload phase
 */ const $dcd4a25c1def153c$export$f10410d219e3ec29 = {
    /**
   * Occurs when the fetch operation returns fewer results than requested.
   * This indicates incomplete data retrieval or potential data loss.
   * Included in error: list of missing block identifiers
   */ FETCH_INCOMPLETE: 'SYNCED_BLOCKS_FETCH_INCOMPLETE',
    /**
   * Occurs when the batch fetch operation throws an error during execution.
   * This indicates a network error, timeout, or API failure.
   * Included in error: resource IDs that failed to fetch
   */ BATCH_FETCH_FAILED: 'SYNCED_BLOCKS_BATCH_FETCH_FAILED',
    /**
   * Occurs when the fetch operation times out without returning results.
   * This is specific to the bulk fetch operation with a configurable timeout.
   */ FETCH_TIMEOUT: 'SYNCED_BLOCKS_FETCH_TIMEOUT'
};
module.exports["SyncedBlocksSSRErrorCodeMap"] = $dcd4a25c1def153c$export$f10410d219e3ec29;

});

parcelRegister("8wyJO", function(module, exports) {

var $ibGN4 = parcelRequire("ibGN4");


var $3V1KT = parcelRequire("3V1KT");

const $01eec1a417789222$export$17ab88ef0193bb4 = (data)=>{
    if (!data) return data;
    if ($01eec1a417789222$var$isConfluenceContentReactions(data)) return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
    if ($01eec1a417789222$var$isContentReactions(data)) return data?.content?.nodes?.[0]?.contentReactionsSummary;
    if ($01eec1a417789222$var$isCommentReactions(data)) return data?.comments?.nodes?.[0]?.reactionsSummary;
};
const $01eec1a417789222$var$isConfluenceContentReactions = (data)=>Boolean(data.confluence_contentReactionsSummary);
const $01eec1a417789222$var$isContentReactions = (data)=>Boolean(data.content);
const $01eec1a417789222$var$isCommentReactions = (data)=>Boolean(data.comments);
const $01eec1a417789222$var$getReactionsContentQuery = ()=>{
    return 0, $3V1KT.ReactionsContentQuery;
};
const $01eec1a417789222$export$d765e1092b1f36ff = (isComment, contentId, containerId)=>{
    const query = isComment ? (0, $ibGN4.ReactionsCommentsQuery) : $01eec1a417789222$var$getReactionsContentQuery();
    const queryVariables = isComment ? {
        contentId: contentId,
        containerId: containerId
    } : {
        contentId: contentId
    };
    return {
        query: query,
        queryVariables: queryVariables
    };
};
module.exports["getReactionsSummary"] = $01eec1a417789222$export$17ab88ef0193bb4;
module.exports["getReactionsQueryInfo"] = $01eec1a417789222$export$d765e1092b1f36ff;

});

parcelRegister("ibGN4", function(module, exports) {

var $bcPqk = parcelRequire("bcPqk");


var $hMpSP = parcelRequire("hMpSP");

const $0c4d3fd1a40dc0de$export$ea32e9ef3caf8ce7 = (0, $hMpSP.default);
const $0c4d3fd1a40dc0de$export$c0002d0cc70e364a = (0, $bcPqk.default);
module.exports["ReactionsCommentsQuery"] = $0c4d3fd1a40dc0de$export$c0002d0cc70e364a;

});

parcelRegister("bcPqk", function(module, exports) {
/**
 * @generated SignedSource<<d1f71583f1da07d7d25964da546e340a>>
 * @relayHash cbefab13307a82cf7144a0c0749ceeba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce
const $6247a0815b189874$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": [
                        "DRAFT",
                        "CURRENT"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "containerId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cbefab13307a82cf7144a0c0749ceeba",
            "id": "856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce",
            "metadata": {},
            "name": "ReactionsCommentsQuery",
            "operationKind": "query",
            "text": "query ReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$6247a0815b189874$var$node.hash = "44a0a66242011ccb75c569988c203697";
var $6247a0815b189874$export$2e2bcd8739ae039 = $6247a0815b189874$var$node;
module.exports["default"] = $6247a0815b189874$export$2e2bcd8739ae039;

});

parcelRegister("hMpSP", function(module, exports) {
/**
 * @generated SignedSource<<eb7ea3f49a5750a597b7cccc9d474194>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $31e432aaf867a396$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "containerId"
            }
        ],
        "kind": "Fragment",
        "name": "ReactionsCommentsQuery_comment",
        "selections": [
            v0 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "containerId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            },
                            v0 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "Comment"
    };
}();
$31e432aaf867a396$var$node.hash = "af213ff403659043868c02fbd688a22c";
var $31e432aaf867a396$export$2e2bcd8739ae039 = $31e432aaf867a396$var$node;
module.exports["default"] = $31e432aaf867a396$export$2e2bcd8739ae039;

});

parcelRegister("3V1KT", function(module, exports) {

var $71jDq = parcelRequire("71jDq");

const $bb6fcff23ee99252$export$d1ed7f06ad741aec = (0, $71jDq.default);
module.exports["ReactionsContentQuery"] = $bb6fcff23ee99252$export$d1ed7f06ad741aec;

});

parcelRegister("71jDq", function(module, exports) {
/**
 * @generated SignedSource<<4ace922d92a4d91954ed2877f69143ae>>
 * @relayHash f5d80e75401b9c7d3d224f964fef6438
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4
const $380a75471f8fd0e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f5d80e75401b9c7d3d224f964fef6438",
            "id": "1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4",
            "metadata": {},
            "name": "ReactionsContentQuery",
            "operationKind": "query",
            "text": "query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$380a75471f8fd0e5$var$node.hash = "324529dfd12ad8cfc9429a4857981e84";
var $380a75471f8fd0e5$export$2e2bcd8739ae039 = $380a75471f8fd0e5$var$node;
module.exports["default"] = $380a75471f8fd0e5$export$2e2bcd8739ae039;

});

parcelRegister("9inwL", function(module, exports) {
/**
 * @generated SignedSource<<f8edd74a2bf0cef86303775c92f6818c>>
 * @relayHash f92419f4eae7659107884daf44afe353
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5083034f862ac3ea960cfc4592f08715470b77981a4653cdbbd9dc1f12df8a1
const $5791e6e7c338c837$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "missingSpaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "missingSpaceKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f92419f4eae7659107884daf44afe353",
            "id": "c5083034f862ac3ea960cfc4592f08715470b77981a4653cdbbd9dc1f12df8a1",
            "metadata": {},
            "name": "ContentPrerequisitesQuery",
            "operationKind": "query",
            "text": "query ContentPrerequisitesQuery($contentId:ID!,$missingSpaceKey:Boolean=false,$spaceKey:String,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,space{id,key,alias}}},space(key:$spaceKey)@skip(if:$missingSpaceKey){id,name}}"
        }
    };
}();
$5791e6e7c338c837$var$node.hash = "96ae26a7fa99861b8e368c368e56f6cc";
var $5791e6e7c338c837$export$2e2bcd8739ae039 = $5791e6e7c338c837$var$node;
module.exports["default"] = $5791e6e7c338c837$export$2e2bcd8739ae039;

});

parcelRegister("4uNpa", function(module, exports) {
/**
 * @generated SignedSource<<d7fe2a7a66643bd9c72401c8da9b795f>>
 * @relayHash 81e3b75d8ec7e8341dfb9fe5d7c36fac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911
const $2411ee21620b66c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "homepageId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "81e3b75d8ec7e8341dfb9fe5d7c36fac",
            "id": "9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911",
            "metadata": {},
            "name": "ContentRedirectQuery",
            "operationKind": "query",
            "text": "query ContentRedirectQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,title,space{id,homepageId,key,alias},history{createdDate}}}}"
        }
    };
}();
$2411ee21620b66c4$var$node.hash = "440c7fc38cc16d750fa69bd87e3ba7c2";
var $2411ee21620b66c4$export$2e2bcd8739ae039 = $2411ee21620b66c4$var$node;
module.exports["default"] = $2411ee21620b66c4$export$2e2bcd8739ae039;

});

parcelRegister("2HQyh", function(module, exports) {
/**
 * @generated SignedSource<<e56ee58f550eae496b45df46a24c2dad>>
 * @relayHash feae64578b0a3fba44f22230201969bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272
const $5b8dbd4fd00aa380$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "exp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keyString"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v7 = [
        {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "type"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "exp"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "creatorId"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v16 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "strategy"
    }, v18 = {
        "concreteType": "RecommendedPagesStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "userCanToggle"
            },
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            }
        ]
    }, v19 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                },
                v19 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                },
                v19 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "feae64578b0a3fba44f22230201969bb",
            "id": "5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272",
            "metadata": {},
            "name": "EndOfPageRecommendationQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationQuery($type:String!,$id:ID!,$exp:String!,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy},status{userCanToggle,isEnabled}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior}}"
        }
    };
}();
$5b8dbd4fd00aa380$var$node.hash = "89dc64ac31ebaadc798791741477c5f3";
var $5b8dbd4fd00aa380$export$2e2bcd8739ae039 = $5b8dbd4fd00aa380$var$node;
module.exports["default"] = $5b8dbd4fd00aa380$export$2e2bcd8739ae039;

});

parcelRegister("2rapj", function(module, exports) {
/**
 * @generated SignedSource<<ecf2ccf6da6891e95b8c24bfee1ef6f6>>
 * @relayHash c4c4095c882cb71b80fdf7c511e33e69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1d623029b3f50e0253d05074cea0ec94b1f823ad4c4b61177f50d160b5886b2
const $029fef3d04f7e0c0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cypherQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "keyString"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    }, v5 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "cypherQuery"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = {
        "kind": "ScalarField",
        "name": "pageId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v11 = {
        "alias": "pageStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v13 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v14 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v17 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v14 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ]
    }, v18 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "emoji-title-published"
            ]
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "value"
    }, v20 = [
        v6 /*: any*/ ,
        v19 /*: any*/ 
    ], v21 = {
        "kind": "ScalarField",
        "name": "blogPostId"
    }, v22 = {
        "alias": "blogPostStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v23 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    v14 /*: any*/ ,
                    v16 /*: any*/ ,
                    v1 /*: any*/ 
                ]
            },
            v1 /*: any*/ 
        ]
    }, v26 = [
        v6 /*: any*/ ,
        v19 /*: any*/ ,
        v1 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EndOfPageRecommendationTwgQuery",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluencePageProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v20 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluenceBlogPostProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v20 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EndOfPageRecommendationTwgQuery",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluencePageProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluenceBlogPostProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "AppUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsProjectDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "TeamCustomFieldValue"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "TeamType"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "ThirdPartyUser"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "c4c4095c882cb71b80fdf7c511e33e69",
            "id": "e1d623029b3f50e0253d05074cea0ec94b1f823ad4c4b61177f50d160b5886b2",
            "metadata": {},
            "name": "EndOfPageRecommendationTwgQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationTwgQuery($cypherQuery:String!,$first:Int,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior},graphStore_cypherQueryV2(query:$cypherQuery,first:$first)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id,data{__typename,...on ConfluencePage{pageId,title,type,subtype,pageStatus:status,links{webUi},space{id,key,alias,name},owner{user{__typename,name,accountId,id},id},properties(keys:[\"emoji-title-published\"]){key,value,id}},...on ConfluenceBlogPost{blogPostId,title,type,blogPostStatus:status,links{webUi},space{id,key,alias,name},owner{user{__typename,name,accountId,id},id},properties(keys:[\"emoji-title-published\"]){key,value,id}},...on Node{__isNode:__typename,id},...on AppUser{id},...on AtlassianAccountUser{id},...on CustomerUser{id},...on DevOpsFeatureFlag{id},...on DevOpsOperationsComponentDetails{id},...on DevOpsOperationsIncidentDetails{id},...on DevOpsOperationsPostIncidentReviewDetails{id},...on DevOpsProjectDetails{id},...on DevOpsPullRequestDetails{id},...on DevOpsRepository{id},...on DevOpsSecurityVulnerabilityDetails{id},...on JiraAutodevJob{id},...on JiraConfluenceRemoteIssueLink{id},...on JiraCustomRemoteIssueLink{id},...on JiraIssueRemoteIssueLink{id},...on JiraWebRemoteIssueLink{id},...on TeamCustomFieldValue{id},...on TeamType{id},...on ThirdPartyUser{id}}}}}}}}}"
        }
    };
}();
$029fef3d04f7e0c0$var$node.hash = "fde8f13a8c898c317f96538ff58fec17";
var $029fef3d04f7e0c0$export$2e2bcd8739ae039 = $029fef3d04f7e0c0$var$node;
module.exports["default"] = $029fef3d04f7e0c0$export$2e2bcd8739ae039;

});

parcelRegister("ky8L5", function(module, exports) {
// Shared query config + variable builders for the TWG recs query. Used by both the
// client hook and the SSR preloader so they issue byte-identical variables (needed
// for the client's cache-first read to hit the SSR-primed entry).
// TWG relationship for related Confluence content (spec: CA3).
const $5282e58fea25450f$var$TWG_RELATIONSHIP = 'confluence_content_has_related_confluence_content';
const $5282e58fea25450f$export$fe20e5d4b8358f61 = 12;
const $5282e58fea25450f$export$5bb8653eb6cf29f = (cloudId)=>`ari:cloud:platform::site/${cloudId}`;
const $5282e58fea25450f$export$46c71f7bb38c3d98 = (cloudId, contentId, contentType)=>`ari:cloud:confluence:${cloudId}:${contentType === 'blogpost' ? 'blogpost' : 'page'}/${contentId}`;
const $5282e58fea25450f$export$7135c395d1f4b359 = (pageAri)=>[
        `MATCH (page {ari: "${pageAri}"})-[:${$5282e58fea25450f$var$TWG_RELATIONSHIP}]->(entity)`,
        `RETURN DISTINCT entity AS ari`
    ].join('\n');
const $5282e58fea25450f$export$8d8ea6a33dea6f1f = (contentType)=>contentType === 'page' || contentType === 'blogpost';
module.exports["MAX_TWG_RECS"] = $5282e58fea25450f$export$fe20e5d4b8358f61;
module.exports["buildTwgQueryContext"] = $5282e58fea25450f$export$5bb8653eb6cf29f;
module.exports["buildTwgContentAri"] = $5282e58fea25450f$export$46c71f7bb38c3d98;
module.exports["buildTwgRecsCypher"] = $5282e58fea25450f$export$7135c395d1f4b359;
module.exports["isTwgSupportedContentType"] = $5282e58fea25450f$export$8d8ea6a33dea6f1f;

});

parcelRegister("38Ncj", function(module, exports) {
/**
 * @generated SignedSource<<97620748d8d680bcf5801bcd64a5c19f>>
 * @relayHash 21cebd3db50676fd19d57554f2f4d6fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904
const $630a58f9ca4672ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isContentTypePublicLinkEligible"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "condition": "isContentTypePublicLinkEligible",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "PublicLinkPage",
                    "kind": "LinkedField",
                    "name": "publicLinkPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "pageStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "21cebd3db50676fd19d57554f2f4d6fc",
            "id": "fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904",
            "metadata": {},
            "name": "useShareAndRestrictButtonDataQuery",
            "operationKind": "query",
            "text": "query useShareAndRestrictButtonDataQuery($contentId:ID!,$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId,pageStatus,accessType}}"
        }
    };
}();
$630a58f9ca4672ab$var$node.hash = "336fe7f51ff27baeb231379611028a5d";
var $630a58f9ca4672ab$export$2e2bcd8739ae039 = $630a58f9ca4672ab$var$node;
module.exports["default"] = $630a58f9ca4672ab$export$2e2bcd8739ae039;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<79c814000abc51a87825021048515fd1>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "031eb89bf77537fd501cf18345136db8";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("47TZD", function(module, exports) {

var $6B1vK = parcelRequire("6B1vK");

const $fb0dcbfe669881ea$export$8f6fbf7ac56d5471 = 3;
const $fb0dcbfe669881ea$var$SOURCE_COLUMN = 'source';
const $fb0dcbfe669881ea$export$6bfcbd8be080e9d0 = (contentId, status)=>Object.freeze({
        contentId: contentId,
        status: status
    });
const $fb0dcbfe669881ea$var$buildIncomingLinksCypher = (targetAri)=>[
        `MATCH (source)-[:content_referenced_entity]->(target:ConfluencePage {ari: "${targetAri}"})`,
        'WHERE source <> target',
        'RETURN source',
        `LIMIT ${$fb0dcbfe669881ea$export$8f6fbf7ac56d5471}`
    ].join('\n');
const $fb0dcbfe669881ea$export$5ecfd95d81f175ce = (cloudId, contentId)=>{
    if (!cloudId.trim() || !/^[1-9]\d*$/.test(contentId)) return undefined;
    let targetAri;
    try {
        targetAri = (0, $6B1vK.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString();
    } catch  {
        return undefined;
    }
    return {
        cypherQuery: $fb0dcbfe669881ea$var$buildIncomingLinksCypher(targetAri),
        first: $fb0dcbfe669881ea$export$8f6fbf7ac56d5471
    };
};
const $fb0dcbfe669881ea$export$ea0577b4a4a51553 = (data)=>{
    const edges = data?.graphStore_cypherQueryV2?.edges;
    if (!edges || edges.length > $fb0dcbfe669881ea$export$8f6fbf7ac56d5471) return {
        status: 'unavailable',
        reason: 'malformed-response'
    };
    for (const edge of edges){
        const columns = edge.node.columns;
        if (columns.length !== 1) return {
            status: 'unavailable',
            reason: 'malformed-response'
        };
        const column = columns[0];
        if (column.key !== $fb0dcbfe669881ea$var$SOURCE_COLUMN || column.value?.__typename !== 'GraphStoreCypherQueryV2AriNode' || typeof column.value.id !== 'string' || !column.value.id.startsWith('ari:')) return {
            status: 'unavailable',
            reason: 'malformed-response'
        };
    }
    return {
        status: 'available',
        count: edges.length
    };
};
const $fb0dcbfe669881ea$export$2f3db422bbda5145 = (contentId, data)=>{
    const result = $fb0dcbfe669881ea$export$ea0577b4a4a51553(data);
    if (result.status === 'unavailable') return $fb0dcbfe669881ea$export$6bfcbd8be080e9d0(contentId, 'unavailable');
    return $fb0dcbfe669881ea$export$6bfcbd8be080e9d0(contentId, result.count > 0 ? 'present' : 'empty');
};
module.exports["INCOMING_LINKS_SAMPLE_LIMIT"] = $fb0dcbfe669881ea$export$8f6fbf7ac56d5471;
module.exports["createIncomingLinksSsrState"] = $fb0dcbfe669881ea$export$6bfcbd8be080e9d0;
module.exports["buildIncomingLinksSampleVariables"] = $fb0dcbfe669881ea$export$5ecfd95d81f175ce;
module.exports["normalizeIncomingLinksSampleData"] = $fb0dcbfe669881ea$export$ea0577b4a4a51553;
module.exports["normalizeIncomingLinksSsrState"] = $fb0dcbfe669881ea$export$2f3db422bbda5145;

});

parcelRegister("6U179", function(module, exports) {
/**
 * @generated SignedSource<<ae7b4939fdea464930e0f014fce7c3a3>>
 * @relayHash 5ebf1285eea0f6e277ccc1791c349170
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83f26dc21ea579fed2d0d4ec2f290a108314a7d06a83cc5b9fbf80b01a76c7b9
const $784926291035c30b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cypherQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "cypherQuery"
                }
            ],
            "concreteType": "GraphStoreCypherQueryV2Connection",
            "kind": "LinkedField",
            "name": "graphStore_cypherQueryV2",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GraphStoreCypherQueryV2Edge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Node",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Column",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "GraphStoreCypherQueryV2AriNode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadIncomingLinksSampleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadIncomingLinksSampleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ebf1285eea0f6e277ccc1791c349170",
            "id": "83f26dc21ea579fed2d0d4ec2f290a108314a7d06a83cc5b9fbf80b01a76c7b9",
            "metadata": {},
            "name": "preloadIncomingLinksSampleQuery",
            "operationKind": "query",
            "text": "query preloadIncomingLinksSampleQuery($cypherQuery:String!,$first:Int!){graphStore_cypherQueryV2(query:$cypherQuery,first:$first)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id}}}}}}}"
        }
    };
}();
$784926291035c30b$var$node.hash = "60d2b49af10374001914afa2e5cda7a3";
var $784926291035c30b$export$2e2bcd8739ae039 = $784926291035c30b$var$node;
module.exports["default"] = $784926291035c30b$export$2e2bcd8739ae039;

});

parcelRegister("66MEr", function(module, exports) {
/**
 * @generated SignedSource<<9f25470e51da80e6750dd1882868cfe2>>
 * @relayHash d52e66d12a0624aac2fdbfe49ab48ab1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c1dd07ac639cb5bde54983be5bcee1631624741f1f5249dd51307802eefc42d
const $f3a6ef2390da2925$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 3
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "OutgoingLinks",
                            "kind": "LinkedField",
                            "name": "outgoingLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "ConfluenceExternalLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "externalOutgoingLinks",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceExternalLink",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "externalOutgoingLinks(first:3)"
                                },
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "PaginatedContentList",
                                    "kind": "LinkedField",
                                    "name": "internalOutgoingLinks",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "base"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webui"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "internalOutgoingLinks(first:3)"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadOutboundBylineSsrStateQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadOutboundBylineSsrStateQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "d52e66d12a0624aac2fdbfe49ab48ab1",
            "id": "8c1dd07ac639cb5bde54983be5bcee1631624741f1f5249dd51307802eefc42d",
            "metadata": {},
            "name": "preloadOutboundBylineSsrStateQuery",
            "operationKind": "query",
            "text": "query preloadOutboundBylineSsrStateQuery($contentId:ID!){content(id:$contentId){nodes{id,outgoingLinks{externalOutgoingLinks(first:3){nodes{url}},internalOutgoingLinks(first:3){nodes{id,links{base,webui}}}}}}}"
        }
    };
}();
$f3a6ef2390da2925$var$node.hash = "aadfb15d662296b74dd0622642b547bf";
var $f3a6ef2390da2925$export$2e2bcd8739ae039 = $f3a6ef2390da2925$var$node;
module.exports["default"] = $f3a6ef2390da2925$export$2e2bcd8739ae039;

});

parcelRegister("3C8hL", function(module, exports) {

var $jJhQa = parcelRequire("jJhQa");

function $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, status, iconCount) {
    if (status === 'present') return Object.freeze({
        contentId: contentId,
        status: status,
        iconCount: iconCount ?? 0
    });
    return Object.freeze({
        contentId: contentId,
        status: status
    });
}
const $55debb7a67d5b98d$export$e84841b18fa82831 = (outboundState, hasDevDocsConnection)=>{
    const hasOutboundSignal = outboundState?.status === 'present' || outboundState?.status === 'unavailable' || hasDevDocsConnection;
    // Without an outbound signal the placeholder is logo-and-label only, so reserve no app tiles.
    if (!hasOutboundSignal) return 0;
    // 'unavailable' gives no reliable estimate, so reserve the maximum.
    if (outboundState?.status === 'unavailable') return 0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS;
    const outboundIconCount = outboundState?.status === 'present' ? outboundState.iconCount : 0;
    const devDocsIconCount = hasDevDocsConnection ? 1 : 0;
    return Math.min(Math.max(outboundIconCount + devDocsIconCount, 1), (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS));
};
const $55debb7a67d5b98d$var$isNullOrUndefined = (value)=>{
    if (value === null) return true;
    return value === undefined;
};
const $55debb7a67d5b98d$var$getHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return undefined;
    }
};
const $55debb7a67d5b98d$var$countDistinctDomains = (externalNodes, internalNodes)=>{
    const domains = new Set();
    for (const node of externalNodes){
        const url = node?.url;
        if (typeof url !== 'string') continue;
        // Skip host-less schemes (mailto:, tel:) whose empty hostname would count as a domain.
        const hostname = $55debb7a67d5b98d$var$getHostname(url);
        if (hostname) domains.add(hostname);
    }
    if (internalNodes.length > 0) domains.add('__internal__');
    return Math.min(domains.size, (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS));
};
const $55debb7a67d5b98d$var$isValidOutgoingLinksResponse = (actualContentId, expectedContentId, collections)=>{
    if (actualContentId !== expectedContentId) return false;
    if ($55debb7a67d5b98d$var$isNullOrUndefined(collections.externalNodes)) return false;
    if ($55debb7a67d5b98d$var$isNullOrUndefined(collections.internalNodes)) return false;
    return true;
};
const $55debb7a67d5b98d$export$6a56c90936a4d835 = (contentId, data)=>{
    const contentNodes = data?.content?.nodes;
    if ($55debb7a67d5b98d$var$isNullOrUndefined(contentNodes) || contentNodes.length !== 1) return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'unavailable');
    const content = contentNodes[0];
    const collections = {
        externalNodes: content?.outgoingLinks?.externalOutgoingLinks?.nodes,
        internalNodes: content?.outgoingLinks?.internalOutgoingLinks?.nodes
    };
    if (!$55debb7a67d5b98d$var$isValidOutgoingLinksResponse(content?.id, contentId, collections)) return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'unavailable');
    const { externalNodes: externalNodes, internalNodes: internalNodes } = collections;
    const hasMalformedExternalNode = externalNodes.some((node)=>typeof node?.url !== 'string' || node.url.length === 0);
    const hasMalformedInternalNode = internalNodes.some((node)=>{
        const base = node?.links?.base;
        const webui = node?.links?.webui;
        return !(typeof base === 'string' && base.length > 0 || typeof webui === 'string' && webui.length > 0);
    });
    if (hasMalformedExternalNode || hasMalformedInternalNode) return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'unavailable');
    if (externalNodes.length === 0 && internalNodes.length === 0) return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'empty');
    return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'present', $55debb7a67d5b98d$var$countDistinctDomains(externalNodes, internalNodes));
};
module.exports["createOutboundBylineSsrState"] = $55debb7a67d5b98d$export$f1091f4b134fe3fc;
module.exports["getReservedBylineIconCount"] = $55debb7a67d5b98d$export$e84841b18fa82831;
module.exports["normalizeOutboundBylineSsrState"] = $55debb7a67d5b98d$export$6a56c90936a4d835;

});

parcelRegister("jJhQa", function(module, exports) {

var $hDf5o = parcelRequire("hDf5o");


var $5b9Ab = parcelRequire("5b9Ab");

const $414ed69874d93138$export$391068ad89fee276 = 3;
const $414ed69874d93138$var$isUnconnectedSmartLink = (link)=>link.access !== 'granted';
const $414ed69874d93138$var$toIcon = (link, icon)=>{
    const product = (0, $hDf5o.formatLabel)(link.product);
    return {
        key: product || icon.key,
        label: product ?? icon.label ?? '',
        icon: icon
    };
};
const $414ed69874d93138$var$dedupeIcons = (icons)=>{
    const seenKeys = new Set();
    const dedupedIcons = [];
    for (const icon of icons)if (!seenKeys.has(icon.key)) {
        seenKeys.add(icon.key);
        dedupedIcons.push(icon);
    }
    return dedupedIcons;
};
const $414ed69874d93138$var$sortRankedIcons = (left, right)=>{
    if (left.isUnconnected !== right.isUnconnected) return Number(right.isUnconnected) - Number(left.isUnconnected);
    return left.occurrenceIndex - right.occurrenceIndex;
};
const $414ed69874d93138$export$a95e00393b41fca9 = (links, additionalIcons = [])=>{
    const rankedIcons = [];
    for (const link of links){
        const icon = (0, $5b9Ab.getSmartLinkIcon)(link);
        if (!icon) continue;
        rankedIcons.push({
            icon: $414ed69874d93138$var$toIcon(link, icon),
            isUnconnected: $414ed69874d93138$var$isUnconnectedSmartLink(link),
            occurrenceIndex: link.occurrenceIndex
        });
    }
    rankedIcons.sort($414ed69874d93138$var$sortRankedIcons);
    const sortedIcons = [
        ...additionalIcons,
        ...rankedIcons.map(({ icon: icon })=>icon)
    ];
    return $414ed69874d93138$var$dedupeIcons(sortedIcons).slice(0, $414ed69874d93138$export$391068ad89fee276);
};
module.exports["MAX_BYLINE_CONNECTION_ICONS"] = $414ed69874d93138$export$391068ad89fee276;
module.exports["getBylineConnectionIcons"] = $414ed69874d93138$export$a95e00393b41fca9;

});

parcelRegister("hDf5o", function(module, exports) {
function $1f3713d3e01cb733$export$957d7daebd899f12(value) {
    if (!value || !Number.isNaN(Number(value))) return undefined;
    return value.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}
module.exports["formatLabel"] = $1f3713d3e01cb733$export$957d7daebd899f12;

});

parcelRegister("5b9Ab", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kTb7m = parcelRequire("kTb7m");


var $3Xkfu = parcelRequire("3Xkfu");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");

const $8753b7baffe8fa69$var$getUrlOrigin = (url)=>{
    try {
        return new URL(url).origin;
    } catch  {
        return url;
    }
};
const $8753b7baffe8fa69$var$isUrlLabelTuple = (icon)=>Array.isArray(icon) && typeof icon[0] === 'string';
const $8753b7baffe8fa69$var$normalizeInlineIcon = (source, inlineIcon, label)=>{
    if (typeof inlineIcon === 'string') return {
        src: inlineIcon,
        key: `url:${$8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${inlineIcon}`,
        label: label,
        kind: 'image'
    };
    // Link extractors returns [url, label] for entity icons behind platform_lp_use_entity_icon_url_for_icon.
    if ($8753b7baffe8fa69$var$isUrlLabelTuple(inlineIcon)) {
        const [iconUrl, iconLabel] = inlineIcon;
        return {
            src: iconUrl,
            key: `url:${$8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${iconUrl}`,
            label: iconLabel ?? label,
            kind: 'image'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(inlineIcon)) return {
        node: inlineIcon,
        key: `node:${source.product ?? $8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${source.ari ?? source.occurrenceIndex}`,
        label: label ?? source.product,
        kind: 'element'
    };
    return undefined;
};
// extractSmartLinkInlineIcon throws on malformed JSON-LD (e.g. a string `generator`, or an entity
// `meta.generator` missing name/icon). Fall back to a neutral link icon so one bad response doesn't
// break icon building for the whole byline — mirrors the failed-image fallback in SmartLinkIconRenderer.
const $8753b7baffe8fa69$var$createFallbackIcon = (source)=>({
        node: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: '',
            color: "var(--ds-icon-subtle, #505258)"
        }),
        key: `fallback:${$8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${source.ari ?? source.occurrenceIndex}`,
        label: source.product,
        kind: 'element'
    });
const $8753b7baffe8fa69$export$d1801a90e60dadcf = (url, source)=>$8753b7baffe8fa69$var$normalizeInlineIcon(source, url, source.product);
const $8753b7baffe8fa69$export$35040aed9264b11c = (response, source)=>{
    let inlineIcon;
    try {
        inlineIcon = (0, $3Xkfu.extractSmartLinkInlineIcon)(response ?? undefined, false);
    } catch (err) {
        const errorObj = err instanceof Error ? err : new Error(String(err));
        (0, $5ZqQS.getMonitoringClient)().submitError(errorObj, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        return $8753b7baffe8fa69$var$createFallbackIcon(source);
    }
    return $8753b7baffe8fa69$var$normalizeInlineIcon(source, inlineIcon, source.product);
};
const $8753b7baffe8fa69$export$1d1e77a71ad0be9f = (link)=>{
    // Keep iconUrl as a compatibility fallback for EnhancedSmartLink objects built before icon normalization.
    return link.icon ?? (link.iconUrl ? $8753b7baffe8fa69$var$normalizeInlineIcon(link, link.iconUrl, link.product) : undefined);
};
module.exports["buildImageIcon"] = $8753b7baffe8fa69$export$d1801a90e60dadcf;
module.exports["extractSmartLinkIcon"] = $8753b7baffe8fa69$export$35040aed9264b11c;
module.exports["getSmartLinkIcon"] = $8753b7baffe8fa69$export$1d1e77a71ad0be9f;

});

parcelRegister("3Xkfu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kkFbH = parcelRequire("kkFbH");


var $fBqzD = parcelRequire("fBqzD");


var $iMQz5 = parcelRequire("iMQz5");


var $fHe6f = parcelRequire("fHe6f");


var $ahlZa = parcelRequire("ahlZa");


var $3CYX0 = parcelRequire("3CYX0");


var $39Mwn = parcelRequire("39Mwn");


var $6MsAF = parcelRequire("6MsAF");


var $38zdI = parcelRequire("38zdI");


var $cVpj0 = parcelRequire("cVpj0");


var $gITbz = parcelRequire("gITbz");


var $bvjEB = parcelRequire("bvjEB");


var $jMFOf = parcelRequire("jMFOf");


var $a5G9M = parcelRequire("a5G9M");


var $S7fVP = parcelRequire("S7fVP");


var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");


var $kku4L = parcelRequire("kku4L");


var $g0csk = parcelRequire("g0csk");


var $2A177 = parcelRequire("2A177");


var $jqhMF = parcelRequire("jqhMF");


var $2GG3F = parcelRequire("2GG3F");


var $jrSlu = parcelRequire("jrSlu");


var $c1Kdq = parcelRequire("c1Kdq");


var $kAdyG = parcelRequire("kAdyG");

const $f1ce3764841d3d06$var$extractorPriorityMap = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
const $f1ce3764841d3d06$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $f1ce3764841d3d06$var$getEmptyJsonLd = ()=>$f1ce3764841d3d06$var$emptyData;
const $f1ce3764841d3d06$var$prioritiseIcon = ({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon })=>urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
const $f1ce3764841d3d06$var$extractTaskType = (jsonLd)=>{
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
const $f1ce3764841d3d06$var$extractFileFormat = (jsonLd)=>jsonLd['schema:fileFormat'];
const $f1ce3764841d3d06$var$documentLabel = (opts, label)=>{
    if (!opts.showIconLabel) return '';
    return (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? label : opts.title || label;
};

const $f1ce3764841d3d06$var$getBlogIconWrapped = ()=>(parcelRequire("6kJW0")).default;

const $f1ce3764841d3d06$var$getDocumentIcon = ()=>(parcelRequire("9v3GN")).default;

const $f1ce3764841d3d06$var$getFileIcon = ()=>(parcelRequire("4Emmj")).default;

const $f1ce3764841d3d06$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("dGdE6")).default;

const $f1ce3764841d3d06$var$getPresentationIcon = ()=>(parcelRequire("b5Dss")).default;

const $f1ce3764841d3d06$var$getSpreadsheetIcon = ()=>(parcelRequire("7vzLW")).default;
const $f1ce3764841d3d06$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $c1Kdq.isConfluenceGenerator)(opts.provider.id)) {
        const LiveDocumentIconWrapped = $f1ce3764841d3d06$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LiveDocumentIconWrapped, {
            label: $f1ce3764841d3d06$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
    }
    const FileIcon = $f1ce3764841d3d06$var$getFileIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FileIcon, {
        label: $f1ce3764841d3d06$var$documentLabel(opts, 'file'),
        testId: "file-icon"
    });
};
const $f1ce3764841d3d06$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                const BlogIconWrapped = $f1ce3764841d3d06$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlogIconWrapped, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $f1ce3764841d3d06$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $f1ce3764841d3d06$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PresentationIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'presentation'),
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $f1ce3764841d3d06$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpreadsheetIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'spreadsheet'),
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                color: "currentColor",
                label: $f1ce3764841d3d06$var$documentLabel(opts, 'template'),
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
    }
};
const $f1ce3764841d3d06$var$extractIconFromDocument = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconFromTask = (opts)=>{
    const { taskType: taskType, provider: provider } = opts;
    const legacyTaskLabel = opts.title || 'task';
    const getLabel = (semantic)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : legacyTaskLabel;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
        label: getLabel('Task'),
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $hhrxw.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $hhrxw.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                    label: getLabel('Task'),
                    testId: "jira-task-icon"
                });
            case 0, $hhrxw.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jMFOf.default), {
                    label: getLabel('Sub-task'),
                    testId: "jira-subtask-icon"
                });
            case 0, $hhrxw.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvjEB.default), {
                    label: getLabel('Story'),
                    testId: "jira-story-icon"
                });
            case 0, $hhrxw.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fHe6f.default), {
                    label: getLabel('Bug'),
                    testId: "jira-bug-icon"
                });
            case 0, $hhrxw.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MsAF.default), {
                    label: getLabel('Epic'),
                    testId: "jira-epic-icon"
                });
            case 0, $hhrxw.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38zdI.default), {
                    label: getLabel('Incident'),
                    testId: "jira-incident-icon"
                });
            case 0, $hhrxw.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                    label: getLabel('Service request'),
                    testId: "jira-service-request-icon"
                });
            case 0, $hhrxw.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ahlZa.default), {
                    label: getLabel('Change'),
                    testId: "jira-change-icon"
                });
            case 0, $hhrxw.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVpj0.default), {
                    label: getLabel('Problem'),
                    testId: "jira-problem-icon"
                });
            case 0, $hhrxw.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};
const $f1ce3764841d3d06$var$typeToIcon = (type, opts)=>{
    const getLabel = (title)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? title : opts.title || title;
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39Mwn.default), {
                label: getLabel('commit'),
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                label: getLabel('project'),
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gITbz.default), {
                label: getLabel('pull request'),
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMQz5.default), {
                label: getLabel('reference'),
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3CYX0.default), {
                label: getLabel('repository'),
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                label: getLabel('goal'),
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return $f1ce3764841d3d06$var$extractIconFromTask(opts);
        default:
            return undefined;
    }
};
const $f1ce3764841d3d06$var$standardisedExtractIcon = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return $f1ce3764841d3d06$var$extractIconFromDocument(type, opts);
        default:
            return type ? $f1ce3764841d3d06$var$standardisedExtractIcon(type, opts) : undefined;
    }
};
const $f1ce3764841d3d06$var$extractIcon = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        ...(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? {} : {
            title: (0, $jqhMF.extractTitle)(jsonLd)
        },
        provider: (0, $2A177.extractProvider)(jsonLd),
        fileFormat: $f1ce3764841d3d06$var$extractFileFormat(jsonLd),
        taskType: $f1ce3764841d3d06$var$extractTaskType(jsonLd),
        icon: jsonLd.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>$f1ce3764841d3d06$var$extractorPriorityMap[b] - $f1ce3764841d3d06$var$extractorPriorityMap[a])[0];
        return $f1ce3764841d3d06$var$extractIconByType(highestPriorityType, opts);
    } else return $f1ce3764841d3d06$var$extractIconByType(type, opts);
};
const $f1ce3764841d3d06$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $2A177.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $hhrxw.JIRA_GENERATOR_ID)) return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'type', showIconLabel);
    }
    return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'provider', showIconLabel);
};
const $f1ce3764841d3d06$export$643db2ee2409e635 = (response, showLabel = true)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entityIcon = (0, $kku4L.extractEntityIcon)(response);
        if (entityIcon) return [
            entityIcon.url,
            entityIcon.label
        ];
        const provider = (0, $g0csk.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $f1ce3764841d3d06$var$extractInlineIcon(response?.data || $f1ce3764841d3d06$var$getEmptyJsonLd(), showLabel);
};
module.exports["extractSmartLinkInlineIcon"] = $f1ce3764841d3d06$export$643db2ee2409e635;

});

parcelRegister("iMQz5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $4hmAW = parcelRequire("4hmAW");

const $6e22e7dea691eafe$var$BranchObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BranchObject({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $6e22e7dea691eafe$export$2e2bcd8739ae039 = $6e22e7dea691eafe$var$BranchObject;
module.exports["default"] = $6e22e7dea691eafe$export$2e2bcd8739ae039;

});

parcelRegister("fHe6f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $4hmAW = parcelRequire("4hmAW");

const $344e992330cc90e5$var$BugObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $344e992330cc90e5$export$2e2bcd8739ae039 = $344e992330cc90e5$var$BugObject;
module.exports["default"] = $344e992330cc90e5$export$2e2bcd8739ae039;

});

parcelRegister("ahlZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $4hmAW = parcelRequire("4hmAW");

const $4e5aedb3fb5b2488$var$ChangesObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ChangesObject({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $4e5aedb3fb5b2488$export$2e2bcd8739ae039 = $4e5aedb3fb5b2488$var$ChangesObject;
module.exports["default"] = $4e5aedb3fb5b2488$export$2e2bcd8739ae039;

});

parcelRegister("3CYX0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $4hmAW = parcelRequire("4hmAW");

const $ff9912959f94fce6$var$CodeObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Code" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CodeObject({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $ff9912959f94fce6$export$2e2bcd8739ae039 = $ff9912959f94fce6$var$CodeObject;
module.exports["default"] = $ff9912959f94fce6$export$2e2bcd8739ae039;

});

parcelRegister("39Mwn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $4hmAW = parcelRequire("4hmAW");

const $29a7acb65f94e0ba$var$CommitObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CommitObject({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $29a7acb65f94e0ba$export$2e2bcd8739ae039 = $29a7acb65f94e0ba$var$CommitObject;
module.exports["default"] = $29a7acb65f94e0ba$export$2e2bcd8739ae039;

});

parcelRegister("6MsAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $4hmAW = parcelRequire("4hmAW");

const $caa0390e0439cdc5$var$EpicObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $caa0390e0439cdc5$export$2e2bcd8739ae039 = $caa0390e0439cdc5$var$EpicObject;
module.exports["default"] = $caa0390e0439cdc5$export$2e2bcd8739ae039;

});

parcelRegister("38zdI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $4hmAW = parcelRequire("4hmAW");

const $021e642953ecdf56$var$IncidentObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function IncidentObject({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $021e642953ecdf56$export$2e2bcd8739ae039 = $021e642953ecdf56$var$IncidentObject;
module.exports["default"] = $021e642953ecdf56$export$2e2bcd8739ae039;

});

parcelRegister("cVpj0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $4hmAW = parcelRequire("4hmAW");

const $c45be7d7373a5bd1$var$ProblemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ProblemObject({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $c45be7d7373a5bd1$export$2e2bcd8739ae039 = $c45be7d7373a5bd1$var$ProblemObject;
module.exports["default"] = $c45be7d7373a5bd1$export$2e2bcd8739ae039;

});

parcelRegister("gITbz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $4hmAW = parcelRequire("4hmAW");

const $d9b76c60fcca1e74$var$PullRequestObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PullRequestObject({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $d9b76c60fcca1e74$export$2e2bcd8739ae039 = $d9b76c60fcca1e74$var$PullRequestObject;
module.exports["default"] = $d9b76c60fcca1e74$export$2e2bcd8739ae039;

});

parcelRegister("bvjEB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $4hmAW = parcelRequire("4hmAW");

const $1e23ddd70a37a65a$var$StoryObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $1e23ddd70a37a65a$export$2e2bcd8739ae039 = $1e23ddd70a37a65a$var$StoryObject;
module.exports["default"] = $1e23ddd70a37a65a$export$2e2bcd8739ae039;

});

parcelRegister("jMFOf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $4hmAW = parcelRequire("4hmAW");

const $08adce465a629da4$var$SubtaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function SubtaskObject({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $08adce465a629da4$export$2e2bcd8739ae039 = $08adce465a629da4$var$SubtaskObject;
module.exports["default"] = $08adce465a629da4$export$2e2bcd8739ae039;

});

parcelRegister("a5G9M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $4hmAW = parcelRequire("4hmAW");

const $dcf12dc0efc2d892$var$TaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $dcf12dc0efc2d892$export$2e2bcd8739ae039 = $dcf12dc0efc2d892$var$TaskObject;
module.exports["default"] = $dcf12dc0efc2d892$export$2e2bcd8739ae039;

});

parcelRegister("S7fVP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $4hmAW = parcelRequire("4hmAW");

const $ae65607ca2739f04$var$WorkItemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $ae65607ca2739f04$export$2e2bcd8739ae039 = $ae65607ca2739f04$var$WorkItemObject;
module.exports["default"] = $ae65607ca2739f04$export$2e2bcd8739ae039;

});

parcelRegister("jrSlu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");


var $l8WFq = parcelRequire("l8WFq");























const $73d439951cf388f8$var$getLazyIcons = ()=>({
        [(0, $hhrxw.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9v3GN")))
        },
        [(0, $hhrxw.IconType).Audio]: {
            default: ()=>(parcelRequire("kPWC0"))
        },
        [(0, $hhrxw.IconType).Code]: {
            default: ()=>(parcelRequire("7nVQ2"))
        },
        [(0, $hhrxw.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Folder]: {
            default: ()=>(parcelRequire("9VLzs"))
        },
        [(0, $hhrxw.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Image]: {
            default: ()=>(parcelRequire("j9LJx"))
        },
        [(0, $hhrxw.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("b5Dss")))
        },
        [(0, $hhrxw.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("7vzLW")))
        },
        [(0, $hhrxw.IconType).Video]: {
            default: ()=>(parcelRequire("96zb4"))
        },
        [(0, $hhrxw.IconType).Archive]: {
            default: ()=>(parcelRequire("8KvsV"))
        },
        [(0, $hhrxw.IconType).Executable]: {
            default: ()=>(parcelRequire("kKj89"))
        },
        [(0, $hhrxw.IconType).GIF]: {
            default: ()=>(parcelRequire("1N5Ke"))
        },
        [(0, $hhrxw.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("7KlQ2"))
        },
        [(0, $hhrxw.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("4D6tQ"))
        },
        [(0, $hhrxw.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("30pMN"))
        },
        [(0, $hhrxw.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("hbVly"))
        },
        [(0, $hhrxw.IconType).MSExcel]: {
            default: ()=>(parcelRequire("5eRas"))
        },
        [(0, $hhrxw.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("bmQsw"))
        },
        [(0, $hhrxw.IconType).MSWord]: {
            default: ()=>(parcelRequire("3tCrI"))
        },
        [(0, $hhrxw.IconType).PDF]: {
            default: ()=>(parcelRequire("eiZGU"))
        },
        [(0, $hhrxw.IconType).Sketch]: {
            default: ()=>(parcelRequire("ldRXm"))
        }
    });
const $73d439951cf388f8$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $l8WFq.default)(fileFormat);
    if (!iconDescriptor?.icon) return null;
    const lazyIcons = $73d439951cf388f8$var$getLazyIcons();
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) return [
        lazyIcons[iconDescriptor.icon]?.default,
        iconDescriptor.label ?? ''
    ];
    return [
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $73d439951cf388f8$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    const icon = $73d439951cf388f8$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "hbd6r",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    });
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const descriptorLabel = icon[1] || '';
        const label = showIconLabel ?? true ? descriptorLabel : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            testId: "document-file-format-icon",
            label: label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        testId: "document-file-format-icon"
    });
};
module.exports["getIconForFileType"] = $73d439951cf388f8$export$4d685c85ebc7a1e3;

});

parcelRegister("l8WFq", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");

const $eb169b73453c71b7$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            icon: icon,
            label: label
        } : {
            icon: icon
        };
    switch(fileFormat){
        case 'folder':
            return getIconDescriptor((0, $hhrxw.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $hhrxw.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $hhrxw.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $hhrxw.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $hhrxw.IconType).Spreadsheet, 'spreadsheet');
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSlides, 'google slide');
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $hhrxw.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $hhrxw.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $hhrxw.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $hhrxw.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $hhrxw.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $hhrxw.IconType).Video, 'video');
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $hhrxw.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $hhrxw.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $hhrxw.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $hhrxw.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
        case 'application/invision.prototype':
            return getIconDescriptor((0, $hhrxw.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $eb169b73453c71b7$export$2e2bcd8739ae039 = $eb169b73453c71b7$var$extractFileFormatIcon;
module.exports["default"] = $eb169b73453c71b7$export$2e2bcd8739ae039;

});

parcelRegister("kPWC0", function(module, exports) {

let $f2b60935c73a6c05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f2b60935c73a6c05$var$load("gkVge"),
    $f2b60935c73a6c05$var$load("hLbGw")
]).then(()=>parcelRequire('hyaPI'));

});

parcelRegister("7nVQ2", function(module, exports) {

let $56078bdb4bba4b6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56078bdb4bba4b6f$var$load("kDfOJ").then(()=>parcelRequire('gMML3'));

});

parcelRegister("9VLzs", function(module, exports) {

let $73ae5688c13ac7f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73ae5688c13ac7f1$var$load("6wr18"),
    $73ae5688c13ac7f1$var$load("ffEVr"),
    $73ae5688c13ac7f1$var$load("iN2uJ")
]).then(()=>parcelRequire('giuMD'));

});

parcelRegister("j9LJx", function(module, exports) {

let $df23e277716dc04b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $df23e277716dc04b$var$load("6wr18"),
    $df23e277716dc04b$var$load("ffEVr"),
    $df23e277716dc04b$var$load("6aZeI")
]).then(()=>parcelRequire('4b38C'));

});

parcelRegister("96zb4", function(module, exports) {

let $6a0ff61f5e39486f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6a0ff61f5e39486f$var$load("6wr18"),
    $6a0ff61f5e39486f$var$load("ffEVr"),
    $6a0ff61f5e39486f$var$load("8TGE7")
]).then(()=>parcelRequire('8aT6O'));

});

parcelRegister("8KvsV", function(module, exports) {

let $65eb06ff5571b2cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65eb06ff5571b2cc$var$load("5JWJI").then(()=>parcelRequire('iqehY'));

});

parcelRegister("kKj89", function(module, exports) {

let $f1a6f16f6403b629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1a6f16f6403b629$var$load("aQ5uu").then(()=>parcelRequire('3OVVx'));

});

parcelRegister("1N5Ke", function(module, exports) {

let $14ded2ce3ce05390$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14ded2ce3ce05390$var$load("geXPZ").then(()=>parcelRequire('EhIdb'));

});

parcelRegister("7KlQ2", function(module, exports) {

let $5a3dc4e9d091ba35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3dc4e9d091ba35$var$load("b4nm1").then(()=>parcelRequire('hmd8r'));

});

parcelRegister("4D6tQ", function(module, exports) {

let $35efd4ccf002d2a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35efd4ccf002d2a8$var$load("jfYeU").then(()=>parcelRequire('lLxTI'));

});

parcelRegister("30pMN", function(module, exports) {

let $23055fbb4908668b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23055fbb4908668b$var$load("kYkz1").then(()=>parcelRequire('kUQwC'));

});

parcelRegister("hbVly", function(module, exports) {

let $c83ff29c592bd62f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c83ff29c592bd62f$var$load("5kI0b").then(()=>parcelRequire('1G3Dq'));

});

parcelRegister("5eRas", function(module, exports) {

let $3d078090de5174e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d078090de5174e1$var$load("3i44s").then(()=>parcelRequire('1kVaD'));

});

parcelRegister("bmQsw", function(module, exports) {

let $846a710eb4b35adb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $846a710eb4b35adb$var$load("4QwAJ").then(()=>parcelRequire('aeJll'));

});

parcelRegister("3tCrI", function(module, exports) {

let $2881e71a7d44971f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2881e71a7d44971f$var$load("fHlIz").then(()=>parcelRequire('8If3N'));

});

parcelRegister("eiZGU", function(module, exports) {

let $a6a299b1e4e47c5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6a299b1e4e47c5f$var$load("aaRXj").then(()=>parcelRequire('8B1YK'));

});

parcelRegister("ldRXm", function(module, exports) {

let $f734aa7c232eacf4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f734aa7c232eacf4$var$load("6OMo6").then(()=>parcelRequire('AzmWu'));

});

parcelRegister("c1Kdq", function(module, exports) {

var $hhrxw = parcelRequire("hhrxw");

const $b2f43b4ca89bcf94$export$38df542ff03a4183 = (id)=>{
    return id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID);
};
module.exports["isConfluenceGenerator"] = $b2f43b4ca89bcf94$export$38df542ff03a4183;

});

parcelRegister("6kJW0", function(module, exports) {

var $iW3KC = parcelRequire("iW3KC");


var $ai0Ge = parcelRequire("ai0Ge");


var $eqhrF = parcelRequire("eqhrF");

// eslint-disable-next-line @typescript-eslint/ban-types
const $616e4ede6f48d352$var$BlogIconWithColor = (0, $eqhrF.renderIconPerSize)((0, $iW3KC.default), (0, $ai0Ge.default));
$616e4ede6f48d352$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $616e4ede6f48d352$export$2e2bcd8739ae039 = $616e4ede6f48d352$var$BlogIconWithColor;
module.exports["default"] = $616e4ede6f48d352$export$2e2bcd8739ae039;

});

parcelRegister("ai0Ge", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $36820b590bf4d8fd$var$BlogObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $36820b590bf4d8fd$export$2e2bcd8739ae039 = $36820b590bf4d8fd$var$BlogObjectTile;
module.exports["default"] = $36820b590bf4d8fd$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size
        }, t3);
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: label,
        color: color,
        testId: testId,
        // @ts-expect-error - Internal, undocumented prop
        shouldScale: true
    }));
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("eqhrF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hhrxw = parcelRequire("hhrxw");

const $ef7997acb045a8f6$var$isIconSizeLarge = (size)=>size && [
        (0, $hhrxw.SmartLinkSize).Large,
        (0, $hhrxw.SmartLinkSize).XLarge
    ].includes(size);
const $ef7997acb045a8f6$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ($ef7997acb045a8f6$var$isIconSizeLarge(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectIcon, props);
    };
};
module.exports["renderIconPerSize"] = $ef7997acb045a8f6$export$28dd5ad82647c000;

});

parcelRegister("9v3GN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hMaHH = parcelRequire("hMaHH");


var $9D4WS = parcelRequire("9D4WS");

const $fc0d527adbaaccfa$var$PageIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), 'blueBold');
$fc0d527adbaaccfa$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $fc0d527adbaaccfa$export$2e2bcd8739ae039 = $fc0d527adbaaccfa$var$PageIconWithColor;
module.exports["default"] = $fc0d527adbaaccfa$export$2e2bcd8739ae039;

});

parcelRegister("9D4WS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lSQgn = parcelRequire("lSQgn");


var $6nWVS = parcelRequire("6nWVS");

const $eb6ec3e0096439cb$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $eb6ec3e0096439cb$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = (0, $6nWVS.transformSmartLinkSizeToIconTileSize)(size);
        if (tileSize === undefined) {
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                color: $eb6ec3e0096439cb$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["renderIconTile"] = $eb6ec3e0096439cb$export$87c3646d0e299cfe;

});

parcelRegister("6nWVS", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");

const $7fb62870d007a2a2$export$3acc3fb10995f020 = (size)=>{
    if ((0, $iDrrr.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $hhrxw.SmartLinkSize).Small:
        case (0, $hhrxw.SmartLinkSize).Medium:
            return undefined;
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $7fb62870d007a2a2$export$3acc3fb10995f020;

});

parcelRegister("4Emmj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $9D4WS = parcelRequire("9D4WS");

const $30795df12c6626e4$var$FileIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$30795df12c6626e4$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $30795df12c6626e4$export$2e2bcd8739ae039 = $30795df12c6626e4$var$FileIconWithColor;
module.exports["default"] = $30795df12c6626e4$export$2e2bcd8739ae039;

});

parcelRegister("dGdE6", function(module, exports) {

var $7pJjg = parcelRequire("7pJjg");


var $dipyx = parcelRequire("dipyx");


var $eqhrF = parcelRequire("eqhrF");

// eslint-disable-next-line @typescript-eslint/ban-types
const $c10f705a5270d647$var$LiveDocumentIconWithColor = (0, $eqhrF.renderIconPerSize)((0, $7pJjg.default), (0, $dipyx.default));
$c10f705a5270d647$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $c10f705a5270d647$export$2e2bcd8739ae039 = $c10f705a5270d647$var$LiveDocumentIconWithColor;
module.exports["default"] = $c10f705a5270d647$export$2e2bcd8739ae039;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("dipyx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gEyoZ = parcelRequire("gEyoZ");

const $5d01faeb97b0ed22$var$PageLiveDocObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $5d01faeb97b0ed22$export$2e2bcd8739ae039 = $5d01faeb97b0ed22$var$PageLiveDocObjectTile;
module.exports["default"] = $5d01faeb97b0ed22$export$2e2bcd8739ae039;

});

parcelRegister("b5Dss", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $9D4WS = parcelRequire("9D4WS");

// eslint-disable-next-line @typescript-eslint/ban-types
const $77093538826d7e25$var$ChartBarIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$77093538826d7e25$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $77093538826d7e25$export$2e2bcd8739ae039 = $77093538826d7e25$var$ChartBarIconWithColor;
module.exports["default"] = $77093538826d7e25$export$2e2bcd8739ae039;

});

parcelRegister("7vzLW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $9D4WS = parcelRequire("9D4WS");

const $7d25c80ed1a76c0d$var$ListBulletedIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$7d25c80ed1a76c0d$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $7d25c80ed1a76c0d$export$2e2bcd8739ae039 = $7d25c80ed1a76c0d$var$ListBulletedIconWithColor;
module.exports["default"] = $7d25c80ed1a76c0d$export$2e2bcd8739ae039;

});

parcelRegister("9Q3yl", function(module, exports) {

var $5lkNm = parcelRequire("5lkNm");


var $6YXrY = parcelRequire("6YXrY");


var $8UJqr = parcelRequire("8UJqr");

const $c22c9af788df97f8$export$68f3db7f6af48bcb = (0, $6YXrY.createFeatureFlaggedComponent)((0, $8UJqr.ConfluenceIcon), (0, $5lkNm.ConfluenceIcon));
module.exports["ConfluenceIcon"] = $c22c9af788df97f8$export$68f3db7f6af48bcb;

});

parcelRegister("7wqCp", function(module, exports) {
parcelRequire("cozmU");


var $ldJ1U = parcelRequire("ldJ1U");


var $6YXrY = parcelRequire("6YXrY");


var $aK5FI = parcelRequire("aK5FI");

const $08585521afd685aa$export$c4b5b1f965d8b3eb = (0, $6YXrY.createFeatureFlaggedComponent)((0, $aK5FI.JiraIcon), (0, $ldJ1U.JiraIcon));
module.exports["JiraIcon"] = $08585521afd685aa$export$c4b5b1f965d8b3eb;

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("3qGQ7", function(module, exports) {
const $1ddb1afb9a8b0771$var$DEFAULT_BYLINE_CONTRIBUTORS_FETCH_LIMIT = 4;
const $1ddb1afb9a8b0771$var$createSharedVariables = ({ spaceKey: spaceKey, versionOverride: versionOverride, isSSR: isSSR, preloadLabels: preloadLabels = false, includeAgentTrustReceiptData: includeAgentTrustReceiptData = false, includeMetadata: includeMetadata = false, includeReactions: includeReactions = false, includeRestrictions: includeRestrictions = false, includeRestrictionAncestors: includeRestrictionAncestors = false, useContentModeFragment: useContentModeFragment = false })=>({
        spaceKey: spaceKey,
        versionOverride: versionOverride,
        isSSR: isSSR,
        useNewContentTopper: true,
        ...preloadLabels || includeMetadata ? {
            preloadLabels: true
        } : {},
        ...includeAgentTrustReceiptData ? {
            includeAgentTrustReceiptData: true
        } : {},
        ...includeMetadata ? {
            includeClassification: true
        } : {},
        ...includeReactions ? {
            includeReactions: true
        } : {},
        ...includeRestrictions ? {
            includeRestrictions: true
        } : {},
        ...includeRestrictionAncestors ? {
            includeRestrictionAncestors: true
        } : {},
        ...useContentModeFragment ? {
            useContentModeFragment: true
        } : {}
    });
const $1ddb1afb9a8b0771$var$createAgentSessionVariables = (agentSessionsUserId)=>agentSessionsUserId ? {
        agentSessionsPropertyKey: `cc-agent-mention-sessions:${agentSessionsUserId}`,
        fetchAgentSessionsMarker: true
    } : {};
const $1ddb1afb9a8b0771$var$createBylineVariables = (includeBylineContributors = false)=>includeBylineContributors ? {
        includeBylineContributors: true,
        bylineContributorsLimit: $1ddb1afb9a8b0771$var$DEFAULT_BYLINE_CONTRIBUTORS_FETCH_LIMIT
    } : {};
const $1ddb1afb9a8b0771$export$5aa9cbe79a3cf3 = ({ contentId: contentId, agentSessionsUserId: agentSessionsUserId, includeBylineContributors: includeBylineContributors, ...sharedOptions })=>({
        contentId: contentId,
        ...$1ddb1afb9a8b0771$var$createSharedVariables(sharedOptions),
        ...$1ddb1afb9a8b0771$var$createAgentSessionVariables(agentSessionsUserId),
        ...$1ddb1afb9a8b0771$var$createBylineVariables(includeBylineContributors)
    });
const $1ddb1afb9a8b0771$export$85ff462ea4060e8a = ({ contentId: contentId, includeBylineContributors: includeBylineContributors, ...sharedOptions })=>({
        contentId: contentId,
        ...$1ddb1afb9a8b0771$var$createSharedVariables(sharedOptions),
        ...$1ddb1afb9a8b0771$var$createBylineVariables(includeBylineContributors)
    });
const $1ddb1afb9a8b0771$export$2021e0be086a965a = ({ spaceKey: spaceKey, agentSessionsUserId: agentSessionsUserId, includeBylineContributors: includeBylineContributors, ...sharedOptions })=>({
        ...$1ddb1afb9a8b0771$var$createSharedVariables({
            ...sharedOptions,
            spaceKey: spaceKey
        }),
        spaceKey: spaceKey,
        ...$1ddb1afb9a8b0771$var$createAgentSessionVariables(agentSessionsUserId),
        ...includeBylineContributors ? {
            includeBylineContributors: true
        } : {}
    });
module.exports["createContentUnifiedQueryVariables"] = $1ddb1afb9a8b0771$export$5aa9cbe79a3cf3;
module.exports["createContentBlogUnifiedQueryVariables"] = $1ddb1afb9a8b0771$export$85ff462ea4060e8a;
module.exports["createContentUnifiedWithSpaceKeyQueryVariables"] = $1ddb1afb9a8b0771$export$2021e0be086a965a;

});

parcelRegister("b2p4s", function(module, exports) {
/**
 * @generated SignedSource<<4e480f3ff7d119a77ec41231b6b4ab42>>
 * @relayHash aa12b95dc97d2068b03de4a55dcec507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c
const $ac606d0e22e5c37c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "aa12b95dc97d2068b03de4a55dcec507",
            "id": "0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c",
            "metadata": {},
            "name": "NotFoundContainerQuery",
            "operationKind": "query",
            "text": "query NotFoundContainerQuery($contentId:ID!,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,links{webui},properties(key:\"editor\"){nodes{id,key,value}}}}}"
        }
    };
}();
$ac606d0e22e5c37c$var$node.hash = "df3b0c202e5cf0f97257fa8a583747bc";
var $ac606d0e22e5c37c$export$2e2bcd8739ae039 = $ac606d0e22e5c37c$var$node;
module.exports["default"] = $ac606d0e22e5c37c$export$2e2bcd8739ae039;

});

parcelRegister("5Kzz3", function(module, exports) {

var $1z9oK = parcelRequire("1z9oK");

parcelRequire("gSgn8");

// This module acts as a live store for streamed SmartLink SSR batch data.
let $eee01957e7d1c366$var$storeState = {};
let $eee01957e7d1c366$var$boundaryMap = {};
const $eee01957e7d1c366$export$f2cf2e0cbb71e3f2 = (data)=>{
    Object.assign($eee01957e7d1c366$var$storeState, data);
};
const $eee01957e7d1c366$export$47351e79b7de3fbe = ()=>{
    return $eee01957e7d1c366$var$storeState;
};
const $eee01957e7d1c366$export$329d1a84b16e6bb = (data)=>{
    Object.assign($eee01957e7d1c366$var$boundaryMap, data);
};
const $eee01957e7d1c366$export$b0766f9270a6fd3 = ()=>{
    return $eee01957e7d1c366$var$boundaryMap;
};
const $eee01957e7d1c366$export$3ec3b3524523ef23 = ()=>{
    $eee01957e7d1c366$var$storeState = {};
    $eee01957e7d1c366$var$boundaryMap = {};
};
{
    const dataStream = (0, $1z9oK.getClientStream)('smartlinks');
    dataStream.addListener((batchData)=>{
        Object.assign($eee01957e7d1c366$var$storeState, batchData);
    });
    const boundaryStream = (0, $1z9oK.getClientStream)('smartlinks-boundary-map');
    boundaryStream.addListener((mapData)=>{
        Object.assign($eee01957e7d1c366$var$boundaryMap, mapData);
    });
}module.exports["updateSSRSmartLinksStore"] = $eee01957e7d1c366$export$f2cf2e0cbb71e3f2;
module.exports["getSSRSmartLinksStore"] = $eee01957e7d1c366$export$47351e79b7de3fbe;
module.exports["updateSSRSmartLinksBoundaryMap"] = $eee01957e7d1c366$export$329d1a84b16e6bb;
module.exports["getSSRSmartLinksBoundaryMap"] = $eee01957e7d1c366$export$b0766f9270a6fd3;
module.exports["resetSSRSmartLinksStore"] = $eee01957e7d1c366$export$3ec3b3524523ef23;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    FeedbackSource["TABS"] = "Tabs";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references',
    NATIVE: 'com.atlassian.confluence.native'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    BLOG_POSTS: 'blog-posts',
    INCLUDE: 'include',
    JIRA: 'jira',
    JIRACHART: 'jirachart',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    CONTRIBUTORS: 'contributors',
    IFRAME: 'iframe',
    LIST_LABELS: 'listlabels',
    POPULAR_LABELS: 'popular-labels',
    TASKS_REPORT_MACRO: 'tasks-report-macro',
    NATIVE_EMBED: 'native-embed',
    HIDE: 'hide',
    PAGE_TREE_SEARCH: 'pagetreesearch',
    WIDGET: 'widget',
    CONTENT_REPORT_TABLE: 'content-report-table',
    CHANGE_HISTORY: 'change-history',
    VIEWPDF: 'viewpdf',
    ATTACHMENTS: 'attachments',
    AGENT_MANAGED_BLOCK: 'agent-managed-block',
    VIEWXLS: 'viewxls'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ATTACHMENTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.BLOG_POSTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTRIBUTORS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.IFRAME,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.POPULAR_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIST_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.WIDGET,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_REPORT_TABLE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHANGE_HISTORY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWPDF,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TASKS_REPORT_MACRO,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWXLS
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $6kV7w = parcelRequire("6kV7w");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $kBr4q.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $kBr4q.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $krgsn = parcelRequire("krgsn");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $krgsn.GraphQLError)(message, null, // nodes - no GraphQL query AST
    null, // source - no GraphQL query text
    null, // positions - no GraphQL query positions
    null, // path - not executing GraphQL schema fields
    originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("bS81H", function(module, exports) {
/**
 * @generated SignedSource<<ecee5cb68219750c899a663dd271634b>>
 * @relayHash 611f36fd3ab140915814f503f8503110
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8
const $5a2ebb253ede159a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentVersion"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatus",
                            "variableName": "contentStatus"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentVersion",
                            "variableName": "contentVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "611f36fd3ab140915814f503f8503110",
            "id": "97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8",
            "metadata": {},
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersDSPIsActionEnabledForContentQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
        }
    };
}();
$5a2ebb253ede159a$var$node.hash = "c488c053b9896d7e6d5b6c4474dd396b";
var $5a2ebb253ede159a$export$2e2bcd8739ae039 = $5a2ebb253ede159a$var$node;
module.exports["default"] = $5a2ebb253ede159a$export$2e2bcd8739ae039;

});

parcelRegister("axutP", function(module, exports) {
/**
 * @generated SignedSource<<471bd2d51696f1de1dc7d46b066715f5>>
 * @relayHash fa5b50f9c89692d4dd86caf1df42c2d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a
const $972689412971ec2f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEnabledOnContentView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fa5b50f9c89692d4dd86caf1df42c2d1",
            "id": "60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a",
            "metadata": {},
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "operationKind": "query",
            "text": "query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!,$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey){isEnabledOnContentView}}"
        }
    };
}();
$972689412971ec2f$var$node.hash = "d0f958354cdf65029012c243a64d4874";
var $972689412971ec2f$export$2e2bcd8739ae039 = $972689412971ec2f$var$node;
module.exports["default"] = $972689412971ec2f$export$2e2bcd8739ae039;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<994231445f227a67e1aaccbbe4790b5b>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("eoU1C", function(module, exports) {
const $b3332cb66ea1a913$export$7f1c6b461c54348b = {
    DIALOG_SPOTLIGHT_SEEN: 'random:ShareAndRestrictDialog:spotlightSeen',
    PUBLIC_LINK_FOOTER_BUTTON_SEEN: 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen',
    EDIT_PUBLIC_LINK_PERMISSION_SEEN: 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen',
    GENERAL_AND_SPECIFIC_ACCESS_SEEN: 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen',
    CTA_NOTIFY_MESSAGE_FOOTER_SEEN: 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
};
const $b3332cb66ea1a913$export$e5c211f9c9c7792f = Object.values($b3332cb66ea1a913$export$7f1c6b461c54348b);
module.exports["ONBOARDING_SHARE_AND_RESTRICT_DIALOG"] = $b3332cb66ea1a913$export$7f1c6b461c54348b;
module.exports["ShareAndRestrictDialogOnboardingKeys"] = $b3332cb66ea1a913$export$e5c211f9c9c7792f;

});

parcelRegister("fsF73", function(module, exports) {
const $29520d740d888926$export$84bb2ff8e52d4c63 = {
    HAS_SEEN_PUBLISH_SPOTLIGHT: 'confluence-recap:hasSeenPublishSpotlight'
};
const $29520d740d888926$export$42e96b8eba35eec9 = Object.values($29520d740d888926$export$84bb2ff8e52d4c63);
module.exports["CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS"] = $29520d740d888926$export$84bb2ff8e52d4c63;
module.exports["ConfluenceRecapOnboardingKeys"] = $29520d740d888926$export$42e96b8eba35eec9;

});

parcelRegister("aqBZ0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<b9ad5a08ae51c98f54e2bf136fb000a5>>
 * @relayHash 3a81188260e43110e57bf35a979f5053
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c767da7861d97903ba1d85d6b0a41ab5ff13ba32a0ebf4537e812118caef418
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalsBetaFeatures"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "success"
    }, v11 = {
        "kind": "ScalarField",
        "name": "message"
    }, v12 = {
        "kind": "ScalarField",
        "name": "principalType"
    }, v13 = {
        "kind": "ScalarField",
        "name": "principalId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v16 = {
        "kind": "ScalarField",
        "name": "value"
    }, v17 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v18 = [
        v7 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v17 /*: any*/ 
            ]
        }
    ], v19 = {
        "condition": "includeApprovalsBetaFeatures",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v9 /*: any*/ 
                ],
                "concreteType": "ConfluenceContentApprovalsSiteSettings",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSiteSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "enabled"
                    }
                ]
            },
            {
                "args": [
                    v9 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "filterSelf",
                        "value": false
                    },
                    {
                        "kind": "Variable",
                        "name": "spaceKey",
                        "variableName": "spaceKey"
                    }
                ],
                "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSpaceSettingConfig",
                "plural": false,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "concreteType": "MutationError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v11 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "disallowFirstPublish"
                            },
                            {
                                "concreteType": "ConfluenceApprovalReviewerConfig",
                                "kind": "LinkedField",
                                "name": "enforcedApprovalReviewerConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isEnabled"
                                    },
                                    {
                                        "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                                        "kind": "LinkedField",
                                        "name": "reviewers",
                                        "plural": true,
                                        "selections": [
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            {
                                                "concreteType": "AtlassianUser",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": v18 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v20 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "status"
    }, v22 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v23 = {
        "args": [
            v9 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v24 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v25 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v26 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v27 = [
        v9 /*: any*/ ,
        v24 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v28 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v29 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v30 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v28 /*: any*/ ,
                    v29 /*: any*/ 
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v32 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            v31 /*: any*/ 
        ]
    }, v33 = [
        v9 /*: any*/ ,
        v24 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v34 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v35 = [
        v16 /*: any*/ 
    ], v36 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v15 /*: any*/ ,
            v34 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v18 /*: any*/ 
            }
        ]
    }, v37 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            v31 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "condition": "includeApprovalsBetaFeatures",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": v35 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            v34 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v35 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v7 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    v16 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v38 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v28 /*: any*/ ,
                    v29 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v7 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v8 /*: any*/ ,
                v19 /*: any*/ ,
                {
                    "args": v20 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v27 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v30 /*: any*/ ,
                        v32 /*: any*/ 
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v30 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v8 /*: any*/ ,
                v19 /*: any*/ ,
                {
                    "args": v20 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v27 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v38 /*: any*/ ,
                        v32 /*: any*/ 
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v38 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3a81188260e43110e57bf35a979f5053",
            "id": "9c767da7861d97903ba1d85d6b0a41ab5ff13ba32a0ebf4537e812118caef418",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}},confluence_contentApprovalsSiteSettings(cloudId:$cloudId)@include(if:$includeApprovalsBetaFeatures){enabled}\n  confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "20f79def106defb4cc34e9f770d1c8cc";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("iOp5s", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

const $e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE = 'Approvals are disabled';
const $e8d397546331cd08$var$isApprovalsDisabledGraphQLError = (error)=>Boolean(error.message?.includes($e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE));
const $e8d397546331cd08$export$b724ffcdc4a2c130 = (error)=>{
    if (!error) return false;
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    if (graphQLErrors?.length) return graphQLErrors.every($e8d397546331cd08$var$isApprovalsDisabledGraphQLError);
    return $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(error);
};
const $e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled = (error)=>{
    (0, $7Sm4c.markErrorAsHandled)(error);
    const originalCause = error.originalError?.cause;
    if (originalCause && $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(originalCause)) (0, $7Sm4c.markErrorAsHandled)(originalCause);
};
const $e8d397546331cd08$export$50302788ce0889ee = (error)=>{
    if (!error || !$e8d397546331cd08$export$b724ffcdc4a2c130(error)) return;
    (0, $7Sm4c.markErrorAsHandled)(error);
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    graphQLErrors?.forEach($e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled);
};
module.exports["markApprovalsDisabledErrorAsHandled"] = $e8d397546331cd08$export$50302788ce0889ee;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $3ricL = parcelRequire("3ricL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $jH9cM.isFedRamp)() && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("9HhEw", function(module, exports) {
/**
 * @generated SignedSource<<79c229d4f4ae3adcbe0b4f7f72920a16>>
 * @relayHash 80f146a83f48be7b9331f291c6222df0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962
const $cb80c8184222fcac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v9 = {
        "kind": "ScalarField",
        "name": "number"
    }, v10 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v11 = {
        "kind": "ScalarField",
        "name": "syncRev"
    }, v12 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "80f146a83f48be7b9331f291c6222df0",
            "id": "441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962",
            "metadata": {},
            "name": "ExternalByLineQuery",
            "operationKind": "query",
            "text": "query ExternalByLineQuery($contentId:ID!){singleContent(id:$contentId){id,type,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId}},ownedBy{__typename,type,displayName,...on KnownUser{accountId}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,confRev,syncRev,contentTypeModified}}}"
        }
    };
}();
$cb80c8184222fcac$var$node.hash = "012bf9a7497572d73e22134c755e8758";
var $cb80c8184222fcac$export$2e2bcd8739ae039 = $cb80c8184222fcac$var$node;
module.exports["default"] = $cb80c8184222fcac$export$2e2bcd8739ae039;

});

parcelRegister("gGK1T", function(module, exports) {
/**
 * @generated SignedSource<<e983bd00ea24afc042f5f11535352524>>
 * @relayHash b8208417e6c09fc98b947c6af794b0f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327
const $edbbfe37cbd0175f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": 4,
            "kind": "LocalArgument",
            "name": "limit"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b8208417e6c09fc98b947c6af794b0f3",
            "id": "c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327",
            "metadata": {},
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "operationKind": "query",
            "text": "query useContentOwnershipContributorsContentOwnershipContributorsQuery($contentId:ID!,$limit:Int=4){content(id:$contentId){nodes{id,history{ownedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}},contentContributors(id:$contentId,limit:$limit){nodes{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}"
        }
    };
}();
$edbbfe37cbd0175f$var$node.hash = "e8dd42a19657acc23120ab54c46606ff";
var $edbbfe37cbd0175f$export$2e2bcd8739ae039 = $edbbfe37cbd0175f$var$node;
module.exports["default"] = $edbbfe37cbd0175f$export$2e2bcd8739ae039;

});

parcelRegister("2E1L5", function(module, exports) {
const $f1205e6da653ae62$export$16708f74bd486c8 = 'confluence_page_ownership_changeboarding';
const $f1205e6da653ae62$export$9ed1986df73b834a = 'change-page-ownership-link';
const $f1205e6da653ae62$export$21191b0c00ca25f4 = 10;
const $f1205e6da653ae62$export$83728ea2bd792f67 = {
    USER_IS_NULL: 'You cannot set an owner as an anonymous user.',
    USER_NOT_FOUND: 'Owner id is an invalid account id.',
    USER_MISSING_PAGE_PERMISSION: 'New owner must have view and edit permission on the content.',
    CONTENT_ID_INVALID: 'Content id is invalid.',
    INSUFFICIENT_PERMISSIONS: 'You must be the content creator, owner, or a space admin to set the owner.'
};
const $f1205e6da653ae62$export$f0b683cb64dc68b0 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $f1205e6da653ae62$export$b344b39e3835f655 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
const $f1205e6da653ae62$export$7ab4b084abc24ac8 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
module.exports["CONTENT_OWNERSHIP_WEB_ITEM_ID"] = $f1205e6da653ae62$export$9ed1986df73b834a;
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $f1205e6da653ae62$export$21191b0c00ca25f4;
module.exports["EXPECTED_ERROR_MESSAGES"] = $f1205e6da653ae62$export$83728ea2bd792f67;
module.exports["PARENT_PAGE_LEARN_MORE_URL"] = $f1205e6da653ae62$export$f0b683cb64dc68b0;
module.exports["CONFIRM_MODAL_LEARN_MORE_LINK"] = $f1205e6da653ae62$export$7ab4b084abc24ac8;

});

parcelRegister("ieWRE", function(module, exports) {
/**
 * @generated SignedSource<<cc3649e97b9be1d6269151089c18fb3f>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126
const $89ec832c644948be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSmartFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "544e060744fb4498c2bc0371295ea8f5",
            "id": "44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126",
            "metadata": {},
            "name": "useIsSmartFoldersEnabledQuery",
            "operationKind": "query",
            "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
        }
    };
}();
$89ec832c644948be$var$node.hash = "03675b093cffce21dc93e86a9415a3c7";
var $89ec832c644948be$export$2e2bcd8739ae039 = $89ec832c644948be$var$node;
module.exports["default"] = $89ec832c644948be$export$2e2bcd8739ae039;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<dc205b784e864c4042673f60370ebfb9>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("a9aSv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $iDrrr = parcelRequire("iDrrr");

const $19ad0c297e7cfe22$var$shimmerKeyframes = null;
const $19ad0c297e7cfe22$var$skeletonStyles = null;
const $19ad0c297e7cfe22$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $19ad0c297e7cfe22$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $19ad0c297e7cfe22$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { width: width, height: height, borderRadius: t1, color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: t2, groupName: groupName, interactionName: interactionName, testId: testId } = t0;
    const borderRadius = t1 === undefined ? "var(--ds-radius-small, 4px)" : t1;
    const isShimmering = t2 === undefined ? false : t2;
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    let t4;
    if ($[0] !== context || $[1] !== interactionName) {
        t3 = ()=>{
            if (context != null && (0, $iDrrr.fg)("platform-dst-skeleton-ufo-hold")) return context.hold(interactionName);
        };
        t4 = [
            context,
            interactionName
        ];
        $[0] = context;
        $[1] = interactionName;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    $19ad0c297e7cfe22$var$useLayoutEffect(t3, t4);
    const t5 = color && ShimmeringEndColor ? color : undefined;
    const t6 = color && ShimmeringEndColor ? ShimmeringEndColor : undefined;
    let t7;
    if ($[4] !== borderRadius || $[5] !== color || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== width) {
        t7 = {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            "--ds-skeleton-from-color": t5,
            "--ds-skeleton-to-color": t6
        };
        $[4] = borderRadius;
        $[5] = color;
        $[6] = height;
        $[7] = t5;
        $[8] = t6;
        $[9] = width;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    let t9;
    if ($[11] !== groupDataAttribute) {
        t9 = groupDataAttribute && {
            [groupDataAttribute]: "true"
        };
        $[11] = groupDataAttribute;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isShimmering && "";
    const t11 = isShimmering && "_1gBibyKB6V";
    let t12;
    if ($[13] !== t10 || $[14] !== t11) {
        t12 = (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            t10,
            t11
        ]);
        $[13] = t10;
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": testId,
            style: t8,
            ...t9,
            className: t12
        });
        $[16] = t12;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    $19ad0c297e7cfe22$var$useLayoutEffect(()=>{
        if (context != null && (0, $iDrrr.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
var $19ad0c297e7cfe22$export$2e2bcd8739ae039 = $19ad0c297e7cfe22$var$Skeleton;
module.exports["default"] = $19ad0c297e7cfe22$export$2e2bcd8739ae039;

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("9V507", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2131e07eab16a3d853e4806b506dca34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $738d50ffcc582510$var$_react = $738d50ffcc582510$var$_interopRequireDefault((parcelRequire("cozmU")));

var $738d50ffcc582510$var$_baseNew = $738d50ffcc582510$var$_interopRequireDefault((parcelRequire("gElAV")));
function $738d50ffcc582510$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-text
 * Usage guidance:
 * Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $738d50ffcc582510$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $738d50ffcc582510$var$_react.default.createElement($738d50ffcc582510$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$738d50ffcc582510$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $738d50ffcc582510$var$_default = module.exports.default = $738d50ffcc582510$var$AiGenerativeTextIcon;

});

parcelRegister("8D7c3", function(module, exports) {
const $9c67d6e83108154f$export$acd187a38a2cd68a = 'confluence:twcg-2055:flag-to-share-action';
const $9c67d6e83108154f$export$f28869dd2aadb934 = (detail)=>{
    const browserWindow = globalThis.document?.defaultView;
    if (!browserWindow) return false;
    const actionEvent = new CustomEvent($9c67d6e83108154f$export$acd187a38a2cd68a, {
        cancelable: true,
        detail: detail
    });
    browserWindow.dispatchEvent(actionEvent);
    return actionEvent.defaultPrevented;
};
module.exports["CONFLUENCE_FLAG_TO_SHARE_ACTION_EVENT"] = $9c67d6e83108154f$export$acd187a38a2cd68a;
module.exports["dispatchConfluenceFlagToShareAction"] = $9c67d6e83108154f$export$f28869dd2aadb934;

});

parcelRegister("1KLPb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a05e8365b19766ca73e82e6f6133ae2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $146f2f46410fb12f$var$_react = $146f2f46410fb12f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $146f2f46410fb12f$var$_baseNew = $146f2f46410fb12f$var$_interopRequireDefault((parcelRequire("gElAV")));
function $146f2f46410fb12f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/book-open
 * Usage guidance:
 * Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $146f2f46410fb12f$var$BookOpenIcon = (props)=>/*#__PURE__*/ $146f2f46410fb12f$var$_react.default.createElement($146f2f46410fb12f$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$146f2f46410fb12f$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $146f2f46410fb12f$var$_default = module.exports.default = $146f2f46410fb12f$var$BookOpenIcon;

});

parcelRegister("2Zz3q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g4vf3 = parcelRequire("g4vf3");

function $9d9e360fdbb0177e$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $g4vf3.MILLISECONDS_IN_A_DAY));
}
function $9d9e360fdbb0177e$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $9d9e360fdbb0177e$export$954628993bf3188e(trialEndTime - Date.now());
}
function $9d9e360fdbb0177e$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $cozmU.useMemo)(()=>$9d9e360fdbb0177e$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $9d9e360fdbb0177e$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $9d9e360fdbb0177e$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $9d9e360fdbb0177e$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $cozmU.useMemo)(()=>$9d9e360fdbb0177e$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $9d9e360fdbb0177e$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $9d9e360fdbb0177e$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $9d9e360fdbb0177e$export$ee6c4faab08346c;

});

parcelRegister("g4vf3", function(module, exports) {
const $d163a47e1480b111$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $d163a47e1480b111$export$98a7370239de6730;

});

parcelRegister("8m50u", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

function $fb7caad66dba5065$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
        const $ = (0, $bDgLe.c)(3);
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $fb7caad66dba5065$export$6e8ea24b15199873;

});

parcelRegister("f7FiQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $gEyoZ = parcelRequire("gEyoZ");

const $b8829d8a161753f9$var$BranchObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BranchObjectTile({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $b8829d8a161753f9$export$2e2bcd8739ae039 = $b8829d8a161753f9$var$BranchObjectTile;
module.exports["default"] = $b8829d8a161753f9$export$2e2bcd8739ae039;

});

parcelRegister("6gVpf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $gEyoZ = parcelRequire("gEyoZ");

const $90d14fc97efa5c87$var$CommitObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CommitObjectTile({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $90d14fc97efa5c87$export$2e2bcd8739ae039 = $90d14fc97efa5c87$var$CommitObjectTile;
module.exports["default"] = $90d14fc97efa5c87$export$2e2bcd8739ae039;

});

parcelRegister("lvsY2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $gEyoZ = parcelRequire("gEyoZ");

const $c843d2b7ba70d597$var$PullRequestObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PullRequestObjectTile({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $c843d2b7ba70d597$export$2e2bcd8739ae039 = $c843d2b7ba70d597$var$PullRequestObjectTile;
module.exports["default"] = $c843d2b7ba70d597$export$2e2bcd8739ae039;

});

parcelRegister("2z1Cx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $gEyoZ = parcelRequire("gEyoZ");

const $3fba6eb33cac86c2$var$CodeObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Code" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CodeObjectTile({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $3fba6eb33cac86c2$export$2e2bcd8739ae039 = $3fba6eb33cac86c2$var$CodeObjectTile;
module.exports["default"] = $3fba6eb33cac86c2$export$2e2bcd8739ae039;

});

parcelRegister("ix7Nw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $gEyoZ = parcelRequire("gEyoZ");

const $e3c6782640cca582$var$BugObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $e3c6782640cca582$export$2e2bcd8739ae039 = $e3c6782640cca582$var$BugObjectTile;
module.exports["default"] = $e3c6782640cca582$export$2e2bcd8739ae039;

});

parcelRegister("lfmf4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d8f6dc54ca6872bb$var$ChangesObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ChangesObjectTile({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $d8f6dc54ca6872bb$export$2e2bcd8739ae039 = $d8f6dc54ca6872bb$var$ChangesObjectTile;
module.exports["default"] = $d8f6dc54ca6872bb$export$2e2bcd8739ae039;

});

parcelRegister("bht3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $gEyoZ = parcelRequire("gEyoZ");

const $ff1c12598ed3ba74$var$EpicObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $ff1c12598ed3ba74$export$2e2bcd8739ae039 = $ff1c12598ed3ba74$var$EpicObjectTile;
module.exports["default"] = $ff1c12598ed3ba74$export$2e2bcd8739ae039;

});

parcelRegister("tBrWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d409ccda82578191$var$IncidentObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function IncidentObjectTile({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $d409ccda82578191$export$2e2bcd8739ae039 = $d409ccda82578191$var$IncidentObjectTile;
module.exports["default"] = $d409ccda82578191$export$2e2bcd8739ae039;

});

parcelRegister("e9ExL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $gEyoZ = parcelRequire("gEyoZ");

const $70d7bc77e47e0fe4$var$ProblemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ProblemObjectTile({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $70d7bc77e47e0fe4$export$2e2bcd8739ae039 = $70d7bc77e47e0fe4$var$ProblemObjectTile;
module.exports["default"] = $70d7bc77e47e0fe4$export$2e2bcd8739ae039;

});

parcelRegister("2hwbE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $gEyoZ = parcelRequire("gEyoZ");

const $0c8c4b462cd0e972$var$WorkItemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $0c8c4b462cd0e972$export$2e2bcd8739ae039 = $0c8c4b462cd0e972$var$WorkItemObjectTile;
module.exports["default"] = $0c8c4b462cd0e972$export$2e2bcd8739ae039;

});

parcelRegister("bnm2b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $gEyoZ = parcelRequire("gEyoZ");

const $54244c8cd22493dc$var$StoryObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $54244c8cd22493dc$export$2e2bcd8739ae039 = $54244c8cd22493dc$var$StoryObjectTile;
module.exports["default"] = $54244c8cd22493dc$export$2e2bcd8739ae039;

});

parcelRegister("h3uhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $gEyoZ = parcelRequire("gEyoZ");

const $35e12172f066a32d$var$SubtaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SubtaskObjectTile({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $35e12172f066a32d$export$2e2bcd8739ae039 = $35e12172f066a32d$var$SubtaskObjectTile;
module.exports["default"] = $35e12172f066a32d$export$2e2bcd8739ae039;

});

parcelRegister("glDuG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $41a316049a2a2c13$var$TaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $41a316049a2a2c13$export$2e2bcd8739ae039 = $41a316049a2a2c13$var$TaskObjectTile;
module.exports["default"] = $41a316049a2a2c13$export$2e2bcd8739ae039;

});

parcelRegister("rECdA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");

const $71deccf66348f07d$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $71deccf66348f07d$export$cf56d0f54cfcce4;

});

parcelRegister("3jjX7", function(module, exports) {
// WARNING: This value is shared between @atlaskit/analytics-cross-product and
// @atlassiansox/analytics-cross-product-interaction-client. Take care when updating.
const $6e6234f2764332e7$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $6e6234f2764332e7$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($6e6234f2764332e7$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$6e6234f2764332e7$export$7bc189309d2ad463];
        } catch (err) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}
module.exports["default"] = $6e6234f2764332e7$export$2e2bcd8739ae039;

});

parcelRegister("1G3WB", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $2zVsi = parcelRequire("2zVsi");

const $dc93231c4629fa01$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $2zVsi.functionWithCondition)(()=>(0, $iDrrr.fg)(featureFlagName), functionTrue, functionFalse);
module.exports["functionWithFG"] = $dc93231c4629fa01$export$53903226fff06fbb;

});

parcelRegister("2zVsi", function(module, exports) {
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $70b08b83582e8047$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
module.exports["functionWithCondition"] = $70b08b83582e8047$export$af3c0e82a18fc057;

});

parcelRegister("c3xon", function(module, exports) {

var $2zVsi = parcelRequire("2zVsi");

function $98c7b2cae218afe1$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return (0, $2zVsi.functionWithCondition)(condition, functionTrue, functionFalse);
}
module.exports["functionUnionWithCondition"] = $98c7b2cae218afe1$export$c41c28c1d883fcd5;

});

parcelRegister("6CHZa", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $e6695a46069ee43e$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9EREa.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};
module.exports["extractPersonAssignedTo"] = $e6695a46069ee43e$export$38a0979ebf273662;

});

parcelRegister("9EREa", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");

const $9cbb96c910c4c39f$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};
module.exports["extractPersonFromJsonLd"] = $9cbb96c910c4c39f$export$c471ae5fddcf1392;

});

parcelRegister("htsh0", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $94cdde39bec9c233$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonCreatedBy"] = $94cdde39bec9c233$export$a66235cba0c9d11a;

});

parcelRegister("7LPcf", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $367262c04ca8598b$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonOwnedBy"] = $367262c04ca8598b$export$19ee667f3f7a6ec3;

});

parcelRegister("JTvZe", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $9EREa.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};
module.exports["extractPersonUpdatedBy"] = $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0;

});

parcelRegister("d4O2g", function(module, exports) {

var $1kPn4 = parcelRequire("1kPn4");

const $b61bca3ca7bdd7f0$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $1kPn4.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $1kPn4.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
module.exports["extractImage"] = $b61bca3ca7bdd7f0$export$4c753a1297cb9805;

});

parcelRegister("lXmY5", function(module, exports) {

var $hiX3M = parcelRequire("hiX3M");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $652810c159b94aae$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.ari || (0, $8YE7G.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $hiX3M.extractAri)(data);
};
module.exports["extractSmartLinkAri"] = $652810c159b94aae$export$16b02be3e2bb31ad;

});

parcelRegister("cLyLO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $b816614c9f5e4543$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $htsh0.extractPersonCreatedBy)(response.data);
};
module.exports["extractSmartLinkAuthorGroup"] = $b816614c9f5e4543$export$41fc716e1bc2dc90;

});

parcelRegister("ddzkt", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $8118f7b98ace9299$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $htsh0.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
module.exports["extractSmartLinkCreatedBy"] = $8118f7b98ace9299$export$242875b46118beb2;

});

parcelRegister("cbT5r", function(module, exports) {

var $04wHu = parcelRequire("04wHu");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $0016e53066bcc8e1$export$7a685df468cbf38f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdAt;
    return response?.data && (0, $04wHu.extractDateCreated)(response.data);
};
module.exports["extractSmartLinkCreatedOn"] = $0016e53066bcc8e1$export$7a685df468cbf38f;

});

parcelRegister("04wHu", function(module, exports) {
const $cb783639b44cd885$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
module.exports["extractDateCreated"] = $cb783639b44cd885$export$e1226a5e0bbbf862;

});

parcelRegister("e1RBl", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $JTvZe = parcelRequire("JTvZe");


var $kAdyG = parcelRequire("kAdyG");

const $0ec810a5f5f35d9a$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $JTvZe.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
module.exports["extractSmartLinkModifiedBy"] = $0ec810a5f5f35d9a$export$7f099a839071a190;

});

parcelRegister("ltT9o", function(module, exports) {

var $hltP6 = parcelRequire("hltP6");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $42cf6b151797d39e$export$75047940e157fd1f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $hltP6.extractDateUpdated)(response.data);
};
module.exports["extractSmartLinkModifiedOn"] = $42cf6b151797d39e$export$75047940e157fd1f;

});

parcelRegister("hltP6", function(module, exports) {
const $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
module.exports["extractDateUpdated"] = $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7;

});

parcelRegister("hoB2R", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $dedbbfb6fd3975a3$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["extractSmartLinkDownloadUrl"] = $dedbbfb6fd3975a3$export$96ed4c1b14ac210a;

});

parcelRegister("cuq2s", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $q9Cpn = parcelRequire("q9Cpn");

const $cc5224b9f28cd9ed$export$a54013f0d02a8f82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, locale: t1, fetchTranslations: fetchTranslations } = t0;
    const incomingLocale = t1 === undefined ? (0, $q9Cpn.DEFAULT_LOCALE) : t1;
    const [messages, setMessages] = (0, $cozmU.useState)();
    let t2;
    if ($[0] !== incomingLocale) {
        t2 = (0, $q9Cpn.normalizeLocale)(incomingLocale);
        $[0] = incomingLocale;
        $[1] = t2;
    } else t2 = $[1];
    const locale = t2;
    let t3;
    let t4;
    if ($[2] !== fetchTranslations || $[3] !== locale) {
        t3 = ()=>{
            const loadTranslations = async ()=>{
                const localeMessages = await fetchTranslations(locale);
                setMessages(localeMessages);
            };
            loadTranslations();
        };
        t4 = [
            fetchTranslations,
            locale
        ];
        $[2] = fetchTranslations;
        $[3] = locale;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!messages) return null;
    let t5;
    if ($[6] !== children || $[7] !== locale || $[8] !== messages) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: locale,
            messages: messages,
            defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
        }, children);
        $[6] = children;
        $[7] = locale;
        $[8] = messages;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ children: children, locale: incomingLocale = (0, $q9Cpn.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $cozmU.useState)();
    const locale = (0, $cozmU.useMemo)(()=>(0, $q9Cpn.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $cozmU.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
    }, children);
};
module.exports["I18nProvider"] = $cc5224b9f28cd9ed$export$a54013f0d02a8f82;

});

parcelRegister("q9Cpn", function(module, exports) {
const $bacd93d5d71e2df6$var$DEFAULT_LANGUAGE = 'en';
const $bacd93d5d71e2df6$var$DEFAULT_REGION = 'US';
const $bacd93d5d71e2df6$export$1af4c7e47ad72f44 = `${$bacd93d5d71e2df6$var$DEFAULT_LANGUAGE}-${$bacd93d5d71e2df6$var$DEFAULT_REGION}`;
const $bacd93d5d71e2df6$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $bacd93d5d71e2df6$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $bacd93d5d71e2df6$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $bacd93d5d71e2df6$export$dca0327c9b9c6498;

});

parcelRegister("hMKdq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ctzvi = parcelRequire("ctzvi");

const $e93c907c43f1ec9c$var$UniqueKeyContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    uniqueKey: undefined
});
const $e93c907c43f1ec9c$export$71829d27b87a2006 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $ctzvi.createUniqueKey)();
        $[0] = t1;
    } else t1 = $[0];
    const uniqueKey = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            uniqueKey: uniqueKey
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e93c907c43f1ec9c$var$UniqueKeyContext.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children })=>{
    const uniqueKey = (0, $cozmU.useMemo)(()=>(0, $ctzvi.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e93c907c43f1ec9c$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        }
    }, children);
};
const $e93c907c43f1ec9c$export$cef64a0cfb90e369 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e93c907c43f1ec9c$var$UniqueKeyContext);
} : ()=>{
    return (0, $cozmU.useContext)($e93c907c43f1ec9c$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $e93c907c43f1ec9c$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $e93c907c43f1ec9c$export$cef64a0cfb90e369;

});

parcelRegister("lWz4S", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRK7f = parcelRequire("iRK7f");


var $hDLmU = parcelRequire("hDLmU");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $495e0a92c5164d61$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $495e0a92c5164d61$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $495e0a92c5164d61$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $cozmU.useState)(contentType);
    const isInitialized = (0, $cozmU.useRef)(true);
    const iframeLoadMetrics = (0, $cozmU.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $cozmU.useRef)();
    (0, $cozmU.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $iRK7f.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $cozmU.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $iRK7f.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $cozmU.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $cozmU.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        }
    }, children);
};
const $495e0a92c5164d61$export$865423e6f8e2e839 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($495e0a92c5164d61$var$PerformanceMetricsContext);
} : ()=>{
    return (0, $cozmU.useContext)($495e0a92c5164d61$var$PerformanceMetricsContext);
};
const $495e0a92c5164d61$export$c6f19d9afc6c86c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, contentType: contentType, sourceComponent: sourceComponent } = t0;
    const { isInitialized: isInitialized, setContentType: setContentType } = $495e0a92c5164d61$export$865423e6f8e2e839();
    let t1;
    let t2;
    if ($[0] !== contentType || $[1] !== isInitialized || $[2] !== setContentType) {
        t1 = ()=>{
            isInitialized && contentType && setContentType(contentType);
        };
        t2 = [
            isInitialized,
            contentType,
            setContentType
        ];
        $[0] = contentType;
        $[1] = isInitialized;
        $[2] = setContentType;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[5] !== children || $[6] !== contentType || $[7] !== isInitialized || $[8] !== sourceComponent) {
        t3 = !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$Provider, {
            contentType: contentType,
            sourceComponent: sourceComponent
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[5] = children;
        $[6] = contentType;
        $[7] = isInitialized;
        $[8] = sourceComponent;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $495e0a92c5164d61$export$865423e6f8e2e839();
    (0, $cozmU.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["usePerformanceMetrics"] = $495e0a92c5164d61$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $495e0a92c5164d61$export$c6f19d9afc6c86c8;

});

parcelRegister("iRK7f", function(module, exports) {

var $iDdTC = parcelRequire("iDdTC");


var $lCTbz = parcelRequire("lCTbz");

const $e6b49468896929e5$export$4de078c3b9971f9b = ()=>(0, $iDdTC.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $e6b49468896929e5$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $e6b49468896929e5$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e6b49468896929e5$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e6b49468896929e5$var$timings
    }
};
const $e6b49468896929e5$export$a23245993532c751 = (contentType)=>(0, $iDdTC.metrics).pageSegmentLoad($e6b49468896929e5$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $e6b49468896929e5$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $e6b49468896929e5$export$a23245993532c751;

});

parcelRegister("ij75C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fcaWu = parcelRequire("fcaWu");


var $36Uax = parcelRequire("36Uax");


var $hMKdq = parcelRequire("hMKdq");


var $kTPbu = parcelRequire("kTPbu");

var $bVevd = parcelRequire("bVevd");


var $eAWIs = parcelRequire("eAWIs");

const $1ae0fabae864f28a$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $fcaWu.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $1ae0fabae864f28a$var$serializeQueryParams = (queryParams)=>queryParams ? new URLSearchParams(Object.entries(queryParams).sort(([paramA], [paramB])=>paramA.localeCompare(paramB))).toString() : '';
const $1ae0fabae864f28a$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $1ae0fabae864f28a$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $1ae0fabae864f28a$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, queryParams: consumerQueryParams, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $cozmU.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $cozmU.useMemo)(()=>allowedFeatures === 'all' ? (0, $36Uax.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature_0)=>feature_0 !== 'edit' && feature_0 !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature_1)=>!$1ae0fabae864f28a$var$nonAllFeatures.includes(feature_1)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature_2)=>(0, $eAWIs.isRedirectionEnabled)(feature_2)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $eAWIs.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const consumerQueryParamsString = $1ae0fabae864f28a$var$serializeQueryParams(consumerQueryParams);
    const contentConfigurationQueryParamsString = $1ae0fabae864f28a$var$serializeQueryParams(contentConfiguration?.queryParams);
    const queryParams = (0, $cozmU.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $1ae0fabae864f28a$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        const searchParams = new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery
        });
        new URLSearchParams(consumerQueryParamsString).forEach((value, key)=>{
            if (!searchParams.has(key)) searchParams.set(key, value);
        });
        new URLSearchParams(contentConfigurationQueryParamsString).forEach((value_0, key_0)=>{
            searchParams.set(key_0, value_0);
        });
        return `?${searchParams.toString()}`;
    }, [
        consumerQueryParamsString,
        contentConfigurationQueryParamsString,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $cozmU.useMemo)(()=>({
            ...$1ae0fabae864f28a$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $1ae0fabae864f28a$var$CONTEXT_PATH = '/wiki/spaces';
const $1ae0fabae864f28a$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $1ae0fabae864f28a$var$constructUrl(mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$1ae0fabae864f28a$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$1ae0fabae864f28a$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$1ae0fabae864f28a$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $1ae0fabae864f28a$export$6e43e60d51b79331;
module.exports["useUrl"] = $1ae0fabae864f28a$export$305222dff575c4e3;

});

parcelRegister("eAWIs", function(module, exports) {
const $66050da24b77bea6$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
    'template-browser',
    'template-browser-panel'
];
const $66050da24b77bea6$var$hasAllowedFeature = (feature, featureName)=>{
    if (typeof feature === 'string') return feature === featureName;
    if (feature && typeof feature === 'object') return Object.prototype.hasOwnProperty.call(feature, featureName);
    return false;
};
const $66050da24b77bea6$export$b47e8b0fa2aae156 = (allowedFeatures)=>{
    if (allowedFeatures === 'all') return true;
    return allowedFeatures?.some((feature)=>$66050da24b77bea6$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName)=>$66050da24b77bea6$var$hasAllowedFeature(feature, featureName))) ?? false;
};
const $66050da24b77bea6$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch  {
        return false;
    }
    return false;
};
const $66050da24b77bea6$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch  {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isInEditorTemplatesPanelEnabled"] = $66050da24b77bea6$export$b47e8b0fa2aae156;
module.exports["isRedirectionEnabled"] = $66050da24b77bea6$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $66050da24b77bea6$export$243fbba563b8aa8e;

});

parcelRegister("4ZxtP", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $4dbfd7f5dbf19ca5$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9EREa.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9EREa.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
module.exports["extractMembers"] = $4dbfd7f5dbf19ca5$export$6281d080d62a0719;

});

parcelRegister("dqxOF", function(module, exports) {
function $9c67ef4150ae4cb3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $9c67ef4150ae4cb3$export$967a6b9924a689f7(a, b);
    return $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(a, b);
}
 //# sourceMappingURL=index.modern.mjs.map
module.exports["shallowEqualObjects"] = $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c;

});

parcelRegister("dDboE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");

const $92e077c22efcc597$export$6be90bcb437e928f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $6JrSr.useId)()}${postfix}`;
    (0, $cozmU.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
module.exports["IdProvider"] = $92e077c22efcc597$export$6be90bcb437e928f;

});

parcelRegister("1TlML", function(module, exports) {
function $cc70dd2ba0f00d0d$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["mergeStyles"] = $cc70dd2ba0f00d0d$export$e618dc39ac9ad607;

});

parcelRegister("1Ltep", function(module, exports) {
$parcel$export(module.exports, "default", () => $1490daf4e920e8da$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $1490daf4e920e8da$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("2iY37", function(module, exports) {
$parcel$export(module.exports, "default", () => $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $1Ltep = parcelRequire("1Ltep");


var $WeoLw = parcelRequire("WeoLw");


var $3yGK6 = parcelRequire("3yGK6");

function $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    return (0, $1Ltep.default)(date).getTime() === (0, $WeoLw.default)(date).getTime();
}

});

parcelRegister("WeoLw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0af0962005736f62$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0af0962005736f62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("hEt1x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $IY7Mb = parcelRequire("IY7Mb");

const $2ddf178f2decc0e9$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $2ddf178f2decc0e9$export$57164260bc1f1218 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $2ddf178f2decc0e9$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $2ddf178f2decc0e9$export$57164260bc1f1218;

});

parcelRegister("IY7Mb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gYqFD = parcelRequire("gYqFD");

const $a0017e6c99530c15$export$d54af28440a5efc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $cozmU.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $a0017e6c99530c15$export$d54af28440a5efc0;

});

parcelRegister("gYqFD", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $c55cff04bbd4c82d$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $c55cff04bbd4c82d$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($c55cff04bbd4c82d$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $c55cff04bbd4c82d$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $c55cff04bbd4c82d$export$2d23ed2854ac1650 = $c55cff04bbd4c82d$export$7e209e67b965bc63($c55cff04bbd4c82d$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $c55cff04bbd4c82d$export$2d23ed2854ac1650;

});

parcelRegister("lNvN4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gIMcb = parcelRequire("gIMcb");


var $hEt1x = parcelRequire("hEt1x");

const $e5ff9295aa55af63$export$8b3e87ea56c3a345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $e5ff9295aa55af63$export$8b3e87ea56c3a345;

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::d33f3d33520a5e35881ec61f3c089abb>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("eU2tf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fe57f9d19e98fdc0$var$messages = (0, $kSwu1.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $fe57f9d19e98fdc0$export$2e2bcd8739ae039 = $fe57f9d19e98fdc0$var$messages;
module.exports["default"] = $fe57f9d19e98fdc0$export$2e2bcd8739ae039;

});

parcelRegister("cSSWJ", function(module, exports) {

var $1GhPJ = parcelRequire("1GhPJ");

const $e8b102093dcaac45$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $e8b102093dcaac45$var$TEAM_SUBJECT = 'teamProfileCard';
const $e8b102093dcaac45$var$USER_SUBJECT = 'profilecard';
const $e8b102093dcaac45$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */ const $e8b102093dcaac45$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $1GhPJ.getPageTime)())
        }
    });
const $e8b102093dcaac45$export$6f40cdf6d42c018d = (type)=>{
    switch(type){
        case 'user':
            return $e8b102093dcaac45$var$USER_SUBJECT;
        case 'team':
            return $e8b102093dcaac45$var$TEAM_SUBJECT;
        case 'agent':
            return $e8b102093dcaac45$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $e8b102093dcaac45$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $e8b102093dcaac45$var$createEvent('ui', 'triggered', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $e8b102093dcaac45$export$c9b0e37b229a297b = (action, attributes)=>$e8b102093dcaac45$var$createEvent('operational', action, $e8b102093dcaac45$var$TEAM_SUBJECT, 'request', attributes);
const $e8b102093dcaac45$export$12dae48763368ac9 = (action, attributes)=>$e8b102093dcaac45$var$createEvent('operational', action, $e8b102093dcaac45$var$USER_SUBJECT, 'request', attributes);
const $e8b102093dcaac45$export$41816a317479160b = (type, actionSubjectId, attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'rendered', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), actionSubjectId, attributes);
const $e8b102093dcaac45$export$fdcd134fbeb1f921 = (type, attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), 'action', attributes);
const $e8b102093dcaac45$export$93260987012593be = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$USER_SUBJECT, 'reportingLines', attributes);
const $e8b102093dcaac45$export$79befd155063a6a7 = (type, attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), 'moreActions', attributes);
const $e8b102093dcaac45$export$2703289b35687fde = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$TEAM_SUBJECT, 'avatar', attributes);
const $e8b102093dcaac45$export$b4411a7661cf2d3f = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $e8b102093dcaac45$export$c86679da702d560e = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $e8b102093dcaac45$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$e8b102093dcaac45$var$createEvent('operational', action, $e8b102093dcaac45$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);
module.exports["PACKAGE_META_DATA"] = $e8b102093dcaac45$export$849551cf61929d4f;
module.exports["getActionSubject"] = $e8b102093dcaac45$export$6f40cdf6d42c018d;

});

parcelRegister("1GhPJ", function(module, exports) {
const $b79121f0bdcafc37$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $b79121f0bdcafc37$var$performanceAvailable = $b79121f0bdcafc37$var$isPerformanceAvailable();
const $b79121f0bdcafc37$var$initialPageTime = Date.now();
const $b79121f0bdcafc37$export$e9faea7c41053334 = ()=>{
    if ($b79121f0bdcafc37$var$performanceAvailable) return performance.now();
    return Date.now() - $b79121f0bdcafc37$var$initialPageTime;
};
module.exports["getPageTime"] = $b79121f0bdcafc37$export$e9faea7c41053334;

});

parcelRegister("4k5Wq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $5avUB = parcelRequire("5avUB");


var $4aRua = parcelRequire("4aRua");


var $eU2tf = parcelRequire("eU2tf");


var $hHYlx = parcelRequire("hHYlx");


var $cSSWJ = parcelRequire("cSSWJ");

const $0f12e30f7425acf6$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorUserNotFound
                })
            });
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorGeneric
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $eU2tf.default).errorRetrySuggestion
                        })
                    })
                ]
            });
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onClick: reload,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorTryAgain
            })
        });
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
            testId: "profilecard-error",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorUserNotFound
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorGeneric
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorRetrySuggestion
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "icon error"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                onClick: reload,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorTryAgain
                })
            })
        ]
    });
};
var $0f12e30f7425acf6$export$2e2bcd8739ae039 = $0f12e30f7425acf6$var$ErrorMessage;
module.exports["default"] = $0f12e30f7425acf6$export$2e2bcd8739ae039;

});

parcelRegister("hHYlx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $3b2daa1fed2d9894$var$styles = {
    errorWrapper: "_2fwxA5DIqT _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    errorTitle: "_3138422ADO",
    teamErrorText: "_1UtDYzKGUX _3138422ADO"
};
const $3b2daa1fed2d9894$export$bb27b7e39840238f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper),
        ...props
    });
const $3b2daa1fed2d9894$export$b065fd053267ec81 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                color: "color.text",
                children: props.children
            })
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text",
            children: props.children
        })
    });
const $3b2daa1fed2d9894$export$90d92ccfb27352c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            children: props.children
        });
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText),
        children: props.children
    });
module.exports["ErrorWrapper"] = $3b2daa1fed2d9894$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $3b2daa1fed2d9894$export$b065fd053267ec81;

});

parcelRegister("jgqX6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0646b18c90b3a18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3c3I9 = parcelRequire("3c3I9");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");


var $2iY37 = parcelRequire("2iY37");

function $e0646b18c90b3a18$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $3c3I9.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $2iY37.default)((0, $dkBOe.default)(dirtyDateLeft)) && difference === 1 && (0, $eYSi7.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("3c3I9", function(module, exports) {
$parcel$export(module.exports, "default", () => $25355f04f79cc351$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $25355f04f79cc351$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("eYSi7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae80c86a80ef7d08$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $ae80c86a80ef7d08$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("4PAHv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $7G50J = parcelRequire("7G50J");


var $eW61a = parcelRequire("eW61a");


var $lUcpS = parcelRequire("lUcpS");


var $1kejP = parcelRequire("1kejP");


var $dRAjC = parcelRequire("dRAjC");


var $4k5Wq = parcelRequire("4k5Wq");


var $kb2tZ = parcelRequire("kb2tZ");


var $hIwXM = parcelRequire("hIwXM");

const $fe1c8bc12e81e628$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $cozmU.useState)();
    // Initialize as true when fix is enabled since we fetch immediately on mount,
    // avoiding a brief error screen flash before the useEffect fires.
    const [isLoading, setIsLoading] = (0, $cozmU.useState)((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash'));
    const [error, setError] = (0, $cozmU.useState)();
    const [isPermitted, setIsPermitted] = (0, $cozmU.useState)(true);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const creatorUserId = (0, $cozmU.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dRAjC.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $eW61a.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $cozmU.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = (0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash') ? creator_type === 'CUSTOMER' && creator ? (0, $dRAjC.getAAIDFromARI)(creator) : undefined : creatorUserId;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                if ((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) profileHref = (0, $eW61a.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $7G50J.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        creatorUserId,
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $1kejP.AgentForbiddenError) && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) return;
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) return;
        fetchData();
    }, [
        fetchData
    ]);
    const forbiddenAgent = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        } : undefined, [
        props.agentName,
        props.accountId
    ]);
    if (!isPermitted && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
                agent: (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? forbiddenAgent : {
                    id: '',
                    named_id: '',
                    name: props.agentName ?? '',
                    description: '\u00A0',
                    creator_type: 'CUSTOMER',
                    is_default: false,
                    actor_type: 'AGENT',
                    user_defined_conversation_starters: null,
                    favourite: false,
                    favourite_count: 0,
                    identity_account_id: props.accountId,
                    creatorInfo: undefined
                },
                isLoading: false,
                resourceClient: props.resourceClient,
                cloudId: props.cloudId,
                hideAgentActions: true,
                hideConversationStarters: true,
                hideAiDisclaimer: true,
                hideStarButton: props.hideStarButton,
                showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
                footerComponent: props.footerComponent
            })
        })
    });
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4k5Wq.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: fireEvent
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions,
            hideAiDisclaimer: props.hideAiDisclaimer,
            hideConversationStarters: props.hideConversationStarters,
            hideAgentActions: props.hideAgentActions,
            hideStarButton: props.hideStarButton,
            showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
            footerComponent: props.footerComponent
        })
    });
};
module.exports["AgentProfileCardResourced"] = $fe1c8bc12e81e628$export$4b013ffffcb40af8;

});

parcelRegister("7G50J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");


var $bltJZ = parcelRequire("bltJZ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $6h4xM = parcelRequire("6h4xM");


var $i4kCF = parcelRequire("i4kCF");


var $hq9Cp = parcelRequire("hq9Cp");


var $fNIRw = parcelRequire("fNIRw");

const $f5fec235121c7193$var$styles = {
    clickableItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoIconWrapper: "_3iDTPbQ4SZ",
    name: "_37wbyuI7V3 _0hPCNLchRC",
    description: "_3SamIHPgdg _3zvHkHdC7N _3W2Oc8wPeg",
    headingWrapper: "_1mT5xdRAKS",
    hiddenIconWrapper: "_313842FQfX"
};
const $f5fec235121c7193$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $f5fec235121c7193$export$f35b2eeaa7e3db15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: t1 } = t0;
    const showCreatorNameWithoutLink = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick || $[4] !== showCreatorNameWithoutLink) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") {
                const creatorName = `${creator.name} ${creator.status === "inactive" ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ""}`;
                return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                    creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: creator.profileLink,
                        onClick: ()=>onCreatorLinkClick(),
                        target: "_blank"
                    }, creatorName)
                });
            }
            if (creator.type === "REMOTE_A2A") {
                if ((0, $cXtTj.default).getExperimentValue("rovo_hide_remote_a2a_agent_creator_exp", "isEnabled", false)) return null;
                return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                    creatorNameWithLink: creator.name
                });
            }
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t2 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = showCreatorNameWithoutLink;
        $[5] = t2;
    } else t2 = $[5];
    const creatorRender = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes");
        $[6] = t3;
    } else t3 = $[6];
    const hideCreatorIcon = t3;
    if ((0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== "REMOTE_A2A";
        let t4;
        if ($[7] !== creatorRender || $[8] !== showRovoIcon) {
            t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[7] = creatorRender;
            $[8] = showRovoIcon;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== creatorRender) {
        t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[10] = creatorRender;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: showCreatorNameWithoutLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') {
            const creatorName = `${creator.name} ${creator.status === 'inactive' ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ''}`;
            return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creatorName)
            });
        }
        if (creator.type === 'REMOTE_A2A') {
            if ((0, $cXtTj.default).getExperimentValue('rovo_hide_remote_a2a_agent_creator_exp', 'isEnabled', false)) return null;
            return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
        } // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    const hideCreatorIcon = (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes');
    if ((0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.clickableItem
    }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $f5fec235121c7193$export$e02348ba0b01a210 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
            label: formatMessage((0, $fNIRw.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            xcss: $f5fec235121c7193$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f5fec235121c7193$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f5fec235121c7193$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        xcss: $f5fec235121c7193$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
        label: formatMessage((0, $fNIRw.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $f5fec235121c7193$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $f5fec235121c7193$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $f5fec235121c7193$export$e02348ba0b01a210;

});

parcelRegister("6h4xM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bsSbN = parcelRequire("bsSbN");

const $fc7d462f5dd0deaa$export$bce21421c351deb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
module.exports["HiddenIcon"] = $fc7d462f5dd0deaa$export$bce21421c351deb1;

});

parcelRegister("i4kCF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iMnC5 = parcelRequire("iMnC5");


var $4ssVW = parcelRequire("4ssVW");

const $fbe2d7b3097e2d22$var$styles = {
    hidden: "_1YKVNsdnbC"
};
const $fbe2d7b3097e2d22$export$703abb8bd2abdfa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)(t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== isHovered || $[3] !== isStarred) {
        t4 = (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            });
        $[2] = isHovered;
        $[3] = isStarred;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel;
    let t6;
    if ($[5] !== agentName || $[6] !== formatMessage || $[7] !== t5) {
        t6 = formatMessage(t5, {
            agentName: agentName
        });
        $[5] = agentName;
        $[6] = formatMessage;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsHovered(true);
        t8 = ()=>setIsHovered(false);
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    let t9;
    if ($[11] !== handleToggle || $[12] !== t4 || $[13] !== t6) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: t4,
            label: t6,
            onClick: handleToggle,
            onMouseEnter: t7,
            onMouseLeave: t8
        });
        $[11] = handleToggle;
        $[12] = t4;
        $[13] = t6;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t3 || $[16] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t9);
        $[15] = t3;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!visible && $fbe2d7b3097e2d22$var$styles.hidden)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage(isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }));
};
module.exports["StarIconButton"] = $fbe2d7b3097e2d22$export$703abb8bd2abdfa5;

});

parcelRegister("4ssVW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a47d9a7d981bdb91$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $a47d9a7d981bdb91$export$2e2bcd8739ae039 = $a47d9a7d981bdb91$var$message;
module.exports["default"] = $a47d9a7d981bdb91$export$2e2bcd8739ae039;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("fNIRw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $246a354bdf98d3ad$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $246a354bdf98d3ad$export$defe85febe8b728c;

});

parcelRegister("1kejP", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $cSSWJ = parcelRequire("cSSWJ");


var $1GhPJ = parcelRequire("1GhPJ");


var $dRAjC = parcelRequire("dRAjC");


var $goaLH = parcelRequire("goaLH");


var $bTlNq = parcelRequire("bTlNq");


var $de4Mg = parcelRequire("de4Mg");


var $bCBEs = parcelRequire("bCBEs");

class $7eb6fbaa97f76140$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
const $7eb6fbaa97f76140$var$buildActivationIdQuery = (cloudId, product)=>({
        query: `
		query RovoAgentProfileCard_ActivationQuery($cloudId: ID!, $product: String!) {
			tenantContexts(cloudIds: [$cloudId]) {
				activationIdByProduct(product: $product) {
					active
				}
			}
		}
	`,
        variables: {
            cloudId: cloudId,
            product: product
        }
    });
const $7eb6fbaa97f76140$var$buildRovoAgentQueryByAri = (agentAri)=>({
        query: `
	  query RovoAgentProfileCard_AgentQueryByAri($agentAri: ID!) {
			agentStudio_agentById(id: $agentAri) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            agentAri: agentAri
        }
    });
const $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountId = (identityAccountId, cloudId)=>({
        query: `
		query RovoAgentProfileCard_AgentQueryByAccountId($id: ID!, $cloudId: String!) {
			agentStudio_agentByIdentityAccountId(cloudId: $cloudId, id: $id) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
						profileUrl
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            id: identityAccountId.startsWith((0, $dRAjC.USER_ARI_PREFIX)) ? identityAccountId : `${0, $dRAjC.USER_ARI_PREFIX}${identityAccountId}`,
            cloudId: cloudId
        }
    });
const $7eb6fbaa97f76140$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $7eb6fbaa97f76140$export$2e2bcd8739ae039 extends (0, $goaLH.default) {
    basePath() {
        return '/gateway/api/assist/rovo/v1/agents';
    }
    sharedCacheKey(idValue) {
        return `${this.options.cloudId ?? ''}:${idValue}`;
    }
    getCachedProfile(idValue) {
        const key = this.sharedCacheKey(idValue);
        const cached = (0, $bCBEs.sharedAgentProfileCache).get(key);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            (0, $bCBEs.sharedAgentProfileCache).delete(key);
            return null;
        }
        return cached.profile;
    }
    setCachedProfile(idValue, profile) {
        (0, $bCBEs.sharedAgentProfileCache).set(this.sharedCacheKey(idValue), {
            expire: Date.now() + (this.config.cacheMaxAge || (0, $bCBEs.SHARED_CACHE_MAX_AGE)),
            profile: profile
        });
    }
    async getActivationId(cloudId, product) {
        const response = await (0, $de4Mg.AGGQuery)('/gateway/api/graphql', $7eb6fbaa97f76140$var$buildActivationIdQuery(cloudId, product));
        return response?.tenantContexts?.[0]?.activationIdByProduct?.active ?? null;
    }
    async getAgentByARIAgg(agentAri) {
        const response = await (0, $de4Mg.AGGQuery)('/gateway/api/graphql', $7eb6fbaa97f76140$var$buildRovoAgentQueryByAri(agentAri));
        if (response.agentStudio_agentById?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentById returning QueryError: ${response.agentStudio_agentById.message}`);
        return response?.agentStudio_agentById;
    }
    async getAgentByAccountIdAgg(identityAccountId, cloudId) {
        const response = await (0, $de4Mg.AGGQuery)('/gateway/api/graphql', $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountId(identityAccountId, cloudId));
        if (response.agentStudio_agentByIdentityAccountId?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentByIdentityAccountId returning QueryError: ${response.agentStudio_agentByIdentityAccountId.message}`);
        return response?.agentStudio_agentByIdentityAccountId;
    }
    makeRequest(id, analytics) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
        let restPromise;
        if (id.type === 'identity') restPromise = fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>{
            if (response.status === 403 && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) throw new $7eb6fbaa97f76140$export$a6d78d75d03919f1();
            return response.json();
        });
        else restPromise = fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>{
            if (response.status === 403 && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) throw new $7eb6fbaa97f76140$export$a6d78d75d03919f1();
            return response.json();
        });
        const aggStartTime = (0, $1GhPJ.getPageTime)();
        const aggPromise = this.getActivationId(this.options.cloudId || '', this.options.productIdentifier || 'rovo').then((activationId)=>{
            if (!activationId) throw new Error('ProfileCard Activation ID not found');
            if (id.type === 'identity') return this.getAgentByAccountIdAgg(id.value, this.options.cloudId || '');
            else {
                const agentAri = `ari:cloud:rovo::agent/activation/${activationId}/${id.value}`;
                return this.getAgentByARIAgg(agentAri);
            }
        })// We are not going to break the flow if the AGG endpoint fails for now
        // @TODO once all the data moved to AGG, we can remove this catch
        .catch((error)=>{
            if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                ...(0, $bTlNq.getErrorAttributes)(error),
                errorType: 'RovoAgentProfileCardAggError',
                duration: (0, $1GhPJ.getPageTime)() - aggStartTime,
                gateway: true,
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            return Promise.resolve(null);
        });
        return Promise.all([
            restPromise,
            aggPromise
        ]).then(([restData, aggData])=>({
                restData: restData,
                aggData: aggData
            }));
    }
    /**
   * This function will call both REST and AGG endpoints to get the agent profile
   * There are some data that is only available in the AGG endpoint, so we need to call both
   * For any new fields, please only add them to the AGG endpoint
   *
   * @TODO migrate everything to AGG endpoint
   */ getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            this.makeRequest(id, analytics).then((data)=>{
                this.setCachedProfile(id.value, data);
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.deleteAgent', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve();
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.deleteAgent', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics(`operational.rovoAgentProfilecard.triggered.${actionSubjectId}`, {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.succeeded.${actionSubjectId}`, {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                this.syncFavouriteToCache(agentId, isFavourite);
                resolve();
            }).catch((error)=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.failed.${actionSubjectId}`, {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    /**
   * Keeps the shared agent profile cache in sync with the favourite state
   */ syncFavouriteToCache(agentId, isFavourite) {
        const prefix = `${this.options.cloudId ?? ''}:`;
        const keysToUpdate = [];
        (0, $bCBEs.sharedAgentProfileCache).forEach((cached, key)=>{
            if (key.startsWith(prefix) && cached.profile?.restData?.id === agentId) keysToUpdate.push(key);
        });
        keysToUpdate.forEach((key)=>{
            const cached = (0, $bCBEs.sharedAgentProfileCache).get(key);
            if (!cached) return;
            const { restData: restData } = cached.profile;
            const wasFavourite = restData.favourite;
            const currentCount = restData.favourite_count ?? 0;
            const favouriteCount = isFavourite ? currentCount + (wasFavourite ? 0 : 1) : Math.max(0, currentCount - (wasFavourite ? 1 : 0));
            (0, $bCBEs.sharedAgentProfileCache).set(key, {
                ...cached,
                profile: {
                    ...cached.profile,
                    restData: {
                        ...restData,
                        favourite: isFavourite,
                        favourite_count: favouriteCount
                    }
                }
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.succeeded.getAgentPermissions', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.failed.getAgentPermissions', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    constructor(options){
        super(options);
        this.options = void 0;
        this.options = options;
    }
}
module.exports["AgentForbiddenError"] = $7eb6fbaa97f76140$export$a6d78d75d03919f1;
module.exports["default"] = $7eb6fbaa97f76140$export$2e2bcd8739ae039;

});

parcelRegister("dRAjC", function(module, exports) {
const $d2643a1af3062f27$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d2643a1af3062f27$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d2643a1af3062f27$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $d2643a1af3062f27$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $d2643a1af3062f27$export$3761e66a04602cbd;

});

parcelRegister("goaLH", function(module, exports) {

var $lPEt0 = parcelRequire("lPEt0");

class $796bf3f876369ae9$export$2e2bcd8739ae039 {
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
    constructor(config){
        this.config = void 0;
        this.cache = void 0;
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $lPEt0.LRUMap)(this.config.cacheSize);
    }
}
module.exports["default"] = $796bf3f876369ae9$export$2e2bcd8739ae039;

});

parcelRegister("bTlNq", function(module, exports) {

var $44kjq = parcelRequire("44kjq");

const $ee2789e570b42c37$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $ee2789e570b42c37$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $ee2789e570b42c37$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $ee2789e570b42c37$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $44kjq.DirectoryGraphQLError)) return !!error && $ee2789e570b42c37$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $44kjq.AGGError)) return !!error.errorType && $ee2789e570b42c37$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $ee2789e570b42c37$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $ee2789e570b42c37$export$6ad9e7706a4ee0f8 = (error)=>{
    const defaultErrorAttributes = {
        errorCount: null,
        errorDetails: null,
        errorCategory: null,
        errorType: null,
        errorPath: null,
        errorNumber: null,
        errorStatusCode: null,
        traceId: null,
        errorStack: null
    };
    if (error instanceof (0, $44kjq.DirectoryGraphQLErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($ee2789e570b42c37$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($ee2789e570b42c37$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $44kjq.DirectoryGraphQLError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber ?? null,
        isSLOFailure: !$ee2789e570b42c37$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $44kjq.AGGErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($ee2789e570b42c37$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($ee2789e570b42c37$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $44kjq.AGGError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorType: error.errorType ?? null,
        errorStatusCode: error.statusCode ?? null,
        isSLOFailure: !$ee2789e570b42c37$var$isIgnoredError(error),
        errorCategory: error.classification ?? null
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $44kjq.DirectoryGraphQLErrors) || causeError instanceof (0, $44kjq.AGGErrors)) return $ee2789e570b42c37$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                ...defaultErrorAttributes,
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            ...defaultErrorAttributes,
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        ...defaultErrorAttributes,
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $ee2789e570b42c37$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $44kjq.DirectoryGraphQLErrors)(errors, traceId);
};
const $ee2789e570b42c37$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $44kjq.AGGErrors)(errors, traceId);
};
module.exports["getErrorAttributes"] = $ee2789e570b42c37$export$6ad9e7706a4ee0f8;
module.exports["handleDirectoryGraphQLErrors"] = $ee2789e570b42c37$export$7642af465ceb7f05;
module.exports["handleAGGErrors"] = $ee2789e570b42c37$export$d9ad65d422ee3f8c;

});

parcelRegister("44kjq", function(module, exports) {
class $6e856ef94dca185e$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = void 0;
        this.traceId = void 0;
        this.code = code;
        this.traceId = traceId;
    }
}
class $6e856ef94dca185e$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = void 0;
        this.type = void 0;
        this.path = void 0;
        this.errorNumber = void 0;
        this.extensions = void 0;
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $6e856ef94dca185e$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $6e856ef94dca185e$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $6e856ef94dca185e$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = void 0;
        this.extensions = void 0;
        this.statusCode = void 0;
        this.errorType = void 0;
        this.classification = void 0;
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $6e856ef94dca185e$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $6e856ef94dca185e$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}
module.exports["HttpError"] = $6e856ef94dca185e$export$65bd6083489bd8bb;
module.exports["DirectoryGraphQLError"] = $6e856ef94dca185e$export$c1e4d0de940c06a2;
module.exports["DirectoryGraphQLErrors"] = $6e856ef94dca185e$export$5a5fbfed34a590a1;
module.exports["AGGError"] = $6e856ef94dca185e$export$4a696f048dcc929;
module.exports["AGGErrors"] = $6e856ef94dca185e$export$60d8267243755b9c;

});

parcelRegister("de4Mg", function(module, exports) {

var $44kjq = parcelRequire("44kjq");


var $bTlNq = parcelRequire("bTlNq");

const $c62bb02609d7d21d$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $c62bb02609d7d21d$var$id = (headers)=>headers;
async function $c62bb02609d7d21d$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $c62bb02609d7d21d$var$id) {
    return $c62bb02609d7d21d$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bTlNq.handleDirectoryGraphQLErrors));
}
async function $c62bb02609d7d21d$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $c62bb02609d7d21d$var$id) {
    return $c62bb02609d7d21d$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bTlNq.handleAGGErrors));
}
async function $c62bb02609d7d21d$var$graphQLQuery(serviceUrl, query, processHeaders = $c62bb02609d7d21d$var$id, handleErrors) {
    const headers = processHeaders($c62bb02609d7d21d$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $44kjq.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}
module.exports["directoryGraphqlQuery"] = $c62bb02609d7d21d$export$a5b5995619d4fe36;
module.exports["AGGQuery"] = $c62bb02609d7d21d$export$a14afb5f82fe705;

});

parcelRegister("bCBEs", function(module, exports) {

var $lPEt0 = parcelRequire("lPEt0");

const $0e922c460acdfb54$var$SHARED_CACHE_SIZE = 50;
const $0e922c460acdfb54$export$815222107f6bee54 = 300000; // 5 minutes
const $0e922c460acdfb54$export$d0bf8b40238c05cd = new (0, $lPEt0.LRUMap)($0e922c460acdfb54$var$SHARED_CACHE_SIZE);
module.exports["SHARED_CACHE_MAX_AGE"] = $0e922c460acdfb54$export$815222107f6bee54;
module.exports["sharedAgentProfileCache"] = $0e922c460acdfb54$export$d0bf8b40238c05cd;

});

parcelRegister("kb2tZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $d107d3e886647d93$var$styles = {
    wrapper: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
    wrapperLegacy: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d"
};
const $d107d3e886647d93$export$2c6604b50c274e6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $d107d3e886647d93$var$styles.wrapper,
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
            children: children
        });
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapper,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
        children: children
    });
};
module.exports["AgentProfileCardWrapper"] = $d107d3e886647d93$export$2c6604b50c274e6f;

});

parcelRegister("hIwXM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $795534535f4e0b8b$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lHol9")));
module.exports["AgentProfileCardLazy"] = $795534535f4e0b8b$export$ed0ca9c1d49ea0bf;

});

parcelRegister("lHol9", function(module, exports) {

let $fcc07e96b4dcc5b5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fcc07e96b4dcc5b5$var$load("eS3wT"),
    $fcc07e96b4dcc5b5$var$load("4uO8Y"),
    $fcc07e96b4dcc5b5$var$load("6wr18"),
    $fcc07e96b4dcc5b5$var$load("aPykv"),
    $fcc07e96b4dcc5b5$var$load("jqoep"),
    $fcc07e96b4dcc5b5$var$load("7EorR"),
    $fcc07e96b4dcc5b5$var$load("ea3NB"),
    $fcc07e96b4dcc5b5$var$load("ffEVr"),
    $fcc07e96b4dcc5b5$var$load("hhss7"),
    $fcc07e96b4dcc5b5$var$load("68aog")
]).then(()=>parcelRequire('ark00'));

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<f026ee318392a45fe95d1de0923dc1ed>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("dA1Sn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoFullCycleOutput = fullCycleOutput === undefined;
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $cozmU.useState)(isNoSSR || isNoFullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $cozmU.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- the saveFullCycleOutput() only runs in the browser
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { style: style, name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if ((0, $6mKj3.expValEquals)("cc_fix_hydration_ttvc", "isEnabled", true)) {
        if (!enabled) return children;
        if (hydrated) {
            let t3;
            if ($[0] !== name || $[1] !== ssrPlaceholder) {
                t3 = ssrPlaceholder ? {
                    "data-ssr-placeholder": name,
                    "data-ssr-placeholder-replace": name
                } : {};
                $[0] = name;
                $[1] = ssrPlaceholder;
                $[2] = t3;
            } else t3 = $[2];
            let t4;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t4 = {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                };
                $[3] = t4;
            } else t4 = $[3];
            let t5;
            if ($[4] !== children || $[5] !== name || $[6] !== t3) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    "data-testid": "two-stage-hydration",
                    "data-fullcycle-name": name,
                    ...t3,
                    style: t4
                }, children);
                $[4] = children;
                $[5] = name;
                $[6] = t3;
                $[7] = t5;
            } else t5 = $[7];
            return t5;
        }
        const innerHTML = fullCycleOutput;
        let t3;
        if ($[8] !== name || $[9] !== ssrPlaceholder) {
            t3 = ssrPlaceholder ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[8] = name;
            $[9] = ssrPlaceholder;
            $[10] = t3;
        } else t3 = $[10];
        let t4;
        if ($[11] !== innerHTML) {
            t4 = {
                __html: innerHTML
            };
            $[11] = innerHTML;
            $[12] = t4;
        } else t4 = $[12];
        let t5;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[13] = t5;
        } else t5 = $[13];
        let t6;
        if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                dangerouslySetInnerHTML: t4,
                style: t5
            });
            $[14] = name;
            $[15] = t3;
            $[16] = t4;
            $[17] = t6;
        } else t6 = $[17];
        return t6;
    }
    if (!enabled || hydrated) return children;
    const innerHTML_0 = fullCycleOutput;
    let t3;
    if ($[22] !== innerHTML_0) {
        t3 = {
            __html: innerHTML_0
        };
        $[22] = innerHTML_0;
        $[23] = t3;
    } else t3 = $[23];
    let t4;
    if ($[24] !== name || $[25] !== style || $[26] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: style,
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            dangerouslySetInnerHTML: t3
        });
        $[24] = name;
        $[25] = style;
        $[26] = t3;
        $[27] = t4;
    } else t4 = $[27];
    return t4;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { name: name, style: style, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder || $[4] !== style) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            style: style,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = style;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const contentId = rec?.content?.id;
        if (!contentId) return;
        const el = transformedRecs.find((card)=>card?.id === contentId);
        if (el) pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder',
    'slide'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("brn6e", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7PLO8 = parcelRequire("7PLO8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $5DJsZ = parcelRequire("5DJsZ");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $iDrrr.fg)('confluence_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName, aiSuggestedEmojiId: aiSuggestedEmojiId, isSmartCreate: isSmartCreate, hasReplacedAIFCEmoji: hasReplacedAIFCEmoji, setHasReplacedAIFCEmoji: setHasReplacedAIFCEmoji, aiEmojiSuggestionSource: aiEmojiSuggestionSource }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    // Snapshot before overwrite to detect if the AIFC-suggested emoji was replaced.
    const previouslySelectedEmoji = emojiTitleState.state.selectedEmoji;
    const previouslySelectedEmojiId = typeof previouslySelectedEmoji === 'string' ? previouslySelectedEmoji : previouslySelectedEmoji?.id;
    const replacedAIFCSuggestedEmoji = !hasReplacedAIFCEmoji && !!isSmartCreate && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedAIFCSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedBlankPageAutoSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'pasteAutoTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedBlankPageAutoSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedSuggestTitleSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'suggestTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedSuggestTitleSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    // Snapshot the shared flag at fire time so the value reflects the latest
    // state regardless of when/where the picker JSX was created.
    const justRestoredEmoji = !!emojiTitleState.justRestoredEmoji;
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage,
            replacedAIFCSuggestedEmoji: replacedAIFCSuggestedEmoji,
            replacedBlankPageAutoSuggestedEmoji: replacedBlankPageAutoSuggestedEmoji,
            replacedSuggestTitleSuggestedEmoji: replacedSuggestTitleSuggestedEmoji,
            aiEmojiSuggestionSource: aiEmojiSuggestionSource,
            isRestoreLatestEmojiEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji'),
            replacedRestoredEmoji: justRestoredEmoji
        }
    });
    // Reset after firing so the next selection correctly reports
    // replacedRestoredEmoji=false.
    emojiTitleState.justRestoredEmoji = false;
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "emoji-title"
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "emoji-title"
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("3shHM", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $5DJsZ = parcelRequire("5DJsZ");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        __callerPackage__: "emoji-title"
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $gsyiL = parcelRequire("gsyiL");

var $iOCEj = parcelRequire("iOCEj");

var $av9vJ = parcelRequire("av9vJ");

var $lEAnc = parcelRequire("lEAnc");

var $6B1vK = parcelRequire("6B1vK");

var $1lJ86 = parcelRequire("1lJ86");

var $cCPLV = parcelRequire("cCPLV");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $6B1vK.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $gsyiL.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $cCPLV.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iOCEj.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $av9vJ.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lEAnc.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $1lJ86.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("iOCEj", function(module, exports) {

var $jp6rV = parcelRequire("jp6rV");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/database/manifest.ts
var $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jp6rV.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $jp6rV.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $db2ae073c8566cc3$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $db2ae073c8566cc3$export$317cd32472deea7e;

});

parcelRegister("jp6rV", function(module, exports) {
// src/confluence/database/types.ts
var $e2055ad385da7e5a$export$e83bc7b627335f1d = "confluence", $e2055ad385da7e5a$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $e2055ad385da7e5a$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $e2055ad385da7e5a$export$d26db9a1a0b750aa;

});

parcelRegister("av9vJ", function(module, exports) {

var $1pgGd = parcelRequire("1pgGd");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/embed/manifest.ts
var $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1pgGd.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $1pgGd.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $7a542d43713a04fa$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $7a542d43713a04fa$export$47d4b4205d0ac61a;

});

parcelRegister("1pgGd", function(module, exports) {
// src/confluence/embed/types.ts
var $10651083a44828c2$export$7a02af293cacddd2 = "confluence", $10651083a44828c2$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $10651083a44828c2$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $10651083a44828c2$export$f817d48842ea0d4a;

});

parcelRegister("lEAnc", function(module, exports) {

var $7SOnZ = parcelRequire("7SOnZ");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/folder/manifest.ts
var $fc398c589f411de7$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7SOnZ.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $7SOnZ.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $fc398c589f411de7$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $fc398c589f411de7$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $fc398c589f411de7$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $fc398c589f411de7$export$501a782385a3f485;

});

parcelRegister("7SOnZ", function(module, exports) {
// src/confluence/folder/types.ts
var $5bd4a92be6836a9b$export$77cf4e1b17902bfa = "confluence", $5bd4a92be6836a9b$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $5bd4a92be6836a9b$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $5bd4a92be6836a9b$export$6256ff329bc25a9c;

});

parcelRegister("1lJ86", function(module, exports) {

var $1AG0i = parcelRequire("1AG0i");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/slide/manifest.ts
var $0fbac26e81c45336$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1AG0i.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $1AG0i.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $0fbac26e81c45336$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $0fbac26e81c45336$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $0fbac26e81c45336$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $0fbac26e81c45336$export$86048ac46024146a;

});

parcelRegister("1AG0i", function(module, exports) {
// src/confluence/slide/types.ts
var $1289bc4ba87a8942$export$204fa7edd529d4b3 = "confluence", $1289bc4ba87a8942$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $1289bc4ba87a8942$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $1289bc4ba87a8942$export$3de52c55a164daa4;

});

parcelRegister("hSHWm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $cozmU.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("hrAmX", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");


var $6mKj3 = parcelRequire("6mKj3");


var $a4dgs = parcelRequire("a4dgs");


var $8zRYE = parcelRequire("8zRYE");


var $jecot = parcelRequire("jecot");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.findIndex((banner)=>banner.name === name);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $a4dgs.BaseStateContainer) {
    constructor(props = {}){
        super();
        // Resolved unconditionally, even when it is about to be discarded, so that exposure for the
        // nav-height flags is unchanged from before this was extracted into a helper.
        this.topNavHeight = void 0;
        /**
     * Read once per instance rather than at each callsite. A mid-session flip would leave this
     * container reading from one backing while writing to the other, losing banners outright.
     * `topNavHeight` below is frozen at construction for the same reason.
     */ this.storeBacked = void 0;
        this.suppressed = void 0;
        this.pendingNotify = null;
        this.unsubscribeFromStore = null;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            if (this.storeBacked) {
                // The store defers and coalesces; a suppressed container drops the write entirely.
                if (!this.suppressed) (0, $8zRYE.showBanner)(name, height);
                return;
            }
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    // Replace rather than mutate: mutating would let the previous state observe the new
                    // height, defeating any memoisation downstream.
                    newArray[index] = {
                        name: name,
                        height: height
                    };
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            if (this.storeBacked) {
                if (!this.suppressed) (0, $8zRYE.hideBanner)(name);
                return;
            }
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        /**
     * Detaches from the store. unstated gives containers no teardown hook, so any caller that creates
     * short-lived containers — fixtures, tests, anything mounted more than once — must call this, or
     * the store keeps the listener and with it this instance alive for the lifetime of the module.
     */ this.destroy = ()=>{
            this.unsubscribeFromStore?.();
            this.unsubscribeFromStore = null;
        };
        this.scheduleNotify = ()=>{
            if (this.pendingNotify) return;
            this.pendingNotify = Promise.resolve().then(()=>{
                this.pendingNotify = null;
                return this.notifyListeners();
            });
        };
        const navHeight = (0, $jecot.resolveTopNavHeight)();
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.suppressed = props.suppressed === true;
        this.storeBacked = (0, $6mKj3.expVal)('confluence_banners_module_store', 'isEnabled', false);
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
        if (this.storeBacked && !this.suppressed) {
            (0, $8zRYE.seedBanners)(this.state.banners);
            this.state = {
                banners: (0, $8zRYE.getBanners)()
            };
            // Mirror the store into `this.state` so every existing reader keeps working unchanged:
            // getTotalHeight, getBannerList, and the 46 `Subscribe` consumers reading state.banners.
            // The mirror is synchronous so a read straight after a flush is fresh; the notification is
            // coalesced, so a tick's worth of store changes costs one round no matter which container
            // (or, later, which hook) wrote them.
            this.unsubscribeFromStore = (0, $8zRYE.subscribeToBanners)(()=>{
                this.state = {
                    banners: (0, $8zRYE.getBanners)()
                };
                this.scheduleNotify();
            });
        }
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("a4dgs", function(module, exports) {
// unstated is deprecated; new banner state belongs in src/bannerStore.ts
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $5ed4587dbe3a0e20$export$5db0f71585d91cd4 extends (0, $kNIYN.Container) {
    subscribe(fn) {
        this.listeners.add(fn);
    }
    unsubscribe(fn) {
        this.listeners.delete(fn);
    }
    setState(updater, callback) {
        return Promise.resolve().then(()=>{
            const next = typeof updater === 'function' ? updater(this.state) : updater;
            if (next == null) {
                callback?.();
                return;
            }
            this.state = Object.assign({}, this.state, next);
            return this.notifyListeners().then(()=>{
                callback?.();
            });
        });
    }
    notifyListeners() {
        // Snapshot before notifying: a listener's re-render makes unstated's Subscribe unsubscribe
        // and resubscribe, which would mutate the Set mid-iteration.
        const snapshot = Array.from(this.listeners);
        return Promise.all(snapshot.map((listener)=>listener())).then(()=>undefined);
    }
    constructor(...args){
        super(...args);
        this.listeners = new Set();
    }
}
module.exports["BaseStateContainer"] = $5ed4587dbe3a0e20$export$5db0f71585d91cd4;

});

parcelRegister("8zRYE", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");

/**
 * Module store for the page-top banner stack, read through `useSyncExternalStore`.
 *
 * A module store, not a library: see `docs/llm/agent-instructions/common/state-management.md`.
 *
 * Writes are deferred to a microtask and coalesced here rather than in any caller, so every writer —
 * the container shim and the `useBannerState` hooks — inherits it. Notification is synchronous and
 * several banners still call `show`/`hide` from a render body, so an undeferred write would update
 * other components mid-render.
 *
 * Global and unscoped: only three production containers exist — the client root, the SSR root
 * (mutually exclusive with it), and `WithoutBanners`, which is write-free and read-once.
 *
 * SSR: Tesseract isolates each request, so module state is per-request. `handleReactRender.tsx`
 * serialises the server's list into `window.__SSR_BANNERS__`, which this store reads at module init,
 * so the first render — including the hydrating one — matches the server without waiting on a
 * container. The server has no such global, so its seed is an explicit `seedBanners` call from the
 * SSR entry point; that keeps `ssrBannerManager` out of this module.
 *
 * `stableUI=1` (E2E/VR runs) is honoured here, at all three entry points that can change `banners`,
 * rather than in each writer. `BannerStateContainer` has its own guards, but they only cover the
 * legacy path once this store is the source of truth: `ssrBannerManager` registers banners
 * regardless of the URL param, so the hydration seed would hand the container back the very banners
 * it dropped, and the `useBannerState` hooks that replace it never saw the param at all.
 */ /** Frozen so a consumer cannot mutate it, and stable so `getSnapshot` never triggers a re-render. */ const $827d62b6188a5818$var$NO_BANNERS = Object.freeze([]);
/**
 * Read at module init rather than from a component, so the store is populated before anything
 * renders. Entries are validated because the value is deserialised from the page.
 *
 * No `typeof window` guard: the build substitutes `globalThis`, so `window` is always defined in both
 * environments. On the server the property simply is not set, which the `Array.isArray` check already
 * covers — the server seed comes from `seedBanners` instead.
 */ const $827d62b6188a5818$var$readHydrationBanners = ()=>{
    // `Array.isArray` is deliberately first: it short-circuits on the server, where the global is
    // never set, so the request URI — not available this early in module evaluation — is never read.
    if (!Array.isArray(window.__SSR_BANNERS__) || (0, $i3jcY.isStableUIEnabledForTests)()) return $827d62b6188a5818$var$NO_BANNERS;
    const parsed = window.__SSR_BANNERS__.filter((banner)=>typeof banner?.name === 'string' && typeof banner?.height === 'number');
    return parsed.length > 0 ? parsed : $827d62b6188a5818$var$NO_BANNERS;
};
let $827d62b6188a5818$var$banners = $827d62b6188a5818$var$readHydrationBanners();
const $827d62b6188a5818$var$listeners = new Set();
const $827d62b6188a5818$export$49fd326b255f6ddb = ()=>$827d62b6188a5818$var$banners;
const $827d62b6188a5818$export$7cfac2c025b473e4 = (listener)=>{
    $827d62b6188a5818$var$listeners.add(listener);
    return ()=>{
        $827d62b6188a5818$var$listeners.delete(listener);
    };
};
const $827d62b6188a5818$var$commit = (next)=>{
    $827d62b6188a5818$var$banners = next;
    // Snapshot first: a listener may unsubscribe while being notified.
    Array.from($827d62b6188a5818$var$listeners).forEach((listener)=>listener());
};
let $827d62b6188a5818$var$pending = [];
let $827d62b6188a5818$var$pendingFlush = null;
const $827d62b6188a5818$var$enqueue = (mutate)=>{
    // Evaluated per call rather than memoised at module init, matching `BannerStateContainer.show`:
    // an SPA transition changes `window.location.search`, so the param is not a session constant.
    // Hides are dropped along with shows, which is safe because nothing can enter the store.
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    $827d62b6188a5818$var$pending.push(mutate);
    if ($827d62b6188a5818$var$pendingFlush) return;
    $827d62b6188a5818$var$pendingFlush = Promise.resolve().then(()=>{
        $827d62b6188a5818$var$pendingFlush = null;
        const queued = $827d62b6188a5818$var$pending;
        $827d62b6188a5818$var$pending = [];
        let next = $827d62b6188a5818$var$banners;
        let changed = false;
        for (const run of queued){
            // Applied against the running value, not the pre-flush one, so a name shown twice in a tick
            // resolves against the first write rather than duplicating.
            const result = run(next);
            if (result === undefined) continue;
            next = result;
            changed = true;
        }
        if (changed) $827d62b6188a5818$var$commit(next);
    });
};
const $827d62b6188a5818$export$f5c0eb035ef26e87 = (name, height)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return [
            ...current,
            {
                name: name,
                height: height
            }
        ];
        if (current[index].height !== height) {
            const next = [
                ...current
            ];
            // Replace rather than mutate, so the previous array keeps the old height.
            next[index] = {
                name: name,
                height: height
            };
            return next;
        }
        return undefined;
    });
};
const $827d62b6188a5818$export$11fa8b7d26b756a8 = (name)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return undefined;
        const next = [
            ...current
        ];
        next.splice(index, 1);
        return next;
    });
};
const $827d62b6188a5818$export$468156c225d4c0f9 = (initial)=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    if ($827d62b6188a5818$var$banners.length === 0 && initial.length > 0) $827d62b6188a5818$var$commit([
        ...initial
    ]);
};
const $827d62b6188a5818$export$b3f5cfd1906442cb = ()=>{
    $827d62b6188a5818$var$banners = $827d62b6188a5818$var$NO_BANNERS;
    $827d62b6188a5818$var$listeners.clear();
    $827d62b6188a5818$var$pending = [];
    $827d62b6188a5818$var$pendingFlush = null;
};
module.exports["getBanners"] = $827d62b6188a5818$export$49fd326b255f6ddb;
module.exports["subscribeToBanners"] = $827d62b6188a5818$export$7cfac2c025b473e4;
module.exports["showBanner"] = $827d62b6188a5818$export$f5c0eb035ef26e87;
module.exports["hideBanner"] = $827d62b6188a5818$export$11fa8b7d26b756a8;
module.exports["seedBanners"] = $827d62b6188a5818$export$468156c225d4c0f9;

});

parcelRegister("jecot", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $ff48e00b2c36a911$export$756e5b68ec79d923 = ()=>{
    if (// The increased height change is applied when FHS or app switcher improvements are enabled.
    // Ideally we could check `useIsFhsEnabled()` but this has to work outside React too.
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false) || (0, $9wGTI.fg)('platform_dst_ads_appswitcher_improvements')) return 56;
    return 48;
};
module.exports["resolveTopNavHeight"] = $ff48e00b2c36a911$export$756e5b68ec79d923;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $kNIYN.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        // Guards optimistic, mutation-owned fields (applied status + option list) from being
        // clobbered by stale refetches while an operation is pending. Kept off `state` so it
        // survives the refetch-driven `setInitialValues` calls.
        this.isOptimisticOperationPending = false;
        this.setIsOptimisticOperationPending = (isOptimisticOperationPending)=>{
            this.isOptimisticOperationPending = isOptimisticOperationPending;
        };
        // The contentId for which the empty add-status trigger should be kept visible after a
        // view-mode delete. Stored as an id (not a boolean) so render can scope it to the current page
        // without a navigation listener — it's only honored while this matches the active contentId,
        // so it naturally clears on navigation. Kept off `state` so a fresh container (refresh) resets it.
        this.keepEmptyTriggerForContentId = null;
        this.setKeepEmptyTriggerForContentId = (contentId)=>{
            this.keepEmptyTriggerForContentId = contentId;
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $6mKj3 = parcelRequire("6mKj3");


var $8rneB = parcelRequire("8rneB");


var $bKZz0 = parcelRequire("bKZz0");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $kNIYN.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        // Analytics-only flag: intentionally bypasses Container state so mutations
        // never trigger subscriber re-renders.
        this.justRestoredEmoji = false;
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false,
            previousEmojiIdByContentId: {}
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        this.getPreviousEmojiId = (contentId)=>this.state.previousEmojiIdByContentId[contentId] ?? null;
        // Pass `null` to clear just that entry.
        this.setPreviousEmojiId = (contentId, previousEmojiId)=>{
            const next = {
                ...this.state.previousEmojiIdByContentId
            };
            if (previousEmojiId === null) delete next[contentId];
            else next[contentId] = previousEmojiId;
            if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) (0, $bKZz0.writeSessionStoragePreviousEmojiCache)(next);
            return this.setState({
                previousEmojiIdByContentId: next
            });
        };
        if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) {
            const hydrated = (0, $bKZz0.readSessionStoragePreviousEmojiCache)();
            if (Object.keys(hydrated).length > 0) this.state = {
                ...this.state,
                previousEmojiIdByContentId: hydrated
            };
        }
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("bKZz0", function(module, exports) {
/**
 * sessionStorage mirror for the per-contentId `previousEmojiId` cache used by
 * the Live Docs "Restore emoji" affordance. Survives same-tab refresh; not a
 * source of truth — the in-memory unstated state is. Failures degrade silently.
 */ 
var $17wUi = parcelRequire("17wUi");


var $ivEX1 = parcelRequire("ivEX1");

const $dabf2e5c28263f4b$var$STORAGE_KEY = (0, $ivEX1.sessionKeys).EMOJI_TITLE_PREVIOUS_EMOJI;
const $dabf2e5c28263f4b$export$6adb2744b497be8f = ()=>{
    try {
        const raw = (0, $17wUi.confluenceSessionStorageInstance)?.getItem($dabf2e5c28263f4b$var$STORAGE_KEY);
        if (!raw || typeof raw !== 'string') return {};
        const parsed = JSON.parse(raw);
        if (!parsed || parsed.v !== 1 || typeof parsed.entries !== 'object' || !parsed.entries) return {};
        // Defensive: filter to non-empty string values in case the slot was
        // mutated by something else on the same origin.
        const out = {};
        for (const [contentId, emojiId] of Object.entries(parsed.entries))if (typeof emojiId === 'string' && emojiId.length > 0) out[contentId] = emojiId;
        return out;
    } catch  {
        return {};
    }
};
const $dabf2e5c28263f4b$export$3ef572a2467e08f4 = (map)=>{
    try {
        const entries = {};
        for (const [contentId, emojiId] of Object.entries(map))if (typeof emojiId === 'string' && emojiId.length > 0) entries[contentId] = emojiId;
        // Drop the key entirely when empty to keep storage clean.
        if (Object.keys(entries).length === 0) {
            (0, $17wUi.confluenceSessionStorageInstance)?.removeItem($dabf2e5c28263f4b$var$STORAGE_KEY);
            return;
        }
        (0, $17wUi.confluenceSessionStorageInstance)?.setItem($dabf2e5c28263f4b$var$STORAGE_KEY, JSON.stringify({
            v: 1,
            entries: entries
        }));
    } catch  {
    // Quota / consent / disabled storage — swallow; in-memory cache is unaffected.
    }
};
const $dabf2e5c28263f4b$export$fc4e54f3757eb471 = $dabf2e5c28263f4b$var$STORAGE_KEY;
module.exports["readSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$6adb2744b497be8f;
module.exports["writeSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$3ef572a2467e08f4;

});

parcelRegister("ivEX1", function(module, exports) {
/**
 * Registry of keys used with `confluenceSessionStorageInstance` (session storage).
 *
 * Keys here are intentionally NOT persisted across browser sessions.
 * Do NOT add keys here that should survive a tab close — use `LocalStorageKeys.ts` instead.
 */ const $ebcfca89ee3399cd$export$43572ca00746d574 = {
    /**
	 * The layout ('grid' | 'list') selected by the user for the folder contents view.
	 * Persisted for the duration of the browser session only.
	 */ FOLDER_VIEW_LAYOUT: 'folder.view.layout',
    /**
	 * Overrides the release track to 'dev'. Useful for running end-to-end tests
	 * from a dev machine against a production instance.
	 * Used by @confluence/build-info.
	 */ TELEMETRY_DEV_TRACK_OVERRIDE: 'confluence.telemetry-dev-track-override',
    /**
	 * Enables Confluence frontend logging when set to 'true'.
	 * Used by @confluence/logger.
	 */ ENABLE_LOGGING: 'confluence.enable-logging',
    /**
	 * Controls the minimum log level (1–5) for Confluence frontend logging.
	 * Used by @confluence/logger.
	 */ LOG_LEVEL: 'confluence.log-level',
    /**
	 * Tracks when the page-watch nudge was last shown to the user.
	 * Used by @confluence/third-party-nudge.
	 */ PAGE_VIEW_NUDGE_DATE: 'page-view-nudge-date',
    /**
	 * Tracks the state of the notification section nudge.
	 * Used by @confluence/third-party-nudge.
	 */ NOTIFICATION_NUDGE_STATE: 'notification-nudge-state',
    /**
	 * Per-contentId cache of the most recent custom emoji observed on a Live
	 * Doc, used to drive the "Restore emoji" affordance.
	 * Used by @confluence/emoji-title.
	 */ EMOJI_TITLE_PREVIOUS_EMOJI: 'confluence.emoji-title.previousEmojiId.v1',
    /**
	 * Set to `true` once the Planner title-based agent suggestion banner has been
	 * dismissed (via the close button or by clicking the CTA) during the current
	 * browser session, so it is not re-shown again until the next session.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_PLANNER_DISMISSED_SESSION: 'confluence.title-agent-nudge.planner-dismissed-session',
    /**
	 * Set to `true` once the Discovery & Feedback title-based agent suggestion
	 * banner has been dismissed (via the close button or by clicking the CTA)
	 * during the current browser session, so it is not re-shown again until the
	 * next session.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_DISCOVERY_AND_FEEDBACK_DISMISSED_SESSION: 'confluence.title-agent-nudge.discovery-and-feedback-dismissed-session',
    /**
	 * Identifies the title-based agent suggestion already shown in this editing
	 * session. The value is the owning agent/content pair so the currently visible
	 * suggestion can remain mounted while all other title suggestions are suppressed.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_SHOWN_SESSION: 'confluence.title-agent-nudge.shown-session'
};
module.exports["sessionKeys"] = $ebcfca89ee3399cd$export$43572ca00746d574;

});

parcelRegister("hjygH", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $1aeb691895c5954d$export$85823f26dca064c3(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("ecUYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $7xVCs = parcelRequire("7xVCs");

function $1b739b5871223ff5$export$347bd2772961ad32(WrappedComponent) {
    function withPageTreeStateUpdater(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                pageTreeStateUpdater: pageTreeStateUpdater,
                ...props
            }));
    }
    return withPageTreeStateUpdater;
}
module.exports["withPageTreeStateUpdater"] = $1b739b5871223ff5$export$347bd2772961ad32;

});

parcelRegister("7xVCs", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kNIYN = parcelRequire("kNIYN");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $kNIYN.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("6e6qw", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");

function $c454c81005f3f72e$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $c454c81005f3f72e$export$60ba61eca4eb64f2(str) {
    const index = $c454c81005f3f72e$export$c14f61804029af13(str) % (0, $7Y8M5.participantColors).length;
    return {
        index: index,
        color: (0, $7Y8M5.participantColors)[index]
    };
}
module.exports["getHashCode"] = $c454c81005f3f72e$export$c14f61804029af13;
module.exports["getParticipantColor"] = $c454c81005f3f72e$export$60ba61eca4eb64f2;

});

parcelRegister("bNhgs", function(module, exports) {

var $dpu2n = parcelRequire("dpu2n");


var $ecHHC = parcelRequire("ecHHC");


var $9mfmQ = parcelRequire("9mfmQ");

const $099bc251bcbff389$export$101d00feadd67b75 = (svgRoot)=>{
    // by this point we have a safe SVG string: we can safely string interpolate to encode as a
    // data:image to enable passing it to an <img> src attribute
    return `data:image/svg+xml;base64,${btoa(new XMLSerializer().serializeToString(svgRoot))}`;
};
const $099bc251bcbff389$export$ad5dfe87b2150403 = (cssProperties)=>{
    let styleString = '';
    Object.keys(cssProperties).forEach((key)=>{
        styleString += `${key}: ${cssProperties[key]}; `;
    });
    return styleString;
};
const $099bc251bcbff389$export$1ce458cf91bd8e41 = (svgRoot, cssProperties)=>{
    const styleRule = new CSSStyleSheet();
    const styleString = $099bc251bcbff389$export$ad5dfe87b2150403(cssProperties);
    // even if styling is malicious, it will be sanitized by the CSSStyleSheet with the string being empty, ensuring safety
    styleRule.insertRule(`svg { ${styleString} }`);
    // we need to cast to CSSStyleRule to access the .style property
    const styleRuleString = styleRule.cssRules[0].style.cssText;
    svgRoot.setAttribute('style', styleRuleString);
};
const $099bc251bcbff389$export$7572e098f6cf1a37 = (index)=>{
    return index !== undefined ? index % (0, $dpu2n.ANONYMOUS_ASSETS).length : Math.floor(Math.random() * (0, $dpu2n.ANONYMOUS_ASSETS).length);
};
const $099bc251bcbff389$export$e79675c646a31542 = (svgString)=>{
    return new DOMParser().parseFromString(svgString, 'image/svg+xml');
};
const $099bc251bcbff389$export$65fe496f5eb91c21 = async (props)=>{
    const index = $099bc251bcbff389$export$7572e098f6cf1a37(props?.index);
    const { id: id, messageDescriptor: messageDescriptor, src: src } = (0, $dpu2n.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $ecHHC.getIntl)();
    const response = await (0, $9mfmQ.fetchWithRetry)({
        url: src,
        shouldRetryOnApiError: true,
        retries: props.retries || 3,
        options: props.options,
        baseDelay: props.baseDelay,
        maxDelay: props.maxDelay
    });
    const svgString = await response.result?.text();
    if (!response.success) throw new Error(`Error while fetching svg ${id} with src ${src}`);
    if (!svgString) throw new Error(`svg returned null with svg ${id} with src ${src}`);
    const doc = $099bc251bcbff389$export$e79675c646a31542(svgString);
    const svg = doc.documentElement;
    $099bc251bcbff389$export$1ce458cf91bd8e41(svg, props.styleProperties);
    return {
        id: id,
        name: intl.formatMessage(messageDescriptor),
        src: $099bc251bcbff389$export$101d00feadd67b75(svg)
    };
};
const $099bc251bcbff389$export$da26b707e2b53fcf = async (props)=>{
    const index = $099bc251bcbff389$export$7572e098f6cf1a37(props?.index);
    const asset = (0, $dpu2n.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $ecHHC.getIntl)();
    return {
        ...asset,
        name: intl.formatMessage(asset.messageDescriptor)
    };
};
const $099bc251bcbff389$export$aa51d138a7f855d7 = async ()=>{
    const intl = await (0, $ecHHC.getIntl)();
    return (0, $dpu2n.ANONYMOUS_ASSETS).map((asset)=>({
            id: asset.id,
            name: intl.formatMessage(asset.messageDescriptor),
            src: asset.src
        }));
};
module.exports["getAnonymousAvatarWithStyling"] = $099bc251bcbff389$export$65fe496f5eb91c21;

});

parcelRegister("dpu2n", function(module, exports) {

var $6RZbK = parcelRequire("6RZbK");


var $hDQT9 = parcelRequire("hDQT9");

var $01Y7m = parcelRequire("01Y7m");

var $hYUzZ = parcelRequire("hYUzZ");

var $iuR2u = parcelRequire("iuR2u");

var $kkbx9 = parcelRequire("kkbx9");

var $cFEKY = parcelRequire("cFEKY");

var $6Ytc9 = parcelRequire("6Ytc9");

var $6I2hp = parcelRequire("6I2hp");

var $9jRbs = parcelRequire("9jRbs");

var $doHfX = parcelRequire("doHfX");

var $iQQz2 = parcelRequire("iQQz2");

var $6aQGf = parcelRequire("6aQGf");

var $rKSC9 = parcelRequire("rKSC9");

var $1HhEl = parcelRequire("1HhEl");

var $59SWb = parcelRequire("59SWb");

var $sNNnf = parcelRequire("sNNnf");

var $3lBYI = parcelRequire("3lBYI");

var $4xgJQ = parcelRequire("4xgJQ");

var $h2x1V = parcelRequire("h2x1V");

var $dpF2z = parcelRequire("dpF2z");

var $1sURO = parcelRequire("1sURO");

var $97Vlu = parcelRequire("97Vlu");

var $kVpsY = parcelRequire("kVpsY");

var $hCuul = parcelRequire("hCuul");

var $fuLed = parcelRequire("fuLed");

var $3kpwJ = parcelRequire("3kpwJ");

var $ei5ou = parcelRequire("ei5ou");

var $jveHG = parcelRequire("jveHG");

var $kG0T4 = parcelRequire("kG0T4");

var $iq6me = parcelRequire("iq6me");

var $amt9P = parcelRequire("amt9P");

var $unK7p = parcelRequire("unK7p");

var $7myjl = parcelRequire("7myjl");

var $c3CGq = parcelRequire("c3CGq");

var $73XLd = parcelRequire("73XLd");

var $4O6RS = parcelRequire("4O6RS");

var $1GH6m = parcelRequire("1GH6m");

var $1HXyl = parcelRequire("1HXyl");

var $htAoo = parcelRequire("htAoo");

var $0547j = parcelRequire("0547j");

var $cgVUh = parcelRequire("cgVUh");

var $cQ8lp = parcelRequire("cQ8lp");

var $5JQ20 = parcelRequire("5JQ20");

var $2YPi6 = parcelRequire("2YPi6");

var $cdkwi = parcelRequire("cdkwi");

var $kh1OZ = parcelRequire("kh1OZ");

var $8Sl6f = parcelRequire("8Sl6f");

var $9Qn7m = parcelRequire("9Qn7m");

var $3vrZh = parcelRequire("3vrZh");

var $2InqY = parcelRequire("2InqY");

var $dWYu6 = parcelRequire("dWYu6");

var $e4PgN = parcelRequire("e4PgN");

var $19hVO = parcelRequire("19hVO");

var $2UNgz = parcelRequire("2UNgz");

var $fVzqf = parcelRequire("fVzqf");

var $lj2Ls = parcelRequire("lj2Ls");

var $fr7Nb = parcelRequire("fr7Nb");

var $3Xksf = parcelRequire("3Xksf");

var $bBmIz = parcelRequire("bBmIz");

var $gYk9S = parcelRequire("gYk9S");

var $iii2c = parcelRequire("iii2c");

var $2AIpZ = parcelRequire("2AIpZ");

var $apAKP = parcelRequire("apAKP");

var $eHyqm = parcelRequire("eHyqm");

var $3qxDD = parcelRequire("3qxDD");

var $eHLy0 = parcelRequire("eHLy0");

var $kdS3N = parcelRequire("kdS3N");

var $1Sij2 = parcelRequire("1Sij2");

var $3pGfT = parcelRequire("3pGfT");

var $4LuNj = parcelRequire("4LuNj");

var $9gWob = parcelRequire("9gWob");

var $dRNzY = parcelRequire("dRNzY");

var $iMJSX = parcelRequire("iMJSX");

var $5cLsu = parcelRequire("5cLsu");

var $iN75X = parcelRequire("iN75X");

var $dKZNQ = parcelRequire("dKZNQ");

var $3N5nT = parcelRequire("3N5nT");

var $gAbKd = parcelRequire("gAbKd");

var $3KwZg = parcelRequire("3KwZg");

var $53QJP = parcelRequire("53QJP");

var $3tNjt = parcelRequire("3tNjt");

var $1QOVp = parcelRequire("1QOVp");

var $8BdMq = parcelRequire("8BdMq");

var $kzKxq = parcelRequire("kzKxq");

var $2bFMn = parcelRequire("2bFMn");

var $1mGLL = parcelRequire("1mGLL");

var $6hNPs = parcelRequire("6hNPs");

var $swN6A = parcelRequire("swN6A");

var $jlxMa = parcelRequire("jlxMa");

var $hY9h4 = parcelRequire("hY9h4");

var $21edV = parcelRequire("21edV");

var $i42iL = parcelRequire("i42iL");

var $5brqg = parcelRequire("5brqg");

var $55gO3 = parcelRequire("55gO3");

var $2cB6n = parcelRequire("2cB6n");

var $drBaG = parcelRequire("drBaG");

var $6OMjq = parcelRequire("6OMjq");

var $8MYut = parcelRequire("8MYut");

var $j8C9j = parcelRequire("j8C9j");

var $6yJEz = parcelRequire("6yJEz");

var $dtUp6 = parcelRequire("dtUp6");

var $isP63 = parcelRequire("isP63");

var $9lleE = parcelRequire("9lleE");

var $5uWd9 = parcelRequire("5uWd9");

var $iIHIG = parcelRequire("iIHIG");

const $357db4d5f3da3ec7$export$4522d3d70312bbdc = [
    {
        id: 'alligator',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iq6me))),
        messageDescriptor: (0, $6RZbK.messages).alligator
    },
    {
        id: 'alpaca',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lj2Ls))),
        messageDescriptor: (0, $6RZbK.messages).alpaca
    },
    {
        id: 'ape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3qxDD))),
        messageDescriptor: (0, $6RZbK.messages).ape
    },
    {
        id: 'apple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hDQT9))),
        messageDescriptor: (0, $6RZbK.messages).apple
    },
    {
        id: 'avocado',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($01Y7m))),
        messageDescriptor: (0, $6RZbK.messages).avocado
    },
    {
        id: 'baboon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3qxDD))),
        messageDescriptor: (0, $6RZbK.messages).baboon
    },
    {
        id: 'badger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hYUzZ))),
        messageDescriptor: (0, $6RZbK.messages).badger
    },
    {
        id: 'bat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iuR2u))),
        messageDescriptor: (0, $6RZbK.messages).bat
    },
    {
        id: 'bear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kkbx9))),
        messageDescriptor: (0, $6RZbK.messages).bear
    },
    {
        id: 'beaver',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cFEKY))),
        messageDescriptor: (0, $6RZbK.messages).beaver
    },
    {
        id: 'bee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Ytc9))),
        messageDescriptor: (0, $6RZbK.messages).bee
    },
    {
        id: 'bird',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kdS3N))),
        messageDescriptor: (0, $6RZbK.messages).bird
    },
    {
        id: 'bison',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6I2hp))),
        messageDescriptor: (0, $6RZbK.messages).bison
    },
    {
        id: 'blobfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).blobfish
    },
    {
        id: 'blossom',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9jRbs))),
        messageDescriptor: (0, $6RZbK.messages).blossom
    },
    {
        id: 'blowfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($doHfX))),
        messageDescriptor: (0, $6RZbK.messages).blowfish
    },
    {
        id: 'blueberries',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iQQz2))),
        messageDescriptor: (0, $6RZbK.messages).blueberries
    },
    {
        id: 'boar',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6aQGf))),
        messageDescriptor: (0, $6RZbK.messages).boar
    },
    {
        id: 'broccoli',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($rKSC9))),
        messageDescriptor: (0, $6RZbK.messages).broccoli
    },
    {
        id: 'buffalo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6I2hp))),
        messageDescriptor: (0, $6RZbK.messages).buffalo
    },
    {
        id: 'bug',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1HhEl))),
        messageDescriptor: (0, $6RZbK.messages).bug
    },
    {
        id: 'bull',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jveHG))),
        messageDescriptor: (0, $6RZbK.messages).bull
    },
    {
        id: 'bunny',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gAbKd))),
        messageDescriptor: (0, $6RZbK.messages).bunny
    },
    {
        id: 'butterfly',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1HhEl))),
        messageDescriptor: (0, $6RZbK.messages).butterfly
    },
    {
        id: 'cactus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($59SWb))),
        messageDescriptor: (0, $6RZbK.messages).cactus
    },
    {
        id: 'camel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($sNNnf))),
        messageDescriptor: (0, $6RZbK.messages).camel
    },
    {
        id: 'candy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3lBYI))),
        messageDescriptor: (0, $6RZbK.messages).candy
    },
    {
        id: 'cantaloupe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bBmIz))),
        messageDescriptor: (0, $6RZbK.messages).cantaloupe
    },
    {
        id: 'capsicum',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4xgJQ))),
        messageDescriptor: (0, $6RZbK.messages).capsicum
    },
    {
        id: 'carrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h2x1V))),
        messageDescriptor: (0, $6RZbK.messages).carrot
    },
    {
        id: 'cat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dpF2z))),
        messageDescriptor: (0, $6RZbK.messages).cat
    },
    {
        id: 'caterpiller',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1sURO))),
        messageDescriptor: (0, $6RZbK.messages).caterpiller
    },
    {
        id: 'chameleon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fVzqf))),
        messageDescriptor: (0, $6RZbK.messages).chameleon
    },
    {
        id: 'cherry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($97Vlu))),
        messageDescriptor: (0, $6RZbK.messages).cherry
    },
    {
        id: 'chili',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kVpsY))),
        messageDescriptor: (0, $6RZbK.messages).chili
    },
    {
        id: 'chimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).chimp
    },
    {
        id: 'chimpanzee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).chimpanzee
    },
    {
        id: 'clover',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hCuul))),
        messageDescriptor: (0, $6RZbK.messages).clover
    },
    {
        id: 'clownfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6yJEz))),
        messageDescriptor: (0, $6RZbK.messages).clownfish
    },
    {
        id: 'cobra',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hY9h4))),
        messageDescriptor: (0, $6RZbK.messages).cobra
    },
    {
        id: 'coconut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fuLed))),
        messageDescriptor: (0, $6RZbK.messages).coconut
    },
    {
        id: 'cod',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).cod
    },
    {
        id: 'cookie',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3kpwJ))),
        messageDescriptor: (0, $6RZbK.messages).cookie
    },
    {
        id: 'corn',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ei5ou))),
        messageDescriptor: (0, $6RZbK.messages).corn
    },
    {
        id: 'cow',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jveHG))),
        messageDescriptor: (0, $6RZbK.messages).cow
    },
    {
        id: 'crab',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kG0T4))),
        messageDescriptor: (0, $6RZbK.messages).crab
    },
    {
        id: 'crocodile',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iq6me))),
        messageDescriptor: (0, $6RZbK.messages).crocodile
    },
    {
        id: 'deer',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($amt9P))),
        messageDescriptor: (0, $6RZbK.messages).deer
    },
    {
        id: 'dinosaur',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($unK7p))),
        messageDescriptor: (0, $6RZbK.messages).dinosaur
    },
    {
        id: 'dodo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7myjl))),
        messageDescriptor: (0, $6RZbK.messages).dodo
    },
    {
        id: 'dog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3CGq))),
        messageDescriptor: (0, $6RZbK.messages).dog
    },
    {
        id: 'dolphin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($73XLd))),
        messageDescriptor: (0, $6RZbK.messages).dolphin
    },
    {
        id: 'donut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4O6RS))),
        messageDescriptor: (0, $6RZbK.messages).donut
    },
    {
        id: 'dragon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1GH6m))),
        messageDescriptor: (0, $6RZbK.messages).dragon
    },
    {
        id: 'duck',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1HXyl))),
        messageDescriptor: (0, $6RZbK.messages).duck
    },
    {
        id: 'elephant',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($htAoo))),
        messageDescriptor: (0, $6RZbK.messages).elephant
    },
    {
        id: 'elk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($amt9P))),
        messageDescriptor: (0, $6RZbK.messages).elk
    },
    {
        id: 'fish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).fish
    },
    {
        id: 'flamingo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cgVUh))),
        messageDescriptor: (0, $6RZbK.messages).flamingo
    },
    {
        id: 'fox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cQ8lp))),
        messageDescriptor: (0, $6RZbK.messages).fox
    },
    {
        id: 'frog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5JQ20))),
        messageDescriptor: (0, $6RZbK.messages).frog
    },
    {
        id: 'gecko',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fVzqf))),
        messageDescriptor: (0, $6RZbK.messages).gecko
    },
    {
        id: 'giraffe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2YPi6))),
        messageDescriptor: (0, $6RZbK.messages).giraffe
    },
    {
        id: 'gorilla',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cdkwi))),
        messageDescriptor: (0, $6RZbK.messages).gorilla
    },
    {
        id: 'grape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kh1OZ))),
        messageDescriptor: (0, $6RZbK.messages).grape
    },
    {
        id: 'hammerhead',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2bFMn))),
        messageDescriptor: (0, $6RZbK.messages).hammerhead
    },
    {
        id: 'hedgehog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8Sl6f))),
        messageDescriptor: (0, $6RZbK.messages).hedgehog
    },
    {
        id: 'hippo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9Qn7m))),
        messageDescriptor: (0, $6RZbK.messages).hippo
    },
    {
        id: 'kangaroo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3vrZh))),
        messageDescriptor: (0, $6RZbK.messages).kangaroo
    },
    {
        id: 'kitten',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dpF2z))),
        messageDescriptor: (0, $6RZbK.messages).kitten
    },
    {
        id: 'kiwi',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2InqY))),
        messageDescriptor: (0, $6RZbK.messages).kiwi
    },
    {
        id: 'koala',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dWYu6))),
        messageDescriptor: (0, $6RZbK.messages).koala
    },
    {
        id: 'lemon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e4PgN))),
        messageDescriptor: (0, $6RZbK.messages).lemon
    },
    {
        id: 'leopard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($drBaG))),
        messageDescriptor: (0, $6RZbK.messages).leopard
    },
    {
        id: 'lettuce',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($19hVO))),
        messageDescriptor: (0, $6RZbK.messages).lettuce
    },
    {
        id: 'lion',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2UNgz))),
        messageDescriptor: (0, $6RZbK.messages).lion
    },
    {
        id: 'lizard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fVzqf))),
        messageDescriptor: (0, $6RZbK.messages).lizard
    },
    {
        id: 'llama',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lj2Ls))),
        messageDescriptor: (0, $6RZbK.messages).llama
    },
    {
        id: 'lobster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fr7Nb))),
        messageDescriptor: (0, $6RZbK.messages).lobster
    },
    {
        id: 'macaque',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).macaque
    },
    {
        id: 'mango',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3Xksf))),
        messageDescriptor: (0, $6RZbK.messages).mango
    },
    {
        id: 'melon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9lleE))),
        messageDescriptor: (0, $6RZbK.messages).melon
    },
    {
        id: 'millipede',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1sURO))),
        messageDescriptor: (0, $6RZbK.messages).millipede
    },
    {
        id: 'monkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).monkey
    },
    {
        id: 'mouse',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iii2c))),
        messageDescriptor: (0, $6RZbK.messages).mouse
    },
    {
        id: 'octopus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2AIpZ))),
        messageDescriptor: (0, $6RZbK.messages).octopus
    },
    {
        id: 'olive',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($apAKP))),
        messageDescriptor: (0, $6RZbK.messages).olive
    },
    {
        id: 'orange',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eHyqm))),
        messageDescriptor: (0, $6RZbK.messages).orange
    },
    {
        id: 'orangutan',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3qxDD))),
        messageDescriptor: (0, $6RZbK.messages).orangutan
    },
    {
        id: 'otter',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eHLy0))),
        messageDescriptor: (0, $6RZbK.messages).otter
    },
    {
        id: 'owl',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kdS3N))),
        messageDescriptor: (0, $6RZbK.messages).owl
    },
    {
        id: 'ox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1Sij2))),
        messageDescriptor: (0, $6RZbK.messages).ox
    },
    {
        id: 'oyster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3pGfT))),
        messageDescriptor: (0, $6RZbK.messages).oyster
    },
    {
        id: 'panda',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4LuNj))),
        messageDescriptor: (0, $6RZbK.messages).panda
    },
    {
        id: 'parrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9gWob))),
        messageDescriptor: (0, $6RZbK.messages).parrot
    },
    {
        id: 'peacock',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dRNzY))),
        messageDescriptor: (0, $6RZbK.messages).peacock
    },
    {
        id: 'pear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iMJSX))),
        messageDescriptor: (0, $6RZbK.messages).pear
    },
    {
        id: 'penguin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cLsu))),
        messageDescriptor: (0, $6RZbK.messages).penguin
    },
    {
        id: 'pig',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iN75X))),
        messageDescriptor: (0, $6RZbK.messages).pig
    },
    {
        id: 'pineapple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dKZNQ))),
        messageDescriptor: (0, $6RZbK.messages).pineapple
    },
    {
        id: 'poodle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3N5nT))),
        messageDescriptor: (0, $6RZbK.messages).poodle
    },
    {
        id: 'puppy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3CGq))),
        messageDescriptor: (0, $6RZbK.messages).puppy
    },
    {
        id: 'python',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hY9h4))),
        messageDescriptor: (0, $6RZbK.messages).python
    },
    {
        id: 'rabbit',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gAbKd))),
        messageDescriptor: (0, $6RZbK.messages).rabbit
    },
    {
        id: 'raccoon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3KwZg))),
        messageDescriptor: (0, $6RZbK.messages).raccoon
    },
    {
        id: 'rat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iii2c))),
        messageDescriptor: (0, $6RZbK.messages).rat
    },
    {
        id: 'rhino',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($53QJP))),
        messageDescriptor: (0, $6RZbK.messages).rhino
    },
    {
        id: 'robot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3tNjt))),
        messageDescriptor: (0, $6RZbK.messages).robot
    },
    {
        id: 'rose',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1QOVp))),
        messageDescriptor: (0, $6RZbK.messages).rose
    },
    {
        id: 'seal',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8BdMq))),
        messageDescriptor: (0, $6RZbK.messages).seal
    },
    {
        id: 'seedling',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kzKxq))),
        messageDescriptor: (0, $6RZbK.messages).seedling
    },
    {
        id: 'shark',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2bFMn))),
        messageDescriptor: (0, $6RZbK.messages).shark
    },
    {
        id: 'shrimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1mGLL))),
        messageDescriptor: (0, $6RZbK.messages).shrimp
    },
    {
        id: 'skunk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6hNPs))),
        messageDescriptor: (0, $6RZbK.messages).skunk
    },
    {
        id: 'sloth',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($swN6A))),
        messageDescriptor: (0, $6RZbK.messages).sloth
    },
    {
        id: 'snail',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jlxMa))),
        messageDescriptor: (0, $6RZbK.messages).snail
    },
    {
        id: 'snake',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hY9h4))),
        messageDescriptor: (0, $6RZbK.messages).snake
    },
    {
        id: 'snowman',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($21edV))),
        messageDescriptor: (0, $6RZbK.messages).snowman
    },
    {
        id: 'squid',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i42iL))),
        messageDescriptor: (0, $6RZbK.messages).squid
    },
    {
        id: 'squirrel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5brqg))),
        messageDescriptor: (0, $6RZbK.messages).squirrel
    },
    {
        id: 'strawberry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($55gO3))),
        messageDescriptor: (0, $6RZbK.messages).strawberry
    },
    {
        id: 'sunfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6yJEz))),
        messageDescriptor: (0, $6RZbK.messages).sunfish
    },
    {
        id: 'sunflower',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2cB6n))),
        messageDescriptor: (0, $6RZbK.messages).sunflower
    },
    {
        id: 'tiger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($drBaG))),
        messageDescriptor: (0, $6RZbK.messages).tiger
    },
    {
        id: 'tomato',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6OMjq))),
        messageDescriptor: (0, $6RZbK.messages).tomato
    },
    {
        id: 'tortoise',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($isP63))),
        messageDescriptor: (0, $6RZbK.messages).tortoise
    },
    {
        id: 'tree',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8MYut))),
        messageDescriptor: (0, $6RZbK.messages).tree
    },
    {
        id: 'trex',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j8C9j))),
        messageDescriptor: (0, $6RZbK.messages).trex
    },
    {
        id: 'trout',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).trout
    },
    {
        id: 'turkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dtUp6))),
        messageDescriptor: (0, $6RZbK.messages).turkey
    },
    {
        id: 'turtle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($isP63))),
        messageDescriptor: (0, $6RZbK.messages).turtle
    },
    {
        id: 'wasp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Ytc9))),
        messageDescriptor: (0, $6RZbK.messages).wasp
    },
    {
        id: 'watermelon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9lleE))),
        messageDescriptor: (0, $6RZbK.messages).watermelon
    },
    {
        id: 'whale',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5uWd9))),
        messageDescriptor: (0, $6RZbK.messages).whale
    },
    {
        id: 'wolf',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iIHIG))),
        messageDescriptor: (0, $6RZbK.messages).wolf
    }
];
module.exports["ANONYMOUS_ASSETS"] = $357db4d5f3da3ec7$export$4522d3d70312bbdc;

});

parcelRegister("6RZbK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $52c1b6ebf0043fde$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    alligator: {
        id: "platform.anonymous-asset-name.alligator",
        defaultMessage: "Anonymous Alligator"
    },
    alpaca: {
        id: "platform.anonymous-asset-name.alpaca",
        defaultMessage: "Anonymous Alpaca"
    },
    ape: {
        id: "platform.anonymous-asset-name.ape",
        defaultMessage: "Anonymous Ape"
    },
    apple: {
        id: "platform.anonymous-asset-name.apple",
        defaultMessage: "Anonymous Apple"
    },
    avocado: {
        id: "platform.anonymous-asset-name.avocado",
        defaultMessage: "Anonymous Avocado"
    },
    baboon: {
        id: "platform.anonymous-asset-name.baboon",
        defaultMessage: "Anonymous Baboon"
    },
    badger: {
        id: "platform.anonymous-asset-name.badger",
        defaultMessage: "Anonymous Badger"
    },
    bat: {
        id: "platform.anonymous-asset-name.bat",
        defaultMessage: "Anonymous Bat"
    },
    bear: {
        id: "platform.anonymous-asset-name.bear",
        defaultMessage: "Anonymous Bear"
    },
    beaver: {
        id: "platform.anonymous-asset-name.beaver",
        defaultMessage: "Anonymous Beaver"
    },
    bee: {
        id: "platform.anonymous-asset-name.bee",
        defaultMessage: "Anonymous Bee"
    },
    bird: {
        id: "platform.anonymous-asset-name.bird",
        defaultMessage: "Anonymous Bird"
    },
    bison: {
        id: "platform.anonymous-asset-name.bison",
        defaultMessage: "Anonymous Bison"
    },
    blobfish: {
        id: "platform.anonymous-asset-name.blobfish",
        defaultMessage: "Anonymous Blobfish"
    },
    blossom: {
        id: "platform.anonymous-asset-name.blossom",
        defaultMessage: "Anonymous Blossom"
    },
    blowfish: {
        id: "platform.anonymous-asset-name.blowfish",
        defaultMessage: "Anonymous Blowfish"
    },
    blueberries: {
        id: "platform.anonymous-asset-name.blueberries",
        defaultMessage: "Anonymous Blueberries"
    },
    boar: {
        id: "platform.anonymous-asset-name.boar",
        defaultMessage: "Anonymous Boar"
    },
    broccoli: {
        id: "platform.anonymous-asset-name.broccoli",
        defaultMessage: "Anonymous Broccoli"
    },
    buffalo: {
        id: "platform.anonymous-asset-name.buffalo",
        defaultMessage: "Anonymous Buffalo"
    },
    bug: {
        id: "platform.anonymous-asset-name.bug",
        defaultMessage: "Anonymous Bug"
    },
    bull: {
        id: "platform.anonymous-asset-name.bull",
        defaultMessage: "Anonymous Bull"
    },
    bunny: {
        id: "platform.anonymous-asset-name.bunny",
        defaultMessage: "Anonymous Bunny"
    },
    butterfly: {
        id: "platform.anonymous-asset-name.butterfly",
        defaultMessage: "Anonymous Butterfly"
    },
    cactus: {
        id: "platform.anonymous-asset-name.cactus",
        defaultMessage: "Anonymous Cactus"
    },
    camel: {
        id: "platform.anonymous-asset-name.camel",
        defaultMessage: "Anonymous Camel"
    },
    candy: {
        id: "platform.anonymous-asset-name.candy",
        defaultMessage: "Anonymous Candy"
    },
    cantaloupe: {
        id: "platform.anonymous-asset-name.cantaloupe",
        defaultMessage: "Anonymous Cantaloupe"
    },
    capsicum: {
        id: "platform.anonymous-asset-name.capsicum",
        defaultMessage: "Anonymous Capsicum"
    },
    carrot: {
        id: "platform.anonymous-asset-name.carrot",
        defaultMessage: "Anonymous Carrot"
    },
    cat: {
        id: "platform.anonymous-asset-name.cat",
        defaultMessage: "Anonymous Cat"
    },
    caterpiller: {
        id: "platform.anonymous-asset-name.caterpiller",
        defaultMessage: "Anonymous Caterpiller"
    },
    chameleon: {
        id: "platform.anonymous-asset-name.chameleon",
        defaultMessage: "Anonymous Chameleon"
    },
    cherry: {
        id: "platform.anonymous-asset-name.cherry",
        defaultMessage: "Anonymous Cherry"
    },
    chili: {
        id: "platform.anonymous-asset-name.chili",
        defaultMessage: "Anonymous Chili"
    },
    chimp: {
        id: "platform.anonymous-asset-name.chimp",
        defaultMessage: "Anonymous Chimp"
    },
    chimpanzee: {
        id: "platform.anonymous-asset-name.chimpanzee",
        defaultMessage: "Anonymous Chimpanzee"
    },
    clover: {
        id: "platform.anonymous-asset-name.clover",
        defaultMessage: "Anonymous Clover"
    },
    clownfish: {
        id: "platform.anonymous-asset-name.clownfish",
        defaultMessage: "Anonymous Clownfish"
    },
    cobra: {
        id: "platform.anonymous-asset-name.cobra",
        defaultMessage: "Anonymous Cobra"
    },
    coconut: {
        id: "platform.anonymous-asset-name.coconut",
        defaultMessage: "Anonymous Coconut"
    },
    cod: {
        id: "platform.anonymous-asset-name.cod",
        defaultMessage: "Anonymous Cod"
    },
    cookie: {
        id: "platform.anonymous-asset-name.cookie",
        defaultMessage: "Anonymous Cookie"
    },
    corn: {
        id: "platform.anonymous-asset-name.corn",
        defaultMessage: "Anonymous Corn"
    },
    cow: {
        id: "platform.anonymous-asset-name.cow",
        defaultMessage: "Anonymous Cow"
    },
    crab: {
        id: "platform.anonymous-asset-name.crab",
        defaultMessage: "Anonymous Crab"
    },
    crocodile: {
        id: "platform.anonymous-asset-name.crocodile",
        defaultMessage: "Anonymous Crocodile"
    },
    deer: {
        id: "platform.anonymous-asset-name.deer",
        defaultMessage: "Anonymous Deer"
    },
    dinosaur: {
        id: "platform.anonymous-asset-name.dinosaur",
        defaultMessage: "Anonymous Dinosaur"
    },
    dodo: {
        id: "platform.anonymous-asset-name.dodo",
        defaultMessage: "Anonymous Dodo"
    },
    dog: {
        id: "platform.anonymous-asset-name.dog",
        defaultMessage: "Anonymous Dog"
    },
    dolphin: {
        id: "platform.anonymous-asset-name.dolphin",
        defaultMessage: "Anonymous Dolphin"
    },
    donut: {
        id: "platform.anonymous-asset-name.donut",
        defaultMessage: "Anonymous Donut"
    },
    dragon: {
        id: "platform.anonymous-asset-name.dragon",
        defaultMessage: "Anonymous Dragon"
    },
    duck: {
        id: "platform.anonymous-asset-name.duck",
        defaultMessage: "Anonymous Duck"
    },
    elephant: {
        id: "platform.anonymous-asset-name.elephant",
        defaultMessage: "Anonymous Elephant"
    },
    elk: {
        id: "platform.anonymous-asset-name.elk",
        defaultMessage: "Anonymous Elk"
    },
    fish: {
        id: "platform.anonymous-asset-name.fish",
        defaultMessage: "Anonymous Fish"
    },
    flamingo: {
        id: "platform.anonymous-asset-name.flamingo",
        defaultMessage: "Anonymous Flamingo"
    },
    fox: {
        id: "platform.anonymous-asset-name.fox",
        defaultMessage: "Anonymous Fox"
    },
    frog: {
        id: "platform.anonymous-asset-name.frog",
        defaultMessage: "Anonymous Frog"
    },
    gecko: {
        id: "platform.anonymous-asset-name.gecko",
        defaultMessage: "Anonymous Gecko"
    },
    giraffe: {
        id: "platform.anonymous-asset-name.giraffe",
        defaultMessage: "Anonymous Giraffe"
    },
    gorilla: {
        id: "platform.anonymous-asset-name.gorilla",
        defaultMessage: "Anonymous Gorilla"
    },
    grape: {
        id: "platform.anonymous-asset-name.grape",
        defaultMessage: "Anonymous Grape"
    },
    hammerhead: {
        id: "platform.anonymous-asset-name.hammerhead",
        defaultMessage: "Anonymous Hammerhead"
    },
    hedgehog: {
        id: "platform.anonymous-asset-name.hedgehog",
        defaultMessage: "Anonymous Hedgehog"
    },
    hippo: {
        id: "platform.anonymous-asset-name.hippo",
        defaultMessage: "Anonymous Hippo"
    },
    kangaroo: {
        id: "platform.anonymous-asset-name.kangaroo",
        defaultMessage: "Anonymous Kangaroo"
    },
    kitten: {
        id: "platform.anonymous-asset-name.kitten",
        defaultMessage: "Anonymous Kitten"
    },
    kiwi: {
        id: "platform.anonymous-asset-name.kiwi",
        defaultMessage: "Anonymous Kiwi"
    },
    koala: {
        id: "platform.anonymous-asset-name.koala",
        defaultMessage: "Anonymous Koala"
    },
    lemon: {
        id: "platform.anonymous-asset-name.lemon",
        defaultMessage: "Anonymous Lemon"
    },
    leopard: {
        id: "platform.anonymous-asset-name.leopard",
        defaultMessage: "Anonymous Leopard"
    },
    lettuce: {
        id: "platform.anonymous-asset-name.lettuce",
        defaultMessage: "Anonymous Lettuce"
    },
    lion: {
        id: "platform.anonymous-asset-name.lion",
        defaultMessage: "Anonymous Lion"
    },
    lizard: {
        id: "platform.anonymous-asset-name.lizard",
        defaultMessage: "Anonymous Lizard"
    },
    llama: {
        id: "platform.anonymous-asset-name.llama",
        defaultMessage: "Anonymous Llama"
    },
    lobster: {
        id: "platform.anonymous-asset-name.lobster",
        defaultMessage: "Anonymous Lobster"
    },
    macaque: {
        id: "platform.anonymous-asset-name.macaque",
        defaultMessage: "Anonymous Macaque"
    },
    mango: {
        id: "platform.anonymous-asset-name.mango",
        defaultMessage: "Anonymous Mango"
    },
    melon: {
        id: "platform.anonymous-asset-name.melon",
        defaultMessage: "Anonymous Melon"
    },
    millipede: {
        id: "platform.anonymous-asset-name.millipede",
        defaultMessage: "Anonymous Millipede"
    },
    monkey: {
        id: "platform.anonymous-asset-name.monkey",
        defaultMessage: "Anonymous Monkey"
    },
    mouse: {
        id: "platform.anonymous-asset-name.mouse",
        defaultMessage: "Anonymous Mouse"
    },
    octopus: {
        id: "platform.anonymous-asset-name.octopus",
        defaultMessage: "Anonymous Octopus"
    },
    olive: {
        id: "platform.anonymous-asset-name.olive",
        defaultMessage: "Anonymous Olive"
    },
    orange: {
        id: "platform.anonymous-asset-name.orange",
        defaultMessage: "Anonymous Orange"
    },
    orangutan: {
        id: "platform.anonymous-asset-name.orangutan",
        defaultMessage: "Anonymous Orangutan"
    },
    otter: {
        id: "platform.anonymous-asset-name.otter",
        defaultMessage: "Anonymous Otter"
    },
    owl: {
        id: "platform.anonymous-asset-name.owl",
        defaultMessage: "Anonymous Owl"
    },
    ox: {
        id: "platform.anonymous-asset-name.ox",
        defaultMessage: "Anonymous Ox"
    },
    oyster: {
        id: "platform.anonymous-asset-name.oyster",
        defaultMessage: "Anonymous Oyster"
    },
    panda: {
        id: "platform.anonymous-asset-name.panda",
        defaultMessage: "Anonymous Panda"
    },
    parrot: {
        id: "platform.anonymous-asset-name.parrot",
        defaultMessage: "Anonymous Parrot"
    },
    peacock: {
        id: "platform.anonymous-asset-name.peacock",
        defaultMessage: "Anonymous Peacock"
    },
    pear: {
        id: "platform.anonymous-asset-name.pear",
        defaultMessage: "Anonymous Pear"
    },
    penguin: {
        id: "platform.anonymous-asset-name.penguin",
        defaultMessage: "Anonymous Penguin"
    },
    pig: {
        id: "platform.anonymous-asset-name.pig",
        defaultMessage: "Anonymous Pig"
    },
    pineapple: {
        id: "platform.anonymous-asset-name.pineapple",
        defaultMessage: "Anonymous Pineapple"
    },
    poodle: {
        id: "platform.anonymous-asset-name.poodle",
        defaultMessage: "Anonymous Poodle"
    },
    puppy: {
        id: "platform.anonymous-asset-name.puppy",
        defaultMessage: "Anonymous Puppy"
    },
    python: {
        id: "platform.anonymous-asset-name.python",
        defaultMessage: "Anonymous Python"
    },
    rabbit: {
        id: "platform.anonymous-asset-name.rabbit",
        defaultMessage: "Anonymous Rabbit"
    },
    raccoon: {
        id: "platform.anonymous-asset-name.raccoon",
        defaultMessage: "Anonymous Raccoon"
    },
    rat: {
        id: "platform.anonymous-asset-name.rat",
        defaultMessage: "Anonymous Rat"
    },
    rhino: {
        id: "platform.anonymous-asset-name.rhino",
        defaultMessage: "Anonymous Rhino"
    },
    robot: {
        id: "platform.anonymous-asset-name.robot",
        defaultMessage: "Anonymous Robot"
    },
    rose: {
        id: "platform.anonymous-asset-name.rose",
        defaultMessage: "Anonymous Rose"
    },
    seal: {
        id: "platform.anonymous-asset-name.seal",
        defaultMessage: "Anonymous Seal"
    },
    seedling: {
        id: "platform.anonymous-asset-name.seedling",
        defaultMessage: "Anonymous Seedling"
    },
    shark: {
        id: "platform.anonymous-asset-name.shark",
        defaultMessage: "Anonymous Shark"
    },
    shrimp: {
        id: "platform.anonymous-asset-name.shrimp",
        defaultMessage: "Anonymous Shrimp"
    },
    skunk: {
        id: "platform.anonymous-asset-name.skunk",
        defaultMessage: "Anonymous Skunk"
    },
    sloth: {
        id: "platform.anonymous-asset-name.sloth",
        defaultMessage: "Anonymous Sloth"
    },
    snail: {
        id: "platform.anonymous-asset-name.snail",
        defaultMessage: "Anonymous Snail"
    },
    snake: {
        id: "platform.anonymous-asset-name.snake",
        defaultMessage: "Anonymous Snake"
    },
    snowman: {
        id: "platform.anonymous-asset-name.snowman",
        defaultMessage: "Anonymous Snowman"
    },
    squid: {
        id: "platform.anonymous-asset-name.squid",
        defaultMessage: "Anonymous Squid"
    },
    squirrel: {
        id: "platform.anonymous-asset-name.squirrel",
        defaultMessage: "Anonymous Squirrel"
    },
    strawberry: {
        id: "platform.anonymous-asset-name.strawberry",
        defaultMessage: "Anonymous Strawberry"
    },
    sunfish: {
        id: "platform.anonymous-asset-name.sunfish",
        defaultMessage: "Anonymous Sunfish"
    },
    sunflower: {
        id: "platform.anonymous-asset-name.sunflower",
        defaultMessage: "Anonymous Sunflower"
    },
    tiger: {
        id: "platform.anonymous-asset-name.tiger",
        defaultMessage: "Anonymous Tiger"
    },
    tomato: {
        id: "platform.anonymous-asset-name.tomato",
        defaultMessage: "Anonymous Tomato"
    },
    tortoise: {
        id: "platform.anonymous-asset-name.tortoise",
        defaultMessage: "Anonymous Tortoise"
    },
    tree: {
        id: "platform.anonymous-asset-name.tree",
        defaultMessage: "Anonymous Tree"
    },
    trex: {
        id: "platform.anonymous-asset-name.trex",
        defaultMessage: "Anonymous T-rex"
    },
    trout: {
        id: "platform.anonymous-asset-name.trout",
        defaultMessage: "Anonymous Trout"
    },
    turkey: {
        id: "platform.anonymous-asset-name.turkey",
        defaultMessage: "Anonymous Turkey"
    },
    turtle: {
        id: "platform.anonymous-asset-name.turtle",
        defaultMessage: "Anonymous Turtle"
    },
    wasp: {
        id: "platform.anonymous-asset-name.wasp",
        defaultMessage: "Anonymous Wasp"
    },
    watermelon: {
        id: "platform.anonymous-asset-name.watermelon",
        defaultMessage: "Anonymous Watermelon"
    },
    whale: {
        id: "platform.anonymous-asset-name.whale",
        defaultMessage: "Anonymous Whale"
    },
    wolf: {
        id: "platform.anonymous-asset-name.wolf",
        defaultMessage: "Anonymous Wolf"
    }
});
module.exports["messages"] = $52c1b6ebf0043fde$export$defe85febe8b728c;

});

parcelRegister("hDQT9", function(module, exports) {
module.exports = new URL("apple.ee886279.svg", import.meta.url).toString();

});

parcelRegister("01Y7m", function(module, exports) {
module.exports = new URL("avocado.8855629b.svg", import.meta.url).toString();

});

parcelRegister("hYUzZ", function(module, exports) {
module.exports = new URL("badger.0fb3ff8d.svg", import.meta.url).toString();

});

parcelRegister("iuR2u", function(module, exports) {
module.exports = new URL("bat.3a3e8172.svg", import.meta.url).toString();

});

parcelRegister("kkbx9", function(module, exports) {
module.exports = new URL("bear.6250dade.svg", import.meta.url).toString();

});

parcelRegister("cFEKY", function(module, exports) {
module.exports = new URL("beaver.72239cbc.svg", import.meta.url).toString();

});

parcelRegister("6Ytc9", function(module, exports) {
module.exports = new URL("bee.1d8bfe50.svg", import.meta.url).toString();

});

parcelRegister("6I2hp", function(module, exports) {
module.exports = new URL("bison.4fe77735.svg", import.meta.url).toString();

});

parcelRegister("9jRbs", function(module, exports) {
module.exports = new URL("blossom.90b2a1c3.svg", import.meta.url).toString();

});

parcelRegister("doHfX", function(module, exports) {
module.exports = new URL("blowfish.8afad7f1.svg", import.meta.url).toString();

});

parcelRegister("iQQz2", function(module, exports) {
module.exports = new URL("blueberries.688d225d.svg", import.meta.url).toString();

});

parcelRegister("6aQGf", function(module, exports) {
module.exports = new URL("boar.15310caf.svg", import.meta.url).toString();

});

parcelRegister("rKSC9", function(module, exports) {
module.exports = new URL("broccoli.fa9fd55e.svg", import.meta.url).toString();

});

parcelRegister("1HhEl", function(module, exports) {
module.exports = new URL("butterfly.f41d19d4.svg", import.meta.url).toString();

});

parcelRegister("59SWb", function(module, exports) {
module.exports = new URL("cactus.0c5c265c.svg", import.meta.url).toString();

});

parcelRegister("sNNnf", function(module, exports) {
module.exports = new URL("camel.6111d481.svg", import.meta.url).toString();

});

parcelRegister("3lBYI", function(module, exports) {
module.exports = new URL("candy.ffd5e59f.svg", import.meta.url).toString();

});

parcelRegister("4xgJQ", function(module, exports) {
module.exports = new URL("capsicum.30f76734.svg", import.meta.url).toString();

});

parcelRegister("h2x1V", function(module, exports) {
module.exports = new URL("carrot.6193f6d7.svg", import.meta.url).toString();

});

parcelRegister("dpF2z", function(module, exports) {
module.exports = new URL("cat.154e1595.svg", import.meta.url).toString();

});

parcelRegister("1sURO", function(module, exports) {
module.exports = new URL("caterpiller.1b6fd239.svg", import.meta.url).toString();

});

parcelRegister("97Vlu", function(module, exports) {
module.exports = new URL("cherry.087938da.svg", import.meta.url).toString();

});

parcelRegister("kVpsY", function(module, exports) {
module.exports = new URL("chili.27401d1a.svg", import.meta.url).toString();

});

parcelRegister("hCuul", function(module, exports) {
module.exports = new URL("clover.296ea840.svg", import.meta.url).toString();

});

parcelRegister("fuLed", function(module, exports) {
module.exports = new URL("coconut.69480f00.svg", import.meta.url).toString();

});

parcelRegister("3kpwJ", function(module, exports) {
module.exports = new URL("cookie.099bb841.svg", import.meta.url).toString();

});

parcelRegister("ei5ou", function(module, exports) {
module.exports = new URL("corn.f527dc60.svg", import.meta.url).toString();

});

parcelRegister("jveHG", function(module, exports) {
module.exports = new URL("cow.e41482e6.svg", import.meta.url).toString();

});

parcelRegister("kG0T4", function(module, exports) {
module.exports = new URL("crab.39812367.svg", import.meta.url).toString();

});

parcelRegister("iq6me", function(module, exports) {
module.exports = new URL("crocodile.221fa99c.svg", import.meta.url).toString();

});

parcelRegister("amt9P", function(module, exports) {
module.exports = new URL("deer.3662e324.svg", import.meta.url).toString();

});

parcelRegister("unK7p", function(module, exports) {
module.exports = new URL("dinosaur.e5c6efb5.svg", import.meta.url).toString();

});

parcelRegister("7myjl", function(module, exports) {
module.exports = new URL("dodo.a7114237.svg", import.meta.url).toString();

});

parcelRegister("c3CGq", function(module, exports) {
module.exports = new URL("dog.6630bd37.svg", import.meta.url).toString();

});

parcelRegister("73XLd", function(module, exports) {
module.exports = new URL("dolphin.3052ec02.svg", import.meta.url).toString();

});

parcelRegister("4O6RS", function(module, exports) {
module.exports = new URL("donut.e4649522.svg", import.meta.url).toString();

});

parcelRegister("1GH6m", function(module, exports) {
module.exports = new URL("dragon.4b6d8278.svg", import.meta.url).toString();

});

parcelRegister("1HXyl", function(module, exports) {
module.exports = new URL("duck.e8819dfa.svg", import.meta.url).toString();

});

parcelRegister("htAoo", function(module, exports) {
module.exports = new URL("elephant.f64545b1.svg", import.meta.url).toString();

});

parcelRegister("0547j", function(module, exports) {
module.exports = new URL("fish.91063cf4.svg", import.meta.url).toString();

});

parcelRegister("cgVUh", function(module, exports) {
module.exports = new URL("flamingo.2d59f884.svg", import.meta.url).toString();

});

parcelRegister("cQ8lp", function(module, exports) {
module.exports = new URL("fox.c1068dfa.svg", import.meta.url).toString();

});

parcelRegister("5JQ20", function(module, exports) {
module.exports = new URL("frog.4c69f05a.svg", import.meta.url).toString();

});

parcelRegister("2YPi6", function(module, exports) {
module.exports = new URL("giraffe.65216e18.svg", import.meta.url).toString();

});

parcelRegister("cdkwi", function(module, exports) {
module.exports = new URL("gorilla.51f05093.svg", import.meta.url).toString();

});

parcelRegister("kh1OZ", function(module, exports) {
module.exports = new URL("grapes.6a50728f.svg", import.meta.url).toString();

});

parcelRegister("8Sl6f", function(module, exports) {
module.exports = new URL("hedgehog.4cc9668b.svg", import.meta.url).toString();

});

parcelRegister("9Qn7m", function(module, exports) {
module.exports = new URL("hippo.81684e99.svg", import.meta.url).toString();

});

parcelRegister("3vrZh", function(module, exports) {
module.exports = new URL("kangaroo.099f9dd4.svg", import.meta.url).toString();

});

parcelRegister("2InqY", function(module, exports) {
module.exports = new URL("kiwi.13ce1a05.svg", import.meta.url).toString();

});

parcelRegister("dWYu6", function(module, exports) {
module.exports = new URL("koala.730a01eb.svg", import.meta.url).toString();

});

parcelRegister("e4PgN", function(module, exports) {
module.exports = new URL("lemon.7d7dfe19.svg", import.meta.url).toString();

});

parcelRegister("19hVO", function(module, exports) {
module.exports = new URL("lettuce.39b86ec6.svg", import.meta.url).toString();

});

parcelRegister("2UNgz", function(module, exports) {
module.exports = new URL("lion.191125b1.svg", import.meta.url).toString();

});

parcelRegister("fVzqf", function(module, exports) {
module.exports = new URL("lizard.de3c3103.svg", import.meta.url).toString();

});

parcelRegister("lj2Ls", function(module, exports) {
module.exports = new URL("llama.d767d641.svg", import.meta.url).toString();

});

parcelRegister("fr7Nb", function(module, exports) {
module.exports = new URL("lobster.2b4a4d94.svg", import.meta.url).toString();

});

parcelRegister("3Xksf", function(module, exports) {
module.exports = new URL("mango.6b9252cb.svg", import.meta.url).toString();

});

parcelRegister("bBmIz", function(module, exports) {
module.exports = new URL("melon.9c97f1e1.svg", import.meta.url).toString();

});

parcelRegister("gYk9S", function(module, exports) {
module.exports = new URL("monkey.423f2177.svg", import.meta.url).toString();

});

parcelRegister("iii2c", function(module, exports) {
module.exports = new URL("mouse.3d0aefe8.svg", import.meta.url).toString();

});

parcelRegister("2AIpZ", function(module, exports) {
module.exports = new URL("octopus.2c0d1056.svg", import.meta.url).toString();

});

parcelRegister("apAKP", function(module, exports) {
module.exports = new URL("olive.3e3e2c53.svg", import.meta.url).toString();

});

parcelRegister("eHyqm", function(module, exports) {
module.exports = new URL("orange.ed5e97f9.svg", import.meta.url).toString();

});

parcelRegister("3qxDD", function(module, exports) {
module.exports = new URL("orangutan.9fa13362.svg", import.meta.url).toString();

});

parcelRegister("eHLy0", function(module, exports) {
module.exports = new URL("otter.1b9e17fe.svg", import.meta.url).toString();

});

parcelRegister("kdS3N", function(module, exports) {
module.exports = new URL("owl.13d3c4d9.svg", import.meta.url).toString();

});

parcelRegister("1Sij2", function(module, exports) {
module.exports = new URL("ox.0ed06fd3.svg", import.meta.url).toString();

});

parcelRegister("3pGfT", function(module, exports) {
module.exports = new URL("oyster.ad23795d.svg", import.meta.url).toString();

});

parcelRegister("4LuNj", function(module, exports) {
module.exports = new URL("panda.0b0047af.svg", import.meta.url).toString();

});

parcelRegister("9gWob", function(module, exports) {
module.exports = new URL("parrot.6fd92eec.svg", import.meta.url).toString();

});

parcelRegister("dRNzY", function(module, exports) {
module.exports = new URL("peacock.80ac60a6.svg", import.meta.url).toString();

});

parcelRegister("iMJSX", function(module, exports) {
module.exports = new URL("pear.c8d37fb0.svg", import.meta.url).toString();

});

parcelRegister("5cLsu", function(module, exports) {
module.exports = new URL("penguin.6577e559.svg", import.meta.url).toString();

});

parcelRegister("iN75X", function(module, exports) {
module.exports = new URL("pig.2ba131ea.svg", import.meta.url).toString();

});

parcelRegister("dKZNQ", function(module, exports) {
module.exports = new URL("pineapple.61ebb967.svg", import.meta.url).toString();

});

parcelRegister("3N5nT", function(module, exports) {
module.exports = new URL("poodle.b40487d6.svg", import.meta.url).toString();

});

parcelRegister("gAbKd", function(module, exports) {
module.exports = new URL("rabbit.b4ce71c1.svg", import.meta.url).toString();

});

parcelRegister("3KwZg", function(module, exports) {
module.exports = new URL("raccoon.16b4372e.svg", import.meta.url).toString();

});

parcelRegister("53QJP", function(module, exports) {
module.exports = new URL("rhino.6dcdebb2.svg", import.meta.url).toString();

});

parcelRegister("3tNjt", function(module, exports) {
module.exports = new URL("robot.fdf311ba.svg", import.meta.url).toString();

});

parcelRegister("1QOVp", function(module, exports) {
module.exports = new URL("rose.22a6e8e6.svg", import.meta.url).toString();

});

parcelRegister("8BdMq", function(module, exports) {
module.exports = new URL("seal.de226e3b.svg", import.meta.url).toString();

});

parcelRegister("kzKxq", function(module, exports) {
module.exports = new URL("seedling.562f3bc0.svg", import.meta.url).toString();

});

parcelRegister("2bFMn", function(module, exports) {
module.exports = new URL("shark.af44e0c5.svg", import.meta.url).toString();

});

parcelRegister("1mGLL", function(module, exports) {
module.exports = new URL("shrimp.116d9eea.svg", import.meta.url).toString();

});

parcelRegister("6hNPs", function(module, exports) {
module.exports = new URL("skunk.a5578a4f.svg", import.meta.url).toString();

});

parcelRegister("swN6A", function(module, exports) {
module.exports = new URL("sloth.f3e9da22.svg", import.meta.url).toString();

});

parcelRegister("jlxMa", function(module, exports) {
module.exports = new URL("snail.06380b65.svg", import.meta.url).toString();

});

parcelRegister("hY9h4", function(module, exports) {
module.exports = new URL("snake.3ead898b.svg", import.meta.url).toString();

});

parcelRegister("21edV", function(module, exports) {
module.exports = new URL("snowman.cdcd9574.svg", import.meta.url).toString();

});

parcelRegister("i42iL", function(module, exports) {
module.exports = new URL("squid.0638299b.svg", import.meta.url).toString();

});

parcelRegister("5brqg", function(module, exports) {
module.exports = new URL("squirrel.e3a31ee3.svg", import.meta.url).toString();

});

parcelRegister("55gO3", function(module, exports) {
module.exports = new URL("strawberry.4111dfb6.svg", import.meta.url).toString();

});

parcelRegister("2cB6n", function(module, exports) {
module.exports = new URL("sunflower.ff291a55.svg", import.meta.url).toString();

});

parcelRegister("drBaG", function(module, exports) {
module.exports = new URL("tiger.2ba2da26.svg", import.meta.url).toString();

});

parcelRegister("6OMjq", function(module, exports) {
module.exports = new URL("tomato.e755033f.svg", import.meta.url).toString();

});

parcelRegister("8MYut", function(module, exports) {
module.exports = new URL("tree.e62f2602.svg", import.meta.url).toString();

});

parcelRegister("j8C9j", function(module, exports) {
module.exports = new URL("t-rex.d85831fb.svg", import.meta.url).toString();

});

parcelRegister("6yJEz", function(module, exports) {
module.exports = new URL("tropical-fish.797d455e.svg", import.meta.url).toString();

});

parcelRegister("dtUp6", function(module, exports) {
module.exports = new URL("turkey.a79defab.svg", import.meta.url).toString();

});

parcelRegister("isP63", function(module, exports) {
module.exports = new URL("turtle.acbe0058.svg", import.meta.url).toString();

});

parcelRegister("9lleE", function(module, exports) {
module.exports = new URL("watermelon.199e013c.svg", import.meta.url).toString();

});

parcelRegister("5uWd9", function(module, exports) {
module.exports = new URL("whale.cc048b8e.svg", import.meta.url).toString();

});

parcelRegister("iIHIG", function(module, exports) {
module.exports = new URL("wolf.a39956da.svg", import.meta.url).toString();

});

parcelRegister("ecHHC", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $2EIXa = parcelRequire("2EIXa");


var $1XjTg = parcelRequire("1XjTg");

const $3bd1d010186fe7d0$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $3bd1d010186fe7d0$var$intlCacheMap = new Map();
const $3bd1d010186fe7d0$export$51771ec7613ad564 = async ()=>{
    const key = (0, $1hQ0e.getDocument)()?.documentElement?.lang || 'en-US';
    if (!$3bd1d010186fe7d0$var$intlCacheMap.has(key)) {
        const messages = await $3bd1d010186fe7d0$var$fetchMessages(key);
        const cache = (0, $kSwu1.createIntlCache)();
        const intl = (0, $kSwu1.createIntl)({
            locale: key,
            messages: messages
        }, cache);
        $3bd1d010186fe7d0$var$intlCacheMap.set(key, intl);
    }
    return $3bd1d010186fe7d0$var$intlCacheMap.get(key);
};
const $3bd1d010186fe7d0$var$fetchMessages = async (locale)=>{
    try {
        const targetLocale = ($3bd1d010186fe7d0$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $2EIXa.locales)) {
            const messages = await (0, $2EIXa.locales)[targetLocale]();
            return messages.default;
        }
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $2EIXa.locales)) {
            const messages = await (0, $2EIXa.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
   * English bundled by default as this is the majority of users
   */ return 0, $1XjTg.default;
};
module.exports["getIntl"] = $3bd1d010186fe7d0$export$51771ec7613ad564;

});

parcelRegister("2EIXa", function(module, exports) {




























const $85bfd356356e38c7$export$df1c34db1371eeed = {
    en: ()=>Promise.resolve((parcelRequire("1XjTg"))),
    cs: ()=>(parcelRequire("c5iVz")),
    da: ()=>(parcelRequire("cKTv6")),
    de: ()=>(parcelRequire("ba7qQ")),
    en_GB: ()=>(parcelRequire("fIKLP")),
    en_ZZ: ()=>(parcelRequire("lVpcM")),
    es: ()=>(parcelRequire("5MC3a")),
    fi: ()=>(parcelRequire("lbr9Z")),
    fr: ()=>(parcelRequire("gfgLh")),
    hr: ()=>(parcelRequire("icWxs")),
    hu: ()=>(parcelRequire("l4lhV")),
    it: ()=>(parcelRequire("8txuZ")),
    ja: ()=>(parcelRequire("lcXoz")),
    ko: ()=>(parcelRequire("e5NrO")),
    nb: ()=>(parcelRequire("b8oPP")),
    nl: ()=>(parcelRequire("imK3v")),
    pl: ()=>(parcelRequire("lvXZc")),
    pt_BR: ()=>(parcelRequire("fojwr")),
    ru: ()=>(parcelRequire("g4Br4")),
    sr_RS: ()=>(parcelRequire("hnd9o")),
    sr_YR: ()=>(parcelRequire("hILXZ")),
    sv: ()=>(parcelRequire("lejHX")),
    th: ()=>(parcelRequire("ka0If")),
    tr: ()=>(parcelRequire("36Auo")),
    uk: ()=>(parcelRequire("9eUA6")),
    vi: ()=>(parcelRequire("kytde")),
    zh: ()=>(parcelRequire("4xtb4")),
    zh_TW: ()=>(parcelRequire("c0Rct"))
};
module.exports["locales"] = $85bfd356356e38c7$export$df1c34db1371eeed;

});

parcelRegister("c5iVz", function(module, exports) {

let $8cc4a2443282ceff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8cc4a2443282ceff$var$load("8QW6R").then(()=>parcelRequire('4mdX2'));

});

parcelRegister("cKTv6", function(module, exports) {

let $9494d53681d834cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9494d53681d834cb$var$load("awxdk").then(()=>parcelRequire('eyLXS'));

});

parcelRegister("ba7qQ", function(module, exports) {

let $820664b746ea9374$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $820664b746ea9374$var$load("5mEC2").then(()=>parcelRequire('55NFn'));

});

parcelRegister("fIKLP", function(module, exports) {

let $b71f3eb9195aa892$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b71f3eb9195aa892$var$load("fu2xp").then(()=>parcelRequire('czahw'));

});

parcelRegister("lVpcM", function(module, exports) {

let $ff62790ade421c02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff62790ade421c02$var$load("5zM7C").then(()=>parcelRequire('dTXdc'));

});

parcelRegister("5MC3a", function(module, exports) {

let $435ef369ce6bcd83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $435ef369ce6bcd83$var$load("batm0").then(()=>parcelRequire('4u9wg'));

});

parcelRegister("lbr9Z", function(module, exports) {

let $f6bfb18052abcbf3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6bfb18052abcbf3$var$load("3AVnS").then(()=>parcelRequire('4ntN9'));

});

parcelRegister("gfgLh", function(module, exports) {

let $bd3b0c896a7b5931$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd3b0c896a7b5931$var$load("51j60").then(()=>parcelRequire('02VrM'));

});

parcelRegister("icWxs", function(module, exports) {

let $d416c18bc8da1813$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d416c18bc8da1813$var$load("2b71C").then(()=>parcelRequire('9tr0O'));

});

parcelRegister("l4lhV", function(module, exports) {

let $f56a7c183817b9d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f56a7c183817b9d7$var$load("2JFq0").then(()=>parcelRequire('fQhwW'));

});

parcelRegister("8txuZ", function(module, exports) {

let $62bb0457f716dbd3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62bb0457f716dbd3$var$load("5f16k").then(()=>parcelRequire('gdp3a'));

});

parcelRegister("lcXoz", function(module, exports) {

let $f708ca9bf4c70287$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f708ca9bf4c70287$var$load("56V0s").then(()=>parcelRequire('8GtTX'));

});

parcelRegister("e5NrO", function(module, exports) {

let $a427e3982aeb4a03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a427e3982aeb4a03$var$load("l8lGz").then(()=>parcelRequire('aYRuH'));

});

parcelRegister("b8oPP", function(module, exports) {

let $81b3b4c4c8461dbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81b3b4c4c8461dbb$var$load("hlqmT").then(()=>parcelRequire('14Tag'));

});

parcelRegister("imK3v", function(module, exports) {

let $d5ee01ba6cbe8436$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5ee01ba6cbe8436$var$load("2s2yj").then(()=>parcelRequire('iMXzI'));

});

parcelRegister("lvXZc", function(module, exports) {

let $fa9b0632ba688ead$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa9b0632ba688ead$var$load("8ozt0").then(()=>parcelRequire('h20wn'));

});

parcelRegister("fojwr", function(module, exports) {

let $b3483da11a3b950e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3483da11a3b950e$var$load("g88j4").then(()=>parcelRequire('8J3ag'));

});

parcelRegister("g4Br4", function(module, exports) {

let $bb3a0efcec506624$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb3a0efcec506624$var$load("fev14").then(()=>parcelRequire('hWxo6'));

});

parcelRegister("hnd9o", function(module, exports) {

let $ca5ec90f467ce7de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca5ec90f467ce7de$var$load("9PBHw").then(()=>parcelRequire('9hkS6'));

});

parcelRegister("hILXZ", function(module, exports) {

let $ce6bc0e0a0642b0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce6bc0e0a0642b0c$var$load("1L95h").then(()=>parcelRequire('cDAjj'));

});

parcelRegister("lejHX", function(module, exports) {

let $f74a3165a8a03385$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f74a3165a8a03385$var$load("jtWXB").then(()=>parcelRequire('gblRe'));

});

parcelRegister("ka0If", function(module, exports) {

let $ead54b51938002ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ead54b51938002ef$var$load("hY0sT").then(()=>parcelRequire('kCJ7N'));

});

parcelRegister("36Auo", function(module, exports) {

let $242e3c9e966f6b26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $242e3c9e966f6b26$var$load("itQsm").then(()=>parcelRequire('aOIVH'));

});

parcelRegister("9eUA6", function(module, exports) {

let $6ba14fb6b210bd41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ba14fb6b210bd41$var$load("jMJn5").then(()=>parcelRequire('iW3aI'));

});

parcelRegister("kytde", function(module, exports) {

let $ef6da49931e0d3f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef6da49931e0d3f3$var$load("1wgqd").then(()=>parcelRequire('evzRl'));

});

parcelRegister("4xtb4", function(module, exports) {

let $34e0e0881054a2f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34e0e0881054a2f0$var$load("fv30i").then(()=>parcelRequire('lWYHM'));

});

parcelRegister("c0Rct", function(module, exports) {

let $0241c94c98c6e436$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0241c94c98c6e436$var$load("hL7rW").then(()=>parcelRequire('3cYOH'));

});

parcelRegister("1XjTg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e1e566f32a0c97fd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $hkAF2 = parcelRequire("hkAF2");

var $e1e566f32a0c97fd$export$2e2bcd8739ae039 = (0, $hkAF2.default);

});

parcelRegister("hkAF2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4e8f77ee27d7e3a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $a4e8f77ee27d7e3a$export$2e2bcd8739ae039 = {
    'platform.anonymous-asset-name.alligator': 'Anonymous Alligator',
    'platform.anonymous-asset-name.alpaca': 'Anonymous Alpaca',
    'platform.anonymous-asset-name.ape': 'Anonymous Ape',
    'platform.anonymous-asset-name.apple': 'Anonymous Apple',
    'platform.anonymous-asset-name.avocado': 'Anonymous Avocado',
    'platform.anonymous-asset-name.baboon': 'Anonymous Baboon',
    'platform.anonymous-asset-name.badger': 'Anonymous Badger',
    'platform.anonymous-asset-name.bat': 'Anonymous Bat',
    'platform.anonymous-asset-name.bear': 'Anonymous Bear',
    'platform.anonymous-asset-name.beaver': 'Anonymous Beaver',
    'platform.anonymous-asset-name.bee': 'Anonymous Bee',
    'platform.anonymous-asset-name.bird': 'Anonymous Bird',
    'platform.anonymous-asset-name.bison': 'Anonymous Bison',
    'platform.anonymous-asset-name.blobfish': 'Anonymous Blobfish',
    'platform.anonymous-asset-name.blossom': 'Anonymous Blossom',
    'platform.anonymous-asset-name.blowfish': 'Anonymous Blowfish',
    'platform.anonymous-asset-name.blueberries': 'Anonymous Blueberries',
    'platform.anonymous-asset-name.boar': 'Anonymous Boar',
    'platform.anonymous-asset-name.broccoli': 'Anonymous Broccoli',
    'platform.anonymous-asset-name.buffalo': 'Anonymous Buffalo',
    'platform.anonymous-asset-name.bug': 'Anonymous Bug',
    'platform.anonymous-asset-name.bull': 'Anonymous Bull',
    'platform.anonymous-asset-name.bunny': 'Anonymous Bunny',
    'platform.anonymous-asset-name.butterfly': 'Anonymous Butterfly',
    'platform.anonymous-asset-name.cactus': 'Anonymous Cactus',
    'platform.anonymous-asset-name.camel': 'Anonymous Camel',
    'platform.anonymous-asset-name.candy': 'Anonymous Candy',
    'platform.anonymous-asset-name.cantaloupe': 'Anonymous Cantaloupe',
    'platform.anonymous-asset-name.capsicum': 'Anonymous Capsicum',
    'platform.anonymous-asset-name.carrot': 'Anonymous Carrot',
    'platform.anonymous-asset-name.cat': 'Anonymous Cat',
    'platform.anonymous-asset-name.caterpiller': 'Anonymous Caterpiller',
    'platform.anonymous-asset-name.chameleon': 'Anonymous Chameleon',
    'platform.anonymous-asset-name.cherry': 'Anonymous Cherry',
    'platform.anonymous-asset-name.chili': 'Anonymous Chili',
    'platform.anonymous-asset-name.chimp': 'Anonymous Chimp',
    'platform.anonymous-asset-name.chimpanzee': 'Anonymous Chimpanzee',
    'platform.anonymous-asset-name.clover': 'Anonymous Clover',
    'platform.anonymous-asset-name.clownfish': 'Anonymous Clownfish',
    'platform.anonymous-asset-name.cobra': 'Anonymous Cobra',
    'platform.anonymous-asset-name.coconut': 'Anonymous Coconut',
    'platform.anonymous-asset-name.cod': 'Anonymous Cod',
    'platform.anonymous-asset-name.cookie': 'Anonymous Cookie',
    'platform.anonymous-asset-name.corn': 'Anonymous Corn',
    'platform.anonymous-asset-name.cow': 'Anonymous Cow',
    'platform.anonymous-asset-name.crab': 'Anonymous Crab',
    'platform.anonymous-asset-name.crocodile': 'Anonymous Crocodile',
    'platform.anonymous-asset-name.deer': 'Anonymous Deer',
    'platform.anonymous-asset-name.dinosaur': 'Anonymous Dinosaur',
    'platform.anonymous-asset-name.dodo': 'Anonymous Dodo',
    'platform.anonymous-asset-name.dog': 'Anonymous Dog',
    'platform.anonymous-asset-name.dolphin': 'Anonymous Dolphin',
    'platform.anonymous-asset-name.donut': 'Anonymous Donut',
    'platform.anonymous-asset-name.dragon': 'Anonymous Dragon',
    'platform.anonymous-asset-name.duck': 'Anonymous Duck',
    'platform.anonymous-asset-name.elephant': 'Anonymous Elephant',
    'platform.anonymous-asset-name.elk': 'Anonymous Elk',
    'platform.anonymous-asset-name.fish': 'Anonymous Fish',
    'platform.anonymous-asset-name.flamingo': 'Anonymous Flamingo',
    'platform.anonymous-asset-name.fox': 'Anonymous Fox',
    'platform.anonymous-asset-name.frog': 'Anonymous Frog',
    'platform.anonymous-asset-name.gecko': 'Anonymous Gecko',
    'platform.anonymous-asset-name.giraffe': 'Anonymous Giraffe',
    'platform.anonymous-asset-name.gorilla': 'Anonymous Gorilla',
    'platform.anonymous-asset-name.grape': 'Anonymous Grape',
    'platform.anonymous-asset-name.hammerhead': 'Anonymous Hammerhead',
    'platform.anonymous-asset-name.hedgehog': 'Anonymous Hedgehog',
    'platform.anonymous-asset-name.hippo': 'Anonymous Hippo',
    'platform.anonymous-asset-name.kangaroo': 'Anonymous Kangaroo',
    'platform.anonymous-asset-name.kitten': 'Anonymous Kitten',
    'platform.anonymous-asset-name.kiwi': 'Anonymous Kiwi',
    'platform.anonymous-asset-name.koala': 'Anonymous Koala',
    'platform.anonymous-asset-name.lemon': 'Anonymous Lemon',
    'platform.anonymous-asset-name.leopard': 'Anonymous Leopard',
    'platform.anonymous-asset-name.lettuce': 'Anonymous Lettuce',
    'platform.anonymous-asset-name.lion': 'Anonymous Lion',
    'platform.anonymous-asset-name.lizard': 'Anonymous Lizard',
    'platform.anonymous-asset-name.llama': 'Anonymous Llama',
    'platform.anonymous-asset-name.lobster': 'Anonymous Lobster',
    'platform.anonymous-asset-name.macaque': 'Anonymous Macaque',
    'platform.anonymous-asset-name.mango': 'Anonymous Mango',
    'platform.anonymous-asset-name.melon': 'Anonymous Melon',
    'platform.anonymous-asset-name.millipede': 'Anonymous Millipede',
    'platform.anonymous-asset-name.monkey': 'Anonymous Monkey',
    'platform.anonymous-asset-name.mouse': 'Anonymous Mouse',
    'platform.anonymous-asset-name.octopus': 'Anonymous Octopus',
    'platform.anonymous-asset-name.olive': 'Anonymous Olive',
    'platform.anonymous-asset-name.orange': 'Anonymous Orange',
    'platform.anonymous-asset-name.orangutan': 'Anonymous Orangutan',
    'platform.anonymous-asset-name.otter': 'Anonymous Otter',
    'platform.anonymous-asset-name.owl': 'Anonymous Owl',
    'platform.anonymous-asset-name.ox': 'Anonymous Ox',
    'platform.anonymous-asset-name.oyster': 'Anonymous Oyster',
    'platform.anonymous-asset-name.panda': 'Anonymous Panda',
    'platform.anonymous-asset-name.parrot': 'Anonymous Parrot',
    'platform.anonymous-asset-name.peacock': 'Anonymous Peacock',
    'platform.anonymous-asset-name.pear': 'Anonymous Pear',
    'platform.anonymous-asset-name.penguin': 'Anonymous Penguin',
    'platform.anonymous-asset-name.pig': 'Anonymous Pig',
    'platform.anonymous-asset-name.pineapple': 'Anonymous Pineapple',
    'platform.anonymous-asset-name.poodle': 'Anonymous Poodle',
    'platform.anonymous-asset-name.puppy': 'Anonymous Puppy',
    'platform.anonymous-asset-name.python': 'Anonymous Python',
    'platform.anonymous-asset-name.rabbit': 'Anonymous Rabbit',
    'platform.anonymous-asset-name.raccoon': 'Anonymous Raccoon',
    'platform.anonymous-asset-name.rat': 'Anonymous Rat',
    'platform.anonymous-asset-name.rhino': 'Anonymous Rhino',
    'platform.anonymous-asset-name.robot': 'Anonymous Robot',
    'platform.anonymous-asset-name.rose': 'Anonymous Rose',
    'platform.anonymous-asset-name.seal': 'Anonymous Seal',
    'platform.anonymous-asset-name.seedling': 'Anonymous Seedling',
    'platform.anonymous-asset-name.shark': 'Anonymous Shark',
    'platform.anonymous-asset-name.shrimp': 'Anonymous Shrimp',
    'platform.anonymous-asset-name.skunk': 'Anonymous Skunk',
    'platform.anonymous-asset-name.sloth': 'Anonymous Sloth',
    'platform.anonymous-asset-name.snail': 'Anonymous Snail',
    'platform.anonymous-asset-name.snake': 'Anonymous Snake',
    'platform.anonymous-asset-name.snowman': 'Anonymous Snowman',
    'platform.anonymous-asset-name.squid': 'Anonymous Squid',
    'platform.anonymous-asset-name.squirrel': 'Anonymous Squirrel',
    'platform.anonymous-asset-name.strawberry': 'Anonymous Strawberry',
    'platform.anonymous-asset-name.sunfish': 'Anonymous Sunfish',
    'platform.anonymous-asset-name.sunflower': 'Anonymous Sunflower',
    'platform.anonymous-asset-name.tiger': 'Anonymous Tiger',
    'platform.anonymous-asset-name.tomato': 'Anonymous Tomato',
    'platform.anonymous-asset-name.tortoise': 'Anonymous Tortoise',
    'platform.anonymous-asset-name.tree': 'Anonymous Tree',
    'platform.anonymous-asset-name.trex': 'Anonymous T-rex',
    'platform.anonymous-asset-name.trout': 'Anonymous Trout',
    'platform.anonymous-asset-name.turkey': 'Anonymous Turkey',
    'platform.anonymous-asset-name.turtle': 'Anonymous Turtle',
    'platform.anonymous-asset-name.wasp': 'Anonymous Wasp',
    'platform.anonymous-asset-name.watermelon': 'Anonymous Watermelon',
    'platform.anonymous-asset-name.whale': 'Anonymous Whale',
    'platform.anonymous-asset-name.wolf': 'Anonymous Wolf'
};

});

parcelRegister("9mfmQ", function(module, exports) {
const $3f8e2a2fed025998$export$435a991cb82816ff = (retryCount, initialDelay = 1000, maxDelay = 30000, factor = 2)=>{
    // Calculate exponential backoff
    const delay = Math.min(initialDelay * Math.pow(factor, retryCount), maxDelay);
    // Add random jitter (between 0 and current delay value)
    return Math.floor(Math.random() * delay);
};
const $3f8e2a2fed025998$export$cffaac380b94df26 = async ({ url: url, options: options, shouldRetryOnApiError: shouldRetryOnApiError, retries: retries = 3, baseDelay: baseDelay = 300, maxDelay: maxDelay = 10000 })=>{
    try {
        const response = await fetch(url, options);
        if (response.ok) return {
            success: true,
            result: response
        };
        if (shouldRetryOnApiError) throw new Error('Failed request with an error');
        const errorBody = await response.json();
        return {
            success: false,
            error: new Error(errorBody)
        };
    } catch (error) {
        if (retries > 0) {
            const retryDelay = $3f8e2a2fed025998$export$435a991cb82816ff(retries, baseDelay, maxDelay);
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return $3f8e2a2fed025998$export$cffaac380b94df26({
                url: url,
                options: options,
                shouldRetryOnApiError: shouldRetryOnApiError,
                retries: retries - 1,
                baseDelay: baseDelay,
                maxDelay: maxDelay
            });
        }
        const newError = error instanceof Error ? error : new Error('An unknown error occurred');
        return {
            success: false,
            error: newError
        };
    }
};
module.exports["fetchWithRetry"] = $3f8e2a2fed025998$export$cffaac380b94df26;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("6UYek", function(module, exports) {

var $fbcPJ = parcelRequire("fbcPJ");


var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $fD0Uz = parcelRequire("fD0Uz");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $1xpoY = parcelRequire("1xpoY");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$var$getLegacyApolloError = (error)=>{
    if (!('errors' in error) || !Array.isArray(error.errors)) return undefined;
    const firstError = error.errors[0];
    return firstError && typeof firstError === 'object' ? firstError : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorMessage = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('message' in firstError)) return undefined;
    return typeof firstError.message === 'string' ? firstError.message : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('extensions' in firstError)) return undefined;
    const { extensions: extensions } = firstError;
    if (!extensions || typeof extensions !== 'object' || !('statusCode' in extensions)) return undefined;
    return typeof extensions.statusCode === 'number' ? extensions.statusCode : undefined;
};
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $cozmU.useState)(null);
    const [contentId, setContentId] = (0, $cozmU.useState)(null);
    const [contentType, setContentType] = (0, $cozmU.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $cozmU.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $cozmU.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = (subscribers[delta] ?? []).filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $cozmU.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            const subscribersForDelta = subscribers[delta];
            if (subscribersForDelta) subscribersForDelta.forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const { error: error } = (0, $fD0Uz.useSubscriptionInterop)((0, $fbcPJ.default), {
        variables: {
            id: id,
            __extensions: extensions
        },
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(data ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        interopApolloAggClient: true,
        __callerPackage__: "graphql"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || $da160e8fa3112de6$var$getLegacyApolloErrorMessage(error) || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode(error);
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            //
            // When graphql-subscriptions rate-limits us it returns an HTML page (eg a 429),
            // which graphql-ws feeds into JSON.parse and throws a SyntaxError. In V8 the
            // thrown message embeds the offending token, eg:
            //   Unexpected token '<', "<!DOCTYPE "... is not valid JSON
            // We match on the HTML markers rather than the generic "Unexpected token" so we
            // only suppress HTML payloads and not unrelated malformed-JSON bugs.
            const isHtmlRateLimitError = (0, $1xpoY.default).getBoolean('confluence_html_error_catching', false) && Boolean(errorMessage && /Unexpected token '<'|<!DOCTYPE|<html/.test(errorMessage));
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage || isHtmlRateLimitError;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("fbcPJ", function(module, exports) {
/**
 * @generated SignedSource<<75dc67bed6c2efce761cd8d41d39e8c1>>
 * @relayHash 509c79ed3aa65395a6739ffb9126f832
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c37239834392dbf88f3de4f8af11c861efb04723bfa417c1f6958c4e58059293
const $31174e902ea6e4b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "version"
    }, v6 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v5 /*: any*/ ,
        v3 /*: any*/ 
    ], v7 = [
        v4 /*: any*/ ,
        v3 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "spaceKey"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentId"
    }, v10 = [
        v9 /*: any*/ ,
        v3 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "confVersion"
    }, v12 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "inlineCommentType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "adfBodyContent"
    }, v15 = {
        "kind": "ScalarField",
        "name": "markerRef"
    }, v16 = {
        "kind": "ScalarField",
        "name": "publishVersionNumber"
    }, v17 = {
        "kind": "ScalarField",
        "name": "from"
    }, v18 = {
        "kind": "ScalarField",
        "name": "to"
    }, v19 = {
        "kind": "ScalarField",
        "name": "pos"
    }, v20 = {
        "kind": "ScalarField",
        "name": "annotationType"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v3 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "replies"
    }, v23 = {
        "kind": "ScalarField",
        "name": "pageCommentType"
    }, v24 = [
        v3 /*: any*/ ,
        v12 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "emojiId"
    }, v26 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceContentModified",
            "kind": "LinkedField",
            "name": "confluence_onContentModified",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "originTabId"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "_deltas"
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "contentStateUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "emojiTitleUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "pageTitlePropertyUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "coverPictureDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "emojiTitleDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "contentStateDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCoverPictureWidthUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureWidthUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "coverPictureWidth"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageBlogified",
                    "kind": "LinkedField",
                    "name": "pageBlogified",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "spaceName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blogTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "converterDisplayName"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceEmbedUpdated",
                    "kind": "LinkedField",
                    "name": "embedUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isBlankStateUpdate"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageMigrated",
                    "kind": "LinkedField",
                    "name": "pageMigrated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fabricEligibility"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentRestrictionUpdated",
                    "kind": "LinkedField",
                    "name": "contentRestrictionUpdated",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluencePageMoved",
                    "kind": "LinkedField",
                    "name": "pageMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldParentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldPosition"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceAlias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceAlias"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageUpdated",
                    "kind": "LinkedField",
                    "name": "pageUpdated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "trigger"
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceWorkflowApplicationChanged",
                    "kind": "LinkedField",
                    "name": "workflowApplicationChanged",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "changeType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newWorkflowStatusId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        v5 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceMarkdownModeUpdated",
                    "kind": "LinkedField",
                    "name": "markdownModeUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isMarkdownMode"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentUpdatedWithTemplate",
                    "kind": "LinkedField",
                    "name": "contentUpdatedWithTemplate",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "inlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceRendererInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "rendererInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "editorInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUpdated",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentDeleted",
                    "kind": "LinkedField",
                    "name": "inlineCommentDeleted",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentResolved",
                    "kind": "LinkedField",
                    "name": "inlineCommentResolved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentResolveProperties",
                            "kind": "LinkedField",
                            "name": "inlineResolveProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolved"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedByDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedFriendlyDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedUser"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "inlineText"
                        },
                        v15 /*: any*/ ,
                        v22 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUnresolved",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentReattached",
                    "kind": "LinkedField",
                    "name": "inlineCommentReattached",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentUpdated",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentResolved",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ ,
                        v22 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentReopened",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceSchedulePublished",
                    "kind": "LinkedField",
                    "name": "schedulePublished",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "publishTime"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventType"
                        },
                        v11 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentAccessRequested",
                    "kind": "LinkedField",
                    "name": "contentAccessRequested",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentAccessDecisionMade",
                    "kind": "LinkedField",
                    "name": "contentAccessDecisionMade",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "decision"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionAdded",
                    "kind": "LinkedField",
                    "name": "inlineReactionAdded",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "newHighlight"
                        },
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "stepType"
                                }
                            ]
                        },
                        v16 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionRemoved",
                    "kind": "LinkedField",
                    "name": "inlineReactionRemoved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionHighlightDeleted",
                    "kind": "LinkedField",
                    "name": "inlineReactionHighlightDeleted",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ 
        },
        "params": {
            "cacheID": "509c79ed3aa65395a6739ffb9126f832",
            "id": "c37239834392dbf88f3de4f8af11c861efb04723bfa417c1f6958c4e58059293",
            "metadata": {},
            "name": "SubscriptionsContextProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,accountId,originTabId,__typename,_deltas,contentStateUpdated{key,value,version,__typename},emojiTitleUpdated{key,value,version,__typename},coverPictureUpdated{key,value,version,__typename},pageTitlePropertyUpdated{key,value,version,__typename},coverPictureDeleted{key,__typename},emojiTitleDeleted{key,__typename},contentStateDeleted{key,__typename},coverPictureWidthUpdated{coverPictureWidth,__typename},pageBlogified{spaceKey,spaceName,blogTitle,converterDisplayName,__typename},embedUpdated{product,isBlankStateUpdate,__typename},pageMigrated{fabricEligibility,__typename},contentRestrictionUpdated{contentId,__typename},pageMoved{oldSpaceKey,newSpaceKey,oldParentId,oldPosition,newSpaceAlias,oldSpaceAlias,__typename},pageUpdated{__typename,trigger,confVersion},workflowApplicationChanged{contentId,changeType,newWorkflowStatusId,contentStatus,version,__typename},markdownModeUpdated{isMarkdownMode,__typename},contentUpdatedWithTemplate{spaceKey,subtype,__typename},inlineCommentCreated{commentId,inlineCommentType,adfBodyContent,__typename,markerRef},rendererInlineCommentCreated{__typename,commentId,adfBodyContent,inlineCommentType,markerRef,publishVersionNumber,step{from,to,pos,mark{attrs{annotationType,__typename},__typename},__typename}},editorInlineCommentCreated{adfBodyContent,commentId,inlineCommentType,markerRef,__typename},inlineCommentUpdated{commentId,markerRef,__typename},inlineCommentDeleted{commentId,inlineCommentType,markerRef,__typename},inlineCommentResolved{commentId,inlineResolveProperties{isDangling,resolved,resolvedByDangling,resolvedFriendlyDate,resolvedTime,resolvedUser,__typename},inlineText,markerRef,replies,__typename},inlineCommentUnresolved{commentId,markerRef,__typename},inlineCommentReattached{commentId,__typename,markerRef,publishVersionNumber,step{from,mark{attrs{__typename,annotationType},__typename},__typename}},commentCreated{__typename,adfBodyContent,commentId,pageCommentType},commentUpdated{__typename,commentId},commentDeleted{__typename,commentId},commentResolved{__typename,adfBodyContent,commentId,pageCommentType,replies},commentReopened{__typename,commentId},schedulePublished{publishTime,eventType,confVersion,__typename},contentAccessRequested{contentId,__typename},contentAccessDecisionMade{contentId,decision,__typename},inlineReactionAdded{commentId,markerRef,emojiId,newHighlight,step{from,to,pos,mark{attrs{annotationType,id},type},stepType},publishVersionNumber,__typename},inlineReactionRemoved{commentId,markerRef,emojiId,__typename},inlineReactionHighlightDeleted{commentId,markerRef,__typename}}}"
        }
    };
}();
$31174e902ea6e4b2$var$node.hash = "c37cfea9a825383fc3da89eb6b15ecfd";
var $31174e902ea6e4b2$export$2e2bcd8739ae039 = $31174e902ea6e4b2$var$node;
module.exports["default"] = $31174e902ea6e4b2$export$2e2bcd8739ae039;

});

parcelRegister("fD0Uz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5NgDK = parcelRequire("5NgDK");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $422HI = parcelRequire("422HI");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

const $c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode = (subscription)=>typeof subscription === 'function' || subscription.kind !== 'Document';
const $c7f06d7e4ea271ae$var$isFormattedExecutionResult = (response)=>Boolean(response && typeof response === 'object' && ('data' in response || 'errors' in response));
const $c7f06d7e4ea271ae$var$isSubscriptionData = (response)=>!$c7f06d7e4ea271ae$var$isFormattedExecutionResult(response);
const $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions = (response)=>{
    if (response == null) return {
        data: undefined,
        extensions: undefined
    };
    if ($c7f06d7e4ea271ae$var$isSubscriptionData(response)) return {
        data: response,
        extensions: undefined
    };
    return {
        data: response.data ?? undefined,
        extensions: response.extensions
    };
};
const $c7f06d7e4ea271ae$export$4966ff7f324f6363 = (response)=>{
    const { data: data, extensions: extensions } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
    return {
        ...extensions ? {
            extensions: extensions
        } : {},
        subscriptionData: {
            data: data,
            loading: false,
            ...extensions ? {
                extensions: extensions
            } : {}
        }
    };
};
const $c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment = ()=>{
    const isProduction = true;
    const isCloudProduction = true;
    const isCloudStaging = false;
    if (isProduction || isCloudProduction || isCloudStaging) return false;
    const isTest = false;
    const isDevelopment = false;
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
    return isTest || isDevelopment || isLocalhost;
};
const $c7f06d7e4ea271ae$export$1bed67b955596e29 = (forceRelay)=>{
    if (!$c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment()) return false;
    window.__TEST_ONLY_FORCE_RELAY_MODE__ = forceRelay;
    return true;
};
function $c7f06d7e4ea271ae$export$275462b87cef6610(subscription, options) {
    const forceRelayMode = window.__TEST_ONLY_FORCE_RELAY_MODE__;
    const shouldUseRelay = forceRelayMode || (0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        phase: 'subscription'
    });
    if (shouldUseRelay) {
        if (!$c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode(subscription)) throw new Error('[Relay migration] useSubscriptionInterop Relay mode requires graphql tag');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options);
    } else {
        const { interopApolloAggClient: interopApolloAggClient, extensions: extensions, ...apolloOptions } = options ?? {};
        // Apollo v2's `useSubscription` does not forward a per-call `context` option down
        // to the WebSocket link, so we smuggle `extensions` through `variables.__extensions`.
        // `AttachExtensionsLink` strips it back out and re-attaches it to the operation
        // context, which `GraphQLWSLink.request` then sets on the wire payload.
        const variables = extensions !== undefined ? {
            ...apolloOptions.variables,
            __extensions: extensions
        } : apolloOptions.variables;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, $5NgDK.useSubscription)((0, $86okN.toDocumentNode)(subscription), {
            ...apolloOptions,
            variables: variables,
            ...interopApolloAggClient ? {
                client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
            } : {}
        });
    }
}
const $c7f06d7e4ea271ae$var$toApolloErrorInterop = (error)=>new (0, $422HI.ApolloErrorInterop)({
        networkError: error instanceof Error ? error : new Error(String(error))
    });
function $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options) {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(!options?.skip);
    const disposableRef = (0, $cozmU.useRef)(null);
    const callbacksRef = (0, $cozmU.useRef)(options);
    callbacksRef.current = options;
    const skip = options?.skip;
    const variables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        phase: 'subscription'
    });
    const extensions = (0, $iF5wn.useMemoObj)(options?.extensions, options?.__callerPackage__, {
        phase: 'subscription'
    });
    (0, $cozmU.useEffect)(()=>{
        if (skip) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(undefined);
        setData(undefined);
        try {
            disposableRef.current = (0, $eqEJl.requestSubscription)(environment, {
                subscription: subscription,
                variables: variables,
                // `RelayWebSocketSubscriptionHandler` reads `cacheConfig.metadata.extensions`
                // and attaches them to the WS payload's `extensions` field.
                // cacheConfig is always set because useMemoObj coerces undefined → {}, so any
                // guard on `extensions` would always evaluate the same way. The consumer
                // (RelayWebSocketSubscriptionHandler) ignores an empty extensions object.
                cacheConfig: {
                    metadata: {
                        extensions: extensions
                    }
                },
                onNext: (response)=>{
                    const { data: responseData } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
                    setData(responseData);
                    setError(undefined);
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionData?.($c7f06d7e4ea271ae$export$4966ff7f324f6363(response));
                },
                onError: (err_0)=>{
                    setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err_0));
                    setLoading(false);
                },
                onCompleted: ()=>{
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionComplete?.();
                }
            });
        } catch (err) {
            setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err));
            setLoading(false);
        }
        return ()=>{
            if (!disposableRef.current) return;
            disposableRef.current.dispose();
            disposableRef.current = null;
        };
    }, [
        environment,
        subscription,
        variables,
        extensions,
        skip
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSubscriptionInterop"] = $c7f06d7e4ea271ae$export$275462b87cef6610;

});

parcelRegister("3vc4U", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $cozmU.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $cozmU.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $cozmU.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $cozmU.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $cozmU.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("9o40q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult_0 = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult_0);
            await onCompleted?.(data);
            return {
                data: newResult_0.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("hNILR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("jacyh", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d9bb792bb433dc50$var$initialState = {
    shouldForceRefetch: false // this is just a boolean that we toggle between false and true to force a refetch in blog tree
};
const $d9bb792bb433dc50$var$actions = {
    forceRefetchBlogTree: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                shouldForceRefetch: !currentState.shouldForceRefetch
            });
        }
};
const $d9bb792bb433dc50$var$BlogTreeStore = (0, $8s9DV.createStore)({
    initialState: $d9bb792bb433dc50$var$initialState,
    actions: $d9bb792bb433dc50$var$actions
});
const $d9bb792bb433dc50$export$9638016a54f09a07 = (0, $kBr4q.createHook)($d9bb792bb433dc50$var$BlogTreeStore);
const $d9bb792bb433dc50$export$861bc4451e1cbefa = (0, $kBr4q.createActionsHook)($d9bb792bb433dc50$var$BlogTreeStore);
module.exports["useBlogTreeStore"] = $d9bb792bb433dc50$export$9638016a54f09a07;
module.exports["useBlogTreeActions"] = $d9bb792bb433dc50$export$861bc4451e1cbefa;

});

parcelRegister("hYoU4", function(module, exports) {

var $nStJY = parcelRequire("nStJY");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $8s9DV.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $j8on0.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $kBr4q.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("5M5fB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3jwuS = parcelRequire("3jwuS");

/**
 * To avoid multiple people saving the draft simultaneously, which causes a lock exception,
 * we only want the first active user to be in charge of saving.
 * See issue CFE-1369 for details.
 */ const $ecd355b99e8f624d$var$checkIsFirstParticipant = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Check if the first participant is the current user
    return participants[0].sessionId === currentUserSessionId;
};
/**
 * Verifies if the current user is the primary participant and has edit permissions.
 * @returns {boolean} True if the user is the first participant with edit permissions,
 *                    false if the user has view only or is not the first participant.
 */ const $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Find the first participant in the sorted list with edit permissions
    const primaryParticipant = participants.find((activeUser)=>activeUser.permit?.isPermittedToEdit);
    return !!primaryParticipant && primaryParticipant.sessionId === currentUserSessionId;
};
const $ecd355b99e8f624d$var$updatePresence = (presenceData, currentParticipants)=>{
    const { joined: joined = [], left: left = [] } = presenceData;
    let updatedParticipants = [];
    if (currentParticipants === null) updatedParticipants = joined;
    else {
        // Add new participants to the list
        updatedParticipants = [
            ...currentParticipants,
            ...joined
        ];
        // Remove participants who have left
        updatedParticipants = updatedParticipants.filter((participant)=>!left.some((leftUser)=>leftUser.sessionId === participant.sessionId));
    }
    // Sort the session IDs to ensure the comparison for choosing the
    // draft sync leader is deterministic.
    updatedParticipants.sort((a, b)=>a.sessionId.localeCompare(b.sessionId));
    return updatedParticipants;
};
const $ecd355b99e8f624d$export$2a8c16d82a0a0e26 = (collabEditProvider)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentUserSessionId = (0, $cozmU.useRef)(null);
    const currentParticipants = (0, $cozmU.useRef)(null);
    const [isFirstParticipant, setIsFirstParticipant] = (0, $cozmU.useState)(true);
    const [isSingleUserSession, setIsSingleUserSession] = (0, $cozmU.useState)(true);
    // Listen to the connected event to grab the current user's sessionId
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = (event)=>{
            currentUserSessionId.current = event?.sid;
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider
    ]);
    const handleUpdatePresence = (0, $cozmU.useCallback)((presenceData)=>{
        const updatedParticipants = $ecd355b99e8f624d$var$updatePresence(presenceData, currentParticipants.current);
        currentParticipants.current = updatedParticipants;
        const isFirst = isLivePage ? $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions(updatedParticipants, currentUserSessionId.current) : $ecd355b99e8f624d$var$checkIsFirstParticipant(updatedParticipants, currentUserSessionId.current);
        setIsFirstParticipant(isFirst);
        setIsSingleUserSession(currentParticipants.current.length <= 1);
    }, [
        isLivePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        collabEditProvider.on('presence', handleUpdatePresence);
        return ()=>{
            collabEditProvider.off('presence', handleUpdatePresence);
        };
    }, [
        collabEditProvider,
        handleUpdatePresence
    ]);
    return {
        isFirstParticipant: isFirstParticipant,
        isSingleUserSession: isSingleUserSession
    };
};
module.exports["usePresence"] = $ecd355b99e8f624d$export$2a8c16d82a0a0e26;

});

parcelRegister("bMmYR", function(module, exports) {
/**
 * Sleep an async context for timeoutMs milliseconds
 *
 * Note this does not block but instead sets a timeout
 *
 * @param timeoutMs The timeout in milliseconds
 * @returns {Promise} A promise that resolves after timeoutMs milliseconds
 */ const $e3747894d76f1f8c$var$sleep = (timeoutMs)=>new Promise((resolve)=>setTimeout(resolve, timeoutMs));
const $e3747894d76f1f8c$export$9369b12211e1fce4 = (action, { backOff: backOff = true, jitter: jitter = true, timeout: timeout = 2000, maxAttempts: maxAttempts = 3 } = {}, shouldRetry)=>{
    const recursiveRetry = async (attempt)=>{
        let nextTryIn = null;
        if (attempt < maxAttempts) {
            const jitterFactor = jitter ? 1 + Math.random() : 1;
            const backOffFactor = backOff ? Math.pow(2, attempt) : 1;
            nextTryIn = timeout * backOffFactor * jitterFactor;
        }
        try {
            return await action(attempt, nextTryIn);
        } catch (ex) {
            if (nextTryIn === null) throw ex;
            if (shouldRetry && !await shouldRetry(ex)) throw ex;
            await $e3747894d76f1f8c$var$sleep(nextTryIn);
            return await recursiveRetry(attempt + 1);
        }
    };
    return recursiveRetry(0);
};
module.exports["retry"] = $e3747894d76f1f8c$export$9369b12211e1fce4;

});

parcelRegister("2VZOl", function(module, exports) {

var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $j8on0.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $8s9DV.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $kBr4q.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("3mVfX", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        isCurrentlySelectedThreadOptimisticallyAdded: false,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false,
            ["MENTIONS_ME"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        replyToContributorUsers: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null,
        triggerOnDemandSummary: false,
        isSummaryDismissedByUser: false,
        automaticSummariesPreference: undefined
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType, isOptimisticAddSuccess)=>({ getState: getState, setState: setState })=>{
            const { currentlySelectedThreadKey: currentlySelectedThreadKey } = getState();
            if (!!isOptimisticAddSuccess && commentType === (0, $8i27m.CommentType).GENERAL && currentlySelectedThreadKey !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID)) // This means that user has selected a different comment thread
            // after new comment was optimistically added on UI but before
            // the GQL mutation succeeded. In this case, we shouldn't set
            // currentlySelectedThreadKey to the new comment.
            return;
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType,
                // Note: Added for COMMENTS-6792: Optimistically adding a footer comment.
                // When adding a footer comment optimistically, setCurrentlySelectedThreadKey is
                // called twice: once when the comment is added to UI optimistically with a fake id,
                // and once more when the mutation succeeds and UI is updated with the actual id.
                // The effect of the second call is rendered on UI before the updated comment list
                // is rendered, which causes a visible flicker, where the new comment goes from
                // "selected" -> "unselected" (for an instant) -> "selected" again.
                // To fix this flicker, we keep showing the comment with fake id as "selected" when
                // this flag is true, even if value of `currentlySelectedThreadKey` has changed.
                isCurrentlySelectedThreadOptimisticallyAdded: commentType === (0, $8i27m.CommentType).GENERAL && !!isOptimisticAddSuccess
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user, contributorUsers: contributorUsers } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user,
                replyToContributorUsers: contributorUsers
            });
        },
    setReplyToContributorUsers: (users)=>({ setState: setState })=>{
            setState({
                replyToContributorUsers: users
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        },
    setTriggerOnDemandSummary: (triggerOnDemandSummary)=>({ setState: setState })=>{
            setState({
                triggerOnDemandSummary: triggerOnDemandSummary
            });
        },
    setIsSummaryDismissedByUser: (isSummaryDismissedByUser)=>({ setState: setState })=>{
            setState({
                isSummaryDismissedByUser: isSummaryDismissedByUser
            });
        },
    setAutomaticSummariesPreference: (automaticSummariesPreference)=>({ setState: setState })=>{
            setState({
                automaticSummariesPreference: automaticSummariesPreference
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $8s9DV.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $kBr4q.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $kBr4q.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $kBr4q.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("5fMeR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fJCU9 = parcelRequire("fJCU9");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("cI8N3"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("hpN8t"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("60ddt"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("gH9zl"))).CommentsPanelWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderActions = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4wZwH",
    name: "CommentsPanelHeaderActions",
    loader: async ()=>(await (parcelRequire("2bP5O"))).CommentsPanelHeaderActions
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelHeaderActions.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const isSlidesView = (0, $gEtAQ.isSlides)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $cozmU.useRef)(hasContentChanged);
    (0, $cozmU.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelClose = (0, $cozmU.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const canClosePanel = (0, $cozmU.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        // Drag-to-resize on page surfaces only (same exclusions as the panel
        // itself). `expValEquals` is the LAST clause per
        // `confluence-feature-gating/no-preconditioning` so exposure is only
        // recorded for users who actually meet the surface preconditions.
        const isResizableSurface = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView && (0, $6mKj3.expValEquals)('confluence_fe_comments_panel_resize', 'isEnabled', true);
        const showFooter = canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: $3b7f940e5fdc8097$var$CommentsPanelHeaderActions
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView
                }),
            FooterComponent: showFooter ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            },
            isResizable: isResizableSurface
        }, 'push');
    };
    const showCommentsPanel = (0, $cozmU.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        isSlidesView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["AgentReceiptPanel"] = "agentReceiptPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    PanelName["SpaceSuggestionReviewPanel"] = "space-suggestion-review-panel";
    PanelName["SuggestionsPanel"] = "suggestionsPanel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    "agentReceiptPanel",
    "space-suggestion-review-panel",
    "suggestionsPanel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("8aF6s", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $8s9DV.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $kBr4q.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $cozmU.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $kBr4q.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $cozmU.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("cI8N3", function(module, exports) {

let $941069a6991e4f76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $941069a6991e4f76$var$load("g81ly"),
    $941069a6991e4f76$var$load("e3LAK"),
    $941069a6991e4f76$var$load("w3Gc8"),
    $941069a6991e4f76$var$load("hs6P3"),
    $941069a6991e4f76$var$load("lgIhe"),
    $941069a6991e4f76$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("hpN8t", function(module, exports) {

let $cadae2c57febfea4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cadae2c57febfea4$var$load("gBfQ7"),
    $cadae2c57febfea4$var$load("eTvQu"),
    $cadae2c57febfea4$var$load("g81ly"),
    $cadae2c57febfea4$var$load("e3LAK"),
    $cadae2c57febfea4$var$load("60QcS"),
    $cadae2c57febfea4$var$load("6wr18"),
    $cadae2c57febfea4$var$load("aIw3f"),
    $cadae2c57febfea4$var$load("8LtYa"),
    $cadae2c57febfea4$var$load("ffEVr"),
    $cadae2c57febfea4$var$load("4XoWv"),
    $cadae2c57febfea4$var$load("4W6oq"),
    $cadae2c57febfea4$var$load("hs6P3"),
    $cadae2c57febfea4$var$load("hhss7"),
    $cadae2c57febfea4$var$load("kv4Kv"),
    $cadae2c57febfea4$var$load("qCaIx"),
    $cadae2c57febfea4$var$load("26l7c"),
    $cadae2c57febfea4$var$load("aAWLw"),
    $cadae2c57febfea4$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("60ddt", function(module, exports) {

let $45ecfea625e292e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $45ecfea625e292e8$var$load("6wr18"),
    $45ecfea625e292e8$var$load("ffEVr"),
    $45ecfea625e292e8$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("gH9zl", function(module, exports) {

let $c27815b89082ffa9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c27815b89082ffa9$var$load("18viy"),
    $c27815b89082ffa9$var$load("fEHF5"),
    $c27815b89082ffa9$var$load("ccAQf"),
    $c27815b89082ffa9$var$load("ipIDQ"),
    $c27815b89082ffa9$var$load("gBfQ7"),
    $c27815b89082ffa9$var$load("eTvQu"),
    $c27815b89082ffa9$var$load("g81ly"),
    $c27815b89082ffa9$var$load("e3LAK"),
    $c27815b89082ffa9$var$load("eS3wT"),
    $c27815b89082ffa9$var$load("4uO8Y"),
    $c27815b89082ffa9$var$load("dfVz8"),
    $c27815b89082ffa9$var$load("cJsay"),
    $c27815b89082ffa9$var$load("8Q1q0"),
    $c27815b89082ffa9$var$load("jsNWB"),
    $c27815b89082ffa9$var$load("1GCFv"),
    $c27815b89082ffa9$var$load("byAMe"),
    $c27815b89082ffa9$var$load("fHwKU"),
    $c27815b89082ffa9$var$load("b0ARW"),
    $c27815b89082ffa9$var$load("e5ukl"),
    $c27815b89082ffa9$var$load("123MJ"),
    $c27815b89082ffa9$var$load("elQ9h"),
    $c27815b89082ffa9$var$load("52ZTT"),
    $c27815b89082ffa9$var$load("iZiYW"),
    $c27815b89082ffa9$var$load("57o6G"),
    $c27815b89082ffa9$var$load("cmmpX"),
    $c27815b89082ffa9$var$load("4XoWv"),
    $c27815b89082ffa9$var$load("hs6P3"),
    $c27815b89082ffa9$var$load("jqoep"),
    $c27815b89082ffa9$var$load("eUsnQ"),
    $c27815b89082ffa9$var$load("ariuh"),
    $c27815b89082ffa9$var$load("cFgVe"),
    $c27815b89082ffa9$var$load("5wzAc"),
    $c27815b89082ffa9$var$load("7EorR"),
    $c27815b89082ffa9$var$load("aLwQm"),
    $c27815b89082ffa9$var$load("6wr18"),
    $c27815b89082ffa9$var$load("Wowvf"),
    $c27815b89082ffa9$var$load("7gL7H"),
    $c27815b89082ffa9$var$load("hhss7"),
    $c27815b89082ffa9$var$load("fZ0vM"),
    $c27815b89082ffa9$var$load("3kale"),
    $c27815b89082ffa9$var$load("4JSav"),
    $c27815b89082ffa9$var$load("kv4Kv"),
    $c27815b89082ffa9$var$load("qCaIx"),
    $c27815b89082ffa9$var$load("hN9W6"),
    $c27815b89082ffa9$var$load("ffEVr"),
    $c27815b89082ffa9$var$load("jzSMU"),
    $c27815b89082ffa9$var$load("dEUQZ"),
    $c27815b89082ffa9$var$load("eLfJM"),
    $c27815b89082ffa9$var$load("80Yra"),
    $c27815b89082ffa9$var$load("cgKMu"),
    $c27815b89082ffa9$var$load("60QcS"),
    $c27815b89082ffa9$var$load("husez"),
    $c27815b89082ffa9$var$load("fYtcg"),
    $c27815b89082ffa9$var$load("9FPrl"),
    $c27815b89082ffa9$var$load("79Tk4"),
    $c27815b89082ffa9$var$load("26l7c"),
    $c27815b89082ffa9$var$load("1R82J"),
    $c27815b89082ffa9$var$load("9YbM1"),
    $c27815b89082ffa9$var$load("aAWLw"),
    $c27815b89082ffa9$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("2bP5O", function(module, exports) {

let $19843dd1ae53e874$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $19843dd1ae53e874$var$load("g81ly"),
    $19843dd1ae53e874$var$load("e3LAK"),
    $19843dd1ae53e874$var$load("w3Gc8"),
    $19843dd1ae53e874$var$load("hs6P3"),
    $19843dd1ae53e874$var$load("lgIhe"),
    $19843dd1ae53e874$var$load("bZz7X"),
    $19843dd1ae53e874$var$load("9izCO")
]).then(()=>parcelRequire('gDZxl'));

});

parcelRegister("en1dX", function(module, exports) {
var $88e03e673e36ecc4$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["COMMENTS_PANEL"] = "commentsPanel";
    AnalyticsSource["STANDALONE"] = "standalone";
    AnalyticsSource["PAGE_FOOTER"] = "pageFooter";
    return AnalyticsSource;
}({});
var $88e03e673e36ecc4$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["REOPEN_COMMENT"] = "reopenComment";
    return ActionName;
}({});
var $88e03e673e36ecc4$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    CommentType["PAGE"] = "page";
    return CommentType;
}({});
module.exports["AnalyticsSource"] = $88e03e673e36ecc4$export$6890652a1aff7d1c;
module.exports["ActionName"] = $88e03e673e36ecc4$export$9c95d6e1614bad84;
module.exports["CommentType"] = $88e03e673e36ecc4$export$ffa1150e6a48f9cd;

});

parcelRegister("fHAwL", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $7fff4328005dca96$var$initialState = {
    // isUpdatingUnreadComments tracks when we're updating the unread comments set
    // (e.g., during initial render or when manually updating the set).
    isUpdatingUnreadComments: true,
    // isUnreadQueryLoading tracks when we're actively fetching comments from the server.
    isUnreadQueryLoading: false,
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    setIsUpdatingUnreadComments: (isUpdatingUnreadComments)=>({ setState: setState })=>{
            setState({
                isUpdatingUnreadComments: isUpdatingUnreadComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $8s9DV.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $kBr4q.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $kBr4q.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $kBr4q.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});

parcelRegister("d3bcC", function(module, exports) {

var $5VFXo = parcelRequire("5VFXo");


var $aXiya = parcelRequire("aXiya");


var $eLFD2 = parcelRequire("eLFD2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");





var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments = (0, $eLFD2.default);
// Helper function to safely convert content type for the viewed comments query
const $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments = (contentType)=>{
    // Only page, database, whiteboard, and slide support the viewed comments query
    if (contentType === 'page' || contentType === 'database' || (0, $1ggpj.isCanvasContentType)(contentType)) return contentType;
    // Fallback to page for other content types (blogpost, embed, etc.)
    return 'page';
};
// Helper to generate stable ROOT_QUERY cache key
// Ensures consistent key format regardless of object property order
const $18a2fd912dfb58ac$var$getRootQueryCacheId = (pageId, contentType)=>{
    const validContentType = $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType);
    // Sort keys to ensure stable JSON.stringify output
    const variables = {
        contentId: pageId,
        contentType: validContentType
    };
    return `$ROOT_QUERY.contentAnalyticsViewedComments(${JSON.stringify(variables)})`;
};
const $18a2fd912dfb58ac$export$cd81a9ad0848990 = ({ pageId: pageId })=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $aXiya.default),
        fragmentSpec: (0, $aXiya.default),
        __callerPackage__: "unread-comments"
    });
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5VFXo.default),
        __callerPackage__: "unread-comments"
    });
    // Network-only query for fresh data
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)($18a2fd912dfb58ac$var$ContentAnalyticsViewedComments, {
        skip: true,
        // Never query on render
        fetchPolicy: 'network-only',
        variables: {
            contentId: pageId,
            contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
        },
        __callerPackage__: "unread-comments"
    });
    // Helper function to process the query result
    const processQueryResult = (0, $cozmU.useCallback)((data)=>{
        const commentIds = data?.contentAnalyticsViewedComments?.commentIds ?? [];
        const viewedCommentsSet = new Set(commentIds.filter((id)=>id !== null && id !== undefined));
        return {
            success: true,
            data: viewedCommentsSet
        };
    }, []);
    // Helper function for cache-only queries
    const executeCacheOnlyQuery = (0, $cozmU.useCallback)(()=>{
        if (!pageId || !contentType) throw new Error('Page ID and content type are required');
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            if (rootQueryData) {
                // Convert fragment data to query result format
                const queryResult = {
                    contentAnalyticsViewedComments: {
                        commentIds: rootQueryData.commentIds
                    }
                };
                return processQueryResult(queryResult);
            }
            return {
                success: false,
                error: new Error('No viewed comments data found in cache')
            };
        } catch (error) {
            // Handle cache read errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        readFragmentInterop
    ]);
    // Helper function for network-only queries
    const executeNetworkOnlyQuery = (0, $cozmU.useCallback)(async ()=>{
        if (!pageId) throw new Error('Page ID and content type are required');
        try {
            const result = await refetch({
                contentId: pageId,
                contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
            });
            // Apollo automatically writes query results to ROOT_QUERY cache, so we don't need to explicitly write
            // The executeCacheOnlyQuery function will read from ROOT_QUERY directly
            return processQueryResult(result.data);
        } catch (error) {
            // Handle expected errors (403/unauthorized, network errors) - just mark as handled
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return {
                    success: false,
                    error: error
                };
            }
            // Handle unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        refetch
    ]);
    // Cached data query - uses cache-only for performance
    const getViewedCommentsCacheOnly = (0, $cozmU.useCallback)(()=>{
        try {
            return executeCacheOnlyQuery();
        } catch (error) {
            return {
                success: false,
                error: error
            };
        }
    }, [
        executeCacheOnlyQuery
    ]);
    // Fresh data query - always uses network-only for latest data
    const getViewedCommentsFresh = (0, $cozmU.useCallback)(()=>executeNetworkOnlyQuery(), [
        executeNetworkOnlyQuery
    ]);
    // Function to update the viewed comments cache
    // This is used for optimistic updates when comments are viewed locally
    const updateViewedCommentsCache = (0, $cozmU.useCallback)((commentIds)=>{
        if (!pageId || !contentType || commentIds.length === 0) return;
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            const existingCommentIds = rootQueryData?.commentIds ?? [];
            // Merge new comment IDs with existing ones
            const existingSet = new Set(existingCommentIds.filter((id)=>id !== null));
            commentIds.forEach((id)=>existingSet.add(id));
            const mergedCommentIds = Array.from(existingSet);
            // Update ROOT_QUERY cache
            writeFragmentInterop({
                fragmentId: rootQueryCacheId,
                data: {
                    commentIds: mergedCommentIds,
                    __typename: 'ViewedComments'
                }
            });
        } catch (error) {
            // Handle cache writing errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        pageId,
        contentType,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return {
        getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
        getViewedCommentsFresh: getViewedCommentsFresh,
        updateViewedCommentsCache: updateViewedCommentsCache
    };
};
module.exports["useViewedComments"] = $18a2fd912dfb58ac$export$cd81a9ad0848990;

});

parcelRegister("5VFXo", function(module, exports) {
/**
 * @generated SignedSource<<81d1b8de15cc7be4dc05b1f67ad843c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1027eddc6949c38$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_read",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$a1027eddc6949c38$var$node.hash = "8133cc01831582777d2e0911570e19eb";
var $a1027eddc6949c38$export$2e2bcd8739ae039 = $a1027eddc6949c38$var$node;
module.exports["default"] = $a1027eddc6949c38$export$2e2bcd8739ae039;

});

parcelRegister("aXiya", function(module, exports) {
/**
 * @generated SignedSource<<958fb5adbccc1c73817035c31c0d22af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e3d4a4e06abb15d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_write",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$7e3d4a4e06abb15d$var$node.hash = "d155cf7774eeec1efd57aa640539aef9";
var $7e3d4a4e06abb15d$export$2e2bcd8739ae039 = $7e3d4a4e06abb15d$var$node;
module.exports["default"] = $7e3d4a4e06abb15d$export$2e2bcd8739ae039;

});

parcelRegister("eLFD2", function(module, exports) {
/**
 * @generated SignedSource<<5a09a8bafd0f0986741b44b0b326104b>>
 * @relayHash 62839dc9a36eb801c9e817f5ebefa91f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 525c1fabca433deba33679d7a93d12d89e84cc662a445506517775392adadc65
const $61b7521c17137f8d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "ViewedComments",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewedComments",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "commentIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useViewedCommentsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useViewedCommentsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "62839dc9a36eb801c9e817f5ebefa91f",
            "id": "525c1fabca433deba33679d7a93d12d89e84cc662a445506517775392adadc65",
            "metadata": {},
            "name": "useViewedCommentsQuery",
            "operationKind": "query",
            "text": "query useViewedCommentsQuery($contentId:ID!,$contentType:ConfluenceAnalyticsCommentContentType!){contentAnalyticsViewedComments(contentId:$contentId,contentType:$contentType){commentIds}}"
        }
    };
}();
$61b7521c17137f8d$var$node.hash = "3584bbc92d39d1aa58e2ff1c3396ad40";
var $61b7521c17137f8d$export$2e2bcd8739ae039 = $61b7521c17137f8d$var$node;
module.exports["default"] = $61b7521c17137f8d$export$2e2bcd8739ae039;

});

parcelRegister("6hmtW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $cozmU.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $cozmU.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $cozmU.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $cozmU.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $cozmU.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $cozmU.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for create comment events (called by content types).
   * Canvas registers this so it can be notified when a new top-level comment
   * is created inside the Confluence comments panel.
   */ registerOnCreateComment(callback) {
        this.onCreateCommentHandler = callback;
    }
    /**
   * Handle a create comment event (fired by CFE after a new comment is saved
   * in the comments panel).  This allows Canvas to sync the new comment to
   * other collaborators.
   */ onCreateComment(threadKey) {
        this.onCreateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param actionType - Optional action type: 'reply' for new replies, 'edit' for comment edits
   */ onUpdateComment(threadKey, actionType) {
        this.onUpdateCommentHandler?.(threadKey, actionType);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    /**
   * Register a handler for update unread comments events (called by content types)
   * @param handler - A callback function that will be called by content types (whiteboards, databases) to register a handler that CFE can use
   * to notify about the comment being read (e.g. update the unread comments status).
   */ registerOnUpdateUnreadComments(handler) {
        this.onUpdateUnreadCommentsHandler = handler;
    }
    /**
   * Handle an update unread comments event (fired by CF)
   * CFE -> Content Types (whiteboards, databases)
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread
   * @see triggerReadStatusComment for the counterpart method
   */ onUpdateUnreadComments(commentIds, read = false) {
        return this.onUpdateUnreadCommentsHandler?.(commentIds, read);
    }
    /**
   * Register a handler for trigger read status comment events (called by CF)
   * @param handler - A callback function used by CFE to register a handler that can be used when content types notifies CFE about a comment being read.
   */ registerTriggerReadStatusComment(handler) {
        this.triggerReadStatusCommentHandler = handler;
    }
    /**
   * Triggers an update of the unread comments status (fired by content types)
   * Content Types (whiteboards, databases) -> CFE
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread.
   * @see onUpdateUnreadComments for the counterpart method
   */ triggerReadStatusComment(commentIds, read = false) {
        return this.triggerReadStatusCommentHandler?.(commentIds, read);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onCreateCommentHandler = void 0;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.onUpdateUnreadCommentsHandler = void 0;
        this.triggerReadStatusCommentHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("lU4RT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $acQiA = parcelRequire("acQiA");


var $9d7Pd = parcelRequire("9d7Pd");


var $3jSHR = parcelRequire("3jSHR");


var $43dcO = parcelRequire("43dcO");


var $imIsb = parcelRequire("imIsb");


var $1P2f3 = parcelRequire("1P2f3");

/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $6b3a69811500fe11$var$DropdownItemCheckbox = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    let children;
    let defaultSelected;
    let description;
    let id;
    let interactionName;
    let isDisabled;
    let isSelected;
    let rest;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: t1, shouldDescriptionWrap: t2, shouldTitleWrap: t3, testId: testId, interactionName: interactionName, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = defaultSelected;
        $[3] = description;
        $[4] = id;
        $[5] = interactionName;
        $[6] = isDisabled;
        $[7] = isSelected;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = testId;
    } else {
        children = $[1];
        defaultSelected = $[2];
        description = $[3];
        id = $[4];
        interactionName = $[5];
        isDisabled = $[6];
        isSelected = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        testId = $[12];
    }
    const providedOnClick = t1 === undefined ? (0, $dpsRj.default) : t1;
    const shouldDescriptionWrap = t2 === undefined ? true : t2;
    const shouldTitleWrap = t3 === undefined ? true : t3;
    typeof $1P2f3;
    let t4;
    if ($[13] !== defaultSelected || $[14] !== id || $[15] !== isSelected) {
        t4 = {
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        };
        $[13] = defaultSelected;
        $[14] = id;
        $[15] = isSelected;
        $[16] = t4;
    } else t4 = $[16];
    const [selected, setSelected] = (0, $43dcO.default)(t4);
    let t5;
    if ($[17] !== providedOnClick || $[18] !== setSelected) {
        t5 = (event)=>{
            setSelected($6b3a69811500fe11$var$_temp);
            providedOnClick(event);
        };
        $[17] = providedOnClick;
        $[18] = setSelected;
        $[19] = t5;
    } else t5 = $[19];
    const onClickHandler = t5;
    const itemRef = (0, $imIsb.default)();
    let t6;
    if ($[20] !== selected) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3jSHR.default), {
            checked: selected
        });
        $[20] = selected;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== children || $[23] !== description || $[24] !== id || $[25] !== interactionName || $[26] !== isDisabled || $[27] !== itemRef || $[28] !== onClickHandler || $[29] !== rest || $[30] !== selected || $[31] !== shouldDescriptionWrap || $[32] !== shouldTitleWrap || $[33] !== t6 || $[34] !== testId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: t6,
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest
        }, children));
        $[22] = children;
        $[23] = description;
        $[24] = id;
        $[25] = interactionName;
        $[26] = isDisabled;
        $[27] = itemRef;
        $[28] = onClickHandler;
        $[29] = rest;
        $[30] = selected;
        $[31] = shouldDescriptionWrap;
        $[32] = shouldTitleWrap;
        $[33] = t6;
        $[34] = testId;
        $[35] = t7;
    } else t7 = $[35];
    return t7;
} : ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $dpsRj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $1P2f3;
    const [selected, setSelected] = (0, $43dcO.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $cozmU.useCallback)((event)=>{
        setSelected((selected_0)=>!selected_0);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $imIsb.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3jSHR.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        interactionName: interactionName,
        ...rest
    }, children));
};
var $6b3a69811500fe11$export$2e2bcd8739ae039 = $6b3a69811500fe11$var$DropdownItemCheckbox;
function $6b3a69811500fe11$var$_temp(selected_0) {
    return !selected_0;
}
module.exports["default"] = $6b3a69811500fe11$export$2e2bcd8739ae039;

});

parcelRegister("3jSHR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $a8ec5e894df17170$var$svgStyles = null; /**
                         * __Checkbox icon__
                         *
                         * Used to visually represent the selected state in DropdownItemCheckbox
                         *
                         * @internal
                         */ 
const $a8ec5e894df17170$var$CheckboxIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { checked: checked } = t0;
    const t1 = checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)";
    const t2 = checked ? "var(--ds-icon-inverse, #FFFFFF)" : "transparent";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            color: t1,
            fill: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1rdFvhlfZc _1pp6NdYbGa"
        ]);
        $[3] = t4;
    } else t4 = $[3];
    const t5 = checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)";
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            stroke: t5,
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            fillRule: "evenodd"
        }, t6, t7);
        $[7] = t6;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t3 || $[10] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            style: t3,
            role: "presentation",
            className: t4
        }, t8);
        $[9] = t3;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
} : ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1rdFvhlfZc _1pp6NdYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })));
};
var $a8ec5e894df17170$export$2e2bcd8739ae039 = $a8ec5e894df17170$var$CheckboxIcon;
module.exports["default"] = $a8ec5e894df17170$export$2e2bcd8739ae039;

});

parcelRegister("43dcO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hR9fw = parcelRequire("hR9fw");


var $lOWpM = parcelRequire("lOWpM");

/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $e413fac5530a681e$var$useCheckboxState = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isSelected: isSelected, id: id, defaultSelected: defaultSelected } = t0;
    const { setItemState: setItemState, getItemState: getItemState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const groupId = (0, $cozmU.useContext)((0, $hR9fw.CheckboxGroupContext));
    let t1;
    if ($[0] !== getItemState || $[1] !== groupId || $[2] !== id) {
        t1 = getItemState(groupId, id);
        $[0] = getItemState;
        $[1] = groupId;
        $[2] = id;
        $[3] = t1;
    } else t1 = $[3];
    const persistedIsSelected = t1;
    let t2;
    if ($[4] !== defaultSelected || $[5] !== persistedIsSelected) {
        t2 = ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
        $[4] = defaultSelected;
        $[5] = persistedIsSelected;
        $[6] = t2;
    } else t2 = $[6];
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[7] !== groupId || $[8] !== id || $[9] !== persistedIsSelected || $[10] !== setItemState) {
        t3 = (newValue)=>{
            const nextValue = newValue(persistedIsSelected);
            setLocalIsSelected(nextValue);
            setItemState(groupId, id, nextValue);
        };
        $[7] = groupId;
        $[8] = id;
        $[9] = persistedIsSelected;
        $[10] = setItemState;
        $[11] = t3;
    } else t3 = $[11];
    const setLocalState = t3;
    if (typeof isSelected === "boolean") {
        let t4;
        if ($[12] !== isSelected) {
            t4 = [
                isSelected,
                $e413fac5530a681e$var$_temp
            ];
            $[12] = isSelected;
            $[13] = t4;
        } else t4 = $[13];
        return t4;
    }
    if (persistedIsSelected === undefined) setItemState(groupId, id, defaultSelected || false);
    let t4;
    if ($[14] !== localIsSelected || $[15] !== setLocalState) {
        t4 = [
            localIsSelected,
            setLocalState
        ];
        $[14] = localIsSelected;
        $[15] = setLocalState;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const groupId = (0, $cozmU.useContext)((0, $hR9fw.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $cozmU.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $e413fac5530a681e$export$2e2bcd8739ae039 = $e413fac5530a681e$var$useCheckboxState;
function $e413fac5530a681e$var$_temp() {
    return false;
}
module.exports["default"] = $e413fac5530a681e$export$2e2bcd8739ae039;

});

parcelRegister("hR9fw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c7ae6da6a8b76651$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $cozmU.createContext)('');
module.exports["CheckboxGroupContext"] = $c7ae6da6a8b76651$export$baf37c4be89255b8;

});

parcelRegister("7DqNt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $eiIYc = parcelRequire("eiIYc");


var $hR9fw = parcelRequire("hR9fw");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $1b4057c4abe15cf7$var$DropdownItemCheckboxGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    let children;
    let hasSeparator;
    let id;
    let isList;
    let isScrollable;
    let rest;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasSeparator;
        $[3] = id;
        $[4] = isList;
        $[5] = isScrollable;
        $[6] = rest;
        $[7] = testId;
        $[8] = title;
    } else {
        children = $[1];
        hasSeparator = $[2];
        id = $[3];
        isList = $[4];
        isScrollable = $[5];
        rest = $[6];
        testId = $[7];
        title = $[8];
    }
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    const t1 = title ? titleId : undefined;
    let t2;
    if ($[9] !== title || $[10] !== titleId) {
        t2 = title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
            id: titleId,
            title: title
        });
        $[9] = title;
        $[10] = titleId;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== hasSeparator || $[14] !== id || $[15] !== isList || $[16] !== isScrollable || $[17] !== rest || $[18] !== t1 || $[19] !== t2 || $[20] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: t1,
            ...rest
        }, t2, children);
        $[12] = children;
        $[13] = hasSeparator;
        $[14] = id;
        $[15] = isList;
        $[16] = isScrollable;
        $[17] = rest;
        $[18] = t1;
        $[19] = t2;
        $[20] = testId;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== id || $[23] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hR9fw.CheckboxGroupContext).Provider, {
            value: id
        }, t3);
        $[22] = id;
        $[23] = t3;
        $[24] = t4;
    } else t4 = $[24];
    return t4;
} : ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hR9fw.CheckboxGroupContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
        id: titleId,
        title: title
    }), children));
};
var $1b4057c4abe15cf7$export$2e2bcd8739ae039 = $1b4057c4abe15cf7$var$DropdownItemCheckboxGroup;
module.exports["default"] = $1b4057c4abe15cf7$export$2e2bcd8739ae039;

});

parcelRegister("eRn3r", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("9aUDG")).lazyForPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("9aUDG")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $5a3Es = parcelRequire("5a3Es");


var $9aUDG = parcelRequire("9aUDG");

parcelRequire("6VSrF");
var $86UVJ = parcelRequire("86UVJ");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("hZz7i");
var $3QYdZ = parcelRequire("3QYdZ");


var $itHHy = parcelRequire("itHHy");


var $bvYi1 = parcelRequire("bvYi1");


});

parcelRegister("jxKH9", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("3Pobi")).MODE);

var $3Pobi = parcelRequire("3Pobi");

const $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN = undefined;
const $e3a55206c71bac9e$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $e3a55206c71bac9e$var$DEFAULT_MODE = (0, $3Pobi.MODE).HYDRATE;
const $e3a55206c71bac9e$var$DEFAULT_RETRY = 2;
const $e3a55206c71bac9e$var$config = {
    crossOrigin: $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN,
    manifest: $e3a55206c71bac9e$var$DEFAULT_MANIFEST,
    mode: $e3a55206c71bac9e$var$DEFAULT_MODE,
    retry: $e3a55206c71bac9e$var$DEFAULT_RETRY
};
const $e3a55206c71bac9e$export$44487a86467333c3 = ()=>$e3a55206c71bac9e$var$config;
const $e3a55206c71bac9e$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $e3a55206c71bac9e$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN;
    $e3a55206c71bac9e$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $e3a55206c71bac9e$var$DEFAULT_MANIFEST;
    $e3a55206c71bac9e$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $e3a55206c71bac9e$var$DEFAULT_MODE;
    $e3a55206c71bac9e$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $e3a55206c71bac9e$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $e3a55206c71bac9e$export$44487a86467333c3;
module.exports["setConfig"] = $e3a55206c71bac9e$export$940a7873bb071df8;

});

parcelRegister("3Pobi", function(module, exports) {
const $2c98e46ce94c4b5d$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $2c98e46ce94c4b5d$export$e48589d9e4824227;

});

parcelRegister("5a3Es", function(module, exports) {

var $eegtN = parcelRequire("eegtN");


var $jxKH9 = parcelRequire("jxKH9");

parcelRequire("itHHy");
var $ehkpF = parcelRequire("ehkpF");
var $8r5Wf = parcelRequire("8r5Wf");


var $hBrZE = parcelRequire("hBrZE");

const $3c20b80e9e8d3df3$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $jxKH9.setConfig)(config);
        (0, $ehkpF.LISTENERS).length = 0;
        (0, $8r5Wf.setCurrent)(0);
        if (!(0, $hBrZE.isNodeEnvironment)()) (0, $eegtN.collect)();
    }
};

});

parcelRegister("eegtN", function(module, exports) {

var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");


var $4qzp5 = parcelRequire("4qzp5");


var $8WAU6 = parcelRequire("8WAU6");

const $a5bf27f95a5c4338$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $jxKH9.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $3Pobi.MODE).RENDER ? (0, $4qzp5.cloneElements)(markers[i], lazyBegin) : (0, $8WAU6.refElements)(markers[i], lazyBegin);
        if ((0, $gy5kI.COLLECTED).has(lazyBegin)) (0, $gy5kI.COLLECTED).get(lazyBegin).push(value);
        else (0, $gy5kI.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $a5bf27f95a5c4338$export$bb44f104e3c54dae;

});

parcelRegister("gy5kI", function(module, exports) {
const $c0c3f558a37c633a$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $c0c3f558a37c633a$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $c0c3f558a37c633a$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $c0c3f558a37c633a$export$4831ef3968ea94ef;

});

parcelRegister("4qzp5", function(module, exports) {
const $33950d892bd67505$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $33950d892bd67505$export$c42217d53a7ebafb;

});

parcelRegister("8WAU6", function(module, exports) {
const $68305ddfb331b362$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $68305ddfb331b362$export$c69443129766a7fc;

});

parcelRegister("itHHy", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("8r5Wf")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("8r5Wf")).setCurrent);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("ehkpF")).LISTENERS);

var $8r5Wf = parcelRequire("8r5Wf");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");


});

parcelRegister("8r5Wf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gy5kI = parcelRequire("gy5kI");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");

let $6245739e6eaab8ef$var$CURRENT_PHASE = (0, $gy5kI.PHASE).PAINT;
const $6245739e6eaab8ef$export$5f80f094fd31fffd = (phase)=>{
    $6245739e6eaab8ef$var$CURRENT_PHASE = phase;
    (0, $ehkpF.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $6245739e6eaab8ef$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $6h5l4.createSubscribe)((0, $ehkpF.LISTENERS)),
    currentValue: ()=>$6245739e6eaab8ef$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).PAINT)
    }
});
const $6245739e6eaab8ef$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($6245739e6eaab8ef$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $6245739e6eaab8ef$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $6245739e6eaab8ef$export$5a25eca35e5debcb;

});

parcelRegister("ehkpF", function(module, exports) {
const $a6527ccf54714552$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $a6527ccf54714552$export$81b9c458a026d68f;

});

parcelRegister("6h5l4", function(module, exports) {
const $491878cc97587aa1$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $491878cc97587aa1$export$364097d812234b3f;

});

parcelRegister("hBrZE", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("9fFjP")).default);

var $9fFjP = parcelRequire("9fFjP");

const $cd0b9b420a47cee1$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $cd0b9b420a47cee1$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $cd0b9b420a47cee1$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $cd0b9b420a47cee1$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $cd0b9b420a47cee1$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $cd0b9b420a47cee1$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $cd0b9b420a47cee1$export$283635c04a02cc36;
module.exports["attrToProp"] = $cd0b9b420a47cee1$export$62bf630d0de3d781;

});

parcelRegister("9fFjP", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bc590d7746b5907$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $6bc590d7746b5907$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9aUDG", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");


var $hBrZE = parcelRequire("hBrZE");
var $9fFjP = parcelRequire("9fFjP");


var $aH9lN = parcelRequire("aH9lN");


var $ilEj6 = parcelRequire("ilEj6");


var $lJ3sU = parcelRequire("lJ3sU");


var $ajpr4 = parcelRequire("ajpr4");


var $67Nku = parcelRequire("67Nku");


var $edTIv = parcelRequire("edTIv");


var $17PxK = parcelRequire("17PxK");

function $6ae0fb8adbd87448$var$_extends() {
    $6ae0fb8adbd87448$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ae0fb8adbd87448$var$_extends.apply(this, arguments);
}
function $6ae0fb8adbd87448$var$lazyProxy(_loader, { defer: defer = (0, $gy5kI.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $hBrZE.isNodeEnvironment)();
    const dataLazyId = (0, $9fFjP.default)(moduleId);
    const LazyInternal = isServer ? (0, $lJ3sU.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $ilEj6.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ajpr4.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $jxKH9.getConfig)();
                return (0, $edTIv.retry)(_loader, {
                    delay: (0, $aH9lN.RETRY_DELAY),
                    factor: (0, $aH9lN.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $hBrZE.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jxKH9.getConfig)();
        return (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $gy5kI.PHASE).PAINT ? (0, $aH9lN.PRIORITY).HIGH : (0, $aH9lN.PRIORITY).LOW;
        return (0, $67Nku.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6ae0fb8adbd87448$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $gy5kI.PHASE).LAZY
    }
};
function $6ae0fb8adbd87448$export$c952e5f94576010e(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$291dd592399bdafa(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$488013bae63b21da(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6ae0fb8adbd87448$export$c952e5f94576010e;
module.exports["lazy"] = $6ae0fb8adbd87448$export$488013bae63b21da;

});

parcelRegister("hXfAR", function(module, exports) {
const $d1240ae4295f4288$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $d1240ae4295f4288$export$303f43e55cf1ef2f;

});

parcelRegister("aH9lN", function(module, exports) {
const $7c952c608ad2380e$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $7c952c608ad2380e$export$a339266ad71b2447 = 300;
const $7c952c608ad2380e$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $7c952c608ad2380e$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $7c952c608ad2380e$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $7c952c608ad2380e$export$ba64c908e55507fe;

});

parcelRegister("ilEj6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("6VSrF");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("itHHy");
var $8r5Wf = parcelRequire("8r5Wf");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $aH9lN = parcelRequire("aH9lN");


var $17PxK = parcelRequire("17PxK");


var $6adGO = parcelRequire("6adGO");


var $jl5l1 = parcelRequire("jl5l1");


var $67Nku = parcelRequire("67Nku");


var $bvYi1 = parcelRequire("bvYi1");


var $aiyJe = parcelRequire("aiyJe");

function $d5b97455f4530d40$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $cozmU.useContext)((0, $bvYi1.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $17PxK.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $aiyJe.useSubscription)({
            context: (0, $dHqFW.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $gy5kI.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $aiyJe.useSubscription)({
                context: (0, $8r5Wf.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $cozmU.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $67Nku.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $aH9lN.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        (0, $cozmU.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $gy5kI.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jxKH9.getConfig)().mode === (0, $3Pobi.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6adGO.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jl5l1.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $d5b97455f4530d40$export$6898b5504b58699a;

});

parcelRegister("6VSrF", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("dHqFW")).WaitContext);

var $dHqFW = parcelRequire("dHqFW");


var $86UVJ = parcelRequire("86UVJ");


});

parcelRegister("dHqFW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eYtLL = parcelRequire("eYtLL");

const $9f93fbb489094a52$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: ()=>(0, $eYtLL.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $9f93fbb489094a52$export$9ba3fe09d15de47b;

});

parcelRegister("eYtLL", function(module, exports) {
const $ae6dc2e0431b9395$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $ae6dc2e0431b9395$export$276c7dbda7675aec;

});

parcelRegister("86UVJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dHqFW = parcelRequire("dHqFW");

const $5e7b0b64cd38d641$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $cozmU.useContext)((0, $dHqFW.WaitContext));
    const value = (0, $cozmU.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $cozmU.useRef)(new Set());
    const api = (0, $cozmU.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $cozmU.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dHqFW.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("hZz7i", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("aZNtm")).LazySuspenseContext);

var $3QYdZ = parcelRequire("3QYdZ");


var $aZNtm = parcelRequire("aZNtm");


});

parcelRegister("3QYdZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");


var $aZNtm = parcelRequire("aZNtm");

class $2ce4f1cfa8b44b57$export$256c542058532d6f extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $hBrZE.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $cozmU.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $2ce4f1cfa8b44b57$export$256c542058532d6f;

});

parcelRegister("aZNtm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8015fa1bd12f3c41$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $8015fa1bd12f3c41$export$c33990e84065970c;

});

parcelRegister("17PxK", function(module, exports) {
const $0d1e6d5848f254be$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $0d1e6d5848f254be$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$0d1e6d5848f254be$export$6aa69c1258005366]: true
    });
    return error;
};
const $0d1e6d5848f254be$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($0d1e6d5848f254be$export$6aa69c1258005366);
module.exports["createLoaderError"] = $0d1e6d5848f254be$export$c73a6a6f0bf7d425;

});

parcelRegister("6adGO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $47ce4bb11269d032$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $47ce4bb11269d032$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($47ce4bb11269d032$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $47ce4bb11269d032$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $47ce4bb11269d032$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $47ce4bb11269d032$export$d55db778a3e1446b;

});

parcelRegister("jl5l1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");

function $e1441e868bb78192$var$_extends() {
    $e1441e868bb78192$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1441e868bb78192$var$_extends.apply(this, arguments);
}
const $e1441e868bb78192$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $hBrZE.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), $e1441e868bb78192$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $e1441e868bb78192$export$ca5b8fbc835d95e4;

});

parcelRegister("67Nku", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");


var $hBrZE = parcelRequire("hBrZE");


var $aH9lN = parcelRequire("aH9lN");


var $2mjKV = parcelRequire("2mjKV");


var $bvYi1 = parcelRequire("bvYi1");

function $4759a958e17e309b$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jxKH9.getConfig)();
    const assets = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $2mjKV.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $4759a958e17e309b$var$fakePromise = {
    then: ()=>$4759a958e17e309b$var$fakePromise,
    catch: ()=>$4759a958e17e309b$var$fakePromise,
    finally: ()=>$4759a958e17e309b$var$fakePromise
};
function $4759a958e17e309b$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $2mjKV.insertLinkTag)(href, rel));
        return $4759a958e17e309b$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $4759a958e17e309b$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $eYtLL.noopCleanup;
}
function $4759a958e17e309b$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $hBrZE.isNodeEnvironment)()) return 0, $eYtLL.noopCleanup;
    (_GlobalReactLooselyLa = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $aH9lN.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $4759a958e17e309b$export$3af04dbcb01bad4d,
        $4759a958e17e309b$export$1046fd6a49d5e7a,
        $4759a958e17e309b$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $eYtLL.noopCleanup;
}
module.exports["preloadAsset"] = $4759a958e17e309b$export$25bad4aa00c45355;

});

parcelRegister("2mjKV", function(module, exports) {

var $bvYi1 = parcelRequire("bvYi1");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");

function $1b7cf5f1f73f5f76$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $eYtLL.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jxKH9.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $1b7cf5f1f73f5f76$export$6610512821c8a4ce;

});

parcelRegister("bvYi1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $86215b3df1759e88$export$e2d53c0cbedd2710 = {
    current: null
};
const $86215b3df1759e88$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $cozmU.createContext)($86215b3df1759e88$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $86215b3df1759e88$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $86215b3df1759e88$export$8146ab57a3f7a7cb;

});

parcelRegister("aiyJe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $77f6862aa953f5ea$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $77f6862aa953f5ea$export$368b4214baeb914c;

});

parcelRegister("lJ3sU", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $hBrZE = parcelRequire("hBrZE");


var $17PxK = parcelRequire("17PxK");

function $fd107d191750b962$var$load(moduleId, loader) {
    try {
        return (0, $hBrZE.getExport)(loader());
    } catch (err) {
        throw (0, $17PxK.createLoaderError)(err);
    }
}
function $fd107d191750b962$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $fd107d191750b962$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $jxKH9.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $gy5kI.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("link", {
                key: url,
                rel: defer === (0, $gy5kI.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $fd107d191750b962$export$eb2e4b04351cdd9e;

});

parcelRegister("ajpr4", function(module, exports) {
const $781f68b739b0ef47$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $781f68b739b0ef47$export$e673efccd97e4223;

});

parcelRegister("edTIv", function(module, exports) {
const $a5ad7fc44a458961$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $a5ad7fc44a458961$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $a5ad7fc44a458961$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $a5ad7fc44a458961$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $a5ad7fc44a458961$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $a5ad7fc44a458961$var$calculateDelay(context, policy);
        if (delay) await $a5ad7fc44a458961$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $a5ad7fc44a458961$export$9369b12211e1fce4;

});

parcelRegister("kLzei", function(module, exports) {
/* getSmartCardRenderers.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $3ricL = parcelRequire("3ricL");


var $4hCFw = parcelRequire("4hCFw");


var $di8q4 = parcelRequire("di8q4");


var $9wGTI = parcelRequire("9wGTI");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $1431e51c33a3f61c$var$emojiWrapperStyles = null;
const $1431e51c33a3f61c$var$SmartCardEmojiWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _3iDTPbvbI6 _37wbyuDIqT _4ouGXIey7F"
        ])
    }, children); // Custom render wrapper for AISnippet providing session data
const $1431e51c33a3f61c$var$AISnippetRenderer = (props)=>{
    const { displayName: displayName, userId: userId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    if (!isAdminHubAIEnabled || !isAIFeatureEnabled || !(0, $6mKj3.expVal)('confluence-ai-linking-ai-snippets', 'should_render_ai_snippet', false)) return props.fallbackComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hCFw.AISnippetWithRelayEnvironment), {
        ...props,
        userId: userId ?? undefined,
        displayName: displayName ?? undefined
    });
};
const $1431e51c33a3f61c$export$61bc672a900b57f = (0, $dOBRD.default)(()=>({
        renderers: {
            emoji: (emojiId, _parentComponent = 'SmartCard', contentType = 'page')=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                        value: sessionData
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                        emoji: emojiId,
                        height: 16,
                        context: "smartCard",
                        wrapper: $1431e51c33a3f61c$var$SmartCardEmojiWrapper,
                        contentType: contentType
                    }))),
            snippet: (0, $9wGTI.fg)('cc-ai-snippet-renderer-gate') ? $1431e51c33a3f61c$var$AISnippetRenderer : undefined
        }
    }));
module.exports["getSmartCardRenderers"] = $1431e51c33a3f61c$export$61bc672a900b57f;

});

parcelRegister("4hCFw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $7akNQ = parcelRequire("7akNQ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $29vMs = parcelRequire("29vMs");

var $cXLoX = parcelRequire("cXLoX");


var $5JhlM = parcelRequire("5JhlM");

var $bBIvl = parcelRequire("bBIvl");


var $d5gEx = parcelRequire("d5gEx");


var $gZFfs = parcelRequire("gZFfs");


var $i8aB6 = parcelRequire("i8aB6");


var $a7t2v = parcelRequire("a7t2v");


var $lgull = parcelRequire("lgull");


var $iTtzC = parcelRequire("iTtzC");

const $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $2795fb4dc781be1d$var$DEFAULT_MAX_LINES = 4;
const $2795fb4dc781be1d$var$styles = {
    container: "_2sNsIg7NXe"
};
const $2795fb4dc781be1d$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $2795fb4dc781be1d$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    }); /**
     * Main AI Snippet component. Fetches the AI snippet data from the server and displays it.
     * If the snippet data type is not supported, it will display the fallback component.
     * If the AI snippet data is not found or another error occurs it will display the AISnippet component,
     * but with the fallback text in place of the response text.
     *
     * @param contentId - The content ID of the AI snippet
     * @param contentType - The content type of the AI snippet
     * @param cloudId - The cloud ID of the AI snippet
     * @param fallbackText - The text to display if the AI snippet fails to load
     * @param fallbackComponent - The component to display if the AI snippet is not supported
     * @param source [optional] - The source for where the AI snippet was triggered from defaults to 'smartlink'
     * @param onLoadComplete [optional] - The callback function that executes when loading has completed
     * @returns
     */ 
const $2795fb4dc781be1d$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $29vMs.AIEventsInstrumentationProvider), {
        config: $2795fb4dc781be1d$var$getAnalyticsConfig(props)
    }, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$ac90160f7ae1e32f, props));
};
const $2795fb4dc781be1d$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $2795fb4dc781be1d$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $iTtzC.default));
    const isLoadingRef = (0, $cozmU.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cXLoX.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $i8aB6.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $2795fb4dc781be1d$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $iDrrr.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $cozmU.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        }; // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($2795fb4dc781be1d$var$styles.container)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null)
    }, queryRef ? /*#__PURE__*/ $cozmU.createElement((0, $lgull.AISnippetLoader), {
        queryRef: queryRef,
        fallbackText: fallbackText,
        contentId: contentId,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        showFooter: showFooter,
        showAwareness: showAwareness
    }) : /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null))));
    return /*#__PURE__*/ $cozmU.createElement((0, $7akNQ.FlagsProvider), null, isEnabledForJira ? content : /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID,
        userId: userId,
        displayName: displayName
    }, content));
};
const $2795fb4dc781be1d$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $d5gEx.RelayEnvironmentProvider), null, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$1b2af18ca4bb327b, props));
};
module.exports["AISnippetWithRelayEnvironment"] = $2795fb4dc781be1d$export$c9a07cebec67e951;

});

parcelRegister("5JhlM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $2eafd2f31cb677aa$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2eafd2f31cb677aa$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2eafd2f31cb677aa$export$f906c21bacdb2d8e.Provider, {
        value: contextValue
    }, children);
};
const $2eafd2f31cb677aa$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $cozmU.useContext)($2eafd2f31cb677aa$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $2eafd2f31cb677aa$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $2eafd2f31cb677aa$export$ff3deb4415ee32e3;

});

parcelRegister("bBIvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $7m1U4 = parcelRequire("7m1U4");

const $b089d8c6b56c64f6$var$styles = (0, $buxP3.xcss)({
    color: 'color.text.subtle'
});
const $b089d8c6b56c64f6$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $b089d8c6b56c64f6$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300', titleMessage: titleMessage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = titleMessage ?? $b089d8c6b56c64f6$var$i18n.generatingSummaryText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: padding,
        xcss: $b089d8c6b56c64f6$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($b089d8c6b56c64f6$var$i18n.generatingSummaryAnimationAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title)));
};
module.exports["AIStreamLoading"] = $b089d8c6b56c64f6$export$47a62cbf3ee79fef;

});

parcelRegister("7m1U4", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $cozmU = parcelRequire("cozmU");

const $c344a4b7f3959518$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
module.exports["GeneratingStreamAnimation"] = $c344a4b7f3959518$export$3709887a1be0e305;

});

parcelRegister("i8aB6", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $cozmU = parcelRequire("cozmU");


var $34VCg = parcelRequire("34VCg");

const $89c606f0d1f4dfb4$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $cozmU.useRef)(new (0, $34VCg.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $cozmU.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $cozmU.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $cozmU.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $89c606f0d1f4dfb4$export$fade2d05a6320d49;

});

parcelRegister("a7t2v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $cXtTj = parcelRequire("cXtTj");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $cXLoX = parcelRequire("cXLoX");


var $cAiYt = parcelRequire("cAiYt");

var $aIn0d = parcelRequire("aIn0d");

var $cHkK6 = parcelRequire("cHkK6");


var $5GgqH = parcelRequire("5GgqH");

const $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $24521ba341a214c8$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $24521ba341a214c8$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cXLoX.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $cozmU.useRef)(text);
    const isExperimentEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const isFeedbackEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-feedback', 'isEnabled', false);
    const handleLikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $cozmU.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        ref: ref
    }, showAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cAiYt.AIAwareness), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        maxLines: maxLines
    }, renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
        options: {
            disableParsingRawHTML: true
        }
    }, $24521ba341a214c8$var$sanitizeMarkdown(text || '')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), null, text || '') : text || ''), showFooter && text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIn0d.AIDisclaimer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cHkK6.AIFeedbackComponent), {
        contentId: contentId,
        onLikeClicked: isFeedbackEnabled ? handleLikeClicked : undefined,
        onDislikeClicked: isFeedbackEnabled ? handleDislikeClicked : undefined
    })));
};
module.exports["AISnippetContent"] = $24521ba341a214c8$export$3cf37822a11d3ff3;

});

parcelRegister("cAiYt", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $bltJZ = parcelRequire("bltJZ");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $1kxSE = parcelRequire("1kxSE");

const $b6dbb4b671decd4a$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $b6dbb4b671decd4a$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $1kxSE.i18n).rovoAwarenessMessage,
        define: (0, $1kxSE.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b6dbb4b671decd4a$var$styles.text)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
        size: "xxsmall",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage(message))));
};
module.exports["AIAwareness"] = $b6dbb4b671decd4a$export$fde99ed387d90f1;

});

parcelRegister("1kxSE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c8fb6889a2026e6c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $c8fb6889a2026e6c$export$a7357cdd1f0b0168;

});

parcelRegister("aIn0d", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $10I6z = parcelRequire("10I6z");

const $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $5f85a79aee555eb3$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $5f85a79aee555eb3$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disclaimerContent = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $10I6z.i18n).disclaimerMessage));
    if (withLink) return /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick
    }, disclaimerContent);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5f85a79aee555eb3$var$styles.text)
    }, disclaimerContent);
};
module.exports["AIDisclaimer"] = $5f85a79aee555eb3$export$e0542ba0c737fe5c;

});

parcelRegister("10I6z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1ae8fb340800d3e1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $1ae8fb340800d3e1$export$a7357cdd1f0b0168;

});

parcelRegister("cHkK6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $91uAX = parcelRequire("91uAX");


var $4MnFz = parcelRequire("4MnFz");


var $chu6R = parcelRequire("chu6R");


var $i1t43 = parcelRequire("i1t43");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $5JhlM = parcelRequire("5JhlM");


var $gecH2 = parcelRequire("gecH2");

const $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $2e66c8b5b2928379$var$i18n = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $2e66c8b5b2928379$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.privacyPolicyLink));
const $2e66c8b5b2928379$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.researchGroupLink));
const $2e66c8b5b2928379$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2e66c8b5b2928379$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$PrivacyPolicyLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $2e66c8b5b2928379$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $iDrrr.fg)('product-terminology-refresh') ? $2e66c8b5b2928379$var$i18n.improveAtlassianTextAppify : $2e66c8b5b2928379$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$ResearchGroupLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $2e66c8b5b2928379$var$DislikeIconWrapperXCSS = (0, $buxP3.xcss)({
    transform: 'rotate(180deg)'
});
const $2e66c8b5b2928379$var$ButtonWrapperXCSS = (0, $buxP3.xcss)({
    height: '24px',
    width: '24px'
});
const $2e66c8b5b2928379$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $cozmU.useState)(false);
    const feedbackCollectorProperties = (0, $5JhlM.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $cozmU.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($2e66c8b5b2928379$var$i18n.flagTitle),
            description: formatMessage($2e66c8b5b2928379$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: handleLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $2e66c8b5b2928379$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: handleDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91uAX.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage($2e66c8b5b2928379$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$EnrolLabel, null)
    })));
};
module.exports["AIFeedbackComponent"] = $2e66c8b5b2928379$export$f9f34317e5bc3551;

});

parcelRegister("gecH2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c8bBH = parcelRequire("c8bBH");

const $62e24cf344a5b8b1$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $62e24cf344a5b8b1$export$ec2ba0e929740f73;

});

parcelRegister("5GgqH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $44sV7 = parcelRequire("44sV7");

const $518681ac338b53b3$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $44sV7.useOnScreen)(ref);
    const dwellTimeRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $518681ac338b53b3$export$15dda63faa44a0df;

});

parcelRegister("44sV7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb;

});

parcelRegister("lgull", function(module, exports) {

var $iTtzC = parcelRequire("iTtzC");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $5JhlM = parcelRequire("5JhlM");


var $a7t2v = parcelRequire("a7t2v");

const $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $a1264e7348edcdb0$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $6SsN4.usePreloadedQuery)((0, $iTtzC.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $iDrrr.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name
    }, content);
    return content;
};
module.exports["AISnippetLoader"] = $a1264e7348edcdb0$export$f50b64530422ea99;

});

parcelRegister("iTtzC", function(module, exports) {
/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $34c51f4beec18331$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$34c51f4beec18331$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $34c51f4beec18331$export$2e2bcd8739ae039 = $34c51f4beec18331$var$node;
module.exports["default"] = $34c51f4beec18331$export$2e2bcd8739ae039;

});

parcelRegister("fNzRA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $en1dX = parcelRequire("en1dX");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $bQm3c = parcelRequire("bQm3c");

var $7b4a2f6cc35c72e1$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    // The footer comments section
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    // The sticky draft that persists outside of the footer
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $7b4a2f6cc35c72e1$export$8a175172a11240d4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    expandCommentContainer: ()=>{},
    closeCommentContainer: ()=>{},
    setWrapperWidth: ()=>{},
    setIsObjectCommentWrapperVisible: ()=>{},
    setFooterEditorEntry: ()=>{}
});
$7b4a2f6cc35c72e1$export$8a175172a11240d4.displayName = 'ObjectCommentDispatchContext';
const $7b4a2f6cc35c72e1$export$358734f355c08965 = /*#__PURE__*/ (0, $cozmU.createContext)({
    expanded: false,
    footerEditorEntry: undefined,
    width: undefined,
    isObjectCommentWrapperVisible: false
});
$7b4a2f6cc35c72e1$export$358734f355c08965.displayName = 'ObjectCommentContext';
const $7b4a2f6cc35c72e1$export$d248a0e4aca56201 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { children: children } = t0;
    const [expanded, setExpanded] = (0, $cozmU.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $cozmU.useState)(undefined);
    const [width, setWidth] = (0, $cozmU.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $cozmU.useState)(false);
    const { edition: edition, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isGuest = accessStatus === "EXTERNAL_COLLABORATOR_ACCESS";
    let t1;
    if ($[0] !== expanded || $[1] !== footerEditorEntry || $[2] !== isObjectCommentWrapperVisible || $[3] !== width) {
        t1 = {
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        };
        $[0] = expanded;
        $[1] = footerEditorEntry;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    const providerValue = t1;
    let t2;
    if ($[5] !== edition || $[6] !== isGuest) {
        t2 = (props)=>{
            const { entryPoint: entryPoint } = props ?? {};
            if (entryPoint) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    editor: "FABRIC",
                    isSingleExperience: true,
                    edition: edition,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    entryPoint: entryPoint,
                    isGuest: isGuest
                }
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            setExpanded(true);
        };
        $[5] = edition;
        $[6] = isGuest;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setFooterEditorEntry(undefined);
            setExpanded(false);
        };
        t4 = (width_0)=>{
            setWidth(width_0 ? `${width_0}px` : "100%");
        };
        t5 = (visible)=>{
            setIsObjectCommentWrapperVisible(visible);
        };
        t6 = (footerEditorEntry_0)=>{
            setFooterEditorEntry(footerEditorEntry_0);
        };
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else {
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
        t6 = $[11];
    }
    let t7;
    if ($[12] !== t2) {
        t7 = {
            expandCommentContainer: t2,
            closeCommentContainer: t3,
            setWrapperWidth: t4,
            setIsObjectCommentWrapperVisible: t5,
            setFooterEditorEntry: t6
        };
        $[12] = t2;
        $[13] = t7;
    } else t7 = $[13];
    const dispatchProviderValue = t7;
    let t8;
    if ($[14] !== children || $[15] !== dispatchProviderValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
            value: dispatchProviderValue
        }, children);
        $[14] = children;
        $[15] = dispatchProviderValue;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== providerValue || $[18] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
            value: providerValue
        }, t8);
        $[17] = providerValue;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : ({ children: children })=>{
    const [expanded, setExpanded] = (0, $cozmU.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $cozmU.useState)(undefined);
    const [width, setWidth] = (0, $cozmU.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $cozmU.useState)(false);
    const { edition: edition, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isGuest = accessStatus === 'EXTERNAL_COLLABORATOR_ACCESS';
    const providerValue = (0, $cozmU.useMemo)(()=>({
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        }), [
        expanded,
        footerEditorEntry,
        width,
        isObjectCommentWrapperVisible
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            expandCommentContainer: (props)=>{
                const { entryPoint: entryPoint } = props ?? {};
                if (entryPoint) (0, $8Ss4E.startEditorExperiences)({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    attributes: {
                        editor: 'FABRIC',
                        isSingleExperience: true,
                        edition: edition,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        entryPoint: entryPoint,
                        isGuest: isGuest
                    }
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                setExpanded(true);
            },
            closeCommentContainer: ()=>{
                setFooterEditorEntry(undefined);
                setExpanded(false);
            },
            setWrapperWidth: (width_0)=>{
                setWidth(width_0 ? `${width_0}px` : '100%');
            },
            setIsObjectCommentWrapperVisible: (visible)=>{
                setIsObjectCommentWrapperVisible(visible);
            },
            setFooterEditorEntry: (footerEditorEntry_0)=>{
                setFooterEditorEntry(footerEditorEntry_0);
            }
        }), [
        setExpanded,
        setFooterEditorEntry,
        setWidth,
        setIsObjectCommentWrapperVisible,
        edition,
        isGuest
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $7b4a2f6cc35c72e1$export$da430766ddf17a6b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
} : ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
};
const $7b4a2f6cc35c72e1$export$8ba3235fe153fa01 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
} : ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
};
module.exports["AddFooterCommentMode"] = $7b4a2f6cc35c72e1$export$94f8d08c2312472b;
module.exports["ObjectCommentProvider"] = $7b4a2f6cc35c72e1$export$d248a0e4aca56201;
module.exports["useObjectCommentContext"] = $7b4a2f6cc35c72e1$export$da430766ddf17a6b;
module.exports["useObjectCommentDispatchContext"] = $7b4a2f6cc35c72e1$export$8ba3235fe153fa01;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("9fywD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $43aed8c383cce8da$var$i18n = (0, $kSwu1.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("4IoVL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $204vt = parcelRequire("204vt");


var $hfrng = parcelRequire("hfrng");


var $3kI72 = parcelRequire("3kI72");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $2TuWI = parcelRequire("2TuWI");


var $cga1x = parcelRequire("cga1x");


var $kzNtP = parcelRequire("kzNtP");


var $c4QoG = parcelRequire("c4QoG");


var $I0A3i = parcelRequire("I0A3i");


var $kQiXs = parcelRequire("kQiXs");

const $17b0f8a5b73de479$var$DEFAULT_CONFIG = {
    clientId: '',
    fileStoreUrl: ''
};
const $17b0f8a5b73de479$var$cachedGetDownloadData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, contentAri: contentAri, contentProduct: contentProduct, isExternalShare: isExternalShare, shareToken: shareToken })=>{
    if ((0, $3kI72.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    })) return (0, $3kI72.fetchTokenForSourceProduct)({
        contentAri: contentAri ?? contentId,
        contentId: contentId,
        sourceProduct: contentProduct
    });
    if (isExternalShare && shareToken && (0, $6mKj3.expValEquals)('add_anonid_in_media_token', 'cohort', 'test')) {
        const tokenResponse = await (0, $I0A3i.fetchExternalContentMediaSessionToken)(shareToken);
        const tokenData = tokenResponse?.data;
        return {
            token: tokenData?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value || '',
            config: tokenData?.externalContentMediaSession?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
        };
    }
    // Fallback to existing logic for backward compatibility
    const response = await (isExternalShare ? (0, $I0A3i.fetchExternalShareMediaToken) : (0, $I0A3i.fetchMediaToken))(contentId);
    const data = response?.data;
    const externalData = data?.['singleContent'];
    const content = isExternalShare ? externalData : data?.['content']?.nodes?.[0];
    return {
        token: content?.body?.atlas_doc_format?.mediaToken?.token || '',
        config: data?.mediaConfiguration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$export$6176af039388fdbf = (dataGetter)=>async ()=>{
        const data = await dataGetter();
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$da46cefd33160c4d = (viewDataGetter, uploadDataGetter)=>async (params)=>{
        // Currently, supplying upload token only for file and collection update action.
        // If no params are provided, the view token is returned.
        const isUpdateAction = !!params?.access?.find(({ type: type, actions: actions })=>(type === 'file' || type == 'collection') && actions.includes('update'));
        const data = await (isUpdateAction ? uploadDataGetter() : viewDataGetter());
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$6cb774192b5cd093 = (contextId)=>{
    try {
        const { snippetId: snippetId, scope: scope } = JSON.parse(contextId);
        return snippetId ? {
            snippetId: snippetId,
            scope: scope
        } : undefined;
    } catch  {} // not JSON or not a SnippetContextId.
};
const $17b0f8a5b73de479$export$724cb324eb7535cd = async (contextId, contentProduct, contentAri)=>{
    if ((0, $3kI72.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    })) {
        const auth = await (0, $3kI72.fetchTokenForSourceProduct)({
            contentAri: contentAri ?? contextId,
            contentId: contextId,
            sourceProduct: contentProduct
        });
        return {
            clientId: auth.config.clientId || '',
            token: auth.token || '',
            baseUrl: auth.config.fileStoreUrl || ''
        };
    }
    if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
        const snippetContext = $17b0f8a5b73de479$export$6cb774192b5cd093(contextId);
        if (snippetContext && snippetContext.scope !== (0, $cga1x.SnippetScope).GLOBAL) {
            const auth = await (0, $2TuWI.fetchSnippetMediaToken)(snippetContext.snippetId);
            return {
                clientId: auth.clientId,
                token: auth.token,
                baseUrl: auth.baseUrl
            };
        }
    }
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = (0, $c4QoG.getTemplateMediaContextValues)(contextId);
    // template media informtion is stored slightly different in the context
    // to be able to discern which call to make
    if (collectionId || templateId) return (0, $c4QoG.getTemplateMediaAuth)({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
    const response = await (0, $I0A3i.fetchMediaToken)(contextId);
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.mediaConfiguration || {};
    return {
        clientId: clientId,
        token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
        baseUrl: fileStoreUrl || ''
    };
};
const $17b0f8a5b73de479$var$cachedGetUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = options.contentType === 'comment' && options.cloudId ? await (0, $I0A3i.getCommentUploadToken)(options.contentId, options.cloudId) : await (0, $I0A3i.getUploadToken)(options.contentId);
    const session = response?.data?.contentMediaSession;
    return {
        token: session?.token?.value || '',
        config: session?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG,
        collectionId: session?.collection || ''
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getUploadCollectionId = async (options)=>{
    const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
    return uploadData.collectionId;
};
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter = (options)=>()=>$17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
const $17b0f8a5b73de479$var$getUploadMediaClientConfig = async (options)=>({
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    });
const $17b0f8a5b73de479$var$createRenameFile = (mediaClientConfig, getCollection)=>{
    const mediaClient = new (0, $204vt.MediaClient)(mediaClientConfig);
    return async (fileId, name)=>{
        const collection = getCollection();
        if (!collection) throw new Error('Cannot rename media file without a collection');
        await mediaClient.mediaStore.request('/files/rename', {
            method: 'PUT',
            endpoint: '/files/rename',
            authContext: {
                collectionName: collection
            },
            params: {
                collection: collection
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                collection: collection,
                files: [
                    {
                        fileId: fileId,
                        fileName: name,
                        oldFileName: ''
                    }
                ]
            })
        });
    };
};
const $17b0f8a5b73de479$var$cachedGetExportDspData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, spaceKey: spaceKey })=>{
    const response = await (0, $I0A3i.getIsExportEnabledForContent)(contentId, spaceKey);
    const isExportAllowed = response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    return {
        isExportAllowed: isExportAllowed,
        exp: Date.now() + 60000
    };
}, (json)=>json.exp);
const $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy = async (options)=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const { contentId: contentId, spaceKey: spaceKey, mediaDspContentId: mediaDspContentId } = options;
    if (!(0, $9wGTI.fg)('dlp_allow_content_dsp_check_without_space_details')) {
        // Note: If you can't provide spaceKey, you can't enable downloads in media viewer
        if (!spaceKey) return true;
    }
    try {
        const relevantContentId = mediaDspContentId || contentId;
        const response = await $17b0f8a5b73de479$var$cachedGetExportDspData.getValue({
            contentId: relevantContentId,
            spaceKey: spaceKey
        });
        const isExportAllowed = response?.isExportAllowed;
        return !isExportAllowed;
    } catch  {
        // Fails CLOSED
        return true;
    }
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetter = (options)=>async ()=>{
        // Only pass contentId, isExternalShare, and shareToken to the cacheWithExp function
        // to avoid unnecessary re-fetching of the token if other options differ
        const authQueryOptions = {
            contentId: options.contentId,
            contentAri: options.contentAri,
            contentProduct: options.contentProduct,
            isExternalShare: options.isExternalShare,
            shareToken: options.shareToken
        };
        let data = await $17b0f8a5b73de479$var$cachedGetDownloadData.getValue(authQueryOptions);
        if (options.mediaToken) data = {
            ...data,
            token: options.mediaToken
        };
        // For drafts mediaToken by default is null and created once any media added to them
        // So, once publishing draft that just got media but token was cached before as `null`
        // we need to re-fetch the token without the cache
        if (!data.token) data = await $17b0f8a5b73de479$var$cachedGetDownloadData.forceGetValue(authQueryOptions);
        return data;
    };
const $17b0f8a5b73de479$export$9891be2d4fea1436 = async (options)=>{
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    };
};
const $17b0f8a5b73de479$export$e43b4f8676d4deae = async (options)=>({
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    });
const $17b0f8a5b73de479$export$39c5d94533971b79 = async (options)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$9891be2d4fea1436(options)
    });
const $17b0f8a5b73de479$export$4887a1cde0f552dc = async (options)=>{
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(options);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$9891be2d4fea1436(options),
        $17b0f8a5b73de479$var$getUploadMediaClientConfig(options),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$e43b4f8676d4deae(options) : undefined,
        $17b0f8a5b73de479$var$getUploadCollectionId(options)
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig,
        ...(0, $6mKj3.expValEquals)('platform_editor_media_file_rename_on_fallback', 'isEnabled', true) ? {
            renameFile: $17b0f8a5b73de479$var$createRenameFile(uploadMediaClientConfig, ()=>collection)
        } : {}
    };
};
const $17b0f8a5b73de479$export$c64cc28e06e9eda = (pathname)=>{
    return !!(0, $1NBp8.PDF_EXPORT_PAGE).match(pathname);
};
let $17b0f8a5b73de479$var$previousAttachUploadedMediaListener;
const $17b0f8a5b73de479$var$registerGlobalFileAddedListener = (options)=>{
    if ($17b0f8a5b73de479$var$previousAttachUploadedMediaListener) (0, $hfrng.globalMediaEventEmitter).off('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
    $17b0f8a5b73de479$var$previousAttachUploadedMediaListener = (0, $kQiXs.attachUploadedMedia)(options);
    (0, $hfrng.globalMediaEventEmitter).on('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$export$af68076132bb2083 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$de798661504725b9 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$221251ab27f63f41 = async (getOptions)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$af68076132bb2083(getOptions)
    });
const $17b0f8a5b73de479$export$e6a9b44aa174a3d4 = async (getOptions)=>{
    const initialOptions = getOptions();
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(initialOptions);
    // Register the global file-added listener dynamically so that SPA navigations always
    // register the attachment callback against the current page's contentId.
    const registerDynamicFileAddedListener = ()=>{
        $17b0f8a5b73de479$var$registerGlobalFileAddedListener(getOptions());
    };
    // Track the last contentId we fetched upload data for, and the cached result.
    // This lets us detect a contentId change and eagerly re-fetch before any upload.
    let lastFetchedContentId = initialOptions.contentId;
    let latestUploadData;
    // Deduplicate concurrent calls to refreshUploadDataIfNeeded — if a refresh is already
    // in-flight (e.g. from useMediaOptions and authProvider both calling simultaneously),
    // subsequent callers share the same promise rather than racing to write latestUploadData.
    let inFlightRefresh;
    // Refresh upload data for the current options if contentId has changed since the
    // last fetch. Concurrent calls are deduplicated via inFlightRefresh.
    // Called by useMediaOptions on navigation so all uploadParams.collection read sites
    // get the correct collection without needing to do anything special themselves.
    const refreshUploadDataIfNeeded = async ()=>{
        const currentOptions = getOptions();
        if (currentOptions.contentId !== lastFetchedContentId) {
            if (inFlightRefresh) return inFlightRefresh;
            inFlightRefresh = (async ()=>{
                registerDynamicFileAddedListener();
                latestUploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
                lastFetchedContentId = currentOptions.contentId;
                inFlightRefresh = undefined;
            })();
            return inFlightRefresh;
        }
    };
    // Build a fully-dynamic uploadMediaClientConfig whose authProvider always fetches
    // upload data for the CURRENT options so tokens stay correct across SPA navigations.
    // Note: we do NOT call registerDynamicFileAddedListener here — the listener is only
    // re-registered in refreshUploadDataIfNeeded (on actual navigation), not on every
    // token fetch, to avoid unnecessary teardown/rebuild of the module-level singleton.
    const dynamicUploadMediaClientConfig = {
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf(async ()=>{
            const currentOptions = getOptions();
            const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
            latestUploadData = uploadData;
            lastFetchedContentId = currentOptions.contentId;
            return uploadData;
        }),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    };
    // Fetch all async dependencies in parallel — no waterfall.
    const [viewMediaClientConfig, viewAndUploadMediaClientConfig, initialUploadData] = await Promise.all([
        $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
        $17b0f8a5b73de479$var$cachedGetUploadData.getValue(getOptions())
    ]);
    latestUploadData = initialUploadData;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        // uploadParams is resolved via a getter so SPA navigations don't leave the collection
        // frozen to the page that was active when this provider was first created.
        get uploadParams () {
            return {
                collection: latestUploadData.collectionId,
                onUploadRejection: getOptions().onUploadRejection
            };
        },
        refreshUploadDataIfNeeded: refreshUploadDataIfNeeded,
        uploadMediaClientConfig: dynamicUploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig,
        ...(0, $6mKj3.expValEquals)('platform_editor_media_file_rename_on_fallback', 'isEnabled', true) ? {
            renameFile: $17b0f8a5b73de479$var$createRenameFile(dynamicUploadMediaClientConfig, ()=>latestUploadData.collectionId)
        } : {}
    };
}; /**
 * Usage sketch (React):
 * const liveOptionsRef = useRef(currentOptions);
 * liveOptionsRef.current = currentOptions; // update on changes
 * const providerPromise = useMemo(() => createEditorMediaProviderDynamic(() => liveOptionsRef.current), []);
 * editorApi.media.actions.setProvider(providerPromise);
 */ 
module.exports["createAuthProvider"] = $17b0f8a5b73de479$export$6176af039388fdbf;
module.exports["getAuthFromContext"] = $17b0f8a5b73de479$export$724cb324eb7535cd;
module.exports["getViewMediaClientConfig"] = $17b0f8a5b73de479$export$9891be2d4fea1436;
module.exports["createRendererMediaProvider"] = $17b0f8a5b73de479$export$39c5d94533971b79;
module.exports["createEditorMediaProvider"] = $17b0f8a5b73de479$export$4887a1cde0f552dc;
module.exports["controlDataExportOnCertainFeatures"] = $17b0f8a5b73de479$export$c64cc28e06e9eda;
module.exports["createRendererMediaProviderDynamic"] = $17b0f8a5b73de479$export$221251ab27f63f41;
module.exports["createEditorMediaProviderDynamic"] = $17b0f8a5b73de479$export$e6a9b44aa174a3d4;

});

parcelRegister("3kI72", function(module, exports) {

var $oWJUu = parcelRequire("oWJUu");


var $55mlV = parcelRequire("55mlV");

const $515968ab7e772985$export$8953ee4427cc19a2 = ({ hostProduct: hostProduct, sourceProduct: sourceProduct })=>{
    return !!sourceProduct && sourceProduct !== hostProduct;
};
const $515968ab7e772985$export$9f88fc74c33fbfe = ({ contentAri: contentAri, contentId: contentId, sourceProduct: sourceProduct })=>{
    switch(sourceProduct){
        case 'confluence-page':
            return (0, $oWJUu.fetchMediaToken)(contentId);
        case 'jira-work-item':
            return (0, $55mlV.fetchJiraMediaToken)(contentAri);
        default:
            throw new Error(`Unsupported source product for token fetch: ${sourceProduct}`);
    }
};
module.exports["requiresCrossProductAuth"] = $515968ab7e772985$export$8953ee4427cc19a2;
module.exports["fetchTokenForSourceProduct"] = $515968ab7e772985$export$9f88fc74c33fbfe;

});

parcelRegister("oWJUu", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $48FpT = parcelRequire("48FpT");

const $61ef070287c5800f$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $61ef070287c5800f$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $61ef070287c5800f$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME = 'MediaUploadTokenQuery';
const $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_QUERY = `query ${$61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME}($contentId: ID!) {
	contentMediaSession(contentId: $contentId) {
		token {
			value
		}
		configuration {
			clientId
			fileStoreUrl
		}
		collection
	}
}`;
const $61ef070287c5800f$var$getContentMediaSession = async (contentId)=>{
    const bodyData = {
        query: $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_QUERY,
        operationName: $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME,
        variables: {
            contentId: contentId
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($61ef070287c5800f$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$61ef070287c5800f$var$COMMON_HEADERS,
            ...$61ef070287c5800f$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get content media session: ${response.statusText}`);
    const result = await response.json();
    return result;
};
const $61ef070287c5800f$export$2b7fb70f168591f8 = async (contentId)=>{
    try {
        const response = await $61ef070287c5800f$var$getContentMediaSession(contentId);
        const contentData = response.data?.contentMediaSession;
        const token = contentData?.token?.value;
        const configuration = contentData?.configuration;
        const collection = contentData?.collection;
        if (!token || !configuration || !collection) throw new Error('Failed to get content media session data');
        return {
            config: configuration,
            token: token,
            collectionId: collection
        };
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-provider/fetchMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get content media session: ${errorMsg}`);
    }
};
module.exports["fetchMediaToken"] = $61ef070287c5800f$export$2b7fb70f168591f8;

});

parcelRegister("55mlV", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $48FpT = parcelRequire("48FpT");

const $05854aa166d857a3$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $05854aa166d857a3$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $05854aa166d857a3$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $05854aa166d857a3$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH = 2048;
const $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_JIRA_MEDIA_TOKEN';
const $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY = `query ${$05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME}($issueAri: ID!, $maxTokenLength: Int!) {
  jira {
    issueById(id: $issueAri) {
      mediaReadToken(maxTokenLength: $maxTokenLength) @optIn(to: "JiraMediaReadTokenInIssue") {
        clientId
        endpointUrl
        tokenLifespanInSeconds
        tokensWithFiles {
          edges {
            node {
              token
            }
          }
        }
      }
    }
  }
}`;
const $05854aa166d857a3$var$getJiraMediaReadToken = async (issueAri)=>{
    const bodyData = {
        query: $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY,
        operationName: $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME,
        variables: {
            issueAri: issueAri,
            maxTokenLength: $05854aa166d857a3$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($05854aa166d857a3$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$05854aa166d857a3$var$COMMON_HEADERS,
            ...$05854aa166d857a3$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get Jira media read token: ${response.statusText}`);
    return await response.json();
};
const $05854aa166d857a3$export$5bc7dcc953e26849 = async (issueAri)=>{
    try {
        const response = await $05854aa166d857a3$var$getJiraMediaReadToken(issueAri);
        const mediaReadToken = response.data?.jira?.issueById?.mediaReadToken;
        const clientId = mediaReadToken?.clientId;
        const endpointUrl = mediaReadToken?.endpointUrl;
        // Use the first available token from tokensWithFiles, or fall back to empty string.
        // A generic read token (without specific file IDs) is sufficient for rendering.
        const token = mediaReadToken?.tokensWithFiles?.edges?.[0]?.node?.token ?? '';
        if (!clientId || !endpointUrl) throw new Error('Missing clientId or endpointUrl');
        return {
            config: {
                clientId: clientId,
                fileStoreUrl: endpointUrl
            },
            token: token
        };
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-provider/fetchJiraMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get Jira media read token: ${errorMsg}`);
    }
};
module.exports["fetchJiraMediaToken"] = $05854aa166d857a3$export$5bc7dcc953e26849;

});

parcelRegister("2TuWI", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL = '/gateway/api/blocks/v1/snippets';
const $15f98e0699368f56$export$73c71f9590626082 = async (snippetId)=>{
    try {
        const response = await (0, $f7B1p.cfetch)(`${$15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL}/${snippetId}/media-token`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        });
        const data = await response.json();
        const collectionId = data.collectionNames?.[snippetId];
        return {
            clientId: data.config.clientId,
            token: data.token,
            baseUrl: data.config.fileStoreUrl,
            ...collectionId !== undefined && {
                collectionId: collectionId
            }
        };
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        throw error;
    }
};
module.exports["fetchSnippetMediaToken"] = $15f98e0699368f56$export$73c71f9590626082;

});

parcelRegister("cga1x", function(module, exports) {
/** Define the source of the snippets */ var $bd320fc30ef678ce$export$100829e61c5df591 = /*#__PURE__*/ function(SnippetScope) {
    SnippetScope["GLOBAL"] = "GLOBAL";
    SnippetScope["USER"] = "USER";
    SnippetScope["SITE"] = "SITE";
    return SnippetScope;
}({});
module.exports["SnippetScope"] = $bd320fc30ef678ce$export$100829e61c5df591;

});

parcelRegister("kzNtP", function(module, exports) {

var $6AroL = parcelRequire("6AroL");


var $3u5lg = parcelRequire("3u5lg");

const $852f3734fd3706d8$var$BUFFER_MS = 60000; // refresh token 60 seconds before it expires
const $852f3734fd3706d8$var$EMPTY = [
    -Infinity,
    null,
    null
];
function $852f3734fd3706d8$export$d18015d30d3c28a4(asyncFunction, tokenOrExpInMsAccessor, tokenExpBufferInMs = $852f3734fd3706d8$var$BUFFER_MS) {
    const cache = {};
    async function getValue(arg, force) {
        // It is ok to have clashing hash because we are going to check args anyway
        // Worse case is calling fn() more often than it should
        let hash = '';
        try {
            hash = JSON.stringify(arg);
        } catch  {}
        const [exp, lastArg, lastValue] = cache[hash] || $852f3734fd3706d8$var$EMPTY;
        if (force || exp <= Date.now() || !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(lastArg, arg)) {
            const value = await asyncFunction(arg);
            let tokenOrExp = null;
            try {
                tokenOrExp = tokenOrExpInMsAccessor(value);
            } catch (e) {}
            let exp = null;
            if (tokenOrExp) {
                if (!isNaN(tokenOrExp)) exp = Number(tokenOrExp);
                else if (typeof tokenOrExp === 'string') try {
                    exp = (0, $6AroL.default)(tokenOrExp).exp * 1000 - tokenExpBufferInMs;
                } catch (e) {}
            }
            cache[hash] = exp === null ? $852f3734fd3706d8$var$EMPTY : [
                exp,
                arg,
                value
            ];
            return value;
        }
        return lastValue;
    }
    return {
        forceGetValue: (arg)=>{
            return getValue(arg, true);
        },
        getValue: (arg)=>{
            return getValue(arg, false);
        }
    };
}
module.exports["cacheWithExp"] = $852f3734fd3706d8$export$d18015d30d3c28a4;

});

parcelRegister("6AroL", function(module, exports) {
function $4cbb5ba451601f11$var$e(e) {
    this.message = e;
}
$4cbb5ba451601f11$var$e.prototype = new Error, $4cbb5ba451601f11$var$e.prototype.name = "InvalidCharacterError";
var $4cbb5ba451601f11$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $4cbb5ba451601f11$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $4cbb5ba451601f11$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($4cbb5ba451601f11$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $4cbb5ba451601f11$var$r(t);
    }
}
function $4cbb5ba451601f11$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $4cbb5ba451601f11$var$o(e, r) {
    if ("string" != typeof e) throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($4cbb5ba451601f11$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$4cbb5ba451601f11$export$b9721ef022f71a68.prototype = new Error, $4cbb5ba451601f11$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $4cbb5ba451601f11$export$2e2bcd8739ae039 = $4cbb5ba451601f11$var$o;
 //# sourceMappingURL=jwt-decode.esm.js.map
module.exports["default"] = $4cbb5ba451601f11$export$2e2bcd8739ae039;

});

parcelRegister("c4QoG", function(module, exports) {

var $kzNtP = parcelRequire("kzNtP");


var $4IoVL = parcelRequire("4IoVL");


var $7EQEd = parcelRequire("7EQEd");

// blueprints/templates in uuid form are technically a new template
const $30f3da79b755ac50$var$isBlueprint = (templateId)=>!/^[0-9]+$/.test(templateId);
const $30f3da79b755ac50$var$isNewTemplate = (templateId)=>!templateId || templateId === '';
const $30f3da79b755ac50$var$shouldUseTemplateId = (templateIds)=>templateIds.length;
const $30f3da79b755ac50$var$formatTemplateId = (templateId, isFirstLoad, isUpload)=>{
    if ($30f3da79b755ac50$var$isNewTemplate(templateId) || $30f3da79b755ac50$var$isBlueprint(templateId) && isUpload || !isFirstLoad) return [];
    else return [
        templateId
    ];
};
const $30f3da79b755ac50$var$cachedGetTemplateUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateUploadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    const session = response?.data?.templateMediaSession;
    const collectionId = session?.collections?.[0]?.value || '';
    return {
        token: session?.uploadToken?.value || '',
        config: session?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        },
        collectionId: collectionId
    };
}, (json)=>json.token);
const $30f3da79b755ac50$var$cachedGetTemplateDownloadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    return {
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        config: response?.data?.templateMediaSession?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        }
    };
}, (json)=>json.token);
const $30f3da79b755ac50$export$ea5d75839efa2930 = async (editorOptions)=>{
    const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !editorOptions.collectionId, true);
    const uploadData = await $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
        ...editorOptions,
        templateIds: templateIds,
        collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : editorOptions.collectionId
    });
    return uploadData.collectionId;
};
const $30f3da79b755ac50$export$8867d7a854cea94a = (contextId)=>{
    let collectionId, templateId, spaceKey = null;
    try {
        ({ collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = JSON.parse(contextId));
    } catch (_) {}
    return {
        collectionId: collectionId,
        templateId: templateId,
        spaceKey: spaceKey
    };
};
const $30f3da79b755ac50$export$c52d46b5239d3052 = async ({ templateId: templateId, collectionId: collectionId, spaceKey: spaceKey })=>{
    // if given a templateId the source is the renderer, otherwise it's the editor
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        templateIds: templateId ? [
            templateId
        ] : [],
        collectionId: templateId ? null : collectionId,
        spaceKey: spaceKey
    });
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.templateMediaSession?.configuration || {};
    return {
        clientId: clientId,
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        baseUrl: fileStoreUrl
    };
};
const $30f3da79b755ac50$var$getAuthFromContext = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = $30f3da79b755ac50$export$8867d7a854cea94a(contextId);
    // templateID = null/undefined -> not template type
    // templateId = "" -> new template
    // templateId = "2394234324" -> user modified template
    // templateId = "23j4h-23jk4h-kj2h34-kj23h4" -> new template
    if (typeof collectionId !== 'string' && typeof templateId !== 'string') // copy source is page contentType
    return (0, $4IoVL.getAuthFromContext)(contextId);
    return $30f3da79b755ac50$export$c52d46b5239d3052({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
};
const $30f3da79b755ac50$export$e7a68a11bc740f17 = (options)=>{
    return {
        authProvider: (0, $4IoVL.createAuthProvider)(async ()=>$30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue(options)),
        getAuthFromContext: $30f3da79b755ac50$var$getAuthFromContext
    };
};
const $30f3da79b755ac50$export$4f3a63958bc8e871 = (options)=>{
    return Promise.resolve({
        viewMediaClientConfig: $30f3da79b755ac50$export$e7a68a11bc740f17(options)
    });
};
const $30f3da79b755ac50$export$582e7673a587f23a = async (options)=>{
    let isFirstDownload = true;
    let collectionId = options.collectionId;
    const getEditorViewTemplateMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(async ()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, isFirstDownload, false);
                isFirstDownload = false;
                return $30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                isFirstDownload = false;
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const getTemplateMediaUploadMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !collectionId, true);
                return $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const viewMediaClientConfig = getEditorViewTemplateMediaClientConfig(options);
    const uploadMediaClientConfig = getTemplateMediaUploadMediaClientConfig(options);
    const collection = await $30f3da79b755ac50$export$ea5d75839efa2930(options);
    collectionId = collection || null;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig
    };
};
module.exports["getTemplateUploadCollectionId"] = $30f3da79b755ac50$export$ea5d75839efa2930;
module.exports["getTemplateMediaContextValues"] = $30f3da79b755ac50$export$8867d7a854cea94a;
module.exports["getTemplateMediaAuth"] = $30f3da79b755ac50$export$c52d46b5239d3052;
module.exports["createRendererTemplateMediaProvider"] = $30f3da79b755ac50$export$4f3a63958bc8e871;
module.exports["createTemplateEditorMediaProvider"] = $30f3da79b755ac50$export$582e7673a587f23a;

});

parcelRegister("7EQEd", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $6UhpO = parcelRequire("6UhpO");


var $23pnW = parcelRequire("23pnW");


var $c0rhi = parcelRequire("c0rhi");

const $bced78bb0973f66e$export$852d9acd488f2352 = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $6UhpO.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
const $bced78bb0973f66e$export$779a7b38112a4dbb = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $23pnW.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["getTemplateDownloadToken"] = $bced78bb0973f66e$export$852d9acd488f2352;
module.exports["getTemplateUploadToken"] = $bced78bb0973f66e$export$779a7b38112a4dbb;

});

parcelRegister("6UhpO", function(module, exports) {
/**
 * @generated SignedSource<<6f71e30a6f3ff9ae17bdb70469621c47>>
 * @relayHash 7da80c4186ab379cb41cda405bebee65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1
const $ba0dcc1d393f4102$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "downloadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "7da80c4186ab379cb41cda405bebee65",
            "id": "b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1",
            "metadata": {},
            "name": "TemplateMediaSessionDownloadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionDownloadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},downloadToken{value,duration}}}"
        }
    };
}();
$ba0dcc1d393f4102$var$node.hash = "cb69ec0c674b12c3415c2289771f970f";
var $ba0dcc1d393f4102$export$2e2bcd8739ae039 = $ba0dcc1d393f4102$var$node;
module.exports["default"] = $ba0dcc1d393f4102$export$2e2bcd8739ae039;

});

parcelRegister("23pnW", function(module, exports) {
/**
 * @generated SignedSource<<d8493d612cba7ab67c2663a1ef2f2968>>
 * @relayHash f5528f55bdab5a02587ef6cd5262334d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059
const $d22835c5674bcb0e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "uploadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "f5528f55bdab5a02587ef6cd5262334d",
            "id": "7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059",
            "metadata": {},
            "name": "TemplateMediaSessionUploadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionUploadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},uploadToken{value,duration}}}"
        }
    };
}();
$d22835c5674bcb0e$var$node.hash = "1d0108dcbf48addfcc8b1c4145c7178d";
var $d22835c5674bcb0e$export$2e2bcd8739ae039 = $d22835c5674bcb0e$var$node;
module.exports["default"] = $d22835c5674bcb0e$export$2e2bcd8739ae039;

});

parcelRegister("I0A3i", function(module, exports) {

var $6IsMq = parcelRequire("6IsMq");


var $3j8TZ = parcelRequire("3j8TZ");


var $iTcHJ = parcelRequire("iTcHJ");


var $bS81H = parcelRequire("bS81H");


var $1UWNP = parcelRequire("1UWNP");


var $6AroL = parcelRequire("6AroL");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $c0rhi = parcelRequire("c0rhi");


var $lUobS = parcelRequire("lUobS");


var $62FVQ = parcelRequire("62FVQ");


var $6mmMU = parcelRequire("6mmMU");


var $egLSs = parcelRequire("egLSs");


var $dqLCu = parcelRequire("dqLCu");

const $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery = (0, $bS81H.default);
const $1fd47ba2b01e31e6$var$FetchMediaTokenQuery = (0, $iTcHJ.default);
const $1fd47ba2b01e31e6$export$96b44174d5bb0faa = (0, $3j8TZ.default);
const $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery = (0, $6IsMq.default);
let $1fd47ba2b01e31e6$var$isFirstLoad = true;
const $1fd47ba2b01e31e6$export$f3bf3f7b03608218 = (requestBody)=>{
    if (requestBody.contentType === 'comment') // Hard disable drag-and-drop upload functionality for comments
    return;
    // Normal uploads (file browser, copy-paste, etc.) go through the regular upload mutation.
    return (0, $egLSs.experimentalFileUploadMutate)({
        variables: requestBody
    });
};
const $1fd47ba2b01e31e6$export$2b7fb70f168591f8 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$FetchMediaTokenQuery,
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ],
            missingContentId: !contentId
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoad ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoad = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
let $1fd47ba2b01e31e6$var$isFirstLoadJira = true;
const $1fd47ba2b01e31e6$export$5bc7dcc953e26849 = (issueAri)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery,
        variables: {
            issueAri: issueAri,
            maxTokenLength: 65536
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoadJira ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoadJira = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
/**
 * `fetchMediaToken` is called repetitively to renew the token before it
 * expires. If an error condition arises (because of frontend or backend), the
 * same error(s) may be reported as unhandled to our analytics and monitoring at
 * a very high rate/volume. Such repetitive reporting fron one user in one tab
 * is noisy. `throttleFetchMediaTokenErrors` attempts to reduce the noise.
 */ const $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((_cacheKey)=>{
    /**
   * The errors that happened last time. The `GraphQLError` instances are big
   * and are not trivial to compare so `prevErrors` caches partial info.
   */ let prevErrors = undefined;
    return (graphQLErrors, networkError)=>{
        // Each of `graphQLErrors` and `networkError` are reported to analytics and
        // monitoring so type of `Error` does not matter to what follows and
        // `GraphQLError` is the most convenient TypeScript type to deal with.
        if (networkError) graphQLErrors = (graphQLErrors || []).concat(networkError);
        if (graphQLErrors) {
            /**
       * The new/current errors which will become `prevErrors` at the end of
       * this iteration.
       */ const nextErrors = {};
            for (const graphQLError of graphQLErrors){
                // Extract the partial, easy-to-compare, cachable info from the big
                // `GraphQLError` instance:
                const message = graphQLError.message || String(graphQLError) || graphQLError.originalError?.message || String(graphQLError.originalError);
                const { path: path } = graphQLError;
                const key = Array.isArray(path) && path.join('.') || message;
                if (key) {
                    const value = (0, $aMcHK.getStatusCode)(graphQLError) || message;
                    if (value) {
                        nextErrors[key] = value;
                        // If a similar error happened in the previous iteration, do not
                        // report it to analytics and monitoring again:
                        if (prevErrors?.[key] === value) (0, $7Sm4c.markErrorAsHandled)(graphQLError);
                    }
                }
            }
            prevErrors = nextErrors;
        } else // If `MediaDownloadTokenQuery` succeeds, report subsequent/future errors
        // even if similar ones occurred and were reported before the current
        // success - there is a meaningful change in state and it may be useful in
        // debugging.
        prevErrors = undefined;
    };
});
const $1fd47ba2b01e31e6$export$e5e77dc812ab6e52 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $lUobS.default),
        variables: {
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$db4c125247d46dd = (shareToken)=>(0, $c0rhi.queryInterop)({
        query: (0, $dqLCu.default),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$2b96f2ad626f63d2 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$de87322aceb1e609 = async (contentId)=>{
    if (!(0, $9wGTI.fg)('confluence-media-upload-token-cache')) return $1fd47ba2b01e31e6$export$2b96f2ad626f63d2(contentId);
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $62FVQ.default),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $6AroL.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4205291ac54c446e = async (contentId, cloudId)=>{
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $6mmMU.default),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $6AroL.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $6mmMU.default),
        variables: {
            cloudId: cloudId,
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4777fc7c5d601381 = (contentId, spaceKey)=>{
    const action = (0, $9wGTI.fg)('cc-dlp_split-attachment-dl-from-export-dsp') ? 'ATTACHMENT_DOWNLOAD' : 'PAGE_EXPORT';
    const variables = {
        action: action,
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1,
        ...spaceKey && {
            spaceKey: spaceKey
        }
    };
    /* Note -> a relay-compatible replacement is available in the @confluence/data-security package.
   * Using queryInterop for compatibility with Relay migration
   */ return (0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery,
        variables: variables,
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "fabric-media-support"
    });
};
module.exports["setAttachment"] = $1fd47ba2b01e31e6$export$f3bf3f7b03608218;
module.exports["fetchMediaToken"] = $1fd47ba2b01e31e6$export$2b7fb70f168591f8;
module.exports["fetchExternalShareMediaToken"] = $1fd47ba2b01e31e6$export$e5e77dc812ab6e52;
module.exports["fetchExternalContentMediaSessionToken"] = $1fd47ba2b01e31e6$export$db4c125247d46dd;
module.exports["getUploadToken"] = $1fd47ba2b01e31e6$export$de87322aceb1e609;
module.exports["getCommentUploadToken"] = $1fd47ba2b01e31e6$export$4205291ac54c446e;
module.exports["getIsExportEnabledForContent"] = $1fd47ba2b01e31e6$export$4777fc7c5d601381;

});

parcelRegister("lUobS", function(module, exports) {
/**
 * @generated SignedSource<<57e8668d9fe3c9f67ee75bb15b6e474f>>
 * @relayHash ea7172d4f00c5846ec23ab207abff057
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e
const $2624e38a54eebf0f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ea7172d4f00c5846ec23ab207abff057",
            "id": "def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e",
            "metadata": {},
            "name": "ExternalShareMediaDownloadTokenQuery",
            "operationKind": "query",
            "text": "query ExternalShareMediaDownloadTokenQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{mediaToken{token}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$2624e38a54eebf0f$var$node.hash = "3592e1b2dcd3aa2c38a177d9b363dafe";
var $2624e38a54eebf0f$export$2e2bcd8739ae039 = $2624e38a54eebf0f$var$node;
module.exports["default"] = $2624e38a54eebf0f$export$2e2bcd8739ae039;

});

parcelRegister("62FVQ", function(module, exports) {
/**
 * @generated SignedSource<<025b00e9b31b73f237130d2a69699587>>
 * @relayHash 20688ce23e5e858cfc82d72bb57f43b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c
const $15e95f80a91466f9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "20688ce23e5e858cfc82d72bb57f43b8",
            "id": "6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c",
            "metadata": {},
            "name": "MediaUploadTokenQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$15e95f80a91466f9$var$node.hash = "1f89a4aaada59e040e6317ae1cdc704c";
var $15e95f80a91466f9$export$2e2bcd8739ae039 = $15e95f80a91466f9$var$node;
module.exports["default"] = $15e95f80a91466f9$export$2e2bcd8739ae039;

});

parcelRegister("6mmMU", function(module, exports) {
/**
 * @generated SignedSource<<daf984ad5eaae28ba5768f141c1480ac>>
 * @relayHash c06482aa2ab100620d21019ae889668d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37
const $39c17bb60e74ced3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "alias": "contentMediaSession",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "confluence_commentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c06482aa2ab100620d21019ae889668d",
            "id": "6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37",
            "metadata": {},
            "name": "MediaUploadTokenQueryCommentQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQueryCommentQuery($cloudId:ID!,$contentId:ID!){contentMediaSession:confluence_commentMediaSession(cloudId:$cloudId,contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$39c17bb60e74ced3$var$node.hash = "ecbc3538cd4e4434bac2e03ab7969cd8";
var $39c17bb60e74ced3$export$2e2bcd8739ae039 = $39c17bb60e74ced3$var$node;
module.exports["default"] = $39c17bb60e74ced3$export$2e2bcd8739ae039;

});

parcelRegister("egLSs", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");

const $7fce44bdcdfe3fe8$export$1b01a64a392afa44 = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
        method: 'POST',
        body: JSON.stringify(variables),
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResult: ()=>({
                experimentalFileUpload: true
            })
    });
};
module.exports["experimentalFileUploadMutate"] = $7fce44bdcdfe3fe8$export$1b01a64a392afa44;

});

parcelRegister("dqLCu", function(module, exports) {
/**
 * @generated SignedSource<<4edd735d079b37bb48067afaa74a4066>>
 * @relayHash c64eff3bdc2352e89d29fc9d40e39f79
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255
const $b85e553ccc70de04$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shareToken"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "shareToken",
                    "variableName": "shareToken"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "externalContentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readWriteToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c64eff3bdc2352e89d29fc9d40e39f79",
            "id": "0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255",
            "metadata": {},
            "name": "ExternalContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ExternalContentMediaSessionQuery($shareToken:String!){externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl,clientId}}}"
        }
    };
}();
$b85e553ccc70de04$var$node.hash = "73d645a33a55cbb7625d57b6d5cf2a1a";
var $b85e553ccc70de04$export$2e2bcd8739ae039 = $b85e553ccc70de04$var$node;
module.exports["default"] = $b85e553ccc70de04$export$2e2bcd8739ae039;

});

parcelRegister("kQiXs", function(module, exports) {

var $I0A3i = parcelRequire("I0A3i");

const $c59debd6932d7898$var$noop = ()=>{};
const $c59debd6932d7898$export$ad897c91dfb246e9 = (options)=>{
    if (options.contentId && options.contentType) return (file)=>{
        const { id: id, name: name, size: size, mimeType: mimeType } = file;
        const { contentId: contentId, contentType: contentType } = options;
        const requestBody = {
            size: size,
            contentType: contentType,
            mimeType: mimeType,
            fileName: name,
            pageId: contentId,
            fileStoreId: id,
            minorEdit: true,
            renderEditorHTML: false,
            collectionName: `contentId-${contentId}`,
            uploadSource: 'fabric-editor'
        };
        (0, $I0A3i.setAttachment)(requestBody);
    };
    else return $c59debd6932d7898$var$noop;
};
module.exports["attachUploadedMedia"] = $c59debd6932d7898$export$ad897c91dfb246e9;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("isuYJ", function(module, exports) {

var $d5Ozc = parcelRequire("d5Ozc");

function $a1048cda8104f400$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[0, $d5Ozc.CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $a1048cda8104f400$export$691e93bad45e6f07;

});

parcelRegister("d5Ozc", function(module, exports) {
const $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] = globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] || new WeakMap();
module.exports["CACHE_MAP_KEY"] = $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.ACCESS_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("icKZN", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $76c86d96bcffdba9$export$4128d9964cdd56b5 = (event, options)=>{
    return event?.isDefaultPrevented() && (Boolean(options?.shouldCheckIframe) && $76c86d96bcffdba9$var$isIframe() || $76c86d96bcffdba9$var$isCtrlOrCommandClick(event) || $76c86d96bcffdba9$var$isMiddleClick(event));
};
const $76c86d96bcffdba9$var$isIframe = ()=>window.parent !== parent;
const $76c86d96bcffdba9$var$isMiddleClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return nativeEvent.button === 1;
};
const $76c86d96bcffdba9$var$isCtrlOrCommandClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return (0, $9wGTI.fg)('platform-smart-card-shift-key') ? nativeEvent.ctrlKey || nativeEvent.metaKey || nativeEvent.shiftKey : nativeEvent.ctrlKey || nativeEvent.metaKey;
};
module.exports["isClickEventToOpenNewTab"] = $76c86d96bcffdba9$export$4128d9964cdd56b5;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6M71K", function(module, exports) {

var $c7nnh = parcelRequire("c7nnh");


var $2TQy9 = parcelRequire("2TQy9");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $5HApy = parcelRequire("5HApy");


var $c3xon = parcelRequire("c3xon");


var $5e2GM = parcelRequire("5e2GM");


var $d5gEx = parcelRequire("d5gEx");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $9HB34 = parcelRequire("9HB34");


var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");


var $7W8i8 = parcelRequire("7W8i8");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $jr2Xf = parcelRequire("jr2Xf");


var $6JLuV = parcelRequire("6JLuV");


var $27fJD = parcelRequire("27fJD");


var $cEgMD = parcelRequire("cEgMD");


var $e4o8D = parcelRequire("e4o8D");


var $l3tKl = parcelRequire("l3tKl");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");





var $3PnE6 = parcelRequire("3PnE6");


var $cknyY = parcelRequire("cknyY");

const $3c75c8f77ed4b940$var$MaybeConditionalRelayEnvironmentProvider = ({ children: children })=>(0, $9wGTI.fg)('ccp-9584-remove-relay-environment-provider') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
        environment: (0, $9HB34.getRelayEnvironment)()
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.ConditionalRelayEnvironmentProvider), null, children);
// Only log first error to console, to prevent spamming console with resolver errors
let $3c75c8f77ed4b940$var$hasLoggedResolverError = false;
const $3c75c8f77ed4b940$var$defaultConfluenceResolveHandler = (createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)=>{
    try {
        // NOTE FOR DEVS OF RESOLVERS: The `data` object comes from linking platform's content resolver service which is an UNSTABLE API SCHEMA.
        // Ensure your resolver logic handles invalid schemas gracefully and is able to notify your team if the schema changes and your code needs to be updated.
        (0, $cknyY.liveDocSmartCardResolver)(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data);
    } catch (resolverError) {
        // prevent errors from causing smart card provider issues
        if (!$3c75c8f77ed4b940$var$hasLoggedResolverError) {
            const logger = (0, $7W8i8.getLogger)('ConfluenceSmartCardProvider');
            logger.error`resolver error: ${resolverError}`;
            $3c75c8f77ed4b940$var$hasLoggedResolverError = true;
        }
    }
};
const $3c75c8f77ed4b940$var$computeInitialStateFromCache = (smartCardClient)=>{
    if ((0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true)) // On page transition create the initial CardStore from Cache
    return !(0, $i6Ps3.isPageSSRd)() && smartCardClient instanceof (0, $3PnE6.ConfluenceSmartCardClient) ? smartCardClient.getInitialCardStoreFromCache() : null;
    else return null;
};
const $3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $2TQy9.default),
        __callerPackage__: "smart-card-provider"
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $c7nnh.default),
        fragmentSpec: (0, $c7nnh.default),
        __callerPackage__: "smart-card-provider"
    });
    const smartCardClient = (0, $cozmU.useMemo)(()=>props?.client || new (0, $3PnE6.ConfluenceSmartCardClient)({
            onResolve: (data)=>$3c75c8f77ed4b940$var$defaultConfluenceResolveHandler(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)
        }), [
        props?.client,
        createAnalyticsEvent,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    const initialStateFromCache = (0, $cozmU.useRef)($3c75c8f77ed4b940$var$computeInitialStateFromCache(smartCardClient));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { children: children, ...restProps } = props;
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const initialState = (0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? initialStateFromCache?.current ?? window['__SSR_SMARTLINKS__'] : window['__SSR_SMARTLINKS__'];
    const internalStoreOptions = (0, $btIEy.useStoreOptions)(initialState, isPageSSR);
    // Merge smartlink SSR data with any passed-in storeOptions (e.g. from shortcuts preloader)
    const presetInitialState = {
        ...internalStoreOptions,
        ...props.storeOptions ? {
            storeOptions: {
                ...(0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) === false ? internalStoreOptions.storeOptions || {} : {},
                ...props.storeOptions,
                ...internalStoreOptions.storeOptions?.initialState && (0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? {
                    initialState: {
                        ...internalStoreOptions.storeOptions.initialState,
                        ...props.storeOptions.initialState
                    }
                } : {}
            }
        } : {}
    };
    const shouldControlDataExport = (0, $dPJCf.useIsOnRoute)((0, $1NBp8.PDF_EXPORT_PAGE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), {
        product: "CONFLUENCE",
        client: smartCardClient,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        shouldControlDataExport: shouldControlDataExport,
        isPreviewPanelAvailable: restProps.isPreviewPanelAvailable,
        openPreviewPanel: restProps.openPreviewPanel,
        ...(0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? {} : presetInitialState,
        ...restProps,
        ...(0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? presetInitialState : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3tKl.HydrationSafeComponent), {
        isEnabled: (0, $6mKj3.expVal)('confluence_smartlinks_suspense', 'isEnabled', false)
    }, children));
};
const $3c75c8f77ed4b940$var$PreviewPanelSmartCardProvider = ({ children: children, ...restProps })=>{
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // Create a wrapper function that updates the preview panel URL
    // This is used for custom domains to update to the correct content URL and avoid CSP issues
    const openPreviewPanelWithModifiedURL = (0, $cozmU.useMemo)(()=>{
        if (!cloudId) return open;
        return ({ url: url, ari: ari, ...rest })=>open({
                url: (0, $5e2GM.getCorrectContentURL)(cloudId, url, ari),
                ari: ari,
                ...rest
            });
    }, [
        open,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, {
        openPreviewPanel: openPreviewPanelWithModifiedURL,
        isPreviewPanelAvailable: renderServerPlaceholder ? (_ari)=>false : (0, $27fJD.isPreviewPanelAvailable),
        ...restProps
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jr2Xf.PreviewPanelsPostMessageListener), null));
};
const $3c75c8f77ed4b940$var$ConsolidatedPreviewPanelSmartCardProvider = (props)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { children: children, doNotUsePreviewPanels: doNotUsePreviewPanels, ...restProps } = props;
    return (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || doNotUsePreviewPanels ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, restProps, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c75c8f77ed4b940$var$MaybeConditionalRelayEnvironmentProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c75c8f77ed4b940$var$PreviewPanelSmartCardProvider, restProps, children));
};
const $3c75c8f77ed4b940$export$a56ebeb3c828cd38 = (props)=>{
    let updatedProps = props;
    const useSessionDataGated = (0, $c3xon.functionUnionWithCondition)(()=>(0, $9wGTI.fg)('platform_sl_3p_auth_rovo_entitlement'), (0, $bQm3c.useSessionData), ()=>undefined);
    const sessionData = useSessionDataGated();
    updatedProps = (0, $cozmU.useMemo)(()=>({
            ...props,
            ...(!!sessionData && (0, $9wGTI.fg)('platform_sl_3p_auth_rovo_entitlement') ? {
                rovoOptions: {
                    isRovoEnabled: sessionData?.isRovoEnabled ?? false,
                    isRovoLLMEnabled: sessionData?.isRovoLLMEnabled ?? false
                }
            } : undefined) || {}
        }), [
        props,
        sessionData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c75c8f77ed4b940$var$ConsolidatedPreviewPanelSmartCardProvider, updatedProps);
};
module.exports["ConfluenceSmartCardProvider"] = $3c75c8f77ed4b940$export$a56ebeb3c828cd38;

});

parcelRegister("c7nnh", function(module, exports) {
/**
 * @generated SignedSource<<fb4cbf9baf031942480cc631faeb9c5f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ecbb6e526a968754$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$ecbb6e526a968754$var$node.hash = "f4093e7916c35c0c1b9141fd35c3dbe3";
var $ecbb6e526a968754$export$2e2bcd8739ae039 = $ecbb6e526a968754$var$node;
module.exports["default"] = $ecbb6e526a968754$export$2e2bcd8739ae039;

});

parcelRegister("2TQy9", function(module, exports) {
/**
 * @generated SignedSource<<b883f85a798a72a16cc53c5b93cb214f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2114907496ee9554$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$2114907496ee9554$var$node.hash = "3fd9bcac35b412a193a9c2f2d5df8b3c";
var $2114907496ee9554$export$2e2bcd8739ae039 = $2114907496ee9554$var$node;
module.exports["default"] = $2114907496ee9554$export$2e2bcd8739ae039;

});

parcelRegister("5e2GM", function(module, exports) {

var $6B1vK = parcelRequire("6B1vK");

const $e6f6530fea1b5195$var$ATLASSIAN_DOMAINS = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $e6f6530fea1b5195$export$97f4c254b641e719 = (hostname)=>!$e6f6530fea1b5195$var$ATLASSIAN_DOMAINS.some((domain)=>hostname.endsWith(domain));
const $e6f6530fea1b5195$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};
const $e6f6530fea1b5195$export$280e79c794cf814e = (url)=>$e6f6530fea1b5195$var$isValidUrl(url) ? new URL(url)?.hostname : '';
const $e6f6530fea1b5195$export$33c8f371dcc1b989 = (ari)=>{
    if (!ari || typeof ari !== 'string') return null;
    try {
        const parsedAri = (0, $6B1vK.ConfluencePageAri).parse(ari);
        return parsedAri && parsedAri.cloudId ? parsedAri.cloudId : null;
    } catch (err) {
        return null;
    }
};
const $e6f6530fea1b5195$export$193bb0d0d16ee7a7 = (parentCloudId, url, ari)=>{
    const parentHost = $e6f6530fea1b5195$export$280e79c794cf814e(window?.location?.href) || '';
    const contentHost = $e6f6530fea1b5195$export$280e79c794cf814e(url);
    if (parentHost === contentHost) return url;
    const cloudId = $e6f6530fea1b5195$export$33c8f371dcc1b989(ari);
    if (!cloudId || !parentCloudId || parentCloudId !== cloudId || !$e6f6530fea1b5195$export$97f4c254b641e719(parentHost)) return url;
    // Swap the URL hostname to use the parent's hostname
    try {
        const urlObj = new URL(url);
        urlObj.hostname = parentHost;
        return urlObj.toString();
    } catch (error) {
        // If URL parsing fails, return original URL
        return url;
    }
};
module.exports["getCorrectContentURL"] = $e6f6530fea1b5195$export$193bb0d0d16ee7a7;

});

parcelRegister("btIEy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $8zMP3 = parcelRequire("8zMP3");


var $l3tKl = parcelRequire("l3tKl");


var $5Kzz3 = parcelRequire("5Kzz3");

// Suspense wrapper to be passed to ADF Renderer
function $e1de24b738f0d933$var$SuspenseWrapperForUrl(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { url: url, children: children } = t0;
    if (!url || !(0, $6mKj3.expVal)("confluence_smartlinks_suspense", "isEnabled", false)) return children;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $5Kzz3.getSSRSmartLinksBoundaryMap)();
        $[0] = t1;
    } else t1 = $[0];
    const boundaryMap = t1;
    const fetcherName = boundaryMap[url];
    if (!fetcherName) return children;
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3tKl.HydrationSafeComponent), {
            isEnabled: true
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== fetcherName || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: fetcherName
        }, t2);
        $[3] = fetcherName;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
}
const $e1de24b738f0d933$export$53d21446ea17fdf1 = (initialState, isPageSSRd, options)=>{
    const $ = (0, $bDgLe.c)(8);
    options?.useSSRStore;
    let t0;
    if ($[0] !== initialState || $[1] !== options?.useSSRStore) {
        t0 = options?.useSSRStore ? (0, $5Kzz3.getSSRSmartLinksStore)() : initialState;
        $[0] = initialState;
        $[1] = options?.useSSRStore;
        $[2] = t0;
    } else t0 = $[2];
    const streamingStoreState = t0;
    let result;
    if ($[3] !== isPageSSRd || $[4] !== streamingStoreState) {
        result = {};
        if (isPageSSRd) result.SuspenseWrapperForUrl = $e1de24b738f0d933$var$SuspenseWrapperForUrl;
        if (streamingStoreState && (isPageSSRd || (0, $6mKj3.expValEquals)("platform_editor_smartlink_local_cache", "isEnabled", true))) {
            let t1;
            if ($[6] !== streamingStoreState) {
                t1 = {
                    initialState: streamingStoreState
                };
                $[6] = streamingStoreState;
                $[7] = t1;
            } else t1 = $[7];
            result.storeOptions = t1;
        }
        $[3] = isPageSSRd;
        $[4] = streamingStoreState;
        $[5] = result;
    } else result = $[5];
    return result;
};
module.exports["useStoreOptions"] = $e1de24b738f0d933$export$53d21446ea17fdf1;

});

parcelRegister("l3tKl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $e4o8D = parcelRequire("e4o8D");

const $53e580037f471881$var$HydrationSafeComponentContent = /*#__PURE__*/ (0, $cozmU.memo)(function HydrationSafeComponentContent({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $53e580037f471881$export$fc846b1429069eec({ children: children, isEnabled: isEnabled = true }) {
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    if (!isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53e580037f471881$var$HydrationSafeComponentContent, {
        isLocked: renderServerPlaceholder
    }, children);
}
module.exports["HydrationSafeComponent"] = $53e580037f471881$export$fc846b1429069eec;

});

parcelRegister("i6Ps3", function(module, exports) {
// Returns true on SSR and SPA if page was SSR'd
const $70ad96d323d38e4d$export$a8c2f05884e8c7a1 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(window.__SSR_RENDERED__);
};
module.exports["isPageSSRd"] = $70ad96d323d38e4d$export$a8c2f05884e8c7a1;

});

parcelRegister("jr2Xf", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JLuV = parcelRequire("6JLuV");

const $7ac1c4b85cd786d3$export$d48d5704d1181ce6 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    let t0;
    let t1;
    if ($[0] !== open) {
        t0 = ()=>{
            const handleMessage = (event)=>{
                const { payload: payload } = event.data;
                if (event.data?.type !== "OPEN_PREVIEW_PANEL") return;
                if (payload?.url) open(payload);
            };
            window.addEventListener("message", handleMessage);
            return ()=>{
                window.removeEventListener("message", handleMessage);
            };
        };
        t1 = [
            open
        ];
        $[0] = open;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return null;
} : ()=>{
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    // Listen for messages from iframes to open preview panels
    (0, $cozmU.useEffect)(()=>{
        const handleMessage = (event)=>{
            const { payload: payload } = event.data;
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            if (payload?.url) open(payload);
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        open
    ]);
    return null;
};
module.exports["PreviewPanelsPostMessageListener"] = $7ac1c4b85cd786d3$export$d48d5704d1181ce6;

});

parcelRegister("3PnE6", function(module, exports) {

var $iyuxZ = parcelRequire("iyuxZ");


var $4yccB = parcelRequire("4yccB");


var $ggGdk = parcelRequire("ggGdk");


var $9wGTI = parcelRequire("9wGTI");


var $6GQtz = parcelRequire("6GQtz");


var $6mKj3 = parcelRequire("6mKj3");


var $eaaOs = parcelRequire("eaaOs");

const $de526bdbda89b480$var$deferIdle = (cb)=>{
    if ('requestIdleCallback' in window) requestIdleCallback(cb, {
        timeout: 5000
    });
    else requestAnimationFrame(cb);
};
class $de526bdbda89b480$export$385f1396b754ac80 extends (0, $4yccB.default) {
    // Called once per page load
    prefetchData(url, appearance) {
        return super.prefetchData(url, appearance).then((data)=>{
            // Using deferIdle(requestIdleCallback) to ensure our onResolve callback doesn't interrupt the smart card client.
            // This means there's a chance under heavy browser load that the delay between client (pre)fetch and onResolve invocation will be >1s, but usually it shouldn't be.
            // Given the data schema is unstable, we're setting the type as unknown and expecting individual resolvers to be mindful.
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
    }
    // Called on load and on click of each smart card link
    async fetchData(url, force, appearance) {
        // Keep inline resolves on the editor provider path only while the inline resolve
        // optimization is active. Disabling the experiment restores the previous
        // appearance-based parent fetch path without needing a code rollback.
        const shouldUseParentFetchData = appearance !== undefined && (appearance !== 'inline' || !(0, $9wGTI.fg)('platform_smartlink_inline_resolve_optimization'));
        if (!shouldUseParentFetchData && (!force || // Exposure needs to fire regardless of whether the url is in cache
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) && this.smartCardLocalCacheClient?.isUrlInCache(url))) return this.editorCardProvider.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        }).then((data)=>{
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
        return super.fetchData(url, force, appearance).then((data)=>{
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
    }
    constructor(props){
        const { onResolve: onResolve, envKey: envKey } = props;
        super(envKey);
        this.onResolve = void 0;
        this.editorCardProvider = void 0;
        // When cleaning up platform_editor_smartlink_local_cache, remove ? here and in other places in this file
        this.smartCardLocalCacheClient = void 0;
        this.getInitialCardStoreFromCache = ()=>{
            const initialStateCardStore = {};
            const cachedData = this.smartCardLocalCacheClient?.getCache() ?? {};
            Object.entries(cachedData).forEach(([cacheKey, value])=>{
                const { metadataStatus: metadataStatus, url: url } = (0, $eaaOs.getUrlAndMetadataStatus)(cacheKey);
                if (initialStateCardStore[url]?.metadataStatus === 'resolved' && metadataStatus !== 'resolved') return;
                const details = value.data;
                // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
                const status = details && details.meta ? (0, $ggGdk.getStatus)(details) : undefined;
                if (status === 'resolved') {
                    // When FG is on, preserve metadataStatus from the cache key (e.g. 'pending' for inline)
                    // so hover cards can trigger a full block fetch. When FG is off, always use 'resolved'.
                    const resolvedMetadataStatus = (0, $9wGTI.fg)('platform_smartlink_inline_resolve_optimization') ? metadataStatus : 'resolved';
                    initialStateCardStore[url] = {
                        status: status,
                        details: details,
                        metadataStatus: resolvedMetadataStatus
                    };
                } else if (status !== undefined) // Include forbidden/unauthorized responses so the card can render the correct error state
                initialStateCardStore[url] = {
                    status: status,
                    details: details,
                    metadataStatus: 'resolved'
                };
            });
            return initialStateCardStore;
        };
        this.onResolve = onResolve;
        // Because Card components uses data from client and it's super hard to pass ConfluenceEditorCardProvider to them,
        // we will create a new ConfluenceEditorCardProvider instance here and use it for SSR support.
        this.editorCardProvider = new (0, $6GQtz.ConfluenceEditorCardProvider)(this.envKey, this.baseUrlOverride);
        if ((0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true)) this.smartCardLocalCacheClient = (0, $iyuxZ.SmartCardLocalCacheClient).getInstance();
        else this.smartCardLocalCacheClient = undefined;
        // Fire a client-side exposure for the SSR preload experiment. The experiment is only
        // evaluated in SSR preload code where the Statsig JS SDK is not initialized, so exposures
        // never reach Statsig from SSR alone. Calling manuallyLogExpExposure here — at the exact
        // point where the SSR-preloaded data is consumed on the client — ensures every page load
        // records an exposure, allowing us to measure the experiment's effect accurately.
        // Once the optimal value is found, this will be converted to a permanent Statsig config.
        (0, $6mKj3.manuallyLogExpExposure)('cc_editor_node_data_providers_preload_config');
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData[this.editorCardProvider.name];
        this.editorCardProvider.setSSRData(ssrData);
    }
}
module.exports["ConfluenceSmartCardClient"] = $de526bdbda89b480$export$385f1396b754ac80;

});

parcelRegister("eaaOs", function(module, exports) {
const $170225c35268fd68$var$CARD_APPEARANCE_CACHE_KEY_SUFFIXES = [
    '|inline',
    '|block',
    '|embed'
];
const $170225c35268fd68$var$isValidUrl = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $170225c35268fd68$export$b2650c09ef142a71 = (cacheKey)=>{
    for (const suffix of $170225c35268fd68$var$CARD_APPEARANCE_CACHE_KEY_SUFFIXES)if (cacheKey.endsWith(suffix)) {
        const strippedUrl = cacheKey.slice(0, -suffix.length);
        // Only treat as appearance-keyed if the remainder is a valid URL,
        // preventing false positives for URLs that legitimately end with |inline etc.
        if ($170225c35268fd68$var$isValidUrl(strippedUrl)) return {
            metadataStatus: suffix === '|inline' ? 'pending' : 'resolved',
            url: strippedUrl
        };
    }
    return {
        metadataStatus: 'resolved',
        url: cacheKey
    };
};
module.exports["getUrlAndMetadataStatus"] = $170225c35268fd68$export$b2650c09ef142a71;

});

parcelRegister("cknyY", function(module, exports) {

var $9sGCn = parcelRequire("9sGCn");

const $901e3ce3ee925fd9$var$getContentIdFromResolvedData = (resolvedData)=>{
    const ari = resolvedData.data['atlassian:ari'];
    return ari?.substring?.(ari?.lastIndexOf?.('/') + 1);
};
// data.data['@type'] will have two elements, for example ['schema:DigitalDocument', 'Document'], where 'schema:DigitalDocument' specifically denotes a live doc
// The resolve logic doesn't consistently position these two elements in the @type array, so the schema we need to validate may be in the 0th or 1st element
const $901e3ce3ee925fd9$var$isResolvedDataUnarchivedLiveDoc = (resolvedData)=>{
    const typeArr = resolvedData.data['@type'];
    const isLiveDoc = typeArr?.[0] === 'schema:DigitalDocument' || typeArr?.[1] === 'schema:DigitalDocument';
    const isArchived = resolvedData.data['atlassian:state'] === 'archived';
    return isLiveDoc && !isArchived;
};
const $901e3ce3ee925fd9$var$isResolvedDataValid = (resolvedData)=>{
    if (!resolvedData || typeof resolvedData !== 'object') return false;
    const data = resolvedData.data;
    const meta = resolvedData.meta;
    if (!data || !meta) return false;
    if (!('@context' in data)) return false;
    const type = data['@type'];
    if (typeof type !== 'string' && !Array.isArray(type)) return false;
    return true;
};
let $901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered = false;
const $901e3ce3ee925fd9$export$e1f1443d16a1c263 = (createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, resolvedData)=>{
    if ($901e3ce3ee925fd9$var$isResolvedDataValid(resolvedData)) {
        if ($901e3ce3ee925fd9$var$isResolvedDataUnarchivedLiveDoc(resolvedData)) {
            const contentId = $901e3ce3ee925fd9$var$getContentIdFromResolvedData(resolvedData);
            if (contentId) {
                let existingCachedData;
                try {
                    existingCachedData = readFragmentInterop({
                        id: `Content:${contentId}`
                    });
                } catch  {
                // readFragment throws an error if no data is found
                }
                // Reads are cheaper than writes, so only write if we don't already have the correct data in cache.
                if (!existingCachedData || existingCachedData?.subType !== 'live' || existingCachedData?.status !== 'current') {
                    writeFragmentInterop({
                        fragmentId: `Content:${contentId}`,
                        // status is current if we are an unarchived live doc
                        data: {
                            __typename: 'Content',
                            id: contentId,
                            subType: 'live',
                            status: 'current'
                        }
                    });
                    // Since graphql cache has been updated, make sure the memoization cache for getCachedPageData is cleared
                    // So if getCachedPageData is called again with the same content id, it will read the updated graphql cache instead of returning the memoized data
                    (0, $9sGCn.clearMemoizedCachedPageData)();
                }
            }
        }
    } else // If resolved data schema is invalid, we likely need to update it ASAP as Linking Platform's content resolver service API may have changed
    if (!$901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered) {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'invalidResolverData',
                actionSubject: 'liveDocSmartCardResolver',
                source: 'confluenceSmartCardProvider'
            }
        }).fire();
        // Only send this event once per load to reduce load on analytics pipeline
        $901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered = true;
    }
};
module.exports["liveDocSmartCardResolver"] = $901e3ce3ee925fd9$export$e1f1443d16a1c263;

});

parcelRegister("i1agE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63ce17648d66a3e35d23384b02311a62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1e048e4b12a2678$var$_react = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d1e048e4b12a2678$var$_baseNew = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d1e048e4b12a2678$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/warning-outline
 * Usage guidance:
 * Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1e048e4b12a2678$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $d1e048e4b12a2678$var$_react.default.createElement($d1e048e4b12a2678$var$_baseNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d1e048e4b12a2678$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $d1e048e4b12a2678$var$_default = module.exports.default = $d1e048e4b12a2678$var$WarningOutlineIcon;

});

parcelRegister("fNtG8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8027429ed7dcbe2$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $b8027429ed7dcbe2$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInMinute);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("b6fxF", function(module, exports) {
/* UserProfileCardForMention.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $lQV5m = parcelRequire("lQV5m");


var $cK21K = parcelRequire("cK21K");


var $iMnC5 = parcelRequire("iMnC5");


var $jp2Q3 = parcelRequire("jp2Q3");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $1koI0 = parcelRequire("1koI0");


var $g0RaX = parcelRequire("g0RaX");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");


var $9zU5G = parcelRequire("9zU5G");

const $0b67b0fc1e6d3033$var$ENTRY_POINT_ID = 'user-profile-card-for-mention';
const $0b67b0fc1e6d3033$var$mentionPopupStyles = {
    hidden: "_0fKRyPnQyn _1pp6NdYbGa"
};
function $0b67b0fc1e6d3033$var$PopperContent({ entryPointReference: entryPointReference, entryPointErrorFallback: entryPointErrorFallback, cloudId: cloudId, testId: testId, agent: agent }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bPFqZ.InternalEntryPointContainer), {
        id: $0b67b0fc1e6d3033$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {}),
        errorFallback: entryPointErrorFallback,
        runtimeProps: {
            cloudId: cloudId,
            testId: testId,
            agent: agent
        }
    });
} /**
   * Props common to both render paths.
   */ 
function $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d5gEx.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$UserProfileCardForMentionInner, {
            ...props
        })
    });
} /** Inner implementation of {@link UserProfileCardForMention}. */ 
function $0b67b0fc1e6d3033$var$UserProfileCardForMentionInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, children: children, referenceElement: referenceElement, placement: placement = 'bottom-start', trigger: trigger, testId: testId, agent: agent, analyticsAttributes: analyticsAttributes }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const onErrorBoundary = (0, $cozmU.useCallback)(()=>{
        (0, $g0RaX.getPageTime)();
    }, []);
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const [entryPointReference, setEntryPointReference] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!referenceElement || !userId || !cloudId || !orgId || !viewerId) return;
        const reference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $1koI0.entryPoint), {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        });
        setEntryPointReference(reference);
        return ()=>{
            reference.dispose();
            setEntryPointReference(null);
        };
    }, [
        referenceElement,
        userId,
        cloudId,
        orgId,
        viewerId,
        environmentProvider
    ]); // Both render paths require these identifiers to make a valid API call. Bail out to
    // the plain children (mention chip without a card) when any are missing - the editor
    // path also needs this guard before its popper renders.
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    if (!referenceElement) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        placement: placement,
        trigger: trigger,
        testId: testId,
        agent: agent,
        analyticsAttributes: analyticsAttributes,
        shouldRenderToParent: false,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
                onError: onErrorBoundary,
                fallback: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cK21K.default), {
                    zIndex: (0, $jp2Q3.layers).modal(),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lQV5m.Popper), {
                        referenceElement: referenceElement,
                        placement: placement,
                        children: ({ ref: ref, style: style, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                ref: ref,
                                style: style,
                                xcss: isReferenceHidden ? $0b67b0fc1e6d3033$var$mentionPopupStyles.hidden : undefined,
                                testId: testId ? `${testId}--mention-popup` : undefined,
                                children: entryPointReference ? /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$PopperContent, {
                                    entryPointReference: entryPointReference,
                                    entryPointErrorFallback: entryPointErrorFallback,
                                    cloudId: cloudId,
                                    testId: testId,
                                    agent: agent
                                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {})
                            })
                    })
                })
            })
        ]
    });
}
module.exports["UserProfileCardForMention"] = $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8;

});

parcelRegister("fxbF1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9089ed3f6a5fc310482f628accd47a0e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4f2fba9f65c2ddf$var$_react = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b4f2fba9f65c2ddf$var$_baseNew = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b4f2fba9f65c2ddf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "History".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/history
 * Usage guidance:
 * Reserved for history and recent
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4f2fba9f65c2ddf$var$HistoryIcon = (props)=>/*#__PURE__*/ $b4f2fba9f65c2ddf$var$_react.default.createElement($b4f2fba9f65c2ddf$var$_baseNew.default, Object.assign({
        name: "HistoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5a6.36 6.36 0 0 0-4.651 2.005l1.298.26a.75.75 0 0 1-.09 1.483l-3.25.25A.75.75 0 0 1 .5 4.75V1.5l.013-.137a.75.75 0 0 1 1.456-.079l.34 1.138A7.86 7.86 0 0 1 8 0a8 8 0 1 1-8 8zm7.25-4.25v4.389l2.219 1.775-.938 1.172-2.5-2A.75.75 0 0 1 7.25 8.5V3.75z"/>`
    }, props));
$b4f2fba9f65c2ddf$var$HistoryIcon.displayName = 'HistoryIcon';
var $b4f2fba9f65c2ddf$var$_default = module.exports.default = $b4f2fba9f65c2ddf$var$HistoryIcon;

});

parcelRegister("ivert", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10f3a345717d1c657b50bf7d56307662>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d78653211ce9e783$var$_react = $d78653211ce9e783$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d78653211ce9e783$var$_baseNew = $d78653211ce9e783$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d78653211ce9e783$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/template
 * Usage guidance:
 * Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d78653211ce9e783$var$TemplateIcon = (props)=>/*#__PURE__*/ $d78653211ce9e783$var$_react.default.createElement($d78653211ce9e783$var$_baseNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$d78653211ce9e783$var$TemplateIcon.displayName = 'TemplateIcon';
var $d78653211ce9e783$var$_default = module.exports.default = $d78653211ce9e783$var$TemplateIcon;

});

parcelRegister("3xwCI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::119d33b234e3a9f5d46223e4e15d9b62>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $293dc2808d336068$var$_react = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("cozmU")));

var $293dc2808d336068$var$_baseNew = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("gElAV")));
function $293dc2808d336068$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pencil".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/pencil
 * Usage guidance:
 * Known uses: compose video title in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $293dc2808d336068$var$PencilIcon = (props)=>/*#__PURE__*/ $293dc2808d336068$var$_react.default.createElement($293dc2808d336068$var$_baseNew.default, Object.assign({
        name: "PencilIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.336 1.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.099 8.099a2 2 0 0 1-1.022.547l-3.379.675a.75.75 0 0 1-.882-.882l.675-3.379a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.707 0l-.961.961 1.939 1.94.96-.961a.5.5 0 0 0 0-.707zm-.79 3.961-1.939-1.94-6.077 6.078a.5.5 0 0 0-.137.255l-.455 2.276 2.276-.455a.5.5 0 0 0 .255-.137zM16 15H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$293dc2808d336068$var$PencilIcon.displayName = 'PencilIcon';
var $293dc2808d336068$var$_default = module.exports.default = $293dc2808d336068$var$PencilIcon;

});

parcelRegister("f7MuR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $8s9DV.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $kBr4q.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $kBr4q.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $cozmU.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("kcIQr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("hnDzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca7347c324945db7$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $9wdry = parcelRequire("9wdry");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");

function $ca7347c324945db7$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $9wdry.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("9wdry", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ee187ccd32d3646$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $6ee187ccd32d3646$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("84256", function(module, exports) {
/* wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9NPFC = parcelRequire("9NPFC");

const $b2cdc17c5a772991$var$glyphStyles = null;
const $b2cdc17c5a772991$var$hexagonSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
};
const $b2cdc17c5a772991$var$hexagonRootStyles = null;
const $b2cdc17c5a772991$var$hexagonStyles = null;
const $b2cdc17c5a772991$var$hexagonBorderStyles = null;
const $b2cdc17c5a772991$var$hexagonContentStyles = null;
const $b2cdc17c5a772991$var$svgIdAttributePattern = /\sid=(["'])([^"']+)\1/g;
const $b2cdc17c5a772991$var$getSvgIdNamespace = (instanceId)=>`third-party-logo-${instanceId.replace(/[^a-zA-Z0-9_-]/g, '-')}`; /**
                                                                                                                             * Third-party SVGs can contain gradients, masks, and clipPaths with document-wide IDs.
                                                                                                                             * Namespacing each render keeps repeated logos from resolving `url(#id)` references to the
                                                                                                                             * first matching SVG definition elsewhere on the page.
                                                                                                                             */ 
const $b2cdc17c5a772991$var$namespaceSvgIds = (markup, namespace)=>{
    const ids = Array.from(markup.matchAll($b2cdc17c5a772991$var$svgIdAttributePattern), ([, , id])=>id);
    const uniqueIds = Array.from(new Set(ids));
    return uniqueIds.reduce((updatedMarkup, id)=>{
        const namespacedId = `${namespace}-${id}`;
        const escapedId = $b2cdc17c5a772991$var$escapeRegExp(id);
        return updatedMarkup.replace(new RegExp(`\\sid=(["'])${escapedId}\\1`, 'g'), ` id=$1${namespacedId}$1`).replace(new RegExp(`url\\(#${escapedId}\\)`, 'g'), `url(#${namespacedId})`).replace(new RegExp(`(\\s(?:href|xlink:href)=["'])#${escapedId}(["'])`, 'g'), `$1#${namespacedId}$2`);
    }, markup);
};
const $b2cdc17c5a772991$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function $b2cdc17c5a772991$export$96b07167eb29fb14({ markup: markup, size: size = 'medium', label: label = '', testId: testId, type: type = 'app' }) {
    const instanceId = (0, $cozmU.useId)();
    const namespacedMarkup = (0, $cozmU.useMemo)(()=>$b2cdc17c5a772991$var$namespaceSvgIds(markup, $b2cdc17c5a772991$var$getSvgIdNamespace(instanceId)), [
        markup,
        instanceId
    ]);
    const glyph = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": "true",
        dangerouslySetInnerHTML: {
            __html: namespacedMarkup
        },
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d"
        ])
    });
    if (type === 'agent') return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _3YEZNOdnbC _1RrJLit2nV",
            $b2cdc17c5a772991$var$hexagonSizeStyles[size]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbccYA _24h04i2Njc _39xV02N91d _0jFU0VN91d _1uo2ZfTcEg",
                "_4c065UNvrM _2Y7lL4NvrM _0KLXruIDZ8"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _0KLXrut28M _1uo2ZfOLYo"
                ]),
                children: glyph
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Tile's backgroundColor API accepts the semantic `white` value.
    ), {
        backgroundColor: "white",
        label: label,
        size: size,
        testId: testId,
        hasBorder: true,
        isInset: false,
        children: glyph
    });
}
module.exports["ThirdPartyLogoWrapper"] = $b2cdc17c5a772991$export$96b07167eb29fb14;

});

parcelRegister("aMsxt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf4bc7217f58b5ef916be3252e86e461>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $84256 = parcelRequire("84256");

const $828d22d75c7e0400$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><mask id="mask0_118280_5589" width="32" height="28" x="8" y="9" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#b43333" d="M18.03 12.455c2.659-4.606 9.307-4.607 11.967 0l8.187 14.181C40.844 31.242 37.52 37 32.201 37H15.825c-5.318 0-8.642-5.758-5.983-10.364z"/></mask><g mask="url(#mask0_118280_5589)"><path fill="url(#paint0_linear_118280_5589)" d="M44.178 37.004H27.47l-3.457-5.988 8.353-14.47z"/><path fill="url(#paint1_linear_118280_5589)" d="m3.846 37.004 11.811-20.457-3.456 5.987h6.913l8.354 14.47z"/><path fill="url(#paint2_linear_118280_5589)" d="m24.015 2.074 8.354 14.47-3.457 5.987H12.204z"/></g><defs><linearGradient id="paint0_linear_118280_5589" x1="41.759" x2="25.302" y1="35.836" y2="25.947" gradientUnits="userSpaceOnUse"><stop offset=".09" stop-color="#ffe921"/><stop offset="1" stop-color="#fec700"/></linearGradient><linearGradient id="paint1_linear_118280_5589" x1="27.359" x2="9.383" y1="38.75" y2="27.875" gradientUnits="userSpaceOnUse"><stop offset=".15" stop-color="#a9a8ff"/><stop offset=".33" stop-color="#6d97ff"/><stop offset=".48" stop-color="#3186ff"/></linearGradient><linearGradient id="paint2_linear_118280_5589" x1="29.992" x2="11.777" y1="12.613" y2="21.115" gradientUnits="userSpaceOnUse"><stop offset=".55" stop-color="#0ebc5f"/><stop offset=".85" stop-color="#78c9ff"/></linearGradient></defs></svg>';
function $828d22d75c7e0400$export$e16bd899bb4eebf9({ size: size, label: label = 'Google Drive', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $84256.ThirdPartyLogoWrapper), {
        markup: $828d22d75c7e0400$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["GoogleDriveIcon"] = $828d22d75c7e0400$export$e16bd899bb4eebf9;

});

parcelRegister("lp1F5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1069d04804a2ae0ab9d0c6315e1cb5f4>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $84256 = parcelRequire("84256");

const $bfe1716349f0e396$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_linear_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint1_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint2_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint3_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint4_linear_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint5_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint6_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint7_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint8_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint9_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="url(#paint10_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="#fff" d="m14.689 31.445 1.31-.683q.221.447.579.659.36.211.79.212.476 0 .726-.193.25-.198.25-.591a.67.67 0 0 0-.24-.52q-.24-.216-.853-.327-1.166-.212-1.695-.74-.525-.53-.525-1.318 0-.981.694-1.569.694-.585 1.83-.586.765 0 1.349.313.583.312.925.894l-1.281.66a1.4 1.4 0 0 0-.457-.472q-.247-.15-.617-.15-.443 0-.675.193a.63.63 0 0 0-.226.5q0 .265.217.467.222.197.886.322 1.117.212 1.666.77.555.553.554 1.4 0 1.03-.66 1.63t-1.883.6q-.886 0-1.599-.384a2.54 2.54 0 0 1-1.064-1.087z"/><defs><radialGradient id="paint1_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.32263 -12.8627 -23.1621 9.55567 25.665 29.882)" gradientUnits="userSpaceOnUse"><stop offset=".29" stop-color="#003b5d" stop-opacity=".2"/><stop offset=".61" stop-color="#004a6c" stop-opacity=".138"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint2_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.41835 -10.8865 -19.5798 7.9222 24.391 24.611)" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#002a42" stop-opacity=".31"/><stop offset=".61" stop-color="#004261" stop-opacity=".214"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.56759 8.10392 8.11617 5.55934 27.893 10.686)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint5_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(3.0738 -8.81188 -15.9013 -5.52951 26.098 31.084)" gradientUnits="userSpaceOnUse"><stop stop-color="#003b5d" stop-opacity=".502"/><stop offset=".49" stop-color="#004c6c" stop-opacity=".362"/><stop offset=".97" stop-color="#007a86" stop-opacity="0"/></radialGradient><radialGradient id="paint6_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.6396 6.75319 6.76325 4.63263 34.97 19.304)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint9_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(12.1028 12.086 12.105 -12.0839 13.08 23.761)" gradientUnits="userSpaceOnUse"><stop offset=".06" stop-color="#00b6bd"/><stop offset=".89" stop-color="#00495c"/></radialGradient><radialGradient id="paint10_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(0 8.45945 -9.64483 0 17.124 30.643)" gradientUnits="userSpaceOnUse"><stop offset=".57" stop-color="#1e8581" stop-opacity="0"/><stop offset=".97" stop-color="#1ecbe6" stop-opacity=".6"/></radialGradient><linearGradient id="paint0_linear_118280_5862" x1="16.812" x2="28.885" y1="10.479" y2="26.325" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".41" stop-color="#0097a8"/><stop offset="1" stop-color="#007791"/></linearGradient><linearGradient id="paint4_linear_118280_5862" x1="26.04" x2="36.102" y1="19.279" y2="32.485" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".48" stop-color="#00a2b8"/><stop offset=".95" stop-color="#00637c"/></linearGradient><linearGradient id="paint7_linear_118280_5862" x1="20.506" x2="26.919" y1="26.346" y2="39.17" gradientUnits="userSpaceOnUse"><stop offset=".05" stop-color="#75fff6"/><stop offset=".51" stop-color="#00c7d1"/><stop offset=".96" stop-color="#0096ad"/></linearGradient><linearGradient id="paint8_linear_118280_5862" x1="28.894" x2="25.466" y1="40.029" y2="35.22" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#0e5a5d" stop-opacity=".322"/><stop offset=".54" stop-color="#126c6b" stop-opacity=".222"/><stop offset=".97" stop-color="#1c948a" stop-opacity="0"/></linearGradient></defs></svg>';
function $bfe1716349f0e396$export$18737550276ca4ad({ size: size, label: label = 'Microsoft SharePoint', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $84256.ThirdPartyLogoWrapper), {
        markup: $bfe1716349f0e396$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["MicrosoftSharePointIcon"] = $bfe1716349f0e396$export$18737550276ca4ad;

});

parcelRegister("f8dGE", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $b042384c0682c153$var$CLONE_DEEP_FLAG = 1, $b042384c0682c153$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b042384c0682c153$var$cloneDeep(value) {
    return $hGc5T(value, $b042384c0682c153$var$CLONE_DEEP_FLAG | $b042384c0682c153$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $b042384c0682c153$var$cloneDeep;

});

parcelRegister("iRqYE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be258611bd1f9388921e0735764086cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbb21a5762820d00$var$_react = $dbb21a5762820d00$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dbb21a5762820d00$var$_baseNew = $dbb21a5762820d00$var$_interopRequireDefault((parcelRequire("gElAV")));
function $dbb21a5762820d00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Terminal".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/terminal
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbb21a5762820d00$var$TerminalIcon = (props)=>/*#__PURE__*/ $dbb21a5762820d00$var$_react.default.createElement($dbb21a5762820d00$var$_baseNew.default, Object.assign({
        name: "TerminalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.4-.49L14 2.5H2a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 3z"/><path fill="currentcolor" d="m4.28 4.72 2.75 2.75a.75.75 0 0 1 0 1.06l-2.75 2.75-1.06-1.06L5.44 8 3.22 5.78zM12.5 9.5V11H8V9.5z"/>`
    }, props));
$dbb21a5762820d00$var$TerminalIcon.displayName = 'TerminalIcon';
var $dbb21a5762820d00$var$_default = module.exports.default = $dbb21a5762820d00$var$TerminalIcon;

});

parcelRegister("cuWGz", function(module, exports) {

var $e66dL = parcelRequire("e66dL");


var $aO6uT = parcelRequire("aO6uT");

function $61987beec044a597$export$57570b1603cf6adb(env) {
    if (env) return env;
    if (typeof window === 'undefined' || !window.location) return (0, $aO6uT.Environment).Unknown;
    const host = window.location.hostname.toLowerCase();
    // Fast path: exact hostname matches
    const exactMatch = (0, $e66dL.EXACT_HOST_MAP)[host];
    if (exactMatch) return exactMatch;
    // Extract TLD for efficient branching (find last dot position)
    const lastDot = host.lastIndexOf('.');
    if (lastDot === -1) return (0, $aO6uT.Environment).Unknown;
    const tld = host.slice(lastDot + 1); // 'com', 'net', etc.
    // Branch by TLD to reduce checks
    switch(tld){
        case 'com':
            return $61987beec044a597$var$classifyComDomain(host);
        case 'net':
            return $61987beec044a597$var$classifyNetDomain(host);
        default:
            return (0, $aO6uT.Environment).Unknown;
    }
}
/**
 * Classify .com domains
 */ function $61987beec044a597$var$classifyComDomain(host) {
    // jira-dev.com (staging)
    if (host.endsWith('.jira-dev.com')) return (0, $aO6uT.Environment).Staging;
    // atlassian-us-gov-mod.com (FedRAMP)
    if (host.endsWith('.atlassian-us-gov-mod.com')) {
        // FedRAMP Bifrost CDN: check most specific first
        if (host.endsWith('.frontend.cdn.atlassian-us-gov-mod.com')) return host.includes('.stg.') ? (0, $aO6uT.Environment).Staging : (0, $aO6uT.Environment).Prod;
        if (host.endsWith('.stg.atlassian-us-gov-mod.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    // atlassian.com domains
    if (host.endsWith('.atlassian.com')) {
        // services.atlassian.com vanity domains (check most specific first)
        if (host.endsWith('.dev.services.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.staging.services.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        if (host.endsWith('.services.atlassian.com')) return (0, $aO6uT.Environment).Prod;
        // Environment-specific subdomains
        if (host.endsWith('.dev.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.stg.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
/**
 * Classify .net domains
 */ function $61987beec044a597$var$classifyNetDomain(host) {
    // atlassian.net (prod tenants)
    if (host.endsWith('.atlassian.net')) return (0, $aO6uT.Environment).Prod;
    // atl-paas-us-gov-mod.net (FedRAMP Micros)
    if (host.endsWith('.atl-paas-us-gov-mod.net')) {
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
        return (0, $aO6uT.Environment).Unknown;
    }
    // atl-paas.net (commercial Micros and Bifrost)
    if (host.endsWith('.atl-paas.net')) {
        // Bifrost commercial: check most specific first
        if (host.endsWith('.frontend.public.atl-paas.net')) {
            if (host.includes('.ddev.') || host.includes('.dev-west2.')) return (0, $aO6uT.Environment).Development;
            if (host.includes('.stg-east.')) return (0, $aO6uT.Environment).Staging;
            if (host.includes('.prod-east.')) return (0, $aO6uT.Environment).Prod;
            return (0, $aO6uT.Environment).Development;
        }
        // Micros commercial
        if (host.includes('.dev.') || host.includes('.platdev.')) return (0, $aO6uT.Environment).Development;
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
module.exports["getEnvironment"] = $61987beec044a597$export$57570b1603cf6adb;

});

parcelRegister("e66dL", function(module, exports) {

var $aO6uT = parcelRequire("aO6uT");

const $1c6adf460a912312$export$636c0c57a2ce36e9 = {
    localhost: (0, $aO6uT.Environment).Development,
    '127.0.0.1': (0, $aO6uT.Environment).Development,
    'id.atlassian.com': (0, $aO6uT.Environment).Prod,
    'admin.atlassian.com': (0, $aO6uT.Environment).Prod,
    'id.stg.internal.atlassian.com': (0, $aO6uT.Environment).Staging,
    'admin.stg.atlassian.com': (0, $aO6uT.Environment).Staging
};
module.exports["EXACT_HOST_MAP"] = $1c6adf460a912312$export$636c0c57a2ce36e9;

});

parcelRegister("aO6uT", function(module, exports) {
var $cf10c8edb5d48b94$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    Environment["Unknown"] = "unknown";
    return Environment;
}({});
module.exports["Environment"] = $cf10c8edb5d48b94$export$7dc6752a22ab011a;

});

parcelRegister("5pQ1Y", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $676464c7222bdee0$export$d84a6ddaa8e6e9d9 = /*#__PURE__*/ (0, $cozmU.createContext)({
    refetchContent: false
});
$676464c7222bdee0$export$d84a6ddaa8e6e9d9.displayName = 'ContentRefetchContext';
const $676464c7222bdee0$export$dfd2d999f6a2731 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setRefetchContent: ()=>{}
});
$676464c7222bdee0$export$dfd2d999f6a2731.displayName = 'ContentRefetchDispatchContext';
const $676464c7222bdee0$export$cfa813593f7b7ba = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const [refetchContent, setRefetchContent] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== refetchContent) {
        t1 = {
            refetchContent: refetchContent
        };
        $[0] = refetchContent;
        $[1] = t1;
    } else t1 = $[1];
    const providerValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchProviderValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
            value: dispatchProviderValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== providerValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
            value: providerValue
        }, t3);
        $[5] = providerValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $676464c7222bdee0$export$68e22604851d391b = ()=>{
    return (0, $cozmU.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
};
const $676464c7222bdee0$export$8ebf7a2378ada555 = ()=>{
    return (0, $cozmU.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
};
module.exports["ContentRefetchProvider"] = $676464c7222bdee0$export$cfa813593f7b7ba;
module.exports["useContentRefetch"] = $676464c7222bdee0$export$68e22604851d391b;
module.exports["useContentRefetchDispatch"] = $676464c7222bdee0$export$8ebf7a2378ada555;

});

parcelRegister("kOUwv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $8s9DV.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $kBr4q.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $kBr4q.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("liGyh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6tkbf = parcelRequire("6tkbf");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $lb2Lp = parcelRequire("lb2Lp");


var $kgNLQ = parcelRequire("kgNLQ");


var $aSsfA = parcelRequire("aSsfA");

const $ba57c93125c5375a$export$63c5e37b7c8d14d1 = ({ location: location } = {})=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { focusedCommentId: focusedCommentId, editComment: editComment, commentId: commentId, replyToComment: replyToComment, showCommentArea: showCommentArea, shouldMention: shouldMention, unreadCommentMark: unreadCommentMark } = getQueryParams();
    const targetCommentId = focusedCommentId || replyToComment || editComment && commentId;
    const shouldSkipQuery = !targetCommentId || !location;
    const { comment: comment, error: error } = (0, $lb2Lp.useCommentById)({
        commentId: targetCommentId || '',
        contentId: pageId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery
        }
    });
    // Note that this will detect missing inline and footer comments because the query will find
    // either type of comment - so if the comment doesn't exist, we will get the "not found" error
    // In the new flow, useCommentById returns an error when the comment isn't found after loading completes
    const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message || String(error)) : false;
    let focusedId;
    let editCommentId;
    let replyToCommentId;
    let commentContainerId;
    if (comment && 'container' in comment) // Comment replies coming from the new manager don't have a container
    commentContainerId = comment.container?.id;
    else commentContainerId = undefined;
    // Only return comment IDs for relevant location; If no location is given, return them all
    const shouldReturnIds = (!location || location === comment?.location?.type) && (pageId === commentContainerId || commentContainerId === undefined);
    if (shouldReturnIds) {
        /* A focused comment query param just uses "focusedCommentId={COMMENT_ID}" */ focusedId = focusedCommentId ? focusedCommentId : undefined;
        /* An edit comment query param uses a combination of "editComment=true&commentId={COMMENT_ID}" */ editCommentId = editComment && editComment === 'true' && commentId ? commentId : undefined;
        /* A reply to comment query param just uses "replyToComment={COMMENT_ID}" */ replyToCommentId = replyToComment ? replyToComment : undefined;
    }
    /* PAGE COMMENTS ONLY: A new comment uses the "showCommentArea=true" query param */ const shouldOpenNewCommentEditor = showCommentArea === 'true';
    /* A mention comment uses the "shouldMention=true" query param */ const shouldMentionInNewCommentEditor = shouldMention === 'true' && replyToCommentId !== undefined;
    const removeCommentQueryParamsFunction = ()=>{
        let commentTypeKey = '', commentIdKey = '', commentMentionKey = '';
        if (focusedId) commentTypeKey = 'focusedCommentId';
        else if (shouldMentionInNewCommentEditor) {
            commentTypeKey = 'replyToComment';
            commentMentionKey = 'shouldMention';
        } else if (replyToCommentId) commentTypeKey = 'replyToComment';
        else if (editCommentId) {
            commentTypeKey = 'editComment';
            commentIdKey = 'commentId';
        } else if (shouldOpenNewCommentEditor) commentTypeKey = 'showCommentArea';
        if (commentTypeKey || commentIdKey || commentMentionKey || unreadCommentMark) {
            const params = getQueryParams();
            setQueryParams({
                ...params,
                [commentTypeKey]: undefined,
                [commentIdKey]: undefined,
                [commentMentionKey]: undefined,
                unreadCommentMark: undefined
            });
        }
    };
    const removeCommentQueryParams = (0, $cozmU.useCallback)(removeCommentQueryParamsFunction, [
        getQueryParams,
        setQueryParams,
        unreadCommentMark,
        editCommentId,
        replyToCommentId,
        shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor,
        focusedId
    ]);
    const setFocusedCommentQueryParam = (commentId)=>{
        const params = getQueryParams();
        setQueryParams({
            ...params,
            focusedCommentId: commentId
        });
    };
    return {
        focusedCommentId: focusedId,
        editCommentId: editCommentId,
        replyToCommentId: replyToCommentId,
        shouldOpenNewCommentEditor: shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor: shouldMentionInNewCommentEditor,
        unreadCommentMark: unreadCommentMark,
        removeCommentQueryParams: removeCommentQueryParams,
        setFocusedCommentQueryParam: setFocusedCommentQueryParam,
        isCommentNotFound: isCommentNotFound
    };
};
const $ba57c93125c5375a$export$b073d30d47d4035b = ({ queryArchivedContent: queryArchivedContent = false } = {})=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'INLINE',
        queryArchivedContent: queryArchivedContent
    });
const $ba57c93125c5375a$export$97d0ff531551284c = ()=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'FOOTER'
    });
module.exports["useInlineCommentQueryParams"] = $ba57c93125c5375a$export$b073d30d47d4035b;

});

parcelRegister("6tkbf", function(module, exports) {

var $lb2Lp = parcelRequire("lb2Lp");


var $6mKj3 = parcelRequire("6mKj3");

const $6b00aa328c211ce7$export$5c24224d7e29c719 = ()=>{
    return {
        context: {
            fetchOptions: {
                ignoreNoNetworkError: (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_offline_fix', 'isEnabled', true)
            }
        }
    };
};
const $6b00aa328c211ce7$export$9f99b736afd21d01 = (errorMessage)=>{
    if (errorMessage) {
        // Check if the full error message matches the string thrown from useCommentById
        if (errorMessage === (0, $lb2Lp.USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE)) return true;
        // Also check the reason message (extracted from backend error format)
        const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
        const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
        // If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
        const backendReasonMessage = 'No comment found for the given id';
        return reasonMessage === backendReasonMessage;
    }
    return false;
};
module.exports["buildMutationContextForNoNetworkError"] = $6b00aa328c211ce7$export$5c24224d7e29c719;
module.exports["isCommentNotFoundError"] = $6b00aa328c211ce7$export$9f99b736afd21d01;

});

parcelRegister("lb2Lp", function(module, exports) {

var $dc3kb = parcelRequire("dc3kb");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");

// The `useCommentById` hook efficiently fetches a single comment by ID with a simple strategy:
// First, it checks the cache for the allCommentsDataQuery using useAllCommentsData with cache-only
// policy. If the comment is found in the cache and data is processed, it uses that data. Otherwise,
// it makes a separate query for just the specific comment. This ensures quick access to individual
// comments without unnecessary network requests when data is already cached. The hook also provides
// loading states, error handling, and comprehensive type safety.
// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this hook - or at least the part that executes the query into the
// useAllCommentsData.ts file.
const $f4841d4502be35b2$var$commentByIdQuery = (0, $dc3kb.default);
const $f4841d4502be35b2$export$4bf99575c214d4b = 'Comment not found: No comment found for the given id';
const $f4841d4502be35b2$export$1f091977fe1929e2 = 'useCommentById requires either commentId or markerRef and contentId to be provided';
const $f4841d4502be35b2$export$778dda4ccca7793f = ({ commentId: commentId, markerRef: markerRef, contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onError: parentOnError, skip: skip = false } = options;
    // Get processed comments data
    const { isDataProcessed: isDataProcessed, flatCommentsMap: flatCommentsMap, flatMarkerRefMap: flatMarkerRefMap, error: processedCommentsError } = (0, $4L9ve.useProcessedCommentsDataState)();
    // Validate that at least one identifier is provided (only if not skipping)
    const validationError = (0, $cozmU.useMemo)(()=>!skip && (!contentId || !commentId && !markerRef) ? new Error($f4841d4502be35b2$export$1f091977fe1929e2) : undefined, [
        skip,
        commentId,
        markerRef,
        contentId
    ]);
    const skipQueries = skip || !!validationError;
    // Skip the individual comment query if we have cached data from the full query, it's been processed, and we're not asking for fresh BE data
    const shouldSkipOneCommentQuery = skipQueries || fetchPolicy !== 'network-only' && isDataProcessed;
    // Always query with all 4 content statuses to guarantee cache hits on preloaded data
    // We'll filter the result client-side based on the passed-in contentStatus
    const oneCommentData = (0, $jMyy4.useQueryInterop)($f4841d4502be35b2$var$commentByIdQuery, {
        variables: {
            pageId: contentId ?? '',
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        skip: shouldSkipOneCommentQuery,
        onError: (error)=>{
            // Handle specific GraphQL errors gracefully
            // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
            // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
            if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "comments-data-manager"
    });
    // Look for the comment using the flat map for O(1) lookup, or fall back to searching arrays
    const finalComment = (0, $cozmU.useMemo)(()=>{
        if (validationError) return undefined;
        // If data is processed, try to find in the flat maps (fastest - O(1))
        if (isDataProcessed) {
            if (commentId) {
                const cachedComment = flatCommentsMap?.[commentId];
                if (cachedComment) return cachedComment;
            } else if (markerRef) {
                const cachedCommentByMarkerRef = flatMarkerRefMap?.[markerRef];
                if (cachedCommentByMarkerRef) return cachedCommentByMarkerRef;
            }
        }
        // Fall back to searching in oneCommentData if available
        if (oneCommentData.data?.comments?.nodes) {
            // Filter out any null nodes - can't just use .filter because TS complains about type
            // mismatch.  Fortunately, this query should only have one comment node anyway.
            const commentData = oneCommentData.data.comments.nodes.filter((node)=>!!node);
            if (!commentData) return undefined;
            // Search in retrieved comments and their replies
            return (0, $kgNLQ.findAndFilterComment)(commentData, commentId, markerRef, contentStatus);
        }
        return undefined;
    }, [
        validationError,
        commentId,
        flatCommentsMap,
        flatMarkerRefMap,
        isDataProcessed,
        oneCommentData.data?.comments?.nodes,
        markerRef,
        contentStatus
    ]);
    // Create an error if we have the full response but can't find the comment
    // 99% of the time this error will be thrown when cachedUseAllCommentsData is populated, but the comment isn't available
    // useCommentByIdQuery **should** throw a similar error if the comment isn't found from the BE,
    // but keep the check here in case the BE changes, or our comment is in another status & is filtered out
    const commentNotFoundError = (0, $cozmU.useMemo)(()=>{
        // Only create error if:
        // 1. We're not loading anymore (have full response)
        // 2. We have data (either from processedCommentsData or oneCommentData)
        // 3. We searched for the comment but didn't find it
        // 4. There's no existing error
        if (!skipQueries && isDataProcessed && !oneCommentData.loading && !processedCommentsError && !oneCommentData.error && finalComment === undefined) return new Error($f4841d4502be35b2$export$4bf99575c214d4b);
        return undefined;
    }, [
        skipQueries,
        isDataProcessed,
        processedCommentsError,
        oneCommentData.loading,
        oneCommentData.error,
        finalComment
    ]);
    // Memoize the final error to ensure stable reference for use in external useEffects
    const error = (0, $cozmU.useMemo)(()=>{
        return validationError || processedCommentsError || oneCommentData.error || commentNotFoundError;
    }, [
        validationError,
        processedCommentsError,
        oneCommentData.error,
        commentNotFoundError
    ]);
    // Call onError when the error changes
    (0, $cozmU.useEffect)(()=>{
        if (error && parentOnError) parentOnError(error);
    }, [
        error,
        parentOnError
    ]);
    return {
        loading: !isDataProcessed && oneCommentData.loading,
        error: // (Only loading state if both are loading)
        error,
        comment: finalComment
    };
};
const $f4841d4502be35b2$export$77a85b13740d9b96 = async ({ commentId: commentId, markerRef: markerRef, contentId: contentId, fetchPolicy: fetchPolicy = 'network-only' })=>{
    if (!contentId || !commentId && !markerRef) return Promise.resolve(null);
    const response = await (0, $c0rhi.queryInterop)({
        query: $f4841d4502be35b2$var$commentByIdQuery,
        variables: {
            pageId: contentId,
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            // Query for all content statuses - don't filter by contentStatus
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "comments-data-manager"
    });
    const nodes = response?.data?.comments?.nodes;
    if (!nodes || nodes.length === 0) return null;
    // Filter out nulls and convert readonly array to mutable array
    const comments = nodes.filter((node)=>node !== null);
    return (0, $kgNLQ.findAndFilterComment)(comments, commentId, markerRef, (0, $NYiei.allContentStatuses));
};
module.exports["USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE"] = $f4841d4502be35b2$export$4bf99575c214d4b;
module.exports["useCommentById"] = $f4841d4502be35b2$export$778dda4ccca7793f;
module.exports["fetchCommentById"] = $f4841d4502be35b2$export$77a85b13740d9b96;

});

parcelRegister("dc3kb", function(module, exports) {
/**
 * @generated SignedSource<<1ab88c86ecf711245680266df88d829b>>
 * @relayHash 30943931b9ef970914fcabde1ec18427
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454
const $09771c757ee62765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRef"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v12 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v9 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v13 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v15 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v16 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v17 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v18 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v23 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v25 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v26 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "number"
    }, v28 = {
        "kind": "ScalarField",
        "name": "when"
    }, v29 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Variable",
                    "name": "inlineMarkerRef",
                    "variableName": "inlineMarkerRef"
                },
                v4 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        v26 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v27 /*: any*/ ,
                                v28 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentByIdQuery",
            "selections": v29 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentByIdQuery",
            "selections": v29 /*: any*/ 
        },
        "params": {
            "cacheID": "30943931b9ef970914fcabde1ec18427",
            "id": "e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454",
            "metadata": {},
            "name": "useCommentByIdQuery",
            "operationKind": "query",
            "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
        }
    };
}();
$09771c757ee62765$var$node.hash = "e144cc71550d14f94a82d8439ed2ba0e";
var $09771c757ee62765$export$2e2bcd8739ae039 = $09771c757ee62765$var$node;
module.exports["default"] = $09771c757ee62765$export$2e2bcd8739ae039;

});

parcelRegister("NYiei", function(module, exports) {

var $1Pttz = parcelRequire("1Pttz");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $kgNLQ = parcelRequire("kgNLQ");

const $bd3b81debc212a33$export$ef1591875b2a95ef = 1500;
const $bd3b81debc212a33$export$a1c5d5765ca44631 = [
    'DRAFT',
    'CURRENT',
    'ARCHIVED',
    'DELETED'
];
const $bd3b81debc212a33$export$a5752cd8da7feaeb = (0, $1Pttz.default);
const $bd3b81debc212a33$export$66fa4e722aa8c832 = (contentId)=>({
        pageId: contentId,
        contentStatus: $bd3b81debc212a33$export$a1c5d5765ca44631,
        first: $bd3b81debc212a33$export$ef1591875b2a95ef
    });
const $bd3b81debc212a33$var$addCommentRootToCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount })=>{
    const updatedRootComments = [
        ...cachedRootComments
    ];
    let updatedTotalCount = totalCount;
    // If there is already a comment with the same ID in the root array, replace it
    // Normally this shouldn't happen because new comments should always have unique IDs, but there
    // is a case were this can happen with replies (see below) - so let's be safe and handle it just
    // in case it ever happens with root comments as well.
    const existingRootIndex = updatedRootComments.findIndex((comment)=>newComment?.id && comment?.id === newComment?.id);
    if (existingRootIndex !== -1) updatedRootComments[existingRootIndex] = newComment;
    else {
        // Else add the newly added comment to the end of the root comments list
        updatedRootComments.push(newComment);
        // Increment total count. Note that we can only add individual comments without any replies, but
        // let's be safe and adjust for any replies in case this ever changes
        updatedTotalCount += repliesCount + 1;
    }
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$addCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to add the reply from the top-level parent's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE). So to add a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array, as the original is readonly
        const updatedReplies = [
            ...parentComment.replies
        ];
        // If there is already a reply with the same ID in the parent's replies, replace it
        // Normally this shouldn't happen because new comments should always have unique IDs, but there
        // is a case were this can happen - when we're in edit mode and another user who is also in
        // edit mode also adds a reply to comment on the new text and then Updates the page -> we get
        // the new reply via the pubsub events and again when the new text is added by the Update.
        const existingReplyIndex = updatedReplies.findIndex((reply)=>newComment?.id && reply?.id === newComment?.id);
        if (existingReplyIndex !== -1) updatedReplies[existingReplyIndex] = newComment;
        else {
            // Else add the new  reply to the array
            updatedReplies.push(newComment);
            // Increment total count. We can only add individual comments without any replies, but let's be
            // safe and adjust for any replies in case this ever changes
            updatedTotalCount += 1 + repliesCount;
        }
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
    } else // Parent comment not found
    error = Error(`Cannot add reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$addCommentToCache = ({ cachedRootComments: cachedRootComments, newComment: newComment, totalCount: totalCount })=>{
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = newComment?.parentId;
    const repliesCount = newComment?.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$addCommentRootToCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$addCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$var$deleteRootCommentInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount })=>{
    let updatedTotalCount = totalCount;
    // Remove the newly resolved comment from the list if we can find it
    // Create a copy of the root comment array without the deleted reply, as the original is readonly
    const updatedRootComments = cachedRootComments.filter((comment)=>comment?.id !== commentId);
    // Decrement total count - currently we can't delete a reply that has any comments, but
    // let's be safe and adjust for any replies in case this ever changes
    updatedTotalCount -= 1 + repliesCount;
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$deleteCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to remove the reply from the top-level comment's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE).  So to remove a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array without the deleted reply, as the original
        // is readonly
        const updatedReplies = (parentComment.replies || []).filter((reply)=>reply?.id !== commentId);
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
        // Decrement total count. Currently we can't delete a reply that has any comments. Also
        // since we can’t have spread fragments in Relay-friendly queries yet, the current
        // CommentReply type doesn't have a `replies` field. And the backend, sends the nested
        // replies to us in a flat list with the correct parentIDs so the FE must manually nest
        // them. But let's adjust the count for replies just in case this ever changes.
        updatedTotalCount -= 1 + repliesCount;
    } else // Parent comment not found
    error = Error(`Cannot delete reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$removeCommentFromCache = ({ cachedRootComments: cachedRootComments, commentId: commentId, totalCount: totalCount })=>{
    // Find the comment to delete to determine if it's a root comment or a reply
    const commentToDelete = (0, $kgNLQ.findCommentInData)(cachedRootComments, commentId);
    if (!commentToDelete) return {
        updatedRootComments: [],
        updatedTotalCount: 0,
        error: new Error(`Cannot delete comment in cache: comment with ID ${commentId} not found`)
    };
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = commentToDelete.parentId;
    const repliesCount = commentToDelete.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$deleteRootCommentInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$deleteCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$export$19f817fe57f17368 = ({ contentId: contentId, options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onCompleted: parentOnCompleted, onError: parentOnError } = options;
    // Shared handling for query errors (initial load and refetch): mark certain errors as handled, then invoke callback.
    // WS-3494 / COMMENTS-188
    const applyQueryErrorHandling = (0, $cozmU.useCallback)((error, callback)=>{
        if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        callback?.(error);
    }, []);
    const handleQueryError = (0, $cozmU.useCallback)((error)=>applyQueryErrorHandling(error, parentOnError), [
        applyQueryErrorHandling,
        parentOnError
    ]);
    // Skip query if no content ID or explicitly skipped
    const shouldSkip = !contentId || !!options.skip;
    const queryResponse = (0, $jMyy4.useQueryInterop)($bd3b81debc212a33$export$a5752cd8da7feaeb, {
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId ?? ''),
        skip: shouldSkip,
        context: {
            single: true
        },
        fetchPolicy: // We auto-batch queries that fire within 10ms of eachother. Since this query is slow, this unbatches it to avoid slowing down everything else
        fetchPolicy,
        onCompleted: (data)=>{
            parentOnCompleted?.(data);
        },
        onError: handleQueryError,
        __callerPackage__: "comments-data-manager"
    });
    const refetch = (0, $cozmU.useCallback)(async ({ onError: refetchOnError } = {})=>{
        try {
            return await queryResponse.refetch();
        } catch (error) {
            applyQueryErrorHandling(error, refetchOnError ?? parentOnError);
        }
    }, [
        queryResponse,
        applyQueryErrorHandling,
        parentOnError
    ]);
    const addCommentInCache = (0, $cozmU.useCallback)(({ newComment: newComment, onError: onError, onCacheMiss: onCacheMiss })=>{
        // If the new comment is a root comment, we need to add it to the root comments list and
        // update the main query's cache and totalCount. If it's a reply, we need to add it to its
        // parent comments's replies list in the cache - but we still  update the whole main query
        // (vs. just update the parent comment itself via a fragment update) because we need to
        // update the main query's totalCount in the cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            let dataProxy = null;
            try {
                dataProxy = (0, $l1uFv.readQueryInterop)({
                    query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                    variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                    __callerPackage__: "comments-data-manager"
                });
            } catch (e) {
                // If cache miss, readQuery throws an error, which we ignore if comment is optimisticResponse.
                // Otherwise rethrow to invoke `onCacheMiss`.
                if ((0, $6mKj3.expValEquals)('confluence_fe_handle_use_all_comments_cache_miss', 'isEnabled', true)) {
                    if (newComment?.id !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID)) onCacheMiss?.(new Error(`Cache miss when adding comment with ID ${newComment?.id} to cache: ${e}`));
                    return;
                }
                throw e;
            }
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy.comments.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$addCommentToCache({
                cachedRootComments: cachedRootComments,
                newComment: newComment,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                },
                __callerPackage__: "comments-data-manager"
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when adding new comment to cache with ID ${newComment?.id}: ${err}`));
        }
    }, [
        contentId
    ]);
    const deleteCommentInCache = (0, $cozmU.useCallback)(({ commentId: commentId, onError: onError, onCacheMiss: onCacheMiss })=>{
        // First, we try to find the comment to determine if it's a root comment or a reply.  If it's a
        // root comment, we need to remove it from the root comments list and update the main query's
        // cache and totalCount. If it's a reply, we need to update its parent comments's replies list
        // in the cache - but we still  update the whole main query (vs. just update the parent comment
        // itself via a fragment update) because we need to update the main query's totalCount in the
        // cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            let dataProxy = null;
            try {
                dataProxy = (0, $l1uFv.readQueryInterop)({
                    query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                    variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                    __callerPackage__: "comments-data-manager"
                });
            } catch (e) {
                if ((0, $6mKj3.expValEquals)('confluence_fe_handle_use_all_comments_cache_miss', 'isEnabled', true)) {
                    onCacheMiss?.(new Error(`Cache miss when deleting comment with ID ${commentId} from cache: ${e}`));
                    return false;
                }
                throw e;
            }
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy.comments.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$removeCommentFromCache({
                cachedRootComments: cachedRootComments,
                commentId: commentId,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return false;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                },
                __callerPackage__: "comments-data-manager"
            });
            return true;
        } catch (err) {
            onError?.(new Error(`An error occurred when deleting cached comment with ID ${commentId}: ${err}`));
            return false;
        }
    }, [
        contentId
    ]);
    return {
        loading: queryResponse.loading,
        error: queryResponse.error,
        refetch: refetch,
        data: queryResponse.data,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    };
};
const $bd3b81debc212a33$export$713a041e7ad7d7c4 = (contentId)=>{
    const dataProxy = (0, $l1uFv.readQueryInterop)({
        query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
        __callerPackage__: "comments-data-manager"
    });
    return dataProxy;
};
module.exports["MAX_COMMENTS_TO_RETURN"] = $bd3b81debc212a33$export$ef1591875b2a95ef;
module.exports["allContentStatuses"] = $bd3b81debc212a33$export$a1c5d5765ca44631;
module.exports["useAllCommentsData"] = $bd3b81debc212a33$export$19f817fe57f17368;
module.exports["getCommentsDataFromCache"] = $bd3b81debc212a33$export$713a041e7ad7d7c4;

});

parcelRegister("1Pttz", function(module, exports) {
/**
 * @generated SignedSource<<88a71c42d0cb01ab5e7d98601a8ad2dc>>
 * @relayHash e661073d22fa388ab2cfa6921674c35d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a72eb2929d0b453a77d38c0daac00993d0e7ed83ff549852056b0cf9f11bcde6
const $e5d3dc3314ebdbc2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAllCommentsDataQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useAllCommentsDataQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "e661073d22fa388ab2cfa6921674c35d",
            "id": "a72eb2929d0b453a77d38c0daac00993d0e7ed83ff549852056b0cf9f11bcde6",
            "metadata": {},
            "name": "useAllCommentsDataQuery",
            "operationKind": "query",
            "text": "query useAllCommentsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$e5d3dc3314ebdbc2$var$node.hash = "776a014f361baa317c627109df7aaaa3";
var $e5d3dc3314ebdbc2$export$2e2bcd8739ae039 = $e5d3dc3314ebdbc2$var$node;
module.exports["default"] = $e5d3dc3314ebdbc2$export$2e2bcd8739ae039;

});

parcelRegister("kDhla", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $8s9DV.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $kBr4q.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $kBr4q.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $kBr4q.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("8SCD6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { contentId: contentId, children: children } = t0;
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    let t1;
    if ($[0] !== isReactionsEnabled) {
        t1 = {
            isReactionsEnabled: isReactionsEnabled
        };
        $[0] = isReactionsEnabled;
        $[1] = t1;
    } else t1 = $[1];
    const reactionsContextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== reactionsContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
            value: reactionsContextValue
        }, children);
        $[2] = children;
        $[3] = reactionsContextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $cozmU.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const queryResult = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "comments-hooks"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first',
        __callerPackage__: "comments-hooks"
    });
    const data = queryResult.data;
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("6lAIr", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $9wGTI = parcelRequire("9wGTI");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");

const $475d5d8641a18b80$var$isParentCommentOpen = (commentData)=>commentData.isOpen;
const $475d5d8641a18b80$var$isInlineLocation = (location)=>{
    return location != null && 'inlineMarkerRef' in location;
};
const $475d5d8641a18b80$var$isParentComment = (comment)=>'isOpen' in comment;
const $475d5d8641a18b80$var$getVisibleGeneralComments = ({ isCommentValid: isCommentValid, comments: comments })=>Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) acc.push({
            ...comment,
            replies: comment.replies.filter((reply)=>reply && isCommentValid(reply))
        });
        return acc;
    }, []);
const $475d5d8641a18b80$var$getNextInlineResolveProperties = (inlineResolveProperties, isDangling)=>{
    if (!inlineResolveProperties) return {};
    return {
        inlineResolveProperties: {
            ...inlineResolveProperties,
            isDangling: isDangling
        }
    };
};
const $475d5d8641a18b80$var$updateCommentLocation = (comment, isDangling)=>{
    const commentLocation = comment.location;
    if (!$475d5d8641a18b80$var$isInlineLocation(commentLocation)) return commentLocation;
    // Preserve the existing location reference when the derived value is unchanged.
    const existingResolveProperties = commentLocation.inlineResolveProperties;
    if (!existingResolveProperties) return commentLocation;
    if (existingResolveProperties.isDangling === isDangling) return commentLocation;
    return {
        ...commentLocation,
        ...$475d5d8641a18b80$var$getNextInlineResolveProperties(commentLocation.inlineResolveProperties, isDangling)
    };
};
const $475d5d8641a18b80$var$getNextComment = (comment, isDangling)=>{
    const nextLocation = $475d5d8641a18b80$var$updateCommentLocation(comment, isDangling);
    if (nextLocation === comment.location) return comment;
    return {
        ...comment,
        location: nextLocation
    };
};
const $475d5d8641a18b80$var$getVisibleInlineComments = (isCommentValid, comments, orderedAnnotationIds, _isNewDanglingCommentExperienceEnabled)=>{
    const activeMarkerRefs = new Set(orderedAnnotationIds);
    const nonDangling = [];
    const dangling = [];
    const validComments = Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) {
            // Reuse the original reply and comment references when filtering changes nothing.
            const filteredReplies = comment.replies.filter(isCommentValid);
            const replies = filteredReplies.length === comment.replies.length ? comment.replies : filteredReplies;
            if (replies === comment.replies) acc.push(comment);
            else acc.push({
                ...comment,
                replies: replies
            });
        }
        return acc;
    }, []);
    for (const comment of validComments){
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        const isDangling = !inlineMarkerRef || !activeMarkerRefs.has(inlineMarkerRef);
        const updatedComment = $475d5d8641a18b80$var$getNextComment(comment, isDangling);
        if (isDangling) dangling.push(updatedComment);
        else nonDangling.push(updatedComment);
    }
    return [
        nonDangling,
        dangling
    ];
};
const $475d5d8641a18b80$export$70df9f207ee9869d = (comment)=>$475d5d8641a18b80$var$isParentComment(comment) ? !$475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
const $475d5d8641a18b80$export$28d3eb19856355d7 = (comment)=>$475d5d8641a18b80$var$isParentComment(comment) ? $475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
const $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList = (comments, orderedAnnotationIds)=>{
    const commentsByMarkerRef = new Map(comments.map((comment)=>{
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        return [
            inlineMarkerRef,
            comment
        ];
    }));
    return orderedAnnotationIds.map((id)=>commentsByMarkerRef.get(id)).filter((comment)=>comment !== undefined);
};
const $475d5d8641a18b80$var$getVisibleInlineThreadsForView = (currentView, sortedNonDanglingComments, danglingComments)=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).OPEN:
            return sortedNonDanglingComments;
        case (0, $3mVfX.ViewValues).DELETED_CONTENT:
            return danglingComments;
        default:
            return [
                ...sortedNonDanglingComments,
                ...danglingComments
            ];
    }
};
const $475d5d8641a18b80$var$getVisibleInlineThreads = ({ isCommentValid: isCommentValid, commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, currentView: currentView, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled })=>{
    const [nonDanglingComments, danglingComments] = $475d5d8641a18b80$var$getVisibleInlineComments(isCommentValid, commentsDataMap.inline, orderedAnnotationIds, isNewDanglingCommentExperienceEnabled);
    const sortedNonDanglingComments = $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList(nonDanglingComments, orderedAnnotationIds);
    const visibleInlineThreadsForView = isNewDanglingCommentExperienceEnabled ? $475d5d8641a18b80$var$getVisibleInlineThreadsForView(currentView, sortedNonDanglingComments, danglingComments) : [
        ...sortedNonDanglingComments,
        ...danglingComments
    ];
    return visibleInlineThreadsForView;
};
const $475d5d8641a18b80$var$getIsCommentValid = ({ currentView: currentView })=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).RESOLVED:
            return $475d5d8641a18b80$export$70df9f207ee9869d;
        default:
            return $475d5d8641a18b80$export$28d3eb19856355d7;
    }
};
// Determine if general comments are enabled based on the user's selection and that the user is not
// in Edit mode. All comments are loaded regardless of the page mode, so since we don't want general
// comments in the list in Edit mode we need to explicitly hide them here.
const $475d5d8641a18b80$var$isGeneralCommentsEnabled = ({ includeGeneralComments: includeGeneralComments, pageMode: pageMode })=>includeGeneralComments && pageMode !== (0, $cD1qu.PageMode).EDIT;
const $475d5d8641a18b80$export$cbe812921774e978 = ({ commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, includeInlineComments: includeInlineComments, includeGeneralComments: includeGeneralComments, currentView: currentView = (0, $3mVfX.ViewValues).OPEN, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled = (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux'), isCommentValid: providedIsCommentValid, pageMode: pageMode })=>{
    const threads = [];
    const isCommentValid = providedIsCommentValid ?? $475d5d8641a18b80$var$getIsCommentValid({
        currentView: currentView
    });
    if (includeInlineComments) {
        const inlineThreads = $475d5d8641a18b80$var$getVisibleInlineThreads({
            isCommentValid: isCommentValid,
            commentsDataMap: commentsDataMap,
            orderedAnnotationIds: orderedAnnotationIds,
            currentView: currentView,
            isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled
        });
        threads.push(...inlineThreads);
    }
    if ($475d5d8641a18b80$var$isGeneralCommentsEnabled({
        includeGeneralComments: includeGeneralComments,
        pageMode: pageMode
    })) {
        const generalThreads = $475d5d8641a18b80$var$getVisibleGeneralComments({
            isCommentValid: isCommentValid,
            comments: commentsDataMap.general
        }).sort((0, $i6UMJ.getCommentsSortedOldestToNewest));
        threads.push(...generalThreads);
    }
    return threads;
};
module.exports["isCommentOpen"] = $475d5d8641a18b80$export$28d3eb19856355d7;
module.exports["getVisibleCommentThreads"] = $475d5d8641a18b80$export$cbe812921774e978;

});

parcelRegister("i6UMJ", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $422HI = parcelRequire("422HI");


var $6faGq = parcelRequire("6faGq");


var $3mVfX = parcelRequire("3mVfX");

var $6ed006a18ff2d87d$export$50c823aead020a09 = /*#__PURE__*/ function(LocationValue) {
    LocationValue["PANEL"] = "panel";
    LocationValue["FOOTER"] = "footer";
    LocationValue["STANDALONE"] = "standalone";
    return LocationValue;
}({});
const $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime = (comment)=>{
    const commentLocation = comment.location;
    const resolvedTime = commentLocation?.inlineResolveProperties?.resolvedTime || commentLocation?.commentResolveProperties?.resolvedTime;
    return resolvedTime || (0, $6faGq.getValidDate)(comment.createdAtNonLocalized).getTime();
};
const $6ed006a18ff2d87d$export$d2935240a910e26e = (currentSort, commentThreads)=>{
    if (currentSort === (0, $3mVfX.SortValues).MOST_RECENT) return [
        ...commentThreads
    ].sort((a, b)=>$6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(b) - $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(a));
    return commentThreads;
};
const $6ed006a18ff2d87d$export$47f9a121266175f = (annotations)=>annotations.map((annotation)=>annotation.threadKey);
const $6ed006a18ff2d87d$export$7119b2a60583b6dc = (marks = [])=>marks.map((mark)=>mark.attrs.id);
const $6ed006a18ff2d87d$export$b02d74cde949c060 = (commentA, commentB)=>(0, $6faGq.getValidDate)(commentA?.createdAtNonLocalized).getTime() - (0, $6faGq.getValidDate)(commentB?.createdAtNonLocalized).getTime();
const $6ed006a18ff2d87d$export$5425fcea1abfd6f7 = (error)=>{
    if (!error) // if falsy, consider it as NOT containing non-reactionsSummary errors
    return true;
    else if (error instanceof (0, $422HI.ApolloErrorInterop) || error instanceof (0, $9B4fQ.ApolloError)) {
        // TODO we will need to migrate to ApolloRelayInterops to get proper error type of ApolloErrorInterop instead of ApolloError
        // after migration, we can remove the instanceof ApolloError check here
        const hasOtherGqlErrors = error.graphQLErrors?.filter((e)=>!e.path?.includes('reactionsSummary'))?.length > 0;
        return !hasOtherGqlErrors && !error.networkError;
    } else // if truthy but not an ApolloErrorInterop, consider it as containing non-reactionsSummary errors
    return false;
};
module.exports["LocationValue"] = $6ed006a18ff2d87d$export$50c823aead020a09;
module.exports["getSortedCommentThreads"] = $6ed006a18ff2d87d$export$d2935240a910e26e;
module.exports["getAnnotationThreadKeys"] = $6ed006a18ff2d87d$export$47f9a121266175f;
module.exports["getMarkIds"] = $6ed006a18ff2d87d$export$7119b2a60583b6dc;
module.exports["getCommentsSortedOldestToNewest"] = $6ed006a18ff2d87d$export$b02d74cde949c060;
module.exports["onlyHasReactionsSummaryErrors"] = $6ed006a18ff2d87d$export$5425fcea1abfd6f7;

});

parcelRegister("6faGq", function(module, exports) {

var $3ejfs = parcelRequire("3ejfs");


var $3iaSn = parcelRequire("3iaSn");

const $fd14f0f09d6b2a27$export$48c62524de3612b3 = (dateString)=>{
    if (!dateString) return new Date(0); // Return earliest possible date if missing
    // Ensure UTC timezone. Some createdAt values are missing the UTC timezone identifier, and some have it
    const normalizedDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
    // Try to parse the date, return earliest date if invalid
    const parsed = new Date(normalizedDate);
    return isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

const $fd14f0f09d6b2a27$export$63880caa66d80fb9 = ({ intl: intl, dateString: dateString, commentStatus: commentStatus = (0, $3iaSn.CommentStatus).OPEN, resolveProperties: resolveProperties, isReply: isReply = false })=>{
    if (!dateString) return '';
    // Get formatted timestamp
    let timestamp;
    try {
        const { formatTimeAgo: formatTimeAgo } = (parcelRequire("1JmNR"));
        timestamp = formatTimeAgo(intl, $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString));
    } catch (error) {
        // Fallback to a simple date format if formatTimeAgo is not available
        const date = $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString);
        timestamp = date.toLocaleDateString(intl.locale);
    }
    // For replies, just return the timestamp without comment status
    if (isReply) return timestamp;
    // Format based on comment status
    switch(commentStatus){
        case (0, $3iaSn.CommentStatus).RESOLVED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                friendlyDate: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).REOPENED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                createdAtNonLocalized: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).OPEN:
        default:
            return intl.formatMessage((0, $3ejfs.commentsi18n).createdTimestamp, {
                timestamp: timestamp
            });
    }
};
module.exports["getValidDate"] = $fd14f0f09d6b2a27$export$48c62524de3612b3;
module.exports["formatTimestampForAriaLabel"] = $fd14f0f09d6b2a27$export$63880caa66d80fb9;

});

parcelRegister("3ejfs", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d1e9edb9f1563526$export$454b2229580969d0 = (0, $kSwu1.defineMessages)({
    resolvedByInfoText: {
        id: "comments-util.resolved.by.info.text",
        defaultMessage: "Resolved by {username} {friendlyDate}"
    },
    reopenedByTooltipTextCommentsPanel: {
        id: "comments-util.reopened.by.tooltip.text.comments.panel",
        defaultMessage: "Added {createdAtNonLocalized}, reopened by {username}"
    },
    createdTimestamp: {
        id: "comments-util.timestamp.created",
        defaultMessage: "created {timestamp}"
    },
    resolvedDateInfoText: {
        id: "comments-util.resolved.date.info.text",
        defaultMessage: "Resolved {friendlyDate}"
    },
    reopenedDateInfoText: {
        id: "comments-util.reopened.date.info.text",
        defaultMessage: "Reopened {friendlyDate}"
    },
    generalCommentTooltip: {
        id: "comments-util.view.tooltip.general.comment",
        defaultMessage: "General comment"
    },
    anonymous: {
        id: "comments-util.display.name.anonymous",
        defaultMessage: "Anonymous"
    },
    editedBy: {
        id: "comments-util.edited.by",
        defaultMessage: "Edited by {username} {at}"
    },
    edited: {
        id: "comments-util.edited",
        defaultMessage: "Edited"
    },
    resolvedByTooltipTextCommentsPanel: {
        id: "comments-util.resolved.by.tooltip.text.comments.panel",
        defaultMessage: "By {username}"
    }
});
module.exports["commentsi18n"] = $d1e9edb9f1563526$export$454b2229580969d0;

});

parcelRegister("3iaSn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c6395b80aeb36ecd$export$4f1057b172870e9c = /*#__PURE__*/ function(CommentStatus) {
    CommentStatus["OPEN"] = "OPEN";
    CommentStatus["RESOLVED"] = "RESOLVED";
    CommentStatus["REOPENED"] = "REOPENED";
    return CommentStatus;
}({});
const $c6395b80aeb36ecd$export$eac30d30628b994a = ({ resolveProperties: resolveProperties })=>{
    return (0, $cozmU.useMemo)(()=>{
        // If no resolve properties, the comment is open
        if (!resolveProperties) return "OPEN";
        // If resolved is false, the comment is reopened
        if (!resolveProperties.resolved) return "REOPENED";
        return "RESOLVED";
    }, [
        resolveProperties
    ]);
};
module.exports["CommentStatus"] = $c6395b80aeb36ecd$export$4f1057b172870e9c;
module.exports["useGetCommentStatus"] = $c6395b80aeb36ecd$export$eac30d30628b994a;

});

parcelRegister("1JmNR", function(module, exports) {
$parcel$export(module.exports, "formatTimeAgo", () => (parcelRequire("1YXTQ")).formatTimeAgo);
$parcel$export(module.exports, "TimeAgo", () => (parcelRequire("1YXTQ")).TimeAgo);
$parcel$export(module.exports, "StaticTimeAgo", () => (parcelRequire("1YXTQ")).StaticTimeAgo);
$parcel$export(module.exports, "formatRelativeTimeAgo", () => (parcelRequire("6gnMn")).formatRelativeTimeAgo);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1YXTQ = parcelRequire("1YXTQ");


var $6gnMn = parcelRequire("6gnMn");


});

parcelRegister("1YXTQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $clUfR = parcelRequire("clUfR");


var $7GLtr = parcelRequire("7GLtr");


var $awd1Q = parcelRequire("awd1Q");


var $bQm3c = parcelRequire("bQm3c");

'use no memo';
const $6f4eb0725770e50a$var$i18n = (0, $kSwu1.defineMessages)({
    now: {
        id: "time-ago.time.now",
        defaultMessage: "now"
    },
    lessThanAMinute: {
        id: "time-ago.time.lessThanAMinute",
        defaultMessage: "less than a minute ago"
    },
    onPreposition: {
        id: "time-ago.prepositions.on",
        defaultMessage: "on {datetime}"
    }
});
const $6f4eb0725770e50a$var$gradation = [
    // Less than 5 seconds -> "now"
    {
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.now)
    },
    // Between 5-45 seconds -> "less than a minute ago"
    {
        threshold: 5,
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.lessThanAMinute)
    },
    // Between 45 seconds-2.5 minutes -> "X minutes ago"
    {
        threshold: 45,
        factor: 60,
        unit: 'minute'
    },
    // Between 2.5-45 minutes -> "X minutes ago" (rounded to 5)
    {
        threshold: 150,
        factor: 60,
        granularity: 5,
        unit: 'minute'
    },
    // Between 45 minutes-24 hours -> "X hours ago"
    {
        threshold: 2700,
        factor: 3600,
        unit: 'hour'
    },
    // After 24 hours -> "full date"
    {
        threshold: 86400,
        format: ({ intl: intl, date: date, locale: locale, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions, timeZone: timeZone, tenantTimeZone: tenantTimeZone })=>{
            const datetime = date.toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: (()=>{
                    // Prefer timeZone if provided, otherwise use tenantTimeZone, otherwise use browser timezone
                    const tz = timeZone || tenantTimeZone || (0, $clUfR.guessTimeZone)();
                    // Validate the timezone, use UTC as fallback for invalid values
                    return (0, $7GLtr.isValidTimeZone)(tz) ? tz : 'Etc/UTC';
                })(),
                ...dateFormatOptions
            });
            if (usePrepositions) return intl.formatMessage($6f4eb0725770e50a$var$i18n.onPreposition, {
                datetime: datetime
            });
            return datetime;
        }
    }
];
const $6f4eb0725770e50a$var$getGradationIndex = (seconds)=>{
    let i = $6f4eb0725770e50a$var$gradation.length - 1;
    while(i > 0 && seconds < ($6f4eb0725770e50a$var$gradation[i].threshold || seconds))i--;
    return i;
};
const $6f4eb0725770e50a$var$getSecondsSince = (date)=>(Date.now() - date.getTime()) / 1000;
const $6f4eb0725770e50a$export$78ae3e68d8c394bc = (intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone)=>{
    const locale = (0, $awd1Q.getTranslation)().locale;
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    const customFormat = $6f4eb0725770e50a$var$gradation[i].format;
    if (customFormat) return customFormat({
        intl: intl,
        date: dateObject,
        locale: locale,
        usePrepositions: usePrepositions,
        dateFormatOptions: dateFormatOptions,
        timeZone: timeZone,
        tenantTimeZone: tenantTimeZone
    });
    const localeLanguage = new Intl.Locale(locale).language;
    const formatter = new Intl.RelativeTimeFormat(localeLanguage, {
        style: 'long',
        numeric: 'auto'
    });
    const granularity = $6f4eb0725770e50a$var$gradation[i].granularity || 1;
    const factor = $6f4eb0725770e50a$var$gradation[i].factor || 1;
    const value = -Math.round(seconds / factor / granularity) * granularity;
    const unit = $6f4eb0725770e50a$var$gradation[i].unit || 'second';
    return formatter.format(value, unit);
};
const $6f4eb0725770e50a$export$fc791eb9f9c39e49 = ({ date: date, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        suppressHydrationWarning: true
    }, $6f4eb0725770e50a$export$78ae3e68d8c394bc(intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone));
};
const $6f4eb0725770e50a$export$9e4a631e7281406a = ({ date: date, ...otherProps })=>{
    const [, setRenders] = (0, $cozmU.useState)(0);
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    (0, $cozmU.useEffect)(()=>{
        if (i != $6f4eb0725770e50a$var$gradation.length - 1) {
            const timeToNextGradation = ($6f4eb0725770e50a$var$gradation[i + 1].threshold || seconds) - seconds;
            const timeout = setTimeout(()=>{
                setRenders((x)=>x + 1);
            }, timeToNextGradation * 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        i,
        seconds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f4eb0725770e50a$export$fc791eb9f9c39e49, {
        date: date,
        ...otherProps
    });
};
module.exports["formatTimeAgo"] = $6f4eb0725770e50a$export$78ae3e68d8c394bc;
module.exports["StaticTimeAgo"] = $6f4eb0725770e50a$export$fc791eb9f9c39e49;
module.exports["TimeAgo"] = $6f4eb0725770e50a$export$9e4a631e7281406a;

});

parcelRegister("clUfR", function(module, exports) {
const $dad8374cf8f904e8$export$c333b33f2586074c = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return 'Etc/UTC';
    }
};
module.exports["guessTimeZone"] = $dad8374cf8f904e8$export$c333b33f2586074c;

});

parcelRegister("7GLtr", function(module, exports) {
const $0e3ee782c26ab488$export$c793e14020d7c7b = (timeZone)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
module.exports["isValidTimeZone"] = $0e3ee782c26ab488$export$c793e14020d7c7b;

});

parcelRegister("6gnMn", function(module, exports) {

var $jb2R2 = parcelRequire("jb2R2");

var $bg9GW = parcelRequire("bg9GW");

var $fNtG8 = parcelRequire("fNtG8");

var $jgqX6 = parcelRequire("jgqX6");

var $hnDzv = parcelRequire("hnDzv");


var $kSwu1 = parcelRequire("kSwu1");

const $926347e03f273aaa$var$i18n = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "time-ago.relative.just-now",
        defaultMessage: "Just now"
    },
    minutesAgo: {
        id: "time-ago.relative.minutes-ago",
        defaultMessage: "{minuteCount} {minuteCount, plural, one {minute} other {minutes}} ago"
    },
    hoursAgo: {
        id: "time-ago.relative.hours-ago",
        defaultMessage: "{hourCount} {hourCount, plural, one {hour} other {hours}} ago"
    },
    daysAgo: {
        id: "time-ago.relative.days-ago",
        defaultMessage: "{dayCount} {dayCount, plural, one {day} other {days}} ago"
    },
    monthsAgo: {
        id: "time-ago.relative.months-ago",
        defaultMessage: "{monthCount} {monthCount, plural, one {month} other {months}} ago"
    },
    yearsAgo: {
        id: "time-ago.relative.years-ago",
        defaultMessage: "{yearCount} {yearCount, plural, one {year} other {years}} ago"
    }
});
const $926347e03f273aaa$export$b77ccb75f39eecf = (date, intl, now = new Date())=>{
    const dateObject = new Date(date);
    const minutesDiff = (0, $fNtG8.default)(now, dateObject);
    const hoursDiff = (0, $bg9GW.default)(now, dateObject);
    const daysDiff = (0, $jb2R2.default)(now, dateObject);
    const monthsDiff = (0, $jgqX6.default)(now, dateObject);
    const yearsDiff = (0, $hnDzv.default)(now, dateObject);
    if (minutesDiff < 1) return intl.formatMessage($926347e03f273aaa$var$i18n.justNow);
    if (minutesDiff < 60) return intl.formatMessage($926347e03f273aaa$var$i18n.minutesAgo, {
        minuteCount: minutesDiff
    });
    if (hoursDiff < 24) return intl.formatMessage($926347e03f273aaa$var$i18n.hoursAgo, {
        hourCount: hoursDiff
    });
    if (daysDiff < 31) return intl.formatMessage($926347e03f273aaa$var$i18n.daysAgo, {
        dayCount: daysDiff
    });
    if (monthsDiff < 12) return intl.formatMessage($926347e03f273aaa$var$i18n.monthsAgo, {
        monthCount: monthsDiff
    });
    return intl.formatMessage($926347e03f273aaa$var$i18n.yearsAgo, {
        yearCount: yearsDiff
    });
};
module.exports["formatRelativeTimeAgo"] = $926347e03f273aaa$export$b77ccb75f39eecf;

});

parcelRegister("a6t12", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $hSs5g = parcelRequire("hSs5g");


var $9zU5G = parcelRequire("9zU5G");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $bedVD = parcelRequire("bedVD");


var $l7wqU = parcelRequire("l7wqU");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$ba990269c861f33b = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, followedRef: followedRef, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7wqU.FeedFollowAction), {
            userId: userId
        }),
        id: 'feed-follow-user',
        callback: ()=>getToggleFollowUser(userId, followedRef.current, 'profileCard')(),
        shouldRender: ()=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId
    });
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel, agent: agent })=>{
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = reportingLines.href;
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }), [
        userProfile
    ]);
    const followUserAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // The card snapshots the actions, so the follow callback reads the latest follow state
    // from this ref (updated on every render) instead of a value captured when the action
    // was built. This keeps repeated follow/unfollow toggles in the correct direction.
    const followedRef = (0, $cozmU.useRef)(false);
    followedRef.current = !!(userId && followedUsers?.includes(userId));
    const followUserActionNext = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$ba990269c861f33b({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            followedRef: followedRef,
            userId: userId
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        getReportingLinesUserProfile(clickedUserId_0).onNavigate();
        return false;
    };
    if ((0, $9wGTI.fg)('people-teams_migrate-user-profile-card') || (0, $6mKj3.expValEquals)('pt_user_profile_card_migration_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        cloudId: cloudId,
        orgId: orgId || '',
        userId: userId,
        viewerId: loggedInUserId,
        placement: position,
        offset: offset,
        trigger: trigger,
        actions: [
            followUserActionNext
        ],
        agent: agent ? {
            ...agent,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags)
        } : undefined,
        ...disabledAriaAttributes ? {} : {
            ariaLabel: ariaLabel
        },
        testId: "profileCardTrigger"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            onVisibilityChange: onVisibilityChange,
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $eW61a = parcelRequire("eW61a");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $eW61a.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $eW61a = parcelRequire("eW61a");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $eW61a.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("bedVD", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");

const $e4e11ee9fe4a88c9$var$i18n = (0, $kSwu1.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("l7wqU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");

const $460a3972eab8fd69$export$38809e1c08e05a16 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { userId: userId } = t0;
    const { followedUsers: followedUsers } = (0, $4GlQ9.useFeedFollow)();
    let t1;
    if ($[0] !== followedUsers || $[1] !== userId) {
        t1 = userId && followedUsers?.includes(userId);
        $[0] = followedUsers;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const followed = !!t1;
    let t2;
    if ($[3] !== followed) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        });
        $[3] = followed;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["FeedFollowAction"] = $460a3972eab8fd69$export$38809e1c08e05a16;

});

parcelRegister("4GlQ9", function(module, exports) {

var $k7Nop = parcelRequire("k7Nop");


var $hOSkW = parcelRequire("hOSkW");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $hOSkW.default);
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $k7Nop.default);
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $jMyy4.useQueryInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error),
        __callerPackage__: "profile"
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $308Wd.useMutationInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            }
        ],
        __callerPackage__: "profile"
    });
    const followedUsersRaw = data?.getFeedUserConfig?.accountIds;
    const followedUsers = followedUsersRaw ? followedUsersRaw.map((id)=>id ?? null) : undefined;
    const getToggleFollowUser = (0, $cozmU.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch  {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers ?? []
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("k7Nop", function(module, exports) {
/**
 * @generated SignedSource<<faabaa80182918f5d00c229b25800acb>>
 * @relayHash 564d8ad9d36377c3d791529bbbb8a24b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c
const $2274f77c1a29b092$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "follow"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "unfollow"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "follow"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollow"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "564d8ad9d36377c3d791529bbbb8a24b",
            "id": "5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c",
            "metadata": {},
            "name": "useFeedFollowFeedFollowMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedFollowFeedFollowMutation($follow:[ID],$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow,unfollowUsers:$unfollow}){success}}"
        }
    };
}();
$2274f77c1a29b092$var$node.hash = "7ecf9b28db7400fffab67e3a3c52027c";
var $2274f77c1a29b092$export$2e2bcd8739ae039 = $2274f77c1a29b092$var$node;
module.exports["default"] = $2274f77c1a29b092$export$2e2bcd8739ae039;

});

parcelRegister("hOSkW", function(module, exports) {
/**
 * @generated SignedSource<<597a7b2d7b3333c8532a887f4cdcbd48>>
 * @relayHash bc87c04b481deeaeaae914ab875dc44e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b
const $eeb53afb4cc8b670$var$node = function() {
    var v0 = [
        {
            "concreteType": "FollowingFeedGetUserConfig",
            "kind": "LinkedField",
            "name": "getFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bc87c04b481deeaeaae914ab875dc44e",
            "id": "11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b",
            "metadata": {},
            "name": "useFeedFollowFeedFollowQuery",
            "operationKind": "query",
            "text": "query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}"
        }
    };
}();
$eeb53afb4cc8b670$var$node.hash = "73bdcd7f6c8309a4d0a16e77fd4c5fed";
var $eeb53afb4cc8b670$export$2e2bcd8739ae039 = $eeb53afb4cc8b670$var$node;
module.exports["default"] = $eeb53afb4cc8b670$export$2e2bcd8739ae039;

});

parcelRegister("bumSD", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $5hJlu = parcelRequire("5hJlu");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $dOBRD.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $5hJlu.default)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $34knR = parcelRequire("34knR");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");


var $c0rhi = parcelRequire("c0rhi");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $34knR.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        const UserProfileClientForConfluencePromise = (0, $c0rhi.queryInterop)({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            },
            __callerPackage__: "profile"
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("ldOrZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {

var $ay9Uu = parcelRequire("ay9Uu");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $ay9Uu.default);
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("ay9Uu", function(module, exports) {
/**
 * @generated SignedSource<<c8072e566be2615c9f169051b183f1d7>>
 * @relayHash e3b7fcde55b949bf8d80bddd9a0ac180
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d
const $bb661b120eec94ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e3b7fcde55b949bf8d80bddd9a0ac180",
            "id": "ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d",
            "metadata": {},
            "name": "UserProfileClientForConfluenceQuery",
            "operationKind": "query",
            "text": "query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false,id:$userId){id,confluence{permissionType}},entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$bb661b120eec94ae$var$node.hash = "f636f7ede64e4c0d1757767b061d53b5";
var $bb661b120eec94ae$export$2e2bcd8739ae039 = $bb661b120eec94ae$var$node;
module.exports["default"] = $bb661b120eec94ae$export$2e2bcd8739ae039;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("gj42z", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kSwu1 = parcelRequire("kSwu1");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        defaultMessage: "We\u2019re having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("8lYIw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7fpiF = parcelRequire("7fpiF");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");

const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { target: t0, name: name, href: t1, to: t2, params: t3 } = props;
    const target = t0 === undefined ? undefined : t0;
    const href = t1 === undefined ? null : t1;
    const to = t2 === undefined ? null : t2;
    const params = t3 === undefined ? {} : t3;
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) {
        let t4;
        if ($[0] !== props || $[1] !== ref) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
                ...props,
                ref: ref,
                path: ""
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t4;
        } else t4 = $[2];
        return t4;
    }
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    let t4;
    if ($[3] !== match || $[4] !== path || $[5] !== props || $[6] !== ref || $[7] !== target) {
        t4 = match && target !== "_blank" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
            ...props,
            ref: ref,
            match: match
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
            ...props,
            ref: ref,
            path: path
        });
        $[3] = match;
        $[4] = path;
        $[5] = props;
        $[6] = ref;
        $[7] = target;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let parentProps;
    let path;
    if ($[0] !== t0) {
        ({ path: path, ...parentProps } = t0);
        $[0] = t0;
        $[1] = parentProps;
        $[2] = path;
    } else {
        parentProps = $[1];
        path = $[2];
    }
    const { children: children, className: className, target: t1, testId: testId, style: style, id: id } = parentProps;
    const target = t1 === undefined ? undefined : t1;
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    let t2;
    if ($[3] !== onPageReload || $[4] !== parentProps) {
        t2 = (e)=>{
            onPageReload(e.target.getAttribute("href"), false);
            if (parentProps.onClick) parentProps.onClick(e);
        };
        $[3] = onPageReload;
        $[4] = parentProps;
        $[5] = t2;
    } else t2 = $[5];
    const onAnchorLinkClick = t2;
    let t3;
    if ($[6] !== parentProps) {
        t3 = (e_0)=>{
            parentProps.onContextMenu?.(e_0);
        };
        $[6] = parentProps;
        $[7] = t3;
    } else t3 = $[7];
    const onAnchorContextMenuClick = t3;
    const t4 = target === "_blank" ? "noreferrer" : undefined;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[8] !== children || $[9] !== className || $[10] !== id || $[11] !== onAnchorContextMenuClick || $[12] !== onAnchorLinkClick || $[13] !== path || $[14] !== ref || $[15] !== style || $[16] !== t4 || $[17] !== t5 || $[18] !== target || $[19] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
            href: path,
            className: className,
            onClick: onAnchorLinkClick,
            onContextMenu: onAnchorContextMenuClick,
            target: target,
            id: id,
            rel: t4,
            "data-testid": testId,
            ref: ref,
            "aria-label": t5,
            style: style
        }, children);
        $[8] = children;
        $[9] = className;
        $[10] = id;
        $[11] = onAnchorContextMenuClick;
        $[12] = onAnchorLinkClick;
        $[13] = path;
        $[14] = ref;
        $[15] = style;
        $[16] = t4;
        $[17] = t5;
        $[18] = target;
        $[19] = testId;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(22);
    let match;
    let parentProps;
    if ($[0] !== t0) {
        ({ match: match, ...parentProps } = t0);
        $[0] = t0;
        $[1] = match;
        $[2] = parentProps;
    } else {
        match = $[1];
        parentProps = $[2];
    }
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    let t1;
    if ($[3] !== match || $[4] !== preloadRoute) {
        t1 = async ()=>preloadRoute(match);
        $[3] = match;
        $[4] = preloadRoute;
        $[5] = t1;
    } else t1 = $[5];
    const onMouseDownCapture = t1;
    let t2;
    if ($[6] !== parentProps || $[7] !== routesContext) {
        t2 = (event)=>{
            if (parentProps.onClick) parentProps.onClick(event);
            const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
            if (!event.defaultPrevented && details?.href) {
                event.preventDefault();
                routesContext.push(details.href);
            }
        };
        $[6] = parentProps;
        $[7] = routesContext;
        $[8] = t2;
    } else t2 = $[8];
    const onClick = t2;
    let t3;
    if ($[9] !== parentProps) {
        t3 = (e)=>{
            parentProps.onContextMenu?.(e);
        };
        $[9] = parentProps;
        $[10] = t3;
    } else t3 = $[10];
    const onContextMenu = t3;
    const t4 = `${match.pathname}${match.search}${match.hash}`;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[11] !== children || $[12] !== className || $[13] !== id || $[14] !== onClick || $[15] !== onContextMenu || $[16] !== onMouseDownCapture || $[17] !== ref || $[18] !== style || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7fpiF.Link), {
            to: t4,
            className: className,
            onClick: onClick,
            onContextMenu: onContextMenu,
            onMouseDownCapture: onMouseDownCapture,
            innerRef: ref,
            id: id,
            "aria-label": t5,
            style: style
        }, children);
        $[11] = children;
        $[12] = className;
        $[13] = id;
        $[14] = onClick;
        $[15] = onContextMenu;
        $[16] = onMouseDownCapture;
        $[17] = ref;
        $[18] = style;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
});
module.exports["Link"] = $9673d4c78655a9a1$export$a6c7ac8248d6e38a;

});

parcelRegister("7fpiF", function(module, exports) {

var $KDAt0 = parcelRequire("KDAt0");


var $cgTkH = parcelRequire("cgTkH");


var $cozmU = parcelRequire("cozmU");


var $22s37 = parcelRequire("22s37");




var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $bB0i2 = parcelRequire("bB0i2");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $546d8f2c65102c44$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $546d8f2c65102c44$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
var $546d8f2c65102c44$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $546d8f2c65102c44$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $22s37.createLocation)(to, null, null, currentLocation) : to;
};
var $546d8f2c65102c44$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef === "undefined") $546d8f2c65102c44$var$forwardRef = $546d8f2c65102c44$var$forwardRefShim;
function $546d8f2c65102c44$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $546d8f2c65102c44$var$LinkAnchor = $546d8f2c65102c44$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1eVGO.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $eb3ax.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$546d8f2c65102c44$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $546d8f2c65102c44$export$a6c7ac8248d6e38a = $546d8f2c65102c44$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $546d8f2c65102c44$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1eVGO.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bB0i2.default)(false);
        var history = context.history;
        var location = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $eb3ax.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $546d8f2c65102c44$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $22s37.createPath)(context.location) === (0, $22s37.createPath)($546d8f2c65102c44$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(component, props);
    });
});
var $546d8f2c65102c44$var$toType, $546d8f2c65102c44$var$refType;
var $546d8f2c65102c44$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef$1 === "undefined") $546d8f2c65102c44$var$forwardRef$1 = $546d8f2c65102c44$var$forwardRefShim$1;
function $546d8f2c65102c44$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $546d8f2c65102c44$export$b0d92dbee9b5b60d = $546d8f2c65102c44$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1eVGO.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bB0i2.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $KDAt0.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $546d8f2c65102c44$var$joinClassnames(className, activeClassName);
            style = (0, $eb3ax.default)({}, style, activeStyle);
        }
        var props = (0, $eb3ax.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim$1 !== $546d8f2c65102c44$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($546d8f2c65102c44$export$a6c7ac8248d6e38a, props);
    });
});
var $546d8f2c65102c44$var$ariaCurrentType;
 //# sourceMappingURL=react-router-dom.js.map
module.exports["Link"] = $546d8f2c65102c44$export$a6c7ac8248d6e38a;

});

parcelRegister("22s37", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $5hfGv = parcelRequire("5hfGv");


var $ucZb7 = parcelRequire("ucZb7");



var $bB0i2 = parcelRequire("bB0i2");

function $17c186b078d80207$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $17c186b078d80207$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $17c186b078d80207$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $17c186b078d80207$var$stripBasename(path, prefix) {
    return $17c186b078d80207$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $17c186b078d80207$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $17c186b078d80207$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $17c186b078d80207$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $17c186b078d80207$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $17c186b078d80207$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $eb3ax.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $5hfGv.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $17c186b078d80207$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $ucZb7.default)(a.state, b.state);
}
function $17c186b078d80207$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $17c186b078d80207$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $17c186b078d80207$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $17c186b078d80207$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $17c186b078d80207$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $17c186b078d80207$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $17c186b078d80207$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $17c186b078d80207$var$PopStateEvent = 'popstate';
var $17c186b078d80207$var$HashChangeEvent = 'hashchange';
function $17c186b078d80207$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $17c186b078d80207$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $bB0i2.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $17c186b078d80207$var$supportsHistory();
    var needsHashChangeListener = !$17c186b078d80207$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($17c186b078d80207$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($17c186b078d80207$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($17c186b078d80207$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $17c186b078d80207$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $17c186b078d80207$var$HashChangeEvent$1 = 'hashchange';
var $17c186b078d80207$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $17c186b078d80207$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $17c186b078d80207$var$stripLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    },
    slash: {
        encodePath: $17c186b078d80207$var$addLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    }
};
function $17c186b078d80207$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $17c186b078d80207$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $17c186b078d80207$var$pushHashPath(path) {
    window.location.hash = path;
}
function $17c186b078d80207$var$replaceHashPath(path) {
    window.location.replace($17c186b078d80207$var$stripHash(window.location.href) + '#' + path);
}
function $17c186b078d80207$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $bB0i2.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $17c186b078d80207$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $17c186b078d80207$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($17c186b078d80207$var$getHashPath());
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $17c186b078d80207$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $17c186b078d80207$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $17c186b078d80207$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $17c186b078d80207$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $17c186b078d80207$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $17c186b078d80207$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $17c186b078d80207$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $17c186b078d80207$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $17c186b078d80207$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $17c186b078d80207$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $17c186b078d80207$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, createKey()) : $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $17c186b078d80207$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $17c186b078d80207$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}
module.exports["createPath"] = $17c186b078d80207$export$fe53371bee54353d;
module.exports["createLocation"] = $17c186b078d80207$export$90c043f1c57770b8;
module.exports["createBrowserHistory"] = $17c186b078d80207$export$719fc203c4e16dee;
module.exports["createHashHistory"] = $17c186b078d80207$export$b71fdd3798280242;

});

parcelRegister("c1UWH", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

class $992a1265dc051ead$var$UnreadCommentsIntersectionObserver {
    createObserver() {
        try {
            if (typeof IntersectionObserver === 'undefined') return;
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    const commentId = entry.target.getAttribute('data-comment-id');
                    if (!commentId) return;
                    if (entry.isIntersecting) {
                        // Comment became visible - set new timer for this specific comment
                        const timer = setTimeout(()=>{
                            this.intersectionCallbacks.forEach((callback)=>{
                                callback(commentId);
                            });
                            // Clear the timer for this comment
                            this.commentTimersMap.delete(commentId);
                            // Unobserve this element since it's been processed
                            if (this.observer && typeof this.observer.unobserve === 'function') {
                                this.observer.unobserve(entry.target);
                                this.observedElementsSet.delete(entry.target);
                            }
                        }, 2000); // 2 seconds default
                        this.commentTimersMap.set(commentId, timer);
                    } else // Comment became invisible - clear timer for this comment
                    if (this.commentTimersMap.has(commentId)) {
                        clearTimeout(this.commentTimersMap.get(commentId));
                        this.commentTimersMap.delete(commentId);
                    }
                });
            }, {
                threshold: [
                    0.25
                ],
                // add a bottom root margin to account for sticky elements at the bottom of the observable viewport such as the sticky footer
                // this is because the intersection observer doesn't know about elements that are above the observed comments, and so we can avoid
                // marking comments as read when they're not actually visible to the user. this is a best effort approach
                rootMargin: '0px 0px -65px 0px',
                // Add a custom name to identify this as the unread comments observer
                // This helps in tests to distinguish it from other intersection observers
                name: 'unreadCommentsObserver'
            });
            // Only set observer if it has the required methods
            if (observer && typeof observer.disconnect === 'function' && typeof observer.observe === 'function' && typeof observer.unobserve === 'function') this.observer = observer;
            else this.observer = null;
        } catch  {
            this.observer = null;
        }
    }
    observeComment(targetElement) {
        // don't observe if the observer is not initialized
        if (!this.observer) return;
        // don't observe if the targetElement is not a valid element
        if (!targetElement) return;
        // don't observe the same element twice
        if (this.observedElementsSet.has(targetElement)) return;
        this.observer.observe(targetElement);
        this.observedElementsSet.add(targetElement);
    }
    unobserveComment(targetElement) {
        // don't unobserve if the observer is not initialized
        if (!this.observer) return;
        // don't unobserve if the targetElement is not a valid element
        if (!targetElement) return;
        // only unobserve if we're actually observing this element
        if (!this.observedElementsSet.has(targetElement)) return;
        // Clear any running timer for this comment
        const commentId = targetElement.getAttribute('data-comment-id');
        if (commentId && this.commentTimersMap.has(commentId)) {
            clearTimeout(this.commentTimersMap.get(commentId));
            this.commentTimersMap.delete(commentId);
        }
        this.observer.unobserve(targetElement);
        this.observedElementsSet.delete(targetElement);
    }
    // By exposing this function, we allow consumers to register callbacks
    registerIntersectionCallback(callback) {
        this.intersectionCallbacks.push(callback);
    }
    deregisterIntersectionCallback(callback) {
        this.intersectionCallbacks = this.intersectionCallbacks.filter((cb)=>cb !== callback);
    }
    // Reconnect the observer if it was disconnected
    reconnect() {
        if (!this.observer) this.createObserver();
    }
    // Clean up method
    disconnect() {
        if (this.observer && typeof this.observer.disconnect === 'function') {
            this.observer.disconnect();
            this.observer = null;
        }
        // Clear all timers
        this.commentTimersMap.forEach((timer)=>clearTimeout(timer));
        this.commentTimersMap.clear();
        // Clear observed elements
        this.observedElementsSet.clear();
        // Clear callbacks
        this.intersectionCallbacks = [];
    }
    constructor(){
        this.observer = null;
        this.commentTimersMap = new Map();
        this.observedElementsSet = new Set();
        this.intersectionCallbacks = [];
        this.createObserver();
    }
}
// memoize ensures an IntersectionObserver is instantiated only once
const $992a1265dc051ead$var$getStableIntersectionObserver = (0, $dOBRD.default)(()=>{
    return new $992a1265dc051ead$var$UnreadCommentsIntersectionObserver();
});
const $992a1265dc051ead$export$ad65f5516d9692ed = ()=>{
    const intersectionObserver = $992a1265dc051ead$var$getStableIntersectionObserver();
    intersectionObserver.reconnect();
    return intersectionObserver;
};
module.exports["getUnreadCommentsIntersectionObserver"] = $992a1265dc051ead$export$ad65f5516d9692ed;

});

parcelRegister("1czFr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gi0WF = parcelRequire("gi0WF");

const $e63c8ea486e09ced$export$faaf0da9552bb131 = (debounceMs = 1000)=>{
    const markCommentsAsRead = (0, $gi0WF.useMarkCommentsAsRead)();
    const pendingCommentIds = (0, $cozmU.useRef)(new Set());
    const timeoutRef = (0, $cozmU.useRef)(null);
    const beforeUnloadHandlerRef = (0, $cozmU.useRef)(null);
    const debouncedMarkCommentsAsRead = (0, $cozmU.useCallback)((commentId)=>{
        // Add the comment ID to the pending set
        pendingCommentIds.current.add(commentId);
        // Clear any existing timeout
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        // Set a new timeout to batch and send the request
        timeoutRef.current = setTimeout(()=>{
            const commentIdsToMark = Array.from(pendingCommentIds.current);
            // Clear the pending set
            pendingCommentIds.current.clear();
            // Reset the timeout ref
            timeoutRef.current = null;
            // Only call the mutation if there are comments to mark
            if (commentIdsToMark.length > 0) markCommentsAsRead(commentIdsToMark);
        }, debounceMs);
    }, [
        markCommentsAsRead,
        debounceMs
    ]);
    // Function to send pending comment IDs
    const sendPendingComments = (0, $cozmU.useCallback)(()=>{
        const commentIdsToMark = Array.from(pendingCommentIds.current);
        if (commentIdsToMark.length === 0) return;
        // Clear the pending set
        pendingCommentIds.current.clear();
        // Just call the existing mutation function
        markCommentsAsRead(commentIdsToMark);
    }, [
        markCommentsAsRead
    ]);
    // Beforeunload event handler (e.g. when the user closes the tab or window)
    const handleBeforeUnload = (0, $cozmU.useCallback)((_event)=>{
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    // Set up beforeunload event listener
    (0, $cozmU.useEffect)(()=>{
        beforeUnloadHandlerRef.current = handleBeforeUnload;
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [
        handleBeforeUnload
    ]);
    // Flush pending comments and clear timeout
    const flushPendingComments = (0, $cozmU.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        // Send any pending comments
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    return {
        debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead,
        flushPendingComments: flushPendingComments
    };
};
module.exports["useDebouncedMarkCommentsAsRead"] = $e63c8ea486e09ced$export$faaf0da9552bb131;

});

parcelRegister("gi0WF", function(module, exports) {

var $8rdFk = parcelRequire("8rdFk");


var $cozmU = parcelRequire("cozmU");


var $308Wd = parcelRequire("308Wd");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bMmYR = parcelRequire("bMmYR");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");

const $170c9bba7ed44542$var$markCommentsAsReadMutation = (0, $8rdFk.default);
const $170c9bba7ed44542$export$db614d7d47784b95 = ()=>{
    const [markCommentsAsRead] = (0, $308Wd.useMutationInterop)($170c9bba7ed44542$var$markCommentsAsReadMutation, {
        __callerPackage__: "unread-comments"
    });
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const markCommentsAsReadFn = (0, $cozmU.useCallback)(async (commentIds)=>{
        if (commentIds.length === 0) return;
        // Start experience tracking for marking comments as read
        experienceTracker.start({
            name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
            attributes: {
                commentIds: commentIds,
                commentCount: commentIds.length
            }
        });
        let attemptNumber = 1;
        try {
            const result = await (0, $bMmYR.retry)(async (attempt)=>{
                attemptNumber = attempt + 1;
                return await markCommentsAsRead({
                    variables: {
                        commentIds: commentIds
                    }
                });
            }, {}, async (error)=>{
                // Don't retry for expected errors (403/unauthorized, network errors)
                return !(0, $1uFM6.isUnauthorizedError)(error) && !(0, $6fil2.containsNetworkError)(error);
            });
            // Check if the mutation succeeded
            if (result?.data?.markCommentsAsRead?.success) // Mark experience as successful
            experienceTracker.succeed({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                attributes: {
                    commentIds: commentIds,
                    commentCount: commentIds.length,
                    attemptNumber: attemptNumber
                }
            });
            else // Backend returned success: false
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: new Error('Backend returned success: false'),
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
        } catch (err) {
            // Handle expected errors (403/unauthorized, network errors) - abort experience tracking
            if ((0, $1uFM6.isUnauthorizedError)(err) || (0, $6fil2.containsNetworkError)(err)) {
                experienceTracker.abort({
                    name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                    reason: 'Expected error (unauthorized or network error)'
                });
                (0, $7Sm4c.markErrorAsHandled)(err);
                return;
            }
            // Mark experience as failed for unexpected errors
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: err,
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
            // Handle unexpected errors (including 500) - track them with context
            (0, $fJlJm.setContentErrorAttributes)(err, {
                objectType: 'comment'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(err);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- experienceTracker from context doesn't need to be in deps
    [
        markCommentsAsRead
    ]);
    return markCommentsAsReadFn;
};
module.exports["useMarkCommentsAsRead"] = $170c9bba7ed44542$export$db614d7d47784b95;

});

parcelRegister("8rdFk", function(module, exports) {
/**
 * @generated SignedSource<<fede2250a28c1036d502c7a0d09fbbf6>>
 * @relayHash 446a6fa3fbbe8bbb4444e858a1c7626c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2666786691a2a90a6a0d6434d55d4758dfc395b6e9ba53c0598118cccde4da14
const $4a78b10481ac8443$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "commentIds",
                            "variableName": "commentIds"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MarkCommentsAsReadPayload",
            "kind": "LinkedField",
            "name": "markCommentsAsRead",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "kind": "ScalarField",
                    "name": "errors"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMarkCommentsAsReadMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMarkCommentsAsReadMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "446a6fa3fbbe8bbb4444e858a1c7626c",
            "id": "2666786691a2a90a6a0d6434d55d4758dfc395b6e9ba53c0598118cccde4da14",
            "metadata": {},
            "name": "useMarkCommentsAsReadMutation",
            "operationKind": "mutation",
            "text": "mutation useMarkCommentsAsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success,errors}}"
        }
    };
}();
$4a78b10481ac8443$var$node.hash = "d155280f920b93703b5ae452997bdcaf";
var $4a78b10481ac8443$export$2e2bcd8739ae039 = $4a78b10481ac8443$var$node;
module.exports["default"] = $4a78b10481ac8443$export$2e2bcd8739ae039;

});

parcelRegister("e4kZB", function(module, exports) {
const $5243889752facbc2$export$446c7c25f5f55821 = (comment)=>{
    return {
        id: comment.id,
        author: {
            accountId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined
        },
        createdAt: {
            value: comment.createdAt?.value || ''
        },
        location: {
            type: comment.location.type,
            inlineMarkerRef: comment.location?.inlineMarkerRef,
            inlineResolveProperties: comment.location?.inlineResolveProperties,
            commentResolveProperties: comment.location?.commentResolveProperties
        }
    };
};
const $5243889752facbc2$export$77349abd6de54bd8 = ({ commentId: commentId, userId: userId, createdAt: createdAt, commentType: commentType, resolveProperties: resolveProperties })=>{
    return {
        id: commentId,
        author: {
            accountId: userId || undefined
        },
        createdAt: {
            value: createdAt || ''
        },
        location: {
            type: commentType,
            ...commentType === 'INLINE' ? {
                inlineResolveProperties: resolveProperties || {
                    resolved: false
                }
            } : {
                commentResolveProperties: resolveProperties || {
                    resolved: false
                }
            }
        }
    };
};
const $5243889752facbc2$export$8df0b6c8bcdda615 = ({ pageMode: pageMode = 'view', annotationsInEditorDoc: annotationsInEditorDoc, rendererAnnotations: rendererAnnotations })=>(markerRef)=>{
        if (!markerRef) return false; // default to false if no marker ref
        // Treat 'live' mode as 'edit' mode
        const effectivePageMode = pageMode === 'live' ? 'edit' : pageMode;
        return effectivePageMode === 'view' ? !rendererAnnotations.has(markerRef) : !annotationsInEditorDoc.has(markerRef);
    };
const $5243889752facbc2$export$22ce26f7ba09f326 = ({ comment: comment, currentUserId: currentUserId, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback })=>{
    // Early return if comment is already viewed
    if (viewedComments.has(comment.id)) return false;
    const isNotOwnComment = comment.author?.accountId && comment.author.accountId !== currentUserId;
    const createdLast30Days = new Date(comment.createdAt?.value) > new Date(Date.now() - 2592000000);
    const commentLocation = comment?.location;
    const markerRef = commentLocation?.inlineMarkerRef;
    const isDanglingInlineComment = isDanglingCallback ? isDanglingCallback(markerRef) : false;
    const isPageComment = comment?.location.type === 'FOOTER';
    const isResolved = comment?.location?.inlineResolveProperties?.resolved || comment?.location?.commentResolveProperties?.resolved;
    return !isResolved && isNotOwnComment && createdLast30Days && (!isDanglingInlineComment || isPageComment);
};
const $5243889752facbc2$export$92c1e243fe45a57f = async ({ allComments: allComments, currentUserId: currentUserId, pageId: pageId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, resetStates: resetStates, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback })=>{
    if (!allComments || !pageId) return;
    const unreadCommentIds = new Set();
    allComments.forEach((comment)=>{
        if (!comment) return;
        if (currentUserId) {
            const parentCommentForValidation = $5243889752facbc2$export$446c7c25f5f55821(comment);
            if ($5243889752facbc2$export$22ce26f7ba09f326({
                comment: parentCommentForValidation,
                currentUserId: currentUserId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) unreadCommentIds.add(comment.id);
            if (comment.replies) comment.replies.forEach((reply)=>{
                if (reply) {
                    const replyForValidation = $5243889752facbc2$export$446c7c25f5f55821(reply);
                    if ($5243889752facbc2$export$22ce26f7ba09f326({
                        comment: replyForValidation,
                        currentUserId: currentUserId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) unreadCommentIds.add(reply.id);
                }
            });
        }
    });
    updateUnreadCommentIDSet(unreadCommentIds, 'initialize');
    // Once we are done updating the unread list, need to reset the states.
    resetStates();
};
module.exports["buildValidationObjectFromProps"] = $5243889752facbc2$export$77349abd6de54bd8;
module.exports["commentIsDangling"] = $5243889752facbc2$export$8df0b6c8bcdda615;
module.exports["isValidUnreadComment"] = $5243889752facbc2$export$22ce26f7ba09f326;
module.exports["createUnreadCommentsSet"] = $5243889752facbc2$export$92c1e243fe45a57f;

});

parcelRegister("fs6LW", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $arQY7 = parcelRequire("arQY7");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $buxP3.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    blockBase: (0, $buxP3.xcss)({
        display: 'flex'
    }),
    cursor: (0, $buxP3.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset, isBlockLevel: t4 } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const isBlockLevel = t4 === undefined ? false : t4;
    const intl = (0, $kSwu1.useIntl)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const willRenderProfileCardTrigger = !isAnonymous && canViewProfile && !!userId && hasViewUserProfilePermission;
    const avatarRef = (0, $cozmU.useRef)(null);
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $cozmU.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $cozmU.useState)(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t5;
    } else t5 = $[0];
    const handleVisibilityChange = t5;
    let t6;
    let t7;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t6 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t7 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t8 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t8;
    } else t8 = $[7];
    const handleKeyDown = t8;
    const t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t10;
    if ($[8] !== intl) {
        t10 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t10 || $[16] !== t9 || $[17] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t9,
            ...t10,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t10;
        $[16] = t9;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    const Icon = t11;
    let t12;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name || $[22] !== willRenderProfileCardTrigger) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            if (willRenderProfileCardTrigger) return {
                tabIndex: -1
            };
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = willRenderProfileCardTrigger;
        $[23] = t12;
    } else t12 = $[23];
    const getAriaProps = t12;
    const t13 = name || "";
    let t14;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[24] = t14;
    } else t14 = $[24];
    const t15 = isBlockLevel && $98dff64af54e38f8$var$avatarWrapperStyles.blockBase;
    const t16 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t17;
    if ($[25] !== t15 || $[26] !== t16) {
        t17 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t15,
            t16
        ];
        $[25] = t15;
        $[26] = t16;
        $[27] = t17;
    } else t17 = $[27];
    let t18;
    if ($[28] !== getAriaProps) {
        t18 = getAriaProps();
        $[28] = getAriaProps;
        $[29] = t18;
    } else t18 = $[29];
    let t19;
    if ($[30] !== Icon || $[31] !== handleKeyDown || $[32] !== t17 || $[33] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t17,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t18
        }, Icon);
        $[30] = Icon;
        $[31] = handleKeyDown;
        $[32] = t17;
        $[33] = t18;
        $[34] = t19;
    } else t19 = $[34];
    let t20;
    if ($[35] !== canViewProfile || $[36] !== isAnonymous || $[37] !== offset || $[38] !== position || $[39] !== t13 || $[40] !== t19 || $[41] !== trigger || $[42] !== userId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t13,
            disabledAriaAttributes: t14,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t19);
        $[35] = canViewProfile;
        $[36] = isAnonymous;
        $[37] = offset;
        $[38] = position;
        $[39] = t13;
        $[40] = t19;
        $[41] = trigger;
        $[42] = userId;
        $[43] = t20;
    } else t20 = $[43];
    return t20;
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("9CnRS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $90dae8a726ff859c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    addNew: {
        id: "inline-comments-common.reactions.add.new",
        defaultMessage: "Add new"
    },
    invalidHighlight: {
        id: "inline-comments-common.error.invalid.highlight",
        defaultMessage: "We\u2019re having trouble adding your comment. Try highlighting more or less text."
    },
    replyCommentPlaceholder: {
        id: "inline-comments-common.reply-comment-placeholder",
        defaultMessage: "Reply"
    },
    staleContent: {
        id: "inline-comments-common.error.stale.content",
        defaultMessage: "Refresh to view the latest updates, and try adding your comment again."
    },
    viewNotPermitted: {
        id: "inline-comments-common.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view this comment. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "inline-comments-common.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    inlineMarkerRefAlreadyExists: {
        id: "inline-comments-common.error.inline.marker.ref.already.exists",
        defaultMessage: "We failed to display your comment. Please refresh to see it."
    },
    unableToApplyAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.annotation",
        defaultMessage: "Something went wrong when adding this comment to the document. Refresh to see your comment."
    },
    unableToApplyDanglingCommentAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.dangling.comment.annotation",
        defaultMessage: "Your comment was created but could not be added to the document because the text has been changed or removed."
    },
    contentHasBeenRemoved: {
        id: "inline-comments-common.error.create.content.removed",
        defaultMessage: "The text you highlighted has already been deleted by someone else. Refresh to view the latest updates."
    },
    cannotHighlightContent: {
        id: "inline-comments-common.error.cannot.highlight.content",
        defaultMessage: "An error occurred when commenting on the highlighted content. The page may be outdated. Refresh to view the latest updates."
    },
    viewOrModifyNotPermitted: {
        id: "inline-comments-common.error.view.or.modify.not.permitted",
        defaultMessage: "You can\u2019t view or modify comments in this space. A space admin can modify your permissions."
    },
    deleteWithRepliesNotAllowed: {
        id: "inline-comments-common.error.delete.with.replies",
        defaultMessage: "You can\u2019t delete this comment anymore because someone else replied to it. Refresh to see all replies."
    },
    commentAlreadyDeleted: {
        id: "inline-comments-common.error.comment.already.deleted",
        defaultMessage: "This comment has been deleted by someone else. Refresh to view the latest updates."
    },
    commentAlreadyDeletedTitle: {
        id: "inline-comments-common.error.comment.already.deleted.title",
        defaultMessage: "Unable to delete comment"
    },
    noCommentsFoundForGivenMarkerRef: {
        id: "inline-comments-common.error.no.comments.found.for.given.marker.ref",
        defaultMessage: "This comment couldn\u2019t be found. Refresh to view the latest updates."
    },
    resolveNotPermitted: {
        id: "inline-comments-common.error.resolve.not.permitted",
        defaultMessage: "You can\u2019t resolve comments in this space. A space admin can modify your permissions."
    },
    resolveError: {
        id: "inline-comments-common.error.resolve.error",
        defaultMessage: "We failed to resolve your comment due to an error. Try resolving the comment again."
    },
    resolveErrorTitle: {
        id: "inline-comments-common.error.resolve.error.title",
        defaultMessage: "Failed to resolve comment"
    },
    deleteError: {
        id: "inline-comments-common.error.delete.error",
        defaultMessage: "We failed to delete your comment due to an error. Try deleting the comment again."
    },
    deleteErrorTitle: {
        id: "inline-comments-common.error.delete.error.title",
        defaultMessage: "Failed to delete comment"
    },
    editNotPermitted: {
        id: "inline-comments-common.error.edit.not.permitted",
        defaultMessage: "You can\u2019t edit comments in this space. A space admin can modify your permissions."
    },
    replyNotPermitted: {
        id: "inline-comments-common.error.reply.not.permitted",
        defaultMessage: "You can\u2019t reply to comments in this space. A space admin can modify your permissions."
    },
    replyNotAllowedParentDeleted: {
        id: "inline-comments-common.error.reply.not.allowed.parent.deleted",
        defaultMessage: "You can\u2019t reply to this comment because it was just deleted by someone else. Refresh to view the latest updates."
    },
    unableToMarkDOM: {
        id: "inline-comments-common.error.unable.to.mark.dom",
        defaultMessage: "Your comment has been successfully created. Refresh to view it."
    },
    networkError: {
        id: "inline-comments-common.error.network",
        defaultMessage: "Your comment wasn't added due to a network error. Check your connection and try again."
    },
    unexpectedError: {
        id: "inline-comments-common.error.unexpected",
        defaultMessage: "Something went wrong when saving this comment. Close the comment or refresh, and try adding your comment again."
    },
    actionNotPermittedTitle: {
        id: "inline-comments-common.error.action.not.permitted.title",
        defaultMessage: "Unauthorized action"
    },
    actionNotPermitted: {
        id: "inline-comments-common.error.action.not.permitted",
        defaultMessage: "You can\u2019t perform that action on inline comments in this space. A space admin can modify your permissions."
    },
    cannotReplyToResolvedComment: {
        id: "inline-comments-common.error.cannot.reply.to.resolved",
        defaultMessage: "You can\u2019t reply to this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    cannotUpdateResolvedComment: {
        id: "inline-comments-common.error.cannot.update.resolved",
        defaultMessage: "You can\u2019t edit this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    unableToGenerateStep: {
        id: "inline-comments-common.error.unable.to.generate.step",
        defaultMessage: "You can\u2019t create a comment because something went wrong with your highlight. Close this window and create a new highlight."
    },
    contentOutOfDate: {
        id: "inline-comments-common.error.content.out.of.date",
        defaultMessage: "You can\u2019t create a comment here because the text has been changed or removed."
    },
    createTimeout: {
        id: "inline-comments-common.error.create.timeout",
        defaultMessage: "Your request to create a comment timed out. Wait a few moments and save the comment again."
    },
    /**
   * The message below is duplicated in the next files:
   * next/packages/resolved-inline-comments-dialog/src/ResolvedInlineCommentsDialogComponent.tsx
   * packages/confluence-frontend-server/src/components/Comment/PageCommentRenderer.js
   *
   * If you are going to change the message please make sure that the same changes are made in the mentioned above files
   */ a11yCommentLabel: {
        id: "inline-comments-common.a11y.comment.wrapper.label",
        defaultMessage: "Comment by {username}"
    },
    commentActionsMenuLabel: {
        id: "inline-comments-common.comment.actions.menu.label",
        defaultMessage: "More actions"
    },
    copyLinkTooltip: {
        id: "inline-comments-common.tooltip.copy.link",
        defaultMessage: "Copy link to comment"
    },
    linkCopiedTooltip: {
        id: "inline-comments-common.tooltip.link.has.been.copied",
        defaultMessage: "Copied!"
    },
    resolve: {
        id: "inline-comments-common.view.action.resolve",
        defaultMessage: "Resolve"
    },
    resolved: {
        id: "inline-comments-common.view.action.resolved",
        defaultMessage: "Resolved"
    },
    edit: {
        id: "inline-comments-common.view.action.edit",
        defaultMessage: "Edit"
    },
    delete: {
        id: "inline-comments-common.view.action.delete",
        defaultMessage: "Delete"
    },
    reopen: {
        id: "inline-comments-common.action.reopen",
        defaultMessage: "Reopen"
    },
    replyPlaceholder: {
        id: "inline-comments-common.reply.placeholder",
        defaultMessage: "Reply"
    },
    replyPlaceholderWithName: {
        id: "inline-comments-common.reply.placeholder.with-name",
        defaultMessage: "Reply to {name}"
    },
    reactionAriaLabelWithName: {
        id: "inline-comments-common.reaction.aria-label.with-name",
        defaultMessage: "React to {name}\u2019s comment"
    },
    resolveThread: {
        id: "inline-comments-common.resolve-thread",
        defaultMessage: "Resolve comment thread"
    },
    /**
   * Collaborator Onboarding sample comment
   */ sampleAuthor: {
        id: "inline-comments-common.sample.comment.author",
        defaultMessage: "Confluence"
    },
    sampleBody: {
        id: "inline-comments-common.sample.comment.body",
        defaultMessage: "Highlight content to add an inline comment. All viewers can see these, so it\u2019s great for targeted discussion on a specific word or phrase"
    },
    sampleReply: {
        id: "inline-comments-common.sample.reply.input",
        defaultMessage: "disabled reply input"
    },
    sampleReplyPlaceholder: {
        id: "inline-comments-common.sample.reply.placeholder",
        defaultMessage: "Reply"
    },
    sampleReplyTooltip: {
        id: "inline-comments-common.sample.reply.tooltip",
        defaultMessage: "Reply is unavailable for sample comments"
    },
    sampleDeleteHeader: {
        id: "inline-comments-common.sample.comment.delete.header",
        defaultMessage: "Only you can see this."
    },
    sampleDeleteIcon: {
        id: "inline-comments-common.sample.comment.delete.icon",
        defaultMessage: "Delete icon"
    },
    sampleDeleteTooltip: {
        id: "inline-comments-common.sample.comment.delete.tooltip",
        defaultMessage: "Delete sample comment"
    },
    sampleCloseIconLabel: {
        id: "inline-comments-common.sample.comment.delete.icon.label",
        defaultMessage: "Close sample comment"
    },
    collapsedRepliesMore: {
        id: "inline-comments-common.collapsed.replies.more",
        defaultMessage: "{numCollapsedReplies} more replies"
    },
    unreadInlineComment: {
        id: "inline-comments-common.unread.inline.comment",
        defaultMessage: "This is an unread inline comment"
    },
    resolvedText: {
        id: "inline-comments-common.resolved",
        defaultMessage: "[Resolved]"
    },
    resolvedFlagText: {
        id: "inline-comments-common.resolved.flag.text",
        defaultMessage: "Comment resolved"
    },
    deletedText: {
        id: "inline-comments-common.deleted",
        defaultMessage: "[Deleted]"
    },
    copyLink: {
        id: "inline-comments-common.copy.link",
        defaultMessage: "Copy link"
    },
    goToCommentCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.gotocomment",
        defaultMessage: "Go to comment"
    },
    undoCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.undo",
        defaultMessage: "Undo"
    },
    contentDeleted: {
        id: "inline-comments-common.content.deleted",
        defaultMessage: "Content deleted"
    },
    originalContentDeleted: {
        id: "inline-comments-common.original.content.deleted",
        defaultMessage: "Original content deleted"
    },
    thisContentWasDeleted: {
        id: "inline-comments-common.dangling.comments.this.content.was.deleted",
        defaultMessage: "This content was deleted."
    },
    viewDeletedContent: {
        id: "inline-comments-common.dangling.comments.view.deleted.content",
        defaultMessage: "View deleted content"
    },
    collapseDeletedContent: {
        id: "inline-comments-common.dangling.comments.collapse.deleted.content",
        defaultMessage: "Collapse deleted content"
    }
});
module.exports["i18n"] = $90dae8a726ff859c$export$a7357cdd1f0b0168;

});

parcelRegister("aZ9If", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eccf7d66f35470272dc64714274958f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ff722a3b4d1cbe6$var$_react = $7ff722a3b4d1cbe6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7ff722a3b4d1cbe6$var$_baseNew = $7ff722a3b4d1cbe6$var$_interopRequireDefault((parcelRequire("gElAV")));
function $7ff722a3b4d1cbe6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TeamworkGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/teamwork-graph
 * Usage guidance:
 * Reserved for Teamwork Graph features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ff722a3b4d1cbe6$var$TeamworkGraphIcon = (props)=>/*#__PURE__*/ $7ff722a3b4d1cbe6$var$_react.default.createElement($7ff722a3b4d1cbe6$var$_baseNew.default, Object.assign({
        name: "TeamworkGraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 12.25a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m8.5 0a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m0-8.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m-7 8.5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0m-1.5-8.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m1.5 0c0 .61-.169 1.18-.46 1.668l4.04 4.042a3.25 3.25 0 1 1-1.074 1.047L5.492 6.492A3.25 3.25 0 1 1 7 3.75m8.5 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0"/>`
    }, props));
$7ff722a3b4d1cbe6$var$TeamworkGraphIcon.displayName = 'TeamworkGraphIcon';
var $7ff722a3b4d1cbe6$var$_default = module.exports.default = $7ff722a3b4d1cbe6$var$TeamworkGraphIcon;

});

parcelRegister("666Tc", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $5SGpQ = parcelRequire("5SGpQ");


var $6mKj3 = parcelRequire("6mKj3");

const $003eb47e4cfe7fce$var$slideOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$48377ae1c677702b = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _4FKVYEXJe6 _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT _4kiQYAcM5X",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4fbc87ee9c503b41 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_35rKQm98eZ _1ghXkF0Rl6 _4xX39A6wH8 _22U8hD7zJH",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // Editor feedback button has a z-index of 460; Table sticky header has a z-index of 500; Renderer Page Toolbar has a z-index of 12
const $003eb47e4cfe7fce$export$f39f3f768bc98e3d = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
        const { rightOffset: t3 } = __cmplp;
        const rightOffset = t3 === undefined ? 0 : t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16090q4": (0, $9aYkv.default)(`${rightOffset}px`),
                "--_162hus6": (0, $9aYkv.default)(__cmplp.offset, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_30huDKOeNX _0bjKvD4Y4b _2OUyjtFYNq _0KLXrulfZc _4ApkO2e9hC _2IhTon3k40 _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc _1DCdHiQEt6 _39xV02ehCh _0NUa3rYbGa",
                __cmplp.mode === "view" ? "_42Yu6BYVCu" : "_42Yu6B6zpv",
                __cmplp.isSticky ? "_1mT5xdy1CL" : "_1mT5xdWVPG",
                Boolean(__cmplp.isAutoDismissResolve) && "",
                Boolean(__cmplp.isAutoDismissResolve) && "_2fBhtevGEi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$82f8f5af33982290 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
        const { rightOffset: t3 } = __cmplp;
        const rightOffset = t3 === undefined ? 0 : t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16090q4": (0, $9aYkv.default)(`${rightOffset}px`),
                "--_162hus6": (0, $9aYkv.default)(__cmplp.offset, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_30huDKOeNX _0bjKvDyzSk _2OUyjtGk8v _0KLXrulfZc _4ApkO2e9hC _2IhTon3k40 _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc _1DCdHiQEt6 _39xV02ehCh _0NUa3rYbGa",
                __cmplp.mode === "view" ? "_42Yu6BYVCu" : "_42Yu6B6zpv",
                __cmplp.isSticky ? "_1mT5xdy1CL" : "_1mT5xdWVPG",
                Boolean(__cmplp.isAutoDismissResolve) && "",
                Boolean(__cmplp.isAutoDismissResolve) && "_2fBhtevGEi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$18986330a3dbad03 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _0KLXrulfZc _0kH15VOeNX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$86b1f0d05f7b12cd = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isCommentsPanel: isCommentsPanel, isFabricPage: isFabricPage, isStandaloneComment: isStandaloneComment, ...__cmpldp } = __cmplp;
        let result;
        if (__cmplp.isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) result = "var(--ds-space-150, 12px)";
        else {
            const basePadding = __cmplp.mode === "view" ? "var(--ds-space-150, 12px) var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px) var(--ds-space-150, 12px)";
            result = __cmplp.isCommentsPanel ? "0" : basePadding;
        }
        const t3 = result;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let result_0;
        if (__cmplp.isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) result_0 = "var(--ds-space-150, 12px)";
        else if (!__cmplp.isCommentsPanel) result_0 = "var(--ds-space-200, 16px)";
        else result_0 = "var(--ds-space-150, 12px)";
        const t5 = result_0;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $9aYkv.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== __cmpls || $[8] !== t4 || $[9] !== t6) {
            t7 = {
                ...__cmpls,
                "--_35y4il": t4,
                "--_1unxhh5": t6
            };
            $[7] = __cmpls;
            $[8] = t4;
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t7,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_4FKVYEUN09 _1wydGWDZ9K _3HchHnGPOD _2ITIGQUofl _4xN29yKGUX",
                __cmplp.isCommentsPanel || __cmplp.isFabricPage ? "_2bqfgdYbGa" : "_2bqfgdNCjk",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$5aae1a36fc838370 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEOKqs _3iDTPbQ4SZ _0hPCNLDIqT _0aFT5vbt8w _3zRROk7NXe _0BZd8NnlTt _1lgKZdxah3 _2waFOoy7kJ _0csg4eDIqT _0XEZqI7NXe _0TAcaW8HPE _0mTZRh7zJH _45Fm8lDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // View mode styled components
const $003eb47e4cfe7fce$export$b38a2fd24b22fb35 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isReply: isReply, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "",
            !__cmplp.isReply && "_4FKVYE8HPE _1x1D3gOeNX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$d1b98bde82a43bb3 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2OcHUsFQfX _4pkS4ZuFDC _33EFmxgv4a _4fkkfBZpcK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$6e006bd290301009 = '24px';
const $003eb47e4cfe7fce$export$3421cb2750fe78a7 = '28px';
const $003eb47e4cfe7fce$export$28ae196bde1430fd = '24px'; // Needed to get the correct overall size to match the comment icon next to it
const $003eb47e4cfe7fce$var$inlineHeaderButtonTheme = (isSSRFocusedComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                background: 'none',
                borderRadius: "var(--ds-radius-small, 4px)",
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: $003eb47e4cfe7fce$export$6e006bd290301009,
                '&:hover': {
                    backgroundColor: `${"var(--ds-surface-hovered, #F0F1F2)"}`
                },
                '&:focus': {
                    boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #4688EC)"}`
                },
                cursor: isSSRFocusedComment ? 'not-allowed' : 'pointer',
                '*': {
                    color: isSSRFocusedComment ? `${"var(--ds-text-subtlest, #6B6E76)"}` : `inherit`
                }
            }
        };
    };
const $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let isSSRFocusedComment;
    let props;
    if ($[0] !== t0) {
        ({ isSSRFocusedComment: isSSRFocusedComment, ...props } = t0);
        $[0] = t0;
        $[1] = isSSRFocusedComment;
        $[2] = props;
    } else {
        isSSRFocusedComment = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== isSSRFocusedComment) {
        t1 = $003eb47e4cfe7fce$var$inlineHeaderButtonTheme(isSSRFocusedComment);
        $[3] = isSSRFocusedComment;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
            theme: t1,
            ...props
        });
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $003eb47e4cfe7fce$export$e575a964a1fe8b0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldShowNavigation: shouldShowNavigation, isReattachHeader: isReattachHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS _3iDTPbQ4SZ _2Zuz6Q8HPE _1Znuxb8HPE",
            __cmplp.shouldShowNavigation ? "_37wbyuI7V3" : "_37wbyuz9WS",
            __cmplp.shouldShowNavigation && "_0jFU0VfFOW _0Of8r28HPE",
            __cmplp.isReattachHeader && "_0jFU0VfFOW _0Of8r25zaO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$b3b0191112eea395 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $003eb47e4cfe7fce$export$f39f3f768bc98e3d : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02ehCh _0jFU0V71Z1",
            __cmplp.showSkeleton ? "_3iDTPbvLZJ" : "_3iDTPbYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$f895097fe90363d1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showNavigation: showNavigation, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.showNavigation ? "_313842Va5s" : "_313842Pgdg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$32dd8f1956fe77b1 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdWVPG _4ApkO28HPE _42Yu6B7dHp _2IhTon8HPE",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4b61d9d7155e9162 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu8gVvo _1mT5xdWVPG _2IhTon5zaO _3OE6xY5zaO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$var$closeButtonTheme = (isUpdatedStandaloneComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: isUpdatedStandaloneComment ? $003eb47e4cfe7fce$export$28ae196bde1430fd : $003eb47e4cfe7fce$export$3421cb2750fe78a7
            }
        };
    };
const $003eb47e4cfe7fce$export$de65de8213222d10 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let isUpdatedStandaloneComment;
    let props;
    if ($[0] !== t0) {
        ({ isUpdatedStandaloneComment: isUpdatedStandaloneComment, ...props } = t0);
        $[0] = t0;
        $[1] = isUpdatedStandaloneComment;
        $[2] = props;
    } else {
        isUpdatedStandaloneComment = $[1];
        props = $[2];
    }
    const t1 = isUpdatedStandaloneComment ?? false;
    let t2;
    if ($[3] !== t1) {
        t2 = $003eb47e4cfe7fce$var$closeButtonTheme(t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== props || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
            theme: t2,
            ...props
        });
        $[5] = props;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["ActionsContainer"] = $003eb47e4cfe7fce$export$48377ae1c677702b;
module.exports["SidebarContainer"] = $003eb47e4cfe7fce$export$f39f3f768bc98e3d;
module.exports["SidebarContainerRounded"] = $003eb47e4cfe7fce$export$82f8f5af33982290;
module.exports["ReplyListContainer"] = $003eb47e4cfe7fce$export$18986330a3dbad03;
module.exports["NewReplyContainer"] = $003eb47e4cfe7fce$export$86b1f0d05f7b12cd;
module.exports["ResolvedNotificationContainer"] = $003eb47e4cfe7fce$export$5aae1a36fc838370;
module.exports["EditorContainer"] = $003eb47e4cfe7fce$export$b38a2fd24b22fb35;
module.exports["NavigationContainer"] = $003eb47e4cfe7fce$export$d1b98bde82a43bb3;
module.exports["InlineHeaderButton"] = $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5;
module.exports["SidebarHeader"] = $003eb47e4cfe7fce$export$e575a964a1fe8b0;
module.exports["LoadingSkeletonContainer"] = $003eb47e4cfe7fce$export$b3b0191112eea395;
module.exports["CloseButtonContainer"] = $003eb47e4cfe7fce$export$32dd8f1956fe77b1;
module.exports["CloseButton"] = $003eb47e4cfe7fce$export$de65de8213222d10;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await Promise.resolve((parcelRequire("9fywD")))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("7tI6B", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $89d6a09a4f827a20$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $89d6a09a4f827a20$export$8995abb8169b2cb8;

});

parcelRegister("9ivsj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dX6FL = parcelRequire("dX6FL");


var $jlWUB = parcelRequire("jlWUB");

const $68c74ae30c005fed$export$c537e63161742ce3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $68c74ae30c005fed$export$c537e63161742ce3;

});

parcelRegister("bzqa9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $lTECB = parcelRequire("lTECB");


var $dPJCf = parcelRequire("dPJCf");


var $4qzKl = parcelRequire("4qzKl");


var $icKZN = parcelRequire("icKZN");

const $abb6860b27595ef6$export$8ce912bc34d0dbea = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== push) {
        t0 = (event, url)=>{
            if (!event?.isDefaultPrevented()) event?.preventDefault();
            if ((0, $icKZN.isClickEventToOpenNewTab)(event)) window.open(url, "_blank");
            else push(url);
        };
        $[0] = push;
        $[1] = t0;
    } else t0 = $[1];
    const handleClick = t0;
    let t1;
    if ($[2] !== handleClick) {
        t1 = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? {
            mention: {
                onClick: async (userId, _, event_0)=>{
                    event_0?.preventDefault();
                    event_0?.stopPropagation();
                    const url_0 = await (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId);
                    handleClick(event_0, url_0);
                }
            },
            link: {
                onClick (e, url_1) {
                    handleClick(e, url_1);
                }
            },
            smartCard: {
                onClick (e_0, url_2) {
                    handleClick(e_0, url_2);
                }
            }
        } : undefined;
        $[2] = handleClick;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useEventHandlers"] = $abb6860b27595ef6$export$8ce912bc34d0dbea;

});

parcelRegister("1a6Dn", function(module, exports) {

var $hrAmX = parcelRequire("hrAmX");


var $a4dgs = parcelRequire("a4dgs");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $a4dgs.BaseStateContainer) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            // The lookup has to happen inside the updater: updates queued in the same microtask are
            // applied in sequence, so an index resolved beforehand would already be stale.
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index === -1) return {
                    ...state,
                    floatingBanners: [
                        ...state.floatingBanners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                if (state.floatingBanners[index].height !== height) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    // Replace rather than mutate, so the previous state keeps the old height.
                    newArray[index] = {
                        name: name,
                        height: height
                    };
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.hideFloating = (name)=>{
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index > -1) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("8WfxO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $cozmU.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $cozmU.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const batchResultData = batchResult?.data;
    const batchResultError = batchResult?.error;
    const batchResultLoading = batchResult?.loading;
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const baseOptions = {
        variables: variables,
        skip: Boolean(batchResult),
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY) && // Keep watching query for home route to avoid VC90 regression
    (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy,
        __callerPackage__: "web-panel-location"
    });
    const result = batchResult ?? {
        loading: loading,
        data: data,
        error: error
    };
    (0, $cozmU.useEffect)(()=>{
        if (batchResultLoading || batchResultError || !batchResultData || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResultData,
        batchResultError,
        batchResultLoading,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    const panels = (result.data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: result.loading,
        error: result.error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("7VJPz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6B1vK = parcelRequire("6B1vK");

var $aBKty = parcelRequire("aBKty");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $au7xi = parcelRequire("au7xi");


var $1lyRS = parcelRequire("1lyRS");

const $cd53535796fd282e$export$16ffa5f7b88dc45f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId })=>{
    const extensionHandlers = {};
    extensionHandlers[0, $au7xi.smartButtonExtensionType] = (extension)=>{
        const pageAri = contentId ? (0, $6B1vK.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : undefined;
        const site = (0, $aBKty.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
        const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            contentId: contentId ?? '',
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extension.extensionKey,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extension),
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1lyRS.SmartButtonLoader), {
            ruleId: extension.parameters?.ruleId,
            scopeId: extension.parameters?.scopeId,
            pageAri: pageAri,
            site: site,
            smartButtonName: extension.parameters?.smartButtonName,
            experienceTrackerName: experienceName,
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            isViewMode: true
        }));
    };
    return extensionHandlers;
};
module.exports["getRendererSmartButtonExtensionHandlers"] = $cd53535796fd282e$export$16ffa5f7b88dc45f;

});

parcelRegister("5kjCz", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $dOBRD.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $cozmU.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $cozmU.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("au7xi", function(module, exports) {
const $ea41547e1b4f38b6$export$73185dbd06fc0dd8 = 'com.atlassian.automation.smart-button';
module.exports["smartButtonExtensionType"] = $ea41547e1b4f38b6$export$73185dbd06fc0dd8;

});

parcelRegister("1lyRS", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e92128cf9491a8$export$32d8d71ddecea49c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LmILK",
    name: "SmartButtonLoader",
    loader: async ()=>(await (parcelRequire("eaHFm"))).SmartButton
});
module.exports["SmartButtonLoader"] = $16e92128cf9491a8$export$32d8d71ddecea49c;

});

parcelRegister("eaHFm", function(module, exports) {

let $a513df0b1bd31e66$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a513df0b1bd31e66$var$load("excC5"),
    $a513df0b1bd31e66$var$load("60QcS"),
    $a513df0b1bd31e66$var$load("6wr18"),
    $a513df0b1bd31e66$var$load("2xKrc"),
    $a513df0b1bd31e66$var$load("hhss7"),
    $a513df0b1bd31e66$var$load("ffEVr"),
    $a513df0b1bd31e66$var$load("lhkXg")
]).then(()=>parcelRequire('hLSQl'));

});

parcelRegister("dK51B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $cozmU.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("fqCbQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $cozmU.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $cozmU.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("iXGsw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $cozmU.useRef)(null);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $cozmU.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $cozmU.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9qJAQ = parcelRequire("9qJAQ");


var $6SsN4 = parcelRequire("6SsN4");


var $422HI = parcelRequire("422HI");


var $zXpxJ = parcelRequire("zXpxJ");


var $iffSy = parcelRequire("iffSy");


var $7q7rs = parcelRequire("7q7rs");


var $7M67g = parcelRequire("7M67g");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

/**
 * Coerce an unknown thrown value into an ApolloErrorInterop, so a rejection carries Apollo's
 * `graphQLErrors` / `networkError` fields on both branches. Mirrors the helper in
 * `useLazyQueryInterop`.
 */ function $b847dc1d37d68706$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $b847dc1d37d68706$export$dcf9d4e77de27956(query, options) {
    const operationName = (0, $7M67g.getRelayOperationName)(query);
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        operationName: operationName,
        phase: 'lazy'
    })) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo(query, options);
}
const $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(13);
    const resolversRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options) {
        t1 = options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        };
        $[2] = options;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = [
            t0,
            t1
        ];
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const [doQuery, t3] = (0, $9qJAQ.useLazyQuery)(...t2);
    const { data: data, error: error } = t3;
    let t4;
    let t5;
    if ($[7] !== data || $[8] !== error) {
        t4 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t5 = [
            data,
            error
        ];
        $[7] = data;
        $[8] = error;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[11] !== doQuery) {
        t6 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[11] = doQuery;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : function useLazyQueryPromiseInteropApollo(query, options) {
    const resolversRef = (0, $cozmU.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ // Interop-only fetch policies must be translated or they reach Apollo untranslated and silently
    // degrade to its default cache behaviour. That matters for `'no-store'` specifically: Apollo's
    // `'no-cache'` is its exact equivalent, and without this mapping a query that is correct today
    // would start writing to the cache.
    const [doQuery, { data: data, error: error }] = (0, $9qJAQ.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        }
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $cozmU.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
function $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${(0, $7M67g.getRelayOperationName)(query) ?? 'unknown'}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const operationName = (0, $7M67g.getRelayOperationName)(query) ?? undefined;
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        operationName: operationName,
        phase: 'memo'
    });
    // Read through refs rather than closing over these directly, so the returned callback keeps a
    // `[environment, query]` dependency list. Every current caller drives it from a `useEffect`
    // dependency array, so a new identity per render would re-fire the query on each render.
    // `context` in particular is usually an inline object and would change identity every time.
    const latestOptionsRef = (0, $cozmU.useRef)(options);
    latestOptionsRef.current = options;
    const hookVariablesRef = (0, $cozmU.useRef)(hookVariables);
    hookVariablesRef.current = hookVariables;
    return (0, $cozmU.useCallback)((callOptions)=>{
        const hookOptions = latestOptionsRef.current;
        // Per-call options win over hook-level ones, and variables merge rather than replace —
        // matching Apollo, which merges the variables handed to its lazy `doQuery` over the ones
        // given to the hook.
        const variables = {
            ...hookVariablesRef.current,
            ...callOptions?.variables
        };
        // Shared with `queryInterop` so the fetch-policy mapping and the `noStore` derivation have
        // one home. `noStore` is load-bearing for this hook specifically: `PagePanelContentQuery`
        // runs through it and is one of the operations whose response carries two `Content` objects
        // sharing an id, so a missed flag reintroduces the record collision.
        return (0, $zXpxJ.executeRelayQuery)({
            environment: environment,
            query: query,
            variables: variables,
            fetchPolicy: callOptions?.fetchPolicy ?? hookOptions?.fetchPolicy,
            errorPolicy: callOptions?.errorPolicy ?? hookOptions?.errorPolicy ?? 'none',
            context: callOptions?.context ?? hookOptions?.context
        }).then((result)=>{
            // Diverges from `queryInterop`, which hands `{ data, error }` back: this hook mirrors
            // Apollo's promise, which rejects. Under `errorPolicy: 'all'` a result carries both
            // data and error, and Apollo's effect resolves before it rejects — a promise settles
            // once — so data being present means resolve.
            if (result.error && result.data === undefined) throw result.error;
            return result.data;
        }).catch((err)=>{
            // Reject with an ApolloErrorInterop on both branches, so callers can read
            // `graphQLErrors` / `networkError` without knowing which branch ran.
            throw $b847dc1d37d68706$var$toApolloError(err);
        });
    }, [
        environment,
        query
    ]);
}
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("hjUDQ", function(module, exports) {
var $3f94275ae089f93c$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $3f94275ae089f93c$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $3f94275ae089f93c$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $3f94275ae089f93c$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $3f94275ae089f93c$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $3f94275ae089f93c$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $3f94275ae089f93c$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $3f94275ae089f93c$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $3f94275ae089f93c$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $3f94275ae089f93c$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $3f94275ae089f93c$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $3f94275ae089f93c$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $3f94275ae089f93c$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $3f94275ae089f93c$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $3f94275ae089f93c$export$a6e645fda5339bf8;
module.exports["Height"] = $3f94275ae089f93c$export$8954cfac7c08d16a;
module.exports["Alignment"] = $3f94275ae089f93c$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $3f94275ae089f93c$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $3f94275ae089f93c$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $3f94275ae089f93c$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $3f94275ae089f93c$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $3f94275ae089f93c$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $3f94275ae089f93c$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $3f94275ae089f93c$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $3f94275ae089f93c$export$bf7ebf7fed6e7189;

});

parcelRegister("cfM7x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $090373eba5349880$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $cozmU.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isHelpHub: false,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $090373eba5349880$export$774887fcc3922763 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    let t1;
    if ($[3] !== defaultValue || $[4] !== props) {
        t1 = {
            ...defaultValue,
            ...props
        };
        $[3] = defaultValue;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const value = t1;
    let t2;
    if ($[6] !== children || $[7] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
            value: value
        }, children);
        $[6] = children;
        $[7] = value;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, ...props })=>{
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
        value: value
    }, children);
};
const $090373eba5349880$export$8dcbb40932065737 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error("useProductDependencies must be used within ProductDependenciesProvider");
    return ctx;
} : function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
};
module.exports["ProductDependenciesContext"] = $090373eba5349880$export$49e1053dfc41d188;
module.exports["useProductDependencies"] = $090373eba5349880$export$8dcbb40932065737;

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("lOeVN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $cozmU.useRef)();
    propsRef.current = props;
    return (0, $cozmU.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("5E8QK"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("5E8QK", function(module, exports) {

let $41c78d93fde5dc21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41c78d93fde5dc21$var$load("4nZ85"),
    $41c78d93fde5dc21$var$load("hhss7"),
    $41c78d93fde5dc21$var$load("kHXvF"),
    $41c78d93fde5dc21$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eW61a = parcelRequire("eW61a");


var $bQm3c = parcelRequire("bQm3c");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $eW61a.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: true,
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    return (0, $cozmU.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("1SPMi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $iTJtk = parcelRequire("iTJtk");


var $bQm3c = parcelRequire("bQm3c");


var $2SowE = parcelRequire("2SowE");

const $c749b0358b0b3fb9$export$46da93e796378064 = (props)=>{
    const { objectId: objectId, objectType: objectType, children: children, source: source } = props;
    // setting default to development so in tests it doesn't fail due to being undefined
    const { environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: objectId,
                objectType: objectType,
                rendererSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            return newPayload;
        });
    }, [
        safeEnvironment,
        objectId,
        objectType,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).media
    }, children));
};
module.exports["RendererAnalyticsListener"] = $c749b0358b0b3fb9$export$46da93e796378064;

});

parcelRegister("iP9x4", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $2j0AL = parcelRequire("2j0AL");


var $4h1jl = parcelRequire("4h1jl");


var $9wGTI = parcelRequire("9wGTI");


var $4IoVL = parcelRequire("4IoVL");

const $2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR = 'mediaProvider unavailable, must use initialAuth';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $2c59df77bd212c3d$var$isServerEnvironment = ()=>undefined;
const $2c59df77bd212c3d$var$isClientEnvironment = ()=>window.__SSR_RENDERED__;
const $2c59df77bd212c3d$var$getInitialAuth = (config)=>{
    const recordedAuth = config.contentProduct === 'jira-work-item' ? (0, $4h1jl.jiraMediaConfigRecorder)?.get() : (0, $4h1jl.mediaConfigRecorder)?.get();
    if (!recordedAuth) return undefined;
    return {
        ...recordedAuth,
        // If the mediaToken is provided in the config, use it.
        // This ensures the correct token is used in cases where the token differs from
        // the initial page, such as media included through an `include` macro.
        token: config?.mediaToken || recordedAuth.token
    };
};
const $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy = ()=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const shouldEnforceDataSecurityPolicy = (0, $4h1jl.mediaConfigEnforceDSPRecorder)?.get();
    return !!shouldEnforceDataSecurityPolicy;
};
const $2c59df77bd212c3d$var$getServerModeConfig = (config)=>({
        mode: 'server',
        config: {
            authProvider: ()=>Promise.reject(new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR)),
            initialAuth: $2c59df77bd212c3d$var$getInitialAuth(config),
            enforceDataSecurityPolicy: $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy()
        }
    });
const $2c59df77bd212c3d$var$createClientAuthProvider = ({ contentAri: contentAri, contentId: contentId, contentProduct: contentProduct, spaceKey: spaceKey, isExternalShare: isExternalShare, mediaToken: mediaToken })=>async (authContext)=>{
        if (!!contentId && (!!spaceKey || contentProduct === 'jira-work-item')) {
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare,
                mediaToken: mediaToken
            });
            return viewMediaClientConfig.authProvider(authContext);
        } else throw new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR);
    };
const $2c59df77bd212c3d$var$getClientModeConfig = (config)=>({
        mode: 'client',
        config: {
            authProvider: $2c59df77bd212c3d$var$createClientAuthProvider(config),
            initialAuth: config.contentProduct === 'jira-work-item' ? window.__JIRA_MEDIA_CONFIG__ : window.__MEDIA_CONFIG__,
            enforceDataSecurityPolicy: window.__MEDIA_CONFIG_ENFORCE_DSP__
        }
    });
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig = (config)=>{
    if ($2c59df77bd212c3d$var$isServerEnvironment()) return $2c59df77bd212c3d$var$getServerModeConfig(config);
    else if ($2c59df77bd212c3d$var$isClientEnvironment()) return $2c59df77bd212c3d$var$getClientModeConfig(config);
};
const $2c59df77bd212c3d$export$85decadf1b9d641b = (0, $dOBRD.default)($2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig, (0, (/*@__PURE__*/$parcel$interopDefault($2j0AL))));
const $2c59df77bd212c3d$export$45c8e19bd67cadee = (config)=>{
    return $2c59df77bd212c3d$export$85decadf1b9d641b(config);
};
module.exports["getMediaSSRModeAndAuthConfigMemoized"] = $2c59df77bd212c3d$export$85decadf1b9d641b;
module.exports["useMediaSSRModeAndAuthConfig"] = $2c59df77bd212c3d$export$45c8e19bd67cadee;

});

parcelRegister("4h1jl", function(module, exports) {

var $2BiLx = parcelRequire("2BiLx");

const $c75b7ce9b9db2aec$export$279f2f878f49d0df = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$269fe681eda28e68 = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$e125b144e38aa5db = new (0, $2BiLx.ObjectRecorder)();
module.exports["mediaConfigRecorder"] = $c75b7ce9b9db2aec$export$279f2f878f49d0df;
module.exports["jiraMediaConfigRecorder"] = $c75b7ce9b9db2aec$export$269fe681eda28e68;
module.exports["mediaConfigEnforceDSPRecorder"] = $c75b7ce9b9db2aec$export$e125b144e38aa5db;

});

parcelRegister("2BiLx", function(module, exports) {
class $53dcea44a491523c$export$e411414ea02dd271 {
    set(object) {
        this.object = object;
    }
    get() {
        return this.object;
    }
    reset() {
        this.object = null;
    }
    constructor(){
        this.object = null;
    }
}
module.exports["ObjectRecorder"] = $53dcea44a491523c$export$e411414ea02dd271;

});

parcelRegister("4o1RV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $1eD4P = parcelRequire("1eD4P");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $bDgLe.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $1eD4P.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $cozmU.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $cozmU.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dOBRD = parcelRequire("dOBRD");


var $f8dGE = parcelRequire("f8dGE");


var $7nEuU = parcelRequire("7nEuU");

var $bnFzS = parcelRequire("bnFzS");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $bDgLe.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $dOBRD.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $dOBRD.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $bnFzS.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $7nEuU.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("7EIq6", function(module, exports) {

var $dd33Q = parcelRequire("dd33Q");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");

const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, {
        ...spaceEnabledContentTypesQueryOptions,
        __callerPackage__: "create-blank-fabric-page"
    });
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = isDefaultSpaceKeyLoading || isAnyContentTypesLoading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("kDja4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUvcQ = parcelRequire("dUvcQ");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $cozmU.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return true;
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dUvcQ.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("dUvcQ", function(module, exports) {

var $7FQjS = parcelRequire("7FQjS");

function $c3d67b941c4ebe95$export$470e5c2be1411c89(name) {
    return (0, $7FQjS.resolveBooleanFlag)(name);
}
module.exports["getBooleanFF"] = $c3d67b941c4ebe95$export$470e5c2be1411c89;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("6ojvx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

parcelRequire("bLswh");
var $hBxDy = parcelRequire("hBxDy");

const $59e5036a3fbf2e2e$export$6a671bebd9daad64 = (0, $cozmU.createContext)((0, $hBxDy.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $59e5036a3fbf2e2e$export$6a671bebd9daad64;

});

parcelRegister("bLswh", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("hBxDy")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2zscg")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2zscg")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2zscg")).JiraExtension);
parcelRequire("9iaDP");
var $2zscg = parcelRequire("2zscg");
var $hBxDy = parcelRequire("hBxDy");

parcelRequire("gwrSD");
var $hcYP2 = parcelRequire("hcYP2");
var $31kME = parcelRequire("31kME");
var $d8yi8 = parcelRequire("d8yi8");


});

parcelRegister("9iaDP", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("hBxDy")).ForgeCDNEnvironment);
$parcel$export(module.exports, "BitbucketExtension", () => (parcelRequire("2zscg")).BitbucketExtension);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2zscg")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2zscg")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2zscg")).JiraExtension);
$parcel$export(module.exports, "GlobalExtension", () => (parcelRequire("2zscg")).GlobalExtension);

var $2y56N = parcelRequire("2y56N");


var $hBxDy = parcelRequire("hBxDy");


var $iztBQ = parcelRequire("iztBQ");


var $2zscg = parcelRequire("2zscg");


});

parcelRegister("2y56N", function(module, exports) {
const $43f88a3108220757$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $43f88a3108220757$export$3ee8c58bb87b9685 = [
    ...$43f88a3108220757$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("iztBQ", function(module, exports) {
const $6db1db68019c99c9$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("gwrSD", function(module, exports) {

var $d8yi8 = parcelRequire("d8yi8");


var $31kME = parcelRequire("31kME");


var $hcYP2 = parcelRequire("hcYP2");


});

parcelRegister("d8yi8", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $487f0b3478e8e725$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $487f0b3478e8e725$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $487f0b3478e8e725$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $487f0b3478e8e725$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $487f0b3478e8e725$export$20b9f6acb0888554(effect) {
    return $487f0b3478e8e725$export$7e816460364ed464(effect) || $487f0b3478e8e725$export$eb5bd7f371e458af(effect) || $487f0b3478e8e725$export$f632ad3064955f31(effect);
}

});

parcelRegister("31kME", function(module, exports) {
const $7d3783c6a9539d7e$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $7d3783c6a9539d7e$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $7d3783c6a9539d7e$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $7d3783c6a9539d7e$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $7d3783c6a9539d7e$export$caa8cab0db5b0a61(effect) {
    return $7d3783c6a9539d7e$export$65d7078e01574f24(effect) || $7d3783c6a9539d7e$export$709a27a9f80556b8(effect) || $7d3783c6a9539d7e$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("hcYP2", function(module, exports) {
// From forge.ts
const $1da5394af23f0a63$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $1da5394af23f0a63$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $1da5394af23f0a63$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $1da5394af23f0a63$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $1da5394af23f0a63$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $1da5394af23f0a63$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $1da5394af23f0a63$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $1da5394af23f0a63$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $1da5394af23f0a63$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $1da5394af23f0a63$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $1da5394af23f0a63$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("ix7El", function(module, exports) {
var $04c5b557f78447f3$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $04c5b557f78447f3$export$1a949ef92fd30eca = (error)=>{
    return error instanceof Error && error.name === 'RelayNetwork' && 'source' in error && Array.isArray(error.source?.errors);
};
const $04c5b557f78447f3$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $04c5b557f78447f3$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $04c5b557f78447f3$export$d76ef0f862d061a6;
module.exports["isRelayNetworkError"] = $04c5b557f78447f3$export$1a949ef92fd30eca;
module.exports["isGQLGatewayError"] = $04c5b557f78447f3$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $04c5b557f78447f3$export$9c0545f564a8227f;

});

parcelRegister("iGKcz", function(module, exports) {
// our service
const $fa265340e5382bcc$var$SERVICE = 'forge-ui';
const $fa265340e5382bcc$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $fa265340e5382bcc$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $fa265340e5382bcc$export$14ef296862e3705e;

});

parcelRegister("DIyeF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $6ojvx = parcelRequire("6ojvx");

const $5577a309d6f3499e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $cozmU.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $5577a309d6f3499e$export$163ecee29aa3a8f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { value: value, children: children } = t0;
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    let t1;
    let t2;
    if ($[0] !== envFromContext || $[1] !== environment || $[2] !== page || $[3] !== product) {
        t1 = ()=>({
                environment: environment ?? envFromContext,
                product: product,
                page: page
            });
        t2 = [
            page,
            environment,
            envFromContext,
            product
        ];
        $[0] = envFromContext;
        $[1] = environment;
        $[2] = page;
        $[3] = product;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    const memoedValue = (0, $5xQdV.useMemoOne)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== memoedValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
            value: memoedValue
        }, children);
        $[6] = children;
        $[7] = memoedValue;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ value: value, children: children })=>{
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $5xQdV.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $5577a309d6f3499e$export$dba2dab0d0f39612 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
} : ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $5577a309d6f3499e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $5577a309d6f3499e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $5577a309d6f3499e$export$dba2dab0d0f39612;

});

parcelRegister("4K6lC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $852mP = parcelRequire("852mP");


var $cXtTj = parcelRequire("cXtTj");

const $a3a18abb8f8abee5$export$d28801614368e543 = 'forge-ui';
const $a3a18abb8f8abee5$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $852mP.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $852mP.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $852mP.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $852mP.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
// Merge forgeUIAttributes from outermost to innermost analytics contexts, so child contexts can
// override parent values in the final payload. If an inner context replaces extensionKey, keep the
// previous extensionKey separately so embedded macro events can report it as parentExtensionKey.
function $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(contexts) {
    return contexts.reduce((prev, curr)=>{
        // Only extract attributes passed as an object via the forgeUIAttributes key
        const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
        const previousExtensionKey = prev.forgeUIAttributes.extensionKey;
        const nextExtensionKey = forgeUIAttributes.extensionKey;
        const isExtensionKeyOverridden = Boolean(previousExtensionKey && nextExtensionKey && previousExtensionKey !== nextExtensionKey);
        // Capture the first extensionKey that gets replaced by a nested context. That replaced
        // value is the parent macro key once a child renderer context contributes its own key.
        const overriddenExtensionKey = prev.overriddenExtensionKey ?? (isExtensionKeyOverridden ? previousExtensionKey : undefined);
        return {
            forgeUIAttributes: {
                ...prev.forgeUIAttributes,
                ...forgeUIAttributes
            },
            overriddenExtensionKey: overriddenExtensionKey
        };
    }, {
        forgeUIAttributes: {}
    });
}
const $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, client: client, commonAttributes: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const commonAttributes = t2;
    let t3;
    if ($[2] !== client || $[3] !== commonAttributes) {
        t3 = (event)=>{
            const { eventType: eventType, data: data } = event.payload;
            const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
            const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
            const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? "unknown";
            let nestingAnalyticsAttributes;
            if ((0, $cXtTj.default).getExperimentValue("platform_forge_nesting_analytics", "isEnabled", false)) {
                const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
                let parentExtensionKey = {};
                if (action === "rendered" && actionSubject === "forge.ui.renderer" && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) parentExtensionKey = {
                    parentExtensionKey: overriddenExtensionKey
                };
                else if (action === "rendered" && actionSubject === "forge.ui.bodied_macro_embedded_content" && attributes?.extensionKey && forgeUIAttributes.extensionKey) parentExtensionKey = {
                    parentExtensionKey: forgeUIAttributes.extensionKey
                };
                nestingAnalyticsAttributes = {
                    ...forgeUIAttributes,
                    ...parentExtensionKey
                };
            }
            const payload = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                ...forgeUIAnalyticsContext,
                source: source,
                attributes: {
                    ...commonAttributes,
                    ...nestingAnalyticsAttributes ?? event.context.reduce($a3a18abb8f8abee5$var$_temp, {}),
                    ...attributes
                },
                tags: tags
            };
            $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
                eventType: eventType,
                ...payload
            });
        };
        $[2] = client;
        $[3] = commonAttributes;
        $[4] = t3;
    } else t3 = $[4];
    const listenerHandler = t3;
    let t4;
    if ($[5] !== children || $[6] !== listenerHandler) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            onEvent: listenerHandler,
            channel: $a3a18abb8f8abee5$export$d28801614368e543
        }, children);
        $[5] = children;
        $[6] = listenerHandler;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        // Use the merged nested context attributes and add parentExtensionKey for embedded macro
        // events that override extensionKey.
        let nestingAnalyticsAttributes;
        if ((0, $cXtTj.default).getExperimentValue('platform_forge_nesting_analytics', 'isEnabled', false)) {
            const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
            let parentExtensionKey = {};
            if (action === 'rendered' && actionSubject === 'forge.ui.renderer' && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) // Child Forge renderer contexts replace extensionKey with the child macro key, so the
            // parent key is the previous extensionKey captured during context merging.
            parentExtensionKey = {
                parentExtensionKey: overriddenExtensionKey
            };
            else if (action === 'rendered' && actionSubject === 'forge.ui.bodied_macro_embedded_content' && attributes?.extensionKey && forgeUIAttributes.extensionKey) // Embedded macro events carry the child macro key on the event attributes, while the
            // surrounding context still carries the parent macro extensionKey.
            parentExtensionKey = {
                parentExtensionKey: forgeUIAttributes.extensionKey
            };
            nestingAnalyticsAttributes = {
                ...forgeUIAttributes,
                ...parentExtensionKey
            };
        }
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...nestingAnalyticsAttributes ?? event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes_0 = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes_0
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: listenerHandler,
        channel: $a3a18abb8f8abee5$export$d28801614368e543
    }, children);
};
var $a3a18abb8f8abee5$export$2e2bcd8739ae039 = $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener;
function $a3a18abb8f8abee5$var$_temp(prev, curr) {
    const forgeUIAttributes_0 = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === "object" ? curr.forgeUIAttributes : {};
    return {
        ...prev,
        ...forgeUIAttributes_0
    };
}
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $a3a18abb8f8abee5$export$d28801614368e543;
module.exports["sendEvent"] = $a3a18abb8f8abee5$export$7329bcdc3edcd90e;
module.exports["default"] = $a3a18abb8f8abee5$export$2e2bcd8739ae039;

});

parcelRegister("2rD5H", function(module, exports) {

var $iLX84 = parcelRequire("iLX84");


var $iDrrr = parcelRequire("iDrrr");

const $2571750a7eec7dec$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2571750a7eec7dec$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					sandboxPolicies
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				sandboxPolicies
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$54ff27488d768aba = (0, $iLX84.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}sandboxPolicies scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2571750a7eec7dec$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2571750a7eec7dec$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2571750a7eec7dec$export$54ff27488d768aba;

});

parcelRegister("hzmpb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $gGKeL = parcelRequire("gGKeL");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $5yGfp = parcelRequire("5yGfp");


var $ix7El = parcelRequire("ix7El");


var $DIyeF = parcelRequire("DIyeF");


var $2rD5H = parcelRequire("2rD5H");


var $9DHhW = parcelRequire("9DHhW");


var $852mP = parcelRequire("852mP");


var $4K6lC = parcelRequire("4K6lC");


var $iGKcz = parcelRequire("iGKcz");


var $jGizm = parcelRequire("jGizm");

const $c7be4ab3ad813948$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $c7be4ab3ad813948$export$88e0391b02a3c5c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions } = t0;
    let t1;
    if ($[0] !== client || $[1] !== cloudId || $[2] !== context || $[3] !== includeHidden || $[4] !== locale || $[5] !== queryOptions || $[6] !== types) {
        t1 = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
        $[0] = client;
        $[1] = cloudId;
        $[2] = context;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = queryOptions;
        $[6] = types;
        $[7] = t1;
    } else t1 = $[7];
    const requestOptions = t1;
    const { error: error, loading: loading, data: data } = (0, $5yGfp.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    let t2;
    if ($[8] !== data || $[9] !== loading) {
        t2 = $c7be4ab3ad813948$export$55348c7eb6377fe1({
            loading: loading,
            data: data
        });
        $[8] = data;
        $[9] = loading;
        $[10] = t2;
    } else t2 = $[10];
    const extensions = t2;
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    let t4;
    if ($[11] !== createAnalyticsEvent || $[12] !== extensions || $[13] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[11] = createAnalyticsEvent;
        $[12] = extensions;
        $[13] = page;
        $[14] = t3;
        $[15] = t4;
    } else {
        t3 = $[14];
        t4 = $[15];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[16] !== createAnalyticsEvent || $[17] !== error || $[18] !== extensions || $[19] !== page) {
        t5 = ()=>{
            if (!extensions && error && error.graphQLErrors.length > 0) {
                const err_0 = error.graphQLErrors.find($c7be4ab3ad813948$var$_temp);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "usePrefilteredExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[16] = createAnalyticsEvent;
        $[17] = error;
        $[18] = extensions;
        $[19] = page;
        $[20] = t5;
        $[21] = t6;
    } else {
        t5 = $[20];
        t6 = $[21];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[22] !== extensions) {
        t7 = extensions || [];
        $[22] = extensions;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== error || $[25] !== loading || $[26] !== t7) {
        t8 = {
            error: error,
            extensions: t7,
            loading: loading
        };
        $[24] = error;
        $[25] = loading;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $5yGfp.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $c7be4ab3ad813948$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err_0 = error.graphQLErrors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $c7be4ab3ad813948$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $jGizm.transformPreFilteredExtensions)(extensions);
    return null;
};
const $c7be4ab3ad813948$var$fetchRequests = new Map();
const $c7be4ab3ad813948$export$f55e1916fecb1860 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types } = t0;
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== context || $[2] !== environment || $[3] !== includeHidden || $[4] !== locale || $[5] !== types) {
        t1 = ()=>{
            const cacheKey = JSON.stringify({
                cloudId: cloudId,
                context: context,
                includeHidden: includeHidden,
                locale: locale,
                types: types
            });
            if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
                const extensions_0 = new Promise((resolve, reject)=>{
                    (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                        cloudId: cloudId,
                        context: context,
                        includeHidden: includeHidden,
                        locale: locale,
                        types: types
                    }, {
                        networkCacheConfig: {
                            metadata: {
                                headers: {
                                    "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                                },
                                allowOnExternalPage: true
                            }
                        }
                    }).subscribe({
                        next: (data)=>{
                            resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                                data: data,
                                loading: false
                            }));
                        },
                        error: (error_0)=>{
                            $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                            reject(error_0);
                        }
                    });
                });
                $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
            }
            $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
                setExtensions(extensions_1);
                setLoading(false);
            }).catch((error_1)=>{
                setError(error_1);
                setLoading(false);
            });
        };
        t2 = [
            cloudId,
            context,
            includeHidden,
            locale,
            types,
            environment
        ];
        $[0] = cloudId;
        $[1] = context;
        $[2] = environment;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = types;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[8] !== createAnalyticsEvent || $[9] !== extensions || $[10] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[8] = createAnalyticsEvent;
        $[9] = extensions;
        $[10] = page;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[13] !== createAnalyticsEvent || $[14] !== error || $[15] !== extensions || $[16] !== page) {
        t5 = ()=>{
            if (!extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
                const err_0 = error.source.errors.find($c7be4ab3ad813948$var$_temp2);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "useExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[13] = createAnalyticsEvent;
        $[14] = error;
        $[15] = extensions;
        $[16] = page;
        $[17] = t5;
        $[18] = t6;
    } else {
        t5 = $[17];
        t6 = $[18];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[19] !== extensions) {
        t7 = extensions || [];
        $[19] = extensions;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== error || $[22] !== loading || $[23] !== t7) {
        t8 = {
            extensions: t7,
            loading: loading,
            error: error
        };
        $[21] = error;
        $[22] = loading;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const cacheKey = JSON.stringify({
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden,
            locale: locale,
            types: types
        });
        if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
            const extensions_0 = new Promise((resolve, reject)=>{
                (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                    cloudId: cloudId,
                    context: // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                    context,
                    includeHidden: includeHidden,
                    locale: locale,
                    types: types
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                            },
                            allowOnExternalPage: true
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                            data: data,
                            loading: false
                        }));
                    },
                    error: (error_0)=>{
                        $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                        reject(error_0);
                    }
                });
            });
            $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
        }
        $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
            setExtensions(extensions_1);
            setLoading(false);
        }).catch((error_1)=>{
            setError(error_1);
            setLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        locale,
        types,
        environment
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
            const err_0 = error.source.errors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
function $c7be4ab3ad813948$var$_temp(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
function $c7be4ab3ad813948$var$_temp2(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $c7be4ab3ad813948$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $c7be4ab3ad813948$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $c7be4ab3ad813948$export$55348c7eb6377fe1;
module.exports["usePrefilteredExtensionListRelay"] = $c7be4ab3ad813948$export$f55e1916fecb1860;

});

parcelRegister("gGKeL", function(module, exports) {
/**
 * @generated SignedSource<<0f5c3c24344d3900f0ac53d7aab68fae>>
 * @relayHash 3c7314efdc53f274caf83358ee897ee6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 904e5a459b011295a8e77317b65201f644f4b1769c4e8d76d1712b4870225d5e
const $57d2af88a889106f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "sandboxPolicies"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "904e5a459b011295a8e77317b65201f644f4b1769c4e8d76d1712b4870225d5e",
            "metadata": {},
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$57d2af88a889106f$var$node.hash = "1b992f547bdf43b63a7ddd13074a26b2";
var $57d2af88a889106f$export$2e2bcd8739ae039 = $57d2af88a889106f$var$node;
module.exports["default"] = $57d2af88a889106f$export$2e2bcd8739ae039;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("6GvGD"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("hYkrv"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("c19Bu"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("h0PPQ"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("khyJi"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("aDqK1"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("5a0IY"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("1udyT"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("2PFxD"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("du0t7"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("jBfC3"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("bydAg"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("6GvGD", function(module, exports) {

let $4ddf3e9f1bf0b5d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4ddf3e9f1bf0b5d2$var$load("hUbK8"),
    $4ddf3e9f1bf0b5d2$var$load("LWh5V"),
    $4ddf3e9f1bf0b5d2$var$load("eNXrl"),
    $4ddf3e9f1bf0b5d2$var$load("2RkKX"),
    $4ddf3e9f1bf0b5d2$var$load("dZsGY"),
    $4ddf3e9f1bf0b5d2$var$load("1Gr4q"),
    $4ddf3e9f1bf0b5d2$var$load("hLNtE"),
    $4ddf3e9f1bf0b5d2$var$load("crwC4"),
    $4ddf3e9f1bf0b5d2$var$load("7G12e"),
    $4ddf3e9f1bf0b5d2$var$load("h4Nf7"),
    $4ddf3e9f1bf0b5d2$var$load("123MJ"),
    $4ddf3e9f1bf0b5d2$var$load("elQ9h"),
    $4ddf3e9f1bf0b5d2$var$load("4XoWv"),
    $4ddf3e9f1bf0b5d2$var$load("59hV4"),
    $4ddf3e9f1bf0b5d2$var$load("cFgVe"),
    $4ddf3e9f1bf0b5d2$var$load("5wzAc"),
    $4ddf3e9f1bf0b5d2$var$load("aLwQm"),
    $4ddf3e9f1bf0b5d2$var$load("gBfQ7"),
    $4ddf3e9f1bf0b5d2$var$load("eTvQu"),
    $4ddf3e9f1bf0b5d2$var$load("dr883"),
    $4ddf3e9f1bf0b5d2$var$load("bePXd"),
    $4ddf3e9f1bf0b5d2$var$load("kHXvF"),
    $4ddf3e9f1bf0b5d2$var$load("ea3NB"),
    $4ddf3e9f1bf0b5d2$var$load("kv4Kv"),
    $4ddf3e9f1bf0b5d2$var$load("qCaIx"),
    $4ddf3e9f1bf0b5d2$var$load("fuOfV"),
    $4ddf3e9f1bf0b5d2$var$load("jL1Ke"),
    $4ddf3e9f1bf0b5d2$var$load("5MQ0D"),
    $4ddf3e9f1bf0b5d2$var$load("exBMi"),
    $4ddf3e9f1bf0b5d2$var$load("6vqGz"),
    $4ddf3e9f1bf0b5d2$var$load("iBJWz"),
    $4ddf3e9f1bf0b5d2$var$load("cvcNg"),
    $4ddf3e9f1bf0b5d2$var$load("iZR3N"),
    $4ddf3e9f1bf0b5d2$var$load("jXM1T"),
    $4ddf3e9f1bf0b5d2$var$load("6wr18"),
    $4ddf3e9f1bf0b5d2$var$load("4N1MY"),
    $4ddf3e9f1bf0b5d2$var$load("ffEVr"),
    $4ddf3e9f1bf0b5d2$var$load("g81ly"),
    $4ddf3e9f1bf0b5d2$var$load("e3LAK"),
    $4ddf3e9f1bf0b5d2$var$load("eS3wT"),
    $4ddf3e9f1bf0b5d2$var$load("4uO8Y"),
    $4ddf3e9f1bf0b5d2$var$load("60QcS"),
    $4ddf3e9f1bf0b5d2$var$load("Wowvf"),
    $4ddf3e9f1bf0b5d2$var$load("2l8zo"),
    $4ddf3e9f1bf0b5d2$var$load("fEWss"),
    $4ddf3e9f1bf0b5d2$var$load("ceGPg"),
    $4ddf3e9f1bf0b5d2$var$load("26l7c"),
    $4ddf3e9f1bf0b5d2$var$load("hhss7"),
    $4ddf3e9f1bf0b5d2$var$load("cgKMu"),
    $4ddf3e9f1bf0b5d2$var$load("lnKog"),
    $4ddf3e9f1bf0b5d2$var$load("aAWLw"),
    $4ddf3e9f1bf0b5d2$var$load("7EorR"),
    $4ddf3e9f1bf0b5d2$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("hYkrv", function(module, exports) {

let $d157e5baca9e8214$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d157e5baca9e8214$var$load("hUbK8"),
    $d157e5baca9e8214$var$load("LWh5V"),
    $d157e5baca9e8214$var$load("eNXrl"),
    $d157e5baca9e8214$var$load("2RkKX"),
    $d157e5baca9e8214$var$load("dZsGY"),
    $d157e5baca9e8214$var$load("1Gr4q"),
    $d157e5baca9e8214$var$load("hLNtE"),
    $d157e5baca9e8214$var$load("crwC4"),
    $d157e5baca9e8214$var$load("7G12e"),
    $d157e5baca9e8214$var$load("h4Nf7"),
    $d157e5baca9e8214$var$load("123MJ"),
    $d157e5baca9e8214$var$load("elQ9h"),
    $d157e5baca9e8214$var$load("4XoWv"),
    $d157e5baca9e8214$var$load("59hV4"),
    $d157e5baca9e8214$var$load("cFgVe"),
    $d157e5baca9e8214$var$load("5wzAc"),
    $d157e5baca9e8214$var$load("aLwQm"),
    $d157e5baca9e8214$var$load("gBfQ7"),
    $d157e5baca9e8214$var$load("eTvQu"),
    $d157e5baca9e8214$var$load("dr883"),
    $d157e5baca9e8214$var$load("bePXd"),
    $d157e5baca9e8214$var$load("kHXvF"),
    $d157e5baca9e8214$var$load("ea3NB"),
    $d157e5baca9e8214$var$load("kv4Kv"),
    $d157e5baca9e8214$var$load("qCaIx"),
    $d157e5baca9e8214$var$load("fuOfV"),
    $d157e5baca9e8214$var$load("jL1Ke"),
    $d157e5baca9e8214$var$load("5MQ0D"),
    $d157e5baca9e8214$var$load("exBMi"),
    $d157e5baca9e8214$var$load("6vqGz"),
    $d157e5baca9e8214$var$load("iBJWz"),
    $d157e5baca9e8214$var$load("cvcNg"),
    $d157e5baca9e8214$var$load("iZR3N"),
    $d157e5baca9e8214$var$load("jXM1T"),
    $d157e5baca9e8214$var$load("6wr18"),
    $d157e5baca9e8214$var$load("4N1MY"),
    $d157e5baca9e8214$var$load("ffEVr"),
    $d157e5baca9e8214$var$load("g81ly"),
    $d157e5baca9e8214$var$load("e3LAK"),
    $d157e5baca9e8214$var$load("eS3wT"),
    $d157e5baca9e8214$var$load("4uO8Y"),
    $d157e5baca9e8214$var$load("60QcS"),
    $d157e5baca9e8214$var$load("Wowvf"),
    $d157e5baca9e8214$var$load("2l8zo"),
    $d157e5baca9e8214$var$load("fEWss"),
    $d157e5baca9e8214$var$load("ceGPg"),
    $d157e5baca9e8214$var$load("26l7c"),
    $d157e5baca9e8214$var$load("hhss7"),
    $d157e5baca9e8214$var$load("cgKMu"),
    $d157e5baca9e8214$var$load("lnKog"),
    $d157e5baca9e8214$var$load("aAWLw"),
    $d157e5baca9e8214$var$load("7EorR"),
    $d157e5baca9e8214$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("c19Bu", function(module, exports) {

let $8bfd07244d38d92b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8bfd07244d38d92b$var$load("hUbK8"),
    $8bfd07244d38d92b$var$load("LWh5V"),
    $8bfd07244d38d92b$var$load("eNXrl"),
    $8bfd07244d38d92b$var$load("2RkKX"),
    $8bfd07244d38d92b$var$load("dZsGY"),
    $8bfd07244d38d92b$var$load("1Gr4q"),
    $8bfd07244d38d92b$var$load("hLNtE"),
    $8bfd07244d38d92b$var$load("crwC4"),
    $8bfd07244d38d92b$var$load("7G12e"),
    $8bfd07244d38d92b$var$load("h4Nf7"),
    $8bfd07244d38d92b$var$load("123MJ"),
    $8bfd07244d38d92b$var$load("elQ9h"),
    $8bfd07244d38d92b$var$load("4XoWv"),
    $8bfd07244d38d92b$var$load("59hV4"),
    $8bfd07244d38d92b$var$load("cFgVe"),
    $8bfd07244d38d92b$var$load("5wzAc"),
    $8bfd07244d38d92b$var$load("aLwQm"),
    $8bfd07244d38d92b$var$load("gBfQ7"),
    $8bfd07244d38d92b$var$load("eTvQu"),
    $8bfd07244d38d92b$var$load("dr883"),
    $8bfd07244d38d92b$var$load("bePXd"),
    $8bfd07244d38d92b$var$load("kHXvF"),
    $8bfd07244d38d92b$var$load("ea3NB"),
    $8bfd07244d38d92b$var$load("kv4Kv"),
    $8bfd07244d38d92b$var$load("qCaIx"),
    $8bfd07244d38d92b$var$load("fuOfV"),
    $8bfd07244d38d92b$var$load("jL1Ke"),
    $8bfd07244d38d92b$var$load("5MQ0D"),
    $8bfd07244d38d92b$var$load("exBMi"),
    $8bfd07244d38d92b$var$load("6vqGz"),
    $8bfd07244d38d92b$var$load("iBJWz"),
    $8bfd07244d38d92b$var$load("cvcNg"),
    $8bfd07244d38d92b$var$load("iZR3N"),
    $8bfd07244d38d92b$var$load("jXM1T"),
    $8bfd07244d38d92b$var$load("6wr18"),
    $8bfd07244d38d92b$var$load("4N1MY"),
    $8bfd07244d38d92b$var$load("ffEVr"),
    $8bfd07244d38d92b$var$load("g81ly"),
    $8bfd07244d38d92b$var$load("e3LAK"),
    $8bfd07244d38d92b$var$load("eS3wT"),
    $8bfd07244d38d92b$var$load("4uO8Y"),
    $8bfd07244d38d92b$var$load("60QcS"),
    $8bfd07244d38d92b$var$load("Wowvf"),
    $8bfd07244d38d92b$var$load("2l8zo"),
    $8bfd07244d38d92b$var$load("fEWss"),
    $8bfd07244d38d92b$var$load("ceGPg"),
    $8bfd07244d38d92b$var$load("26l7c"),
    $8bfd07244d38d92b$var$load("hhss7"),
    $8bfd07244d38d92b$var$load("cgKMu"),
    $8bfd07244d38d92b$var$load("lnKog"),
    $8bfd07244d38d92b$var$load("aAWLw"),
    $8bfd07244d38d92b$var$load("7EorR"),
    $8bfd07244d38d92b$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("h0PPQ", function(module, exports) {

let $c62aa5256a123966$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c62aa5256a123966$var$load("eS3wT"),
    $c62aa5256a123966$var$load("4uO8Y"),
    $c62aa5256a123966$var$load("hUbK8"),
    $c62aa5256a123966$var$load("2RkKX"),
    $c62aa5256a123966$var$load("1Gr4q"),
    $c62aa5256a123966$var$load("hLNtE"),
    $c62aa5256a123966$var$load("crwC4"),
    $c62aa5256a123966$var$load("7G12e"),
    $c62aa5256a123966$var$load("h4Nf7"),
    $c62aa5256a123966$var$load("123MJ"),
    $c62aa5256a123966$var$load("elQ9h"),
    $c62aa5256a123966$var$load("4XoWv"),
    $c62aa5256a123966$var$load("cFgVe"),
    $c62aa5256a123966$var$load("5wzAc"),
    $c62aa5256a123966$var$load("aLwQm"),
    $c62aa5256a123966$var$load("gBfQ7"),
    $c62aa5256a123966$var$load("eTvQu"),
    $c62aa5256a123966$var$load("kHXvF"),
    $c62aa5256a123966$var$load("ea3NB"),
    $c62aa5256a123966$var$load("kv4Kv"),
    $c62aa5256a123966$var$load("qCaIx"),
    $c62aa5256a123966$var$load("exBMi"),
    $c62aa5256a123966$var$load("6vqGz"),
    $c62aa5256a123966$var$load("iBJWz"),
    $c62aa5256a123966$var$load("cvcNg"),
    $c62aa5256a123966$var$load("iZR3N"),
    $c62aa5256a123966$var$load("jXM1T"),
    $c62aa5256a123966$var$load("6wr18"),
    $c62aa5256a123966$var$load("4N1MY"),
    $c62aa5256a123966$var$load("ffEVr"),
    $c62aa5256a123966$var$load("g81ly"),
    $c62aa5256a123966$var$load("e3LAK"),
    $c62aa5256a123966$var$load("cgKMu"),
    $c62aa5256a123966$var$load("60QcS"),
    $c62aa5256a123966$var$load("Wowvf"),
    $c62aa5256a123966$var$load("2l8zo"),
    $c62aa5256a123966$var$load("fEWss"),
    $c62aa5256a123966$var$load("ceGPg"),
    $c62aa5256a123966$var$load("26l7c"),
    $c62aa5256a123966$var$load("hhss7"),
    $c62aa5256a123966$var$load("aAWLw"),
    $c62aa5256a123966$var$load("7EorR"),
    $c62aa5256a123966$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("khyJi", function(module, exports) {

let $ec4055c2d9fb7f6e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ec4055c2d9fb7f6e$var$load("eS3wT"),
    $ec4055c2d9fb7f6e$var$load("4uO8Y"),
    $ec4055c2d9fb7f6e$var$load("hUbK8"),
    $ec4055c2d9fb7f6e$var$load("2RkKX"),
    $ec4055c2d9fb7f6e$var$load("1Gr4q"),
    $ec4055c2d9fb7f6e$var$load("hLNtE"),
    $ec4055c2d9fb7f6e$var$load("crwC4"),
    $ec4055c2d9fb7f6e$var$load("7G12e"),
    $ec4055c2d9fb7f6e$var$load("h4Nf7"),
    $ec4055c2d9fb7f6e$var$load("123MJ"),
    $ec4055c2d9fb7f6e$var$load("elQ9h"),
    $ec4055c2d9fb7f6e$var$load("4XoWv"),
    $ec4055c2d9fb7f6e$var$load("cFgVe"),
    $ec4055c2d9fb7f6e$var$load("5wzAc"),
    $ec4055c2d9fb7f6e$var$load("aLwQm"),
    $ec4055c2d9fb7f6e$var$load("gBfQ7"),
    $ec4055c2d9fb7f6e$var$load("eTvQu"),
    $ec4055c2d9fb7f6e$var$load("kHXvF"),
    $ec4055c2d9fb7f6e$var$load("ea3NB"),
    $ec4055c2d9fb7f6e$var$load("kv4Kv"),
    $ec4055c2d9fb7f6e$var$load("qCaIx"),
    $ec4055c2d9fb7f6e$var$load("exBMi"),
    $ec4055c2d9fb7f6e$var$load("6vqGz"),
    $ec4055c2d9fb7f6e$var$load("iBJWz"),
    $ec4055c2d9fb7f6e$var$load("cvcNg"),
    $ec4055c2d9fb7f6e$var$load("iZR3N"),
    $ec4055c2d9fb7f6e$var$load("jXM1T"),
    $ec4055c2d9fb7f6e$var$load("6wr18"),
    $ec4055c2d9fb7f6e$var$load("4N1MY"),
    $ec4055c2d9fb7f6e$var$load("ffEVr"),
    $ec4055c2d9fb7f6e$var$load("g81ly"),
    $ec4055c2d9fb7f6e$var$load("e3LAK"),
    $ec4055c2d9fb7f6e$var$load("cgKMu"),
    $ec4055c2d9fb7f6e$var$load("60QcS"),
    $ec4055c2d9fb7f6e$var$load("Wowvf"),
    $ec4055c2d9fb7f6e$var$load("2l8zo"),
    $ec4055c2d9fb7f6e$var$load("fEWss"),
    $ec4055c2d9fb7f6e$var$load("ceGPg"),
    $ec4055c2d9fb7f6e$var$load("26l7c"),
    $ec4055c2d9fb7f6e$var$load("hhss7"),
    $ec4055c2d9fb7f6e$var$load("aAWLw"),
    $ec4055c2d9fb7f6e$var$load("7EorR"),
    $ec4055c2d9fb7f6e$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("aDqK1", function(module, exports) {

let $7be24a2a36b2dd0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7be24a2a36b2dd0b$var$load("eS3wT"),
    $7be24a2a36b2dd0b$var$load("4uO8Y"),
    $7be24a2a36b2dd0b$var$load("hUbK8"),
    $7be24a2a36b2dd0b$var$load("2RkKX"),
    $7be24a2a36b2dd0b$var$load("1Gr4q"),
    $7be24a2a36b2dd0b$var$load("hLNtE"),
    $7be24a2a36b2dd0b$var$load("crwC4"),
    $7be24a2a36b2dd0b$var$load("7G12e"),
    $7be24a2a36b2dd0b$var$load("h4Nf7"),
    $7be24a2a36b2dd0b$var$load("123MJ"),
    $7be24a2a36b2dd0b$var$load("elQ9h"),
    $7be24a2a36b2dd0b$var$load("4XoWv"),
    $7be24a2a36b2dd0b$var$load("cFgVe"),
    $7be24a2a36b2dd0b$var$load("5wzAc"),
    $7be24a2a36b2dd0b$var$load("aLwQm"),
    $7be24a2a36b2dd0b$var$load("gBfQ7"),
    $7be24a2a36b2dd0b$var$load("eTvQu"),
    $7be24a2a36b2dd0b$var$load("kHXvF"),
    $7be24a2a36b2dd0b$var$load("ea3NB"),
    $7be24a2a36b2dd0b$var$load("kv4Kv"),
    $7be24a2a36b2dd0b$var$load("qCaIx"),
    $7be24a2a36b2dd0b$var$load("exBMi"),
    $7be24a2a36b2dd0b$var$load("6vqGz"),
    $7be24a2a36b2dd0b$var$load("iBJWz"),
    $7be24a2a36b2dd0b$var$load("cvcNg"),
    $7be24a2a36b2dd0b$var$load("iZR3N"),
    $7be24a2a36b2dd0b$var$load("jXM1T"),
    $7be24a2a36b2dd0b$var$load("6wr18"),
    $7be24a2a36b2dd0b$var$load("4N1MY"),
    $7be24a2a36b2dd0b$var$load("ffEVr"),
    $7be24a2a36b2dd0b$var$load("g81ly"),
    $7be24a2a36b2dd0b$var$load("e3LAK"),
    $7be24a2a36b2dd0b$var$load("cgKMu"),
    $7be24a2a36b2dd0b$var$load("60QcS"),
    $7be24a2a36b2dd0b$var$load("Wowvf"),
    $7be24a2a36b2dd0b$var$load("2l8zo"),
    $7be24a2a36b2dd0b$var$load("fEWss"),
    $7be24a2a36b2dd0b$var$load("ceGPg"),
    $7be24a2a36b2dd0b$var$load("26l7c"),
    $7be24a2a36b2dd0b$var$load("hhss7"),
    $7be24a2a36b2dd0b$var$load("aAWLw"),
    $7be24a2a36b2dd0b$var$load("7EorR"),
    $7be24a2a36b2dd0b$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("5a0IY", function(module, exports) {

let $3c1e72c498fff006$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3c1e72c498fff006$var$load("eS3wT"),
    $3c1e72c498fff006$var$load("4uO8Y"),
    $3c1e72c498fff006$var$load("hUbK8"),
    $3c1e72c498fff006$var$load("2RkKX"),
    $3c1e72c498fff006$var$load("1Gr4q"),
    $3c1e72c498fff006$var$load("hLNtE"),
    $3c1e72c498fff006$var$load("crwC4"),
    $3c1e72c498fff006$var$load("7G12e"),
    $3c1e72c498fff006$var$load("h4Nf7"),
    $3c1e72c498fff006$var$load("123MJ"),
    $3c1e72c498fff006$var$load("elQ9h"),
    $3c1e72c498fff006$var$load("4XoWv"),
    $3c1e72c498fff006$var$load("cFgVe"),
    $3c1e72c498fff006$var$load("5wzAc"),
    $3c1e72c498fff006$var$load("aLwQm"),
    $3c1e72c498fff006$var$load("gBfQ7"),
    $3c1e72c498fff006$var$load("eTvQu"),
    $3c1e72c498fff006$var$load("kHXvF"),
    $3c1e72c498fff006$var$load("ea3NB"),
    $3c1e72c498fff006$var$load("kv4Kv"),
    $3c1e72c498fff006$var$load("qCaIx"),
    $3c1e72c498fff006$var$load("exBMi"),
    $3c1e72c498fff006$var$load("6vqGz"),
    $3c1e72c498fff006$var$load("iBJWz"),
    $3c1e72c498fff006$var$load("cvcNg"),
    $3c1e72c498fff006$var$load("iZR3N"),
    $3c1e72c498fff006$var$load("jXM1T"),
    $3c1e72c498fff006$var$load("6wr18"),
    $3c1e72c498fff006$var$load("4N1MY"),
    $3c1e72c498fff006$var$load("ffEVr"),
    $3c1e72c498fff006$var$load("g81ly"),
    $3c1e72c498fff006$var$load("e3LAK"),
    $3c1e72c498fff006$var$load("60QcS"),
    $3c1e72c498fff006$var$load("Wowvf"),
    $3c1e72c498fff006$var$load("2l8zo"),
    $3c1e72c498fff006$var$load("fEWss"),
    $3c1e72c498fff006$var$load("ceGPg"),
    $3c1e72c498fff006$var$load("26l7c"),
    $3c1e72c498fff006$var$load("hhss7"),
    $3c1e72c498fff006$var$load("cgKMu"),
    $3c1e72c498fff006$var$load("lnKog"),
    $3c1e72c498fff006$var$load("aAWLw"),
    $3c1e72c498fff006$var$load("7EorR"),
    $3c1e72c498fff006$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("1udyT", function(module, exports) {

let $11531cdc96747f11$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $11531cdc96747f11$var$load("hUbK8"),
    $11531cdc96747f11$var$load("2RkKX"),
    $11531cdc96747f11$var$load("dZsGY"),
    $11531cdc96747f11$var$load("1Gr4q"),
    $11531cdc96747f11$var$load("hLNtE"),
    $11531cdc96747f11$var$load("crwC4"),
    $11531cdc96747f11$var$load("7G12e"),
    $11531cdc96747f11$var$load("h4Nf7"),
    $11531cdc96747f11$var$load("123MJ"),
    $11531cdc96747f11$var$load("elQ9h"),
    $11531cdc96747f11$var$load("4XoWv"),
    $11531cdc96747f11$var$load("59hV4"),
    $11531cdc96747f11$var$load("cFgVe"),
    $11531cdc96747f11$var$load("5wzAc"),
    $11531cdc96747f11$var$load("aLwQm"),
    $11531cdc96747f11$var$load("gBfQ7"),
    $11531cdc96747f11$var$load("eTvQu"),
    $11531cdc96747f11$var$load("dr883"),
    $11531cdc96747f11$var$load("bePXd"),
    $11531cdc96747f11$var$load("kHXvF"),
    $11531cdc96747f11$var$load("ea3NB"),
    $11531cdc96747f11$var$load("kv4Kv"),
    $11531cdc96747f11$var$load("qCaIx"),
    $11531cdc96747f11$var$load("fuOfV"),
    $11531cdc96747f11$var$load("jL1Ke"),
    $11531cdc96747f11$var$load("5MQ0D"),
    $11531cdc96747f11$var$load("exBMi"),
    $11531cdc96747f11$var$load("6vqGz"),
    $11531cdc96747f11$var$load("iBJWz"),
    $11531cdc96747f11$var$load("cvcNg"),
    $11531cdc96747f11$var$load("iZR3N"),
    $11531cdc96747f11$var$load("jXM1T"),
    $11531cdc96747f11$var$load("6wr18"),
    $11531cdc96747f11$var$load("4N1MY"),
    $11531cdc96747f11$var$load("ffEVr"),
    $11531cdc96747f11$var$load("g81ly"),
    $11531cdc96747f11$var$load("e3LAK"),
    $11531cdc96747f11$var$load("eS3wT"),
    $11531cdc96747f11$var$load("4uO8Y"),
    $11531cdc96747f11$var$load("60QcS"),
    $11531cdc96747f11$var$load("Wowvf"),
    $11531cdc96747f11$var$load("2l8zo"),
    $11531cdc96747f11$var$load("fEWss"),
    $11531cdc96747f11$var$load("ceGPg"),
    $11531cdc96747f11$var$load("26l7c"),
    $11531cdc96747f11$var$load("hhss7"),
    $11531cdc96747f11$var$load("cgKMu"),
    $11531cdc96747f11$var$load("lnKog"),
    $11531cdc96747f11$var$load("aAWLw"),
    $11531cdc96747f11$var$load("7EorR"),
    $11531cdc96747f11$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("2PFxD", function(module, exports) {

let $2100917232ee0414$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2100917232ee0414$var$load("hUbK8"),
    $2100917232ee0414$var$load("2RkKX"),
    $2100917232ee0414$var$load("dZsGY"),
    $2100917232ee0414$var$load("1Gr4q"),
    $2100917232ee0414$var$load("hLNtE"),
    $2100917232ee0414$var$load("crwC4"),
    $2100917232ee0414$var$load("7G12e"),
    $2100917232ee0414$var$load("h4Nf7"),
    $2100917232ee0414$var$load("123MJ"),
    $2100917232ee0414$var$load("elQ9h"),
    $2100917232ee0414$var$load("4XoWv"),
    $2100917232ee0414$var$load("59hV4"),
    $2100917232ee0414$var$load("cFgVe"),
    $2100917232ee0414$var$load("5wzAc"),
    $2100917232ee0414$var$load("aLwQm"),
    $2100917232ee0414$var$load("gBfQ7"),
    $2100917232ee0414$var$load("eTvQu"),
    $2100917232ee0414$var$load("dr883"),
    $2100917232ee0414$var$load("bePXd"),
    $2100917232ee0414$var$load("kHXvF"),
    $2100917232ee0414$var$load("ea3NB"),
    $2100917232ee0414$var$load("kv4Kv"),
    $2100917232ee0414$var$load("qCaIx"),
    $2100917232ee0414$var$load("fuOfV"),
    $2100917232ee0414$var$load("jL1Ke"),
    $2100917232ee0414$var$load("5MQ0D"),
    $2100917232ee0414$var$load("exBMi"),
    $2100917232ee0414$var$load("6vqGz"),
    $2100917232ee0414$var$load("iBJWz"),
    $2100917232ee0414$var$load("cvcNg"),
    $2100917232ee0414$var$load("iZR3N"),
    $2100917232ee0414$var$load("jXM1T"),
    $2100917232ee0414$var$load("6wr18"),
    $2100917232ee0414$var$load("4N1MY"),
    $2100917232ee0414$var$load("ffEVr"),
    $2100917232ee0414$var$load("g81ly"),
    $2100917232ee0414$var$load("e3LAK"),
    $2100917232ee0414$var$load("eS3wT"),
    $2100917232ee0414$var$load("4uO8Y"),
    $2100917232ee0414$var$load("60QcS"),
    $2100917232ee0414$var$load("Wowvf"),
    $2100917232ee0414$var$load("2l8zo"),
    $2100917232ee0414$var$load("fEWss"),
    $2100917232ee0414$var$load("ceGPg"),
    $2100917232ee0414$var$load("26l7c"),
    $2100917232ee0414$var$load("hhss7"),
    $2100917232ee0414$var$load("cgKMu"),
    $2100917232ee0414$var$load("lnKog"),
    $2100917232ee0414$var$load("aAWLw"),
    $2100917232ee0414$var$load("7EorR"),
    $2100917232ee0414$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("du0t7", function(module, exports) {

let $9d0e70c95e792d79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9d0e70c95e792d79$var$load("eS3wT"),
    $9d0e70c95e792d79$var$load("4uO8Y"),
    $9d0e70c95e792d79$var$load("hUbK8"),
    $9d0e70c95e792d79$var$load("2RkKX"),
    $9d0e70c95e792d79$var$load("1Gr4q"),
    $9d0e70c95e792d79$var$load("hLNtE"),
    $9d0e70c95e792d79$var$load("crwC4"),
    $9d0e70c95e792d79$var$load("7G12e"),
    $9d0e70c95e792d79$var$load("h4Nf7"),
    $9d0e70c95e792d79$var$load("123MJ"),
    $9d0e70c95e792d79$var$load("elQ9h"),
    $9d0e70c95e792d79$var$load("4XoWv"),
    $9d0e70c95e792d79$var$load("cFgVe"),
    $9d0e70c95e792d79$var$load("5wzAc"),
    $9d0e70c95e792d79$var$load("aLwQm"),
    $9d0e70c95e792d79$var$load("gBfQ7"),
    $9d0e70c95e792d79$var$load("eTvQu"),
    $9d0e70c95e792d79$var$load("kHXvF"),
    $9d0e70c95e792d79$var$load("ea3NB"),
    $9d0e70c95e792d79$var$load("kv4Kv"),
    $9d0e70c95e792d79$var$load("qCaIx"),
    $9d0e70c95e792d79$var$load("exBMi"),
    $9d0e70c95e792d79$var$load("6vqGz"),
    $9d0e70c95e792d79$var$load("iBJWz"),
    $9d0e70c95e792d79$var$load("cvcNg"),
    $9d0e70c95e792d79$var$load("iZR3N"),
    $9d0e70c95e792d79$var$load("jXM1T"),
    $9d0e70c95e792d79$var$load("6wr18"),
    $9d0e70c95e792d79$var$load("4N1MY"),
    $9d0e70c95e792d79$var$load("ffEVr"),
    $9d0e70c95e792d79$var$load("g81ly"),
    $9d0e70c95e792d79$var$load("e3LAK"),
    $9d0e70c95e792d79$var$load("cgKMu"),
    $9d0e70c95e792d79$var$load("60QcS"),
    $9d0e70c95e792d79$var$load("Wowvf"),
    $9d0e70c95e792d79$var$load("2l8zo"),
    $9d0e70c95e792d79$var$load("fEWss"),
    $9d0e70c95e792d79$var$load("ceGPg"),
    $9d0e70c95e792d79$var$load("26l7c"),
    $9d0e70c95e792d79$var$load("hhss7"),
    $9d0e70c95e792d79$var$load("aAWLw"),
    $9d0e70c95e792d79$var$load("7EorR"),
    $9d0e70c95e792d79$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("jBfC3", function(module, exports) {

let $e44d956a24bfe607$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e44d956a24bfe607$var$load("eS3wT"),
    $e44d956a24bfe607$var$load("4uO8Y"),
    $e44d956a24bfe607$var$load("hUbK8"),
    $e44d956a24bfe607$var$load("2RkKX"),
    $e44d956a24bfe607$var$load("1Gr4q"),
    $e44d956a24bfe607$var$load("hLNtE"),
    $e44d956a24bfe607$var$load("crwC4"),
    $e44d956a24bfe607$var$load("7G12e"),
    $e44d956a24bfe607$var$load("h4Nf7"),
    $e44d956a24bfe607$var$load("123MJ"),
    $e44d956a24bfe607$var$load("elQ9h"),
    $e44d956a24bfe607$var$load("4XoWv"),
    $e44d956a24bfe607$var$load("cFgVe"),
    $e44d956a24bfe607$var$load("5wzAc"),
    $e44d956a24bfe607$var$load("aLwQm"),
    $e44d956a24bfe607$var$load("gBfQ7"),
    $e44d956a24bfe607$var$load("eTvQu"),
    $e44d956a24bfe607$var$load("kHXvF"),
    $e44d956a24bfe607$var$load("ea3NB"),
    $e44d956a24bfe607$var$load("kv4Kv"),
    $e44d956a24bfe607$var$load("qCaIx"),
    $e44d956a24bfe607$var$load("exBMi"),
    $e44d956a24bfe607$var$load("6vqGz"),
    $e44d956a24bfe607$var$load("iBJWz"),
    $e44d956a24bfe607$var$load("cvcNg"),
    $e44d956a24bfe607$var$load("iZR3N"),
    $e44d956a24bfe607$var$load("jXM1T"),
    $e44d956a24bfe607$var$load("6wr18"),
    $e44d956a24bfe607$var$load("4N1MY"),
    $e44d956a24bfe607$var$load("ffEVr"),
    $e44d956a24bfe607$var$load("g81ly"),
    $e44d956a24bfe607$var$load("e3LAK"),
    $e44d956a24bfe607$var$load("60QcS"),
    $e44d956a24bfe607$var$load("Wowvf"),
    $e44d956a24bfe607$var$load("2l8zo"),
    $e44d956a24bfe607$var$load("fEWss"),
    $e44d956a24bfe607$var$load("ceGPg"),
    $e44d956a24bfe607$var$load("26l7c"),
    $e44d956a24bfe607$var$load("hhss7"),
    $e44d956a24bfe607$var$load("cgKMu"),
    $e44d956a24bfe607$var$load("lnKog"),
    $e44d956a24bfe607$var$load("aAWLw"),
    $e44d956a24bfe607$var$load("7EorR"),
    $e44d956a24bfe607$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("bydAg", function(module, exports) {

let $868d682de9ef0645$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $868d682de9ef0645$var$load("eS3wT"),
    $868d682de9ef0645$var$load("4uO8Y"),
    $868d682de9ef0645$var$load("hUbK8"),
    $868d682de9ef0645$var$load("2RkKX"),
    $868d682de9ef0645$var$load("1Gr4q"),
    $868d682de9ef0645$var$load("hLNtE"),
    $868d682de9ef0645$var$load("crwC4"),
    $868d682de9ef0645$var$load("7G12e"),
    $868d682de9ef0645$var$load("h4Nf7"),
    $868d682de9ef0645$var$load("123MJ"),
    $868d682de9ef0645$var$load("elQ9h"),
    $868d682de9ef0645$var$load("4XoWv"),
    $868d682de9ef0645$var$load("cFgVe"),
    $868d682de9ef0645$var$load("5wzAc"),
    $868d682de9ef0645$var$load("aLwQm"),
    $868d682de9ef0645$var$load("gBfQ7"),
    $868d682de9ef0645$var$load("eTvQu"),
    $868d682de9ef0645$var$load("kHXvF"),
    $868d682de9ef0645$var$load("ea3NB"),
    $868d682de9ef0645$var$load("kv4Kv"),
    $868d682de9ef0645$var$load("qCaIx"),
    $868d682de9ef0645$var$load("exBMi"),
    $868d682de9ef0645$var$load("6vqGz"),
    $868d682de9ef0645$var$load("iBJWz"),
    $868d682de9ef0645$var$load("cvcNg"),
    $868d682de9ef0645$var$load("iZR3N"),
    $868d682de9ef0645$var$load("jXM1T"),
    $868d682de9ef0645$var$load("6wr18"),
    $868d682de9ef0645$var$load("4N1MY"),
    $868d682de9ef0645$var$load("ffEVr"),
    $868d682de9ef0645$var$load("g81ly"),
    $868d682de9ef0645$var$load("e3LAK"),
    $868d682de9ef0645$var$load("60QcS"),
    $868d682de9ef0645$var$load("Wowvf"),
    $868d682de9ef0645$var$load("2l8zo"),
    $868d682de9ef0645$var$load("fEWss"),
    $868d682de9ef0645$var$load("ceGPg"),
    $868d682de9ef0645$var$load("26l7c"),
    $868d682de9ef0645$var$load("hhss7"),
    $868d682de9ef0645$var$load("cgKMu"),
    $868d682de9ef0645$var$load("lnKog"),
    $868d682de9ef0645$var$load("aAWLw"),
    $868d682de9ef0645$var$load("7EorR"),
    $868d682de9ef0645$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("grspz", function(module, exports) {
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};
module.exports["getLocalId"] = $cdcead6f01277136$export$957229695d10ea4a;

});

parcelRegister("lvOsp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9qJAQ = parcelRequire("9qJAQ");


var $3u5lg = parcelRequire("3u5lg");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $8BQV6 = parcelRequire("8BQV6");


var $422HI = parcelRequire("422HI");


var $26Yfd = parcelRequire("26Yfd");


var $bUmU8 = parcelRequire("bUmU8");


var $kczYx = parcelRequire("kczYx");


var $iffSy = parcelRequire("iffSy");


var $3NBsC = parcelRequire("3NBsC");


var $7q7rs = parcelRequire("7q7rs");


var $5T18X = parcelRequire("5T18X");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");


var $bFdYQ = parcelRequire("bFdYQ");


var $3VgTg = parcelRequire("3VgTg");


var $7M67g = parcelRequire("7M67g");

/** Synced-each-render ref; no microtask lag. */ function $278c8d04dad7bc1d$var$useSyncedRef(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
/**
 * Coerce an unknown thrown value into an ApolloErrorInterop so callers can
 * read Apollo's `graphQLErrors` / `networkError` fields uniformly across the
 * Apollo and Relay branches.
 */ function $278c8d04dad7bc1d$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $278c8d04dad7bc1d$var$getOperationName(node) {
    if ('definitions' in node) {
        const def = node.definitions?.find((d)=>d.kind === 'OperationDefinition' && 'name' in d);
        return def?.name?.value ?? 'unknown';
    }
    return 'unknown';
}
function $278c8d04dad7bc1d$export$363a8d7f501f3769(query, options) {
    const operationName = (0, $7M67g.getRelayOperationName)(query);
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        operationName: operationName,
        phase: 'lazy'
    })) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $278c8d04dad7bc1d$var$useLazyQueryInteropApollo(query, options);
}
const $278c8d04dad7bc1d$var$useLazyQueryInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(53);
    let apolloFetchPolicy;
    let apolloOptions;
    let interopApolloAggClient;
    let t0;
    if ($[0] !== options) {
        ({ interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {});
        apolloFetchPolicy = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.fetchPolicy);
        t0 = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.nextFetchPolicy);
        $[0] = options;
        $[1] = apolloFetchPolicy;
        $[2] = apolloOptions;
        $[3] = interopApolloAggClient;
        $[4] = t0;
    } else {
        apolloFetchPolicy = $[1];
        apolloOptions = $[2];
        interopApolloAggClient = $[3];
        t0 = $[4];
    }
    const apolloNextFetchPolicy = t0;
    const t1 = options?.__callerPackage__;
    let t2;
    if ($[5] !== apolloFetchPolicy || $[6] !== apolloOptions.onCompleted || $[7] !== apolloOptions.variables || $[8] !== interopApolloAggClient || $[9] !== query || $[10] !== t1) {
        t2 = {
            query: query,
            variables: apolloOptions.variables,
            fetchPolicy: apolloFetchPolicy,
            useAggClient: interopApolloAggClient,
            onCompleted: apolloOptions.onCompleted,
            callerPackage: t1
        };
        $[5] = apolloFetchPolicy;
        $[6] = apolloOptions.onCompleted;
        $[7] = apolloOptions.variables;
        $[8] = interopApolloAggClient;
        $[9] = query;
        $[10] = t1;
        $[11] = t2;
    } else t2 = $[11];
    const { getLatestVariables: getLatestVariables, getVariables: getCacheBridgeVariables, isEnabled: isCacheBridgeEnabled, onCompleted: onApolloCompletedWithCacheBridge, syncObservedResult: syncObservedResult, updateLatestVariables: updateLatestVariables } = (0, $3VgTg.useApolloQueryCacheBridgeSync)(t2);
    const onApolloCompleted = isCacheBridgeEnabled ? onApolloCompletedWithCacheBridge : apolloOptions.onCompleted;
    let t3;
    if ($[12] !== query) {
        t3 = (0, $86okN.toDocumentNode)(query);
        $[12] = query;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== apolloNextFetchPolicy) {
        t4 = apolloNextFetchPolicy ? {
            nextFetchPolicy: apolloNextFetchPolicy
        } : {};
        $[14] = apolloNextFetchPolicy;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== onApolloCompleted) {
        t5 = onApolloCompleted ? {
            onCompleted: onApolloCompleted
        } : {};
        $[16] = onApolloCompleted;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== interopApolloAggClient) {
        t6 = interopApolloAggClient ? {
            client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
        } : {};
        $[18] = interopApolloAggClient;
        $[19] = t6;
    } else t6 = $[19];
    const t7 = apolloOptions?.context;
    const t8 = query.params?.id;
    let t9;
    if ($[20] !== t7 || $[21] !== t8) {
        t9 = {
            ...t7,
            requestId: t8
        };
        $[20] = t7;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== apolloFetchPolicy || $[24] !== apolloOptions || $[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== t9) {
        t10 = {
            ...apolloOptions,
            fetchPolicy: apolloFetchPolicy,
            ...t4,
            ...t5,
            ...t6,
            context: t9
        };
        $[23] = apolloFetchPolicy;
        $[24] = apolloOptions;
        $[25] = t4;
        $[26] = t5;
        $[27] = t6;
        $[28] = t9;
        $[29] = t10;
    } else t10 = $[29];
    const lazyQueryResult = (0, $9qJAQ.useLazyQuery)(t3, t10);
    const [executeLazyQuery, apolloResult] = lazyQueryResult;
    const apolloData = apolloResult.data;
    const apolloError = apolloResult.error;
    const apolloCalled = apolloResult.called;
    let t11;
    if ($[30] !== apolloResult.variables || $[31] !== getCacheBridgeVariables) {
        t11 = getCacheBridgeVariables(apolloResult.variables);
        $[30] = apolloResult.variables;
        $[31] = getCacheBridgeVariables;
        $[32] = t11;
    } else t11 = $[32];
    const apolloVariables = t11;
    let t12;
    let t13;
    if ($[33] !== apolloVariables || $[34] !== isCacheBridgeEnabled || $[35] !== updateLatestVariables) {
        t12 = ()=>{
            if (!isCacheBridgeEnabled) return;
            updateLatestVariables(apolloVariables);
        };
        t13 = [
            apolloVariables,
            isCacheBridgeEnabled,
            updateLatestVariables
        ];
        $[33] = apolloVariables;
        $[34] = isCacheBridgeEnabled;
        $[35] = updateLatestVariables;
        $[36] = t12;
        $[37] = t13;
    } else {
        t12 = $[36];
        t13 = $[37];
    }
    (0, $cozmU.useEffect)(t12, t13);
    let t14;
    let t15;
    if ($[38] !== apolloCalled || $[39] !== apolloData || $[40] !== apolloError || $[41] !== apolloVariables || $[42] !== isCacheBridgeEnabled || $[43] !== syncObservedResult) {
        t14 = ()=>{
            if (!isCacheBridgeEnabled) return;
            syncObservedResult({
                skip: !apolloCalled,
                variables: apolloVariables,
                data: apolloData,
                error: apolloError
            });
        };
        t15 = [
            apolloCalled,
            apolloData,
            apolloError,
            apolloVariables,
            isCacheBridgeEnabled,
            syncObservedResult
        ];
        $[38] = apolloCalled;
        $[39] = apolloData;
        $[40] = apolloError;
        $[41] = apolloVariables;
        $[42] = isCacheBridgeEnabled;
        $[43] = syncObservedResult;
        $[44] = t14;
        $[45] = t15;
    } else {
        t14 = $[44];
        t15 = $[45];
    }
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    if ($[46] !== executeLazyQuery || $[47] !== getLatestVariables || $[48] !== updateLatestVariables) {
        t16 = (executeOptions)=>{
            updateLatestVariables(executeOptions?.variables ?? getLatestVariables());
            return executeLazyQuery(executeOptions);
        };
        $[46] = executeLazyQuery;
        $[47] = getLatestVariables;
        $[48] = updateLatestVariables;
        $[49] = t16;
    } else t16 = $[49];
    const executeLazyQueryWithCacheBridgeVariables = t16;
    if (!isCacheBridgeEnabled) return lazyQueryResult;
    let t17;
    if ($[50] !== apolloResult || $[51] !== executeLazyQueryWithCacheBridgeVariables) {
        t17 = [
            executeLazyQueryWithCacheBridgeVariables,
            apolloResult
        ];
        $[50] = apolloResult;
        $[51] = executeLazyQueryWithCacheBridgeVariables;
        $[52] = t17;
    } else t17 = $[52];
    return t17;
} : function useLazyQueryInteropApollo(query, options) {
    const { interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {};
    // Interop-only policies must be translated before they reach Apollo — see mapFetchPolicyForApollo.
    const apolloFetchPolicy = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.fetchPolicy);
    const apolloNextFetchPolicy = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.nextFetchPolicy);
    const { getLatestVariables: getLatestVariables, getVariables: getCacheBridgeVariables, isEnabled: isCacheBridgeEnabled, onCompleted: onApolloCompletedWithCacheBridge, syncObservedResult: syncObservedResult, updateLatestVariables: updateLatestVariables } = (0, $3VgTg.useApolloQueryCacheBridgeSync)({
        query: query,
        variables: apolloOptions.variables,
        fetchPolicy: apolloFetchPolicy,
        useAggClient: interopApolloAggClient,
        onCompleted: apolloOptions.onCompleted,
        callerPackage: options?.__callerPackage__
    });
    const onApolloCompleted = isCacheBridgeEnabled ? onApolloCompletedWithCacheBridge : apolloOptions.onCompleted;
    const lazyQueryResult = (0, $9qJAQ.useLazyQuery)((0, $86okN.toDocumentNode)(query), {
        ...apolloOptions,
        fetchPolicy: apolloFetchPolicy,
        ...apolloNextFetchPolicy ? {
            nextFetchPolicy: apolloNextFetchPolicy
        } : {},
        ...onApolloCompleted ? {
            onCompleted: onApolloCompleted
        } : {},
        ...interopApolloAggClient ? {
            client: window['GLOBAL_APOLLO_AGG_CLIENT'] ?? window['MOCK_GATEWAY_APOLLO_CLIENT']
        } : {},
        context: {
            ...apolloOptions?.context,
            requestId: query.params?.id
        }
    });
    const [executeLazyQuery, apolloResult] = lazyQueryResult;
    const apolloData = apolloResult.data;
    const apolloError = apolloResult.error;
    const apolloCalled = apolloResult.called;
    const apolloVariables = getCacheBridgeVariables(apolloResult.variables);
    (0, $cozmU.useEffect)(()=>{
        if (!isCacheBridgeEnabled) return;
        updateLatestVariables(apolloVariables);
    }, [
        apolloVariables,
        isCacheBridgeEnabled,
        updateLatestVariables
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isCacheBridgeEnabled) return;
        syncObservedResult({
            skip: !apolloCalled,
            variables: apolloVariables,
            data: apolloData,
            error: apolloError
        });
    }, [
        apolloCalled,
        apolloData,
        apolloError,
        apolloVariables,
        isCacheBridgeEnabled,
        syncObservedResult
    ]);
    const executeLazyQueryWithCacheBridgeVariables = (0, $cozmU.useCallback)((executeOptions)=>{
        updateLatestVariables(executeOptions?.variables ?? getLatestVariables());
        return executeLazyQuery(executeOptions);
    }, [
        executeLazyQuery,
        getLatestVariables,
        updateLatestVariables
    ]);
    if (!isCacheBridgeEnabled) return lazyQueryResult;
    return [
        executeLazyQueryWithCacheBridgeVariables,
        apolloResult
    ];
};
function $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${$278c8d04dad7bc1d$var$getOperationName(query)}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const operationName = (0, $7M67g.getRelayOperationName)(query) ?? undefined;
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        operationName: operationName,
        phase: 'memo'
    });
    const hookContext = options?.context;
    // Match Apollo's cache-first default rather than inheriting fetchQuery's
    // network-only default when the caller omits fetchPolicy.
    // See the equivalent comment in useQueryInterop: 'no-store' suppresses store reads as well as
    // writes, and is derived from the initial policy only.
    const noStore = (0, $3NBsC.isNoStoreFetchPolicy)(options?.fetchPolicy);
    const initialFetchPolicy = (0, $3NBsC.mapFetchPolicyForQuery)(options?.fetchPolicy);
    const subsequentFetchPolicy = options?.nextFetchPolicy ? (0, $3NBsC.mapFetchPolicyForQuery)(options.nextFetchPolicy) : initialFetchPolicy;
    const cacheBridgeFetchPolicy = options?.fetchPolicy;
    const cacheBridgeSubsequentFetchPolicy = options?.nextFetchPolicy ?? cacheBridgeFetchPolicy;
    const interopApolloAggClient = options?.interopApolloAggClient;
    const pollInterval = options?.pollInterval ?? 0;
    const notifyOnNetworkStatusChange = options?.notifyOnNetworkStatusChange || false;
    const onError = (0, $26Yfd.useStableCallback)(options?.onError ?? function noop() {});
    const onCompleted = (0, $26Yfd.useStableCallback)(options?.onCompleted ?? function noop() {});
    // Defers onCompleted/onError to a post-commit effect so callers observe the state
    // that describes the result being reported, matching Apollo — whose lazy path routes
    // through the same `afterExecute` -> `handleErrorOrCompleted` effect once the query
    // has been run. `queueNotification` is referentially stable, so listing it in the
    // `execute`/`fetchMore` dependency arrays cannot re-issue a request.
    const { queueNotification: queueNotification, markLoading: markLoading } = (0, $bUmU8.useDeferredQueryNotifications)({
        onCompleted: onCompleted,
        onError: onError,
        hasCallbacks: Boolean(options?.onCompleted || options?.onError)
    });
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [called, setCalled] = (0, $cozmU.useState)(false);
    // Mirrors Apollo's `variables` from the most recent invocation.
    const [activeVariables, setActiveVariables] = (0, $cozmU.useState)(hookVariables);
    // True only while a poll tick is the in-flight request. Apollo reports a tick as
    // `networkStatus: poll` rather than `loading`, and the lazy result has no `networkStatus`
    // field, so this flag is what keeps a tick out of the UFO hold below.
    const [isPollTickInFlight, setIsPollTickInFlight] = (0, $cozmU.useState)(false);
    const isMountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // Subscribe to cache updates after query is called to keep data reactive.
    // This ensures that when mutations update the cache, components using this
    // lazy query will automatically re-render with the fresh data, matching
    // Apollo's behavior where useLazyQuery subscribes to cache changes.
    // See: https://hello.atlassian.net/browse/COPPER-XXXXX (Star menu bug)
    (0, $cozmU.useEffect)(()=>{
        if (!called) return;
        // 'no-store' writes nothing, so there is no record of its own to watch — and subscribing
        // would surface *other* operations' writes to the same ids, which is the pollution the
        // policy exists to prevent. These queries refetch explicitly instead.
        if (noStore) return;
        // Subscribe to the Relay store to watch for cache updates (e.g., from mutations).
        // This matches the pattern used in useQueryInterop for reactive cache updates.
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), activeVariables);
        const retainDisposable = environment.retain(operation);
        const storeSubscription = environment.subscribe(environment.lookup(operation.fragment), (snapshot)=>{
            // Only update if mounted and data is not missing from cache
            if (isMountedRef.current && !snapshot.isMissingData) setData(snapshot.data);
        });
        return ()=>{
            storeSubscription.dispose();
            retainDisposable.dispose();
        };
    }, [
        called,
        environment,
        query,
        activeVariables,
        noStore
    ]);
    // Sequencing counters discard out-of-order responses.
    const executeIdRef = (0, $cozmU.useRef)(0);
    const fetchMoreIdRef = (0, $cozmU.useRef)(0);
    // A poll tick must not race an `execute` for the same query — see `pollTick`.
    const executeInFlightRef = (0, $cozmU.useRef)(false);
    // hookContext is unmemoised; data/activeVariables can change mid-fetchMore via a concurrent execute.
    const hookContextRef = $278c8d04dad7bc1d$var$useSyncedRef(hookContext);
    const dataRef = $278c8d04dad7bc1d$var$useSyncedRef(data);
    const activeVarsRef = $278c8d04dad7bc1d$var$useSyncedRef(activeVariables);
    const mirrorRelayResultToApollo = (0, $cozmU.useCallback)((relayResult, resultVariables, fetchPolicy)=>{
        // Lazy Relay execution remains the original source of truth; mirror
        // successful payloads into Apollo with the variables from that run.
        (0, $bFdYQ.syncQueryCacheBridge)({
            source: 'relay',
            query: query,
            variables: resultVariables,
            data: relayResult,
            fetchPolicy: fetchPolicy,
            useAggClient: interopApolloAggClient
        });
    }, [
        interopApolloAggClient,
        query
    ]);
    const ufoContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const ufoOperationName = `relay_${query.params?.name ?? 'unnamed'}`;
    (0, $cozmU.useEffect)(()=>{
        // A poll tick is excluded: it can repeat indefinitely, so holding the interaction for one
        // would never release. Mirrors useQueryInterop, which excludes `networkStatus: poll`.
        if (called && loading && !isPollTickInFlight) return ufoContext?.hold(ufoOperationName);
    }, [
        called,
        loading,
        isPollTickInFlight,
        ufoOperationName,
        ufoContext
    ]);
    const execute = (0, $cozmU.useCallback)((executeOptions)=>{
        const variables = executeOptions?.variables ?? hookVariables;
        const context = {
            ...hookContextRef.current,
            ...executeOptions?.context
        };
        // First execute uses fetchPolicy, re-invocations use nextFetchPolicy.
        const isFirstCall = executeIdRef.current === 0;
        const cacheBridgeResultFetchPolicy = isFirstCall ? cacheBridgeFetchPolicy : cacheBridgeSubsequentFetchPolicy;
        executeIdRef.current += 1;
        // Invalidate any in-flight fetchMore so it can't merge into fresh execute data.
        fetchMoreIdRef.current += 1;
        const id = executeIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === executeIdRef.current;
        setCalled(true);
        setActiveVariables(variables);
        setLoading(true);
        setError(undefined);
        // Every execute is a fresh loading transition, so a repeat execute with identical
        // variables still reports — matching Apollo, whose dedup guard is bypassed by the
        // loading flag going true.
        markLoading();
        executeInFlightRef.current = true;
        (0, $kczYx.fetchQuery)(environment, query, variables, {
            fetchPolicy: isFirstCall ? initialFetchPolicy : subsequentFetchPolicy,
            networkCacheConfig: {
                metadata: context
            }
        }, {
            noStore: noStore
        }).toPromise().then((result)=>{
            // Cleared even when unmounted, and only by the latest execute, so a superseded
            // response cannot open the door for a poll tick while a newer request is in flight.
            if (id === executeIdRef.current) executeInFlightRef.current = false;
            if (!isStillCurrent()) return;
            setLoading(false);
            if (result !== undefined) {
                mirrorRelayResultToApollo(result, variables, cacheBridgeResultFetchPolicy);
                setData(result);
                setError(undefined);
                queueNotification({
                    type: 'completed',
                    data: result,
                    identity: {
                        query: query,
                        variables: variables
                    }
                });
                return;
            }
            // Store-only cache miss: surface so callers aren't left indeterminate.
            const err = $278c8d04dad7bc1d$var$toApolloError(new Error('[Relay migration] fetchQuery resolved with no data (likely a store-only cache miss)'));
            setError(err);
            queueNotification({
                type: 'error',
                error: err,
                identity: {
                    query: query,
                    variables: variables
                }
            });
        }).catch((rawErr)=>{
            if (id === executeIdRef.current) executeInFlightRef.current = false;
            if (!isStillCurrent()) return;
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            setError(err);
            setLoading(false);
            queueNotification({
                type: 'error',
                error: err,
                identity: {
                    query: query,
                    variables: variables
                }
            });
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        hookVariables,
        initialFetchPolicy,
        subsequentFetchPolicy,
        cacheBridgeFetchPolicy,
        cacheBridgeSubsequentFetchPolicy,
        mirrorRelayResultToApollo,
        queueNotification,
        markLoading,
        noStore
    ]);
    const fetchMore = (0, $cozmU.useCallback)((fetchMoreOpts)=>{
        const baseVariables = activeVarsRef.current;
        const variables = {
            ...baseVariables,
            ...fetchMoreOpts.variables
        };
        fetchMoreIdRef.current += 1;
        const id = fetchMoreIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === fetchMoreIdRef.current;
        setLoading(true);
        return (0, $kczYx.fetchQuery)(environment, query, variables, {
            // fetchMore must always hit the network (matches Apollo); cached pages would be stale.
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: hookContextRef.current
            }
        }, {
            noStore: noStore
        }).toPromise().then((fetchMoreResult)=>{
            // Throw so .catch handles it (avoids double onError).
            if (fetchMoreResult === undefined) throw new Error('[Relay migration] fetchMore resolved with no data (likely a store-only cache miss)');
            const merged = fetchMoreOpts.updateQuery(dataRef.current ?? {}, {
                fetchMoreResult: fetchMoreResult,
                variables: variables
            });
            if (isStillCurrent()) {
                mirrorRelayResultToApollo(merged, baseVariables, cacheBridgeSubsequentFetchPolicy);
                setData(merged);
                setLoading(false);
                setError(undefined);
            }
            return {
                data: merged,
                loading: false,
                networkStatus: (0, $5T18X.NetworkStatus).ready,
                stale: false
            };
        }).catch((rawErr)=>{
            // Deliberately does NOT report via onError. Measured against real Apollo
            // (useLazyQuery + fetchMore, success and failure, either
            // notifyOnNetworkStatusChange): neither callback is invoked — the promise
            // rejection is the only signal. Reporting here would over-fire relative to
            // Apollo and disagree with useQueryInterop.fetchMore, which reports nothing.
            // Error state is still surfaced so the hook's `error` field stays accurate.
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            if (isStillCurrent()) {
                setError(err);
                setLoading(false);
            }
            throw err;
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (activeVarsRef, dataRef, hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        cacheBridgeSubsequentFetchPolicy,
        mirrorRelayResultToApollo,
        noStore
    ]);
    // ── Polling ──────────────────────────────────────────────────────────────────────────────
    // Apollo's lazy queries DO poll, contrary to what this hook previously assumed. `pollInterval`
    // reaches `client.watchQuery`, and `ObservableQuery.setUpQuery` starts the timer as soon as the
    // observable is subscribed — which for `useLazyQuery` is the first `execute`, since
    // `QueryData.execute` short-circuits until `runLazy` is true. Dropping the option left callers
    // with a single request and a promise that never resolves: the report/long-task call sites poll
    // a `ConfluenceLongTask` until it reports success, so one `InProgress` response stalled them
    // forever with no error to show for it.
    // A generation counter invalidates ticks that a `stopPolling()` or an effect teardown has
    // superseded, so an in-flight tick can never schedule its successor after being cancelled.
    const pollGenerationRef = (0, $cozmU.useRef)(0);
    const pollTimeoutRef = (0, $cozmU.useRef)(null);
    // The variables that were active when the caller last called `stopPolling()`. Apollo's
    // `stopPolling` is sticky: it clears `options.pollInterval` on the observable, and polling only
    // resumes once the *prepared* options change — i.e. a later `execute` with different variables
    // (`QueryData.updateObservableQuery` -> `ObservableQuery.setOptions` -> `startPolling`). A bare
    // re-execute with identical variables leaves polling stopped, so the guard is deep-compared
    // against the active variables rather than just cleared on the next execute.
    const pollStoppedVariablesRef = (0, $cozmU.useRef)(null);
    // Declared ahead of `pollTick` so a tick can schedule its successor without referencing its own
    // binding; re-pointed at the freshly-closed-over `pollTick` on every render below.
    const pollTickRef = (0, $cozmU.useRef)(()=>{});
    const cancelScheduledPoll = (0, $cozmU.useCallback)(()=>{
        pollGenerationRef.current += 1;
        if (pollTimeoutRef.current !== null) {
            clearTimeout(pollTimeoutRef.current);
            pollTimeoutRef.current = null;
        }
    }, []);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        pollStoppedVariablesRef.current = activeVarsRef.current;
        cancelScheduledPoll();
    }, [
        cancelScheduledPoll,
        activeVarsRef
    ]);
    // Redefined each render rather than memoised, and reached only through the synced ref below, so
    // a tick always closes over the current environment/variables/callbacks with no stale-closure
    // window and no dependency array that could re-arm the timer.
    const pollTick = (interval, generation)=>{
        const isCurrentGeneration = ()=>isMountedRef.current && generation === pollGenerationRef.current;
        const scheduleNextTick = ()=>{
            if (!isCurrentGeneration()) return;
            // setTimeout chained off the previous tick's settlement, not setInterval: Apollo
            // reschedules in `poll()` only after the fetch resolves or rejects
            // (`QueryManager.startPollingQuery`), so a response slower than the interval can never
            // stack requests.
            pollTimeoutRef.current = setTimeout(()=>pollTickRef.current(interval, generation), interval);
        };
        // Apollo skips a tick outright while a request for the query is already in flight and just
        // reschedules (`maybeFetch` -> `checkInFlight`).
        if (executeInFlightRef.current) {
            scheduleNextTick();
            return;
        }
        const variables = activeVarsRef.current;
        if (notifyOnNetworkStatusChange) {
            setIsPollTickInFlight(true);
            setLoading(true);
        }
        (0, $kczYx.fetchQuery)(environment, query, variables, {
            // Apollo forces `network-only` on every tick regardless of the query's own policy
            // (`startPollingQuery` overrides `info.options.fetchPolicy`) — a poll that could be
            // served from the cache would never observe the change it is polling for.
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: hookContextRef.current
            }
        }, {
            noStore: noStore
        }).toPromise().then((result)=>{
            if (!isMountedRef.current) return;
            if (notifyOnNetworkStatusChange) {
                setIsPollTickInFlight(false);
                setLoading(false);
            }
            if (!isCurrentGeneration()) return;
            // Guard against empty completions so a store-only miss can't wipe `data`.
            if (result !== undefined) {
                mirrorRelayResultToApollo(result, variables, cacheBridgeSubsequentFetchPolicy);
                setData(result);
                setError(undefined);
                // `markLoading()` is deliberately NOT called for a tick: the dedup guard in
                // useDeferredQueryNotifications then suppresses this notification for an
                // unchanged operation, which is what makes a tick apply its data without
                // reporting to onCompleted/onError. Same arrangement as useQueryInterop's
                // runPollTick, and the contract callers are documented against.
                queueNotification({
                    type: 'completed',
                    data: result,
                    identity: {
                        query: query,
                        variables: variables
                    }
                });
            }
            scheduleNextTick();
        }).catch((rawErr)=>{
            if (!isMountedRef.current) return;
            if (notifyOnNetworkStatusChange) {
                setIsPollTickInFlight(false);
                setLoading(false);
            }
            if (!isCurrentGeneration()) return;
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            setError(err);
            queueNotification({
                type: 'error',
                error: err,
                identity: {
                    query: query,
                    variables: variables
                }
            });
            // Apollo keeps polling after a failed tick (`fetchQuery(...).then(poll, poll)`).
            scheduleNextTick();
        });
    };
    pollTickRef.current = pollTick;
    (0, $cozmU.useEffect)(()=>{
        // Gated on `called`, not mount: Apollo cannot poll before the observable is subscribed, and
        // for a lazy query that is the first `execute`.
        if (!called || pollInterval <= 0) return;
        // Apollo's QueryManager does not poll in `ssrMode`.
        if (typeof window === 'undefined') return;
        if (pollStoppedVariablesRef.current !== null && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(pollStoppedVariablesRef.current, activeVariables)) return;
        pollStoppedVariablesRef.current = null;
        pollGenerationRef.current += 1;
        const generation = pollGenerationRef.current;
        // First tick lands one interval after the execute, matching Apollo's initial `poll()`.
        pollTimeoutRef.current = setTimeout(()=>pollTickRef.current(pollInterval, generation), pollInterval);
        return cancelScheduledPoll;
    // `activeVariables` is a dependency so a re-execute re-arms the timer from now, as Apollo's
    // `setOptions` -> `startPolling` does when the prepared options change.
    }, [
        called,
        pollInterval,
        activeVariables,
        cancelScheduledPoll
    ]);
    // Cast: Apollo's overloaded fetchMore is structurally a superset of FetchMoreType.
    return [
        execute,
        {
            data: data,
            loading: loading,
            error: error,
            called: called,
            variables: activeVariables,
            fetchMore: fetchMore,
            stopPolling: stopPolling
        }
    ];
}
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("kZEms", function(module, exports) {
/* ViewPageLabelsLoader.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $jmjWc = parcelRequire("jmjWc");


var $7boqA = parcelRequire("7boqA");


var $PPtZc = parcelRequire("PPtZc");

const $ba30ab1568e9f84e$export$78128841bacb1fe0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VUF4f",
            __cmplp.className
        ])
    });
});

const $ba30ab1568e9f84e$var$ViewPageLabelsLoaderBase = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vfOAM",
    name: "ViewPageLabelsLoaderBase",
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ba30ab1568e9f84e$export$78128841bacb1fe0, null),
    loader: async ()=>(await (parcelRequire("W0S0s"))).ViewPageLabels
});
const $ba30ab1568e9f84e$export$34eb2891dd16ab98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $PPtZc.VIEW_PAGE_LABELS_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ba30ab1568e9f84e$var$ViewPageLabelsLoaderBase, props));
module.exports["LabelsSelectPlaceholder"] = $ba30ab1568e9f84e$export$78128841bacb1fe0;
module.exports["ViewPageLabelsLoader"] = $ba30ab1568e9f84e$export$34eb2891dd16ab98;

});

parcelRegister("PPtZc", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $7c335dc4c85f3f9f$export$3a36b2d62e2d34a2 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.VIEW_PAGE_LABELS_METRIC_KEY)
});
module.exports["VIEW_PAGE_LABELS_METRIC"] = $7c335dc4c85f3f9f$export$3a36b2d62e2d34a2;

});

parcelRegister("W0S0s", function(module, exports) {

let $0ae617ac34432c8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0ae617ac34432c8c$var$load("aLbuU"),
    $0ae617ac34432c8c$var$load("dgerE"),
    $0ae617ac34432c8c$var$load("4fYzp"),
    $0ae617ac34432c8c$var$load("953Uz"),
    $0ae617ac34432c8c$var$load("jigcs"),
    $0ae617ac34432c8c$var$load("4LmEY")
]).then(()=>parcelRequire('heHIK'));

});

parcelRegister("i28ZW", function(module, exports) {

var $i0mmi = parcelRequire("i0mmi");


var $6mKj3 = parcelRequire("6mKj3");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");


var $jMyy4 = parcelRequire("jMyy4");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $i0mmi.default);
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$a7c1ec142e70d69d = 'archive';
const $981a614bc39b93a3$export$92f9e1ed9114d3a6 = 'copy';
const $981a614bc39b93a3$export$3ea24d3a964169d2 = 'view_analytics';
const $981a614bc39b93a3$export$df267ad9042b4cda = 'export';
const $981a614bc39b93a3$export$4111393d4921f4a7 = 'create';
const $981a614bc39b93a3$export$5c2e91d1aa10ff80 = 'attachment';
const $981a614bc39b93a3$export$b838cef2a8827875 = (operations, spaceOperation)=>{
    return operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
};
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled && !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        },
        __callerPackage__: "space-utils"
    });
    const operations = data?.space?.operations;
    return {
        canManageSomeUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a89133b28496ff30),
        canAdminister: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$50faaafd42078ad9),
        canArchive: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a7c1ec142e70d69d),
        canCopy: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$92f9e1ed9114d3a6),
        canViewAnalytics: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3ea24d3a964169d2),
        canExportSpace: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$df267ad9042b4cda),
        canAddAttachment: operations?.some((operation)=>operation?.operation === $981a614bc39b93a3$export$4111393d4921f4a7 && operation?.targetType === $981a614bc39b93a3$export$5c2e91d1aa10ff80) ?? false,
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["MANAGE_PUBLIC_LINKS"] = $981a614bc39b93a3$export$fae9e1a00840692e;
module.exports["ADMINISTER"] = $981a614bc39b93a3$export$80ed1bd55ccf4772;
module.exports["MANAGE_CONTENT"] = $981a614bc39b93a3$export$50faaafd42078ad9;
module.exports["hasSpaceOperation"] = $981a614bc39b93a3$export$b838cef2a8827875;
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("i0mmi", function(module, exports) {
/**
 * @generated SignedSource<<10e9286ab7437b1579bfb197b3cdf663>>
 * @relayHash 0a3dc9cecca8233daf01e0443fdaa5e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471
const $7dc84e66153faa36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0a3dc9cecca8233daf01e0443fdaa5e6",
            "id": "1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471",
            "metadata": {},
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "operationKind": "query",
            "text": "query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin},operations{operation,targetType}}}"
        }
    };
}();
$7dc84e66153faa36$var$node.hash = "4d967e32f567d3367490b1d8fb6f1ecf";
var $7dc84e66153faa36$export$2e2bcd8739ae039 = $7dc84e66153faa36$var$node;
module.exports["default"] = $7dc84e66153faa36$export$2e2bcd8739ae039;

});

parcelRegister("iquRY", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !isLoggedIn;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1,
            onError: $cccaa992351fdb79$var$_temp
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t3 = data?.confluence_spaceRoleMode;
    let t4;
    if ($[5] !== isNotPreRoles || $[6] !== loading || $[7] !== t3) {
        t4 = {
            spaceRoleMode: t3,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[5] = isNotPreRoles;
        $[6] = loading;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<2ff02ee1cce578f61d9a435abf2def2c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $cozmU = parcelRequire("cozmU");


var $isuYJ = parcelRequire("isuYJ");


var $hzmpb = parcelRequire("hzmpb");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $7Ndnw = parcelRequire("7Ndnw");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== moduleType) {
        t3 = ()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType];
        $[0] = moduleType;
        $[1] = t3;
    } else t3 = $[1];
    const [ssrExtensionResult] = (0, $cozmU.useState)(t3);
    let t4;
    if ($[2] !== cloudId || $[3] !== contentId || $[4] !== locale || $[5] !== moduleType || $[6] !== queryOptions || $[7] !== resolvedAttachmentId || $[8] !== returnBlockedExtensions || $[9] !== skipQuery || $[10] !== spaceContextOnly || $[11] !== spaceKey) {
        t4 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[2] = cloudId;
        $[3] = contentId;
        $[4] = locale;
        $[5] = moduleType;
        $[6] = queryOptions;
        $[7] = resolvedAttachmentId;
        $[8] = returnBlockedExtensions;
        $[9] = skipQuery;
        $[10] = spaceContextOnly;
        $[11] = spaceKey;
        $[12] = t4;
    } else t4 = $[12];
    const options = t4;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t5;
    let t6;
    if ($[13] !== extsError || $[14] !== spaceError) {
        t5 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t6 = [
            extsError,
            spaceError
        ];
        $[13] = extsError;
        $[14] = spaceError;
        $[15] = t5;
        $[16] = t6;
    } else {
        t5 = $[15];
        t6 = $[16];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) && !skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (0, $9wGTI.fg)("confluence_space_apps_ssr_preload")) {
        let t7;
        if ($[17] !== ssrExtensionResult.error || $[18] !== ssrExtensionResult.extensions) {
            t7 = {
                extensions: ssrExtensionResult.extensions,
                loading: false,
                error: ssrExtensionResult.error
            };
            $[17] = ssrExtensionResult.error;
            $[18] = ssrExtensionResult.extensions;
            $[19] = t7;
        } else t7 = $[19];
        return t7;
    }
    let t7;
    if ($[20] !== extsData || $[21] !== extsError || $[22] !== extsLoading) {
        t7 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[20] = extsData;
        $[21] = extsError;
        $[22] = extsLoading;
        $[23] = t7;
    } else t7 = $[23];
    return t7;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const [ssrExtensionResult] = (0, $cozmU.useState)(()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType]);
    const options = (0, $cozmU.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $cozmU.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    if (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) && !skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (0, $9wGTI.fg)('confluence_space_apps_ssr_preload')) return {
        extensions: ssrExtensionResult.extensions,
        loading: false,
        error: ssrExtensionResult.error
    };
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $hzmpb.usePrefilteredExtensionListRelay), (0, $hzmpb.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("wtSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $251dbde4d6244b59$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pM5to",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("dJXEu"))).NotFound
});
module.exports["NotFound"] = $251dbde4d6244b59$export$271f9f08425019c7;

});

parcelRegister("dJXEu", function(module, exports) {

let $a00dbff984076c51$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a00dbff984076c51$var$load("fEWss"),
    $a00dbff984076c51$var$load("ceGPg"),
    $a00dbff984076c51$var$load("7EorR"),
    $a00dbff984076c51$var$load("85Ack"),
    $a00dbff984076c51$var$load("k0Z8C"),
    $a00dbff984076c51$var$load("hhss7"),
    $a00dbff984076c51$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("lLRfG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gXfti = parcelRequire("gXfti");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $4291167636037428$var$PageLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $gXfti.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $4291167636037428$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4291167636037428$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $4291167636037428$export$570dec5b65c6715b;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = window.__SSR_REACT_STREAMING__ ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("jEeDd", function(module, exports) {

var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    return identity;
}
module.exports["getLoginLink"] = $2dd269c5e0cf48e9$export$264b5fa7ee2d3260;

});

parcelRegister("hpRYU", function(module, exports) {

var $1dUJk = parcelRequire("1dUJk");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kfLla = parcelRequire("kfLla");


var $l9ukq = parcelRequire("l9ukq");


var $24tIi = parcelRequire("24tIi");


var $bQm3c = parcelRequire("bQm3c");


var $iMnC5 = parcelRequire("iMnC5");


var $9wGTI = parcelRequire("9wGTI");


var $b3j2Y = parcelRequire("b3j2Y");


var $7lu50 = parcelRequire("7lu50");


var $7Sm4c = parcelRequire("7Sm4c");


var $83Z6R = parcelRequire("83Z6R");


var $jjoF2 = parcelRequire("jjoF2");


var $VQdE0 = parcelRequire("VQdE0");


var $g3p2i = parcelRequire("g3p2i");


var $jMyy4 = parcelRequire("jMyy4");

const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
const $4cbf051190fe8573$var$withoutAriaLabelledBy = (props)=>{
    const { 'aria-labelledby': _ariaLabelledBy, ...inputProps } = props;
    return inputProps;
};
const $4cbf051190fe8573$var$LabelledInput = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Input, $4cbf051190fe8573$var$withoutAriaLabelledBy(props));
const $4cbf051190fe8573$var$wrapWithLabelledInput = (InputComponent)=>{
    const WrappedLabelledInput = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InputComponent, $4cbf051190fe8573$var$withoutAriaLabelledBy(props));
    return WrappedLabelledInput;
};
const $4cbf051190fe8573$var$getLabelledComponents = (components)=>{
    return {
        ...components,
        Input: components?.Input ? $4cbf051190fe8573$var$wrapWithLabelledInput(components.Input) : $4cbf051190fe8573$var$LabelledInput
    };
};
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
const $4cbf051190fe8573$var$DefaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, children);
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, displayEmailInByline: displayEmailInByline, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, verifiedTeams: verifiedTeams, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, 'aria-labelledby': ariaLabelledByFromField, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId, isClearable: isClearable = true, includeUsers: includeUsers = true, transformOptions: transformOptions, userResolvers: userResolvers, components: components, isHeaderFocused: isHeaderFocused, setIsHeaderFocused: setIsHeaderFocused })=>{
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const queryUserAndGroupSearch = (0, $83Z6R.useLazyQueryPromiseInterop)((0, $VQdE0.default), {
        __callerPackage__: "user-and-group-search"
    });
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $jMyy4.useQueryInterop)((0, $1dUJk.default), {
        __callerPackage__: "user-and-group-search"
    });
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError);
            // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            queryData: queryUserAndGroupSearch({
                variables: {
                    withGroups: includeGroup,
                    searchTerm: searchTerm,
                    sitePermissionTypeFilter: sitePermissionTypeFilter,
                    withUsers: withUsers
                }
            }),
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.search.error",
        defaultMessage: "Sorry, we\u2019re having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.permission.error",
        defaultMessage: "We couldn\u2019t find any results because you don't have permission to search the user directory."
    });
    // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.groups",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name"
    }));
    const pickerAriaLabelledBy = ariaLabel ? undefined : ariaLabelledBy || ariaLabelledByFromField || `react-select-${fieldId}-placeholder`;
    const pickerComponents = (0, $cozmU.useMemo)(()=>ariaLabel ? $4cbf051190fe8573$var$getLabelledComponents(components) : components, [
        ariaLabel,
        components
    ]);
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        displayEmailInByline: displayEmailInByline,
        allowEmail: allowEmail,
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: enableEmailSearch,
        allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        components: pickerComponents,
        withUsers: // Type assertion: runtime receives Option, but UserPicker types expect OptionData
        withUsers,
        header: header,
        open: open,
        ariaLabel: ariaLabel,
        ariaLabelledBy: pickerAriaLabelledBy,
        'aria-describedby': userpickerDescribedbyId,
        isHeaderFocused: isHeaderFocused,
        setIsHeaderFocused: setIsHeaderFocused
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kfLla.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        // bug with UserPicker forces us to use a callback rather than just pass in a string
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance,
        isClearable: isClearable
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24tIi.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        includeUsers: includeUsers,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context",
        productKey: "confluence",
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        includeTeamsUpdates: includeTeamsUpdates,
        verifiedTeams: verifiedTeams,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        isClearable: isClearable,
        transformOptions: transformOptions,
        userResolvers: userResolvers,
        displayEmailInByline: true,
        enableEmailSearch: true,
        allowEmailSelectionWhenEmailMatched: false,
        isTeamSyncedToGroupDirectoryFilter: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = $4cbf051190fe8573$export$fd4159eb872f73c6;
module.exports["UserAndGroupSearchPicker"] = $4cbf051190fe8573$export$ca514d5352bb0171;

});

parcelRegister("1dUJk", function(module, exports) {
/**
 * @generated SignedSource<<b63c5c1bb2388ba01c0f335df08966f1>>
 * @relayHash 55f887ce338962f3d231967eb05baaf5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a
const $a7eff2b640cdd5ac$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "55f887ce338962f3d231967eb05baaf5",
            "id": "f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a",
            "metadata": {},
            "name": "UserAndGroupSearchPickerQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$a7eff2b640cdd5ac$var$node.hash = "6fe67cddff8056d8e38840c5214712ee";
var $a7eff2b640cdd5ac$export$2e2bcd8739ae039 = $a7eff2b640cdd5ac$var$node;
module.exports["default"] = $a7eff2b640cdd5ac$export$2e2bcd8739ae039;

});

parcelRegister("jjoF2", function(module, exports) {

var $9fywD = parcelRequire("9fywD");


var $11dKl = parcelRequire("11dKl");


var $9eE57 = parcelRequire("9eE57");


var $g3p2i = parcelRequire("g3p2i");

const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, queryData: queryData, customInclusion: customInclusion, setError: setError, filterResults: filterResults })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return queryData.then((data)=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch ?? {};
        const userList = users.map((item)=>({
                id: `user-${item && 'accountId' in item ? item.accountId : ''}`,
                name: item?.displayName || '',
                extra: item,
                type: 'user',
                avatarUrl: item?.profilePicture ? item.profilePicture.path : '',
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item?.id}`,
                name: item?.name || '',
                type: 'group',
                extra: item,
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().includes(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};
module.exports["userGroupSearchPromise"] = $9d3a4572140e810a$export$c139484855007019;

});

parcelRegister("11dKl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $f9006b515271a00f$var$i18n = (0, $kSwu1.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalGroupLozengeProps"] = $f9006b515271a00f$export$fef38ba78dbe85a6;

});

parcelRegister("g3p2i", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});
module.exports["SitePermissionType"] = $fc6a2e7c662c45f6$export$8995abb8169b2cb8;
module.exports["SitePermissionTypeFilter"] = $fc6a2e7c662c45f6$export$3347a7c058a0368a;

});

parcelRegister("VQdE0", function(module, exports) {
/**
 * @generated SignedSource<<d8c13f003578e6757b54483ce7e2bebb>>
 * @relayHash 8824351f0529abac5573900b2bee2db5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751
const $3fbecf5b2b9bf0ac$var$node = function() {
    var v0 = {
        "defaultValue": 50,
        "kind": "LocalArgument",
        "name": "maxResults"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchTerm"
    }, v2 = {
        "defaultValue": "NONE",
        "kind": "LocalArgument",
        "name": "sitePermissionTypeFilter"
    }, v3 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withGroups"
    }, v4 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withUsers"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "maxResults",
            "variableName": "maxResults"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "searchTerm"
        },
        {
            "kind": "Variable",
            "name": "sitePermissionTypeFilter",
            "variableName": "sitePermissionTypeFilter"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "condition": "withGroups",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    v8 /*: any*/ 
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "8824351f0529abac5573900b2bee2db5",
            "id": "2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751",
            "metadata": {},
            "name": "UserAndGroupSearchQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchQuery($searchTerm:String!,$maxResults:Int=50,$withGroups:Boolean=true,$withUsers:Boolean=true,$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm,maxResults:$maxResults,sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){__typename,type,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},groups@include(if:$withGroups){id,name,permissionType}}}"
        }
    };
}();
$3fbecf5b2b9bf0ac$var$node.hash = "52200fecbeb2441b36c8ceb106bad130";
var $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039 = $3fbecf5b2b9bf0ac$var$node;
module.exports["default"] = $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039;

});

parcelRegister("hkzol", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $kTb7m = parcelRequire("kTb7m");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $56QzY = parcelRequire("56QzY");


var $6abPE = parcelRequire("6abPE");


var $jooGc = parcelRequire("jooGc");


var $kfIha = parcelRequire("kfIha");

const $5e3895b62fe84f52$var$i18n = (0, $kSwu1.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "copy-content-link.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "copy-content-link.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY = 100;
const $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT = 2500;
const $5e3895b62fe84f52$var$iconButtonAppearances = new Set([
    'default',
    'primary',
    'discovery',
    'subtle'
]);
const $5e3895b62fe84f52$var$formatIconButtonAppearance = (appearance)=>$5e3895b62fe84f52$var$iconButtonAppearances.has(appearance) ? appearance : 'default';
const $5e3895b62fe84f52$export$9957974f8b4d8f74 = 'copyShareLink';
const $5e3895b62fe84f52$export$534d10f1c5b9c7b3 = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, isDraft: isDraft = false, isLivePage: isLivePage = false, isDisabled: isDisabled = false, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', buttonText: buttonText = '', copiedTextTooltipLabel: copiedTextTooltipLabel = $5e3895b62fe84f52$var$i18n.copiedTextLabel, onClickAttributes: onClickAttributes, iconColor: iconColor, urlOverride: urlOverride = '' })=>{
    const intl = (0, $kSwu1.useIntl)();
    const cleanupCopiedTimer = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isCopied, setIsCopied] = (0, $cozmU.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $cozmU.useState)();
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    // Hook to store copy content link click state
    const { setHasClickedCopyContentLink: setHasClickedCopyContentLink, resetHasClickedCopyContentLink: resetHasClickedCopyContentLink } = (0, $jooGc.useCopyContentLinkActions)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    (0, $cozmU.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $cozmU.useEffect)(()=>{
        resetHasClickedCopyContentLink();
    }, [
        resetHasClickedCopyContentLink
    ]);
    const { unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $6abPE.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source,
        skip: Boolean(urlOverride)
    });
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e3895b62fe84f52$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    ...onClickAttributes ?? {}
                }
            }
        }).fire();
        //mark has copy content link click to true
        setHasClickedCopyContentLink();
        try {
            if (!urlOverride) await copyContentLink();
            else await copyToClipboard(urlOverride);
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e3895b62fe84f52$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e3895b62fe84f52$var$i18n.errorCopyingTextLabel : copiedTextTooltipLabel);
    const onMouseLeave = ()=>{
        if (shouldResetOnHover) setIsCopied(false);
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    const iconButtonAppearance = $5e3895b62fe84f52$var$formatIconButtonAppearance(buttonAppearance);
    const getCopyButton = ()=>buttonText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: "copy-link-button",
            "aria-label": copyLinkText,
            appearance: buttonAppearance,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled
        }, buttonText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "copy-link-button",
            label: copyLinkText,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                    ...iconProps,
                    color: iconColor
                }),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            appearance: iconButtonAppearance
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isCopied && confirmationText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            if (isCopied) return confirmationText;
            if (buttonText) return buttonText;
            else return copyLinkText;
        },
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true,
        delay: $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY
    }, getCopyButton()));
};
module.exports["ACTION_SUBJECT_ID"] = $5e3895b62fe84f52$export$9957974f8b4d8f74;
module.exports["CopyLinkButton"] = $5e3895b62fe84f52$export$534d10f1c5b9c7b3;

});

parcelRegister("6abPE", function(module, exports) {

var $2i78V = parcelRequire("2i78V");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $hkzol = parcelRequire("hkzol");


var $kfIha = parcelRequire("kfIha");

const $68bb0af1984f782c$var$useCopyContentLinkQuery = (0, $2i78V.default);
const $68bb0af1984f782c$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, skip: skip = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $cozmU.useState)();
    const { toUrl: toUrl } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($68bb0af1984f782c$var$useCopyContentLinkQuery, {
        variables: {
            contentId: contentId || ''
        },
        skip: !contentId || skip,
        __callerPackage__: "copy-content-link"
    });
    const makeContentLink = (0, $cozmU.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === 'edit') copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) {
                const copyLinkUrl = `${links.base}${copyLink}`;
                return copyLinkUrl;
            }
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === 'edit') {
            routeName = contentType === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === 'blogpost' ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case 'overview':
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case 'blogpost':
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case 'page':
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case 'whiteboard':
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case 'slide':
                routeName = (0, $1NBp8.SLIDES_VIEW).name;
                break;
            case 'folder':
                routeName = (0, $1NBp8.FOLDER_VIEW).name;
                break;
            // omit databases and other unsupported content types
            default:
                if (!contentType) // contentType is undefined/empty - this is a data issue, not a
                // truly unsupported type. Return undefined rather than erroring.
                return undefined;
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'generated',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            const copyLinkUrl = `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
            return copyLinkUrl;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $cozmU.useCallback)(()=>{
        return copyToClipboard(makeContentLink());
    }, [
        makeContentLink,
        copyToClipboard
    ]);
    return {
        queryError: queryError,
        unsupportedLinkError: unsupportedLinkError,
        makeContentLink: makeContentLink,
        copyContentLink: copyContentLink
    };
};
module.exports["useCopyContentLink"] = $68bb0af1984f782c$export$a049904f049cf16d;

});

parcelRegister("2i78V", function(module, exports) {
/**
 * @generated SignedSource<<0b2f5f44bd64ba7831c6ee7b039fb54f>>
 * @relayHash 29cac5aad51907935410d62eca7f1996
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34
const $77e7fa3fd8a73973$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tinyui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "29cac5aad51907935410d62eca7f1996",
            "id": "9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34",
            "metadata": {},
            "name": "useCopyContentLinkQuery",
            "operationKind": "query",
            "text": "query useCopyContentLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
        }
    };
}();
$77e7fa3fd8a73973$var$node.hash = "37d735340f7b52ac7552b4a67a3fb5da";
var $77e7fa3fd8a73973$export$2e2bcd8739ae039 = $77e7fa3fd8a73973$var$node;
module.exports["default"] = $77e7fa3fd8a73973$export$2e2bcd8739ae039;

});

parcelRegister("jooGc", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4ca5e403580d1e7d$var$initialState = {
    hasClickedCopyContentLink: false
};
const $4ca5e403580d1e7d$var$actions = {
    setHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: true
            });
        },
    resetHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: false
            });
        }
};
const $4ca5e403580d1e7d$var$CopyContentLinkStore = (0, $8s9DV.createStore)({
    initialState: $4ca5e403580d1e7d$var$initialState,
    actions: $4ca5e403580d1e7d$var$actions,
    name: 'CopyContentLinkStore'
});
const $4ca5e403580d1e7d$export$77cd2a2387f7879a = (0, $kBr4q.createStateHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
const $4ca5e403580d1e7d$export$c42bcb6cac241c15 = (0, $kBr4q.createActionsHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
module.exports["useCopyContentLinkActions"] = $4ca5e403580d1e7d$export$c42bcb6cac241c15;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $cozmU.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _1mT5xdRAKS"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _3OE6xY715P _2IhTon715P _42Yu6BgtVO"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("7bpSh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9dee672aff5abe3d$export$c4ffab2abecc9a7c = (0, $cozmU.createContext)(null);
module.exports["ContentModeFragmentContext"] = $9dee672aff5abe3d$export$c4ffab2abecc9a7c;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$79a38b1b3ee7546f = 'contextPanelTabTarget';
const $4a3de077c1d50444$export$d3c15ca89bcfbca6 = 'templates';
const $4a3de077c1d50444$export$9d622978cb62b57d = 'block';
const $4a3de077c1d50444$export$3059f9ac1064e696 = 'import';
const $4a3de077c1d50444$export$ccd8928f1e8269de = 'templates';
const $4a3de077c1d50444$export$2f49124c0813d6f9 = 'import';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$c1ea49786444cf5a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$79a38b1b3ee7546f];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$242446a58b76be13 = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    const tabTarget = $4a3de077c1d50444$export$c1ea49786444cf5a(getQueryParams);
    return (queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a) && (tabTarget === $4a3de077c1d50444$export$d3c15ca89bcfbca6 || tabTarget === $4a3de077c1d50444$export$9d622978cb62b57d);
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams, isRovoLLMEnabled = false)=>{
    const paramsToRemove = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    };
    // Clear contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) paramsToRemove[$4a3de077c1d50444$export$79a38b1b3ee7546f] = null;
    setQueryParams(paramsToRemove, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, inEditorTemplatesPanel, tabTarget, isRovoLLMEnabled = false)=>{
    const params = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: inEditorTemplatesPanel
    };
    // Set contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (tabTarget && (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false))) params[$4a3de077c1d50444$export$79a38b1b3ee7546f] = tabTarget;
    setQueryParams(params, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["CONTEXT_PANEL_TAB_TARGET"] = $4a3de077c1d50444$export$79a38b1b3ee7546f;
module.exports["CONTEXT_PANEL_TAB_TARGET_TEMPLATES"] = $4a3de077c1d50444$export$d3c15ca89bcfbca6;
module.exports["CONTEXT_PANEL_TAB_TARGET_BLOCK"] = $4a3de077c1d50444$export$9d622978cb62b57d;
module.exports["CONTEXT_PANEL_TAB_TARGET_IMPORT"] = $4a3de077c1d50444$export$3059f9ac1064e696;
module.exports["PANEL_MODE_TEMPLATES"] = $4a3de077c1d50444$export$ccd8928f1e8269de;
module.exports["PANEL_MODE_IMPORT"] = $4a3de077c1d50444$export$2f49124c0813d6f9;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpenWithTemplatesPanelMode"] = $4a3de077c1d50444$export$242446a58b76be13;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("3FlVr", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable check-file/filename-blocklist */ var $3196fb7749a17aaf$export$3b10d30805d4d939 = /*#__PURE__*/ function(ReactionLocation) {
    ReactionLocation["PAGE"] = "page";
    ReactionLocation["BLOGPOST"] = "blogpost";
    ReactionLocation["PAGE_COMMENT"] = "page-comment";
    ReactionLocation["INLINE_COMMENT"] = "inline-comment";
    ReactionLocation["EDITOR_INLINE_COMMENT"] = "editor-inline-comment";
    ReactionLocation["FEED_PAGE"] = "feed-page";
    ReactionLocation["FEED_BLOGPOST"] = "feed-blogpost";
    ReactionLocation["FEED_COMMENT"] = "feed-comment";
    ReactionLocation["OBJECT_COMMENT_FOOTER_PAGE"] = "object-comment-footer-page";
    ReactionLocation["OBJECT_COMMENT_FOOTER_BLOGPOST"] = "object-comment-footer-blogpost";
    return ReactionLocation;
}({});
var $3196fb7749a17aaf$export$d86afc9493bb8e1 = /*#__PURE__*/ function(ReactionContainerType) {
    ReactionContainerType["PAGE"] = "page";
    ReactionContainerType["BLOGPOST"] = "blogpost";
    ReactionContainerType["SPACE"] = "space";
    return ReactionContainerType;
}({});
module.exports["ReactionLocation"] = $3196fb7749a17aaf$export$3b10d30805d4d939;
module.exports["ReactionContainerType"] = $3196fb7749a17aaf$export$d86afc9493bb8e1;

});

parcelRegister("1NF8X", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $bFPHx = parcelRequire("bFPHx");


var $5Kc7f = parcelRequire("5Kc7f");


const $032b81a28ff18608$export$96ee387620e23ced = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "XLglR",
    name: "ReactionsLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), {
            useAccuratePills: true,
            ...props
        });
    },
    loader: async ()=>(await (parcelRequire("9GMfm"))).Reactions
});

const $032b81a28ff18608$export$ddfc48793728637f = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "4wRdk",
    name: "ReactionsLoaderBackground",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("9GMfm"))).Reactions
});
module.exports["ReactionsLoader"] = $032b81a28ff18608$export$96ee387620e23ced;
module.exports["ReactionsLoaderBackground"] = $032b81a28ff18608$export$ddfc48793728637f;

});

parcelRegister("bFPHx", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $b3Wpp = parcelRequire("b3Wpp");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $b35Wv = parcelRequire("b35Wv");


var $4ez2K = parcelRequire("4ez2K");


var $1sCHt = parcelRequire("1sCHt");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");

const $3ae84312c23de134$var$ReactionsPlaceholderQuery = (0, $b3Wpp.default);
const $3ae84312c23de134$var$placeholderContainerStyles = null;
const $3ae84312c23de134$var$reactionPillStyles = null;
const $3ae84312c23de134$var$reactionIconStyles = null;
const $3ae84312c23de134$var$DEFAULT_NUM_PILLS = 2;
const $3ae84312c23de134$export$47a91e92112986d6 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { useAccuratePills: useAccuratePills, onlyRenderPicker: onlyRenderPicker, customAnalyticsAttributes: customAnalyticsAttributes } = t0;
    const isSSR = window.__SSR_RENDERED__ || undefined;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = !isSSR || !useAccuratePills || !contentId || onlyRenderPicker;
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($3ae84312c23de134$var$ReactionsPlaceholderQuery, {
        ...t3,
        __callerPackage__: "reactions"
    });
    if (loading) return null;
    let t4;
    if ($[5] !== customAnalyticsAttributes || $[6] !== onlyRenderPicker) {
        t4 = (numPills)=>onlyRenderPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                justifyContent: "center",
                alignItems: "center",
                testId: "reactions-picker-placeholder"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))),
                label: "",
                analyticsContext: {
                    name: "reactionsPicker",
                    ...customAnalyticsAttributes
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "reactions-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0wOv4QsJSq _313842FQfX _1DCdHiFQfX _2XsHFMdnbC"
                ])
            }, Array(numPills).fill("").map($3ae84312c23de134$var$_temp), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-testid": "reaction-icon",
                className: (0, $hekY6.default)([
                    "_2uo31faVjy _0bjKvDS5Zs _39xV02xpxF _0jFU0VxpxF _2XsHFMgVvo"
                ])
            }));
        $[5] = customAnalyticsAttributes;
        $[6] = onlyRenderPicker;
        $[7] = t4;
    } else t4 = $[7];
    const renderPlaceholder = t4;
    if (isSSR) {
        const numDistinctReactions = data?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.length;
        const numReactionPills = numDistinctReactions !== undefined ? numDistinctReactions : $3ae84312c23de134$var$DEFAULT_NUM_PILLS;
        let t5;
        if ($[8] !== numReactionPills || $[9] !== renderPlaceholder) {
            t5 = renderPlaceholder(numReactionPills);
            $[8] = numReactionPills;
            $[9] = renderPlaceholder;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    } else {
        let t5;
        if ($[11] !== renderPlaceholder) {
            t5 = renderPlaceholder($3ae84312c23de134$var$DEFAULT_NUM_PILLS);
            $[11] = renderPlaceholder;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
};
function $3ae84312c23de134$var$_temp(_, i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        key: i,
        "data-testid": "reactions-pill",
        className: (0, $hekY6.default)([
            "_2uo31faVjy _0bjKvDS5Zs _39xV02hzUg _0jFU0VoWWg _0adFHs1Y8M"
        ])
    });
}
module.exports["ReactionsPlaceholder"] = $3ae84312c23de134$export$47a91e92112986d6;

});

parcelRegister("b3Wpp", function(module, exports) {
/**
 * @generated SignedSource<<1d6855ec0a749a41169ad18fea189d4c>>
 * @relayHash 82e58e09cb6c0ae8731a0483a5357faf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6
const $41658e2724bc842d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "82e58e09cb6c0ae8731a0483a5357faf",
            "id": "d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6",
            "metadata": {},
            "name": "ReactionsPlaceholderQuery",
            "operationKind": "query",
            "text": "query ReactionsPlaceholderQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsSummaryForEmoji{id}}}}}"
        }
    };
}();
$41658e2724bc842d$var$node.hash = "22ecbec40a97883abeadc26399cf4367";
var $41658e2724bc842d$export$2e2bcd8739ae039 = $41658e2724bc842d$var$node;
module.exports["default"] = $41658e2724bc842d$export$2e2bcd8739ae039;

});

parcelRegister("5Kc7f", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");


var $iKpb2 = parcelRequire("iKpb2");

const $aba7293523a7a5b0$var$styles = {
    emojiPlaceholderBackground: "_0KLXruGsB2",
    wrapperStyles: "_2Zuz6Q2ADO _1Znuxb8HPE _313842Ll21",
    countSkeletonStyles: "_0bjKvDS5Zs _39xV02uFDC _0jFU0VuFDC _0KLXruGsB2"
};
const $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS = {
    shortName: 'loading-placeholder',
    size: 16,
    xcss: $aba7293523a7a5b0$var$styles.emojiPlaceholderBackground
};
const $aba7293523a7a5b0$export$d85d0301f09f2005 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            className: (0, $hekY6.default)([
                $aba7293523a7a5b0$var$styles.wrapperStyles
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $aba7293523a7a5b0$var$styles.countSkeletonStyles
            ])
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ReactionsSummaryViewPlaceholder"] = $aba7293523a7a5b0$export$d85d0301f09f2005;

});

parcelRegister("9GMfm", function(module, exports) {

let $70dd7617066dd5f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $70dd7617066dd5f7$var$load("g81ly"),
    $70dd7617066dd5f7$var$load("e3LAK"),
    $70dd7617066dd5f7$var$load("eS3wT"),
    $70dd7617066dd5f7$var$load("4uO8Y"),
    $70dd7617066dd5f7$var$load("fYtcg"),
    $70dd7617066dd5f7$var$load("9FPrl"),
    $70dd7617066dd5f7$var$load("26l7c"),
    $70dd7617066dd5f7$var$load("dZsGY"),
    $70dd7617066dd5f7$var$load("h4Nf7"),
    $70dd7617066dd5f7$var$load("6wr18"),
    $70dd7617066dd5f7$var$load("59hV4"),
    $70dd7617066dd5f7$var$load("dr883"),
    $70dd7617066dd5f7$var$load("bePXd"),
    $70dd7617066dd5f7$var$load("ipIDQ"),
    $70dd7617066dd5f7$var$load("ea3NB"),
    $70dd7617066dd5f7$var$load("7EorR"),
    $70dd7617066dd5f7$var$load("fuOfV"),
    $70dd7617066dd5f7$var$load("jL1Ke"),
    $70dd7617066dd5f7$var$load("5MQ0D"),
    $70dd7617066dd5f7$var$load("6vqGz"),
    $70dd7617066dd5f7$var$load("ffEVr"),
    $70dd7617066dd5f7$var$load("jzSMU"),
    $70dd7617066dd5f7$var$load("Wowvf"),
    $70dd7617066dd5f7$var$load("2l8zo"),
    $70dd7617066dd5f7$var$load("hhss7"),
    $70dd7617066dd5f7$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("ewCYL", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $9wGTI = parcelRequire("9wGTI");

const $9204e37f72fd5b13$var$getPageCommentLeftMargin = (isDisabled)=>{
    if (isDisabled) // reactions-spacer is 5px wide
    return '0';
    else return '5px';
};
const $9204e37f72fd5b13$var$reactionsContainerStyles = null; // styling for disable state of reactions
const $9204e37f72fd5b13$var$disabledOrReadOnlyStyles = null; // hide the add reaction button and users dialog link for read-only
const $9204e37f72fd5b13$var$readOnlyStyles = null;
const $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 = ({ isDisabled: isDisabled, hasReactions: _hasReactions, readOnly: readOnly, ...props })=>{
    'use no memo';
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _4l3O9BCNcR _1RO7DI0ULC _3zEvDYnQyn _10gybenQyn _3Zv1Q0uNcX _0mapbD5UaJ _3PGAKIZpcK",
            (isDisabled || readOnly) && "_4CzNtGsyl5 _3PGAKIKGUX _0jwYZZsyl5 _4c1j4xYbGa",
            readOnly && "_0uUfRBYbGa _0c8i1XYbGa"
        ])
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$c7a67ebff2d113d4 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842UNDJ _0adFHsSPN1 _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$b4e61fe3d4c2583b = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFMdnbC _313842UNDJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // apply for inline comment on view or edit page
const $9204e37f72fd5b13$export$86c494d6cf94f63c = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t2;
        const t3 = __cmplp.isDisabled ? "var(--ds-text-subtlest, #6B6E76)" : "var(--ds-text-subtle, #505258)";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_10axpyj": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ $cozmU.createElement(C, {
            ...__cmplp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_3PGAKINTQj",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$144e39595b801848 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842UNDJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // Original empty-state footer styling, retained as the gate-off fallback so that disabling
const $9204e37f72fd5b13$var$objectCommentFooterReactionsLegacyStyles = null;
const $9204e37f72fd5b13$var$objectCommentFooterReactionsStyles = null; // The render params are intentionally untyped: the ambient `css` prop in this package resolves to
const $9204e37f72fd5b13$export$6534fd4b5ea3346a = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(11);
    let isDisabled;
    let props;
    let readOnly;
    if ($[0] !== t0) {
        const { isDisabled: t1, hasReactions: hasReactions, readOnly: t2, ...t3 } = t0;
        isDisabled = t1;
        readOnly = t2;
        props = t3;
        $[0] = t0;
        $[1] = isDisabled;
        $[2] = props;
        $[3] = readOnly;
    } else {
        isDisabled = $[1];
        props = $[2];
        readOnly = $[3];
    }
    const t1 = (isDisabled || readOnly) && "_4CzNtGsyl5 _3PGAKIKGUX _0jwYZZsyl5 _4c1j4xYbGa";
    const t2 = readOnly && "_0uUfRBYbGa _0c8i1XYbGa";
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _4l3O9BCNcR _1RO7DI0ULC _3zEvDYnQyn _10gybenQyn _3Zv1Q0uNcX _0mapbD5UaJ _3PGAKIZpcK",
            t1,
            t2,
            (0, $9wGTI.fg)("add_a_reaction_bug") && "_0aFT5vbt8w _0hPCNLchRC _4kzS0HAsDq _04oUsnYvD1 _2RxggLYvD1 _00QdnPzXzM _4DJMR3Va5s _3UmIXGmnOE _39ls2CZpcK _0cW5eq2ADO"
        ]);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== props || $[8] !== ref || $[9] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            ...props,
            className: t3
        });
        $[7] = props;
        $[8] = ref;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
});
$9204e37f72fd5b13$export$6534fd4b5ea3346a.displayName = 'ObjectCommentFooterReactionsContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$a44f62ffda6523d1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4ouGXIGVdc _3138425zaO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$49f6fd955ad6275a = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFM1Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["ReactionsContainer"] = $9204e37f72fd5b13$export$3dcc1cf4fc9c7641;
module.exports["PageReactionsContainer"] = $9204e37f72fd5b13$export$c7a67ebff2d113d4;
module.exports["PageCommentReactionsContainer"] = $9204e37f72fd5b13$export$b4e61fe3d4c2583b;
module.exports["InlineCommentReactionsContainer"] = $9204e37f72fd5b13$export$86c494d6cf94f63c;
module.exports["FeedReactionsContainer"] = $9204e37f72fd5b13$export$144e39595b801848;
module.exports["ObjectCommentFooterReactionsContainer"] = $9204e37f72fd5b13$export$6534fd4b5ea3346a;
module.exports["MutationErrorContainer"] = $9204e37f72fd5b13$export$a44f62ffda6523d1;

});

parcelRegister("5qhgL", function(module, exports) {
/* reactions-utils.ts generated by @compiled/babel-plugin v2.0.0 */ 
var $ewCYL = parcelRequire("ewCYL");


var $3FlVr = parcelRequire("3FlVr");

const $bfbd403eb560ce3e$export$610a53f6a2b349ea = (location)=>{
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
            return 0, $ewCYL.PageReactionsContainer;
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
            return 0, $ewCYL.PageCommentReactionsContainer;
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
            return 0, $ewCYL.InlineCommentReactionsContainer;
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            return 0, $ewCYL.FeedReactionsContainer;
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            return 0, $ewCYL.ObjectCommentFooterReactionsContainer;
        default:
            return 0, $ewCYL.ReactionsContainer;
    }
};
const $bfbd403eb560ce3e$export$bab27241713f2853 = (location)=>{
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
            return 'page';
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            return 'blogpost';
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            return 'comment';
    }
};
const $bfbd403eb560ce3e$export$ebc11b395f5b2d6c = (location)=>{
    let isPage = false;
    let isComment = false;
    let isFeed = false;
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            isPage = true;
            break;
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
            isFeed = true;
            break;
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
            isComment = true;
            break;
        // Feed comment is a special case that looks and queries like feed, but is technically a comment
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            isComment = true;
            isFeed = true;
            break;
    }
    return {
        isPage: isPage,
        isComment: isComment,
        isFeed: isFeed
    };
};
module.exports["getWrappingContainerByLocation"] = $bfbd403eb560ce3e$export$610a53f6a2b349ea;
module.exports["getContentTypeByLocation"] = $bfbd403eb560ce3e$export$bab27241713f2853;
module.exports["getBooleanLocationTypes"] = $bfbd403eb560ce3e$export$ebc11b395f5b2d6c;

});

parcelRegister("ke5Nx", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7zgzO = parcelRequire("7zgzO");

var $7176b627a488fb1c$export$eeec4f91154bc947 = /*#__PURE__*/ function(ReactionType) {
    ReactionType["COMMENT"] = "comment";
    return ReactionType;
}({});
const $7176b627a488fb1c$export$2278b801a31eb230 = ()=>{
    const $ = (0, $bDgLe.c)(15);
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    if ($[0] !== getQueryParams) {
        t0 = getQueryParams();
        $[0] = getQueryParams;
        $[1] = t0;
    } else t0 = $[1];
    const { action: action, contentId: contentId, contentType: contentType, focusedCommentId: focusedCommentId, emojiId: emojiId } = t0;
    const reaction = action && action === "react";
    const quickReaction = action && action === "addReaction";
    const focusedPageReactionsId = reaction && contentType && (contentType === "page" || contentType === "blogpost") && contentId ? contentId : undefined;
    const focusedCommentReactionsId = reaction && focusedCommentId ? focusedCommentId : undefined;
    const quickReactionsEmojiId = quickReaction && emojiId ? emojiId : undefined;
    const focusedCommentQuickReactionsId = quickReactionsEmojiId && focusedCommentId ? focusedCommentId : undefined;
    const focusedPageQuickReactionsId = quickReaction && quickReactionsEmojiId && contentType && (contentType === "page" || contentType === "blogpost") && contentId ? contentId : undefined;
    let t1;
    if ($[2] !== action || $[3] !== emojiId || $[4] !== focusedCommentId || $[5] !== getQueryParams || $[6] !== setQueryParams) {
        t1 = (t2)=>{
            const { reactionType: reactionType } = t2 === undefined ? {} : t2;
            if (action && emojiId) {
                const queryParams = getQueryParams();
                setQueryParams({
                    ...queryParams,
                    action: undefined,
                    emojiId: undefined,
                    contentType: undefined,
                    contentId: undefined
                });
            } else if (reactionType === "comment" && action && focusedCommentId) {
                const queryParams_0 = getQueryParams();
                setQueryParams({
                    ...queryParams_0,
                    action: undefined,
                    focusedCommentId: undefined
                });
            }
        };
        $[2] = action;
        $[3] = emojiId;
        $[4] = focusedCommentId;
        $[5] = getQueryParams;
        $[6] = setQueryParams;
        $[7] = t1;
    } else t1 = $[7];
    const removeReactionsQueryParams = t1;
    let t2;
    if ($[8] !== focusedCommentQuickReactionsId || $[9] !== focusedCommentReactionsId || $[10] !== focusedPageQuickReactionsId || $[11] !== focusedPageReactionsId || $[12] !== quickReactionsEmojiId || $[13] !== removeReactionsQueryParams) {
        t2 = {
            focusedPageReactionsId: focusedPageReactionsId,
            focusedCommentReactionsId: focusedCommentReactionsId,
            focusedCommentQuickReactionsId: focusedCommentQuickReactionsId,
            focusedPageQuickReactionsId: focusedPageQuickReactionsId,
            quickReactionsEmojiId: quickReactionsEmojiId,
            removeReactionsQueryParams: removeReactionsQueryParams
        };
        $[8] = focusedCommentQuickReactionsId;
        $[9] = focusedCommentReactionsId;
        $[10] = focusedPageQuickReactionsId;
        $[11] = focusedPageReactionsId;
        $[12] = quickReactionsEmojiId;
        $[13] = removeReactionsQueryParams;
        $[14] = t2;
    } else t2 = $[14];
    return t2;
};
module.exports["ReactionType"] = $7176b627a488fb1c$export$eeec4f91154bc947;
module.exports["useReactionsQueryParams"] = $7176b627a488fb1c$export$2278b801a31eb230;

});

parcelRegister("aUU0C", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $6b57ff110c624a89$var$initialState = {
    annotations: []
};
const $6b57ff110c624a89$var$actions = {
    setEditorAnnotations: (newAnnotations, pageId)=>({ getState: getState, setState: setState })=>{
            const { annotations: annotations } = getState();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(newAnnotations, annotations)) setState({
                annotations: newAnnotations,
                pageId: pageId
            });
        }
};
const $6b57ff110c624a89$var$EditorAnnotationsStore = (0, $8s9DV.createStore)({
    initialState: $6b57ff110c624a89$var$initialState,
    actions: $6b57ff110c624a89$var$actions,
    name: 'EditorAnnotationsStore'
});
const $6b57ff110c624a89$export$af3b3e68acbfeb43 = (0, $kBr4q.createHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
const $6b57ff110c624a89$export$72e98d7f4c892f01 = (0, $kBr4q.createActionsHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
module.exports["useEditorAnnotations"] = $6b57ff110c624a89$export$af3b3e68acbfeb43;
module.exports["useEditorAnnotationsActions"] = $6b57ff110c624a89$export$72e98d7f4c892f01;

});

parcelRegister("inDu6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kRW4Y = parcelRequire("kRW4Y");

function $34458177b4f70747$export$69f1ef99d32d73a0(InnerComponent) {
    var _WithDialogs;
    return _WithDialogs = class WithDialogs extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $kRW4Y.DialogsStateContainer)
                ]
            }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    dialogs: dialogs
                }));
        }
    }, _WithDialogs.displayName = `withDialogs(${InnerComponent.displayName || InnerComponent.name})`, _WithDialogs;
}
module.exports["withDialogs"] = $34458177b4f70747$export$69f1ef99d32d73a0;

});

parcelRegister("cgy29", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aWwYt = parcelRequire("aWwYt");


var $cMvMc = parcelRequire("cMvMc");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cZa7r = parcelRequire("cZa7r");


var $4DJgG = parcelRequire("4DJgG");

const $dacb5f0322f4a333$export$5ae138a5a05281f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics } = t0;
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            content.current = document.querySelector("div#content");
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[2] !== commentToReattach || $[3] !== contentId || $[4] !== createComment || $[5] !== hideObjectSidebar || $[6] !== isFabric || $[7] !== isObjectSidebarShown || $[8] !== setSelectionOptionsForCreateEditor) {
        t3 = (t4)=>{
            const { experienceAttributes: experienceAttributes } = t4 === undefined ? {} : t4;
            if (isObjectSidebarShown) hideObjectSidebar();
            if (isFabric) setSelectionOptionsForCreateEditor({
                experienceAttributes: experienceAttributes
            });
            else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
                content: content,
                contentId: contentId,
                commentToReattach: commentToReattach
            }));
        };
        $[2] = commentToReattach;
        $[3] = contentId;
        $[4] = createComment;
        $[5] = hideObjectSidebar;
        $[6] = isFabric;
        $[7] = isObjectSidebarShown;
        $[8] = setSelectionOptionsForCreateEditor;
        $[9] = t3;
    } else t3 = $[9];
    const createReactInlineCommentHighlight = t3;
    let t4;
    if ($[10] !== createReactInlineCommentHighlight || $[11] !== hasContentChanged || $[12] !== sendKeyboardShortcutAnalytics) {
        const handleCommentButtonClick = (t5)=>{
            const { dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 } = t5;
            if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>createReactInlineCommentHighlight({
                        experienceAttributes: experienceAttributes_0
                    })
            });
            else createReactInlineCommentHighlight({
                experienceAttributes: experienceAttributes_0
            });
            if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
        };
        t4 = {
            handleCommentButtonClick: handleCommentButtonClick
        };
        $[10] = createReactInlineCommentHighlight;
        $[11] = hasContentChanged;
        $[12] = sendKeyboardShortcutAnalytics;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        content.current = document.querySelector('div#content');
    }, []);
    const createReactInlineCommentHighlight = ({ experienceAttributes: experienceAttributes } = {})=>{
        if (isObjectSidebarShown) hideObjectSidebar();
        if (isFabric) setSelectionOptionsForCreateEditor({
            experienceAttributes: experienceAttributes
        });
        else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach
        }));
    };
    const handleCommentButtonClick = ({ dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 })=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight({
                    experienceAttributes: experienceAttributes_0
                })
        });
        else createReactInlineCommentHighlight({
            experienceAttributes: experienceAttributes_0
        });
        if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
    };
    return {
        handleCommentButtonClick: handleCommentButtonClick
    };
};
module.exports["useCreateCommentAction"] = $dacb5f0322f4a333$export$5ae138a5a05281f1;

});

parcelRegister("izhdc", function(module, exports) {

var $8i27m = parcelRequire("8i27m");

const $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b = (currentlyRenderedThreads, unresolvedInlineComments)=>{
    // Grab everything on the screen as a set for quick access
    const allRenderedInlineCommentIds = new Set(unresolvedInlineComments);
    // Grab all of the refs for inline comments that are available on the panel
    const panelCommentRefs = currentlyRenderedThreads.map((comment)=>{
        if (comment.type === 'INLINE') {
            if ('inlineMarkerRef' in comment && comment.inlineMarkerRef) return {
                ref: comment.inlineMarkerRef,
                type: (0, $8i27m.CommentType).INLINE
            };
            else return {
                ref: '',
                type: (0, $8i27m.CommentType).INLINE
            };
        } else return {
            ref: comment.id,
            type: (0, $8i27m.CommentType).GENERAL
        };
    }).filter((comment)=>{
        return comment.ref !== '';
    });
    // Grab the refs that we can navigate too (aka the ones rendered on the page, so open (i.e. not resolved) comments)
    const navigableInlineCommentRefs = new Set(panelCommentRefs.map((comment)=>{
        if (comment.type === (0, $8i27m.CommentType).INLINE) return allRenderedInlineCommentIds.has(comment.ref) ? comment.ref : '';
        else return comment.ref;
    }));
    return {
        panelCommentRefs: panelCommentRefs,
        navigableInlineCommentRefs: navigableInlineCommentRefs
    };
};
const $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29 = (action, panelCommentRefs, currentlySelectedThreadKey)=>{
    let nextIndex = panelCommentRefs.findIndex((comment)=>{
        return comment.ref === currentlySelectedThreadKey;
    });
    if (nextIndex === -1) nextIndex = 0;
    else if (action === 'next') nextIndex = (nextIndex + 1) % panelCommentRefs.length;
    else nextIndex = (nextIndex - 1 + panelCommentRefs.length) % panelCommentRefs.length;
    return panelCommentRefs[nextIndex];
};
module.exports["parsePanelAndInlineRefs"] = $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b;
module.exports["getNextRef"] = $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29;

});

parcelRegister("gSkOQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aSsfA = parcelRequire("aSsfA");


var $6lAIr = parcelRequire("6lAIr");


var $i6UMJ = parcelRequire("i6UMJ");


var $8i27m = parcelRequire("8i27m");


var $4L9ve = parcelRequire("4L9ve");

const $89de80864b4e19fe$export$618f651f678380bf = ()=>{
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { commentsDataMap: commentsDataMap } = (0, $4L9ve.useProcessedCommentsDataState)();
    return (0, $cozmU.useMemo)(()=>{
        const footerCommentThreads = (0, $6lAIr.getVisibleCommentThreads)({
            includeGeneralComments: true,
            commentsDataMap: commentsDataMap,
            includeInlineComments: false,
            orderedAnnotationIds: (0, $i6UMJ.getAnnotationThreadKeys)(orderedActiveAnnotationIdList),
            pageMode: pageMode
        });
        const footerCommentIds = footerCommentThreads.map((thread)=>thread.id);
        return {
            footerCommentIds: footerCommentIds,
            footerCommentThreads: footerCommentThreads
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotationIdList,
        pageMode
    ]);
};
module.exports["useFooterComments"] = $89de80864b4e19fe$export$618f651f678380bf;

});

parcelRegister("fIKxq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $8zMP3 = parcelRequire("8zMP3");


var $ihn35 = parcelRequire("ihn35");



// Cohort split for `confluence_eop_recs_twg_source_exp`, evaluated at loader
// activation to pick which arm's chunk loads (treatment -> TWG source; control
// (default) -> cc-smarts). Read WITHOUT firing exposure: exposure is logged once
// at page load from `EndOfPageRecommendationFinalLoader` below, so it isn't biased
// toward users who scroll far enough to activate this loader.
const $d90c1a5bdc683f34$var$loadRecommendationComponent = async ()=>{
    if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_eop_recs_twg_source_exp', 'isEnabled', true)) return (await (parcelRequire("gFSq2"))).EndOfPageRecommendationTwg;
    return (await (parcelRequire("dWAcA"))).EndOfPageRecommendation;
};
const $d90c1a5bdc683f34$export$ea341515a2d0d231 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cFlY8",
    name: "EndOfPageRecommendationLoader",
    loader: $d90c1a5bdc683f34$var$loadRecommendationComponent
});
const $d90c1a5bdc683f34$export$ab3a258d2d028df5 = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $cozmU.useEffect)($d90c1a5bdc683f34$var$_temp, t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihn35.EndOfPageRecPlaceholderContainer), null);
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "end-of-page-recommendations",
            fallback: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d90c1a5bdc683f34$export$ea341515a2d0d231, props));
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
function $d90c1a5bdc683f34$var$_temp() {
    (0, $6mKj3.manuallyLogExpExposure)("confluence_eop_recs_twg_source_exp");
}
module.exports["EndOfPageRecommendationLoader"] = $d90c1a5bdc683f34$export$ea341515a2d0d231;
module.exports["EndOfPageRecommendationFinalLoader"] = $d90c1a5bdc683f34$export$ab3a258d2d028df5;

});

parcelRegister("ihn35", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0Of8r2p0Oa _1wydGWkG2W _1EqgXl8yGE _39xV02N91d _0jFU0Vv6H3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$efb20161e583b9b8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgEqul _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _1wydGW2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$80837d77c7223a53 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _1Znuxb2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$7b34b3c5c4f8605a = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0KLXruDMqu _0jFU0VHZdu _39xV02dnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$48423cf6a25b5248 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu88HPE _2sNsIgmnOE _4FKVYEADSh _3iDTPbQ4SZ _0aFT5vbt8w _1EqgXlPyJ7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$49166591ec160d97 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2Zuz6Q2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$ee3e739bedcb3f4c = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0aFT5v1qpb _3TGfC9HnLE _2mHwu85zaO _3iDTPbQ4SZ _0jFU0VT0NC _37wbyuI7V3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$227f3f793075b973 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu8NHnM _2sNsIgmnOE _3iDTPbQ4SZ _0aFT5vbt8w _1ZnuxbGXk2 _1EqgXlB9Ek",
            !__cmplp.isNav4Enabled && "_2Zuz6QkG2W",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$545440ab15c19255 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu88HPE _2sNsIgd8bj _1UtDYzZpcK _3iDTPbQ4SZ _0hPCNLDIqT _2Zuz6QNHnM",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$a436177ded449686 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu85zaO _3iDTPbQ4SZ _0hPCNLDIqT _2Zuz6Q8HPE",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$faaa5da096482ae9 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgd8bj _1UtDYzZpcK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$a1abff0c22b50819 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFM1Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$23b4998b204f6604 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgd8bj _1UtDYzZpcK _1wydGW2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["EndOfPageRecPlaceholderContainer"] = $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d;
module.exports["InfoContainer"] = $e8a7d12ee4dfec6a$export$48423cf6a25b5248;
module.exports["FeedbackContainer"] = $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1;
module.exports["EndOfPageRecAdminConfigContainer"] = $e8a7d12ee4dfec6a$export$227f3f793075b973;
module.exports["EndOfPageRecHideControlContainer"] = $e8a7d12ee4dfec6a$export$545440ab15c19255;
module.exports["EndOfPageRecHideToggleContainer"] = $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab;
module.exports["SpaceFeedbackButtonWrapper"] = $e8a7d12ee4dfec6a$export$a1abff0c22b50819;

});

parcelRegister("gFSq2", function(module, exports) {

let $c23ab0297282a054$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c23ab0297282a054$var$load("eS3wT"),
    $c23ab0297282a054$var$load("4uO8Y"),
    $c23ab0297282a054$var$load("26l7c"),
    $c23ab0297282a054$var$load("4UHov"),
    $c23ab0297282a054$var$load("bb3WM"),
    $c23ab0297282a054$var$load("hEj0j"),
    $c23ab0297282a054$var$load("i35vr"),
    $c23ab0297282a054$var$load("6E7BW"),
    $c23ab0297282a054$var$load("1GCFv"),
    $c23ab0297282a054$var$load("52ZTT"),
    $c23ab0297282a054$var$load("cmmpX"),
    $c23ab0297282a054$var$load("59hV4"),
    $c23ab0297282a054$var$load("dr883"),
    $c23ab0297282a054$var$load("bePXd"),
    $c23ab0297282a054$var$load("6wr18"),
    $c23ab0297282a054$var$load("7gL7H"),
    $c23ab0297282a054$var$load("ea3NB"),
    $c23ab0297282a054$var$load("amIJr"),
    $c23ab0297282a054$var$load("4ZzjZ"),
    $c23ab0297282a054$var$load("3cJjP"),
    $c23ab0297282a054$var$load("dgWVQ"),
    $c23ab0297282a054$var$load("11yNG"),
    $c23ab0297282a054$var$load("gQYVn"),
    $c23ab0297282a054$var$load("9RGBF"),
    $c23ab0297282a054$var$load("2iL13"),
    $c23ab0297282a054$var$load("cpTbC"),
    $c23ab0297282a054$var$load("fhT77"),
    $c23ab0297282a054$var$load("jvUhP"),
    $c23ab0297282a054$var$load("7sOKp"),
    $c23ab0297282a054$var$load("7Ysw6"),
    $c23ab0297282a054$var$load("3xL2F"),
    $c23ab0297282a054$var$load("kMyku"),
    $c23ab0297282a054$var$load("hG1ar"),
    $c23ab0297282a054$var$load("2GC7K"),
    $c23ab0297282a054$var$load("cklhl"),
    $c23ab0297282a054$var$load("kobFT"),
    $c23ab0297282a054$var$load("gpIIT"),
    $c23ab0297282a054$var$load("cHAvQ"),
    $c23ab0297282a054$var$load("5d2zd"),
    $c23ab0297282a054$var$load("frCen"),
    $c23ab0297282a054$var$load("7zQG2"),
    $c23ab0297282a054$var$load("1HPRy"),
    $c23ab0297282a054$var$load("gnalD"),
    $c23ab0297282a054$var$load("9BBvG"),
    $c23ab0297282a054$var$load("6vqGz"),
    $c23ab0297282a054$var$load("cYv6T"),
    $c23ab0297282a054$var$load("ffEVr"),
    $c23ab0297282a054$var$load("Wowvf"),
    $c23ab0297282a054$var$load("2l8zo"),
    $c23ab0297282a054$var$load("7EorR"),
    $c23ab0297282a054$var$load("hhss7"),
    $c23ab0297282a054$var$load("3KskI")
]).then(()=>parcelRequire('5mYJd'));

});

parcelRegister("dWAcA", function(module, exports) {

let $a26cc614edc8166c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a26cc614edc8166c$var$load("eS3wT"),
    $a26cc614edc8166c$var$load("4uO8Y"),
    $a26cc614edc8166c$var$load("26l7c"),
    $a26cc614edc8166c$var$load("4UHov"),
    $a26cc614edc8166c$var$load("bb3WM"),
    $a26cc614edc8166c$var$load("hEj0j"),
    $a26cc614edc8166c$var$load("i35vr"),
    $a26cc614edc8166c$var$load("6E7BW"),
    $a26cc614edc8166c$var$load("1GCFv"),
    $a26cc614edc8166c$var$load("52ZTT"),
    $a26cc614edc8166c$var$load("cmmpX"),
    $a26cc614edc8166c$var$load("59hV4"),
    $a26cc614edc8166c$var$load("dr883"),
    $a26cc614edc8166c$var$load("bePXd"),
    $a26cc614edc8166c$var$load("6wr18"),
    $a26cc614edc8166c$var$load("7gL7H"),
    $a26cc614edc8166c$var$load("ea3NB"),
    $a26cc614edc8166c$var$load("amIJr"),
    $a26cc614edc8166c$var$load("4ZzjZ"),
    $a26cc614edc8166c$var$load("3cJjP"),
    $a26cc614edc8166c$var$load("dgWVQ"),
    $a26cc614edc8166c$var$load("11yNG"),
    $a26cc614edc8166c$var$load("gQYVn"),
    $a26cc614edc8166c$var$load("9RGBF"),
    $a26cc614edc8166c$var$load("2iL13"),
    $a26cc614edc8166c$var$load("cpTbC"),
    $a26cc614edc8166c$var$load("fhT77"),
    $a26cc614edc8166c$var$load("jvUhP"),
    $a26cc614edc8166c$var$load("7sOKp"),
    $a26cc614edc8166c$var$load("7Ysw6"),
    $a26cc614edc8166c$var$load("3xL2F"),
    $a26cc614edc8166c$var$load("kMyku"),
    $a26cc614edc8166c$var$load("hG1ar"),
    $a26cc614edc8166c$var$load("2GC7K"),
    $a26cc614edc8166c$var$load("cklhl"),
    $a26cc614edc8166c$var$load("kobFT"),
    $a26cc614edc8166c$var$load("gpIIT"),
    $a26cc614edc8166c$var$load("cHAvQ"),
    $a26cc614edc8166c$var$load("5d2zd"),
    $a26cc614edc8166c$var$load("frCen"),
    $a26cc614edc8166c$var$load("7zQG2"),
    $a26cc614edc8166c$var$load("1HPRy"),
    $a26cc614edc8166c$var$load("gnalD"),
    $a26cc614edc8166c$var$load("9BBvG"),
    $a26cc614edc8166c$var$load("6vqGz"),
    $a26cc614edc8166c$var$load("cYv6T"),
    $a26cc614edc8166c$var$load("ffEVr"),
    $a26cc614edc8166c$var$load("Wowvf"),
    $a26cc614edc8166c$var$load("2l8zo"),
    $a26cc614edc8166c$var$load("7EorR"),
    $a26cc614edc8166c$var$load("hhss7"),
    $a26cc614edc8166c$var$load("iV6RN")
]).then(()=>parcelRequire('kPKkS'));

});

parcelRegister("lOxqc", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $550abe5a694aeafb$export$45bb2daf3af483ad = 'TWG';
const $550abe5a694aeafb$var$contentIdOf = (node)=>node.pageId ?? node.blogPostId ?? undefined;
// Content statuses that cc-smarts would never recommend. We filter these out of the
// TWG results so treatment doesn't surface drafts/archived/trashed/etc. that control
// can't (the graph traversal isn't status-filtered, unlike the cc-smarts backend).
const $550abe5a694aeafb$var$NON_CURRENT_STATUSES = new Set([
    'archived',
    'deleted',
    'draft',
    'historical',
    'trashed'
]);
// Keep CURRENT and unknown/absent status (ConfluenceBlogPost.status is nullable and may
// not hydrate), dropping only definitively non-current content. Lenient on purpose so a
// blog whose status doesn't resolve isn't silently dropped.
const $550abe5a694aeafb$var$isCurrentContent = (node)=>{
    const status = node.pageStatus ?? node.blogPostStatus;
    return !status || !$550abe5a694aeafb$var$NON_CURRENT_STATUSES.has(String(status).toLowerCase());
};
const $550abe5a694aeafb$export$7440bc9de8627a49 = (data)=>{
    const seen = new Set();
    const nodes = [];
    // Linear (bounded by the query's `first`); the perf heuristic is a false positive.
    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- bounded by the query's `first`
    const columns = (data?.graphStore_cypherQueryV2?.edges ?? []).flatMap((edge)=>edge?.node?.columns ?? []);
    for (const column of columns){
        // Relay's multi-fragment union type doesn't allow direct field access; read the
        // selected fields through TwgContentNode (which matches the query selection).
        const node = column?.value?.data;
        const contentId = node ? $550abe5a694aeafb$var$contentIdOf(node) : undefined;
        // Only ConfluencePage/ConfluenceBlogPost are selected, so a present content id is
        // the presence + identity check; other node types resolve to `{}` and are skipped.
        // Non-current content is dropped so treatment matches what cc-smarts would show.
        if (node && contentId && $550abe5a694aeafb$var$isCurrentContent(node) && !seen.has(contentId)) {
            seen.add(contentId);
            nodes.push(node);
        }
    }
    return nodes;
};
// Map an AGG content node onto the `content` shape transformGlobalContent expects.
// Renames: webUi->webui, subtype->subType, owner.user.name->displayName,
// owner.user.accountId->creatorId, properties->emoji.nodes. `type` is derived from
// which id is present (the AGG enum is `PAGE`/`BLOG_POST`, which wouldn't match the
// card's lower-case, no-underscore content types and would render the wrong icon).
const $550abe5a694aeafb$var$toGlobalContentShape = (node)=>{
    const status = node.pageStatus ?? node.blogPostStatus;
    return {
        id: $550abe5a694aeafb$var$contentIdOf(node) ?? '',
        title: node.title ?? '',
        type: node.blogPostId ? 'blogpost' : 'page',
        subType: node.subtype ?? undefined,
        status: status ? String(status).toLowerCase() : undefined,
        links: {
            webui: node.links?.webUi ?? ''
        },
        space: {
            id: node.space?.id ?? '',
            key: node.space?.key ?? '',
            alias: node.space?.alias ?? '',
            name: node.space?.name ?? ''
        },
        creatorId: node.owner?.user?.accountId ?? '',
        history: {
            ownedBy: {
                displayName: node.owner?.user?.name ?? ''
            }
        },
        emoji: {
            nodes: node.properties ?? []
        }
    };
};
const $550abe5a694aeafb$export$a7ad6e153f92c731 = (data)=>{
    return $550abe5a694aeafb$export$7440bc9de8627a49(data).map((node)=>{
        const card = (0, $cxMI6.transformGlobalContent)($550abe5a694aeafb$var$toGlobalContentShape(node));
        // Parity with the cc-smarts transformer: zero these + stamp a strategy.
        card.likesCount = 0;
        card.commentsCount = 0;
        card.recommendationStrategy = $550abe5a694aeafb$export$45bb2daf3af483ad;
        return card;
    });
};
module.exports["TWG_STRATEGY"] = $550abe5a694aeafb$export$45bb2daf3af483ad;
module.exports["transformTwgRecs"] = $550abe5a694aeafb$export$a7ad6e153f92c731;

});

parcelRegister("jc6xl", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $2rapj = parcelRequire("2rapj");


var $lOxqc = parcelRequire("lOxqc");


var $ky8L5 = parcelRequire("ky8L5");

const $362c0e733b0222dd$export$7018f964cac4cdb1 = (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { entityId: entityId, entityType: entityType, spaceKey: spaceKey, skip: t1 } = t0;
    const skip = t1 === undefined ? false : t1;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] !== cloudId || $[1] !== entityId || $[2] !== entityType || $[3] !== skip) {
        t2 = skip || !(0, $ky8L5.isTwgSupportedContentType)(entityType) || !cloudId || !entityId;
        $[0] = cloudId;
        $[1] = entityId;
        $[2] = entityType;
        $[3] = skip;
        $[4] = t2;
    } else t2 = $[4];
    const shouldSkip = t2;
    let t3;
    if ($[5] !== cloudId || $[6] !== entityId || $[7] !== entityType || $[8] !== shouldSkip) {
        t3 = shouldSkip ? "" : (0, $ky8L5.buildTwgRecsCypher)((0, $ky8L5.buildTwgContentAri)(cloudId, entityId, entityType));
        $[5] = cloudId;
        $[6] = entityId;
        $[7] = entityType;
        $[8] = shouldSkip;
        $[9] = t3;
    } else t3 = $[9];
    const cypherQuery = t3;
    let t4;
    if ($[10] !== cypherQuery || $[11] !== spaceKey) {
        t4 = {
            cypherQuery: cypherQuery,
            first: (0, $ky8L5.MAX_TWG_RECS),
            key: spaceKey,
            keyString: spaceKey
        };
        $[10] = cypherQuery;
        $[11] = spaceKey;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== cloudId || $[14] !== shouldSkip) {
        t5 = shouldSkip ? undefined : {
            headers: {
                "X-Query-Context": (0, $ky8L5.buildTwgQueryContext)(cloudId)
            }
        };
        $[13] = cloudId;
        $[14] = shouldSkip;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== shouldSkip || $[17] !== t4 || $[18] !== t5) {
        t6 = {
            variables: t4,
            interopApolloAggClient: true,
            context: t5,
            errorPolicy: "all",
            fetchPolicy: "cache-first",
            skip: shouldSkip
        };
        $[16] = shouldSkip;
        $[17] = t4;
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $2rapj.default), {
        ...t6,
        __callerPackage__: "page-recommendations"
    });
    let t7;
    if ($[20] !== data) {
        t7 = (0, $lOxqc.transformTwgRecs)(data);
        $[20] = data;
        $[21] = t7;
    } else t7 = $[21];
    const pageCardData = t7;
    const isEnabled = Boolean(data?.getRecommendedPagesSpaceStatus?.recommendedPagesEnabled && data?.getRecommendedPagesSpaceStatus?.defaultBehavior === "SHOWN");
    const t8 = data?.space?.id ?? undefined;
    let t9;
    if ($[22] !== error || $[23] !== isEnabled || $[24] !== loading || $[25] !== pageCardData || $[26] !== shouldSkip || $[27] !== t8) {
        t9 = {
            pageCardData: pageCardData,
            spaceId: t8,
            isEnabled: isEnabled,
            loading: loading,
            error: error,
            skip: shouldSkip
        };
        $[22] = error;
        $[23] = isEnabled;
        $[24] = loading;
        $[25] = pageCardData;
        $[26] = shouldSkip;
        $[27] = t8;
        $[28] = t9;
    } else t9 = $[28];
    return t9;
};
module.exports["useTwgRecommendationData"] = $362c0e733b0222dd$export$7018f964cac4cdb1;

});

parcelRegister("JTIzG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

var $27a67c702eae1a5a$export$419c8aa8913e9327 = /*#__PURE__*/ function(BriefingNudgeExperimentState) {
    BriefingNudgeExperimentState["CONTROL"] = "control";
    BriefingNudgeExperimentState["NUDGE"] = "nudge";
    BriefingNudgeExperimentState["NUDGE_AUTOPLAY"] = "nudge_autoplay";
    return BriefingNudgeExperimentState;
}({});
const $27a67c702eae1a5a$export$df5bf03825b93c3d = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAtlassianHostedLLMOnlyEnabled: isAtlassianHostedLLMOnlyEnabled } = (0, $bQm3c.useSessionData)();
    // Deferred: MediaSource is unavailable during SSR
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setAudioSupportedByBrowser(typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'));
    }, []);
    const { isAIPolicyEnabled: isAIPolicyEnabled, isAudioV3EnabledForPolicy: isAudioV3EnabledForPolicy, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $cozmU.useMemo)(()=>{
        const aiPolicyEnabled = !(isAtlassianHostedLLMOnlyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_disable_if_ahm_enabled')) && isAdminHubAIEnabled && isAIEarlyAccessEnabled;
        const audioV3EnabledForPolicy = aiPolicyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3');
        return {
            isAIPolicyEnabled: aiPolicyEnabled,
            isAudioV3EnabledForPolicy: audioV3EnabledForPolicy,
            // Keep byline visibility stable through SSR and hydration. ListenByline checks browser
            // support after hydration and disables its trigger when audio playback is unsupported.
            isAudioBylineEntrypointEnabled: audioV3EnabledForPolicy
        };
    }, [
        isAdminHubAIEnabled,
        isAIEarlyAccessEnabled,
        isAtlassianHostedLLMOnlyEnabled
    ]);
    const isAudioV3Enabled = isAudioV3EnabledForPolicy && audioSupportedByBrowser;
    const audioBriefingNudgeExperimentState = (0, $cozmU.useMemo)(()=>{
        if (!isAudioV3Enabled) return "control";
        if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge')) return "nudge";
        else if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay')) return "nudge_autoplay";
        else return "control";
    }, [
        isAudioV3Enabled
    ]);
    return {
        isAIPolicyAndBrowserSupportEnabled: isAIPolicyEnabled && audioSupportedByBrowser,
        isAudioV3Enabled: isAudioV3Enabled,
        isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled,
        audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState
    };
};
module.exports["BriefingNudgeExperimentState"] = $27a67c702eae1a5a$export$419c8aa8913e9327;
module.exports["useAudioFeatureFlags"] = $27a67c702eae1a5a$export$df5bf03825b93c3d;

});

parcelRegister("iNYtG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4r9Ir = parcelRequire("4r9Ir");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $bQm3c = parcelRequire("bQm3c");


var $6UYek = parcelRequire("6UYek");


var $8i27m = parcelRequire("8i27m");


var $3mVfX = parcelRequire("3mVfX");


var $l5y3Y = parcelRequire("l5y3Y");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $804Ue = parcelRequire("804Ue");


var $83eLG = parcelRequire("83eLG");


var $aM1he = parcelRequire("aM1he");

const $d9d12cfcf38f06b2$export$ae25147d30bdeffa = ({ contentId: contentId, contentType: contentType })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const { addNewComment: addNewComment, removeComment: removeComment, clearNewComments: clearNewComments } = (0, $cozmU.useContext)((0, $4r9Ir.NewCommentsContext));
    const { addSubscriber: addSubscriber, removeSubscriber: removeSubscriber, setContentType: setContentType, setContentId: setContentId } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const subscriptions = (0, $cozmU.useRef)([]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: contentId
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { getCurrentCommentsPanelState: getCurrentCommentsPanelState, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment } = (0, $8i27m.useCommentsDataActions)();
    const { setReplyToCommentId: setReplyToCommentId, getCommentsPanelState: getCommentsPanelState } = (0, $3mVfX.useCommentsPanelActions)();
    const clearReplyIfRemoved = (0, $cozmU.useCallback)(({ commentId: commentId })=>{
        const { replyToCommentId: replyToCommentId } = getCommentsPanelState();
        if (replyToCommentId === commentId) setReplyToCommentId();
    }, [
        getCommentsPanelState,
        setReplyToCommentId
    ]);
    const { deleteCommentInCache: deleteCommentInCache, addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    // The missed-events reload path below is dead: it only runs when MissedPubSubCommentEventsHandler
    // fires onEventFetchSuccess, which no longer happens now that cc_fps_migration_comments and
    // confluence_enable_subscriptions-context-provider are permanently enabled (those gates early-return
    // all of MissedPubSubCommentEventsHandler's effects). This no-op reloader is a placeholder to
    // preserve the (unreachable) reloader signature.
    // TODO: This began being flagged by oxlint as part of a feature-gate cleanup PR; investigate separately.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Preserve source behavior; see TODO above.
    const activeCommentsRefetch = ()=>Promise.resolve();
    const subscribeToPageCommentsPubSub = (0, $cozmU.useCallback)(()=>{
        // Early return if pageMode is Edit - do not setup pubsub for edit pages
        if (pageMode === (0, $cD1qu.PageMode).EDIT) return;
        if (subscriptions.current.length > 0) return;
        const queryArgs = {
            isReactionsEnabled: isReactionsEnabled
        };
        subscriptions.current = (0, $83eLG.setUpPageCommentsPubSub)({
            contentId: contentId,
            contentType: contentType,
            userId: userId,
            reloader: activeCommentsRefetch,
            addNewComment: addNewComment,
            removeComment: removeComment,
            queryArgs: queryArgs,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            reopenParentComment: reopenParentComment,
            getCurrentCommentsPanelState: getCurrentCommentsPanelState,
            addSubscriber: addSubscriber,
            setContentType: setContentType,
            setContentId: setContentId,
            updateUnreadCommentIDSet: updateUnreadCommentIDSet,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
            addCommentInCache: addCommentInCache,
            deleteCommentInCache: deleteCommentInCache,
            clearReplyIfRemoved: clearReplyIfRemoved
        }) ?? [];
    }, [
        contentId,
        contentType,
        userId,
        // oxlint-disable-next-line react-hooks/exhaustive-deps -- Preserve source behavior; see TODO above.
        activeCommentsRefetch,
        addNewComment,
        removeComment,
        isReactionsEnabled,
        updateRemovedCommentIdsMap,
        reopenParentComment,
        getCurrentCommentsPanelState,
        addSubscriber,
        setContentType,
        setContentId,
        updateUnreadCommentIDSet,
        getViewedCommentsCacheOnly,
        addCommentInCache,
        deleteCommentInCache,
        pageMode,
        clearReplyIfRemoved
    ]);
    const unsubscribeFromPageCommentsPubSub = (0, $cozmU.useCallback)(()=>{
        // Early return if pageMode is Edit - no pubsub was set up for edit pages
        if (pageMode === (0, $cD1qu.PageMode).EDIT) return;
        if (subscriptions.current.length === 0) return;
        const queryArgs = {
            isReactionsEnabled: isReactionsEnabled
        };
        (0, $83eLG.removePageCommentsPubSub)({
            contentId: contentId,
            contentType: contentType,
            userId: userId,
            reloader: activeCommentsRefetch,
            addNewComment: addNewComment,
            removeComment: removeComment,
            queryArgs: queryArgs,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            removeSubscriber: removeSubscriber,
            subscriptions: subscriptions.current,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        });
        subscriptions.current = [];
    }, [
        contentId,
        contentType,
        userId,
        // oxlint-disable-next-line react-hooks/exhaustive-deps -- Preserve source behavior; see TODO above.
        activeCommentsRefetch,
        addNewComment,
        removeComment,
        isReactionsEnabled,
        updateRemovedCommentIdsMap,
        removeSubscriber,
        getViewedCommentsCacheOnly,
        pageMode
    ]);
    const handleEventFetchSuccess = (0, $cozmU.useCallback)((data)=>{
        if (data && data.contentId === contentId) {
            if (data.commentEvents.length) {
                const commentData = data.commentEvents.map((event)=>{
                    return {
                        commentId: event.id,
                        accountId: event.accountId
                    };
                });
                (0, $aM1he.reloadAndAddPageComments)(activeCommentsRefetch, addNewComment, commentData, userId);
            }
        }
    }, [
        contentId,
        addNewComment,
        // oxlint-disable-next-line react-hooks/exhaustive-deps -- Preserve source behavior; see TODO above.
        activeCommentsRefetch,
        userId
    ]);
    if (!userId || pageMode === (0, $cD1qu.PageMode).EDIT && (0, $6mKj3.expValEquals)('confluence_comments_get_document_version_number', 'isEnabled', true)) return null;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $804Ue.MissedPubSubCommentEventsHandler), {
        contentId: contentId,
        eventType: (0, $804Ue.CommentEventType).FOOTER,
        subscribeToPubSubEvents: subscribeToPageCommentsPubSub,
        unsubscribeFromPubSubEvents: unsubscribeFromPageCommentsPubSub,
        onEventFetchSuccess: handleEventFetchSuccess,
        onDocumentReturn: clearNewComments,
        isAutoReloadPageComments: true
    }));
};
module.exports["PageCommentsPubSubHandler"] = $d9d12cfcf38f06b2$export$ae25147d30bdeffa;

});

parcelRegister("4r9Ir", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7IghX = parcelRequire("7IghX");

const $4ae3b5b25efc2fdf$export$c465d99c658013a3 = /*#__PURE__*/ (0, $cozmU.createContext)({
    newCommentPositions: [],
    addNewComment: ()=>{},
    removeComment: ()=>{},
    acknowledgeComment: ()=>{},
    acknowledgeComments: ()=>{},
    clearNewComments: ()=>{}
});
const $4ae3b5b25efc2fdf$var$getCommentScreenPosition = (commentId)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentElem = document.querySelector(`#comment-${commentId}`);
    if (commentElem) return {
        top: commentElem.offsetTop,
        bottom: commentElem.offsetTop + commentElem.offsetHeight
    };
    return {
        top: Number.NEGATIVE_INFINITY,
        bottom: Number.POSITIVE_INFINITY
    };
};
const $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [newCommentPositions, setNewCommentPositions] = (0, $cozmU.useState)(t1);
    const { count: count, setCount: setCount } = (0, $cozmU.useContext)((0, $7IghX.PageCommentsCountContext));
    let t2;
    if ($[1] !== count || $[2] !== setCount) {
        t2 = (t3)=>{
            const { currentUserMadeComment: currentUserMadeComment, newCommentId: newCommentId } = t3;
            if (newCommentId) {
                const pos = $4ae3b5b25efc2fdf$var$getCommentScreenPosition(newCommentId);
                setNewCommentPositions((existingPositions)=>{
                    const commentExists = existingPositions.some((e)=>e.id === newCommentId);
                    return !commentExists ? [
                        ...existingPositions,
                        {
                            id: newCommentId,
                            pos: pos,
                            seen: false,
                            currentUserMadeComment: currentUserMadeComment
                        }
                    ] : existingPositions;
                });
                setCount(count + 1);
            }
        };
        $[1] = count;
        $[2] = setCount;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== count || $[5] !== newCommentPositions || $[6] !== setCount) {
        t3 = (commentId)=>{
            if (commentId) {
                const idx = newCommentPositions.findIndex((comment)=>commentId === comment.id);
                if (idx !== -1) {
                    const positionCopy = [
                        ...newCommentPositions
                    ];
                    positionCopy.splice(idx, 1);
                    setNewCommentPositions(positionCopy);
                }
                const newCount = count - 1;
                setCount(newCount < 0 ? 0 : newCount);
            }
        };
        $[4] = count;
        $[5] = newCommentPositions;
        $[6] = setCount;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    let t5;
    if ($[8] !== newCommentPositions) {
        t4 = (commentId_0)=>{
            if (commentId_0) {
                const comment_0 = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId_0);
                if (comment_0) comment_0.seen = true;
            }
        };
        t5 = (commentIds)=>{
            if (commentIds && commentIds.length) commentIds.forEach((commentId_1)=>{
                const comment_1 = newCommentPositions.find((commentPosition_0)=>commentPosition_0.id === commentId_1);
                if (comment_1) comment_1.seen = true;
            });
        };
        $[8] = newCommentPositions;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setNewCommentPositions([]);
        };
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== newCommentPositions || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t7 = {
            newCommentPositions: newCommentPositions,
            addNewComment: t2,
            removeComment: t3,
            acknowledgeComment: t4,
            acknowledgeComments: t5,
            clearNewComments: t6
        };
        $[12] = newCommentPositions;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t7;
    } else t7 = $[17];
    const newCommentsContextValue = t7;
    let t8;
    if ($[18] !== children || $[19] !== newCommentsContextValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ae3b5b25efc2fdf$export$c465d99c658013a3.Provider, {
            value: newCommentsContextValue
        }, children);
        $[18] = children;
        $[19] = newCommentsContextValue;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ children: children })=>{
    const [newCommentPositions, setNewCommentPositions] = (0, $cozmU.useState)([]);
    const { count: count, setCount: setCount } = (0, $cozmU.useContext)((0, $7IghX.PageCommentsCountContext));
    const newCommentsContextValue = (0, $cozmU.useMemo)(()=>({
            newCommentPositions: newCommentPositions,
            addNewComment: ({ currentUserMadeComment: currentUserMadeComment, newCommentId: newCommentId })=>{
                if (newCommentId) {
                    const pos = $4ae3b5b25efc2fdf$var$getCommentScreenPosition(newCommentId);
                    setNewCommentPositions((existingPositions)=>{
                        const commentExists = existingPositions.some((e)=>e.id === newCommentId);
                        return !commentExists ? [
                            ...existingPositions,
                            {
                                id: newCommentId,
                                pos: pos,
                                seen: false,
                                currentUserMadeComment: currentUserMadeComment
                            }
                        ] : existingPositions;
                    });
                    // Update the comment count
                    setCount(count + 1);
                }
            },
            removeComment: (commentId)=>{
                if (commentId) {
                    const idx = newCommentPositions.findIndex((comment)=>commentId === comment.id);
                    if (idx !== -1) {
                        const positionCopy = [
                            ...newCommentPositions
                        ];
                        positionCopy.splice(idx, 1);
                        setNewCommentPositions(positionCopy);
                    }
                    // Update the comment count
                    const newCount = count - 1;
                    setCount(newCount < 0 ? 0 : newCount);
                }
            },
            acknowledgeComment: (commentId_0)=>{
                if (commentId_0) {
                    const comment_0 = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId_0);
                    if (comment_0) comment_0.seen = true;
                }
            },
            acknowledgeComments: (commentIds)=>{
                if (commentIds && commentIds.length) commentIds.forEach((commentId_1)=>{
                    const comment_1 = newCommentPositions.find((commentPosition_0)=>commentPosition_0.id === commentId_1);
                    if (comment_1) comment_1.seen = true;
                });
            },
            clearNewComments: ()=>{
                setNewCommentPositions([]);
            }
        }), [
        count,
        newCommentPositions,
        setCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ae3b5b25efc2fdf$export$c465d99c658013a3.Provider, {
        value: newCommentsContextValue
    }, children);
};
module.exports["NewCommentsContext"] = $4ae3b5b25efc2fdf$export$c465d99c658013a3;
module.exports["NewCommentsProvider"] = $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f;

});

parcelRegister("7IghX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $230ca5ca2ceedabc$export$560530991a10c1f8 = /*#__PURE__*/ (0, $cozmU.createContext)({
    count: 0,
    setCount: ()=>{}
});
const $230ca5ca2ceedabc$export$d3be1c3b23ba5810 = ({ children: children, contentId: contentId })=>{
    const [count, setCount] = (0, $cozmU.useState)(0);
    const pageCommentsCountContextValue = (0, $cozmU.useMemo)(()=>({
            count: count,
            setCount: setCount
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        count,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($230ca5ca2ceedabc$export$560530991a10c1f8.Provider, {
        value: pageCommentsCountContextValue
    }, children);
};
module.exports["PageCommentsCountContext"] = $230ca5ca2ceedabc$export$560530991a10c1f8;
module.exports["PageCommentsCountProvider"] = $230ca5ca2ceedabc$export$d3be1c3b23ba5810;

});

parcelRegister("804Ue", function(module, exports) {

var $lFugL = parcelRequire("lFugL");


var $cozmU = parcelRequire("cozmU");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $flE5X = parcelRequire("flE5X");


var $cAdj8 = parcelRequire("cAdj8");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $6mKj3 = parcelRequire("6mKj3");

var $11771bad87ca0882$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["ACTIVE"] = 0] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 1] = "TERMINATED";
    return PubSubState;
}({});
var $11771bad87ca0882$export$77deeade63afd3a6 = /*#__PURE__*/ function(CommentEventType) {
    CommentEventType[CommentEventType["ALL"] = 0] = "ALL";
    CommentEventType[CommentEventType["FOOTER"] = 1] = "FOOTER";
    CommentEventType[CommentEventType["INLINE"] = 2] = "INLINE";
    return CommentEventType;
}({});
const $11771bad87ca0882$export$5a33be95ac52bdad = 2000;
const $11771bad87ca0882$export$f09c511f29ef2d = 3000;
const $11771bad87ca0882$export$45c0a7c4ba2fbb03 = ({ contentId: contentId, eventType: eventType, subscribeToPubSubEvents: subscribeToPubSubEvents, unsubscribeFromPubSubEvents: unsubscribeFromPubSubEvents, onEventFetchSuccess: onEventFetchSuccess, onFetchContentVersionEvent: onFetchContentVersionEvent, onDocumentReturn: onDocumentReturn, lastPollTime: lastPollTime, inactiveInterval: inactiveInterval = $11771bad87ca0882$export$5a33be95ac52bdad, returnInterval: returnInterval = $11771bad87ca0882$export$f09c511f29ef2d, isAutoReloadPageComments: isAutoReloadPageComments = false })=>{
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const lastEventCheckTimeRef = (0, $cozmU.useRef)(lastPollTime || Date.now());
    const subscriptionShutdownTimer = (0, $cozmU.useRef)(null);
    const missedEventQueryTimeout = (0, $cozmU.useRef)(null);
    // Check if document is undefined to handle SSR playwright tests
    const [documentVisible, setDocumentVisible] = (0, $cozmU.useState)(typeof document !== 'undefined' ? !document.hidden : true);
    const [pubSubState, setPubSubState] = (0, $cozmU.useState)(0);
    const { pageInfo: pageInfo, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        // this is required for page navigation using the page tree
        onCompleted: (data)=>{
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
                const number = data?.content?.nodes?.[0]?.version?.number;
                if (number) setPublishedDocumentVersion(number);
            }
        }
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    (0, $cozmU.useEffect)(()=>{
        const latestVersion = pageInfo?.version?.number;
        if (latestVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
            setPublishedDocumentVersion(latestVersion);
            if ((0, $6mKj3.expValEquals)('confluence_fe_correct_document_needs_update', 'isEnabled', true)) // Set documentNeedsUpdate to true only if all of the following are true:
            // 1. pageMode is VIEW
            // 2. currentDocumentVersion is set to a valid version number
            // 3. latestVersion is different from currentDocumentVersion
            // Otherwise, set documentNeedsUpdate to false.
            setDocumentNeedsUpdate(pageMode === (0, $cD1qu.PageMode).VIEW && currentDocumentVersion > 0 && latestVersion !== currentDocumentVersion);
            else setDocumentNeedsUpdate(latestVersion !== currentDocumentVersion);
        }
    }, [
        pageInfo?.version?.number,
        currentDocumentVersion,
        setPublishedDocumentVersion,
        setDocumentNeedsUpdate,
        pageMode
    ]);
    const fetchContentVersionNumber = async ()=>{
        try {
            if (refetch) {
                const { data: data } = await refetch();
                return data?.content?.nodes?.[0]?.version?.number;
            }
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            return;
        }
    };
    const fetchMissingCommentEventsSinceTime = async (contentId, since)=>{
        try {
            const response = await (0, $c0rhi.queryInterop)({
                query: (0, $lFugL.default),
                variables: {
                    contentId: contentId,
                    since: since
                },
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
                __callerPackage__: "comments-pubsub"
            });
            const comments = response.data?.quickReload?.comments || [];
            let filteredCommentEvents = comments;
            // Filter out comment events tha we're not subscribed to
            if (eventType !== 0) filteredCommentEvents = comments.filter((comment)=>eventType === 1 ? comment.comment?.location.type === 'FOOTER' : comment.comment?.location.type === 'INLINE');
            const commentEvents = filteredCommentEvents.map((comment)=>{
                const commentId = comment.comment?.id;
                const type = comment.comment?.location.type;
                const accountId = comment.comment?.author?.accountId || '';
                return {
                    id: commentId,
                    type: type,
                    accountId: accountId
                };
            });
            const time = response.data?.quickReload?.time;
            return {
                commentEvents: commentEvents,
                time: time,
                contentId: contentId
            };
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            // Just do nothing
            return;
        }
    };
    const clearMissedEventTimeout = ()=>{
        if (missedEventQueryTimeout.current) {
            clearTimeout(missedEventQueryTimeout.current);
            missedEventQueryTimeout.current = null;
        }
    };
    const checkAndHandleMissedEvents = ()=>{
        // If we already have a timeout queued clear it
        clearMissedEventTimeout();
        // Check for the missed events on a timeout after the user has been back for 3 seconds
        missedEventQueryTimeout.current = setTimeout(async ()=>{
            if (documentNeedsUpdate) return;
            const contentLatestVersion = await fetchContentVersionNumber();
            if (!isAutoReloadPageComments && contentLatestVersion !== publishedDocumentVersion) {
                if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // when experiment is ON, this is done in the useEffect block above
                setPublishedDocumentVersion(contentLatestVersion);
                onFetchContentVersionEvent && onFetchContentVersionEvent();
                return;
            }
            // Call passed in fetch function
            fetchMissingCommentEventsSinceTime(contentId, lastEventCheckTimeRef.current || Date.now()).then((res)=>{
                // This check of content types is needed in case the promise resolves after a user has already changed pages
                if (res && contentId === res.contentId) {
                    lastEventCheckTimeRef.current = res.time ?? Date.now();
                    // Return the result to the caller
                    onEventFetchSuccess(res);
                }
            // If the call fails, do nothing, just assume the events were missed
            });
        }, returnInterval);
    };
    // Wire up pub sub events when the component mounts
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            window.removeEventListener('beforeunload', unsubscribeFromPubSubEvents);
            unsubscribeFromPubSubEvents();
            if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
            clearMissedEventTimeout();
        };
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Need to subscribe to the pubsub when component mounts or contentId, publishedDocumentVersion changes
    (0, $cozmU.useEffect)(()=>{
        // No need to subscribe to the pubsub when doc version is 0
        // We need the events only when we have a valid version number i.e published
        if (publishedDocumentVersion === 0) return;
        subscribeToPubSubEvents();
        // Make sure to unsubscribe from pubsub events if the browser closes
        window.addEventListener('beforeunload', unsubscribeFromPubSubEvents);
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        publishedDocumentVersion,
        documentNeedsUpdate
    ]);
    // Listen to document visibility changes
    (0, $cozmU.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        const changeVisibility = ()=>setDocumentVisible(!document.hidden);
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>{
            document.removeEventListener('visibilitychange', changeVisibility);
        };
    }, [
        setDocumentVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        if (documentVisible && subscriptionShutdownTimer.current) {
            clearTimeout(subscriptionShutdownTimer.current);
            subscriptionShutdownTimer.current = null;
        }
        // When the document becomes hidden, record the current time as the last check time
        if (!documentVisible) lastEventCheckTimeRef.current = Date.now();
        // If the document is no longer visible, set a timeout to unsubscribe from pubsub events
        if (!documentVisible && !subscriptionShutdownTimer.current && pubSubState === 0) subscriptionShutdownTimer.current = setTimeout(()=>{
            unsubscribeFromPubSubEvents();
            setPubSubState(1);
        }, inactiveInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    // Resubscribe to the pubsub events when we come back and handle any missed events
    (0, $cozmU.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        setPubSubState((prevState)=>{
            if (documentVisible && prevState === 1) {
                onDocumentReturn && onDocumentReturn();
                checkAndHandleMissedEvents();
                subscribeToPubSubEvents();
                return 0;
            }
            return prevState;
        });
    // We only want this to fire when the document visibility has changed, not the pubsub state
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    return null;
};
module.exports["CommentEventType"] = $11771bad87ca0882$export$77deeade63afd3a6;
module.exports["MissedPubSubCommentEventsHandler"] = $11771bad87ca0882$export$45c0a7c4ba2fbb03;

});

parcelRegister("lFugL", function(module, exports) {
/**
 * @generated SignedSource<<ec37448e00124aacfed3c0e6870df73b>>
 * @relayHash 7477557bbdcb7cd2b6d07a81a3bcb66a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559
const $f560d9e78fe64cde$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "since"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "since",
            "variableName": "since"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "time"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "KnownUser"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "UnknownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7477557bbdcb7cd2b6d07a81a3bcb66a",
            "id": "b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559",
            "metadata": {},
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "operationKind": "query",
            "text": "query MissedPubSubCommentEventsHandlerQuery($contentId:Long!,$since:Long!){quickReload(pageId:$contentId,since:$since){time,comments{comment{id,location{__typename,type},author{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}"
        }
    };
}();
$f560d9e78fe64cde$var$node.hash = "7c3b6fa82a316ebe81a0bcd5cab2114e";
var $f560d9e78fe64cde$export$2e2bcd8739ae039 = $f560d9e78fe64cde$var$node;
module.exports["default"] = $f560d9e78fe64cde$export$2e2bcd8739ae039;

});

parcelRegister("83eLG", function(module, exports) {

var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $e4kZB = parcelRequire("e4kZB");


var $lb2Lp = parcelRequire("lb2Lp");


var $hfNnW = parcelRequire("hfNnW");


var $b11gn = parcelRequire("b11gn");

const $ced40be9017d58cb$var$FETCH_COMMENT_RETRY_DELAYS_MS = [
    500,
    1000,
    2000
];
/**
 * Fetches a comment by ID with automatic retry on null result.
 * The pubsub event can arrive before the server has committed the comment,
 * causing fetchCommentById to return null. We retry with backoff to handle this.
 */ const $ced40be9017d58cb$var$fetchCommentByIdWithRetry = async ({ commentId: commentId, contentId: contentId })=>{
    let result = await (0, $lb2Lp.fetchCommentById)({
        commentId: commentId,
        contentId: contentId,
        fetchPolicy: 'network-only'
    });
    if (result !== null) return result;
    for (const delayMs of $ced40be9017d58cb$var$FETCH_COMMENT_RETRY_DELAYS_MS){
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve)=>setTimeout(resolve, delayMs));
        // eslint-disable-next-line no-await-in-loop
        result = await (0, $lb2Lp.fetchCommentById)({
            commentId: commentId,
            contentId: contentId,
            fetchPolicy: 'network-only'
        });
        if (result !== null) return result;
    }
    return result;
};
const $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment = ({ comment: comment, userId: userId, viewedComments: viewedComments, updateUnreadCommentIDSet: updateUnreadCommentIDSet })=>{
    const validUnreadCommentIds = new Set();
    // Validate the main comment
    const commentForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
        commentId: comment.id,
        userId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined,
        createdAt: comment.createdAt?.value || undefined,
        commentType: 'FOOTER',
        // Page comments are always FOOTER type
        resolveProperties: {
            resolved: false
        } // reopened comment = resolved false
    });
    if ((0, $e4kZB.isValidUnreadComment)({
        comment: commentForValidation,
        currentUserId: userId,
        viewedComments: viewedComments
    })) validUnreadCommentIds.add(comment.id);
    // Validate replies if they exist
    if (comment.replies) comment.replies.forEach((reply)=>{
        const replyForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
            commentId: reply.id,
            userId: reply.author?.__typename === 'KnownUser' ? reply.author.accountId : undefined,
            createdAt: reply.createdAt?.value || undefined,
            commentType: 'FOOTER',
            // Page comments are always FOOTER type
            resolveProperties: {
                resolved: false
            } // reopened comment = resolved false
        });
        if ((0, $e4kZB.isValidUnreadComment)({
            comment: replyForValidation,
            currentUserId: userId,
            viewedComments: viewedComments
        })) validUnreadCommentIds.add(reply.id);
    });
    updateUnreadCommentIDSet(validUnreadCommentIds, 'add');
};
const $ced40be9017d58cb$export$4d067148c1e8c84d = ({ userId: userId, contentId: contentId, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, clearReplyIfRemoved: clearReplyIfRemoved })=>(event, payload)=>{
        if (!event) return;
        let commentRequestBody;
        const { accountId: accountId, originTabId: originTabId } = payload;
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) commentRequestBody = payload?.[event];
        else commentRequestBody = payload.commentRequestBody;
        const { commentId: commentId } = commentRequestBody;
        const isReply = commentRequestBody?.pageCommentType === 'REPLY';
        if ((0, $hfNnW.shouldSkipOwnPubSubEvent)({
            accountId: accountId,
            currentUserId: userId,
            originTabId: originTabId,
            isReply: isReply,
            isOwnReplyPubSubProcessingEnabled: (0, $6mKj3.expVal)('cc_comments_pubsub_process_own_replies', 'isEnabled', false)
        })) return;
        const { start: startCommentsPubSubExperience, succeed: succeedCommentsPubSubExperience, fail: failCommentsPubSubExperience } = (0, $b11gn.createCommentsPubSubExperienceTracker)((0, $b11gn.CommentsPubSubSource).PageCommentsPubSub);
        startCommentsPubSubExperience(event);
        try {
            switch(event){
                case 'commentCreated':
                case 'avi:confluence:created:comment':
                    if (addCommentInCache && commentId) {
                        const fetchFn = (0, $6mKj3.expVal)('cc_comments_page_comment_retry', 'isEnabled', false) ? $ced40be9017d58cb$var$fetchCommentByIdWithRetry : ({ commentId: cId, contentId: cntId })=>(0, $lb2Lp.fetchCommentById)({
                                commentId: cId,
                                contentId: cntId,
                                fetchPolicy: 'network-only'
                            });
                        fetchFn({
                            commentId: commentId,
                            contentId: contentId
                        }).then((comment)=>{
                            if (comment) {
                                addCommentInCache({
                                    newComment: comment,
                                    onError: failCommentsPubSubExperience
                                });
                                succeedCommentsPubSubExperience();
                            } else failCommentsPubSubExperience(new Error(`commentCreated: comment ${commentId} not found after retries`));
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                    } else failCommentsPubSubExperience(new Error('commentCreated: addCommentInCache or commentId is not defined'));
                    if (updateUnreadCommentIDSet && accountId !== userId) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                    break;
                case 'commentResolved':
                case 'avi:confluence:resolved:comment':
                    if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    }).then(()=>{
                        clearReplyIfRemoved?.({
                            commentId: commentId
                        });
                        // Handle unread comments after fetchCommentById completes
                        const { replies: replies = [] } = commentRequestBody;
                        if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                            commentId,
                            ...replies
                        ]), 'remove');
                    }).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentResolved: commentId is not defined'));
                    // Only commentActionType and commentId are used; the rest of the variables here are defaults
                    if (updateRemovedCommentIdsMap && commentId) updateRemovedCommentIdsMap({
                        threadKey: commentId,
                        commentId: commentId,
                        commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                        isReply: false,
                        commentType: (0, $kgNLQ.CommentType).GENERAL
                    });
                    break;
                case 'commentDeleted':
                case 'avi:confluence:deleted:comment':
                    if (deleteCommentInCache && commentId) {
                        const deletionSuccessful = deleteCommentInCache({
                            commentId: commentId,
                            onError: failCommentsPubSubExperience
                        });
                        if (deletionSuccessful) clearReplyIfRemoved?.({
                            commentId: commentId
                        });
                    }
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'remove');
                    // Only commentActionType and commentId are used; the rest of the variables here are defaults
                    if (updateRemovedCommentIdsMap && commentId) updateRemovedCommentIdsMap({
                        threadKey: commentId,
                        commentId: commentId,
                        commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                        isReply: false,
                        commentType: (0, $kgNLQ.CommentType).GENERAL
                    });
                    succeedCommentsPubSubExperience();
                    break;
                case 'commentReopened':
                case 'avi:confluence:reopen:comment':
                    if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    }).then((commentData)=>{
                        // Handle unread comments with the fetched comment data
                        if (updateUnreadCommentIDSet && commentData && userId && getViewedCommentsCacheOnly) {
                            const viewedCommentsResult = getViewedCommentsCacheOnly();
                            if (viewedCommentsResult.success && viewedCommentsResult.data) $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment({
                                comment: commentData,
                                userId: userId,
                                viewedComments: viewedCommentsResult.data,
                                updateUnreadCommentIDSet: updateUnreadCommentIDSet
                            });
                        }
                    }).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentReopened: commentId is not defined'));
                    // Remove from commentThreadsRemovedByOtherUsers when reopened
                    if (commentId && reopenParentComment) reopenParentComment({
                        threadKey: commentId,
                        commentType: (0, $kgNLQ.CommentType).GENERAL,
                        parentCommentId: commentId
                    });
                    break;
                case 'commentUpdated':
                case 'avi:confluence:updated:comment':
                    if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    }).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentUpdated: commentId is not defined'));
                    break;
                default:
                    failCommentsPubSubExperience(new Error(`Unhandled comments pubsub event: ${event}`));
                    break;
            }
        } catch (error) {
            failCommentsPubSubExperience(error);
            throw error;
        }
    };
const $ced40be9017d58cb$export$c542af303309df99 = ({ contentId: contentId, contentType: contentType, userId: userId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, queryArgs: { isReactionsEnabled: isReactionsEnabled }, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, updateCommentBody: updateCommentBody, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, getCurrentCommentsPanelState: getCurrentCommentsPanelState, addSubscriber: addSubscriber, setContentType: setContentType, setContentId: setContentId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, clearReplyIfRemoved: clearReplyIfRemoved })=>{
    const pubSubResourceType = contentType || 'page';
    const subscriberIds = [];
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!addSubscriber || !setContentType || !setContentId) return;
        setContentType(pubSubResourceType);
        setContentId(contentId);
        const subscribers = [
            {
                subscriberId: 'pageCommentsPubSubCommentCreated',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    addNewCommentThreads: addNewCommentThreads,
                    addReplyToCommentThread: addReplyToCommentThread,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    addCommentInCache: addCommentInCache
                }),
                delta: 'commentCreated'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentResolved',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    clearReplyIfRemoved: clearReplyIfRemoved
                }),
                delta: 'commentResolved'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentDeleted',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    removeComment: removeComment,
                    updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                    getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    deleteCommentInCache: deleteCommentInCache,
                    clearReplyIfRemoved: clearReplyIfRemoved
                }),
                delta: 'commentDeleted'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentReopened',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    addNewCommentThreads: addNewCommentThreads,
                    reopenParentComment: reopenParentComment,
                    getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                    getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet
                }),
                delta: 'commentReopened'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentUpdated',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    updateQueryVariables: {
                        contentId: contentId,
                        isReactionsEnabled: isReactionsEnabled
                    },
                    updateCommentBody: updateCommentBody
                }),
                delta: 'commentUpdated'
            }
        ];
        for (const subscriber of subscribers)subscriberIds.push({
            subscriberId: addSubscriber(subscriber),
            delta: subscriber.delta
        });
        return subscriberIds;
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.joinChannel(pubSubResourceType, contentId).finally(()=>{
            client.subscribe((0, $7S9uM.eventToAvi)('created:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                addNewCommentThreads: addNewCommentThreads,
                addReplyToCommentThread: addReplyToCommentThread,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                addCommentInCache: addCommentInCache
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('resolved:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('deleted:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                removeComment: removeComment,
                updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                deleteCommentInCache: deleteCommentInCache
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('reopen:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                addNewCommentThreads: addNewCommentThreads,
                reopenParentComment: reopenParentComment,
                getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('updated:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                updateQueryVariables: {
                    contentId: contentId,
                    isReactionsEnabled: isReactionsEnabled
                },
                updateCommentBody: updateCommentBody
            }));
        }).catch((error)=>{
            throw new Error(`Unable to joinChannel ${JSON.stringify(error)}`);
        });
    });
};
const $ced40be9017d58cb$export$f6e2e9a186163b28 = ({ contentId: contentId, contentType: contentType, userId: userId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, queryArgs: { isReactionsEnabled: isReactionsEnabled }, removeSubscriber: removeSubscriber, subscriptions: subscriptions, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly })=>{
    const pubSubResourceType = contentType || 'page';
    const eventsToUnsubscribe = [
        'commentCreated',
        'commentDeleted',
        'commentUpdated'
    ];
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!removeSubscriber || !subscriptions?.length) return;
        for (const subscriber of subscriptions)if (eventsToUnsubscribe.includes(subscriber.delta)) removeSubscriber(subscriber);
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.leaveChannel(pubSubResourceType, contentId);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            reloader: reloader,
            addNewComment: addNewComment,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
        client.unsubscribe((0, $7S9uM.eventToAvi)('deleted:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            reloader: reloader,
            removeComment: removeComment,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
        client.unsubscribe((0, $7S9uM.eventToAvi)('updated:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            updateQueryVariables: {
                contentId: contentId,
                isReactionsEnabled: isReactionsEnabled
            },
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
    });
};
module.exports["setUpPageCommentsPubSub"] = $ced40be9017d58cb$export$c542af303309df99;
module.exports["removePageCommentsPubSub"] = $ced40be9017d58cb$export$f6e2e9a186163b28;

});

parcelRegister("hfNnW", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $3ZKFP = parcelRequire("3ZKFP");

const $8c6826fc16df1cbc$export$e314db58fea1ec32 = ({ accountId: accountId = null, currentUserId: currentUserId = null, originTabId: originTabId = null, isReply: isReply = false, isOwnReplyPubSubProcessingEnabled: isOwnReplyPubSubProcessingEnabled = false })=>{
    if ((0, $6mKj3.expVal)('cc_use_browser_tab_id', 'isEnabled', false)) return originTabId === (0, $3ZKFP.getBrowserTabId)();
    if (!accountId || accountId !== currentUserId) return false;
    // Agents comment through public APIs, so their events reach the frontend as current-user
    // events; processing own replies is the workaround for that until the originating tab is used.
    if (!isReply) return true;
    return !isOwnReplyPubSubProcessingEnabled;
};
module.exports["shouldSkipOwnPubSubEvent"] = $8c6826fc16df1cbc$export$e314db58fea1ec32;

});

parcelRegister("b11gn", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

var $c84c3a6392bd7f68$export$4dc7cc9100b67c07 = /*#__PURE__*/ function(CommentsPubSubSource) {
    CommentsPubSubSource["EditorInlineCommentsPubSub"] = "editorInlineCommentsPubSub";
    CommentsPubSubSource["RendererInlineCommentsPubSub"] = "rendererInlineCommentsPubSub";
    CommentsPubSubSource["PageCommentsPubSub"] = "pageCommentsPubSub";
    return CommentsPubSubSource;
}({});
const $c84c3a6392bd7f68$export$c83a826d1956bd57 = (source)=>{
    // Unique per event invocation; lets us detect concurrent-event collisions
    // by matching initialTrackingId === terminalTrackingId in logs.
    let trackingId;
    return {
        start: (event)=>{
            // IMPORTANT - because this is in a factory method, it is deliberate that mixing
            // & matching starts / failures / successes across invocations will lead to different trackingIDs.
            // If you need to refactor this to be cross-file, or cross-function for a valid case,
            // you'll probably need to lift this out of the factory
            trackingId = crypto.randomUUID();
            (0, $fGzMp.getExperienceTracker)().start({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                // 15s — above the AGG client's ~10s network timeout.
                timeout: 15000,
                attributes: {
                    event: event,
                    source: source,
                    initialTrackingId: trackingId
                }
            });
        },
        succeed: ()=>{
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                attributes: {
                    terminalTrackingId: trackingId
                }
            });
        },
        fail: (err)=>{
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                error: err instanceof Error ? err : new Error(String(err)),
                attributes: {
                    terminalTrackingId: trackingId
                }
            });
        }
    };
};
module.exports["CommentsPubSubSource"] = $c84c3a6392bd7f68$export$4dc7cc9100b67c07;
module.exports["createCommentsPubSubExperienceTracker"] = $c84c3a6392bd7f68$export$c83a826d1956bd57;

});

parcelRegister("aM1he", function(module, exports) {

var $kQekh = parcelRequire("kQekh");


var $c0rhi = parcelRequire("c0rhi");

const $406672c94379d4ab$export$5a1cd239009d83a6 = async (commentId, { contentId: contentId, isReactionsEnabled: isReactionsEnabled })=>{
    const query = isReactionsEnabled ? (0, $kQekh.CommentsSectionGetSingleCommentQuery) : (0, $kQekh.CommentsSectionGetSingleCommentWithoutReactionsQuery);
    const variables = isReactionsEnabled ? {
        commentId: commentId,
        contentId: contentId
    } : {
        commentId: commentId
    };
    // Query the single comment to update the cache
    (0, $c0rhi.queryInterop)({
        query: query,
        variables: variables,
        __callerPackage__: "comments-pubsub"
    });
};
const $406672c94379d4ab$export$af4b8274c1b86043 = (reloader, addNewComment, commentData, currentUserId)=>reloader().then(()=>{
        setTimeout(()=>{
            // HACK: Give the comments section time to render the new comment
            commentData.forEach((data)=>{
                addNewComment({
                    newCommentId: data.commentId,
                    currentUserMadeComment: data.accountId === currentUserId
                });
            });
        }, 3000);
    }).catch((err)=>{
        throw err;
    });
module.exports["reloadAndAddPageComments"] = $406672c94379d4ab$export$af4b8274c1b86043;

});

parcelRegister("kQekh", function(module, exports) {

var $k5aG8 = parcelRequire("k5aG8");


var $f9FCO = parcelRequire("f9FCO");

const $90ffe60e2eae60ca$export$bf87400a8da436f8 = (0, $f9FCO.default);
const $90ffe60e2eae60ca$export$caecd77287327384 = (0, $k5aG8.default);
module.exports["CommentsSectionGetSingleCommentQuery"] = $90ffe60e2eae60ca$export$bf87400a8da436f8;
module.exports["CommentsSectionGetSingleCommentWithoutReactionsQuery"] = $90ffe60e2eae60ca$export$caecd77287327384;

});

parcelRegister("k5aG8", function(module, exports) {
/**
 * @generated SignedSource<<8ed7915c440f335b6a58fb7784fdbb97>>
 * @relayHash d3bcc60b520b9e62b29ac8be494a67be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7283bb4b16c1cdbaba6a6dd79d25ca7b709cb15a18141ac1fd787bca033d468c
const $2711060718729916$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d3bcc60b520b9e62b29ac8be494a67be",
            "id": "7283bb4b16c1cdbaba6a6dd79d25ca7b709cb15a18141ac1fd787bca033d468c",
            "metadata": {},
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "operationKind": "query",
            "text": "query CommentsSectionGetSingleCommentQueryWithoutReactionsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}}}}}"
        }
    };
}();
$2711060718729916$var$node.hash = "2d393682eae4feef3986d5e4ea1bd5a6";
var $2711060718729916$export$2e2bcd8739ae039 = $2711060718729916$var$node;
module.exports["default"] = $2711060718729916$export$2e2bcd8739ae039;

});

parcelRegister("f9FCO", function(module, exports) {
/**
 * @generated SignedSource<<ba3d28415cb064032a9b12514118849b>>
 * @relayHash 1a3bffe088c5850ddf1b9c1ca4f044de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99bae9281cfcad757a48d4ce24663228d32566fabd997953e6327a8ca274f81a
const $c1f0ddf438970e3e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "contentId"
            }
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentsSectionGetSingleCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentsSectionGetSingleCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1a3bffe088c5850ddf1b9c1ca4f044de",
            "id": "99bae9281cfcad757a48d4ce24663228d32566fabd997953e6327a8ca274f81a",
            "metadata": {},
            "name": "CommentsSectionGetSingleCommentQuery",
            "operationKind": "query",
            "text": "query CommentsSectionGetSingleCommentQuery($commentId:ID!,$contentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$c1f0ddf438970e3e$var$node.hash = "326ee68c128aba1a564502e019c38ae6";
var $c1f0ddf438970e3e$export$2e2bcd8739ae039 = $c1f0ddf438970e3e$var$node;
module.exports["default"] = $c1f0ddf438970e3e$export$2e2bcd8739ae039;

});

parcelRegister("lfmjq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRa9 = parcelRequire("7aRa9");

const $0d3a7c976c53fe50$export$687b1508b29e79eb = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const moved = urlParams.get('moved');
        if (moved === 'success') {
            // Show the success flag
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d3a7c976c53fe50$var$i18n.movePageItemMovedTitle),
                isAutoDismiss: true
            });
            // Clean up URL parameters without causing a page reload
            urlParams.delete('moved');
            const newParams = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
            const newUrl = `${window.location.pathname}${newParams}${window.location.hash}`;
            window.history.replaceState({}, '', newUrl);
        }
    }, [
        flags,
        intl
    ]);
    return null;
});
const $0d3a7c976c53fe50$var$i18n = (0, $kSwu1.defineMessages)({
    movePageItemMovedTitle: {
        id: "page-tree.move-page.flag.success",
        defaultMessage: "Item moved"
    }
});
module.exports["MovePageSuccessFlag"] = $0d3a7c976c53fe50$export$687b1508b29e79eb;

});

parcelRegister("hd53J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $6mKj3 = parcelRequire("6mKj3");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $NYiei = parcelRequire("NYiei");


var $4L9ve = parcelRequire("4L9ve");

// Initiates the loading of all comment data for the specified page in the background
// This component is also responsible for processing the raw comments data and updating
// the ProcessedCommentsDataStore with categorized results using default contentStatus filters.
// Experience tracking constants
const $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE = 'comments-data-background-load';
const $52b7f7492d78c524$export$bdd232a9ca677e73 = ({ contentId: contentId })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [{ lastProcessedData: lastProcessedData }, { setProcessedData: setProcessedData, setError: setError, setRefetch: setRefetch, clearErrorAndResetIsDataProcessed: clearErrorAndResetIsDataProcessed, setDataToProcessed: setDataToProcessed, processCommentsData: processCommentsData }] = (0, $4L9ve.useProcessedCommentsData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const previousContentId = (0, $cozmU.useRef)(undefined);
    // Track refetch count to force effect to run after every refetch
    const [refetchCount, setRefetchCount] = (0, $cozmU.useState)(0);
    // Call the hook to load all comments - should only when content has settled and is ready so we
    // don't impact loading times
    // Always fetch with network-only to ensure we get fresh data
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: !contentId,
            fetchPolicy: 'network-only'
        }
    });
    // Set refetch function in store whenever it changes.
    // Wrap refetch so that when the view calls it (e.g. Retry), we clear error/processed state first.
    // Increment refetchCount in .then() to force the processing effect to run.
    // On refetch failure we always setError, then call the caller's onError if they passed one.
    (0, $cozmU.useEffect)(()=>{
        if (refetch) {
            const wrappedRefetch = ({ onError: callerOnError } = {})=>{
                clearErrorAndResetIsDataProcessed();
                return refetch({
                    onError: (err)=>{
                        setError(err instanceof Error ? err : new Error(String(err)));
                        callerOnError?.(err);
                    }
                }).then((result)=>{
                    setRefetchCount((c)=>c + 1);
                    return result;
                });
            };
            setRefetch(wrappedRefetch);
        }
    }, [
        refetch,
        setRefetch,
        clearErrorAndResetIsDataProcessed,
        setError
    ]);
    // Process and update the ProcessedCommentsDataStore when data changes or refetch completes
    // This is the ONLY place where the processed data store should be updated
    // Depends on refetchCount to ensure effect runs after every refetch
    (0, $cozmU.useEffect)(()=>{
        // Don't process data while loading
        if (loading) return;
        if (error) {
            setError(error);
            return;
        }
        // When data is undefined (e.g. refetch failed and error was set in the wrapper catch),
        // don't call setProcessedData or we'd overwrite that error with error: undefined.
        if (data === undefined) return;
        // Fast path: if data reference is same as last processed (cached data from refetch),
        // just flip isDataProcessed to true without reprocessing
        if (data === lastProcessedData) {
            setDataToProcessed();
            return;
        }
        const stats = processCommentsData({
            data: data,
            pageMode: pageMode
        });
        if (previousContentId.current !== contentId && (0, $6mKj3.expValEquals)('confluence_fe_emit_comments_data_stats_event', 'isEnabled', true)) {
            previousContentId.current = contentId;
            if (stats) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'loaded',
                    actionSubject: 'comments',
                    actionSubjectId: 'CommentsDataBackgroundLoader',
                    objectType: 'page',
                    objectId: contentId,
                    source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                    attributes: {
                        pageMode: pageMode,
                        isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                        ...stats
                    }
                }
            }).fire();
        }
    }, [
        data,
        loading,
        error,
        pageMode,
        setProcessedData,
        setError,
        contentId,
        previousContentId,
        refetchCount,
        lastProcessedData,
        setDataToProcessed,
        processCommentsData,
        createAnalyticsEvent
    ]);
    // Experience tracking: Handle success/failure when loading completes
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        // Only track completion if we're not still loading
        if (!loading) {
            if (error) // Experience failed due to error
            experienceTracker.fail({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
                error: error
            });
            else // Experience succeeded - comments data loaded successfully
            experienceTracker.succeed({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE
            });
        }
    }, [
        loading,
        error,
        contentId,
        experienceTracker
    ]);
    // This component only triggers the hook, doesn't render anything other than the ExperienceStart,
    // which handles being rendered multiple times with the same props gracefully
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
        attributes: {
            contentId: contentId
        }
    });
};
module.exports["CommentsDataBackgroundLoader"] = $52b7f7492d78c524$export$bdd232a9ca677e73;

});

parcelRegister("jXhAV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d2180b659da4cd23$export$cace184d1f5b9f1 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "QfGBR",
    name: "QuickReload",
    loader: async ()=>{
        const { QuickReload: QuickReload } = await (parcelRequire("gPa4d"));
        return QuickReload;
    }
});
module.exports["QuickReload"] = $d2180b659da4cd23$export$cace184d1f5b9f1;

});

parcelRegister("gPa4d", function(module, exports) {

let $c3f937dac49ddcb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c3f937dac49ddcb1$var$load("5vReS"),
    $c3f937dac49ddcb1$var$load("g81ly"),
    $c3f937dac49ddcb1$var$load("e3LAK"),
    $c3f937dac49ddcb1$var$load("6wr18"),
    $c3f937dac49ddcb1$var$load("bAgKB"),
    $c3f937dac49ddcb1$var$load("ifgY7"),
    $c3f937dac49ddcb1$var$load("fM5g3"),
    $c3f937dac49ddcb1$var$load("excC5"),
    $c3f937dac49ddcb1$var$load("ffEVr"),
    $c3f937dac49ddcb1$var$load("7XFs3")
]).then(()=>parcelRequire('1EPbu'));

});

parcelRegister("83sfO", function(module, exports) {
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';
module.exports["LIVE_PAGE_SUBTYPE"] = $567f280605647fdf$export$5d4c19aec4201e9;

});

parcelRegister("fSC8h", function(module, exports) {
var $aa49ff5a5783772f$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["POLLING_ONLY"] = 0] = "POLLING_ONLY";
    PubSubState[PubSubState["PUBSUB_ONLY"] = 1] = "PUBSUB_ONLY";
    PubSubState[PubSubState["ACTIVE"] = 2] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 3] = "TERMINATED";
    return PubSubState;
}({});
const $aa49ff5a5783772f$export$5a33be95ac52bdad = 2000;
var $aa49ff5a5783772f$export$8f29965b50c50222 = /*#__PURE__*/ function(PubSubFlagType) {
    PubSubFlagType[PubSubFlagType["COMMENT"] = 0] = "COMMENT";
    PubSubFlagType[PubSubFlagType["EDIT"] = 1] = "EDIT";
    return PubSubFlagType;
}({});
var $aa49ff5a5783772f$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode[PageMode["EDITOR"] = 0] = "EDITOR";
    PageMode[PageMode["LIVE"] = 1] = "LIVE";
    PageMode[PageMode["RENDERER"] = 2] = "RENDERER";
    return PageMode;
}({});
module.exports["PubSubState"] = $aa49ff5a5783772f$export$c51d39001809fe3e;
module.exports["INACTIVE_TAB_WAIT_INTERVAL"] = $aa49ff5a5783772f$export$5a33be95ac52bdad;
module.exports["PubSubFlagType"] = $aa49ff5a5783772f$export$8f29965b50c50222;
module.exports["PageMode"] = $aa49ff5a5783772f$export$6ea4b0c62affbe44;

});

parcelRegister("2xS8W", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $w6R6I = parcelRequire("w6R6I");


var $1d2ww = parcelRequire("1d2ww");


var $3mVfX = parcelRequire("3mVfX");


var $aHcFH = parcelRequire("aHcFH");


var $6mKj3 = parcelRequire("6mKj3");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $fNzRA = parcelRequire("fNzRA");


var $ep3mz = parcelRequire("ep3mz");


var $jAfH5 = parcelRequire("jAfH5");


var $aOKRX = parcelRequire("aOKRX");


var $niTts = parcelRequire("niTts");


var $l1B53 = parcelRequire("l1B53");


var $dL5YQ = parcelRequire("dL5YQ");

const $e3138de675756a06$var$styles = {
    stickyDraftViewPageWrapper: "_1mT5xdHE3j _42Yu6B7dHp",
    stickyDraftLivePageWrapper: "_1mT5xdy1CL _42Yu6BN779",
    hiddenStyles: "_3iDTPbYbGa",
    visibleStyles: "_3iDTPbQ4SZ",
    commonStyle: "_0hPCNLDIqT _37wbyuDIqT _0Bm75GPgdg _0KLXrulfZc",
    childWrapperStyle: "_4FKVYE5zaO _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _3vBAKH9r67 _22sfPnNvrM _2IVJ4M6wH8",
    zIndexStyle: "_42Yu6Bbhqd _3OE6xYPgdg _39xV02N91d"
};
const $e3138de675756a06$export$d2696a038fec0750 = (t0)=>{
    const $ = (0, $bDgLe.c)(54);
    const { pageWidthType: pageWidthType } = t0;
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { expandCommentContainer: expandCommentContainer, setWrapperWidth: setWrapperWidth, setIsObjectCommentWrapperVisible: setIsObjectCommentWrapperVisible, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [objectCommentWrapperDimensions, setObjectCommentWrapperDimensions] = (0, $cozmU.useState)(null);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isViewPage = pageMode === (0, $cD1qu.PageMode).VIEW;
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = (0, $aOKRX.usePageContentDimensions)();
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    let t1;
    let t2;
    if ($[0] !== expandCommentContainer || $[1] !== expanded || $[2] !== isObjectCommentWrapperVisible || $[3] !== setFooterEditorEntry) {
        t1 = ()=>{
            if (isObjectCommentWrapperVisible && expanded) {
                expandCommentContainer();
                setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).FOOTER);
            }
        };
        t2 = [
            isObjectCommentWrapperVisible,
            expandCommentContainer,
            expanded,
            setFooterEditorEntry
        ];
        $[0] = expandCommentContainer;
        $[1] = expanded;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = setFooterEditorEntry;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[6] !== isViewPage || $[7] !== setIsObjectCommentWrapperVisible || $[8] !== setWrapperWidth) {
        t3 = ()=>{
            let intersectionObserver = null;
            let resizeObserver = null;
            const calculateObjectCommentWrapperWidth = ()=>{
                const objectCommentWrapper = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (objectCommentWrapper) {
                    const rect = objectCommentWrapper.getBoundingClientRect();
                    setObjectCommentWrapperDimensions({
                        width: rect.width
                    });
                    setWrapperWidth(rect.width);
                }
            };
            const setupObservers = ()=>{
                const commentWrapper = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (!commentWrapper) {
                    setIsObjectCommentWrapperVisible(false);
                    return;
                }
                if (!intersectionObserver) {
                    intersectionObserver = new IntersectionObserver((t4)=>{
                        const [entry] = t4;
                        setIsObjectCommentWrapperVisible(entry.isIntersecting);
                    }, {
                        rootMargin: "0px"
                    });
                    intersectionObserver.observe(commentWrapper);
                }
                if (!resizeObserver) {
                    resizeObserver = new ResizeObserver(()=>{
                        calculateObjectCommentWrapperWidth();
                    });
                    resizeObserver.observe(commentWrapper);
                }
                calculateObjectCommentWrapperWidth();
            };
            setupObservers();
            const mutationObserver = new MutationObserver(()=>{
                const commentWrapper_0 = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (commentWrapper_0 && (!intersectionObserver || !isViewPage && !resizeObserver)) setupObservers();
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
            return ()=>{
                if (intersectionObserver) intersectionObserver.disconnect();
                if (resizeObserver) resizeObserver.disconnect();
                mutationObserver.disconnect();
            };
        };
        $[6] = isViewPage;
        $[7] = setIsObjectCommentWrapperVisible;
        $[8] = setWrapperWidth;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== contentId || $[11] !== isViewPage || $[12] !== setIsObjectCommentWrapperVisible || $[13] !== setWrapperWidth) {
        t4 = [
            isViewPage,
            setWrapperWidth,
            setIsObjectCommentWrapperVisible,
            contentId
        ];
        $[10] = contentId;
        $[11] = isViewPage;
        $[12] = setIsObjectCommentWrapperVisible;
        $[13] = setWrapperWidth;
        $[14] = t4;
    } else t4 = $[14];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[15] !== pageContentLeft || $[16] !== pageContentRight || $[17] !== pageContentWidth) {
        t5 = {
            width: pageContentWidth,
            left: pageContentLeft,
            right: pageContentRight
        };
        $[15] = pageContentLeft;
        $[16] = pageContentRight;
        $[17] = pageContentWidth;
        $[18] = t5;
    } else t5 = $[18];
    const pageContentDimensions = t5;
    let t6;
    if ($[19] !== pageWidthType) {
        t6 = ()=>{
            if (pageWidthType === undefined) return "100%";
            return JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? "1000px" : "unset";
        };
        $[19] = pageWidthType;
        $[20] = t6;
    } else t6 = $[20];
    const getMaxWidth = t6;
    let t7;
    if ($[21] !== getMaxWidth || $[22] !== hasRecs || $[23] !== isViewPage || $[24] !== objectCommentWrapperDimensions || $[25] !== pageMode || $[26] !== pageWidthType) {
        t7 = ()=>{
            if (isViewPage && (0, $6mKj3.expValEquals)("confluence_unify_footer_comments_space_width", "isEnabled", true)) {
                const computedWidths = (0, $aHcFH.getWidthAndMaxWidth)({
                    pageMode: pageMode,
                    pageWidthType: pageWidthType,
                    hasEndOfPageRecommendations: hasRecs ?? false
                });
                return {
                    width: computedWidths.width,
                    maxWidth: computedWidths.maxWidth
                };
            }
            return {
                maxWidth: isViewPage ? getMaxWidth() : "100%",
                width: !isViewPage && objectCommentWrapperDimensions ? `${objectCommentWrapperDimensions.width}px` : "100%"
            };
        };
        $[21] = getMaxWidth;
        $[22] = hasRecs;
        $[23] = isViewPage;
        $[24] = objectCommentWrapperDimensions;
        $[25] = pageMode;
        $[26] = pageWidthType;
        $[27] = t7;
    } else t7 = $[27];
    const getStyle = t7;
    const showStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT;
    let t8;
    if ($[28] !== expandCommentContainer || $[29] !== setFooterEditorEntry) {
        t8 = ()=>{
            expandCommentContainer();
            setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT);
        };
        $[28] = expandCommentContainer;
        $[29] = setFooterEditorEntry;
        $[30] = t8;
    } else t8 = $[30];
    const expandEditorHandler = t8;
    if (!showStickyDraft) return;
    const t9 = isViewPage ? $e3138de675756a06$var$styles.stickyDraftViewPageWrapper : $e3138de675756a06$var$styles.stickyDraftLivePageWrapper;
    const t10 = showStickyDraft ? $e3138de675756a06$var$styles.visibleStyles : $e3138de675756a06$var$styles.hiddenStyles;
    const t11 = !isViewPage && $e3138de675756a06$var$styles.zIndexStyle;
    let t12;
    if ($[31] !== t10 || $[32] !== t11 || $[33] !== t9) {
        t12 = (0, $w6R6I.cx)(t9, t10, $e3138de675756a06$var$styles.commonStyle, t11);
        $[31] = t10;
        $[32] = t11;
        $[33] = t9;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== pageContentDimensions || $[36] !== pageMode) {
        t13 = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $niTts.hideWhiteSpace)({
            shouldRenderFixedStyle: true,
            pageContentDimensions: pageContentDimensions
        }) : undefined;
        $[35] = pageContentDimensions;
        $[36] = pageMode;
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== getStyle) {
        t14 = getStyle();
        $[38] = getStyle;
        $[39] = t14;
    } else t14 = $[39];
    const t15 = !showStickyDraft ? $e3138de675756a06$var$styles.hiddenStyles : $e3138de675756a06$var$styles.visibleStyles;
    let t16;
    if ($[40] !== t15) {
        t16 = (0, $w6R6I.cx)(t15);
        $[40] = t15;
        $[41] = t16;
    } else t16 = $[41];
    let t17;
    if ($[42] !== expandEditorHandler) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1B53.DraftCommentBox), {
            expandPageCommentEditorHandler: expandEditorHandler
        });
        $[42] = expandEditorHandler;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== t16 || $[45] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dL5YQ.ObjectAddCommentProfileWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t16
        }, t17)));
        $[44] = t16;
        $[45] = t17;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== t14 || $[48] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e3138de675756a06$var$styles.childWrapperStyle,
            style: t14
        }, t18);
        $[47] = t14;
        $[48] = t18;
        $[49] = t19;
    } else t19 = $[49];
    let t20;
    if ($[50] !== t12 || $[51] !== t13 || $[52] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t12,
            testId: "sticky-draft-comment-box",
            id: "addCommentButton-draft",
            style: t13
        }, t19);
        $[50] = t12;
        $[51] = t13;
        $[52] = t19;
        $[53] = t20;
    } else t20 = $[53];
    return t20;
};
module.exports["StickyDraftCommentContainer"] = $e3138de675756a06$export$d2696a038fec0750;

});

parcelRegister("jAfH5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");


var $2HQyh = parcelRequire("2HQyh");


var $8dbvt = parcelRequire("8dbvt");


var $jc6xl = parcelRequire("jc6xl");

const $7e53ce3ad8fd4fef$export$1d93f080b8c40251 = (skip = false)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    // Which arm this user is on. Inlined at each callsite (not stored in a variable)
    // per the feature-gating lint rule so it stays statically analyzable. NO-EXPOSURE
    // reader: this hook runs on view-page load for layout (`hasRecs`), so exposure is
    // logged at the loader instead — the reader is deterministic and fires none, so
    // evaluating it twice is safe.
    // TWG source (skipped in control). Same query/variables as the rendering
    // container, so it dedupes and `hasRecs` matches what's rendered. Passes the real
    // content type so blog posts build a `blogpost/` ARI (not a wrong `page/` one).
    const twg = (0, $jc6xl.useTwgRecommendationData)({
        entityId: contentId ?? '',
        entityType: contentType ?? 'page',
        spaceKey: spaceKey ?? '',
        skip: skip || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_eop_recs_twg_source_exp', 'isEnabled', true)
    });
    // cc-smarts (control) source. Skipped in the treatment arm.
    const smartsSkip = skip || (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_eop_recs_twg_source_exp', 'isEnabled', true);
    const baseOptions = {
        variables: {
            type: 'page',
            id: contentId ?? '',
            exp: 'end_of_page_v5',
            key: spaceKey ?? '',
            keyString: spaceKey ?? ''
        },
        context: {
            single: true
        },
        errorPolicy: 'all',
        skip: smartsSkip
    };
    const { error: smartsError, loading: smartsLoading, data: smartsData } = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $2HQyh.default), {
        ...baseOptions,
        __callerPackage__: "page-recommendations"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $2HQyh.default), {
        ...baseOptions,
        __callerPackage__: "page-recommendations"
    });
    const smartsPageCardData = (0, $cozmU.useMemo)(()=>(0, $8dbvt.transformAndOrderRecs)(smartsData?.getRecommendedPages?.recommendedPages), [
        smartsData
    ]);
    if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_eop_recs_twg_source_exp', 'isEnabled', true)) {
        if (twg.error || skip) return {
            loading: false,
            error: twg.error,
            data: undefined,
            hasRecs: false
        };
        // Gate on `isEnabled`: TWG returns related content regardless of the space/user
        // enablement toggle, but the widget only renders when enabled. Without this, the
        // layout would reserve space for a recs widget that never appears.
        return {
            loading: twg.loading,
            error: undefined,
            data: twg.isEnabled ? twg.pageCardData : undefined,
            // `> 2` intentionally matches the cc-smarts control arm exactly so both arms
            // report `hasRecs` identically — keeps the experiment free of layout-driven
            // confounds. (Pre-existing quirk: the grid renders at >= 2 cards.)
            hasRecs: twg.isEnabled && twg.pageCardData.length > 2
        };
    }
    if (smartsError || skip) return {
        loading: false,
        error: smartsError,
        data: undefined,
        hasRecs: false
    };
    return {
        loading: smartsLoading,
        error: smartsError,
        data: smartsPageCardData,
        hasRecs: smartsPageCardData && smartsPageCardData.length > 2
    };
};
module.exports["usePageRecommendationData"] = $7e53ce3ad8fd4fef$export$1d93f080b8c40251;

});

parcelRegister("aOKRX", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k7Uqa = parcelRequire("k7Uqa");

const $b6b1455842ddb08b$export$d0606705f36ae70a = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [dimensions, setDimensions] = (0, $cozmU.useState)((0, $k7Uqa.EMPTY_PAGE_CONTENT_RECT));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            const publish = (rect)=>setDimensions((current)=>(0, $k7Uqa.isSamePageContentRect)(current, rect) ? current : rect);
            publish((0, $k7Uqa.getPageContentRect)());
            return (0, $k7Uqa.subscribeToPageContentRect)(publish);
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return dimensions;
};
module.exports["usePageContentDimensions"] = $b6b1455842ddb08b$export$d0606705f36ae70a;

});

parcelRegister("niTts", function(module, exports) {
const $829c98791d74b4c3$export$a9fce9e535ae2163 = ({ shouldRenderFixedStyle: shouldRenderFixedStyle, pageContentDimensions: pageContentDimensions, fallbackWidth: fallbackWidth = '100%' })=>{
    if (!shouldRenderFixedStyle) return {
        width: fallbackWidth
    };
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = pageContentDimensions;
    // Handle case where dimensions might be undefined or width might be a string
    const width = typeof pageContentWidth === 'number' ? pageContentWidth : 0;
    const left = pageContentLeft ?? 0;
    const right = pageContentRight ?? 0;
    return {
        left: left > 0 ? `${left}px` : '0px',
        right: right > 0 ? `${window.innerWidth - right}px` : '0px',
        width: width > 0 ? `${width}px` : '100%'
    };
};
module.exports["hideWhiteSpace"] = $829c98791d74b4c3$export$a9fce9e535ae2163;

});

parcelRegister("l1B53", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hBYtq = parcelRequire("hBYtq");

const $656c656df397599d$var$styles = {
    draftComment: "_0bjKvDKxmn _4FKVYE2ADO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d _0jFU0VnlTt _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _1UtDYzKGUX _0KLXru7Cj1"
};
const $656c656df397599d$var$i18n = (0, $kSwu1.defineMessages)({
    unsavedDraftComment: {
        id: "object-comments.draft-comment-box.text",
        defaultMessage: "Comment in progress - select to continue"
    }
});
const $656c656df397599d$export$82fe65228be9eec = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { testId: t1, expandPageCommentEditorHandler: expandPageCommentEditorHandler } = t0;
    const testId = t1 === undefined ? "draft-comment-box" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage($656c656df397599d$var$i18n.unsavedDraftComment);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== expandPageCommentEditorHandler || $[3] !== t2 || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $656c656df397599d$var$styles.draftComment,
            testId: testId,
            onClick: expandPageCommentEditorHandler
        }, t2);
        $[2] = expandPageCommentEditorHandler;
        $[3] = t2;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["DraftCommentBox"] = $656c656df397599d$export$82fe65228be9eec;

});

parcelRegister("dL5YQ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $8lS8J = parcelRequire("8lS8J");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $fs6LW = parcelRequire("fs6LW");


var $bQm3c = parcelRequire("bQm3c");


var $e4o8D = parcelRequire("e4o8D");

const $f361dd7d6e4d9bdd$var$ObjectAddCommentProfileWrapperUserQuery = (0, $8lS8J.default);
const $f361dd7d6e4d9bdd$var$styles = {
    addCommentWrapperStyles: "_39xV02N91d",
    addCommentWrapperWithBannerStyles: "_3iDTPbgBM8 _2iEGP2tJLP _17lj8p5zaO _39xV02N91d",
    addCommentOpenContainerStyles: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _0hPCNLchRC",
    addCommentOpenContainerWithBannerStyles: "_3iDTPbcK7c",
    addCommentEditorStyles: "_2j3gqAiZR3 _3B2K2QiZR3 _39xV02N91d _4ouGXIdnbC",
    bannerStyles: "_2j3gqAiZR3 _3B2K2Q7dHp _4ouGXIdnbC",
    avatarStyles: "_2j3gqA7dHp _3B2K2QiZR3 _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC"
};
const $f361dd7d6e4d9bdd$var$avatarFloatStyle = {
    float: 'left'
};
const $f361dd7d6e4d9bdd$export$5a360c1cb6170ba8 = (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { children: children, banner: banner } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const t1 = userId || "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            id: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = !userId;
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
        t4 = {
            variables: t2,
            fetchPolicy: (0, $9wGTI.fg)("confluence-comments-fix-avatar-flash") ? "cache-first" : "cache-and-network",
            skip: t3
        };
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const { data: userData, loading: loading } = (0, $jMyy4.useQueryInterop)($f361dd7d6e4d9bdd$var$ObjectAddCommentProfileWrapperUserQuery, {
        ...t4,
        __callerPackage__: "object-comments"
    });
    const t5 = userData?.user?.photos?.[0]?.value || "";
    const t6 = userData?.user?.displayName || "";
    let t7;
    if ($[5] !== t5 || $[6] !== t6 || $[7] !== userId) {
        t7 = {
            avatarUrl: t5,
            accountId: userId,
            displayName: t6
        };
        $[5] = t5;
        $[6] = t6;
        $[7] = userId;
        $[8] = t7;
    } else t7 = $[8];
    const userInfo = t7;
    const t8 = banner ? $f361dd7d6e4d9bdd$var$styles.addCommentWrapperWithBannerStyles : $f361dd7d6e4d9bdd$var$styles.addCommentWrapperStyles;
    let t9;
    if ($[9] !== banner) {
        t9 = banner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f361dd7d6e4d9bdd$var$styles.bannerStyles
        }, banner) : null;
        $[9] = banner;
        $[10] = t9;
    } else t9 = $[10];
    const t10 = banner ? $f361dd7d6e4d9bdd$var$styles.addCommentOpenContainerWithBannerStyles : $f361dd7d6e4d9bdd$var$styles.addCommentOpenContainerStyles;
    let t11;
    if ($[11] !== loading || $[12] !== renderServerPlaceholder || $[13] !== userInfo) {
        t11 = loading || renderServerPlaceholder ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
            canViewProfile: true,
            src: userInfo.avatarUrl,
            userId: userInfo.accountId,
            isAnonymous: !userInfo.accountId,
            name: userInfo.displayName,
            testId: "profile-avatar-comment"
        });
        $[11] = loading;
        $[12] = renderServerPlaceholder;
        $[13] = userInfo;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f361dd7d6e4d9bdd$var$styles.avatarStyles,
            style: $f361dd7d6e4d9bdd$var$avatarFloatStyle
        }, t11);
        $[15] = t11;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== children) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f361dd7d6e4d9bdd$var$styles.addCommentEditorStyles
        }, children);
        $[17] = children;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== t10 || $[20] !== t12 || $[21] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t10
        }, t12, t13);
        $[19] = t10;
        $[20] = t12;
        $[21] = t13;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== t14 || $[24] !== t8 || $[25] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t8
        }, t9, t14);
        $[23] = t14;
        $[24] = t8;
        $[25] = t9;
        $[26] = t15;
    } else t15 = $[26];
    return t15;
};
module.exports["ObjectAddCommentProfileWrapper"] = $f361dd7d6e4d9bdd$export$5a360c1cb6170ba8;

});

parcelRegister("8lS8J", function(module, exports) {
/**
 * @generated SignedSource<<41cbeaa06d5991b406f8cd5c92a2f482>>
 * @relayHash 0725da37403499b17b096784b15edae6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1
const $a4f88c0b86e6c5fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0725da37403499b17b096784b15edae6",
            "id": "a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1",
            "metadata": {},
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "operationKind": "query",
            "text": "query ObjectAddCommentProfileWrapperUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a4f88c0b86e6c5fb$var$node.hash = "d4c2e7d15525539be1b21ee5306d9088";
var $a4f88c0b86e6c5fb$export$2e2bcd8739ae039 = $a4f88c0b86e6c5fb$var$node;
module.exports["default"] = $a4f88c0b86e6c5fb$export$2e2bcd8739ae039;

});

parcelRegister("70pcM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3mVfX = parcelRequire("3mVfX");


var $jmjWc = parcelRequire("jmjWc");


var $8zMP3 = parcelRequire("8zMP3");


const $21986f05fdcd4f3c$var$ObjectCommentContainerLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zDMTR",
    name: "ObjectCommentContainerLoader",
    loader: async ()=>(await (parcelRequire("413Bo"))).ObjectCommentContainer
});
const $21986f05fdcd4f3c$export$5a58d81bd405c4ec = ({ pageWidthType: pageWidthType, showLabels: showLabels, hasReactions: hasReactions, editorIsUserOffline: editorIsUserOffline, hasCommentSessions: hasCommentSessions })=>{
    const { setShowGeneralComments: setShowGeneralComments } = (0, $3mVfX.useCommentsPanelActions)();
    (0, $cozmU.useEffect)(()=>{
        setShowGeneralComments(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to set the comment type once on the comment mount
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "object-comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21986f05fdcd4f3c$var$ObjectCommentContainerLoader, {
        pageWidthType: pageWidthType,
        showLabels: showLabels,
        hasReactions: hasReactions,
        editorIsUserOffline: editorIsUserOffline,
        hasCommentSessions: hasCommentSessions
    }));
};
module.exports["ObjectCommentWrapper"] = $21986f05fdcd4f3c$export$5a58d81bd405c4ec;

});

parcelRegister("413Bo", function(module, exports) {

let $2eca0cbd6c91be19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2eca0cbd6c91be19$var$load("gBfQ7"),
    $2eca0cbd6c91be19$var$load("eTvQu"),
    $2eca0cbd6c91be19$var$load("g81ly"),
    $2eca0cbd6c91be19$var$load("e3LAK"),
    $2eca0cbd6c91be19$var$load("6wr18"),
    $2eca0cbd6c91be19$var$load("dlm6q"),
    $2eca0cbd6c91be19$var$load("fxlto"),
    $2eca0cbd6c91be19$var$load("lK9vp"),
    $2eca0cbd6c91be19$var$load("dfVz8"),
    $2eca0cbd6c91be19$var$load("8Q1q0"),
    $2eca0cbd6c91be19$var$load("byAMe"),
    $2eca0cbd6c91be19$var$load("aIw3f"),
    $2eca0cbd6c91be19$var$load("Wowvf"),
    $2eca0cbd6c91be19$var$load("4W6oq"),
    $2eca0cbd6c91be19$var$load("jqoep"),
    $2eca0cbd6c91be19$var$load("7EorR"),
    $2eca0cbd6c91be19$var$load("eUsnQ"),
    $2eca0cbd6c91be19$var$load("ffEVr"),
    $2eca0cbd6c91be19$var$load("eLfJM"),
    $2eca0cbd6c91be19$var$load("ei0GF"),
    $2eca0cbd6c91be19$var$load("79Tk4"),
    $2eca0cbd6c91be19$var$load("1R82J"),
    $2eca0cbd6c91be19$var$load("9YbM1"),
    $2eca0cbd6c91be19$var$load("01KnF")
]).then(()=>parcelRequire('5CNGn'));

});

parcelRegister("5kqgA", function(module, exports) {

var $awDRb = parcelRequire("awDRb");


var $b07B9 = parcelRequire("b07B9");


var $aX2oa = parcelRequire("aX2oa");


var $5WAcP = parcelRequire("5WAcP");


var $5x3Dm = parcelRequire("5x3Dm");


var $co8T8 = parcelRequire("co8T8");


var $cozmU = parcelRequire("cozmU");


var $gsyiL = parcelRequire("gsyiL");

var $6B1vK = parcelRequire("6B1vK");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");

const $a5c37f1d79bf5cbd$export$d8614f1b6b2d1358 = ({ contentId: contentId, contentType: contentType, options: queryOptions = {} })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [createPagePropertyMutation, createPagePropertyResult] = (0, $308Wd.useMutationInterop)((0, $co8T8.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const [updatePagePropertyMutation, updatePagePropertyResult] = (0, $308Wd.useMutationInterop)((0, $5x3Dm.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const [deletePagePropertyMutation, deletePagePropertyResult] = (0, $308Wd.useMutationInterop)((0, $5WAcP.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const [createBlogPropertyMutation, createBlogPropertyResult] = (0, $308Wd.useMutationInterop)((0, $aX2oa.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const [updateBlogPropertyMutation, updateBlogPropertyResult] = (0, $308Wd.useMutationInterop)((0, $b07B9.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const [deleteBlogPropertyMutation, deleteBlogPropertyResult] = (0, $308Wd.useMutationInterop)((0, $awDRb.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const updateContentProperty = (0, $cozmU.useCallback)(({ propertyKey: propertyKey, propertyValue: propertyValueString, isDelete: isDelete = false, hasExistingProperty: hasExistingProperty = false, options: options = {}, shouldOptimisticResponse: shouldOptimisticResponse = false })=>{
        if (isDelete) {
            if (contentType === 'page') return deletePagePropertyMutation({
                variables: {
                    pageId: (0, $6B1vK.ConfluencePageAri).create({
                        siteId: cloudId,
                        pageId: contentId
                    }).toString(),
                    propertyKey: propertyKey
                },
                ...options,
                optimisticResponse: shouldOptimisticResponse ? {
                    success: true,
                    errors: []
                } : undefined
            });
            else if (contentType === 'blogpost') return deleteBlogPropertyMutation({
                variables: {
                    blogPostId: (0, $gsyiL.ConfluenceBlogpostAri).create({
                        siteId: cloudId,
                        blogpostId: contentId
                    }).toString(),
                    propertyKey: propertyKey
                },
                ...options,
                optimisticResponse: shouldOptimisticResponse ? {
                    success: true,
                    errors: []
                } : undefined
            });
        } else if (!!propertyValueString) {
            // Property value need to be stringified again before passing to graphql otherwise backend cannot parse it correctly
            const propertyValue = JSON.stringify(propertyValueString);
            if (hasExistingProperty) {
                // When there is existing property, we update it
                if (contentType === 'page') return updatePagePropertyMutation({
                    variables: {
                        pageId: (0, $6B1vK.ConfluencePageAri).create({
                            siteId: cloudId,
                            pageId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        pageProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
                else if (contentType === 'blogpost') return updateBlogPropertyMutation({
                    variables: {
                        blogPostId: (0, $gsyiL.ConfluenceBlogpostAri).create({
                            siteId: cloudId,
                            blogpostId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        blogPostProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
            } else {
                // When there is no existing property, we create it
                if (contentType === 'page') return createPagePropertyMutation({
                    variables: {
                        pageId: (0, $6B1vK.ConfluencePageAri).create({
                            siteId: cloudId,
                            pageId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        pageProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
                else if (contentType === 'blogpost') return createBlogPropertyMutation({
                    variables: {
                        blogPostId: (0, $gsyiL.ConfluenceBlogpostAri).create({
                            siteId: cloudId,
                            blogpostId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        blogPostProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
            }
        }
    }, [
        createPagePropertyMutation,
        createBlogPropertyMutation,
        updatePagePropertyMutation,
        updateBlogPropertyMutation,
        deletePagePropertyMutation,
        deleteBlogPropertyMutation,
        contentId,
        cloudId,
        contentType
    ]);
    const processUpdateContentPropertyResult = (0, $cozmU.useCallback)((result)=>{
        if (result && 'confluence' in result && result.confluence) {
            if ('createPageProperty' in result.confluence) {
                const { createPageProperty: createPageProperty } = result.confluence;
                return {
                    success: createPageProperty?.success,
                    id: createPageProperty?.pageProperty?.id,
                    key: createPageProperty?.pageProperty?.key,
                    value: createPageProperty?.pageProperty?.value,
                    errors: createPageProperty?.errors ? [
                        ...createPageProperty.errors
                    ] : undefined
                };
            }
            if ('createBlogPostProperty' in result.confluence) {
                const { createBlogPostProperty: createBlogPostProperty } = result.confluence;
                return {
                    success: createBlogPostProperty?.success,
                    id: createBlogPostProperty?.blogPostProperty?.id,
                    key: createBlogPostProperty?.blogPostProperty?.key,
                    value: createBlogPostProperty?.blogPostProperty?.value,
                    errors: createBlogPostProperty?.errors ? [
                        ...createBlogPostProperty.errors
                    ] : undefined
                };
            }
            if ('updateValuePageProperty' in result.confluence) {
                const { updateValuePageProperty: updateValuePageProperty } = result.confluence;
                return {
                    success: updateValuePageProperty?.success,
                    id: updateValuePageProperty?.pageProperty?.id,
                    key: updateValuePageProperty?.pageProperty?.key,
                    value: updateValuePageProperty?.pageProperty?.value,
                    errors: updateValuePageProperty?.errors ? [
                        ...updateValuePageProperty.errors
                    ] : undefined
                };
            }
            if ('updateValueBlogPostProperty' in result.confluence) {
                const { updateValueBlogPostProperty: updateValueBlogPostProperty } = result.confluence;
                return {
                    success: updateValueBlogPostProperty?.success,
                    id: updateValueBlogPostProperty?.blogPostProperty?.id,
                    key: updateValueBlogPostProperty?.blogPostProperty?.key,
                    value: updateValueBlogPostProperty?.blogPostProperty?.value,
                    errors: updateValueBlogPostProperty?.errors ? [
                        ...updateValueBlogPostProperty.errors
                    ] : undefined
                };
            }
            if ('deletePageProperty' in result.confluence) {
                const { deletePageProperty: deletePageProperty } = result.confluence;
                return {
                    success: deletePageProperty?.success,
                    errors: deletePageProperty?.errors ? [
                        ...deletePageProperty.errors
                    ] : undefined
                };
            }
            if ('deleteBlogPostProperty' in result.confluence) {
                const { deleteBlogPostProperty: deleteBlogPostProperty } = result.confluence;
                return {
                    success: deleteBlogPostProperty?.success,
                    errors: deleteBlogPostProperty?.errors ? [
                        ...deleteBlogPostProperty.errors
                    ] : undefined
                };
            }
        }
        return null;
    }, []);
    return {
        updateContentProperty: updateContentProperty,
        processUpdateContentPropertyResult: processUpdateContentPropertyResult,
        updateContentPropertyResult: createPagePropertyResult || updatePagePropertyResult || deletePagePropertyResult || createBlogPropertyResult || updateBlogPropertyResult || deleteBlogPropertyResult
    };
};
module.exports["useUpdateContentProperty"] = $a5c37f1d79bf5cbd$export$d8614f1b6b2d1358;

});

parcelRegister("awDRb", function(module, exports) {
/**
 * @generated SignedSource<<dfe8519267b68a4378b78429167f3c63>>
 * @relayHash 7ea43002279108ebdaf4bacd5136e32c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b94e26cf760050f97f1735eb7c08613c6631650155dfaef62fc5ff0db5b416cf
const $070558e2bb126032$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogPostId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyBlogDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeleteBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "deleteBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyBlogDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeleteBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "deleteBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7ea43002279108ebdaf4bacd5136e32c",
            "id": "b94e26cf760050f97f1735eb7c08613c6631650155dfaef62fc5ff0db5b416cf",
            "metadata": {},
            "name": "useUpdateContentPropertyBlogDeleteMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyBlogDeleteMutation($propertyKey:String!,$blogPostId:ID!){confluence{deleteBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId}){success,errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$070558e2bb126032$var$node.hash = "9c55ced69dfdca7b034578bc15733a6a";
var $070558e2bb126032$export$2e2bcd8739ae039 = $070558e2bb126032$var$node;
module.exports["default"] = $070558e2bb126032$export$2e2bcd8739ae039;

});

parcelRegister("b07B9", function(module, exports) {
/**
 * @generated SignedSource<<7575a61e168d4fd5931f7e5595e93934>>
 * @relayHash 83c667f6e4eab61cc7723fc091cb0002
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83b68e9d7eb3a6372d990fbb1ea21f606ae1cf9fdb97bb2190a609d28a9954c9
const $22e9015d273a347d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogPostId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "blogPostProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyBlogUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValueBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyBlogUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValueBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "83c667f6e4eab61cc7723fc091cb0002",
            "id": "83b68e9d7eb3a6372d990fbb1ea21f606ae1cf9fdb97bb2190a609d28a9954c9",
            "metadata": {},
            "name": "useUpdateContentPropertyBlogUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyBlogUpdateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{updateValueBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$22e9015d273a347d$var$node.hash = "580533e46ac660d594c903425683aacb";
var $22e9015d273a347d$export$2e2bcd8739ae039 = $22e9015d273a347d$var$node;
module.exports["default"] = $22e9015d273a347d$export$2e2bcd8739ae039;

});

parcelRegister("aX2oa", function(module, exports) {
/**
 * @generated SignedSource<<b3f8ab82df27637909fcdd1713b75918>>
 * @relayHash faed0d2f1dd78a502a219a9a5d9dc53b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4a419a258f4c5ca2db7e6708ac16a9abfa6d2a91dbdf3fc909766277682e0c0
const $fcc85e5ea801be9e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogPostId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "blogPostProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyBlogCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreateBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "createBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyBlogCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreateBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "createBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "faed0d2f1dd78a502a219a9a5d9dc53b",
            "id": "d4a419a258f4c5ca2db7e6708ac16a9abfa6d2a91dbdf3fc909766277682e0c0",
            "metadata": {},
            "name": "useUpdateContentPropertyBlogCreateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyBlogCreateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{createBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$fcc85e5ea801be9e$var$node.hash = "1ac5be7a6ec97ac06bb016be27c4c3a0";
var $fcc85e5ea801be9e$export$2e2bcd8739ae039 = $fcc85e5ea801be9e$var$node;
module.exports["default"] = $fcc85e5ea801be9e$export$2e2bcd8739ae039;

});

parcelRegister("5WAcP", function(module, exports) {
/**
 * @generated SignedSource<<c5551e0bc3921a0985db3a2a7e1c0d4c>>
 * @relayHash ff4d35071121f198fae1a7890dfd8302
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d7131b41a92502615d964ebb289e6095bdc12211082b0acc52ded04f767ae954
const $a12a59c8911be0e2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyPageDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeletePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "deletePageProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyPageDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeletePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "deletePageProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ff4d35071121f198fae1a7890dfd8302",
            "id": "d7131b41a92502615d964ebb289e6095bdc12211082b0acc52ded04f767ae954",
            "metadata": {},
            "name": "useUpdateContentPropertyPageDeleteMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyPageDeleteMutation($propertyKey:String!,$pageId:ID!){confluence{deletePageProperty(input:{key:$propertyKey,pageId:$pageId}){success,errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$a12a59c8911be0e2$var$node.hash = "c20456827070d144db3082bf07a8c31a";
var $a12a59c8911be0e2$export$2e2bcd8739ae039 = $a12a59c8911be0e2$var$node;
module.exports["default"] = $a12a59c8911be0e2$export$2e2bcd8739ae039;

});

parcelRegister("5x3Dm", function(module, exports) {
/**
 * @generated SignedSource<<56f4baafca333faf75f7d54926973a2c>>
 * @relayHash 3010f6b1356aae10019a1ad07e146372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 799d904d34743a2ad3869f0c1587983f184044efc037e58ca7920c9641500955
const $c8d393500a85ca00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "pageProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyPageUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValuePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValuePageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyPageUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValuePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValuePageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3010f6b1356aae10019a1ad07e146372",
            "id": "799d904d34743a2ad3869f0c1587983f184044efc037e58ca7920c9641500955",
            "metadata": {},
            "name": "useUpdateContentPropertyPageUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyPageUpdateMutation($propertyKey:String!,$pageId:ID!,$propertyValue:String!){confluence{updateValuePageProperty(input:{key:$propertyKey,pageId:$pageId,value:$propertyValue}){success,pageProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$c8d393500a85ca00$var$node.hash = "4b090e3281dd15c3d9500ac77008df26";
var $c8d393500a85ca00$export$2e2bcd8739ae039 = $c8d393500a85ca00$var$node;
module.exports["default"] = $c8d393500a85ca00$export$2e2bcd8739ae039;

});

parcelRegister("co8T8", function(module, exports) {
/**
 * @generated SignedSource<<986ee9c28f9f845e1d05fa984d3be73f>>
 * @relayHash 775b265500f7bd394ac32842ea15a9b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4ec12421aefe00f5172e1e893f8debec2d20b956db4831765eb2119ba6cbbc7
const $7454710a26b8c5f5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "pageProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyPageCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreatePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "createPageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyPageCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreatePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "createPageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "775b265500f7bd394ac32842ea15a9b6",
            "id": "f4ec12421aefe00f5172e1e893f8debec2d20b956db4831765eb2119ba6cbbc7",
            "metadata": {},
            "name": "useUpdateContentPropertyPageCreateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyPageCreateMutation($propertyKey:String!,$pageId:ID!,$propertyValue:String!){confluence{createPageProperty(input:{key:$propertyKey,pageId:$pageId,value:$propertyValue}){success,pageProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$7454710a26b8c5f5$var$node.hash = "787bb4cf02c8a8364865f8c585f8b1ad";
var $7454710a26b8c5f5$export$2e2bcd8739ae039 = $7454710a26b8c5f5$var$node;
module.exports["default"] = $7454710a26b8c5f5$export$2e2bcd8739ae039;

});

parcelRegister("2zphh", function(module, exports) {
const $bf70d92172ad781d$export$eae7710ac4f92e1b = (user)=>{
    return user.isAnonymous || !user.avatarUrl ? undefined : user.avatarUrl;
};
module.exports["getUserAvatarSrc"] = $bf70d92172ad781d$export$eae7710ac4f92e1b;

});

parcelRegister("erzVD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0c6da6b618ff535$export$44ec82a0a8c60a0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xpRfQ",
    name: "InspectPermissionsDialog",
    loader: async ()=>(await (parcelRequire("ayITn"))).InspectPermissionsDialog
});
module.exports["InspectPermissionsDialog"] = $d0c6da6b618ff535$export$44ec82a0a8c60a0e;

});

parcelRegister("ayITn", function(module, exports) {

let $7affe7045304c936$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7affe7045304c936$var$load("gkVge"),
    $7affe7045304c936$var$load("kVHWO"),
    $7affe7045304c936$var$load("amPsT"),
    $7affe7045304c936$var$load("c831e"),
    $7affe7045304c936$var$load("LWh5V"),
    $7affe7045304c936$var$load("dZsGY"),
    $7affe7045304c936$var$load("l3CW5"),
    $7affe7045304c936$var$load("h4Nf7"),
    $7affe7045304c936$var$load("6wr18"),
    $7affe7045304c936$var$load("59hV4"),
    $7affe7045304c936$var$load("cFgVe"),
    $7affe7045304c936$var$load("5wzAc"),
    $7affe7045304c936$var$load("Wowvf"),
    $7affe7045304c936$var$load("dr883"),
    $7affe7045304c936$var$load("bePXd"),
    $7affe7045304c936$var$load("ea3NB"),
    $7affe7045304c936$var$load("hhss7"),
    $7affe7045304c936$var$load("fuOfV"),
    $7affe7045304c936$var$load("jL1Ke"),
    $7affe7045304c936$var$load("5MQ0D"),
    $7affe7045304c936$var$load("6vqGz"),
    $7affe7045304c936$var$load("ffEVr"),
    $7affe7045304c936$var$load("eS3wT"),
    $7affe7045304c936$var$load("4uO8Y"),
    $7affe7045304c936$var$load("7EorR"),
    $7affe7045304c936$var$load("85liN")
]).then(()=>parcelRequire('jl66H'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("ePExc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ec704748a0115052$export$9542b2119eeb5eb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "327gI",
    name: "ShareAndRestrictDialogController",
    loader: async ()=>(await (parcelRequire("ck4Iu"))).Controller
});
module.exports["ShareAndRestrictDialogController"] = $ec704748a0115052$export$9542b2119eeb5eb4;

});

parcelRegister("ck4Iu", function(module, exports) {

let $8f8b02e35a76bf01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8f8b02e35a76bf01$var$load("cjpt9"),
    $8f8b02e35a76bf01$var$load("cmmpX"),
    $8f8b02e35a76bf01$var$load("cFgVe"),
    $8f8b02e35a76bf01$var$load("5wzAc"),
    $8f8b02e35a76bf01$var$load("6wr18"),
    $8f8b02e35a76bf01$var$load("bRqDI"),
    $8f8b02e35a76bf01$var$load("jrCdz"),
    $8f8b02e35a76bf01$var$load("k55bj"),
    $8f8b02e35a76bf01$var$load("ffEVr"),
    $8f8b02e35a76bf01$var$load("Wowvf"),
    $8f8b02e35a76bf01$var$load("2l8zo"),
    $8f8b02e35a76bf01$var$load("7EorR"),
    $8f8b02e35a76bf01$var$load("2tyj0"),
    $8f8b02e35a76bf01$var$load("hhss7"),
    $8f8b02e35a76bf01$var$load("bunf9")
]).then(()=>parcelRequire('4adOe'));

});

parcelRegister("3jRrs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $3PNw6 = parcelRequire("3PNw6");

const $7f8675ab969ce2e0$export$e275bea1043f4431 = ()=>{
    // This explicitly does not fire exposure, in order to prevent a Holdout exposure, which can dilute the Holdout measurement.
    const isInConfluenceHoldout = (0, $cXtTj.default).initializeCompleted() && !(0, $cXtTj.default).checkGate('product-confluence-holdout-observability-gate', {
        fireGateExposure: false
    });
    return {
        holdout: isInConfluenceHoldout ? 'confluence-holdout' : ''
    };
};
const $7f8675ab969ce2e0$export$c7fd2161616b0849 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: $7f8675ab969ce2e0$export$e275bea1043f4431()
    });
};
module.exports["getIsInConfluenceHoldoutData"] = $7f8675ab969ce2e0$export$e275bea1043f4431;

});

parcelRegister("fdPUP", function(module, exports) {
const $73fa77a308d85fef$export$219d516b185caa05 = 'ShareAndRestrictDialog';
const $73fa77a308d85fef$export$da7d900b1da56fbf = 'share-and-restrict-dialog-user-picker-input';
const $73fa77a308d85fef$export$3f89eb51f735e9b3 = [
    'page'
];
const $73fa77a308d85fef$export$b1e4cd5fa4074c7a = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions';
const $73fa77a308d85fef$export$ce504fce6cf8855f = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
module.exports["SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE"] = $73fa77a308d85fef$export$219d516b185caa05;
module.exports["USER_PICKER_INPUT_ID"] = $73fa77a308d85fef$export$da7d900b1da56fbf;
module.exports["ACCESS_LINK_ENROLLED_CONTENT_TYPES"] = $73fa77a308d85fef$export$3f89eb51f735e9b3;
module.exports["SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION"] = $73fa77a308d85fef$export$ce504fce6cf8855f;

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("dcvq8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $28c0ce898ab65517$export$7bd982897ab56fe5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1kdap",
    name: "GlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("hEJM3"))).GlobalFeedbackCollector
});

const $28c0ce898ab65517$export$76de8e4d628aac4a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "7vDuP",
    name: "LazyGlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("hEJM3"))).GlobalFeedbackCollector
});
module.exports["GlobalFeedbackCollector"] = $28c0ce898ab65517$export$7bd982897ab56fe5;
module.exports["LazyGlobalFeedbackCollector"] = $28c0ce898ab65517$export$76de8e4d628aac4a;

});

parcelRegister("hEJM3", function(module, exports) {

let $cda9addd653760d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cda9addd653760d9$var$load("4nZ85"),
    $cda9addd653760d9$var$load("kHXvF"),
    $cda9addd653760d9$var$load("iWnyc"),
    $cda9addd653760d9$var$load("hhss7"),
    $cda9addd653760d9$var$load("dGk3x")
]).then(()=>parcelRequire('liJpy'));

});

parcelRegister("6Skv2", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $i28ZW = parcelRequire("i28ZW");

const $56a1bd181349f72b$export$6f68fdaa2d77a244 = (operations, operation, targetType)=>(operations || []).some((op)=>op?.operation === operation && op?.targetType === targetType);
const $56a1bd181349f72b$export$1f45e3a137b2157c = (space)=>(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? (0, $i28ZW.hasSpaceOperation)(space?.operations, (0, $i28ZW.MANAGE_PUBLIC_LINKS)) : Boolean(space?.currentUser?.isAdmin);
const $56a1bd181349f72b$export$818b606ecaafcde3 = (space)=>space ? $56a1bd181349f72b$export$1f45e3a137b2157c(space) : undefined;
module.exports["hasPublicLinksOperation"] = $56a1bd181349f72b$export$6f68fdaa2d77a244;
module.exports["hasManagePublicLinksOperation"] = $56a1bd181349f72b$export$1f45e3a137b2157c;
module.exports["hasManagePublicLinksOperationOrUndefined"] = $56a1bd181349f72b$export$818b606ecaafcde3;

});

parcelRegister("hC6vw", function(module, exports) {
/**
 * @generated SignedSource<<05f748b5a6c8adbf92302798905bd021>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d0a960900d3ff81b$export$cb24eb3958583602 = /*#__PURE__*/ function(PublicLinkPageStatus) {
    PublicLinkPageStatus["BLOCKED_BY_ORG"] = "BLOCKED_BY_ORG";
    PublicLinkPageStatus["BLOCKED_BY_PRODUCT"] = "BLOCKED_BY_PRODUCT";
    PublicLinkPageStatus["BLOCKED_BY_SPACE"] = "BLOCKED_BY_SPACE";
    PublicLinkPageStatus["BLOCKED_BY_CONTAINER_POLICY"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkPageStatus["BLOCKED_BY_CLASSIFICATION_LEVEL"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    PublicLinkPageStatus["OFF"] = "OFF";
    PublicLinkPageStatus["ON"] = "ON";
    PublicLinkPageStatus["SITE_BLOCKED"] = "SITE_BLOCKED";
    PublicLinkPageStatus["SITE_DISABLED"] = "SITE_DISABLED";
    PublicLinkPageStatus["SPACE_BLOCKED"] = "SPACE_BLOCKED";
    PublicLinkPageStatus["SPACE_DISABLED"] = "SPACE_DISABLED";
    return PublicLinkPageStatus;
}({});
module.exports["PublicLinkPageStatus"] = $d0a960900d3ff81b$export$cb24eb3958583602;

});

parcelRegister("5izWN", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e2e3e1973cea2910$export$acd4d92ce9f1584f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { label: label, color: t1 } = t0;
    const color = t1 === undefined ? "currentColor" : t1;
    const t2 = label || undefined;
    const t3 = label ? "img" : "presentation";
    const t4 = label ? undefined : true;
    let t5;
    if ($[0] !== color) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.5885 8.1713C7.8852 6.38061 6.80333 6.11304 5.24293 6.11304C3.41207 6.11304 1.85167 6.87459 0.457716 9.01518L0.228858 9.36509C0.0416106 9.65324 0 9.75616 0 9.87965C0 10.0031 0.0624158 10.1061 0.291274 10.2501L2.64227 11.7115C2.7671 11.7938 2.87113 11.835 2.97515 11.835C3.09999 11.835 3.18321 11.7733 3.30804 11.588L3.68253 11.0117C4.26508 10.1266 4.78521 9.83849 5.45098 9.83849C6.03353 9.83849 6.72011 10.0031 7.57312 10.4148L10.0281 11.5674C10.2778 11.6909 10.5483 11.6292 10.6731 11.341L11.8382 8.78877C11.963 8.50062 11.8798 8.31537 11.5885 8.1713ZM0.790601 3.6637C4.49394 5.45439 5.57581 5.72197 7.13621 5.72197C8.96708 5.72197 10.5275 4.96041 11.9214 2.81982L12.1503 2.46991C12.3375 2.18176 12.3791 2.07884 12.3791 1.95535C12.3791 1.83185 12.3167 1.72894 12.0879 1.58486L9.73687 0.123496C9.61204 0.0411652 9.50801 0 9.40399 0C9.27915 0 9.19593 0.0617478 9.0711 0.246991L8.69661 0.823304C8.11406 1.70836 7.59393 1.99651 6.92816 1.99651C6.34561 1.99651 5.65904 1.83185 4.80602 1.4202L2.351 0.267574C2.10133 0.144078 1.83086 0.205826 1.70603 0.493983L0.540937 3.04623C0.416106 3.33438 0.499327 3.51963 0.790601 3.6637Z",
            fill: color
        });
        $[0] = color;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 -0.5 13 13",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-label": t2,
            role: t3,
            "aria-hidden": t4
        }, t5);
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ label: label, color: color = 'currentColor' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 -0.5 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        "aria-hidden": label ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.5885 8.1713C7.8852 6.38061 6.80333 6.11304 5.24293 6.11304C3.41207 6.11304 1.85167 6.87459 0.457716 9.01518L0.228858 9.36509C0.0416106 9.65324 0 9.75616 0 9.87965C0 10.0031 0.0624158 10.1061 0.291274 10.2501L2.64227 11.7115C2.7671 11.7938 2.87113 11.835 2.97515 11.835C3.09999 11.835 3.18321 11.7733 3.30804 11.588L3.68253 11.0117C4.26508 10.1266 4.78521 9.83849 5.45098 9.83849C6.03353 9.83849 6.72011 10.0031 7.57312 10.4148L10.0281 11.5674C10.2778 11.6909 10.5483 11.6292 10.6731 11.341L11.8382 8.78877C11.963 8.50062 11.8798 8.31537 11.5885 8.1713ZM0.790601 3.6637C4.49394 5.45439 5.57581 5.72197 7.13621 5.72197C8.96708 5.72197 10.5275 4.96041 11.9214 2.81982L12.1503 2.46991C12.3375 2.18176 12.3791 2.07884 12.3791 1.95535C12.3791 1.83185 12.3167 1.72894 12.0879 1.58486L9.73687 0.123496C9.61204 0.0411652 9.50801 0 9.40399 0C9.27915 0 9.19593 0.0617478 9.0711 0.246991L8.69661 0.823304C8.11406 1.70836 7.59393 1.99651 6.92816 1.99651C6.34561 1.99651 5.65904 1.83185 4.80602 1.4202L2.351 0.267574C2.10133 0.144078 1.83086 0.205826 1.70603 0.493983L0.540937 3.04623C0.416106 3.33438 0.499327 3.51963 0.790601 3.6637Z",
        fill: color
    }));
module.exports["ConfluenceLogoIcon"] = $e2e3e1973cea2910$export$acd4d92ce9f1584f;

});

parcelRegister("4Ewfm", function(module, exports) {

var $fg72c = parcelRequire("fg72c");


var $8oEoE = parcelRequire("8oEoE");

const $b2ff9ab7087360b2$export$3b523c26f78a7afe = (principal)=>{
    if (principal.type === 'user') {
        const warning = principal.knownErrors?.accessWarning;
        return warning === 'pending-site-access-warning' || warning === 'pending-userbase-propagation-warning';
    }
    return false;
};
function $b2ff9ab7087360b2$export$9871f41355e50e43({ principals: principals, removals: removals, principalsPendingAccess: principalsPendingAccess, removeAll: removeAll }) {
    if (Array.from(principals.values()).some(({ principal: principal })=>$b2ff9ab7087360b2$export$3b523c26f78a7afe(principal))) return true;
    if (principalsPendingAccess.some(({ principal: { id: id } })=>removals.has(id))) return true;
    if (removeAll && principalsPendingAccess.length > 0) return true;
    return false;
}
function $b2ff9ab7087360b2$export$e84d96463240149a({ generalAccess: generalAccess, principals: principals }) {
    return $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'mutation-restrictions'
    });
}
function $b2ff9ab7087360b2$export$50e102a305a0ed72({ generalAccess: generalAccess, principals: principals }) {
    const currentRestrictions = $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'publish-modal-restrictions'
    });
    const read = {
        operation: 'read',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const update = {
        operation: 'update',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const { publishModalReadRestrictions: publishModalReadRestrictions, publishModalUpdateRestrictions: publishModalUpdateRestrictions } = $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions);
    return [
        publishModalReadRestrictions,
        publishModalUpdateRestrictions
    ];
}
function $b2ff9ab7087360b2$export$49bcbf98a41d5666({ generalAccess: generalAccess, principals: principals }) {
    const restrictions = $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'mutation-restrictions'
    });
    const gqlInput = {
        read: restrictions.read,
        update: restrictions.update
    };
    gqlInput.restrictionState = (0, $fg72c.generalAccessLevelToMode)(generalAccess);
    gqlInput.permissions = $b2ff9ab7087360b2$var$buildPermissionsFromPrincipals(principals, generalAccess);
    return gqlInput;
}
/**
 * Builds the flat permissions array format (view/edit) from the principals map.
 * This is the new format used by the permissions + restrictionState fields on ConfluenceContentInput.
 *
 * Unlike the old restrictions format (read/update with separate user/group arrays),
 * this produces flat arrays of { id, type } objects for view and edit.
 */ function $b2ff9ab7087360b2$var$buildPermissionsFromPrincipals(principals, _generalAccess) {
    const viewList = [];
    const editList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const principalType = principal.type === 'user' ? 'USER' : 'GROUP';
        // Add can-view principals to view list
        if (role === 'can-view') viewList.push({
            id: principal.id,
            type: principalType
        });
        // Add can-edit principals to edit list only
        if (role === 'can-edit') editList.push({
            id: principal.id,
            type: principalType
        });
    }
    return {
        view: viewList,
        edit: editList
    };
}
/**
 * Generates restrictions based on the general access level, the provided principals map and restrictionType.
 */ function $b2ff9ab7087360b2$var$getRestrictions({ generalAccess: generalAccess, principals: principals, restrictionType: restrictionType }) {
    switch(generalAccess){
        case 'restricted':
            return {
                read: $b2ff9ab7087360b2$var$getReadList(principals, restrictionType),
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        case 'open-can-view':
            return {
                read: {
                    group: [],
                    user: []
                },
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        default:
            return {
                read: {
                    group: [],
                    user: []
                },
                update: {
                    group: [],
                    user: []
                }
            };
    }
}
/**
 * Converts the current state to publish modal restrictions by transforming user and group lists.
 *
 * @param {ContentRestriction} read - The read restrictions content.
 * @param {ContentRestriction} update - The update restrictions content.
 * @param {PageRestrictionsInput} currentRestrictions - The current restrictions input.
 * @returns {{ publishModalReadRestrictions: ContentRestriction, publishModalUpdateRestrictions: ContentRestriction }} The transformed publish modal restrictions.
 */ function $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions) {
    const { restrictions: { user: { results: readUserList }, group: { results: readGroupList } } } = read;
    const { restrictions: { user: { results: updateUserList }, group: { results: updateGroupList } } } = update;
    const { read: currentReadList, update: currentUpdateList } = currentRestrictions;
    $b2ff9ab7087360b2$var$pushTransformedUser(readUserList, currentReadList.user);
    $b2ff9ab7087360b2$var$pushTransformedUser(updateUserList, currentUpdateList.user);
    $b2ff9ab7087360b2$var$pushTransformedGroup(readGroupList, currentReadList.group);
    $b2ff9ab7087360b2$var$pushTransformedGroup(updateGroupList, currentUpdateList.group);
    return {
        publishModalReadRestrictions: read,
        publishModalUpdateRestrictions: update
    };
}
/**
 * Transforms and adds user restrictions to the publish modal user list.
 */ function $b2ff9ab7087360b2$var$pushTransformedUser(list, users) {
    for (const user of users){
        if (!user) continue;
        list.push({
            ...user,
            type: 'known',
            // instead of type: 'user'
            publicName: user.displayName,
            isExternalCollaborator: false
        });
    }
}
/**
 * Transforms and adds group restrictions to the publish modal group list.
 */ function $b2ff9ab7087360b2$var$pushTransformedGroup(list, groups) {
    for (const group of groups){
        if (!group) continue;
        list.push(group);
    }
}
const $b2ff9ab7087360b2$var$getUsageType = (principal)=>{
    if ((principal.type === 'group' || principal.type === 'team') && 'usageType' in principal && principal.usageType) return principal.usageType;
    if (principal.type === 'group') return (0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP;
    if (principal.type === 'team') return (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION;
};
/**
 * Generates a list of principals with 'can-edit' access for the update list.
 */ function $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && role === 'can-edit') groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && role === 'can-edit') userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
/**
 * Generates a list of principals with 'can-view' access for the read list.
 */ function $b2ff9ab7087360b2$var$getReadList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && (role === 'can-view' || role === 'can-edit')) groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && (role === 'can-view' || role === 'can-edit')) userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
module.exports["isUserPendingAccess"] = $b2ff9ab7087360b2$export$3b523c26f78a7afe;
module.exports["shouldMutationIncludeInvites"] = $b2ff9ab7087360b2$export$9871f41355e50e43;
module.exports["getRestrictionsForMutation"] = $b2ff9ab7087360b2$export$e84d96463240149a;
module.exports["getRestrictionsForPublishModal"] = $b2ff9ab7087360b2$export$50e102a305a0ed72;
module.exports["getGqlRestrictionsInputForPublishModal"] = $b2ff9ab7087360b2$export$49bcbf98a41d5666;

});

parcelRegister("fg72c", function(module, exports) {
const $06bae8500a7e571b$export$406c89e51172952a = {
    restricted: 'VIEW_RESTRICTED',
    'open-can-view': 'EDIT_RESTRICTED',
    'open-can-edit': 'OPEN'
};
const $06bae8500a7e571b$export$3e8e3eee6dfccab0 = (level)=>$06bae8500a7e571b$export$406c89e51172952a[level];
module.exports["generalAccessLevelToMode"] = $06bae8500a7e571b$export$3e8e3eee6dfccab0;

});

parcelRegister("8oEoE", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0f8a7127f2228c42$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $0f8a7127f2228c42$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ConfluenceGroupUsageType"] = $0f8a7127f2228c42$export$e7c9280c9da1cc0a;

});

parcelRegister("7QoAs", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $d9tcB = parcelRequire("d9tcB");


var $fdPUP = parcelRequire("fdPUP");


var $4Ewfm = parcelRequire("4Ewfm");


var $22cFL = parcelRequire("22cFL");


var $jI7Td = parcelRequire("jI7Td");

const $164b2844d962585d$var$blockedAccessUsersLimit = 10;
const $164b2844d962585d$var$blockedAccessLevelsLimit = 10;
const $164b2844d962585d$export$4da22e4767045266 = async ({ contentId: contentId, cloudId: cloudId, edition: edition, numberOfAncestors: numberOfAncestors, addMode: addMode, stagedUserPrincipals: stagedUserPrincipals, setMasterState: setMasterState, fireAnalyticEvent: fireAnalyticEvent })=>{
    //The validation  is skipped if free edition
    if (edition == (0, $d9tcB.ConfluenceEdition).FREE) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    const activeStagedUserPrincipals = stagedUserPrincipals.filter((user)=>!(0, $4Ewfm.isUserPendingAccess)({
            type: 'user',
            ...user
        }));
    //The validation  is skipped if staged user count is 0
    if (activeStagedUserPrincipals.length == 0) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    // if staged user count is greater than 10,
    // or content is more than 10 levels deep
    if (activeStagedUserPrincipals.length > $164b2844d962585d$var$blockedAccessUsersLimit || numberOfAncestors > $164b2844d962585d$var$blockedAccessLevelsLimit) {
        fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'BlockedAccessCheckLimitExceeded',
            actionSubject: 'BlockedAccessCheck',
            source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
            attributes: {
                NewUsersCount: activeStagedUserPrincipals.length,
                numberOfAncestors: numberOfAncestors
            }
        });
        const accountIds = activeStagedUserPrincipals.map((user)=>{
            return user.id;
        });
        const { data: usersContentAccessData, error: usersContentAccessError } = await (0, $c0rhi.queryInterop)({
            query: (0, $jI7Td.default),
            variables: {
                accessType: addMode == 'as-editor' ? 'EDIT' : 'VIEW',
                accountIds: accountIds,
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'network-only',
            __callerPackage__: "share-and-restrict-dialog"
        });
        if (usersContentAccessError) {
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'errored',
                actionSubject: 'UsersContentAccessQuery',
                actionSubjectId: 'validateRestrictedPrincipals',
                attributes: {
                    message: usersContentAccessError.message
                }
            });
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: false
            };
        }
        const canNotAccessList = usersContentAccessData?.confluence_userContentAccess?.cannotAccessList;
        if (canNotAccessList != null && canNotAccessList.length > 0) {
            const restrictedUserPrincipalsList = canNotAccessList.map((userId)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === userId),
                    restrictedResources: null
                };
                return restrictedPrincipal;
            });
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList
                }));
            return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
        }
    } else {
        const blockedAccessSubjects = activeStagedUserPrincipals.map((user)=>{
            const blockedAccessSubject = {
                subjectId: user.id,
                subjectType: 'USER'
            };
            return blockedAccessSubject;
        });
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $22cFL.default),
            variables: {
                // The GraphQL query expects a number, but contentId is a string. For the relay migration we will type it as any to not break existing functionality,
                // but this should be fixed in the future and keep the types consistent.
                contentId: contentId,
                accessType: addMode == 'as-editor' ? 'EDIT' : 'VIEW',
                subjects: blockedAccessSubjects
            },
            fetchPolicy: 'network-only',
            __callerPackage__: "share-and-restrict-dialog"
        });
        if (error) fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'errored',
            actionSubject: 'BlockedAccessRestrictionsQuery',
            actionSubjectId: 'validateRestrictedPrincipals',
            attributes: {
                message: error?.message
            }
        });
        const blockedAccessRestrictions = data?.blockedAccessRestrictions;
        const blockedAccessRestrictionSummary = blockedAccessRestrictions?.blockedAccessRestrictionSummary;
        if (blockedAccessRestrictions && blockedAccessRestrictionSummary && blockedAccessRestrictionSummary.length > 0) {
            const restrictedUserPrincipalsList = blockedAccessRestrictionSummary.map((restrictedUser)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === restrictedUser?.subject?.subjectId),
                    restrictedResources: restrictedUser?.restrictedResources
                };
                return restrictedPrincipal;
            });
            const assignableSpaceRolesIntersection = blockedAccessRestrictions.blockedAccessAssignableSpaceRolesIntersection;
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList,
                    assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
                }));
            //current user is not empowered to fix at least one of the selected user's restrictions
            if (!blockedAccessRestrictions.canFixRestrictionsForAllSubjects) return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: true,
                // Expose this extra info for Realtime requests to consume
                // In USD these get set directly on the masterState
                // But realtime requests don't have access to masterState
                restrictedUserPrincipals: restrictedUserPrincipalsList,
                assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
            };
        }
    }
    // all added principles can access or blocked access was skipped
    return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
};
module.exports["validateRestrictedPrincipals"] = $164b2844d962585d$export$4da22e4767045266;

});

parcelRegister("22cFL", function(module, exports) {
/**
 * @generated SignedSource<<75c554d8ad4e342d8666c6b62aee9b86>>
 * @relayHash 0823488049ea540f2c3f5c4cb3a9f517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed
const $855873b1252722a0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "subjects"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "subjectId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessType",
                    "variableName": "accessType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "subjects",
                    "variableName": "subjects"
                }
            ],
            "concreteType": "BlockedAccessRestrictions",
            "kind": "LinkedField",
            "name": "blockedAccessRestrictions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SubjectRestrictionHierarchySummary",
                    "kind": "LinkedField",
                    "name": "blockedAccessRestrictionSummary",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "BlockedAccessSubject",
                            "kind": "LinkedField",
                            "name": "subject",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "subjectType"
                                }
                            ]
                        },
                        {
                            "concreteType": "RestrictedResource",
                            "kind": "LinkedField",
                            "name": "restrictedResources",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceTitle"
                                },
                                {
                                    "concreteType": "RestrictedResourceLinks",
                                    "kind": "LinkedField",
                                    "name": "resourceLink",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "base"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUi"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "requiredAccessType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceType"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "BlockedAccessEmpowerment",
                    "kind": "LinkedField",
                    "name": "blockedAccessEmpowerment",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCurrentUserEmpowered"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceBlockedAccessAssignableSpaceRole",
                    "kind": "LinkedField",
                    "name": "blockedAccessAssignableSpaceRolesIntersection",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "roleId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDescription"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleType"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "canFixRestrictionsForAllSubjects"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BlockedAccessRestrictionsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BlockedAccessRestrictionsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0823488049ea540f2c3f5c4cb3a9f517",
            "id": "e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed",
            "metadata": {},
            "name": "BlockedAccessRestrictionsQuery",
            "operationKind": "query",
            "text": "query BlockedAccessRestrictionsQuery($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!){blockedAccessRestrictions(accessType:$accessType,contentId:$contentId,subjects:$subjects){blockedAccessRestrictionSummary{subject{subjectId,subjectType},restrictedResources{resourceId,resourceTitle,resourceLink{base,webUi},requiredAccessType,resourceType}},blockedAccessEmpowerment{subjectId,isCurrentUserEmpowered},blockedAccessAssignableSpaceRolesIntersection{roleId,roleDescription,roleName,roleType},canFixRestrictionsForAllSubjects}}"
        }
    };
}();
$855873b1252722a0$var$node.hash = "cc9731fa07afd21d30e45e70eeb338f4";
var $855873b1252722a0$export$2e2bcd8739ae039 = $855873b1252722a0$var$node;
module.exports["default"] = $855873b1252722a0$export$2e2bcd8739ae039;

});

parcelRegister("jI7Td", function(module, exports) {
/**
 * @generated SignedSource<<bc99a62c4eb8102fc854786a36828b06>>
 * @relayHash 727771f625528321882e822398d219fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9
const $b86f4f4db61ac40f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessType",
                    "variableName": "accessType"
                },
                {
                    "kind": "Variable",
                    "name": "accountIds",
                    "variableName": "accountIds"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluenceUserContentAccessResult",
            "kind": "LinkedField",
            "name": "confluence_userContentAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canAccessList"
                },
                {
                    "kind": "ScalarField",
                    "name": "cannotAccessList"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UsersContentAccessQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UsersContentAccessQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "727771f625528321882e822398d219fd",
            "id": "e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9",
            "metadata": {},
            "name": "UsersContentAccessQuery",
            "operationKind": "query",
            "text": "query UsersContentAccessQuery($accessType:ResourceAccessType!,$accountIds:[String]!,$cloudId:ID!,$contentId:ID!){confluence_userContentAccess(accessType:$accessType,accountIds:$accountIds,cloudId:$cloudId,contentId:$contentId){canAccessList,cannotAccessList}}"
        }
    };
}();
$b86f4f4db61ac40f$var$node.hash = "3af84917efe0ce91f68b18f96d2f126c";
var $b86f4f4db61ac40f$export$2e2bcd8739ae039 = $b86f4f4db61ac40f$var$node;
module.exports["default"] = $b86f4f4db61ac40f$export$2e2bcd8739ae039;

});

parcelRegister("f2UnK", function(module, exports) {

var $8NGcs = parcelRequire("8NGcs");


var $dYU3e = parcelRequire("dYU3e");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery = (0, $8NGcs.default);
const $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d = (cloudId)=>{
    return (0, $dYU3e.query)({
        query: $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery,
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "share-and-restrict-dialog"
    }).then(({ data: data, hasErrors: hasErrors })=>{
        if (hasErrors) // Handle errors silently for preloading
        return null;
        return data?.confluence_spaceRoleMode || null;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return null;
    });
};
const $0ac8a6fa9069d7d8$export$c715e7f8018f9029 = async (cloudId)=>{
    await $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d(cloudId);
};
module.exports["preloadSpaceRoleMode"] = $0ac8a6fa9069d7d8$export$c715e7f8018f9029;

});

parcelRegister("8NGcs", function(module, exports) {
/**
 * @generated SignedSource<<bbbcf040ac95e90832074d5908ee571b>>
 * @relayHash 4c198432b204cbcb18fb5160733adf98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4
const $556eda7e15abe5d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4c198432b204cbcb18fb5160733adf98",
            "id": "cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4",
            "metadata": {},
            "name": "preloadSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query preloadSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$556eda7e15abe5d2$var$node.hash = "1b6118c2bdcdd04e86f799370c9c7bca";
var $556eda7e15abe5d2$export$2e2bcd8739ae039 = $556eda7e15abe5d2$var$node;
module.exports["default"] = $556eda7e15abe5d2$export$2e2bcd8739ae039;

});

parcelRegister("gabmL", function(module, exports) {

var $9eNhQ = parcelRequire("9eNhQ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bQm3c = parcelRequire("bQm3c");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $hC6vw = parcelRequire("hC6vw");


var $1X7PR = parcelRequire("1X7PR");


var $bgRei = parcelRequire("bgRei");

const $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES = [
    'This is a Standard/Premium feature. You are currently subscribed to the Free plan.',
    'Anonymous access is not permitted'
];
const $b34fb09a67265b07$var$i18n = (0, $kSwu1.defineMessages)({
    publicLinkUrlPathError: {
        id: "public-links.usePublicLinkDataProvider.sharePathError.message",
        defaultMessage: "publicLinkStatus was ON, but no publicLinkUrlPath was provided"
    }
});
const $b34fb09a67265b07$var$computeData = (pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)=>{
    // Are Public Links allowed for this content type
    const isPublicLinkAllowedForContentType = !contentData.error && contentData.data !== undefined && enrolledContentTypes.includes(contentData.data.contentType);
    // Are Editable Public Links allowed for this content type
    const isPublicLinkEditAllowedForContentType = isPublicLinkAllowedForContentType && (edition === (0, $euL71.ConfluenceEdition).PREMIUM || (0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) && contentData.data?.contentType === 'whiteboard';
    // Can current user edit Public Link status
    const baseCanEditPublicLink = !contentData.error && contentData.data?.canEditPublicLink === true;
    const canUpdateOrDeletePublicLink = !contentData.error && (contentData.data?.canUpdatePublicLink === true || contentData.data?.canDeletePublicLink === true);
    // Render-time call to ensure the experiment exposure is tracked even when baseCanEditPublicLink short-circuits the next clause.
    (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const isWhiteboardWithoutM0 = contentData.data?.contentType === 'whiteboard' && !(0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false);
    const canEditPublicLink = baseCanEditPublicLink && (!isPublicLinkStatusOnForContent || canUpdateOrDeletePublicLink || !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) || // When shareable_links_m0 is off for whiteboards, canUpdateOrDeletePublicLink operations
    // may not be available (the public_link RBAC operations are part of the m0 permissions
    // model). In this case, fall back to baseCanEditPublicLink only.
    isWhiteboardWithoutM0);
    // Value for if the Public Link has edit permissions i.e. Editable Public Whiteboards
    const isEditPublicLink = !!(!permissionsData.error && permissionsData.data?.hasEditPermission);
    // Are Public Links enabled by admins at Site and Space levels
    const isPublicLinkAdminEnabled = isPublicLinkStatusOnForContent || !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).OFF;
    // Is Public Link allowed for content type, admin enabled, and status ON
    const isPublicLinkFullyEnabled = isPublicLinkStatusOnForContent && isPublicLinkAdminEnabled && isPublicLinkAllowedForContentType;
    const refetch = (dataToFetch = 'all')=>{
        // if dataToFetch !== permission, it means it's either all or public-link
        if (dataToFetch !== 'permission') {
            pageData.refetch();
            contentData.refetch?.();
        }
        // if dataToFetch !== public-link, it means it's either all or permission
        if (dataToFetch !== 'public-link') isPublicLinkEditAllowedForContentType && permissionsData.refetch();
    };
    return {
        isPublicLinkAdminEnabled: isPublicLinkAdminEnabled,
        isPublicLinkFullyEnabled: isPublicLinkFullyEnabled,
        isPublicLinkAllowedForContentType: isPublicLinkAllowedForContentType,
        isPublicLinkEditAllowedForContentType: isPublicLinkEditAllowedForContentType,
        isEditPublicLink: isEditPublicLink,
        canEditPublicLink: canEditPublicLink,
        publicLinkStatus: pageData.data?.pageStatus,
        publicLinkSharePath: pageData.data?.publicLinkUrlPath,
        refetch: refetch
    };
};
const $b34fb09a67265b07$export$4725159de576f61f = (props)=>{
    const publicLinkData = $b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: props.contentId,
        ...props
    });
    return publicLinkData.isLoading ? {
        isPublicLinkFullyEnabled: false,
        isPublicLinkAdminEnabled: false,
        isPublicLinkAllowedForContentType: false,
        isPublicLinkEditAllowedForContentType: false,
        canEditPublicLink: false,
        publicLinkStatus: undefined,
        publicLinkSharePath: undefined,
        isEditPublicLink: false,
        refetch: ()=>{},
        ...publicLinkData
    } : publicLinkData;
};
const $b34fb09a67265b07$export$b7ccc28cc819be23 = (props)=>{
    const enrolledContentTypes = [
        'page',
        'whiteboard'
    ];
    const intl = (0, $kSwu1.useIntl)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    let contentData = (0, $1X7PR.usePublicLinkContentQuery)({
        contentId: props.pageId,
        skip: props.contentQueryProps?.skip
    });
    const contentType = props.contentQueryProps?.skip ? props.contentQueryProps?.contentType : contentData?.data?.contentType;
    contentData = {
        ...contentData,
        data: {
            ...contentData?.data,
            canEditPublicLink: contentData?.data?.canEditPublicLink ?? false,
            canUpdatePublicLink: contentData?.data?.canUpdatePublicLink ?? false,
            canDeletePublicLink: contentData?.data?.canDeletePublicLink ?? false,
            contentType: contentType ?? ''
        }
    };
    const shouldSkip = props.skip || !enrolledContentTypes.includes(contentData?.data?.contentType || '') || !isLicensed || edition === (0, $euL71.ConfluenceEdition).FREE;
    const rawPageData = (0, $jMyy4.useQueryInterop)((0, $9eNhQ.default), {
        variables: {
            pageId: props.pageId
        },
        fetchPolicy: props.fetchPolicy,
        skip: shouldSkip,
        __callerPackage__: "public-links"
    });
    const permissionsData = (0, $bgRei.usePublicLinkPermissionsForObject)({
        objectId: props.pageId,
        skip: shouldSkip || edition !== (0, $euL71.ConfluenceEdition).PREMIUM && !(0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false) || contentData?.data?.contentType !== 'whiteboard'
    });
    const pageData = (0, $cozmU.useMemo)(()=>({
            isLoading: rawPageData.loading,
            data: rawPageData.data?.publicLinkPage,
            error: rawPageData.error,
            refetch: rawPageData.refetch
        }), [
        rawPageData.loading,
        rawPageData.data,
        rawPageData.error,
        rawPageData.refetch
    ]);
    if ((0, $1uFM6.isUnauthorizedError)(rawPageData.error) || // We currently aren't being given error types by the backend.
    // When we do, we can better parse these expected errors.
    // https://product-fabric.atlassian.net/browse/CPE-1991
    $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES.some((msg)=>rawPageData.error?.message?.includes(msg))) (0, $7Sm4c.markErrorAsHandled)(rawPageData.error);
    // Is Public Link Status for page ON
    const isPublicLinkStatusOnForContent = !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).ON;
    const loading = pageData.isLoading || contentData.isLoading || permissionsData.isLoading;
    const errors = (0, $cozmU.useMemo)(()=>[
            pageData,
            contentData,
            permissionsData
        ].map((query)=>!query.isLoading && query.error).filter((err)=>Boolean(err)), [
        pageData,
        contentData,
        permissionsData
    ]);
    if (isPublicLinkStatusOnForContent && pageData.data?.publicLinkUrlPath === null) errors.push(new Error(intl.formatMessage($b34fb09a67265b07$var$i18n.publicLinkUrlPathError)));
    return loading ? {
        isLoading: true,
        errors: errors
    } : {
        isLoading: false,
        errors: errors,
        ...$b34fb09a67265b07$var$computeData(pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)
    };
};
const $b34fb09a67265b07$export$b86a4cadf4c50ae1 = ({ contentId: contentId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children($b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: contentId
    })));
module.exports["usePublicLinkData"] = $b34fb09a67265b07$export$4725159de576f61f;
module.exports["usePublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b7ccc28cc819be23;
module.exports["PublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b86a4cadf4c50ae1;

});

parcelRegister("9eNhQ", function(module, exports) {
/**
 * @generated SignedSource<<f3ce31061615fe76b947269deb5d6c75>>
 * @relayHash 3f5a736f4dd660a89b02a4452e465d11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184
const $858700f9e1edfc48$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                }
            ],
            "concreteType": "PublicLinkPage",
            "kind": "LinkedField",
            "name": "publicLinkPage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pageId"
                },
                {
                    "kind": "ScalarField",
                    "name": "pageStatus"
                },
                {
                    "kind": "ScalarField",
                    "name": "publicLinkUrlPath"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3f5a736f4dd660a89b02a4452e465d11",
            "id": "d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184",
            "metadata": {},
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "operationKind": "query",
            "text": "query usePublicLinkPageDataProviderPublicLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId,pageStatus,publicLinkUrlPath}}"
        }
    };
}();
$858700f9e1edfc48$var$node.hash = "c030204610be720b223484d4a8d871cf";
var $858700f9e1edfc48$export$2e2bcd8739ae039 = $858700f9e1edfc48$var$node;
module.exports["default"] = $858700f9e1edfc48$export$2e2bcd8739ae039;

});

parcelRegister("1X7PR", function(module, exports) {

var $OoVEI = parcelRequire("OoVEI");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $cLo2u = parcelRequire("cLo2u");


var $foQ4a = parcelRequire("foQ4a");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $6Skv2 = parcelRequire("6Skv2");

const $3e0fb5c21944a86f$var$computeData = (data, isExternalCollaborator)=>{
    const contentType = data?.content?.nodes?.[0]?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const hasManagePublicLinksPermission = Boolean(data?.space?.currentUser?.isAdmin);
    const canEditContent = (0, $6Skv2.hasPublicLinksOperation)(operations, 'update', contentType);
    const canCreatePublicLink = (0, $6Skv2.hasPublicLinksOperation)(operations, 'create_public_link', contentType);
    const canUpdatePublicLink = (0, $6Skv2.hasPublicLinksOperation)(operations, 'update', 'public_link');
    const canDeletePublicLink = (0, $6Skv2.hasPublicLinksOperation)(operations, 'delete', 'public_link');
    const canEditPublicLink = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? canCreatePublicLink && !isExternalCollaborator : (hasManagePublicLinksPermission || canEditContent) && !isExternalCollaborator;
    return {
        contentType: contentType,
        canEditPublicLink: canEditPublicLink,
        canUpdatePublicLink: canUpdatePublicLink,
        canDeletePublicLink: canDeletePublicLink
    };
};
const $3e0fb5c21944a86f$export$13a7a098bd5c2599 = (props)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const { loading: loading, data: data, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $OoVEI.default), {
        skip: props.skip,
        variables: {
            contentId: props.contentId,
            hasSpaceKey: Boolean(spaceKey),
            spaceKey: spaceKey ?? ''
        },
        __callerPackage__: "public-links"
    });
    (0, $cozmU.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    return loading ? {
        isLoading: true,
        refetch: refetch
    } : {
        isLoading: false,
        error: error,
        data: error ? undefined : $3e0fb5c21944a86f$var$computeData(data, isExternalCollaborator),
        refetch: refetch
    };
};
module.exports["usePublicLinkContentQuery"] = $3e0fb5c21944a86f$export$13a7a098bd5c2599;

});

parcelRegister("OoVEI", function(module, exports) {
/**
 * @generated SignedSource<<5d5c701005fd929073b85f42c85deac0>>
 * @relayHash 6ab077a19d911ef98a26d3adbdc3fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d97e35dd1097710a89c08e998e3514fe92b46c99fab60a5106b9d4e4545db9da
const $77c51ddc0082b191$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasSpaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "hasSpaceKey",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAdmin"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "6ab077a19d911ef98a26d3adbdc3fb56",
            "id": "d97e35dd1097710a89c08e998e3514fe92b46c99fab60a5106b9d4e4545db9da",
            "metadata": {},
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "operationKind": "query",
            "text": "query usePublicLinkContentQueryPublicLinkContentQuery($contentId:ID!,$spaceKey:String!,$hasSpaceKey:Boolean!){content(id:$contentId){nodes{id,type,operations{operation,targetType}}},space(key:$spaceKey)@include(if:$hasSpaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$77c51ddc0082b191$var$node.hash = "59655c56a4e7fa1ddec49b3697d04128";
var $77c51ddc0082b191$export$2e2bcd8739ae039 = $77c51ddc0082b191$var$node;
module.exports["default"] = $77c51ddc0082b191$export$2e2bcd8739ae039;

});

parcelRegister("bgRei", function(module, exports) {

var $8lkfF = parcelRequire("8lkfF");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");


var $j0YKV = parcelRequire("j0YKV");

const $6b8bec8977e1e896$export$c2d35981ca787f77 = ({ objectId: objectId, objectType: objectType = (0, $j0YKV.PublicLinkPermissionsObjectType).CONTENT, skip: skip })=>{
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8lkfF.default), {
        variables: {
            objectId: objectId,
            objectType: objectType
        },
        skip: skip,
        __callerPackage__: "public-links"
    });
    (0, $cozmU.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    const hasEditPermission = data?.publicLinkPermissionsForObject?.permissions?.includes((0, $j0YKV.PublicLinkPermissionsType).EDIT) ?? false;
    return loading ? {
        isLoading: true,
        refetch: refetch
    } : {
        isLoading: false,
        error: error,
        refetch: refetch,
        data: error ? undefined : {
            hasEditPermission: hasEditPermission,
            permissions: data?.publicLinkPermissionsForObject?.permissions ?? []
        }
    };
};
module.exports["usePublicLinkPermissionsForObject"] = $6b8bec8977e1e896$export$c2d35981ca787f77;

});

parcelRegister("8lkfF", function(module, exports) {
/**
 * @generated SignedSource<<b2f7222ee25d0f3ae1bf362da6a46d5f>>
 * @relayHash f71176804f0f8510a7464cc538777917
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1
const $5d187f97ac5d0d36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "objectId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "objectType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "objectId",
                    "variableName": "objectId"
                },
                {
                    "kind": "Variable",
                    "name": "objectType",
                    "variableName": "objectType"
                }
            ],
            "concreteType": "PublicLinkPermissions",
            "kind": "LinkedField",
            "name": "publicLinkPermissionsForObject",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "permissions"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f71176804f0f8510a7464cc538777917",
            "id": "52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1",
            "metadata": {},
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "operationKind": "query",
            "text": "query usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery($objectId:ID!,$objectType:PublicLinkPermissionsObjectType!){publicLinkPermissionsForObject(objectId:$objectId,objectType:$objectType){permissions}}"
        }
    };
}();
$5d187f97ac5d0d36$var$node.hash = "374477f8db79649c77f638ae2ac0ca9b";
var $5d187f97ac5d0d36$export$2e2bcd8739ae039 = $5d187f97ac5d0d36$var$node;
module.exports["default"] = $5d187f97ac5d0d36$export$2e2bcd8739ae039;

});

parcelRegister("j0YKV", function(module, exports) {
/**
 * @generated SignedSource<<f0cd509e142f69bcae46da270cdbb1c1>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d2563be1c2ded005$export$fcb2676e4c5b8efd = /*#__PURE__*/ function(PublicLinkPermissionsObjectType) {
    PublicLinkPermissionsObjectType["CONTENT"] = "CONTENT";
    return PublicLinkPermissionsObjectType;
}({});
var $d2563be1c2ded005$export$1d899d09218cc934 = /*#__PURE__*/ function(PublicLinkPermissionsType) {
    PublicLinkPermissionsType["EDIT"] = "EDIT";
    return PublicLinkPermissionsType;
}({});
module.exports["PublicLinkPermissionsObjectType"] = $d2563be1c2ded005$export$fcb2676e4c5b8efd;
module.exports["PublicLinkPermissionsType"] = $d2563be1c2ded005$export$1d899d09218cc934;

});

parcelRegister("gqypm", function(module, exports) {

var $CIjCq = parcelRequire("CIjCq");


var $f7MuR = parcelRequire("f7MuR");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ skip: skip, fetchPolicy: fetchPolicy })=>{
    const traitsResult = (0, $f7MuR.useSiteUserTraits)({
        skip: skip,
        fetchPolicy: fetchPolicy
    });
    const adaptedData = traitsResult.data !== null ? {
        experimentalSiteUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(traitsResult.data.attributes)
        }
    } : undefined;
    return {
        data: adaptedData,
        loading: traitsResult.loading,
        error: traitsResult.error ?? undefined
    };
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("04VgG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $47a3fe800ce35819$export$77dedcd16f070a20 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7obd3",
    name: "ReadTime",
    loader: async ()=>(await (parcelRequire("4Xn71"))).ReadTime
});
module.exports["ReadTime"] = $47a3fe800ce35819$export$77dedcd16f070a20;

});

parcelRegister("4Xn71", function(module, exports) {

let $39be99b93cbc1846$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $39be99b93cbc1846$var$load("7wYa9"),
    $39be99b93cbc1846$var$load("irgIM")
]).then(()=>parcelRequire('cbZqw'));

});

parcelRegister("jkVM2", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5f9bfd31a6a2d08f$export$2791e79b1a186ba4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CFAQV",
    name: "EditorContentState",
    loader: async ()=>(await (parcelRequire("9ndkG"))).EditorContentState
});
module.exports["EditorContentState"] = $5f9bfd31a6a2d08f$export$2791e79b1a186ba4;

});

parcelRegister("9ndkG", function(module, exports) {

let $01c2d9340c4c4abe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $01c2d9340c4c4abe$var$load("dgerE"),
    $01c2d9340c4c4abe$var$load("el56J"),
    $01c2d9340c4c4abe$var$load("hhss7"),
    $01c2d9340c4c4abe$var$load("9cpj1"),
    $01c2d9340c4c4abe$var$load("aC3bY"),
    $01c2d9340c4c4abe$var$load("ljCe8")
]).then(()=>parcelRequire('iDxDj'));

});

parcelRegister("6MSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9387550ed869acb8$export$4242cfff65d64b16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M3-19",
    name: "RestrictedPage",
    loader: async ()=>(await (parcelRequire("cPSsQ"))).RestrictedPage
});
module.exports["RestrictedPage"] = $9387550ed869acb8$export$4242cfff65d64b16;

});

parcelRegister("cPSsQ", function(module, exports) {

let $95847ef03231a1cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $95847ef03231a1cd$var$load("dgerE"),
    $95847ef03231a1cd$var$load("6wr18"),
    $95847ef03231a1cd$var$load("ffEVr"),
    $95847ef03231a1cd$var$load("2tyj0"),
    $95847ef03231a1cd$var$load("fEWss"),
    $95847ef03231a1cd$var$load("ceGPg"),
    $95847ef03231a1cd$var$load("7EorR"),
    $95847ef03231a1cd$var$load("hhss7"),
    $95847ef03231a1cd$var$load("2OcM6"),
    $95847ef03231a1cd$var$load("kUiwW")
]).then(()=>parcelRequire('3kPYw'));

});

parcelRegister("dmDX7", function(module, exports) {

var $7NYI2 = parcelRequire("7NYI2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $7NYI2.default);
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId, preferPreloadedData: preferPreloadedData = false })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $cozmU.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: preferPreloadedData ? 'cache-first' : 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        },
        __callerPackage__: "access-requests"
    });
    // SSR-safe resolution signal, for consumers that render on the server. `true` as soon as the
    // answer is available in the store on the current render — including the server render, when the
    // result was SSR-preloaded and read via `cache-first`. Unlike `isLoadingForFirstTime`, this lets an
    // SSR consumer render the resolved copy directly into the server HTML.
    const isPendingRequestResolvedForSSR = shouldSkip || data !== undefined;
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime,
        isPendingRequestResolvedForSSR: isPendingRequestResolvedForSSR
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("7NYI2", function(module, exports) {
/**
 * @generated SignedSource<<4d7ccfc95dff4e3b611db90e9453df55>>
 * @relayHash f8787096f4d42896880d52d9cbd4670c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9
const $3cde78eca68e7b16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f8787096f4d42896880d52d9cbd4670c",
            "id": "ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9",
            "metadata": {},
            "name": "usePendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query usePendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3cde78eca68e7b16$var$node.hash = "4d877c3ca505e954e3d6f173f1138ce0";
var $3cde78eca68e7b16$export$2e2bcd8739ae039 = $3cde78eca68e7b16$var$node;
module.exports["default"] = $3cde78eca68e7b16$export$2e2bcd8739ae039;

});

parcelRegister("f3euL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $1UCmC = parcelRequire("1UCmC");

const $af526147f97ee327$export$dcb53e05895a448a = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.INACCESSIBLE_PAGE_LOAD_KEY)
});
module.exports["INACCESSIBLE_PAGE_LOAD"] = $af526147f97ee327$export$dcb53e05895a448a;

});

parcelRegister("iVU5h", function(module, exports) {
const $6269d9b82324487a$export$42ca032027818031 = ()=>{
    return new URLSearchParams(window.location.search).get('amn-referral-source') || '';
};
module.exports["getAMNReferralSourceFromQueryParam"] = $6269d9b82324487a$export$42ca032027818031;

});

parcelRegister("iSXh4", function(module, exports) {

var $9VdrT = parcelRequire("9VdrT");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $5ZqQS = parcelRequire("5ZqQS");

const $270f2eb7bad14df2$var$createAriId = (cloudId, pageId)=>`ari:cloud:confluence:${cloudId}:page/${pageId}`;
const $270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery = (0, $9VdrT.default);
const $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey = 'isAutomatedMeetingNotes';
const $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey = 'meetingRecurrenceAri';
const $270f2eb7bad14df2$export$d2c3b4dbe2618d37 = (pageId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery, {
        variables: {
            pageAri: $270f2eb7bad14df2$var$createAriId(cloudId, pageId)
        },
        __callerPackage__: "automated-meeting-notes"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    return {
        isLoading: loading,
        ...$270f2eb7bad14df2$export$1607cf22d9dbad(data)
    };
};
const $270f2eb7bad14df2$export$1607cf22d9dbad = (data)=>{
    const pageProperties = data?.page?.properties?.nodes;
    const amnProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey);
    const recurrenceProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey);
    const isAMN = amnProperty?.value === 'true';
    const isRecurringParent = recurrenceProperty != undefined;
    const isLiveAMNPage = data?.page?.subType?.toLowerCase() === 'live' && isAMN;
    return {
        isAMN: isAMN,
        isRecurringParent: isRecurringParent,
        isLiveAMNPage: isLiveAMNPage
    };
};
module.exports["useAutomatedMeetingNotesPageProperties"] = $270f2eb7bad14df2$export$d2c3b4dbe2618d37;
module.exports["extractAmnPageProperties"] = $270f2eb7bad14df2$export$1607cf22d9dbad;

});

parcelRegister("9VdrT", function(module, exports) {
/**
 * @generated SignedSource<<c55748e87ec72b47f4575a0869b376cf>>
 * @relayHash 2d27dcc1d1eac2731f01ec3e79c7f7d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd
const $2aa10c7c748cb29a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageAri"
                }
            ],
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "keys",
                            "value": [
                                "isAutomatedMeetingNotes",
                                "meetingRecurrenceAri"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"])"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2d27dcc1d1eac2731f01ec3e79c7f7d9",
            "id": "bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd",
            "metadata": {},
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "operationKind": "query",
            "text": "query useAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"]){nodes{key,value}},subType,id}}"
        }
    };
}();
$2aa10c7c748cb29a$var$node.hash = "a7e1d622b5e3dfb0202b4f6045de22bd";
var $2aa10c7c748cb29a$export$2e2bcd8739ae039 = $2aa10c7c748cb29a$var$node;
module.exports["default"] = $2aa10c7c748cb29a$export$2e2bcd8739ae039;

});

parcelRegister("7r2px", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $0bdd6e0a6db7c960$var$logger = (0, $7W8i8.getLogger)('retrieveContentExtensionMetrics');
const $0bdd6e0a6db7c960$export$1fa8ce0cc2ea267e = 10;
const $0bdd6e0a6db7c960$export$5da22daff5be7fe6 = (contentBody)=>{
    try {
        const contentExtensionMetrics = {
            contentExtensionCount: {
                connect: {},
                forge: {}
            },
            contentExtensionKeys: {
                connect: [],
                forge: []
            },
            depth: {
                connect: [],
                forge: []
            },
            hasExtensions: false
        };
        const document = JSON.parse(contentBody);
        const visit = (node)=>{
            $0bdd6e0a6db7c960$export$bd4248834ea73a5(node, contentExtensionMetrics);
        };
        document?.content?.forEach(visit);
        return contentExtensionMetrics;
    } catch  {
        $0bdd6e0a6db7c960$var$logger.error`Unable to parse ADF`;
        return {};
    }
};
const $0bdd6e0a6db7c960$export$bd4248834ea73a5 = (node, contentExtensionMetrics, depth)=>{
    $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode(node, contentExtensionMetrics.contentExtensionCount);
    $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode(node, contentExtensionMetrics.contentExtensionKeys);
    if (depth !== undefined) $0bdd6e0a6db7c960$var$retrieveContentExtensionDepthFromNode(node, contentExtensionMetrics.depth, depth);
    contentExtensionMetrics.hasExtensions = contentExtensionMetrics.contentExtensionKeys?.connect.length > 0 || contentExtensionMetrics.contentExtensionKeys?.forge.length > 0;
    return contentExtensionMetrics;
};
function $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode({ attrs: attrs, type: type }, contentExtensionKeys) {
    if (attrs && type) {
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs;
        if (extensionType === 'com.atlassian.ecosystem' && extensionKey) contentExtensionKeys.forge.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.macro.core' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.migration' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else return;
    }
}
function $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode({ attrs: attrs, type: type }, contentExtensionCount) {
    if (attrs && type) {
        const { extensionType: extensionType } = attrs;
        let extensionsObj;
        if (extensionType === 'com.atlassian.ecosystem') extensionsObj = contentExtensionCount.forge;
        else if (extensionType === 'com.atlassian.confluence.macro.core') extensionsObj = contentExtensionCount.connect;
        else if (extensionType === 'com.atlassian.confluence.migration') extensionsObj = contentExtensionCount.connect;
        else return;
        if (extensionsObj) extensionsObj[type] = (extensionsObj[type] || 0) + 1;
    }
}
function $0bdd6e0a6db7c960$var$retrieveContentExtensionDepthFromNode({ attrs: attrs, type: type }, contentExtensionDepth, depth) {
    if (attrs && type) {
        const { extensionType: extensionType } = attrs;
        if (extensionType === 'com.atlassian.ecosystem') contentExtensionDepth.forge.push(depth);
        else if (extensionType === 'com.atlassian.confluence.macro.core' || extensionType === 'com.atlassian.confluence.migration') contentExtensionDepth.connect.push(depth);
    }
}
module.exports["retrieveContentExtensionMetrics"] = $0bdd6e0a6db7c960$export$5da22daff5be7fe6;
module.exports["retrieveContentExtensionMetricsFromNode"] = $0bdd6e0a6db7c960$export$bd4248834ea73a5;

});

parcelRegister("juCeZ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $9Z1sw = parcelRequire("9Z1sw");

const $816e839f3c4509f6$export$b3d89882591ee965 = ({ contentId: contentId, location: location })=>{
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: location
        },
        skip: Boolean(batchResult)
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first',
        __callerPackage__: "web-panel-location"
    });
    const panels = batchResult?.data?.webPanels || data?.webPanels || [];
    return panels.map((panel)=>panel?.moduleKey).join(',');
};
module.exports["useConnectAppsData"] = $816e839f3c4509f6$export$b3d89882591ee965;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");

var $esV19 = parcelRequire("esV19");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $6Mfv2.default)((0, $gkHoc.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $esV19.default)(cutoffDate) ? (0, $6Mfv2.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("7N1sB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lpNn5 = parcelRequire("lpNn5");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $6mKj3 = parcelRequire("6mKj3");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $aJPUt = parcelRequire("aJPUt");


var $9QIM2 = parcelRequire("9QIM2");


var $e4o8D = parcelRequire("e4o8D");


var $666Tc = parcelRequire("666Tc");

const $c0db869228662b46$var$i18n = (0, $kSwu1.defineMessages)({
    nextCommentLabel: {
        id: "inline-comments-common.next-comment-label",
        defaultMessage: "Next comment"
    },
    previousCommentLabel: {
        id: "inline-comments-common.previous-comment-label",
        defaultMessage: "Previous comment"
    },
    nextAnnotationLabel: {
        id: "inline-comments-common.next-annotation-label",
        defaultMessage: "Next"
    },
    previousAnnotationLabel: {
        id: "inline-comments-common.previous-annotation-label",
        defaultMessage: "Previous"
    }
});
const $c0db869228662b46$export$c7f093fedf3e73fe = (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    const { isSSRFocusedComment: isSSRFocusedComment, goToNextInlineComment: goToNextInlineComment, goToPrevInlineComment: goToPrevInlineComment } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const t2 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT) : (0, $gnkil.PREV_COMMENT_SHORTCUT);
    let t3;
    if ($[0] !== t2) {
        t3 = {
            shortcut: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const prevCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t3);
    const t4 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT) : (0, $gnkil.NEXT_COMMENT_SHORTCUT);
    let t5;
    if ($[2] !== t4) {
        t5 = {
            shortcut: t4
        };
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    const nextCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t5);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const noop = $c0db869228662b46$var$_temp;
    const isPageOrDoc = pageClass === "renderer" || pageClass === "editor";
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.previousAnnotationLabel : $c0db869228662b46$var$i18n.previousCommentLabel);
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.previousAnnotationLabel : $c0db869228662b46$var$i18n.previousCommentLabel;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== formatMessage) {
        t8 = formatMessage(t7);
        $[6] = formatMessage;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            label: t8,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== experienceTracker || $[11] !== goToPrevInlineComment || $[12] !== isPageOrDoc || $[13] !== isSSRFocusedComment || $[14] !== pageClass) {
        t10 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to previous comment via button.");
            return goToPrevInlineComment();
        } : noop;
        $[10] = experienceTracker;
        $[11] = goToPrevInlineComment;
        $[12] = isPageOrDoc;
        $[13] = isSSRFocusedComment;
        $[14] = pageClass;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== isSSRFocusedComment || $[17] !== t10 || $[18] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-previous",
            testId: "comment-navigation-prev",
            iconBefore: t9,
            onClick: t10
        });
        $[16] = isSSRFocusedComment;
        $[17] = t10;
        $[18] = t9;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== prevCommentShortcutStrings || $[21] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t6,
            shortcut: prevCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t11);
        $[20] = prevCommentShortcutStrings;
        $[21] = t11;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.nextAnnotationLabel : $c0db869228662b46$var$i18n.nextCommentLabel);
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.nextAnnotationLabel : $c0db869228662b46$var$i18n.nextCommentLabel;
        $[24] = t14;
    } else t14 = $[24];
    let t15;
    if ($[25] !== formatMessage) {
        t15 = formatMessage(t14);
        $[25] = formatMessage;
        $[26] = t15;
    } else t15 = $[26];
    let t16;
    if ($[27] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: t15,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[27] = t15;
        $[28] = t16;
    } else t16 = $[28];
    let t17;
    if ($[29] !== experienceTracker || $[30] !== goToNextInlineComment || $[31] !== isPageOrDoc || $[32] !== isSSRFocusedComment || $[33] !== pageClass) {
        t17 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to next comment via button.");
            return goToNextInlineComment();
        } : noop;
        $[29] = experienceTracker;
        $[30] = goToNextInlineComment;
        $[31] = isPageOrDoc;
        $[32] = isSSRFocusedComment;
        $[33] = pageClass;
        $[34] = t17;
    } else t17 = $[34];
    let t18;
    if ($[35] !== isSSRFocusedComment || $[36] !== t16 || $[37] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-next",
            testId: "comment-navigation-next",
            iconBefore: t16,
            onClick: t17
        });
        $[35] = isSSRFocusedComment;
        $[36] = t16;
        $[37] = t17;
        $[38] = t18;
    } else t18 = $[38];
    let t19;
    if ($[39] !== nextCommentShortcutStrings || $[40] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t13,
            shortcut: nextCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t18);
        $[39] = nextCommentShortcutStrings;
        $[40] = t18;
        $[41] = t19;
    } else t19 = $[41];
    let t20;
    if ($[42] !== renderServerPlaceholder) {
        t20 = renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            id: "inline-comment-index"
        }) : null;
        $[42] = renderServerPlaceholder;
        $[43] = t20;
    } else t20 = $[43];
    let t21;
    if ($[44] !== t12 || $[45] !== t19 || $[46] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.NavigationContainer), {
            "data-testid": "comment-navigation-container"
        }, t12, t19, t20);
        $[44] = t12;
        $[45] = t19;
        $[46] = t20;
        $[47] = t21;
    } else t21 = $[47];
    return t21;
};
function $c0db869228662b46$var$_temp() {}
module.exports["CommentNavigation"] = $c0db869228662b46$export$c7f093fedf3e73fe;

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    if (!contentId) return null;
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'slide':
            return (0, $1NBp8.SLIDES_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("IxgpR", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $bQm3c = parcelRequire("bQm3c");

const $0e9e4b59a5aca70c$var$isLocaleStringEnglish = (locale = '')=>{
    const englishPrefix = 'en';
    return locale.toLowerCase().startsWith(englishPrefix);
};
const $0e9e4b59a5aca70c$export$c43edf0c6374359f = ({ localeChecks: localeChecks = [
    'session',
    'intl'
] } = {})=>{
    const { locale: intlLocale = '' } = (0, $kSwu1.useIntl)() || {};
    const { locale: sessionLocale = '' } = (0, $bQm3c.useSessionData)() || {};
    const localeCheckers = {
        session: ()=>$0e9e4b59a5aca70c$var$isLocaleStringEnglish(sessionLocale),
        intl: ()=>$0e9e4b59a5aca70c$var$isLocaleStringEnglish(intlLocale)
    };
    return localeChecks.every((check)=>localeCheckers[check]());
};
module.exports["useCheckIsLocaleEnglish"] = $0e9e4b59a5aca70c$export$c43edf0c6374359f;

});

parcelRegister("kymtV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kcIQr = parcelRequire("kcIQr");


var $8aF6s = parcelRequire("8aF6s");


var $jBejw = parcelRequire("jBejw");


var $gsAuf = parcelRequire("gsAuf");

const $9bfe716549ab8714$export$1ec43e43e3a28820 = ()=>{
    const { createAndResolve: createAndResolve, loading: loading } = (0, $gsAuf.useCreatePagePdfExportTask)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const startExport = (0, $cozmU.useCallback)(async ({ contentId: contentId, contentType: contentType, url: url, source: source = 'menu' })=>{
        const commonAttributes = {
            contentId: contentId,
            contentType: contentType ?? null,
            exportSource: source
        };
        // One track event per create attempt (funnel entry for every surface, including legacy which
        // opens no modal) carrying the resolved decision and backend error code. Shared by the
        // initial run and "Try again" so both are instrumented identically.
        const runCreate = async ()=>{
            const result = await createAndResolve(contentId, contentType);
            if (result.type === 'error') createEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'pagePdfExport',
                    action: 'failed',
                    actionSubject: 'pagePdfExportCreate',
                    attributes: {
                        ...commonAttributes,
                        decision: 'error',
                        reason: result.reason,
                        errorCode: result.errorCode ?? null,
                        statusCode: result.statusCode ?? null
                    }
                }
            }).fire();
            else createEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'pagePdfExport',
                    action: 'succeeded',
                    actionSubject: 'pagePdfExportCreate',
                    attributes: {
                        ...commonAttributes,
                        decision: result.type,
                        exportTaskId: result.type === 'modal' ? result.exportTaskId ?? null : null
                    }
                }
            }).fire();
            return result;
        };
        // Real "Try again": re-run the same create flow. Defined once here so the overflow menu and
        // the Cmd/Ctrl+P shortcut share identical retry behaviour. A legacy decision navigates to
        // the hidden-action URL as a side effect; the modal maps modal/error decisions itself.
        const onRetry = async ()=>{
            const retryDecision = await runCreate();
            if (retryDecision.type === 'legacy' && url) window.location.assign(url);
            return retryDecision;
        };
        const decision = await runCreate();
        switch(decision.type){
            case 'legacy':
                // V1/V2: navigate to the hidden-action URL when the caller provided one. Callers that
                // own their own legacy fallback (e.g. the print shortcut) omit `url`, and act on the
                // returned `legacy` decision instead.
                if (url) window.location.assign(url);
                break;
            case 'modal':
                showModal((0, $jBejw.PagePdfExportModal), {
                    contentId: contentId,
                    contentType: contentType,
                    exportTaskId: decision.exportTaskId,
                    source: source,
                    onRetry: onRetry
                });
                break;
            case 'error':
            default:
                // Open the modal in its built-in error state (null task id); "Try again" re-runs create.
                showModal((0, $jBejw.PagePdfExportModal), {
                    contentId: contentId,
                    contentType: contentType,
                    exportTaskId: null,
                    source: source,
                    onRetry: onRetry
                });
                break;
        }
        return decision;
    }, [
        createAndResolve,
        createEvent,
        showModal
    ]);
    return {
        startExport: startExport,
        loading: loading
    };
};
module.exports["useStartPagePdfExport"] = $9bfe716549ab8714$export$1ec43e43e3a28820;

});

parcelRegister("jBejw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e57c66f2698c5617$export$d106071c054f3436 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "1xkUz",
    name: "PagePdfExportModal",
    loader: async ()=>(await (parcelRequire("fFymS"))).PagePdfExportModal
});
module.exports["PagePdfExportModal"] = $e57c66f2698c5617$export$d106071c054f3436;

});

parcelRegister("fFymS", function(module, exports) {

let $b6855824264dbce4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b6855824264dbce4$var$load("6wr18"),
    $b6855824264dbce4$var$load("ffEVr"),
    $b6855824264dbce4$var$load("ccAQf"),
    $b6855824264dbce4$var$load("oKrxj")
]).then(()=>parcelRequire('liWq5'));

});

parcelRegister("gsAuf", function(module, exports) {

var $fM8Mx = parcelRequire("fM8Mx");


var $cozmU = parcelRequire("cozmU");


var $gsyiL = parcelRequire("gsyiL");

var $6B1vK = parcelRequire("6B1vK");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $b0AwI = parcelRequire("b0AwI");

/**
 * The `contentId` mutation input is typed `ID!` but the backend expects a type-specific Confluence
 * content ARI — `blogpost/…` for blogposts, `page/…` for everything else. Live docs are
 * `contentType === 'page'`, so they correctly resolve to a page ARI.
 */ const $01eed5ca3125a453$var$buildContentAri = (cloudId, contentId, contentType)=>contentType === 'blogpost' ? (0, $gsyiL.ConfluenceBlogpostAri).create({
        siteId: cloudId,
        blogpostId: contentId
    }).toString() : (0, $6B1vK.ConfluencePageAri).create({
        siteId: cloudId,
        pageId: contentId
    }).toString();
const $01eed5ca3125a453$var$CREATE_PDF_EXPORT_TASK_MUTATION = (0, $fM8Mx.default);
const $01eed5ca3125a453$export$c9155252c3ac4484 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [createTask, { loading: loading }] = (0, $308Wd.useMutationInterop)($01eed5ca3125a453$var$CREATE_PDF_EXPORT_TASK_MUTATION, {
        __callerPackage__: "page-pdf-export"
    });
    const createAndResolve = (0, $cozmU.useCallback)(async (contentId, contentType)=>{
        let createResult;
        try {
            const result = await createTask({
                variables: {
                    contentId: $01eed5ca3125a453$var$buildContentAri(cloudId, contentId, contentType)
                }
            });
            const payload = result?.data?.confluence_createPdfExportTaskForSingleContent;
            createResult = payload ? {
                success: payload.success,
                exportVersion: payload.exportVersion,
                exportTaskId: payload.exportTaskId,
                errors: payload.errors?.map((error)=>({
                        message: error?.message ?? null,
                        extensions: error?.extensions ? {
                            errorType: error.extensions.errorType ?? null,
                            statusCode: error.extensions.statusCode ?? null
                        } : null
                    })) ?? null
            } : undefined;
        } catch (error) {
            createResult = undefined;
        }
        return (0, $b0AwI.resolvePagePdfExportCreateResult)({
            createResult: createResult,
            isExperimentEnabled: true
        });
    }, [
        createTask,
        cloudId
    ]);
    return {
        createAndResolve: createAndResolve,
        loading: loading
    };
};
module.exports["useCreatePagePdfExportTask"] = $01eed5ca3125a453$export$c9155252c3ac4484;

});

parcelRegister("fM8Mx", function(module, exports) {
/**
 * @generated SignedSource<<a3e608f92169bde9e02a07e39432e594>>
 * @relayHash 96dce17396b98402ea852d82fd7ba6ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0cc26de84f1d64f1941793801db3e6df205067025012647431441512d2deafb8
const $3b0cc2b76685a2ca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "exportTaskId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "exportVersion"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCreatePagePdfExportTaskMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceCreatePdfExportTaskForSingleContentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createPdfExportTaskForSingleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCreatePagePdfExportTaskMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceCreatePdfExportTaskForSingleContentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createPdfExportTaskForSingleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "96dce17396b98402ea852d82fd7ba6ba",
            "id": "0cc26de84f1d64f1941793801db3e6df205067025012647431441512d2deafb8",
            "metadata": {},
            "name": "useCreatePagePdfExportTaskMutation",
            "operationKind": "mutation",
            "text": "mutation useCreatePagePdfExportTaskMutation($contentId:ID!){confluence_createPdfExportTaskForSingleContent(input:{contentId:$contentId}){success,exportTaskId,exportVersion,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$3b0cc2b76685a2ca$var$node.hash = "744df54379316c281f95d3307db18404";
var $3b0cc2b76685a2ca$export$2e2bcd8739ae039 = $3b0cc2b76685a2ca$var$node;
module.exports["default"] = $3b0cc2b76685a2ca$export$2e2bcd8739ae039;

});

parcelRegister("b0AwI", function(module, exports) {
const $da9c7f91e4b9420f$export$3ccc38d5bb117541 = ({ createResult: createResult, isExperimentEnabled: isExperimentEnabled })=>{
    if (!createResult || createResult.success === false || Boolean(createResult.errors?.length)) {
        const errorCode = createResult?.errors?.map((error)=>error?.extensions?.errorType).find((value)=>Boolean(value)) ?? null;
        const statusCode = createResult?.errors?.map((error)=>error?.extensions?.statusCode).find((value)=>value != null) ?? null;
        return {
            type: 'error',
            reason: 'create-failed',
            errorCode: errorCode,
            statusCode: statusCode
        };
    }
    if (!isExperimentEnabled) return {
        type: 'legacy'
    };
    switch(createResult.exportVersion){
        case 'V1':
        case 'V2':
            return {
                type: 'legacy'
            };
        case 'V3':
            return {
                type: 'modal',
                exportTaskId: createResult.exportTaskId
            };
        default:
            return {
                type: 'error',
                reason: 'unsupported-export-version'
            };
    }
};
module.exports["resolvePagePdfExportCreateResult"] = $da9c7f91e4b9420f$export$3ccc38d5bb117541;

});

parcelRegister("lOI2p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $d8ad782c0a3406d7$export$8cca2d6324f11821 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onClose: onClose, popupRef: popupRef, triggerRef: triggerRef } = t0;
    let t1;
    let t2;
    if ($[0] !== onClose || $[1] !== popupRef || $[2] !== triggerRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const keyDownEvent = (t3)=>{
                const { key: key } = t3;
                if (key === "Escape" || key === "Esc") onClose();
            };
            const clickEvent = (event)=>{
                if (!document.body.contains(event.target)) return;
                if (popupRef && popupRef.contains(event.target)) return;
                if (triggerRef && triggerRef.contains(event.target)) return;
                if (event.target.closest(".atlaskit-portal-container [role=dialog]")) return;
                onClose();
            };
            window.addEventListener("click", clickEvent);
            window.addEventListener("keydown", keyDownEvent);
            return ()=>{
                window.removeEventListener("click", clickEvent);
                window.removeEventListener("keydown", keyDownEvent);
            };
        };
        t2 = [
            popupRef,
            triggerRef,
            onClose
        ];
        $[0] = onClose;
        $[1] = popupRef;
        $[2] = triggerRef;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ onClose: onClose, popupRef: popupRef, triggerRef: triggerRef })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!popupRef) return;
        const keyDownEvent = ({ key: key })=>{
            if (key === 'Escape' || key === 'Esc') onClose();
        };
        const clickEvent = (event)=>{
            // Refresh button inside Forge app triggers earlier then clickEvent
            // Forge App starts update and popup does not have event.target anymore
            if (!document.body.contains(event.target)) return;
            // Do not close if interaction was performed on the current popup
            if (popupRef && popupRef.contains(event.target)) return;
            // Do not close if interaction was performed on the trigger container
            if (triggerRef && triggerRef.contains(event.target)) return;
            // Do not close if interaction was performed on the ModalDialog with an error
            if (event.target.closest('.atlaskit-portal-container [role=dialog]')) return;
            onClose();
        };
        window.addEventListener('click', clickEvent);
        window.addEventListener('keydown', keyDownEvent);
        return ()=>{
            window.removeEventListener('click', clickEvent);
            window.removeEventListener('keydown', keyDownEvent);
        };
    }, [
        popupRef,
        triggerRef,
        onClose
    ]);
};
module.exports["useInlineDialogCloseManager"] = $d8ad782c0a3406d7$export$8cca2d6324f11821;

});

parcelRegister("jYZsR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

const $0b4c17fd4adf87fd$export$de5a461d22cbfa90 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { onUpdate: onUpdate, popupRef: popupRef, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== onUpdate || $[1] !== popupRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(onUpdate, 100);
            const observer = new ResizeObserver(()=>{
                updateWithDelay();
            });
            observer.observe(popupRef);
            return ()=>{
                observer.disconnect();
            };
        };
        t2 = [
            popupRef,
            onUpdate
        ];
        $[0] = onUpdate;
        $[1] = popupRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[4] = children;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ onUpdate: onUpdate, popupRef: popupRef, children: children })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!popupRef) return;
        const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(onUpdate, 100);
        // Workaround to update popup position (by using scheduleUpdate function)
        // on any Forge App resize
        const observer = new ResizeObserver(()=>{
            updateWithDelay();
        });
        observer.observe(popupRef);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupRef,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
};
module.exports["ResizeChangeListener"] = $0b4c17fd4adf87fd$export$de5a461d22cbfa90;

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("hdxAi", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2d2e882c9a90b3be$var$getInitialState = ()=>({
        deletedMentions: [],
        addedMentions: [],
        deletedTasks: [],
        addedTasks: [],
        unrestrictedMentions: [],
        //Added mentions which have access to the current page
        parentSpaceRestrictedMentions: [],
        //Added mentions which dont have access to the current page due to parent or space restrictions
        pageRestrictedMentions: [],
        //Added mentions which dont have access to the current page due to page restrictions
        unrestrictedTasks: [],
        //Added task mentions which have access to the current page
        parentSpaceRestrictedTasks: [],
        //Added task mentions which dont have access to the current page due to parent or space restrictions
        pageRestrictedTasks: [],
        //Added task mentions which dont have access to the current page due to page restrictions
        editorApi: undefined,
        mentionsAdded: {
            currentUser: [],
            //Mentions of current user added by the current user
            otherUsers: [] //Mentions of other users added by the current user
        },
        tasksAdded: {
            currentUser: [],
            //Task mentions of current user added by the current user
            otherUsers: [] //Task mentions of other users added by the current user
        }
    });
const $2d2e882c9a90b3be$var$actions = {
    setDeletedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                deletedMentions: mentions
            });
        },
    setAddedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                addedMentions: mentions
            });
        },
    setUnrestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                unrestrictedMentions: mentions
            });
        },
    addUnrestrictedMentions: (addedUnrestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { unrestrictedMentions: unrestrictedMentions } = getState();
            const updatedUnrestrictedMentions = [
                ...unrestrictedMentions,
                ...addedUnrestrictedMentions
            ];
            setState({
                unrestrictedMentions: updatedUnrestrictedMentions
            });
        },
    removeUnrestrictedMentions: (removedUnrestrictedMention)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedUnrestrictedMention.map((mention)=>mention.localId));
            const { unrestrictedMentions: unrestrictedMentions } = getState();
            const updatedUnrestrictedMentions = unrestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                unrestrictedMentions: updatedUnrestrictedMentions
            });
        },
    setParentSpaceRestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                parentSpaceRestrictedMentions: mentions
            });
        },
    addParentSpaceRestrictedMentions: (addedParentSpaceRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { parentSpaceRestrictedMentions: parentSpaceRestrictedMentions } = getState();
            const updatedParentSpaceRestrictedMentions = [
                ...parentSpaceRestrictedMentions,
                ...addedParentSpaceRestrictedMentions
            ];
            setState({
                parentSpaceRestrictedMentions: updatedParentSpaceRestrictedMentions
            });
        },
    removeParentSpaceRestrictedMentions: (removedParentSpaceRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedParentSpaceRestrictedMentions.map((mention)=>mention.localId));
            const { parentSpaceRestrictedMentions: parentSpaceRestrictedMentions } = getState();
            const updatedParentSpaceRestrictedMentions = parentSpaceRestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                parentSpaceRestrictedMentions: updatedParentSpaceRestrictedMentions
            });
        },
    setPageRestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                pageRestrictedMentions: mentions
            });
        },
    addPageRestrictedMentions: (addedPageRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { pageRestrictedMentions: pageRestrictedMentions } = getState();
            const updatedPageRestrictedMention = [
                ...pageRestrictedMentions,
                ...addedPageRestrictedMentions
            ];
            setState({
                pageRestrictedMentions: updatedPageRestrictedMention
            });
        },
    removePageRestrictedMentions: (removedPageRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedPageRestrictedMentions.map((mention)=>mention.localId));
            const { pageRestrictedMentions: pageRestrictedMentions } = getState();
            const updatedPageRestrictedMention = pageRestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                pageRestrictedMentions: updatedPageRestrictedMention
            });
        },
    setDeletedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                deletedTasks: tasks
            });
        },
    setAddedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                addedTasks: tasks
            });
        },
    setPageRestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                pageRestrictedTasks: tasks
            });
        },
    addPageRestrictedTasks: (addedPageRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { pageRestrictedTasks: pageRestrictedTasks } = getState();
            const updatedPageRestrictedTasks = [
                ...pageRestrictedTasks,
                ...addedPageRestrictedTasks
            ];
            setState({
                pageRestrictedTasks: updatedPageRestrictedTasks
            });
        },
    removePageRestrictedTasks: (removedPageRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedPageRestrictedTasks.map((tasks)=>tasks.localId));
            const { pageRestrictedTasks: pageRestrictedTasks } = getState();
            const updatedPageRestrictedTasks = pageRestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                pageRestrictedTasks: updatedPageRestrictedTasks
            });
        },
    setParentSpaceRestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                parentSpaceRestrictedTasks: tasks
            });
        },
    addParentSpaceRestrictedTasks: (addedParentSpaceRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { parentSpaceRestrictedTasks: parentSpaceRestrictedTasks } = getState();
            const updatedParentSpaceRestrictedTasks = [
                ...parentSpaceRestrictedTasks,
                ...addedParentSpaceRestrictedTasks
            ];
            setState({
                parentSpaceRestrictedTasks: updatedParentSpaceRestrictedTasks
            });
        },
    removeParentSpaceRestrictedTasks: (removedParentSpaceRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedParentSpaceRestrictedTasks.map((tasks)=>tasks.localId));
            const { parentSpaceRestrictedTasks: parentSpaceRestrictedTasks } = getState();
            const updatedParentSpaceRestrictedTasks = parentSpaceRestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                parentSpaceRestrictedTasks: updatedParentSpaceRestrictedTasks
            });
        },
    setUnrestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                unrestrictedTasks: tasks
            });
        },
    addUnrestrictedTasks: (addedUnrestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { unrestrictedTasks: unrestrictedTasks } = getState();
            const updatedUnrestrictedTasks = [
                ...unrestrictedTasks,
                ...addedUnrestrictedTasks
            ];
            setState({
                unrestrictedTasks: updatedUnrestrictedTasks
            });
        },
    removeUnrestrictedTasks: (removedUnrestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedUnrestrictedTasks.map((tasks)=>tasks.localId));
            const { unrestrictedTasks: unrestrictedTasks } = getState();
            const updatedUnrestrictedTasks = unrestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                unrestrictedTasks: updatedUnrestrictedTasks
            });
        },
    setMentionsAdded: (mentionsToAdd)=>({ setState: setState, getState: getState })=>{
            const { mentionsAdded: mentionsAdded } = getState();
            const updatedMentionsAdded = mentionsAdded;
            if (mentionsToAdd.currentUser) {
                if (mentionsToAdd.currentUser.length > 0) {
                    const currentUserMentions = mentionsToAdd.currentUser;
                    updatedMentionsAdded.currentUser = [
                        ...currentUserMentions,
                        ...mentionsAdded.currentUser
                    ];
                } else updatedMentionsAdded.currentUser = [];
            }
            setState({
                mentionsAdded: updatedMentionsAdded
            });
        },
    setTasksAdded: (tasksToAdd)=>({ setState: setState, getState: getState })=>{
            const { tasksAdded: tasksAdded } = getState();
            const updatedTasksAdded = tasksAdded;
            if (tasksToAdd.currentUser) {
                if (tasksToAdd.currentUser.length > 0) {
                    const currentUserTasks = tasksToAdd.currentUser;
                    updatedTasksAdded.currentUser = [
                        ...currentUserTasks,
                        ...tasksAdded.currentUser
                    ];
                } else updatedTasksAdded.currentUser = [];
            }
            setState({
                tasksAdded: updatedTasksAdded
            });
        },
    clearMentionsFlags: ()=>({ setState: setState })=>{
            setState($2d2e882c9a90b3be$var$getInitialState());
        }
};
const $2d2e882c9a90b3be$var$MentionsNotificationsStore = (0, $8s9DV.createStore)({
    initialState: $2d2e882c9a90b3be$var$getInitialState(),
    actions: $2d2e882c9a90b3be$var$actions,
    name: 'MentionsNotificationsStore'
});
const $2d2e882c9a90b3be$export$63a7b4a5d3248013 = (0, $kBr4q.createHook)($2d2e882c9a90b3be$var$MentionsNotificationsStore);
const $2d2e882c9a90b3be$export$e03e9325d0a65293 = (0, $kBr4q.createActionsHook)($2d2e882c9a90b3be$var$MentionsNotificationsStore);
module.exports["useMentionsNotifications"] = $2d2e882c9a90b3be$export$63a7b4a5d3248013;
module.exports["useMentionsNotificationsActions"] = $2d2e882c9a90b3be$export$e03e9325d0a65293;

});

parcelRegister("gektR", function(module, exports) {

var $kNIYN = parcelRequire("kNIYN");


var $jVylI = parcelRequire("jVylI");

class $904056f857fff237$export$e38a13e9484b72c7 extends (0, $kNIYN.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
            isUpdatingAlignment: false,
            isLoadingComplete: false
        };
        this.toggleAlignmentButton = (newAlignmentState)=>{
            if (this.state.alignmentButtonState !== newAlignmentState) this.setState({
                alignmentButtonState: newAlignmentState || (0, $jVylI.TitleAlignmentType).LEFT
            });
        };
        this.setIsLoadingComplete = (isLoadingComplete)=>{
            this.setState({
                isLoadingComplete: isLoadingComplete
            });
        };
        this.setIsUpdatingAlignment = (isUpdatingAlignment)=>{
            this.setState({
                isUpdatingAlignment: isUpdatingAlignment
            });
        };
        this.resetToDefaults = ()=>{
            this.setState({
                alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
                isUpdatingAlignment: false,
                isLoadingComplete: false
            });
        };
    }
}
module.exports["AlignmentButtonContainer"] = $904056f857fff237$export$e38a13e9484b72c7;

});

parcelRegister("63EIj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36c7522a305dc07d$export$cbe74da24be93fbd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lwzlE",
    name: "RendererContentState",
    loader: async ()=>(await (parcelRequire("6dfkC"))).RendererContentState
});
module.exports["RendererContentState"] = $36c7522a305dc07d$export$cbe74da24be93fbd;

});

parcelRegister("6dfkC", function(module, exports) {

let $485fd97ccf08a985$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $485fd97ccf08a985$var$load("dgerE"),
    $485fd97ccf08a985$var$load("9opeZ")
]).then(()=>parcelRequire('44FvL'));

});

parcelRegister("dpqzw", function(module, exports) {
const $e10f62297c04a73f$export$51c8f3f20bd49804 = 'fabric-editor-popup-scroll-parent';
const $e10f62297c04a73f$export$547bf96576574b25 = '.ProseMirror > *';
const $e10f62297c04a73f$export$f76b40820c13783a = '.ak-renderer-document';
const $e10f62297c04a73f$export$7718f42d39a9217b = 'content';
module.exports["EDITOR_PARENT_CLASS"] = $e10f62297c04a73f$export$51c8f3f20bd49804;
module.exports["EDITOR_CHILDREN_SELECTOR"] = $e10f62297c04a73f$export$547bf96576574b25;
module.exports["RENDERED_CONTENT_SELECTOR"] = $e10f62297c04a73f$export$f76b40820c13783a;
module.exports["FABRIC_PAGE_CONTENT_ID"] = $e10f62297c04a73f$export$7718f42d39a9217b;

});

parcelRegister("gkIgp", function(module, exports) {
var $44e99c386783fe05$export$ea1a2a449eaeaa2d = /*#__PURE__*/ function(CollabServiceProperty) {
    CollabServiceProperty["NCS"] = "ncs";
    CollabServiceProperty["SYNCHRONY"] = "synchrony";
    return CollabServiceProperty;
}({});
module.exports["CollabServiceProperty"] = $44e99c386783fe05$export$ea1a2a449eaeaa2d;

});

parcelRegister("4ri4I", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $kBr4q.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $kBr4q.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("cmBjr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $bqMNb = parcelRequire("bqMNb");


var $jv3O2 = parcelRequire("jv3O2");


var $i9VoI = parcelRequire("i9VoI");

const $1c71f3d63aae3f56$export$b0544c15da22323d = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const showConvertToLivePageFlag = (0, $jv3O2.useShowConvertToLivePageFlag)({
        flags: flags
    });
    const onSubscriptionEvent = (0, $cozmU.useCallback)((response)=>{
        const { accountId: accountId, pageUpdated: pageUpdated } = response || {};
        const trigger = pageUpdated?.trigger;
        if (trigger !== 'convertToLiveEdit') return;
        showConvertToLivePageFlag({
            converterWasCurrentUser: accountId === userId
        });
        // When another user converts the page to a live doc, we need to add a query param to avoid the double action bar bug.
        // Without this, the page may read stale SSR values indicating it's not a live page, causing UI weirdness.
        // The query param forces RouteState to increment transitionId, preventing it from using initial SSR values.
        setQueryParams({
            [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
        });
    }, [
        showConvertToLivePageFlag,
        userId,
        setQueryParams
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'convertToLivePageFlag',
        contentId: contentId,
        delta: 'pageUpdated',
        contentType: 'page',
        skip: !contentId,
        onDataReceived: (response)=>onSubscriptionEvent(response)
    });
    return null;
});
module.exports["ConvertToLivePageFlag"] = $1c71f3d63aae3f56$export$b0544c15da22323d;

});

parcelRegister("kSPGK", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

class $5d6af3820d303892$var$OptimisticTitleChangeEventBus {
    emit(contentId, title) {
        if (this.listeners[contentId]) this.listeners[contentId].forEach((fn)=>{
            fn(title);
        });
    }
    subscribe(contentId, fn) {
        if (!this.listeners[contentId]) this.listeners[contentId] = [];
        this.listeners[contentId].push(fn);
    }
    unsubcribe(contentId, fn) {
        if (this.listeners[contentId]) {
            const index = this.listeners[contentId].findIndex((item)=>item[0] === fn);
            if (index !== -1) this.listeners[contentId].splice(index, 1);
        }
    }
    constructor(){
        this.listeners = void 0;
        this.listeners = {};
    }
}
const $5d6af3820d303892$var$optimisticTitleChangeEventBus = new $5d6af3820d303892$var$OptimisticTitleChangeEventBus();
const $5d6af3820d303892$export$255638cdf0226b65 = (contentId, initialTitle, onOptimisticUpdate)=>{
    const $ = (0, $bDgLe.c)(16);
    const [optimisticTitle, setOptimisticTitle] = (0, $cozmU.useState)(initialTitle);
    let t0;
    if ($[0] !== contentId || $[1] !== optimisticTitle) {
        t0 = (value)=>{
            if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
        };
        $[0] = contentId;
        $[1] = optimisticTitle;
        $[2] = t0;
    } else t0 = $[2];
    const publishOptimisticTitle = t0;
    let t1;
    if ($[3] !== contentId || $[4] !== onOptimisticUpdate) {
        t1 = (title)=>{
            setOptimisticTitle(title);
            onOptimisticUpdate && onOptimisticUpdate(contentId, title);
        };
        $[3] = contentId;
        $[4] = onOptimisticUpdate;
        $[5] = t1;
    } else t1 = $[5];
    const handleTitleChanged = t1;
    let t2;
    let t3;
    if ($[6] !== contentId || $[7] !== handleTitleChanged) {
        t2 = ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
            return ()=>{
                $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
            };
        };
        t3 = [
            contentId,
            handleTitleChanged
        ];
        $[6] = contentId;
        $[7] = handleTitleChanged;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[10] !== initialTitle) {
        t4 = ()=>{
            setOptimisticTitle(initialTitle);
        };
        t5 = [
            initialTitle
        ];
        $[10] = initialTitle;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[13] !== optimisticTitle || $[14] !== publishOptimisticTitle) {
        t6 = {
            optimisticTitle: optimisticTitle,
            setOptimisticTitle: publishOptimisticTitle
        };
        $[13] = optimisticTitle;
        $[14] = publishOptimisticTitle;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["useOptimisticTitleChange"] = $5d6af3820d303892$export$255638cdf0226b65;

});

parcelRegister("lfFzM", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim,
        __callerPackage__: "super-admin"
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("c4ECQ", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $e40ae21eed558c2b$export$91111a1ebace330 = /*#__PURE__*/ function(ContentRestrictionType) {
    ContentRestrictionType["NO_RESTRICTIONS"] = "NO_RESTRICTIONS";
    ContentRestrictionType["RESTRICT_EDIT"] = "RESTRICT_EDIT";
    ContentRestrictionType["RESTRICT_VIEW"] = "RESTRICT_VIEW";
    return ContentRestrictionType;
}({});
var $e40ae21eed558c2b$export$7602248773d1f745 = /*#__PURE__*/ function(RestrictionFrom) {
    RestrictionFrom["DIRECT"] = "DIRECT";
    RestrictionFrom["MULTIPLE"] = "MULTIPLE";
    RestrictionFrom["NONE"] = "NONE";
    RestrictionFrom["PAGE_INHERITED"] = "PAGE_INHERITED";
    RestrictionFrom["SPACE"] = "SPACE";
    return RestrictionFrom;
}({});
var $e40ae21eed558c2b$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["GROUP"] = "GROUP";
    EntityType["USER"] = "USER";
    return EntityType;
}({});
var $e40ae21eed558c2b$export$af2022a36dc13b47 = /*#__PURE__*/ function(PermissionType) {
    PermissionType["EDIT"] = "EDIT";
    PermissionType["VIEW"] = "VIEW";
    return PermissionType;
}({});
var $e40ae21eed558c2b$export$efe8384a5aa2f235 = /*#__PURE__*/ function(ErrorMessageType) {
    ErrorMessageType["NO_ANCESTOR_VIEW"] = "NO_ANCESTOR_VIEW";
    ErrorMessageType["NO_SPACE_VIEW"] = "NO_SPACE_VIEW";
    ErrorMessageType["NO_SPACE_EDIT"] = "NO_SPACE_EDIT";
    return ErrorMessageType;
}({});
var $e40ae21eed558c2b$export$4ecc254c2ddad822 = /*#__PURE__*/ function(OpenDialogType) {
    OpenDialogType["INSPECT_PERMISSIONS"] = "INSPECT_PERMISSIONS";
    OpenDialogType["ACCESS_DETAILS"] = "ACCESS_DETAILS";
    OpenDialogType["RESTRICTIONS"] = "RESTRICTIONS";
    OpenDialogType["PUBLIC_LINKS_VALIDATION"] = "PUBLIC_LINKS_VALIDATION";
    return OpenDialogType;
}({});
module.exports["ContentRestrictionType"] = $e40ae21eed558c2b$export$91111a1ebace330;
module.exports["RestrictionFrom"] = $e40ae21eed558c2b$export$7602248773d1f745;
module.exports["EntityType"] = $e40ae21eed558c2b$export$8eda7e02f8f033b2;
module.exports["PermissionType"] = $e40ae21eed558c2b$export$af2022a36dc13b47;
module.exports["ErrorMessageType"] = $e40ae21eed558c2b$export$efe8384a5aa2f235;
module.exports["OpenDialogType"] = $e40ae21eed558c2b$export$4ecc254c2ddad822;

});

parcelRegister("fG32j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");



var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
const $06e8bea7aad8a7b8$export$f1b4255eb8ae314e = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceRestrictionCheck(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId } = t0;
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== asSuperAdmin) {
        t1 = asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        };
        $[0] = asSuperAdmin;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = spaceKey || stateSpaceKey;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = {
            context: t1,
            errorPolicy: "all",
            variables: t3
        };
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        ...t4,
        __callerPackage__: "restrictions"
    });
    let t5;
    let t6;
    if ($[7] !== children || $[8] !== contentId || $[9] !== data || $[10] !== error || $[11] !== loading) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let isSpaceNotFound;
            let isSpaceRestricted;
            if (error) {
                isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
                isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
                if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (data) {
                const errorSwallowed = data.space === null;
                isSpaceNotFound = errorSwallowed && window.__SPACE_NOTFOUND_CHECK_ERROR__;
                isSpaceRestricted = errorSwallowed && window.__SPACE_RESTRICTED_CHECK_ERROR__;
            }
            if (loading) {
                t6 = null;
                break bb0;
            }
            const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.__SPACE_RESTRICTED_ERROR__ === contentId;
            t5 = children({
                error: error,
                isSpaceNotFound: isSpaceNotFound,
                isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
            });
        }
        $[7] = children;
        $[8] = contentId;
        $[9] = data;
        $[10] = error;
        $[11] = loading;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    return t5;
} : function SpaceRestrictionCheck({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        context: asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        },
        errorPolicy: 'all',
        variables: {
            // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
            // SpaceBaseComponent is not written in TypeScript and it may provide
            // undefined as it is reading spaceKey from redux. While it would result
            // in a better separation of concerns to have a fix in SpaceBaseComponent,
            // such a fix would be riskier.
            spaceKey: spaceKey || stateSpaceKey
        },
        __callerPackage__: "restrictions"
    });
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if (loading) return null;
    const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
    return children({
        error: error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
    });
};
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("lqy4C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $cozmU.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $8s9DV.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $kBr4q.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $kBr4q.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("ftFOj", function(module, exports) {

var $ieWRE = parcelRequire("ieWRE");


var $jtuBN = parcelRequire("jtuBN");


var $gZneu = parcelRequire("gZneu");

/** @schema cc */ const $46cf70134ef7593d$var$query = (0, $ieWRE.default);
const $46cf70134ef7593d$export$957cf4ab6fd3f58e = (spaceKey)=>{
    const isSmartFoldersSupported = (0, $gZneu.useIsSmartFoldersSupported)();
    const shouldSkipQuery = !isSmartFoldersSupported || !spaceKey;
    const { loading: loading, data: data } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($46cf70134ef7593d$var$query, {
        variables: {
            spaceKey: spaceKey ?? ''
        },
        skip: shouldSkipQuery,
        __callerPackage__: "smart-folder"
    });
    const enabledContentTypes = data?.space?.spaceTypeSettings?.enabledContentTypes;
    const isFoldersEnabledInSpace = enabledContentTypes?.isFoldersEnabled ?? false;
    const isSmartFoldersEnabledInSpace = enabledContentTypes?.isSmartFoldersEnabled ?? false;
    return {
        isSmartFoldersEnabled: isSmartFoldersSupported && isFoldersEnabledInSpace && isSmartFoldersEnabledInSpace,
        loading: loading
    };
};
module.exports["useIsSmartFoldersEnabled"] = $46cf70134ef7593d$export$957cf4ab6fd3f58e;

});

parcelRegister("gZneu", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $23af0ee2a39f4a09$export$4f0b8fcf328460ea = ()=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    return isRovoEnabled && (0, $6mKj3.expVal)('confluence_smart_folders_milestone_1', 'isEnabled', false);
};
module.exports["useIsSmartFoldersSupported"] = $23af0ee2a39f4a09$export$4f0b8fcf328460ea;

});

parcelRegister("sD2Tz", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9Vkdl = parcelRequire("9Vkdl");


var $1Gu3g = parcelRequire("1Gu3g");


var $4ri4I = parcelRequire("4ri4I");


var $6mKj3 = parcelRequire("6mKj3");


var $58PBI = parcelRequire("58PBI");

// predictive prefetch only runs in browser environments that expose the API.
// Evaluated lazily (as a function) so that test environments can mock window.matchMedia before it is checked.
const $f75716c2560aeeb6$var$getHasMatchMedia = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function'; // Copied from https://foresightjs.com/docs/react/hook
function $f75716c2560aeeb6$var$useForesight(options, enabled) {
    const $ = (0, $bDgLe.c)(5);
    const elementRef = (0, $cozmU.useRef)(null);
    const registerResults = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== enabled || $[1] !== options) {
        t0 = ()=>{
            if (!elementRef.current || !enabled) return;
            if (!$f75716c2560aeeb6$var$getHasMatchMedia()) return;
            (0, $9Vkdl.ForesightManager).initialize({
                enableMousePrediction: true,
                trajectoryPredictionTime: (0, $6mKj3.expVal)("platform_editor_predictive_collabdraft_prefetch", "trajectoryPredictionTime", 120),
                positionHistorySize: 8
            });
            const currentElement = elementRef.current;
            registerResults.current = (0, $9Vkdl.ForesightManager).instance.register({
                element: currentElement,
                ...options
            });
            return ()=>{
                (0, $9Vkdl.ForesightManager).instance?.unregister(currentElement, "useEffect");
            };
        };
        t1 = [
            options,
            enabled
        ];
        $[0] = enabled;
        $[1] = options;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            elementRef: elementRef,
            registerResults: registerResults
        };
        $[4] = t2;
    } else t2 = $[4];
    return t2;
}
const $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS = 15000;
const $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents = new Map();
const $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics = (contentId)=>{
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    if (pendingPrefetch) {
        clearTimeout(pendingPrefetch.timeoutId);
        $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
    }
};
const $f75716c2560aeeb6$var$registerPendingPrefetchAnalytics = ({ contentId: contentId, sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent })=>{
    // If there's an existing pending prefetch event for this content that hasn't
    // resolved or timed out yet, fire a prefetchUnused event for it before
    // replacing it with the new one.
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics(contentId);
    if (pendingPrefetch) sendPrefetchAnalyticsEvent('prefetchUnused', contentId, {
        clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
        prefetchSource: 'foresightjs'
    });
    const firedAt = Date.now();
    const timeoutId = setTimeout(()=>{
        const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
        if (!pendingPrefetch || pendingPrefetch.firedAt !== firedAt) return;
        $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
        sendPrefetchAnalyticsEvent('prefetchUnused', contentId, {
            clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
            prefetchSource: 'foresightjs'
        });
    }, $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS);
    $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.set(contentId, {
        firedAt: firedAt,
        timeoutId: timeoutId
    });
};
const $f75716c2560aeeb6$export$545c7ef2fbcc68a6 = (contentId, sendPrefetchAnalyticsEvent)=>{
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    if (!pendingPrefetch) return;
    const timeToClickMs = Date.now() - pendingPrefetch.firedAt;
    clearTimeout(pendingPrefetch.timeoutId);
    $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
    sendPrefetchAnalyticsEvent('prefetchAndClick', contentId, {
        clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
        prefetchSource: 'foresightjs',
        timeToClickMs: timeToClickMs
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Styling div for hover area only
const $f75716c2560aeeb6$var$HoverAreaWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS _4jFnWevLYW _3Ku51Iogpp _3dCYwDWVPG",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f75716c2560aeeb6$export$93fd4db39a89045f = ({ contentId: contentId, spaceKey: spaceKey, children: children, editSource: editSource, isEmbeddedEditor: isEmbeddedEditor, sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent, predictivelyPrefetch: predictivelyPrefetch })=>{
    const preloader = (0, $cozmU.useContext)((0, $58PBI.EditContentButtonPreloaderContext)); // See packages/confluence-fabric-editor/src/editorPreloader.tsx
    const [doPreload, setDoPreload] = (0, $cozmU.useState)(false);
    const doPreloadRef = (0, $cozmU.useRef)(doPreload);
    const [{ editSource: contextEditSource }, { setEditSource: setEditSource }] = (0, $4ri4I.useEditSource)();
    (0, $cozmU.useEffect)(()=>{
        // Keep the ref in sync with the latest doPreload value so that the function returned by
        // cleanup editorPreloadManager always uses the current doPreload value instead of the one before.
        doPreloadRef.current = doPreload;
    }, [
        doPreload
    ]); // Cleanup editorPreloadManager on contentId change and unmount.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics(contentId);
            if (doPreloadRef.current) (0, $1Gu3g.EditorPreloadManager).removePreloadedId(contentId);
        };
    }, [
        contentId
    ]); // Register edit-button element with ForesightJS for mouse trajectory prediction
    // Only call useForesight when predictive prefetch is enabled
    const foresightOptions = (0, $cozmU.useMemo)(()=>({
            callback: async ()=>{
                if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId) && predictivelyPrefetch) {
                    setDoPreload(true);
                    setEditSource(editSource);
                    $f75716c2560aeeb6$var$registerPendingPrefetchAnalytics({
                        contentId: contentId,
                        sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent
                    });
                }
            },
            name: `edit-button-${contentId}`,
            reactivateAfter: 15000
        }), [
        contentId,
        editSource,
        setEditSource,
        setDoPreload,
        predictivelyPrefetch,
        sendPrefetchAnalyticsEvent
    ]);
    const { elementRef: elementRef } = $f75716c2560aeeb6$var$useForesight(foresightOptions, predictivelyPrefetch); // On hover callback
    const onHover = (0, $cozmU.useCallback)(async ()=>{
        if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId)) {
            setDoPreload(true);
            setEditSource(editSource);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        editSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f75716c2560aeeb6$var$HoverAreaWrapper, {
        ref: $f75716c2560aeeb6$var$getHasMatchMedia() && predictivelyPrefetch && (0, $6mKj3.expValEquals)('platform_editor_predictive_collabdraft_prefetch', 'isEnabled', true) ? elementRef : null,
        onMouseEnter: $f75716c2560aeeb6$var$getHasMatchMedia() && predictivelyPrefetch && (0, $6mKj3.expValEquals)('platform_editor_predictive_collabdraft_prefetch', 'isEnabled', true) ? undefined : onHover
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        onMouseEnter: onHover,
        onFocus: onHover
    }, children), editSource === contextEditSource && doPreload && preloader ? preloader({
        contentId: contentId,
        spaceKey: spaceKey,
        isEmbeddedEditor: isEmbeddedEditor
    }) : null);
};
module.exports["resolvePendingPrefetchAnalytics"] = $f75716c2560aeeb6$export$545c7ef2fbcc68a6;
module.exports["EditContentButtonPreloader"] = $f75716c2560aeeb6$export$93fd4db39a89045f;

});

parcelRegister("9Vkdl", function(module, exports) {

var $akD6a = parcelRequire("akD6a");

function $73991e0e121001da$var$k() {
    let n = $73991e0e121001da$var$E(), e = $73991e0e121001da$var$L();
    return {
        isTouchDevice: n,
        isLimitedConnection: e,
        shouldRegister: !e
    };
}
function $73991e0e121001da$var$E() {
    return typeof window > "u" || typeof navigator > "u" ? !1 : window.matchMedia("(pointer: coarse)").matches && navigator.maxTouchPoints > 0;
}
function $73991e0e121001da$var$L() {
    let n = navigator.connection;
    if (!n) return !1;
    let e = $73991e0e121001da$export$1435e6a4c843d234.instance.getManagerData.globalSettings.minimumConnectionType, t = [
        "slow-2g",
        "2g",
        "3g",
        "4g"
    ], i = t.indexOf(n.effectiveType), r = t.indexOf(e);
    return i < r || n.saveData;
}
function $73991e0e121001da$var$F(n) {
    if (typeof window > "u" || typeof document > "u") return !1;
    let e = window.innerWidth || document.documentElement.clientWidth, t = window.innerHeight || document.documentElement.clientHeight;
    return n.top < t && n.bottom > 0 && n.left < e && n.right > 0;
}
function $73991e0e121001da$var$T() {
    return {
        mouse: {
            hover: 0,
            trajectory: 0
        },
        tab: {
            forwards: 0,
            reverse: 0
        },
        scroll: {
            down: 0,
            left: 0,
            right: 0,
            up: 0
        },
        touch: 0,
        viewport: 0,
        total: 0
    };
}
function $73991e0e121001da$var$H() {
    return {
        debug: !1,
        enableManagerLogging: !1,
        enableMousePrediction: !0,
        enableScrollPrediction: !0,
        positionHistorySize: 8,
        trajectoryPredictionTime: 120,
        scrollMargin: 150,
        defaultHitSlop: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        },
        enableTabPrediction: !0,
        tabOffset: 2,
        touchDeviceStrategy: "onTouchStart",
        minimumConnectionType: "3g"
    };
}
function $73991e0e121001da$var$R(n, e, t) {
    let { element: i, callback: r, hitSlop: o, name: s, meta: c, reactivateAfter: b } = n, d = i.getBoundingClientRect(), a = o ? (0, $akD6a.b)(o) : t;
    return {
        id: e,
        element: i,
        callback: r,
        elementBounds: {
            originalRect: d,
            expandedRect: (0, $akD6a.c)(d, a),
            hitSlop: a
        },
        name: s || i.id || "unnamed",
        isIntersectingWithViewport: $73991e0e121001da$var$F(d),
        registerCount: 1,
        meta: c ?? {},
        callbackInfo: {
            callbackFiredCount: 0,
            lastCallbackInvokedAt: void 0,
            lastCallbackCompletedAt: void 0,
            lastCallbackRuntime: void 0,
            lastCallbackStatus: void 0,
            lastCallbackErrorMessage: void 0,
            reactivateAfter: b ?? 1 / 0,
            isCallbackActive: !0,
            isRunningCallback: !1,
            reactivateTimeoutId: void 0
        }
    };
}
var $73991e0e121001da$var$f = class {
    addEventListener(e, t, i) {
        if (i?.signal?.aborted) return;
        let r = this.eventListeners.get(e) ?? [];
        r.push(t), this.eventListeners.set(e, r), i?.signal?.addEventListener("abort", ()=>this.removeEventListener(e, t));
    }
    removeEventListener(e, t) {
        let i = this.eventListeners.get(e);
        if (!i) return;
        let r = i.indexOf(t);
        r > -1 && i.splice(r, 1);
    }
    emit(e) {
        let t = this.eventListeners.get(e.type);
        if (!(!t || t.length === 0)) for(let i = 0; i < t.length; i++)try {
            let r = t[i];
            r && r(e);
        } catch (r) {
            console.error(`Error in ForesightManager event listener ${i} for ${e.type}:`, r);
        }
    }
    hasListeners(e) {
        let t = this.eventListeners.get(e);
        return t !== void 0 && t.length > 0;
    }
    getEventListeners() {
        return this.eventListeners;
    }
    constructor(){
        this.eventListeners = new Map;
    }
};
function $73991e0e121001da$var$y(n, e) {
    return n !== void 0 && e !== n;
}
var $73991e0e121001da$var$I = {
    trajectoryPredictionTime: {
        min: 10,
        max: 200
    },
    positionHistorySize: {
        min: 2,
        max: 30
    },
    scrollMargin: {
        min: 30,
        max: 300
    },
    tabOffset: {
        min: 0,
        max: 20
    }
};
function $73991e0e121001da$var$h(n, e, t) {
    if (!$73991e0e121001da$var$y(t, n[e])) return !1;
    let { min: i, max: r } = $73991e0e121001da$var$I[e];
    return n[e] = (0, $akD6a.a)(t, i, r, e), !0;
}
function $73991e0e121001da$var$m(n, e, t) {
    return $73991e0e121001da$var$y(t, n[e]) ? (n[e] = t, !0) : !1;
}
function $73991e0e121001da$var$M(n, e) {
    $73991e0e121001da$var$h(n, "trajectoryPredictionTime", e.trajectoryPredictionTime), $73991e0e121001da$var$h(n, "positionHistorySize", e.positionHistorySize), $73991e0e121001da$var$h(n, "scrollMargin", e.scrollMargin), $73991e0e121001da$var$h(n, "tabOffset", e.tabOffset), $73991e0e121001da$var$m(n, "enableMousePrediction", e.enableMousePrediction), $73991e0e121001da$var$m(n, "enableScrollPrediction", e.enableScrollPrediction), $73991e0e121001da$var$m(n, "enableTabPrediction", e.enableTabPrediction), $73991e0e121001da$var$m(n, "enableManagerLogging", e.enableManagerLogging), e.defaultHitSlop !== void 0 && (n.defaultHitSlop = (0, $akD6a.b)(e.defaultHitSlop)), e.touchDeviceStrategy !== void 0 && (n.touchDeviceStrategy = e.touchDeviceStrategy), e.minimumConnectionType !== void 0 && (n.minimumConnectionType = e.minimumConnectionType), e.debug !== void 0 && (n.debug = e.debug);
}
function $73991e0e121001da$var$D(n, e) {
    let t = [], i = !1, r = !1, o = !1, s = !1, c = !1;
    if (!e) return {
        changedSettings: t,
        positionHistorySizeChanged: i,
        scrollPredictionChanged: r,
        tabPredictionChanged: o,
        hitSlopChanged: s,
        touchStrategyChanged: c
    };
    let b = [
        "trajectoryPredictionTime",
        "positionHistorySize",
        "scrollMargin",
        "tabOffset"
    ];
    for (let a of b){
        let l = n[a];
        $73991e0e121001da$var$h(n, a, e[a]) && (t.push({
            setting: a,
            oldValue: l,
            newValue: n[a]
        }), a === "positionHistorySize" && (i = !0));
    }
    let d = [
        "enableMousePrediction",
        "enableScrollPrediction",
        "enableTabPrediction"
    ];
    for (let a of d){
        let l = n[a];
        $73991e0e121001da$var$m(n, a, e[a]) && (t.push({
            setting: a,
            oldValue: l,
            newValue: n[a]
        }), a === "enableScrollPrediction" && (r = !0), a === "enableTabPrediction" && (o = !0));
    }
    if (e.defaultHitSlop !== void 0) {
        let a = n.defaultHitSlop, l = (0, $akD6a.b)(e.defaultHitSlop);
        (0, $akD6a.d)(a, l) || (n.defaultHitSlop = l, t.push({
            setting: "defaultHitSlop",
            oldValue: a,
            newValue: l
        }), s = !0);
    }
    if (e.touchDeviceStrategy !== void 0) {
        let a = n.touchDeviceStrategy;
        n.touchDeviceStrategy = e.touchDeviceStrategy, t.push({
            setting: "touchDeviceStrategy",
            oldValue: a,
            newValue: e.touchDeviceStrategy
        }), c = !0;
    }
    if (e.minimumConnectionType !== void 0) {
        let a = n.minimumConnectionType;
        n.minimumConnectionType = e.minimumConnectionType, t.push({
            setting: "minimumConnectionType",
            oldValue: a,
            newValue: e.minimumConnectionType
        });
    }
    return {
        changedSettings: t,
        positionHistorySizeChanged: i,
        scrollPredictionChanged: r,
        tabPredictionChanged: o,
        hitSlopChanged: s,
        touchStrategyChanged: c
    };
}


var $73991e0e121001da$export$1435e6a4c843d234 = class n {
    async getOrCreateDesktopHandler() {
        if (!this.desktopHandler) {
            let { DesktopHandler: e } = await (parcelRequire("2GQEm"));
            this.desktopHandler = new e(this.handlerDependencies), this.devLog("DesktopHandler lazy loaded");
        }
        return this.desktopHandler;
    }
    async getOrCreateTouchHandler() {
        if (!this.touchDeviceHandler) {
            let { TouchDeviceHandler: e } = await (parcelRequire("4mSfC"));
            this.touchDeviceHandler = new e(this.handlerDependencies), this.devLog("TouchDeviceHandler lazy loaded");
        }
        return this.touchDeviceHandler;
    }
    static initialize(e) {
        return this.isInitiated || (n.manager = new n(e)), n.manager;
    }
    static get isInitiated() {
        return !!n.manager;
    }
    static get instance() {
        return this.initialize();
    }
    generateId() {
        return `foresight-${++this.idCounter}`;
    }
    get isUsingDesktopHandler() {
        return this.currentDeviceStrategy === "mouse" || this.currentDeviceStrategy === "pen";
    }
    addEventListener(e, t, i) {
        this.eventEmitter.addEventListener(e, t, i);
    }
    removeEventListener(e, t) {
        this.eventEmitter.removeEventListener(e, t);
    }
    hasListeners(e) {
        return this.eventEmitter.hasListeners(e);
    }
    get getManagerData() {
        let e = this.desktopHandler?.loadedPredictors, t = this.touchDeviceHandler?.loadedPredictors;
        return {
            registeredElements: this.elements,
            globalSettings: this._globalSettings,
            globalCallbackHits: this._globalCallbackHits,
            eventListeners: this.eventEmitter.getEventListeners(),
            currentDeviceStrategy: this.currentDeviceStrategy,
            activeElementCount: this.activeElementCount,
            loadedModules: {
                desktopHandler: this.desktopHandler !== null,
                touchHandler: this.touchDeviceHandler !== null,
                predictors: {
                    mouse: e?.mouse ?? !1,
                    tab: e?.tab ?? !1,
                    scroll: e?.scroll ?? !1,
                    viewport: t?.viewport ?? !1,
                    touchStart: t?.touchStart ?? !1
                }
            }
        };
    }
    get registeredElements() {
        return this.elements;
    }
    register(e) {
        let { element: t, ...i } = e;
        return t instanceof NodeList ? Array.from(t, (r)=>this.registerElement({
                ...i,
                element: r
            })) : this.registerElement({
            ...i,
            element: t
        });
    }
    registerElement(e) {
        let { isTouchDevice: t, isLimitedConnection: i, shouldRegister: r } = $73991e0e121001da$var$k();
        if (!r) return {
            isLimitedConnection: i,
            isTouchDevice: t,
            isRegistered: !1,
            unregister: ()=>{},
            elementData: null
        };
        let o = this.elements.get(e.element);
        if (o) return o.registerCount++, {
            isLimitedConnection: i,
            isTouchDevice: t,
            isRegistered: !1,
            unregister: ()=>{},
            elementData: null
        };
        this.isSetup || this.initializeGlobalListeners();
        let s = $73991e0e121001da$var$R(e, this.generateId(), this._globalSettings.defaultHitSlop);
        return this.elements.set(e.element, s), this.activeElementCount++, this.updateCheckableStatus(s), this.currentlyActiveHandler?.observeElement(e.element), this.eventEmitter.emit({
            type: "elementRegistered",
            timestamp: Date.now(),
            elementData: s
        }), {
            isTouchDevice: t,
            isLimitedConnection: i,
            isRegistered: !0,
            unregister: ()=>{
                this.unregister(e.element);
            },
            elementData: s
        };
    }
    unregister(e, t) {
        e instanceof NodeList ? e.forEach((i)=>this.unregisterElement(i, t)) : this.unregisterElement(e, t);
    }
    unregisterElement(e, t) {
        let i = this.elements.get(e);
        if (!i) return;
        this.clearReactivateTimeout(i), this.currentlyActiveHandler?.unobserveElement(e), this.elements.delete(e), this.checkableElements.delete(i), i.callbackInfo.isCallbackActive && this.activeElementCount--;
        let r = this.elements.size === 0 && this.isSetup;
        r && (this.devLog("All elements unregistered, removing global listeners"), this.removeGlobalListeners()), this.eventEmitter.emit({
            type: "elementUnregistered",
            elementData: i,
            timestamp: Date.now(),
            unregisterReason: t ?? "by user",
            wasLastRegisteredElement: r
        });
    }
    reactivate(e) {
        e instanceof NodeList ? e.forEach((t)=>this.reactivateElement(t)) : this.reactivateElement(e);
    }
    reactivateElement(e) {
        let t = this.elements.get(e);
        t && (this.isSetup || this.initializeGlobalListeners(), this.clearReactivateTimeout(t), t.callbackInfo.isRunningCallback || (t.callbackInfo.isCallbackActive = !0, this.activeElementCount++, this.updateCheckableStatus(t), this.currentlyActiveHandler?.observeElement(e), this.eventEmitter.emit({
            type: "elementReactivated",
            elementData: t,
            timestamp: Date.now()
        })));
    }
    clearReactivateTimeout(e) {
        clearTimeout(e.callbackInfo.reactivateTimeoutId), e.callbackInfo.reactivateTimeoutId = void 0;
    }
    updateCheckableStatus(e) {
        e.isIntersectingWithViewport && e.callbackInfo.isCallbackActive && !e.callbackInfo.isRunningCallback ? this.checkableElements.add(e) : this.checkableElements.delete(e);
    }
    callCallback(e, t) {
        e.callbackInfo.isRunningCallback || !e.callbackInfo.isCallbackActive || (this.markElementAsRunning(e), this.executeCallbackAsync(e, t));
    }
    markElementAsRunning(e) {
        e.callbackInfo.callbackFiredCount++, e.callbackInfo.lastCallbackInvokedAt = Date.now(), e.callbackInfo.isRunningCallback = !0, this.clearReactivateTimeout(e), this.checkableElements.delete(e);
    }
    async executeCallbackAsync(e, t) {
        this.updateHitCounters(t), this.eventEmitter.emit({
            type: "callbackInvoked",
            timestamp: Date.now(),
            elementData: e,
            hitType: t
        });
        let i = performance.now(), r, o = null;
        try {
            await e.callback(e), r = "success";
        } catch (s) {
            o = s instanceof Error ? s.message : String(s), r = "error", console.error(`Error in callback for element ${e.name}:`, s);
        }
        this.finalizeCallback(e, t, i, r, o);
    }
    finalizeCallback(e, t, i, r, o) {
        e.callbackInfo.lastCallbackCompletedAt = Date.now(), e.callbackInfo.isRunningCallback = !1, e.callbackInfo.isCallbackActive = !1, this.activeElementCount--, this.currentlyActiveHandler?.unobserveElement(e.element), e.callbackInfo.reactivateAfter !== 1 / 0 && (e.callbackInfo.reactivateTimeoutId = setTimeout(()=>{
            this.reactivate(e.element);
        }, e.callbackInfo.reactivateAfter));
        let s = this.activeElementCount === 0;
        s && (this.devLog("All elements unactivated, removing global listeners"), this.removeGlobalListeners()), this.eventEmitter.emit({
            type: "callbackCompleted",
            timestamp: Date.now(),
            elementData: e,
            hitType: t,
            elapsed: e.callbackInfo.lastCallbackRuntime = performance.now() - i,
            status: e.callbackInfo.lastCallbackStatus = r,
            errorMessage: e.callbackInfo.lastCallbackErrorMessage = o,
            wasLastActiveElement: s
        });
    }
    updateHitCounters(e) {
        switch(e.kind){
            case "mouse":
                this._globalCallbackHits.mouse[e.subType]++;
                break;
            case "tab":
                this._globalCallbackHits.tab[e.subType]++;
                break;
            case "scroll":
                this._globalCallbackHits.scroll[e.subType]++;
                break;
            case "touch":
                this._globalCallbackHits.touch++;
                break;
            case "viewport":
                this._globalCallbackHits.viewport++;
                break;
            default:
        }
        this._globalCallbackHits.total++;
    }
    async setDeviceStrategy(e) {
        let t = this.currentDeviceStrategy;
        t !== e && this.devLog(`Switching device strategy from ${t} to ${e}`), this.currentlyActiveHandler?.disconnect(), this.currentlyActiveHandler = e === "mouse" || e === "pen" ? await this.getOrCreateDesktopHandler() : await this.getOrCreateTouchHandler(), this.currentlyActiveHandler.connect();
    }
    initializeGlobalListeners() {
        this.isSetup || typeof document > "u" || (this.devLog("Initializing global listeners (pointermove, MutationObserver)"), this.setDeviceStrategy(this.currentDeviceStrategy), document.addEventListener("pointermove", this.handlePointerMove), this.domObserver = new MutationObserver(this.handleDomMutations), this.domObserver.observe(document.documentElement, {
            childList: !0,
            subtree: !0,
            attributes: !1
        }), this.isSetup = !0);
    }
    removeGlobalListeners() {
        typeof document > "u" || (this.isSetup = !1, this.domObserver?.disconnect(), this.domObserver = null, document.removeEventListener("pointermove", this.handlePointerMove), this.currentlyActiveHandler?.disconnect(), this.rafId && (cancelAnimationFrame(this.rafId), this.rafId = null), this.pendingPointerEvent = null);
    }
    alterGlobalSettings(e) {
        let t = $73991e0e121001da$var$D(this._globalSettings, e);
        t.positionHistorySizeChanged && this.desktopHandler && this.desktopHandler.trajectoryPositions.positions.resize(this._globalSettings.positionHistorySize), t.scrollPredictionChanged && this.isUsingDesktopHandler && this.desktopHandler && (this._globalSettings.enableScrollPrediction ? this.desktopHandler.connectScrollPredictor() : this.desktopHandler.disconnectScrollPredictor()), t.tabPredictionChanged && this.isUsingDesktopHandler && this.desktopHandler && (this._globalSettings.enableTabPrediction ? this.desktopHandler.connectTabPredictor() : this.desktopHandler.disconnectTabPredictor()), t.hitSlopChanged && this.forceUpdateAllElementBounds(), t.touchStrategyChanged && !this.isUsingDesktopHandler && this.touchDeviceHandler && this.touchDeviceHandler.setTouchPredictor(), t.changedSettings.length > 0 && this.eventEmitter.emit({
            type: "managerSettingsChanged",
            timestamp: Date.now(),
            managerData: this.getManagerData,
            updatedSettings: t.changedSettings
        });
    }
    forceUpdateAllElementBounds() {
        for (let e of this.elements.values())e.isIntersectingWithViewport && this.forceUpdateElementBounds(e);
    }
    forceUpdateElementBounds(e) {
        let t = e.element.getBoundingClientRect(), i = (0, $akD6a.c)(t, e.elementBounds.hitSlop);
        if (!(0, $akD6a.d)(i, e.elementBounds.expandedRect)) {
            let r = {
                ...e,
                elementBounds: {
                    ...e.elementBounds,
                    originalRect: t,
                    expandedRect: i
                }
            };
            this.elements.set(e.element, r), this.eventEmitter.emit({
                type: "elementDataUpdated",
                elementData: r,
                updatedProps: [
                    "bounds"
                ]
            });
        }
    }
    devLog(e) {
        this._globalSettings.enableManagerLogging && console.log(`%c\u{1F6E0}\uFE0F ForesightManager: ${e}`, "color: #16a34a; font-weight: bold;");
    }
    constructor(e){
        this.elements = new Map;
        this.checkableElements = new Set;
        this.idCounter = 0;
        this.activeElementCount = 0;
        this.desktopHandler = null;
        this.touchDeviceHandler = null;
        this.currentlyActiveHandler = null;
        this.isSetup = !1;
        this.pendingPointerEvent = null;
        this.rafId = null;
        this.domObserver = null;
        this.currentDeviceStrategy = $73991e0e121001da$var$E() ? "touch" : "mouse";
        this.eventEmitter = new $73991e0e121001da$var$f;
        this._globalCallbackHits = $73991e0e121001da$var$T();
        this._globalSettings = $73991e0e121001da$var$H();
        this.handlePointerMove = (e)=>{
            this.pendingPointerEvent = e, e.pointerType !== this.currentDeviceStrategy && (this.eventEmitter.emit({
                type: "deviceStrategyChanged",
                timestamp: Date.now(),
                newStrategy: e.pointerType,
                oldStrategy: this.currentDeviceStrategy
            }), this.currentDeviceStrategy = e.pointerType, this.setDeviceStrategy(this.currentDeviceStrategy)), !this.rafId && (this.rafId = requestAnimationFrame(()=>{
                if (!this.isUsingDesktopHandler) {
                    this.rafId = null;
                    return;
                }
                this.pendingPointerEvent && this.desktopHandler?.processMouseMovement(this.pendingPointerEvent), this.rafId = null;
            }));
        };
        this.handleDomMutations = (e)=>{
            if (!e.length) return;
            this.desktopHandler?.invalidateTabCache();
            let t = !1;
            for(let i = 0; i < e.length; i++){
                let r = e[i];
                if (r && r.type === "childList" && r.removedNodes.length > 0) {
                    t = !0;
                    break;
                }
            }
            if (t) for (let i of this.elements.keys())i.isConnected || this.unregister(i, "disconnected");
        };
        e !== void 0 && $73991e0e121001da$var$M(this._globalSettings, e), this.handlerDependencies = {
            elements: this.elements,
            callCallback: this.callCallback.bind(this),
            emit: this.eventEmitter.emit.bind(this.eventEmitter),
            hasListeners: this.eventEmitter.hasListeners.bind(this.eventEmitter),
            settings: this._globalSettings
        }, this.devLog(`ForesightManager initialized with device strategy: ${this.currentDeviceStrategy}`), this.initializeGlobalListeners();
    }
};
module.exports["ForesightManager"] = $73991e0e121001da$export$1435e6a4c843d234;

});

parcelRegister("akD6a", function(module, exports) {
function $785a19cc58757094$export$407448d2b89b1813(t, o, e, r) {
    return t < o ? console.warn(`ForesightJS: "${r}" value ${t} is below minimum bound ${o}, clamping to ${o}`) : t > e && console.warn(`ForesightJS: "${r}" value ${t} is above maximum bound ${e}, clamping to ${e}`), Math.min(Math.max(t, o), e);
}
function $785a19cc58757094$export$8b22cf2602fb60ce(t) {
    if (typeof t == "number") {
        let o = $785a19cc58757094$export$407448d2b89b1813(t, 0, 2e3, "hitslop");
        return {
            top: o,
            left: o,
            right: o,
            bottom: o
        };
    }
    return {
        top: $785a19cc58757094$export$407448d2b89b1813(t.top, 0, 2e3, "hitslop - top"),
        left: $785a19cc58757094$export$407448d2b89b1813(t.left, 0, 2e3, "hitslop - left"),
        right: $785a19cc58757094$export$407448d2b89b1813(t.right, 0, 2e3, "hitslop - right"),
        bottom: $785a19cc58757094$export$407448d2b89b1813(t.bottom, 0, 2e3, "hitslop - bottom")
    };
}
function $785a19cc58757094$export$db3b6bfb95261072(t, o) {
    return {
        left: t.left - o.left,
        right: t.right + o.right,
        top: t.top - o.top,
        bottom: t.bottom + o.bottom
    };
}
function $785a19cc58757094$export$4368d992c4eafac0(t, o) {
    return !t || !o ? t === o : t.left === o.left && t.right === o.right && t.top === o.top && t.bottom === o.bottom;
}
function $785a19cc58757094$export$f1e1789686576879(t, o) {
    return t.x >= o.left && t.x <= o.right && t.y >= o.top && t.y <= o.bottom;
}
module.exports["a"] = $785a19cc58757094$export$407448d2b89b1813;
module.exports["b"] = $785a19cc58757094$export$8b22cf2602fb60ce;
module.exports["c"] = $785a19cc58757094$export$db3b6bfb95261072;
module.exports["d"] = $785a19cc58757094$export$4368d992c4eafac0;
module.exports["e"] = $785a19cc58757094$export$f1e1789686576879;

});

parcelRegister("2GQEm", function(module, exports) {

let $1f58583a48d142e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f58583a48d142e6$var$load("1gINj").then(()=>parcelRequire('11JE0'));

});

parcelRegister("4mSfC", function(module, exports) {

let $32e34c97c7dd1cf5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32e34c97c7dd1cf5$var$load("1GVLI").then(()=>parcelRequire('5CVfh'));

});

parcelRegister("1Gu3g", function(module, exports) {
/**
 * Editor Preload Manager
 *
 * A static cache for preloaded contentId's designed to prevent
 * the duplication of preload triggers on any one page during
 * a user's session
 */ class $4fc0e3bf51597bc1$export$369fde9923d909f1 {
    /**
   * Should Preload
   *
   * A mutative lookup to the cache that'll insert the contentId provided
   * if it's not already present. Returns true if the cache did not already
   * contain the provided contentId.
   */ static shouldPreload(contentId) {
        if (this.cache.has(contentId)) return false;
        this.cache.add(contentId);
        return true;
    }
    /**
   * Remove Preloaded ID
   *
   * Removes a contentId from the cache, allowing it to be re-preloaded
   */ static removePreloadedId(contentId) {
        this.cache.delete(contentId);
        this.intentCache.delete(contentId);
    }
    /**
   * Clear
   *
   * Removes all cached contentId's from the cache
   */ static clear() {
        this.cache.clear();
        this.intentCache.clear();
    }
}
$4fc0e3bf51597bc1$export$369fde9923d909f1.cache = new Set();
$4fc0e3bf51597bc1$export$369fde9923d909f1.intentCache = new Set();
module.exports["EditorPreloadManager"] = $4fc0e3bf51597bc1$export$369fde9923d909f1;

});

parcelRegister("58PBI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';
module.exports["EditContentButtonPreloaderContext"] = $037500d910957a1c$export$2dc50c54ef05578f;

});

parcelRegister("3TgYS", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");

var $e8033b5fc56f919b$export$1e5f9e0e1f5f771c = /*#__PURE__*/ function(LocalActivityAction) {
    LocalActivityAction["deleted"] = "deleted";
    LocalActivityAction["viewed"] = "viewed";
    return LocalActivityAction;
}({});
const $e8033b5fc56f919b$export$c008b11c6b6e84c9 = (0, $8s9DV.createStore)({
    name: 'localActivityStore',
    initialState: {
        localActivity: []
    },
    actions: {
        setLocalActivity: (localActivity)=>({ setState: setState })=>{
                setState({
                    localActivity: [
                        ...localActivity
                    ]
                });
            },
        getLocalActivity: ()=>({ getState: getState })=>{
                return getState().localActivity;
            }
    }
});
const $e8033b5fc56f919b$var$localActivitySelector = (0, $fjHkB.createSelector)((state)=>state.localActivity, (localActivity)=>localActivity);
const $e8033b5fc56f919b$export$f16e1a8a1b5f5fcc = (0, $kBr4q.createStateHook)($e8033b5fc56f919b$export$c008b11c6b6e84c9, {
    selector: $e8033b5fc56f919b$var$localActivitySelector
});
const $e8033b5fc56f919b$export$b62470c19b810f2b = (0, $kBr4q.createActionsHook)($e8033b5fc56f919b$export$c008b11c6b6e84c9);
module.exports["LocalActivityAction"] = $e8033b5fc56f919b$export$1e5f9e0e1f5f771c;
module.exports["useLocalActivityCache"] = $e8033b5fc56f919b$export$f16e1a8a1b5f5fcc;
module.exports["useLocalActivityCacheStoreActions"] = $e8033b5fc56f919b$export$b62470c19b810f2b;

});

parcelRegister("jYPbB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3TgYS = parcelRequire("3TgYS");


var $fdNea = parcelRequire("fdNea");

const $62bd2c9093526b74$export$c4f820168ec5144 = ()=>{
    const { getLocalActivity: getLocalActivity, setLocalActivity: setLocalActivity } = (0, $3TgYS.useLocalActivityCacheStoreActions)();
    const track = (0, $cozmU.useCallback)((contentId, action)=>{
        (0, $fdNea.trackLocalActivity)({
            contentId: contentId,
            action: action
        }, setLocalActivity, getLocalActivity);
    }, [
        setLocalActivity,
        getLocalActivity
    ]);
    return {
        track: track
    };
};
module.exports["useLocalActivityTracker"] = $62bd2c9093526b74$export$c4f820168ec5144;

});

parcelRegister("fdNea", function(module, exports) {

var $de4za = parcelRequire("de4za");


var $cozmU = parcelRequire("cozmU");


var $3TgYS = parcelRequire("3TgYS");


var $fFmJj = parcelRequire("fFmJj");

const $5be82f78ca966df2$var$useLocalActivityContentFragment = (0, $de4za.default);
const $5be82f78ca966df2$var$MAX_EVENTS = 100;
const $5be82f78ca966df2$var$contentIdsToBeEvicted = new Set();
const $5be82f78ca966df2$var$isMarkedForEviction = (event)=>$5be82f78ca966df2$var$contentIdsToBeEvicted.has(event.content.id || '');
const $5be82f78ca966df2$export$1b153e31f71ec597 = ({ filters: filters } = {})=>{
    const readLocalActivityContentFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $5be82f78ca966df2$var$useLocalActivityContentFragment,
        __callerPackage__: "local-activity"
    });
    const dehydratedLocalActivities = (0, $3TgYS.useLocalActivityCache)();
    const localActivities = [];
    for (const event of dehydratedLocalActivities){
        const hydratedEvent = {
            ...event
        };
        try {
            if (event?.content?.id) {
                const contentFragment = readLocalActivityContentFragment({
                    id: `Content:${event.content.id}`
                });
                if (contentFragment) hydratedEvent.content = {
                    ...hydratedEvent.content,
                    ...contentFragment
                };
            }
        } catch  {
        // If the fragment does not exist, don't do anything this event will get filtered out
        }
        localActivities.push(hydratedEvent);
    }
    /**
   * Events which are marked as consistent for all backend APIs can safely be evicted.
   * At the time of writing, there is only 1 supported backend API (Activity Platform),
   * so we can immediately mark the event for eviction.
   *
   * This eviction is "lazy", meaning that the event is *marked* as evicted & filtered from the
   * result set, but not actually removed from memory until `trackLocalActivity` is called.
   */ const markAsConsistent = (0, $cozmU.useCallback)((contentId)=>{
        $5be82f78ca966df2$var$contentIdsToBeEvicted.add(contentId);
    }, []);
    const result = {
        viewedEvents: [],
        deletedContentIds: new Set(),
        markAsConsistent: markAsConsistent
    };
    localActivities.forEach((event)=>{
        if (!$5be82f78ca966df2$var$shouldIncludeEvent(event, filters)) return;
        if (event.action === (0, $3TgYS.LocalActivityAction).viewed) result.viewedEvents.push(event);
        else if (event.action === (0, $3TgYS.LocalActivityAction).deleted) result.deletedContentIds.add(event.content.id || '');
    });
    return result;
};
const $5be82f78ca966df2$var$shouldIncludeEvent = (event, filters)=>{
    // Filter events which will be evicted
    if ($5be82f78ca966df2$var$isMarkedForEviction(event)) return false;
    if (!filters) return true;
    return filters.spaceKey === ('space' in event.content ? event.content.space?.key : undefined);
};
const $5be82f78ca966df2$export$3fa173aba6d1fb4b = ({ contentId: contentId, action: action }, setLocalActivity, getLocalActivity)=>{
    /**
   * The Content is dehydrated (i.e. only Content.id is present, not full Content)
   * because we may not know all Content data at track time.
   * The full Content will be hydrated from cache automatically when querying in useLocalActivity
   */ let dehydratedEvents = [];
    try {
        dehydratedEvents = getLocalActivity()?.filter((e)=>!$5be82f78ca966df2$var$isMarkedForEviction(e)).slice(0, $5be82f78ca966df2$var$MAX_EVENTS - 1) || [];
    } catch  {}
    $5be82f78ca966df2$var$contentIdsToBeEvicted.clear();
    const data = {
        localActivity: [
            {
                id: `${contentId}-${action}`,
                action: action,
                timestamp: new Date().toISOString(),
                content: {
                    id: contentId,
                    __typename: 'Content'
                },
                __typename: 'LocalActivityEvent'
            },
            ...dehydratedEvents
        ]
    };
    setLocalActivity(data.localActivity);
};
module.exports["useLocalActivity"] = $5be82f78ca966df2$export$1b153e31f71ec597;
module.exports["trackLocalActivity"] = $5be82f78ca966df2$export$3fa173aba6d1fb4b;

});

parcelRegister("de4za", function(module, exports) {
/**
 * @generated SignedSource<<b2f9f951eae1eb199798be4df9dd7524>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b7736c1a4cd6fb8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useLocalActivityContentFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ 
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "emoji-title-published",
                            "emoji-title-draft"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v1 /*: any*/ ,
                            {
                                "concreteType": "Version",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "number"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
            }
        ],
        "type": "Content"
    };
}();
$2b7736c1a4cd6fb8$var$node.hash = "e057d047fb173be62229acfca15ccbce";
var $2b7736c1a4cd6fb8$export$2e2bcd8739ae039 = $2b7736c1a4cd6fb8$var$node;
module.exports["default"] = $2b7736c1a4cd6fb8$export$2e2bcd8739ae039;

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("2cKGu", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $c721ee7829bb57f5$export$f2c6bba4d41ef211 = (contentType, contentMode)=>{
    // Starring currently doesn't support unpublished drafts (which could be of contentType page or blogpost)
    if (contentMode === 'draft') return false;
    return contentType === 'page' || contentType === 'blogpost' || (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
};
module.exports["useIsStarringEnabled"] = $c721ee7829bb57f5$export$f2c6bba4d41ef211;

});

parcelRegister("jX3NS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2dbb3e83d74c73f9a7ff48dd32e63e6>>
 * @codegenCommand yarn workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $84256 = parcelRequire("84256");

const $bba93e208e351ca2$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_radial_118280_5819)" d="M16.396 15.797c-5.198 0-9.083 4.255-9.376 8.995.181 1.021.776 3.038 1.708 2.935 1.165-.13 4.1 0 6.602-4.531 1.828-3.31 5.589-7.4 1.066-7.4"/><path fill="url(#paint1_radial_118280_5819)" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint2_radial_118280_5819)" fill-opacity=".4" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint3_radial_118280_5819)" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint4_radial_118280_5819)" fill-opacity=".6" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint5_radial_118280_5819)" fill-opacity=".9" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint6_linear_118280_5819)" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><path fill="url(#paint7_radial_118280_5819)" fill-opacity=".4" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><path fill="url(#paint8_radial_118280_5819)" fill-opacity=".9" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><defs><radialGradient id="paint0_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(50.153 -14.375 16.71)scale(10.7161 17.7747)" gradientUnits="userSpaceOnUse"><stop stop-color="#4894fe"/><stop offset=".695" stop-color="#0934b3"/></radialGradient><radialGradient id="paint1_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(130.923 17.143 10.667)scale(46.0803 34.1459)" gradientUnits="userSpaceOnUse"><stop offset=".165" stop-color="#23c0fe"/><stop offset=".534" stop-color="#1c91ff"/></radialGradient><radialGradient id="paint2_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(220.014 10.522 6.163)scale(9.36856 21.4466)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".661" stop-color="#adc0ff" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(220.236 17.663 9.818)scale(10.5597 16.0372)" gradientUnits="userSpaceOnUse"><stop stop-color="#033acc"/><stop offset="1" stop-color="#368eff" stop-opacity="0"/></radialGradient><radialGradient id="paint4_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(66.571 -1.855 16.474)scale(23.1705 25.0138)" gradientUnits="userSpaceOnUse"><stop offset=".593" stop-color="#3464e3" stop-opacity="0"/><stop offset="1" stop-color="#033acc"/></radialGradient><radialGradient id="paint5_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(135 16.558 11.022)scale(34.0831 53.3967)" gradientUnits="userSpaceOnUse"><stop stop-color="#4bfde8"/><stop offset=".544" stop-color="#4bfde8" stop-opacity="0"/></radialGradient><radialGradient id="paint7_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(21.632 -45.065 64.673)scale(15.4444 29.2464)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".785" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="paint8_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(139.243 16.894 16.587)scale(21.1738 21.2455)" gradientUnits="userSpaceOnUse"><stop stop-color="#4bfde8"/><stop offset=".585" stop-color="#4bfde8" stop-opacity="0"/></radialGradient><linearGradient id="paint6_linear_118280_5819" x1="28.722" x2="28.722" y1="34.931" y2="19.517" gradientUnits="userSpaceOnUse"><stop stop-color="#0086ff"/><stop offset=".49" stop-color="#0bf"/></linearGradient></defs></svg>';
function $bba93e208e351ca2$export$adf3a43722623322({ size: size, label: label = 'Microsoft OneDrive', testId: testId, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $84256.ThirdPartyLogoWrapper), {
        markup: $bba93e208e351ca2$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type
    });
}
module.exports["MicrosoftOneDriveIcon"] = $bba93e208e351ca2$export$adf3a43722623322;

});

parcelRegister("3BmH5", function(module, exports) {

var $6rBRz = parcelRequire("6rBRz");

const $b13a5e685a63e41e$export$1813df84621a6710 = (properties)=>{
    const devDocsProperties = (0, $6rBRz.getDevDocsProperties)(properties);
    const smartFolderProperties = (0, $6rBRz.getDevDocsSmartFolderProperties)(properties);
    return {
        containerApp: smartFolderProperties?.containerApp ?? null,
        devDocsProperties: devDocsProperties,
        smartFolderProperties: smartFolderProperties
    };
};
module.exports["getDevDocsFolderMetadata"] = $b13a5e685a63e41e$export$1813df84621a6710;

});

parcelRegister("6rBRz", function(module, exports) {
const $7f56be30e613d57d$export$717f665ef6ce5e67 = 'devdocsProperties';
const $7f56be30e613d57d$var$SMART_FOLDER_PROPERTIES_KEY = 'smartFolderProperties';
const $7f56be30e613d57d$var$parseContentPropertyValue = (propertyValue)=>{
    let parsedValue = propertyValue;
    try {
        for(let unwrapCount = 0; unwrapCount < 3; unwrapCount += 1){
            if (typeof parsedValue === 'string') {
                parsedValue = JSON.parse(parsedValue);
                continue;
            }
            if (!parsedValue || typeof parsedValue !== 'object' || Array.isArray(parsedValue)) return null;
            const value = parsedValue.value;
            if (typeof value === 'string' || value && typeof value === 'object') {
                parsedValue = value;
                continue;
            }
            return parsedValue;
        }
    } catch  {
        return null;
    }
    return parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue) ? parsedValue : null;
};
const $7f56be30e613d57d$var$getStringValue = (parsedValue, key)=>{
    const value = parsedValue[key];
    return typeof value === 'string' && value.length > 0 ? value : null;
};
const $7f56be30e613d57d$var$getBooleanValue = (parsedValue, key)=>parsedValue[key] === true;
const $7f56be30e613d57d$var$getObjectValue = (parsedValue, key)=>{
    const value = parsedValue[key];
    return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
};
const $7f56be30e613d57d$export$48d1088454f9afc1 = (properties)=>{
    const devDocsProperties = properties?.find((property)=>property?.key === $7f56be30e613d57d$export$717f665ef6ce5e67);
    const parsedValue = devDocsProperties?.value !== undefined ? $7f56be30e613d57d$var$parseContentPropertyValue(devDocsProperties.value) : null;
    return parsedValue ? {
        customPrompt: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'customPrompt'),
        ref: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'ref'),
        repoName: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'repoName'),
        syncTaskAri: $7f56be30e613d57d$var$getStringValue(parsedValue, 'syncTaskAri')
    } : null;
};
const $7f56be30e613d57d$export$8cfd9e7aae7c88a3 = (properties)=>Boolean(properties?.some((property)=>property?.key === $7f56be30e613d57d$export$717f665ef6ce5e67));
const $7f56be30e613d57d$export$a9f33e9d1e3524ad = (properties)=>{
    const smartFolderProperties = properties?.find((property)=>property?.key === $7f56be30e613d57d$var$SMART_FOLDER_PROPERTIES_KEY);
    const parsedValue = smartFolderProperties?.value !== undefined ? $7f56be30e613d57d$var$parseContentPropertyValue(smartFolderProperties.value) : null;
    return parsedValue ? {
        containerApp: $7f56be30e613d57d$var$getStringValue(parsedValue, 'containerApp'),
        lastSynced: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSynced'),
        lastSyncAttemptedAt: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSyncAttemptedAt'),
        lastSyncTaskAri: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSyncTaskAri'),
        syncErrorType: $7f56be30e613d57d$var$getStringValue(parsedValue, 'syncErrorType'),
        syncInProgress: $7f56be30e613d57d$var$getBooleanValue(parsedValue, 'syncInProgress')
    } : null;
};
module.exports["getDevDocsProperties"] = $7f56be30e613d57d$export$48d1088454f9afc1;
module.exports["hasDevDocsContentProperty"] = $7f56be30e613d57d$export$8cfd9e7aae7c88a3;
module.exports["getDevDocsSmartFolderProperties"] = $7f56be30e613d57d$export$a9f33e9d1e3524ad;

});

parcelRegister("i1PdO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $aboIx = parcelRequire("aboIx");

const $294e9e08bc7d2598$var$getPropertyCollections = ({ contentProperties: contentProperties, devDocsOwnershipProperties: devDocsOwnershipProperties, devDocsProperties: devDocsProperties, propertyCollections: propertyCollections, smartFolderProperties: smartFolderProperties })=>[
        ...propertyCollections ?? [],
        contentProperties,
        devDocsOwnershipProperties,
        devDocsProperties,
        smartFolderProperties
    ];
const $294e9e08bc7d2598$export$acc7106896b1bce2 = (sources)=>{
    const { contentProperties: contentProperties, devDocsOwnershipProperties: devDocsOwnershipProperties, devDocsProperties: devDocsProperties, propertyCollections: propertyCollections, smartFolderProperties: smartFolderProperties } = sources;
    const isDevDocsEnabled = (0, $6mKj3.isExperimentEnabled)('confluence_dev_docs');
    const isDevDocsOwned = (0, $cozmU.useMemo)(()=>(0, $aboIx.isDevDocsOwnedFolder)({
            propertyCollections: $294e9e08bc7d2598$var$getPropertyCollections({
                contentProperties: contentProperties,
                devDocsOwnershipProperties: devDocsOwnershipProperties,
                devDocsProperties: devDocsProperties,
                propertyCollections: propertyCollections,
                smartFolderProperties: smartFolderProperties
            })
        }), [
        contentProperties,
        devDocsOwnershipProperties,
        devDocsProperties,
        propertyCollections,
        smartFolderProperties
    ]);
    return (0, $cozmU.useMemo)(()=>({
            isDevDocsEnabled: isDevDocsEnabled,
            isDevDocsEligible: isDevDocsEnabled && isDevDocsOwned,
            isDevDocsOwned: isDevDocsOwned
        }), [
        isDevDocsEnabled,
        isDevDocsOwned
    ]);
};
module.exports["useDevDocsFolderEligibility"] = $294e9e08bc7d2598$export$acc7106896b1bce2;

});

parcelRegister("aboIx", function(module, exports) {

var $6rBRz = parcelRequire("6rBRz");

const $95f2a41306aaddc5$var$DEV_DOCS_CONTAINER_APPS = new Set([
    'bitbucket',
    'github'
]);
const $95f2a41306aaddc5$var$isDevDocsContainerApp = (containerApp)=>Boolean(containerApp && $95f2a41306aaddc5$var$DEV_DOCS_CONTAINER_APPS.has(containerApp.trim().toLowerCase()));
const $95f2a41306aaddc5$export$270f9eb55072514a = ({ propertyCollections: propertyCollections = [] })=>{
    if (propertyCollections.some((properties)=>(0, $6rBRz.hasDevDocsContentProperty)(properties))) return true;
    return propertyCollections.some((properties)=>$95f2a41306aaddc5$var$isDevDocsContainerApp((0, $6rBRz.getDevDocsSmartFolderProperties)(properties)?.containerApp));
};
const $95f2a41306aaddc5$export$4977c1f16ed3f03f = ({ ownershipProperties: ownershipProperties, smartFolderProperties: smartFolderProperties })=>$95f2a41306aaddc5$export$270f9eb55072514a({
        propertyCollections: [
            ownershipProperties,
            smartFolderProperties
        ]
    });
module.exports["isDevDocsOwnedFolder"] = $95f2a41306aaddc5$export$270f9eb55072514a;
module.exports["shouldExcludeDevDocsAutoSync"] = $95f2a41306aaddc5$export$4977c1f16ed3f03f;

});

parcelRegister("fZLJ8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3BmH5 = parcelRequire("3BmH5");


var $i1PdO = parcelRequire("i1PdO");


var $aboIx = parcelRequire("aboIx");

const $050967cdd11104af$var$MANAGED_FOLDER_SUBTYPE = 'managed';
const $050967cdd11104af$var$isManagedFolderAncestor = (ancestor)=>ancestor?.type?.toLowerCase() === 'folder' && ancestor?.subType?.toLowerCase() === $050967cdd11104af$var$MANAGED_FOLDER_SUBTYPE;
const $050967cdd11104af$var$getCreatedByDisplayName = (ancestor)=>{
    const displayName = ancestor?.['history']?.createdBy?.displayName?.trim();
    return displayName || null;
};
const $050967cdd11104af$export$b792028224cde203 = (ancestors)=>{
    const managedDevDocsAncestor = ancestors?.find((ancestor)=>{
        if (!$050967cdd11104af$var$isManagedFolderAncestor(ancestor)) return false;
        if (!(0, $aboIx.isDevDocsOwnedFolder)({
            propertyCollections: [
                ancestor?.properties?.nodes
            ]
        })) return false;
        return Boolean((0, $3BmH5.getDevDocsFolderMetadata)(ancestor?.properties?.nodes).devDocsProperties?.repoName);
    });
    const folderMetadata = (0, $3BmH5.getDevDocsFolderMetadata)(managedDevDocsAncestor?.properties?.nodes);
    const repoName = folderMetadata.devDocsProperties?.repoName;
    const folderId = managedDevDocsAncestor?.id;
    if (!repoName || !folderId) return null;
    return {
        folderId: folderId,
        folderWebui: managedDevDocsAncestor?.links?.webui ?? null,
        repoName: repoName,
        provider: folderMetadata.containerApp,
        owner: $050967cdd11104af$var$getCreatedByDisplayName(managedDevDocsAncestor),
        lastSynced: folderMetadata.smartFolderProperties?.lastSynced ?? null
    };
};
const $050967cdd11104af$export$1e19ef9187efb6c7 = (ancestors)=>{
    const ancestorPropertyCollections = (0, $cozmU.useMemo)(()=>ancestors?.map((ancestor)=>ancestor?.properties?.nodes) ?? [], [
        ancestors
    ]);
    const { isDevDocsEligible: isDevDocsEligible } = (0, $i1PdO.useDevDocsFolderEligibility)({
        propertyCollections: ancestorPropertyCollections
    });
    return (0, $cozmU.useMemo)(()=>{
        if (!isDevDocsEligible) return null;
        return $050967cdd11104af$export$b792028224cde203(ancestors);
    }, [
        ancestors,
        isDevDocsEligible
    ]);
};
module.exports["getDevDocsConnectionFromAncestors"] = $050967cdd11104af$export$b792028224cde203;
module.exports["useDevDocsBylineConnection"] = $050967cdd11104af$export$1e19ef9187efb6c7;

});

parcelRegister("aYZaZ", function(module, exports) {
$parcel$export(module.exports, "Buttons", () => (parcelRequire("iQb1R")).Buttons);

var $jmjWc = parcelRequire("jmjWc");


var $6tSjb = parcelRequire("6tSjb");


var $iQb1R = parcelRequire("iQb1R");


const $ecc7cc41466863e8$export$82d507aca0e648e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZRz6B",
    name: "EllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("jpuOg"))).EllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});
module.exports["EllipsisDropdownComponent"] = $ecc7cc41466863e8$export$82d507aca0e648e3;

});

parcelRegister("6tSjb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5SGpQ = parcelRequire("5SGpQ");


var $6TaGl = parcelRequire("6TaGl");

const $565f8db62106cdff$var$i18n = (0, $kSwu1.defineMessages)({
    more: {
        id: "editor-ellipsis-dropdown.placeholder.ellipsis.more",
        defaultMessage: "More"
    }
});
const $565f8db62106cdff$export$2edf2f3658d4e349 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const label = intl.formatMessage($565f8db62106cdff$var$i18n.more);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        testId: "ellipsis-placeholder",
        isDisabled: true,
        iconBefore: moreIcon,
        appearance: "subtle"
    });
};
module.exports["EllipsisPlaceholder"] = $565f8db62106cdff$export$2edf2f3658d4e349;

});

parcelRegister("jpuOg", function(module, exports) {

let $e218404c05e7136c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e218404c05e7136c$var$load("iY1NC"),
    $e218404c05e7136c$var$load("fM5g3"),
    $e218404c05e7136c$var$load("cH8yZ"),
    $e218404c05e7136c$var$load("iY5MP")
]).then(()=>parcelRequire('3d2EW'));

});

parcelRegister("iQb1R", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $f15550a75cff81e6$export$665d5a662b7213f3 = /*#__PURE__*/ function(Buttons) {
    Buttons["DELETE_DRAFT"] = "delete-draft";
    Buttons["EDIT_LABELS"] = "edit-labels";
    Buttons["MOVE_PAGE"] = "move-page";
    Buttons["PREVIEW"] = "preview";
    Buttons["PUBLISH_WITHOUT_NOTIFY"] = "publish-without-notify";
    Buttons["RESOLVED_COMMENTS"] = "resolved-comments";
    Buttons["TEMPLATE_BROWSER"] = "template-browser";
    Buttons["VIEW_CHANGES"] = "view-changes";
    Buttons["EXPORT"] = "export";
    Buttons["ADVANCED"] = "advanced";
    Buttons["ARCHIVE"] = "archive";
    Buttons["ATTACHMENTS"] = "attachments";
    Buttons["SWITCH_TO_LIVE_EDIT"] = "switch-to-live-edit";
    Buttons["CLASSIFY_CONTENT"] = "classify-content";
    Buttons["MANAGE"] = "manage";
    Buttons["PRESENT"] = "presentation-mode";
    return Buttons;
}({});
module.exports["Buttons"] = $f15550a75cff81e6$export$665d5a662b7213f3;

});

parcelRegister("dfgVG", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $d6588355bb2f168c$export$37ee5f1519219257 = (contentId)=>{
    return (0, $17wUi.confluenceSessionStorageInstance)?.getItem((0, $1UApO.keys).EDITOR_REVERTED) === contentId;
};
const $d6588355bb2f168c$export$1c5c21f47c0c866b = (contentId)=>{
    (0, $17wUi.confluenceSessionStorageInstance)?.setItem((0, $1UApO.keys).EDITOR_REVERTED, contentId);
};
const $d6588355bb2f168c$export$75835fd24886e23f = ()=>{
    (0, $17wUi.confluenceSessionStorageInstance)?.removeItem((0, $1UApO.keys).EDITOR_REVERTED);
};
module.exports["checkRevertFlag"] = $d6588355bb2f168c$export$37ee5f1519219257;
module.exports["addRevertFlag"] = $d6588355bb2f168c$export$1c5c21f47c0c866b;
module.exports["removeRevertFlag"] = $d6588355bb2f168c$export$75835fd24886e23f;

});

parcelRegister("6ld6a", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $jtuBN = parcelRequire("jtuBN");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery, skipFetchIfCached: skipFetchIfCached } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipFetchIfCached || $[9] !== skipQuery || $[10] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery,
            skipFetchIfCached: skipFetchIfCached
        };
        $[8] = skipFetchIfCached;
        $[9] = skipQuery;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), {
        ...baseQueryOptions,
        __callerPackage__: "web-item-location"
    });
    if (!data) {
        let t8;
        let t9;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[12] = t8;
            $[13] = t9;
        } else {
            t8 = $[12];
            t9 = $[13];
        }
        let t10;
        if ($[14] !== error || $[15] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[14] = error;
            $[15] = loading;
            $[16] = t10;
        } else t10 = $[16];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[17] !== allowedWebItems || $[18] !== data || $[19] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        if ((0, $9wGTI.fg)("cc_record_non_content_macros")) (0, $8wW9d.recordNonContentAppKeys)("web-item", webItems.map($f64809aa9d8f3ca2$var$_temp2));
        $[17] = allowedWebItems;
        $[18] = data;
        $[19] = notAllowedWebItems;
        $[20] = webItems;
        $[21] = webSections;
    } else {
        webItems = $[20];
        webSections = $[21];
    }
    let t8;
    if ($[22] !== error || $[23] !== webItems || $[24] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[22] = error;
        $[23] = webItems;
        $[24] = webSections;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
function $f64809aa9d8f3ca2$var$_temp2(webItem_0) {
    return webItem_0.completeKey;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("c54hr", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $8s9DV.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $kBr4q.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $kBr4q.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("1PC5x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $297029061926b2dd$export$77691412571457f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8jq35",
    name: "LinkToThisPageDialog",
    loader: async ()=>(await (parcelRequire("itLch"))).LinkToThisPageDialog
});
module.exports["LinkToThisPageDialog"] = $297029061926b2dd$export$77691412571457f;

});

parcelRegister("itLch", function(module, exports) {

let $d73f8bc3a05bd793$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d73f8bc3a05bd793$var$load("iWnyc"),
    $d73f8bc3a05bd793$var$load("hhss7"),
    $d73f8bc3a05bd793$var$load("Wowvf"),
    $d73f8bc3a05bd793$var$load("dXoLf")
]).then(()=>parcelRequire('gaLJH'));

});

parcelRegister("82Ooj", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $3802aca2c5107012$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    livePagesEditModeFlagTitle: {
        id: "live-pages-features.live-pages.edit-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re editing this live doc"
    },
    livePagesEditModeFlagDescription: {
        id: "live-pages-features.live-pages.edit-mode-flag.description",
        defaultMessage: "Tip: To switch to viewing only, use the keyboard shortcut {keyCombination}."
    },
    livePagesViewModeFlagTitle: {
        id: "live-pages-features.live-pages.view-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re viewing this live doc"
    },
    livePagesViewModeFlagDescription: {
        id: "live-pages-features.live-pages.view-mode-flag.description",
        defaultMessage: "Tip: To start editing, select {keyCombination} on your keyboard."
    }
});
const $3802aca2c5107012$export$f1bb393ced142bbb = (flags)=>{
    const intl = (0, $kSwu1.useIntl)();
    const logger = (0, $7W8i8.getLogger)('editor-mainbuttons-livepage-modechanger');
    const hasLivePageModeFlagBeenShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            return flagsShown[mode] === true;
        } catch (error) {
            logger.error`Error checking if live page mode flag has been shown for mode: "${mode}". Reason: ${error.message}`;
            return false;
        }
    };
    const setLivePageModeFlagAsShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            flagsShown[mode] = true;
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN, JSON.stringify(flagsShown));
        } catch (error) {
            logger.error`Error setting live page mode flag as shown for mode: "${mode}". Reason: ${error.message}`;
        }
    };
    const modeDetails = {
        view: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_EDIT), intl.formatMessage)
            })
        },
        edit: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_VIEW), intl.formatMessage)
            })
        }
    };
    const showLivePageModeFlag = (newMode)=>{
        const selectedModeDetails = modeDetails[newMode];
        if (selectedModeDetails) {
            if (!hasLivePageModeFlagBeenShown(newMode)) {
                const { title: title, description: description } = selectedModeDetails;
                const flagId = 'live-pages-mode-flag';
                // hide any flags that are currently showing
                flags.hideFlag(flagId);
                flags.showFlag({
                    id: flagId,
                    title: title,
                    description: description,
                    close: 'auto'
                });
                setLivePageModeFlagAsShown(newMode);
            }
        }
    };
    return {
        showLivePageModeFlag: showLivePageModeFlag
    };
};
module.exports["useLivePageModeFlag"] = $3802aca2c5107012$export$f1bb393ced142bbb;

});

parcelRegister("5KL6w", function(module, exports) {
$parcel$export(module.exports, "usePresenterModeContext", () => (parcelRequire("l1b8J")).usePresenterModeContext);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $3HHS0 = parcelRequire("3HHS0");


var $l1b8J = parcelRequire("l1b8J");


const $51949aafbfeff0f9$export$d9be451d5ed0cecd = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qz-Pe",
    name: "PresenterModeContextProvider",
    loader: async ()=>(await Promise.resolve((parcelRequire("l1b8J")))).PresenterModeContextProvider
});

const $51949aafbfeff0f9$export$62fbe81a4ea288fa = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "P5ZKu",
    name: "LazyPresenterModeContextConsumer",
    loader: async ()=>(await Promise.resolve((parcelRequire("l1b8J")))).PresenterModeContextConsumer,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3HHS0.PresentationModePlaceholder), null)
});
module.exports["PresenterModeContextProvider"] = $51949aafbfeff0f9$export$d9be451d5ed0cecd;
module.exports["LazyPresenterModeContextConsumer"] = $51949aafbfeff0f9$export$62fbe81a4ea288fa;

});

parcelRegister("3HHS0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $667e8b8d9015d9ff$export$a718db6ba6835b50 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '40px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '17px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '10%'
        }
    }));
};
module.exports["PresentationModePlaceholder"] = $667e8b8d9015d9ff$export$a718db6ba6835b50;

});

parcelRegister("l1b8J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $d3MrN = parcelRequire("d3MrN");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7J5Uc = parcelRequire("7J5Uc");


var $8uOqu = parcelRequire("8uOqu");

const $fb6fb6e8473a5f8b$var$PresenterModeContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    isPresenterModeActive: false,
    isBrowserFullscreen: false,
    hasEnteredPresentMode: false,
    presenterModeContextError: null,
    isPresenterModeEnabled: false,
    enterPresenterMode: ()=>{
    // Intentional no-op
    },
    exitPresenterMode: ()=>{
    // Intentional no-op
    },
    setPresenterModeContextError: ()=>{
    // Intentional no-op
    },
    enterBrowserFullscreen: ()=>{
    // Intentional no-op
    },
    enterSystemFullscreen: ()=>{
    // Intentional no-op
    },
    setIsBrowserFullscreen: ()=>{
    // Intentional no-op
    },
    setHasEnteredPresentMode: ()=>{
    // Intentional no-op
    }
});
const $fb6fb6e8473a5f8b$export$d9be451d5ed0cecd = ({ children: children, contentId: contentId, spaceKey: spaceKey })=>{
    const [isPresenterModeActive, setIsPresenterModeActive] = (0, $cozmU.useState)(false);
    const [isBrowserFullscreen, setIsBrowserFullscreen] = (0, $cozmU.useState)(false);
    const [presenterModeContextError, setPresenterModeContextError] = (0, $cozmU.useState)(null);
    const [hasEnteredPresentMode, setHasEnteredPresentMode] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { restoreThemePreference: restoreThemePreference } = (0, $7J5Uc.useThemingActions)();
    const enterBrowserFullscreen = (0, $cozmU.useCallback)(()=>{
        setIsBrowserFullscreen(true);
    }, []);
    const handleFullScreenApiError = (0, $cozmU.useCallback)((error)=>{
        enterBrowserFullscreen();
        setPresenterModeContextError(error);
    }, [
        setPresenterModeContextError,
        enterBrowserFullscreen
    ]);
    const fscreenRequestFullscreen = (0, $cozmU.useCallback)(()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        return Promise.resolve((0, $d3MrN.default).requestFullscreen(document.documentElement));
    }, []);
    const fscreenExitFullscreen = (0, $cozmU.useCallback)(()=>{
        return Promise.resolve((0, $d3MrN.default).exitFullscreen());
    }, []);
    const isPresenterModeEnabled = (0, $d3MrN.default).fullscreenEnabled;
    const enterPresenterMode = (0, $cozmU.useCallback)(()=>{
        setHasEnteredPresentMode(true);
        experienceTracker.start({
            name: (0, $irVI7.PRESENTER_MODE_FULLSCREEN_API_EXPERIENCE)
        });
        (0, $d3MrN.default).addEventListener('fullscreenerror', handleFullScreenApiError, false);
        setIsPresenterModeActive(true);
        setPresenterModeContextError(null);
        if (!isPresenterModeEnabled) {
            const error = new Error('Fullscreen mode is not supported');
            handleFullScreenApiError(error);
            enterBrowserFullscreen();
            return;
        }
        if ((0, $d3MrN.default).fullscreenElement) fscreenExitFullscreen().then(fscreenRequestFullscreen).then(()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
            });
        }).catch(enterBrowserFullscreen);
        else fscreenRequestFullscreen().then(()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
            });
        }).catch(enterBrowserFullscreen);
    }, [
        experienceTracker,
        fscreenRequestFullscreen,
        isPresenterModeEnabled,
        fscreenExitFullscreen,
        handleFullScreenApiError,
        enterBrowserFullscreen,
        setHasEnteredPresentMode
    ]);
    const enterSystemFullscreen = (0, $cozmU.useCallback)(()=>{
        setIsBrowserFullscreen(false);
        enterPresenterMode();
    }, [
        enterPresenterMode
    ]);
    const exitPresenterMode = (0, $cozmU.useCallback)(()=>{
        setIsPresenterModeActive(false);
        (0, $d3MrN.default).removeEventListener('fullscreenerror', handleFullScreenApiError, false);
        restoreThemePreference();
    }, [
        setIsPresenterModeActive,
        handleFullScreenApiError,
        restoreThemePreference
    ]);
    const data = (0, $cozmU.useMemo)(()=>({
            isPresenterModeActive: isPresenterModeActive,
            isBrowserFullscreen: isBrowserFullscreen,
            hasEnteredPresentMode: hasEnteredPresentMode,
            enterPresenterMode: enterPresenterMode,
            exitPresenterMode: exitPresenterMode,
            isPresenterModeEnabled: isPresenterModeEnabled,
            presenterModeContextError: presenterModeContextError,
            setPresenterModeContextError: setPresenterModeContextError,
            enterBrowserFullscreen: enterBrowserFullscreen,
            setIsBrowserFullscreen: setIsBrowserFullscreen,
            enterSystemFullscreen: enterSystemFullscreen,
            setHasEnteredPresentMode: setHasEnteredPresentMode
        }), [
        isPresenterModeActive,
        isBrowserFullscreen,
        hasEnteredPresentMode,
        enterPresenterMode,
        exitPresenterMode,
        isPresenterModeEnabled,
        presenterModeContextError,
        setPresenterModeContextError,
        enterBrowserFullscreen,
        setIsBrowserFullscreen,
        enterSystemFullscreen,
        setHasEnteredPresentMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb6fb6e8473a5f8b$var$PresenterModeContext.Provider, {
        value: data
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8uOqu.PresenterModeWrapper), {
        contentId: contentId,
        spaceKey: spaceKey
    }));
};
const $fb6fb6e8473a5f8b$export$5b228b85ce187234 = ()=>{
    return (0, $cozmU.useContext)($fb6fb6e8473a5f8b$var$PresenterModeContext);
};
const $fb6fb6e8473a5f8b$export$530d225c8bef9444 = ({ children: children })=>{
    const { enterPresenterMode: enterPresenterMode } = $fb6fb6e8473a5f8b$export$5b228b85ce187234();
    return children(enterPresenterMode);
};
module.exports["PresenterModeContextProvider"] = $fb6fb6e8473a5f8b$export$d9be451d5ed0cecd;
module.exports["usePresenterModeContext"] = $fb6fb6e8473a5f8b$export$5b228b85ce187234;
module.exports["PresenterModeContextConsumer"] = $fb6fb6e8473a5f8b$export$530d225c8bef9444;

});

parcelRegister("d3MrN", function(module, exports) {
var $982122d42c7c3a7b$var$key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5,
    fullscreen: 6
};
var $982122d42c7c3a7b$var$webkit = [
    'webkitFullscreenEnabled',
    'webkitFullscreenElement',
    'webkitRequestFullscreen',
    'webkitExitFullscreen',
    'webkitfullscreenchange',
    'webkitfullscreenerror',
    '-webkit-full-screen'
];
var $982122d42c7c3a7b$var$moz = [
    'mozFullScreenEnabled',
    'mozFullScreenElement',
    'mozRequestFullScreen',
    'mozCancelFullScreen',
    'mozfullscreenchange',
    'mozfullscreenerror',
    '-moz-full-screen'
];
var $982122d42c7c3a7b$var$ms = [
    'msFullscreenEnabled',
    'msFullscreenElement',
    'msRequestFullscreen',
    'msExitFullscreen',
    'MSFullscreenChange',
    'MSFullscreenError',
    '-ms-fullscreen'
];
// so it doesn't throw if no window or document
var $982122d42c7c3a7b$var$document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
var $982122d42c7c3a7b$var$vendor = 'fullscreenEnabled' in $982122d42c7c3a7b$var$document && Object.keys($982122d42c7c3a7b$var$key) || $982122d42c7c3a7b$var$webkit[0] in $982122d42c7c3a7b$var$document && $982122d42c7c3a7b$var$webkit || $982122d42c7c3a7b$var$moz[0] in $982122d42c7c3a7b$var$document && $982122d42c7c3a7b$var$moz || $982122d42c7c3a7b$var$ms[0] in $982122d42c7c3a7b$var$document && $982122d42c7c3a7b$var$ms || [];
var $982122d42c7c3a7b$var$fscreen = {
    requestFullscreen: function(element) {
        return element[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.requestFullscreen]]();
    },
    requestFullscreenFunction: function(element) {
        return element[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.requestFullscreen]];
    },
    get exitFullscreen () {
        return $982122d42c7c3a7b$var$document[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.exitFullscreen]].bind($982122d42c7c3a7b$var$document);
    },
    get fullscreenPseudoClass () {
        return ":" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreen];
    },
    addEventListener: function(type, handler1, options) {
        return $982122d42c7c3a7b$var$document.addEventListener($982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key[type]], handler1, options);
    },
    removeEventListener: function(type, handler1, options) {
        return $982122d42c7c3a7b$var$document.removeEventListener($982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key[type]], handler1, options);
    },
    get fullscreenEnabled () {
        return Boolean($982122d42c7c3a7b$var$document[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenEnabled]]);
    },
    set fullscreenEnabled (val){},
    get fullscreenElement () {
        return $982122d42c7c3a7b$var$document[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenElement]];
    },
    set fullscreenElement (val){},
    get onfullscreenchange () {
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenchange]).toLowerCase()];
    },
    set onfullscreenchange (handler){
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenchange]).toLowerCase()] = handler;
    },
    get onfullscreenerror () {
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenerror]).toLowerCase()];
    },
    set onfullscreenerror (handler){
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenerror]).toLowerCase()] = handler;
    }
};
var $982122d42c7c3a7b$export$2e2bcd8739ae039 //# sourceMappingURL=fscreen.esm.js.map
 = $982122d42c7c3a7b$var$fscreen;
module.exports["default"] = $982122d42c7c3a7b$export$2e2bcd8739ae039;

});

parcelRegister("8uOqu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");


var $l1b8J = parcelRequire("l1b8J");


var $hMdkB = parcelRequire("hMdkB");

const $a1ce8cd657fbddc0$export$2a648297aa723519 = ({ contentId: contentId, spaceKey: spaceKey })=>{
    const { isPresenterModeActive: isPresenterModeActive, isBrowserFullscreen: isBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    if (isPresenterModeActive || isBrowserFullscreen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMdkB.PresenterModePortal), {
            contentId: contentId,
            spaceKey: spaceKey,
            setFlagsVisibility: flags.setFlagsVisibility
        }));
    return null;
};
module.exports["PresenterModeWrapper"] = $a1ce8cd657fbddc0$export$2a648297aa723519;

});

parcelRegister("hMdkB", function(module, exports) {

var $g6TxC = parcelRequire("g6TxC");


var $9HwND = parcelRequire("9HwND");


var $Ndi2y = parcelRequire("Ndi2y");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d3MrN = parcelRequire("d3MrN");


var $1enXm = parcelRequire("1enXm");


var $6SsN4 = parcelRequire("6SsN4");


var $cK21K = parcelRequire("cK21K");


var $lfoFx = parcelRequire("lfoFx");


var $jMyy4 = parcelRequire("jMyy4");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $8rneB = parcelRequire("8rneB");


var $di8q4 = parcelRequire("di8q4");


var $e8Lxy = parcelRequire("e8Lxy");


var $cTIr3 = parcelRequire("cTIr3");


var $euF5O = parcelRequire("euF5O");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $cMvQV = parcelRequire("cMvQV");


var $Qlykt = parcelRequire("Qlykt");


var $ep3mz = parcelRequire("ep3mz");


var $kDhla = parcelRequire("kDhla");


var $9wGTI = parcelRequire("9wGTI");


var $chP0Z = parcelRequire("chP0Z");


var $j3Lh2 = parcelRequire("j3Lh2");


var $kXAIp = parcelRequire("kXAIp");


var $2jkzM = parcelRequire("2jkzM");


var $ibtF1 = parcelRequire("ibtF1");


var $7mDnI = parcelRequire("7mDnI");


var $gnyTR = parcelRequire("gnyTR");


var $l1b8J = parcelRequire("l1b8J");


var $fDEVM = parcelRequire("fDEVM");

const $bdd13d294a89f9eb$var$i18n = (0, $kSwu1.defineMessages)({
    genericErrorMessage: {
        id: "presentation-mode.portal.generic.error.message",
        defaultMessage: "Something\u2019s not right. Refresh and try again."
    }
});
const $bdd13d294a89f9eb$var$presenterModeContainerStyle = null;
const $bdd13d294a89f9eb$var$spacerStyle = null; /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
const $bdd13d294a89f9eb$var$titleFixedSpacingStyle = null; /* eslint-enable @atlaskit/design-system/use-tokens-typography */ 
const $bdd13d294a89f9eb$export$fa29436318a8d949 = 'presenter-mode-zoom-container';
const $bdd13d294a89f9eb$export$e1872a7bb3bd287c = 'presenter-mode-container';
const $bdd13d294a89f9eb$export$158030c0e49f9498 = 'presenter-mode-portal-container';
const $bdd13d294a89f9eb$export$750df9d29fdbd29f = 'presenter-mode-title-text';
const $bdd13d294a89f9eb$export$9439b54f8681bb48 = 'presenter-mode-content-container';
const $bdd13d294a89f9eb$export$4d12947f8edb059f = 'presenter-mode-content-container-bottom-spacer';
(0, $cMvQV.setUserAgent)();
const $bdd13d294a89f9eb$var$legacyMacroRendererContextValue = {
    shouldRefetchMacroQuery: true
};
const $bdd13d294a89f9eb$var$presenterModeStickyHeaders = {
    offsetTop: 0
};
const $bdd13d294a89f9eb$var$PresenterModePortalContentFragment = (0, $Ndi2y.default);
const $bdd13d294a89f9eb$var$PresenterModePortalPresenterModeContentTitleQuery = (0, $9HwND.default);
const $bdd13d294a89f9eb$var$PresenterModePortalPresenterModeCoverPictureQuery = (0, $g6TxC.default);
const $bdd13d294a89f9eb$var$PresenterModePortalRender = ({ contentId: contentId, spaceKey: spaceKey, isCustomCursorActive: isCustomCursorActive, contentRendered: contentRendered, onSwitchCursor: onSwitchCursor, loading: loading, coverPictureProperty: coverPictureProperty, error: error, title: title, emojiTitle: emojiTitle, contentData: contentData, editorContent: editorContent, onRendered: onRendered, isTitleCenterAligned: isTitleCenterAligned, viewportWidth: viewportWidth, intl: intl })=>{
    const hasCoverPicture = !!coverPictureProperty;
    const hasEmoji = !!emojiTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: 519
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1enXm.default), {
        autoFocus: false,
        returnFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.PresenterModePortalContainer), {
        id: $bdd13d294a89f9eb$export$158030c0e49f9498,
        isCustomCursorActive: isCustomCursorActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2jkzM.HeaderPresenterMode), {
        contentRendered: contentRendered,
        onSwitchCursorClick: onSwitchCursor,
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: $bdd13d294a89f9eb$export$e1872a7bb3bd287c,
        className: (0, $hekY6.default)([
            "_39xV02N91d"
        ])
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.LoadingContainer), {
        "data-testid": "presenter-mode-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large",
        interactionName: "presenter-mode-portal"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ibtF1.HeaderImage), {
        contentId: contentId,
        coverPictureProperty: coverPictureProperty
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.PresenterModeZoomContainer), {
        "data-testid": "presenter-mode-zoom-container",
        id: $bdd13d294a89f9eb$export$fa29436318a8d949,
        isFirefox: (0, $cMvQV.isFirefox)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.FlagsContainer), null, Boolean(error) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7mDnI.ErrorFlag), {
        title: intl.formatMessage($bdd13d294a89f9eb$var$i18n.genericErrorMessage)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.TitleContainer), {
        id: $bdd13d294a89f9eb$export$750df9d29fdbd29f,
        "data-testid": "presenter-mode-title-container",
        hasCoverPicture: hasCoverPicture,
        isTitleCenterAligned: isTitleCenterAligned,
        hasEmoji: hasEmoji,
        width: viewportWidth
    }, emojiTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.EmojiWrapper), {
        hasCoverPicture: hasCoverPicture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emojiTitle,
        height: hasCoverPicture ? (0, $Qlykt.EMOJI_SIZE_LARGE) : (0, $Qlykt.EMOJI_SIZE_MEDIUM),
        hasCoverPicture: hasCoverPicture,
        isPageTitleComponent: true,
        context: "presenterMode",
        showTooltip: true,
        renderResourcedEmoji: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.TitleTextWrapper), {
        "data-testId": "titleTextWrapper",
        shouldAddLeftPadding: hasEmoji && !isTitleCenterAligned && !hasCoverPicture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("h1", {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _1kk5TkN779 _1UtDYzy7kJ _3W2Oc8wPeg _3zvHkHwPeg _4kiQYAS40j _0Of8r2gVvo _3iDTPbvLZJ _4ya3eECBl1 _26BoRwGt0E _2UheSnpJKa _1cTrnnmdCj _3VvjmbhzUg _2AcsaDpJKa"
        ])
    }, title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $euF5O.LegacyMacroRendererContext).Provider, {
        value: $bdd13d294a89f9eb$var$legacyMacroRendererContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8Lxy.PageContentRenderer), {
        contentId: contentId,
        document: editorContent,
        data: contentData,
        onRendered: onRendered,
        hasInlineComments: false,
        appearance: "full-page",
        stickyHeaders: $bdd13d294a89f9eb$var$presenterModeStickyHeaders,
        spaceKey: spaceKey,
        isPresentational: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: $bdd13d294a89f9eb$export$4d12947f8edb059f,
        className: (0, $hekY6.default)([
            "_0jFU0VHMkp"
        ])
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTIr3.LazyQRCodeGenerator), {
        contentId: contentId,
        spaceKey: spaceKey
    })))));
};
const $bdd13d294a89f9eb$var$PresenterModePortalFragmentData = ({ contentNode: contentNode, contentLoading: contentLoading, contentUnifiedError: contentUnifiedError, ...props })=>{
    const fragmentData = (0, $6SsN4.useFragment)($bdd13d294a89f9eb$var$PresenterModePortalContentFragment, contentNode);
    const emojiTitle = (0, $8rneB.getEmojiFromPublishedPageProperties)(fragmentData);
    const coverPictureProperty = fragmentData?.properties?.nodes?.find((node)=>node?.key === 'cover-picture-id-published');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bdd13d294a89f9eb$var$PresenterModePortalRender, {
        ...props,
        loading: contentLoading,
        coverPictureProperty: coverPictureProperty,
        error: contentUnifiedError,
        title: fragmentData?.title ?? '',
        emojiTitle: emojiTitle
    });
};
const $bdd13d294a89f9eb$var$PresenterModePortalQueryData = ({ contentId: contentId, contentLoading: contentLoading, contentUnifiedError: contentUnifiedError, ...props })=>{
    const { data: titleData, loading: titleLoading, error: contentTitleError } = (0, $jMyy4.useQueryInterop)($bdd13d294a89f9eb$var$PresenterModePortalPresenterModeContentTitleQuery, {
        fetchPolicy: 'cache-first',
        variables: {
            contentId: contentId
        },
        __callerPackage__: "presentation-mode"
    });
    const { data: coverPictureQueryData, loading: coverPictureLoading, error: presenterModeCoverPictureError } = (0, $jMyy4.useQueryInterop)($bdd13d294a89f9eb$var$PresenterModePortalPresenterModeCoverPictureQuery, {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        variables: {
            contentId: contentId,
            status: [
                'current'
            ]
        },
        __callerPackage__: "presentation-mode"
    });
    const coverPictureProperty = coverPictureQueryData?.content?.nodes?.[0]?.properties?.nodes?.[0] ?? undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bdd13d294a89f9eb$var$PresenterModePortalRender, {
        ...props,
        contentId: contentId,
        loading: contentLoading || titleLoading || coverPictureLoading,
        coverPictureProperty: coverPictureProperty,
        error: contentTitleError || contentUnifiedError || presenterModeCoverPictureError,
        title: titleData?.content?.nodes?.[0]?.title ?? '',
        emojiTitle: (0, $8rneB.getPublishedEmojiId)(titleData)
    });
}; /**
    * This component encapsulates the actual presenter mode experience. It's responsible
    * for rendering the nav bar and the content itself, which it gets via GraphQL.
    * Everything is placed within a Portal component which is rendered on top of the page.
    */ 
const $bdd13d294a89f9eb$export$c815374aa38c89e7 = ({ contentId: contentId, spaceKey: spaceKey, setFlagsVisibility: setFlagsVisibility })=>{
    const [isCustomCursorActive, setIsCustomCursorActive] = (0, $cozmU.useState)(true);
    const [contentRendered, setContentRendered] = (0, $cozmU.useState)(false);
    const [editorContent, setEditorContent] = (0, $cozmU.useState)();
    const { isBrowserFullscreen: isBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    const [{ fullPageEditorPresetAPI: editorApi }] = (0, $kDhla.useFullPageEditorApi)();
    const intl = (0, $kSwu1.useIntl)();
    const handleSwitchCursor = (newValue)=>setIsCustomCursorActive(newValue); // Prevent scrolling of content underneath the portal
    (0, $j3Lh2.useLockBodyScroll)(); // Handles entering/exiting fullscreen mode
    (0, $chP0Z.useFullscreenMode)();
    (0, $cozmU.useEffect)(()=>{
        editorApi?.core.actions.requestDocument((doc)=>{
            setEditorContent(doc);
        });
    }, [
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isBrowserFullscreen) (0, $d3MrN.default).exitFullscreen();
    }, [
        isBrowserFullscreen
    ]); // Handles hiding flags while in Presenter Mode
    (0, $kXAIp.useHideFlags)(setFlagsVisibility);
    const [contentType] = (0, $ep3mz.useContentType)();
    const isBlogpost = contentType === 'blogpost';
    const skipContentUnifiedQuery = !contentId || !spaceKey; // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const pageContentUnifiedResult = (0, $jMyy4.useQueryInterop)((0, $jgc4t.default), {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: skipContentUnifiedQuery || isBlogpost,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: null
        },
        __callerPackage__: "presentation-mode"
    });
    const blogContentUnifiedResult = (0, $jMyy4.useQueryInterop)((0, $f9opb.default), {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: skipContentUnifiedQuery || !isBlogpost,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: null
        },
        __callerPackage__: "presentation-mode"
    });
    const { data: contentData, loading: contentLoading, error: contentUnifiedError } = isBlogpost ? blogContentUnifiedResult : pageContentUnifiedResult;
    const contentNode = contentData?.content?.nodes?.[0];
    const handleOnRenderedEvent = ()=>setContentRendered(true);
    const isTitleCenterAligned = (0, $fDEVM.useIsTitleCenterAligned)(contentId);
    const [viewportWidth, setViewportWidth] = (0, $cozmU.useState)(window.innerWidth);
    (0, $cozmU.useEffect)(()=>{
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    const sharedProps = {
        contentId: contentId,
        spaceKey: spaceKey,
        isCustomCursorActive: isCustomCursorActive,
        contentRendered: contentRendered,
        onSwitchCursor: handleSwitchCursor,
        contentData: contentData,
        editorContent: editorContent,
        onRendered: handleOnRenderedEvent,
        isTitleCenterAligned: isTitleCenterAligned,
        viewportWidth: viewportWidth,
        intl: intl
    };
    if ((0, $9wGTI.fg)('confluence_frontend_view_page_relay_fragment_dedup')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bdd13d294a89f9eb$var$PresenterModePortalFragmentData, {
        ...sharedProps,
        contentNode: contentNode,
        contentLoading: contentLoading,
        contentUnifiedError: contentUnifiedError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bdd13d294a89f9eb$var$PresenterModePortalQueryData, {
        ...sharedProps,
        contentLoading: contentLoading,
        contentUnifiedError: contentUnifiedError
    });
};
module.exports["PresenterModeZoomContainerId"] = $bdd13d294a89f9eb$export$fa29436318a8d949;
module.exports["PresenterModeContainerId"] = $bdd13d294a89f9eb$export$e1872a7bb3bd287c;
module.exports["PresenterModePortalContainerId"] = $bdd13d294a89f9eb$export$158030c0e49f9498;
module.exports["PresenterModePageTitleId"] = $bdd13d294a89f9eb$export$750df9d29fdbd29f;
module.exports["PresenterModeBottomSpacerId"] = $bdd13d294a89f9eb$export$4d12947f8edb059f;
module.exports["PresenterModePortal"] = $bdd13d294a89f9eb$export$c815374aa38c89e7;

});

parcelRegister("g6TxC", function(module, exports) {
/**
 * @generated SignedSource<<0249018a616de758b0f652bd2ee9dca9>>
 * @relayHash de4d9d686320df3885759997cb1dea1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 596432b3fe72e76dfac96d97bcdd00fadb3129b5e172d978a8692f0079b1c431
const $43087a03fe0f39ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PresenterModePortalPresenterModeCoverPictureQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PresenterModePortalPresenterModeCoverPictureQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "de4d9d686320df3885759997cb1dea1b",
            "id": "596432b3fe72e76dfac96d97bcdd00fadb3129b5e172d978a8692f0079b1c431",
            "metadata": {},
            "name": "PresenterModePortalPresenterModeCoverPictureQuery",
            "operationKind": "query",
            "text": "query PresenterModePortalPresenterModeCoverPictureQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$43087a03fe0f39ae$var$node.hash = "06d34d781803b4e8c4ff1a93ae7349df";
var $43087a03fe0f39ae$export$2e2bcd8739ae039 = $43087a03fe0f39ae$var$node;
module.exports["default"] = $43087a03fe0f39ae$export$2e2bcd8739ae039;

});

parcelRegister("9HwND", function(module, exports) {
/**
 * @generated SignedSource<<effa270f732243c74762ffd31141ca90>>
 * @relayHash 71650dfb167b5e53344553c052814f35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8784ffad5fb2dc131a0387a6140976fd26edfa297aa6c8b24de67ea4b167b55d
const $0cb2cdb46393f11b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "alias": "emojiTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"emoji-title-published\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PresenterModePortalPresenterModeContentTitleQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PresenterModePortalPresenterModeContentTitleQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "71650dfb167b5e53344553c052814f35",
            "id": "8784ffad5fb2dc131a0387a6140976fd26edfa297aa6c8b24de67ea4b167b55d",
            "metadata": {},
            "name": "PresenterModePortalPresenterModeContentTitleQuery",
            "operationKind": "query",
            "text": "query PresenterModePortalPresenterModeContentTitleQuery($contentId:ID!){content(id:$contentId){nodes{id,title,emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value}}}}}"
        }
    };
}();
$0cb2cdb46393f11b$var$node.hash = "bb4f3c014152c410cb5600c2a10111e8";
var $0cb2cdb46393f11b$export$2e2bcd8739ae039 = $0cb2cdb46393f11b$var$node;
module.exports["default"] = $0cb2cdb46393f11b$export$2e2bcd8739ae039;

});

parcelRegister("Ndi2y", function(module, exports) {
/**
 * @generated SignedSource<<ae828fd914e7407dae64b7f293ba8e58>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $78439205b7877f59$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PresenterModePortal_content",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "keys",
                    "value": [
                        "cover-picture-id-published",
                        "emoji-title-published",
                        "editor",
                        "import-source",
                        "imported-page-modified-date"
                    ]
                }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JsonContentProperty",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
        }
    ],
    "type": "Content"
};
$78439205b7877f59$var$node.hash = "32009a58e11b994a0a956b61ff15cbc6";
var $78439205b7877f59$export$2e2bcd8739ae039 = $78439205b7877f59$var$node;
module.exports["default"] = $78439205b7877f59$export$2e2bcd8739ae039;

});

parcelRegister("cTIr3", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $jmjWc = parcelRequire("jmjWc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fa2236fe735b9be$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0jFU0VN91d _39xV02N91d",
            __cmplp.className
        ])
    });
});
const $2fa2236fe735b9be$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2fa2236fe735b9be$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large"
    }));

const $2fa2236fe735b9be$export$c545dc5a218e1111 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mUAtU",
    name: "LazyQRCodeGenerator",
    loader: async ()=>(await (parcelRequire("kP5tp"))).QRCodeComponent,
    loading: $2fa2236fe735b9be$var$LoadingSpinner
});
module.exports["LazyQRCodeGenerator"] = $2fa2236fe735b9be$export$c545dc5a218e1111;

});

parcelRegister("kP5tp", function(module, exports) {

let $f28cd0f37a03f89e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f28cd0f37a03f89e$var$load("6wr18"),
    $f28cd0f37a03f89e$var$load("ffEVr"),
    $f28cd0f37a03f89e$var$load("2nHxT")
]).then(()=>parcelRequire('5RnXN'));

});

parcelRegister("chP0Z", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $d3MrN = parcelRequire("d3MrN");


var $l1b8J = parcelRequire("l1b8J");

const $a7ed65c805684c1a$export$5306b0eb80cf6407 = ()=>{
    const { exitPresenterMode: exitPresenterMode } = (0, $l1b8J.usePresenterModeContext)();
    (0, $cozmU.useEffect)(()=>{
        // Event handler for when entering/exiting fullscreen mode
        const handleFullscreenChange = ()=>{
            /**
       * This handles the case where the user has pressed Esc instead of using
       * the "Exit" button to close presenter mode. In this case, the browser
       * will be forced out of fullscreen mode, but presenter mode will still
       * technically be active, so we need to listen for the event to make
       * sure we exit presenter mode.
       */ if (!(0, $d3MrN.default).fullscreenElement) exitPresenterMode();
        };
        (0, $d3MrN.default).addEventListener('fullscreenchange', handleFullscreenChange, false);
        return ()=>{
            /**
       * This handles the common case where the user clicks the "Exit" button to close
       * presenter mode, which will cause this callback to run.
       */ if ((0, $d3MrN.default).fullscreenElement) (0, $d3MrN.default).exitFullscreen();
            (0, $d3MrN.default).removeEventListener('fullscreenchange', handleFullscreenChange, false);
        };
    }, [
        exitPresenterMode
    ]);
};
module.exports["useFullscreenMode"] = $a7ed65c805684c1a$export$5306b0eb80cf6407;

});

parcelRegister("j3Lh2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $e231207f12babf5b$export$bd4ec12442706c3d = ()=>{
    (0, $cozmU.useLayoutEffect)(()=>{
        const originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.body.style.overflow = originalStyle;
        };
    }, []);
};
module.exports["useLockBodyScroll"] = $e231207f12babf5b$export$bd4ec12442706c3d;

});

parcelRegister("kXAIp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $731701c7a4a3e42e$export$3fe03aa4ff5dc935 = (setFlagsVisibility)=>{
    (0, $cozmU.useEffect)(()=>{
        setFlagsVisibility(false);
        return ()=>{
            setFlagsVisibility(true);
        };
    }, [
        setFlagsVisibility
    ]);
};
module.exports["useHideFlags"] = $731701c7a4a3e42e$export$3fe03aa4ff5dc935;

});

parcelRegister("2jkzM", function(module, exports) {
/* HeaderPresenterMode.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $9DHhW = parcelRequire("9DHhW");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $7QM6o = parcelRequire("7QM6o");


var $3IVqo = parcelRequire("3IVqo");


var $gnyTR = parcelRequire("gnyTR");


var $9BWGi = parcelRequire("9BWGi");


var $l1b8J = parcelRequire("l1b8J");

const $66cd5922db697139$export$ef625543408b2447 = 'presenter-mode-control-panel';
const $66cd5922db697139$var$headerContainerStyles = null;
const $66cd5922db697139$var$verticalDividerStyles = null;
const $66cd5922db697139$var$rightControlPanelStyles = null;
const $66cd5922db697139$var$i18n = (0, $kSwu1.defineMessages)({
    exit: {
        id: "presentation-mode.header.exit",
        defaultMessage: "Exit"
    }
});
const $66cd5922db697139$export$c7c42ad700a3285 = ({ onSwitchCursorClick: onSwitchCursorClick, contentRendered: contentRendered, spaceKey: spaceKey, contentId: contentId })=>{
    const { exitPresenterMode: exitPresenterMode, isBrowserFullscreen: isBrowserFullscreen, setIsBrowserFullscreen: setIsBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const [showLazyButtons, setShowLazyButtons] = (0, $cozmU.useState)(false);
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    (0, $cozmU.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setShowLazyButtons(true);
        }, 0);
        return ()=>{
            clearTimeout(timeout);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewPresentScreen',
                attributes: {
                    objectId: contentId,
                    containerId: spaceId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        spaceId
    ]);
    const exit = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'present',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'close',
                objectId: contentId,
                containerId: spaceId
            }
        }).fire();
        exitPresenterMode();
    }, [
        createAnalyticsEvent,
        exitPresenterMode,
        contentId,
        spaceId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3IVqo.ControlPanelContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "presentation-mode-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: $66cd5922db697139$export$ef625543408b2447,
        className: (0, $hekY6.default)([
            "_4FKVYE8HPE _0bjKvDKxmn _0hPCNLDIqT _0KLXruoI2d _1mT5xdy1CL _2IhTonNHnM _4ApkO2NHnM _3iDTPbQ4SZ _42Yu6BHOnL _2OUyjtGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2XsHFMIZbP _3iDTPbQ4SZ _37wbyuz9WS _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9BWGi.LazyNavigation), {
        contentRendered: contentRendered,
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3JzbaeOeNX _0jFU0VoWWg _39xV02dnbC"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9BWGi.LazySettingsMenu), {
        onSwitchCursorClick: onSwitchCursorClick,
        contentId: contentId,
        spaceKey: spaceKey
    }), contentRendered && showLazyButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.ButtonContainer), {
        id: "presenter-mode-exit-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "presentation-mode-button-close",
        onClick: isBrowserFullscreen ? ()=>setIsBrowserFullscreen(false) : exit
    }, intl.formatMessage($66cd5922db697139$var$i18n.exit))))))));
};
module.exports["HeaderControlPanel"] = $66cd5922db697139$export$ef625543408b2447;
module.exports["HeaderPresenterMode"] = $66cd5922db697139$export$c7c42ad700a3285;

});

parcelRegister("3IVqo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $969cdac05668aa2c$var$ControlPanelContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    isSettingsOpen: false,
    setIsSettingsOpen: ()=>{
    // Intentional no-op
    },
    isNavigationMenuOpen: false,
    setIsNavigationMenuOpen: ()=>{
    // Intentional no-op
    },
    width: '1'
});
const $969cdac05668aa2c$export$a5457ef551a7a8bf = ({ children: children })=>{
    const [isSettingsOpen, setIsSettingsOpen] = (0, $cozmU.useState)(false);
    const [isNavigationMenuOpen, setIsNavigationMenuOpen] = (0, $cozmU.useState)(false);
    const [width, setWidth] = (0, $cozmU.useState)('1');
    const headerWidth = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById('presenter-mode-control-panel')?.getBoundingClientRect().width || 242;
    (0, $cozmU.useEffect)(()=>{
        setWidth(headerWidth.toString());
    }, [
        headerWidth
    ]);
    const data = (0, $cozmU.useMemo)(()=>({
            isSettingsOpen: isSettingsOpen,
            setIsSettingsOpen: setIsSettingsOpen,
            isNavigationMenuOpen: isNavigationMenuOpen,
            setIsNavigationMenuOpen: setIsNavigationMenuOpen,
            width: width
        }), [
        isSettingsOpen,
        setIsSettingsOpen,
        isNavigationMenuOpen,
        setIsNavigationMenuOpen,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($969cdac05668aa2c$var$ControlPanelContext.Provider, {
        value: data
    }, children);
};
const $969cdac05668aa2c$export$7a069434e96a0028 = ()=>{
    return (0, $cozmU.useContext)($969cdac05668aa2c$var$ControlPanelContext);
};
module.exports["ControlPanelContextProvider"] = $969cdac05668aa2c$export$a5457ef551a7a8bf;
module.exports["useControlPanelContext"] = $969cdac05668aa2c$export$7a069434e96a0028;

});

parcelRegister("gnyTR", function(module, exports) {
/* presenterModeStyles.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $Qlykt = parcelRequire("Qlykt");


var $O8fsx = parcelRequire("O8fsx");

const $72178c9eda154f79$var$screenSizeXS = 1080;
const $72178c9eda154f79$var$screenSizeS = 1280;
const $72178c9eda154f79$var$screenSizeM = 1536;
const $72178c9eda154f79$var$screenSizeL = 2560;
const $72178c9eda154f79$var$screenSizeHeaderImageBreakpoint = 1792;
const $72178c9eda154f79$var$CALCULATE_SCALED_COVER_IMAGE_HEIGHT_PRESENTER_MODE = 'min(max(calc(100vw * (7 / 38)), 140px), 750px)';
const $72178c9eda154f79$export$5aeddb36a71179f1 = -122;
const $72178c9eda154f79$export$18d6dec26df5efab = -104;
const $72178c9eda154f79$export$5cbab9ac5bb5eb6 = -95;
const $72178c9eda154f79$export$9efff5a152b2c8b9 = -82;
const $72178c9eda154f79$var$zoomLevelXSToM = 1.3;
const $72178c9eda154f79$var$zoomLevelL = 2;
const $72178c9eda154f79$var$cursorImage = `url(${(0, (/*@__PURE__*/$parcel$interopDefault($O8fsx)))}), auto`;
const $72178c9eda154f79$var$headerImageMediaQuery = {
    [`@media only screen and (min-width: ${$72178c9eda154f79$var$screenSizeHeaderImageBreakpoint}px)`]: {
        height: '360px'
    },
    [`@media only screen and (min-width: ${$72178c9eda154f79$var$screenSizeM}px) and (max-width: ${$72178c9eda154f79$var$screenSizeHeaderImageBreakpoint}px)`]: {
        height: '240px'
    },
    [`@media only screen and (max-width: ${$72178c9eda154f79$var$screenSizeM}px)`]: {
        height: '240px'
    }
};
const $72178c9eda154f79$export$ec38912285043019 = '1.5';
const $72178c9eda154f79$export$21d0e1ba36d5f647 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCustomCursorActive: isCustomCursorActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1db81y0": (0, $9aYkv.default)($72178c9eda154f79$var$cursorImage)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02qUim _0jFU0VWP8C _0KLXrulfZc _1mT5xdy1CL _2IhTondnbC _3OE6xYdnbC _2WAcuGLTLW _4bt5LAnQyn _3iDTPbQ4SZ _37wbyuDIqT _1Iq3WEYbGa _15QM2vOiJt _3fwf53OiJt _07PAZcU77s _3kZsVwOiJt _1pEPU0DIqT _2t1ILkVa5s _0QlLlGDIqT _2zPjG3YbGa",
            __cmplp.isCustomCursorActive ? "_0wOv4Q5MK9" : "_0wOv4QIZbP",
            __cmplp.isCustomCursorActive ? "_0acWuSCzj6" : "_0acWuSU77s",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$4b720caa3a1b5952 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fDMqu _0jFU0VlpyH _39xV02qUim _1DCdHiyFLW _27VrYpPgdg _0Ts0IxZqHV _2rWOAdZqHV _36tfrOwBC3 _4tBjibGVdc _21pNNZGVdc _3CHuwjN91d _4wCECZN91d _0Hb43qZqHV _2fs9BZN91d _0MdbOFPgdg _1z7xmEwBC3 _3oPxm8GVdc _3NXnmVGVdc _2uOYsGGVdc _2Wu2Z3wBC3 _3Aden1GVdc",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$141080fc4b582742 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1DCdHiVa5s _0jFU0Vb1xp",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$422f3370501bb5d5 = (scale, isFirefox)=>{
    return isFirefox ? `transform: scale(${scale})` : `zoom: ${scale};`;
};
const $72178c9eda154f79$export$354b8b07cc867365 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirefox: isFirefox, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _0yKXXaBwqQ _2ZftLr8yGE _03Q2gnsfvo _4Gnv1KL3tl _40kS8HAthV",
            __cmplp.isFirefox ? "_17edDNMgaz" : undefined,
            __cmplp.isFirefox ? undefined : "_4evpNUiZR3",
            __cmplp.isFirefox ? "_1hWSvYPrS9" : undefined,
            __cmplp.isFirefox ? undefined : "_0GAmc0dIGx",
            __cmplp.isFirefox ? "_0FtVHtVzjv" : undefined,
            __cmplp.isFirefox ? undefined : "_4kmPg3af8D",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$5e3f251c730829 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _0jFU0VWP8C",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$35e09ba17cc51c69 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, hasEmoji: hasEmoji, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XghbEl32T _3iDTPbQ4SZ _24h04i2Njc _4kiQYA7GLB _39xV02N91d _1EqgXl8yGE _3W2Oc8wPeg _1T2N03wPeg",
            __cmplp.isTitleCenterAligned ? "_37wbyuDIqT" : "_37wbyuzUZr",
            __cmplp.isTitleCenterAligned || __cmplp.hasCoverPicture ? "_0aFT5vbt8w" : "_0aFT5v1qpb",
            __cmplp.isTitleCenterAligned ? "_0hPCNLDIqT" : "_0hPCNLQame",
            __cmplp.hasCoverPicture || __cmplp.isTitleCenterAligned && __cmplp.hasEmoji ? "_2mHwu85zaO" : "_2mHwu8yL8i",
            __cmplp.hasCoverPicture && __cmplp.hasEmoji ? "_313842RiSR" : "_313842dnbC",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$f39f7ca4ec945bd5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldAddLeftPadding: shouldAddLeftPadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.shouldAddLeftPadding ? "_2Zuz6Q8HPE" : "_2Zuz6QZqHV",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$var$emojiCoverPictureMaxWidth = (hasCoverPicture)=>hasCoverPicture ? `${0, $Qlykt.EMOJI_SIZE_LARGE}px` : `${0, $Qlykt.EMOJI_SIZE_MEDIUM}px`;
const $72178c9eda154f79$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_mn762q": (0, $9aYkv.default)($72178c9eda154f79$var$emojiCoverPictureMaxWidth(__cmplp.hasCoverPicture))
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _1EqgXlOSVc _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$1b225d69cabf8532 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4rYULUVpNL _3ODULk9XL4 _4nvRjBpNyl",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XsHFM2ADO _3iDTPbvbI6",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$a87575d1597be323 = (width)=>{
    if (!width || width < $72178c9eda154f79$var$screenSizeXS) return $72178c9eda154f79$export$5aeddb36a71179f1;
    else if (width < $72178c9eda154f79$var$screenSizeM) return $72178c9eda154f79$export$18d6dec26df5efab;
    else if (width < $72178c9eda154f79$var$screenSizeL) return $72178c9eda154f79$export$5cbab9ac5bb5eb6;
    else return $72178c9eda154f79$export$9efff5a152b2c8b9;
};
module.exports["mToLScreenZoomLevel"] = $72178c9eda154f79$export$ec38912285043019;
module.exports["PresenterModePortalContainer"] = $72178c9eda154f79$export$21d0e1ba36d5f647;
module.exports["HeaderImageContainer"] = $72178c9eda154f79$export$4b720caa3a1b5952;
module.exports["NoHeaderImageSpacer"] = $72178c9eda154f79$export$141080fc4b582742;
module.exports["PresenterModeZoomContainer"] = $72178c9eda154f79$export$354b8b07cc867365;
module.exports["LoadingContainer"] = $72178c9eda154f79$export$5e3f251c730829;
module.exports["SpinnerContainer"] = $72178c9eda154f79$export$a5e06607a5ac6158;
module.exports["TitleContainer"] = $72178c9eda154f79$export$35e09ba17cc51c69;
module.exports["TitleTextWrapper"] = $72178c9eda154f79$export$f39f7ca4ec945bd5;
module.exports["EmojiWrapper"] = $72178c9eda154f79$export$e31a6cc0a4c97f0e;
module.exports["FlagsContainer"] = $72178c9eda154f79$export$1b225d69cabf8532;
module.exports["ButtonContainer"] = $72178c9eda154f79$export$eddf54ea3db8d0f0;

});

parcelRegister("O8fsx", function(module, exports) {
module.exports = new URL("customCursor.8a87402c.svg", import.meta.url).toString();

});

parcelRegister("9BWGi", function(module, exports) {
/* LazyButtons.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $jmjWc = parcelRequire("jmjWc");

const $cb3e4c1f9ef026ad$var$spinnerContainerStyles = null;
const $cb3e4c1f9ef026ad$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0jFU0VUofl _39xV02Uofl _0adFHs8HPE"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "presentation-mode-lazy-buttons"
    }));

const $cb3e4c1f9ef026ad$export$490f62136438ac6e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9F1oH",
    name: "LazyNavigation",
    loader: async ()=>(await (parcelRequire("6cTcM"))).NavigationPresenterMode,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb3e4c1f9ef026ad$var$LoadingSpinner, null)
});

const $cb3e4c1f9ef026ad$export$37c96b963636f7cc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "60c-p",
    name: "LazySettingsMenu",
    loader: async ()=>(await (parcelRequire("fK8uT"))).SettingsMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb3e4c1f9ef026ad$var$LoadingSpinner, null)
});
module.exports["LazyNavigation"] = $cb3e4c1f9ef026ad$export$490f62136438ac6e;
module.exports["LazySettingsMenu"] = $cb3e4c1f9ef026ad$export$37c96b963636f7cc;

});

parcelRegister("6cTcM", function(module, exports) {

let $484eafa2caaa60a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $484eafa2caaa60a6$var$load("ea3NB"),
    $484eafa2caaa60a6$var$load("6wr18"),
    $484eafa2caaa60a6$var$load("7EorR"),
    $484eafa2caaa60a6$var$load("aLbuU"),
    $484eafa2caaa60a6$var$load("ffEVr"),
    $484eafa2caaa60a6$var$load("hhss7"),
    $484eafa2caaa60a6$var$load("9IaUU")
]).then(()=>parcelRequire('lQ3Oi'));

});

parcelRegister("fK8uT", function(module, exports) {

let $b761be44ff5fcc2b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b761be44ff5fcc2b$var$load("6wr18"),
    $b761be44ff5fcc2b$var$load("ffEVr"),
    $b761be44ff5fcc2b$var$load("Wowvf"),
    $b761be44ff5fcc2b$var$load("62AD8")
]).then(()=>parcelRequire('2JGhm'));

});

parcelRegister("ibtF1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3oWMY = parcelRequire("3oWMY");


var $3WPGR = parcelRequire("3WPGR");


var $1d2ww = parcelRequire("1d2ww");


var $gnyTR = parcelRequire("gnyTR");


var $fDEVM = parcelRequire("fDEVM");

const $647837bde418af85$export$82c94077b89191c5 = 'presenter-mode-header-image-container';
const $647837bde418af85$export$7b5e76b410389064 = ({ contentId: contentId, coverPictureProperty: coverPictureProperty })=>{
    const [coverPictureData, setCoverPictureData] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (!coverPictureProperty) return;
        const publishedId = (0, $3WPGR.propertyToId)(coverPictureProperty);
        if (!publishedId) return;
        const coverPic = {
            draft: null,
            published: {
                value: {
                    id: (0, $fDEVM.createHigherResImgSrc)(publishedId?.value?.id),
                    position: publishedId?.value?.position || 0
                },
                version: publishedId?.version
            }
        };
        setCoverPictureData(coverPic);
    }, [
        coverPictureProperty
    ]);
    if (!coverPictureData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.NoHeaderImageSpacer), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.HeaderImageContainer), {
        id: $647837bde418af85$export$82c94077b89191c5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3oWMY.RendererPageCoverPicture), {
        contentId: contentId,
        isPagePreview: false,
        coverPicture: coverPictureData,
        contentAppearance: {
            draft: '',
            published: (0, $1d2ww.ContentAppearanceType).FULL_WIDTH
        },
        isSpaceOverview: false,
        isPresenterMode: true
    }));
};
module.exports["HeaderImageContainerId"] = $647837bde418af85$export$82c94077b89191c5;
module.exports["HeaderImage"] = $647837bde418af85$export$7b5e76b410389064;

});

parcelRegister("fDEVM", function(module, exports) {

var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $hMdkB = parcelRequire("hMdkB");

var $9b92440f7f429369$export$1ef9fc5d7a7ef8e2 = /*#__PURE__*/ function(TYPE_OF_NODE) {
    TYPE_OF_NODE["LAYOUT"] = "layout";
    TYPE_OF_NODE["HR"] = "hr";
    TYPE_OF_NODE["EXPAND"] = "expand";
    TYPE_OF_NODE["HEADING"] = "header";
    TYPE_OF_NODE["EMPTY"] = "empty";
    TYPE_OF_NODE["OTHER"] = "other";
    TYPE_OF_NODE["STICKY_HEADER"] = "stickyHeader";
    TYPE_OF_NODE["TABLE"] = "table";
    TYPE_OF_NODE["MACRO"] = "macro";
    TYPE_OF_NODE["IMAGE"] = "image";
    return TYPE_OF_NODE;
}({});
const $9b92440f7f429369$export$be27aa1bed7edb58 = (scrollUp)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const scrollContainer = document.getElementById(`${(0, $hMdkB.PresenterModePortalContainerId)}`);
    // Scroll by half the viewport height
    const scrollAmount = window.innerHeight * 0.5 * (scrollUp ? -1 : 1);
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(()=>{
        scrollContainer?.scrollBy({
            top: scrollContainer.getBoundingClientRect().top + scrollAmount,
            behavior: 'smooth'
        });
    });
};
const $9b92440f7f429369$export$8286ea4d39e1c85c = (originalSrc)=>{
    if (!originalSrc.includes('images.unsplash.com')) return originalSrc;
    const baseAndParams = originalSrc.split('?');
    const queryParams = new URLSearchParams(baseAndParams[1]);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const width = Math.min(document?.documentElement?.clientWidth, 3000);
    queryParams.set('w', width.toString());
    queryParams.delete('q');
    return `${baseAndParams[0]}?${queryParams.toString()}`;
};
const $9b92440f7f429369$export$87b554716dce1db0 = (refNode)=>{
    const getFirstTextNodeIterative = (refNode)=>{
        const stack = [
            refNode
        ];
        while(stack.length > 0){
            const node = stack.pop();
            if (node.nodeType == 3 && node.nodeValue?.trim().length !== 0) return node;
            for(let i = node.childNodes.length - 1; i >= 0; i--)stack.push(node.childNodes[i]);
        }
    };
    return getFirstTextNodeIterative(refNode);
};
const $9b92440f7f429369$export$91dc29669e88d0db = (node)=>{
    return /^([Hh])[0-6].*/.test(node?.tagName);
};
const $9b92440f7f429369$export$dd1bc94b04021eeb = (node)=>{
    const firstTextNode = $9b92440f7f429369$export$87b554716dce1db0(node);
    if ($9b92440f7f429369$export$91dc29669e88d0db(node) && !firstTextNode) return true;
    if ($9b92440f7f429369$export$ed5642f3e4fb7c54(node)) return true;
    const isImage = node.classList.contains('rich-media-item') || !!node.querySelector('img') || !!node.querySelector('svg');
    const isEmptyTextElement = !firstTextNode;
    return !isImage && isEmptyTextElement;
};
const $9b92440f7f429369$export$fb85bc5d6d9ef19b = (node)=>{
    return node.classList.contains('rich-media-item') || !!node.querySelector('img') || !!node.querySelector('svg');
};
const $9b92440f7f429369$export$bf32d97724374086 = (node)=>{
    return !!node.querySelector('.pm-table-sticky-wrapper');
};
const $9b92440f7f429369$export$567a2801b8f40ab5 = (node)=>{
    return node.classList.contains('pm-table-container') || !!node.querySelector('.pm-table-container') && !$9b92440f7f429369$export$bf32d97724374086(node);
};
const $9b92440f7f429369$export$1980ca1f3eaf85fb = (node)=>{
    return node.getAttribute('data-layout-section') === 'true';
};
const $9b92440f7f429369$export$d8bf6fedd3b53772 = (node)=>{
    return node.tagName === 'HR';
};
const $9b92440f7f429369$export$35e907bd866058b8 = (node)=>{
    return node.classList.contains('ak-renderer-extension') || !!node.querySelector('.ak-renderer-extension');
};
const $9b92440f7f429369$export$1d7f19df4bf635f6 = (node)=>{
    return node.classList.contains('code-block') || !!node.querySelector('.code-block');
};
const $9b92440f7f429369$export$ed5642f3e4fb7c54 = (node)=>{
    return node.tagName === 'BR';
};
const $9b92440f7f429369$export$822db98f95375647 = (contentId)=>{
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)({
        contentId: contentId
    });
    return !!(titleContentProperties?.titleLayoutAlignment === (0, $jVylI.TitleAlignmentType).CENTER);
};
module.exports["TYPE_OF_NODE"] = $9b92440f7f429369$export$1ef9fc5d7a7ef8e2;
module.exports["scrollFixedAmount"] = $9b92440f7f429369$export$be27aa1bed7edb58;
module.exports["createHigherResImgSrc"] = $9b92440f7f429369$export$8286ea4d39e1c85c;
module.exports["getFirstTextNode"] = $9b92440f7f429369$export$87b554716dce1db0;
module.exports["isHeading"] = $9b92440f7f429369$export$91dc29669e88d0db;
module.exports["isEmpty"] = $9b92440f7f429369$export$dd1bc94b04021eeb;
module.exports["isImage"] = $9b92440f7f429369$export$fb85bc5d6d9ef19b;
module.exports["isStickyHeaderOfTable"] = $9b92440f7f429369$export$bf32d97724374086;
module.exports["isTable"] = $9b92440f7f429369$export$567a2801b8f40ab5;
module.exports["isLayout"] = $9b92440f7f429369$export$1980ca1f3eaf85fb;
module.exports["isHorizontalRule"] = $9b92440f7f429369$export$d8bf6fedd3b53772;
module.exports["isMacro"] = $9b92440f7f429369$export$35e907bd866058b8;
module.exports["isCodeBlock"] = $9b92440f7f429369$export$1d7f19df4bf635f6;
module.exports["useIsTitleCenterAligned"] = $9b92440f7f429369$export$822db98f95375647;

});

parcelRegister("7mDnI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $FKQbh = parcelRequire("FKQbh");


var $24dy7 = parcelRequire("24dy7");

const $dfd48e08cc962979$export$518ba8e0e60f145f = ({ title: title })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        appearance: "error",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            spacing: "spacious",
            label: "Error"
        }),
        id: "error",
        key: "error",
        title: title
    });
};
module.exports["ErrorFlag"] = $dfd48e08cc962979$export$518ba8e0e60f145f;

});

parcelRegister("jcM8h", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kN9tW = parcelRequire("kN9tW");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aDSIl = parcelRequire("aDSIl");


var $7ZB0A = parcelRequire("7ZB0A");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $is1T6 = parcelRequire("is1T6");


var $4n1IT = parcelRequire("4n1IT");


var $irVI7 = parcelRequire("irVI7");


var $a6t12 = parcelRequire("a6t12");


var $68BwE = parcelRequire("68BwE");


var $jFm04 = parcelRequire("jFm04");


var $3SLf9 = parcelRequire("3SLf9");


var $jMyy4 = parcelRequire("jMyy4");

const $a26c936fb563039b$var$i18n = (0, $kSwu1.defineMessages)({
    creator: {
        id: "content-ownership.content-owner-popup.creator",
        defaultMessage: "<b>Creator</b>"
    },
    owner: {
        id: "content-ownership.content-owner-popup.owner",
        defaultMessage: "<b>Owner</b>"
    },
    changeOwner: {
        id: "content-ownership.content-owner-popup.change-owner",
        defaultMessage: "Change owner"
    },
    ariaLabel: {
        id: "content-ownership.content-owner-popup.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
// fixed dimensions
const $a26c936fb563039b$var$contentOwnerContainerStyles = (0, $buxP3.xcss)({
    width: '232px',
    height: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerViewerContainerStyles = (0, $buxP3.xcss)({
    width: '232px',
    height: '140px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerItemStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentCreatorItemStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerChangeItemStyles = (0, $buxP3.xcss)({
    marginTop: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerNameItemStyles = (0, $buxP3.xcss)({
    marginTop: 'space.025',
    textDecoration: 'underline',
    color: 'color.text',
    ':hover': {
        color: 'color.link',
        cursor: 'pointer'
    }
});
const $a26c936fb563039b$var$ContentOwnerDetailsPanelName = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { userId: userId, fullName: fullName, ariaLabel: ariaLabel } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            0,
            28
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== fullName || $[2] !== userId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            position: "left-start",
            offset: t1,
            fullName: fullName
        }, fullName);
        $[1] = fullName;
        $[2] = userId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== ariaLabel || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $a26c936fb563039b$var$contentOwnerNameItemStyles,
            role: "tooltip",
            "aria-label": ariaLabel
        }, t2);
        $[4] = ariaLabel;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ userId: userId, fullName: fullName, ariaLabel: ariaLabel })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $a26c936fb563039b$var$contentOwnerNameItemStyles,
        role: "tooltip",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: userId,
        position: "left-start",
        offset: [
            0,
            28
        ],
        fullName: fullName
    }, fullName));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanel = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, openModal: openModal, setInitialFocusRef: setInitialFocusRef } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    let t1;
    if ($[0] !== closePopup || $[1] !== experienceTracker || $[2] !== openModal) {
        t1 = ()=>{
            openModal();
            closePopup();
            experienceTracker.start({
                name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
            });
        };
        $[0] = closePopup;
        $[1] = experienceTracker;
        $[2] = openModal;
        $[3] = t1;
    } else t1 = $[3];
    const onClickChangeOwner = t1;
    const isAllowedToChange = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedBy.userId);
    const t2 = isAllowedToChange ? $a26c936fb563039b$var$contentOwnerContainerStyles : $a26c936fb563039b$var$contentOwnerViewerContainerStyles;
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$a26c936fb563039b$var$i18n.creator,
            values: {
                b: $a26c936fb563039b$var$_temp
            }
        });
        $[6] = t4;
    } else t4 = $[6];
    const t5 = createdBy.userId;
    const t6 = createdBy.fullName;
    let t7;
    if ($[7] !== createdBy.fullName || $[8] !== intl) {
        t7 = intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: createdBy.fullName
        });
        $[7] = createdBy.fullName;
        $[8] = intl;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== createdBy.fullName || $[11] !== createdBy.userId || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $a26c936fb563039b$var$contentCreatorItemStyles
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
            userId: t5,
            fullName: t6,
            ariaLabel: t7
        }));
        $[10] = createdBy.fullName;
        $[11] = createdBy.userId;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$a26c936fb563039b$var$i18n.owner,
            values: {
                b: $a26c936fb563039b$var$_temp2
            }
        });
        $[14] = t9;
    } else t9 = $[14];
    const t10 = ownedBy.userId;
    const t11 = ownedBy.fullName;
    let t12;
    if ($[15] !== intl || $[16] !== ownedBy.fullName) {
        t12 = intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: ownedBy.fullName
        });
        $[15] = intl;
        $[16] = ownedBy.fullName;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== ownedBy.fullName || $[19] !== ownedBy.userId || $[20] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $a26c936fb563039b$var$contentOwnerItemStyles
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
            userId: t10,
            fullName: t11,
            ariaLabel: t12
        }));
        $[18] = ownedBy.fullName;
        $[19] = ownedBy.userId;
        $[20] = t12;
        $[21] = t13;
    } else t13 = $[21];
    let t14;
    if ($[22] !== intl || $[23] !== isAllowedToChange || $[24] !== onClickChangeOwner || $[25] !== setInitialFocusRef) {
        t14 = isAllowedToChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $a26c936fb563039b$var$contentOwnerChangeItemStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            onClick: onClickChangeOwner,
            appearance: "link",
            spacing: "none",
            ref: setInitialFocusRef
        }, intl.formatMessage($a26c936fb563039b$var$i18n.changeOwner)));
        $[22] = intl;
        $[23] = isAllowedToChange;
        $[24] = onClickChangeOwner;
        $[25] = setInitialFocusRef;
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== t13 || $[28] !== t14 || $[29] !== t3 || $[30] !== t8) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t3
        }, t8, t13, t14);
        $[27] = t13;
        $[28] = t14;
        $[29] = t3;
        $[30] = t8;
        $[31] = t15;
    } else t15 = $[31];
    return t15;
} : ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, openModal: openModal, setInitialFocusRef: setInitialFocusRef })=>{
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    const onClickChangeOwner = (0, $cozmU.useCallback)(()=>{
        openModal();
        closePopup();
        experienceTracker.start({
            name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
        });
    }, [
        closePopup,
        openModal,
        experienceTracker
    ]);
    const isAllowedToChange = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedBy.userId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            isAllowedToChange ? $a26c936fb563039b$var$contentOwnerContainerStyles : $a26c936fb563039b$var$contentOwnerViewerContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $a26c936fb563039b$var$contentCreatorItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a26c936fb563039b$var$i18n.creator,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: createdBy.userId,
        fullName: createdBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: createdBy.fullName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $a26c936fb563039b$var$contentOwnerItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a26c936fb563039b$var$i18n.owner,
        values: {
            b: (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks_0)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: ownedBy.userId,
        fullName: ownedBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: ownedBy.fullName
        })
    })), isAllowedToChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $a26c936fb563039b$var$contentOwnerChangeItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: onClickChangeOwner,
        appearance: "link",
        spacing: "none",
        ref: setInitialFocusRef
    }, intl.formatMessage($a26c936fb563039b$var$i18n.changeOwner))));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, setInitialFocusRef: setInitialFocusRef } = t0;
    if (!ownedBy || !createdBy) return null;
    let t1;
    if ($[0] !== closePopup || $[1] !== createdBy || $[2] !== ownedBy || $[3] !== setInitialFocusRef) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, (t2)=>{
            const { openModal: openModal } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanel, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closePopup,
                openModal: openModal,
                setInitialFocusRef: setInitialFocusRef
            });
        });
        $[0] = closePopup;
        $[1] = createdBy;
        $[2] = ownedBy;
        $[3] = setInitialFocusRef;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, setInitialFocusRef: setInitialFocusRef })=>{
    if (!ownedBy || !createdBy) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, ({ openModal: openModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanel, {
            ownedBy: ownedBy,
            createdBy: createdBy,
            closePopup: closePopup,
            openModal: openModal,
            setInitialFocusRef: setInitialFocusRef
        }));
};
const $a26c936fb563039b$export$62380b37452323f8 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { contentId: contentId, itemId: itemId, itemLabel: itemLabel, isOpen: isOpen, onClick: onClick, onCloseParent: onCloseParent, onClosePopup: onClosePopup, onMouseEnter: onMouseEnter, elemBefore: elemBefore } = t0;
    let t1;
    if ($[0] !== onCloseParent || $[1] !== onClosePopup) {
        t1 = ()=>{
            onClosePopup();
            onCloseParent?.();
        };
        $[0] = onCloseParent;
        $[1] = onClosePopup;
        $[2] = t1;
    } else t1 = $[2];
    const closeOwnerDialog = t1;
    let t2;
    if ($[3] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = !contentId;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = {
            variables: t2,
            skip: t3
        };
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const { data: ownerHistoryData } = (0, $jMyy4.useQueryInterop)((0, $kN9tW.default), {
        ...t4,
        __callerPackage__: "content-ownership"
    });
    const toUserData = $a26c936fb563039b$var$_temp3;
    const t5 = ownerHistoryData?.singleContent?.history?.ownedBy;
    let t6;
    if ($[8] !== t5) {
        t6 = toUserData(t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    const ownedBy = t6;
    const t7 = ownerHistoryData?.singleContent?.history?.createdBy;
    let t8;
    if ($[10] !== t7) {
        t8 = toUserData(t7);
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    const createdBy = t8;
    const t9 = `container-${itemId}`;
    let t10;
    if ($[12] !== closeOwnerDialog || $[13] !== createdBy || $[14] !== ownedBy) {
        t10 = (t11)=>{
            const { setInitialFocusRef: setInitialFocusRef } = t11;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closeOwnerDialog,
                setInitialFocusRef: setInitialFocusRef
            });
        };
        $[12] = closeOwnerDialog;
        $[13] = createdBy;
        $[14] = ownedBy;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== elemBefore || $[17] !== isOpen || $[18] !== itemLabel || $[19] !== onClick || $[20] !== onMouseEnter) {
        t11 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                elemBefore: elemBefore,
                ...triggerProps,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                isSelected: isOpen,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, itemLabel));
        $[16] = elemBefore;
        $[17] = isOpen;
        $[18] = itemLabel;
        $[19] = onClick;
        $[20] = onMouseEnter;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== isOpen || $[23] !== onClosePopup || $[24] !== t10 || $[25] !== t11 || $[26] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            key: t9,
            isOpen: isOpen,
            onClose: onClosePopup,
            onBlur: onClosePopup,
            placement: "left-start",
            content: t10,
            trigger: t11
        });
        $[22] = isOpen;
        $[23] = onClosePopup;
        $[24] = t10;
        $[25] = t11;
        $[26] = t9;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
} : ({ contentId: contentId, itemId: itemId, itemLabel: itemLabel, isOpen: isOpen, onClick: onClick, onCloseParent: onCloseParent, onClosePopup: onClosePopup, onMouseEnter: onMouseEnter, elemBefore: elemBefore })=>{
    const closeOwnerDialog = ()=>{
        onClosePopup();
        onCloseParent?.();
    };
    const { data: ownerHistoryData } = (0, $jMyy4.useQueryInterop)((0, $kN9tW.default), {
        variables: {
            contentId: contentId
        },
        skip: !contentId,
        __callerPackage__: "content-ownership"
    });
    const toUserData = (user)=>({
            userId: user?.accountId ?? undefined,
            fullName: user?.displayName,
            isAnonymous: !user?.accountId
        });
    const ownedBy = toUserData(ownerHistoryData?.singleContent?.history?.ownedBy);
    const createdBy = toUserData(ownerHistoryData?.singleContent?.history?.createdBy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        key: `container-${itemId}`,
        isOpen: isOpen,
        onClose: onClosePopup,
        // @ts-ignore onBlur not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
        onBlur: onClosePopup,
        placement: "left-start",
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closeOwnerDialog,
                setInitialFocusRef: setInitialFocusRef
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                elemBefore: elemBefore,
                ...triggerProps,
                onClick: onClick,
                // @ts-ignore onMouseEnter not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
                onMouseEnter: onMouseEnter,
                isSelected: isOpen,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, itemLabel))
    });
};
function $a26c936fb563039b$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks);
}
function $a26c936fb563039b$var$_temp2(chunks_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks_0);
}
function $a26c936fb563039b$var$_temp3(user) {
    return {
        userId: user?.accountId ?? undefined,
        fullName: user?.displayName,
        isAnonymous: !user?.accountId
    };
}
module.exports["ContentOwnerPopupComponent"] = $a26c936fb563039b$export$62380b37452323f8;

});

parcelRegister("kN9tW", function(module, exports) {
/**
 * @generated SignedSource<<10c675709560dcdd57f41b244dd44cf1>>
 * @relayHash 7fe01343636a1cc8e3587d1c0025997f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70169404e9af278282103e5852c5a75edc0d3390fd4aa4707ab74a4bbff37105
const $cbf179a03b0882d6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v5 = [
        v3 /*: any*/ ,
        v4 /*: any*/ 
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v4 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v5 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v5 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v6 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v6 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7fe01343636a1cc8e3587d1c0025997f",
            "id": "70169404e9af278282103e5852c5a75edc0d3390fd4aa4707ab74a4bbff37105",
            "metadata": {},
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "operationKind": "query",
            "text": "query ContentOwnerPopupComponentContentOwnerQuery($contentId:ID!){singleContent(id:$contentId){id,history{createdBy{__typename,displayName,...on KnownUser{accountId}},ownedBy{__typename,displayName,...on KnownUser{accountId}}}}}"
        }
    };
}();
$cbf179a03b0882d6$var$node.hash = "ab500ff679b71481a192bc88337cadcd";
var $cbf179a03b0882d6$export$2e2bcd8739ae039 = $cbf179a03b0882d6$var$node;
module.exports["default"] = $cbf179a03b0882d6$export$2e2bcd8739ae039;

});

parcelRegister("3SLf9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $i28ZW = parcelRequire("i28ZW");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $5k5SG = parcelRequire("5k5SG");


var $68BwE = parcelRequire("68BwE");

const $93ff62a422a2769d$export$fe5ee8722fdedf98 = (ownedByAccountId)=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isSpaceOrSiteAdmin = (0, $5k5SG.useIsSpaceOrSiteAdmin)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isSiteAdmin: isSiteAdmin } = (0, $68BwE.useSPAViewContext)();
    const { canManageContent: canManageContent = false } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: !spaceKey || !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false)
    }) ?? {};
    const isElevated = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? canManageContent || isSiteAdmin : isSpaceOrSiteAdmin;
    return (0, $cozmU.useMemo)(()=>{
        if (!userId) return false;
        const isCurrentUserOwner = ownedByAccountId === userId;
        return isElevated || isCurrentUserOwner;
    }, [
        isElevated,
        ownedByAccountId,
        userId
    ]);
};
module.exports["useIsAllowedToChangeOwner"] = $93ff62a422a2769d$export$fe5ee8722fdedf98;

});

parcelRegister("3u7PM", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3cfcff3140a018ad$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    noEditAccessFlagTitle: {
        id: "edit-features.no-edit-access-flag.title",
        defaultMessage: "This shortcut requires edit access"
    },
    noEditAccessFlagDescription: {
        id: "edit-features.no-edit-access-flag.description",
        defaultMessage: "To use this keyboard shortcut, you'll need edit access to this content."
    }
});
const $3cfcff3140a018ad$export$175b3f54640daa25 = (flags)=>{
    const intl = (0, $kSwu1.useIntl)();
    const showNoEditAccessFlag = ()=>{
        flags.showFlag({
            id: 'live-pages-mode-flag',
            title: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagTitle),
            description: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagDescription),
            close: 'auto'
        });
    };
    return {
        showNoEditAccessFlag: showNoEditAccessFlag
    };
};
module.exports["useNoEditAccessFlag"] = $3cfcff3140a018ad$export$175b3f54640daa25;

});

parcelRegister("briGH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7W8i8 = parcelRequire("7W8i8");

const $8540b650e122e686$var$RETRY_STATUS_CODE = [
    409,
    412
];
const $8540b650e122e686$export$8e3b4758c0e0a83 = (response)=>response?.data?.experimentalMigratePages?.status;
const $8540b650e122e686$var$logger = (0, $7W8i8.getLogger)('PageMigration');
const $8540b650e122e686$export$9369b12211e1fce4 = (refetchContentHash, migratePages, retriesLeft = 3, interval = 1000, statusCodes = [])=>{
    return new Promise((resolve, reject)=>{
        // b/c contentHash is variable and could changed when user in preview
        // perform refetch to grab the latest contentHash (to avoid 412 and 409 error when performing migration)
        return refetchContentHash().then((contentHash)=>{
            migratePages(contentHash).then((response)=>{
                const status = $8540b650e122e686$export$8e3b4758c0e0a83(response);
                setTimeout(()=>{
                    if (retriesLeft === 1) {
                        const message = 'Number of retrying attempt reach maximum number of retries';
                        $8540b650e122e686$var$logger.debug`${message}`;
                        return reject(message, statusCodes);
                    }
                    // only retry when status code is 409, 412
                    if ($8540b650e122e686$var$RETRY_STATUS_CODE.indexOf(Number.parseInt(status)) !== -1) {
                        statusCodes.push(Number.parseInt(status));
                        $8540b650e122e686$export$9369b12211e1fce4(refetchContentHash, migratePages, retriesLeft - 1, interval, statusCodes).then(resolve, reject);
                    } else return resolve(response, statusCodes);
                }, interval);
            }).catch((error)=>{
                return reject(error, statusCodes);
            });
        });
    });
};
module.exports["getStatusFromResponse"] = $8540b650e122e686$export$8e3b4758c0e0a83;
module.exports["retry"] = $8540b650e122e686$export$9369b12211e1fce4;

});

parcelRegister("6ug2F", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fc0e6c31b10b3145$export$ad537527a445740e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GFqC1",
    name: "AgentPresenceLoader",
    loader: async ()=>(await (parcelRequire("b7QIT"))).AgentPresence
});
module.exports["AgentPresenceLoader"] = $fc0e6c31b10b3145$export$ad537527a445740e;

});

parcelRegister("b7QIT", function(module, exports) {

let $81993ed620399a55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $81993ed620399a55$var$load("cH8yZ"),
    $81993ed620399a55$var$load("8T2wY"),
    $81993ed620399a55$var$load("ea3NB"),
    $81993ed620399a55$var$load("eS3wT"),
    $81993ed620399a55$var$load("4uO8Y"),
    $81993ed620399a55$var$load("26l7c"),
    $81993ed620399a55$var$load("6wr18"),
    $81993ed620399a55$var$load("cmmpX"),
    $81993ed620399a55$var$load("VXbA1"),
    $81993ed620399a55$var$load("jqoep"),
    $81993ed620399a55$var$load("7EorR"),
    $81993ed620399a55$var$load("ffEVr"),
    $81993ed620399a55$var$load("hhss7"),
    $81993ed620399a55$var$load("34R0T")
]).then(()=>parcelRequire('f2tcq'));

});

parcelRegister("1Zthr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $86e4d9c8583d266f$export$9c05e92142f10f44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CxVtX",
    name: "UnarchivePagesDialogLoader",
    loader: async ()=>(await (parcelRequire("gSWuY"))).UnarchivePagesLoader
});
module.exports["UnarchivePagesDialogLoader"] = $86e4d9c8583d266f$export$9c05e92142f10f44;

});

parcelRegister("gSWuY", function(module, exports) {

let $c4af11191dbecb34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c4af11191dbecb34$var$load("iWnyc"),
    $c4af11191dbecb34$var$load("g81ly"),
    $c4af11191dbecb34$var$load("e3LAK"),
    $c4af11191dbecb34$var$load("2l8zo"),
    $c4af11191dbecb34$var$load("26l7c"),
    $c4af11191dbecb34$var$load("6wr18"),
    $c4af11191dbecb34$var$load("dRQ13"),
    $c4af11191dbecb34$var$load("jyWy1"),
    $c4af11191dbecb34$var$load("9pso5"),
    $c4af11191dbecb34$var$load("LWh5V"),
    $c4af11191dbecb34$var$load("251nM"),
    $c4af11191dbecb34$var$load("kHXvF"),
    $c4af11191dbecb34$var$load("excC5"),
    $c4af11191dbecb34$var$load("ffEVr"),
    $c4af11191dbecb34$var$load("7EorR"),
    $c4af11191dbecb34$var$load("Wowvf"),
    $c4af11191dbecb34$var$load("hhss7"),
    $c4af11191dbecb34$var$load("dxDVc")
]).then(()=>parcelRequire('ew61I'));

});

parcelRegister("6eFi0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ad336c78e6fcf61a$export$492577bc4a81367b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "seFL5",
    name: "ResolvedInlineCommentsDialogLoader",
    loader: async ()=>(await (parcelRequire("jpqg7"))).ResolvedInlineCommentsDialog
});
module.exports["ResolvedInlineCommentsDialogLoader"] = $ad336c78e6fcf61a$export$492577bc4a81367b;

});

parcelRegister("jpqg7", function(module, exports) {

let $e214b89f3d167c55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e214b89f3d167c55$var$load("gBfQ7"),
    $e214b89f3d167c55$var$load("eTvQu"),
    $e214b89f3d167c55$var$load("husez"),
    $e214b89f3d167c55$var$load("lK9vp"),
    $e214b89f3d167c55$var$load("dfVz8"),
    $e214b89f3d167c55$var$load("cJsay"),
    $e214b89f3d167c55$var$load("6MdJu"),
    $e214b89f3d167c55$var$load("1GCFv"),
    $e214b89f3d167c55$var$load("e5ukl"),
    $e214b89f3d167c55$var$load("123MJ"),
    $e214b89f3d167c55$var$load("elQ9h"),
    $e214b89f3d167c55$var$load("52ZTT"),
    $e214b89f3d167c55$var$load("iZiYW"),
    $e214b89f3d167c55$var$load("57o6G"),
    $e214b89f3d167c55$var$load("cmmpX"),
    $e214b89f3d167c55$var$load("hs6P3"),
    $e214b89f3d167c55$var$load("eUsnQ"),
    $e214b89f3d167c55$var$load("7EorR"),
    $e214b89f3d167c55$var$load("aEiTV"),
    $e214b89f3d167c55$var$load("h1yOv"),
    $e214b89f3d167c55$var$load("aLwQm"),
    $e214b89f3d167c55$var$load("kHXvF"),
    $e214b89f3d167c55$var$load("6wr18"),
    $e214b89f3d167c55$var$load("Wowvf"),
    $e214b89f3d167c55$var$load("7gL7H"),
    $e214b89f3d167c55$var$load("hhss7"),
    $e214b89f3d167c55$var$load("fZ0vM"),
    $e214b89f3d167c55$var$load("3kale"),
    $e214b89f3d167c55$var$load("4JSav"),
    $e214b89f3d167c55$var$load("excC5"),
    $e214b89f3d167c55$var$load("kv4Kv"),
    $e214b89f3d167c55$var$load("qCaIx"),
    $e214b89f3d167c55$var$load("hN9W6"),
    $e214b89f3d167c55$var$load("exBMi"),
    $e214b89f3d167c55$var$load("iBJWz"),
    $e214b89f3d167c55$var$load("ffEVr"),
    $e214b89f3d167c55$var$load("jzSMU"),
    $e214b89f3d167c55$var$load("d8SWd"),
    $e214b89f3d167c55$var$load("dEUQZ"),
    $e214b89f3d167c55$var$load("eLfJM"),
    $e214b89f3d167c55$var$load("80Yra"),
    $e214b89f3d167c55$var$load("ei0GF"),
    $e214b89f3d167c55$var$load("cgKMu"),
    $e214b89f3d167c55$var$load("60QcS"),
    $e214b89f3d167c55$var$load("kGmwI"),
    $e214b89f3d167c55$var$load("79Tk4"),
    $e214b89f3d167c55$var$load("26l7c"),
    $e214b89f3d167c55$var$load("1R82J"),
    $e214b89f3d167c55$var$load("9YbM1"),
    $e214b89f3d167c55$var$load("aAWLw"),
    $e214b89f3d167c55$var$load("hOsjc")
]).then(()=>parcelRequire('92Mdh'));

});

parcelRegister("bzwhi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $67Foi = parcelRequire("67Foi");


var $lsxnT = parcelRequire("lsxnT");


var $dINOl = parcelRequire("dINOl");


var $1j3IV = parcelRequire("1j3IV");


var $4R0nV = parcelRequire("4R0nV");


var $4TcLf = parcelRequire("4TcLf");


var $4ZXww = parcelRequire("4ZXww");


var $kSwrz = parcelRequire("kSwrz");

var $2347032a59a3f6fa$export$6054829ec0b77d62 = /*#__PURE__*/ function(MoreActionsObjectSidebarTourSteps) {
    MoreActionsObjectSidebarTourSteps[MoreActionsObjectSidebarTourSteps["FIRST"] = 0] = "FIRST";
    return MoreActionsObjectSidebarTourSteps;
}({});
const $2347032a59a3f6fa$var$i18n = (0, $kSwu1.defineMessages)({
    ok: {
        id: "object-sidebar-components.more-actions.tour.ok",
        defaultMessage: "OK"
    },
    getTheDetailsYouNeed: {
        id: "object-sidebar-components.more-actions.tour.get-the-details-you-need",
        defaultMessage: "Get the details you need"
    },
    viewAndManageOwnership: {
        id: "object-sidebar-components.more-actions.tour.view-and-manage-ownership",
        defaultMessage: "View and manage ownership, labels, and more in a single panel."
    }
});
const $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME = 'more-actions-object-sidebar-spotlight';
const $2347032a59a3f6fa$var$useSpotlights = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { end: end } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const theme = (0, $IQ4Dz.default)();
    const GetTheDetailsYouNeedGif = theme.colorMode === "dark" ? (0, (/*@__PURE__*/$parcel$interopDefault($1j3IV))) : (0, (/*@__PURE__*/$parcel$interopDefault($4R0nV)));
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($2347032a59a3f6fa$var$i18n.ok);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== end || $[3] !== t1) {
        t2 = [
            {
                onClick: end,
                text: t1
            }
        ];
        $[2] = end;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== end) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dINOl.CrossIconCloseButton), {
            onClose: end,
            source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
        });
        $[7] = end;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== GetTheDetailsYouNeedGif || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = [
            {
                key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                targetRadius: 3,
                actions: t2,
                image: GetTheDetailsYouNeedGif,
                dialogWidth: 341,
                heading: t3,
                headingAfterElement: t4,
                children: t5
            }
        ];
        $[11] = GetTheDetailsYouNeedGif;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ end: end })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const theme = (0, $IQ4Dz.default)();
    const GetTheDetailsYouNeedGif = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($1j3IV))) : (0, (/*@__PURE__*/$parcel$interopDefault($4R0nV)));
    return [
        {
            key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            targetRadius: 3,
            actions: [
                {
                    onClick: end,
                    text: formatMessage($2347032a59a3f6fa$var$i18n.ok)
                }
            ],
            image: GetTheDetailsYouNeedGif,
            dialogWidth: 341,
            heading: formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed),
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dINOl.CrossIconCloseButton), {
                onClose: end,
                source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
            }),
            children: formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership)
        }
    ];
};
const $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING = 'floatingActionBarChangeboarding';
const $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS = [
    $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING
];
const $2347032a59a3f6fa$export$4ead2825721da9b4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { step: step } = t0;
    const [t1, t2] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const { activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex } = t1;
    const { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour } = t2;
    const [messageType] = (0, $cozmU.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    let t3;
    if ($[0] !== endTour) {
        t3 = ()=>{
            endTour();
        };
        $[0] = endTour;
        $[1] = t3;
    } else t3 = $[1];
    const concludeTour = t3;
    let t4;
    if ($[2] !== concludeTour) {
        t4 = {
            end: concludeTour
        };
        $[2] = concludeTour;
        $[3] = t4;
    } else t4 = $[3];
    const spotlights = $2347032a59a3f6fa$var$useSpotlights(t4);
    let t5;
    if ($[4] !== Spotlight || $[5] !== activeSpotlightIndex || $[6] !== messageType || $[7] !== spotlights || $[8] !== step) {
        t5 = activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null;
        $[4] = Spotlight;
        $[5] = activeSpotlightIndex;
        $[6] = messageType;
        $[7] = spotlights;
        $[8] = step;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== activeSpotlightIndex || $[11] !== concludeTour || $[12] !== initiateTour || $[13] !== lastActiveSpotlightIndex || $[14] !== resetTour || $[15] !== t5) {
        t6 = {
            activeSpotlight: t5,
            initiateTour: initiateTour,
            concludeTour: concludeTour,
            resetTour: resetTour,
            activeSpotlightIndex: activeSpotlightIndex,
            lastActiveSpotlightIndex: lastActiveSpotlightIndex
        };
        $[10] = activeSpotlightIndex;
        $[11] = concludeTour;
        $[12] = initiateTour;
        $[13] = lastActiveSpotlightIndex;
        $[14] = resetTour;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ step: step })=>{
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex }, { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour }] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const [messageType, _] = (0, $cozmU.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $cozmU.useCallback)(()=>{
        endTour();
    }, [
        endTour
    ]);
    const spotlights = $2347032a59a3f6fa$var$useSpotlights({
        end: concludeTour
    });
    return {
        activeSpotlight: activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null,
        initiateTour: initiateTour,
        concludeTour: concludeTour,
        resetTour: resetTour,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex
    };
};
module.exports["MoreActionsObjectSidebarTourSteps"] = $2347032a59a3f6fa$export$6054829ec0b77d62;
module.exports["useMoreActionsObjectSidebarTour"] = $2347032a59a3f6fa$export$4ead2825721da9b4;

});

parcelRegister("dINOl", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $9DHhW = parcelRequire("9DHhW");

const $732e88608cb14d24$export$f56d620db6064703 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { onClose: onClose, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== onClose || $[2] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "dismiss",
                    source: source
                }
            }).fire();
            onClose();
        };
        $[0] = createAnalyticsEvent;
        $[1] = onClose;
        $[2] = source;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $732e88608cb14d24$var$messages.dismiss);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== handleClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $732e88608cb14d24$var$_temp,
            appearance: "subtle",
            label: t2,
            onClick: handleClick
        });
        $[5] = handleClick;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onClose: onClose, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: source
            }
        }).fire();
        onClose();
    }, [
        onClose,
        createAnalyticsEvent,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }),
        appearance: "subtle",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $732e88608cb14d24$var$messages.dismiss),
        onClick: handleClick
    });
};
const $732e88608cb14d24$var$messages = (0, $kSwu1.defineMessages)({
    dismiss: {
        id: "object-sidebar-components.cross-icon-close-button.dismiss",
        defaultMessage: "Dismiss"
    }
});
function $732e88608cb14d24$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps,
        color: "var(--ds-icon-inverse, #FFFFFF)"
    });
}
module.exports["CrossIconCloseButton"] = $732e88608cb14d24$export$f56d620db6064703;

});

parcelRegister("1j3IV", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedDark.bbe9839d.gif", import.meta.url).toString();

});

parcelRegister("4R0nV", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedLight.9900190e.gif", import.meta.url).toString();

});

parcelRegister("4TcLf", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2cb4928bb9fae204$var$initialState = {
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $2cb4928bb9fae204$var$Store = (0, $8s9DV.createStore)({
    initialState: $2cb4928bb9fae204$var$initialState,
    actions: {
        goToStep: (nextStep)=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: nextStep
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState($2cb4928bb9fae204$var$initialState);
            },
        initiateTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: 0
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            }
    }
});
const $2cb4928bb9fae204$export$2488884e040ac8b3 = (0, $kBr4q.createHook)($2cb4928bb9fae204$var$Store);
const $2cb4928bb9fae204$export$66587c60bfe17f2b = (0, $kBr4q.createActionsHook)($2cb4928bb9fae204$var$Store);
module.exports["useMoreActionsObjectSidebarTourState"] = $2cb4928bb9fae204$export$2488884e040ac8b3;

});

parcelRegister("kSwrz", function(module, exports) {
var $c5d0a4f039ea82e6$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
module.exports["MessageType"] = $c5d0a4f039ea82e6$export$80edbf15fa61a4db;

});

parcelRegister("3krUE", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c06b6cca0a728bb0$export$154e7cde95b8409b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "-pxiH",
    name: "LazyWatchSettingsOverflowMenuShortcut",
    loader: async ()=>(await (parcelRequire("aQPUv"))).WatchSettingsOverflowMenuShortcut
});
module.exports["LazyWatchSettingsOverflowMenuShortcut"] = $c06b6cca0a728bb0$export$154e7cde95b8409b;

});

parcelRegister("aQPUv", function(module, exports) {

let $7e670703673b31fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7e670703673b31fe$var$load("cH8yZ"),
    $7e670703673b31fe$var$load("6wr18"),
    $7e670703673b31fe$var$load("8hbZ5"),
    $7e670703673b31fe$var$load("ffEVr"),
    $7e670703673b31fe$var$load("aLbuU"),
    $7e670703673b31fe$var$load("3yFtm")
]).then(()=>parcelRequire('dQUV0'));

});

parcelRegister("g95v4", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $8aF6s = parcelRequire("8aF6s");


var $bjj9l = parcelRequire("bjj9l");

const $4f70211624fcedf9$export$7098d17bb6837941 = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    let t0;
    if ($[0] !== showModal) {
        t0 = (t1)=>{
            const options = t1 === undefined ? {} : t1;
            showModal((0, $bjj9l.AgentsAwarenessModalLoadable), {
                ...options,
                messageType: "transactional"
            });
        };
        $[0] = showModal;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["useOpenAgentsAwarenessModal"] = $4f70211624fcedf9$export$7098d17bb6837941;

});

parcelRegister("1TN2N", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b742140c6b014561$export$fcc1c0135b5761c6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "F85M0",
    name: "LazyForgeContentTools",
    loader: async ()=>(await (parcelRequire("jGPod"))).ForgeContentTools
});
module.exports["LazyForgeContentTools"] = $b742140c6b014561$export$fcc1c0135b5761c6;

});

parcelRegister("jGPod", function(module, exports) {

let $e559cd79ad030162$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e559cd79ad030162$var$load("6wr18"),
    $e559cd79ad030162$var$load("bzc8Q"),
    $e559cd79ad030162$var$load("ffEVr"),
    $e559cd79ad030162$var$load("7EorR"),
    $e559cd79ad030162$var$load("ea3NB"),
    $e559cd79ad030162$var$load("Wowvf"),
    $e559cd79ad030162$var$load("kyfJT")
]).then(()=>parcelRequire('dhbEh'));

});

parcelRegister("hL4RO", function(module, exports) {
// Slack Connect web-item ids are `<addonKey>__<moduleKey>`. The addon key is bare in prod but
// suffixed on non-prod installs (e.g. `-ddev`, `-stg-east`), so match on prefix + module suffix.
const $655d13c70191fa8e$var$SLACK_CONNECT_APP_ID_PREFIX = 'confluence-chats-integration';
// Module suffixes being deprecated as part of the Connect deprecation. Add future modules here.
const $655d13c70191fa8e$var$DEPRECATED_CONNECT_MODULE_SUFFIXES = [
    '__page-config-dialog-trigger',
    '__profile'
];
const $655d13c70191fa8e$export$66793f50054894c5 = [
    '__space-config-link'
];
const $655d13c70191fa8e$export$2855598082f8f510 = (webItemId, moduleSuffixes = $655d13c70191fa8e$var$DEPRECATED_CONNECT_MODULE_SUFFIXES)=>Boolean(webItemId?.startsWith($655d13c70191fa8e$var$SLACK_CONNECT_APP_ID_PREFIX) && moduleSuffixes.some((suffix)=>webItemId.endsWith(suffix)));
module.exports["DEPRECATED_SPACE_SETTINGS_MODULE_SUFFIXES"] = $655d13c70191fa8e$export$66793f50054894c5;
module.exports["isDeprecatedConnectWebItem"] = $655d13c70191fa8e$export$2855598082f8f510;

});

parcelRegister("d8J72", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bYLFm = parcelRequire("bYLFm");


var $gjbSq = parcelRequire("gjbSq");


var $b3j2Y = parcelRequire("b3j2Y");


var $3eMfQ = parcelRequire("3eMfQ");

const $6f5c98e13f07416a$export$dc453ea17a7d7b53 = (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    let contentId;
    let dialogs;
    let onClick;
    let props;
    let sectionItem;
    let shouldHighlight;
    let spaceKey;
    if ($[0] !== t0) {
        ({ sectionItem: sectionItem, contentId: contentId, spaceKey: spaceKey, dialogs: dialogs, shouldHighlight: shouldHighlight, onClick: onClick, ...props } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = dialogs;
        $[3] = onClick;
        $[4] = props;
        $[5] = sectionItem;
        $[6] = shouldHighlight;
        $[7] = spaceKey;
    } else {
        contentId = $[1];
        dialogs = $[2];
        onClick = $[3];
        props = $[4];
        sectionItem = $[5];
        shouldHighlight = $[6];
        spaceKey = $[7];
    }
    let t1;
    if ($[8] !== contentId || $[9] !== spaceKey) {
        t1 = {
            contentId: contentId,
            spaceKey: spaceKey
        };
        $[8] = contentId;
        $[9] = spaceKey;
        $[10] = t1;
    } else t1 = $[10];
    const { canConvertPageToFolder: canConvertPageToFolder, contentTitle: contentTitle, error: error } = (0, $gjbSq.useCanConvertPageToFolder)(t1);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[11] !== contentId || $[12] !== contentTitle || $[13] !== createAnalyticsEvent || $[14] !== dialogs || $[15] !== onClick || $[16] !== spaceKey) {
        t2 = (e)=>{
            onClick?.(e);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "convertPageToFolder",
                    source: "contentToolsItem"
                }
            }).fire();
            dialogs.showDialog((0, $bYLFm.ConvertPageToFolderDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                contentTitle: contentTitle
            });
        };
        $[11] = contentId;
        $[12] = contentTitle;
        $[13] = createAnalyticsEvent;
        $[14] = dialogs;
        $[15] = onClick;
        $[16] = spaceKey;
        $[17] = t2;
    } else t2 = $[17];
    const openDialog = t2;
    if (!canConvertPageToFolder) {
        let t3;
        if ($[18] !== error) {
            t3 = error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }) : null;
            $[18] = error;
            $[19] = t3;
        } else t3 = $[19];
        return t3;
    }
    let t3;
    if ($[20] !== error) {
        t3 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[20] = error;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== openDialog || $[23] !== props || $[24] !== sectionItem || $[25] !== shouldHighlight) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eMfQ.LazyContentToolsItem), {
            key: sectionItem.completeKey,
            ...sectionItem,
            url: "",
            ...props,
            onClick: openDialog,
            shouldHighlight: shouldHighlight
        });
        $[22] = openDialog;
        $[23] = props;
        $[24] = sectionItem;
        $[25] = shouldHighlight;
        $[26] = t4;
    } else t4 = $[26];
    let t5;
    if ($[27] !== t3 || $[28] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4);
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
};
module.exports["ConvertToFolderItem"] = $6f5c98e13f07416a$export$dc453ea17a7d7b53;

});

parcelRegister("bYLFm", function(module, exports) {

var $WfKBt = parcelRequire("WfKBt");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $fEPJS = parcelRequire("fEPJS");


var $1VhsF = parcelRequire("1VhsF");


var $ad7Ou = parcelRequire("ad7Ou");


var $7joZr = parcelRequire("7joZr");


var $9DHhW = parcelRequire("9DHhW");


var $kA6Zo = parcelRequire("kA6Zo");


var $2wCqQ = parcelRequire("2wCqQ");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $dPJCf = parcelRequire("dPJCf");


var $67Foi = parcelRequire("67Foi");


var $1NBp8 = parcelRequire("1NBp8");


var $cb6fO = parcelRequire("cb6fO");


var $b3j2Y = parcelRequire("b3j2Y");


var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");


var $euL71 = parcelRequire("euL71");


var $bQm3c = parcelRequire("bQm3c");


var $laFNM = parcelRequire("laFNM");


var $308Wd = parcelRequire("308Wd");

const $ad7bf5a97d16ed21$var$COMPONENT_NAME = 'ConvertPageToFolderDialogModal';
const $ad7bf5a97d16ed21$var$source = 'VIEW_PAGE';
const $ad7bf5a97d16ed21$var$warningMessageStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.100'
});
const $ad7bf5a97d16ed21$export$de0fa8bd80a55013 = 241;
const $ad7bf5a97d16ed21$var$ConvertPageToFolderDialogComponent = ({ spaceKey: spaceKey, contentId: contentId, contentTitle: contentTitle, onClose: onClose, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { approvalRequest: approvalRequest } = (0, $laFNM.useApprovals)();
    const hasApprovalReview = Boolean(approvalRequest?.review);
    const [isConverting, setIsConverting] = (0, $cozmU.useState)(false);
    const [convertPageToFolderMutation, { error: convertPageToFolderError }] = (0, $308Wd.useMutationInterop)((0, $WfKBt.default), {
        __callerPackage__: "folder-conversion"
    });
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'clicked',
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}CancelButton`,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        onClose();
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const convertPageToFolderSuccess = (data)=>{
        setIsConverting(false);
        experienceTracker.succeed({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE)
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                action: 'success',
                attributes: undefined,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        flags.showFlag({
            type: 'success-circle',
            title: formatMessage($ad7bf5a97d16ed21$var$i18n.successFlagTitle),
            description: formatMessage($ad7bf5a97d16ed21$var$i18n.successFlagDescription),
            close: 'auto'
        });
        const contentId = data?.data?.convertToFolder?.content?.id;
        if (contentId) {
            const newlyCreatedFolderUrl = (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: (0, $cb6fO.generateSlug)(contentTitle)
            });
            newlyCreatedFolderUrl && push(newlyCreatedFolderUrl);
        }
        onClose();
    };
    const showErrorFlag = ({ title: title, description: description, actions: actions })=>{
        flags.showFlag({
            type: 'error',
            title: title,
            description: description,
            close: 'auto',
            actions: actions
        });
    };
    const abortExperienceOnExpectedError = (error)=>{
        (0, $7Sm4c.markErrorAsHandled)(error);
        experienceTracker.abort({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE),
            reason: 'Expected Apollo error'
        });
    };
    const convertPageToFolderFailure = (error)=>{
        if ($ad7bf5a97d16ed21$var$isPageEditRestrictedError(error)) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.editPermissionErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.editPermissionErrorFlagDescription)
            });
            abortExperienceOnExpectedError(error);
        } else if ($ad7bf5a97d16ed21$var$isNameCollisionError(error)) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.nameCollisionErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.nameCollisionErrorFlagDescription)
            });
            abortExperienceOnExpectedError(error);
        } else if ($ad7bf5a97d16ed21$var$isNameLengthLimitError(error) && contentTitle) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.nameLengthLimitErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.nameLengthLimitErrorFlagDescription, {
                    numCharsOverLimit: contentTitle.length - $ad7bf5a97d16ed21$export$de0fa8bd80a55013
                })
            });
            abortExperienceOnExpectedError(error);
        } else {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagDescription),
                actions: [
                    {
                        content: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagAction),
                        onClick: handlePageToFolderConversion
                    }
                ]
            });
            if ((0, $95rLf.isExpectedApolloError)(error)) {
                abortExperienceOnExpectedError(error);
                return;
            }
            (0, $fGzMp.stopExperienceOnError)((0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE), error);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                    action: 'failed',
                    attributes: {
                        error: error
                    },
                    actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}ConvertButton`,
                    source: $ad7bf5a97d16ed21$var$source
                }
            }).fire();
        }
    };
    const handlePageToFolderConversion = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}ConvertButton`,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        setIsConverting(true);
        experienceTracker.start({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE)
        });
        convertPageToFolderMutation({
            variables: {
                id: contentId
            }
        }).then((data)=>{
            convertPageToFolderSuccess(data);
        }).catch((error)=>{
            convertPageToFolderFailure(error);
            setIsConverting(false);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        width: "450px",
        key: "ConvertPageToFolderDialog",
        onClose: handleOnClose,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.100"
    }, isPremium && hasApprovalReview && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $ad7bf5a97d16ed21$var$warningMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.approvalsWarning))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleOnClose,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handlePageToFolderConversion,
        appearance: "primary",
        isLoading: isConverting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogSubmitText)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
        name: "convertPageToFolderDialogModalScreen",
        id: "convertPageToFolderModalScreenEvent"
    }), convertPageToFolderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: convertPageToFolderError
    }));
};
const $ad7bf5a97d16ed21$var$ConvertPageToFolderDialogWithFlags = (0, $7aRa9.withFlags)($ad7bf5a97d16ed21$var$ConvertPageToFolderDialogComponent);
const $ad7bf5a97d16ed21$export$ae121ae5418ce48b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $laFNM.ApprovalsProvider), {
        contentId: props.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad7bf5a97d16ed21$var$ConvertPageToFolderDialogWithFlags, props));
const $ad7bf5a97d16ed21$var$isPageEditRestrictedError = (error)=>error.message.includes('User does not have permissions to perform this action');
const $ad7bf5a97d16ed21$var$isNameCollisionError = (error)=>error.message.includes('A folder exists with the same title in this space');
const $ad7bf5a97d16ed21$var$isNameLengthLimitError = (error)=>error.message.includes('Title cannot be longer than 255 characters');
const $ad7bf5a97d16ed21$var$i18n = (0, $kSwu1.defineMessages)({
    dialogHeader: {
        id: "folder-conversion.convert-page-to-folder.dialog.header",
        defaultMessage: "Convert this page into a folder?"
    },
    dialogDescription: {
        id: "folder-conversion.convert-page-to-folder.dialog.description",
        defaultMessage: "We\u2019ll archive the original page, so you don\u2019t need to worry about losing your work."
    },
    cancel: {
        id: "folder-conversion.convert-page-to-folder.dialog.cancel",
        defaultMessage: "Cancel"
    },
    dialogSubmitText: {
        id: "folder-conversion.convert-page-to-folder.dialog.submit",
        defaultMessage: "Convert"
    },
    approvalsWarning: {
        id: "folder-conversion.convert-page-to-folder.dialog.approvalsWarning",
        defaultMessage: "This will end an approval."
    },
    successFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.success-message.title",
        defaultMessage: "Conversion complete"
    },
    successFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.success-message.description.placeholder-title",
        defaultMessage: "We\u2019ve finished converting the page to a folder."
    },
    defaultErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.title",
        defaultMessage: "We couldn\u2019t convert the page to a folder"
    },
    defaultErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.description.placeholder-title",
        defaultMessage: "Something went wrong, and we were unable to convert this page to a folder."
    },
    defaultErrorFlagAction: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.action",
        defaultMessage: "Try again"
    },
    editPermissionErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.edit-permissions.title",
        defaultMessage: "Request edit and archive access to continue"
    },
    editPermissionErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.edit-permissions.description",
        defaultMessage: "To convert this page to a folder, you\u2019ll need permission to edit and archive it."
    },
    nameCollisionErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-collision.title",
        defaultMessage: "Rename this page to continue"
    },
    nameCollisionErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-collision.description",
        defaultMessage: "To avoid duplicate titles, you\u2019ll need to rename this page before we can convert it to a folder and archive the original."
    },
    nameLengthLimitErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-length-limit.title",
        defaultMessage: "Give this page a shorter title"
    },
    nameLengthLimitErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-length-limit.description",
        defaultMessage: "Before we can convert this page to a folder, archiving the original, you\u2019ll need to give it a title that is at least {numCharsOverLimit, plural, one {# character} other {# characters}} shorter."
    }
});
module.exports["ConvertPageToFolderDialog"] = $ad7bf5a97d16ed21$export$ae121ae5418ce48b;

});

parcelRegister("WfKBt", function(module, exports) {
/**
 * @generated SignedSource<<a6c73600adeb768aa334b04a865edb6f>>
 * @relayHash 4eea0357b0c46bdca044a6b3b9b301ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9a17fe744f7014b84fa0265289a77140bedf705796685c18a7cc805136059b2
const $c938044c857e7ec1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceConvertContentToFolderPayload",
            "kind": "LinkedField",
            "name": "convertToFolder",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4eea0357b0c46bdca044a6b3b9b301ec",
            "id": "c9a17fe744f7014b84fa0265289a77140bedf705796685c18a7cc805136059b2",
            "metadata": {},
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "operationKind": "mutation",
            "text": "mutation ConvertPageToFolderDialogConvertPageToFolderMutation($id:ID!){convertToFolder(id:$id){content{id}}}"
        }
    };
}();
$c938044c857e7ec1$var$node.hash = "9e061c22a3f4cc67b35d81eed7b18a16";
var $c938044c857e7ec1$export$2e2bcd8739ae039 = $c938044c857e7ec1$var$node;
module.exports["default"] = $c938044c857e7ec1$export$2e2bcd8739ae039;

});

parcelRegister("gjbSq", function(module, exports) {

var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $3jwuS = parcelRequire("3jwuS");


var $gEtAQ = parcelRequire("gEtAQ");


var $cEgMD = parcelRequire("cEgMD");


var $jr6cv = parcelRequire("jr6cv");


var $jMyy4 = parcelRequire("jMyy4");

const $8906a897a8abc933$export$cf0b322c7c05f5e9 = 'action-convert-page-to-folder';
const $8906a897a8abc933$export$9009d9583737dc08 = ({ contentId: contentId, spaceKey: spaceKey, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $jr6cv.default), {
        skip: Boolean(skipQuery) || // Company Hub hides its space from the user, is rather presented to the user as "a new surface", not a page so converting it to a folder wouldn't make sense.
        // Additionally, if this query were to execute, it would break the Company Hub history/version preview, because it doesn't respect the versionOverride query parameter.
        (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey
        },
        __callerPackage__: "folder-conversion"
    });
    const isViewPageRoute = (0, $gEtAQ.isViewPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isPage = data?.singleContent?.type === 'page';
    const isFoldersEnabledForSpace = data?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled;
    const isPublished = data?.singleContent?.status === 'current';
    let canEdit = false;
    let canArchive = false; // need to check archive permission since page is archived as a part of conversion
    data?.singleContent?.operations?.forEach((operationCheckResult)=>{
        if (operationCheckResult?.targetType === 'page') {
            if (operationCheckResult?.operation === 'update') canEdit = true;
            else if (operationCheckResult?.operation === 'archive') canArchive = true;
        }
    });
    const canConvertPageToFolder = Boolean(isViewPageRoute && !isLivePage && isPage && isFoldersEnabledForSpace && isPublished && canEdit && canArchive);
    if ((0, $95rLf.isExpectedApolloError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const contentTitle = data?.singleContent?.title;
    const hasLoaded = $8906a897a8abc933$export$d5c654a6fe10b3c1(Boolean(skipQuery), Boolean(data), Boolean(error), loading);
    return {
        canConvertPageToFolder: canConvertPageToFolder,
        contentTitle: contentTitle,
        loading: loading,
        error: error,
        hasLoaded: hasLoaded
    };
};
const $8906a897a8abc933$export$d5c654a6fe10b3c1 = (skip, hasData, hasError, loading)=>{
    return skip || (hasData || hasError) && !loading;
};
module.exports["CONVERT_PAGE_TO_FOLDER_WEBITEM_ID"] = $8906a897a8abc933$export$cf0b322c7c05f5e9;
module.exports["useCanConvertPageToFolder"] = $8906a897a8abc933$export$9009d9583737dc08;

});

parcelRegister("jr6cv", function(module, exports) {
/**
 * @generated SignedSource<<cff4ec53e648470d277e9ebff3ca6267>>
 * @relayHash 48a9429ef50ceb1df349c422f817239b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9d4b264a2064bf474a2da6e6304f03e630787bd8c8a1da86bbb0fe266d4ae062
const $98dc97ed41815985$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertPageToFolderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertPageToFolderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "48a9429ef50ceb1df349c422f817239b",
            "id": "9d4b264a2064bf474a2da6e6304f03e630787bd8c8a1da86bbb0fe266d4ae062",
            "metadata": {},
            "name": "ConvertPageToFolderQuery",
            "operationKind": "query",
            "text": "query ConvertPageToFolderQuery($contentId:ID!,$spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled}}},singleContent(id:$contentId){id,title,type,status,operations{operation,targetType}}}"
        }
    };
}();
$98dc97ed41815985$var$node.hash = "ed0995bcdb62a84d190715c954ff6018";
var $98dc97ed41815985$export$2e2bcd8739ae039 = $98dc97ed41815985$var$node;
module.exports["default"] = $98dc97ed41815985$export$2e2bcd8739ae039;

});

parcelRegister("3eMfQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $9wGTI = parcelRequire("9wGTI");


var $4LDXE = parcelRequire("4LDXE");



const $35cdf415560d18a2$export$ecf6343598832c90 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ldI6_",
    name: "LazyContentToolsItem",
    loader: async ()=>(0, $9wGTI.fg)('confluence_link_item_append_trace_context') ? (await (parcelRequire("4cPvJ"))).ContentToolsItemWithRoutesContext : (await (parcelRequire("J1GVU"))).ContentToolsItem
});


const $35cdf415560d18a2$export$3de34eae48b0740b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uFc6G",
    name: "LazyContentToolsItemWithPlaceholder",
    loader: async ()=>(0, $9wGTI.fg)('confluence_link_item_append_trace_context') ? (await (parcelRequire("4cPvJ"))).ContentToolsItemWithRoutesContext : (await (parcelRequire("J1GVU"))).ContentToolsItem,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4LDXE.ContentToolsItemPlaceholder), null)
});
module.exports["LazyContentToolsItem"] = $35cdf415560d18a2$export$ecf6343598832c90;
module.exports["LazyContentToolsItemWithPlaceholder"] = $35cdf415560d18a2$export$3de34eae48b0740b;

});

parcelRegister("4LDXE", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e6ba7f6f1ee193d5$export$4a15f2daa593cc3 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                height: "40px",
                display: "flex",
                width: "100%",
                padding: "var(--ds-space-100, 8px) var(--ds-space-250, 20px)",
                alignItems: "center",
                boxSizing: "border-box"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                height: "17px",
                width: "100%",
                backgroundColor: "var(--ds-skeleton, #0515240F)",
                borderRadius: "10%"
            }
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentToolsItemPlaceholder"] = $e6ba7f6f1ee193d5$export$4a15f2daa593cc3;

});

parcelRegister("4cPvJ", function(module, exports) {

let $31003d64a3cbc110$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $31003d64a3cbc110$var$load("bzc8Q"),
    $31003d64a3cbc110$var$load("4TY0p")
]).then(()=>parcelRequire('ebxOW'));

});

parcelRegister("J1GVU", function(module, exports) {

let $087583f96ab988ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $087583f96ab988ae$var$load("bzc8Q").then(()=>parcelRequire('al4VD'));

});

parcelRegister("k9WFY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $77aec7b4d93beceb$export$c4e96d849cdd6a3d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g6cZS",
    name: "PublishPageAsBlogDialog",
    loader: async ()=>(await (parcelRequire("ephDI"))).PublishPageAsBlogDialog
});
module.exports["PublishPageAsBlogDialog"] = $77aec7b4d93beceb$export$c4e96d849cdd6a3d;

});

parcelRegister("ephDI", function(module, exports) {

let $a7d11550c104ea75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a7d11550c104ea75$var$load("6HLQW"),
    $a7d11550c104ea75$var$load("hBTro"),
    $a7d11550c104ea75$var$load("4fYzp"),
    $a7d11550c104ea75$var$load("5zDuS"),
    $a7d11550c104ea75$var$load("fJjZJ")
]).then(()=>parcelRequire('8d4o6'));

});

parcelRegister("5G6sa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $f44739e864265bc9$var$ContentHistoryStore = (0, $8s9DV.createStore)({
    initialState: {
        wasTransitionedFromEditor: false
    },
    actions: {
        setWasTransitionedFromEditor: (wasTransitionedFromEditor)=>({ setState: setState })=>{
                setState({
                    wasTransitionedFromEditor: wasTransitionedFromEditor
                });
            }
    },
    name: 'newContentHistoryState'
});
const $f44739e864265bc9$export$90587b2a92cba8d5 = (0, $kBr4q.createStateHook)($f44739e864265bc9$var$ContentHistoryStore);
const $f44739e864265bc9$export$9b1a939bc5c5d3b = (0, $kBr4q.createActionsHook)($f44739e864265bc9$var$ContentHistoryStore);
module.exports["useNewContentHistoryState"] = $f44739e864265bc9$export$90587b2a92cba8d5;
module.exports["useNewContentHistoryActions"] = $f44739e864265bc9$export$9b1a939bc5c5d3b;

});

parcelRegister("fzhfU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $JTIzG = parcelRequire("JTIzG");

const $e4992c54b0e0da53$export$ede5d3bbbf3ec238 = (0, $3u0dr.isReactCompilerActiveV2)() ? (isAIEnabledForContent)=>{
    const { isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    return isAIEnabledForContent && isAIPolicyAndBrowserSupportEnabled && !isAudioBylineEntrypointEnabled;
} : (isAIEnabledForContent)=>{
    const { isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    // Only show audio entrypoint in sidebar if:
    // 1. AI is Enabled for content
    // 2. AI Policy and browser support are enabled AND
    // 3. The when byline entrypoint is not enabled (ex: Audio V2 experience), the object sidebar will be the only audio entrypoint.
    return isAIEnabledForContent && isAIPolicyAndBrowserSupportEnabled && !isAudioBylineEntrypointEnabled;
};
module.exports["useHasAudioButton"] = $e4992c54b0e0da53$export$ede5d3bbbf3ec238;

});

parcelRegister("7om8k", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hNRe4 = parcelRequire("hNRe4");

const $a7795cfffaaaa1a7$export$a976a35f73cf7a61 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hNRe4.PageOwnershipByLineWithContributorsDropdown), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hNRe4.PageOwnershipByLineWithContributorsDropdown), props);
};
module.exports["BadgeStylePageOwnershipByline"] = $a7795cfffaaaa1a7$export$a976a35f73cf7a61;

});

parcelRegister("hNRe4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $lpNn5 = parcelRequire("lpNn5");


var $4n1IT = parcelRequire("4n1IT");


var $kz1Yj = parcelRequire("kz1Yj");


var $6Pqow = parcelRequire("6Pqow");


var $kh0hi = parcelRequire("kh0hi");


var $buxP3 = parcelRequire("buxP3");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $eToX6 = parcelRequire("eToX6");


var $kuujH = parcelRequire("kuujH");


var $jFm04 = parcelRequire("jFm04");


var $2zphh = parcelRequire("2zphh");


var $iMxJy = parcelRequire("iMxJy");


const $a1b50edf1fd86d1e$var$LazyPopupContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_Qz_k",
    name: "LazyPopupContent",
    loader: async ()=>(await (parcelRequire("cFBoN"))).PageOwnershipByLineWithContributorsDropdownContent
});
const $a1b50edf1fd86d1e$var$triggerStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    backgroundColor: 'color.background.neutral.subtle',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $a1b50edf1fd86d1e$var$smartFolderHeaderTriggerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    borderRadius: 'radius.small',
    minHeight: 'space.300',
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    backgroundColor: 'color.background.neutral.subtle',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $a1b50edf1fd86d1e$var$previewPanelCardStyle = (0, $buxP3.xcss)({
    paddingInline: 'space.050',
    paddingBlock: 'space.025',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal'
});
const $a1b50edf1fd86d1e$var$PageOwnershipByLineWithContributorsDropdownComponent = ({ owner: owner, author: author, contributorCountWithoutOwner: contributorCountWithoutOwner, analyticsSource: analyticsSource, generatedBy: generatedBy, isSmartFolderHeaderByline: isSmartFolderHeaderByline = false, shouldRenderToParent: shouldRenderToParentProp })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { openModal: openChangeOwnerModal } = (0, $jFm04.useContentOwnershipContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const [triggerRefDuplicate, setTriggerRefDuplicate] = (0, $cozmU.useState)(null);
    const createDuplicateRef = (0, $iMxJy.useDuplicateRef)();
    // Tracks whether the dropdown was explicitly opened by a click (pinned open).
    // When pinned, the dropdown stays open even when the mouse leaves.
    const isPinnedRef = (0, $cozmU.useRef)(false);
    // Reset state when changing contentId
    (0, $cozmU.useEffect)(()=>{
        setIsDropdownOpen(false);
        isPinnedRef.current = false;
    }, [
        contentId
    ]);
    const pageOwner = owner ?? author;
    const avatarSrc = (0, $2zphh.getUserAvatarSrc)(pageOwner);
    const profileCardResidesInPreviewPanel = (0, $eToX6.isInPreviewPanel)();
    const onPopupTriggerClick = (0, $cozmU.useCallback)(()=>{
        if ((0, $6mKj3.expValEquals)('cc_show_byline_job_title', 'isEnabled', true)) {
            if (isDropdownOpen && !isPinnedRef.current) // Menu is open from hover — pin it open instead of closing
            isPinnedRef.current = true;
            else {
                // Closed → open and pin, or pinned → close and unpin
                const next = !isDropdownOpen;
                isPinnedRef.current = next;
                setIsDropdownOpen(next);
            }
        } else // Control path: simple toggle without pinning
        setIsDropdownOpen((prev)=>!prev);
    }, [
        isDropdownOpen
    ]);
    // Hover-to-open logic: when cc_show_byline_job_title experiment is enabled,
    // the dropdown opens on hover instead of requiring a click (tooltip is also hidden).
    // A 200ms delay on mouse leave prevents the dropdown from closing while the user
    // moves their cursor from the trigger to the popup content.
    const hoverCloseTimeoutRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        return ()=>clearHoverCloseTimeout();
    }, []);
    const clearHoverCloseTimeout = ()=>{
        if (hoverCloseTimeoutRef.current) {
            clearTimeout(hoverCloseTimeoutRef.current);
            hoverCloseTimeoutRef.current = null;
        }
    };
    const startHoverCloseTimeout = ()=>{
        clearHoverCloseTimeout();
        hoverCloseTimeoutRef.current = setTimeout(()=>{
            setIsDropdownOpen(false);
        }, 200);
    };
    const onPopupTriggerMouseEnter = ()=>{
        if ((0, $6mKj3.expValEquals)('cc_show_byline_job_title', 'isEnabled', true)) {
            clearHoverCloseTimeout();
            setIsDropdownOpen(true);
        }
    };
    const onPopupTriggerMouseLeave = ()=>{
        if (!isPinnedRef.current && (0, $6mKj3.expValEquals)('cc_show_byline_job_title', 'isEnabled', true)) startHoverCloseTimeout();
    };
    const onPopupContentMouseEnter = ()=>{
        clearHoverCloseTimeout();
    };
    const onPopupContentMouseLeave = ()=>{
        if (!isPinnedRef.current && (0, $6mKj3.expValEquals)('cc_show_byline_job_title', 'isEnabled', true)) startHoverCloseTimeout();
    };
    const onPopupClose = (0, $cozmU.useCallback)(()=>{
        clearHoverCloseTimeout();
        isPinnedRef.current = false;
        setIsDropdownOpen(false);
    }, []);
    const onChangeOwnerClick = (0, $cozmU.useCallback)(()=>{
        // accessibility: return focus to dropdown trigger when change owner modal closes - doesnt happen automatically because the change owner modal trigger is in the dropdown which gets unmounted when the modal opens.
        openChangeOwnerModal({
            returnFocusRef: triggerRefDuplicate ?? undefined
        });
        setIsDropdownOpen(false);
    }, [
        openChangeOwnerModal,
        triggerRefDuplicate
    ]);
    const ownerInfoInsidePreviewPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.050",
        alignBlock: "center",
        xcss: $a1b50edf1fd86d1e$var$previewPanelCardStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: avatarSrc,
        borderColor: "transparent",
        size: "xxsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1
    }, intl.formatMessage(generatedBy === 'ONBOARDING' ? (0, $kuujH.i18n).bylineMainTextCreatedByConfluence : (0, $kuujH.i18n).abbreviatedBylineMainText, {
        user: pageOwner.fullName
    })));
    const popupTrigger = ({ ref: ref, ...triggerProps })=>{
        const triggerRef = createDuplicateRef(ref, setTriggerRefDuplicate);
        const pressable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            testId: "owner-with-contributors-dropdown-trigger",
            xcss: isSmartFolderHeaderByline ? $a1b50edf1fd86d1e$var$smartFolderHeaderTriggerStyles : $a1b50edf1fd86d1e$var$triggerStyles,
            onClick: onPopupTriggerClick,
            onMouseEnter: onPopupTriggerMouseEnter,
            onMouseLeave: onPopupTriggerMouseLeave,
            ref: triggerRef,
            ...triggerProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarSrc,
            borderColor: "transparent",
            size: "xxsmall"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            size: "small",
            color: "color.text.subtle",
            maxLines: 1
        }, intl.formatMessage(generatedBy === 'ONBOARDING' ? (0, $kuujH.i18n).bylineMainTextCreatedByConfluence : (0, $kuujH.i18n).abbreviatedBylineMainText, {
            user: pageOwner.fullName
        }))));
        if ((0, $6mKj3.expValEquals)('cc_show_byline_job_title', 'isEnabled', true)) return pressable;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: isDropdownOpen ? undefined : intl.formatMessage(analyticsSource.startsWith('folder') ? (0, $kuujH.i18n).ownerDropdownTooltip : (0, $kuujH.i18n).ownerWithContributorsDropdownTooltip),
            position: "bottom",
            hideTooltipOnClick: true
        }, pressable);
    };
    if (profileCardResidesInPreviewPanel) return ownerInfoInsidePreviewPanel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                role: "presentation",
                onMouseEnter: onPopupContentMouseEnter,
                onMouseLeave: onPopupContentMouseLeave,
                onFocus: onPopupContentMouseEnter,
                onBlur: onPopupContentMouseLeave
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1b50edf1fd86d1e$var$LazyPopupContent, {
                analyticsSource: `${analyticsSource}-byline`,
                owner: pageOwner,
                onChangeOwnerClick: onChangeOwnerClick,
                contributorCountWithoutOwner: contributorCountWithoutOwner
            })),
        trigger: popupTrigger,
        isOpen: isDropdownOpen,
        onClose: onPopupClose,
        placement: "bottom-start",
        shouldRenderToParent: shouldRenderToParentProp !== undefined ? shouldRenderToParentProp : (0, $6mKj3.expValEquals)('a11y-fixes-week2-may-2026', 'isEnabled', true)
    });
};
const $a1b50edf1fd86d1e$export$4f664a3a9881436 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
})((0, $jFm04.withContentOwnershipContextProvider)($a1b50edf1fd86d1e$var$PageOwnershipByLineWithContributorsDropdownComponent));
module.exports["PageOwnershipByLineWithContributorsDropdown"] = $a1b50edf1fd86d1e$export$4f664a3a9881436;

});

parcelRegister("iMxJy", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");

const $de8876e797e08e86$export$376d7d7a8afb5e40 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const [createDuplicateRef] = (0, $cozmU.useState)($de8876e797e08e86$var$_temp2);
    return createDuplicateRef;
} : ()=>{
    const [createDuplicateRef] = (0, $cozmU.useState)(()=>(0, $dOBRD.default)((ref, setDuplicatedRef)=>{
            return (node)=>{
                if (typeof ref === 'function') ref(node);
                else if (ref) ref.current = node;
                setDuplicatedRef({
                    current: node
                });
            };
        }));
    return createDuplicateRef;
};
function $de8876e797e08e86$var$_temp(ref, setDuplicatedRef) {
    return (node)=>{
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
        setDuplicatedRef({
            current: node
        });
    };
}
function $de8876e797e08e86$var$_temp2() {
    return (0, $dOBRD.default)($de8876e797e08e86$var$_temp);
}
module.exports["useDuplicateRef"] = $de8876e797e08e86$export$376d7d7a8afb5e40;

});

parcelRegister("cFBoN", function(module, exports) {

let $939653086c9f003d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $939653086c9f003d$var$load("3tHBV"),
    $939653086c9f003d$var$load("cWvhX")
]).then(()=>parcelRequire('8M3ga'));

});

parcelRegister("aV3a0", function(module, exports) {

var $kae7O = parcelRequire("kae7O");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5T18X = parcelRequire("5T18X");


var $jMyy4 = parcelRequire("jMyy4");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kqgA = parcelRequire("5kqgA");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gzIc1 = parcelRequire("gzIc1");


var $jVylI = parcelRequire("jVylI");

const $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery = (0, $kae7O.default);
const $c042cea05c5afe3c$export$56ad806c83a5bd5e = (queryData)=>queryData?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.find((node)=>node?.key === 'page-title-property-draft');
const $c042cea05c5afe3c$var$i18n = (0, $kSwu1.defineMessages)({
    errorFlagTitle: {
        id: "content-topper.page-title.alignment.error.title",
        defaultMessage: "We couldn\u2019t update the title alignment"
    },
    errorFlagDescription: {
        id: "content-topper.page-title.alignment.error.description",
        defaultMessage: "Try again, or refresh the page."
    }
});
const $c042cea05c5afe3c$export$e3e4716593714d84 = ({ contentId: contentId, propertyKey: propertyKey = 'page-title-property-draft', isDelete: isDelete = false, loadTitleContentProperties: loadTitleContentProperties = false, updateAlignmentState: updateAlignmentState, updateCoverPictureWidthState: updateCoverPictureWidthState, contentType: contentType, flags: flags, updateIsLoadingComplete: updateIsLoadingComplete })=>{
    const isInitialLoadComplete = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const isTitleCenteredInitial = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const handleError = (0, $cozmU.useCallback)((error, suppressErrors)=>{
        const isUnauthOrNotFoundError = (0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error);
        if (!isUnauthOrNotFoundError) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!suppressErrors) flags?.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagDescription)
        });
    }, [
        flags
    ]);
    const getAlignmentFromContentProperty = (response)=>{
        const titlePropertyContent = $c042cea05c5afe3c$export$56ad806c83a5bd5e(response);
        if (titlePropertyContent?.value) try {
            return (0, $gzIc1.contentPropertyHelper)(titlePropertyContent)?.titleLayoutAlignment || (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        } catch (e) {
            handleError(e, false);
            return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        }
        else return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
    };
    const onCompleted = (response_0)=>{
        const coverPictureWidth = response_0.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
        updateAlignmentState?.(getAlignmentFromContentProperty(response_0));
        updateCoverPictureWidthState?.(coverPictureWidth);
    };
    const { data: data, networkStatus: networkStatus, refetch: refetchProperties } = (0, $jMyy4.useQueryInterop)($c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network',
        // cache-and-network is required for: edit cover width, transition out of edit, transition back to edit for same page (for Live Docs and Classic pages)
        onError: (error_0)=>{
            handleError(error_0, true);
        },
        skip: !(loadTitleContentProperties || Boolean(window.__SSR_RENDERED__)),
        notifyOnNetworkStatusChange: true,
        __callerPackage__: "content-topper"
    });
    const isTitleAlignmentLoading = networkStatus === (0, $5T18X.NetworkStatus).loading && !data;
    const refetchLoading = networkStatus === (0, $5T18X.NetworkStatus).refetch;
    const coverImageWidthCached = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth;
    isTitleCenteredInitial.current = (Boolean(window.__SSR_RENDERED__) || !isTitleAlignmentLoading) && getAlignmentFromContentProperty(data) === (0, $jVylI.TitleAlignmentType).CENTER;
    if (!isInitialLoadComplete.current && loadTitleContentProperties && data) {
        isInitialLoadComplete.current = true;
        onCompleted(data);
        updateIsLoadingComplete?.(true);
    }
    const { updateContentProperty: updateContentProperty, updateContentPropertyResult: { loading: isUpdatingAlignment } = {} } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page'
    });
    const onPageTitlePropertyUpdatedSubscriptionData = (0, $cozmU.useCallback)((_eventName, response_1)=>{
        const { pageTitlePropertyUpdated: pageTitlePropertyUpdated } = response_1 || {};
        try {
            const value = JSON.parse(pageTitlePropertyUpdated?.value);
            updateAlignmentState?.(value?.titleLayoutAlignment);
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        updateAlignmentState
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType || 'page',
        delta: 'pageTitlePropertyUpdated',
        onDataReceived: onPageTitlePropertyUpdatedSubscriptionData,
        subscriberId: 'useTitleContentPropertiesForEditor'
    });
    const updatePageTitleProperty = (0, $cozmU.useCallback)(async (propertyValue)=>{
        try {
            const getVersionNumber = (data_0)=>data_0?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.[0]?.version?.number || 0;
            const versionData = await refetchProperties();
            const versionNumber = getVersionNumber(versionData.data);
            const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
            await updateContentProperty({
                propertyKey: propertyKey,
                propertyValue: propertyValue,
                isDelete: isDelete,
                hasExistingProperty: versionNumber > 0,
                shouldOptimisticResponse: true,
                options: {
                    update: ()=>{
                        try {
                            const cacheData = (0, $l1uFv.readQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                __callerPackage__: "content-topper"
                            });
                            cacheData.content.nodes[0].pageTitleDraft.nodes[0] = {
                                ...cacheData.content.nodes[0].pageTitleDraft.nodes[0],
                                id: contentId,
                                key: propertyKey,
                                value: JSON.stringify(propertyValue),
                                version: {
                                    number: newVersionNumber,
                                    __typename: 'Version'
                                }
                            };
                            (0, $fEmGS.writeQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                data: cacheData,
                                __callerPackage__: "content-topper"
                            });
                        } catch (error_2) {
                            throw new Error(` failed to write to cache while updating ${propertyKey} content property after user updated page title${error_2.message}`);
                        }
                    }
                }
            });
        } catch (err) {
            handleError(err, false);
        }
    }, [
        propertyKey,
        contentId,
        isDelete,
        updateContentProperty,
        refetchProperties,
        handleError
    ]);
    return {
        isUpdatingAlignment: isUpdatingAlignment || refetchLoading,
        updatePageTitleProperty: updatePageTitleProperty,
        onCompleted: // exported for testing purposes
        onCompleted,
        isTitleAlignmentLoading: isTitleAlignmentLoading,
        isTitleCenteredInitial: isTitleCenteredInitial.current,
        coverImageWidthCached: coverImageWidthCached
    };
};
module.exports["useTitleContentPropertiesForEditor"] = $c042cea05c5afe3c$export$e3e4716593714d84;

});

parcelRegister("gjEAi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $44846349058524ee$export$9e2285f96d44792b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Swb7P",
    name: 'ApprovalBannerLoadable',
    loader: async ()=>(await (parcelRequire("fPIj7"))).ApprovalBanner
});
module.exports["ApprovalBanner"] = $44846349058524ee$export$9e2285f96d44792b;

});

parcelRegister("fPIj7", function(module, exports) {

let $b86dfcefb2dacbcc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b86dfcefb2dacbcc$var$load("dgerE"),
    $b86dfcefb2dacbcc$var$load("9cpj1"),
    $b86dfcefb2dacbcc$var$load("8gmaR")
]).then(()=>parcelRequire('hbQeG'));

});

parcelRegister("lrMxq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7boqA = parcelRequire("7boqA");


var $jmjWc = parcelRequire("jmjWc");


var $fgdVB = parcelRequire("fgdVB");


const $172892494f392667$var$ObjectSidebarControlLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "liSnz",
    name: "ObjectSidebarControlLoader",
    loader: async ()=>(await (parcelRequire("BIzGK"))).ObjectSidebarControl
});
const $172892494f392667$export$3fab07431350539e = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
module.exports["ObjectSidebarControl"] = $172892494f392667$export$3fab07431350539e;

});

parcelRegister("BIzGK", function(module, exports) {

let $07160868526172af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $07160868526172af$var$load("iY1NC"),
    $07160868526172af$var$load("6qeHt"),
    $07160868526172af$var$load("fvcK2"),
    $07160868526172af$var$load("4W6oq"),
    $07160868526172af$var$load("6wr18"),
    $07160868526172af$var$load("jv1fw"),
    $07160868526172af$var$load("k1ZP0"),
    $07160868526172af$var$load("kujst"),
    $07160868526172af$var$load("jj1og"),
    $07160868526172af$var$load("3fdX4"),
    $07160868526172af$var$load("7wYa9"),
    $07160868526172af$var$load("bb3WM"),
    $07160868526172af$var$load("jdmfD"),
    $07160868526172af$var$load("i3R6S"),
    $07160868526172af$var$load("koD3t"),
    $07160868526172af$var$load("diMTQ"),
    $07160868526172af$var$load("aMUi4"),
    $07160868526172af$var$load("fwumK"),
    $07160868526172af$var$load("9D0WW"),
    $07160868526172af$var$load("6XCf4"),
    $07160868526172af$var$load("ebvEF"),
    $07160868526172af$var$load("hSDwk"),
    $07160868526172af$var$load("b0ARW"),
    $07160868526172af$var$load("eeYoU"),
    $07160868526172af$var$load("18viy"),
    $07160868526172af$var$load("k6TzV"),
    $07160868526172af$var$load("iN26T"),
    $07160868526172af$var$load("VXbA1"),
    $07160868526172af$var$load("iLykf"),
    $07160868526172af$var$load("8T2wY"),
    $07160868526172af$var$load("7EorR"),
    $07160868526172af$var$load("aEiTV"),
    $07160868526172af$var$load("ccAQf"),
    $07160868526172af$var$load("1qlDN"),
    $07160868526172af$var$load("1yVM6"),
    $07160868526172af$var$load("8GFi1"),
    $07160868526172af$var$load("ffEVr"),
    $07160868526172af$var$load("hHIPg")
]).then(()=>parcelRequire('lVF98'));

});

parcelRegister("7Qvc2", function(module, exports) {
const $bcd09bd1d7b9cf0f$export$449c8054b4d9a926 = 'agentReceiptPanel';
const $bcd09bd1d7b9cf0f$export$109252224b02bc40 = 'ROVO_SMART_CREATION';
module.exports["AGENT_TRUST_RECEIPT_PANEL_ID"] = $bcd09bd1d7b9cf0f$export$449c8054b4d9a926;
module.exports["ROVO_SMART_CREATION_GENERATED_BY"] = $bcd09bd1d7b9cf0f$export$109252224b02bc40;

});

parcelRegister("b2GGc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jC4nA = parcelRequire("jC4nA");


var $jmjWc = parcelRequire("jmjWc");


var $7Qvc2 = parcelRequire("7Qvc2");

const $6e30f4ac71490dc9$var$i18n = (0, $kSwu1.defineMessages)({
    headerLabel: {
        id: "agent-trust-receipt.panel.header.non-final",
        defaultMessage: "Agent receipt"
    }
});
const $6e30f4ac71490dc9$var$AgentReceiptHeaderIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
        label: "",
        color: "currentColor"
    });

// Interaction-only, gated panel body — lazy so its chunk only loads when the panel is opened, and
// never ships in the byline/right-rail entry-point bundles that statically import this factory.
const $6e30f4ac71490dc9$var$LazyAgentTrustReceiptPanelBody = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "vTotT",
    name: "LazyAgentTrustReceiptPanelBody",
    loader: async ()=>(await (parcelRequire("1tJ1l"))).AgentTrustReceiptPanelBody
});
const $6e30f4ac71490dc9$var$AgentTrustReceiptBodyComponent = ({ receipt: receipt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e30f4ac71490dc9$var$LazyAgentTrustReceiptPanelBody, {
        receipt: receipt
    });
const $6e30f4ac71490dc9$export$2249a9400d169a9f = ({ receipt: receipt })=>({
        id: (0, $7Qvc2.AGENT_TRUST_RECEIPT_PANEL_ID),
        headerComponentElements: {
            HeaderIcon: $6e30f4ac71490dc9$var$AgentReceiptHeaderIcon,
            headerLabel: $6e30f4ac71490dc9$var$i18n.headerLabel
        },
        BodyComponent: $6e30f4ac71490dc9$var$AgentTrustReceiptBodyComponent,
        props: {
            receipt: receipt
        }
    });
module.exports["createAgentTrustReceiptPanel"] = $6e30f4ac71490dc9$export$2249a9400d169a9f;

});

parcelRegister("1tJ1l", function(module, exports) {

let $113b6c0d0ec5e834$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $113b6c0d0ec5e834$var$load("6wr18"),
    $113b6c0d0ec5e834$var$load("eOkWq"),
    $113b6c0d0ec5e834$var$load("ffEVr"),
    $113b6c0d0ec5e834$var$load("e6FBZ")
]).then(()=>parcelRequire('eBdsu'));

});

parcelRegister("essql", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4L9ve = parcelRequire("4L9ve");


var $8i27m = parcelRequire("8i27m");


var $aUU0C = parcelRequire("aUU0C");


var $bQm3c = parcelRequire("bQm3c");


var $8WQTF = parcelRequire("8WQTF");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $9nXVV = parcelRequire("9nXVV");


var $3bH25 = parcelRequire("3bH25");


var $e4kZB = parcelRequire("e4kZB");

const $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED = 1000;
const $2524304961e9b056$export$3c5a4187b7dbe412 = ({ pageId: pageId, pageContentTypeProps: pageContentTypeProps, onCommentRead: onCommentRead })=>{
    const [{ isUpdatingUnreadComments: isUpdatingUnreadComments }, { setIsUpdatingUnreadComments: setIsUpdatingUnreadComments, setIsUnreadQueryLoading: setIsUnreadQueryLoading, updateUnreadCommentIDSet: updateUnreadCommentIDSet, setShouldClearVisibleThreads: setShouldClearVisibleThreads }] = (0, $fHAwL.useUnreadComments)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // Setup observer for unread comments
    (0, $9nXVV.useUnreadCommentsObserverSetup)({
        pageId: pageId,
        onCommentRead: onCommentRead
    });
    // Destructure pageContentTypeProps with defaults
    const { pageMode: pageMode } = pageContentTypeProps || {};
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    // Get processed comments data
    const { commentsDataMap: commentsDataMap, error: error, openComments: openComments, isDataProcessed: isDataProcessed } = (0, $4L9ve.useProcessedCommentsDataState)();
    const loading = !isDataProcessed;
    // Get comments data directly from comments-data package (for pages only)
    // This fixes the circular dependency issue
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList = [] }] = (0, $8i27m.useCommentsData)();
    const { isDanglingCallback: isDanglingCallback } = (0, $3bH25.useIsDanglingCallback)({
        pageMode: pageMode
    });
    // We still need these for the logic in handleUpdateUnreadComments
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations, pageId: editorPageId } = editorAnnotationsState;
    const isRenderer = pageMode === 'view';
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions, pageId: rendererPageId } = rendererActionsResult || {};
    const { getViewedCommentsFresh: getViewedCommentsFresh } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    (0, $cozmU.useEffect)(()=>{
        // isUnreadQueryLoading is used in other areas of the code to make sure unread logic is processed before further logic
        setIsUnreadQueryLoading(loading);
    }, [
        loading,
        setIsUnreadQueryLoading
    ]);
    // Handle GraphQL query errors with proper error handling
    (0, $cozmU.useEffect)(()=>{
        if (!error || !pageId) return;
        // Handle expected errors (403/unauthorized, network errors) - just mark as handled
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return;
        }
        // Handle unexpected errors (including 500) - track them with context
        (0, $fJlJm.setContentErrorAttributes)(error, {
            objectId: pageId,
            objectType: 'page'
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMMENTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error,
        pageId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (pageId) {
            updateUnreadCommentIDSet(new Set(), 'removeAll');
            setShouldClearVisibleThreads(false);
            // reset so we can recreate the set for the page that the user is changing to
            setIsUpdatingUnreadComments(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId
    ]);
    const resetStates = (0, $cozmU.useCallback)(()=>{
        setIsUpdatingUnreadComments(false);
    }, [
        setIsUpdatingUnreadComments
    ]);
    const handleUpdateUnreadComments = (0, $cozmU.useCallback)(async ()=>{
        if (userId && isUpdatingUnreadComments) {
            if (loading) return [];
            if (!pageId) return;
            const currentAllCommentsFromQuery = openComments || [];
            if (currentAllCommentsFromQuery.length === 0) {
                resetStates(); // we no longer need to create the set if there are no comments on the page
                return;
            }
            // Skip if renderer actions or editor annotations are for different page
            if (pageMode && (isRenderer && rendererActions && rendererPageId !== pageId || !isRenderer && annotations && editorPageId !== pageId)) return; // Wait for next rerender when rendererActions / annotations are updated for the current page
            const rendererAnnotations = rendererActions?.getAnnotationMarks() || [];
            const annotationsInEditorDoc = new Set(annotations || []);
            if (currentAllCommentsFromQuery.length < $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED) {
                const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
                const hasPageComments = currentAllCommentsFromQuery.some((comment)=>comment?.location?.type === 'FOOTER');
                // skip creating unread comments set if the page is archived
                // or if there are no page comments and inline comments
                if (isArchived || pageMode && !hasPageComments && (isRenderer && rendererAnnotations?.length === 0 || !isRenderer && annotationsInEditorDoc?.size === 0)) return;
                // continuing here means one of these 3 scenarios are true so we do want to check for unread comments
                // 1. no inline comments, yes page comments
                // 2. yes inline comments, no page comments
                // 3. yes inline comments, yes page comments
                const viewedComments = await getViewedCommentsFresh();
                if (viewedComments.success && viewedComments.data) (0, $e4kZB.createUnreadCommentsSet)({
                    allComments: currentAllCommentsFromQuery,
                    currentUserId: userId,
                    pageId: pageId,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    resetStates: resetStates,
                    viewedComments: viewedComments.data,
                    isDanglingCallback: isDanglingCallback
                });
            }
        }
    }, [
        userId,
        isUpdatingUnreadComments,
        loading,
        pageId,
        pageMode,
        isRenderer,
        rendererActions,
        rendererPageId,
        annotations,
        editorPageId,
        openComments,
        resetStates,
        contentStatus,
        getViewedCommentsFresh,
        updateUnreadCommentIDSet,
        isDanglingCallback
    ]);
    (0, $3bH25.useDanglingAndResolvedHandler)({
        orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
        commentsDataMap: commentsDataMap,
        userId: userId || '',
        pageId: pageId || '',
        isDanglingCallback: pageMode ? isDanglingCallback : undefined
    });
    (0, $cozmU.useEffect)(()=>{
        const isNotPageContentType = !pageContentTypeProps;
        if (isNotPageContentType && !(0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) return;
        handleUpdateUnreadComments();
    }, [
        handleUpdateUnreadComments,
        rendererActions,
        annotations,
        pageContentTypeProps
    ]);
};
module.exports["useUnreadCommentsSetup"] = $2524304961e9b056$export$3c5a4187b7dbe412;

});

parcelRegister("9nXVV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $c1UWH = parcelRequire("c1UWH");


var $fHAwL = parcelRequire("fHAwL");


var $1czFr = parcelRequire("1czFr");


var $d3bcC = parcelRequire("d3bcC");

const $b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS = 1000;
const $b14365a28be63efb$export$d5d84acfffa9b3ca = ({ pageId: pageId, onCommentRead: onCommentRead })=>{
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead, flushPendingComments: flushPendingComments } = (0, $1czFr.useDebouncedMarkCommentsAsRead)($b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS);
    const { updateViewedCommentsCache: updateViewedCommentsCache } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const intersectionCallback = (0, $cozmU.useCallback)((commentId)=>{
        if (commentId) {
            updateUnreadCommentIDSet(new Set([
                commentId
            ]), 'remove');
            debouncedMarkCommentsAsRead(commentId);
            updateViewedCommentsCache([
                commentId
            ]);
            if ((0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) // Notify external systems about the comment being read (e.g. content types, whiteboards, databases)
            onCommentRead?.([
                commentId
            ]);
        }
    }, [
        updateUnreadCommentIDSet,
        debouncedMarkCommentsAsRead,
        updateViewedCommentsCache,
        onCommentRead
    ]);
    // Create refs to avoid stale closures in useEffect
    const intersectionCallbackRef = (0, $cozmU.useRef)(intersectionCallback);
    intersectionCallbackRef.current = intersectionCallback;
    const flushPendingCommentsRef = (0, $cozmU.useRef)(flushPendingComments);
    flushPendingCommentsRef.current = flushPendingComments;
    (0, $cozmU.useEffect)(()=>{
        if (!pageId) return;
        const observer = (0, $c1UWH.getUnreadCommentsIntersectionObserver)();
        observer.registerIntersectionCallback((commentId)=>{
            intersectionCallbackRef.current(commentId);
        });
        return ()=>{
            observer.disconnect();
            flushPendingCommentsRef.current();
        };
    }, [
        pageId
    ]);
};
module.exports["useUnreadCommentsObserverSetup"] = $b14365a28be63efb$export$d5d84acfffa9b3ca;

});

parcelRegister("3bH25", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $cozmU = parcelRequire("cozmU");


var $aUU0C = parcelRequire("aUU0C");


var $8WQTF = parcelRequire("8WQTF");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $e4kZB = parcelRequire("e4kZB");

const $280745ffe1b8b376$export$30b625574e8a38c7 = ({ pageMode: pageMode })=>{
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations } = editorAnnotationsState;
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions } = rendererActionsResult || {};
    const isDanglingCallback = (0, $cozmU.useCallback)((markerRef)=>{
        if (!pageMode) return false;
        return (0, $e4kZB.commentIsDangling)({
            pageMode: pageMode,
            annotationsInEditorDoc: new Set(annotations),
            rendererAnnotations: new Set(rendererActions?.getAnnotationMarks()?.map((ann)=>ann.attrs.id).filter(Boolean) || [])
        })(markerRef);
    }, [
        annotations,
        rendererActions,
        pageMode
    ]);
    return {
        isDanglingCallback: isDanglingCallback
    };
};
// Helper function to process added annotations (reopened / undangled)
const $280745ffe1b8b376$var$processAddedAnnotations = ({ currentList: currentList, previousThreadKeys: previousThreadKeys, commentsDataMap: commentsDataMap, viewedComments: viewedComments, userId: userId, isDanglingCallback: isDanglingCallback })=>{
    const addedCommentIds = new Set();
    for (const annotation of currentList)if (!previousThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Early return if comment is already viewed
            if (viewedComments.has(commentData.id)) return addedCommentIds;
            // Add the main comment ID if it's a valid unread comment
            if ((0, $e4kZB.isValidUnreadComment)({
                comment: commentData,
                currentUserId: userId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) addedCommentIds.add(commentData.id);
            // Add all reply IDs if they're valid unread comments
            commentData.replies?.forEach((reply)=>{
                if (reply) {
                    // Skip if reply is already viewed
                    if (viewedComments.has(reply.id)) return;
                    if ((0, $e4kZB.isValidUnreadComment)({
                        comment: reply,
                        currentUserId: userId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) addedCommentIds.add(reply.id);
                }
            });
        }
    }
    return addedCommentIds;
};
// Helper function to process removed annotations (resolved / dangled)
const $280745ffe1b8b376$var$processRemovedAnnotations = ({ previousList: previousList, currentThreadKeys: currentThreadKeys, commentsDataMap: commentsDataMap })=>{
    const removedCommentIds = new Set();
    for (const annotation of previousList)if (!currentThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Add the main comment ID
            removedCommentIds.add(commentData.id);
            // Add all reply IDs
            commentData.replies?.forEach((reply)=>{
                if (reply) removedCommentIds.add(reply.id);
            });
        }
    }
    return removedCommentIds;
};
const $280745ffe1b8b376$export$ce2ddc24e5a132d = ({ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: commentsDataMap, userId: userId, pageId: pageId, isDanglingCallback: isDanglingCallback })=>{
    const [{ isUpdatingUnreadComments: isUpdatingUnreadComments }, { updateUnreadCommentIDSet: updateUnreadCommentIDSet }] = (0, $fHAwL.useUnreadComments)();
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: pageId
    });
    // Keep track of the previous orderedActiveAnnotationIdList
    const previousOrderedActiveAnnotationIdListRef = (0, $cozmU.useRef)(orderedActiveAnnotationIdList);
    // Handle the async getViewedComments call
    const processAnnotations = (0, $cozmU.useCallback)(async ()=>{
        const previousList = previousOrderedActiveAnnotationIdListRef.current;
        const currentList = orderedActiveAnnotationIdList;
        // Early exit if lists are identical (same length)
        if (previousList.length === currentList.length) return;
        // Build thread key sets for processing
        const previousThreadKeys = new Set(previousList.map((annotation)=>annotation.threadKey));
        const currentThreadKeys = new Set(currentList.map((annotation)=>annotation.threadKey));
        const viewedCommentsResult = getViewedCommentsCacheOnly();
        if (!viewedCommentsResult.success || !viewedCommentsResult.data) return;
        const viewedComments = viewedCommentsResult.data;
        // Process added annotations (reopened / undangled)
        const addedCommentIds = $280745ffe1b8b376$var$processAddedAnnotations({
            currentList: currentList,
            previousThreadKeys: previousThreadKeys,
            commentsDataMap: commentsDataMap,
            viewedComments: viewedComments,
            userId: userId,
            isDanglingCallback: isDanglingCallback
        });
        // Process removed annotations (resolved / dangled)
        const removedCommentIds = $280745ffe1b8b376$var$processRemovedAnnotations({
            previousList: previousList,
            currentThreadKeys: currentThreadKeys,
            commentsDataMap: commentsDataMap
        });
        // Update unread comment ID set for added annotations
        if (addedCommentIds.size > 0) updateUnreadCommentIDSet(addedCommentIds, 'add');
        // Update unread comment ID set for removed annotations
        if (removedCommentIds.size > 0) updateUnreadCommentIDSet(removedCommentIds, 'remove');
        // Update the previous list ref to current list for next comparison
        previousOrderedActiveAnnotationIdListRef.current = currentList;
    }, [
        orderedActiveAnnotationIdList,
        commentsDataMap,
        userId,
        isDanglingCallback,
        getViewedCommentsCacheOnly,
        updateUnreadCommentIDSet
    ]);
    (0, $cozmU.useEffect)(()=>{
        // skip entirely if:
        // - feature flag is disabled
        // - isDanglingCallback check is not enabled
        // - isUpdatingUnreadComments being true means the unread query and viewed comments query are not complete yet, which means we shouldn't process the annotations yet
        if (!isDanglingCallback || isUpdatingUnreadComments) return;
        processAnnotations();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- exclude commentsDataMap because we don't need to rerun this hook when it changes
    }, [
        processAnnotations,
        isUpdatingUnreadComments
    ]);
};
module.exports["useIsDanglingCallback"] = $280745ffe1b8b376$export$30b625574e8a38c7;
module.exports["useDanglingAndResolvedHandler"] = $280745ffe1b8b376$export$ce2ddc24e5a132d;

});

parcelRegister("98zed", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");


var $eNbbn = parcelRequire("eNbbn");

const $91141199ce9a5735$export$899773b8bcad4fc7 = ()=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    const ssrStatus = (0, $eNbbn.useLivePageSSRStatus)();
    if (!ssrStatus.isTypeKnown && isTransition) return {
        isLive: undefined,
        isTypeKnown: false
    };
    return ssrStatus;
};
module.exports["useIsLivePageWithSSR"] = $91141199ce9a5735$export$899773b8bcad4fc7;

});

parcelRegister("kE2cJ", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");



parcelRequire("gSgn8");


var $9wGTI = parcelRequire("9wGTI");


var $7zgzO = parcelRequire("7zgzO");

const $14c2681824cc07d8$export$7b9b5b70059a466b = ({ href: href = null, name: name, params: params, to: to = null, usePush: usePush = false, forceReload: forceReload = false, reason: reason, skipRouteChange: skipRouteChange = false, excludedQueryParams: excludedQueryParams })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { push: push, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams, getHref: getHref, matchRoute: matchRoute } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const getUrl = ()=>{
        const customPath = href || to;
        let parsedUrl = {};
        if (customPath) parsedUrl = (0, $jiJCD.parse)(customPath, true);
        const currentQuery = getQueryParams();
        if (excludedQueryParams && (0, $9wGTI.fg)('confluence_frontend_excluded_query_params_redirect')) excludedQueryParams.forEach((param)=>{
            delete currentQuery[param];
        });
        return toUrl(name, {
            hash: getHash(),
            query: currentQuery,
            ...params,
            ...parsedUrl
        });
    };
    (0, $cozmU.useEffect)(()=>{
        const oldRoute = matchRoute(getHref());
        const oldRouteName = oldRoute?.name || null;
        const getAnalyticsAttributes = ({ newRouteName: newRouteName })=>({
                oldRouteName: oldRouteName,
                newRouteName: newRouteName,
                // It is safe to fire an event with the names of the route params because they are not UGC.
                // They are part of our route definitions. In contrast, the values of the route params are UGC.
                // Additionally, both the names and values of the route query params are UGC because they are
                // read directly from the URL without matching against our route definitions.
                oldRouteParamNames: Object.keys(oldRoute?.params || {}),
                newRouteParamNames: Object.keys(params || {}),
                // Space key related attributes.
                isOldRouteSpaceKeyDefined: !!oldRoute?.params?.spaceKey,
                isNewRouteSpaceKeyDefined: !!params?.spaceKey,
                areSpaceKeysEqual: oldRoute?.params?.spaceKey === params?.spaceKey,
                areSpaceKeysEqualLowercase: oldRoute?.params?.spaceKey?.toLowerCase() === params?.spaceKey?.toLowerCase()
            });
        const doRedirect = ()=>{
            // Reset the delayed content redirection object to avoid unnecessary redirects
            window['__DELAYED_CONTENT_REDIRECTION__'] = {};
            const gottenUrl = getUrl();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'redirect',
                    actionSubject: oldRouteName,
                    actionSubjectId: name || matchRoute(gottenUrl)?.name,
                    source: oldRouteName
                }
            }).fire();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirect',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: getAnalyticsAttributes({
                        newRouteName: name || matchRoute(gottenUrl)?.name
                    })
                }
            }).fire();
            // Skip route change by only rewrite URL
            if (skipRouteChange) try {
                window.history.replaceState({}, '', gottenUrl);
                return;
            } catch  {
            // If replaceState failed, then run the redirect normally
            }
            (usePush ? push : replace)(gottenUrl, forceReload);
        };
        try {
            doRedirect();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirectFailed',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: {
                        ...getAnalyticsAttributes({
                            newRouteName: name
                        }),
                        errorMessage: error?.message
                    }
                }
            }).fire();
            throw error;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["Redirection"] = $14c2681824cc07d8$export$7b9b5b70059a466b;

});

parcelRegister("4yKPM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $508846ea2a5b6903$export$1c961952eacaae6a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "BrZ9o",
    name: "InlineCommentsHighlighterLoader",
    loader: async ()=>(await (parcelRequire("3ebwV"))).InlineCommentsHighlighter
});
module.exports["InlineCommentsHighlighterLoader"] = $508846ea2a5b6903$export$1c961952eacaae6a;

});

parcelRegister("3ebwV", function(module, exports) {

let $259b9f86712491f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $259b9f86712491f5$var$load("g81ly"),
    $259b9f86712491f5$var$load("e3LAK"),
    $259b9f86712491f5$var$load("fYtcg"),
    $259b9f86712491f5$var$load("9FPrl"),
    $259b9f86712491f5$var$load("26l7c"),
    $259b9f86712491f5$var$load("8LtYa"),
    $259b9f86712491f5$var$load("9H0e8"),
    $259b9f86712491f5$var$load("hs6P3"),
    $259b9f86712491f5$var$load("aC3bY"),
    $259b9f86712491f5$var$load("953Uz"),
    $259b9f86712491f5$var$load("4UHov"),
    $259b9f86712491f5$var$load("7EorR"),
    $259b9f86712491f5$var$load("cGAab")
]).then(()=>parcelRequire('c2Ip8'));

});

parcelRegister("jhifQ", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $56fbb6365252754d$export$f8c96a5c7f3b43a6 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FOCUSED_INLINE_COMMENT_SEGMENT_KEY)
});
const $56fbb6365252754d$export$ac7f79e65475cee7 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
module.exports["FOCUSED_INLINE_COMMENT_METRIC"] = $56fbb6365252754d$export$f8c96a5c7f3b43a6;
module.exports["RENDERER_INLINE_COMMENT_RENDER_METRIC"] = $56fbb6365252754d$export$ac7f79e65475cee7;

});

parcelRegister("8amSw", function(module, exports) {
$parcel$export(module.exports, "CUSTOM_HEADER_FOOTER_TYPES", () => (parcelRequire("lvV7v")).CUSTOM_HEADER_FOOTER_TYPES);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");



var $lvV7v = parcelRequire("lvV7v");


const $b4c0f70deb5f986b$export$c002ebd7506cf24 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3f0hi",
    name: "CustomHeaderFooterLoader",
    loader: async ()=>(await (parcelRequire("c2l9w"))).CustomHeaderFooter
});

const $b4c0f70deb5f986b$export$abd9d7fbad77ffb4 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "gCcak",
    name: "CustomHeaderFooterBackgroundLoader",
    loader: async ()=>(await (parcelRequire("c2l9w"))).CustomHeaderFooter
});
module.exports["CustomHeaderFooterLoader"] = $b4c0f70deb5f986b$export$c002ebd7506cf24;

});

parcelRegister("c2l9w", function(module, exports) {

let $8c3614604b9a71ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8c3614604b9a71ff$var$load("jzSMU"),
    $8c3614604b9a71ff$var$load("bVl1P")
]).then(()=>parcelRequire('hnY2b'));

});

parcelRegister("lvV7v", function(module, exports) {
const $f7cada3b80c5d028$export$c16b69b19b9f847 = {
    HEADER: 'header',
    FOOTER: 'footer'
};
module.exports["CUSTOM_HEADER_FOOTER_TYPES"] = $f7cada3b80c5d028$export$c16b69b19b9f847;

});

parcelRegister("6pBXK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $95494d62ea246593$export$ffdc57aecb97ae41 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nmqvg",
    name: "ReadingAidsAcronymsHighlighter",
    loader: async ()=>(await (parcelRequire("3jZOc"))).ReadingAidsAcronymsHighlighter
});
module.exports["ReadingAidsAcronymsHighlighter"] = $95494d62ea246593$export$ffdc57aecb97ae41;

});

parcelRegister("3jZOc", function(module, exports) {

let $26b3175999865824$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $26b3175999865824$var$load("6mkG4").then(()=>parcelRequire('6vx1i'));

});

parcelRegister("kJNMt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7zgzO = parcelRequire("7zgzO");


var $fURMF = parcelRequire("fURMF");

const $0e8eac2a5609c7f2$export$139fec31c31601bb = ({ isSmooth: isSmooth })=>{
    const { getHash: getHash, getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    // we're using refs here to avoid violating the rules
    // of hooks, but still prevent ourselves from
    // scrolling to page start multiple times in case if
    // `RoutesContext` changes unexpectedly -- if that happens,
    // we'll just take the latest context values into account
    // when executing scroll, and ignore everything we've seen
    // prior to that.
    const getHashRef = (0, $cozmU.useRef)(getHash);
    const getQueryParamsRef = (0, $cozmU.useRef)(getQueryParams);
    getHashRef.current = getHash;
    getQueryParamsRef.current = getQueryParams;
    (0, $cozmU.useEffect)(()=>{
        const hash = getHashRef.current();
        const queryParams = getQueryParamsRef.current();
        const queryParamsThatTriggerScroll = [
            'focusedCommentId'
        ];
        const doesPageHaveExplicitScrollTarget = hash.length > 0 || queryParamsThatTriggerScroll.some((paramName)=>Boolean(queryParams[paramName]));
        if (!doesPageHaveExplicitScrollTarget) (0, $fURMF.scrollToPageStart)(isSmooth);
    }, [
        getHashRef,
        getQueryParamsRef,
        isSmooth
    ]);
    return null;
};
module.exports["ScrollToPageStart"] = $0e8eac2a5609c7f2$export$139fec31c31601bb;

});

parcelRegister("dJ5r4", function(module, exports) {
$parcel$export(module.exports, "ViewCommentShortcutListener", () => (parcelRequire("fPcdI")).ViewCommentShortcutListener);

var $fPcdI = parcelRequire("fPcdI");


});

parcelRegister("fPcdI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fJCU9 = parcelRequire("fJCU9");


var $9DHhW = parcelRequire("9DHhW");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $liGyh = parcelRequire("liGyh");


var $dANtQ = parcelRequire("dANtQ");


var $9QIM2 = parcelRequire("9QIM2");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $aJPUt = parcelRequire("aJPUt");


var $inDu6 = parcelRequire("inDu6");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $gczDe = parcelRequire("gczDe");


var $3mVfX = parcelRequire("3mVfX");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $9wGTI = parcelRequire("9wGTI");


var $cgy29 = parcelRequire("cgy29");


var $8i27m = parcelRequire("8i27m");


var $fHAwL = parcelRequire("fHAwL");


var $4L9ve = parcelRequire("4L9ve");


var $bQm3c = parcelRequire("bQm3c");


var $izhdc = parcelRequire("izhdc");


var $gSkOQ = parcelRequire("gSkOQ");

const $c392465906bed01c$var$ViewCommentShortcutListenerComponent = ({ isFabricPage: isFabricPage, contentId: contentId, dialogs: dialogs, preloadedCanAddComments: preloadedCanAddComments })=>{
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { commentsDataMap: commentsDataMap } = (0, $4L9ve.useProcessedCommentsDataState)();
    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isNextCommentLoading, setIsNextCommentLoading] = (0, $cozmU.useState)(false);
    const [{ currentlyRenderedThreads: currentlyRenderedThreads, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey }] = (0, $3mVfX.useCommentsPanel)();
    // Track previous annotation for difference-based scrolling
    const previousAnnotationRef = (0, $cozmU.useRef)(undefined);
    // Update ref whenever activeHighlight changes
    (0, $cozmU.useEffect)(()=>{
        // Only update if there's a valid value (not empty string or null)
        if (activeHighlight) previousAnnotationRef.current = activeHighlight;
    }, [
        activeHighlight
    ]);
    const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = (0, $aWwYt.useObjectSidebarState)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', false, preloadedCanAddComments);
    const orderedActiveAnnotations = (0, $cozmU.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    (0, $cozmU.useEffect)(()=>{
        setIsNextCommentLoading(false);
    }, [
        activeHighlight,
        currentlySelectedThreadKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            setCurrentlySelectedThreadKey('');
        };
    }, [
        setCurrentlySelectedThreadKey
    ]);
    const { footerCommentThreads: footerCommentThreads, footerCommentIds: footerCommentIds } = (0, $gSkOQ.useFooterComments)();
    const { unreadInlineComments: unreadInlineComments, unreadGeneralComments: unreadGeneralComments } = (0, $cozmU.useMemo)(()=>{
        const unreadInlineComments = [];
        const unreadGeneralComments = [];
        orderedActiveAnnotations.forEach((threadKey)=>{
            const commentData = commentsDataMap.inline[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                // in SSR, unreadCommentIDSet is undefined
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadInlineComments.push(threadKey);
            }
        });
        Object.keys(commentsDataMap.general).forEach((threadKey)=>{
            const commentData = commentsDataMap.general[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadGeneralComments.push(threadKey);
            }
        });
        return {
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotations,
        unreadCommentIDSet
    ]);
    const sendKeyboardShortcutAnalytics = (shortcut)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'viewPage',
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                actionSubjectId: 'createComment',
                attributes: {
                    key: shortcut
                }
            }
        }).fire();
    };
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $cgy29.useCreateCommentAction)({
        contentId: contentId || '',
        isFabric: isFabricPage,
        sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics
    });
    const getCommentIndex = (0, $cozmU.useCallback)((currentThreadKey)=>{
        return [
            ...orderedActiveAnnotations,
            ...footerCommentIds
        ]?.findIndex((threadKey)=>threadKey === currentThreadKey);
    }, [
        orderedActiveAnnotations,
        footerCommentIds
    ]);
    const openInlineComment = (0, $cozmU.useCallback)((markerRef)=>{
        if (pageClass === 'renderer' || pageClass === 'editor') experienceTracker.start({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
            attributes: {
                annotationId: markerRef,
                entryPoint: 'comments-shortcuts/ViewCommentShortcutListener',
                pageClass: 'renderer'
            }
        });
        const previousAnnotationId = previousAnnotationRef.current;
        setCurrentlySelectedThreadKey('');
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const commentElement = document.getElementById(markerRef);
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            annotationId: markerRef
        });
        (0, $4EKKB.selectInlineComment).debug(`Keyboard selection now triggering annotation selection for annotation ${markerRef}`);
        emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [
                markerRef
            ],
            eventTarget: commentElement
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: markerRef,
            previousAnnotationId: previousAnnotationId,
            commentType: 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        experienceTracker,
        pageClass,
        isObjectSidebarShown
    ]);
    const scrollToFooterComment = (0, $cozmU.useCallback)((threadKey)=>{
        // Reset previous annotation ref when navigating to footer comment
        previousAnnotationRef.current = undefined;
        setCurrentlySelectedThreadKey(threadKey);
        emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [],
            eventTarget: null
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: threadKey,
            commentType: 'FOOTER',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const onNavigationClick = (0, $cozmU.useCallback)((nextMarkerRef)=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                openInlineComment(nextMarkerRef);
            }
        });
        else openInlineComment(nextMarkerRef);
    }, [
        hasContentChanged,
        resetContentChanged,
        showModal,
        openInlineComment
    ]);
    const handlePanelCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        // If nothing is on the panel, there's nothing to navigate to
        if (currentlyRenderedThreads.length === 0) return;
        const { panelCommentRefs: panelCommentRefs, navigableInlineCommentRefs: navigableInlineCommentRefs } = (0, $izhdc.parsePanelAndInlineRefs)(currentlyRenderedThreads, orderedActiveAnnotations);
        const nextRef = (0, $izhdc.getNextRef)(action, panelCommentRefs, currentlySelectedThreadKey);
        // Handle panel selection state management in the listener
        setCurrentlySelectedThreadKey(nextRef.ref);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: nextRef.ref,
            commentType: nextRef.type === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER,
            isResolved: !navigableInlineCommentRefs.has(nextRef.ref)
        });
    }, [
        currentlyRenderedThreads,
        orderedActiveAnnotations,
        currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const handleNextCommentNavigation = (0, $cozmU.useCallback)(({ action: action, isNavigateToNextUnread: isNavigateToNextUnread })=>{
        //Check if the next inline comment is still in process of being rendered. Otherwise, quickly pressing keys will force comment to open and close instead of navigating
        if (isNextCommentLoading) return;
        setIsNextCommentLoading(true);
        navigateToInlineComment({
            action: action,
            triggeredByKeyboardShortcut: true,
            currentCommentIndex: getCommentIndex(activeHighlight || currentlySelectedThreadKey || ''),
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: false,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            isNavigateToNextUnread: isNavigateToNextUnread,
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments,
            footerComments: footerCommentIds,
            scrollToFooterComment: scrollToFooterComment,
            commentsDataMap: commentsDataMap
        });
    }, [
        isNextCommentLoading,
        navigateToInlineComment,
        getCommentIndex,
        activeHighlight,
        currentlySelectedThreadKey,
        onNavigationClick,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        createAnalyticsEvent,
        contentId,
        unreadInlineComments,
        unreadGeneralComments,
        footerCommentIds,
        scrollToFooterComment,
        commentsDataMap
    ]);
    const handleStandaloneCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: false,
            action: action
        });
        else {
            // No highlight selected, so we navigate to the first inline comment
            const firstInlineCommentMarkerRef = orderedActiveAnnotations[0];
            if (!firstInlineCommentMarkerRef && footerCommentThreads.length === 0) return;
            if (firstInlineCommentMarkerRef) openInlineComment(firstInlineCommentMarkerRef);
            else scrollToFooterComment(footerCommentThreads[0]?.id);
        }
    }, [
        activeHighlight,
        currentlySelectedThreadKey,
        orderedActiveAnnotations,
        handleNextCommentNavigation,
        footerCommentThreads,
        openInlineComment,
        scrollToFooterComment
    ]);
    const handleCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        // Define behavior when the comments panel is shown - panel FG is a prereq for nav, so has to be checked first
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) handlePanelCommentNavigation(action);
        else // Comments panel not shown
        handleStandaloneCommentNavigation(action);
    }, [
        isObjectSidebarShown,
        panel?.id,
        handlePanelCommentNavigation,
        handleStandaloneCommentNavigation
    ]);
    const handleNextUnreadNavigation = (0, $cozmU.useCallback)(()=>{
        //unread panel navigation
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) {
            let nextThreadKey = '';
            let nextCommentType = (0, $8i27m.CommentType).GENERAL;
            if (!currentlySelectedThreadKey) {
                if (unreadInlineComments.length > 0) {
                    nextThreadKey = unreadInlineComments[0];
                    nextCommentType = (0, $8i27m.CommentType).INLINE;
                } else nextThreadKey = unreadGeneralComments[0];
            } else {
                nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(getCommentIndex(currentlySelectedThreadKey ?? '') + 1, //Add one otherwise it might get stuck on the current comment because there are unread replies which are collapsed
                [
                    ...orderedActiveAnnotations,
                    ...footerCommentIds
                ], [
                    ...unreadInlineComments,
                    ...unreadGeneralComments
                ]) ?? '';
                if (unreadInlineComments.includes(nextThreadKey)) nextCommentType = (0, $8i27m.CommentType).INLINE;
            }
            // Handle panel selection state management in the listener
            setCurrentlySelectedThreadKey(nextThreadKey);
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                annotationId: nextThreadKey,
                commentType: nextCommentType === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
                isCommentsPanelOpen: isObjectSidebarShown,
                hasKeyPressed: true,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                shortcutType: (0, $9FoVw.ShortcutType).UNREAD
            });
            return;
        }
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: true,
            action: 'next'
        });
        else {
            if (unreadInlineComments.length + unreadGeneralComments.length === 0) return;
            if (unreadInlineComments[0]) openInlineComment(unreadInlineComments[0]);
            else scrollToFooterComment(unreadGeneralComments[0]);
        }
    }, [
        isObjectSidebarShown,
        panel?.id,
        handleNextCommentNavigation,
        unreadInlineComments,
        activeHighlight,
        openInlineComment,
        scrollToFooterComment,
        currentlySelectedThreadKey,
        unreadGeneralComments,
        footerCommentIds,
        getCommentIndex,
        orderedActiveAnnotations,
        setCurrentlySelectedThreadKey
    ]);
    const openCommentEditorShortcutCb = (e)=>{
        e.preventDefault();
        // This check is necessary to see which keyboard shortcut was used so it can be sent to analytics.
        // e.key is used to get the key that was pressed according to the current keyboard layout.
        // We compare with CREATE_COMMENT_SHORTCUT because it is a single-letter keyboard shortcut.
        // It's more difficult to compare with UNIVERSAL_OPEN_COMMENT_EDITOR because it includes modifiers.  Modifiers which change what e.key maps to depending on the keyboard layout.
        const shortcut = e.key === (0, $gnkil.CREATE_COMMENT_SHORTCUT) ? (0, $gnkil.CREATE_COMMENT_SHORTCUT) : (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR);
        if (canAddComments || !(0, $9wGTI.fg)('confluence_fe_add_comment_kb_check_permission')) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (document.querySelector('[data-testid="highlightActionsPopup"]')) {
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                const createButton = document.querySelector('#create-inline-comment-button');
                // If createButton is not found or is disabled, do nothing.
                // This handles the case when hovering over media (image/video) objects in renderer.
                // In this scenario, a `highlightActionsPopup` is shown but the Comment button (which
                // has a different id) behaves differently: if any comment exists on the media object,
                // button click opens it as standalone; otherwise button click opens CreateComment.
                // Keyboard shortcut is disabled for this scenario.
                const createButtonIsEnabled = createButton && createButton?.getAttribute('disabled') !== '';
                if (createButtonIsEnabled) handleCommentButtonClick({
                    dialogs: dialogs,
                    shortcut: shortcut,
                    experienceAttributes: {
                        entryPoint: 'keyboardShortcut',
                        edition: edition
                    }
                });
            } else {
                // Check if we should show sticky draft instead of scrolling to object comment wrapper
                const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT;
                if (!expanded) expandCommentContainer({
                    entryPoint: 'keyboardShortcutView'
                });
                if (isShowStickyDraft || !isObjectCommentWrapperVisible) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
                else // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        sendKeyboardShortcutAnalytics(shortcut);
    };
    if (!isFabricPage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "comments-shortcut-listener"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_SELECT_COMMENT_SHORTCUT),
        listener: ()=>{
            const openComment = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.getElementById('renderer-comments-sidebar') || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.getElementById(`comment-thread-${currentlySelectedThreadKey}-container`);
            if (openComment) (0, $aHcFH.focusElementAndUpdateTabIndex)(openComment);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.NEXT_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to next comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('next');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.PREV_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to previous comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('previous');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('Keyboard navigation to next unread comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleNextUnreadNavigation();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.CREATE_COMMENT_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>openCommentEditorShortcutCb(e)
    }));
};
const $c392465906bed01c$export$c1f9f1253d923bc1 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})((0, $inDu6.withDialogs)($c392465906bed01c$var$ViewCommentShortcutListenerComponent));
module.exports["ViewCommentShortcutListener"] = $c392465906bed01c$export$c1f9f1253d923bc1;

});

parcelRegister("fyPYm", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bavCP = parcelRequire("bavCP");


var $eyzLS = parcelRequire("eyzLS");

let $701bdc3764047e40$var$lastContentId;
const $701bdc3764047e40$export$cc2fc38458ee98cc = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    let t2;
    if ($[0] !== contentId) {
        t1 = ()=>{
            $701bdc3764047e40$var$lastContentId = contentId;
        };
        t2 = [
            contentId
        ];
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = $701bdc3764047e40$var$lastContentId === contentId;
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: (0, $eyzLS.default),
            variables: t3,
            fetchPolicy: "network-only",
            skip: t4,
            __callerPackage__: "content-body"
        }, $701bdc3764047e40$var$_temp);
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
function $701bdc3764047e40$var$_temp() {
    return null;
}
module.exports["ContentViewedEvent"] = $701bdc3764047e40$export$cc2fc38458ee98cc;

});

parcelRegister("eyzLS", function(module, exports) {
/**
 * @generated SignedSource<<b170f4062a7b22df5c789ae2263ec5d9>>
 * @relayHash 6b82c836e177933e272ade59efcd5b5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6442e1d626bb37ef4897bdc166747bc6f6f93f7d888574ea37d7d5521fde4b42
const $ac80f5dc8fd0c04e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "trigger",
                    "value": "viewed"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentViewedEventQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentViewedEventQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "6b82c836e177933e272ade59efcd5b5c",
            "id": "6442e1d626bb37ef4897bdc166747bc6f6f93f7d888574ea37d7d5521fde4b42",
            "metadata": {},
            "name": "ContentViewedEventQuery",
            "operationKind": "query",
            "text": "query ContentViewedEventQuery($contentId:ID){content(id:$contentId,trigger:\"viewed\"){nodes{id}}}"
        }
    };
}();
$ac80f5dc8fd0c04e$var$node.hash = "d8b1d8e3bca16082db7c9284db04b505";
var $ac80f5dc8fd0c04e$export$2e2bcd8739ae039 = $ac80f5dc8fd0c04e$var$node;
module.exports["default"] = $ac80f5dc8fd0c04e$export$2e2bcd8739ae039;

});

parcelRegister("39nIX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");

var $398ES = parcelRequire("398ES");


var $7boqA = parcelRequire("7boqA");


var $5RuD9 = parcelRequire("5RuD9");


var $jhifQ = parcelRequire("jhifQ");


/* View Mode Exports */ const $166368e9a123fc4e$var$InlineCommentsLoaderPaint = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fZs06",
    name: "InlineCommentsLoaderPaint",
    loader: async ()=>(await (parcelRequire("VXY8c"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderLazy = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i8DIK",
    name: "InlineCommentsLoaderLazy",
    loader: async ()=>(await (parcelRequire("VXY8c"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vilgC",
    name: "InlineCommentsLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("VXY8c"))).InlineComments
});

const $166368e9a123fc4e$var$InlineCommentsLoaderBackground = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "05zPo",
    name: "InlineCommentsLoaderBackground",
    loader: async ()=>(await (parcelRequire("VXY8c"))).InlineComments
});
const $166368e9a123fc4e$var$loaders = {
    [(0, $398ES.LoadingPriority).LAZY]: $166368e9a123fc4e$var$InlineCommentsLoaderLazy,
    [(0, $398ES.LoadingPriority).PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderPaint,
    [(0, $398ES.LoadingPriority).AFTER_PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint
};
const $166368e9a123fc4e$export$bceb71dc98e1c75f = ({ loadingPriority: loadingPriority, focusedCommentId: focusedCommentId, ...rest })=>{
    const CommentsLoader = $166368e9a123fc4e$var$loaders[loadingPriority] || $166368e9a123fc4e$var$InlineCommentsLoaderBackground;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, focusedCommentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        key: `start-${focusedCommentId}`,
        metric: (0, $jhifQ.FOCUSED_INLINE_COMMENT_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CommentsLoader, rest));
};
module.exports["InlineCommentsLoader"] = $166368e9a123fc4e$export$bceb71dc98e1c75f;

});

parcelRegister("5RuD9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8uhVX = parcelRequire("8uhVX");


var $beAZw = parcelRequire("beAZw");

const $58d1b0f1d68392b5$var$checkForSSRFocusedComment = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $58d1b0f1d68392b5$export$d174da0f28ffce9e = ()=>{
    return $58d1b0f1d68392b5$var$checkForSSRFocusedComment() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8uhVX.FocusedInlineComment), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null);
};
module.exports["InlineCommentsLoading"] = $58d1b0f1d68392b5$export$d174da0f28ffce9e;

});

parcelRegister("8uhVX", function(module, exports) {
/* FocusedInlineComment.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $9wGTI = parcelRequire("9wGTI");


var $dOBRD = parcelRequire("dOBRD");


var $kSwu1 = parcelRequire("kSwu1");


var $jMyy4 = parcelRequire("jMyy4");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");




var $9CnRS = parcelRequire("9CnRS");


var $666Tc = parcelRequire("666Tc");


var $k5dl6 = parcelRequire("k5dl6");



var $f8HSn = parcelRequire("f8HSn");


var $qYtBT = parcelRequire("qYtBT");


var $dQJV7 = parcelRequire("dQJV7");


var $c04ej = parcelRequire("c04ej");

const $d9a6205ec51ab13a$var$parseContent = (0, $dOBRD.default)((content)=>{
    if (!content?.length) return null;
    try {
        return JSON.parse(content);
    } catch  {
        return null;
    }
});
const $d9a6205ec51ab13a$var$FocusedInlineCommentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.SidebarContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_162hus6": (0, $9aYkv.default)(__cmplp.offset, "px")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2IhTon3k40 _2mf0CM1PzL _2PfEqSsyl5",
            __cmplp.showSkeleton ? "_3iDTPbvLZJ" : "_3iDTPbYbGa",
            __cmplp.className
        ])
    });
}); /* Comment Editor CSS*/ 
const $d9a6205ec51ab13a$var$EditorContainerSSRFallback = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2qR9w71Y8M _3ppEVQOeNX _2saX4d4Y4b _1nozOlmnOE _2xyuKVuNcX _1gNu1g2Njc _3lRpoLN91d",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$EditorContainerSSRTokenized = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2qR9w71Y8M _3ppEVQOeNX _2saX4dKxmn _1nozOlmnOE _2xyuKVuNcX _1gNu1g2Njc _3lRpoLN91d",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$CommentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEeCFc _2xIroY98eZ _497WNwYbGa _2zndICT6kp _3JzbaednbC _2bqfgddnbC _3iDTPbQ4SZ _0aFT5vbt8w _4aZwk7dnbC _18JcJDy7kJ",
            __cmplp.isFocused && "_2uo31fDM2k",
            __cmplp.className
        ])
    });
});
const $d9a6205ec51ab13a$export$622cea445a1c5b7d = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRefOffset'];
    return 0;
}; // Makes sure to only show focusedInlineCommentSSR if the page was ssr'd
const $d9a6205ec51ab13a$export$db871669e60ed1cb = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $d9a6205ec51ab13a$export$7afb8d400fcdf579 = ()=>{
    const EditorContainerSSR = (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? $d9a6205ec51ab13a$var$EditorContainerSSRTokenized : $d9a6205ec51ab13a$var$EditorContainerSSRFallback;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const focusedCommentId = match?.query.focusedCommentId;
    const focusedCommentIdString = typeof focusedCommentId === 'string' ? focusedCommentId : ''; // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $k5dl6.default), {
        variables: {
            commentId: focusedCommentIdString,
            contentId: contentId
        },
        skip: !(contentId && focusedCommentId),
        __callerPackage__: "inline-comments"
    });
    let commentData;
    let isTopLevelComment = true; /* If focusedCommentId is a reply grab top-level comment Data from ancestors.
                                 If ancestors is non-empty it means focusedCommentId is a reply*/ 
    if (data?.comments?.nodes?.[0]?.ancestors && data.comments.nodes[0].ancestors.length > 0) {
        commentData = data.comments.nodes[0].ancestors[0];
        isTopLevelComment = false;
    } else commentData = data?.comments?.nodes?.[0];
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['isTopLevelComment'] = isTopLevelComment;
    const content = data?.content?.nodes?.[0];
    const operations = content?.operations || [];
    const canCreateComments = Boolean(operations.find((op)=>op?.operation === 'create' && op?.targetType === 'comment'));
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName;
    const commentId = commentData?.id;
    const when = commentData?.version?.when;
    const commentContent = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const currentUserAvatarUrl = data?.user?.photos?.[0]?.value ?? undefined;
    const currentUserDisplayName = data?.user?.displayName ?? undefined;
    const currentUserId = data?.user?.id;
    const adf = $d9a6205ec51ab13a$var$parseContent(commentContent);
    const renderReplies = ()=>{
        const replies = commentData?.replies || [];
        return replies.map((reply)=>{
            const adf = $d9a6205ec51ab13a$var$parseContent(reply?.body?.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
                key: reply?.id,
                isFocused: focusedCommentId === reply?.id,
                "data-comment-id": reply?.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
                commentMode: "view",
                userId: reply?.author?.accountId,
                avatarUrl: reply?.author?.profilePicture?.path,
                displayName: reply?.author?.displayName,
                date: reply?.version?.when,
                permissionType: reply?.author?.permissionType
            }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c04ej.CommentRenderer), {
                adf: adf
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQJV7.CommentActions), {
                isReply: true,
                permissions: reply?.permissions
            }));
        });
    }; // Scroll to focusedInlineComment if it's out of the screen
    const scrollOffset = window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment'] && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['scrollOffset'];
    if (scrollOffset) window.scrollTo({
        top: scrollOffset
    });
    if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$FocusedInlineCommentContainer, {
        mode: "view",
        id: "focused-inline-comment-sidebar-skeleton",
        "data-testid": "focused-inline-comment-sidebar-skeleton",
        showSkeleton: $d9a6205ec51ab13a$export$db871669e60ed1cb(),
        offset: $d9a6205ec51ab13a$export$622cea445a1c5b7d()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $qYtBT.CommentHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
        tabIndex: -1,
        "data-comment-id": commentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "view",
        userId: topCommentUserId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: when,
        permissionType: permissionType,
        size: "medium"
    }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c04ej.CommentRenderer), {
        adf: adf
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQJV7.CommentActions), {
        permissions: commentData?.permissions,
        isReply: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.ReplyListContainer), {
        "data-testid": "reply-container"
    }, renderReplies()), canCreateComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.NewReplyContainer), {
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditorContainerSSR, {
        isReply: true,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "reply",
        userId: currentUserId,
        avatarUrl: currentUserAvatarUrl,
        displayName: currentUserDisplayName,
        date: when,
        permissionType: permissionType,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        disabled: true,
        placeholder: formatMessage((0, $9CnRS.i18n).replyPlaceholder),
        "aria-label": formatMessage((0, $9CnRS.i18n).replyPlaceholder)
    })))), undefined);
    return null;
};
module.exports["FocusedInlineComment"] = $d9a6205ec51ab13a$export$7afb8d400fcdf579;

});

parcelRegister("f8HSn", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $fs6LW = parcelRequire("fs6LW");


var $gvWVt = parcelRequire("gvWVt");


var $1YXTQ = parcelRequire("1YXTQ");


var $7tI6B = parcelRequire("7tI6B");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$DateContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0aFT5v1qpb _3TGfC9LRg7 _3iDTPbQ4SZ _0hPCNLDIqT _2nAzZY7NXe _3RsaIWDqSm _0wo9inYbGa _4iwgQuue9s _446nnCjOvk _2lNPC8ue9s _0C6zJvue9s _38OER1ue9s",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$var$AuthorContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _22oNuexTF4 _2yDaurOiJt _4spS4gp3yX _3hQzY9X0uO _1jiWpAxTF4 _29j1ZvOiJt _14UqCFp3yX _0ojMq8X0uO _3SAfpPX0uO",
            __cmplp.commentMode !== 'reply' ? "_2XsHFMLl21" : "_2XsHFMOLYo",
            __cmplp.commentMode === 'view' && "_1wydGW2ADO",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$AvatarWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1Znuxb2ADO",
            __cmplp.commentMode === 'view' && "_0jFU0VcGqM",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$ProfileLinkContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _2T6Qwz7NXe _0Q3GESdnbC _4eIIqhdnbC _0Hw68KdnbC _2c53ZwdnbC _0dd3JMYbGa _2G5wyoue9s _44YFBHjOvk _300gQyZpcK _3jmJJAZpcK _3sSsf9ZpcK _2kTPupxTF4 _0uh2fEOiJt _38Fkkxp3yX _2je84wX0uO _2nvP5bxTF4 _25zaNoOiJt _0BkunOp3yX _1ntv0BX0uO _2XmlcKq7kh _4iwgQuX0uO",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$LozengeWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2Zuz6Q2ADO _1RrJLiBwqQ",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, displayName: displayName, avatarUrl: avatarUrl, permissionType: permissionType, size: size })=>{
    const isDateShown = commentMode === 'view' && date;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$AuthorContainer, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$AvatarWrapper, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl,
        size: size,
        trigger: "click",
        name: displayName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$ProfileLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, displayName), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$DateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
        date: date
    })))));
};
module.exports["CommentAuthor"] = $b0598b16360d1677$export$d05a2f5fbf67a6d7;

});

parcelRegister("qYtBT", function(module, exports) {
/* CommentHeader.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $l3wuH = parcelRequire("l3wuH");


var $6TaGl = parcelRequire("6TaGl");


var $7N1sB = parcelRequire("7N1sB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9359cd91b07ea16f$var$SidebarHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEadeX _1mT5xdRAKS _3iDTPbQ4SZ _0jFU0VfFOW _0Of8r28HPE _3w3L6SfmT7 _2b10MqKxmn _0MaIcWSPN1 _2umo1wSPN1 _1F9kkuIZbP _41HqaF8HPE _0YELLt1Y8M _2DyqaeUWqv",
            __cmplp.className
        ])
    });
});
const $9359cd91b07ea16f$export$af4e8b81cdb5570a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9359cd91b07ea16f$var$SidebarHeader, {
        "data-testid": "inline-comment-ssr-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7N1sB.CommentNavigation), {
        goToNextInlineComment: ()=>{},
        goToPrevInlineComment: ()=>{}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "overflow-menu-icon",
        color: "var(--ds-icon-disabled, #080F214A)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "close-icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: "close-icon",
        color: `${"var(--ds-icon-disabled, #080F214A)"}`,
        spacing: "none"
    })));
};
module.exports["CommentHeader"] = $9359cd91b07ea16f$export$af4e8b81cdb5570a;

});

parcelRegister("dQJV7", function(module, exports) {
/* CommentActions.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $bFPHx = parcelRequire("bFPHx");


var $666Tc = parcelRequire("666Tc");


var $9CnRS = parcelRequire("9CnRS");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6040be4eb93366f$var$ActionsContainerSSR = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.ActionsContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4kiQYAfFOW _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionItem = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0aFT5v1qpb _3TGfC9LRg7 _3iDTPbccYA _1UtDYzKGUX _3138421Y8M _2ed5MiiZR3 _2EaR2a7dHp _04CNNZAEMG _0XEZqI7NXe _0sfB8dz9WS _0gKGieGaer _45Fm8l0dzo _0Ya3911Y8M _4m1FceSsSj _0y3UDVbQDk _1z9enHKGUX _0RxVZVKGUX",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionButton = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fYbGa _30huDKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2xIroY98eZ _497WNwOLYo _2zndICT6kp _1UtDYzOLYo _4ya3eEOLYo _0wOv4Q7zJH",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$export$e75a036919cd8d68 = ({ isReply: isReply, permissions: permissions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionsContainerSSR, null, permissions.isResolvable && !isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).resolve))), permissions.isEditable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).edit))), permissions.isRemovable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).delete))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), null)));
module.exports["CommentActions"] = $e6040be4eb93366f$export$e75a036919cd8d68;

});

parcelRegister("c04ej", function(module, exports) {
/* CommentRenderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $bzqa9 = parcelRequire("bzqa9");


var $hEeUR = parcelRequire("hEeUR");


var $6mKj3 = parcelRequire("6mKj3");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61a27fe9845a1cb4$var$CommentRendererContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0Of8r28HPE _1wydGW8HPE",
            __cmplp.className
        ])
    });
});
const $61a27fe9845a1cb4$export$ce6d3ea87eba7794 = ({ adf: adf })=>{
    const eventHandlers = (0, $bzqa9.useEventHandlers)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($61a27fe9845a1cb4$var$CommentRendererContainer, {
        id: "ssr-comment-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEeUR.ADFRenderer), {
        document: adf,
        appearance: "comment",
        eventHandlers: eventHandlers,
        ...(0, $6mKj3.expValEquals)('confluence_comments_media_ssr_support', 'isEnabled', true) && {
            media: undefined
        }
    }));
};
module.exports["CommentRenderer"] = $61a27fe9845a1cb4$export$ce6d3ea87eba7794;

});

parcelRegister("beAZw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $rVJpV = parcelRequire("rVJpV");


var $666Tc = parcelRequire("666Tc");

const $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80 = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'] && Array.isArray(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'])) return Boolean(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'].length);
    return false;
};
const $c9d0ea73f4f989e9$export$e90f33bd7f6da077 = ({ offset: offset = 0 })=>{
    /* For SSR check window object or use offset if passed */ // Previously, clicking on a comment via the inline comment button would still generate an offset.
    // That meant that on transitions, the loading skeleton would still flicker, so we check for window.__SSR_RENDERED__ as well
    /// to prevent the flicker on transitions.
    const sideBarOffset = window.__SSR_RENDERED__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] || offset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.LoadingSkeletonContainer), {
        id: "inline-comment-sidebar-skeleton",
        "data-testid": "inline-comment-sidebar-skeleton",
        showSkeleton: $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80() || Boolean(offset),
        offset: sideBarOffset,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $rVJpV.LoadingSkeletonChildren), null));
};
module.exports["InlineCommentsLoadingSkeleton"] = $c9d0ea73f4f989e9$export$e90f33bd7f6da077;

});

parcelRegister("rVJpV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lfoFx = parcelRequire("lfoFx");


var $l3wuH = parcelRequire("l3wuH");


var $6TaGl = parcelRequire("6TaGl");


var $666Tc = parcelRequire("666Tc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SkeletonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYE5zaO _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonRow = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { flex: flex, useColumnDirection: useColumnDirection, marginTop: marginTop, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_flb7sw": (0, $9aYkv.default)(__cmplp.flex),
                "--_11vu6jx": (0, $9aYkv.default)(__cmplp.marginTop, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _313842nyBQ",
                __cmplp.flex ? "_1ma2CfoML7" : "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
                __cmplp.useColumnDirection ? "_0aFT5vbt8w" : "_0aFT5v1qpb",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$CommentAuthorSkeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _0jFU0VUofl _39xV02Uofl _0KLXruGsB2",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonLine = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_iz5w78": (0, $9aYkv.default)(__cmplp.marginBottom, "px"),
                "--_10ib6lf": (0, $9aYkv.default)(__cmplp.height, "px"),
                "--_1gljcou": (0, $9aYkv.default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_0bjKvD4Y4b _0KLXruGsB2 _39xV027Ovj",
                typeof __cmplp.marginBottom === "number" ? "_1DCdHipKMF" : "_1DCdHi2AF2",
                __cmplp.height ? "_0jFU0VQtZt" : "_0jFU0VJg58",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3138422ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SidebarHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEWlT4 _1mT5xdRAKS _3iDTPbQ4SZ _37wbyuI7V3 _0jFU0VfFOW",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$CloseButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.InlineHeaderButton) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMyrFs _0jFU0VoWWg _39xV02oWWg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$NavContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.NavigationContainer) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$4857ba7068d0bed8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC _1DCdHidnbC _1mT5xdRAKS _0KLXrulfZc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$a42ae5e40534ea56 = ()=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 30,
            height: 8,
            marginBottom: 0
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SidebarHeader, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CloseButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: ""
            })
        })));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentAuthorSkeleton, null));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$export$4857ba7068d0bed8, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 5,
            marginTop: 5,
            useColumnDirection: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 81
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 53,
            height: 6
        })))));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t3, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium",
            interactionName: "inline-comments-loading-skeleton"
        })));
        $[6] = t6;
    } else t6 = $[6];
    return t6;
};
module.exports["LoadingSkeletonChildren"] = $f5ae94c9feb318d8$export$a42ae5e40534ea56;

});

parcelRegister("VXY8c", function(module, exports) {

let $0ae3d78d58c06b0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0ae3d78d58c06b0b$var$load("gBfQ7"),
    $0ae3d78d58c06b0b$var$load("eTvQu"),
    $0ae3d78d58c06b0b$var$load("g81ly"),
    $0ae3d78d58c06b0b$var$load("e3LAK"),
    $0ae3d78d58c06b0b$var$load("6wr18"),
    $0ae3d78d58c06b0b$var$load("lK9vp"),
    $0ae3d78d58c06b0b$var$load("dfVz8"),
    $0ae3d78d58c06b0b$var$load("8Q1q0"),
    $0ae3d78d58c06b0b$var$load("byAMe"),
    $0ae3d78d58c06b0b$var$load("cKqFC"),
    $0ae3d78d58c06b0b$var$load("Wowvf"),
    $0ae3d78d58c06b0b$var$load("4W6oq"),
    $0ae3d78d58c06b0b$var$load("jqoep"),
    $0ae3d78d58c06b0b$var$load("7EorR"),
    $0ae3d78d58c06b0b$var$load("eUsnQ"),
    $0ae3d78d58c06b0b$var$load("ffEVr"),
    $0ae3d78d58c06b0b$var$load("eLfJM"),
    $0ae3d78d58c06b0b$var$load("ei0GF"),
    $0ae3d78d58c06b0b$var$load("79Tk4"),
    $0ae3d78d58c06b0b$var$load("1R82J"),
    $0ae3d78d58c06b0b$var$load("9YbM1"),
    $0ae3d78d58c06b0b$var$load("1PFZq")
]).then(()=>parcelRequire('31yzi'));

});

parcelRegister("3s9yq", function(module, exports) {

var $4gWyR = parcelRequire("4gWyR");

const $dc6096cce6b3b96b$export$8c4bf31cea6aa53c = (0, $4gWyR.default);
module.exports["InlineCommentsQuery"] = $dc6096cce6b3b96b$export$8c4bf31cea6aa53c;

});

parcelRegister("4gWyR", function(module, exports) {
/**
 * @generated SignedSource<<3bfeca0bb9e902eac5c5f7e4df1177b1>>
 * @relayHash b1e02ca7b094a1ff9aaf5a6b5ddc5a29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ca55d271207d138fc62881aa0d6c6f83af1c22e78c15115c42f10e48b73f506
const $ed32661450888f95$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v4 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "pageId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v3 /*: any*/ 
                        ]
                    },
                    v3 /*: any*/ 
                ]
            }
        ]
    }, v5 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v18 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "ScalarField",
        "name": "when"
    }, v23 = {
        "kind": "ScalarField",
        "name": "number"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v25 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v28 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v30 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v2 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v31 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v29 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v32 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsQuery",
            "selections": [
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v24 /*: any*/ ,
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsQuery",
            "selections": [
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v30 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b1e02ca7b094a1ff9aaf5a6b5ddc5a29",
            "id": "9ca55d271207d138fc62881aa0d6c6f83af1c22e78c15115c42f10e48b73f506",
            "metadata": {},
            "name": "InlineCommentsQuery",
            "operationKind": "query",
            "text": "query InlineCommentsQuery($pageId:ID!)@allowHigherTimeout{content(id:$pageId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:1000){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}}}"
        }
    };
}();
$ed32661450888f95$var$node.hash = "82d41657ba53df28146f886f7478ca62";
var $ed32661450888f95$export$2e2bcd8739ae039 = $ed32661450888f95$var$node;
module.exports["default"] = $ed32661450888f95$export$2e2bcd8739ae039;

});

parcelRegister("aXika", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $fGzMp = parcelRequire("fGzMp");


var $aJPUt = parcelRequire("aJPUt");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");


var $4zbo1 = parcelRequire("4zbo1");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");

var $3qGQ7 = parcelRequire("3qGQ7");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $9Q3jD = parcelRequire("9Q3jD");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $1NBp8 = parcelRequire("1NBp8");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $isEtk = parcelRequire("isEtk");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $bQm3c = parcelRequire("bQm3c");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $essql = parcelRequire("essql");


var $gsWjA = parcelRequire("gsWjA");


var $2aFNh = parcelRequire("2aFNh");


var $iuaOs = parcelRequire("iuaOs");

const $50e9068f0df1c4d8$var$pageMap = {
    SPACE_OVERVIEW: {
        route: (0, $1NBp8.SPACE_OVERVIEW),
        errorAttribution: 'next-space-overview',
        name: (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE),
        isContentView: false
    },
    COMPANY_HUB: {
        route: (0, $1NBp8.COMPANY_HUB),
        errorAttribution: 'next-company-hub',
        name: (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE),
        isContentView: false
    },
    page: {
        route: (0, $1NBp8.VIEW_PAGE),
        errorAttribution: 'next-view-page',
        name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
        isContentView: true
    }
};
const $50e9068f0df1c4d8$export$2fe638b9bbc723fb = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, spaceKey: spaceKey, children: children, stickyHeader: stickyHeader, contentScreenStyles: contentScreenStyles, isContainerContentView: isContainerContentView = true, versionOverride: versionOverride = null, customPerfData: customPerfData, isEmbeddedPage: isEmbeddedPage })=>{
    const { setCurrentDocumentVersion: setCurrentDocumentVersion, setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const [{ routeName: routeName = '', contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { edition: edition, userId: userId } = (0, $bQm3c.useSessionData)();
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    (0, $essql.useUnreadCommentsSetup)({
        pageId: contentId,
        pageContentTypeProps: {
            pageMode: 'view'
        }
    });
    const extractDataAndSetPublishedVersion = (0, $cozmU.useCallback)(({ refetchContentQueryResult: refetchContentQueryResult })=>{
        const { data: data } = refetchContentQueryResult;
        if (data) {
            const versionNumber = data.content?.nodes?.[0]?.version?.number;
            if (versionNumber !== undefined && versionNumber !== null) setPublishedDocumentVersion(versionNumber);
        }
    }, [
        setPublishedDocumentVersion
    ]);
    const isBlogpost = contentType === 'blogpost';
    const skipContentQuery = !contentId || !spaceKey;
    const pageContentQueryVariables = {
        ...(0, $3qGQ7.createContentUnifiedQueryVariables)({
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            // confluence-feature-gating/inline-usage: expValEquals must be inlined
            agentSessionsUserId: !!userId && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? userId : undefined,
            includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
            includeBylineContributors: (0, $9wGTI.fg)('confluence_vp_title_byline_frag_dedup'),
            includeMetadata: (0, $9wGTI.fg)('confluence_vp_meta_frag_reader'),
            includeReactions: (0, $9wGTI.fg)('confluence_vp_reactions_frag_reader')
        }),
        ...(0, $9wGTI.fg)('confluence_vp_mode_frag_reader') ? {
            useContentModeFragment: true
        } : {}
    };
    const blogContentQueryVariables = {
        ...(0, $3qGQ7.createContentBlogUnifiedQueryVariables)({
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
            includeBylineContributors: (0, $9wGTI.fg)('confluence_vp_title_byline_frag_dedup'),
            includeMetadata: (0, $9wGTI.fg)('confluence_vp_meta_frag_reader'),
            includeReactions: (0, $9wGTI.fg)('confluence_vp_reactions_frag_reader')
        }),
        ...(0, $9wGTI.fg)('confluence_vp_mode_frag_reader') ? {
            useContentModeFragment: true
        } : {}
    };
    const pageContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $jgc4t.default), {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: skipContentQuery || isBlogpost,
        variables: pageContentQueryVariables,
        __callerPackage__: "view-page-common"
    });
    const blogContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $f9opb.default), {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: skipContentQuery || !isBlogpost,
        variables: blogContentQueryVariables,
        __callerPackage__: "view-page-common"
    });
    const contentQueryResult = isBlogpost ? blogContentQueryResult : pageContentQueryResult;
    const { route: route, errorAttribution: errorAttribution, name: name, isContentView: isContentView } = $50e9068f0df1c4d8$var$pageMap[routeName] ?? $50e9068f0df1c4d8$var$pageMap['page'];
    const contentQueryVariables = isBlogpost ? blogContentQueryVariables : pageContentQueryVariables;
    const { refetch: refetch } = contentQueryResult;
    (0, $2aFNh.useContentExtensionMetrics)(contentQueryResult?.data?.content?.nodes?.[0]?.body?.dynamic?.value, customPerfData);
    (0, $cozmU.useEffect)(()=>{
        // If navigating to a different page, always assume document is up to date.
        // Added for COMMENTS-5327, so when user jumps from an outdated page to another
        // up-to-date page, we won't disable the comment button due to outdated-ness.
        // Caveat: The destination page may not actually be up-to-date, e.g. if the
        // page content was loaded from cache that's saved from the user's previous
        // visit in the same browser tab, and a new version was published since then.
        // Invoking `setDocumentNeedsUpdate(false)` here means `documentNeedsUpdate`
        // may be `false` when page is actually outdated, but this scenario can already
        // occur before this change. COMMENTS-5816 tracks fixing this scenario altogether.
        if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // With confluence_fe_disable_comment_if_page_outdated_v2 ON,
        // `documentNeedsUpdate` is set to true whenever we set a new
        // `publishedDocumentVersion` IF it's different from `currentDocumentVersion`.
        // This useEffect can be cleaned up after v2 is fully rolled out.
        setDocumentNeedsUpdate(false);
    }, [
        contentId,
        setDocumentNeedsUpdate
    ]);
    // Use this instead of `contentQueryResult.data?.content?.nodes?.[0]?.version?.number`
    // because that field is fetched by other queries too, and thus may become mismatched
    // with the actual version of `body` in GQL cache.
    const contentVersion = contentQueryResult.data?.content?.nodes?.[0]?.body?.dynamic?.content?.version?.number;
    (0, $cozmU.useEffect)(()=>{
        if (contentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) setCurrentDocumentVersion(contentVersion);
    }, [
        contentVersion,
        setCurrentDocumentVersion
    ]);
    const reload = (0, $cozmU.useCallback)(async ()=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
            attributes: {
                contentType: (0, $8Ss4E.routeNameToContentTypeMap)[routeName],
                contentId: contentId,
                isSpaceOverviewNextRendered: true,
                edition: edition,
                quickReload: true //tell exp metrics error came from reload and not primary experience
            }
        });
        try {
            const refetchContentQueryResult = await refetch(contentQueryVariables);
            extractDataAndSetPublishedVersion({
                refetchContentQueryResult: refetchContentQueryResult
            });
        } catch (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                (0, $fGzMp.getExperienceTracker)().abort({
                    name: name,
                    reason: 'Expected Apollo error'
                });
                return; //if it's an expected GQL failure don't throw or fail the experience
            }
            (0, $fGzMp.stopExperienceOnError)(name, error);
            throw error; //this successfully avoids the success below
        }
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: name
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        refetch,
        contentId
    ]);
    const content = contentQueryResult.data?.content?.nodes?.[0];
    const fabricEditorSupported = contentQueryResult.loading ? null : content?.metadata?.frontend?.fabricEditorSupported ?? null;
    const bodyRepresentation = contentQueryResult.loading ? null : content?.body?.dynamic?.representation ?? null;
    (0, $iuaOs.useContentReloadOnFabricSupportChange)({
        contentId: contentId,
        fabricEditorSupported: fabricEditorSupported,
        bodyRepresentation: bodyRepresentation,
        reload: reload
    });
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'content',
        types: [
            (0, $c0urc.ReloadType).content,
            (0, $c0urc.ReloadType).comment
        ],
        reload: reload
    });
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'commentsDataManager',
        types: [
            (0, $c0urc.ReloadType).comment
        ],
        reload: async ()=>{
            await (0, $4L9ve.getProcessedCommentsDataState)().refetch?.();
        },
        priority: (0, $c0urc.ReloadPriority).background
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        key: contentId,
        metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
        contentId: contentId,
        mode: (0, $5kjCz.RENDERER),
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q3jD.PagePrerequisites), {
        route: route,
        contentQueryResult: contentQueryResult,
        versionOverride: versionOverride
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $isEtk.ContentStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zbo1.ContentContainer), {
        fetchTheme: true,
        contentThemeSpaceData: contentQueryResult.data ? contentQueryResult.data.space ?? null : undefined,
        contentId: contentId,
        spaceKey: spaceKey,
        key: "content-screen",
        errorAttribution: errorAttribution,
        isScreenContentView: isContentView,
        isContainerContentView: isContainerContentView,
        contentScreenStyles: contentScreenStyles,
        stickyHeader: stickyHeader,
        versionOverride: versionOverride,
        isEmbeddedPage: isEmbeddedPage
    }, ({ isThemed: isThemed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("article", null, children && children({
            isThemed: isThemed,
            contentQueryData: contentQueryResult.data,
            contentQueryError: contentQueryResult.error,
            contentQueryRefetch: reload
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC),
            customData: {
                isThemed: isThemed
            }
        }))))));
});
module.exports["ViewPageContainer"] = $50e9068f0df1c4d8$export$2fe638b9bbc723fb;

});

parcelRegister("4zbo1", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $jMyy4 = parcelRequire("jMyy4");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");


var $3jwuS = parcelRequire("3jwuS");


var $bEdUx = parcelRequire("bEdUx");


var $aWwYt = parcelRequire("aWwYt");


var $6KaG6 = parcelRequire("6KaG6");


var $5Myco = parcelRequire("5Myco");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $dPJCf = parcelRequire("dPJCf");


var $1vpkQ = parcelRequire("1vpkQ");


var $jln20 = parcelRequire("jln20");


var $3YWj2 = parcelRequire("3YWj2");


var $9Gxdl = parcelRequire("9Gxdl");


var $VPepg = parcelRequire("VPepg");

const $699adfe23402337d$var$EMPTY_CONTENT_SCREEN_STYLES = {};
const $699adfe23402337d$var$EMPTY_LOOK_AND_FEEL = {};
const $699adfe23402337d$var$useContentRecommendationParam = (0, $dPJCf.createSingleQueryParamHook)('contentRecommendation');
const $699adfe23402337d$var$contentWrapperStyles = null;
const $699adfe23402337d$var$ContentContainerThemeRenderer = (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { children: children, spaceKey: spaceKey, errorAttribution: errorAttribution, contentScreenStyles: t1, stickyHeader: t2, isEmbeddedPage: isEmbeddedPage, isScreenContentView: isScreenContentView, isContainerContentView: isContainerContentView, isLivePage: isLivePage, isObjectSidebarShown: isObjectSidebarShown, pageMode: pageMode, behavior: behavior, shouldAddBannerPadding: shouldAddBannerPadding, themeData: themeData, loading: loading, error: error } = t0;
    const contentScreenStyles = t1 === undefined ? $699adfe23402337d$var$EMPTY_CONTENT_SCREEN_STYLES : t1;
    const stickyHeader = t2 === undefined ? null : t2;
    if (error) {
        const t3 = children;
        let t4;
        if ($[0] !== error) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[0] = error;
            $[1] = t4;
        } else t4 = $[1];
        let t5;
        if ($[2] !== errorAttribution || $[3] !== t3 || $[4] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: errorAttribution
            }, t3, t4);
            $[2] = errorAttribution;
            $[3] = t3;
            $[4] = t4;
            $[5] = t5;
        } else t5 = $[5];
        return t5;
    }
    const theme = Boolean(themeData?.theme);
    const lookAndFeel = themeData?.lookAndFeel || $699adfe23402337d$var$EMPTY_LOOK_AND_FEEL;
    let t3;
    if ($[6] !== children || $[7] !== loading || $[8] !== theme) {
        t3 = typeof children === "function" ? children({
            isThemed: theme,
            isLoading: loading
        }) : children;
        $[6] = children;
        $[7] = loading;
        $[8] = theme;
        $[9] = t3;
    } else t3 = $[9];
    const childrenToRender = t3;
    const t4 = !theme && stickyHeader ? stickyHeader : null;
    const t5 = shouldAddBannerPadding ? 12 : 0;
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_2O5VijiZR3 _3YEZNO7dHp _1bHrqEAEMG _3iDTPbvLZJ _39xV02N91d"
        ]);
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== childrenToRender || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t6
        }, childrenToRender);
        $[11] = childrenToRender;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== behavior || $[15] !== isObjectSidebarShown || $[16] !== pageMode) {
        t8 = !(0, $9wGTI.fg)("ads-panel-system-confluence-object-sidebar") && isObjectSidebarShown && pageMode === (0, $cD1qu.PageMode).VIEW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, behavior === "push" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Myco.ObjectSidebarPushPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6KaG6.ObjectSidebarPanel), {
            ignoreGap: true
        }));
        $[14] = behavior;
        $[15] = isObjectSidebarShown;
        $[16] = pageMode;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== t7 || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t7, t8);
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== isContainerContentView || $[22] !== isLivePage || $[23] !== loading || $[24] !== lookAndFeel || $[25] !== t5 || $[26] !== t9 || $[27] !== theme) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Gxdl.ContentContainerComponent), {
            isThemed: theme,
            lookAndFeel: lookAndFeel,
            isContentView: isContainerContentView,
            isLoading: loading,
            isLivePage: isLivePage,
            additionalPaddingTop: t5
        }, t9);
        $[21] = isContainerContentView;
        $[22] = isLivePage;
        $[23] = loading;
        $[24] = lookAndFeel;
        $[25] = t5;
        $[26] = t9;
        $[27] = theme;
        $[28] = t10;
    } else t10 = $[28];
    let t11;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bEdUx.HighlightActionsProviderForNav4), null);
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== contentScreenStyles || $[31] !== isEmbeddedPage || $[32] !== isLivePage || $[33] !== isScreenContentView || $[34] !== loading || $[35] !== lookAndFeel || $[36] !== spaceKey || $[37] !== t10 || $[38] !== t4 || $[39] !== theme) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3YWj2.ContentScreenComponent), {
            spaceKey: spaceKey,
            isThemed: theme,
            isLoading: loading,
            lookAndFeel: lookAndFeel,
            isContentView: isScreenContentView,
            contentScreenStyles: contentScreenStyles,
            isLivePage: isLivePage,
            isEmbeddedPage: isEmbeddedPage
        }, t4, t10, t11);
        $[30] = contentScreenStyles;
        $[31] = isEmbeddedPage;
        $[32] = isLivePage;
        $[33] = isScreenContentView;
        $[34] = loading;
        $[35] = lookAndFeel;
        $[36] = spaceKey;
        $[37] = t10;
        $[38] = t4;
        $[39] = theme;
        $[40] = t12;
    } else t12 = $[40];
    let t13;
    if ($[41] !== errorAttribution || $[42] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: errorAttribution
        }, t12);
        $[41] = errorAttribution;
        $[42] = t12;
        $[43] = t13;
    } else t13 = $[43];
    return t13;
};
const $699adfe23402337d$var$ContentContainerWithThemeFragment = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let contentThemeSpaceData;
    let props;
    if ($[0] !== t0) {
        ({ contentThemeSpaceData: contentThemeSpaceData, ...props } = t0);
        $[0] = t0;
        $[1] = contentThemeSpaceData;
        $[2] = props;
    } else {
        contentThemeSpaceData = $[1];
        props = $[2];
    }
    const themeData = (0, $6SsN4.useFragment)((0, $VPepg.ContentContainerThemeFragment), contentThemeSpaceData);
    let t1;
    if ($[3] !== props || $[4] !== themeData) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($699adfe23402337d$var$ContentContainerThemeRenderer, {
            ...props,
            themeData: themeData,
            loading: false
        });
        $[3] = props;
        $[4] = themeData;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $699adfe23402337d$var$ContentContainerWithThemeQuery = (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    let contentId;
    let fetchTheme;
    let isBlogpost;
    let props;
    let spaceKey;
    let versionOverride;
    if ($[0] !== t0) {
        ({ contentId: contentId, spaceKey: spaceKey, versionOverride: versionOverride, isBlogpost: isBlogpost, fetchTheme: fetchTheme, ...props } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = fetchTheme;
        $[3] = isBlogpost;
        $[4] = props;
        $[5] = spaceKey;
        $[6] = versionOverride;
    } else {
        contentId = $[1];
        fetchTheme = $[2];
        isBlogpost = $[3];
        props = $[4];
        spaceKey = $[5];
        versionOverride = $[6];
    }
    const skipThemeQuery = !fetchTheme || !contentId;
    const isSSR = Boolean(window.__SSR_RENDERED__);
    let t1;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            single: true
        };
        $[7] = t1;
    } else t1 = $[7];
    const t2 = skipThemeQuery || isBlogpost;
    let t3;
    if ($[8] !== contentId || $[9] !== spaceKey || $[10] !== versionOverride) {
        t3 = {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            useNewContentTopper: true
        };
        $[8] = contentId;
        $[9] = spaceKey;
        $[10] = versionOverride;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== t2 || $[13] !== t3) {
        t4 = {
            context: t1,
            skip: t2,
            variables: t3
        };
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    const pageThemeQueryResult = (0, $jMyy4.useQueryInterop)((0, $jgc4t.default), {
        ...t4,
        __callerPackage__: "content-container"
    });
    let t5;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            single: true
        };
        $[15] = t5;
    } else t5 = $[15];
    const t6 = skipThemeQuery || !isBlogpost;
    let t7;
    if ($[16] !== contentId || $[17] !== spaceKey || $[18] !== versionOverride) {
        t7 = {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: versionOverride,
            useNewContentTopper: true
        };
        $[16] = contentId;
        $[17] = spaceKey;
        $[18] = versionOverride;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== t6 || $[21] !== t7) {
        t8 = {
            context: t5,
            skip: t6,
            variables: t7
        };
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
    } else t8 = $[22];
    const blogThemeQueryResult = (0, $jMyy4.useQueryInterop)((0, $f9opb.default), {
        ...t8,
        __callerPackage__: "content-container"
    });
    const queryResult = isBlogpost ? blogThemeQueryResult : pageThemeQueryResult;
    const t9 = queryResult.data?.space;
    let t10;
    if ($[23] !== props || $[24] !== queryResult.error || $[25] !== queryResult.loading || $[26] !== spaceKey || $[27] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($699adfe23402337d$var$ContentContainerThemeRenderer, {
            ...props,
            themeData: t9,
            loading: queryResult.loading,
            error: queryResult.error,
            spaceKey: spaceKey
        });
        $[23] = props;
        $[24] = queryResult.error;
        $[25] = queryResult.loading;
        $[26] = spaceKey;
        $[27] = t9;
        $[28] = t10;
    } else t10 = $[28];
    return t10;
};
const $699adfe23402337d$export$9d2b4227a95687cc = ({ contentId: contentId, fetchTheme: fetchTheme = false, children: children, isScreenContentView: isScreenContentView = false, isContainerContentView: isContainerContentView = false, spaceKey: spaceKey, errorAttribution: errorAttribution = (0, $3IBnw.Attribution).BACKBONE, contentScreenStyles: contentScreenStyles = $699adfe23402337d$var$EMPTY_CONTENT_SCREEN_STYLES, stickyHeader: stickyHeader = null, versionOverride: versionOverride = null, isEmbeddedPage: isEmbeddedPage, contentThemeSpaceData: contentThemeSpaceData })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const behavior = (0, $aWwYt.useBehavior)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const contentRecommendationParam = $699adfe23402337d$var$useContentRecommendationParam();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const isSidebarApprovalsPaneOpen = rightSidebarContext.getCurrent()?.panelId === (0, $1vpkQ.APPROVALS_PANE_ID) && pageMode === (0, $cD1qu.PageMode).VIEW;
    const approvalsPaneContextKey = (0, $1vpkQ.getApprovalsPaneContextKey)({
        contentId: contentId,
        contentStatus: (0, $1vpkQ.APPROVALS_PANE_CURRENT_CONTENT_STATUS)
    });
    const rightSidebarContextRef = (0, $cozmU.useRef)(rightSidebarContext);
    rightSidebarContextRef.current = rightSidebarContext;
    (0, $cozmU.useEffect)(()=>{
        hideObjectSidebar();
    }, [
        contentId,
        hideObjectSidebar
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $1vpkQ.syncApprovalsPaneContextOwnership)({
            isApprovalsExperimentEnabled: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen,
            contextKey: approvalsPaneContextKey,
            closeApprovalsPane: ()=>rightSidebarContextRef.current.close((0, $1vpkQ.APPROVALS_PANE_ID))
        });
    }, [
        approvalsPaneContextKey,
        isSidebarApprovalsPaneOpen
    ]);
    const isBlogpost = contentType === 'blogpost';
    const hasParentThemeData = contentThemeSpaceData !== undefined;
    const shouldAddBannerPadding = !isLivePage && contentRecommendationParam === 'on' && (0, $9wGTI.fg)('cc-engagement-nth-user-teammate-rollout-gate');
    const sharedProps = {
        children: children,
        spaceKey: spaceKey,
        errorAttribution: errorAttribution,
        contentScreenStyles: contentScreenStyles,
        stickyHeader: stickyHeader,
        isEmbeddedPage: isEmbeddedPage,
        isScreenContentView: isScreenContentView,
        isContainerContentView: isContainerContentView,
        isLivePage: isLivePage,
        isObjectSidebarShown: isObjectSidebarShown,
        pageMode: pageMode,
        behavior: behavior,
        shouldAddBannerPadding: shouldAddBannerPadding
    };
    if (hasParentThemeData && (0, $9wGTI.fg)('confluence_frontend_view_page_relay_fragment_dedup')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($699adfe23402337d$var$ContentContainerWithThemeFragment, {
        ...sharedProps,
        contentThemeSpaceData: contentThemeSpaceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($699adfe23402337d$var$ContentContainerWithThemeQuery, {
        ...sharedProps,
        contentId: contentId,
        spaceKey: spaceKey,
        versionOverride: versionOverride,
        isBlogpost: isBlogpost,
        fetchTheme: fetchTheme
    });
};
module.exports["ContentContainer"] = $699adfe23402337d$export$9d2b4227a95687cc;

});

parcelRegister("3YWj2", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kNIYN = parcelRequire("kNIYN");


var $hrAmX = parcelRequire("hrAmX");


var $3Klda = parcelRequire("3Klda");

const $7517944cc70514f3$export$af5427d1c079635b = {
    position: 'relative',
    background: "var(--ds-surface, #FFFFFF)",
    paddingTop: '0',
    paddingRight: "var(--ds-space-500, 40px)",
    paddingBottom: "var(--ds-space-250, 20px)",
    paddingLeft: "var(--ds-space-500, 40px)",
    minHeight: 'calc(100vh - 56px)',
    boxSizing: 'border-box',
    // added in for cover image
    '--full-cover-image-margin': '-40px',
    // should be the negative value of the padding of the container
    '--full-cover-image-width': 'calc(100% + 80px)' // should do calculations based on the padding of the container
};
const $7517944cc70514f3$export$ae92da2802c530ea = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0',
    display: 'none',
    bottom: '0',
    left: '0',
    right: '0',
    zIndex: '10',
    background: "var(--ds-skeleton, #0515240F)"
};
const $7517944cc70514f3$var$LIVE_PAGES_SCREEN_STYLES = {
    paddingTop: '0px',
    paddingRight: '0px',
    paddingBottom: '0px',
    paddingLeft: '0px',
    minHeight: 'unset',
    // added in for cover image
    '--full-cover-image-margin': '0px',
    // should be the negative value of the padding of the container
    '--full-cover-image-width': '100%' // should do calculations based on the padding of the container
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7517944cc70514f3$var$OverflowHiddenDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $7517944cc70514f3$var$PositionRelativeDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $7517944cc70514f3$var$DEFAULT_LOOK_AND_FEEL = {
    content: {
        screen: $7517944cc70514f3$export$af5427d1c079635b
    }
};
const $7517944cc70514f3$var$EMPTY_CONTENT_SCREEN_STYLES = {};
function $7517944cc70514f3$var$convertGutters(customScreenStyles) {
    if (customScreenStyles.gutterLeft === 'none') customScreenStyles.paddingLeft = '0';
    if (customScreenStyles.gutterRight === 'none') customScreenStyles.paddingRight = '0';
    if (customScreenStyles.gutterTop === '0px') customScreenStyles.paddingTop = '0';
    if (customScreenStyles.gutterBottom === '0px') customScreenStyles.paddingBottom = '0';
    return customScreenStyles;
}
function $7517944cc70514f3$var$getStylesFromLookAndFeel(lookAndFeel) {
    if (!lookAndFeel || !lookAndFeel.content) return {};
    const screenLookAndFeel = $7517944cc70514f3$var$convertGutters({
        ...lookAndFeel.content.screen
    });
    delete screenLookAndFeel.layer;
    return screenLookAndFeel;
}
function $7517944cc70514f3$var$adjustMinHeight(styles, bannerHeight, isEmbeddedPage) {
    const updatedStyles = {
        ...styles
    };
    // When in embedded confluence, override minHeight to 'auto' so the content area sizes to its actual content
    if (isEmbeddedPage) updatedStyles.minHeight = 'auto';
    else if (updatedStyles.minHeight === '100vh' && bannerHeight > 0) // Update the minHeight style only if a banner is being shown and the minHeight is "100vh" (aka full height)
    updatedStyles.minHeight = `calc(${updatedStyles.minHeight} - ${bannerHeight}px)`;
    return updatedStyles;
}
const $7517944cc70514f3$export$b578f5d8b8749ec2 = ({ spaceKey: spaceKey, children: children, lookAndFeel: lookAndFeel = $7517944cc70514f3$var$DEFAULT_LOOK_AND_FEEL, contentScreenStyles: // This prop contains react-css values to customize the default content screen styles according to the consumer's need.
contentScreenStyles = $7517944cc70514f3$var$EMPTY_CONTENT_SCREEN_STYLES, isThemed: isThemed = false, isContentView: isContentView = false, isLoading: isLoading = false, isLivePage: isLivePage = false, isEmbeddedPage: isEmbeddedPage = false })=>{
    const previousStyleState = (0, $cozmU.useRef)(null);
    const shouldApplyTheme = isThemed || isContentView;
    let styles;
    // 99.9% of time we should have lookAndFeel preloaded on SSR
    if (isLoading) {
        const previous = previousStyleState.current;
        // In transition since style in the same space should be the same
        // We can optimistically use the same style as the previous one
        if (spaceKey && spaceKey === previous?.spaceKey) styles = previous?.getStyles(isLivePage) || $7517944cc70514f3$export$ae92da2802c530ea;
        else styles = $7517944cc70514f3$export$ae92da2802c530ea;
    } else {
        const getStyles = shouldApplyTheme ? (live)=>({
                ...$7517944cc70514f3$export$af5427d1c079635b,
                ...live ? $7517944cc70514f3$var$LIVE_PAGES_SCREEN_STYLES : {},
                ...contentScreenStyles,
                ...$7517944cc70514f3$var$getStylesFromLookAndFeel(lookAndFeel)
            }) : ()=>({});
        previousStyleState.current = {
            getStyles: getStyles,
            spaceKey: spaceKey
        };
        styles = getStyles(isLivePage);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        const bannerHeight = bannerState.getTotalHeight();
        const updatedStyles = $7517944cc70514f3$var$adjustMinHeight(styles, bannerHeight, isEmbeddedPage);
        // styles came from a GraphQL result which will contain __typename
        delete updatedStyles.__typename;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "content-screen-component",
            className: "content-screen-component",
            style: updatedStyles
        }, shouldApplyTheme ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
            lookAndFeel: lookAndFeel
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7517944cc70514f3$var$PositionRelativeDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7517944cc70514f3$var$OverflowHiddenDiv, null), children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children));
    });
};
module.exports["ContentScreenComponent"] = $7517944cc70514f3$export$b578f5d8b8749ec2;

});

parcelRegister("3Klda", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");

const $2ba61f17a8768eba$var$screenLayerStyles = {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
    height: 250
};
class $2ba61f17a8768eba$export$e0e5b47f08900b58 extends (0, $cozmU.Component) {
    render() {
        const { lookAndFeel: lookAndFeel } = this.props;
        if (!lookAndFeel || !lookAndFeel.content) return null;
        const customScreenLayerStyles = lookAndFeel?.content?.screen?.layer || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "content-screen-background-layer",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                ...$2ba61f17a8768eba$var$screenLayerStyles,
                ...customScreenLayerStyles
            }
        });
    }
}
$2ba61f17a8768eba$export$e0e5b47f08900b58.propTypes = {
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object
};
module.exports["ContentScreenBackgroundLayer"] = $2ba61f17a8768eba$export$e0e5b47f08900b58;

});

parcelRegister("9Gxdl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $lTECB = parcelRequire("lTECB");


var $lJlG6 = parcelRequire("lJlG6");

// Both default styles are needed to properly apply `background-color` in resulting DOM when merged with look-and-feel
const $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES = {
    background: "var(--ds-surface, #FFFFFF)",
    backgroundColor: "var(--ds-surface, #FFFFFF)"
};
const $70d1ccf7a353c4c2$var$LOADING_SCREEN_STYLES = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0',
    display: 'none',
    bottom: '0',
    left: '0',
    right: '0',
    zIndex: '10',
    background: "var(--ds-skeleton, #0515240F)"
};
const $70d1ccf7a353c4c2$var$_convertVerticalGutterSize = (gutterValue)=>{
    switch(gutterValue){
        case 'small':
        case 'medium':
        case 'large':
        case 'default':
            return null;
        default:
            return gutterValue;
    }
};
const $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize = (gutterValue)=>{
    switch(gutterValue){
        case 'small':
            return 5;
        case 'medium':
            return 10;
        case 'large':
            return 15;
        case 'default':
            return null;
        case 'none':
        default:
            return 0;
    }
};
class $70d1ccf7a353c4c2$export$b5a05341299897cc extends (0, $cozmU.Component) {
    static _getContainerStyles(lookAndFeel, isThemed, isLivePage, additionalPaddingTop) {
        if (!lookAndFeel.content) return $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES;
        const { screen: screen, container: container } = lookAndFeel.content;
        const containerStyles = {
            ...$70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES,
            ...container
        };
        const { padding: padding } = containerStyles;
        let paddingTop = additionalPaddingTop || 0;
        // if page header is fixed, content will need to be pushed down so that the title of the page isn't covered (unless rendered via embedded-confluence)
        // themed spaces do not have fixed headers and do not need the styling
        if (!isThemed && !isLivePage && !(0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() && !(0, $lJlG6.isMobileApp_DO_NOT_USE)()) // add 46px padding since the object header height is 56px and with-sticky-header div above it has 10px height already
        paddingTop += 46;
        containerStyles.padding = `${paddingTop}px 0px 0px 0px`;
        if (isThemed && padding === '0') // if the theme doesn't have a padding, we should add a padding because otherwise comments overflow the container
        // see also: https://product-fabric.atlassian.net/wiki/spaces/~speachey/pages/3093430887/DEVHELP-6933
        containerStyles.padding = '20px';
        const { gutterTop: gutterTop, gutterBottom: gutterBottom } = screen;
        if (gutterTop) containerStyles.marginTop = $70d1ccf7a353c4c2$var$_convertVerticalGutterSize(screen.gutterTop);
        if (gutterBottom) containerStyles.marginBottom = $70d1ccf7a353c4c2$var$_convertVerticalGutterSize(screen.gutterBottom);
        const gutterRight = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterRight);
        const gutterLeft = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterLeft);
        if (gutterRight !== null) containerStyles.marginRight = `${gutterRight}%`;
        if (gutterLeft !== null) containerStyles.marginLeft = `${gutterLeft}%`;
        containerStyles.width = `${100 - gutterRight - gutterLeft}%`;
        containerStyles.boxSizing = 'border-box';
        containerStyles.display = 'flex';
        containerStyles.flexDirection = 'row';
        // container is from graphql result which will contain __typename
        delete containerStyles.__typename;
        return containerStyles;
    }
    static _getInlineCommentStyles(lookAndFeel) {
        if (!lookAndFeel.content) return null;
        const { screen: screen = {} } = lookAndFeel.content;
        const gutterRight = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterRight);
        if (gutterRight === 0) /**
       * When we have no gutterRight, we need to override the default ic-sidebar marging-right of -20px and make it 0
       *  so that it does not pull too far right.
       */ return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", null, '.ic-sidebar.ic-is-spa-view-page { margin-right: 0 !important; }'));
        return null;
    }
    getLoadingStyles() {
        const { isLoading: isLoading } = this.props;
        return isLoading ? $70d1ccf7a353c4c2$var$LOADING_SCREEN_STYLES : {};
    }
    render() {
        const { lookAndFeel: lookAndFeel, isThemed: isThemed, isContentView: isContentView, isLivePage: isLivePage, additionalPaddingTop: additionalPaddingTop } = this.props;
        const shouldApplyTheme = isThemed || isContentView;
        const containerStyles = shouldApplyTheme ? $70d1ccf7a353c4c2$export$b5a05341299897cc._getContainerStyles(lookAndFeel, isThemed, isLivePage, additionalPaddingTop) : this.getLoadingStyles();
        const inLineCommentStyles = shouldApplyTheme ? $70d1ccf7a353c4c2$export$b5a05341299897cc._getInlineCommentStyles(lookAndFeel) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "content-container-component",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.props.className,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: containerStyles
        }, inLineCommentStyles, this.props.children);
    }
}
$70d1ccf7a353c4c2$export$b5a05341299897cc.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).any,
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    isThemed: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    /**
   * In view page we apply default style regardless whether theme was enabled or not
   */ isContentView: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isLivePage: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    additionalPaddingTop: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number
};
$70d1ccf7a353c4c2$export$b5a05341299897cc.defaultProps = {
    isContentView: false,
    lookAndFeel: {
        content: {
            screen: $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES
        }
    },
    isLivePage: false
};
module.exports["ContentContainerComponent"] = $70d1ccf7a353c4c2$export$b5a05341299897cc;

});

parcelRegister("VPepg", function(module, exports) {

var $6rIhr = parcelRequire("6rIhr");

const $847592e36c5d5e9b$export$bc63ffaabbce08aa = (0, $6rIhr.default);
module.exports["ContentContainerThemeFragment"] = $847592e36c5d5e9b$export$bc63ffaabbce08aa;

});

parcelRegister("6rIhr", function(module, exports) {
/**
 * @generated SignedSource<<9ee77f54bb9332f4676335e626d51f90>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $da9651dac0078049$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "background"
    }, v1 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v2 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v3 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v4 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v5 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v6 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v7 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v8 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v9 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ContentContainerTheme_space",
        "selections": [
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ScreenLookAndFeel",
                                "kind": "LinkedField",
                                "name": "screen",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    v8 /*: any*/ ,
                                    v9 /*: any*/ ,
                                    {
                                        "concreteType": "LayerScreenLookAndFeel",
                                        "kind": "LinkedField",
                                        "name": "layer",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ ,
                                            v3 /*: any*/ ,
                                            v4 /*: any*/ ,
                                            v5 /*: any*/ ,
                                            v6 /*: any*/ ,
                                            v7 /*: any*/ ,
                                            v8 /*: any*/ ,
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "width"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "height"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterTop"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterRight"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterBottom"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterLeft"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    v8 /*: any*/ ,
                                    v9 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "padding"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "borderRadius"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Space"
    };
}();
$da9651dac0078049$var$node.hash = "bfa43eb9ba39936a810f3d392573282f";
var $da9651dac0078049$export$2e2bcd8739ae039 = $da9651dac0078049$var$node;
module.exports["default"] = $da9651dac0078049$export$2e2bcd8739ae039;

});

parcelRegister("9Q3jD", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4uSkp = parcelRequire("4uSkp");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $iPRuY = parcelRequire("iPRuY");

const $fb83eb4a10554029$export$69ad3f5eb9aa63a1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, contentQueryResult: contentQueryResult, route: route, versionOverride: versionOverride, status: status } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== experienceTracker) {
        t1 = (error)=>{
            const isTimeoutError = error?.toString().includes("SocketTimeoutException");
            if (isTimeoutError) experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                error: error
            });
            else experienceTracker.abort({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                reason: error.message
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        };
        $[0] = experienceTracker;
        $[1] = t1;
    } else t1 = $[1];
    const handleTimeoutError = t1;
    let t2;
    if ($[2] !== experienceTracker) {
        t2 = (error_0)=>{
            const isUserError = (0, $aMcHK.getStatusCodeError)(error_0)?.startsWith("4");
            if (isUserError) experienceTracker.abort({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                reason: error_0.message
            });
            else experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                error: error_0
            });
            (0, $7Sm4c.markErrorAsHandled)(error_0);
            throw error_0;
        };
        $[2] = experienceTracker;
        $[3] = t2;
    } else t2 = $[3];
    const handleUnexpectedError = t2;
    let t3;
    if ($[4] !== children || $[5] !== contentQueryResult || $[6] !== handleTimeoutError || $[7] !== handleUnexpectedError || $[8] !== route || $[9] !== status || $[10] !== versionOverride) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4uSkp.ViewPageGateway), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iPRuY.ContentPrerequisites), {
            route: route,
            contentQueryResult: contentQueryResult,
            versionOverride: versionOverride,
            handleUnexpectedError: handleUnexpectedError,
            handleTimeoutError: handleTimeoutError,
            status: status
        }, children));
        $[4] = children;
        $[5] = contentQueryResult;
        $[6] = handleTimeoutError;
        $[7] = handleUnexpectedError;
        $[8] = route;
        $[9] = status;
        $[10] = versionOverride;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ children: children, contentQueryResult: contentQueryResult, route: route, versionOverride: versionOverride, status: status })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const handleTimeoutError = (error)=>{
        const isTimeoutError = error?.toString().includes('SocketTimeoutException');
        if (isTimeoutError) experienceTracker.fail({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            error: error
        });
        else experienceTracker.abort({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            reason: error.message
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    };
    const handleUnexpectedError = (error_0)=>{
        const isUserError = (0, $aMcHK.getStatusCodeError)(error_0)?.startsWith('4');
        if (isUserError) experienceTracker.abort({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            reason: error_0.message
        });
        else experienceTracker.fail({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            error: error_0
        });
        (0, $7Sm4c.markErrorAsHandled)(error_0);
        throw error_0; // Throw to propagate to error boundary - otherwise just shows a blank screen
    };
    // When unauthorized and viewing a restricted page, user is prompted
    // with SuperAdmin gateway
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4uSkp.ViewPageGateway), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iPRuY.ContentPrerequisites), {
        route: route,
        contentQueryResult: contentQueryResult,
        versionOverride: versionOverride,
        handleUnexpectedError: handleUnexpectedError,
        handleTimeoutError: handleTimeoutError,
        status: status
    }, children));
};
module.exports["PagePrerequisites"] = $fb83eb4a10554029$export$69ad3f5eb9aa63a1;

});

parcelRegister("4uSkp", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $bavCP = parcelRequire("bavCP");


var $lLRfG = parcelRequire("lLRfG");


var $1uFM6 = parcelRequire("1uFM6");


var $9xNes = parcelRequire("9xNes");


var $f3euL = parcelRequire("f3euL");


var $ep3mz = parcelRequire("ep3mz");


var $2k9aV = parcelRequire("2k9aV");


var $c4ECQ = parcelRequire("c4ECQ");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $lfFzM = parcelRequire("lfFzM");


var $iPPFu = parcelRequire("iPPFu");

function $34641b344ae1099e$export$27cc57004471e91(hasDirectRestrictions, hasPageInheritedRestrictions, hasSpaceRestrictions) {
    // multiple restrictions = at least two.
    const hasMultipleRestrictions = hasDirectRestrictions ? hasPageInheritedRestrictions || hasSpaceRestrictions : hasPageInheritedRestrictions && hasSpaceRestrictions;
    if (hasMultipleRestrictions) return (0, $c4ECQ.RestrictionFrom).MULTIPLE;
    if (hasDirectRestrictions) return (0, $c4ECQ.RestrictionFrom).DIRECT;
    if (hasPageInheritedRestrictions) return (0, $c4ECQ.RestrictionFrom).PAGE_INHERITED;
    if (hasSpaceRestrictions) return (0, $c4ECQ.RestrictionFrom).SPACE;
    return (0, $c4ECQ.RestrictionFrom).NONE;
}
const $34641b344ae1099e$var$CUSTOM_ATTRIBUTES = {
    inaccessiblePageType: 'RESTRICTED_CONFIRMATION_PAGE'
};
class $34641b344ae1099e$export$92eba4cf4af6c314 extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        this.checkConsentToViewPage();
    }
    componentDidUpdate() {
        this.checkConsentToViewPage();
    }
    checkConsentToViewPage() {
        const localStorageValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED);
        if (!localStorageValue) {
            this.setState({
                restrictedPageViewConfirmed: false
            });
            return;
        }
        // Set the state if it matches so we can skip rendering the confirmation.
        if (String(localStorageValue) === this.props.contentId) this.setState({
            restrictedPageViewConfirmed: true
        });
        else {
            // This means the user is on a different page currently. Can safely
            // delete the entry now so we can render the confirmation again if the
            // former page is accessed again.
            (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED);
            this.setState({
                restrictedPageViewConfirmed: false
            });
        }
    }
    render() {
        const { children: children, contentId: contentId } = this.props;
        if (!contentId) // in this case children renders ContentPrerequisites which shows the appropriate 404 page
        return children;
        const { restrictedPageViewConfirmed: restrictedPageViewConfirmed } = this.state;
        if (restrictedPageViewConfirmed) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfFzM.AdminKeyQuery), null, ({ loading: loading, error: error, isSuperAdmin: isSuperAdmin })=>{
            if (loading) return null;
            if (error) throw error;
            if (!isSuperAdmin) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $iPPFu.ViewPageGatewayQuery),
                variables: {
                    contentId: contentId
                },
                fetchPolicy: "network-only",
                context: {
                    asSuperAdmin: false
                },
                __callerPackage__: "view-page-gateway"
            }, ({ loading: loading, error: error })=>{
                if (loading) return null;
                // render confirmation if the user is accessing a restricted
                // page and has not already confirmed viewing the page
                if (error && !restrictedPageViewConfirmed && (0, $1uFM6.isUnauthorizedError)(error)) return this.renderRestrictedPageConfirmation();
                return children;
            });
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            restrictedPageViewConfirmed: false
        };
        this.onRestrictedPageViewConfirmClick = ()=>{
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED, this.props.contentId);
            // Set the state regardles of localstorage setItem succeeding or not so we
            // can render the page.
            this.setState({
                restrictedPageViewConfirmed: true
            });
        };
        this.renderRestrictedPageConfirmation = ()=>{
            const { contentId: contentId, spaceKey: spaceKey } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2k9aV.RestrictionsCheck), {
                contentId: contentId,
                spaceKey: spaceKey
            }, ({ hasDirectViewRestrictions: hasDirectViewRestrictions, hasInheritedViewRestrictions: hasInheritedViewRestrictions, isSpaceRestricted: isSpaceRestricted, error: error })=>{
                if (error) throw error;
                const restrictionFromType = $34641b344ae1099e$export$27cc57004471e91(hasDirectViewRestrictions, hasInheritedViewRestrictions, isSpaceRestricted);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9xNes.RestrictedPageConfirmation), {
                    restrictionFromType: restrictionFromType,
                    onViewPageClick: this.onRestrictedPageViewConfirmClick
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
                    metric: (0, $f3euL.INACCESSIBLE_PAGE_LOAD),
                    customData: {
                        contentId: contentId,
                        ...$34641b344ae1099e$var$CUSTOM_ATTRIBUTES
                    }
                }));
            });
        };
    }
}
$34641b344ae1099e$export$92eba4cf4af6c314.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node.isRequired
};
const $34641b344ae1099e$export$35cf1eab48371b15 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ep3mz.PageSubscriber), null, (t2)=>{
            const { contentId: contentId, spaceKey: spaceKey } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34641b344ae1099e$export$92eba4cf4af6c314, {
                contentId: contentId,
                spaceKey: spaceKey
            }, children);
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
$34641b344ae1099e$export$35cf1eab48371b15.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node.isRequired
};
module.exports["ViewPageGateway"] = $34641b344ae1099e$export$35cf1eab48371b15;

});

parcelRegister("9xNes", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4667b31838ac7b2c$export$8c5f260af94a9e2e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tXIbI",
    name: "RestrictedPageConfirmation",
    loader: async ()=>(await (parcelRequire("fPQ3g"))).RestrictedPageConfirmation
});
module.exports["RestrictedPageConfirmation"] = $4667b31838ac7b2c$export$8c5f260af94a9e2e;

});

parcelRegister("fPQ3g", function(module, exports) {

let $b873fed1dab1bebc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b873fed1dab1bebc$var$load("37xVM").then(()=>parcelRequire('7NZoR'));

});

parcelRegister("2k9aV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $80NaV = parcelRequire("80NaV");


var $fG32j = parcelRequire("fG32j");

const $d8539e55a4f27a93$export$26883b91564da8f7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, spaceKey: spaceKey } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = (t2)=>{
            const { error: spaceRestrictionCheckError, isSpaceRestricted: isSpaceRestricted } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80NaV.PageViewRestrictions), null, (t3)=>{
                const { error: pageViewRestrictionsError, hasDirectViewRestrictions: hasDirectViewRestrictions, hasInheritedViewRestrictions: hasInheritedViewRestrictions } = t3;
                return children({
                    error: spaceRestrictionCheckError || pageViewRestrictionsError,
                    hasDirectViewRestrictions: hasDirectViewRestrictions,
                    hasInheritedViewRestrictions: hasInheritedViewRestrictions,
                    isSpaceRestricted: isSpaceRestricted
                });
            });
        };
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== spaceKey || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fG32j.SpaceRestrictionCheck), {
            asSuperAdmin: false,
            spaceKey: spaceKey
        }, t1);
        $[2] = spaceKey;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, spaceKey: spaceKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fG32j.SpaceRestrictionCheck), {
        asSuperAdmin: false,
        spaceKey: spaceKey
    }, ({ error: spaceRestrictionCheckError, isSpaceRestricted: isSpaceRestricted })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80NaV.PageViewRestrictions), null, ({ error: pageViewRestrictionsError, hasDirectViewRestrictions: hasDirectViewRestrictions, hasInheritedViewRestrictions: hasInheritedViewRestrictions })=>children({
                error: spaceRestrictionCheckError || pageViewRestrictionsError,
                hasDirectViewRestrictions: hasDirectViewRestrictions,
                hasInheritedViewRestrictions: hasInheritedViewRestrictions,
                isSpaceRestricted: isSpaceRestricted
            })));
module.exports["RestrictionsCheck"] = $d8539e55a4f27a93$export$26883b91564da8f7;

});

parcelRegister("80NaV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jLw6A = parcelRequire("jLw6A");

const $ac3796b23ede5ce7$export$6bf9ddef68460137 = (0, $3u0dr.isReactCompilerActiveV2)() ? function PageViewRestrictions(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const { restrictions: restrictions, error: error, loading: loading } = (0, $jLw6A.usePageRestrictionsContext)();
    const hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
    const hasInheritedViewRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
    if (loading) return null;
    let t1;
    if ($[0] !== children || $[1] !== error || $[2] !== hasDirectViewRestrictions || $[3] !== hasInheritedViewRestrictions) {
        t1 = children({
            error: error,
            hasDirectViewRestrictions: hasDirectViewRestrictions,
            hasInheritedViewRestrictions: hasInheritedViewRestrictions
        });
        $[0] = children;
        $[1] = error;
        $[2] = hasDirectViewRestrictions;
        $[3] = hasInheritedViewRestrictions;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : function PageViewRestrictions({ children: children }) {
    const { restrictions: restrictions, error: error, loading: loading } = (0, $jLw6A.usePageRestrictionsContext)();
    const hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
    const hasInheritedViewRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
    if (loading) return null;
    return children({
        error: error,
        hasDirectViewRestrictions: hasDirectViewRestrictions,
        hasInheritedViewRestrictions: hasInheritedViewRestrictions
    });
};
module.exports["PageViewRestrictions"] = $ac3796b23ede5ce7$export$6bf9ddef68460137;

});

parcelRegister("iPPFu", function(module, exports) {

var $4TFAM = parcelRequire("4TFAM");

parcelRequire("6SsN4");

const $db6511a61fa44cc3$export$aaf44510d6f97779 = (0, $4TFAM.default);
module.exports["ViewPageGatewayQuery"] = $db6511a61fa44cc3$export$aaf44510d6f97779;

});

parcelRegister("4TFAM", function(module, exports) {
/**
 * @generated SignedSource<<81653e42791a16b5c2fc1ce2c6d3fb97>>
 * @relayHash 1acb34527ccd100c0ace8e92cab69d27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57a50bcfa4464ca8772d815dabebd3afaae7a423dc8d57145cebe9e090f27da7
const $592a74ea097f12b6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ViewPageGatewayQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ViewPageGatewayQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1acb34527ccd100c0ace8e92cab69d27",
            "id": "57a50bcfa4464ca8772d815dabebd3afaae7a423dc8d57145cebe9e090f27da7",
            "metadata": {},
            "name": "ViewPageGatewayQuery",
            "operationKind": "query",
            "text": "query ViewPageGatewayQuery($contentId:ID){content(id:$contentId){nodes{id,status}}}"
        }
    };
}();
$592a74ea097f12b6$var$node.hash = "c438f21d4b5a7f5b4c6a8f3518f32689";
var $592a74ea097f12b6$export$2e2bcd8739ae039 = $592a74ea097f12b6$var$node;
module.exports["default"] = $592a74ea097f12b6$export$2e2bcd8739ae039;

});

parcelRegister("iPRuY", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9inwL = parcelRequire("9inwL");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $kE2cJ = parcelRequire("kE2cJ");


var $hpnxK = parcelRequire("hpnxK");


var $hNtOj = parcelRequire("hNtOj");


var $dPJCf = parcelRequire("dPJCf");


var $frfjk = parcelRequire("frfjk");


var $gMFJB = parcelRequire("gMFJB");


var $llOcx = parcelRequire("llOcx");


var $jH9vM = parcelRequire("jH9vM");


var $iElL7 = parcelRequire("iElL7");

const $eb18cf4dc4cf4350$var$useContentPrerequisites = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { spaceKey: spaceKey, contentId: contentId, contentQueryResult: contentQueryResult, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, status: status, skip: skip } = t0;
    const missingSpaceKey = !spaceKey;
    const missingContentId = !contentId;
    const missingContentSSR = undefined;
    const contentQueryResultCheck = (0, $9wGTI.fg)("use_content_query_result_data_error") ? contentQueryResult?.data || contentQueryResult?.error : contentQueryResult;
    const skipContentPrerequisites = skip || missingContentId || Boolean(contentQueryResultCheck) && !missingContentSSR;
    let t1;
    if ($[0] !== status) {
        t1 = status ? {
            status: status
        } : {};
        $[0] = status;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== contentId || $[3] !== missingSpaceKey || $[4] !== spaceKey || $[5] !== t1) {
        t2 = {
            contentId: contentId,
            missingSpaceKey: missingSpaceKey,
            spaceKey: spaceKey,
            ...t1
        };
        $[2] = contentId;
        $[3] = missingSpaceKey;
        $[4] = spaceKey;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== skipContentPrerequisites || $[8] !== t2) {
        t3 = {
            errorPolicy: "all",
            variables: t2,
            skip: skipContentPrerequisites
        };
        $[7] = skipContentPrerequisites;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    const contentPrerequisitesQueryResult = (0, $jMyy4.useQueryInterop)((0, $9inwL.default), {
        ...t3,
        __callerPackage__: "content-prerequisites"
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, error: error, loading: queryLoading } = skipContentPrerequisites ? contentQueryResult || {} : contentPrerequisitesQueryResult;
    const [t4] = (0, $ep3mz.usePageState)();
    const { contentIdLoading: contentIdLoading } = t4;
    const loading = queryLoading || contentIdLoading;
    if ((!data || missingContentId) && loading) {
        let t5;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                isLoading: true
            };
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    }
    const isEmptyContent = !loading && !error && data && !data?.content;
    const isTimeoutError = error?.toString().includes("SocketTimeoutException");
    if (error && (0, $1uFM6.isUnauthorizedError)(error) || isEmptyContent) {
        if (error) (0, $7Sm4c.markErrorAsHandled)(error);
        if (isEmptyContent && true) createAnalyticsEvent({
            type: "sendOperationalEvent",
            data: {
                source: "ContentPrerequisites",
                action: "returnedEmpty",
                actionSubject: "content",
                attributes: {
                    contentId: contentId,
                    skip: skip,
                    hadContentQueryData: Boolean(contentQueryResult?.data)
                }
            }
        }).fire();
        let t5;
        if ($[11] !== error) {
            t5 = {
                error: error,
                isRestricted: true
            };
            $[11] = error;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
    let t5;
    if ($[13] !== data?.content?.nodes) {
        t5 = data?.content?.nodes || [];
        $[13] = data?.content?.nodes;
        $[14] = t5;
    } else t5 = $[14];
    const content = t5;
    const shouldHandleErrors = !!error;
    if (missingContentId || content.length === 0 && !shouldHandleErrors || shouldHandleErrors && (0, $f9jv7.isNotFoundError)(error)) {
        let t6;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                isNotFound: true
            };
            $[15] = t6;
        } else t6 = $[15];
        return t6;
    }
    const expectedSpaceKey = content[0]?.space?.alias || content[0]?.space?.key;
    const wrongSpaceKeyOnSSR = undefined;
    let t6;
    if ($[16] !== error) {
        t6 = error && (0, $hpnxK.isNotFoundSpaceError)(error);
        $[16] = error;
        $[17] = t6;
    } else t6 = $[17];
    const notFoundSpaceError = t6;
    if (missingSpaceKey || wrongSpaceKeyOnSSR || notFoundSpaceError) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        const t7 = `CP-noSK:${missingSpaceKey}|wrongSK:${Boolean(wrongSpaceKeyOnSSR)}|noSpace:${Boolean(notFoundSpaceError)}`;
        let t8;
        if ($[18] !== expectedSpaceKey || $[19] !== t7) {
            t8 = {
                isRedirect: true,
                redirectSpaceKey: expectedSpaceKey,
                redirectReason: t7
            };
            $[18] = expectedSpaceKey;
            $[19] = t7;
            $[20] = t8;
        } else t8 = $[20];
        return t8;
    }
    if (error && handleTimeoutError && isTimeoutError) {
        handleTimeoutError(error);
        let t7;
        if ($[21] !== error) {
            t7 = {
                error: error,
                isTimeoutError: true
            };
            $[21] = error;
            $[22] = t7;
        } else t7 = $[22];
        return t7;
    }
    if (error && handleUnexpectedError) {
        handleUnexpectedError(error);
        let t7;
        if ($[23] !== error) {
            t7 = {
                error: error,
                isUnexpectedError: true
            };
            $[23] = error;
            $[24] = t7;
        } else t7 = $[24];
        return t7;
    }
    let t7;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {};
        $[25] = t7;
    } else t7 = $[25];
    return t7;
} : ({ spaceKey: spaceKey, contentId: contentId, contentQueryResult: contentQueryResult, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, status: status, skip: skip })=>{
    // Redirect legacy url which doesn't have spaceKey
    const missingSpaceKey = !spaceKey;
    const missingContentId = !contentId;
    // Content is considered missing when we attempted to use contentQueryResult but no data
    // is available due to known or unknown errors. This is only applicable for SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const missingContentSSR = undefined;
    // We need to check for "data" or "error" existence in contentQueryResult and not just the existence of contentQueryResult,
    // since this object is the query result from Apollo and it might be present but with no data or error such as { variables: fn, refetch: fn }
    const contentQueryResultCheck = (0, $9wGTI.fg)('use_content_query_result_data_error') ? contentQueryResult?.data || contentQueryResult?.error : contentQueryResult;
    const skipContentPrerequisites = skip || missingContentId || Boolean(contentQueryResultCheck) && !missingContentSSR;
    const contentPrerequisitesQueryResult = (0, $jMyy4.useQueryInterop)((0, $9inwL.default), {
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            missingSpaceKey: missingSpaceKey,
            spaceKey: spaceKey,
            ...status ? {
                status: status
            } : {}
        },
        skip: skipContentPrerequisites,
        __callerPackage__: "content-prerequisites"
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, error: error, loading: queryLoading } = skipContentPrerequisites ? contentQueryResult || {} : contentPrerequisitesQueryResult;
    const [{ contentIdLoading: contentIdLoading }] = (0, $ep3mz.usePageState)();
    const loading = queryLoading || contentIdLoading;
    if ((!data || missingContentId) && loading) return {
        isLoading: true
    };
    // Known Apollo bug: Errors are not saved within Apollo in-memory cache
    // https://github.com/apollographql/apollo-client/issues/4806. For restricted spaces and pages,
    // the 403 error is subsequently undefined after retrieval attempt. Restricted spaces means
    // content will be null, but the error might be undefined.
    const isEmptyContent = !loading && !error && data && !data?.content;
    const isTimeoutError = error?.toString().includes('SocketTimeoutException');
    if (error && (0, $1uFM6.isUnauthorizedError)(error) || isEmptyContent) {
        if (error) (0, $7Sm4c.markErrorAsHandled)(error);
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (isEmptyContent && true) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'ContentPrerequisites',
                action: 'returnedEmpty',
                actionSubject: 'content',
                attributes: {
                    contentId: contentId,
                    skip: skip,
                    hadContentQueryData: Boolean(contentQueryResult?.data)
                }
            }
        }).fire();
        return {
            error: error,
            isRestricted: true
        };
    }
    // Catch all for errors, no content and calls that return null/undefined
    // If FF is on, this catches Not Found errors (404) and other errors are handled below
    const content = data?.content?.nodes || [];
    const shouldHandleErrors = !!error;
    if (missingContentId || content.length === 0 && !shouldHandleErrors || shouldHandleErrors && (0, $f9jv7.isNotFoundError)(error)) return {
        isNotFound: true
    };
    const expectedSpaceKey = content[0]?.space?.alias || content[0]?.space?.key;
    // Checks for case where old / wrong spacekey is provided causing reload
    // on SSR -> SPA transition once the ContentRedirectQuery resolves.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const wrongSpaceKeyOnSSR = undefined;
    const notFoundSpaceError = error && (0, $hpnxK.isNotFoundSpaceError)(error);
    if (missingSpaceKey || wrongSpaceKeyOnSSR || notFoundSpaceError) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return {
            isRedirect: true,
            redirectSpaceKey: expectedSpaceKey,
            redirectReason: `CP-noSK:${missingSpaceKey}|wrongSK:${Boolean(wrongSpaceKeyOnSSR)}|noSpace:${Boolean(notFoundSpaceError)}`
        };
    }
    if (error && handleTimeoutError && isTimeoutError) {
        handleTimeoutError(error);
        return {
            error: error,
            isTimeoutError: true
        };
    }
    if (error && handleUnexpectedError) {
        handleUnexpectedError(error);
        return {
            error: error,
            isUnexpectedError: true
        };
    }
    return {};
};
const $eb18cf4dc4cf4350$export$1ff4591c5a23ba79 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { children: children, route: route, contentQueryResult: contentQueryResult, passThroughOnLoading: t1, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, status: status, versionOverride: versionOverride } = t0;
    const passThroughOnLoading = t1 === undefined ? false : t1;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    let t2;
    if ($[0] !== contentId || $[1] !== contentQueryResult || $[2] !== handleTimeoutError || $[3] !== handleUnexpectedError || $[4] !== spaceKey || $[5] !== status) {
        t2 = {
            spaceKey: spaceKey,
            contentId: contentId,
            contentQueryResult: contentQueryResult,
            handleUnexpectedError: handleUnexpectedError,
            handleTimeoutError: handleTimeoutError,
            status: status
        };
        $[0] = contentId;
        $[1] = contentQueryResult;
        $[2] = handleTimeoutError;
        $[3] = handleUnexpectedError;
        $[4] = spaceKey;
        $[5] = status;
        $[6] = t2;
    } else t2 = $[6];
    const prerequisites = $eb18cf4dc4cf4350$var$useContentPrerequisites(t2);
    if (prerequisites.isNotFound) {
        let t3;
        if ($[7] !== contentId || $[8] !== route || $[9] !== spaceKey) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $frfjk.NotFoundContainer), {
                route: route,
                spaceKey: spaceKey,
                contentId: contentId
            });
            $[7] = contentId;
            $[8] = route;
            $[9] = spaceKey;
            $[10] = t3;
        } else t3 = $[10];
        return t3;
    }
    let t3;
    if ($[11] !== children || $[12] !== contentId || $[13] !== isTransition || $[14] !== passThroughOnLoading || $[15] !== prerequisites.error || $[16] !== prerequisites.isLoading || $[17] !== prerequisites.isRedirect || $[18] !== prerequisites.isRestricted || $[19] !== prerequisites.isTimeoutError || $[20] !== prerequisites.redirectReason || $[21] !== prerequisites.redirectSpaceKey || $[22] !== route || $[23] !== spaceKey) {
        t3 = ()=>{
            if (!isTransition && contentId && (0, $hNtOj.ssrPermissionsErrorHandler).getRestrictedRoute() === "view") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $llOcx.UnauthorizedScreen), {
                contentId: contentId,
                accessType: (0, $hNtOj.ssrPermissionsErrorHandler).getErrorType()
            });
            if (prerequisites.isLoading) return passThroughOnLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, children) : null;
            if (contentId && prerequisites.isRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $llOcx.UnauthorizedScreen), {
                contentId: contentId,
                accessType: $eb18cf4dc4cf4350$var$getAccessType(prerequisites.error)
            });
            if (prerequisites.isRedirect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
                name: route.name,
                reason: prerequisites.redirectReason,
                params: {
                    contentId: contentId,
                    spaceKey: prerequisites.redirectSpaceKey
                }
            });
            if (prerequisites.isTimeoutError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iElL7.TimeoutErrorScreen), {
                contentId: contentId,
                spaceKey: spaceKey
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, children);
        };
        $[11] = children;
        $[12] = contentId;
        $[13] = isTransition;
        $[14] = passThroughOnLoading;
        $[15] = prerequisites.error;
        $[16] = prerequisites.isLoading;
        $[17] = prerequisites.isRedirect;
        $[18] = prerequisites.isRestricted;
        $[19] = prerequisites.isTimeoutError;
        $[20] = prerequisites.redirectReason;
        $[21] = prerequisites.redirectSpaceKey;
        $[22] = route;
        $[23] = spaceKey;
        $[24] = t3;
    } else t3 = $[24];
    const getContentComponent = t3;
    let t4;
    if ($[25] !== versionOverride) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jH9vM.ContentRedirect), {
            versionOverride: versionOverride
        });
        $[25] = versionOverride;
        $[26] = t4;
    } else t4 = $[26];
    let t5;
    if ($[27] !== getContentComponent) {
        t5 = getContentComponent();
        $[27] = getContentComponent;
        $[28] = t5;
    } else t5 = $[28];
    let t6;
    if ($[29] !== t4 || $[30] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[29] = t4;
        $[30] = t5;
        $[31] = t6;
    } else t6 = $[31];
    return t6;
} : ({ children: children, route: route, contentQueryResult: contentQueryResult, passThroughOnLoading: passThroughOnLoading = false, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, status: status, versionOverride: versionOverride })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const prerequisites = $eb18cf4dc4cf4350$var$useContentPrerequisites({
        spaceKey: spaceKey,
        contentId: contentId,
        contentQueryResult: contentQueryResult,
        handleUnexpectedError: handleUnexpectedError,
        handleTimeoutError: handleTimeoutError,
        status: status
    });
    if (prerequisites.isNotFound) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $frfjk.NotFoundContainer), {
        route: route,
        spaceKey: spaceKey,
        contentId: contentId
    });
    const getContentComponent = ()=>{
        if (!isTransition && contentId && (0, $hNtOj.ssrPermissionsErrorHandler).getRestrictedRoute() === 'view') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $llOcx.UnauthorizedScreen), {
            contentId: contentId,
            accessType: (0, $hNtOj.ssrPermissionsErrorHandler).getErrorType()
        });
        if (prerequisites.isLoading) return passThroughOnLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, children) : null;
        if (contentId && prerequisites.isRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $llOcx.UnauthorizedScreen), {
            contentId: contentId,
            accessType: $eb18cf4dc4cf4350$var$getAccessType(prerequisites.error)
        });
        if (prerequisites.isRedirect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: route.name,
            reason: prerequisites.redirectReason,
            params: {
                contentId: contentId,
                spaceKey: prerequisites.redirectSpaceKey
            }
        });
        if (prerequisites.isTimeoutError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iElL7.TimeoutErrorScreen), {
            contentId: contentId,
            spaceKey: spaceKey
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, children);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jH9vM.ContentRedirect), {
        versionOverride: versionOverride
    }), getContentComponent());
};
function $eb18cf4dc4cf4350$var$getAccessType(error) {
    return error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
}
module.exports["ContentPrerequisites"] = $eb18cf4dc4cf4350$export$1ff4591c5a23ba79;

});

parcelRegister("hpnxK", function(module, exports) {
const $88d658a04ba6cccf$export$bb4f02e6ef6f6e17 = (error)=>error.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $88d658a04ba6cccf$export$bb4f02e6ef6f6e17;

});

parcelRegister("frfjk", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $b2p4s = parcelRequire("b2p4s");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $lt6Lx = parcelRequire("lt6Lx");


var $3IBnw = parcelRequire("3IBnw");


var $f9jv7 = parcelRequire("f9jv7");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $1NBp8 = parcelRequire("1NBp8");


var $wtSEP = parcelRequire("wtSEP");


var $3WD5B = parcelRequire("3WD5B");


var $kE2cJ = parcelRequire("kE2cJ");


var $gMFJB = parcelRequire("gMFJB");

const $4bb6cb1596a8393b$export$32fe640941018446 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { route: route, spaceKey: spaceKey, contentId: contentId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = window.location.search.match(/draftShareId=(.*?)(#|&|$)/)?.[1] ?? "";
        $[0] = t1;
    } else t1 = $[0];
    const urlDraftShareId = t1;
    const t2 = contentId ?? "";
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            "draft"
        ];
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== t2) {
        t4 = {
            contentId: t2,
            draftShareId: urlDraftShareId,
            status: t3
        };
        $[2] = t2;
        $[3] = t4;
    } else t4 = $[3];
    const t5 = !contentId || !spaceKey || route !== (0, $1NBp8.VIEW_PAGE);
    let t6;
    if ($[4] !== t4 || $[5] !== t5) {
        t6 = {
            variables: t4,
            skip: t5,
            fetchPolicy: window.__SSR_RENDERED__ ? "cache-only" : "cache-and-network",
            onError: $4bb6cb1596a8393b$var$_temp
        };
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $b2p4s.default), {
        ...t6,
        __callerPackage__: "content-prerequisites"
    });
    let t7;
    if ($[7] !== contentId || $[8] !== data?.content?.nodes?.[0]?.links?.webui || $[9] !== data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value || $[10] !== spaceKey) {
        t7 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const draftShareId = data?.content?.nodes?.[0]?.links?.webui?.match(/draftShareId=(.*?)(#|&|$)/)?.[1];
            const isFabric = data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value === "\"v2\"";
            if (isFabric && draftShareId) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
                    href: (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: "pages"
                    }, {
                        query: {
                            draftShareId: draftShareId
                        }
                    })
                });
                break bb0;
            }
        }
        $[7] = contentId;
        $[8] = data?.content?.nodes?.[0]?.links?.webui;
        $[9] = data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value;
        $[10] = spaceKey;
        $[11] = t7;
    } else t7 = $[11];
    if (t7 !== Symbol.for("react.early_return_sentinel")) return t7;
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
            notFound: true
        });
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== route || $[14] !== spaceKey) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, t8, route === (0, $1NBp8.SPACE_OVERVIEW) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3WD5B.OverviewNotFound), {
            spaceKey: spaceKey
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null));
        $[13] = route;
        $[14] = spaceKey;
        $[15] = t9;
    } else t9 = $[15];
    return t9;
} : ({ route: route, spaceKey: spaceKey, contentId: contentId })=>{
    // View page URLs inserted by the `/Create Confluence page` extension will include draftShareId
    const urlDraftShareId = window.location.search.match(/draftShareId=(.*?)(#|&|$)/)?.[1] ?? '';
    /*
   * If we've hit this component, the page may actually be an unpublished draft,
   * if so then redirect to the editor given the user has edit permission
   */ const { data: data } = (0, $jMyy4.useQueryInterop)((0, $b2p4s.default), {
        variables: {
            contentId: contentId ?? '',
            draftShareId: urlDraftShareId,
            status: [
                'draft'
            ]
        },
        skip: !contentId || !spaceKey || route !== (0, $1NBp8.VIEW_PAGE),
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-only' : 'cache-and-network',
        onError: (error)=>{
            if (!(0, $1uFM6.isUnauthorizedError)(error) && !(0, $f9jv7.isNotFoundError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "content-prerequisites"
    });
    // Query result will include draftShareId if the page is a draft
    const draftShareId = data?.content?.nodes?.[0]?.links?.webui?.match(/draftShareId=(.*?)(#|&|$)/)?.[1];
    const isFabric = data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value === '"v2"';
    if (isFabric && draftShareId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.EDIT_PAGE_V2).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: 'pages'
        }, {
            query: {
                draftShareId: draftShareId
            }
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
        notFound: true
    }), route === (0, $1NBp8.SPACE_OVERVIEW) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3WD5B.OverviewNotFound), {
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null));
};
function $4bb6cb1596a8393b$var$_temp(error) {
    if (!(0, $1uFM6.isUnauthorizedError)(error) && !(0, $f9jv7.isNotFoundError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["NotFoundContainer"] = $4bb6cb1596a8393b$export$32fe640941018446;

});

parcelRegister("3WD5B", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $122d2f3e6774c3f2$export$df359d26db880cab = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AHMpB",
    name: "OverviewNotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("9NMv1"))).OverviewNotFound
});
module.exports["OverviewNotFound"] = $122d2f3e6774c3f2$export$df359d26db880cab;

});

parcelRegister("9NMv1", function(module, exports) {

let $722e4f9ba06e42b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $722e4f9ba06e42b4$var$load("bn8Oy").then(()=>parcelRequire('bDiji'));

});

parcelRegister("gMFJB", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d38ee66b6872a958$export$ffe4f7ef348542da = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02N91d",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d",
            __cmplp.className
        ])
    });
});
module.exports["ContentExpansionContainer"] = $d38ee66b6872a958$export$ffe4f7ef348542da;

});

parcelRegister("llOcx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lt6Lx = parcelRequire("lt6Lx");


var $88O8D = parcelRequire("88O8D");


var $6MSEP = parcelRequire("6MSEP");


var $gMFJB = parcelRequire("gMFJB");

const $3d886ddd51b4b1de$export$6af94d617557e778 = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88O8D.LoginIfAnonymous), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
            siteTitleOnly: true
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), props)));
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88O8D.LoginIfAnonymous), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
        siteTitleOnly: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), props))));
module.exports["UnauthorizedScreen"] = $3d886ddd51b4b1de$export$6af94d617557e778;

});

parcelRegister("88O8D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $kE2cJ = parcelRequire("kE2cJ");


var $bQm3c = parcelRequire("bQm3c");


var $jEeDd = parcelRequire("jEeDd");

const $d2b0786819b3899c$export$cd1cc7f28314b96a = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    return userId ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $jEeDd.getLoginLink)(),
        usePush: (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)()
    });
};
module.exports["LoginIfAnonymous"] = $d2b0786819b3899c$export$cd1cc7f28314b96a;

});

parcelRegister("jH9vM", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $4uNpa = parcelRequire("4uNpa");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $1uFM6 = parcelRequire("1uFM6");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $cb6fO = parcelRequire("cb6fO");


var $bQm3c = parcelRequire("bQm3c");


var $bFVuH = parcelRequire("bFVuH");

const $5b842fead80f6623$export$2ca6584fed43f61 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { versionOverride: versionOverride } = t0;
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, contentSlug: contentSlug, spaceKey: spaceKey } = t1;
    const { isHideTitleInUrl: isHideTitleInUrl } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] !== contentId || $[1] !== versionOverride) {
        t2 = {
            contentId: contentId,
            versionOverride: versionOverride
        };
        $[0] = contentId;
        $[1] = versionOverride;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            single: true
        };
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2) {
        t4 = {
            errorPolicy: "all",
            variables: t2,
            context: t3
        };
        $[4] = t2;
        $[5] = t4;
    } else t4 = $[5];
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $4uNpa.default), {
        ...t4,
        __callerPackage__: "content-prerequisites"
    });
    if (loading) return null;
    if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const content = data?.content?.nodes?.[0];
    const space = content?.space;
    const title = content?.title;
    let t5;
    if ($[6] !== isHideTitleInUrl) {
        t5 = isHideTitleInUrl && (0, $6mKj3.isExperimentEnabled)("confluence_hide_content_title_in_url");
        $[6] = isHideTitleInUrl;
        $[7] = t5;
    } else t5 = $[7];
    const redirectToHideTitleSlug = t5;
    let t6;
    if ($[8] !== content || $[9] !== redirectToHideTitleSlug || $[10] !== space?.alias || $[11] !== space?.key || $[12] !== title) {
        t6 = content && {
            ...content,
            slug: redirectToHideTitleSlug ? undefined : (0, $cb6fO.generateSlug)(title),
            spaceKey: space?.alias || space?.key,
            createdDate: content?.history?.createdDate
        };
        $[8] = content;
        $[9] = redirectToHideTitleSlug;
        $[10] = space?.alias;
        $[11] = space?.key;
        $[12] = title;
        $[13] = t6;
    } else t6 = $[13];
    const contentWithSlug = t6;
    let t7;
    if ($[14] !== contentSlug || $[15] !== contentWithSlug || $[16] !== redirectToHideTitleSlug || $[17] !== space || $[18] !== spaceKey) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFVuH.ContentRedirectComponent), {
            contentSlugInUrl: contentSlug,
            contentWithSlug: contentWithSlug,
            space: space,
            spaceKeyInUrl: spaceKey,
            redirectToHideTitleSlug: redirectToHideTitleSlug
        });
        $[14] = contentSlug;
        $[15] = contentWithSlug;
        $[16] = redirectToHideTitleSlug;
        $[17] = space;
        $[18] = spaceKey;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
} : ({ versionOverride: versionOverride })=>{
    const [{ contentId: contentId, contentSlug: contentSlug, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const { isHideTitleInUrl: isHideTitleInUrl } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $4uNpa.default), {
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            versionOverride: versionOverride
        },
        context: {
            single: true
        },
        __callerPackage__: "content-prerequisites"
    });
    if (loading) return null;
    // UnauthorizedError is a special case here since no specific UI are required for it.
    // In case of an UnauthorizedError the data or content are expected to be empty, and
    // ContentRedirectComponent will handle such case properly.
    if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const content = data?.content?.nodes?.[0];
    const space = content?.space;
    const title = content?.title;
    const redirectToHideTitleSlug = isHideTitleInUrl && (0, $6mKj3.isExperimentEnabled)('confluence_hide_content_title_in_url');
    const contentWithSlug = content && {
        ...content,
        slug: redirectToHideTitleSlug ? undefined : (0, $cb6fO.generateSlug)(title),
        spaceKey: space?.alias || space?.key,
        createdDate: content?.history?.createdDate
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFVuH.ContentRedirectComponent), {
        contentSlugInUrl: contentSlug,
        contentWithSlug: contentWithSlug,
        space: space,
        spaceKeyInUrl: spaceKey,
        redirectToHideTitleSlug: redirectToHideTitleSlug
    });
};
module.exports["ContentRedirect"] = $5b842fead80f6623$export$2ca6584fed43f61;

});

parcelRegister("bFVuH", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1NBp8 = parcelRequire("1NBp8");


var $6HckY = parcelRequire("6HckY");


var $kE2cJ = parcelRequire("kE2cJ");


var $7zgzO = parcelRequire("7zgzO");


var $4o1RV = parcelRequire("4o1RV");


var $3jwuS = parcelRequire("3jwuS");

const $40c3e9fb4beb4b02$export$c859cd2f253879ed = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(60);
    const { contentWithSlug: contentWithSlug, space: space, spaceKeyInUrl: spaceKeyInUrl, contentSlugInUrl: t1, redirectToHideTitleSlug: redirectToHideTitleSlug } = t0;
    const contentSlugInUrl = t1 === undefined ? "" : t1;
    const { match: match, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t2;
    if ($[0] !== contentWithSlug || $[1] !== isLivePage || $[2] !== spaceKeyInUrl) {
        t2 = ()=>{
            if (isLivePage) return false;
            return contentWithSlug && spaceKeyInUrl !== contentWithSlug?.spaceKey;
        };
        $[0] = contentWithSlug;
        $[1] = isLivePage;
        $[2] = spaceKeyInUrl;
        $[3] = t2;
    } else t2 = $[3];
    const shouldRedirectIncorrectSpaceKey = t2;
    let t3;
    if ($[4] !== contentSlugInUrl || $[5] !== contentWithSlug?.slug || $[6] !== isLivePage) {
        t3 = ()=>isLivePage ? false : decodeURIComponent(contentWithSlug?.slug || "") !== decodeURIComponent(contentSlugInUrl);
        $[4] = contentSlugInUrl;
        $[5] = contentWithSlug?.slug;
        $[6] = isLivePage;
        $[7] = t3;
    } else t3 = $[7];
    contentWithSlug?.slug;
    const shouldRedirectIncorrectSlug = t3;
    const isIncorrectSlug = shouldRedirectIncorrectSlug();
    let t4;
    if ($[8] !== shouldRedirectIncorrectSpaceKey) {
        t4 = shouldRedirectIncorrectSpaceKey();
        $[8] = shouldRedirectIncorrectSpaceKey;
        $[9] = t4;
    } else t4 = $[9];
    const isIncorrectSpaceKey = t4;
    const hasContentTitleToStrip = redirectToHideTitleSlug && isIncorrectSlug;
    let t5;
    if ($[10] !== getHash || $[11] !== redirectToHideTitleSlug) {
        t5 = redirectToHideTitleSlug && Boolean(getHash());
        $[10] = getHash;
        $[11] = redirectToHideTitleSlug;
        $[12] = t5;
    } else t5 = $[12];
    const hasAnchorHashToStrip = t5;
    let t6;
    if ($[13] !== contentWithSlug || $[14] !== getQueryParams || $[15] !== hasAnchorHashToStrip || $[16] !== hasContentTitleToStrip || $[17] !== isIncorrectSpaceKey || $[18] !== match?.name || $[19] !== match?.params || $[20] !== replace || $[21] !== toUrl) {
        t6 = ()=>{
            if (!contentWithSlug || isIncorrectSpaceKey) return;
            if (!hasContentTitleToStrip && !hasAnchorHashToStrip) return;
            window.__DELAYED_CONTENT_REDIRECTION__ = {};
            const targetUrl = toUrl(match?.name, {
                ...match?.params,
                hash: undefined,
                query: getQueryParams(),
                spaceKey: contentWithSlug.spaceKey,
                contentId: contentWithSlug.id,
                contentSlug: contentWithSlug.slug
            });
            replace(targetUrl);
        };
        $[13] = contentWithSlug;
        $[14] = getQueryParams;
        $[15] = hasAnchorHashToStrip;
        $[16] = hasContentTitleToStrip;
        $[17] = isIncorrectSpaceKey;
        $[18] = match?.name;
        $[19] = match?.params;
        $[20] = replace;
        $[21] = toUrl;
        $[22] = t6;
    } else t6 = $[22];
    const t7 = match?.name;
    const t8 = match?.params;
    let t9;
    if ($[23] !== contentWithSlug || $[24] !== getHash || $[25] !== getQueryParams || $[26] !== hasAnchorHashToStrip || $[27] !== hasContentTitleToStrip || $[28] !== isIncorrectSpaceKey || $[29] !== replace || $[30] !== t7 || $[31] !== t8 || $[32] !== toUrl) {
        t9 = [
            hasContentTitleToStrip,
            hasAnchorHashToStrip,
            isIncorrectSpaceKey,
            contentWithSlug,
            t7,
            t8,
            replace,
            toUrl,
            getHash,
            getQueryParams
        ];
        $[23] = contentWithSlug;
        $[24] = getHash;
        $[25] = getQueryParams;
        $[26] = hasAnchorHashToStrip;
        $[27] = hasContentTitleToStrip;
        $[28] = isIncorrectSpaceKey;
        $[29] = replace;
        $[30] = t7;
        $[31] = t8;
        $[32] = toUrl;
        $[33] = t9;
    } else t9 = $[33];
    (0, $cozmU.useEffect)(t6, t9);
    if (!contentWithSlug) return null;
    if (space && contentWithSlug.id === `${space.homepageId}` && match?.name === (0, $1NBp8.VIEW_PAGE).name) {
        let t10;
        if ($[34] !== contentWithSlug || $[35] !== match?.params || $[36] !== routePolicy) {
            t10 = !routePolicy || routePolicy.willPushInSelf((0, $1NBp8.VIEW_PAGE).name, match?.params.contentId, (0, $1NBp8.SPACE_OVERVIEW).name, contentWithSlug.id);
            $[34] = contentWithSlug;
            $[35] = match?.params;
            $[36] = routePolicy;
            $[37] = t10;
        } else t10 = $[37];
        const willPushInSelf = t10;
        let t11;
        if ($[38] !== contentWithSlug || $[39] !== willPushInSelf) {
            t11 = willPushInSelf ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
                name: (0, $1NBp8.SPACE_OVERVIEW).name,
                params: {
                    spaceKey: contentWithSlug.spaceKey,
                    contentId: contentWithSlug.id,
                    contentSlug: contentWithSlug.slug
                }
            }) : null;
            $[38] = contentWithSlug;
            $[39] = willPushInSelf;
            $[40] = t11;
        } else t11 = $[40];
        return t11;
    }
    if (!isIncorrectSpaceKey && (isIncorrectSlug || window.__DELAYED_CONTENT_REDIRECTION__?.contentSlug)) {
        const t10 = match?.name;
        const t11 = `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`;
        const t12 = match?.params;
        let t13;
        if ($[41] !== contentWithSlug.id || $[42] !== contentWithSlug.slug || $[43] !== contentWithSlug.spaceKey || $[44] !== t12) {
            t13 = {
                ...t12,
                spaceKey: contentWithSlug.spaceKey,
                contentId: contentWithSlug.id,
                contentSlug: contentWithSlug.slug
            };
            $[41] = contentWithSlug.id;
            $[42] = contentWithSlug.slug;
            $[43] = contentWithSlug.spaceKey;
            $[44] = t12;
            $[45] = t13;
        } else t13 = $[45];
        const t14 = Boolean(!isIncorrectSlug);
        let t15;
        if ($[46] !== t10 || $[47] !== t11 || $[48] !== t13 || $[49] !== t14) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6HckY.DelayRedirectionOnClient), {
                name: t10,
                reason: t11,
                params: t13,
                skipRouteChange: t14
            });
            $[46] = t10;
            $[47] = t11;
            $[48] = t13;
            $[49] = t14;
            $[50] = t15;
        } else t15 = $[50];
        return t15;
    }
    if (!isIncorrectSpaceKey && !isIncorrectSlug) return null;
    const t10 = match?.name;
    const t11 = `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`;
    const t12 = match?.params;
    let t13;
    if ($[51] !== contentWithSlug.id || $[52] !== contentWithSlug.slug || $[53] !== contentWithSlug.spaceKey || $[54] !== t12) {
        t13 = {
            ...t12,
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        };
        $[51] = contentWithSlug.id;
        $[52] = contentWithSlug.slug;
        $[53] = contentWithSlug.spaceKey;
        $[54] = t12;
        $[55] = t13;
    } else t13 = $[55];
    let t14;
    if ($[56] !== t10 || $[57] !== t11 || $[58] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: t10,
            reason: t11,
            params: t13
        });
        $[56] = t10;
        $[57] = t11;
        $[58] = t13;
        $[59] = t14;
    } else t14 = $[59];
    return t14;
} : ({ contentWithSlug: contentWithSlug, space: space, spaceKeyInUrl: spaceKeyInUrl, contentSlugInUrl: contentSlugInUrl = '', redirectToHideTitleSlug: redirectToHideTitleSlug })=>{
    const { match: match, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const shouldRedirectIncorrectSpaceKey = (0, $cozmU.useCallback)(()=>{
        if (isLivePage) /*
       * Live Pages exist on the view page route, but render the Confluence editor
       * The Confluence editor has its own space key redirection logic and move event listeners (via useSpaceKeyWatcher)
       * Consequently this redirection will clash with the redirects from the editor.
       */ return false;
        return contentWithSlug && spaceKeyInUrl !== contentWithSlug?.spaceKey;
    }, [
        spaceKeyInUrl,
        contentWithSlug,
        isLivePage
    ]);
    const shouldRedirectIncorrectSlug = (0, $cozmU.useCallback)(()=>{
        // When current slug in URL does not match with slug in content ==> slug changed
        // Important to decode when compare because react router decodes the params first
        // so contentSlug will be decoded string
        //
        // Live pages will handle its own redirection logic from content slug
        return isLivePage ? false : decodeURIComponent(contentWithSlug?.slug || '') !== decodeURIComponent(contentSlugInUrl);
    }, [
        contentWithSlug?.slug,
        contentSlugInUrl,
        isLivePage
    ]);
    const isIncorrectSlug = shouldRedirectIncorrectSlug();
    const isIncorrectSpaceKey = shouldRedirectIncorrectSpaceKey();
    const hasContentTitleToStrip = redirectToHideTitleSlug && isIncorrectSlug;
    const hasAnchorHashToStrip = redirectToHideTitleSlug && Boolean(getHash());
    // Strip the content title slug and/or heading anchor hash from the URL when the
    // hide-title-in-url setting and experiment are enabled.
    // This runs as a useEffect (rather than relying on <Redirection>) so that it fires on every navigation,
    // including revisits to pages / blogs.
    (0, $cozmU.useEffect)(()=>{
        if (!contentWithSlug || isIncorrectSpaceKey) return;
        if (!hasContentTitleToStrip && !hasAnchorHashToStrip) return;
        window['__DELAYED_CONTENT_REDIRECTION__'] = {};
        const targetUrl = toUrl(match?.name, {
            ...match?.params,
            // When hiding title from the address bar URL, also strip heading anchor hashes to avoid exposing UGC in the address bar.
            hash: undefined,
            query: getQueryParams(),
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        });
        replace(targetUrl);
    }, [
        hasContentTitleToStrip,
        hasAnchorHashToStrip,
        isIncorrectSpaceKey,
        contentWithSlug,
        match?.name,
        match?.params,
        replace,
        toUrl,
        getHash,
        getQueryParams
    ]);
    // Don't redirect if we have insufficient information to successfully redirect the user
    if (!contentWithSlug) return null;
    // Do redirect if we should go back to the Space Home Overview Tab
    if (space && contentWithSlug.id === `${space.homepageId}` && match?.name === (0, $1NBp8.VIEW_PAGE).name) {
        const willPushInSelf = !routePolicy || routePolicy.willPushInSelf((0, $1NBp8.VIEW_PAGE).name, match?.params.contentId, (0, $1NBp8.SPACE_OVERVIEW).name, contentWithSlug.id);
        return willPushInSelf ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.SPACE_OVERVIEW).name,
            params: {
                spaceKey: contentWithSlug.spaceKey,
                contentId: contentWithSlug.id,
                contentSlug: contentWithSlug.slug
            }
        }) : null;
    }
    // Incorrect slug cannot do redirection in SSR, if there is #anchor fragment in the URL,
    // it will be lost in the redirection, as #anchor fragment is not passed to the server.
    // So we need to do redirection in client side.
    // If the content slug is already fixed in PageState, but URL is incorrect, rewrite URL without
    // triggering route change.
    if (!isIncorrectSpaceKey && (isIncorrectSlug || window.__DELAYED_CONTENT_REDIRECTION__?.contentSlug)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6HckY.DelayRedirectionOnClient), {
        name: match?.name,
        reason: `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`,
        params: {
            ...match?.params,
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        },
        skipRouteChange: Boolean(!isIncorrectSlug)
    });
    // Don't redirect if we otherwise don't need to
    if (!isIncorrectSpaceKey && !isIncorrectSlug) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: match?.name,
        reason: `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`,
        params: {
            ...match?.params,
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        }
    });
});
module.exports["ContentRedirectComponent"] = $40c3e9fb4beb4b02$export$c859cd2f253879ed;

});

parcelRegister("6HckY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kE2cJ = parcelRequire("kE2cJ");

const $aab50db669fe7470$export$9c627468834548a9 = (props)=>{
    // In client-side rendering, we can directly render the Redirection component
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), props);
};
module.exports["DelayRedirectionOnClient"] = $aab50db669fe7470$export$9c627468834548a9;

});

parcelRegister("iElL7", function(module, exports) {

var $lS0xA = parcelRequire("lS0xA");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $6Pqow = parcelRequire("6Pqow");


var $3izAL = parcelRequire("3izAL");


var $I7hWB = parcelRequire("I7hWB");


var $9DHhW = parcelRequire("9DHhW");


var $8lYIw = parcelRequire("8lYIw");


var $1NBp8 = parcelRequire("1NBp8");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $dc6f00ca158cde35$var$timeoutErrorStyles = (0, $buxP3.xcss)({
    margin: 'auto',
    width: '50%',
    height: '90vh'
});
const $dc6f00ca158cde35$var$timeoutErrorBorderContainerStyles = (0, $buxP3.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.500',
    borderRadius: 'radius.large'
});
const $dc6f00ca158cde35$var$headingStyles = (0, $buxP3.xcss)({
    paddingBottom: 'space.200'
});
const $dc6f00ca158cde35$var$bulletStyles = null;
const $dc6f00ca158cde35$var$i18n = (0, $kSwu1.defineMessages)({
    heading: {
        id: "content-prerequisites.timeout-error-screen.heading",
        defaultMessage: "Unable to load page"
    },
    resolutionOptions: {
        id: "content-prerequisites.timeout-error-screen.resolution-options",
        defaultMessage: "To resolve this issue, you may want to:"
    },
    reloadPage: {
        id: "content-prerequisites.timeout-error-screen.reload-page",
        defaultMessage: "Reload this page"
    },
    convertToCloudEditor: {
        id: "content-prerequisites.timeout-error-screen.convert-to-cloud-editor",
        defaultMessage: "<EditLink>Return to edit mode</EditLink> and convert to the <SACLink>cloud editor</SACLink> now"
    },
    removeMacroOrBreakPageContent: {
        id: "content-prerequisites.timeout-error-screen.remove-excerpt-macro-or-break-page-content",
        defaultMessage: "Remove one or more excerpt macros, or break this page content into several smaller pages"
    },
    contactAdmin: {
        id: "content-prerequisites.timeout-error-screen.contact-admin",
        defaultMessage: "If this keeps happening, ask your admin to contact <SupportLink>our Support team</SupportLink> and give them the URL of this page."
    }
});
const $dc6f00ca158cde35$export$f8e8c76e5ae5ca9e = ({ contentId: contentId, spaceKey: spaceKey })=>{
    const [{ contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isBlogpost = contentType === 'blogpost';
    const routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $lS0xA.default), {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "content-prerequisites"
    });
    const linkParams = (0, $cozmU.useMemo)(()=>({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: isBlogpost ? 'blog' : 'pages'
        }), [
        contentId,
        spaceKey,
        isBlogpost
    ]); // If the editor property is undefined or null, we assume it's TinyMCE even though the missing missing property is not strictly TinyMCE.
    // It's okay to assume this for the purposes of this error screen b/c editor property as null is most likely TinyMCE.
    const editorProperty = data?.singleContent?.properties?.nodes?.[0]?.value;
    const isTinyMCE = !editorProperty || editorProperty === '"v1"';
    (0, $cozmU.useEffect)(()=>{
        if (isTinyMCE) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'errorScreen',
                attributes: {
                    customErrorUI: 'tinyMceTimeouts',
                    editorProperty: editorProperty
                }
            }
        })?.fire();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTinyMCE,
        createAnalyticsEvent
    ]);
    if (!isTinyMCE) return null;
    const editHref = routeType.toUrl(linkParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $dc6f00ca158cde35$var$timeoutErrorStyles,
        direction: "column",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $dc6f00ca158cde35$var$timeoutErrorBorderContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $dc6f00ca158cde35$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $dc6f00ca158cde35$var$i18n.heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $dc6f00ca158cde35$var$i18n.resolutionOptions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        className: (0, $hekY6.default)([
            "_1wydGW5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $dc6f00ca158cde35$var$i18n.reloadPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$dc6f00ca158cde35$var$i18n.convertToCloudEditor,
        values: {
            SACLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: "https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor"
                }, chunks),
            EditLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: editHref
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $dc6f00ca158cde35$var$i18n.removeMacroOrBreakPageContent))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$dc6f00ca158cde35$var$i18n.contactAdmin,
        values: {
            SupportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: "https://support.atlassian.com/contact/#/"
                }, chunks)
        }
    }))));
};
module.exports["TimeoutErrorScreen"] = $dc6f00ca158cde35$export$f8e8c76e5ae5ca9e;

});

parcelRegister("lS0xA", function(module, exports) {
/**
 * @generated SignedSource<<6f05060aef91edbb8530ac92dd61a679>>
 * @relayHash c72c86c38eafd81a46c0b3d86969a316
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ffa8f11ede7fae2172b2e0f0740171fc9fa13cfe1a648392c4c5e36a4a0557a
const $82ca62ae3478d21d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TimeoutErrorScreenQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TimeoutErrorScreenQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c72c86c38eafd81a46c0b3d86969a316",
            "id": "9ffa8f11ede7fae2172b2e0f0740171fc9fa13cfe1a648392c4c5e36a4a0557a",
            "metadata": {},
            "name": "TimeoutErrorScreenQuery",
            "operationKind": "query",
            "text": "query TimeoutErrorScreenQuery($contentId:ID!){singleContent(id:$contentId){id,properties(key:\"editor\"){nodes{id,key,value}}}}"
        }
    };
}();
$82ca62ae3478d21d$var$node.hash = "607b11a2ee268d24f66b7b4f714aa8ae";
var $82ca62ae3478d21d$export$2e2bcd8739ae039 = $82ca62ae3478d21d$var$node;
module.exports["default"] = $82ca62ae3478d21d$export$2e2bcd8739ae039;

});

parcelRegister("2aFNh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7r2px = parcelRequire("7r2px");

function $73c871442f6e75aa$export$6bbd36bf45aa851e(contentBody, customPerfData) {
    const memoRef = (0, $cozmU.useRef)({
        contentBody: undefined,
        contentExtensionMetrics: undefined
    });
    if (customPerfData && (memoRef.current.contentBody !== contentBody || !('contentExtensionMetrics' in customPerfData))) {
        // `retrieveContentExtensionsMetrics` parses the ADF string into JSON, but that's likely to be only one of multiple such parsings.
        // For example, the Atlaskit editor/renderer will very likely parse the ADF string into JSON as well.
        // For large documents (e.g. 16MB) such parsing can take noticeable time which is undesirable especially before rendering.
        // This allows an alternative to `retrieveContentExtensionsMetrics` to optionally perform the computation in a more performant way.
        // But if it doesn't, `retrieveContentExtensionsMetrics` will be the fallback.
        let propertyValue;
        Object.defineProperty(customPerfData, 'contentExtensionMetrics', {
            enumerable: true,
            get () {
                if (propertyValue) return propertyValue;
                memoRef.current.contentBody = contentBody;
                const contentExtensionMetrics = contentBody ? (0, $7r2px.retrieveContentExtensionMetrics)(contentBody) : {};
                memoRef.current.contentExtensionMetrics = contentExtensionMetrics;
                return memoRef.current.contentExtensionMetrics;
            },
            set (value) {
                propertyValue = value;
            }
        });
    }
}
module.exports["useContentExtensionMetrics"] = $73c871442f6e75aa$export$6bbd36bf45aa851e;

});

parcelRegister("iuaOs", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");

const $53a589a30318add1$export$c86a38251c189bb6 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { contentId: contentId, fabricEditorSupported: fabricEditorSupported, bodyRepresentation: bodyRepresentation, reload: reload } = t0;
    const currentContentId = (0, $cozmU.useRef)(null);
    const currentFabricEditorSupportedRef = (0, $cozmU.useRef)(null);
    const currentBodyRepresentationRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== bodyRepresentation || $[1] !== contentId || $[2] !== fabricEditorSupported || $[3] !== reload) {
        t1 = ()=>{
            if (!(0, $9wGTI.fg)("confluence_refetch_content_on_fabric_support_chng")) return;
            if (contentId !== currentContentId.current) {
                currentContentId.current = contentId;
                currentFabricEditorSupportedRef.current = fabricEditorSupported;
                currentBodyRepresentationRef.current = bodyRepresentation;
            } else {
                if (fabricEditorSupported === null || currentFabricEditorSupportedRef.current === null || bodyRepresentation === null || currentBodyRepresentationRef.current === null) {
                    currentFabricEditorSupportedRef.current = fabricEditorSupported;
                    currentBodyRepresentationRef.current = bodyRepresentation;
                } else if (fabricEditorSupported !== currentFabricEditorSupportedRef.current || bodyRepresentation !== currentBodyRepresentationRef.current) {
                    currentFabricEditorSupportedRef.current = fabricEditorSupported;
                    currentBodyRepresentationRef.current = bodyRepresentation;
                    reload();
                }
            }
        };
        t2 = [
            contentId,
            fabricEditorSupported,
            bodyRepresentation,
            reload
        ];
        $[0] = bodyRepresentation;
        $[1] = contentId;
        $[2] = fabricEditorSupported;
        $[3] = reload;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
};
module.exports["useContentReloadOnFabricSupportChange"] = $53a589a30318add1$export$c86a38251c189bb6;

});

parcelRegister("6UMDm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $dfgVG = parcelRequire("dfgVG");

var $jNUT6 = parcelRequire("jNUT6");

const $1493c1e4d7d497eb$export$f12106fa80cfd400 = /*#__PURE__*/ (0, $cozmU.createContext)({
    editorProperty: '',
    fabricEditorSupported: false,
    isAutoConverted: false,
    queryDataId: ''
});
const $1493c1e4d7d497eb$export$78dcd8ae786efebe = ({ editorProperty: editorProperty, fabricEditorSupported: fabricEditorSupported, isAutoConverted: isAutoConvertedWithNewTinyPages, queryDataId: queryDataId, children: children })=>{
    const isAutoConverted = (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? isAutoConvertedWithNewTinyPages : !editorProperty && fabricEditorSupported;
    const isFabric = editorProperty === 'v2' || ((0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? isAutoConvertedWithNewTinyPages : isAutoConverted);
    const autoConversionContextValue = (0, $cozmU.useMemo)(()=>({
            editorProperty: editorProperty,
            fabricEditorSupported: fabricEditorSupported,
            isAutoConverted: isAutoConverted,
            queryDataId: queryDataId
        }), [
        editorProperty,
        fabricEditorSupported,
        isAutoConverted,
        queryDataId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1493c1e4d7d497eb$export$f12106fa80cfd400.Provider, {
        value: autoConversionContextValue
    }, children, !isFabric && queryDataId && (0, $dfgVG.checkRevertFlag)(queryDataId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "auto-editor-conversion-revert-success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jNUT6.RevertEditorSuccess), null)));
};
const $1493c1e4d7d497eb$export$847684e45bf010db = ()=>(0, $cozmU.useContext)($1493c1e4d7d497eb$export$f12106fa80cfd400);
module.exports["AutoConversionByLineContextProvider"] = $1493c1e4d7d497eb$export$78dcd8ae786efebe;
module.exports["useAutoConversionByLineContext"] = $1493c1e4d7d497eb$export$847684e45bf010db;

});

parcelRegister("jNUT6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRa9 = parcelRequire("7aRa9");


var $dfgVG = parcelRequire("dfgVG");

const $1d10088386de9373$var$i18n = (0, $kSwu1.defineMessages)({
    revertEditorFlagSuccessTitle: {
        id: "editor-conversion.revert-editor.flag.success.title",
        defaultMessage: "Page is reverted to legacy editor"
    },
    revertEditorFlagSuccessBody: {
        id: "editor-conversion.revert-editor.flag.success.body",
        defaultMessage: "Please note, cloud editor features such as better real-time collaboration, smart links, Live Docs, and AI-powered features are not available."
    }
});
const $1d10088386de9373$export$974b18a34ecfb5af = ({ flags: flags })=>{
    (0, $cozmU.useEffect)(()=>{
        const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1d10088386de9373$var$i18n.revertEditorFlagSuccessBody);
        flags.showSuccessFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1d10088386de9373$var$i18n.revertEditorFlagSuccessTitle),
            description: description,
            isAutoDismiss: true
        });
        (0, $dfgVG.removeRevertFlag)();
    }, [
        flags
    ]);
    return null;
};
const $1d10088386de9373$export$b2e4e7debfeba26 = (0, $7aRa9.withFlags)($1d10088386de9373$export$974b18a34ecfb5af);
module.exports["RevertEditorSuccess"] = $1d10088386de9373$export$b2e4e7debfeba26;

});

parcelRegister("kQRQB", function(module, exports) {
$parcel$export(module.exports, "ContentTitle", () => (parcelRequire("a3W69")).ContentTitle);
$parcel$export(module.exports, "ContentTitleFromFragment", () => (parcelRequire("a3W69")).ContentTitleFromFragment);

var $a3W69 = parcelRequire("a3W69");


});

parcelRegister("4mihy", function(module, exports) {

var $cJCba = parcelRequire("cJCba");

const $4aa61b5693986156$export$2799e7163d440679 = (createAnalyticsEvent, source, importSource, importDate, contentId, rating, dataFormat, feedback)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'submitted',
            actionSubject: 'survey',
            actionSubjectId: 'importFeedbackSurvey',
            source: source,
            attributes: {
                rating: rating,
                dataFormat: dataFormat,
                feedback: feedback,
                importType: importSource,
                importDate: importDate.toISOString(),
                contentType: (0, $cJCba.getIsWhiteboardSource)(importSource) ? 'whiteboard' : 'page',
                contentId: contentId
            }
        }
    }).fire();
};
module.exports["submitSurveyFeedback"] = $4aa61b5693986156$export$2799e7163d440679;

});

parcelRegister("cJCba", function(module, exports) {
var $ac1d1a087c23a95b$export$ddc693d0d8207b4d = /*#__PURE__*/ function(ImportSource) {
    ImportSource["NOTION"] = "Notion";
    ImportSource["MIRO"] = "Miro";
    ImportSource["MURAL"] = "Mural";
    return ImportSource;
}({});
const $ac1d1a087c23a95b$export$5571cbf5d27f8c0c = (importSource)=>{
    return [
        "Miro",
        "Mural"
    ].map((source)=>source.toLowerCase()).includes(importSource.toLowerCase());
};
const $ac1d1a087c23a95b$export$38afe04e637d5e32 = (importSource)=>{
    const normalizedInput = importSource.toLowerCase();
    for (const source of Object.values($ac1d1a087c23a95b$export$ddc693d0d8207b4d)){
        if (normalizedInput.includes(source.toLowerCase())) return source;
    }
    return undefined;
};
module.exports["ImportSource"] = $ac1d1a087c23a95b$export$ddc693d0d8207b4d;
module.exports["getIsWhiteboardSource"] = $ac1d1a087c23a95b$export$5571cbf5d27f8c0c;
module.exports["getImportSourceEnum"] = $ac1d1a087c23a95b$export$38afe04e637d5e32;

});

parcelRegister("jQob7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $dTHYM = parcelRequire("dTHYM");


var $7BfeF = parcelRequire("7BfeF");


var $9DzWa = parcelRequire("9DzWa");


var $dUI0h = parcelRequire("dUI0h");


var $hpa99 = parcelRequire("hpa99");


var $ad7Ou = parcelRequire("ad7Ou");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $4MnFz = parcelRequire("4MnFz");


var $chu6R = parcelRequire("chu6R");


var $9wGTI = parcelRequire("9wGTI");


var $4mihy = parcelRequire("4mihy");


var $54nea = parcelRequire("54nea");


var $cJCba = parcelRequire("cJCba");


var $aUiHE = parcelRequire("aUiHE");

const $3069ee56b74f24de$export$5efdacda4e928df9 = ({ isOpen: isOpen, closeModal: closeModal, importSource: importSource, importDate: importDate, contentId: contentId, onFeedbackSubmit: onFeedbackSubmit })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const importSourceEnum = (0, $cJCba.getImportSourceEnum)(importSource);
    const NOTION_DATA_FORMAT_OPTIONS = (0, $54nea.useDataFormatOptions)();
    const DATA_FORMAT_OPTIONS = (0, $54nea.useDataFormatOptionsFromSource)(importSourceEnum);
    if (!importSourceEnum && (0, $9wGTI.fg)('cc_importer_axp_enable_miro_import_bulk_feedback')) return null;
    const onSubmit = (data)=>{
        if (!data['data-format'] || data['data-format'].length === 0) return {
            'data-format': intl.formatMessage((0, $aUiHE.modalFormMessages).selectDataFormatError)
        };
        (0, $4mihy.submitSurveyFeedback)(createAnalyticsEvent, 'importedPageFeedbackSurveyModal', importSourceEnum ?? importSource, importDate, contentId, 'negative', // Modal only shown for negative feedback
        data['data-format'].map((option)=>option.value), data['tell-us-about-your-experience']);
        closeModal();
        onFeedbackSubmit();
        showFlag({
            isAutoDismiss: true,
            title: intl.formatMessage((0, $aUiHE.modalFormMessages).submittedTitle),
            description: intl.formatMessage((0, $aUiHE.modalFormMessages).submittedDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: ""
            })
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: closeModal,
        width: "large",
        testId: "import-feedback-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: onSubmit,
        id: "feedback-modal-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).requiredFieldsAsterisk), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $aUiHE.modalFormMessages).feedbackText,
        values: {
            source: importSourceEnum
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "data-format",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).dataFormatLabel),
        isRequired: true,
        testId: "data-format-select-field"
    }, ({ fieldProps: { id: id, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            inputId: id,
            ...rest,
            options: (0, $9wGTI.fg)('cc_importer_axp_enable_miro_import_bulk_feedback') ? DATA_FORMAT_OPTIONS : NOTION_DATA_FORMAT_OPTIONS,
            menuPosition: "fixed",
            isClearable: true,
            isMulti: true,
            clearControlLabel: intl.formatMessage((0, $aUiHE.modalFormMessages).dataFormatClearControlLabel),
            testId: "data-format-select-dropdown"
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).dataFormatHelperText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).tellUsAboutYourExperience),
        name: "tell-us-about-your-experience",
        testId: "tell-us-about-your-experience-field",
        isRequired: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...fieldProps,
            placeholder: intl.formatMessage((0, $aUiHE.modalFormMessages).tellUsAboutYourExperiencePlaceholder),
            testId: "tell-us-about-your-experience-textarea"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: closeModal,
        testId: "feedback-modal-close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).closeButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        type: "submit",
        testId: "feedback-modal-submit-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).feedbackButton)))))));
};
module.exports["FeedbackModal"] = $3069ee56b74f24de$export$5efdacda4e928df9;

});

parcelRegister("54nea", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $cJCba = parcelRequire("cJCba");


var $kyTyD = parcelRequire("kyTyD");


var $3M5DA = parcelRequire("3M5DA");


var $ffmqQ = parcelRequire("ffmqQ");

const $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).mentions,
        value: 'mentions'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).audioEmbeddedLink,
        value: 'audio_embedded_link'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).attachments,
        value: 'attachments'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).blockEquation,
        value: 'block_equation'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).breadcrumb,
        value: 'breadcrumb'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).bulletedLists,
        value: 'bulleted_lists'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).button,
        value: 'button'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).callout,
        value: 'callout'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).codeBlock,
        value: 'code_block'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).codeMermaid,
        value: 'code_mermaid'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).twoColumns,
        value: 'two_columns'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).customizedText,
        value: 'customized_text'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).databaseChildPageProperties,
        value: 'database_child_properties'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).dates,
        value: 'dates'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).dividers,
        value: 'dividers'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).embed,
        value: 'embed'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).emojis,
        value: 'emojis'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).headerImages,
        value: 'header_images'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).headings,
        value: 'headings'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).images,
        value: 'images'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).inlineEquation,
        value: 'inline_equation'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).linkToPage,
        value: 'link_to_page'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).numberedLists,
        value: 'numbered_lists'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).pageComments,
        value: 'page_comments'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).pageEmojis,
        value: 'page_emojis'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).quotes,
        value: 'quotes'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).reminder,
        value: 'reminder'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).staticTables,
        value: 'static_tables'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).syncedBlock,
        value: 'synced_block'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).tableCustomization,
        value: 'table_customization'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).tableData,
        value: 'table_data'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).tableOfContents,
        value: 'table_of_contents'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).todoList,
        value: 'todo_list'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).toggleHeading,
        value: 'toggle_heading'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).toggleList,
        value: 'toggle_list'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).videoEmbeddedLink,
        value: 'video_embedded_link'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).webBookmark,
        value: 'web_bookmark'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).other,
        value: 'other'
    }
];
const $b21152ef0867f201$var$MIRO_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).comments,
        value: 'comments'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).colors,
        value: 'colors'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).connectors,
        value: 'connectors'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).rotations,
        value: 'rotations'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).shapes,
        value: 'shapes'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).talkTracks,
        value: 'talk_tracks'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).lockedElements,
        value: 'locked_elements'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).stickyNotes,
        value: 'sticky_notes'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).frames,
        value: 'frames'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).borders,
        value: 'borders'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).draw,
        value: 'draw'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).websiteEmbeds,
        value: 'website_embeds'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).jiraCards,
        value: 'jira_cards'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).tables,
        value: 'tables'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).gifs,
        value: 'gifs'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).text,
        value: 'text'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).stamps,
        value: 'stamps'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).tags,
        value: 'tags'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).mindMaps,
        value: 'mind_maps'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).other,
        value: 'other'
    }
];
const $b21152ef0867f201$var$MURAL_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).borders,
        value: 'borders'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).colors,
        value: 'colors'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).comments,
        value: 'comments'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).connectors,
        value: 'connectors'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).draw,
        value: 'draw'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).gifs,
        value: 'gifs'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).lockedElements,
        value: 'locked_elements'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).mindMaps,
        value: 'mind_maps'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).rotations,
        value: 'rotations'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).shapes,
        value: 'shapes'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).stamps,
        value: 'stamps'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).stickyNotes,
        value: 'sticky_notes'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).tables,
        value: 'tables'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).tags,
        value: 'tags'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).text,
        value: 'text'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).websiteEmbeds,
        value: 'website_embeds'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).other,
        value: 'other'
    }
];
const $b21152ef0867f201$export$1e5c15dd4d474cfc = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS.map((option)=>({
            value: option.value,
            label: formatMessage(option.message)
        }));
};
const $b21152ef0867f201$export$769861949a982d7a = (importSource)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let dataFormatOptions;
    switch(importSource){
        case (0, $cJCba.ImportSource).NOTION:
            dataFormatOptions = $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS;
            break;
        case (0, $cJCba.ImportSource).MIRO:
            dataFormatOptions = $b21152ef0867f201$var$MIRO_DATA_FORMAT_OPTIONS;
            break;
        case (0, $cJCba.ImportSource).MURAL:
            dataFormatOptions = $b21152ef0867f201$var$MURAL_DATA_FORMAT_OPTIONS;
            break;
        default:
            // Should never happen
            dataFormatOptions = $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS;
    }
    return dataFormatOptions.map((option)=>({
            value: option.value,
            label: formatMessage(option.message)
        }));
};
module.exports["useDataFormatOptions"] = $b21152ef0867f201$export$1e5c15dd4d474cfc;
module.exports["useDataFormatOptionsFromSource"] = $b21152ef0867f201$export$769861949a982d7a;

});

parcelRegister("kyTyD", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b8d9cf0582cd5f3a$export$5487dbca878f120b = (0, $kSwu1.defineMessages)({
    mentions: {
        id: "import-feedback.data-format-options.notion.mentions",
        defaultMessage: "@mentions"
    },
    audioEmbeddedLink: {
        id: "import-feedback.data-format-options.notion.audio-embedded-link",
        defaultMessage: "Audio (embedded link)"
    },
    attachments: {
        id: "import-feedback.data-format-options.notion.attachments",
        defaultMessage: "Attachments"
    },
    blockEquation: {
        id: "import-feedback.data-format-options.notion.block-equation",
        defaultMessage: "Block equation"
    },
    breadcrumb: {
        id: "import-feedback.data-format-options.notion.breadcrumb",
        defaultMessage: "Breadcrumb"
    },
    bulletedLists: {
        id: "import-feedback.data-format-options.notion.bulleted-lists",
        defaultMessage: "Bullet lists"
    },
    button: {
        id: "import-feedback.data-format-options.notion.button",
        defaultMessage: "Button"
    },
    callout: {
        id: "import-feedback.data-format-options.notion.callout",
        defaultMessage: "Callout"
    },
    codeBlock: {
        id: "import-feedback.data-format-options.notion.code-block",
        defaultMessage: "Code block"
    },
    codeMermaid: {
        id: "import-feedback.data-format-options.notion.code-mermaid",
        defaultMessage: "Code - Mermaid (diagram)"
    },
    twoColumns: {
        id: "import-feedback.data-format-options.notion.two-columns",
        defaultMessage: "2 columns"
    },
    customizedText: {
        id: "import-feedback.data-format-options.notion.customized-text",
        defaultMessage: "Customized text"
    },
    databaseChildPageProperties: {
        id: "import-feedback.data-format-options.notion.database-child-page-properties",
        defaultMessage: "Database child page properties"
    },
    dates: {
        id: "import-feedback.data-format-options.notion.dates",
        defaultMessage: "Dates"
    },
    dividers: {
        id: "import-feedback.data-format-options.notion.dividers",
        defaultMessage: "Dividers"
    },
    embed: {
        id: "import-feedback.data-format-options.notion.embed",
        defaultMessage: "Embed (e.g. Figma)"
    },
    emojis: {
        id: "import-feedback.data-format-options.notion.emojis",
        defaultMessage: "Emojis"
    },
    headerImages: {
        id: "import-feedback.data-format-options.notion.header-images",
        defaultMessage: "Header images"
    },
    headings: {
        id: "import-feedback.data-format-options.notion.headings",
        defaultMessage: "Headings"
    },
    images: {
        id: "import-feedback.data-format-options.notion.images",
        defaultMessage: "Images"
    },
    inlineEquation: {
        id: "import-feedback.data-format-options.notion.inline-equation",
        defaultMessage: "Inline equation"
    },
    linkToPage: {
        id: "import-feedback.data-format-options.notion.link-to-page",
        defaultMessage: "Link to page"
    },
    numberedLists: {
        id: "import-feedback.data-format-options.notion.numbered-lists",
        defaultMessage: "Numbered lists"
    },
    pageComments: {
        id: "import-feedback.data-format-options.notion.page-comments",
        defaultMessage: "Page comments"
    },
    pageEmojis: {
        id: "import-feedback.data-format-options.notion.page-emojis",
        defaultMessage: "Page emojis"
    },
    quotes: {
        id: "import-feedback.data-format-options.notion.quotes",
        defaultMessage: "Quotes"
    },
    reminder: {
        id: "import-feedback.data-format-options.notion.reminder",
        defaultMessage: "Reminder"
    },
    staticTables: {
        id: "import-feedback.data-format-options.notion.static-tables",
        defaultMessage: "Static tables"
    },
    syncedBlock: {
        id: "import-feedback.data-format-options.notion.synced-block",
        defaultMessage: "Synced block"
    },
    tableCustomization: {
        id: "import-feedback.data-format-options.notion.table-customization",
        defaultMessage: "Table customization"
    },
    tableData: {
        id: "import-feedback.data-format-options.notion.table-data",
        defaultMessage: "Table data"
    },
    tableOfContents: {
        id: "import-feedback.data-format-options.notion.table-of-contents",
        defaultMessage: "Table of contents"
    },
    todoList: {
        id: "import-feedback.data-format-options.notion.todo-list",
        defaultMessage: "To-Do list"
    },
    toggleHeading: {
        id: "import-feedback.data-format-options.notion.toggle-heading",
        defaultMessage: "Toggle heading"
    },
    toggleList: {
        id: "import-feedback.data-format-options.notion.toggle-list",
        defaultMessage: "Toggle list"
    },
    videoEmbeddedLink: {
        id: "import-feedback.data-format-options.notion.video-embedded-link",
        defaultMessage: "Video (embedded link)"
    },
    webBookmark: {
        id: "import-feedback.data-format-options.notion.web-bookmark",
        defaultMessage: "Web bookmark"
    },
    other: {
        id: "import-feedback.data-format-options.notion.other",
        defaultMessage: "Other"
    }
});
module.exports["notionDataFormatOptionsMessages"] = $b8d9cf0582cd5f3a$export$5487dbca878f120b;

});

parcelRegister("3M5DA", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $78b530d7902d0707$export$c02ae8a2bd2ff74a = (0, $kSwu1.defineMessages)({
    comments: {
        id: "import-feedback.data-format-options.miro.comments",
        defaultMessage: "Comments"
    },
    colors: {
        id: "import-feedback.data-format-options.miro.colors",
        defaultMessage: "Colors"
    },
    connectors: {
        id: "import-feedback.data-format-options.miro.connectors",
        defaultMessage: "Connectors"
    },
    rotations: {
        id: "import-feedback.data-format-options.miro.rotations",
        defaultMessage: "Rotations"
    },
    shapes: {
        id: "import-feedback.data-format-options.miro.shapes",
        defaultMessage: "Shapes"
    },
    talkTracks: {
        id: "import-feedback.data-format-options.miro.talk-tracks",
        defaultMessage: "Talk Tracks"
    },
    lockedElements: {
        id: "import-feedback.data-format-options.miro.locked-elements",
        defaultMessage: "Locked Elements"
    },
    stickyNotes: {
        id: "import-feedback.data-format-options.miro.sticky-notes",
        defaultMessage: "Sticky notes"
    },
    frames: {
        id: "import-feedback.data-format-options.miro.frames",
        defaultMessage: "Frames"
    },
    borders: {
        id: "import-feedback.data-format-options.miro.borders",
        defaultMessage: "Borders"
    },
    draw: {
        id: "import-feedback.data-format-options.miro.draw",
        defaultMessage: "Draw"
    },
    websiteEmbeds: {
        id: "import-feedback.data-format-options.miro.website-embeds",
        defaultMessage: "Website embeds"
    },
    jiraCards: {
        id: "import-feedback.data-format-options.miro.jira-cards",
        defaultMessage: "Jira cards"
    },
    tables: {
        id: "import-feedback.data-format-options.miro.tables",
        defaultMessage: "Tables"
    },
    gifs: {
        id: "import-feedback.data-format-options.miro.gifs",
        defaultMessage: "GIFs"
    },
    text: {
        id: "import-feedback.data-format-options.miro.text",
        defaultMessage: "Text"
    },
    stamps: {
        id: "import-feedback.data-format-options.miro.stamps",
        defaultMessage: "Stamps"
    },
    tags: {
        id: "import-feedback.data-format-options.miro.tags",
        defaultMessage: "Tags"
    },
    mindMaps: {
        id: "import-feedback.data-format-options.miro.mind-maps",
        defaultMessage: "Mind maps"
    },
    other: {
        id: "import-feedback.data-format-options.miro.other",
        defaultMessage: "Other"
    }
});
module.exports["miroDataFormatOptionsMessages"] = $78b530d7902d0707$export$c02ae8a2bd2ff74a;

});

parcelRegister("ffmqQ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ff44c6ff801bbed9$export$47d9fbb91e8e28a3 = (0, $kSwu1.defineMessages)({
    comments: {
        id: "import-feedback.data-format-options.mural.comments",
        defaultMessage: "Comments"
    },
    stickyNotes: {
        id: "import-feedback.data-format-options.mural.sticky-notes",
        defaultMessage: "Sticky Notes"
    },
    borders: {
        id: "import-feedback.data-format-options.mural.borders",
        defaultMessage: "Borders"
    },
    draw: {
        id: "import-feedback.data-format-options.mural.draw",
        defaultMessage: "Draw"
    },
    websiteEmbeds: {
        id: "import-feedback.data-format-options.mural.website-embeds",
        defaultMessage: "Website Embeds"
    },
    tables: {
        id: "import-feedback.data-format-options.mural.tables",
        defaultMessage: "Tables"
    },
    gifs: {
        id: "import-feedback.data-format-options.mural.gifs",
        defaultMessage: "GIFs"
    },
    text: {
        id: "import-feedback.data-format-options.mural.text",
        defaultMessage: "Text"
    },
    stamps: {
        id: "import-feedback.data-format-options.mural.stamps",
        defaultMessage: "Stamps"
    },
    tags: {
        id: "import-feedback.data-format-options.mural.tags",
        defaultMessage: "Tags"
    },
    mindMaps: {
        id: "import-feedback.data-format-options.mural.mind-maps",
        defaultMessage: "Mind Maps"
    },
    colors: {
        id: "import-feedback.data-format-options.mural.colors",
        defaultMessage: "Colors"
    },
    connectors: {
        id: "import-feedback.data-format-options.mural.connectors",
        defaultMessage: "Connectors"
    },
    rotations: {
        id: "import-feedback.data-format-options.mural.rotations",
        defaultMessage: "Rotations"
    },
    shapes: {
        id: "import-feedback.data-format-options.mural.shapes",
        defaultMessage: "Shapes"
    },
    lockedElements: {
        id: "import-feedback.data-format-options.mural.locked-elements",
        defaultMessage: "Locked Elements"
    },
    other: {
        id: "import-feedback.data-format-options.mural.other",
        defaultMessage: "Other"
    }
});
module.exports["muralDataFormatOptionsMessages"] = $ff44c6ff801bbed9$export$47d9fbb91e8e28a3;

});

parcelRegister("aUiHE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a14bce3fd3c2a8ba$export$4055a71a6988efc8 = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "import-feedback.feedback-modal.title",
        defaultMessage: "Give feedback on imported content"
    },
    dataFormatHelperText: {
        id: "import-feedback.feedback-modal.data-format-helper-text",
        defaultMessage: "Start typing to get a list of possible matches or press down to select."
    },
    requiredFieldsAsterisk: {
        id: "import-feedback.feedback-modal.required-fields-asterisk",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    feedbackText: {
        id: "import-feedback.feedback-modal.feedback-text",
        defaultMessage: "This content was imported from {source\t}. Please let us know what issues you found below!"
    },
    dataFormatLabel: {
        id: "import-feedback.feedback-modal.data-format-label",
        defaultMessage: "Data formats with issues"
    },
    dataFormatClearControlLabel: {
        id: "import-feedback.feedback-modal.data-format-clear-control-label",
        defaultMessage: "Clear selected data format"
    },
    tellUsAboutYourExperience: {
        id: "import-feedback.feedback-modal.tell-us-about-your-experience",
        defaultMessage: "Tell us about your experience"
    },
    tellUsAboutYourExperiencePlaceholder: {
        id: "import-feedback.feedback-modal.tell-us-about-your-experience-placeholder",
        defaultMessage: "Please expand on what could be improved for this imported content."
    },
    feedbackButton: {
        id: "import-feedback.feedback-modal.feedback-button",
        defaultMessage: "Send Feedback"
    },
    closeButton: {
        id: "import-feedback.feedback-modal.close-button",
        defaultMessage: "Cancel"
    },
    selectDataFormatError: {
        id: "import-feedback.feedback-modal.select-data-format-error",
        defaultMessage: "Please select a data format"
    },
    submittedTitle: {
        id: "import-feedback.feedback-modal.submitted-title",
        defaultMessage: "Thanks!"
    },
    submittedDescription: {
        id: "import-feedback.feedback-modal.submitted-description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    }
});
module.exports["modalFormMessages"] = $a14bce3fd3c2a8ba$export$4055a71a6988efc8;

});

parcelRegister("aK6zf", function(module, exports) {
const $08986653719b52d0$var$IMPORT_SOURCE_PROPERTY_KEY = 'import-source';
const $08986653719b52d0$var$IMPORT_DATE_PROPERTY_KEY = 'imported-page-modified-date';
const $08986653719b52d0$export$e8d166ad05d55a7e = 90;
const $08986653719b52d0$export$660ec42e439d82e5 = 120000; // 2 minutes
function $08986653719b52d0$export$d7c17bfc5f552f72(contentQueryData) {
    const pageProperties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes;
    const importedFromProperty = pageProperties?.find((property)=>property?.key === $08986653719b52d0$var$IMPORT_SOURCE_PROPERTY_KEY);
    return importedFromProperty?.value || undefined;
}
function $08986653719b52d0$export$cccab9e45bf98465(contentQueryData) {
    const pageProperties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes;
    const originalImportDate = pageProperties?.find((property)=>property?.key === $08986653719b52d0$var$IMPORT_DATE_PROPERTY_KEY)?.value?.replace(/^"|"$/g, '');
    return originalImportDate ? new Date(originalImportDate) : undefined;
}
function $08986653719b52d0$export$f5748926afca39a(contentQueryData) {
    const importedFromProperty = $08986653719b52d0$export$d7c17bfc5f552f72(contentQueryData);
    const originalImportDate = $08986653719b52d0$export$cccab9e45bf98465(contentQueryData);
    const lastModifiedDate = contentQueryData?.content?.nodes?.[0]?.metadata?.lastModifiedDate ? new Date(contentQueryData?.content?.nodes?.[0]?.metadata?.lastModifiedDate) : undefined;
    if (!originalImportDate || !lastModifiedDate) return false;
    return !!importedFromProperty && $08986653719b52d0$var$isPageWithinFeedbackTimeThreshold(originalImportDate) && !$08986653719b52d0$var$isPageLastModifiedAfterImportDate(lastModifiedDate, originalImportDate);
}
function $08986653719b52d0$var$isPageWithinFeedbackTimeThreshold(importDate) {
    return Date.now() <= importDate.getTime() + $08986653719b52d0$export$e8d166ad05d55a7e * 86400000;
}
function $08986653719b52d0$var$isPageLastModifiedAfterImportDate(lastModifiedDate, importDate) {
    return lastModifiedDate.getTime() > importDate.getTime() + $08986653719b52d0$export$660ec42e439d82e5;
}
module.exports["getImportSource"] = $08986653719b52d0$export$d7c17bfc5f552f72;
module.exports["getImportDate"] = $08986653719b52d0$export$cccab9e45bf98465;
module.exports["isImportBannerEnabled"] = $08986653719b52d0$export$f5748926afca39a;

});

parcelRegister("8tF9d", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c08f0377995c9fbd$export$8f5a21cf0975ea0d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "TAXXG",
    name: "LivePageComponentLoader",
    loader: async ()=>(await (parcelRequire("dww3b"))).LivePageComponent
});
module.exports["LivePageComponentLoader"] = $c08f0377995c9fbd$export$8f5a21cf0975ea0d;

});

parcelRegister("dww3b", function(module, exports) {

let $9d87200f7378366e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9d87200f7378366e$var$load("cH8yZ"),
    $9d87200f7378366e$var$load("g81ly"),
    $9d87200f7378366e$var$load("e3LAK"),
    $9d87200f7378366e$var$load("fYtcg"),
    $9d87200f7378366e$var$load("9FPrl"),
    $9d87200f7378366e$var$load("79Tk4"),
    $9d87200f7378366e$var$load("26l7c"),
    $9d87200f7378366e$var$load("6wr18"),
    $9d87200f7378366e$var$load("7fJS0"),
    $9d87200f7378366e$var$load("Jyh1v"),
    $9d87200f7378366e$var$load("l9Ivm"),
    $9d87200f7378366e$var$load("5vReS"),
    $9d87200f7378366e$var$load("02yT2"),
    $9d87200f7378366e$var$load("ffEVr"),
    $9d87200f7378366e$var$load("excC5"),
    $9d87200f7378366e$var$load("aLbuU"),
    $9d87200f7378366e$var$load("d8SWd"),
    $9d87200f7378366e$var$load("dEUQZ"),
    $9d87200f7378366e$var$load("eS3wT"),
    $9d87200f7378366e$var$load("4uO8Y"),
    $9d87200f7378366e$var$load("80Yra"),
    $9d87200f7378366e$var$load("1blTK"),
    $9d87200f7378366e$var$load("d6DuA"),
    $9d87200f7378366e$var$load("5is1n"),
    $9d87200f7378366e$var$load("bV5bW"),
    $9d87200f7378366e$var$load("ei0GF"),
    $9d87200f7378366e$var$load("cgKMu"),
    $9d87200f7378366e$var$load("60QcS"),
    $9d87200f7378366e$var$load("husez"),
    $9d87200f7378366e$var$load("4izLy"),
    $9d87200f7378366e$var$load("kGmwI"),
    $9d87200f7378366e$var$load("2tyj0"),
    $9d87200f7378366e$var$load("fEWss"),
    $9d87200f7378366e$var$load("ceGPg"),
    $9d87200f7378366e$var$load("953Uz"),
    $9d87200f7378366e$var$load("hhss7"),
    $9d87200f7378366e$var$load("7EorR"),
    $9d87200f7378366e$var$load("fz1VH")
]).then(()=>parcelRequire('egCae'));

});

parcelRegister("cMKmt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3TgYS = parcelRequire("3TgYS");


var $jYPbB = parcelRequire("jYPbB");

const $46239388d4485db7$export$9d6b189b48dfd2fa = ({ contentId: contentId })=>{
    $46239388d4485db7$var$useLocalActivityViewPageTracker(contentId);
    return null;
};
const $46239388d4485db7$var$useLocalActivityViewPageTracker = (contentId)=>{
    const { track: track } = (0, $jYPbB.useLocalActivityTracker)();
    (0, $cozmU.useEffect)(()=>{
        track(contentId, (0, $3TgYS.LocalActivityAction).viewed);
    }, [
        track,
        contentId
    ]);
};
module.exports["LocalActivityViewPageTracker"] = $46239388d4485db7$export$9d6b189b48dfd2fa;

});

parcelRegister("3nzqU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");


var $JCGnt = parcelRequire("JCGnt");


const $4d7d073c1c91ca91$var$useLazyAmplitudeInit = ()=>{
    return (0, $cozmU.useCallback)(async ()=>{
        if (!(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return; // no-op
        const module = await (parcelRequire("3sUQf"));
        return module.AmplitudeSessionReplay.init();
    }, []);
};

const $4d7d073c1c91ca91$var$useLazyAmplitudeStop = ()=>{
    return (0, $cozmU.useCallback)(async ()=>{
        if (!(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return; // no-op
        const module = await (parcelRequire("3sUQf"));
        return module.AmplitudeSessionReplay.stop();
    }, []);
};
const $4d7d073c1c91ca91$export$7ac5f7e6449ca924 = ({ skip: skip = false, timeoutMs: timeoutMs = 180000 // 3 minutes default
 } = {})=>{
    const amplitudeInit = $4d7d073c1c91ca91$var$useLazyAmplitudeInit();
    const amplitudeStop = $4d7d073c1c91ca91$var$useLazyAmplitudeStop();
    const timeoutRef = (0, $cozmU.useRef)();
    const isInitializedRef = (0, $cozmU.useRef)(false);
    const analyticsEventFiredRef = (0, $cozmU.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isNewUser: isNewUser, loading: isLoadingNewUser } = (0, $JCGnt.useIsNewUser)({}, skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate'));
    (0, $cozmU.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return;
        // Initialize amplitude
        amplitudeInit();
        isInitializedRef.current = true;
        // Set timeout to stop after specified time
        timeoutRef.current = setTimeout(()=>{
            amplitudeStop();
            isInitializedRef.current = false;
        }, timeoutMs);
        // Cleanup function
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
    }, [
        skip,
        amplitudeInit,
        amplitudeStop,
        timeoutMs
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate') || !isInitializedRef.current || analyticsEventFiredRef.current || isLoadingNewUser) return;
        if (isNewUser) {
            //Use this analytics event to add extra attributes so it can be filtered in Amplitude
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'triggered',
                    actionSubject: 'amplitudeSessionReplay',
                    source: 'confluenceAmplitudeSessionReplay',
                    attributes: {
                        isNewUser: true
                    }
                }
            }).fire();
            analyticsEventFiredRef.current = true;
        }
    }, [
        skip,
        isNewUser,
        createAnalyticsEvent,
        isLoadingNewUser
    ]);
    // Cleanup effect that always runs on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
    }, [
        amplitudeStop
    ]);
    // Handle pagehide to stop amplitude session replay when page closes
    (0, $cozmU.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return;
        const handlePageHide = ()=>{
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
        window.addEventListener('pagehide', handlePageHide);
        return ()=>{
            window.removeEventListener('pagehide', handlePageHide);
        };
    }, [
        skip,
        amplitudeStop
    ]);
};
module.exports["useAmplitudeSessionReplay"] = $4d7d073c1c91ca91$export$7ac5f7e6449ca924;

});

parcelRegister("3sUQf", function(module, exports) {

let $2860142d72563b41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2860142d72563b41$var$load("czC5b").then(()=>parcelRequire('d1GUC'));

});


//# sourceMappingURL=ViewPage.64fc981c.js.map
